(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[888],{

/***/ 18552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 1989:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(51789),
    hashDelete = __webpack_require__(80401),
    hashGet = __webpack_require__(57667),
    hashHas = __webpack_require__(21327),
    hashSet = __webpack_require__(81866);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 96425:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(3118),
    baseLodash = __webpack_require__(9435);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),

/***/ 38407:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(27040),
    listCacheDelete = __webpack_require__(14125),
    listCacheGet = __webpack_require__(82117),
    listCacheHas = __webpack_require__(67518),
    listCacheSet = __webpack_require__(54705);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 7548:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(3118),
    baseLodash = __webpack_require__(9435);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),

/***/ 57071:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 83369:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(24785),
    mapCacheDelete = __webpack_require__(11285),
    mapCacheGet = __webpack_require__(96000),
    mapCacheHas = __webpack_require__(49916),
    mapCacheSet = __webpack_require__(95265);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 53818:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 58525:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 88668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369),
    setCacheAdd = __webpack_require__(90619),
    setCacheHas = __webpack_require__(72385);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 46384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    stackClear = __webpack_require__(37465),
    stackDelete = __webpack_require__(63779),
    stackGet = __webpack_require__(67599),
    stackHas = __webpack_require__(44758),
    stackSet = __webpack_require__(34309);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 62705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 11149:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 70577:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852),
    root = __webpack_require__(55639);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 96874:
/***/ (function(module) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),

/***/ 77412:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 34963:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 47443:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(42118);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),

/***/ 14636:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(22545),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isIndex = __webpack_require__(65776),
    isTypedArray = __webpack_require__(36719);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 29932:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 62488:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 82908:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 34865:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(89465),
    eq = __webpack_require__(77813);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),

/***/ 18470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(77813);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 44037:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),

/***/ 63886:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    keysIn = __webpack_require__(81704);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),

/***/ 89465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var defineProperty = __webpack_require__(38777);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),

/***/ 85990:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    arrayEach = __webpack_require__(77412),
    assignValue = __webpack_require__(34865),
    baseAssign = __webpack_require__(44037),
    baseAssignIn = __webpack_require__(63886),
    cloneBuffer = __webpack_require__(64626),
    copyArray = __webpack_require__(278),
    copySymbols = __webpack_require__(18805),
    copySymbolsIn = __webpack_require__(1911),
    getAllKeys = __webpack_require__(58234),
    getAllKeysIn = __webpack_require__(46904),
    getTag = __webpack_require__(64160),
    initCloneArray = __webpack_require__(43824),
    initCloneByTag = __webpack_require__(29148),
    initCloneObject = __webpack_require__(38517),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isMap = __webpack_require__(56688),
    isObject = __webpack_require__(13218),
    isSet = __webpack_require__(72928),
    keys = __webpack_require__(3674),
    keysIn = __webpack_require__(81704);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),

/***/ 3118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),

/***/ 89881:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(47816),
    createBaseEach = __webpack_require__(99291);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 80760:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),

/***/ 41848:
/***/ (function(module) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),

/***/ 21078:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isFlattenable = __webpack_require__(37285);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),

/***/ 28483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(25063);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 47816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(28483),
    keys = __webpack_require__(3674);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 97786:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),

/***/ 68866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 44239:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    getRawTag = __webpack_require__(89607),
    objectToString = __webpack_require__(2333);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 13:
/***/ (function(module) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),

/***/ 42118:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(41848),
    baseIsNaN = __webpack_require__(62722),
    strictIndexOf = __webpack_require__(42351);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),

/***/ 9454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 90939:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(2492),
    isObjectLike = __webpack_require__(37005);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 2492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    equalArrays = __webpack_require__(67114),
    equalByTag = __webpack_require__(18351),
    equalObjects = __webpack_require__(16096),
    getTag = __webpack_require__(64160),
    isArray = __webpack_require__(1469),
    isBuffer = __webpack_require__(44144),
    isTypedArray = __webpack_require__(36719);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 25588:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(64160),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),

/***/ 2958:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(46384),
    baseIsEqual = __webpack_require__(90939);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),

/***/ 62722:
/***/ (function(module) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),

/***/ 28458:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isMasked = __webpack_require__(15346),
    isObject = __webpack_require__(13218),
    toSource = __webpack_require__(80346);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 29221:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(64160),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),

/***/ 38749:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isLength = __webpack_require__(41780),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 67206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseMatches = __webpack_require__(91573),
    baseMatchesProperty = __webpack_require__(16432),
    identity = __webpack_require__(6557),
    isArray = __webpack_require__(1469),
    property = __webpack_require__(39601);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),

/***/ 280:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(25726),
    nativeKeys = __webpack_require__(86916);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 10313:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218),
    isPrototype = __webpack_require__(25726),
    nativeKeysIn = __webpack_require__(33498);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),

/***/ 9435:
/***/ (function(module) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),

/***/ 69199:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseEach = __webpack_require__(89881),
    isArrayLike = __webpack_require__(98612);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),

/***/ 91573:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(2958),
    getMatchData = __webpack_require__(1499),
    matchesStrictComparable = __webpack_require__(42634);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),

/***/ 16432:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(90939),
    get = __webpack_require__(27361),
    hasIn = __webpack_require__(79095),
    isKey = __webpack_require__(15403),
    isStrictComparable = __webpack_require__(89162),
    matchesStrictComparable = __webpack_require__(42634),
    toKey = __webpack_require__(40327);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),

/***/ 82689:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    baseGet = __webpack_require__(97786),
    baseIteratee = __webpack_require__(67206),
    baseMap = __webpack_require__(69199),
    baseSortBy = __webpack_require__(71131),
    baseUnary = __webpack_require__(7518),
    compareMultiple = __webpack_require__(85022),
    identity = __webpack_require__(6557),
    isArray = __webpack_require__(1469);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),

/***/ 40371:
/***/ (function(module) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),

/***/ 79152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),

/***/ 15742:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseUnset = __webpack_require__(57406),
    isIndex = __webpack_require__(65776);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex(index)) {
        splice.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

module.exports = basePullAt;


/***/ }),

/***/ 28045:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557),
    metaMap = __webpack_require__(89250);

/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var baseSetData = !metaMap ? identity : function(func, data) {
  metaMap.set(func, data);
  return func;
};

module.exports = baseSetData;


/***/ }),

/***/ 56560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var constant = __webpack_require__(75703),
    defineProperty = __webpack_require__(38777),
    identity = __webpack_require__(6557);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),

/***/ 14259:
/***/ (function(module) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),

/***/ 71131:
/***/ (function(module) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),

/***/ 67762:
/***/ (function(module) {

/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */
function baseSum(array, iteratee) {
  var result,
      index = -1,
      length = array.length;

  while (++index < length) {
    var current = iteratee(array[index]);
    if (current !== undefined) {
      result = result === undefined ? current : (result + current);
    }
  }
  return result;
}

module.exports = baseSum;


/***/ }),

/***/ 22545:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 80531:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    arrayMap = __webpack_require__(29932),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 27561:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(67990);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),

/***/ 7518:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 57406:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    last = __webpack_require__(10928),
    parent = __webpack_require__(40292),
    toKey = __webpack_require__(40327);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),

/***/ 74757:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 54290:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(6557);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 71811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isKey = __webpack_require__(15403),
    stringToPath = __webpack_require__(55514),
    toString = __webpack_require__(79833);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),

/***/ 74318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Uint8Array = __webpack_require__(11149);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),

/***/ 64626:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;


/***/ }),

/***/ 57157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),

/***/ 93147:
/***/ (function(module) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),

/***/ 40419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),

/***/ 77133:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),

/***/ 26393:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),

/***/ 85022:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var compareAscending = __webpack_require__(26393);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),

/***/ 52157:
/***/ (function(module) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgs(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersLength = holders.length,
      leftIndex = -1,
      leftLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(leftLength + rangeLength),
      isUncurried = !isCurried;

  while (++leftIndex < leftLength) {
    result[leftIndex] = partials[leftIndex];
  }
  while (++argsIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[holders[argsIndex]] = args[argsIndex];
    }
  }
  while (rangeLength--) {
    result[leftIndex++] = args[argsIndex++];
  }
  return result;
}

module.exports = composeArgs;


/***/ }),

/***/ 14054:
/***/ (function(module) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */
function composeArgsRight(args, partials, holders, isCurried) {
  var argsIndex = -1,
      argsLength = args.length,
      holdersIndex = -1,
      holdersLength = holders.length,
      rightIndex = -1,
      rightLength = partials.length,
      rangeLength = nativeMax(argsLength - holdersLength, 0),
      result = Array(rangeLength + rightLength),
      isUncurried = !isCurried;

  while (++argsIndex < rangeLength) {
    result[argsIndex] = args[argsIndex];
  }
  var offset = argsIndex;
  while (++rightIndex < rightLength) {
    result[offset + rightIndex] = partials[rightIndex];
  }
  while (++holdersIndex < holdersLength) {
    if (isUncurried || argsIndex < argsLength) {
      result[offset + holders[holdersIndex]] = args[argsIndex++];
    }
  }
  return result;
}

module.exports = composeArgsRight;


/***/ }),

/***/ 278:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 98363:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assignValue = __webpack_require__(34865),
    baseAssignValue = __webpack_require__(89465);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),

/***/ 18805:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    getSymbols = __webpack_require__(99551);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),

/***/ 1911:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyObject = __webpack_require__(98363),
    getSymbolsIn = __webpack_require__(51442);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),

/***/ 14429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(55639);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 97991:
/***/ (function(module) {

/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */
function countHolders(array, placeholder) {
  var length = array.length,
      result = 0;

  while (length--) {
    if (array[length] === placeholder) {
      ++result;
    }
  }
  return result;
}

module.exports = countHolders;


/***/ }),

/***/ 99291:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(98612);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 25063:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 22402:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createCtor = __webpack_require__(71774),
    root = __webpack_require__(55639);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createBind(func, bitmask, thisArg) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return fn.apply(isBind ? thisArg : this, arguments);
  }
  return wrapper;
}

module.exports = createBind;


/***/ }),

/***/ 71774:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(3118),
    isObject = __webpack_require__(13218);

/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */
function createCtor(Ctor) {
  return function() {
    // Use a `switch` statement to work with class constructors. See
    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
    // for more details.
    var args = arguments;
    switch (args.length) {
      case 0: return new Ctor;
      case 1: return new Ctor(args[0]);
      case 2: return new Ctor(args[0], args[1]);
      case 3: return new Ctor(args[0], args[1], args[2]);
      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
    }
    var thisBinding = baseCreate(Ctor.prototype),
        result = Ctor.apply(thisBinding, args);

    // Mimic the constructor's `return` behavior.
    // See https://es5.github.io/#x13.2.2 for more details.
    return isObject(result) ? result : thisBinding;
  };
}

module.exports = createCtor;


/***/ }),

/***/ 46347:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(96874),
    createCtor = __webpack_require__(71774),
    createHybrid = __webpack_require__(86935),
    createRecurry = __webpack_require__(94487),
    getHolder = __webpack_require__(20893),
    replaceHolders = __webpack_require__(46460),
    root = __webpack_require__(55639);

/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createCurry(func, bitmask, arity) {
  var Ctor = createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length,
        placeholder = getHolder(wrapper);

    while (index--) {
      args[index] = arguments[index];
    }
    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
      ? []
      : replaceHolders(args, placeholder);

    length -= holders.length;
    if (length < arity) {
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, undefined,
        args, holders, undefined, undefined, arity - length);
    }
    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
    return apply(fn, this, args);
  }
  return wrapper;
}

module.exports = createCurry;


/***/ }),

/***/ 67740:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(67206),
    isArrayLike = __webpack_require__(98612),
    keys = __webpack_require__(3674);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),

/***/ 23468:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var LodashWrapper = __webpack_require__(7548),
    flatRest = __webpack_require__(99021),
    getData = __webpack_require__(66833),
    getFuncName = __webpack_require__(97658),
    isArray = __webpack_require__(1469),
    isLaziable = __webpack_require__(86528);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


/***/ }),

/***/ 86935:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var composeArgs = __webpack_require__(52157),
    composeArgsRight = __webpack_require__(14054),
    countHolders = __webpack_require__(97991),
    createCtor = __webpack_require__(71774),
    createRecurry = __webpack_require__(94487),
    getHolder = __webpack_require__(20893),
    reorder = __webpack_require__(90451),
    replaceHolders = __webpack_require__(46460),
    root = __webpack_require__(55639);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_ARY_FLAG = 128,
    WRAP_FLIP_FLAG = 512;

/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
  var isAry = bitmask & WRAP_ARY_FLAG,
      isBind = bitmask & WRAP_BIND_FLAG,
      isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
      isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
      isFlip = bitmask & WRAP_FLIP_FLAG,
      Ctor = isBindKey ? undefined : createCtor(func);

  function wrapper() {
    var length = arguments.length,
        args = Array(length),
        index = length;

    while (index--) {
      args[index] = arguments[index];
    }
    if (isCurried) {
      var placeholder = getHolder(wrapper),
          holdersCount = countHolders(args, placeholder);
    }
    if (partials) {
      args = composeArgs(args, partials, holders, isCurried);
    }
    if (partialsRight) {
      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
    }
    length -= holdersCount;
    if (isCurried && length < arity) {
      var newHolders = replaceHolders(args, placeholder);
      return createRecurry(
        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
        args, newHolders, argPos, ary, arity - length
      );
    }
    var thisBinding = isBind ? thisArg : this,
        fn = isBindKey ? thisBinding[func] : func;

    length = args.length;
    if (argPos) {
      args = reorder(args, argPos);
    } else if (isFlip && length > 1) {
      args.reverse();
    }
    if (isAry && ary < length) {
      args.length = ary;
    }
    if (this && this !== root && this instanceof wrapper) {
      fn = Ctor || createCtor(fn);
    }
    return fn.apply(thisBinding, args);
  }
  return wrapper;
}

module.exports = createHybrid;


/***/ }),

/***/ 84375:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(96874),
    createCtor = __webpack_require__(71774),
    root = __webpack_require__(55639);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1;

/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */
function createPartial(func, bitmask, thisArg, partials) {
  var isBind = bitmask & WRAP_BIND_FLAG,
      Ctor = createCtor(func);

  function wrapper() {
    var argsIndex = -1,
        argsLength = arguments.length,
        leftIndex = -1,
        leftLength = partials.length,
        args = Array(leftLength + argsLength),
        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

    while (++leftIndex < leftLength) {
      args[leftIndex] = partials[leftIndex];
    }
    while (argsLength--) {
      args[leftIndex++] = arguments[++argsIndex];
    }
    return apply(fn, isBind ? thisArg : this, args);
  }
  return wrapper;
}

module.exports = createPartial;


/***/ }),

/***/ 94487:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isLaziable = __webpack_require__(86528),
    setData = __webpack_require__(258),
    setWrapToString = __webpack_require__(69255);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
  var isCurry = bitmask & WRAP_CURRY_FLAG,
      newHolders = isCurry ? holders : undefined,
      newHoldersRight = isCurry ? undefined : holders,
      newPartials = isCurry ? partials : undefined,
      newPartialsRight = isCurry ? undefined : partials;

  bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
  bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

  if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
    bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
  }
  var newData = [
    func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
    newHoldersRight, argPos, ary, arity
  ];

  var result = wrapFunc.apply(undefined, newData);
  if (isLaziable(func)) {
    setData(result, newData);
  }
  result.placeholder = placeholder;
  return setWrapToString(result, func, bitmask);
}

module.exports = createRecurry;


/***/ }),

/***/ 97727:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetData = __webpack_require__(28045),
    createBind = __webpack_require__(22402),
    createCurry = __webpack_require__(46347),
    createHybrid = __webpack_require__(86935),
    createPartial = __webpack_require__(84375),
    getData = __webpack_require__(66833),
    mergeData = __webpack_require__(63833),
    setData = __webpack_require__(258),
    setWrapToString = __webpack_require__(69255),
    toInteger = __webpack_require__(40554);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */
function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
  var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
  if (!isBindKey && typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var length = partials ? partials.length : 0;
  if (!length) {
    bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
    partials = holders = undefined;
  }
  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
  arity = arity === undefined ? arity : toInteger(arity);
  length -= holders ? holders.length : 0;

  if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
    var partialsRight = partials,
        holdersRight = holders;

    partials = holders = undefined;
  }
  var data = isBindKey ? undefined : getData(func);

  var newData = [
    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
    argPos, ary, arity
  ];

  if (data) {
    mergeData(newData, data);
  }
  func = newData[0];
  bitmask = newData[1];
  thisArg = newData[2];
  partials = newData[3];
  holders = newData[4];
  arity = newData[9] = newData[9] === undefined
    ? (isBindKey ? 0 : func.length)
    : nativeMax(newData[9] - length, 0);

  if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
    bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
  }
  if (!bitmask || bitmask == WRAP_BIND_FLAG) {
    var result = createBind(func, bitmask, thisArg);
  } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
    result = createCurry(func, bitmask, arity);
  } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
    result = createPartial(func, bitmask, thisArg, partials);
  } else {
    result = createHybrid.apply(undefined, newData);
  }
  var setter = data ? baseSetData : setData;
  return setWrapToString(setter(result, newData), func, bitmask);
}

module.exports = createWrap;


/***/ }),

/***/ 38777:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),

/***/ 67114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(88668),
    arraySome = __webpack_require__(82908),
    cacheHas = __webpack_require__(74757);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 18351:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    Uint8Array = __webpack_require__(11149),
    eq = __webpack_require__(77813),
    equalArrays = __webpack_require__(67114),
    mapToArray = __webpack_require__(68776),
    setToArray = __webpack_require__(21814);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 16096:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(58234);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 99021:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var flatten = __webpack_require__(85564),
    overRest = __webpack_require__(45357),
    setToString = __webpack_require__(30061);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),

/***/ 31957:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 58234:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbols = __webpack_require__(99551),
    keys = __webpack_require__(3674);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 46904:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(68866),
    getSymbolsIn = __webpack_require__(51442),
    keysIn = __webpack_require__(81704);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),

/***/ 66833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var metaMap = __webpack_require__(89250),
    noop = __webpack_require__(50308);

/**
 * Gets metadata for `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {*} Returns the metadata for `func`.
 */
var getData = !metaMap ? noop : function(func) {
  return metaMap.get(func);
};

module.exports = getData;


/***/ }),

/***/ 97658:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var realNames = __webpack_require__(52060);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the name of `func`.
 *
 * @private
 * @param {Function} func The function to query.
 * @returns {string} Returns the function name.
 */
function getFuncName(func) {
  var result = (func.name + ''),
      array = realNames[result],
      length = hasOwnProperty.call(realNames, result) ? array.length : 0;

  while (length--) {
    var data = array[length],
        otherFunc = data.func;
    if (otherFunc == null || otherFunc == func) {
      return data.name;
    }
  }
  return result;
}

module.exports = getFuncName;


/***/ }),

/***/ 20893:
/***/ (function(module) {

/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */
function getHolder(func) {
  var object = func;
  return object.placeholder;
}

module.exports = getHolder;


/***/ }),

/***/ 45050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(37019);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 1499:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(89162),
    keys = __webpack_require__(3674);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),

/***/ 10852:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(28458),
    getValue = __webpack_require__(47801);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 85924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),

/***/ 89607:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 99551:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    stubArray = __webpack_require__(70479);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 51442:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(62488),
    getPrototype = __webpack_require__(85924),
    getSymbols = __webpack_require__(99551),
    stubArray = __webpack_require__(70479);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),

/***/ 64160:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(18552),
    Map = __webpack_require__(57071),
    Promise = __webpack_require__(53818),
    Set = __webpack_require__(58525),
    WeakMap = __webpack_require__(70577),
    baseGetTag = __webpack_require__(44239),
    toSource = __webpack_require__(80346);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 47801:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 58775:
/***/ (function(module) {

/** Used to match wrap detail comments. */
var reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */
function getWrapDetails(source) {
  var match = source.match(reWrapDetails);
  return match ? match[1].split(reSplitDetails) : [];
}

module.exports = getWrapDetails;


/***/ }),

/***/ 222:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var castPath = __webpack_require__(71811),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469),
    isIndex = __webpack_require__(65776),
    isLength = __webpack_require__(41780),
    toKey = __webpack_require__(40327);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),

/***/ 51789:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 80401:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 57667:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 21327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 81866:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(94536);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 43824:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),

/***/ 29148:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(74318),
    cloneDataView = __webpack_require__(57157),
    cloneRegExp = __webpack_require__(93147),
    cloneSymbol = __webpack_require__(40419),
    cloneTypedArray = __webpack_require__(77133);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),

/***/ 38517:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseCreate = __webpack_require__(3118),
    getPrototype = __webpack_require__(85924),
    isPrototype = __webpack_require__(25726);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),

/***/ 83112:
/***/ (function(module) {

/** Used to match wrap detail comments. */
var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;

/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */
function insertWrapDetails(source, details) {
  var length = details.length;
  if (!length) {
    return source;
  }
  var lastIndex = length - 1;
  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
  details = details.join(length > 2 ? ', ' : ' ');
  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}

module.exports = insertWrapDetails;


/***/ }),

/***/ 37285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(62705),
    isArguments = __webpack_require__(35694),
    isArray = __webpack_require__(1469);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),

/***/ 65776:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 15403:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),

/***/ 37019:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 86528:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(96425),
    getData = __webpack_require__(66833),
    getFuncName = __webpack_require__(97658),
    lodash = __webpack_require__(8111);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

module.exports = isLaziable;


/***/ }),

/***/ 15346:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(14429);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 25726:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 89162:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isObject = __webpack_require__(13218);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),

/***/ 27040:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 14125:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 82117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 67518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 54705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(18470);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 24785:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(1989),
    ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 11285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 96000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 49916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 95265:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(45050);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 68776:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 42634:
/***/ (function(module) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),

/***/ 24523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(88306);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 63833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var composeArgs = __webpack_require__(52157),
    composeArgsRight = __webpack_require__(14054),
    replaceHolders = __webpack_require__(46460);

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */
function mergeData(data, source) {
  var bitmask = data[1],
      srcBitmask = source[1],
      newBitmask = bitmask | srcBitmask,
      isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

  var isCombo =
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
    ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
    ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

  // Exit early if metadata can't be merged.
  if (!(isCommon || isCombo)) {
    return data;
  }
  // Use source `thisArg` if available.
  if (srcBitmask & WRAP_BIND_FLAG) {
    data[2] = source[2];
    // Set when currying a bound function.
    newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
  }
  // Compose partial arguments.
  var value = source[3];
  if (value) {
    var partials = data[3];
    data[3] = partials ? composeArgs(partials, value, source[4]) : value;
    data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
  }
  // Compose partial right arguments.
  value = source[5];
  if (value) {
    partials = data[5];
    data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
    data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
  }
  // Use source `argPos` if available.
  value = source[7];
  if (value) {
    data[7] = value;
  }
  // Use source `ary` if it's smaller.
  if (srcBitmask & WRAP_ARY_FLAG) {
    data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
  }
  // Use source `arity` if one is not provided.
  if (data[9] == null) {
    data[9] = source[9];
  }
  // Use source `func` and merge bitmasks.
  data[0] = source[0];
  data[1] = newBitmask;

  return data;
}

module.exports = mergeData;


/***/ }),

/***/ 89250:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var WeakMap = __webpack_require__(70577);

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;


/***/ }),

/***/ 94536:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(10852);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 86916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(5569);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 33498:
/***/ (function(module) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),

/***/ 31167:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(31957);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 2333:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 5569:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 45357:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var apply = __webpack_require__(96874);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),

/***/ 40292:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786),
    baseSlice = __webpack_require__(14259);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),

/***/ 52060:
/***/ (function(module) {

/** Used to lookup unminified function names. */
var realNames = {};

module.exports = realNames;


/***/ }),

/***/ 90451:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var copyArray = __webpack_require__(278),
    isIndex = __webpack_require__(65776);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMin = Math.min;

/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */
function reorder(array, indexes) {
  var arrLength = array.length,
      length = nativeMin(indexes.length, arrLength),
      oldArray = copyArray(array);

  while (length--) {
    var index = indexes[length];
    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
  }
  return array;
}

module.exports = reorder;


/***/ }),

/***/ 46460:
/***/ (function(module) {

/** Used as the internal argument placeholder. */
var PLACEHOLDER = '__lodash_placeholder__';

/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */
function replaceHolders(array, placeholder) {
  var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (value === placeholder || value === PLACEHOLDER) {
      array[index] = PLACEHOLDER;
      result[resIndex++] = index;
    }
  }
  return result;
}

module.exports = replaceHolders;


/***/ }),

/***/ 55639:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(31957);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 90619:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 72385:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 258:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetData = __webpack_require__(28045),
    shortOut = __webpack_require__(21275);

/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */
var setData = shortOut(baseSetData);

module.exports = setData;


/***/ }),

/***/ 21814:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 30061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSetToString = __webpack_require__(56560),
    shortOut = __webpack_require__(21275);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),

/***/ 69255:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getWrapDetails = __webpack_require__(58775),
    insertWrapDetails = __webpack_require__(83112),
    setToString = __webpack_require__(30061),
    updateWrapDetails = __webpack_require__(87241);

/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */
function setWrapToString(wrapper, reference, bitmask) {
  var source = (reference + '');
  return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
}

module.exports = setWrapToString;


/***/ }),

/***/ 21275:
/***/ (function(module) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),

/***/ 37465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 63779:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 67599:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 44758:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 34309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(38407),
    Map = __webpack_require__(57071),
    MapCache = __webpack_require__(83369);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 42351:
/***/ (function(module) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),

/***/ 55514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(24523);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 40327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 80346:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 67990:
/***/ (function(module) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),

/***/ 87241:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayEach = __webpack_require__(77412),
    arrayIncludes = __webpack_require__(47443);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

/** Used to associate wrap methods with their bit flags. */
var wrapFlags = [
  ['ary', WRAP_ARY_FLAG],
  ['bind', WRAP_BIND_FLAG],
  ['bindKey', WRAP_BIND_KEY_FLAG],
  ['curry', WRAP_CURRY_FLAG],
  ['curryRight', WRAP_CURRY_RIGHT_FLAG],
  ['flip', WRAP_FLIP_FLAG],
  ['partial', WRAP_PARTIAL_FLAG],
  ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
  ['rearg', WRAP_REARG_FLAG]
];

/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */
function updateWrapDetails(details, bitmask) {
  arrayEach(wrapFlags, function(pair) {
    var value = '_.' + pair[0];
    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
      details.push(value);
    }
  });
  return details.sort();
}

module.exports = updateWrapDetails;


/***/ }),

/***/ 21913:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(96425),
    LodashWrapper = __webpack_require__(7548),
    copyArray = __webpack_require__(278);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),

/***/ 39514:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createWrap = __webpack_require__(97727);

/** Used to compose bitmasks for function metadata. */
var WRAP_ARY_FLAG = 128;

/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */
function ary(func, n, guard) {
  n = guard ? undefined : n;
  n = (func && n == null) ? func.length : n;
  return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}

module.exports = ary;


/***/ }),

/***/ 66678:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClone = __webpack_require__(85990);

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

module.exports = clone;


/***/ }),

/***/ 75703:
/***/ (function(module) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),

/***/ 40087:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createWrap = __webpack_require__(97727);

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8;

/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */
function curry(func, arity, guard) {
  arity = guard ? undefined : arity;
  var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
  result.placeholder = curry.placeholder;
  return result;
}

// Assign default placeholders.
curry.placeholder = {};

module.exports = curry;


/***/ }),

/***/ 66073:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(84486);


/***/ }),

/***/ 77813:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 63105:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(34963),
    baseFilter = __webpack_require__(80760),
    baseIteratee = __webpack_require__(67206),
    isArray = __webpack_require__(1469);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),

/***/ 13311:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createFind = __webpack_require__(67740),
    findIndex = __webpack_require__(30998);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),

/***/ 30998:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(41848),
    baseIteratee = __webpack_require__(67206),
    toInteger = __webpack_require__(40554);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),

/***/ 85564:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFlatten = __webpack_require__(21078);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),

/***/ 59242:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createFlow = __webpack_require__(23468);

/**
 * Creates a function that returns the result of invoking the given functions
 * with the `this` binding of the created function, where each successive
 * invocation is supplied the return value of the previous.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flowRight
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flow([_.add, square]);
 * addSquare(1, 2);
 * // => 9
 */
var flow = createFlow();

module.exports = flow;


/***/ }),

/***/ 84486:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayEach = __webpack_require__(77412),
    baseEach = __webpack_require__(89881),
    castFunction = __webpack_require__(54290),
    isArray = __webpack_require__(1469);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),

/***/ 84599:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapping = __webpack_require__(68836),
    fallbackHolder = __webpack_require__(69306);

/** Built-in value reference. */
var push = Array.prototype.push;

/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */
function baseArity(func, n) {
  return n == 2
    ? function(a, b) { return func.apply(undefined, arguments); }
    : function(a) { return func.apply(undefined, arguments); };
}

/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */
function baseAry(func, n) {
  return n == 2
    ? function(a, b) { return func(a, b); }
    : function(a) { return func(a); };
}

/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */
function cloneArray(array) {
  var length = array ? array.length : 0,
      result = Array(length);

  while (length--) {
    result[length] = array[length];
  }
  return result;
}

/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */
function createCloner(func) {
  return function(object) {
    return func({}, object);
  };
}

/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */
function flatSpread(func, start) {
  return function() {
    var length = arguments.length,
        lastIndex = length - 1,
        args = Array(length);

    while (length--) {
      args[length] = arguments[length];
    }
    var array = args[start],
        otherArgs = args.slice(0, start);

    if (array) {
      push.apply(otherArgs, array);
    }
    if (start != lastIndex) {
      push.apply(otherArgs, args.slice(start + 1));
    }
    return func.apply(this, otherArgs);
  };
}

/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */
function wrapImmutable(func, cloner) {
  return function() {
    var length = arguments.length;
    if (!length) {
      return;
    }
    var args = Array(length);
    while (length--) {
      args[length] = arguments[length];
    }
    var result = args[0] = cloner.apply(undefined, args);
    func.apply(undefined, args);
    return result;
  };
}

/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */
function baseConvert(util, name, func, options) {
  var isLib = typeof name == 'function',
      isObj = name === Object(name);

  if (isObj) {
    options = func;
    func = name;
    name = undefined;
  }
  if (func == null) {
    throw new TypeError;
  }
  options || (options = {});

  var config = {
    'cap': 'cap' in options ? options.cap : true,
    'curry': 'curry' in options ? options.curry : true,
    'fixed': 'fixed' in options ? options.fixed : true,
    'immutable': 'immutable' in options ? options.immutable : true,
    'rearg': 'rearg' in options ? options.rearg : true
  };

  var defaultHolder = isLib ? func : fallbackHolder,
      forceCurry = ('curry' in options) && options.curry,
      forceFixed = ('fixed' in options) && options.fixed,
      forceRearg = ('rearg' in options) && options.rearg,
      pristine = isLib ? func.runInContext() : undefined;

  var helpers = isLib ? func : {
    'ary': util.ary,
    'assign': util.assign,
    'clone': util.clone,
    'curry': util.curry,
    'forEach': util.forEach,
    'isArray': util.isArray,
    'isError': util.isError,
    'isFunction': util.isFunction,
    'isWeakMap': util.isWeakMap,
    'iteratee': util.iteratee,
    'keys': util.keys,
    'rearg': util.rearg,
    'toInteger': util.toInteger,
    'toPath': util.toPath
  };

  var ary = helpers.ary,
      assign = helpers.assign,
      clone = helpers.clone,
      curry = helpers.curry,
      each = helpers.forEach,
      isArray = helpers.isArray,
      isError = helpers.isError,
      isFunction = helpers.isFunction,
      isWeakMap = helpers.isWeakMap,
      keys = helpers.keys,
      rearg = helpers.rearg,
      toInteger = helpers.toInteger,
      toPath = helpers.toPath;

  var aryMethodKeys = keys(mapping.aryMethod);

  var wrappers = {
    'castArray': function(castArray) {
      return function() {
        var value = arguments[0];
        return isArray(value)
          ? castArray(cloneArray(value))
          : castArray.apply(undefined, arguments);
      };
    },
    'iteratee': function(iteratee) {
      return function() {
        var func = arguments[0],
            arity = arguments[1],
            result = iteratee(func, arity),
            length = result.length;

        if (config.cap && typeof arity == 'number') {
          arity = arity > 2 ? (arity - 2) : 1;
          return (length && length <= arity) ? result : baseAry(result, arity);
        }
        return result;
      };
    },
    'mixin': function(mixin) {
      return function(source) {
        var func = this;
        if (!isFunction(func)) {
          return mixin(func, Object(source));
        }
        var pairs = [];
        each(keys(source), function(key) {
          if (isFunction(source[key])) {
            pairs.push([key, func.prototype[key]]);
          }
        });

        mixin(func, Object(source));

        each(pairs, function(pair) {
          var value = pair[1];
          if (isFunction(value)) {
            func.prototype[pair[0]] = value;
          } else {
            delete func.prototype[pair[0]];
          }
        });
        return func;
      };
    },
    'nthArg': function(nthArg) {
      return function(n) {
        var arity = n < 0 ? 1 : (toInteger(n) + 1);
        return curry(nthArg(n), arity);
      };
    },
    'rearg': function(rearg) {
      return function(func, indexes) {
        var arity = indexes ? indexes.length : 0;
        return curry(rearg(func, indexes), arity);
      };
    },
    'runInContext': function(runInContext) {
      return function(context) {
        return baseConvert(util, runInContext(context), options);
      };
    }
  };

  /*--------------------------------------------------------------------------*/

  /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */
  function castCap(name, func) {
    if (config.cap) {
      var indexes = mapping.iterateeRearg[name];
      if (indexes) {
        return iterateeRearg(func, indexes);
      }
      var n = !isLib && mapping.iterateeAry[name];
      if (n) {
        return iterateeAry(func, n);
      }
    }
    return func;
  }

  /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castCurry(name, func, n) {
    return (forceCurry || (config.curry && n > 1))
      ? curry(func, n)
      : func;
  }

  /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */
  function castFixed(name, func, n) {
    if (config.fixed && (forceFixed || !mapping.skipFixed[name])) {
      var data = mapping.methodSpread[name],
          start = data && data.start;

      return start  === undefined ? ary(func, n) : flatSpread(func, start);
    }
    return func;
  }

  /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */
  function castRearg(name, func, n) {
    return (config.rearg && n > 1 && (forceRearg || !mapping.skipRearg[name]))
      ? rearg(func, mapping.methodRearg[name] || mapping.aryRearg[n])
      : func;
  }

  /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */
  function cloneByPath(object, path) {
    path = toPath(path);

    var index = -1,
        length = path.length,
        lastIndex = length - 1,
        result = clone(Object(object)),
        nested = result;

    while (nested != null && ++index < length) {
      var key = path[index],
          value = nested[key];

      if (value != null &&
          !(isFunction(value) || isError(value) || isWeakMap(value))) {
        nested[key] = clone(index == lastIndex ? value : Object(value));
      }
      nested = nested[key];
    }
    return result;
  }

  /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */
  function convertLib(options) {
    return _.runInContext.convert(options)(undefined);
  }

  /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */
  function createConverter(name, func) {
    var realName = mapping.aliasToReal[name] || name,
        methodName = mapping.remap[realName] || realName,
        oldOptions = options;

    return function(options) {
      var newUtil = isLib ? pristine : helpers,
          newFunc = isLib ? pristine[methodName] : func,
          newOptions = assign(assign({}, oldOptions), options);

      return baseConvert(newUtil, realName, newFunc, newOptions);
    };
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */
  function iterateeAry(func, n) {
    return overArg(func, function(func) {
      return typeof func == 'function' ? baseAry(func, n) : func;
    });
  }

  /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */
  function iterateeRearg(func, indexes) {
    return overArg(func, function(func) {
      var n = indexes.length;
      return baseArity(rearg(baseAry(func, n), indexes), n);
    });
  }

  /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function() {
      var length = arguments.length;
      if (!length) {
        return func();
      }
      var args = Array(length);
      while (length--) {
        args[length] = arguments[length];
      }
      var index = config.rearg ? 0 : (length - 1);
      args[index] = transform(args[index]);
      return func.apply(undefined, args);
    };
  }

  /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */
  function wrap(name, func, placeholder) {
    var result,
        realName = mapping.aliasToReal[name] || name,
        wrapped = func,
        wrapper = wrappers[realName];

    if (wrapper) {
      wrapped = wrapper(func);
    }
    else if (config.immutable) {
      if (mapping.mutate.array[realName]) {
        wrapped = wrapImmutable(func, cloneArray);
      }
      else if (mapping.mutate.object[realName]) {
        wrapped = wrapImmutable(func, createCloner(func));
      }
      else if (mapping.mutate.set[realName]) {
        wrapped = wrapImmutable(func, cloneByPath);
      }
    }
    each(aryMethodKeys, function(aryKey) {
      each(mapping.aryMethod[aryKey], function(otherName) {
        if (realName == otherName) {
          var data = mapping.methodSpread[realName],
              afterRearg = data && data.afterRearg;

          result = afterRearg
            ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey)
            : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);

          result = castCap(realName, result);
          result = castCurry(realName, result, aryKey);
          return false;
        }
      });
      return !result;
    });

    result || (result = wrapped);
    if (result == func) {
      result = forceCurry ? curry(result, 1) : function() {
        return func.apply(this, arguments);
      };
    }
    result.convert = createConverter(realName, func);
    result.placeholder = func.placeholder = placeholder;

    return result;
  }

  /*--------------------------------------------------------------------------*/

  if (!isObj) {
    return wrap(name, func, defaultHolder);
  }
  var _ = func;

  // Convert methods by ary cap.
  var pairs = [];
  each(aryMethodKeys, function(aryKey) {
    each(mapping.aryMethod[aryKey], function(key) {
      var func = _[mapping.remap[key] || key];
      if (func) {
        pairs.push([key, wrap(key, func, _)]);
      }
    });
  });

  // Convert remaining methods.
  each(keys(_), function(key) {
    var func = _[key];
    if (typeof func == 'function') {
      var length = pairs.length;
      while (length--) {
        if (pairs[length][0] == key) {
          return;
        }
      }
      func.convert = createConverter(key, func);
      pairs.push([key, func]);
    }
  });

  // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
  each(pairs, function(pair) {
    _[pair[0]] = pair[1];
  });

  _.convert = convertLib;
  _.placeholder = _;

  // Assign aliases.
  each(keys(_), function(key) {
    each(mapping.realToAlias[key] || [], function(alias) {
      _[alias] = _[key];
    });
  });

  return _;
}

module.exports = baseConvert;


/***/ }),

/***/ 69087:
/***/ (function(module) {

module.exports = {
  'cap': false,
  'curry': false,
  'fixed': false,
  'immutable': false,
  'rearg': false
};


/***/ }),

/***/ 68836:
/***/ (function(__unused_webpack_module, exports) {

/** Used to map aliases to their real names. */
exports.aliasToReal = {

  // Lodash aliases.
  'each': 'forEach',
  'eachRight': 'forEachRight',
  'entries': 'toPairs',
  'entriesIn': 'toPairsIn',
  'extend': 'assignIn',
  'extendAll': 'assignInAll',
  'extendAllWith': 'assignInAllWith',
  'extendWith': 'assignInWith',
  'first': 'head',

  // Methods that are curried variants of others.
  'conforms': 'conformsTo',
  'matches': 'isMatch',
  'property': 'get',

  // Ramda aliases.
  '__': 'placeholder',
  'F': 'stubFalse',
  'T': 'stubTrue',
  'all': 'every',
  'allPass': 'overEvery',
  'always': 'constant',
  'any': 'some',
  'anyPass': 'overSome',
  'apply': 'spread',
  'assoc': 'set',
  'assocPath': 'set',
  'complement': 'negate',
  'compose': 'flowRight',
  'contains': 'includes',
  'dissoc': 'unset',
  'dissocPath': 'unset',
  'dropLast': 'dropRight',
  'dropLastWhile': 'dropRightWhile',
  'equals': 'isEqual',
  'identical': 'eq',
  'indexBy': 'keyBy',
  'init': 'initial',
  'invertObj': 'invert',
  'juxt': 'over',
  'omitAll': 'omit',
  'nAry': 'ary',
  'path': 'get',
  'pathEq': 'matchesProperty',
  'pathOr': 'getOr',
  'paths': 'at',
  'pickAll': 'pick',
  'pipe': 'flow',
  'pluck': 'map',
  'prop': 'get',
  'propEq': 'matchesProperty',
  'propOr': 'getOr',
  'props': 'at',
  'symmetricDifference': 'xor',
  'symmetricDifferenceBy': 'xorBy',
  'symmetricDifferenceWith': 'xorWith',
  'takeLast': 'takeRight',
  'takeLastWhile': 'takeRightWhile',
  'unapply': 'rest',
  'unnest': 'flatten',
  'useWith': 'overArgs',
  'where': 'conformsTo',
  'whereEq': 'isMatch',
  'zipObj': 'zipObject'
};

/** Used to map ary to method names. */
exports.aryMethod = {
  '1': [
    'assignAll', 'assignInAll', 'attempt', 'castArray', 'ceil', 'create',
    'curry', 'curryRight', 'defaultsAll', 'defaultsDeepAll', 'floor', 'flow',
    'flowRight', 'fromPairs', 'invert', 'iteratee', 'memoize', 'method', 'mergeAll',
    'methodOf', 'mixin', 'nthArg', 'over', 'overEvery', 'overSome','rest', 'reverse',
    'round', 'runInContext', 'spread', 'template', 'trim', 'trimEnd', 'trimStart',
    'uniqueId', 'words', 'zipAll'
  ],
  '2': [
    'add', 'after', 'ary', 'assign', 'assignAllWith', 'assignIn', 'assignInAllWith',
    'at', 'before', 'bind', 'bindAll', 'bindKey', 'chunk', 'cloneDeepWith',
    'cloneWith', 'concat', 'conformsTo', 'countBy', 'curryN', 'curryRightN',
    'debounce', 'defaults', 'defaultsDeep', 'defaultTo', 'delay', 'difference',
    'divide', 'drop', 'dropRight', 'dropRightWhile', 'dropWhile', 'endsWith', 'eq',
    'every', 'filter', 'find', 'findIndex', 'findKey', 'findLast', 'findLastIndex',
    'findLastKey', 'flatMap', 'flatMapDeep', 'flattenDepth', 'forEach',
    'forEachRight', 'forIn', 'forInRight', 'forOwn', 'forOwnRight', 'get',
    'groupBy', 'gt', 'gte', 'has', 'hasIn', 'includes', 'indexOf', 'intersection',
    'invertBy', 'invoke', 'invokeMap', 'isEqual', 'isMatch', 'join', 'keyBy',
    'lastIndexOf', 'lt', 'lte', 'map', 'mapKeys', 'mapValues', 'matchesProperty',
    'maxBy', 'meanBy', 'merge', 'mergeAllWith', 'minBy', 'multiply', 'nth', 'omit',
    'omitBy', 'overArgs', 'pad', 'padEnd', 'padStart', 'parseInt', 'partial',
    'partialRight', 'partition', 'pick', 'pickBy', 'propertyOf', 'pull', 'pullAll',
    'pullAt', 'random', 'range', 'rangeRight', 'rearg', 'reject', 'remove',
    'repeat', 'restFrom', 'result', 'sampleSize', 'some', 'sortBy', 'sortedIndex',
    'sortedIndexOf', 'sortedLastIndex', 'sortedLastIndexOf', 'sortedUniqBy',
    'split', 'spreadFrom', 'startsWith', 'subtract', 'sumBy', 'take', 'takeRight',
    'takeRightWhile', 'takeWhile', 'tap', 'throttle', 'thru', 'times', 'trimChars',
    'trimCharsEnd', 'trimCharsStart', 'truncate', 'union', 'uniqBy', 'uniqWith',
    'unset', 'unzipWith', 'without', 'wrap', 'xor', 'zip', 'zipObject',
    'zipObjectDeep'
  ],
  '3': [
    'assignInWith', 'assignWith', 'clamp', 'differenceBy', 'differenceWith',
    'findFrom', 'findIndexFrom', 'findLastFrom', 'findLastIndexFrom', 'getOr',
    'includesFrom', 'indexOfFrom', 'inRange', 'intersectionBy', 'intersectionWith',
    'invokeArgs', 'invokeArgsMap', 'isEqualWith', 'isMatchWith', 'flatMapDepth',
    'lastIndexOfFrom', 'mergeWith', 'orderBy', 'padChars', 'padCharsEnd',
    'padCharsStart', 'pullAllBy', 'pullAllWith', 'rangeStep', 'rangeStepRight',
    'reduce', 'reduceRight', 'replace', 'set', 'slice', 'sortedIndexBy',
    'sortedLastIndexBy', 'transform', 'unionBy', 'unionWith', 'update', 'xorBy',
    'xorWith', 'zipWith'
  ],
  '4': [
    'fill', 'setWith', 'updateWith'
  ]
};

/** Used to map ary to rearg configs. */
exports.aryRearg = {
  '2': [1, 0],
  '3': [2, 0, 1],
  '4': [3, 2, 0, 1]
};

/** Used to map method names to their iteratee ary. */
exports.iterateeAry = {
  'dropRightWhile': 1,
  'dropWhile': 1,
  'every': 1,
  'filter': 1,
  'find': 1,
  'findFrom': 1,
  'findIndex': 1,
  'findIndexFrom': 1,
  'findKey': 1,
  'findLast': 1,
  'findLastFrom': 1,
  'findLastIndex': 1,
  'findLastIndexFrom': 1,
  'findLastKey': 1,
  'flatMap': 1,
  'flatMapDeep': 1,
  'flatMapDepth': 1,
  'forEach': 1,
  'forEachRight': 1,
  'forIn': 1,
  'forInRight': 1,
  'forOwn': 1,
  'forOwnRight': 1,
  'map': 1,
  'mapKeys': 1,
  'mapValues': 1,
  'partition': 1,
  'reduce': 2,
  'reduceRight': 2,
  'reject': 1,
  'remove': 1,
  'some': 1,
  'takeRightWhile': 1,
  'takeWhile': 1,
  'times': 1,
  'transform': 2
};

/** Used to map method names to iteratee rearg configs. */
exports.iterateeRearg = {
  'mapKeys': [1],
  'reduceRight': [1, 0]
};

/** Used to map method names to rearg configs. */
exports.methodRearg = {
  'assignInAllWith': [1, 0],
  'assignInWith': [1, 2, 0],
  'assignAllWith': [1, 0],
  'assignWith': [1, 2, 0],
  'differenceBy': [1, 2, 0],
  'differenceWith': [1, 2, 0],
  'getOr': [2, 1, 0],
  'intersectionBy': [1, 2, 0],
  'intersectionWith': [1, 2, 0],
  'isEqualWith': [1, 2, 0],
  'isMatchWith': [2, 1, 0],
  'mergeAllWith': [1, 0],
  'mergeWith': [1, 2, 0],
  'padChars': [2, 1, 0],
  'padCharsEnd': [2, 1, 0],
  'padCharsStart': [2, 1, 0],
  'pullAllBy': [2, 1, 0],
  'pullAllWith': [2, 1, 0],
  'rangeStep': [1, 2, 0],
  'rangeStepRight': [1, 2, 0],
  'setWith': [3, 1, 2, 0],
  'sortedIndexBy': [2, 1, 0],
  'sortedLastIndexBy': [2, 1, 0],
  'unionBy': [1, 2, 0],
  'unionWith': [1, 2, 0],
  'updateWith': [3, 1, 2, 0],
  'xorBy': [1, 2, 0],
  'xorWith': [1, 2, 0],
  'zipWith': [1, 2, 0]
};

/** Used to map method names to spread configs. */
exports.methodSpread = {
  'assignAll': { 'start': 0 },
  'assignAllWith': { 'start': 0 },
  'assignInAll': { 'start': 0 },
  'assignInAllWith': { 'start': 0 },
  'defaultsAll': { 'start': 0 },
  'defaultsDeepAll': { 'start': 0 },
  'invokeArgs': { 'start': 2 },
  'invokeArgsMap': { 'start': 2 },
  'mergeAll': { 'start': 0 },
  'mergeAllWith': { 'start': 0 },
  'partial': { 'start': 1 },
  'partialRight': { 'start': 1 },
  'without': { 'start': 1 },
  'zipAll': { 'start': 0 }
};

/** Used to identify methods which mutate arrays or objects. */
exports.mutate = {
  'array': {
    'fill': true,
    'pull': true,
    'pullAll': true,
    'pullAllBy': true,
    'pullAllWith': true,
    'pullAt': true,
    'remove': true,
    'reverse': true
  },
  'object': {
    'assign': true,
    'assignAll': true,
    'assignAllWith': true,
    'assignIn': true,
    'assignInAll': true,
    'assignInAllWith': true,
    'assignInWith': true,
    'assignWith': true,
    'defaults': true,
    'defaultsAll': true,
    'defaultsDeep': true,
    'defaultsDeepAll': true,
    'merge': true,
    'mergeAll': true,
    'mergeAllWith': true,
    'mergeWith': true,
  },
  'set': {
    'set': true,
    'setWith': true,
    'unset': true,
    'update': true,
    'updateWith': true
  }
};

/** Used to map real names to their aliases. */
exports.realToAlias = (function() {
  var hasOwnProperty = Object.prototype.hasOwnProperty,
      object = exports.aliasToReal,
      result = {};

  for (var key in object) {
    var value = object[key];
    if (hasOwnProperty.call(result, value)) {
      result[value].push(key);
    } else {
      result[value] = [key];
    }
  }
  return result;
}());

/** Used to map method names to other names. */
exports.remap = {
  'assignAll': 'assign',
  'assignAllWith': 'assignWith',
  'assignInAll': 'assignIn',
  'assignInAllWith': 'assignInWith',
  'curryN': 'curry',
  'curryRightN': 'curryRight',
  'defaultsAll': 'defaults',
  'defaultsDeepAll': 'defaultsDeep',
  'findFrom': 'find',
  'findIndexFrom': 'findIndex',
  'findLastFrom': 'findLast',
  'findLastIndexFrom': 'findLastIndex',
  'getOr': 'get',
  'includesFrom': 'includes',
  'indexOfFrom': 'indexOf',
  'invokeArgs': 'invoke',
  'invokeArgsMap': 'invokeMap',
  'lastIndexOfFrom': 'lastIndexOf',
  'mergeAll': 'merge',
  'mergeAllWith': 'mergeWith',
  'padChars': 'pad',
  'padCharsEnd': 'padEnd',
  'padCharsStart': 'padStart',
  'propertyOf': 'get',
  'rangeStep': 'range',
  'rangeStepRight': 'rangeRight',
  'restFrom': 'rest',
  'spreadFrom': 'spread',
  'trimChars': 'trim',
  'trimCharsEnd': 'trimEnd',
  'trimCharsStart': 'trimStart',
  'zipAll': 'zip'
};

/** Used to track methods that skip fixing their arity. */
exports.skipFixed = {
  'castArray': true,
  'flow': true,
  'flowRight': true,
  'iteratee': true,
  'mixin': true,
  'rearg': true,
  'runInContext': true
};

/** Used to track methods that skip rearranging arguments. */
exports.skipRearg = {
  'add': true,
  'assign': true,
  'assignIn': true,
  'bind': true,
  'bindKey': true,
  'concat': true,
  'difference': true,
  'divide': true,
  'eq': true,
  'gt': true,
  'gte': true,
  'isEqual': true,
  'lt': true,
  'lte': true,
  'matchesProperty': true,
  'merge': true,
  'multiply': true,
  'overArgs': true,
  'partial': true,
  'partialRight': true,
  'propertyOf': true,
  'random': true,
  'range': true,
  'rangeRight': true,
  'subtract': true,
  'zip': true,
  'zipObject': true,
  'zipObjectDeep': true
};


/***/ }),

/***/ 4269:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
  'ary': __webpack_require__(39514),
  'assign': __webpack_require__(44037),
  'clone': __webpack_require__(66678),
  'curry': __webpack_require__(40087),
  'forEach': __webpack_require__(77412),
  'isArray': __webpack_require__(1469),
  'isError': __webpack_require__(64647),
  'isFunction': __webpack_require__(23560),
  'isWeakMap': __webpack_require__(81018),
  'iteratee': __webpack_require__(72594),
  'keys': __webpack_require__(280),
  'rearg': __webpack_require__(4963),
  'toInteger': __webpack_require__(40554),
  'toPath': __webpack_require__(30084)
};


/***/ }),

/***/ 92822:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseConvert = __webpack_require__(84599),
    util = __webpack_require__(4269);

/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */
function convert(name, func, options) {
  return baseConvert(util, name, func, options);
}

module.exports = convert;


/***/ }),

/***/ 8816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var convert = __webpack_require__(92822),
    func = convert('flow', __webpack_require__(59242));

func.placeholder = __webpack_require__(69306);
module.exports = func;


/***/ }),

/***/ 88846:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var convert = __webpack_require__(92822),
    func = convert('map', __webpack_require__(35161));

func.placeholder = __webpack_require__(69306);
module.exports = func;


/***/ }),

/***/ 69306:
/***/ (function(module) {

/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */
module.exports = {};


/***/ }),

/***/ 15919:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var convert = __webpack_require__(92822),
    func = convert('sum', __webpack_require__(12297), __webpack_require__(69087));

func.placeholder = __webpack_require__(69306);
module.exports = func;


/***/ }),

/***/ 27361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGet = __webpack_require__(97786);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),

/***/ 79095:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseHasIn = __webpack_require__(13),
    hasPath = __webpack_require__(222);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),

/***/ 6557:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 35694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(9454),
    isObjectLike = __webpack_require__(37005);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 1469:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 98612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(23560),
    isLength = __webpack_require__(41780);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 44144:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(55639),
    stubFalse = __webpack_require__(95062);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 64647:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005),
    isPlainObject = __webpack_require__(68630);

/** `Object#toString` result references. */
var domExcTag = '[object DOMException]',
    errorTag = '[object Error]';

/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */
function isError(value) {
  if (!isObjectLike(value)) {
    return false;
  }
  var tag = baseGetTag(value);
  return tag == errorTag || tag == domExcTag ||
    (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
}

module.exports = isError;


/***/ }),

/***/ 23560:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObject = __webpack_require__(13218);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 41780:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 56688:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsMap = __webpack_require__(25588),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),

/***/ 13218:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 37005:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 68630:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    getPrototype = __webpack_require__(85924),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),

/***/ 72928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsSet = __webpack_require__(29221),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),

/***/ 33448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(44239),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 36719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(38749),
    baseUnary = __webpack_require__(7518),
    nodeUtil = __webpack_require__(31167);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 81018:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getTag = __webpack_require__(64160),
    isObjectLike = __webpack_require__(37005);

/** `Object#toString` result references. */
var weakMapTag = '[object WeakMap]';

/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */
function isWeakMap(value) {
  return isObjectLike(value) && getTag(value) == weakMapTag;
}

module.exports = isWeakMap;


/***/ }),

/***/ 72594:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseClone = __webpack_require__(85990),
    baseIteratee = __webpack_require__(67206);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1;

/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */
function iteratee(func) {
  return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
}

module.exports = iteratee;


/***/ }),

/***/ 3674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeys = __webpack_require__(280),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 81704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(14636),
    baseKeysIn = __webpack_require__(10313),
    isArrayLike = __webpack_require__(98612);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),

/***/ 10928:
/***/ (function(module) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),

/***/ 35161:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    baseIteratee = __webpack_require__(67206),
    baseMap = __webpack_require__(69199),
    isArray = __webpack_require__(1469);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),

/***/ 88306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(83369);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 50308:
/***/ (function(module) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),

/***/ 75472:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseOrderBy = __webpack_require__(82689),
    isArray = __webpack_require__(1469);

/**
 * This method is like `_.sortBy` except that it allows specifying the sort
 * orders of the iteratees to sort by. If `orders` is unspecified, all values
 * are sorted in ascending order. Otherwise, specify an order of "desc" for
 * descending or "asc" for ascending sort order of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @param {string[]} [orders] The sort orders of `iteratees`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 34 },
 *   { 'user': 'fred',   'age': 40 },
 *   { 'user': 'barney', 'age': 36 }
 * ];
 *
 * // Sort by `user` in ascending order and by `age` in descending order.
 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
 */
function orderBy(collection, iteratees, orders, guard) {
  if (collection == null) {
    return [];
  }
  if (!isArray(iteratees)) {
    iteratees = iteratees == null ? [] : [iteratees];
  }
  orders = guard ? undefined : orders;
  if (!isArray(orders)) {
    orders = orders == null ? [] : [orders];
  }
  return baseOrderBy(collection, iteratees, orders);
}

module.exports = orderBy;


/***/ }),

/***/ 39601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseProperty = __webpack_require__(40371),
    basePropertyDeep = __webpack_require__(79152),
    isKey = __webpack_require__(15403),
    toKey = __webpack_require__(40327);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),

/***/ 4963:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createWrap = __webpack_require__(97727),
    flatRest = __webpack_require__(99021);

/** Used to compose bitmasks for function metadata. */
var WRAP_REARG_FLAG = 256;

/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */
var rearg = flatRest(function(func, indexes) {
  return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});

module.exports = rearg;


/***/ }),

/***/ 82729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIteratee = __webpack_require__(67206),
    basePullAt = __webpack_require__(15742);

/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = baseIteratee(predicate, 3);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  basePullAt(array, indexes);
  return result;
}

module.exports = remove;


/***/ }),

/***/ 70479:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 95062:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 12297:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseSum = __webpack_require__(67762),
    identity = __webpack_require__(6557);

/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */
function sum(array) {
  return (array && array.length)
    ? baseSum(array, identity)
    : 0;
}

module.exports = sum;


/***/ }),

/***/ 18601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toNumber = __webpack_require__(14841);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),

/***/ 40554:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var toFinite = __webpack_require__(18601);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),

/***/ 14841:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTrim = __webpack_require__(27561),
    isObject = __webpack_require__(13218),
    isSymbol = __webpack_require__(33448);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),

/***/ 30084:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(29932),
    copyArray = __webpack_require__(278),
    isArray = __webpack_require__(1469),
    isSymbol = __webpack_require__(33448),
    stringToPath = __webpack_require__(55514),
    toKey = __webpack_require__(40327),
    toString = __webpack_require__(79833);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),

/***/ 79833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(80531);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 8111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(96425),
    LodashWrapper = __webpack_require__(7548),
    baseLodash = __webpack_require__(9435),
    isArray = __webpack_require__(1469),
    isObjectLike = __webpack_require__(37005),
    wrapperClone = __webpack_require__(21913);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),

/***/ 69921:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
exports.typeOf=y;


/***/ }),

/***/ 59864:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(69921);
} else {}


/***/ }),

/***/ 89961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "f6": function() { return /* binding */ Le; },
  "vJ": function() { return /* binding */ $e; },
  "iv": function() { return /* binding */ Ae; },
  "ZP": function() { return /* binding */ styled_components_browser_esm; },
  "F4": function() { return /* binding */ We; },
  "Fg": function() { return /* binding */ Xe; },
  "Zz": function() { return /* binding */ Je; }
});

// UNUSED EXPORTS: ServerStyleSheet, StyleSheetConsumer, StyleSheetContext, StyleSheetManager, ThemeConsumer, ThemeContext, __PRIVATE__, isStyledComponent, version

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(59864);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/shallowequal/index.js
var shallowequal = __webpack_require__(88665);
var shallowequal_default = /*#__PURE__*/__webpack_require__.n(shallowequal);
;// CONCATENATED MODULE: ../../node_modules/@emotion/stylis/dist/stylis.browser.esm.js
function stylis_min (W) {
  function M(d, c, e, h, a) {
    for (var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;) {
      g = e.charCodeAt(l);
      l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);

      if (0 === b + n + v + m) {
        if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
          switch (g) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;

            default:
              f += e.charAt(l);
          }

          g = 59;
        }

        switch (g) {
          case 123:
            f = f.trim();
            q = f.charCodeAt(0);
            k = 1;

            for (t = ++l; l < B;) {
              switch (g = e.charCodeAt(l)) {
                case 123:
                  k++;
                  break;

                case 125:
                  k--;
                  break;

                case 47:
                  switch (g = e.charCodeAt(l + 1)) {
                    case 42:
                    case 47:
                      a: {
                        for (u = l + 1; u < J; ++u) {
                          switch (e.charCodeAt(u)) {
                            case 47:
                              if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                l = u + 1;
                                break a;
                              }

                              break;

                            case 10:
                              if (47 === g) {
                                l = u + 1;
                                break a;
                              }

                          }
                        }

                        l = u;
                      }

                  }

                  break;

                case 91:
                  g++;

                case 40:
                  g++;

                case 34:
                case 39:
                  for (; l++ < J && e.charCodeAt(l) !== g;) {
                  }

              }

              if (0 === k) break;
              l++;
            }

            k = e.substring(t, l);
            0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));

            switch (q) {
              case 64:
                0 < r && (f = f.replace(N, ''));
                g = f.charCodeAt(1);

                switch (g) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    r = c;
                    break;

                  default:
                    r = O;
                }

                k = M(c, r, k, g, a + 1);
                t = k.length;
                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                if (0 < t) switch (g) {
                  case 115:
                    f = f.replace(da, ea);

                  case 100:
                  case 109:
                  case 45:
                    k = f + '{' + k + '}';
                    break;

                  case 107:
                    f = f.replace(fa, '$1 $2');
                    k = f + '{' + k + '}';
                    k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                    break;

                  default:
                    k = f + k, 112 === h && (k = (p += k, ''));
                } else k = '';
                break;

              default:
                k = M(c, X(c, f, I), k, h, a + 1);
            }

            F += k;
            k = I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
            break;

          case 125:
          case 59:
            f = (0 < r ? f.replace(N, '') : f).trim();
            if (1 < (t = f.length)) switch (0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q) {
              case 0:
                break;

              case 64:
                if (105 === g || 99 === g) {
                  G += f + e.charAt(l);
                  break;
                }

              default:
                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
            }
            I = r = u = q = 0;
            f = '';
            g = e.charCodeAt(++l);
        }
      }

      switch (g) {
        case 13:
        case 10:
          47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
          0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
          z = 1;
          D++;
          break;

        case 59:
        case 125:
          if (0 === b + n + v + m) {
            z++;
            break;
          }

        default:
          z++;
          y = e.charAt(l);

          switch (g) {
            case 9:
            case 32:
              if (0 === n + m + b) switch (x) {
                case 44:
                case 58:
                case 9:
                case 32:
                  y = '';
                  break;

                default:
                  32 !== g && (y = ' ');
              }
              break;

            case 0:
              y = '\\0';
              break;

            case 12:
              y = '\\f';
              break;

            case 11:
              y = '\\v';
              break;

            case 38:
              0 === n + b + m && (r = I = 1, y = '\f' + y);
              break;

            case 108:
              if (0 === n + b + m + E && 0 < u) switch (l - u) {
                case 2:
                  112 === x && 58 === e.charCodeAt(l - 3) && (E = x);

                case 8:
                  111 === K && (E = K);
              }
              break;

            case 58:
              0 === n + b + m && (u = l);
              break;

            case 44:
              0 === b + v + n + m && (r = 1, y += '\r');
              break;

            case 34:
            case 39:
              0 === b && (n = n === g ? 0 : 0 === n ? g : n);
              break;

            case 91:
              0 === n + b + v && m++;
              break;

            case 93:
              0 === n + b + v && m--;
              break;

            case 41:
              0 === n + b + m && v--;
              break;

            case 40:
              if (0 === n + b + m) {
                if (0 === q) switch (2 * x + 3 * K) {
                  case 533:
                    break;

                  default:
                    q = 1;
                }
                v++;
              }

              break;

            case 64:
              0 === b + v + n + m + u + k && (k = 1);
              break;

            case 42:
            case 47:
              if (!(0 < n + m + v)) switch (b) {
                case 0:
                  switch (2 * g + 3 * e.charCodeAt(l + 1)) {
                    case 235:
                      b = 47;
                      break;

                    case 220:
                      t = l, b = 42;
                  }

                  break;

                case 42:
                  47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
              }
          }

          0 === b && (f += y);
      }

      K = x;
      x = g;
      l++;
    }

    t = p.length;

    if (0 < t) {
      r = c;
      if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
      p = r.join(',') + '{' + p + '}';

      if (0 !== w * E) {
        2 !== w || L(p, 2) || (E = 0);

        switch (E) {
          case 111:
            p = p.replace(ha, ':-moz-$1') + p;
            break;

          case 112:
            p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
        }

        E = 0;
      }
    }

    return G + p + F;
  }

  function X(d, c, e) {
    var h = c.trim().split(ia);
    c = h;
    var a = h.length,
        m = d.length;

    switch (m) {
      case 0:
      case 1:
        var b = 0;

        for (d = 0 === m ? '' : d[0] + ' '; b < a; ++b) {
          c[b] = Z(d, c[b], e).trim();
        }

        break;

      default:
        var v = b = 0;

        for (c = []; b < a; ++b) {
          for (var n = 0; n < m; ++n) {
            c[v++] = Z(d[n] + ' ', h[b], e).trim();
          }
        }

    }

    return c;
  }

  function Z(d, c, e) {
    var h = c.charCodeAt(0);
    33 > h && (h = (c = c.trim()).charCodeAt(0));

    switch (h) {
      case 38:
        return c.replace(F, '$1' + d.trim());

      case 58:
        return d.trim() + c.replace(F, '$1' + d.trim());

      default:
        if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
    }

    return d + c;
  }

  function P(d, c, e, h) {
    var a = d + ';',
        m = 2 * c + 3 * e + 4 * h;

    if (944 === m) {
      d = a.indexOf(':', 9) + 1;
      var b = a.substring(d, a.length - 1).trim();
      b = a.substring(0, d).trim() + b + ';';
      return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
    }

    if (0 === w || 2 === w && !L(a, 1)) return a;

    switch (m) {
      case 1015:
        return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;

      case 951:
        return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;

      case 963:
        return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;

      case 1009:
        if (100 !== a.charCodeAt(4)) break;

      case 969:
      case 942:
        return '-webkit-' + a + a;

      case 978:
        return '-webkit-' + a + '-moz-' + a + a;

      case 1019:
      case 983:
        return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;

      case 883:
        if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
        if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
        break;

      case 932:
        if (45 === a.charCodeAt(4)) switch (a.charCodeAt(5)) {
          case 103:
            return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;

          case 115:
            return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;

          case 98:
            return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
        }
        return '-webkit-' + a + '-ms-' + a + a;

      case 964:
        return '-webkit-' + a + '-ms-flex-' + a + a;

      case 1023:
        if (99 !== a.charCodeAt(8)) break;
        b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
        return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;

      case 1005:
        return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;

      case 1e3:
        b = a.substring(13).trim();
        c = b.indexOf('-') + 1;

        switch (b.charCodeAt(0) + b.charCodeAt(c)) {
          case 226:
            b = a.replace(G, 'tb');
            break;

          case 232:
            b = a.replace(G, 'tb-rl');
            break;

          case 220:
            b = a.replace(G, 'lr');
            break;

          default:
            return a;
        }

        return '-webkit-' + a + '-ms-' + b + a;

      case 1017:
        if (-1 === a.indexOf('sticky', 9)) break;

      case 975:
        c = (a = d).length - 10;
        b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();

        switch (m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)) {
          case 203:
            if (111 > b.charCodeAt(8)) break;

          case 115:
            a = a.replace(b, '-webkit-' + b) + ';' + a;
            break;

          case 207:
          case 102:
            a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
        }

        return a + ';';

      case 938:
        if (45 === a.charCodeAt(5)) switch (a.charCodeAt(6)) {
          case 105:
            return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;

          case 115:
            return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;

          default:
            return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
        }
        break;

      case 973:
      case 989:
        if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;

      case 931:
      case 953:
        if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
        break;

      case 962:
        if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
    }

    return a;
  }

  function L(d, c) {
    var e = d.indexOf(1 === c ? ':' : '{'),
        h = d.substring(0, 3 !== c ? e : 10);
    e = d.substring(e + 1, d.length - 1);
    return R(2 !== c ? h : h.replace(na, '$1'), e, c);
  }

  function ea(d, c) {
    var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
    return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
  }

  function H(d, c, e, h, a, m, b, v, n, q) {
    for (var g = 0, x = c, w; g < A; ++g) {
      switch (w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;

        default:
          x = w;
      }
    }

    if (x !== c) return x;
  }

  function T(d) {
    switch (d) {
      case void 0:
      case null:
        A = S.length = 0;
        break;

      default:
        if ('function' === typeof d) S[A++] = d;else if ('object' === typeof d) for (var c = 0, e = d.length; c < e; ++c) {
          T(d[c]);
        } else Y = !!d | 0;
    }

    return T;
  }

  function U(d) {
    d = d.prefix;
    void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
    return U;
  }

  function B(d, c) {
    var e = d;
    33 > e.charCodeAt(0) && (e = e.trim());
    V = e;
    e = [V];

    if (0 < A) {
      var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
      void 0 !== h && 'string' === typeof h && (c = h);
    }

    var a = M(O, e, c, 0, 0);
    0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
    V = '';
    E = 0;
    z = D = 1;
    return a;
  }

  var ca = /^\0+/g,
      N = /[\0\r\f]/g,
      aa = /: */g,
      ka = /zoo|gra/,
      ma = /([,: ])(transform)/g,
      ia = /,\r+?/g,
      F = /([\t\r\n ])*\f?&/g,
      fa = /@(k\w+)\s*(\S*)\s*/,
      Q = /::(place)/g,
      ha = /:(read-only)/g,
      G = /[svh]\w+-[tblr]{2}/,
      da = /\(\s*(.*)\s*\)/g,
      oa = /([\s\S]*?);/g,
      ba = /-self|flex-/g,
      na = /[^]*?(:[rp][el]a[\w-]+)[^]*/,
      la = /stretch|:\s*\w+\-(?:conte|avail)/,
      ja = /([^-])(image-set\()/,
      z = 1,
      D = 1,
      E = 0,
      w = 1,
      O = [],
      S = [],
      A = 0,
      R = null,
      Y = 0,
      V = '';
  B.use = T;
  B.set = U;
  void 0 !== W && U(W);
  return B;
}

/* harmony default export */ var stylis_browser_esm = (stylis_min);

;// CONCATENATED MODULE: ../../node_modules/@emotion/unitless/dist/unitless.browser.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

/* harmony default export */ var unitless_browser_esm = (unitlessKeys);

;// CONCATENATED MODULE: ../../node_modules/@emotion/memoize/dist/emotion-memoize.esm.js
function memoize(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}



;// CONCATENATED MODULE: ../../node_modules/@emotion/is-prop-valid/dist/emotion-is-prop-valid.esm.js


var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);



// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(73463);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js
/* provided dependency */ var process = __webpack_require__(93542);
function y(){return(y=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(e[r]=n[r])}return e}).apply(this,arguments)}var v=function(e,t){for(var n=[e[0]],r=0,o=t.length;r<o;r+=1)n.push(t[r],e[r+1]);return n},g=function(t){return null!==t&&"object"==typeof t&&"[object Object]"===(t.toString?t.toString():Object.prototype.toString.call(t))&&!(0,react_is.typeOf)(t)},S=Object.freeze([]),w=Object.freeze({});function E(e){return"function"==typeof e}function b(e){return false||e.displayName||e.name||"Component"}function _(e){return e&&"string"==typeof e.styledComponentId}var N="undefined"!=typeof process&&void 0!==process.env&&(process.env.REACT_APP_SC_ATTR||process.env.SC_ATTR)||"data-styled",A="5.3.11",C="undefined"!=typeof window&&"HTMLElement"in window,I=Boolean("boolean"==typeof SC_DISABLE_SPEEDY?SC_DISABLE_SPEEDY:"undefined"!=typeof process&&void 0!==process.env&&(void 0!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&""!==process.env.REACT_APP_SC_DISABLE_SPEEDY?"false"!==process.env.REACT_APP_SC_DISABLE_SPEEDY&&process.env.REACT_APP_SC_DISABLE_SPEEDY:void 0!==process.env.SC_DISABLE_SPEEDY&&""!==process.env.SC_DISABLE_SPEEDY?"false"!==process.env.SC_DISABLE_SPEEDY&&process.env.SC_DISABLE_SPEEDY:"production"!=="production")),P={},O= false?0:{};function R(){for(var e=arguments.length<=0?void 0:arguments[0],t=[],n=1,r=arguments.length;n<r;n+=1)t.push(n<0||arguments.length<=n?void 0:arguments[n]);return t.forEach((function(t){e=e.replace(/%[a-z]/,t)})),e}function D(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];throw true?new Error("An error occurred. See https://git.io/JUIaE#"+e+" for more information."+(n.length>0?" Args: "+n.join(", "):"")):0}var j=function(){function e(e){this.groupSizes=new Uint32Array(512),this.length=512,this.tag=e}var t=e.prototype;return t.indexOfGroup=function(e){for(var t=0,n=0;n<e;n++)t+=this.groupSizes[n];return t},t.insertRules=function(e,t){if(e>=this.groupSizes.length){for(var n=this.groupSizes,r=n.length,o=r;e>=o;)(o<<=1)<0&&D(16,""+e);this.groupSizes=new Uint32Array(o),this.groupSizes.set(n),this.length=o;for(var s=r;s<o;s++)this.groupSizes[s]=0}for(var i=this.indexOfGroup(e+1),a=0,c=t.length;a<c;a++)this.tag.insertRule(i,t[a])&&(this.groupSizes[e]++,i++)},t.clearGroup=function(e){if(e<this.length){var t=this.groupSizes[e],n=this.indexOfGroup(e),r=n+t;this.groupSizes[e]=0;for(var o=n;o<r;o++)this.tag.deleteRule(n)}},t.getGroup=function(e){var t="";if(e>=this.length||0===this.groupSizes[e])return t;for(var n=this.groupSizes[e],r=this.indexOfGroup(e),o=r+n,s=r;s<o;s++)t+=this.tag.getRule(s)+"/*!sc*/\n";return t},e}(),T=new Map,x=new Map,k=1,V=function(e){if(T.has(e))return T.get(e);for(;x.has(k);)k++;var t=k++;return false&&0,T.set(e,t),x.set(t,e),t},B=function(e){return x.get(e)},z=function(e,t){t>=k&&(k=t+1),T.set(e,t),x.set(t,e)},M="style["+N+'][data-styled-version="5.3.11"]',G=new RegExp("^"+N+'\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'),L=function(e,t,n){for(var r,o=n.split(","),s=0,i=o.length;s<i;s++)(r=o[s])&&e.registerName(t,r)},F=function(e,t){for(var n=(t.textContent||"").split("/*!sc*/\n"),r=[],o=0,s=n.length;o<s;o++){var i=n[o].trim();if(i){var a=i.match(G);if(a){var c=0|parseInt(a[1],10),u=a[2];0!==c&&(z(u,c),L(e,u,a[3]),e.getTag().insertRules(c,r)),r.length=0}else r.push(i)}}},Y=function(){return true?__webpack_require__.nc:0},q=function(e){var t=document.head,n=e||t,r=document.createElement("style"),o=function(e){for(var t=e.childNodes,n=t.length;n>=0;n--){var r=t[n];if(r&&1===r.nodeType&&r.hasAttribute(N))return r}}(n),s=void 0!==o?o.nextSibling:null;r.setAttribute(N,"active"),r.setAttribute("data-styled-version","5.3.11");var i=Y();return i&&r.setAttribute("nonce",i),n.insertBefore(r,s),r},H=function(){function e(e){var t=this.element=q(e);t.appendChild(document.createTextNode("")),this.sheet=function(e){if(e.sheet)return e.sheet;for(var t=document.styleSheets,n=0,r=t.length;n<r;n++){var o=t[n];if(o.ownerNode===e)return o}D(17)}(t),this.length=0}var t=e.prototype;return t.insertRule=function(e,t){try{return this.sheet.insertRule(t,e),this.length++,!0}catch(e){return!1}},t.deleteRule=function(e){this.sheet.deleteRule(e),this.length--},t.getRule=function(e){var t=this.sheet.cssRules[e];return void 0!==t&&"string"==typeof t.cssText?t.cssText:""},e}(),$=function(){function e(e){var t=this.element=q(e);this.nodes=t.childNodes,this.length=0}var t=e.prototype;return t.insertRule=function(e,t){if(e<=this.length&&e>=0){var n=document.createTextNode(t),r=this.nodes[e];return this.element.insertBefore(n,r||null),this.length++,!0}return!1},t.deleteRule=function(e){this.element.removeChild(this.nodes[e]),this.length--},t.getRule=function(e){return e<this.length?this.nodes[e].textContent:""},e}(),W=function(){function e(e){this.rules=[],this.length=0}var t=e.prototype;return t.insertRule=function(e,t){return e<=this.length&&(this.rules.splice(e,0,t),this.length++,!0)},t.deleteRule=function(e){this.rules.splice(e,1),this.length--},t.getRule=function(e){return e<this.length?this.rules[e]:""},e}(),U=C,J={isServer:!C,useCSSOMInjection:!I},X=function(){function e(e,t,n){void 0===e&&(e=w),void 0===t&&(t={}),this.options=y({},J,{},e),this.gs=t,this.names=new Map(n),this.server=!!e.isServer,!this.server&&C&&U&&(U=!1,function(e){for(var t=document.querySelectorAll(M),n=0,r=t.length;n<r;n++){var o=t[n];o&&"active"!==o.getAttribute(N)&&(F(e,o),o.parentNode&&o.parentNode.removeChild(o))}}(this))}e.registerId=function(e){return V(e)};var t=e.prototype;return t.reconstructWithOptions=function(t,n){return void 0===n&&(n=!0),new e(y({},this.options,{},t),this.gs,n&&this.names||void 0)},t.allocateGSInstance=function(e){return this.gs[e]=(this.gs[e]||0)+1},t.getTag=function(){return this.tag||(this.tag=(n=(t=this.options).isServer,r=t.useCSSOMInjection,o=t.target,e=n?new W(o):r?new H(o):new $(o),new j(e)));var e,t,n,r,o},t.hasNameForId=function(e,t){return this.names.has(e)&&this.names.get(e).has(t)},t.registerName=function(e,t){if(V(e),this.names.has(e))this.names.get(e).add(t);else{var n=new Set;n.add(t),this.names.set(e,n)}},t.insertRules=function(e,t,n){this.registerName(e,t),this.getTag().insertRules(V(e),n)},t.clearNames=function(e){this.names.has(e)&&this.names.get(e).clear()},t.clearRules=function(e){this.getTag().clearGroup(V(e)),this.clearNames(e)},t.clearTag=function(){this.tag=void 0},t.toString=function(){return function(e){for(var t=e.getTag(),n=t.length,r="",o=0;o<n;o++){var s=B(o);if(void 0!==s){var i=e.names.get(s),a=t.getGroup(o);if(i&&a&&i.size){var c=N+".g"+o+'[id="'+s+'"]',u="";void 0!==i&&i.forEach((function(e){e.length>0&&(u+=e+",")})),r+=""+a+c+'{content:"'+u+'"}/*!sc*/\n'}}}return r}(this)},e}(),Z=/(a)(d)/gi,K=function(e){return String.fromCharCode(e+(e>25?39:97))};function Q(e){var t,n="";for(t=Math.abs(e);t>52;t=t/52|0)n=K(t%52)+n;return(K(t%52)+n).replace(Z,"$1-$2")}var ee=function(e,t){for(var n=t.length;n;)e=33*e^t.charCodeAt(--n);return e},te=function(e){return ee(5381,e)};function ne(e){for(var t=0;t<e.length;t+=1){var n=e[t];if(E(n)&&!_(n))return!1}return!0}var re=te("5.3.11"),oe=function(){function e(e,t,n){this.rules=e,this.staticRulesId="",this.isStatic= true&&(void 0===n||n.isStatic)&&ne(e),this.componentId=t,this.baseHash=ee(re,t),this.baseStyle=n,X.registerId(t)}return e.prototype.generateAndInjectStyles=function(e,t,n){var r=this.componentId,o=[];if(this.baseStyle&&o.push(this.baseStyle.generateAndInjectStyles(e,t,n)),this.isStatic&&!n.hash)if(this.staticRulesId&&t.hasNameForId(r,this.staticRulesId))o.push(this.staticRulesId);else{var s=_e(this.rules,e,t,n).join(""),i=Q(ee(this.baseHash,s)>>>0);if(!t.hasNameForId(r,i)){var a=n(s,"."+i,void 0,r);t.insertRules(r,i,a)}o.push(i),this.staticRulesId=i}else{for(var c=this.rules.length,u=ee(this.baseHash,n.hash),l="",d=0;d<c;d++){var h=this.rules[d];if("string"==typeof h)l+=h, false&&(0);else if(h){var p=_e(h,e,t,n),f=Array.isArray(p)?p.join(""):p;u=ee(u,f+d),l+=f}}if(l){var m=Q(u>>>0);if(!t.hasNameForId(r,m)){var y=n(l,"."+m,void 0,r);t.insertRules(r,m,y)}o.push(m)}}return o.join(" ")},e}(),se=/^\s*\/\/.*$/gm,ie=[":","[",".","#"];function ae(e){var t,n,r,o,s=void 0===e?w:e,i=s.options,a=void 0===i?w:i,c=s.plugins,u=void 0===c?S:c,l=new stylis_browser_esm(a),d=[],p=function(e){function t(t){if(t)try{e(t+"}")}catch(e){}}return function(n,r,o,s,i,a,c,u,l,d){switch(n){case 1:if(0===l&&64===r.charCodeAt(0))return e(r+";"),"";break;case 2:if(0===u)return r+"/*|*/";break;case 3:switch(u){case 102:case 112:return e(o[0]+r),"";default:return r+(0===d?"/*|*/":"")}case-2:r.split("/*|*/}").forEach(t)}}}((function(e){d.push(e)})),f=function(e,r,s){return 0===r&&-1!==ie.indexOf(s[n.length])||s.match(o)?e:"."+t};function m(e,s,i,a){void 0===a&&(a="&");var c=e.replace(se,""),u=s&&i?i+" "+s+" { "+c+" }":c;return t=a,n=s,r=new RegExp("\\"+n+"\\b","g"),o=new RegExp("(\\"+n+"\\b){2,}"),l(i||!s?"":s,u)}return l.use([].concat(u,[function(e,t,o){2===e&&o.length&&o[0].lastIndexOf(n)>0&&(o[0]=o[0].replace(r,f))},p,function(e){if(-2===e){var t=d;return d=[],t}}])),m.hash=u.length?u.reduce((function(e,t){return t.name||D(15),ee(e,t.name)}),5381).toString():"",m}var ce=react.createContext(),ue=ce.Consumer,le=react.createContext(),de=(le.Consumer,new X),he=ae();function pe(){return (0,react.useContext)(ce)||de}function fe(){return (0,react.useContext)(le)||he}function me(e){var t=(0,react.useState)(e.stylisPlugins),n=t[0],s=t[1],c=pe(),u=(0,react.useMemo)((function(){var t=c;return e.sheet?t=e.sheet:e.target&&(t=t.reconstructWithOptions({target:e.target},!1)),e.disableCSSOMInjection&&(t=t.reconstructWithOptions({useCSSOMInjection:!1})),t}),[e.disableCSSOMInjection,e.sheet,e.target]),l=(0,react.useMemo)((function(){return ae({options:{prefix:!e.disableVendorPrefixes},plugins:n})}),[e.disableVendorPrefixes,n]);return (0,react.useEffect)((function(){shallowequal_default()(n,e.stylisPlugins)||s(e.stylisPlugins)}),[e.stylisPlugins]),react.createElement(ce.Provider,{value:u},react.createElement(le.Provider,{value:l}, false?0:e.children))}var ye=function(){function e(e,t){var n=this;this.inject=function(e,t){void 0===t&&(t=he);var r=n.name+t.hash;e.hasNameForId(n.id,r)||e.insertRules(n.id,r,t(n.rules,r,"@keyframes"))},this.toString=function(){return D(12,String(n.name))},this.name=e,this.id="sc-keyframes-"+e,this.rules=t}return e.prototype.getName=function(e){return void 0===e&&(e=he),this.name+e.hash},e}(),ve=/([A-Z])/,ge=/([A-Z])/g,Se=/^ms-/,we=function(e){return"-"+e.toLowerCase()};function Ee(e){return ve.test(e)?e.replace(ge,we).replace(Se,"-ms-"):e}var be=function(e){return null==e||!1===e||""===e};function _e(e,n,r,o){if(Array.isArray(e)){for(var s,i=[],a=0,c=e.length;a<c;a+=1)""!==(s=_e(e[a],n,r,o))&&(Array.isArray(s)?i.push.apply(i,s):i.push(s));return i}if(be(e))return"";if(_(e))return"."+e.styledComponentId;if(E(e)){if("function"!=typeof(l=e)||l.prototype&&l.prototype.isReactComponent||!n)return e;var u=e(n);return false&&0,_e(u,n,r,o)}var l;return e instanceof ye?r?(e.inject(r,o),e.getName(o)):e:g(e)?function e(t,n){var r,o,s=[];for(var i in t)t.hasOwnProperty(i)&&!be(t[i])&&(Array.isArray(t[i])&&t[i].isCss||E(t[i])?s.push(Ee(i)+":",t[i],";"):g(t[i])?s.push.apply(s,e(t[i],i)):s.push(Ee(i)+": "+(r=i,null==(o=t[i])||"boolean"==typeof o||""===o?"":"number"!=typeof o||0===o||r in unitless_browser_esm||r.startsWith("--")?String(o).trim():o+"px")+";"));return n?[n+" {"].concat(s,["}"]):s}(e):e.toString()}var Ne=function(e){return Array.isArray(e)&&(e.isCss=!0),e};function Ae(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];return E(e)||g(e)?Ne(_e(v(S,[e].concat(n)))):0===n.length&&1===e.length&&"string"==typeof e[0]?e:Ne(_e(v(e,n)))}var Ce=/invalid hook call/i,Ie=new Set,Pe=function(e,t){if(false){ var o, n, r; }},Oe=function(e,t,n){return void 0===n&&(n=w),e.theme!==n.theme&&e.theme||t||n.theme},Re=/[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g,De=/(^-|-$)/g;function je(e){return e.replace(Re,"-").replace(De,"")}var Te=function(e){return Q(te(e)>>>0)};function xe(e){return"string"==typeof e&&( true||0)}var ke=function(e){return"function"==typeof e||"object"==typeof e&&null!==e&&!Array.isArray(e)},Ve=function(e){return"__proto__"!==e&&"constructor"!==e&&"prototype"!==e};function Be(e,t,n){var r=e[n];ke(t)&&ke(r)?ze(r,t):e[n]=t}function ze(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];for(var o=0,s=n;o<s.length;o++){var i=s[o];if(ke(i))for(var a in i)Ve(a)&&Be(e,i[a],a)}return e}var Me=react.createContext(),Ge=Me.Consumer;function Le(e){var t=(0,react.useContext)(Me),n=(0,react.useMemo)((function(){return function(e,t){if(!e)return D(14);if(E(e)){var n=e(t);return true?n:0}return Array.isArray(e)||"object"!=typeof e?D(8):t?y({},t,{},e):e}(e.theme,t)}),[e.theme,t]);return e.children?react.createElement(Me.Provider,{value:n},e.children):null}var Fe={};function Ye(e,t,n){var o=_(e),i=!xe(e),a=t.attrs,c=void 0===a?S:a,l=t.componentId,d=void 0===l?function(e,t){var n="string"!=typeof e?"sc":je(e);Fe[n]=(Fe[n]||0)+1;var r=n+"-"+Te("5.3.11"+n+Fe[n]);return t?t+"-"+r:r}(t.displayName,t.parentComponentId):l,h=t.displayName,p=void 0===h?function(e){return xe(e)?"styled."+e:"Styled("+b(e)+")"}(e):h,v=t.displayName&&t.componentId?je(t.displayName)+"-"+t.componentId:t.componentId||d,g=o&&e.attrs?Array.prototype.concat(e.attrs,c).filter(Boolean):c,N=t.shouldForwardProp;o&&e.shouldForwardProp&&(N=t.shouldForwardProp?function(n,r,o){return e.shouldForwardProp(n,r,o)&&t.shouldForwardProp(n,r,o)}:e.shouldForwardProp);var A,C=new oe(n,v,o?e.componentStyle:void 0),I=C.isStatic&&0===c.length,P=function(e,t){return function(e,t,n,r){var o=e.attrs,i=e.componentStyle,a=e.defaultProps,c=e.foldedComponentIds,l=e.shouldForwardProp,d=e.styledComponentId,h=e.target,p=function(e,t,n){void 0===e&&(e=w);var r=y({},t,{theme:e}),o={};return n.forEach((function(e){var t,n,s,i=e;for(t in E(i)&&(i=i(r)),i)r[t]=o[t]="className"===t?(n=o[t],s=i[t],n&&s?n+" "+s:n||s):i[t]})),[r,o]}(Oe(t,(0,react.useContext)(Me),a)||w,t,o),m=p[0],v=p[1],g=function(e,t,n,r){var o=pe(),s=fe(),i=t?e.generateAndInjectStyles(w,o,s):e.generateAndInjectStyles(n,o,s);return false&&0,i}(i,r,m, false?0:void 0),S=n,b=v.$as||t.$as||v.as||t.as||h,_=xe(b),N=v!==t?y({},t,{},v):t,A={};for(var C in N)"$"!==C[0]&&"as"!==C&&("forwardedAs"===C?A.as=N[C]:(l?l(C,isPropValid,b):!_||isPropValid(C))&&(A[C]=N[C]));return t.style&&v.style!==t.style&&(A.style=y({},t.style,{},v.style)),A.className=Array.prototype.concat(c,d,g!==d?g:null,t.className,v.className).filter(Boolean).join(" "),A.ref=S,(0,react.createElement)(b,A)}(A,e,t,I)};return P.displayName=p,(A=react.forwardRef(P)).attrs=g,A.componentStyle=C,A.displayName=p,A.shouldForwardProp=N,A.foldedComponentIds=o?Array.prototype.concat(e.foldedComponentIds,e.styledComponentId):S,A.styledComponentId=v,A.target=o?e.target:e,A.withComponent=function(e){var r=t.componentId,o=function(e,t){if(null==e)return{};var n,r,o={},s=Object.keys(e);for(r=0;r<s.length;r++)n=s[r],t.indexOf(n)>=0||(o[n]=e[n]);return o}(t,["componentId"]),s=r&&r+"-"+(xe(e)?e:je(b(e)));return Ye(e,y({},o,{attrs:g,componentId:s}),n)},Object.defineProperty(A,"defaultProps",{get:function(){return this._foldedDefaultProps},set:function(t){this._foldedDefaultProps=o?ze({},e.defaultProps,t):t}}), false&&(0),Object.defineProperty(A,"toString",{value:function(){return"."+A.styledComponentId}}),i&&hoist_non_react_statics_cjs_default()(A,e,{attrs:!0,componentStyle:!0,displayName:!0,foldedComponentIds:!0,shouldForwardProp:!0,styledComponentId:!0,target:!0,withComponent:!0}),A}var qe=function(e){return function e(t,r,o){if(void 0===o&&(o=w),!(0,react_is.isValidElementType)(r))return D(1,String(r));var s=function(){return t(r,o,Ae.apply(void 0,arguments))};return s.withConfig=function(n){return e(t,r,y({},o,{},n))},s.attrs=function(n){return e(t,r,y({},o,{attrs:Array.prototype.concat(o.attrs,n).filter(Boolean)}))},s}(Ye,e)};["a","abbr","address","area","article","aside","audio","b","base","bdi","bdo","big","blockquote","body","br","button","canvas","caption","cite","code","col","colgroup","data","datalist","dd","del","details","dfn","dialog","div","dl","dt","em","embed","fieldset","figcaption","figure","footer","form","h1","h2","h3","h4","h5","h6","head","header","hgroup","hr","html","i","iframe","img","input","ins","kbd","keygen","label","legend","li","link","main","map","mark","marquee","menu","menuitem","meta","meter","nav","noscript","object","ol","optgroup","option","output","p","param","picture","pre","progress","q","rp","rt","ruby","s","samp","script","section","select","small","source","span","strong","style","sub","summary","sup","table","tbody","td","textarea","tfoot","th","thead","time","title","tr","track","u","ul","var","video","wbr","circle","clipPath","defs","ellipse","foreignObject","g","image","line","linearGradient","marker","mask","path","pattern","polygon","polyline","radialGradient","rect","stop","svg","text","textPath","tspan"].forEach((function(e){qe[e]=qe(e)}));var He=function(){function e(e,t){this.rules=e,this.componentId=t,this.isStatic=ne(e),X.registerId(this.componentId+1)}var t=e.prototype;return t.createStyles=function(e,t,n,r){var o=r(_e(this.rules,t,n,r).join(""),""),s=this.componentId+e;n.insertRules(s,s,o)},t.removeStyles=function(e,t){t.clearRules(this.componentId+e)},t.renderStyles=function(e,t,n,r){e>2&&X.registerId(this.componentId+e),this.removeStyles(e,n),this.createStyles(e,t,n,r)},e}();function $e(e){for(var t=arguments.length,n=new Array(t>1?t-1:0),o=1;o<t;o++)n[o-1]=arguments[o];var i=Ae.apply(void 0,[e].concat(n)),a="sc-global-"+Te(JSON.stringify(i)),u=new He(i,a);function d(e){var t=pe(),n=fe(),o=(0,react.useContext)(Me),d=(0,react.useRef)(t.allocateGSInstance(a)).current;return false&&0, false&&0,t.server&&h(d,e,t,o,n),(0,react.useLayoutEffect)((function(){if(!t.server)return h(d,e,t,o,n),function(){return u.removeStyles(d,t)}}),[d,e,t,o,n]),null}function h(e,t,n,r,o){if(u.isStatic)u.renderStyles(e,P,n,o);else{var s=y({},t,{theme:Oe(t,r,d.defaultProps)});u.renderStyles(e,s,n,o)}}return false&&0,react.memo(d)}function We(e){ false&&0;for(var t=arguments.length,n=new Array(t>1?t-1:0),r=1;r<t;r++)n[r-1]=arguments[r];var o=Ae.apply(void 0,[e].concat(n)).join(""),s=Te(o);return new ye(s,o)}var Ue=function(){function e(){var e=this;this._emitSheetCSS=function(){var t=e.instance.toString();if(!t)return"";var n=Y();return"<style "+[n&&'nonce="'+n+'"',N+'="true"','data-styled-version="5.3.11"'].filter(Boolean).join(" ")+">"+t+"</style>"},this.getStyleTags=function(){return e.sealed?D(2):e._emitSheetCSS()},this.getStyleElement=function(){var t;if(e.sealed)return D(2);var n=((t={})[N]="",t["data-styled-version"]="5.3.11",t.dangerouslySetInnerHTML={__html:e.instance.toString()},t),o=Y();return o&&(n.nonce=o),[react.createElement("style",y({},n,{key:"sc-0-0"}))]},this.seal=function(){e.sealed=!0},this.instance=new X({isServer:!0}),this.sealed=!1}var t=e.prototype;return t.collectStyles=function(e){return this.sealed?D(2):react.createElement(me,{sheet:this.instance},e)},t.interleaveWithNodeStream=function(e){return D(3)},e}(),Je=function(e){var t=react.forwardRef((function(t,n){var o=(0,react.useContext)(Me),i=e.defaultProps,a=Oe(t,o,i);return false&&0,react.createElement(e,y({},t,{theme:a,ref:n}))}));return hoist_non_react_statics_cjs_default()(t,e),t.displayName="WithTheme("+b(e)+")",t},Xe=function(){return (0,react.useContext)(Me)},Ze={StyleSheet:X,masterSheet:de}; false&&0, false&&(0);/* harmony default export */ var styled_components_browser_esm = (qe);
//# sourceMappingURL=styled-components.browser.esm.js.map


/***/ }),

/***/ 8459:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ io_22ea0cf9_all; },
  "A": function() { return /* binding */ ALL; },
  "B": function() { return /* binding */ compose; },
  "C": function() { return /* binding */ CALL; },
  "D": function() { return /* binding */ logError; },
  "E": function() { return /* binding */ wrapSagaDispatch; },
  "F": function() { return /* binding */ FORK; },
  "G": function() { return /* binding */ GET_CONTEXT; },
  "H": function() { return /* binding */ identity; },
  "J": function() { return /* binding */ JOIN; },
  "L": function() { return /* binding */ take; },
  "M": function() { return /* binding */ fork; },
  "N": function() { return /* binding */ cancel; },
  "O": function() { return /* binding */ call; },
  "P": function() { return /* binding */ PUT; },
  "Q": function() { return /* binding */ delay; },
  "R": function() { return /* binding */ RACE; },
  "S": function() { return /* binding */ SELECT; },
  "T": function() { return /* binding */ TAKE; },
  "U": function() { return /* binding */ actionChannel; },
  "V": function() { return /* binding */ sliding; },
  "W": function() { return /* binding */ race; },
  "Z": function() { return /* binding */ put; },
  "a": function() { return /* binding */ CPS; },
  "a4": function() { return /* binding */ io_22ea0cf9_select; },
  "b": function() { return /* binding */ CANCEL; },
  "d": function() { return /* binding */ ACTION_CHANNEL; },
  "e": function() { return /* binding */ expanding; },
  "f": function() { return /* binding */ CANCELLED; },
  "g": function() { return /* binding */ FLUSH; },
  "h": function() { return /* binding */ SET_CONTEXT; },
  "i": function() { return /* binding */ internalErr; },
  "j": function() { return /* binding */ getMetaInfo; },
  "k": function() { return /* binding */ kTrue; },
  "l": function() { return /* binding */ createAllStyleChildCallbacks; },
  "m": function() { return /* binding */ createEmptyArray; },
  "o": function() { return /* binding */ once; },
  "p": function() { return /* binding */ assignWithSymbols; },
  "q": function() { return /* binding */ makeIterator; },
  "r": function() { return /* binding */ remove; },
  "s": function() { return /* binding */ shouldComplete; },
  "t": function() { return /* binding */ noop; },
  "u": function() { return /* binding */ flatMap; },
  "v": function() { return /* binding */ getLocation; },
  "y": function() { return /* binding */ shouldCancel; },
  "z": function() { return /* binding */ shouldTerminate; }
});

// UNUSED EXPORTS: I, K, X, Y, _, a0, a1, a2, a3, a5, a6, a7, a8, c, n, w, x

// EXTERNAL MODULE: ../../node_modules/@redux-saga/symbols/dist/redux-saga-symbols.esm.js
var redux_saga_symbols_esm = __webpack_require__(23143);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@redux-saga/is/dist/redux-saga-is.esm.js
var redux_saga_is_esm = __webpack_require__(83594);
;// CONCATENATED MODULE: ../../node_modules/@redux-saga/delay-p/dist/redux-saga-delay-p.esm.js


var MAX_SIGNED_INT = 2147483647;
function delayP(ms, val) {
  if (val === void 0) {
    val = true;
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/setTimeout#maximum_delay_value
  if (false) {}

  var timeoutId;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(resolve, Math.min(MAX_SIGNED_INT, ms), val);
  });

  promise[redux_saga_symbols_esm/* CANCEL */.n1] = function () {
    clearTimeout(timeoutId);
  };

  return promise;
}

/* harmony default export */ var redux_saga_delay_p_esm = (delayP);

;// CONCATENATED MODULE: ../../node_modules/@redux-saga/core/dist/io-22ea0cf9.js





var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue =
/*#__PURE__*/
konst(true);

var noop = function noop() {};

if (false) {}
var identity = function identity(v) {
  return v;
};
var hasSymbol = typeof Symbol === 'function';
var asyncIteratorSymbol = hasSymbol && Symbol.asyncIterator ? Symbol.asyncIterator : '@@asyncIterator';
function check(value, predicate, error) {
  if (!predicate(value)) {
    throw new Error(error);
  }
}
var assignWithSymbols = function assignWithSymbols(target, source) {
  (0,esm_extends/* default */.Z)(target, source);

  if (Object.getOwnPropertySymbols) {
    Object.getOwnPropertySymbols(source).forEach(function (s) {
      target[s] = source[s];
    });
  }
};
var flatMap = function flatMap(mapper, arr) {
  var _ref;

  return (_ref = []).concat.apply(_ref, arr.map(mapper));
};
function remove(array, item) {
  var index = array.indexOf(item);

  if (index >= 0) {
    array.splice(index, 1);
  }
}
function once(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }

    called = true;
    fn();
  };
}

var kThrow = function kThrow(err) {
  throw err;
};

var kReturn = function kReturn(value) {
  return {
    value: value,
    done: true
  };
};

function makeIterator(next, thro, name) {
  if (thro === void 0) {
    thro = kThrow;
  }

  if (name === void 0) {
    name = 'iterator';
  }

  var iterator = {
    meta: {
      name: name
    },
    next: next,
    throw: thro,
    return: kReturn,
    isSagaIterator: true
  };

  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }

  return iterator;
}
function logError(error, _ref2) {
  var sagaStack = _ref2.sagaStack;

  /*eslint-disable no-console*/
  console.error(error);
  console.error(sagaStack);
}
var internalErr = function internalErr(err) {
  return new Error("\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.\n  Error: " + err + "\n");
};
var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + "setContext(props): argument " + props + " is not a plain object";
};
var FROZEN_ACTION_ERROR = "You can't put (a.k.a. dispatch from saga) frozen actions.\nWe have to define a special non-enumerable property on those actions for scheduling purposes.\nOtherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).\nIf you are using redux and you care about this behaviour (frozen actions),\nthen you might want to switch to freezing actions in a middleware rather than in action creator.\nExample implementation:\n\nconst freezeActions = store => next => action => next(Object.freeze(action))\n"; // creates empty, but not-holey array

var createEmptyArray = function createEmptyArray(n) {
  return Array.apply(null, new Array(n));
};
var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    if (false) {}

    return dispatch(Object.defineProperty(action, redux_saga_symbols_esm/* SAGA_ACTION */.Nm, {
      value: true
    }));
  };
};
var shouldTerminate = function shouldTerminate(res) {
  return res === redux_saga_symbols_esm/* TERMINATE */.EO;
};
var shouldCancel = function shouldCancel(res) {
  return res === redux_saga_symbols_esm/* TASK_CANCEL */.Wd;
};
var shouldComplete = function shouldComplete(res) {
  return shouldTerminate(res) || shouldCancel(res);
};
function createAllStyleChildCallbacks(shape, parentCallback) {
  var keys = Object.keys(shape);
  var totalCount = keys.length;

  if (false) {}

  var completedCount = 0;
  var completed;
  var results = (0,redux_saga_is_esm/* array */.IX)(shape) ? createEmptyArray(totalCount) : {};
  var childCallbacks = {};

  function checkEnd() {
    if (completedCount === totalCount) {
      completed = true;
      parentCallback(results);
    }
  }

  keys.forEach(function (key) {
    var chCbAtKey = function chCbAtKey(res, isErr) {
      if (completed) {
        return;
      }

      if (isErr || shouldComplete(res)) {
        parentCallback.cancel();
        parentCallback(res, isErr);
      } else {
        results[key] = res;
        completedCount++;
        checkEnd();
      }
    };

    chCbAtKey.cancel = noop;
    childCallbacks[key] = chCbAtKey;
  });

  parentCallback.cancel = function () {
    if (!completed) {
      completed = true;
      keys.forEach(function (key) {
        return childCallbacks[key].cancel();
      });
    }
  };

  return childCallbacks;
}
function getMetaInfo(fn) {
  return {
    name: fn.name || 'anonymous',
    location: getLocation(fn)
  };
}
function getLocation(instrumented) {
  return instrumented[redux_saga_symbols_esm/* SAGA_LOCATION */.b_];
}
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

var BUFFER_OVERFLOW = "Channel's Buffer overflow!";
var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;
var zeroBuffer = {
  isEmpty: kTrue,
  put: noop,
  take: noop
};

function ringBuffer(limit, overflowAction) {
  if (limit === void 0) {
    limit = 10;
  }

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];

    while (length) {
      items.push(take());
    }

    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit;

        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);

          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;

          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;
            arr = flush();
            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;
            arr.length = doubledLimit;
            limit = doubledLimit;
            push(it);
            break;

          default: // DROP

        }
      }
    },
    take: take,
    flush: flush
  };
}

var none = function none() {
  return zeroBuffer;
};
var fixed = function fixed(limit) {
  return ringBuffer(limit, ON_OVERFLOW_THROW);
};
var dropping = function dropping(limit) {
  return ringBuffer(limit, ON_OVERFLOW_DROP);
};
var sliding = function sliding(limit) {
  return ringBuffer(limit, ON_OVERFLOW_SLIDE);
};
var expanding = function expanding(initialSize) {
  return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
};

var buffers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  none: none,
  fixed: fixed,
  dropping: dropping,
  sliding: sliding,
  expanding: expanding
});

var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var effectTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TAKE: TAKE,
  PUT: PUT,
  ALL: ALL,
  RACE: RACE,
  CALL: CALL,
  CPS: CPS,
  FORK: FORK,
  JOIN: JOIN,
  CANCEL: CANCEL,
  SELECT: SELECT,
  ACTION_CHANNEL: ACTION_CHANNEL,
  CANCELLED: CANCELLED,
  FLUSH: FLUSH,
  GET_CONTEXT: GET_CONTEXT,
  SET_CONTEXT: SET_CONTEXT
});

var TEST_HINT = '\n(HINT: if you are getting these errors in tests, consider using createMockTask from @redux-saga/testing-utils)';

var makeEffect = function makeEffect(type, payload) {
  var _ref;

  return _ref = {}, _ref[redux_saga_symbols_esm.IO] = true, _ref.combinator = false, _ref.type = type, _ref.payload = payload, _ref;
};

var isForkEffect = function isForkEffect(eff) {
  return effect(eff) && eff.type === FORK;
};

var detach = function detach(eff) {
  if (false) {}

  return makeEffect(FORK, _extends({}, eff.payload, {
    detached: true
  }));
};
function take(patternOrChannel, multicastPattern) {
  if (patternOrChannel === void 0) {
    patternOrChannel = '*';
  }

  if (false) {}

  if ((0,redux_saga_is_esm/* pattern */.uj)(patternOrChannel)) {
    if ((0,redux_saga_is_esm/* notUndef */.d5)(multicastPattern)) {
      /* eslint-disable no-console */
      console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types");
    }

    return makeEffect(TAKE, {
      pattern: patternOrChannel
    });
  }

  if ((0,redux_saga_is_esm/* multicast */.Om)(patternOrChannel) && (0,redux_saga_is_esm/* notUndef */.d5)(multicastPattern) && (0,redux_saga_is_esm/* pattern */.uj)(multicastPattern)) {
    return makeEffect(TAKE, {
      channel: patternOrChannel,
      pattern: multicastPattern
    });
  }

  if ((0,redux_saga_is_esm/* channel */.CE)(patternOrChannel)) {
    if ((0,redux_saga_is_esm/* notUndef */.d5)(multicastPattern)) {
      /* eslint-disable no-console */
      console.warn("take(channel) takes one argument but two were provided. Second argument is ignored.");
    }

    return makeEffect(TAKE, {
      channel: patternOrChannel
    });
  }

  if (false) {}
}
var takeMaybe = function takeMaybe() {
  var eff = take.apply(void 0, arguments);
  eff.payload.maybe = true;
  return eff;
};
function put(channel$1, action) {
  if (false) {}

  if ((0,redux_saga_is_esm/* undef */.sR)(action)) {
    action = channel$1; // `undefined` instead of `null` to make default parameter work

    channel$1 = undefined;
  }

  return makeEffect(PUT, {
    channel: channel$1,
    action: action
  });
}
var putResolve = function putResolve() {
  var eff = put.apply(void 0, arguments);
  eff.payload.resolve = true;
  return eff;
};
function io_22ea0cf9_all(effects) {
  var eff = makeEffect(ALL, effects);
  eff.combinator = true;
  return eff;
}
function race(effects) {
  var eff = makeEffect(RACE, effects);
  eff.combinator = true;
  return eff;
} // this match getFnCallDescriptor logic

var validateFnDescriptor = function validateFnDescriptor(effectName, fnDescriptor) {
  check(fnDescriptor, notUndef, effectName + ": argument fn is undefined or null");

  if (func(fnDescriptor)) {
    return;
  }

  var context = null;
  var fn;

  if (array(fnDescriptor)) {
    context = fnDescriptor[0];
    fn = fnDescriptor[1];
    check(fn, notUndef, effectName + ": argument of type [context, fn] has undefined or null `fn`");
  } else if (object(fnDescriptor)) {
    context = fnDescriptor.context;
    fn = fnDescriptor.fn;
    check(fn, notUndef, effectName + ": argument of type {context, fn} has undefined or null `fn`");
  } else {
    check(fnDescriptor, func, effectName + ": argument fn is not function");
    return;
  }

  if (context && string(fn)) {
    check(context[fn], func, effectName + ": context arguments has no such method - \"" + fn + "\"");
    return;
  }

  check(fn, func, effectName + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
};

function getFnCallDescriptor(fnDescriptor, args) {
  var context = null;
  var fn;

  if ((0,redux_saga_is_esm/* func */.Yl)(fnDescriptor)) {
    fn = fnDescriptor;
  } else {
    if ((0,redux_saga_is_esm/* array */.IX)(fnDescriptor)) {
      context = fnDescriptor[0];
      fn = fnDescriptor[1];
    } else {
      context = fnDescriptor.context;
      fn = fnDescriptor.fn;
    }

    if (context && (0,redux_saga_is_esm/* string */.Z_)(fn) && (0,redux_saga_is_esm/* func */.Yl)(context[fn])) {
      fn = context[fn];
    }
  }

  return {
    context: context,
    fn: fn,
    args: args
  };
}

var isNotDelayEffect = function isNotDelayEffect(fn) {
  return fn !== delay;
};

function call(fnDescriptor) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (false) { var arg0; }

  return makeEffect(CALL, getFnCallDescriptor(fnDescriptor, args));
}
function apply(context, fn, args) {
  if (args === void 0) {
    args = [];
  }

  var fnDescriptor = [context, fn];

  if (false) {}

  return makeEffect(CALL, getFnCallDescriptor([context, fn], args));
}
function cps(fnDescriptor) {
  if (false) {}

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return makeEffect(CPS, getFnCallDescriptor(fnDescriptor, args));
}
function fork(fnDescriptor) {
  if (false) {}

  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return makeEffect(FORK, getFnCallDescriptor(fnDescriptor, args));
}
function spawn(fnDescriptor) {
  if (false) {}

  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(fork.apply(void 0, [fnDescriptor].concat(args)));
}
function join(taskOrTasks) {
  if (false) {}

  return makeEffect(JOIN, taskOrTasks);
}
function cancel(taskOrTasks) {
  if (taskOrTasks === void 0) {
    taskOrTasks = redux_saga_symbols_esm/* SELF_CANCELLATION */.sC;
  }

  if (false) {}

  return makeEffect(CANCEL, taskOrTasks);
}
function io_22ea0cf9_select(selector) {
  if (selector === void 0) {
    selector = identity;
  }

  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  if (false) {}

  return makeEffect(SELECT, {
    selector: selector,
    args: args
  });
}
/**
  channel(pattern, [buffer])    => creates a proxy channel for store actions
**/

function actionChannel(pattern$1, buffer$1) {
  if (false) {}

  return makeEffect(ACTION_CHANNEL, {
    pattern: pattern$1,
    buffer: buffer$1
  });
}
function cancelled() {
  return makeEffect(CANCELLED, {});
}
function flush(channel$1) {
  if (false) {}

  return makeEffect(FLUSH, channel$1);
}
function getContext(prop) {
  if (false) {}

  return makeEffect(GET_CONTEXT, prop);
}
function setContext(props) {
  if (false) {}

  return makeEffect(SET_CONTEXT, props);
}
var delay =
/*#__PURE__*/
call.bind(null, redux_saga_delay_p_esm);




/***/ }),

/***/ 83594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CE": function() { return /* binding */ channel; },
/* harmony export */   "IX": function() { return /* binding */ array; },
/* harmony export */   "MC": function() { return /* binding */ promise; },
/* harmony export */   "NA": function() { return /* binding */ symbol; },
/* harmony export */   "Om": function() { return /* binding */ multicast; },
/* harmony export */   "Yl": function() { return /* binding */ func; },
/* harmony export */   "Z_": function() { return /* binding */ string; },
/* harmony export */   "d5": function() { return /* binding */ notUndef; },
/* harmony export */   "eR": function() { return /* binding */ stringableFunc; },
/* harmony export */   "hZ": function() { return /* binding */ iterator; },
/* harmony export */   "sR": function() { return /* binding */ undef; },
/* harmony export */   "uj": function() { return /* binding */ pattern; }
/* harmony export */ });
/* unused harmony exports buffer, effect, iterable, number, object, observable, sagaAction, task */
/* harmony import */ var _redux_saga_symbols__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23143);


var undef = function undef(v) {
  return v === null || v === undefined;
};
var notUndef = function notUndef(v) {
  return v !== null && v !== undefined;
};
var func = function func(f) {
  return typeof f === 'function';
};
var number = function number(n) {
  return typeof n === 'number';
};
var string = function string(s) {
  return typeof s === 'string';
};
var array = Array.isArray;
var object = function object(obj) {
  return obj && !array(obj) && typeof obj === 'object';
};
var promise = function promise(p) {
  return p && func(p.then);
};
var iterator = function iterator(it) {
  return it && func(it.next) && func(it.throw);
};
var iterable = function iterable(it) {
  return it && func(Symbol) ? func(it[Symbol.iterator]) : array(it);
};
var task = function task(t) {
  return t && t[TASK];
};
var sagaAction = function sagaAction(a) {
  return Boolean(a && a[SAGA_ACTION]);
};
var observable = function observable(ob) {
  return ob && func(ob.subscribe);
};
var buffer = function buffer(buf) {
  return buf && func(buf.isEmpty) && func(buf.take) && func(buf.put);
};
var pattern = function pattern(pat) {
  return pat && (string(pat) || symbol(pat) || func(pat) || array(pat) && pat.every(pattern));
};
var channel = function channel(ch) {
  return ch && func(ch.take) && func(ch.close);
};
var stringableFunc = function stringableFunc(f) {
  return func(f) && f.hasOwnProperty('toString');
};
var symbol = function symbol(sym) {
  return Boolean(sym) && typeof Symbol === 'function' && sym.constructor === Symbol && sym !== Symbol.prototype;
};
var multicast = function multicast(ch) {
  return channel(ch) && ch[_redux_saga_symbols__WEBPACK_IMPORTED_MODULE_0__/* .MULTICAST */ .AS];
};
var effect = function effect(eff) {
  return eff && eff[IO];
};




/***/ }),

/***/ 23143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AS": function() { return /* binding */ MULTICAST; },
/* harmony export */   "Cs": function() { return /* binding */ TASK; },
/* harmony export */   "EO": function() { return /* binding */ TERMINATE; },
/* harmony export */   "IO": function() { return /* binding */ IO; },
/* harmony export */   "Nm": function() { return /* binding */ SAGA_ACTION; },
/* harmony export */   "Wd": function() { return /* binding */ TASK_CANCEL; },
/* harmony export */   "b_": function() { return /* binding */ SAGA_LOCATION; },
/* harmony export */   "n1": function() { return /* binding */ CANCEL; },
/* harmony export */   "sC": function() { return /* binding */ SELF_CANCELLATION; },
/* harmony export */   "sZ": function() { return /* binding */ CHANNEL_END_TYPE; },
/* harmony export */   "uq": function() { return /* binding */ MATCH; }
/* harmony export */ });
var createSymbol = function createSymbol(name) {
  return "@@redux-saga/" + name;
};

var CANCEL =
/*#__PURE__*/
createSymbol('CANCEL_PROMISE');
var CHANNEL_END_TYPE =
/*#__PURE__*/
createSymbol('CHANNEL_END');
var IO =
/*#__PURE__*/
createSymbol('IO');
var MATCH =
/*#__PURE__*/
createSymbol('MATCH');
var MULTICAST =
/*#__PURE__*/
createSymbol('MULTICAST');
var SAGA_ACTION =
/*#__PURE__*/
createSymbol('SAGA_ACTION');
var SELF_CANCELLATION =
/*#__PURE__*/
createSymbol('SELF_CANCELLATION');
var TASK =
/*#__PURE__*/
createSymbol('TASK');
var TASK_CANCEL =
/*#__PURE__*/
createSymbol('TASK_CANCEL');
var TERMINATE =
/*#__PURE__*/
createSymbol('TERMINATE');
var SAGA_LOCATION =
/*#__PURE__*/
createSymbol('LOCATION');




/***/ }),

/***/ 66417:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ DEFAULT_ENVIRONMENT; }
/* harmony export */ });
const DEFAULT_ENVIRONMENT = 'production';


//# sourceMappingURL=constants.js.map


/***/ }),

/***/ 73232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);


//# sourceMappingURL=debug-build.js.map


/***/ }),

/***/ 8589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RP": function() { return /* binding */ notifyEventProcessors; },
/* harmony export */   "cc": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "fH": function() { return /* binding */ getGlobalEventProcessors; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90063);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97946);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58536);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81757);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73232);



/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */
function getGlobalEventProcessors() {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .YO)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */
function addGlobalEventProcessor(callback) {
  // eslint-disable-next-line deprecation/deprecation
  getGlobalEventProcessors().push(callback);
}

/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */
function notifyEventProcessors(
  processors,
  event,
  hint,
  index = 0,
) {
  return new _sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .SyncPromise */ .cW((resolve, reject) => {
    const processor = processors[index];
    if (event === null || typeof processor !== 'function') {
      resolve(event);
    } else {
      const result = processor({ ...event }, hint) ;

      _debug_build_js__WEBPACK_IMPORTED_MODULE_2__/* .DEBUG_BUILD */ .X && processor.id && result === null && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`Event processor "${processor.id}" dropped event`);

      if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .isThenable */ .J8)(result)) {
        void result
          .then(final => notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
          .then(null, reject);
      } else {
        void notifyEventProcessors(processors, result, hint, index + 1)
          .then(resolve)
          .then(null, reject);
      }
    }
  });
}


//# sourceMappingURL=eventProcessors.js.map


/***/ }),

/***/ 92642:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ withScope; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "YA": function() { return /* binding */ setTag; },
/* harmony export */   "cg": function() { return /* binding */ captureSession; },
/* harmony export */   "e": function() { return /* binding */ configureScope; },
/* harmony export */   "eN": function() { return /* binding */ captureEvent; },
/* harmony export */   "nZ": function() { return /* binding */ getCurrentScope; },
/* harmony export */   "n_": function() { return /* binding */ addBreadcrumb; },
/* harmony export */   "s3": function() { return /* binding */ getClient; },
/* harmony export */   "uT": function() { return /* binding */ captureMessage; },
/* harmony export */   "yj": function() { return /* binding */ startSession; }
/* harmony export */ });
/* unused harmony exports captureCheckIn, close, endSession, flush, isInitialized, lastEventId, setContext, setExtra, setExtras, setTags, setUser, startTransaction, withActiveSpan, withIsolationScope, withMonitor */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90063);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66417);
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66465);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48364);
/* harmony import */ var _utils_prepareEvent_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48738);







/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */
function captureException(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  exception,
  hint,
) {
  // eslint-disable-next-line deprecation/deprecation
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureException(exception, (0,_utils_prepareEvent_js__WEBPACK_IMPORTED_MODULE_1__/* .parseEventHintOrCaptureContext */ .U0)(hint));
}

/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */
function captureMessage(
  message,
  // eslint-disable-next-line deprecation/deprecation
  captureContext,
) {
  // This is necessary to provide explicit scopes upgrade, without changing the original
  // arity of the `captureMessage(message, level)` method.
  const level = typeof captureContext === 'string' ? captureContext : undefined;
  const context = typeof captureContext !== 'string' ? { captureContext } : undefined;
  // eslint-disable-next-line deprecation/deprecation
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureMessage(message, level, context);
}

/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */
function captureEvent(event, hint) {
  // eslint-disable-next-line deprecation/deprecation
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureEvent(event, hint);
}

/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */
// eslint-disable-next-line deprecation/deprecation
function configureScope(callback) {
  // eslint-disable-next-line deprecation/deprecation
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().configureScope(callback);
}

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
// eslint-disable-next-line deprecation/deprecation
function addBreadcrumb(breadcrumb, hint) {
  // eslint-disable-next-line deprecation/deprecation
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().addBreadcrumb(breadcrumb, hint);
}

/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function setContext(name, context) {
  // eslint-disable-next-line deprecation/deprecation
  getCurrentHub().setContext(name, context);
}

/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
// eslint-disable-next-line deprecation/deprecation
function setExtras(extras) {
  // eslint-disable-next-line deprecation/deprecation
  getCurrentHub().setExtras(extras);
}

/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line deprecation/deprecation
function setExtra(key, extra) {
  // eslint-disable-next-line deprecation/deprecation
  getCurrentHub().setExtra(key, extra);
}

/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
// eslint-disable-next-line deprecation/deprecation
function setTags(tags) {
  // eslint-disable-next-line deprecation/deprecation
  getCurrentHub().setTags(tags);
}

/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
// eslint-disable-next-line deprecation/deprecation
function setTag(key, value) {
  // eslint-disable-next-line deprecation/deprecation
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().setTag(key, value);
}

/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
// eslint-disable-next-line deprecation/deprecation
function setUser(user) {
  // eslint-disable-next-line deprecation/deprecation
  getCurrentHub().setUser(user);
}

/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */

/**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */
function withScope(
  ...rest
) {
  // eslint-disable-next-line deprecation/deprecation
  const hub = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();

  // If a scope is defined, we want to make this the active scope instead of the default one
  if (rest.length === 2) {
    const [scope, callback] = rest;
    if (!scope) {
      // eslint-disable-next-line deprecation/deprecation
      return hub.withScope(callback);
    }

    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(() => {
      // eslint-disable-next-line deprecation/deprecation
      hub.getStackTop().scope = scope ;
      return callback(scope );
    });
  }

  // eslint-disable-next-line deprecation/deprecation
  return hub.withScope(rest[0]);
}

/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */
function withIsolationScope(callback) {
  return runWithAsyncContext(() => {
    return callback(getIsolationScope());
  });
}

/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */
function withActiveSpan(span, callback) {
  return withScope(scope => {
    // eslint-disable-next-line deprecation/deprecation
    scope.setSpan(span);
    return callback(scope);
  });
}

/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */
function startTransaction(
  context,
  customSamplingContext,
  // eslint-disable-next-line deprecation/deprecation
) {
  // eslint-disable-next-line deprecation/deprecation
  return getCurrentHub().startTransaction({ ...context }, customSamplingContext);
}

/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */
function captureCheckIn(checkIn, upsertMonitorConfig) {
  const scope = getCurrentScope();
  const client = getClient();
  if (!client) {
    DEBUG_BUILD && logger.warn('Cannot capture check-in. No client defined.');
  } else if (!client.captureCheckIn) {
    DEBUG_BUILD && logger.warn('Cannot capture check-in. Client does not support sending check-ins.');
  } else {
    return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
  }

  return uuid4();
}

/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */
function withMonitor(
  monitorSlug,
  callback,
  upsertMonitorConfig,
) {
  const checkInId = captureCheckIn({ monitorSlug, status: 'in_progress' }, upsertMonitorConfig);
  const now = timestampInSeconds();

  function finishCheckIn(status) {
    captureCheckIn({ monitorSlug, status, checkInId, duration: timestampInSeconds() - now });
  }

  let maybePromiseResult;
  try {
    maybePromiseResult = callback();
  } catch (e) {
    finishCheckIn('error');
    throw e;
  }

  if (isThenable(maybePromiseResult)) {
    Promise.resolve(maybePromiseResult).then(
      () => {
        finishCheckIn('ok');
      },
      () => {
        finishCheckIn('error');
      },
    );
  } else {
    finishCheckIn('ok');
  }

  return maybePromiseResult;
}

/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
async function flush(timeout) {
  const client = getClient();
  if (client) {
    return client.flush(timeout);
  }
  DEBUG_BUILD && logger.warn('Cannot flush events. No client defined.');
  return Promise.resolve(false);
}

/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
async function close(timeout) {
  const client = getClient();
  if (client) {
    return client.close(timeout);
  }
  DEBUG_BUILD && logger.warn('Cannot flush events and disable SDK. No client defined.');
  return Promise.resolve(false);
}

/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
  // eslint-disable-next-line deprecation/deprecation
  return getCurrentHub().lastEventId();
}

/**
 * Get the currently active client.
 */
function getClient() {
  // eslint-disable-next-line deprecation/deprecation
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
}

/**
 * Returns true if Sentry has been properly initialized.
 */
function isInitialized() {
  return !!getClient();
}

/**
 * Get the currently active scope.
 */
function getCurrentScope() {
  // eslint-disable-next-line deprecation/deprecation
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getScope();
}

/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */
function startSession(context) {
  const client = getClient();
  const isolationScope = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
  const currentScope = getCurrentScope();

  const { release, environment = _constants_js__WEBPACK_IMPORTED_MODULE_2__/* .DEFAULT_ENVIRONMENT */ .J } = (client && client.getOptions()) || {};

  // Will fetch userAgent if called from browser sdk
  const { userAgent } = _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {};

  const session = (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .makeSession */ .Hv)({
    release,
    environment,
    user: currentScope.getUser() || isolationScope.getUser(),
    ...(userAgent && { userAgent }),
    ...context,
  });

  // End existing session if there's one
  const currentSession = isolationScope.getSession();
  if (currentSession && currentSession.status === 'ok') {
    (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .updateSession */ .CT)(currentSession, { status: 'exited' });
  }

  endSession();

  // Afterwards we set the new session on the scope
  isolationScope.setSession(session);

  // TODO (v8): Remove this and only use the isolation scope(?).
  // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
  currentScope.setSession(session);

  return session;
}

/**
 * End the session on the current isolation scope.
 */
function endSession() {
  const isolationScope = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
  const currentScope = getCurrentScope();

  const session = currentScope.getSession() || isolationScope.getSession();
  if (session) {
    (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .closeSession */ .RJ)(session);
  }
  _sendSessionUpdate();

  // the session is over; take it off of the scope
  isolationScope.setSession();

  // TODO (v8): Remove this and only use the isolation scope(?).
  // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
  currentScope.setSession();
}

/**
 * Sends the current Session on the scope
 */
function _sendSessionUpdate() {
  const isolationScope = (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getIsolationScope */ .aF)();
  const currentScope = getCurrentScope();
  const client = getClient();
  // TODO (v8): Remove currentScope and only use the isolation scope(?).
  // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
  const session = currentScope.getSession() || isolationScope.getSession();
  if (session && client && client.captureSession) {
    client.captureSession(session);
  }
}

/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */
function captureSession(end = false) {
  // both send the update and pull the session from the scope
  if (end) {
    endSession();
    return;
  }

  // only send the update
  _sendSessionUpdate();
}


//# sourceMappingURL=exports.js.map


/***/ }),

/***/ 66465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ getCurrentHub; },
/* harmony export */   "aF": function() { return /* binding */ getIsolationScope; },
/* harmony export */   "cu": function() { return /* binding */ getMainCarrier; }
/* harmony export */ });
/* unused harmony exports API_VERSION, Hub, ensureHubOnCarrier, getHubFromCarrier, makeMain, runWithAsyncContext, setAsyncContextStrategy, setHubOnCarrier */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81757);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63699);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7790);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(58536);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(90063);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66417);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(73232);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51877);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48364);
/* harmony import */ var _version_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91476);







/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
const API_VERSION = parseFloat(_version_js__WEBPACK_IMPORTED_MODULE_0__/* .SDK_VERSION */ .J);

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;

/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */
// eslint-disable-next-line deprecation/deprecation
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */

  /** Contains the last event id of a captured event.  */

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */
   constructor(
    client,
    scope,
    isolationScope,
      _version = API_VERSION,
  ) {this._version = _version;
    let assignedScope;
    if (!scope) {
      assignedScope = new _scope_js__WEBPACK_IMPORTED_MODULE_1__/* .Scope */ .sX();
      assignedScope.setClient(client);
    } else {
      assignedScope = scope;
    }

    let assignedIsolationScope;
    if (!isolationScope) {
      assignedIsolationScope = new _scope_js__WEBPACK_IMPORTED_MODULE_1__/* .Scope */ .sX();
      assignedIsolationScope.setClient(client);
    } else {
      assignedIsolationScope = isolationScope;
    }

    this._stack = [{ scope: assignedScope }];

    if (client) {
      // eslint-disable-next-line deprecation/deprecation
      this.bindClient(client);
    }

    this._isolationScope = assignedIsolationScope;
  }

  /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */
   bindClient(client) {
    // eslint-disable-next-line deprecation/deprecation
    const top = this.getStackTop();
    top.client = client;
    top.scope.setClient(client);
    // eslint-disable-next-line deprecation/deprecation
    if (client && client.setupIntegrations) {
      // eslint-disable-next-line deprecation/deprecation
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */
   pushScope() {
    // We want to clone the content of prev scope
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.getScope().clone();
    // eslint-disable-next-line deprecation/deprecation
    this.getStack().push({
      // eslint-disable-next-line deprecation/deprecation
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */
   popScope() {
    // eslint-disable-next-line deprecation/deprecation
    if (this.getStack().length <= 1) return false;
    // eslint-disable-next-line deprecation/deprecation
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */
   withScope(callback) {
    // eslint-disable-next-line deprecation/deprecation
    const scope = this.pushScope();

    let maybePromiseResult;
    try {
      maybePromiseResult = callback(scope);
    } catch (e) {
      // eslint-disable-next-line deprecation/deprecation
      this.popScope();
      throw e;
    }

    if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .isThenable */ .J8)(maybePromiseResult)) {
      // @ts-expect-error - isThenable returns the wrong type
      return maybePromiseResult.then(
        res => {
          // eslint-disable-next-line deprecation/deprecation
          this.popScope();
          return res;
        },
        e => {
          // eslint-disable-next-line deprecation/deprecation
          this.popScope();
          throw e;
        },
      );
    }

    // eslint-disable-next-line deprecation/deprecation
    this.popScope();
    return maybePromiseResult;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */
   getClient() {
    // eslint-disable-next-line deprecation/deprecation
    return this.getStackTop().client ;
  }

  /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */
   getScope() {
    // eslint-disable-next-line deprecation/deprecation
    return this.getStackTop().scope;
  }

  /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */
   getIsolationScope() {
    return this._isolationScope;
  }

  /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */
   getStack() {
    return this._stack;
  }

  /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */
   captureException(exception, hint) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .uuid4 */ .DM)());
    const syntheticException = new Error('Sentry syntheticException');
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().captureException(exception, {
      originalException: exception,
      syntheticException,
      ...hint,
      event_id: eventId,
    });

    return eventId;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
  ) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .uuid4 */ .DM)());
    const syntheticException = new Error(message);
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().captureMessage(message, level, {
      originalException: message,
      syntheticException,
      ...hint,
      event_id: eventId,
    });

    return eventId;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .uuid4 */ .DM)();
    if (!event.type) {
      this._lastEventId = eventId;
    }
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().captureEvent(event, { ...hint, event_id: eventId });
    return eventId;
  }

  /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */
   addBreadcrumb(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    const { scope, client } = this.getStackTop();

    if (!client) return;

    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    const timestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .dateTimestampInSeconds */ .yW)();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb
      ? ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .consoleSandbox */ .Cf)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    if (client.emit) {
      client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    }

    // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
    // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
    // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
    // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
    // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
    // the event processing pipeline.
    // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */
   setUser(user) {
    // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().setUser(user);
    // eslint-disable-next-line deprecation/deprecation
    this.getIsolationScope().setUser(user);
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */
   setTags(tags) {
    // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().setTags(tags);
    // eslint-disable-next-line deprecation/deprecation
    this.getIsolationScope().setTags(tags);
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */
   setExtras(extras) {
    // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().setExtras(extras);
    // eslint-disable-next-line deprecation/deprecation
    this.getIsolationScope().setExtras(extras);
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */
   setTag(key, value) {
    // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().setTag(key, value);
    // eslint-disable-next-line deprecation/deprecation
    this.getIsolationScope().setTag(key, value);
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */
   setExtra(key, extra) {
    // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().setExtra(key, extra);
    // eslint-disable-next-line deprecation/deprecation
    this.getIsolationScope().setExtra(key, extra);
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setContext(name, context) {
    // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
    // eslint-disable-next-line deprecation/deprecation
    this.getScope().setContext(name, context);
    // eslint-disable-next-line deprecation/deprecation
    this.getIsolationScope().setContext(name, context);
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */
   configureScope(callback) {
    // eslint-disable-next-line deprecation/deprecation
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
   run(callback) {
    // eslint-disable-next-line deprecation/deprecation
    const oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      // eslint-disable-next-line deprecation/deprecation
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */
   getIntegration(integration) {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    if (!client) return null;
    try {
      // eslint-disable-next-line deprecation/deprecation
      return client.getIntegration(integration);
    } catch (_oO) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */
   startTransaction(context, customSamplingContext) {
    const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);

    if (_debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && !result) {
      // eslint-disable-next-line deprecation/deprecation
      const client = this.getClient();
      if (!client) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn(
          "Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'",
        );
      } else {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
      }
    }

    return result;
  }

  /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      // eslint-disable-next-line deprecation/deprecation
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */
   endSession() {
    // eslint-disable-next-line deprecation/deprecation
    const layer = this.getStackTop();
    const scope = layer.scope;
    const session = scope.getSession();
    if (session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_7__/* .closeSession */ .RJ)(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    scope.setSession();
  }

  /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */
   startSession(context) {
    // eslint-disable-next-line deprecation/deprecation
    const { scope, client } = this.getStackTop();
    const { release, environment = _constants_js__WEBPACK_IMPORTED_MODULE_8__/* .DEFAULT_ENVIRONMENT */ .J } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    const { userAgent } = _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {};

    const session = (0,_session_js__WEBPACK_IMPORTED_MODULE_7__/* .makeSession */ .Hv)({
      release,
      environment,
      user: scope.getUser(),
      ...(userAgent && { userAgent }),
      ...context,
    });

    // End existing session if there's one
    const currentSession = scope.getSession && scope.getSession();
    if (currentSession && currentSession.status === 'ok') {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_7__/* .updateSession */ .CT)(currentSession, { status: 'exited' });
    }
    // eslint-disable-next-line deprecation/deprecation
    this.endSession();

    // Afterwards we set the new session on the scope
    scope.setSession(session);

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */
   shouldSendDefaultPii() {
    // eslint-disable-next-line deprecation/deprecation
    const client = this.getClient();
    const options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    // eslint-disable-next-line deprecation/deprecation
    const { scope, client } = this.getStackTop();

    const session = scope.getSession();
    if (session && client && client.captureSession) {
      client.captureSession(session);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   _callExtensionMethod(method, ...args) {
    const carrier = getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    _debug_build_js__WEBPACK_IMPORTED_MODULE_6__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .logger.warn */ .kg.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ = _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return _sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .GLOBAL_OBJ */ .n2;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */
// eslint-disable-next-line deprecation/deprecation
function getCurrentHub() {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();

  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    const hub = registry.__SENTRY__.acs.getCurrentHub();

    if (hub) {
      return hub;
    }
  }

  // Return hub that lives on a global object
  return getGlobalHub(registry);
}

/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */
function getIsolationScope() {
  // eslint-disable-next-line deprecation/deprecation
  return getCurrentHub().getIsolationScope();
}

// eslint-disable-next-line deprecation/deprecation
function getGlobalHub(registry = getMainCarrier()) {
  // If there's no hub, or its an old API, assign a new one

  if (
    !hasHubOnCarrier(registry) ||
    // eslint-disable-next-line deprecation/deprecation
    getHubFromCarrier(registry).isOlderThan(API_VERSION)
  ) {
    // eslint-disable-next-line deprecation/deprecation
    setHubOnCarrier(registry, new Hub());
  }

  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */
// eslint-disable-next-line deprecation/deprecation
function ensureHubOnCarrier(carrier, parent = getGlobalHub()) {
  // If there's no hub on current domain, or it's an old API, assign a new one
  if (
    !hasHubOnCarrier(carrier) ||
    // eslint-disable-next-line deprecation/deprecation
    getHubFromCarrier(carrier).isOlderThan(API_VERSION)
  ) {
    // eslint-disable-next-line deprecation/deprecation
    const client = parent.getClient();
    // eslint-disable-next-line deprecation/deprecation
    const scope = parent.getScope();
    // eslint-disable-next-line deprecation/deprecation
    const isolationScope = parent.getIsolationScope();
    // eslint-disable-next-line deprecation/deprecation
    setHubOnCarrier(carrier, new Hub(client, scope.clone(), isolationScope.clone()));
  }
}

/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */
function setAsyncContextStrategy(strategy) {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();
  registry.__SENTRY__ = registry.__SENTRY__ || {};
  registry.__SENTRY__.acs = strategy;
}

/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */
function runWithAsyncContext(callback, options = {}) {
  const registry = getMainCarrier();

  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
  }

  // if there was no strategy, fallback to just calling the callback
  return callback();
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
// eslint-disable-next-line deprecation/deprecation
function getHubFromCarrier(carrier) {
  // eslint-disable-next-line deprecation/deprecation
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_9__/* .getGlobalSingleton */ .YO)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
// eslint-disable-next-line deprecation/deprecation
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map


/***/ }),

/***/ 51877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "lW": function() { return /* binding */ getGlobalScope; },
/* harmony export */   "sX": function() { return /* binding */ Scope; }
/* harmony export */ });
/* unused harmony export setGlobalScope */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81757);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7790);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63699);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58536);
/* harmony import */ var _eventProcessors_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8589);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48364);
/* harmony import */ var _utils_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29390);





/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */
let globalScope;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class Scope  {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /** Propagation Context for distributed tracing */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /**
   * Transaction Name
   */

  /** Span */

  /** Session */

  /** Request Mode Session Status */

  /** The client on this scope */

  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
    this._propagationContext = generatePropagationContext();
  }

  /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */
   static clone(scope) {
    return scope ? scope.clone() : new Scope();
  }

  /**
   * Clone this scope instance.
   */
   clone() {
    const newScope = new Scope();
    newScope._breadcrumbs = [...this._breadcrumbs];
    newScope._tags = { ...this._tags };
    newScope._extra = { ...this._extra };
    newScope._contexts = { ...this._contexts };
    newScope._user = this._user;
    newScope._level = this._level;
    newScope._span = this._span;
    newScope._session = this._session;
    newScope._transactionName = this._transactionName;
    newScope._fingerprint = this._fingerprint;
    newScope._eventProcessors = [...this._eventProcessors];
    newScope._requestSession = this._requestSession;
    newScope._attachments = [...this._attachments];
    newScope._sdkProcessingMetadata = { ...this._sdkProcessingMetadata };
    newScope._propagationContext = { ...this._propagationContext };
    newScope._client = this._client;

    return newScope;
  }

  /** Update the client on the scope. */
   setClient(client) {
    this._client = client;
  }

  /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */
   getClient() {
    return this._client;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    // If null is passed we want to unset everything, but still define keys,
    // so that later down in the pipeline any existing values are cleared.
    this._user = user || {
      email: undefined,
      id: undefined,
      ip_address: undefined,
      segment: undefined,
      username: undefined,
    };

    if (this._session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_0__/* .updateSession */ .CT)(this._session, { user });
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
    // eslint-disable-next-line deprecation/deprecation
    level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * Sets the transaction name on the scope for future events.
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */
   getSpan() {
    return this._span;
  }

  /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    const span = this._span;
    // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
    // Also, this method will be removed anyway.
    // eslint-disable-next-line deprecation/deprecation
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;

    if (scopeToMerge instanceof Scope) {
      const scopeData = scopeToMerge.getScopeData();

      this._tags = { ...this._tags, ...scopeData.tags };
      this._extra = { ...this._extra, ...scopeData.extra };
      this._contexts = { ...this._contexts, ...scopeData.contexts };
      if (scopeData.user && Object.keys(scopeData.user).length) {
        this._user = scopeData.user;
      }
      if (scopeData.level) {
        this._level = scopeData.level;
      }
      if (scopeData.fingerprint.length) {
        this._fingerprint = scopeData.fingerprint;
      }
      if (scopeToMerge.getRequestSession()) {
        this._requestSession = scopeToMerge.getRequestSession();
      }
      if (scopeData.propagationContext) {
        this._propagationContext = scopeData.propagationContext;
      }
    } else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(scopeToMerge)) {
      const scopeContext = captureContext ;
      this._tags = { ...this._tags, ...scopeContext.tags };
      this._extra = { ...this._extra, ...scopeContext.extra };
      this._contexts = { ...this._contexts, ...scopeContext.contexts };
      if (scopeContext.user) {
        this._user = scopeContext.user;
      }
      if (scopeContext.level) {
        this._level = scopeContext.level;
      }
      if (scopeContext.fingerprint) {
        this._fingerprint = scopeContext.fingerprint;
      }
      if (scopeContext.requestSession) {
        this._requestSession = scopeContext.requestSession;
      }
      if (scopeContext.propagationContext) {
        this._propagationContext = scopeContext.propagationContext;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    this._propagationContext = generatePropagationContext();
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = {
      timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)(),
      ...breadcrumb,
    };

    const breadcrumbs = this._breadcrumbs;
    breadcrumbs.push(mergedBreadcrumb);
    this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;

    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */
   getAttachments() {
    const data = this.getScopeData();

    return data.attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /** @inheritDoc */
   getScopeData() {
    const {
      _breadcrumbs,
      _attachments,
      _contexts,
      _tags,
      _extra,
      _user,
      _level,
      _fingerprint,
      _eventProcessors,
      _propagationContext,
      _sdkProcessingMetadata,
      _transactionName,
      _span,
    } = this;

    return {
      breadcrumbs: _breadcrumbs,
      attachments: _attachments,
      contexts: _contexts,
      tags: _tags,
      extra: _extra,
      user: _user,
      level: _level,
      fingerprint: _fingerprint || [],
      eventProcessors: _eventProcessors,
      propagationContext: _propagationContext,
      sdkProcessingMetadata: _sdkProcessingMetadata,
      transactionName: _transactionName,
      span: _span,
    };
  }

  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */
   applyToEvent(
    event,
    hint = {},
    additionalEventProcessors = [],
  ) {
    (0,_utils_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_3__/* .applyScopeDataToEvent */ .gi)(event, this.getScopeData());

    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
      ...additionalEventProcessors,
      // eslint-disable-next-line deprecation/deprecation
      ...(0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_4__/* .getGlobalEventProcessors */ .fH)(),
      ...this._eventProcessors,
    ];

    return (0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_4__/* .notifyEventProcessors */ .RP)(eventProcessors, event, hint);
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * @inheritDoc
   */
   setPropagationContext(context) {
    this._propagationContext = context;
    return this;
  }

  /**
   * @inheritDoc
   */
   getPropagationContext() {
    return this._propagationContext;
  }

  /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */
   captureException(exception, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)();

    if (!this._client) {
      _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.warn */ .kg.warn('No client configured on scope - will not capture exception!');
      return eventId;
    }

    const syntheticException = new Error('Sentry syntheticException');

    this._client.captureException(
      exception,
      {
        originalException: exception,
        syntheticException,
        ...hint,
        event_id: eventId,
      },
      this,
    );

    return eventId;
  }

  /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */
   captureMessage(message, level, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)();

    if (!this._client) {
      _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.warn */ .kg.warn('No client configured on scope - will not capture message!');
      return eventId;
    }

    const syntheticException = new Error(message);

    this._client.captureMessage(
      message,
      level,
      {
        originalException: message,
        syntheticException,
        ...hint,
        event_id: eventId,
      },
      this,
    );

    return eventId;
  }

  /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)();

    if (!this._client) {
      _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.warn */ .kg.warn('No client configured on scope - will not capture event!');
      return eventId;
    }

    this._client.captureEvent(event, { ...hint, event_id: eventId }, this);

    return eventId;
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }
}

/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */
function getGlobalScope() {
  if (!globalScope) {
    globalScope = new Scope();
  }

  return globalScope;
}

/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */
function setGlobalScope(scope) {
  globalScope = scope;
}

function generatePropagationContext() {
  return {
    traceId: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)(),
    spanId: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .uuid4 */ .DM)().substring(16),
  };
}


//# sourceMappingURL=scope.js.map


/***/ }),

/***/ 48364:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ updateSession; },
/* harmony export */   "Hv": function() { return /* binding */ makeSession; },
/* harmony export */   "RJ": function() { return /* binding */ closeSession; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7790);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63699);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21995);


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  const session = {
    sid: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  if (context.abnormal_mechanism) {
    session.abnormal_mechanism = context.abnormal_mechanism;
  }

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    abnormal_mechanism: session.abnormal_mechanism,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map


/***/ }),

/***/ 92980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getDynamicSamplingContextFromClient; },
/* harmony export */   "j": function() { return /* binding */ getDynamicSamplingContextFromSpan; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21995);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66417);
/* harmony import */ var _exports_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92642);
/* harmony import */ var _utils_getRootSpan_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85112);
/* harmony import */ var _utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43002);






/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */
function getDynamicSamplingContextFromClient(
  trace_id,
  client,
  scope,
) {
  const options = client.getOptions();

  const { publicKey: public_key } = client.getDsn() || {};
  // TODO(v8): Remove segment from User
  // eslint-disable-next-line deprecation/deprecation
  const { segment: user_segment } = (scope && scope.getUser()) || {};

  const dsc = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)({
    environment: options.environment || _constants_js__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_ENVIRONMENT */ .J,
    release: options.release,
    user_segment,
    public_key,
    trace_id,
  }) ;

  client.emit && client.emit('createDsc', dsc);

  return dsc;
}

/**
 * A Span with a frozen dynamic sampling context.
 */

/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */
function getDynamicSamplingContextFromSpan(span) {
  const client = (0,_exports_js__WEBPACK_IMPORTED_MODULE_2__/* .getClient */ .s3)();
  if (!client) {
    return {};
  }

  // passing emit=false here to only emit later once the DSC is actually populated
  const dsc = getDynamicSamplingContextFromClient((0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(span).trace_id || '', client, (0,_exports_js__WEBPACK_IMPORTED_MODULE_2__/* .getCurrentScope */ .nZ)());

  // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
  const txn = (0,_utils_getRootSpan_js__WEBPACK_IMPORTED_MODULE_4__/* .getRootSpan */ .G)(span) ;
  if (!txn) {
    return dsc;
  }

  // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
  // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
  // @see Transaction class constructor
  const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
  if (v7FrozenDsc) {
    return v7FrozenDsc;
  }

  // TODO (v8): Replace txn.metadata with txn.attributes[]
  // We can't do this yet because attributes aren't always set yet.
  // eslint-disable-next-line deprecation/deprecation
  const { sampleRate: maybeSampleRate, source } = txn.metadata;
  if (maybeSampleRate != null) {
    dsc.sample_rate = `${maybeSampleRate}`;
  }

  // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
  const jsonSpan = (0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanToJSON */ .XU)(txn);

  // after JSON conversion, txn.name becomes jsonSpan.description
  if (source && source !== 'url') {
    dsc.transaction = jsonSpan.description;
  }

  dsc.sampled = String((0,_utils_spanUtils_js__WEBPACK_IMPORTED_MODULE_3__/* .spanIsSampled */ .Tt)(txn));

  client.emit && client.emit('createDsc', dsc);

  return dsc;
}


//# sourceMappingURL=dynamicSamplingContext.js.map


/***/ }),

/***/ 29390:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "gi": function() { return /* binding */ applyScopeDataToEvent; },
/* harmony export */   "yo": function() { return /* binding */ mergeScopeData; }
/* harmony export */ });
/* unused harmony export mergeAndOverwriteScopeData */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21995);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63699);
/* harmony import */ var _tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92980);
/* harmony import */ var _getRootSpan_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85112);
/* harmony import */ var _spanUtils_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43002);





/**
 * Applies data from the scope to the event and runs all event processors on it.
 */
function applyScopeDataToEvent(event, data) {
  const { fingerprint, span, breadcrumbs, sdkProcessingMetadata } = data;

  // Apply general data
  applyDataToEvent(event, data);

  // We want to set the trace context for normal events only if there isn't already
  // a trace context on the event. There is a product feature in place where we link
  // errors with transaction and it relies on that.
  if (span) {
    applySpanToEvent(event, span);
  }

  applyFingerprintToEvent(event, fingerprint);
  applyBreadcrumbsToEvent(event, breadcrumbs);
  applySdkMetadataToEvent(event, sdkProcessingMetadata);
}

/** Merge data of two scopes together. */
function mergeScopeData(data, mergeData) {
  const {
    extra,
    tags,
    user,
    contexts,
    level,
    sdkProcessingMetadata,
    breadcrumbs,
    fingerprint,
    eventProcessors,
    attachments,
    propagationContext,
    // eslint-disable-next-line deprecation/deprecation
    transactionName,
    span,
  } = mergeData;

  mergeAndOverwriteScopeData(data, 'extra', extra);
  mergeAndOverwriteScopeData(data, 'tags', tags);
  mergeAndOverwriteScopeData(data, 'user', user);
  mergeAndOverwriteScopeData(data, 'contexts', contexts);
  mergeAndOverwriteScopeData(data, 'sdkProcessingMetadata', sdkProcessingMetadata);

  if (level) {
    data.level = level;
  }

  if (transactionName) {
    // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
  }

  if (span) {
    data.span = span;
  }

  if (breadcrumbs.length) {
    data.breadcrumbs = [...data.breadcrumbs, ...breadcrumbs];
  }

  if (fingerprint.length) {
    data.fingerprint = [...data.fingerprint, ...fingerprint];
  }

  if (eventProcessors.length) {
    data.eventProcessors = [...data.eventProcessors, ...eventProcessors];
  }

  if (attachments.length) {
    data.attachments = [...data.attachments, ...attachments];
  }

  data.propagationContext = { ...data.propagationContext, ...propagationContext };
}

/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */
function mergeAndOverwriteScopeData

(data, prop, mergeVal) {
  if (mergeVal && Object.keys(mergeVal).length) {
    // Clone object
    data[prop] = { ...data[prop] };
    for (const key in mergeVal) {
      if (Object.prototype.hasOwnProperty.call(mergeVal, key)) {
        data[prop][key] = mergeVal[key];
      }
    }
  }
}

function applyDataToEvent(event, data) {
  const {
    extra,
    tags,
    user,
    contexts,
    level,
    // eslint-disable-next-line deprecation/deprecation
    transactionName,
  } = data;

  const cleanedExtra = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)(extra);
  if (cleanedExtra && Object.keys(cleanedExtra).length) {
    event.extra = { ...cleanedExtra, ...event.extra };
  }

  const cleanedTags = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)(tags);
  if (cleanedTags && Object.keys(cleanedTags).length) {
    event.tags = { ...cleanedTags, ...event.tags };
  }

  const cleanedUser = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)(user);
  if (cleanedUser && Object.keys(cleanedUser).length) {
    event.user = { ...cleanedUser, ...event.user };
  }

  const cleanedContexts = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)(contexts);
  if (cleanedContexts && Object.keys(cleanedContexts).length) {
    event.contexts = { ...cleanedContexts, ...event.contexts };
  }

  if (level) {
    event.level = level;
  }

  if (transactionName) {
    event.transaction = transactionName;
  }
}

function applyBreadcrumbsToEvent(event, breadcrumbs) {
  const mergedBreadcrumbs = [...(event.breadcrumbs || []), ...breadcrumbs];
  event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}

function applySdkMetadataToEvent(event, sdkProcessingMetadata) {
  event.sdkProcessingMetadata = {
    ...event.sdkProcessingMetadata,
    ...sdkProcessingMetadata,
  };
}

function applySpanToEvent(event, span) {
  event.contexts = { trace: (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .spanToTraceContext */ .wy)(span), ...event.contexts };
  const rootSpan = (0,_getRootSpan_js__WEBPACK_IMPORTED_MODULE_2__/* .getRootSpan */ .G)(span);
  if (rootSpan) {
    event.sdkProcessingMetadata = {
      dynamicSamplingContext: (0,_tracing_dynamicSamplingContext_js__WEBPACK_IMPORTED_MODULE_3__/* .getDynamicSamplingContextFromSpan */ .j)(span),
      ...event.sdkProcessingMetadata,
    };
    const transactionName = (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_1__/* .spanToJSON */ .XU)(rootSpan).description;
    if (transactionName) {
      event.tags = { transaction: transactionName, ...event.tags };
    }
  }
}

/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */
function applyFingerprintToEvent(event, fingerprint) {
  // Make sure it's an array first and we actually have something in place
  event.fingerprint = event.fingerprint ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .arrayify */ .lE)(event.fingerprint) : [];

  // If we have something on the scope, then merge it with event
  if (fingerprint) {
    event.fingerprint = event.fingerprint.concat(fingerprint);
  }

  // If we have no data at all, remove empty array default
  if (event.fingerprint && !event.fingerprint.length) {
    delete event.fingerprint;
  }
}


//# sourceMappingURL=applyScopeDataToEvent.js.map


/***/ }),

/***/ 85112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ getRootSpan; }
/* harmony export */ });
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */
function getRootSpan(span) {
  // TODO (v8): Remove this check and just return span
  // eslint-disable-next-line deprecation/deprecation
  return span.transaction;
}


//# sourceMappingURL=getRootSpan.js.map


/***/ }),

/***/ 48738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ prepareEvent; },
/* harmony export */   "U0": function() { return /* binding */ parseEventHintOrCaptureContext; }
/* harmony export */ });
/* unused harmony exports applyDebugIds, applyDebugMeta */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63699);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7790);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(39660);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(90063);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64017);
/* harmony import */ var _constants_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66417);
/* harmony import */ var _eventProcessors_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8589);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(51877);
/* harmony import */ var _applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29390);
/* harmony import */ var _spanUtils_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(43002);







/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */

/**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */
function prepareEvent(
  options,
  event,
  hint,
  scope,
  client,
  isolationScope,
) {
  const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = options;
  const prepared = {
    ...event,
    event_id: event.event_id || hint.event_id || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)(),
    timestamp: event.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .dateTimestampInSeconds */ .yW)(),
  };
  const integrations = hint.integrations || options.integrations.map(i => i.name);

  applyClientOptions(prepared, options);
  applyIntegrationsMetadata(prepared, integrations);

  // Only put debug IDs onto frames for error events.
  if (event.type === undefined) {
    applyDebugIds(prepared, options.stackParser);
  }

  // If we have scope given to us, use it as the base for further modifications.
  // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
  const finalScope = getFinalScope(scope, hint.captureContext);

  if (hint.mechanism) {
    (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .addExceptionMechanism */ .EG)(prepared, hint.mechanism);
  }

  const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];

  // This should be the last thing called, since we want that
  // {@link Hub.addEventProcessor} gets the finished prepared event.
  // Merge scope data together
  const data = (0,_scope_js__WEBPACK_IMPORTED_MODULE_2__/* .getGlobalScope */ .lW)().getScopeData();

  if (isolationScope) {
    const isolationData = isolationScope.getScopeData();
    (0,_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_3__/* .mergeScopeData */ .yo)(data, isolationData);
  }

  if (finalScope) {
    const finalScopeData = finalScope.getScopeData();
    (0,_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_3__/* .mergeScopeData */ .yo)(data, finalScopeData);
  }

  const attachments = [...(hint.attachments || []), ...data.attachments];
  if (attachments.length) {
    hint.attachments = attachments;
  }

  (0,_applyScopeDataToEvent_js__WEBPACK_IMPORTED_MODULE_3__/* .applyScopeDataToEvent */ .gi)(prepared, data);

  // TODO (v8): Update this order to be: Global > Client > Scope
  const eventProcessors = [
    ...clientEventProcessors,
    // eslint-disable-next-line deprecation/deprecation
    ...(0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_4__/* .getGlobalEventProcessors */ .fH)(),
    // Run scope event processors _after_ all other processors
    ...data.eventProcessors,
  ];

  const result = (0,_eventProcessors_js__WEBPACK_IMPORTED_MODULE_4__/* .notifyEventProcessors */ .RP)(eventProcessors, prepared, hint);

  return result.then(evt => {
    if (evt) {
      // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
      // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
      // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
      // any new data
      applyDebugMeta(evt);
    }

    if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
      return normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
    }
    return evt;
  });
}

/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */
function applyClientOptions(event, options) {
  const { environment, release, dist, maxValueLength = 250 } = options;

  if (!('environment' in event)) {
    event.environment = 'environment' in options ? environment : _constants_js__WEBPACK_IMPORTED_MODULE_5__/* .DEFAULT_ENVIRONMENT */ .J;
  }

  if (event.release === undefined && release !== undefined) {
    event.release = release;
  }

  if (event.dist === undefined && dist !== undefined) {
    event.dist = dist;
  }

  if (event.message) {
    event.message = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .truncate */ .$G)(event.message, maxValueLength);
  }

  const exception = event.exception && event.exception.values && event.exception.values[0];
  if (exception && exception.value) {
    exception.value = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .truncate */ .$G)(exception.value, maxValueLength);
  }

  const request = event.request;
  if (request && request.url) {
    request.url = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .truncate */ .$G)(request.url, maxValueLength);
  }
}

const debugIdStackParserCache = new WeakMap();

/**
 * Puts debug IDs into the stack frames of an error event.
 */
function applyDebugIds(event, stackParser) {
  const debugIdMap = _sentry_utils__WEBPACK_IMPORTED_MODULE_7__/* .GLOBAL_OBJ._sentryDebugIds */ .n2._sentryDebugIds;

  if (!debugIdMap) {
    return;
  }

  let debugIdStackFramesCache;
  const cachedDebugIdStackFrameCache = debugIdStackParserCache.get(stackParser);
  if (cachedDebugIdStackFrameCache) {
    debugIdStackFramesCache = cachedDebugIdStackFrameCache;
  } else {
    debugIdStackFramesCache = new Map();
    debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
  }

  // Build a map of filename -> debug_id
  const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace) => {
    let parsedStack;
    const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
    if (cachedParsedStack) {
      parsedStack = cachedParsedStack;
    } else {
      parsedStack = stackParser(debugIdStackTrace);
      debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
    }

    for (let i = parsedStack.length - 1; i >= 0; i--) {
      const stackFrame = parsedStack[i];
      if (stackFrame.filename) {
        acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
        break;
      }
    }
    return acc;
  }, {});

  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (frame.filename) {
          frame.debug_id = filenameDebugIdMap[frame.filename];
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }
}

/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */
function applyDebugMeta(event) {
  // Extract debug IDs and filenames from the stack frames on the event.
  const filenameDebugIdMap = {};
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    event.exception.values.forEach(exception => {
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      exception.stacktrace.frames.forEach(frame => {
        if (frame.debug_id) {
          if (frame.abs_path) {
            filenameDebugIdMap[frame.abs_path] = frame.debug_id;
          } else if (frame.filename) {
            filenameDebugIdMap[frame.filename] = frame.debug_id;
          }
          delete frame.debug_id;
        }
      });
    });
  } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
  }

  if (Object.keys(filenameDebugIdMap).length === 0) {
    return;
  }

  // Fill debug_meta information
  event.debug_meta = event.debug_meta || {};
  event.debug_meta.images = event.debug_meta.images || [];
  const images = event.debug_meta.images;
  Object.keys(filenameDebugIdMap).forEach(filename => {
    images.push({
      type: 'sourcemap',
      code_file: filename,
      debug_id: filenameDebugIdMap[filename],
    });
  });
}

/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */
function applyIntegrationsMetadata(event, integrationNames) {
  if (integrationNames.length > 0) {
    event.sdk = event.sdk || {};
    event.sdk.integrations = [...(event.sdk.integrations || []), ...integrationNames];
  }
}

/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */
function normalizeEvent(event, depth, maxBreadth) {
  if (!event) {
    return null;
  }

  const normalized = {
    ...event,
    ...(event.breadcrumbs && {
      breadcrumbs: event.breadcrumbs.map(b => ({
        ...b,
        ...(b.data && {
          data: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .normalize */ .Fv)(b.data, depth, maxBreadth),
        }),
      })),
    }),
    ...(event.user && {
      user: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .normalize */ .Fv)(event.user, depth, maxBreadth),
    }),
    ...(event.contexts && {
      contexts: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .normalize */ .Fv)(event.contexts, depth, maxBreadth),
    }),
    ...(event.extra && {
      extra: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .normalize */ .Fv)(event.extra, depth, maxBreadth),
    }),
  };

  // event.contexts.trace stores information about a Transaction. Similarly,
  // event.spans[] stores information about child Spans. Given that a
  // Transaction is conceptually a Span, normalization should apply to both
  // Transactions and Spans consistently.
  // For now the decision is to skip normalization of Transactions and Spans,
  // so this block overwrites the normalized event to add back the original
  // Transaction information prior to normalization.
  if (event.contexts && event.contexts.trace && normalized.contexts) {
    normalized.contexts.trace = event.contexts.trace;

    // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
    if (event.contexts.trace.data) {
      normalized.contexts.trace.data = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .normalize */ .Fv)(event.contexts.trace.data, depth, maxBreadth);
    }
  }

  // event.spans[].data may contain circular/dangerous data so we need to normalize it
  if (event.spans) {
    normalized.spans = event.spans.map(span => {
      const data = (0,_spanUtils_js__WEBPACK_IMPORTED_MODULE_9__/* .spanToJSON */ .XU)(span).data;

      if (data) {
        // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_8__/* .normalize */ .Fv)(data, depth, maxBreadth);
      }

      return span;
    });
  }

  return normalized;
}

function getFinalScope(scope, captureContext) {
  if (!captureContext) {
    return scope;
  }

  const finalScope = scope ? scope.clone() : new _scope_js__WEBPACK_IMPORTED_MODULE_2__/* .Scope */ .sX();
  finalScope.update(captureContext);
  return finalScope;
}

/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */
function parseEventHintOrCaptureContext(
  hint,
) {
  if (!hint) {
    return undefined;
  }

  // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
  if (hintIsScopeOrFunction(hint)) {
    return { captureContext: hint };
  }

  if (hintIsScopeContext(hint)) {
    return {
      captureContext: hint,
    };
  }

  return hint;
}

function hintIsScopeOrFunction(
  hint,
) {
  return hint instanceof _scope_js__WEBPACK_IMPORTED_MODULE_2__/* .Scope */ .sX || typeof hint === 'function';
}

const captureContextKeys = [
  'user',
  'level',
  'extra',
  'contexts',
  'tags',
  'fingerprint',
  'requestSession',
  'propagationContext',
] ;

function hintIsScopeContext(hint) {
  return Object.keys(hint).some(key => captureContextKeys.includes(key ));
}


//# sourceMappingURL=prepareEvent.js.map


/***/ }),

/***/ 43002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$k": function() { return /* binding */ spanTimeInputToSeconds; },
/* harmony export */   "Hb": function() { return /* binding */ spanToTraceHeader; },
/* harmony export */   "Tt": function() { return /* binding */ spanIsSampled; },
/* harmony export */   "XU": function() { return /* binding */ spanToJSON; },
/* harmony export */   "i0": function() { return /* binding */ TRACE_FLAG_SAMPLED; },
/* harmony export */   "ve": function() { return /* binding */ TRACE_FLAG_NONE; },
/* harmony export */   "wy": function() { return /* binding */ spanToTraceContext; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21995);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49691);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7790);


// These are aligned with OpenTelemetry trace flags
const TRACE_FLAG_NONE = 0x0;
const TRACE_FLAG_SAMPLED = 0x1;

/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */
function spanToTraceContext(span) {
  const { spanId: span_id, traceId: trace_id } = span.spanContext();
  const { data, op, parent_span_id, status, tags, origin } = spanToJSON(span);

  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .dropUndefinedKeys */ .Jr)({
    data,
    op,
    parent_span_id,
    span_id,
    status,
    tags,
    trace_id,
    origin,
  });
}

/**
 * Convert a Span to a Sentry trace header.
 */
function spanToTraceHeader(span) {
  const { traceId, spanId } = span.spanContext();
  const sampled = spanIsSampled(span);
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .generateSentryTraceHeader */ .$p)(traceId, spanId, sampled);
}

/**
 * Convert a span time input intp a timestamp in seconds.
 */
function spanTimeInputToSeconds(input) {
  if (typeof input === 'number') {
    return ensureTimestampInSeconds(input);
  }

  if (Array.isArray(input)) {
    // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
  }

  if (input instanceof Date) {
    return ensureTimestampInSeconds(input.getTime());
  }

  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .timestampInSeconds */ .ph)();
}

/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */
function ensureTimestampInSeconds(timestamp) {
  const isMs = timestamp > 9999999999;
  return isMs ? timestamp / 1000 : timestamp;
}

/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */
function spanToJSON(span) {
  if (spanIsSpanClass(span)) {
    return span.getSpanJSON();
  }

  // Fallback: We also check for `.toJSON()` here...
  // eslint-disable-next-line deprecation/deprecation
  if (typeof span.toJSON === 'function') {
    // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
  }

  return {};
}

/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */
function spanIsSpanClass(span) {
  return typeof (span ).getSpanJSON === 'function';
}

/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */
function spanIsSampled(span) {
  // We align our trace flags with the ones OpenTelemetry use
  // So we also check for sampled the same way they do.
  const { traceFlags } = span.spanContext();
  // eslint-disable-next-line no-bitwise
  return Boolean(traceFlags & TRACE_FLAG_SAMPLED);
}


//# sourceMappingURL=spanUtils.js.map


/***/ }),

/***/ 91476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ SDK_VERSION; }
/* harmony export */ });
const SDK_VERSION = '7.119.1';


//# sourceMappingURL=version.js.map


/***/ }),

/***/ 16845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Gd": function() { return /* binding */ getCurrentHub; }
});

// UNUSED EXPORTS: API_VERSION, Hub, ensureHubOnCarrier, getHubFromCarrier, getMainCarrier, makeMain, runWithAsyncContext, setAsyncContextStrategy, setHubOnCarrier

// EXTERNAL MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(16894);
// EXTERNAL MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(94931);
// EXTERNAL MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(32797);
// EXTERNAL MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(37552);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/core/esm/constants.js
const DEFAULT_ENVIRONMENT = 'production';


//# sourceMappingURL=constants.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(42008);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/syncpromise.js


/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  const PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {

   constructor(
    executor,
  ) {SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);
    this._state = States.PENDING;
    this._handlers = [];

    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init2() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init3() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if ((0,is/* isThenable */.J8)(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init4() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    const cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/core/esm/eventProcessors.js


/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
  return (0,worldwide/* getGlobalSingleton */.YO)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}

/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */
function notifyEventProcessors(
  processors,
  event,
  hint,
  index = 0,
) {
  return new SyncPromise((resolve, reject) => {
    const processor = processors[index];
    if (event === null || typeof processor !== 'function') {
      resolve(event);
    } else {
      const result = processor({ ...event }, hint) ;

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        processor.id &&
        result === null &&
        esm_logger/* logger.log */.kg.log(`Event processor "${processor.id}" dropped event`);

      if ((0,is/* isThenable */.J8)(result)) {
        void result
          .then(final => notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
          .then(null, reject);
      } else {
        void notifyEventProcessors(processors, result, hint, index + 1)
          .then(resolve)
          .then(null, reject);
      }
    }
  });
}


//# sourceMappingURL=eventProcessors.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/object.js





/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  const original = source[name] ;
  const wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    markFunctionWrapped(wrapped, original);
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  try {
    Object.defineProperty(obj, name, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: value,
      writable: true,
      configurable: true,
    });
  } catch (o_O) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.log(`Failed to add non-enumerable property "${name}" to object`, obj);
  }
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  try {
    const proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, '__sentry_original__', original);
  } catch (o_O) {} // eslint-disable-line no-empty
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(value)

 {
  if (isError(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if (isEvent(value)) {
    const newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && isInstanceOf(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return isElement(target) ? htmlTreeAsString(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return truncate(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return truncate(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if ((0,is/* isPlainObject */.PO)(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/core/esm/session.js


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = (0,time/* timestampInSeconds */.ph)();

  const session = {
    sid: (0,misc/* uuid4 */.DM)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,time/* timestampInSeconds */.ph)();

  if (context.abnormal_mechanism) {
    session.abnormal_mechanism = context.abnormal_mechanism;
  }

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0,misc/* uuid4 */.DM)();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return dropUndefinedKeys({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    abnormal_mechanism: session.abnormal_mechanism,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/core/esm/scope.js




/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class scope_Scope  {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /** Propagation Context for distributed tracing */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /** Transaction Name */

  /** Span */

  /** Session */

  /** Request Mode Session Status */

  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
    this._propagationContext = generatePropagationContext();
  }

  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
   static clone(scope) {
    const newScope = new scope_Scope();
    if (scope) {
      newScope._breadcrumbs = [...scope._breadcrumbs];
      newScope._tags = { ...scope._tags };
      newScope._extra = { ...scope._extra };
      newScope._contexts = { ...scope._contexts };
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = [...scope._eventProcessors];
      newScope._requestSession = scope._requestSession;
      newScope._attachments = [...scope._attachments];
      newScope._sdkProcessingMetadata = { ...scope._sdkProcessingMetadata };
      newScope._propagationContext = { ...scope._propagationContext };
    }
    return newScope;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this._user = user || {};
    if (this._session) {
      updateSession(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
    // eslint-disable-next-line deprecation/deprecation
    level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSpan() {
    return this._span;
  }

  /**
   * @inheritDoc
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    const span = this.getSpan();
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      const updatedScope = (captureContext )(this);
      return updatedScope instanceof scope_Scope ? updatedScope : this;
    }

    if (captureContext instanceof scope_Scope) {
      this._tags = { ...this._tags, ...captureContext._tags };
      this._extra = { ...this._extra, ...captureContext._extra };
      this._contexts = { ...this._contexts, ...captureContext._contexts };
      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }
      if (captureContext._level) {
        this._level = captureContext._level;
      }
      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
      if (captureContext._requestSession) {
        this._requestSession = captureContext._requestSession;
      }
      if (captureContext._propagationContext) {
        this._propagationContext = captureContext._propagationContext;
      }
    } else if ((0,is/* isPlainObject */.PO)(captureContext)) {
      // eslint-disable-next-line no-param-reassign
      captureContext = captureContext ;
      this._tags = { ...this._tags, ...captureContext.tags };
      this._extra = { ...this._extra, ...captureContext.extra };
      this._contexts = { ...this._contexts, ...captureContext.contexts };
      if (captureContext.user) {
        this._user = captureContext.user;
      }
      if (captureContext.level) {
        this._level = captureContext.level;
      }
      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
      if (captureContext.requestSession) {
        this._requestSession = captureContext.requestSession;
      }
      if (captureContext.propagationContext) {
        this._propagationContext = captureContext.propagationContext;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    this._propagationContext = generatePropagationContext();
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = {
      timestamp: (0,time/* dateTimestampInSeconds */.yW)(),
      ...breadcrumb,
    };

    const breadcrumbs = this._breadcrumbs;
    breadcrumbs.push(mergedBreadcrumb);
    this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;

    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
   getAttachments() {
    return this._attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
   applyToEvent(
    event,
    hint = {},
    additionalEventProcessors,
  ) {
    if (this._extra && Object.keys(this._extra).length) {
      event.extra = { ...this._extra, ...event.extra };
    }
    if (this._tags && Object.keys(this._tags).length) {
      event.tags = { ...this._tags, ...event.tags };
    }
    if (this._user && Object.keys(this._user).length) {
      event.user = { ...this._user, ...event.user };
    }
    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = { ...this._contexts, ...event.contexts };
    }
    if (this._level) {
      event.level = this._level;
    }
    if (this._transactionName) {
      event.transaction = this._transactionName;
    }

    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (this._span) {
      event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
      const transaction = this._span.transaction;
      if (transaction) {
        event.sdkProcessingMetadata = {
          dynamicSamplingContext: transaction.getDynamicSamplingContext(),
          ...event.sdkProcessingMetadata,
        };
        const transactionName = transaction.name;
        if (transactionName) {
          event.tags = { transaction: transactionName, ...event.tags };
        }
      }
    }

    this._applyFingerprint(event);

    const scopeBreadcrumbs = this._getBreadcrumbs();
    const breadcrumbs = [...(event.breadcrumbs || []), ...scopeBreadcrumbs];
    event.breadcrumbs = breadcrumbs.length > 0 ? breadcrumbs : undefined;

    event.sdkProcessingMetadata = {
      ...event.sdkProcessingMetadata,
      ...this._sdkProcessingMetadata,
      propagationContext: this._propagationContext,
    };

    // TODO (v8): Update this order to be: Global > Client > Scope
    return notifyEventProcessors(
      [...(additionalEventProcessors || []), ...getGlobalEventProcessors(), ...this._eventProcessors],
      event,
      hint,
    );
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * @inheritDoc
   */
   setPropagationContext(context) {
    this._propagationContext = context;
    return this;
  }

  /**
   * @inheritDoc
   */
   getPropagationContext() {
    return this._propagationContext;
  }

  /**
   * Get the breadcrumbs for this scope.
   */
   _getBreadcrumbs() {
    return this._breadcrumbs;
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }

  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
   _applyFingerprint(event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0,misc/* arrayify */.lE)(event.fingerprint) : [];

    // If we have something on the scope, then merge it with event
    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    }

    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  }
}

function generatePropagationContext() {
  return {
    traceId: (0,misc/* uuid4 */.DM)(),
    spanId: (0,misc/* uuid4 */.DM)().substring(16),
  };
}


//# sourceMappingURL=scope.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/core/esm/hub.js





/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
const API_VERSION = 4;

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;

/**
 * @inheritDoc
 */
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */

  /** Contains the last event id of a captured event.  */

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
   constructor(client, scope = new scope_Scope(),   _version = API_VERSION) {this._version = _version;
    this._stack = [{ scope }];
    if (client) {
      this.bindClient(client);
    }
  }

  /**
   * @inheritDoc
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * @inheritDoc
   */
   bindClient(client) {
    const top = this.getStackTop();
    top.client = client;
    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   */
   pushScope() {
    // We want to clone the content of prev scope
    const scope = scope_Scope.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   */
   popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   */
   withScope(callback) {
    const scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  }

  /**
   * @inheritDoc
   */
   getClient() {
    return this.getStackTop().client ;
  }

  /** Returns the scope of the top stack. */
   getScope() {
    return this.getStackTop().scope;
  }

  /** Returns the scope stack for domains or the process. */
   getStack() {
    return this._stack;
  }

  /** Returns the topmost scope layer in the order domain > local > process. */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   */
   captureException(exception, hint) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)());
    const syntheticException = new Error('Sentry syntheticException');
    this._withClient((client, scope) => {
      client.captureException(
        exception,
        {
          originalException: exception,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
  ) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)());
    const syntheticException = new Error(message);
    this._withClient((client, scope) => {
      client.captureMessage(
        message,
        level,
        {
          originalException: message,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,misc/* uuid4 */.DM)();
    if (!event.type) {
      this._lastEventId = eventId;
    }

    this._withClient((client, scope) => {
      client.captureEvent(event, { ...hint, event_id: eventId }, scope);
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, hint) {
    const { scope, client } = this.getStackTop();

    if (!client) return;

    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    const timestamp = (0,time/* dateTimestampInSeconds */.yW)();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb
      ? ((0,esm_logger/* consoleSandbox */.Cf)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    if (client.emit) {
      client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    }

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this.getScope().setUser(user);
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this.getScope().setTags(tags);
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this.getScope().setExtras(extras);
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.getScope().setTag(key, value);
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this.getScope().setExtra(key, extra);
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setContext(name, context) {
    this.getScope().setContext(name, context);
  }

  /**
   * @inheritDoc
   */
   configureScope(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
   run(callback) {
    const oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    const client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   startTransaction(context, customSamplingContext) {
    const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && !result) {
      const client = this.getClient();
      if (!client) {
        // eslint-disable-next-line no-console
        console.warn(
          "Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'",
        );
      } else {
        // eslint-disable-next-line no-console
        console.warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
      }
    }

    return result;
  }

  /**
   * @inheritDoc
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   */
   endSession() {
    const layer = this.getStackTop();
    const scope = layer.scope;
    const session = scope.getSession();
    if (session) {
      closeSession(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    scope.setSession();
  }

  /**
   * @inheritDoc
   */
   startSession(context) {
    const { scope, client } = this.getStackTop();
    const { release, environment = DEFAULT_ENVIRONMENT } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    const { userAgent } = worldwide/* GLOBAL_OBJ.navigator */.n2.navigator || {};

    const session = makeSession({
      release,
      environment,
      user: scope.getUser(),
      ...(userAgent && { userAgent }),
      ...context,
    });

    // End existing session if there's one
    const currentSession = scope.getSession && scope.getSession();
    if (currentSession && currentSession.status === 'ok') {
      updateSession(currentSession, { status: 'exited' });
    }
    this.endSession();

    // Afterwards we set the new session on the scope
    scope.setSession(session);

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
   shouldSendDefaultPii() {
    const client = this.getClient();
    const options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    const { scope, client } = this.getStackTop();

    const session = scope.getSession();
    if (session && client && client.captureSession) {
      client.captureSession(session);
    }
  }

  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
   _withClient(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(client, scope);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   _callExtensionMethod(method, ...args) {
    const carrier = getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  worldwide/* GLOBAL_OBJ.__SENTRY__ */.n2.__SENTRY__ = worldwide/* GLOBAL_OBJ.__SENTRY__ */.n2.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return worldwide/* GLOBAL_OBJ */.n2;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();

  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    const hub = registry.__SENTRY__.acs.getCurrentHub();

    if (hub) {
      return hub;
    }
  }

  // Return hub that lives on a global object
  return getGlobalHub(registry);
}

function getGlobalHub(registry = getMainCarrier()) {
  // If there's no hub, or its an old API, assign a new one
  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }

  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */
function ensureHubOnCarrier(carrier, parent = getGlobalHub()) {
  // If there's no hub on current domain, or it's an old API, assign a new one
  if (!hasHubOnCarrier(carrier) || getHubFromCarrier(carrier).isOlderThan(API_VERSION)) {
    const globalHubTopStack = parent.getStackTop();
    setHubOnCarrier(carrier, new Hub(globalHubTopStack.client, Scope.clone(globalHubTopStack.scope)));
  }
}

/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */
function setAsyncContextStrategy(strategy) {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();
  registry.__SENTRY__ = registry.__SENTRY__ || {};
  registry.__SENTRY__.acs = strategy;
}

/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */
function runWithAsyncContext(callback, options = {}) {
  const registry = getMainCarrier();

  if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
    return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
  }

  // if there was no strategy, fallback to just calling the callback
  return callback();
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
  return (0,worldwide/* getGlobalSingleton */.YO)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map


/***/ }),

/***/ 42008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; }
/* harmony export */ });
/* unused harmony exports isDOMError, isDOMException, isElement, isError, isErrorEvent, isEvent, isInstanceOf, isNaN, isPrimitive, isRegExp, isSyntheticEvent, isVueViewModel */
// eslint-disable-next-line @typescript-eslint/unbound-method
const objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
  return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}

/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isVueViewModel(wat) {
  // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
  return !!(typeof wat === 'object' && wat !== null && ((wat ).__isVue || (wat )._isVue));
}


//# sourceMappingURL=is.js.map


/***/ }),

/***/ 32797:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* unused harmony exports CONSOLE_LEVELS, originalConsoleMethods */
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37552);


/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';

const CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'] ;

/** This may be mutated by the console instrumentation. */
const originalConsoleMethods

 = {};

/** JSDoc */

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!("console" in _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2)) {
    return callback();
  }

  const console = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console ;
  const wrappedFuncs = {};

  const wrappedLevels = Object.keys(originalConsoleMethods) ;

  // Restore all wrapped console methods
  wrappedLevels.forEach(level => {
    const originalConsoleMethod = originalConsoleMethods[level] ;
    wrappedFuncs[level] = console[level] ;
    console[level] = originalConsoleMethod;
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    wrappedLevels.forEach(level => {
      console[level] = wrappedFuncs[level] ;
    });
  }
}

function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
    isEnabled: () => enabled,
  };

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    CONSOLE_LEVELS.forEach(name => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

const logger = makeLogger();


//# sourceMappingURL=logger.js.map


/***/ }),

/***/ 16894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "lE": function() { return /* binding */ arrayify; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, addExceptionTypeValue, checkOrSetAlreadyCaught, getEventDescription, parseSemver */
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37552);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  const gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  const crypto = gbl.crypto || gbl.msCrypto;

  let getRandomByte = () => Math.random() * 16;
  try {
    if (crypto && crypto.randomUUID) {
      return crypto.randomUUID().replace(/-/g, '');
    }
    if (crypto && crypto.getRandomValues) {
      getRandomByte = () => crypto.getRandomValues(new Uint8Array(1))[0];
    }
  } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
  }

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  const exception = (event.exception = event.exception || {});
  const values = (exception.values = exception.values || []);
  const firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  const defaultMechanism = { type: 'generic', handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    const mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  const match = input.match(SEMVER_REGEXP) || [];
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
  if (frame.lineno === undefined) {
    return;
  }

  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    addNonEnumerableProperty(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}


//# sourceMappingURL=misc.js.map


/***/ }),

/***/ 98206:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l$": function() { return /* binding */ dynamicRequire; },
  "KV": function() { return /* binding */ isNodeEnv; }
});

// UNUSED EXPORTS: loadModule

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/env.js
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

/**
 * Get source of SDK.
 */
function getSDKSource() {
  // @ts-expect-error "npm" is injected by rollup during build process
  return "npm";
}


//# sourceMappingURL=env.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/node.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(93542);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !isBrowserBundle() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
  let mod;

  try {
    mod = dynamicRequire(module, moduleName);
  } catch (e) {
    // no-empty
  }

  try {
    const { cwd } = dynamicRequire(module, 'process');
    mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`) ;
  } catch (e) {
    // no-empty
  }

  return mod;
}


//# sourceMappingURL=node.js.map


/***/ }),

/***/ 94931:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, browserPerformanceTimeOrigin, timestampWithMs, usingPerformanceAPI */
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98206);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37552);
/* module decorator */ module = __webpack_require__.hmd(module);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
const dateTimestampSource = {
  nowSeconds: () => Date.now() / 1000,
};

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    return undefined;
  }

  // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.
  const timeOrigin = Date.now() - performance.now();

  return {
    now: () => performance.now(),
    timeOrigin,
  };
}

/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
  try {
    const perfHooks = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks') ;
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}

/**
 * The Performance API implementation for the current platform, if available.
 */
const platformPerformance = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();

const timestampSource =
  platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1000,
      };

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);

/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */
const timestampWithMs = (/* unused pure expression or super */ null && (timestampInSeconds));

/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
const usingPerformanceAPI = platformPerformance !== undefined;

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
const browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 37552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */

// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/** Returns 'obj' if it's the global object, otherwise returns undefined */
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : undefined;
}

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ =
  (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof window == 'object' && isGlobalObj(window)) ||
  (typeof self == 'object' && isGlobalObj(self)) ||
  (typeof __webpack_require__.g == 'object' && isGlobalObj(__webpack_require__.g)) ||
  (function () {
    return this;
  })() ||
  {};

/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */
function getGlobalObject() {
  return GLOBAL_OBJ ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = (obj || GLOBAL_OBJ) ;
  const __SENTRY__ = (gbl.__SENTRY__ = gbl.__SENTRY__ || {});
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 46990:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "EN": function() { return /* binding */ baggageHeaderToDynamicSamplingContext; },
/* harmony export */   "IQ": function() { return /* binding */ dynamicSamplingContextToSentryBaggageHeader; },
/* harmony export */   "bU": function() { return /* binding */ BAGGAGE_HEADER_NAME; }
/* harmony export */ });
/* unused harmony exports MAX_BAGGAGE_STRING_LENGTH, SENTRY_BAGGAGE_KEY_PREFIX, SENTRY_BAGGAGE_KEY_PREFIX_REGEX */
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51982);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81757);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58536);




const BAGGAGE_HEADER_NAME = 'baggage';

const SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
const MAX_BAGGAGE_STRING_LENGTH = 8192;

/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */
function baggageHeaderToDynamicSamplingContext(
  // Very liberal definition of what any incoming header might look like
  baggageHeader,
) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(baggageHeader) && !Array.isArray(baggageHeader)) {
    return undefined;
  }

  // Intermediary object to store baggage key value pairs of incoming baggage headers on.
  // It is later used to read Sentry-DSC-values from.
  let baggageObject = {};

  if (Array.isArray(baggageHeader)) {
    // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggageHeaderToObject(curr);
      for (const key of Object.keys(currBaggageObject)) {
        acc[key] = currBaggageObject[key];
      }
      return acc;
    }, {});
  } else {
    // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
    // this is how we choose to handle it)
    if (!baggageHeader) {
      return undefined;
    }

    baggageObject = baggageHeaderToObject(baggageHeader);
  }

  // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});

  // Only return a dynamic sampling context object if there are keys in it.
  // A keyless object means there were no sentry values on the header, which means that there is no DSC.
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext ;
  } else {
    return undefined;
  }
}

/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */
function dynamicSamplingContextToSentryBaggageHeader(
  // this also takes undefined for convenience and bundle size in other places
  dynamicSamplingContext,
) {
  if (!dynamicSamplingContext) {
    return undefined;
  }

  // Prefix all DSC keys with "sentry-" and put them into a new object
  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(
    (acc, [dscKey, dscValue]) => {
      if (dscValue) {
        acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
      }
      return acc;
    },
    {},
  );

  return objectToBaggageHeader(sentryPrefixedDSC);
}

/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */
function baggageHeaderToObject(baggageHeader) {
  return baggageHeader
    .split(',')
    .map(baggageEntry => baggageEntry.split('=').map(keyOrValue => decodeURIComponent(keyOrValue.trim())))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
}

/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */
function objectToBaggageHeader(object) {
  if (Object.keys(object).length === 0) {
    // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
  }

  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
    if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
      _debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X &&
        _logger_js__WEBPACK_IMPORTED_MODULE_2__/* .logger.warn */ .kg.warn(
          `Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`,
        );
      return baggageHeader;
    } else {
      return newBaggageHeader;
    }
  }, '');
}


//# sourceMappingURL=baggage.js.map


/***/ }),

/***/ 54194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rt": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "iY": function() { return /* binding */ getComponentName; },
/* harmony export */   "l4": function() { return /* binding */ getLocationHref; },
/* harmony export */   "qT": function() { return /* binding */ getDomElement; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81757);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90063);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

const DEFAULT_MAX_STRING_LENGTH = 80;

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(
  elem,
  options = {},
) {
  if (!elem) {
    return '<unknown>';
  }

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem ;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = ' > ';
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = (!Array.isArray(options) && options.maxStringLength) || DEFAULT_MAX_STRING_LENGTH;

    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds maxStringLength
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength)) {
        break;
      }

      out.push(nextStr);

      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
  const elem = el

;

  const out = [];
  let className;
  let classes;
  let key;
  let attr;
  let i;

  if (!elem || !elem.tagName) {
    return '';
  }

  // @ts-expect-error WINDOW has HTMLElement
  if (WINDOW.HTMLElement) {
    // If using the component name annotation plugin, this value may be available on the DOM node
    if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) {
      return elem.dataset['sentryComponent'];
    }
  }

  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  const keyAttrPairs =
    keyAttrs && keyAttrs.length
      ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)])
      : null;

  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }

    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && (0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  const allowedAttrs = ['aria-label', 'type', 'name', 'title', 'alt'];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push(`[${key}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function getLocationHref() {
  try {
    return WINDOW.document.location.href;
  } catch (oO) {
    return '';
  }
}

/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
  if (WINDOW.document && WINDOW.document.querySelector) {
    return WINDOW.document.querySelector(selector) ;
  }
  return null;
}

/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */
function getComponentName(elem) {
  // @ts-expect-error WINDOW has HTMLElement
  if (!WINDOW.HTMLElement) {
    return null;
  }

  let currentElem = elem ;
  const MAX_TRAVERSE_HEIGHT = 5;
  for (let i = 0; i < MAX_TRAVERSE_HEIGHT; i++) {
    if (!currentElem) {
      return null;
    }

    if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) {
      return currentElem.dataset['sentryComponent'];
    }

    currentElem = currentElem.parentNode;
  }

  return null;
}


//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 51982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);


//# sourceMappingURL=debug-build.js.map


/***/ }),

/***/ 81757:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "Le": function() { return /* binding */ isParameterizedString; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; },
/* harmony export */   "y1": function() { return /* binding */ isVueViewModel; }
/* harmony export */ });
// eslint-disable-next-line @typescript-eslint/unbound-method
const objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isParameterizedString(wat) {
  return (
    typeof wat === 'object' &&
    wat !== null &&
    '__sentry_template_string__' in wat &&
    '__sentry_template_values__' in wat
  );
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
  return wat === null || isParameterizedString(wat) || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}

/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isVueViewModel(wat) {
  // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
  return !!(typeof wat === 'object' && wat !== null && ((wat ).__isVue || (wat )._isVue));
}


//# sourceMappingURL=is.js.map


/***/ }),

/***/ 58536:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "LD": function() { return /* binding */ originalConsoleMethods; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51982);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90063);



/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';

const CONSOLE_LEVELS = [
  'debug',
  'info',
  'warn',
  'error',
  'log',
  'assert',
  'trace',
] ;

/** This may be mutated by the console instrumentation. */
const originalConsoleMethods

 = {};

/** JSDoc */

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!("console" in _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2)) {
    return callback();
  }

  const console = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console ;
  const wrappedFuncs = {};

  const wrappedLevels = Object.keys(originalConsoleMethods) ;

  // Restore all wrapped console methods
  wrappedLevels.forEach(level => {
    const originalConsoleMethod = originalConsoleMethods[level] ;
    wrappedFuncs[level] = console[level] ;
    console[level] = originalConsoleMethod;
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    wrappedLevels.forEach(level => {
      console[level] = wrappedFuncs[level] ;
    });
  }
}

function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
    isEnabled: () => enabled,
  };

  if (_debug_build_js__WEBPACK_IMPORTED_MODULE_1__/* .DEBUG_BUILD */ .X) {
    CONSOLE_LEVELS.forEach(name => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

const logger = makeLogger();


//# sourceMappingURL=logger.js.map


/***/ }),

/***/ 63699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "lE": function() { return /* binding */ arrayify; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, parseSemver */
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21995);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90063);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  const gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  const crypto = gbl.crypto || gbl.msCrypto;

  let getRandomByte = () => Math.random() * 16;
  try {
    if (crypto && crypto.randomUUID) {
      return crypto.randomUUID().replace(/-/g, '');
    }
    if (crypto && crypto.getRandomValues) {
      getRandomByte = () => {
        // crypto.getRandomValues might return undefined instead of the typed array
        // in old Chromium versions (e.g. 23.0.1235.0 (151422))
        // However, `typedArray` is still filled in-place.
        // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
        const typedArray = new Uint8Array(1);
        crypto.getRandomValues(typedArray);
        return typedArray[0];
      };
    }
  } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
  }

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  const exception = (event.exception = event.exception || {});
  const values = (exception.values = exception.values || []);
  const firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  const defaultMechanism = { type: 'generic', handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    const mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  const match = input.match(SEMVER_REGEXP) || [];
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
  if (frame.lineno === undefined) {
    return;
  }

  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}


//# sourceMappingURL=misc.js.map


/***/ }),

/***/ 64017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Fv": function() { return /* binding */ normalize; },
  "Qy": function() { return /* binding */ normalizeToSize; }
});

// UNUSED EXPORTS: normalizeUrlToBase, walk

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(81757);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Helper to decycle json objects
 */
function memoBuilder() {
  const hasWeakSet = typeof WeakSet === 'function';
  const inner = hasWeakSet ? new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < inner.length; i++) {
      const value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }

  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}


//# sourceMappingURL=memo.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(21995);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(69038);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input, depth = 100, maxProperties = +Infinity) {
  try {
    // since we're at the outermost level, we don't provide a key
    return visit('', input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}

/** JSDoc */
function normalizeToSize(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  object,
  // Default Node.js REPL depth
  depth = 3,
  // 100kB, as 200kB is max payload size, so half sounds reasonable
  maxSize = 100 * 1024,
) {
  const normalized = normalize(object, depth);

  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }

  return normalized ;
}

/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(
  key,
  value,
  depth = +Infinity,
  maxProperties = +Infinity,
  memo = memoBuilder(),
) {
  const [memoize, unmemoize] = memo;

  // Get the simple cases out of the way first
  if (
    value == null || // this matches null and undefined -> eqeq not eqeqeq
    (['number', 'boolean', 'string'].includes(typeof value) && !(0,is/* isNaN */.i2)(value))
  ) {
    return value ;
  }

  const stringified = stringifyValue(key, value);

  // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
  // Everything else will have already been serialized, so if we don't see that pattern, we're done.
  if (!stringified.startsWith('[object ')) {
    return stringified;
  }

  // From here on, we can assert that `value` is either an object or an array.

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  if ((value )['__sentry_skip_normalization__']) {
    return value ;
  }

  // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
  // We keep a certain amount of depth.
  // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
  const remainingDepth =
    typeof (value )['__sentry_override_normalization_depth__'] === 'number'
      ? ((value )['__sentry_override_normalization_depth__'] )
      : depth;

  // We're also done if we've reached the max depth
  if (remainingDepth === 0) {
    // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
  }

  // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
  if (memoize(value)) {
    return '[Circular ~]';
  }

  // If the value has a `toJSON` method, we call it to extract more information
  const valueWithToJSON = value ;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      // We need to normalize the return value of `.toJSON()` in case it has circular references
      return visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
      // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
  }

  // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
  // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
  // property/entry, and keep track of the number of items we add to it.
  const normalized = (Array.isArray(value) ? [] : {}) ;
  let numAdded = 0;

  // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
  // properties are non-enumerable and otherwise would get missed.
  const visitable = (0,object/* convertToPlainObject */.Sh)(value );

  for (const visitKey in visitable) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }

    if (numAdded >= maxProperties) {
      normalized[visitKey] = '[MaxProperties ~]';
      break;
    }

    // Recursively visit all the child nodes
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);

    numAdded++;
  }

  // Once we've visited all the branches, remove the parent from memo storage
  unmemoize(value);

  // Return accumulated values
  return normalized;
}

/* eslint-disable complexity */
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(
  key,
  // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
  // our internal use, it'll do
  value,
) {
  try {
    if (key === 'domain' && value && typeof value === 'object' && (value )._events) {
      return '[Domain]';
    }

    if (key === 'domainEmitter') {
      return '[DomainEmitter]';
    }

    // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.

    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
      return '[Global]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
      return '[Window]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
      return '[Document]';
    }

    if ((0,is/* isVueViewModel */.y1)(value)) {
      return '[VueViewModel]';
    }

    // React's SyntheticEvent thingy
    if ((0,is/* isSyntheticEvent */.Cy)(value)) {
      return '[SyntheticEvent]';
    }

    if (typeof value === 'number' && value !== value) {
      return '[NaN]';
    }

    if (typeof value === 'function') {
      return `[Function: ${(0,stacktrace/* getFunctionName */.$P)(value)}]`;
    }

    if (typeof value === 'symbol') {
      return `[${String(value)}]`;
    }

    // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
    if (typeof value === 'bigint') {
      return `[BigInt: ${String(value)}]`;
    }

    // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
    // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
    // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
    // we can make sure that only plain objects come out that way.
    const objName = getConstructorName(value);

    // Handle HTML Elements
    if (/^HTML(\w*)Element$/.test(objName)) {
      return `[HTMLElement: ${objName}]`;
    }

    return `[object ${objName}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}
/* eslint-enable complexity */

function getConstructorName(value) {
  const prototype = Object.getPrototypeOf(value);

  return prototype ? prototype.constructor.name : 'null prototype';
}

/** Calculates bytes size of input string */
function utf8Length(value) {
  // eslint-disable-next-line no-bitwise
  return ~-encodeURI(value).split(/%..|./).length;
}

/** Calculates bytes size of input object */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}

/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */
function normalizeUrlToBase(url, basePath) {
  const escapedBase = basePath
    // Backslash to forward
    .replace(/\\/g, '/')
    // Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');

  let newUrl = url;
  try {
    newUrl = decodeURI(url);
  } catch (_Oo) {
    // Sometime this breaks
  }
  return (
    newUrl
      .replace(/\\/g, '/')
      .replace(/webpack:\/?/g, '') // Remove intermediate base path
      // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
      .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///')
  );
}


//# sourceMappingURL=normalize.js.map


/***/ }),

/***/ 21995:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54194);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51982);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81757);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58536);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39660);






/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  const original = source[name] ;
  const wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    markFunctionWrapped(wrapped, original);
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  try {
    Object.defineProperty(obj, name, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: value,
      writable: true,
      configurable: true,
    });
  } catch (o_O) {
    _debug_build_js__WEBPACK_IMPORTED_MODULE_0__/* .DEBUG_BUILD */ .X && _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.log */ .kg.log(`Failed to add non-enumerable property "${name}" to object`, obj);
  }
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  try {
    const proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, '__sentry_original__', original);
  } catch (o_O) {} // eslint-disable-line no-empty
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(
  value,
)

 {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isError */ .VZ)(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if ((0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isEvent */ .cO)(value)) {
    const newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && (0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return (0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isElement */ .kK)(target) ? (0,_browser_js__WEBPACK_IMPORTED_MODULE_3__/* .htmlTreeAsString */ .Rt)(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_4__/* .truncate */ .$G)(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_4__/* .truncate */ .$G)(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if (isPojo(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

function isPojo(input) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_2__/* .isPlainObject */ .PO)(input)) {
    return false;
  }

  try {
    const name = (Object.getPrototypeOf(input) ).constructor.name;
    return !name || name === 'Object';
  } catch (e) {
    return true;
  }
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map


/***/ }),

/***/ 69038:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "Sq": function() { return /* binding */ stackParserFromStackParserOptions; },
/* harmony export */   "pE": function() { return /* binding */ createStackParser; }
/* harmony export */ });
/* unused harmony exports nodeStackLineParser, stripSentryFramesAndReverse */



const STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const STRIP_FRAME_REGEXP = /captureMessage|captureException/;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  const sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);

  return (stack, skipFirst = 0) => {
    const frames = [];
    const lines = stack.split('\n');

    for (let i = skipFirst; i < lines.length; i++) {
      const line = lines[i];
      // Ignore lines over 1kb as they are unlikely to be stack frames.
      // Many of the regular expressions use backtracking which results in run time that increases exponentially with
      // input size. Huge strings can result in hangs/Denial of Service:
      // https://github.com/getsentry/sentry-javascript/issues/2286
      if (line.length > 1024) {
        continue;
      }

      // https://github.com/getsentry/sentry-javascript/issues/5459
      // Remove webpack (error: *) wrappers
      const cleanedLine = WEBPACK_ERROR_REGEXP.test(line) ? line.replace(WEBPACK_ERROR_REGEXP, '$1') : line;

      // https://github.com/getsentry/sentry-javascript/issues/7813
      // Skip Error: lines
      if (cleanedLine.match(/\S*Error: /)) {
        continue;
      }

      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);

        if (frame) {
          frames.push(frame);
          break;
        }
      }

      if (frames.length >= STACKTRACE_FRAME_LIMIT) {
        break;
      }
    }

    return stripSentryFramesAndReverse(frames);
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }

  const localStack = Array.from(stack);

  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) {
    localStack.pop();
  }

  // Reversing in the middle of the procedure allows us to just pop the values off the stack
  localStack.reverse();

  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
    localStack.pop();

    // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
    // is produced within the hub itself, making it:
    //
    //   Sentry.captureException()
    //   getCurrentHub().captureException()
    //
    // instead of just the top `Sentry` call itself.
    // This forces us to possibly strip an additional frame in the exact same was as above.
    if (STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
      localStack.pop();
    }
  }

  return localStack.slice(0, STACKTRACE_FRAME_LIMIT).map(frame => ({
    ...frame,
    filename: frame.filename || localStack[localStack.length - 1].filename,
    function: frame.function || '?',
  }));
}

const defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */
function nodeStackLineParser(getModule) {
  return [90, node(getModule)];
}


//# sourceMappingURL=stacktrace.js.map


/***/ }),

/***/ 39660:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "U0": function() { return /* binding */ stringMatchesSomePattern; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; }
/* harmony export */ });
/* unused harmony exports isMatchingPattern, snipLine */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81757);


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.slice(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
  let newLine = line;
  const lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
    // eslint-disable-next-line no-param-reassign
    colno = lineLength;
  }

  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }

  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }

  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }

  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  const output = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    try {
      // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
      // console warnings. This happens when a Vue template is rendered with
      // an undeclared variable, which we try to stringify, ultimately causing
      // Vue to issue another warning which repeats indefinitely.
      // see: https://github.com/getsentry/sentry-javascript/pull/8981
      if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isVueViewModel */ .y1)(value)) {
        output.push('[VueViewModel]');
      } else {
        output.push(String(value));
      }
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */
function isMatchingPattern(
  value,
  pattern,
  requireExactStringMatch = false,
) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
    return false;
  }

  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
    return pattern.test(value);
  }
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(pattern)) {
    return requireExactStringMatch ? value === pattern : value.includes(pattern);
  }

  return false;
}

/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */
function stringMatchesSomePattern(
  testString,
  patterns = [],
  requireExactStringMatch = false,
) {
  return patterns.some(pattern => isMatchingPattern(testString, pattern, requireExactStringMatch));
}


//# sourceMappingURL=string.js.map


/***/ }),

/***/ 97946:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81757);


/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  const PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {

   constructor(
    executor,
  ) {SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);
    this._state = States.PENDING;
    this._handlers = [];

    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init2() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init3() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init4() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    const cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map


/***/ }),

/***/ 7790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, timestampWithMs */
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90063);


const ONE_SECOND_IN_MS = 1000;

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */
function dateTimestampInSeconds() {
  return Date.now() / ONE_SECOND_IN_MS;
}

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function createUnixTimestampInSecondsFunc() {
  const { performance } = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  if (!performance || !performance.now) {
    return dateTimestampInSeconds;
  }

  // Some browser and environments don't have a timeOrigin, so we fallback to
  // using Date.now() to compute the starting time.
  const approxStartingTimeOrigin = Date.now() - performance.now();
  const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;

  // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
  // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
  //
  // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
  // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
  // correct for this.
  // See: https://github.com/getsentry/sentry-javascript/issues/2590
  // See: https://github.com/mdn/content/issues/4713
  // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
  return () => {
    return (timeOrigin + performance.now()) / ONE_SECOND_IN_MS;
  };
}

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = createUnixTimestampInSecondsFunc();

/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */
const timestampWithMs = (/* unused pure expression or super */ null && (timestampInSeconds));

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
const browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 49691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$p": function() { return /* binding */ generateSentryTraceHeader; },
/* harmony export */   "pT": function() { return /* binding */ propagationContextFromHeaders; }
/* harmony export */ });
/* unused harmony exports TRACEPARENT_REGEXP, extractTraceparentData, tracingContextFromHeaders */
/* harmony import */ var _baggage_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(46990);
/* harmony import */ var _misc_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63699);



// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
  if (!traceparent) {
    return undefined;
  }

  const matches = traceparent.match(TRACEPARENT_REGEXP);
  if (!matches) {
    return undefined;
  }

  let parentSampled;
  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2],
  };
}

/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */
// TODO(v8): Remove this function
function tracingContextFromHeaders(
  sentryTrace,
  baggage,
)

 {
  const traceparentData = extractTraceparentData(sentryTrace);
  const dynamicSamplingContext = baggageHeaderToDynamicSamplingContext(baggage);

  const { traceId, parentSpanId, parentSampled } = traceparentData || {};

  if (!traceparentData) {
    return {
      traceparentData,
      dynamicSamplingContext: undefined,
      propagationContext: {
        traceId: traceId || uuid4(),
        spanId: uuid4().substring(16),
      },
    };
  } else {
    return {
      traceparentData,
      dynamicSamplingContext: dynamicSamplingContext || {}, // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
      propagationContext: {
        traceId: traceId || uuid4(),
        parentSpanId: parentSpanId || uuid4().substring(16),
        spanId: uuid4().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}, // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
      },
    };
  }
}

/**
 * Create a propagation context from incoming headers.
 */
function propagationContextFromHeaders(
  sentryTrace,
  baggage,
) {
  const traceparentData = extractTraceparentData(sentryTrace);
  const dynamicSamplingContext = (0,_baggage_js__WEBPACK_IMPORTED_MODULE_0__/* .baggageHeaderToDynamicSamplingContext */ .EN)(baggage);

  const { traceId, parentSpanId, parentSampled } = traceparentData || {};

  if (!traceparentData) {
    return {
      traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
      spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
    };
  } else {
    return {
      traceId: traceId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
      parentSpanId: parentSpanId || (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
      spanId: (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
      sampled: parentSampled,
      dsc: dynamicSamplingContext || {}, // If we have traceparent data but no DSC it means we are not head of trace and we must freeze it
    };
  }
}

/**
 * Create sentry-trace header from span context values.
 */
function generateSentryTraceHeader(
  traceId = (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
  spanId = (0,_misc_js__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)().substring(16),
  sampled,
) {
  let sampledString = '';
  if (sampled !== undefined) {
    sampledString = sampled ? '-1' : '-0';
  }
  return `${traceId}-${spanId}${sampledString}`;
}


//# sourceMappingURL=tracing.js.map


/***/ }),

/***/ 90063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */

// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/** Returns 'obj' if it's the global object, otherwise returns undefined */
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : undefined;
}

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ =
  (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof window == 'object' && isGlobalObj(window)) ||
  (typeof self == 'object' && isGlobalObj(self)) ||
  (typeof __webpack_require__.g == 'object' && isGlobalObj(__webpack_require__.g)) ||
  (function () {
    return this;
  })() ||
  {};

/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */
function getGlobalObject() {
  return GLOBAL_OBJ ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = (obj || GLOBAL_OBJ) ;
  const __SENTRY__ = (gbl.__SENTRY__ = gbl.__SENTRY__ || {});
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 29919:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(4090);

var $apply = __webpack_require__(49638);
var $call = __webpack_require__(68418);
var $reflectApply = __webpack_require__(36476);

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),

/***/ 49638:
/***/ (function(module) {

"use strict";


/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;


/***/ }),

/***/ 68418:
/***/ (function(module) {

"use strict";


/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;


/***/ }),

/***/ 68381:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(4090);
var $TypeError = __webpack_require__(5408);

var $call = __webpack_require__(68418);
var $actualApply = __webpack_require__(29919);

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};


/***/ }),

/***/ 36476:
/***/ (function(module) {

"use strict";


/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),

/***/ 8435:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(51331);

var callBindBasic = __webpack_require__(68381);

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};


/***/ }),

/***/ 51331:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $Object = __webpack_require__(54546);

var $Error = __webpack_require__(42321);
var $EvalError = __webpack_require__(69654);
var $RangeError = __webpack_require__(48205);
var $ReferenceError = __webpack_require__(2976);
var $SyntaxError = __webpack_require__(48342);
var $TypeError = __webpack_require__(5408);
var $URIError = __webpack_require__(82885);

var abs = __webpack_require__(14383);
var floor = __webpack_require__(45736);
var max = __webpack_require__(27130);
var min = __webpack_require__(22400);
var pow = __webpack_require__(23654);
var round = __webpack_require__(96890);
var sign = __webpack_require__(82026);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(30963);
var $defineProperty = __webpack_require__(70999);

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(31108)();

var getProto = __webpack_require__(21750);
var $ObjectGPO = __webpack_require__(2938);
var $ReflectGPO = __webpack_require__(78354);

var $apply = __webpack_require__(49638);
var $call = __webpack_require__(68418);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(4090);
var hasOwn = __webpack_require__(22590);
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 78149:
/***/ (function(module) {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),

/***/ 30963:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(78149);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 31108:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(32497);

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 32497:
/***/ (function(module) {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 22590:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(4090);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ 13421:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.parse = parse;
exports.serialize = serialize;

/**
 * Module variables.
 * @private
 */

var __toString = Object.prototype.toString

/**
 * RegExp to match cookie-name in RFC 6265 sec 4.1.1
 * This refers out to the obsoleted definition of token in RFC 2616 sec 2.2
 * which has been replaced by the token definition in RFC 7230 appendix B.
 *
 * cookie-name       = token
 * token             = 1*tchar
 * tchar             = "!" / "#" / "$" / "%" / "&" / "'" /
 *                     "*" / "+" / "-" / "." / "^" / "_" /
 *                     "`" / "|" / "~" / DIGIT / ALPHA
 */

var cookieNameRegExp = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;

/**
 * RegExp to match cookie-value in RFC 6265 sec 4.1.1
 *
 * cookie-value      = *cookie-octet / ( DQUOTE *cookie-octet DQUOTE )
 * cookie-octet      = %x21 / %x23-2B / %x2D-3A / %x3C-5B / %x5D-7E
 *                     ; US-ASCII characters excluding CTLs,
 *                     ; whitespace DQUOTE, comma, semicolon,
 *                     ; and backslash
 */

var cookieValueRegExp = /^("?)[\u0021\u0023-\u002B\u002D-\u003A\u003C-\u005B\u005D-\u007E]*\1$/;

/**
 * RegExp to match domain-value in RFC 6265 sec 4.1.1
 *
 * domain-value      = <subdomain>
 *                     ; defined in [RFC1034], Section 3.5, as
 *                     ; enhanced by [RFC1123], Section 2.1
 * <subdomain>       = <label> | <subdomain> "." <label>
 * <label>           = <let-dig> [ [ <ldh-str> ] <let-dig> ]
 *                     Labels must be 63 characters or less.
 *                     'let-dig' not 'letter' in the first char, per RFC1123
 * <ldh-str>         = <let-dig-hyp> | <let-dig-hyp> <ldh-str>
 * <let-dig-hyp>     = <let-dig> | "-"
 * <let-dig>         = <letter> | <digit>
 * <letter>          = any one of the 52 alphabetic characters A through Z in
 *                     upper case and a through z in lower case
 * <digit>           = any one of the ten digits 0 through 9
 */

var domainValueRegExp = /^([a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i;

/**
 * RegExp to match path-value in RFC 6265 sec 4.1.1
 *
 * path-value        = <any CHAR except CTLs or ";">
 * CHAR              = %x01-7F
 *                     ; defined in RFC 5234 appendix B.1
 */

var pathValueRegExp = /^[\u0020-\u003A\u003D-\u007E]*$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {};
  var len = str.length;
  // RFC 6265 sec 4.1.1, RFC 2616 2.2 defines a cookie name consists of one char minimum, plus '='.
  var max = len - 2;
  if (max < 0) return obj;

  var dec = (options && options.decode) || decode;
  var index = 0;
  var eqIdx = 0;
  var endIdx = 0;

  do {
    eqIdx = str.indexOf('=', index);

    // no more cookie pairs
    if (eqIdx === -1) {
      break;
    }

    endIdx = str.indexOf(';', index);

    if (endIdx === -1) {
      endIdx = len;
    } else if (eqIdx > endIdx) {
      // backtrack on prior semicolon
      index = str.lastIndexOf(';', eqIdx - 1) + 1;
      continue;
    }

    var keyStartIdx = startIndex(str, index, eqIdx);
    var keyEndIdx = endIndex(str, eqIdx, keyStartIdx);
    var key = str.slice(keyStartIdx, keyEndIdx);

    // only assign once
    if (undefined === obj[key]) {
      var valStartIdx = startIndex(str, eqIdx + 1, endIdx);
      var valEndIdx = endIndex(str, endIdx, valStartIdx);

      if (str.charCodeAt(valStartIdx) === 0x22 /* " */ && str.charCodeAt(valEndIdx - 1) === 0x22 /* " */) {
        valStartIdx++;
        valEndIdx--;
      }

      var val = str.slice(valStartIdx, valEndIdx);
      obj[key] = tryDecode(val, dec);
    }

    index = endIdx + 1
  } while (index < max);

  return obj;
}

function startIndex(str, index, max) {
  do {
    var code = str.charCodeAt(index);
    if (code !== 0x20 /*   */ && code !== 0x09 /* \t */) return index;
  } while (++index < max);
  return max;
}

function endIndex(str, index, min) {
  while (index > min) {
    var code = str.charCodeAt(--index);
    if (code !== 0x20 /*   */ && code !== 0x09 /* \t */) return index + 1;
  }
  return min;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize a name value pair into a cookie string suitable for
 * http headers. An optional options object specifies cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!cookieNameRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !cookieValueRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (!isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!domainValueRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!pathValueRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    var expires = opt.expires

    if (!isDate(expires) || isNaN(expires.valueOf())) {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + expires.toUTCString()
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.partitioned) {
    str += '; Partitioned'
  }

  if (opt.priority) {
    var priority = typeof opt.priority === 'string'
      ? opt.priority.toLowerCase()
      : opt.priority

    switch (priority) {
      case 'low':
        str += '; Priority=Low'
        break
      case 'medium':
        str += '; Priority=Medium'
        break
      case 'high':
        str += '; Priority=High'
        break
      default:
        throw new TypeError('option priority is invalid')
    }
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * URL-decode string value. Optimized to skip native call when no %.
 *
 * @param {string} str
 * @returns {string}
 */

function decode (str) {
  return str.indexOf('%') !== -1
    ? decodeURIComponent(str)
    : str
}

/**
 * URL-encode value.
 *
 * @param {string} val
 * @returns {string}
 */

function encode (val) {
  return encodeURIComponent(val)
}

/**
 * Determine if value is a Date.
 *
 * @param {*} val
 * @private
 */

function isDate (val) {
  return __toString.call(val) === '[object Date]' ||
    val instanceof Date
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ }),

/***/ 35196:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.checkCookies = exports.hasCookie = exports.removeCookies = exports.deleteCookie = exports.setCookies = exports.setCookie = exports.getCookie = exports.getCookies = void 0;
var cookie_1 = __webpack_require__(13421);
var isClientSide = function () { return typeof window !== 'undefined'; };
var processValue = function (value) {
    if (value === 'true')
        return true;
    if (value === 'false')
        return false;
    if (value === 'undefined')
        return undefined;
    if (value === 'null')
        return null;
    return value;
};
var stringify = function (value) {
    if (value === void 0) { value = ''; }
    try {
        var result = JSON.stringify(value);
        return (/^[\{\[]/.test(result)) ? result : value;
    }
    catch (e) {
        return value;
    }
};
var decode = function (str) {
    if (!str)
        return str;
    return str.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
};
var getCookies = function (options) {
    var req;
    if (options)
        req = options.req;
    if (!isClientSide()) {
        // if cookie-parser is used in project get cookies from ctx.req.cookies
        // if cookie-parser isn't used in project get cookies from ctx.req.headers.cookie
        if (req && req.cookies)
            return req.cookies;
        if (req && req.headers && req.headers.cookie)
            return (0, cookie_1.parse)(req.headers.cookie);
        return {};
    }
    var _cookies = {};
    var documentCookies = document.cookie ? document.cookie.split('; ') : [];
    for (var i = 0, len = documentCookies.length; i < len; i++) {
        var cookieParts = documentCookies[i].split('=');
        var _cookie = cookieParts.slice(1).join('=');
        var name_1 = cookieParts[0];
        _cookies[name_1] = _cookie;
    }
    return _cookies;
};
exports.getCookies = getCookies;
var getCookie = function (key, options) {
    var _cookies = (0, exports.getCookies)(options);
    var value = _cookies[key];
    if (value === undefined)
        return undefined;
    return processValue(decode(value));
};
exports.getCookie = getCookie;
var setCookie = function (key, data, options) {
    var _cookieOptions;
    var _req;
    var _res;
    if (options) {
        var req = options.req, res = options.res, _options = __rest(options, ["req", "res"]);
        _req = req;
        _res = res;
        _cookieOptions = _options;
    }
    var cookieStr = (0, cookie_1.serialize)(key, stringify(data), __assign({ path: '/' }, _cookieOptions));
    if (!isClientSide()) {
        if (_res && _req) {
            var currentCookies = _res.getHeader('Set-Cookie');
            if (!Array.isArray(currentCookies)) {
                currentCookies = !currentCookies ? [] : [String(currentCookies)];
            }
            _res.setHeader('Set-Cookie', currentCookies.concat(cookieStr));
            if (_req && _req.cookies) {
                var _cookies = _req.cookies;
                data === '' ? delete _cookies[key] : _cookies[key] = stringify(data);
            }
            if (_req && _req.headers && _req.headers.cookie) {
                var _cookies = (0, cookie_1.parse)(_req.headers.cookie);
                data === '' ? delete _cookies[key] : _cookies[key] = stringify(data);
                _req.headers.cookie = Object.entries(_cookies).reduce(function (accum, item) {
                    return accum.concat("".concat(item[0], "=").concat(item[1], ";"));
                }, '');
            }
        }
    }
    else {
        document.cookie = cookieStr;
    }
};
exports.setCookie = setCookie;
/**
 * @deprecated setCookies was deprecated. It will be deleted in the new version. Use setCookie instead.
 */
var setCookies = function (key, data, options) {
    console.warn('[WARN]: setCookies was deprecated. It will be deleted in the new version. Use setCookie instead.');
    return (0, exports.setCookie)(key, data, options);
};
exports.setCookies = setCookies;
var deleteCookie = function (key, options) {
    return (0, exports.setCookie)(key, '', __assign(__assign({}, options), { maxAge: -1 }));
};
exports.deleteCookie = deleteCookie;
/**
 * @deprecated removeCookies was deprecated. It will be deleted in the new version. Use deleteCookie instead.
 */
var removeCookies = function (key, options) {
    console.warn('[WARN]: removeCookies was deprecated. It will be deleted in the new version. Use deleteCookie instead.');
    return (0, exports.deleteCookie)(key, options);
};
exports.removeCookies = removeCookies;
var hasCookie = function (key, options) {
    if (!key)
        return false;
    var cookie = (0, exports.getCookies)(options);
    return cookie.hasOwnProperty(key);
};
exports.hasCookie = hasCookie;
/**
 * @deprecated checkCookies was deprecated. It will be deleted in the new version. Use hasCookie instead.
 */
var checkCookies = function (key, options) {
    console.warn('[WARN]: checkCookies was deprecated. It will be deleted in the new version. Use hasCookie instead.');
    return (0, exports.hasCookie)(key, options);
};
exports.checkCookies = checkCookies;


/***/ }),

/***/ 69623:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = addLeadingZeros;
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}
module.exports = exports.default;

/***/ }),

/***/ 16733:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = assign;
function assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }
  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      ;
      target[property] = object[property];
    }
  }
  return target;
}
module.exports = exports.default;

/***/ }),

/***/ 98041:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = cloneObject;
var _index = _interopRequireDefault(__webpack_require__(16733));
function cloneObject(object) {
  return (0, _index.default)({}, object);
}
module.exports = exports.default;

/***/ }),

/***/ 59026:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(50626));
var _default = _index.default;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 1906:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.getDefaultOptions = getDefaultOptions;
exports.setDefaultOptions = setDefaultOptions;
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

/***/ }),

/***/ 91902:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(53279));
var _index2 = _interopRequireDefault(__webpack_require__(19819));
var _index3 = _interopRequireDefault(__webpack_require__(29377));
var _index4 = _interopRequireDefault(__webpack_require__(94753));
var _index5 = _interopRequireDefault(__webpack_require__(65070));
var _index6 = _interopRequireDefault(__webpack_require__(69623));
var _index7 = _interopRequireDefault(__webpack_require__(1181));
var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return _index7.default.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = (0, _index5.default)(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return (0, _index6.default)(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return (0, _index6.default)(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = (0, _index3.default)(date);

    // Padding
    return (0, _index6.default)(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return (0, _index6.default)(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return (0, _index6.default)(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return (0, _index6.default)(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return _index7.default.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return (0, _index6.default)(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = (0, _index4.default)(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return (0, _index6.default)(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = (0, _index2.default)(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return (0, _index6.default)(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return _index7.default.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = (0, _index.default)(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return (0, _index6.default)(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return (0, _index6.default)(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return (0, _index6.default)(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return (0, _index6.default)(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return _index7.default.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return _index7.default.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return (0, _index6.default)(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return (0, _index6.default)(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return _index7.default.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return _index7.default.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return _index7.default.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return (0, _index6.default)(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return (0, _index6.default)(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + (0, _index6.default)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + (0, _index6.default)(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = (0, _index6.default)(Math.floor(absOffset / 60), 2);
  var minutes = (0, _index6.default)(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var _default = formatters;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 1181:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(69623));
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return (0, _index.default)(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return (0, _index.default)(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return (0, _index.default)(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return (0, _index.default)(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return (0, _index.default)(fractionalSeconds, token.length);
  }
};
var _default = formatters;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 13360:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var _default = longFormatters;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 4261:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getTimezoneOffsetInMilliseconds;
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}
module.exports = exports.default;

/***/ }),

/***/ 53279:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCDayOfYear;
var _index = _interopRequireDefault(__webpack_require__(39276));
var _index2 = _interopRequireDefault(__webpack_require__(26193));
var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
module.exports = exports.default;

/***/ }),

/***/ 19819:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCISOWeek;
var _index = _interopRequireDefault(__webpack_require__(39276));
var _index2 = _interopRequireDefault(__webpack_require__(35265));
var _index3 = _interopRequireDefault(__webpack_require__(94941));
var _index4 = _interopRequireDefault(__webpack_require__(26193));
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  (0, _index4.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
module.exports = exports.default;

/***/ }),

/***/ 29377:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCISOWeekYear;
var _index = _interopRequireDefault(__webpack_require__(39276));
var _index2 = _interopRequireDefault(__webpack_require__(26193));
var _index3 = _interopRequireDefault(__webpack_require__(35265));
function getUTCISOWeekYear(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0, _index3.default)(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0, _index3.default)(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
module.exports = exports.default;

/***/ }),

/***/ 94753:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCWeek;
var _index = _interopRequireDefault(__webpack_require__(39276));
var _index2 = _interopRequireDefault(__webpack_require__(23658));
var _index3 = _interopRequireDefault(__webpack_require__(34746));
var _index4 = _interopRequireDefault(__webpack_require__(26193));
var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  (0, _index4.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}
module.exports = exports.default;

/***/ }),

/***/ 65070:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getUTCWeekYear;
var _index = _interopRequireDefault(__webpack_require__(39276));
var _index2 = _interopRequireDefault(__webpack_require__(26193));
var _index3 = _interopRequireDefault(__webpack_require__(23658));
var _index4 = _interopRequireDefault(__webpack_require__(65862));
var _index5 = __webpack_require__(1906);
function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = (0, _index5.getDefaultOptions)();
  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
module.exports = exports.default;

/***/ }),

/***/ 88440:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
exports.isProtectedWeekYearToken = isProtectedWeekYearToken;
exports.throwProtectedError = throwProtectedError;
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

/***/ }),

/***/ 26193:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = requiredArgs;
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}
module.exports = exports.default;

/***/ }),

/***/ 35265:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCISOWeek;
var _index = _interopRequireDefault(__webpack_require__(39276));
var _index2 = _interopRequireDefault(__webpack_require__(26193));
function startOfUTCISOWeek(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var weekStartsOn = 1;
  var date = (0, _index.default)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
module.exports = exports.default;

/***/ }),

/***/ 94941:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCISOWeekYear;
var _index = _interopRequireDefault(__webpack_require__(29377));
var _index2 = _interopRequireDefault(__webpack_require__(35265));
var _index3 = _interopRequireDefault(__webpack_require__(26193));
function startOfUTCISOWeekYear(dirtyDate) {
  (0, _index3.default)(1, arguments);
  var year = (0, _index.default)(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = (0, _index2.default)(fourthOfJanuary);
  return date;
}
module.exports = exports.default;

/***/ }),

/***/ 23658:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCWeek;
var _index = _interopRequireDefault(__webpack_require__(39276));
var _index2 = _interopRequireDefault(__webpack_require__(26193));
var _index3 = _interopRequireDefault(__webpack_require__(65862));
var _index4 = __webpack_require__(1906);
function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0, _index2.default)(1, arguments);
  var defaultOptions = (0, _index4.getDefaultOptions)();
  var weekStartsOn = (0, _index3.default)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0, _index.default)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}
module.exports = exports.default;

/***/ }),

/***/ 34746:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = startOfUTCWeekYear;
var _index = _interopRequireDefault(__webpack_require__(65070));
var _index2 = _interopRequireDefault(__webpack_require__(26193));
var _index3 = _interopRequireDefault(__webpack_require__(23658));
var _index4 = _interopRequireDefault(__webpack_require__(65862));
var _index5 = __webpack_require__(1906);
function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0, _index2.default)(1, arguments);
  var defaultOptions = (0, _index5.getDefaultOptions)();
  var firstWeekContainsDate = (0, _index4.default)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = (0, _index.default)(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = (0, _index3.default)(firstWeek, options);
  return date;
}
module.exports = exports.default;

/***/ }),

/***/ 65862:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toInteger;
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}
module.exports = exports.default;

/***/ }),

/***/ 78995:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = addMilliseconds;
var _index = _interopRequireDefault(__webpack_require__(65862));
var _index2 = _interopRequireDefault(__webpack_require__(39276));
var _index3 = _interopRequireDefault(__webpack_require__(26193));
/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var timestamp = (0, _index2.default)(dirtyDate).getTime();
  var amount = (0, _index.default)(dirtyAmount);
  return new Date(timestamp + amount);
}
module.exports = exports.default;

/***/ }),

/***/ 36012:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addLeadingZeros; }
/* harmony export */ });
function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

/***/ }),

/***/ 15344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ defaultLocale; }
});

;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/formatDistance/index.js
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
/* harmony default export */ var _lib_formatDistance = (formatDistance);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildFormatLongFn/index.js
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/formatLong/index.js

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
/* harmony default export */ var _lib_formatLong = (formatLong);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/formatRelative/index.js
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
/* harmony default export */ var _lib_formatRelative = (formatRelative);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildLocalizeFn/index.js
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/localize/index.js

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
/* harmony default export */ var _lib_localize = (localize);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildMatchFn/index.js
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/_lib/buildMatchPatternFn/index.js
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/_lib/match/index.js


var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
/* harmony default export */ var _lib_match = (match);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/locale/en-US/index.js





/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _lib_formatDistance,
  formatLong: _lib_formatLong,
  formatRelative: _lib_formatRelative,
  localize: _lib_localize,
  match: _lib_match,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
/* harmony default export */ var en_US = (locale);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/defaultLocale/index.js

/* harmony default export */ var defaultLocale = (en_US);

/***/ }),

/***/ 18667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getDefaultOptions; }
/* harmony export */ });
/* unused harmony export setDefaultOptions */
var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}
function setDefaultOptions(newOptions) {
  defaultOptions = newOptions;
}

/***/ }),

/***/ 60429:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
/* harmony default export */ __webpack_exports__["Z"] = (longFormatters);

/***/ }),

/***/ 1645:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getTimezoneOffsetInMilliseconds; }
/* harmony export */ });
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

/***/ }),

/***/ 17898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getUTCISOWeek; }
});

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(66700);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__(55143);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__(90257);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(19785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCISOWeekYear/index.js



function startOfUTCISOWeekYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var year = (0,getUTCISOWeekYear/* default */.Z)(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = (0,startOfUTCISOWeek/* default */.Z)(fourthOfJanuary);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCISOWeek(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = (0,startOfUTCISOWeek/* default */.Z)(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 90257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getUTCISOWeekYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);
/* harmony import */ var _startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55143);



function getUTCISOWeekYear(dirtyDate) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfUTCISOWeek_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 10663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ getUTCWeek; }
});

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(66700);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(52329);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(72763);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(19785);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(42765);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(18667);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCWeekYear/index.js





function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = (0,getUTCWeekYear/* default */.Z)(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = (0,startOfUTCWeek/* default */.Z)(firstWeek, options);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCWeek/index.js




var MILLISECONDS_IN_WEEK = 604800000;
function getUTCWeek(dirtyDate, options) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var diff = (0,startOfUTCWeek/* default */.Z)(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/***/ }),

/***/ 72763:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getUTCWeekYear; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);
/* harmony import */ var _startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52329);
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(42765);
/* harmony import */ var _defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18667);





function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = (0,_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_2__/* .getDefaultOptions */ .j)();
  var firstWeekContainsDate = (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0,_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0,_startOfUTCWeek_index_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/***/ }),

/***/ 13503:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Do": function() { return /* binding */ isProtectedWeekYearToken; },
/* harmony export */   "Iu": function() { return /* binding */ isProtectedDayOfYearToken; },
/* harmony export */   "qp": function() { return /* binding */ throwProtectedError; }
/* harmony export */ });
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

/***/ }),

/***/ 19785:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ requiredArgs; }
/* harmony export */ });
function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/***/ }),

/***/ 55143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfUTCISOWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


function startOfUTCISOWeek(dirtyDate) {
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var weekStartsOn = 1;
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 52329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfUTCWeek; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66700);
/* harmony import */ var _requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);
/* harmony import */ var _toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42765);
/* harmony import */ var _defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18667);




function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var defaultOptions = (0,_defaultOptions_index_js__WEBPACK_IMPORTED_MODULE_1__/* .getDefaultOptions */ .j)();
  var weekStartsOn = (0,_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 42765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toInteger; }
/* harmony export */ });
function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/***/ }),

/***/ 63761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ addDays; }
/* harmony export */ });
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42765);
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);



/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  var amount = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}

/***/ }),

/***/ 64312:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "qk": function() { return /* binding */ millisecondsInSecond; },
/* harmony export */   "vh": function() { return /* binding */ millisecondsInHour; },
/* harmony export */   "yJ": function() { return /* binding */ millisecondsInMinute; }
/* harmony export */ });
/* unused harmony exports daysInWeek, daysInYear, maxTime, minTime, minutesInHour, monthsInQuarter, monthsInYear, quartersInYear, secondsInHour, secondsInMinute, secondsInDay, secondsInWeek, secondsInYear, secondsInMonth, secondsInQuarter */
/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */
var daysInWeek = 7;

/**
 * Days in 1 year
 * One years equals 365.2425 days according to the formula:
 *
 * > Leap year occures every 4 years, except for years that are divisable by 100 and not divisable by 400.
 * > 1 mean year = (365+1/4-1/100+1/400) days = 365.2425 days
 *
 * @name daysInYear
 * @constant
 * @type {number}
 * @default
 */
var daysInYear = 365.2425;

/**
 * Maximum allowed time.
 *
 * @name maxTime
 * @constant
 * @type {number}
 * @default
 */
var maxTime = Math.pow(10, 8) * 24 * 60 * 60 * 1000;

/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInMinute = 60000;

/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInHour = 3600000;

/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInSecond = 1000;

/**
 * Minimum allowed time.
 *
 * @name minTime
 * @constant
 * @type {number}
 * @default
 */
var minTime = -maxTime;

/**
 * Minutes in 1 hour
 *
 * @name minutesInHour
 * @constant
 * @type {number}
 * @default
 */
var minutesInHour = 60;

/**
 * Months in 1 quarter
 *
 * @name monthsInQuarter
 * @constant
 * @type {number}
 * @default
 */
var monthsInQuarter = 3;

/**
 * Months in 1 year
 *
 * @name monthsInYear
 * @constant
 * @type {number}
 * @default
 */
var monthsInYear = 12;

/**
 * Quarters in 1 year
 *
 * @name quartersInYear
 * @constant
 * @type {number}
 * @default
 */
var quartersInYear = 4;

/**
 * Seconds in 1 hour
 *
 * @name secondsInHour
 * @constant
 * @type {number}
 * @default
 */
var secondsInHour = 3600;

/**
 * Seconds in 1 minute
 *
 * @name secondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var secondsInMinute = 60;

/**
 * Seconds in 1 day
 *
 * @name secondsInDay
 * @constant
 * @type {number}
 * @default
 */
var secondsInDay = secondsInHour * 24;

/**
 * Seconds in 1 week
 *
 * @name secondsInWeek
 * @constant
 * @type {number}
 * @default
 */
var secondsInWeek = secondsInDay * 7;

/**
 * Seconds in 1 year
 *
 * @name secondsInYear
 * @constant
 * @type {number}
 * @default
 */
var secondsInYear = secondsInDay * daysInYear;

/**
 * Seconds in 1 month
 *
 * @name secondsInMonth
 * @constant
 * @type {number}
 * @default
 */
var secondsInMonth = secondsInYear / 12;

/**
 * Seconds in 1 quarter
 *
 * @name secondsInQuarter
 * @constant
 * @type {number}
 * @default
 */
var secondsInQuarter = secondsInMonth * 3;

/***/ }),

/***/ 97361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ format; }
});

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isValid/index.js + 1 modules
var isValid = __webpack_require__(31200);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/subMilliseconds/index.js + 1 modules
var subMilliseconds = __webpack_require__(89248);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(66700);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(19785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/getUTCDayOfYear/index.js


var MILLISECONDS_IN_DAY = 86400000;
function getUTCDayOfYear(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__(17898);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getUTCISOWeekYear/index.js
var getUTCISOWeekYear = __webpack_require__(90257);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__(10663);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(72763);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
var addLeadingZeros = __webpack_require__(36012);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/format/lightFormatters/index.js

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return (0,addLeadingZeros/* default */.Z)(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : (0,addLeadingZeros/* default */.Z)(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return (0,addLeadingZeros/* default */.Z)(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return (0,addLeadingZeros/* default */.Z)(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return (0,addLeadingZeros/* default */.Z)(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return (0,addLeadingZeros/* default */.Z)(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return (0,addLeadingZeros/* default */.Z)(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return (0,addLeadingZeros/* default */.Z)(fractionalSeconds, token.length);
  }
};
/* harmony default export */ var lightFormatters = (formatters);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/format/formatters/index.js







var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters_formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return lightFormatters.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = (0,getUTCWeekYear/* default */.Z)(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return (0,addLeadingZeros/* default */.Z)(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return (0,addLeadingZeros/* default */.Z)(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = (0,getUTCISOWeekYear/* default */.Z)(date);

    // Padding
    return (0,addLeadingZeros/* default */.Z)(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return (0,addLeadingZeros/* default */.Z)(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return (0,addLeadingZeros/* default */.Z)(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return (0,addLeadingZeros/* default */.Z)(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return lightFormatters.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return (0,addLeadingZeros/* default */.Z)(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = (0,getUTCWeek/* default */.Z)(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return (0,addLeadingZeros/* default */.Z)(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = (0,getUTCISOWeek/* default */.Z)(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return (0,addLeadingZeros/* default */.Z)(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return lightFormatters.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return (0,addLeadingZeros/* default */.Z)(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return (0,addLeadingZeros/* default */.Z)(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return (0,addLeadingZeros/* default */.Z)(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return (0,addLeadingZeros/* default */.Z)(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return lightFormatters.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return lightFormatters.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return (0,addLeadingZeros/* default */.Z)(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return (0,addLeadingZeros/* default */.Z)(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return lightFormatters.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return lightFormatters.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return lightFormatters.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return (0,addLeadingZeros/* default */.Z)(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return (0,addLeadingZeros/* default */.Z)(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + (0,addLeadingZeros/* default */.Z)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + (0,addLeadingZeros/* default */.Z)(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = (0,addLeadingZeros/* default */.Z)(Math.floor(absOffset / 60), 2);
  var minutes = (0,addLeadingZeros/* default */.Z)(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
/* harmony default export */ var format_formatters = (formatters_formatters);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__(60429);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(1645);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__(13503);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(42765);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(18667);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/defaultLocale/index.js + 10 modules
var defaultLocale = __webpack_require__(15344);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/format/index.js










 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  (0,requiredArgs/* default */.Z)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = (0,toDate/* default */.Z)(dirtyDate);
  if (!(0,isValid/* default */.Z)(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = (0,getTimezoneOffsetInMilliseconds/* default */.Z)(originalDate);
  var utcDate = (0,subMilliseconds/* default */.Z)(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters/* default */.Z[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = format_formatters[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0,protectedTokens/* isProtectedWeekYearToken */.Do)(substring)) {
        (0,protectedTokens/* throwProtectedError */.qp)(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0,protectedTokens/* isProtectedDayOfYearToken */.Iu)(substring)) {
        (0,protectedTokens/* throwProtectedError */.qp)(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}

/***/ }),

/***/ 82276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isSameDay; }
/* harmony export */ });
/* harmony import */ var _startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10405);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(2, arguments);
  var dateLeftStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateLeft);
  var dateRightStartOfDay = (0,_startOfDay_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/***/ }),

/***/ 82236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ isToday; }
/* harmony export */ });
/* harmony import */ var _isSameDay_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82276);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name isToday
 * @category Day Helpers
 * @summary Is the given date today?
 * @pure false
 *
 * @description
 * Is the given date today?
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @param {Date|Number} date - the date to check
 * @returns {Boolean} the date is today
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * const result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  return (0,_isSameDay_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate, Date.now());
}

/***/ }),

/***/ 31200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ isValid; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(19785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/isDate/index.js


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  return value instanceof Date || (0,esm_typeof/* default */.Z)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(66700);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/isValid/index.js



/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  (0,requiredArgs/* default */.Z)(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = (0,toDate/* default */.Z)(dirtyDate);
  return !isNaN(Number(date));
}

/***/ }),

/***/ 31807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ parseISO; }
/* harmony export */ });
/* harmony import */ var _constants_index_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64312);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);
/* harmony import */ var _lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42765);



/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */
function parseISO(argument, options) {
  var _options$additionalDi;
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var additionalDigits = (0,_lib_toInteger_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }
  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }
  var timestamp = date.getTime();
  var time = 0;
  var offset;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time);
    // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.
    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;

  // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex);
  // Invalid ISO-formatted year
  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;

  // either year or century is null, not both
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex);
  // Invalid ISO-formatted string
  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInHour */ .vh + minutes * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInMinute */ .yJ + seconds * 1000;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign * (hours * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInHour */ .vh + minutes * _constants_index_js__WEBPACK_IMPORTED_MODULE_2__/* .millisecondsInMinute */ .yJ);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

// February is null to handle the leap year (using ||)
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/***/ }),

/***/ 10405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ startOfDay; }
/* harmony export */ });
/* harmony import */ var _toDate_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66700);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var date = (0,_toDate_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

/***/ }),

/***/ 89248:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ subMilliseconds; }
});

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(42765);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(66700);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(19785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/addMilliseconds/index.js



/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var timestamp = (0,toDate/* default */.Z)(dirtyDate).getTime();
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return new Date(timestamp + amount);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/subMilliseconds/index.js



/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

/***/ }),

/***/ 66700:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ toDate; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86522);
/* harmony import */ var _lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19785);


/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  (0,_lib_requiredArgs_index_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/***/ }),

/***/ 55695:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = format;
var _index = _interopRequireDefault(__webpack_require__(33187));
var _index2 = _interopRequireDefault(__webpack_require__(15356));
var _index3 = _interopRequireDefault(__webpack_require__(39276));
var _index4 = _interopRequireDefault(__webpack_require__(91902));
var _index5 = _interopRequireDefault(__webpack_require__(13360));
var _index6 = _interopRequireDefault(__webpack_require__(4261));
var _index7 = __webpack_require__(88440);
var _index8 = _interopRequireDefault(__webpack_require__(65862));
var _index9 = _interopRequireDefault(__webpack_require__(26193));
var _index10 = __webpack_require__(1906);
var _index11 = _interopRequireDefault(__webpack_require__(59026));
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  (0, _index9.default)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = (0, _index10.getDefaultOptions)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : _index11.default;
  var firstWeekContainsDate = (0, _index8.default)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = (0, _index8.default)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = (0, _index3.default)(dirtyDate);
  if (!(0, _index.default)(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = (0, _index6.default)(originalDate);
  var utcDate = (0, _index2.default)(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = _index5.default[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }
    var formatter = _index4.default[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, _index7.isProtectedWeekYearToken)(substring)) {
        (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, _index7.isProtectedDayOfYearToken)(substring)) {
        (0, _index7.throwProtectedError)(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString(input) {
  var matched = input.match(escapedStringRegExp);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp, "'");
}
module.exports = exports.default;

/***/ }),

/***/ 93018:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isDate;
var _typeof2 = _interopRequireDefault(__webpack_require__(67425));
var _index = _interopRequireDefault(__webpack_require__(26193));
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  (0, _index.default)(1, arguments);
  return value instanceof Date || (0, _typeof2.default)(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}
module.exports = exports.default;

/***/ }),

/***/ 33187:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = isValid;
var _index = _interopRequireDefault(__webpack_require__(93018));
var _index2 = _interopRequireDefault(__webpack_require__(39276));
var _index3 = _interopRequireDefault(__webpack_require__(26193));
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  (0, _index3.default)(1, arguments);
  if (!(0, _index.default)(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = (0, _index2.default)(dirtyDate);
  return !isNaN(Number(date));
}
module.exports = exports.default;

/***/ }),

/***/ 22348:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildFormatLongFn;
function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}
module.exports = exports.default;

/***/ }),

/***/ 84738:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildLocalizeFn;
function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}
module.exports = exports.default;

/***/ }),

/***/ 89653:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildMatchFn;
function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}
module.exports = exports.default;

/***/ }),

/***/ 71604:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = buildMatchPatternFn;
function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
module.exports = exports.default;

/***/ }),

/***/ 23361:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
var _default = formatDistance;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 11780:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(22348));
var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: (0, _index.default)({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: (0, _index.default)({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0, _index.default)({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var _default = formatLong;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 33663:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
};
var _default = formatRelative;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 78350:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(84738));
var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: (0, _index.default)({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0, _index.default)({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: (0, _index.default)({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: (0, _index.default)({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0, _index.default)({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var _default = localize;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 66049:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(89653));
var _index2 = _interopRequireDefault(__webpack_require__(71604));
var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: (0, _index2.default)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: (0, _index.default)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0, _index.default)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: (0, _index.default)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0, _index.default)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0, _index.default)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var _default = match;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 50626:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;
var _index = _interopRequireDefault(__webpack_require__(23361));
var _index2 = _interopRequireDefault(__webpack_require__(11780));
var _index3 = _interopRequireDefault(__webpack_require__(33663));
var _index4 = _interopRequireDefault(__webpack_require__(78350));
var _index5 = _interopRequireDefault(__webpack_require__(66049));
/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _index.default,
  formatLong: _index2.default,
  formatRelative: _index3.default,
  localize: _index4.default,
  match: _index5.default,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var _default = locale;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 15356:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = subMilliseconds;
var _index = _interopRequireDefault(__webpack_require__(78995));
var _index2 = _interopRequireDefault(__webpack_require__(26193));
var _index3 = _interopRequireDefault(__webpack_require__(65862));
/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  (0, _index2.default)(2, arguments);
  var amount = (0, _index3.default)(dirtyAmount);
  return (0, _index.default)(dirtyDate, -amount);
}
module.exports = exports.default;

/***/ }),

/***/ 39276:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = (__webpack_require__(71600)["default"]);
Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toDate;
var _typeof2 = _interopRequireDefault(__webpack_require__(67425));
var _index = _interopRequireDefault(__webpack_require__(26193));
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  (0, _index.default)(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || (0, _typeof2.default)(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}
module.exports = exports.default;

/***/ }),

/***/ 5141:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(68381);
var gOPD = __webpack_require__(91790);

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;


/***/ }),

/***/ 70870:
/***/ (function(module) {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),

/***/ 91790:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(70870);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 70999:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),

/***/ 69654:
/***/ (function(module) {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),

/***/ 42321:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),

/***/ 48205:
/***/ (function(module) {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),

/***/ 2976:
/***/ (function(module) {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),

/***/ 48342:
/***/ (function(module) {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),

/***/ 5408:
/***/ (function(module) {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),

/***/ 82885:
/***/ (function(module) {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),

/***/ 54546:
/***/ (function(module) {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ }),

/***/ 37795:
/***/ (function(module) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),

/***/ 4090:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(37795);

module.exports = Function.prototype.bind || implementation;


/***/ }),

/***/ 2938:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $Object = __webpack_require__(54546);

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;


/***/ }),

/***/ 78354:
/***/ (function(module) {

"use strict";


/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ }),

/***/ 21750:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reflectGetProto = __webpack_require__(78354);
var originalGetProto = __webpack_require__(2938);

var getDunderProto = __webpack_require__(5141);

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;


/***/ }),

/***/ 73463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(48570);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 59392:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var named_references_1 = __webpack_require__(62820);
var numeric_unicode_map_1 = __webpack_require__(11946);
var surrogate_pairs_1 = __webpack_require__(4265);
var allNamedReferences = __assign(__assign({}, named_references_1.namedReferences), { all: named_references_1.namedReferences.html5 });
var encodeRegExps = {
    specialChars: /[<>'"&]/g,
    nonAscii: /[<>'"&\u0080-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g,
    nonAsciiPrintable: /[<>'"&\x01-\x08\x11-\x15\x17-\x1F\x7f-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g,
    nonAsciiPrintableOnly: /[\x01-\x08\x11-\x15\x17-\x1F\x7f-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g,
    extensive: /[\x01-\x0c\x0e-\x1f\x21-\x2c\x2e-\x2f\x3a-\x40\x5b-\x60\x7b-\x7d\x7f-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/g
};
var defaultEncodeOptions = {
    mode: 'specialChars',
    level: 'all',
    numeric: 'decimal'
};
/** Encodes all the necessary (specified by `level`) characters in the text */
function encode(text, _a) {
    var _b = _a === void 0 ? defaultEncodeOptions : _a, _c = _b.mode, mode = _c === void 0 ? 'specialChars' : _c, _d = _b.numeric, numeric = _d === void 0 ? 'decimal' : _d, _e = _b.level, level = _e === void 0 ? 'all' : _e;
    if (!text) {
        return '';
    }
    var encodeRegExp = encodeRegExps[mode];
    var references = allNamedReferences[level].characters;
    var isHex = numeric === 'hexadecimal';
    encodeRegExp.lastIndex = 0;
    var _b = encodeRegExp.exec(text);
    var _c;
    if (_b) {
        _c = '';
        var _d = 0;
        do {
            if (_d !== _b.index) {
                _c += text.substring(_d, _b.index);
            }
            var _e = _b[0];
            var result_1 = references[_e];
            if (!result_1) {
                var code_1 = _e.length > 1 ? surrogate_pairs_1.getCodePoint(_e, 0) : _e.charCodeAt(0);
                result_1 = (isHex ? '&#x' + code_1.toString(16) : '&#' + code_1) + ';';
            }
            _c += result_1;
            _d = _b.index + _e.length;
        } while ((_b = encodeRegExp.exec(text)));
        if (_d !== text.length) {
            _c += text.substring(_d);
        }
    }
    else {
        _c =
            text;
    }
    return _c;
}
exports.encode = encode;
var defaultDecodeOptions = {
    scope: 'body',
    level: 'all'
};
var strict = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);/g;
var attribute = /&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+)[;=]?/g;
var baseDecodeRegExps = {
    xml: {
        strict: strict,
        attribute: attribute,
        body: named_references_1.bodyRegExps.xml
    },
    html4: {
        strict: strict,
        attribute: attribute,
        body: named_references_1.bodyRegExps.html4
    },
    html5: {
        strict: strict,
        attribute: attribute,
        body: named_references_1.bodyRegExps.html5
    }
};
var decodeRegExps = __assign(__assign({}, baseDecodeRegExps), { all: baseDecodeRegExps.html5 });
var fromCharCode = String.fromCharCode;
var outOfBoundsChar = fromCharCode(65533);
var defaultDecodeEntityOptions = {
    level: 'all'
};
/** Decodes a single entity */
function decodeEntity(entity, _a) {
    var _b = (_a === void 0 ? defaultDecodeEntityOptions : _a).level, level = _b === void 0 ? 'all' : _b;
    if (!entity) {
        return '';
    }
    var _b = entity;
    var decodeEntityLastChar_1 = entity[entity.length - 1];
    if (false) {}
    else if (false) {}
    else {
        var decodeResultByReference_1 = allNamedReferences[level].entities[entity];
        if (decodeResultByReference_1) {
            _b = decodeResultByReference_1;
        }
        else if (entity[0] === '&' && entity[1] === '#') {
            var decodeSecondChar_1 = entity[2];
            var decodeCode_1 = decodeSecondChar_1 == 'x' || decodeSecondChar_1 == 'X'
                ? parseInt(entity.substr(3), 16)
                : parseInt(entity.substr(2));
            _b =
                decodeCode_1 >= 0x10ffff
                    ? outOfBoundsChar
                    : decodeCode_1 > 65535
                        ? surrogate_pairs_1.fromCodePoint(decodeCode_1)
                        : fromCharCode(numeric_unicode_map_1.numericUnicodeMap[decodeCode_1] || decodeCode_1);
        }
    }
    return _b;
}
exports.decodeEntity = decodeEntity;
/** Decodes all entities in the text */
function decode(text, _a) {
    var decodeSecondChar_1 = _a === void 0 ? defaultDecodeOptions : _a, decodeCode_1 = decodeSecondChar_1.level, level = decodeCode_1 === void 0 ? 'all' : decodeCode_1, _b = decodeSecondChar_1.scope, scope = _b === void 0 ? level === 'xml' ? 'strict' : 'body' : _b;
    if (!text) {
        return '';
    }
    var decodeRegExp = decodeRegExps[level][scope];
    var references = allNamedReferences[level].entities;
    var isAttribute = scope === 'attribute';
    var isStrict = scope === 'strict';
    decodeRegExp.lastIndex = 0;
    var replaceMatch_1 = decodeRegExp.exec(text);
    var replaceResult_1;
    if (replaceMatch_1) {
        replaceResult_1 = '';
        var replaceLastIndex_1 = 0;
        do {
            if (replaceLastIndex_1 !== replaceMatch_1.index) {
                replaceResult_1 += text.substring(replaceLastIndex_1, replaceMatch_1.index);
            }
            var replaceInput_1 = replaceMatch_1[0];
            var decodeResult_1 = replaceInput_1;
            var decodeEntityLastChar_2 = replaceInput_1[replaceInput_1.length - 1];
            if (isAttribute
                && decodeEntityLastChar_2 === '=') {
                decodeResult_1 = replaceInput_1;
            }
            else if (isStrict
                && decodeEntityLastChar_2 !== ';') {
                decodeResult_1 = replaceInput_1;
            }
            else {
                var decodeResultByReference_2 = references[replaceInput_1];
                if (decodeResultByReference_2) {
                    decodeResult_1 = decodeResultByReference_2;
                }
                else if (replaceInput_1[0] === '&' && replaceInput_1[1] === '#') {
                    var decodeSecondChar_2 = replaceInput_1[2];
                    var decodeCode_2 = decodeSecondChar_2 == 'x' || decodeSecondChar_2 == 'X'
                        ? parseInt(replaceInput_1.substr(3), 16)
                        : parseInt(replaceInput_1.substr(2));
                    decodeResult_1 =
                        decodeCode_2 >= 0x10ffff
                            ? outOfBoundsChar
                            : decodeCode_2 > 65535
                                ? surrogate_pairs_1.fromCodePoint(decodeCode_2)
                                : fromCharCode(numeric_unicode_map_1.numericUnicodeMap[decodeCode_2] || decodeCode_2);
                }
            }
            replaceResult_1 += decodeResult_1;
            replaceLastIndex_1 = replaceMatch_1.index + replaceInput_1.length;
        } while ((replaceMatch_1 = decodeRegExp.exec(text)));
        if (replaceLastIndex_1 !== text.length) {
            replaceResult_1 += text.substring(replaceLastIndex_1);
        }
    }
    else {
        replaceResult_1 =
            text;
    }
    return replaceResult_1;
}
exports.decode = decode;


/***/ }),

/***/ 62820:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:true}));exports.bodyRegExps={xml:/&(?:#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,html4:/&notin;|&(?:nbsp|iexcl|cent|pound|curren|yen|brvbar|sect|uml|copy|ordf|laquo|not|shy|reg|macr|deg|plusmn|sup2|sup3|acute|micro|para|middot|cedil|sup1|ordm|raquo|frac14|frac12|frac34|iquest|Agrave|Aacute|Acirc|Atilde|Auml|Aring|AElig|Ccedil|Egrave|Eacute|Ecirc|Euml|Igrave|Iacute|Icirc|Iuml|ETH|Ntilde|Ograve|Oacute|Ocirc|Otilde|Ouml|times|Oslash|Ugrave|Uacute|Ucirc|Uuml|Yacute|THORN|szlig|agrave|aacute|acirc|atilde|auml|aring|aelig|ccedil|egrave|eacute|ecirc|euml|igrave|iacute|icirc|iuml|eth|ntilde|ograve|oacute|ocirc|otilde|ouml|divide|oslash|ugrave|uacute|ucirc|uuml|yacute|thorn|yuml|quot|amp|lt|gt|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g,html5:/&centerdot;|&copysr;|&divideontimes;|&gtcc;|&gtcir;|&gtdot;|&gtlPar;|&gtquest;|&gtrapprox;|&gtrarr;|&gtrdot;|&gtreqless;|&gtreqqless;|&gtrless;|&gtrsim;|&ltcc;|&ltcir;|&ltdot;|&lthree;|&ltimes;|&ltlarr;|&ltquest;|&ltrPar;|&ltri;|&ltrie;|&ltrif;|&notin;|&notinE;|&notindot;|&notinva;|&notinvb;|&notinvc;|&notni;|&notniva;|&notnivb;|&notnivc;|&parallel;|&timesb;|&timesbar;|&timesd;|&(?:AElig|AMP|Aacute|Acirc|Agrave|Aring|Atilde|Auml|COPY|Ccedil|ETH|Eacute|Ecirc|Egrave|Euml|GT|Iacute|Icirc|Igrave|Iuml|LT|Ntilde|Oacute|Ocirc|Ograve|Oslash|Otilde|Ouml|QUOT|REG|THORN|Uacute|Ucirc|Ugrave|Uuml|Yacute|aacute|acirc|acute|aelig|agrave|amp|aring|atilde|auml|brvbar|ccedil|cedil|cent|copy|curren|deg|divide|eacute|ecirc|egrave|eth|euml|frac12|frac14|frac34|gt|iacute|icirc|iexcl|igrave|iquest|iuml|laquo|lt|macr|micro|middot|nbsp|not|ntilde|oacute|ocirc|ograve|ordf|ordm|oslash|otilde|ouml|para|plusmn|pound|quot|raquo|reg|sect|shy|sup1|sup2|sup3|szlig|thorn|times|uacute|ucirc|ugrave|uml|uuml|yacute|yen|yuml|#\d+|#[xX][\da-fA-F]+|[0-9a-zA-Z]+);?/g};exports.namedReferences={xml:{entities:{"&lt;":"<","&gt;":">","&quot;":'"',"&apos;":"'","&amp;":"&"},characters:{"<":"&lt;",">":"&gt;",'"':"&quot;","'":"&apos;","&":"&amp;"}},html4:{entities:{"&apos;":"'","&nbsp":" ","&nbsp;":" ","&iexcl":"¡","&iexcl;":"¡","&cent":"¢","&cent;":"¢","&pound":"£","&pound;":"£","&curren":"¤","&curren;":"¤","&yen":"¥","&yen;":"¥","&brvbar":"¦","&brvbar;":"¦","&sect":"§","&sect;":"§","&uml":"¨","&uml;":"¨","&copy":"©","&copy;":"©","&ordf":"ª","&ordf;":"ª","&laquo":"«","&laquo;":"«","&not":"¬","&not;":"¬","&shy":"­","&shy;":"­","&reg":"®","&reg;":"®","&macr":"¯","&macr;":"¯","&deg":"°","&deg;":"°","&plusmn":"±","&plusmn;":"±","&sup2":"²","&sup2;":"²","&sup3":"³","&sup3;":"³","&acute":"´","&acute;":"´","&micro":"µ","&micro;":"µ","&para":"¶","&para;":"¶","&middot":"·","&middot;":"·","&cedil":"¸","&cedil;":"¸","&sup1":"¹","&sup1;":"¹","&ordm":"º","&ordm;":"º","&raquo":"»","&raquo;":"»","&frac14":"¼","&frac14;":"¼","&frac12":"½","&frac12;":"½","&frac34":"¾","&frac34;":"¾","&iquest":"¿","&iquest;":"¿","&Agrave":"À","&Agrave;":"À","&Aacute":"Á","&Aacute;":"Á","&Acirc":"Â","&Acirc;":"Â","&Atilde":"Ã","&Atilde;":"Ã","&Auml":"Ä","&Auml;":"Ä","&Aring":"Å","&Aring;":"Å","&AElig":"Æ","&AElig;":"Æ","&Ccedil":"Ç","&Ccedil;":"Ç","&Egrave":"È","&Egrave;":"È","&Eacute":"É","&Eacute;":"É","&Ecirc":"Ê","&Ecirc;":"Ê","&Euml":"Ë","&Euml;":"Ë","&Igrave":"Ì","&Igrave;":"Ì","&Iacute":"Í","&Iacute;":"Í","&Icirc":"Î","&Icirc;":"Î","&Iuml":"Ï","&Iuml;":"Ï","&ETH":"Ð","&ETH;":"Ð","&Ntilde":"Ñ","&Ntilde;":"Ñ","&Ograve":"Ò","&Ograve;":"Ò","&Oacute":"Ó","&Oacute;":"Ó","&Ocirc":"Ô","&Ocirc;":"Ô","&Otilde":"Õ","&Otilde;":"Õ","&Ouml":"Ö","&Ouml;":"Ö","&times":"×","&times;":"×","&Oslash":"Ø","&Oslash;":"Ø","&Ugrave":"Ù","&Ugrave;":"Ù","&Uacute":"Ú","&Uacute;":"Ú","&Ucirc":"Û","&Ucirc;":"Û","&Uuml":"Ü","&Uuml;":"Ü","&Yacute":"Ý","&Yacute;":"Ý","&THORN":"Þ","&THORN;":"Þ","&szlig":"ß","&szlig;":"ß","&agrave":"à","&agrave;":"à","&aacute":"á","&aacute;":"á","&acirc":"â","&acirc;":"â","&atilde":"ã","&atilde;":"ã","&auml":"ä","&auml;":"ä","&aring":"å","&aring;":"å","&aelig":"æ","&aelig;":"æ","&ccedil":"ç","&ccedil;":"ç","&egrave":"è","&egrave;":"è","&eacute":"é","&eacute;":"é","&ecirc":"ê","&ecirc;":"ê","&euml":"ë","&euml;":"ë","&igrave":"ì","&igrave;":"ì","&iacute":"í","&iacute;":"í","&icirc":"î","&icirc;":"î","&iuml":"ï","&iuml;":"ï","&eth":"ð","&eth;":"ð","&ntilde":"ñ","&ntilde;":"ñ","&ograve":"ò","&ograve;":"ò","&oacute":"ó","&oacute;":"ó","&ocirc":"ô","&ocirc;":"ô","&otilde":"õ","&otilde;":"õ","&ouml":"ö","&ouml;":"ö","&divide":"÷","&divide;":"÷","&oslash":"ø","&oslash;":"ø","&ugrave":"ù","&ugrave;":"ù","&uacute":"ú","&uacute;":"ú","&ucirc":"û","&ucirc;":"û","&uuml":"ü","&uuml;":"ü","&yacute":"ý","&yacute;":"ý","&thorn":"þ","&thorn;":"þ","&yuml":"ÿ","&yuml;":"ÿ","&quot":'"',"&quot;":'"',"&amp":"&","&amp;":"&","&lt":"<","&lt;":"<","&gt":">","&gt;":">","&OElig;":"Œ","&oelig;":"œ","&Scaron;":"Š","&scaron;":"š","&Yuml;":"Ÿ","&circ;":"ˆ","&tilde;":"˜","&ensp;":" ","&emsp;":" ","&thinsp;":" ","&zwnj;":"‌","&zwj;":"‍","&lrm;":"‎","&rlm;":"‏","&ndash;":"–","&mdash;":"—","&lsquo;":"‘","&rsquo;":"’","&sbquo;":"‚","&ldquo;":"“","&rdquo;":"”","&bdquo;":"„","&dagger;":"†","&Dagger;":"‡","&permil;":"‰","&lsaquo;":"‹","&rsaquo;":"›","&euro;":"€","&fnof;":"ƒ","&Alpha;":"Α","&Beta;":"Β","&Gamma;":"Γ","&Delta;":"Δ","&Epsilon;":"Ε","&Zeta;":"Ζ","&Eta;":"Η","&Theta;":"Θ","&Iota;":"Ι","&Kappa;":"Κ","&Lambda;":"Λ","&Mu;":"Μ","&Nu;":"Ν","&Xi;":"Ξ","&Omicron;":"Ο","&Pi;":"Π","&Rho;":"Ρ","&Sigma;":"Σ","&Tau;":"Τ","&Upsilon;":"Υ","&Phi;":"Φ","&Chi;":"Χ","&Psi;":"Ψ","&Omega;":"Ω","&alpha;":"α","&beta;":"β","&gamma;":"γ","&delta;":"δ","&epsilon;":"ε","&zeta;":"ζ","&eta;":"η","&theta;":"θ","&iota;":"ι","&kappa;":"κ","&lambda;":"λ","&mu;":"μ","&nu;":"ν","&xi;":"ξ","&omicron;":"ο","&pi;":"π","&rho;":"ρ","&sigmaf;":"ς","&sigma;":"σ","&tau;":"τ","&upsilon;":"υ","&phi;":"φ","&chi;":"χ","&psi;":"ψ","&omega;":"ω","&thetasym;":"ϑ","&upsih;":"ϒ","&piv;":"ϖ","&bull;":"•","&hellip;":"…","&prime;":"′","&Prime;":"″","&oline;":"‾","&frasl;":"⁄","&weierp;":"℘","&image;":"ℑ","&real;":"ℜ","&trade;":"™","&alefsym;":"ℵ","&larr;":"←","&uarr;":"↑","&rarr;":"→","&darr;":"↓","&harr;":"↔","&crarr;":"↵","&lArr;":"⇐","&uArr;":"⇑","&rArr;":"⇒","&dArr;":"⇓","&hArr;":"⇔","&forall;":"∀","&part;":"∂","&exist;":"∃","&empty;":"∅","&nabla;":"∇","&isin;":"∈","&notin;":"∉","&ni;":"∋","&prod;":"∏","&sum;":"∑","&minus;":"−","&lowast;":"∗","&radic;":"√","&prop;":"∝","&infin;":"∞","&ang;":"∠","&and;":"∧","&or;":"∨","&cap;":"∩","&cup;":"∪","&int;":"∫","&there4;":"∴","&sim;":"∼","&cong;":"≅","&asymp;":"≈","&ne;":"≠","&equiv;":"≡","&le;":"≤","&ge;":"≥","&sub;":"⊂","&sup;":"⊃","&nsub;":"⊄","&sube;":"⊆","&supe;":"⊇","&oplus;":"⊕","&otimes;":"⊗","&perp;":"⊥","&sdot;":"⋅","&lceil;":"⌈","&rceil;":"⌉","&lfloor;":"⌊","&rfloor;":"⌋","&lang;":"〈","&rang;":"〉","&loz;":"◊","&spades;":"♠","&clubs;":"♣","&hearts;":"♥","&diams;":"♦"},characters:{"'":"&apos;"," ":"&nbsp;","¡":"&iexcl;","¢":"&cent;","£":"&pound;","¤":"&curren;","¥":"&yen;","¦":"&brvbar;","§":"&sect;","¨":"&uml;","©":"&copy;","ª":"&ordf;","«":"&laquo;","¬":"&not;","­":"&shy;","®":"&reg;","¯":"&macr;","°":"&deg;","±":"&plusmn;","²":"&sup2;","³":"&sup3;","´":"&acute;","µ":"&micro;","¶":"&para;","·":"&middot;","¸":"&cedil;","¹":"&sup1;","º":"&ordm;","»":"&raquo;","¼":"&frac14;","½":"&frac12;","¾":"&frac34;","¿":"&iquest;","À":"&Agrave;","Á":"&Aacute;","Â":"&Acirc;","Ã":"&Atilde;","Ä":"&Auml;","Å":"&Aring;","Æ":"&AElig;","Ç":"&Ccedil;","È":"&Egrave;","É":"&Eacute;","Ê":"&Ecirc;","Ë":"&Euml;","Ì":"&Igrave;","Í":"&Iacute;","Î":"&Icirc;","Ï":"&Iuml;","Ð":"&ETH;","Ñ":"&Ntilde;","Ò":"&Ograve;","Ó":"&Oacute;","Ô":"&Ocirc;","Õ":"&Otilde;","Ö":"&Ouml;","×":"&times;","Ø":"&Oslash;","Ù":"&Ugrave;","Ú":"&Uacute;","Û":"&Ucirc;","Ü":"&Uuml;","Ý":"&Yacute;","Þ":"&THORN;","ß":"&szlig;","à":"&agrave;","á":"&aacute;","â":"&acirc;","ã":"&atilde;","ä":"&auml;","å":"&aring;","æ":"&aelig;","ç":"&ccedil;","è":"&egrave;","é":"&eacute;","ê":"&ecirc;","ë":"&euml;","ì":"&igrave;","í":"&iacute;","î":"&icirc;","ï":"&iuml;","ð":"&eth;","ñ":"&ntilde;","ò":"&ograve;","ó":"&oacute;","ô":"&ocirc;","õ":"&otilde;","ö":"&ouml;","÷":"&divide;","ø":"&oslash;","ù":"&ugrave;","ú":"&uacute;","û":"&ucirc;","ü":"&uuml;","ý":"&yacute;","þ":"&thorn;","ÿ":"&yuml;",'"':"&quot;","&":"&amp;","<":"&lt;",">":"&gt;","Œ":"&OElig;","œ":"&oelig;","Š":"&Scaron;","š":"&scaron;","Ÿ":"&Yuml;","ˆ":"&circ;","˜":"&tilde;"," ":"&ensp;"," ":"&emsp;"," ":"&thinsp;","‌":"&zwnj;","‍":"&zwj;","‎":"&lrm;","‏":"&rlm;","–":"&ndash;","—":"&mdash;","‘":"&lsquo;","’":"&rsquo;","‚":"&sbquo;","“":"&ldquo;","”":"&rdquo;","„":"&bdquo;","†":"&dagger;","‡":"&Dagger;","‰":"&permil;","‹":"&lsaquo;","›":"&rsaquo;","€":"&euro;","ƒ":"&fnof;","Α":"&Alpha;","Β":"&Beta;","Γ":"&Gamma;","Δ":"&Delta;","Ε":"&Epsilon;","Ζ":"&Zeta;","Η":"&Eta;","Θ":"&Theta;","Ι":"&Iota;","Κ":"&Kappa;","Λ":"&Lambda;","Μ":"&Mu;","Ν":"&Nu;","Ξ":"&Xi;","Ο":"&Omicron;","Π":"&Pi;","Ρ":"&Rho;","Σ":"&Sigma;","Τ":"&Tau;","Υ":"&Upsilon;","Φ":"&Phi;","Χ":"&Chi;","Ψ":"&Psi;","Ω":"&Omega;","α":"&alpha;","β":"&beta;","γ":"&gamma;","δ":"&delta;","ε":"&epsilon;","ζ":"&zeta;","η":"&eta;","θ":"&theta;","ι":"&iota;","κ":"&kappa;","λ":"&lambda;","μ":"&mu;","ν":"&nu;","ξ":"&xi;","ο":"&omicron;","π":"&pi;","ρ":"&rho;","ς":"&sigmaf;","σ":"&sigma;","τ":"&tau;","υ":"&upsilon;","φ":"&phi;","χ":"&chi;","ψ":"&psi;","ω":"&omega;","ϑ":"&thetasym;","ϒ":"&upsih;","ϖ":"&piv;","•":"&bull;","…":"&hellip;","′":"&prime;","″":"&Prime;","‾":"&oline;","⁄":"&frasl;","℘":"&weierp;","ℑ":"&image;","ℜ":"&real;","™":"&trade;","ℵ":"&alefsym;","←":"&larr;","↑":"&uarr;","→":"&rarr;","↓":"&darr;","↔":"&harr;","↵":"&crarr;","⇐":"&lArr;","⇑":"&uArr;","⇒":"&rArr;","⇓":"&dArr;","⇔":"&hArr;","∀":"&forall;","∂":"&part;","∃":"&exist;","∅":"&empty;","∇":"&nabla;","∈":"&isin;","∉":"&notin;","∋":"&ni;","∏":"&prod;","∑":"&sum;","−":"&minus;","∗":"&lowast;","√":"&radic;","∝":"&prop;","∞":"&infin;","∠":"&ang;","∧":"&and;","∨":"&or;","∩":"&cap;","∪":"&cup;","∫":"&int;","∴":"&there4;","∼":"&sim;","≅":"&cong;","≈":"&asymp;","≠":"&ne;","≡":"&equiv;","≤":"&le;","≥":"&ge;","⊂":"&sub;","⊃":"&sup;","⊄":"&nsub;","⊆":"&sube;","⊇":"&supe;","⊕":"&oplus;","⊗":"&otimes;","⊥":"&perp;","⋅":"&sdot;","⌈":"&lceil;","⌉":"&rceil;","⌊":"&lfloor;","⌋":"&rfloor;","〈":"&lang;","〉":"&rang;","◊":"&loz;","♠":"&spades;","♣":"&clubs;","♥":"&hearts;","♦":"&diams;"}},html5:{entities:{"&AElig":"Æ","&AElig;":"Æ","&AMP":"&","&AMP;":"&","&Aacute":"Á","&Aacute;":"Á","&Abreve;":"Ă","&Acirc":"Â","&Acirc;":"Â","&Acy;":"А","&Afr;":"𝔄","&Agrave":"À","&Agrave;":"À","&Alpha;":"Α","&Amacr;":"Ā","&And;":"⩓","&Aogon;":"Ą","&Aopf;":"𝔸","&ApplyFunction;":"⁡","&Aring":"Å","&Aring;":"Å","&Ascr;":"𝒜","&Assign;":"≔","&Atilde":"Ã","&Atilde;":"Ã","&Auml":"Ä","&Auml;":"Ä","&Backslash;":"∖","&Barv;":"⫧","&Barwed;":"⌆","&Bcy;":"Б","&Because;":"∵","&Bernoullis;":"ℬ","&Beta;":"Β","&Bfr;":"𝔅","&Bopf;":"𝔹","&Breve;":"˘","&Bscr;":"ℬ","&Bumpeq;":"≎","&CHcy;":"Ч","&COPY":"©","&COPY;":"©","&Cacute;":"Ć","&Cap;":"⋒","&CapitalDifferentialD;":"ⅅ","&Cayleys;":"ℭ","&Ccaron;":"Č","&Ccedil":"Ç","&Ccedil;":"Ç","&Ccirc;":"Ĉ","&Cconint;":"∰","&Cdot;":"Ċ","&Cedilla;":"¸","&CenterDot;":"·","&Cfr;":"ℭ","&Chi;":"Χ","&CircleDot;":"⊙","&CircleMinus;":"⊖","&CirclePlus;":"⊕","&CircleTimes;":"⊗","&ClockwiseContourIntegral;":"∲","&CloseCurlyDoubleQuote;":"”","&CloseCurlyQuote;":"’","&Colon;":"∷","&Colone;":"⩴","&Congruent;":"≡","&Conint;":"∯","&ContourIntegral;":"∮","&Copf;":"ℂ","&Coproduct;":"∐","&CounterClockwiseContourIntegral;":"∳","&Cross;":"⨯","&Cscr;":"𝒞","&Cup;":"⋓","&CupCap;":"≍","&DD;":"ⅅ","&DDotrahd;":"⤑","&DJcy;":"Ђ","&DScy;":"Ѕ","&DZcy;":"Џ","&Dagger;":"‡","&Darr;":"↡","&Dashv;":"⫤","&Dcaron;":"Ď","&Dcy;":"Д","&Del;":"∇","&Delta;":"Δ","&Dfr;":"𝔇","&DiacriticalAcute;":"´","&DiacriticalDot;":"˙","&DiacriticalDoubleAcute;":"˝","&DiacriticalGrave;":"`","&DiacriticalTilde;":"˜","&Diamond;":"⋄","&DifferentialD;":"ⅆ","&Dopf;":"𝔻","&Dot;":"¨","&DotDot;":"⃜","&DotEqual;":"≐","&DoubleContourIntegral;":"∯","&DoubleDot;":"¨","&DoubleDownArrow;":"⇓","&DoubleLeftArrow;":"⇐","&DoubleLeftRightArrow;":"⇔","&DoubleLeftTee;":"⫤","&DoubleLongLeftArrow;":"⟸","&DoubleLongLeftRightArrow;":"⟺","&DoubleLongRightArrow;":"⟹","&DoubleRightArrow;":"⇒","&DoubleRightTee;":"⊨","&DoubleUpArrow;":"⇑","&DoubleUpDownArrow;":"⇕","&DoubleVerticalBar;":"∥","&DownArrow;":"↓","&DownArrowBar;":"⤓","&DownArrowUpArrow;":"⇵","&DownBreve;":"̑","&DownLeftRightVector;":"⥐","&DownLeftTeeVector;":"⥞","&DownLeftVector;":"↽","&DownLeftVectorBar;":"⥖","&DownRightTeeVector;":"⥟","&DownRightVector;":"⇁","&DownRightVectorBar;":"⥗","&DownTee;":"⊤","&DownTeeArrow;":"↧","&Downarrow;":"⇓","&Dscr;":"𝒟","&Dstrok;":"Đ","&ENG;":"Ŋ","&ETH":"Ð","&ETH;":"Ð","&Eacute":"É","&Eacute;":"É","&Ecaron;":"Ě","&Ecirc":"Ê","&Ecirc;":"Ê","&Ecy;":"Э","&Edot;":"Ė","&Efr;":"𝔈","&Egrave":"È","&Egrave;":"È","&Element;":"∈","&Emacr;":"Ē","&EmptySmallSquare;":"◻","&EmptyVerySmallSquare;":"▫","&Eogon;":"Ę","&Eopf;":"𝔼","&Epsilon;":"Ε","&Equal;":"⩵","&EqualTilde;":"≂","&Equilibrium;":"⇌","&Escr;":"ℰ","&Esim;":"⩳","&Eta;":"Η","&Euml":"Ë","&Euml;":"Ë","&Exists;":"∃","&ExponentialE;":"ⅇ","&Fcy;":"Ф","&Ffr;":"𝔉","&FilledSmallSquare;":"◼","&FilledVerySmallSquare;":"▪","&Fopf;":"𝔽","&ForAll;":"∀","&Fouriertrf;":"ℱ","&Fscr;":"ℱ","&GJcy;":"Ѓ","&GT":">","&GT;":">","&Gamma;":"Γ","&Gammad;":"Ϝ","&Gbreve;":"Ğ","&Gcedil;":"Ģ","&Gcirc;":"Ĝ","&Gcy;":"Г","&Gdot;":"Ġ","&Gfr;":"𝔊","&Gg;":"⋙","&Gopf;":"𝔾","&GreaterEqual;":"≥","&GreaterEqualLess;":"⋛","&GreaterFullEqual;":"≧","&GreaterGreater;":"⪢","&GreaterLess;":"≷","&GreaterSlantEqual;":"⩾","&GreaterTilde;":"≳","&Gscr;":"𝒢","&Gt;":"≫","&HARDcy;":"Ъ","&Hacek;":"ˇ","&Hat;":"^","&Hcirc;":"Ĥ","&Hfr;":"ℌ","&HilbertSpace;":"ℋ","&Hopf;":"ℍ","&HorizontalLine;":"─","&Hscr;":"ℋ","&Hstrok;":"Ħ","&HumpDownHump;":"≎","&HumpEqual;":"≏","&IEcy;":"Е","&IJlig;":"Ĳ","&IOcy;":"Ё","&Iacute":"Í","&Iacute;":"Í","&Icirc":"Î","&Icirc;":"Î","&Icy;":"И","&Idot;":"İ","&Ifr;":"ℑ","&Igrave":"Ì","&Igrave;":"Ì","&Im;":"ℑ","&Imacr;":"Ī","&ImaginaryI;":"ⅈ","&Implies;":"⇒","&Int;":"∬","&Integral;":"∫","&Intersection;":"⋂","&InvisibleComma;":"⁣","&InvisibleTimes;":"⁢","&Iogon;":"Į","&Iopf;":"𝕀","&Iota;":"Ι","&Iscr;":"ℐ","&Itilde;":"Ĩ","&Iukcy;":"І","&Iuml":"Ï","&Iuml;":"Ï","&Jcirc;":"Ĵ","&Jcy;":"Й","&Jfr;":"𝔍","&Jopf;":"𝕁","&Jscr;":"𝒥","&Jsercy;":"Ј","&Jukcy;":"Є","&KHcy;":"Х","&KJcy;":"Ќ","&Kappa;":"Κ","&Kcedil;":"Ķ","&Kcy;":"К","&Kfr;":"𝔎","&Kopf;":"𝕂","&Kscr;":"𝒦","&LJcy;":"Љ","&LT":"<","&LT;":"<","&Lacute;":"Ĺ","&Lambda;":"Λ","&Lang;":"⟪","&Laplacetrf;":"ℒ","&Larr;":"↞","&Lcaron;":"Ľ","&Lcedil;":"Ļ","&Lcy;":"Л","&LeftAngleBracket;":"⟨","&LeftArrow;":"←","&LeftArrowBar;":"⇤","&LeftArrowRightArrow;":"⇆","&LeftCeiling;":"⌈","&LeftDoubleBracket;":"⟦","&LeftDownTeeVector;":"⥡","&LeftDownVector;":"⇃","&LeftDownVectorBar;":"⥙","&LeftFloor;":"⌊","&LeftRightArrow;":"↔","&LeftRightVector;":"⥎","&LeftTee;":"⊣","&LeftTeeArrow;":"↤","&LeftTeeVector;":"⥚","&LeftTriangle;":"⊲","&LeftTriangleBar;":"⧏","&LeftTriangleEqual;":"⊴","&LeftUpDownVector;":"⥑","&LeftUpTeeVector;":"⥠","&LeftUpVector;":"↿","&LeftUpVectorBar;":"⥘","&LeftVector;":"↼","&LeftVectorBar;":"⥒","&Leftarrow;":"⇐","&Leftrightarrow;":"⇔","&LessEqualGreater;":"⋚","&LessFullEqual;":"≦","&LessGreater;":"≶","&LessLess;":"⪡","&LessSlantEqual;":"⩽","&LessTilde;":"≲","&Lfr;":"𝔏","&Ll;":"⋘","&Lleftarrow;":"⇚","&Lmidot;":"Ŀ","&LongLeftArrow;":"⟵","&LongLeftRightArrow;":"⟷","&LongRightArrow;":"⟶","&Longleftarrow;":"⟸","&Longleftrightarrow;":"⟺","&Longrightarrow;":"⟹","&Lopf;":"𝕃","&LowerLeftArrow;":"↙","&LowerRightArrow;":"↘","&Lscr;":"ℒ","&Lsh;":"↰","&Lstrok;":"Ł","&Lt;":"≪","&Map;":"⤅","&Mcy;":"М","&MediumSpace;":" ","&Mellintrf;":"ℳ","&Mfr;":"𝔐","&MinusPlus;":"∓","&Mopf;":"𝕄","&Mscr;":"ℳ","&Mu;":"Μ","&NJcy;":"Њ","&Nacute;":"Ń","&Ncaron;":"Ň","&Ncedil;":"Ņ","&Ncy;":"Н","&NegativeMediumSpace;":"​","&NegativeThickSpace;":"​","&NegativeThinSpace;":"​","&NegativeVeryThinSpace;":"​","&NestedGreaterGreater;":"≫","&NestedLessLess;":"≪","&NewLine;":"\n","&Nfr;":"𝔑","&NoBreak;":"⁠","&NonBreakingSpace;":" ","&Nopf;":"ℕ","&Not;":"⫬","&NotCongruent;":"≢","&NotCupCap;":"≭","&NotDoubleVerticalBar;":"∦","&NotElement;":"∉","&NotEqual;":"≠","&NotEqualTilde;":"≂̸","&NotExists;":"∄","&NotGreater;":"≯","&NotGreaterEqual;":"≱","&NotGreaterFullEqual;":"≧̸","&NotGreaterGreater;":"≫̸","&NotGreaterLess;":"≹","&NotGreaterSlantEqual;":"⩾̸","&NotGreaterTilde;":"≵","&NotHumpDownHump;":"≎̸","&NotHumpEqual;":"≏̸","&NotLeftTriangle;":"⋪","&NotLeftTriangleBar;":"⧏̸","&NotLeftTriangleEqual;":"⋬","&NotLess;":"≮","&NotLessEqual;":"≰","&NotLessGreater;":"≸","&NotLessLess;":"≪̸","&NotLessSlantEqual;":"⩽̸","&NotLessTilde;":"≴","&NotNestedGreaterGreater;":"⪢̸","&NotNestedLessLess;":"⪡̸","&NotPrecedes;":"⊀","&NotPrecedesEqual;":"⪯̸","&NotPrecedesSlantEqual;":"⋠","&NotReverseElement;":"∌","&NotRightTriangle;":"⋫","&NotRightTriangleBar;":"⧐̸","&NotRightTriangleEqual;":"⋭","&NotSquareSubset;":"⊏̸","&NotSquareSubsetEqual;":"⋢","&NotSquareSuperset;":"⊐̸","&NotSquareSupersetEqual;":"⋣","&NotSubset;":"⊂⃒","&NotSubsetEqual;":"⊈","&NotSucceeds;":"⊁","&NotSucceedsEqual;":"⪰̸","&NotSucceedsSlantEqual;":"⋡","&NotSucceedsTilde;":"≿̸","&NotSuperset;":"⊃⃒","&NotSupersetEqual;":"⊉","&NotTilde;":"≁","&NotTildeEqual;":"≄","&NotTildeFullEqual;":"≇","&NotTildeTilde;":"≉","&NotVerticalBar;":"∤","&Nscr;":"𝒩","&Ntilde":"Ñ","&Ntilde;":"Ñ","&Nu;":"Ν","&OElig;":"Œ","&Oacute":"Ó","&Oacute;":"Ó","&Ocirc":"Ô","&Ocirc;":"Ô","&Ocy;":"О","&Odblac;":"Ő","&Ofr;":"𝔒","&Ograve":"Ò","&Ograve;":"Ò","&Omacr;":"Ō","&Omega;":"Ω","&Omicron;":"Ο","&Oopf;":"𝕆","&OpenCurlyDoubleQuote;":"“","&OpenCurlyQuote;":"‘","&Or;":"⩔","&Oscr;":"𝒪","&Oslash":"Ø","&Oslash;":"Ø","&Otilde":"Õ","&Otilde;":"Õ","&Otimes;":"⨷","&Ouml":"Ö","&Ouml;":"Ö","&OverBar;":"‾","&OverBrace;":"⏞","&OverBracket;":"⎴","&OverParenthesis;":"⏜","&PartialD;":"∂","&Pcy;":"П","&Pfr;":"𝔓","&Phi;":"Φ","&Pi;":"Π","&PlusMinus;":"±","&Poincareplane;":"ℌ","&Popf;":"ℙ","&Pr;":"⪻","&Precedes;":"≺","&PrecedesEqual;":"⪯","&PrecedesSlantEqual;":"≼","&PrecedesTilde;":"≾","&Prime;":"″","&Product;":"∏","&Proportion;":"∷","&Proportional;":"∝","&Pscr;":"𝒫","&Psi;":"Ψ","&QUOT":'"',"&QUOT;":'"',"&Qfr;":"𝔔","&Qopf;":"ℚ","&Qscr;":"𝒬","&RBarr;":"⤐","&REG":"®","&REG;":"®","&Racute;":"Ŕ","&Rang;":"⟫","&Rarr;":"↠","&Rarrtl;":"⤖","&Rcaron;":"Ř","&Rcedil;":"Ŗ","&Rcy;":"Р","&Re;":"ℜ","&ReverseElement;":"∋","&ReverseEquilibrium;":"⇋","&ReverseUpEquilibrium;":"⥯","&Rfr;":"ℜ","&Rho;":"Ρ","&RightAngleBracket;":"⟩","&RightArrow;":"→","&RightArrowBar;":"⇥","&RightArrowLeftArrow;":"⇄","&RightCeiling;":"⌉","&RightDoubleBracket;":"⟧","&RightDownTeeVector;":"⥝","&RightDownVector;":"⇂","&RightDownVectorBar;":"⥕","&RightFloor;":"⌋","&RightTee;":"⊢","&RightTeeArrow;":"↦","&RightTeeVector;":"⥛","&RightTriangle;":"⊳","&RightTriangleBar;":"⧐","&RightTriangleEqual;":"⊵","&RightUpDownVector;":"⥏","&RightUpTeeVector;":"⥜","&RightUpVector;":"↾","&RightUpVectorBar;":"⥔","&RightVector;":"⇀","&RightVectorBar;":"⥓","&Rightarrow;":"⇒","&Ropf;":"ℝ","&RoundImplies;":"⥰","&Rrightarrow;":"⇛","&Rscr;":"ℛ","&Rsh;":"↱","&RuleDelayed;":"⧴","&SHCHcy;":"Щ","&SHcy;":"Ш","&SOFTcy;":"Ь","&Sacute;":"Ś","&Sc;":"⪼","&Scaron;":"Š","&Scedil;":"Ş","&Scirc;":"Ŝ","&Scy;":"С","&Sfr;":"𝔖","&ShortDownArrow;":"↓","&ShortLeftArrow;":"←","&ShortRightArrow;":"→","&ShortUpArrow;":"↑","&Sigma;":"Σ","&SmallCircle;":"∘","&Sopf;":"𝕊","&Sqrt;":"√","&Square;":"□","&SquareIntersection;":"⊓","&SquareSubset;":"⊏","&SquareSubsetEqual;":"⊑","&SquareSuperset;":"⊐","&SquareSupersetEqual;":"⊒","&SquareUnion;":"⊔","&Sscr;":"𝒮","&Star;":"⋆","&Sub;":"⋐","&Subset;":"⋐","&SubsetEqual;":"⊆","&Succeeds;":"≻","&SucceedsEqual;":"⪰","&SucceedsSlantEqual;":"≽","&SucceedsTilde;":"≿","&SuchThat;":"∋","&Sum;":"∑","&Sup;":"⋑","&Superset;":"⊃","&SupersetEqual;":"⊇","&Supset;":"⋑","&THORN":"Þ","&THORN;":"Þ","&TRADE;":"™","&TSHcy;":"Ћ","&TScy;":"Ц","&Tab;":"\t","&Tau;":"Τ","&Tcaron;":"Ť","&Tcedil;":"Ţ","&Tcy;":"Т","&Tfr;":"𝔗","&Therefore;":"∴","&Theta;":"Θ","&ThickSpace;":"  ","&ThinSpace;":" ","&Tilde;":"∼","&TildeEqual;":"≃","&TildeFullEqual;":"≅","&TildeTilde;":"≈","&Topf;":"𝕋","&TripleDot;":"⃛","&Tscr;":"𝒯","&Tstrok;":"Ŧ","&Uacute":"Ú","&Uacute;":"Ú","&Uarr;":"↟","&Uarrocir;":"⥉","&Ubrcy;":"Ў","&Ubreve;":"Ŭ","&Ucirc":"Û","&Ucirc;":"Û","&Ucy;":"У","&Udblac;":"Ű","&Ufr;":"𝔘","&Ugrave":"Ù","&Ugrave;":"Ù","&Umacr;":"Ū","&UnderBar;":"_","&UnderBrace;":"⏟","&UnderBracket;":"⎵","&UnderParenthesis;":"⏝","&Union;":"⋃","&UnionPlus;":"⊎","&Uogon;":"Ų","&Uopf;":"𝕌","&UpArrow;":"↑","&UpArrowBar;":"⤒","&UpArrowDownArrow;":"⇅","&UpDownArrow;":"↕","&UpEquilibrium;":"⥮","&UpTee;":"⊥","&UpTeeArrow;":"↥","&Uparrow;":"⇑","&Updownarrow;":"⇕","&UpperLeftArrow;":"↖","&UpperRightArrow;":"↗","&Upsi;":"ϒ","&Upsilon;":"Υ","&Uring;":"Ů","&Uscr;":"𝒰","&Utilde;":"Ũ","&Uuml":"Ü","&Uuml;":"Ü","&VDash;":"⊫","&Vbar;":"⫫","&Vcy;":"В","&Vdash;":"⊩","&Vdashl;":"⫦","&Vee;":"⋁","&Verbar;":"‖","&Vert;":"‖","&VerticalBar;":"∣","&VerticalLine;":"|","&VerticalSeparator;":"❘","&VerticalTilde;":"≀","&VeryThinSpace;":" ","&Vfr;":"𝔙","&Vopf;":"𝕍","&Vscr;":"𝒱","&Vvdash;":"⊪","&Wcirc;":"Ŵ","&Wedge;":"⋀","&Wfr;":"𝔚","&Wopf;":"𝕎","&Wscr;":"𝒲","&Xfr;":"𝔛","&Xi;":"Ξ","&Xopf;":"𝕏","&Xscr;":"𝒳","&YAcy;":"Я","&YIcy;":"Ї","&YUcy;":"Ю","&Yacute":"Ý","&Yacute;":"Ý","&Ycirc;":"Ŷ","&Ycy;":"Ы","&Yfr;":"𝔜","&Yopf;":"𝕐","&Yscr;":"𝒴","&Yuml;":"Ÿ","&ZHcy;":"Ж","&Zacute;":"Ź","&Zcaron;":"Ž","&Zcy;":"З","&Zdot;":"Ż","&ZeroWidthSpace;":"​","&Zeta;":"Ζ","&Zfr;":"ℨ","&Zopf;":"ℤ","&Zscr;":"𝒵","&aacute":"á","&aacute;":"á","&abreve;":"ă","&ac;":"∾","&acE;":"∾̳","&acd;":"∿","&acirc":"â","&acirc;":"â","&acute":"´","&acute;":"´","&acy;":"а","&aelig":"æ","&aelig;":"æ","&af;":"⁡","&afr;":"𝔞","&agrave":"à","&agrave;":"à","&alefsym;":"ℵ","&aleph;":"ℵ","&alpha;":"α","&amacr;":"ā","&amalg;":"⨿","&amp":"&","&amp;":"&","&and;":"∧","&andand;":"⩕","&andd;":"⩜","&andslope;":"⩘","&andv;":"⩚","&ang;":"∠","&ange;":"⦤","&angle;":"∠","&angmsd;":"∡","&angmsdaa;":"⦨","&angmsdab;":"⦩","&angmsdac;":"⦪","&angmsdad;":"⦫","&angmsdae;":"⦬","&angmsdaf;":"⦭","&angmsdag;":"⦮","&angmsdah;":"⦯","&angrt;":"∟","&angrtvb;":"⊾","&angrtvbd;":"⦝","&angsph;":"∢","&angst;":"Å","&angzarr;":"⍼","&aogon;":"ą","&aopf;":"𝕒","&ap;":"≈","&apE;":"⩰","&apacir;":"⩯","&ape;":"≊","&apid;":"≋","&apos;":"'","&approx;":"≈","&approxeq;":"≊","&aring":"å","&aring;":"å","&ascr;":"𝒶","&ast;":"*","&asymp;":"≈","&asympeq;":"≍","&atilde":"ã","&atilde;":"ã","&auml":"ä","&auml;":"ä","&awconint;":"∳","&awint;":"⨑","&bNot;":"⫭","&backcong;":"≌","&backepsilon;":"϶","&backprime;":"‵","&backsim;":"∽","&backsimeq;":"⋍","&barvee;":"⊽","&barwed;":"⌅","&barwedge;":"⌅","&bbrk;":"⎵","&bbrktbrk;":"⎶","&bcong;":"≌","&bcy;":"б","&bdquo;":"„","&becaus;":"∵","&because;":"∵","&bemptyv;":"⦰","&bepsi;":"϶","&bernou;":"ℬ","&beta;":"β","&beth;":"ℶ","&between;":"≬","&bfr;":"𝔟","&bigcap;":"⋂","&bigcirc;":"◯","&bigcup;":"⋃","&bigodot;":"⨀","&bigoplus;":"⨁","&bigotimes;":"⨂","&bigsqcup;":"⨆","&bigstar;":"★","&bigtriangledown;":"▽","&bigtriangleup;":"△","&biguplus;":"⨄","&bigvee;":"⋁","&bigwedge;":"⋀","&bkarow;":"⤍","&blacklozenge;":"⧫","&blacksquare;":"▪","&blacktriangle;":"▴","&blacktriangledown;":"▾","&blacktriangleleft;":"◂","&blacktriangleright;":"▸","&blank;":"␣","&blk12;":"▒","&blk14;":"░","&blk34;":"▓","&block;":"█","&bne;":"=⃥","&bnequiv;":"≡⃥","&bnot;":"⌐","&bopf;":"𝕓","&bot;":"⊥","&bottom;":"⊥","&bowtie;":"⋈","&boxDL;":"╗","&boxDR;":"╔","&boxDl;":"╖","&boxDr;":"╓","&boxH;":"═","&boxHD;":"╦","&boxHU;":"╩","&boxHd;":"╤","&boxHu;":"╧","&boxUL;":"╝","&boxUR;":"╚","&boxUl;":"╜","&boxUr;":"╙","&boxV;":"║","&boxVH;":"╬","&boxVL;":"╣","&boxVR;":"╠","&boxVh;":"╫","&boxVl;":"╢","&boxVr;":"╟","&boxbox;":"⧉","&boxdL;":"╕","&boxdR;":"╒","&boxdl;":"┐","&boxdr;":"┌","&boxh;":"─","&boxhD;":"╥","&boxhU;":"╨","&boxhd;":"┬","&boxhu;":"┴","&boxminus;":"⊟","&boxplus;":"⊞","&boxtimes;":"⊠","&boxuL;":"╛","&boxuR;":"╘","&boxul;":"┘","&boxur;":"└","&boxv;":"│","&boxvH;":"╪","&boxvL;":"╡","&boxvR;":"╞","&boxvh;":"┼","&boxvl;":"┤","&boxvr;":"├","&bprime;":"‵","&breve;":"˘","&brvbar":"¦","&brvbar;":"¦","&bscr;":"𝒷","&bsemi;":"⁏","&bsim;":"∽","&bsime;":"⋍","&bsol;":"\\","&bsolb;":"⧅","&bsolhsub;":"⟈","&bull;":"•","&bullet;":"•","&bump;":"≎","&bumpE;":"⪮","&bumpe;":"≏","&bumpeq;":"≏","&cacute;":"ć","&cap;":"∩","&capand;":"⩄","&capbrcup;":"⩉","&capcap;":"⩋","&capcup;":"⩇","&capdot;":"⩀","&caps;":"∩︀","&caret;":"⁁","&caron;":"ˇ","&ccaps;":"⩍","&ccaron;":"č","&ccedil":"ç","&ccedil;":"ç","&ccirc;":"ĉ","&ccups;":"⩌","&ccupssm;":"⩐","&cdot;":"ċ","&cedil":"¸","&cedil;":"¸","&cemptyv;":"⦲","&cent":"¢","&cent;":"¢","&centerdot;":"·","&cfr;":"𝔠","&chcy;":"ч","&check;":"✓","&checkmark;":"✓","&chi;":"χ","&cir;":"○","&cirE;":"⧃","&circ;":"ˆ","&circeq;":"≗","&circlearrowleft;":"↺","&circlearrowright;":"↻","&circledR;":"®","&circledS;":"Ⓢ","&circledast;":"⊛","&circledcirc;":"⊚","&circleddash;":"⊝","&cire;":"≗","&cirfnint;":"⨐","&cirmid;":"⫯","&cirscir;":"⧂","&clubs;":"♣","&clubsuit;":"♣","&colon;":":","&colone;":"≔","&coloneq;":"≔","&comma;":",","&commat;":"@","&comp;":"∁","&compfn;":"∘","&complement;":"∁","&complexes;":"ℂ","&cong;":"≅","&congdot;":"⩭","&conint;":"∮","&copf;":"𝕔","&coprod;":"∐","&copy":"©","&copy;":"©","&copysr;":"℗","&crarr;":"↵","&cross;":"✗","&cscr;":"𝒸","&csub;":"⫏","&csube;":"⫑","&csup;":"⫐","&csupe;":"⫒","&ctdot;":"⋯","&cudarrl;":"⤸","&cudarrr;":"⤵","&cuepr;":"⋞","&cuesc;":"⋟","&cularr;":"↶","&cularrp;":"⤽","&cup;":"∪","&cupbrcap;":"⩈","&cupcap;":"⩆","&cupcup;":"⩊","&cupdot;":"⊍","&cupor;":"⩅","&cups;":"∪︀","&curarr;":"↷","&curarrm;":"⤼","&curlyeqprec;":"⋞","&curlyeqsucc;":"⋟","&curlyvee;":"⋎","&curlywedge;":"⋏","&curren":"¤","&curren;":"¤","&curvearrowleft;":"↶","&curvearrowright;":"↷","&cuvee;":"⋎","&cuwed;":"⋏","&cwconint;":"∲","&cwint;":"∱","&cylcty;":"⌭","&dArr;":"⇓","&dHar;":"⥥","&dagger;":"†","&daleth;":"ℸ","&darr;":"↓","&dash;":"‐","&dashv;":"⊣","&dbkarow;":"⤏","&dblac;":"˝","&dcaron;":"ď","&dcy;":"д","&dd;":"ⅆ","&ddagger;":"‡","&ddarr;":"⇊","&ddotseq;":"⩷","&deg":"°","&deg;":"°","&delta;":"δ","&demptyv;":"⦱","&dfisht;":"⥿","&dfr;":"𝔡","&dharl;":"⇃","&dharr;":"⇂","&diam;":"⋄","&diamond;":"⋄","&diamondsuit;":"♦","&diams;":"♦","&die;":"¨","&digamma;":"ϝ","&disin;":"⋲","&div;":"÷","&divide":"÷","&divide;":"÷","&divideontimes;":"⋇","&divonx;":"⋇","&djcy;":"ђ","&dlcorn;":"⌞","&dlcrop;":"⌍","&dollar;":"$","&dopf;":"𝕕","&dot;":"˙","&doteq;":"≐","&doteqdot;":"≑","&dotminus;":"∸","&dotplus;":"∔","&dotsquare;":"⊡","&doublebarwedge;":"⌆","&downarrow;":"↓","&downdownarrows;":"⇊","&downharpoonleft;":"⇃","&downharpoonright;":"⇂","&drbkarow;":"⤐","&drcorn;":"⌟","&drcrop;":"⌌","&dscr;":"𝒹","&dscy;":"ѕ","&dsol;":"⧶","&dstrok;":"đ","&dtdot;":"⋱","&dtri;":"▿","&dtrif;":"▾","&duarr;":"⇵","&duhar;":"⥯","&dwangle;":"⦦","&dzcy;":"џ","&dzigrarr;":"⟿","&eDDot;":"⩷","&eDot;":"≑","&eacute":"é","&eacute;":"é","&easter;":"⩮","&ecaron;":"ě","&ecir;":"≖","&ecirc":"ê","&ecirc;":"ê","&ecolon;":"≕","&ecy;":"э","&edot;":"ė","&ee;":"ⅇ","&efDot;":"≒","&efr;":"𝔢","&eg;":"⪚","&egrave":"è","&egrave;":"è","&egs;":"⪖","&egsdot;":"⪘","&el;":"⪙","&elinters;":"⏧","&ell;":"ℓ","&els;":"⪕","&elsdot;":"⪗","&emacr;":"ē","&empty;":"∅","&emptyset;":"∅","&emptyv;":"∅","&emsp13;":" ","&emsp14;":" ","&emsp;":" ","&eng;":"ŋ","&ensp;":" ","&eogon;":"ę","&eopf;":"𝕖","&epar;":"⋕","&eparsl;":"⧣","&eplus;":"⩱","&epsi;":"ε","&epsilon;":"ε","&epsiv;":"ϵ","&eqcirc;":"≖","&eqcolon;":"≕","&eqsim;":"≂","&eqslantgtr;":"⪖","&eqslantless;":"⪕","&equals;":"=","&equest;":"≟","&equiv;":"≡","&equivDD;":"⩸","&eqvparsl;":"⧥","&erDot;":"≓","&erarr;":"⥱","&escr;":"ℯ","&esdot;":"≐","&esim;":"≂","&eta;":"η","&eth":"ð","&eth;":"ð","&euml":"ë","&euml;":"ë","&euro;":"€","&excl;":"!","&exist;":"∃","&expectation;":"ℰ","&exponentiale;":"ⅇ","&fallingdotseq;":"≒","&fcy;":"ф","&female;":"♀","&ffilig;":"ﬃ","&fflig;":"ﬀ","&ffllig;":"ﬄ","&ffr;":"𝔣","&filig;":"ﬁ","&fjlig;":"fj","&flat;":"♭","&fllig;":"ﬂ","&fltns;":"▱","&fnof;":"ƒ","&fopf;":"𝕗","&forall;":"∀","&fork;":"⋔","&forkv;":"⫙","&fpartint;":"⨍","&frac12":"½","&frac12;":"½","&frac13;":"⅓","&frac14":"¼","&frac14;":"¼","&frac15;":"⅕","&frac16;":"⅙","&frac18;":"⅛","&frac23;":"⅔","&frac25;":"⅖","&frac34":"¾","&frac34;":"¾","&frac35;":"⅗","&frac38;":"⅜","&frac45;":"⅘","&frac56;":"⅚","&frac58;":"⅝","&frac78;":"⅞","&frasl;":"⁄","&frown;":"⌢","&fscr;":"𝒻","&gE;":"≧","&gEl;":"⪌","&gacute;":"ǵ","&gamma;":"γ","&gammad;":"ϝ","&gap;":"⪆","&gbreve;":"ğ","&gcirc;":"ĝ","&gcy;":"г","&gdot;":"ġ","&ge;":"≥","&gel;":"⋛","&geq;":"≥","&geqq;":"≧","&geqslant;":"⩾","&ges;":"⩾","&gescc;":"⪩","&gesdot;":"⪀","&gesdoto;":"⪂","&gesdotol;":"⪄","&gesl;":"⋛︀","&gesles;":"⪔","&gfr;":"𝔤","&gg;":"≫","&ggg;":"⋙","&gimel;":"ℷ","&gjcy;":"ѓ","&gl;":"≷","&glE;":"⪒","&gla;":"⪥","&glj;":"⪤","&gnE;":"≩","&gnap;":"⪊","&gnapprox;":"⪊","&gne;":"⪈","&gneq;":"⪈","&gneqq;":"≩","&gnsim;":"⋧","&gopf;":"𝕘","&grave;":"`","&gscr;":"ℊ","&gsim;":"≳","&gsime;":"⪎","&gsiml;":"⪐","&gt":">","&gt;":">","&gtcc;":"⪧","&gtcir;":"⩺","&gtdot;":"⋗","&gtlPar;":"⦕","&gtquest;":"⩼","&gtrapprox;":"⪆","&gtrarr;":"⥸","&gtrdot;":"⋗","&gtreqless;":"⋛","&gtreqqless;":"⪌","&gtrless;":"≷","&gtrsim;":"≳","&gvertneqq;":"≩︀","&gvnE;":"≩︀","&hArr;":"⇔","&hairsp;":" ","&half;":"½","&hamilt;":"ℋ","&hardcy;":"ъ","&harr;":"↔","&harrcir;":"⥈","&harrw;":"↭","&hbar;":"ℏ","&hcirc;":"ĥ","&hearts;":"♥","&heartsuit;":"♥","&hellip;":"…","&hercon;":"⊹","&hfr;":"𝔥","&hksearow;":"⤥","&hkswarow;":"⤦","&hoarr;":"⇿","&homtht;":"∻","&hookleftarrow;":"↩","&hookrightarrow;":"↪","&hopf;":"𝕙","&horbar;":"―","&hscr;":"𝒽","&hslash;":"ℏ","&hstrok;":"ħ","&hybull;":"⁃","&hyphen;":"‐","&iacute":"í","&iacute;":"í","&ic;":"⁣","&icirc":"î","&icirc;":"î","&icy;":"и","&iecy;":"е","&iexcl":"¡","&iexcl;":"¡","&iff;":"⇔","&ifr;":"𝔦","&igrave":"ì","&igrave;":"ì","&ii;":"ⅈ","&iiiint;":"⨌","&iiint;":"∭","&iinfin;":"⧜","&iiota;":"℩","&ijlig;":"ĳ","&imacr;":"ī","&image;":"ℑ","&imagline;":"ℐ","&imagpart;":"ℑ","&imath;":"ı","&imof;":"⊷","&imped;":"Ƶ","&in;":"∈","&incare;":"℅","&infin;":"∞","&infintie;":"⧝","&inodot;":"ı","&int;":"∫","&intcal;":"⊺","&integers;":"ℤ","&intercal;":"⊺","&intlarhk;":"⨗","&intprod;":"⨼","&iocy;":"ё","&iogon;":"į","&iopf;":"𝕚","&iota;":"ι","&iprod;":"⨼","&iquest":"¿","&iquest;":"¿","&iscr;":"𝒾","&isin;":"∈","&isinE;":"⋹","&isindot;":"⋵","&isins;":"⋴","&isinsv;":"⋳","&isinv;":"∈","&it;":"⁢","&itilde;":"ĩ","&iukcy;":"і","&iuml":"ï","&iuml;":"ï","&jcirc;":"ĵ","&jcy;":"й","&jfr;":"𝔧","&jmath;":"ȷ","&jopf;":"𝕛","&jscr;":"𝒿","&jsercy;":"ј","&jukcy;":"є","&kappa;":"κ","&kappav;":"ϰ","&kcedil;":"ķ","&kcy;":"к","&kfr;":"𝔨","&kgreen;":"ĸ","&khcy;":"х","&kjcy;":"ќ","&kopf;":"𝕜","&kscr;":"𝓀","&lAarr;":"⇚","&lArr;":"⇐","&lAtail;":"⤛","&lBarr;":"⤎","&lE;":"≦","&lEg;":"⪋","&lHar;":"⥢","&lacute;":"ĺ","&laemptyv;":"⦴","&lagran;":"ℒ","&lambda;":"λ","&lang;":"⟨","&langd;":"⦑","&langle;":"⟨","&lap;":"⪅","&laquo":"«","&laquo;":"«","&larr;":"←","&larrb;":"⇤","&larrbfs;":"⤟","&larrfs;":"⤝","&larrhk;":"↩","&larrlp;":"↫","&larrpl;":"⤹","&larrsim;":"⥳","&larrtl;":"↢","&lat;":"⪫","&latail;":"⤙","&late;":"⪭","&lates;":"⪭︀","&lbarr;":"⤌","&lbbrk;":"❲","&lbrace;":"{","&lbrack;":"[","&lbrke;":"⦋","&lbrksld;":"⦏","&lbrkslu;":"⦍","&lcaron;":"ľ","&lcedil;":"ļ","&lceil;":"⌈","&lcub;":"{","&lcy;":"л","&ldca;":"⤶","&ldquo;":"“","&ldquor;":"„","&ldrdhar;":"⥧","&ldrushar;":"⥋","&ldsh;":"↲","&le;":"≤","&leftarrow;":"←","&leftarrowtail;":"↢","&leftharpoondown;":"↽","&leftharpoonup;":"↼","&leftleftarrows;":"⇇","&leftrightarrow;":"↔","&leftrightarrows;":"⇆","&leftrightharpoons;":"⇋","&leftrightsquigarrow;":"↭","&leftthreetimes;":"⋋","&leg;":"⋚","&leq;":"≤","&leqq;":"≦","&leqslant;":"⩽","&les;":"⩽","&lescc;":"⪨","&lesdot;":"⩿","&lesdoto;":"⪁","&lesdotor;":"⪃","&lesg;":"⋚︀","&lesges;":"⪓","&lessapprox;":"⪅","&lessdot;":"⋖","&lesseqgtr;":"⋚","&lesseqqgtr;":"⪋","&lessgtr;":"≶","&lesssim;":"≲","&lfisht;":"⥼","&lfloor;":"⌊","&lfr;":"𝔩","&lg;":"≶","&lgE;":"⪑","&lhard;":"↽","&lharu;":"↼","&lharul;":"⥪","&lhblk;":"▄","&ljcy;":"љ","&ll;":"≪","&llarr;":"⇇","&llcorner;":"⌞","&llhard;":"⥫","&lltri;":"◺","&lmidot;":"ŀ","&lmoust;":"⎰","&lmoustache;":"⎰","&lnE;":"≨","&lnap;":"⪉","&lnapprox;":"⪉","&lne;":"⪇","&lneq;":"⪇","&lneqq;":"≨","&lnsim;":"⋦","&loang;":"⟬","&loarr;":"⇽","&lobrk;":"⟦","&longleftarrow;":"⟵","&longleftrightarrow;":"⟷","&longmapsto;":"⟼","&longrightarrow;":"⟶","&looparrowleft;":"↫","&looparrowright;":"↬","&lopar;":"⦅","&lopf;":"𝕝","&loplus;":"⨭","&lotimes;":"⨴","&lowast;":"∗","&lowbar;":"_","&loz;":"◊","&lozenge;":"◊","&lozf;":"⧫","&lpar;":"(","&lparlt;":"⦓","&lrarr;":"⇆","&lrcorner;":"⌟","&lrhar;":"⇋","&lrhard;":"⥭","&lrm;":"‎","&lrtri;":"⊿","&lsaquo;":"‹","&lscr;":"𝓁","&lsh;":"↰","&lsim;":"≲","&lsime;":"⪍","&lsimg;":"⪏","&lsqb;":"[","&lsquo;":"‘","&lsquor;":"‚","&lstrok;":"ł","&lt":"<","&lt;":"<","&ltcc;":"⪦","&ltcir;":"⩹","&ltdot;":"⋖","&lthree;":"⋋","&ltimes;":"⋉","&ltlarr;":"⥶","&ltquest;":"⩻","&ltrPar;":"⦖","&ltri;":"◃","&ltrie;":"⊴","&ltrif;":"◂","&lurdshar;":"⥊","&luruhar;":"⥦","&lvertneqq;":"≨︀","&lvnE;":"≨︀","&mDDot;":"∺","&macr":"¯","&macr;":"¯","&male;":"♂","&malt;":"✠","&maltese;":"✠","&map;":"↦","&mapsto;":"↦","&mapstodown;":"↧","&mapstoleft;":"↤","&mapstoup;":"↥","&marker;":"▮","&mcomma;":"⨩","&mcy;":"м","&mdash;":"—","&measuredangle;":"∡","&mfr;":"𝔪","&mho;":"℧","&micro":"µ","&micro;":"µ","&mid;":"∣","&midast;":"*","&midcir;":"⫰","&middot":"·","&middot;":"·","&minus;":"−","&minusb;":"⊟","&minusd;":"∸","&minusdu;":"⨪","&mlcp;":"⫛","&mldr;":"…","&mnplus;":"∓","&models;":"⊧","&mopf;":"𝕞","&mp;":"∓","&mscr;":"𝓂","&mstpos;":"∾","&mu;":"μ","&multimap;":"⊸","&mumap;":"⊸","&nGg;":"⋙̸","&nGt;":"≫⃒","&nGtv;":"≫̸","&nLeftarrow;":"⇍","&nLeftrightarrow;":"⇎","&nLl;":"⋘̸","&nLt;":"≪⃒","&nLtv;":"≪̸","&nRightarrow;":"⇏","&nVDash;":"⊯","&nVdash;":"⊮","&nabla;":"∇","&nacute;":"ń","&nang;":"∠⃒","&nap;":"≉","&napE;":"⩰̸","&napid;":"≋̸","&napos;":"ŉ","&napprox;":"≉","&natur;":"♮","&natural;":"♮","&naturals;":"ℕ","&nbsp":" ","&nbsp;":" ","&nbump;":"≎̸","&nbumpe;":"≏̸","&ncap;":"⩃","&ncaron;":"ň","&ncedil;":"ņ","&ncong;":"≇","&ncongdot;":"⩭̸","&ncup;":"⩂","&ncy;":"н","&ndash;":"–","&ne;":"≠","&neArr;":"⇗","&nearhk;":"⤤","&nearr;":"↗","&nearrow;":"↗","&nedot;":"≐̸","&nequiv;":"≢","&nesear;":"⤨","&nesim;":"≂̸","&nexist;":"∄","&nexists;":"∄","&nfr;":"𝔫","&ngE;":"≧̸","&nge;":"≱","&ngeq;":"≱","&ngeqq;":"≧̸","&ngeqslant;":"⩾̸","&nges;":"⩾̸","&ngsim;":"≵","&ngt;":"≯","&ngtr;":"≯","&nhArr;":"⇎","&nharr;":"↮","&nhpar;":"⫲","&ni;":"∋","&nis;":"⋼","&nisd;":"⋺","&niv;":"∋","&njcy;":"њ","&nlArr;":"⇍","&nlE;":"≦̸","&nlarr;":"↚","&nldr;":"‥","&nle;":"≰","&nleftarrow;":"↚","&nleftrightarrow;":"↮","&nleq;":"≰","&nleqq;":"≦̸","&nleqslant;":"⩽̸","&nles;":"⩽̸","&nless;":"≮","&nlsim;":"≴","&nlt;":"≮","&nltri;":"⋪","&nltrie;":"⋬","&nmid;":"∤","&nopf;":"𝕟","&not":"¬","&not;":"¬","&notin;":"∉","&notinE;":"⋹̸","&notindot;":"⋵̸","&notinva;":"∉","&notinvb;":"⋷","&notinvc;":"⋶","&notni;":"∌","&notniva;":"∌","&notnivb;":"⋾","&notnivc;":"⋽","&npar;":"∦","&nparallel;":"∦","&nparsl;":"⫽⃥","&npart;":"∂̸","&npolint;":"⨔","&npr;":"⊀","&nprcue;":"⋠","&npre;":"⪯̸","&nprec;":"⊀","&npreceq;":"⪯̸","&nrArr;":"⇏","&nrarr;":"↛","&nrarrc;":"⤳̸","&nrarrw;":"↝̸","&nrightarrow;":"↛","&nrtri;":"⋫","&nrtrie;":"⋭","&nsc;":"⊁","&nsccue;":"⋡","&nsce;":"⪰̸","&nscr;":"𝓃","&nshortmid;":"∤","&nshortparallel;":"∦","&nsim;":"≁","&nsime;":"≄","&nsimeq;":"≄","&nsmid;":"∤","&nspar;":"∦","&nsqsube;":"⋢","&nsqsupe;":"⋣","&nsub;":"⊄","&nsubE;":"⫅̸","&nsube;":"⊈","&nsubset;":"⊂⃒","&nsubseteq;":"⊈","&nsubseteqq;":"⫅̸","&nsucc;":"⊁","&nsucceq;":"⪰̸","&nsup;":"⊅","&nsupE;":"⫆̸","&nsupe;":"⊉","&nsupset;":"⊃⃒","&nsupseteq;":"⊉","&nsupseteqq;":"⫆̸","&ntgl;":"≹","&ntilde":"ñ","&ntilde;":"ñ","&ntlg;":"≸","&ntriangleleft;":"⋪","&ntrianglelefteq;":"⋬","&ntriangleright;":"⋫","&ntrianglerighteq;":"⋭","&nu;":"ν","&num;":"#","&numero;":"№","&numsp;":" ","&nvDash;":"⊭","&nvHarr;":"⤄","&nvap;":"≍⃒","&nvdash;":"⊬","&nvge;":"≥⃒","&nvgt;":">⃒","&nvinfin;":"⧞","&nvlArr;":"⤂","&nvle;":"≤⃒","&nvlt;":"<⃒","&nvltrie;":"⊴⃒","&nvrArr;":"⤃","&nvrtrie;":"⊵⃒","&nvsim;":"∼⃒","&nwArr;":"⇖","&nwarhk;":"⤣","&nwarr;":"↖","&nwarrow;":"↖","&nwnear;":"⤧","&oS;":"Ⓢ","&oacute":"ó","&oacute;":"ó","&oast;":"⊛","&ocir;":"⊚","&ocirc":"ô","&ocirc;":"ô","&ocy;":"о","&odash;":"⊝","&odblac;":"ő","&odiv;":"⨸","&odot;":"⊙","&odsold;":"⦼","&oelig;":"œ","&ofcir;":"⦿","&ofr;":"𝔬","&ogon;":"˛","&ograve":"ò","&ograve;":"ò","&ogt;":"⧁","&ohbar;":"⦵","&ohm;":"Ω","&oint;":"∮","&olarr;":"↺","&olcir;":"⦾","&olcross;":"⦻","&oline;":"‾","&olt;":"⧀","&omacr;":"ō","&omega;":"ω","&omicron;":"ο","&omid;":"⦶","&ominus;":"⊖","&oopf;":"𝕠","&opar;":"⦷","&operp;":"⦹","&oplus;":"⊕","&or;":"∨","&orarr;":"↻","&ord;":"⩝","&order;":"ℴ","&orderof;":"ℴ","&ordf":"ª","&ordf;":"ª","&ordm":"º","&ordm;":"º","&origof;":"⊶","&oror;":"⩖","&orslope;":"⩗","&orv;":"⩛","&oscr;":"ℴ","&oslash":"ø","&oslash;":"ø","&osol;":"⊘","&otilde":"õ","&otilde;":"õ","&otimes;":"⊗","&otimesas;":"⨶","&ouml":"ö","&ouml;":"ö","&ovbar;":"⌽","&par;":"∥","&para":"¶","&para;":"¶","&parallel;":"∥","&parsim;":"⫳","&parsl;":"⫽","&part;":"∂","&pcy;":"п","&percnt;":"%","&period;":".","&permil;":"‰","&perp;":"⊥","&pertenk;":"‱","&pfr;":"𝔭","&phi;":"φ","&phiv;":"ϕ","&phmmat;":"ℳ","&phone;":"☎","&pi;":"π","&pitchfork;":"⋔","&piv;":"ϖ","&planck;":"ℏ","&planckh;":"ℎ","&plankv;":"ℏ","&plus;":"+","&plusacir;":"⨣","&plusb;":"⊞","&pluscir;":"⨢","&plusdo;":"∔","&plusdu;":"⨥","&pluse;":"⩲","&plusmn":"±","&plusmn;":"±","&plussim;":"⨦","&plustwo;":"⨧","&pm;":"±","&pointint;":"⨕","&popf;":"𝕡","&pound":"£","&pound;":"£","&pr;":"≺","&prE;":"⪳","&prap;":"⪷","&prcue;":"≼","&pre;":"⪯","&prec;":"≺","&precapprox;":"⪷","&preccurlyeq;":"≼","&preceq;":"⪯","&precnapprox;":"⪹","&precneqq;":"⪵","&precnsim;":"⋨","&precsim;":"≾","&prime;":"′","&primes;":"ℙ","&prnE;":"⪵","&prnap;":"⪹","&prnsim;":"⋨","&prod;":"∏","&profalar;":"⌮","&profline;":"⌒","&profsurf;":"⌓","&prop;":"∝","&propto;":"∝","&prsim;":"≾","&prurel;":"⊰","&pscr;":"𝓅","&psi;":"ψ","&puncsp;":" ","&qfr;":"𝔮","&qint;":"⨌","&qopf;":"𝕢","&qprime;":"⁗","&qscr;":"𝓆","&quaternions;":"ℍ","&quatint;":"⨖","&quest;":"?","&questeq;":"≟","&quot":'"',"&quot;":'"',"&rAarr;":"⇛","&rArr;":"⇒","&rAtail;":"⤜","&rBarr;":"⤏","&rHar;":"⥤","&race;":"∽̱","&racute;":"ŕ","&radic;":"√","&raemptyv;":"⦳","&rang;":"⟩","&rangd;":"⦒","&range;":"⦥","&rangle;":"⟩","&raquo":"»","&raquo;":"»","&rarr;":"→","&rarrap;":"⥵","&rarrb;":"⇥","&rarrbfs;":"⤠","&rarrc;":"⤳","&rarrfs;":"⤞","&rarrhk;":"↪","&rarrlp;":"↬","&rarrpl;":"⥅","&rarrsim;":"⥴","&rarrtl;":"↣","&rarrw;":"↝","&ratail;":"⤚","&ratio;":"∶","&rationals;":"ℚ","&rbarr;":"⤍","&rbbrk;":"❳","&rbrace;":"}","&rbrack;":"]","&rbrke;":"⦌","&rbrksld;":"⦎","&rbrkslu;":"⦐","&rcaron;":"ř","&rcedil;":"ŗ","&rceil;":"⌉","&rcub;":"}","&rcy;":"р","&rdca;":"⤷","&rdldhar;":"⥩","&rdquo;":"”","&rdquor;":"”","&rdsh;":"↳","&real;":"ℜ","&realine;":"ℛ","&realpart;":"ℜ","&reals;":"ℝ","&rect;":"▭","&reg":"®","&reg;":"®","&rfisht;":"⥽","&rfloor;":"⌋","&rfr;":"𝔯","&rhard;":"⇁","&rharu;":"⇀","&rharul;":"⥬","&rho;":"ρ","&rhov;":"ϱ","&rightarrow;":"→","&rightarrowtail;":"↣","&rightharpoondown;":"⇁","&rightharpoonup;":"⇀","&rightleftarrows;":"⇄","&rightleftharpoons;":"⇌","&rightrightarrows;":"⇉","&rightsquigarrow;":"↝","&rightthreetimes;":"⋌","&ring;":"˚","&risingdotseq;":"≓","&rlarr;":"⇄","&rlhar;":"⇌","&rlm;":"‏","&rmoust;":"⎱","&rmoustache;":"⎱","&rnmid;":"⫮","&roang;":"⟭","&roarr;":"⇾","&robrk;":"⟧","&ropar;":"⦆","&ropf;":"𝕣","&roplus;":"⨮","&rotimes;":"⨵","&rpar;":")","&rpargt;":"⦔","&rppolint;":"⨒","&rrarr;":"⇉","&rsaquo;":"›","&rscr;":"𝓇","&rsh;":"↱","&rsqb;":"]","&rsquo;":"’","&rsquor;":"’","&rthree;":"⋌","&rtimes;":"⋊","&rtri;":"▹","&rtrie;":"⊵","&rtrif;":"▸","&rtriltri;":"⧎","&ruluhar;":"⥨","&rx;":"℞","&sacute;":"ś","&sbquo;":"‚","&sc;":"≻","&scE;":"⪴","&scap;":"⪸","&scaron;":"š","&sccue;":"≽","&sce;":"⪰","&scedil;":"ş","&scirc;":"ŝ","&scnE;":"⪶","&scnap;":"⪺","&scnsim;":"⋩","&scpolint;":"⨓","&scsim;":"≿","&scy;":"с","&sdot;":"⋅","&sdotb;":"⊡","&sdote;":"⩦","&seArr;":"⇘","&searhk;":"⤥","&searr;":"↘","&searrow;":"↘","&sect":"§","&sect;":"§","&semi;":";","&seswar;":"⤩","&setminus;":"∖","&setmn;":"∖","&sext;":"✶","&sfr;":"𝔰","&sfrown;":"⌢","&sharp;":"♯","&shchcy;":"щ","&shcy;":"ш","&shortmid;":"∣","&shortparallel;":"∥","&shy":"­","&shy;":"­","&sigma;":"σ","&sigmaf;":"ς","&sigmav;":"ς","&sim;":"∼","&simdot;":"⩪","&sime;":"≃","&simeq;":"≃","&simg;":"⪞","&simgE;":"⪠","&siml;":"⪝","&simlE;":"⪟","&simne;":"≆","&simplus;":"⨤","&simrarr;":"⥲","&slarr;":"←","&smallsetminus;":"∖","&smashp;":"⨳","&smeparsl;":"⧤","&smid;":"∣","&smile;":"⌣","&smt;":"⪪","&smte;":"⪬","&smtes;":"⪬︀","&softcy;":"ь","&sol;":"/","&solb;":"⧄","&solbar;":"⌿","&sopf;":"𝕤","&spades;":"♠","&spadesuit;":"♠","&spar;":"∥","&sqcap;":"⊓","&sqcaps;":"⊓︀","&sqcup;":"⊔","&sqcups;":"⊔︀","&sqsub;":"⊏","&sqsube;":"⊑","&sqsubset;":"⊏","&sqsubseteq;":"⊑","&sqsup;":"⊐","&sqsupe;":"⊒","&sqsupset;":"⊐","&sqsupseteq;":"⊒","&squ;":"□","&square;":"□","&squarf;":"▪","&squf;":"▪","&srarr;":"→","&sscr;":"𝓈","&ssetmn;":"∖","&ssmile;":"⌣","&sstarf;":"⋆","&star;":"☆","&starf;":"★","&straightepsilon;":"ϵ","&straightphi;":"ϕ","&strns;":"¯","&sub;":"⊂","&subE;":"⫅","&subdot;":"⪽","&sube;":"⊆","&subedot;":"⫃","&submult;":"⫁","&subnE;":"⫋","&subne;":"⊊","&subplus;":"⪿","&subrarr;":"⥹","&subset;":"⊂","&subseteq;":"⊆","&subseteqq;":"⫅","&subsetneq;":"⊊","&subsetneqq;":"⫋","&subsim;":"⫇","&subsub;":"⫕","&subsup;":"⫓","&succ;":"≻","&succapprox;":"⪸","&succcurlyeq;":"≽","&succeq;":"⪰","&succnapprox;":"⪺","&succneqq;":"⪶","&succnsim;":"⋩","&succsim;":"≿","&sum;":"∑","&sung;":"♪","&sup1":"¹","&sup1;":"¹","&sup2":"²","&sup2;":"²","&sup3":"³","&sup3;":"³","&sup;":"⊃","&supE;":"⫆","&supdot;":"⪾","&supdsub;":"⫘","&supe;":"⊇","&supedot;":"⫄","&suphsol;":"⟉","&suphsub;":"⫗","&suplarr;":"⥻","&supmult;":"⫂","&supnE;":"⫌","&supne;":"⊋","&supplus;":"⫀","&supset;":"⊃","&supseteq;":"⊇","&supseteqq;":"⫆","&supsetneq;":"⊋","&supsetneqq;":"⫌","&supsim;":"⫈","&supsub;":"⫔","&supsup;":"⫖","&swArr;":"⇙","&swarhk;":"⤦","&swarr;":"↙","&swarrow;":"↙","&swnwar;":"⤪","&szlig":"ß","&szlig;":"ß","&target;":"⌖","&tau;":"τ","&tbrk;":"⎴","&tcaron;":"ť","&tcedil;":"ţ","&tcy;":"т","&tdot;":"⃛","&telrec;":"⌕","&tfr;":"𝔱","&there4;":"∴","&therefore;":"∴","&theta;":"θ","&thetasym;":"ϑ","&thetav;":"ϑ","&thickapprox;":"≈","&thicksim;":"∼","&thinsp;":" ","&thkap;":"≈","&thksim;":"∼","&thorn":"þ","&thorn;":"þ","&tilde;":"˜","&times":"×","&times;":"×","&timesb;":"⊠","&timesbar;":"⨱","&timesd;":"⨰","&tint;":"∭","&toea;":"⤨","&top;":"⊤","&topbot;":"⌶","&topcir;":"⫱","&topf;":"𝕥","&topfork;":"⫚","&tosa;":"⤩","&tprime;":"‴","&trade;":"™","&triangle;":"▵","&triangledown;":"▿","&triangleleft;":"◃","&trianglelefteq;":"⊴","&triangleq;":"≜","&triangleright;":"▹","&trianglerighteq;":"⊵","&tridot;":"◬","&trie;":"≜","&triminus;":"⨺","&triplus;":"⨹","&trisb;":"⧍","&tritime;":"⨻","&trpezium;":"⏢","&tscr;":"𝓉","&tscy;":"ц","&tshcy;":"ћ","&tstrok;":"ŧ","&twixt;":"≬","&twoheadleftarrow;":"↞","&twoheadrightarrow;":"↠","&uArr;":"⇑","&uHar;":"⥣","&uacute":"ú","&uacute;":"ú","&uarr;":"↑","&ubrcy;":"ў","&ubreve;":"ŭ","&ucirc":"û","&ucirc;":"û","&ucy;":"у","&udarr;":"⇅","&udblac;":"ű","&udhar;":"⥮","&ufisht;":"⥾","&ufr;":"𝔲","&ugrave":"ù","&ugrave;":"ù","&uharl;":"↿","&uharr;":"↾","&uhblk;":"▀","&ulcorn;":"⌜","&ulcorner;":"⌜","&ulcrop;":"⌏","&ultri;":"◸","&umacr;":"ū","&uml":"¨","&uml;":"¨","&uogon;":"ų","&uopf;":"𝕦","&uparrow;":"↑","&updownarrow;":"↕","&upharpoonleft;":"↿","&upharpoonright;":"↾","&uplus;":"⊎","&upsi;":"υ","&upsih;":"ϒ","&upsilon;":"υ","&upuparrows;":"⇈","&urcorn;":"⌝","&urcorner;":"⌝","&urcrop;":"⌎","&uring;":"ů","&urtri;":"◹","&uscr;":"𝓊","&utdot;":"⋰","&utilde;":"ũ","&utri;":"▵","&utrif;":"▴","&uuarr;":"⇈","&uuml":"ü","&uuml;":"ü","&uwangle;":"⦧","&vArr;":"⇕","&vBar;":"⫨","&vBarv;":"⫩","&vDash;":"⊨","&vangrt;":"⦜","&varepsilon;":"ϵ","&varkappa;":"ϰ","&varnothing;":"∅","&varphi;":"ϕ","&varpi;":"ϖ","&varpropto;":"∝","&varr;":"↕","&varrho;":"ϱ","&varsigma;":"ς","&varsubsetneq;":"⊊︀","&varsubsetneqq;":"⫋︀","&varsupsetneq;":"⊋︀","&varsupsetneqq;":"⫌︀","&vartheta;":"ϑ","&vartriangleleft;":"⊲","&vartriangleright;":"⊳","&vcy;":"в","&vdash;":"⊢","&vee;":"∨","&veebar;":"⊻","&veeeq;":"≚","&vellip;":"⋮","&verbar;":"|","&vert;":"|","&vfr;":"𝔳","&vltri;":"⊲","&vnsub;":"⊂⃒","&vnsup;":"⊃⃒","&vopf;":"𝕧","&vprop;":"∝","&vrtri;":"⊳","&vscr;":"𝓋","&vsubnE;":"⫋︀","&vsubne;":"⊊︀","&vsupnE;":"⫌︀","&vsupne;":"⊋︀","&vzigzag;":"⦚","&wcirc;":"ŵ","&wedbar;":"⩟","&wedge;":"∧","&wedgeq;":"≙","&weierp;":"℘","&wfr;":"𝔴","&wopf;":"𝕨","&wp;":"℘","&wr;":"≀","&wreath;":"≀","&wscr;":"𝓌","&xcap;":"⋂","&xcirc;":"◯","&xcup;":"⋃","&xdtri;":"▽","&xfr;":"𝔵","&xhArr;":"⟺","&xharr;":"⟷","&xi;":"ξ","&xlArr;":"⟸","&xlarr;":"⟵","&xmap;":"⟼","&xnis;":"⋻","&xodot;":"⨀","&xopf;":"𝕩","&xoplus;":"⨁","&xotime;":"⨂","&xrArr;":"⟹","&xrarr;":"⟶","&xscr;":"𝓍","&xsqcup;":"⨆","&xuplus;":"⨄","&xutri;":"△","&xvee;":"⋁","&xwedge;":"⋀","&yacute":"ý","&yacute;":"ý","&yacy;":"я","&ycirc;":"ŷ","&ycy;":"ы","&yen":"¥","&yen;":"¥","&yfr;":"𝔶","&yicy;":"ї","&yopf;":"𝕪","&yscr;":"𝓎","&yucy;":"ю","&yuml":"ÿ","&yuml;":"ÿ","&zacute;":"ź","&zcaron;":"ž","&zcy;":"з","&zdot;":"ż","&zeetrf;":"ℨ","&zeta;":"ζ","&zfr;":"𝔷","&zhcy;":"ж","&zigrarr;":"⇝","&zopf;":"𝕫","&zscr;":"𝓏","&zwj;":"‍","&zwnj;":"‌"},characters:{"Æ":"&AElig;","&":"&amp;","Á":"&Aacute;","Ă":"&Abreve;","Â":"&Acirc;","А":"&Acy;","𝔄":"&Afr;","À":"&Agrave;","Α":"&Alpha;","Ā":"&Amacr;","⩓":"&And;","Ą":"&Aogon;","𝔸":"&Aopf;","⁡":"&af;","Å":"&angst;","𝒜":"&Ascr;","≔":"&coloneq;","Ã":"&Atilde;","Ä":"&Auml;","∖":"&ssetmn;","⫧":"&Barv;","⌆":"&doublebarwedge;","Б":"&Bcy;","∵":"&because;","ℬ":"&bernou;","Β":"&Beta;","𝔅":"&Bfr;","𝔹":"&Bopf;","˘":"&breve;","≎":"&bump;","Ч":"&CHcy;","©":"&copy;","Ć":"&Cacute;","⋒":"&Cap;","ⅅ":"&DD;","ℭ":"&Cfr;","Č":"&Ccaron;","Ç":"&Ccedil;","Ĉ":"&Ccirc;","∰":"&Cconint;","Ċ":"&Cdot;","¸":"&cedil;","·":"&middot;","Χ":"&Chi;","⊙":"&odot;","⊖":"&ominus;","⊕":"&oplus;","⊗":"&otimes;","∲":"&cwconint;","”":"&rdquor;","’":"&rsquor;","∷":"&Proportion;","⩴":"&Colone;","≡":"&equiv;","∯":"&DoubleContourIntegral;","∮":"&oint;","ℂ":"&complexes;","∐":"&coprod;","∳":"&awconint;","⨯":"&Cross;","𝒞":"&Cscr;","⋓":"&Cup;","≍":"&asympeq;","⤑":"&DDotrahd;","Ђ":"&DJcy;","Ѕ":"&DScy;","Џ":"&DZcy;","‡":"&ddagger;","↡":"&Darr;","⫤":"&DoubleLeftTee;","Ď":"&Dcaron;","Д":"&Dcy;","∇":"&nabla;","Δ":"&Delta;","𝔇":"&Dfr;","´":"&acute;","˙":"&dot;","˝":"&dblac;","`":"&grave;","˜":"&tilde;","⋄":"&diamond;","ⅆ":"&dd;","𝔻":"&Dopf;","¨":"&uml;","⃜":"&DotDot;","≐":"&esdot;","⇓":"&dArr;","⇐":"&lArr;","⇔":"&iff;","⟸":"&xlArr;","⟺":"&xhArr;","⟹":"&xrArr;","⇒":"&rArr;","⊨":"&vDash;","⇑":"&uArr;","⇕":"&vArr;","∥":"&spar;","↓":"&downarrow;","⤓":"&DownArrowBar;","⇵":"&duarr;","̑":"&DownBreve;","⥐":"&DownLeftRightVector;","⥞":"&DownLeftTeeVector;","↽":"&lhard;","⥖":"&DownLeftVectorBar;","⥟":"&DownRightTeeVector;","⇁":"&rightharpoondown;","⥗":"&DownRightVectorBar;","⊤":"&top;","↧":"&mapstodown;","𝒟":"&Dscr;","Đ":"&Dstrok;","Ŋ":"&ENG;","Ð":"&ETH;","É":"&Eacute;","Ě":"&Ecaron;","Ê":"&Ecirc;","Э":"&Ecy;","Ė":"&Edot;","𝔈":"&Efr;","È":"&Egrave;","∈":"&isinv;","Ē":"&Emacr;","◻":"&EmptySmallSquare;","▫":"&EmptyVerySmallSquare;","Ę":"&Eogon;","𝔼":"&Eopf;","Ε":"&Epsilon;","⩵":"&Equal;","≂":"&esim;","⇌":"&rlhar;","ℰ":"&expectation;","⩳":"&Esim;","Η":"&Eta;","Ë":"&Euml;","∃":"&exist;","ⅇ":"&exponentiale;","Ф":"&Fcy;","𝔉":"&Ffr;","◼":"&FilledSmallSquare;","▪":"&squf;","𝔽":"&Fopf;","∀":"&forall;","ℱ":"&Fscr;","Ѓ":"&GJcy;",">":"&gt;","Γ":"&Gamma;","Ϝ":"&Gammad;","Ğ":"&Gbreve;","Ģ":"&Gcedil;","Ĝ":"&Gcirc;","Г":"&Gcy;","Ġ":"&Gdot;","𝔊":"&Gfr;","⋙":"&ggg;","𝔾":"&Gopf;","≥":"&geq;","⋛":"&gtreqless;","≧":"&geqq;","⪢":"&GreaterGreater;","≷":"&gtrless;","⩾":"&ges;","≳":"&gtrsim;","𝒢":"&Gscr;","≫":"&gg;","Ъ":"&HARDcy;","ˇ":"&caron;","^":"&Hat;","Ĥ":"&Hcirc;","ℌ":"&Poincareplane;","ℋ":"&hamilt;","ℍ":"&quaternions;","─":"&boxh;","Ħ":"&Hstrok;","≏":"&bumpeq;","Е":"&IEcy;","Ĳ":"&IJlig;","Ё":"&IOcy;","Í":"&Iacute;","Î":"&Icirc;","И":"&Icy;","İ":"&Idot;","ℑ":"&imagpart;","Ì":"&Igrave;","Ī":"&Imacr;","ⅈ":"&ii;","∬":"&Int;","∫":"&int;","⋂":"&xcap;","⁣":"&ic;","⁢":"&it;","Į":"&Iogon;","𝕀":"&Iopf;","Ι":"&Iota;","ℐ":"&imagline;","Ĩ":"&Itilde;","І":"&Iukcy;","Ï":"&Iuml;","Ĵ":"&Jcirc;","Й":"&Jcy;","𝔍":"&Jfr;","𝕁":"&Jopf;","𝒥":"&Jscr;","Ј":"&Jsercy;","Є":"&Jukcy;","Х":"&KHcy;","Ќ":"&KJcy;","Κ":"&Kappa;","Ķ":"&Kcedil;","К":"&Kcy;","𝔎":"&Kfr;","𝕂":"&Kopf;","𝒦":"&Kscr;","Љ":"&LJcy;","<":"&lt;","Ĺ":"&Lacute;","Λ":"&Lambda;","⟪":"&Lang;","ℒ":"&lagran;","↞":"&twoheadleftarrow;","Ľ":"&Lcaron;","Ļ":"&Lcedil;","Л":"&Lcy;","⟨":"&langle;","←":"&slarr;","⇤":"&larrb;","⇆":"&lrarr;","⌈":"&lceil;","⟦":"&lobrk;","⥡":"&LeftDownTeeVector;","⇃":"&downharpoonleft;","⥙":"&LeftDownVectorBar;","⌊":"&lfloor;","↔":"&leftrightarrow;","⥎":"&LeftRightVector;","⊣":"&dashv;","↤":"&mapstoleft;","⥚":"&LeftTeeVector;","⊲":"&vltri;","⧏":"&LeftTriangleBar;","⊴":"&trianglelefteq;","⥑":"&LeftUpDownVector;","⥠":"&LeftUpTeeVector;","↿":"&upharpoonleft;","⥘":"&LeftUpVectorBar;","↼":"&lharu;","⥒":"&LeftVectorBar;","⋚":"&lesseqgtr;","≦":"&leqq;","≶":"&lg;","⪡":"&LessLess;","⩽":"&les;","≲":"&lsim;","𝔏":"&Lfr;","⋘":"&Ll;","⇚":"&lAarr;","Ŀ":"&Lmidot;","⟵":"&xlarr;","⟷":"&xharr;","⟶":"&xrarr;","𝕃":"&Lopf;","↙":"&swarrow;","↘":"&searrow;","↰":"&lsh;","Ł":"&Lstrok;","≪":"&ll;","⤅":"&Map;","М":"&Mcy;"," ":"&MediumSpace;","ℳ":"&phmmat;","𝔐":"&Mfr;","∓":"&mp;","𝕄":"&Mopf;","Μ":"&Mu;","Њ":"&NJcy;","Ń":"&Nacute;","Ň":"&Ncaron;","Ņ":"&Ncedil;","Н":"&Ncy;","​":"&ZeroWidthSpace;","\n":"&NewLine;","𝔑":"&Nfr;","⁠":"&NoBreak;"," ":"&nbsp;","ℕ":"&naturals;","⫬":"&Not;","≢":"&nequiv;","≭":"&NotCupCap;","∦":"&nspar;","∉":"&notinva;","≠":"&ne;","≂̸":"&nesim;","∄":"&nexists;","≯":"&ngtr;","≱":"&ngeq;","≧̸":"&ngeqq;","≫̸":"&nGtv;","≹":"&ntgl;","⩾̸":"&nges;","≵":"&ngsim;","≎̸":"&nbump;","≏̸":"&nbumpe;","⋪":"&ntriangleleft;","⧏̸":"&NotLeftTriangleBar;","⋬":"&ntrianglelefteq;","≮":"&nlt;","≰":"&nleq;","≸":"&ntlg;","≪̸":"&nLtv;","⩽̸":"&nles;","≴":"&nlsim;","⪢̸":"&NotNestedGreaterGreater;","⪡̸":"&NotNestedLessLess;","⊀":"&nprec;","⪯̸":"&npreceq;","⋠":"&nprcue;","∌":"&notniva;","⋫":"&ntriangleright;","⧐̸":"&NotRightTriangleBar;","⋭":"&ntrianglerighteq;","⊏̸":"&NotSquareSubset;","⋢":"&nsqsube;","⊐̸":"&NotSquareSuperset;","⋣":"&nsqsupe;","⊂⃒":"&vnsub;","⊈":"&nsubseteq;","⊁":"&nsucc;","⪰̸":"&nsucceq;","⋡":"&nsccue;","≿̸":"&NotSucceedsTilde;","⊃⃒":"&vnsup;","⊉":"&nsupseteq;","≁":"&nsim;","≄":"&nsimeq;","≇":"&ncong;","≉":"&napprox;","∤":"&nsmid;","𝒩":"&Nscr;","Ñ":"&Ntilde;","Ν":"&Nu;","Œ":"&OElig;","Ó":"&Oacute;","Ô":"&Ocirc;","О":"&Ocy;","Ő":"&Odblac;","𝔒":"&Ofr;","Ò":"&Ograve;","Ō":"&Omacr;","Ω":"&ohm;","Ο":"&Omicron;","𝕆":"&Oopf;","“":"&ldquo;","‘":"&lsquo;","⩔":"&Or;","𝒪":"&Oscr;","Ø":"&Oslash;","Õ":"&Otilde;","⨷":"&Otimes;","Ö":"&Ouml;","‾":"&oline;","⏞":"&OverBrace;","⎴":"&tbrk;","⏜":"&OverParenthesis;","∂":"&part;","П":"&Pcy;","𝔓":"&Pfr;","Φ":"&Phi;","Π":"&Pi;","±":"&pm;","ℙ":"&primes;","⪻":"&Pr;","≺":"&prec;","⪯":"&preceq;","≼":"&preccurlyeq;","≾":"&prsim;","″":"&Prime;","∏":"&prod;","∝":"&vprop;","𝒫":"&Pscr;","Ψ":"&Psi;",'"':"&quot;","𝔔":"&Qfr;","ℚ":"&rationals;","𝒬":"&Qscr;","⤐":"&drbkarow;","®":"&reg;","Ŕ":"&Racute;","⟫":"&Rang;","↠":"&twoheadrightarrow;","⤖":"&Rarrtl;","Ř":"&Rcaron;","Ŗ":"&Rcedil;","Р":"&Rcy;","ℜ":"&realpart;","∋":"&niv;","⇋":"&lrhar;","⥯":"&duhar;","Ρ":"&Rho;","⟩":"&rangle;","→":"&srarr;","⇥":"&rarrb;","⇄":"&rlarr;","⌉":"&rceil;","⟧":"&robrk;","⥝":"&RightDownTeeVector;","⇂":"&downharpoonright;","⥕":"&RightDownVectorBar;","⌋":"&rfloor;","⊢":"&vdash;","↦":"&mapsto;","⥛":"&RightTeeVector;","⊳":"&vrtri;","⧐":"&RightTriangleBar;","⊵":"&trianglerighteq;","⥏":"&RightUpDownVector;","⥜":"&RightUpTeeVector;","↾":"&upharpoonright;","⥔":"&RightUpVectorBar;","⇀":"&rightharpoonup;","⥓":"&RightVectorBar;","ℝ":"&reals;","⥰":"&RoundImplies;","⇛":"&rAarr;","ℛ":"&realine;","↱":"&rsh;","⧴":"&RuleDelayed;","Щ":"&SHCHcy;","Ш":"&SHcy;","Ь":"&SOFTcy;","Ś":"&Sacute;","⪼":"&Sc;","Š":"&Scaron;","Ş":"&Scedil;","Ŝ":"&Scirc;","С":"&Scy;","𝔖":"&Sfr;","↑":"&uparrow;","Σ":"&Sigma;","∘":"&compfn;","𝕊":"&Sopf;","√":"&radic;","□":"&square;","⊓":"&sqcap;","⊏":"&sqsubset;","⊑":"&sqsubseteq;","⊐":"&sqsupset;","⊒":"&sqsupseteq;","⊔":"&sqcup;","𝒮":"&Sscr;","⋆":"&sstarf;","⋐":"&Subset;","⊆":"&subseteq;","≻":"&succ;","⪰":"&succeq;","≽":"&succcurlyeq;","≿":"&succsim;","∑":"&sum;","⋑":"&Supset;","⊃":"&supset;","⊇":"&supseteq;","Þ":"&THORN;","™":"&trade;","Ћ":"&TSHcy;","Ц":"&TScy;","\t":"&Tab;","Τ":"&Tau;","Ť":"&Tcaron;","Ţ":"&Tcedil;","Т":"&Tcy;","𝔗":"&Tfr;","∴":"&therefore;","Θ":"&Theta;","  ":"&ThickSpace;"," ":"&thinsp;","∼":"&thksim;","≃":"&simeq;","≅":"&cong;","≈":"&thkap;","𝕋":"&Topf;","⃛":"&tdot;","𝒯":"&Tscr;","Ŧ":"&Tstrok;","Ú":"&Uacute;","↟":"&Uarr;","⥉":"&Uarrocir;","Ў":"&Ubrcy;","Ŭ":"&Ubreve;","Û":"&Ucirc;","У":"&Ucy;","Ű":"&Udblac;","𝔘":"&Ufr;","Ù":"&Ugrave;","Ū":"&Umacr;",_:"&lowbar;","⏟":"&UnderBrace;","⎵":"&bbrk;","⏝":"&UnderParenthesis;","⋃":"&xcup;","⊎":"&uplus;","Ų":"&Uogon;","𝕌":"&Uopf;","⤒":"&UpArrowBar;","⇅":"&udarr;","↕":"&varr;","⥮":"&udhar;","⊥":"&perp;","↥":"&mapstoup;","↖":"&nwarrow;","↗":"&nearrow;","ϒ":"&upsih;","Υ":"&Upsilon;","Ů":"&Uring;","𝒰":"&Uscr;","Ũ":"&Utilde;","Ü":"&Uuml;","⊫":"&VDash;","⫫":"&Vbar;","В":"&Vcy;","⊩":"&Vdash;","⫦":"&Vdashl;","⋁":"&xvee;","‖":"&Vert;","∣":"&smid;","|":"&vert;","❘":"&VerticalSeparator;","≀":"&wreath;"," ":"&hairsp;","𝔙":"&Vfr;","𝕍":"&Vopf;","𝒱":"&Vscr;","⊪":"&Vvdash;","Ŵ":"&Wcirc;","⋀":"&xwedge;","𝔚":"&Wfr;","𝕎":"&Wopf;","𝒲":"&Wscr;","𝔛":"&Xfr;","Ξ":"&Xi;","𝕏":"&Xopf;","𝒳":"&Xscr;","Я":"&YAcy;","Ї":"&YIcy;","Ю":"&YUcy;","Ý":"&Yacute;","Ŷ":"&Ycirc;","Ы":"&Ycy;","𝔜":"&Yfr;","𝕐":"&Yopf;","𝒴":"&Yscr;","Ÿ":"&Yuml;","Ж":"&ZHcy;","Ź":"&Zacute;","Ž":"&Zcaron;","З":"&Zcy;","Ż":"&Zdot;","Ζ":"&Zeta;","ℨ":"&zeetrf;","ℤ":"&integers;","𝒵":"&Zscr;","á":"&aacute;","ă":"&abreve;","∾":"&mstpos;","∾̳":"&acE;","∿":"&acd;","â":"&acirc;","а":"&acy;","æ":"&aelig;","𝔞":"&afr;","à":"&agrave;","ℵ":"&aleph;","α":"&alpha;","ā":"&amacr;","⨿":"&amalg;","∧":"&wedge;","⩕":"&andand;","⩜":"&andd;","⩘":"&andslope;","⩚":"&andv;","∠":"&angle;","⦤":"&ange;","∡":"&measuredangle;","⦨":"&angmsdaa;","⦩":"&angmsdab;","⦪":"&angmsdac;","⦫":"&angmsdad;","⦬":"&angmsdae;","⦭":"&angmsdaf;","⦮":"&angmsdag;","⦯":"&angmsdah;","∟":"&angrt;","⊾":"&angrtvb;","⦝":"&angrtvbd;","∢":"&angsph;","⍼":"&angzarr;","ą":"&aogon;","𝕒":"&aopf;","⩰":"&apE;","⩯":"&apacir;","≊":"&approxeq;","≋":"&apid;","'":"&apos;","å":"&aring;","𝒶":"&ascr;","*":"&midast;","ã":"&atilde;","ä":"&auml;","⨑":"&awint;","⫭":"&bNot;","≌":"&bcong;","϶":"&bepsi;","‵":"&bprime;","∽":"&bsim;","⋍":"&bsime;","⊽":"&barvee;","⌅":"&barwedge;","⎶":"&bbrktbrk;","б":"&bcy;","„":"&ldquor;","⦰":"&bemptyv;","β":"&beta;","ℶ":"&beth;","≬":"&twixt;","𝔟":"&bfr;","◯":"&xcirc;","⨀":"&xodot;","⨁":"&xoplus;","⨂":"&xotime;","⨆":"&xsqcup;","★":"&starf;","▽":"&xdtri;","△":"&xutri;","⨄":"&xuplus;","⤍":"&rbarr;","⧫":"&lozf;","▴":"&utrif;","▾":"&dtrif;","◂":"&ltrif;","▸":"&rtrif;","␣":"&blank;","▒":"&blk12;","░":"&blk14;","▓":"&blk34;","█":"&block;","=⃥":"&bne;","≡⃥":"&bnequiv;","⌐":"&bnot;","𝕓":"&bopf;","⋈":"&bowtie;","╗":"&boxDL;","╔":"&boxDR;","╖":"&boxDl;","╓":"&boxDr;","═":"&boxH;","╦":"&boxHD;","╩":"&boxHU;","╤":"&boxHd;","╧":"&boxHu;","╝":"&boxUL;","╚":"&boxUR;","╜":"&boxUl;","╙":"&boxUr;","║":"&boxV;","╬":"&boxVH;","╣":"&boxVL;","╠":"&boxVR;","╫":"&boxVh;","╢":"&boxVl;","╟":"&boxVr;","⧉":"&boxbox;","╕":"&boxdL;","╒":"&boxdR;","┐":"&boxdl;","┌":"&boxdr;","╥":"&boxhD;","╨":"&boxhU;","┬":"&boxhd;","┴":"&boxhu;","⊟":"&minusb;","⊞":"&plusb;","⊠":"&timesb;","╛":"&boxuL;","╘":"&boxuR;","┘":"&boxul;","└":"&boxur;","│":"&boxv;","╪":"&boxvH;","╡":"&boxvL;","╞":"&boxvR;","┼":"&boxvh;","┤":"&boxvl;","├":"&boxvr;","¦":"&brvbar;","𝒷":"&bscr;","⁏":"&bsemi;","\\":"&bsol;","⧅":"&bsolb;","⟈":"&bsolhsub;","•":"&bullet;","⪮":"&bumpE;","ć":"&cacute;","∩":"&cap;","⩄":"&capand;","⩉":"&capbrcup;","⩋":"&capcap;","⩇":"&capcup;","⩀":"&capdot;","∩︀":"&caps;","⁁":"&caret;","⩍":"&ccaps;","č":"&ccaron;","ç":"&ccedil;","ĉ":"&ccirc;","⩌":"&ccups;","⩐":"&ccupssm;","ċ":"&cdot;","⦲":"&cemptyv;","¢":"&cent;","𝔠":"&cfr;","ч":"&chcy;","✓":"&checkmark;","χ":"&chi;","○":"&cir;","⧃":"&cirE;","ˆ":"&circ;","≗":"&cire;","↺":"&olarr;","↻":"&orarr;","Ⓢ":"&oS;","⊛":"&oast;","⊚":"&ocir;","⊝":"&odash;","⨐":"&cirfnint;","⫯":"&cirmid;","⧂":"&cirscir;","♣":"&clubsuit;",":":"&colon;",",":"&comma;","@":"&commat;","∁":"&complement;","⩭":"&congdot;","𝕔":"&copf;","℗":"&copysr;","↵":"&crarr;","✗":"&cross;","𝒸":"&cscr;","⫏":"&csub;","⫑":"&csube;","⫐":"&csup;","⫒":"&csupe;","⋯":"&ctdot;","⤸":"&cudarrl;","⤵":"&cudarrr;","⋞":"&curlyeqprec;","⋟":"&curlyeqsucc;","↶":"&curvearrowleft;","⤽":"&cularrp;","∪":"&cup;","⩈":"&cupbrcap;","⩆":"&cupcap;","⩊":"&cupcup;","⊍":"&cupdot;","⩅":"&cupor;","∪︀":"&cups;","↷":"&curvearrowright;","⤼":"&curarrm;","⋎":"&cuvee;","⋏":"&cuwed;","¤":"&curren;","∱":"&cwint;","⌭":"&cylcty;","⥥":"&dHar;","†":"&dagger;","ℸ":"&daleth;","‐":"&hyphen;","⤏":"&rBarr;","ď":"&dcaron;","д":"&dcy;","⇊":"&downdownarrows;","⩷":"&eDDot;","°":"&deg;","δ":"&delta;","⦱":"&demptyv;","⥿":"&dfisht;","𝔡":"&dfr;","♦":"&diams;","ϝ":"&gammad;","⋲":"&disin;","÷":"&divide;","⋇":"&divonx;","ђ":"&djcy;","⌞":"&llcorner;","⌍":"&dlcrop;",$:"&dollar;","𝕕":"&dopf;","≑":"&eDot;","∸":"&minusd;","∔":"&plusdo;","⊡":"&sdotb;","⌟":"&lrcorner;","⌌":"&drcrop;","𝒹":"&dscr;","ѕ":"&dscy;","⧶":"&dsol;","đ":"&dstrok;","⋱":"&dtdot;","▿":"&triangledown;","⦦":"&dwangle;","џ":"&dzcy;","⟿":"&dzigrarr;","é":"&eacute;","⩮":"&easter;","ě":"&ecaron;","≖":"&eqcirc;","ê":"&ecirc;","≕":"&eqcolon;","э":"&ecy;","ė":"&edot;","≒":"&fallingdotseq;","𝔢":"&efr;","⪚":"&eg;","è":"&egrave;","⪖":"&eqslantgtr;","⪘":"&egsdot;","⪙":"&el;","⏧":"&elinters;","ℓ":"&ell;","⪕":"&eqslantless;","⪗":"&elsdot;","ē":"&emacr;","∅":"&varnothing;"," ":"&emsp13;"," ":"&emsp14;"," ":"&emsp;","ŋ":"&eng;"," ":"&ensp;","ę":"&eogon;","𝕖":"&eopf;","⋕":"&epar;","⧣":"&eparsl;","⩱":"&eplus;","ε":"&epsilon;","ϵ":"&varepsilon;","=":"&equals;","≟":"&questeq;","⩸":"&equivDD;","⧥":"&eqvparsl;","≓":"&risingdotseq;","⥱":"&erarr;","ℯ":"&escr;","η":"&eta;","ð":"&eth;","ë":"&euml;","€":"&euro;","!":"&excl;","ф":"&fcy;","♀":"&female;","ﬃ":"&ffilig;","ﬀ":"&fflig;","ﬄ":"&ffllig;","𝔣":"&ffr;","ﬁ":"&filig;",fj:"&fjlig;","♭":"&flat;","ﬂ":"&fllig;","▱":"&fltns;","ƒ":"&fnof;","𝕗":"&fopf;","⋔":"&pitchfork;","⫙":"&forkv;","⨍":"&fpartint;","½":"&half;","⅓":"&frac13;","¼":"&frac14;","⅕":"&frac15;","⅙":"&frac16;","⅛":"&frac18;","⅔":"&frac23;","⅖":"&frac25;","¾":"&frac34;","⅗":"&frac35;","⅜":"&frac38;","⅘":"&frac45;","⅚":"&frac56;","⅝":"&frac58;","⅞":"&frac78;","⁄":"&frasl;","⌢":"&sfrown;","𝒻":"&fscr;","⪌":"&gtreqqless;","ǵ":"&gacute;","γ":"&gamma;","⪆":"&gtrapprox;","ğ":"&gbreve;","ĝ":"&gcirc;","г":"&gcy;","ġ":"&gdot;","⪩":"&gescc;","⪀":"&gesdot;","⪂":"&gesdoto;","⪄":"&gesdotol;","⋛︀":"&gesl;","⪔":"&gesles;","𝔤":"&gfr;","ℷ":"&gimel;","ѓ":"&gjcy;","⪒":"&glE;","⪥":"&gla;","⪤":"&glj;","≩":"&gneqq;","⪊":"&gnapprox;","⪈":"&gneq;","⋧":"&gnsim;","𝕘":"&gopf;","ℊ":"&gscr;","⪎":"&gsime;","⪐":"&gsiml;","⪧":"&gtcc;","⩺":"&gtcir;","⋗":"&gtrdot;","⦕":"&gtlPar;","⩼":"&gtquest;","⥸":"&gtrarr;","≩︀":"&gvnE;","ъ":"&hardcy;","⥈":"&harrcir;","↭":"&leftrightsquigarrow;","ℏ":"&plankv;","ĥ":"&hcirc;","♥":"&heartsuit;","…":"&mldr;","⊹":"&hercon;","𝔥":"&hfr;","⤥":"&searhk;","⤦":"&swarhk;","⇿":"&hoarr;","∻":"&homtht;","↩":"&larrhk;","↪":"&rarrhk;","𝕙":"&hopf;","―":"&horbar;","𝒽":"&hscr;","ħ":"&hstrok;","⁃":"&hybull;","í":"&iacute;","î":"&icirc;","и":"&icy;","е":"&iecy;","¡":"&iexcl;","𝔦":"&ifr;","ì":"&igrave;","⨌":"&qint;","∭":"&tint;","⧜":"&iinfin;","℩":"&iiota;","ĳ":"&ijlig;","ī":"&imacr;","ı":"&inodot;","⊷":"&imof;","Ƶ":"&imped;","℅":"&incare;","∞":"&infin;","⧝":"&infintie;","⊺":"&intercal;","⨗":"&intlarhk;","⨼":"&iprod;","ё":"&iocy;","į":"&iogon;","𝕚":"&iopf;","ι":"&iota;","¿":"&iquest;","𝒾":"&iscr;","⋹":"&isinE;","⋵":"&isindot;","⋴":"&isins;","⋳":"&isinsv;","ĩ":"&itilde;","і":"&iukcy;","ï":"&iuml;","ĵ":"&jcirc;","й":"&jcy;","𝔧":"&jfr;","ȷ":"&jmath;","𝕛":"&jopf;","𝒿":"&jscr;","ј":"&jsercy;","є":"&jukcy;","κ":"&kappa;","ϰ":"&varkappa;","ķ":"&kcedil;","к":"&kcy;","𝔨":"&kfr;","ĸ":"&kgreen;","х":"&khcy;","ќ":"&kjcy;","𝕜":"&kopf;","𝓀":"&kscr;","⤛":"&lAtail;","⤎":"&lBarr;","⪋":"&lesseqqgtr;","⥢":"&lHar;","ĺ":"&lacute;","⦴":"&laemptyv;","λ":"&lambda;","⦑":"&langd;","⪅":"&lessapprox;","«":"&laquo;","⤟":"&larrbfs;","⤝":"&larrfs;","↫":"&looparrowleft;","⤹":"&larrpl;","⥳":"&larrsim;","↢":"&leftarrowtail;","⪫":"&lat;","⤙":"&latail;","⪭":"&late;","⪭︀":"&lates;","⤌":"&lbarr;","❲":"&lbbrk;","{":"&lcub;","[":"&lsqb;","⦋":"&lbrke;","⦏":"&lbrksld;","⦍":"&lbrkslu;","ľ":"&lcaron;","ļ":"&lcedil;","л":"&lcy;","⤶":"&ldca;","⥧":"&ldrdhar;","⥋":"&ldrushar;","↲":"&ldsh;","≤":"&leq;","⇇":"&llarr;","⋋":"&lthree;","⪨":"&lescc;","⩿":"&lesdot;","⪁":"&lesdoto;","⪃":"&lesdotor;","⋚︀":"&lesg;","⪓":"&lesges;","⋖":"&ltdot;","⥼":"&lfisht;","𝔩":"&lfr;","⪑":"&lgE;","⥪":"&lharul;","▄":"&lhblk;","љ":"&ljcy;","⥫":"&llhard;","◺":"&lltri;","ŀ":"&lmidot;","⎰":"&lmoustache;","≨":"&lneqq;","⪉":"&lnapprox;","⪇":"&lneq;","⋦":"&lnsim;","⟬":"&loang;","⇽":"&loarr;","⟼":"&xmap;","↬":"&rarrlp;","⦅":"&lopar;","𝕝":"&lopf;","⨭":"&loplus;","⨴":"&lotimes;","∗":"&lowast;","◊":"&lozenge;","(":"&lpar;","⦓":"&lparlt;","⥭":"&lrhard;","‎":"&lrm;","⊿":"&lrtri;","‹":"&lsaquo;","𝓁":"&lscr;","⪍":"&lsime;","⪏":"&lsimg;","‚":"&sbquo;","ł":"&lstrok;","⪦":"&ltcc;","⩹":"&ltcir;","⋉":"&ltimes;","⥶":"&ltlarr;","⩻":"&ltquest;","⦖":"&ltrPar;","◃":"&triangleleft;","⥊":"&lurdshar;","⥦":"&luruhar;","≨︀":"&lvnE;","∺":"&mDDot;","¯":"&strns;","♂":"&male;","✠":"&maltese;","▮":"&marker;","⨩":"&mcomma;","м":"&mcy;","—":"&mdash;","𝔪":"&mfr;","℧":"&mho;","µ":"&micro;","⫰":"&midcir;","−":"&minus;","⨪":"&minusdu;","⫛":"&mlcp;","⊧":"&models;","𝕞":"&mopf;","𝓂":"&mscr;","μ":"&mu;","⊸":"&mumap;","⋙̸":"&nGg;","≫⃒":"&nGt;","⇍":"&nlArr;","⇎":"&nhArr;","⋘̸":"&nLl;","≪⃒":"&nLt;","⇏":"&nrArr;","⊯":"&nVDash;","⊮":"&nVdash;","ń":"&nacute;","∠⃒":"&nang;","⩰̸":"&napE;","≋̸":"&napid;","ŉ":"&napos;","♮":"&natural;","⩃":"&ncap;","ň":"&ncaron;","ņ":"&ncedil;","⩭̸":"&ncongdot;","⩂":"&ncup;","н":"&ncy;","–":"&ndash;","⇗":"&neArr;","⤤":"&nearhk;","≐̸":"&nedot;","⤨":"&toea;","𝔫":"&nfr;","↮":"&nleftrightarrow;","⫲":"&nhpar;","⋼":"&nis;","⋺":"&nisd;","њ":"&njcy;","≦̸":"&nleqq;","↚":"&nleftarrow;","‥":"&nldr;","𝕟":"&nopf;","¬":"&not;","⋹̸":"&notinE;","⋵̸":"&notindot;","⋷":"&notinvb;","⋶":"&notinvc;","⋾":"&notnivb;","⋽":"&notnivc;","⫽⃥":"&nparsl;","∂̸":"&npart;","⨔":"&npolint;","↛":"&nrightarrow;","⤳̸":"&nrarrc;","↝̸":"&nrarrw;","𝓃":"&nscr;","⊄":"&nsub;","⫅̸":"&nsubseteqq;","⊅":"&nsup;","⫆̸":"&nsupseteqq;","ñ":"&ntilde;","ν":"&nu;","#":"&num;","№":"&numero;"," ":"&numsp;","⊭":"&nvDash;","⤄":"&nvHarr;","≍⃒":"&nvap;","⊬":"&nvdash;","≥⃒":"&nvge;",">⃒":"&nvgt;","⧞":"&nvinfin;","⤂":"&nvlArr;","≤⃒":"&nvle;","<⃒":"&nvlt;","⊴⃒":"&nvltrie;","⤃":"&nvrArr;","⊵⃒":"&nvrtrie;","∼⃒":"&nvsim;","⇖":"&nwArr;","⤣":"&nwarhk;","⤧":"&nwnear;","ó":"&oacute;","ô":"&ocirc;","о":"&ocy;","ő":"&odblac;","⨸":"&odiv;","⦼":"&odsold;","œ":"&oelig;","⦿":"&ofcir;","𝔬":"&ofr;","˛":"&ogon;","ò":"&ograve;","⧁":"&ogt;","⦵":"&ohbar;","⦾":"&olcir;","⦻":"&olcross;","⧀":"&olt;","ō":"&omacr;","ω":"&omega;","ο":"&omicron;","⦶":"&omid;","𝕠":"&oopf;","⦷":"&opar;","⦹":"&operp;","∨":"&vee;","⩝":"&ord;","ℴ":"&oscr;","ª":"&ordf;","º":"&ordm;","⊶":"&origof;","⩖":"&oror;","⩗":"&orslope;","⩛":"&orv;","ø":"&oslash;","⊘":"&osol;","õ":"&otilde;","⨶":"&otimesas;","ö":"&ouml;","⌽":"&ovbar;","¶":"&para;","⫳":"&parsim;","⫽":"&parsl;","п":"&pcy;","%":"&percnt;",".":"&period;","‰":"&permil;","‱":"&pertenk;","𝔭":"&pfr;","φ":"&phi;","ϕ":"&varphi;","☎":"&phone;","π":"&pi;","ϖ":"&varpi;","ℎ":"&planckh;","+":"&plus;","⨣":"&plusacir;","⨢":"&pluscir;","⨥":"&plusdu;","⩲":"&pluse;","⨦":"&plussim;","⨧":"&plustwo;","⨕":"&pointint;","𝕡":"&popf;","£":"&pound;","⪳":"&prE;","⪷":"&precapprox;","⪹":"&prnap;","⪵":"&prnE;","⋨":"&prnsim;","′":"&prime;","⌮":"&profalar;","⌒":"&profline;","⌓":"&profsurf;","⊰":"&prurel;","𝓅":"&pscr;","ψ":"&psi;"," ":"&puncsp;","𝔮":"&qfr;","𝕢":"&qopf;","⁗":"&qprime;","𝓆":"&qscr;","⨖":"&quatint;","?":"&quest;","⤜":"&rAtail;","⥤":"&rHar;","∽̱":"&race;","ŕ":"&racute;","⦳":"&raemptyv;","⦒":"&rangd;","⦥":"&range;","»":"&raquo;","⥵":"&rarrap;","⤠":"&rarrbfs;","⤳":"&rarrc;","⤞":"&rarrfs;","⥅":"&rarrpl;","⥴":"&rarrsim;","↣":"&rightarrowtail;","↝":"&rightsquigarrow;","⤚":"&ratail;","∶":"&ratio;","❳":"&rbbrk;","}":"&rcub;","]":"&rsqb;","⦌":"&rbrke;","⦎":"&rbrksld;","⦐":"&rbrkslu;","ř":"&rcaron;","ŗ":"&rcedil;","р":"&rcy;","⤷":"&rdca;","⥩":"&rdldhar;","↳":"&rdsh;","▭":"&rect;","⥽":"&rfisht;","𝔯":"&rfr;","⥬":"&rharul;","ρ":"&rho;","ϱ":"&varrho;","⇉":"&rrarr;","⋌":"&rthree;","˚":"&ring;","‏":"&rlm;","⎱":"&rmoustache;","⫮":"&rnmid;","⟭":"&roang;","⇾":"&roarr;","⦆":"&ropar;","𝕣":"&ropf;","⨮":"&roplus;","⨵":"&rotimes;",")":"&rpar;","⦔":"&rpargt;","⨒":"&rppolint;","›":"&rsaquo;","𝓇":"&rscr;","⋊":"&rtimes;","▹":"&triangleright;","⧎":"&rtriltri;","⥨":"&ruluhar;","℞":"&rx;","ś":"&sacute;","⪴":"&scE;","⪸":"&succapprox;","š":"&scaron;","ş":"&scedil;","ŝ":"&scirc;","⪶":"&succneqq;","⪺":"&succnapprox;","⋩":"&succnsim;","⨓":"&scpolint;","с":"&scy;","⋅":"&sdot;","⩦":"&sdote;","⇘":"&seArr;","§":"&sect;",";":"&semi;","⤩":"&tosa;","✶":"&sext;","𝔰":"&sfr;","♯":"&sharp;","щ":"&shchcy;","ш":"&shcy;","­":"&shy;","σ":"&sigma;","ς":"&varsigma;","⩪":"&simdot;","⪞":"&simg;","⪠":"&simgE;","⪝":"&siml;","⪟":"&simlE;","≆":"&simne;","⨤":"&simplus;","⥲":"&simrarr;","⨳":"&smashp;","⧤":"&smeparsl;","⌣":"&ssmile;","⪪":"&smt;","⪬":"&smte;","⪬︀":"&smtes;","ь":"&softcy;","/":"&sol;","⧄":"&solb;","⌿":"&solbar;","𝕤":"&sopf;","♠":"&spadesuit;","⊓︀":"&sqcaps;","⊔︀":"&sqcups;","𝓈":"&sscr;","☆":"&star;","⊂":"&subset;","⫅":"&subseteqq;","⪽":"&subdot;","⫃":"&subedot;","⫁":"&submult;","⫋":"&subsetneqq;","⊊":"&subsetneq;","⪿":"&subplus;","⥹":"&subrarr;","⫇":"&subsim;","⫕":"&subsub;","⫓":"&subsup;","♪":"&sung;","¹":"&sup1;","²":"&sup2;","³":"&sup3;","⫆":"&supseteqq;","⪾":"&supdot;","⫘":"&supdsub;","⫄":"&supedot;","⟉":"&suphsol;","⫗":"&suphsub;","⥻":"&suplarr;","⫂":"&supmult;","⫌":"&supsetneqq;","⊋":"&supsetneq;","⫀":"&supplus;","⫈":"&supsim;","⫔":"&supsub;","⫖":"&supsup;","⇙":"&swArr;","⤪":"&swnwar;","ß":"&szlig;","⌖":"&target;","τ":"&tau;","ť":"&tcaron;","ţ":"&tcedil;","т":"&tcy;","⌕":"&telrec;","𝔱":"&tfr;","θ":"&theta;","ϑ":"&vartheta;","þ":"&thorn;","×":"&times;","⨱":"&timesbar;","⨰":"&timesd;","⌶":"&topbot;","⫱":"&topcir;","𝕥":"&topf;","⫚":"&topfork;","‴":"&tprime;","▵":"&utri;","≜":"&trie;","◬":"&tridot;","⨺":"&triminus;","⨹":"&triplus;","⧍":"&trisb;","⨻":"&tritime;","⏢":"&trpezium;","𝓉":"&tscr;","ц":"&tscy;","ћ":"&tshcy;","ŧ":"&tstrok;","⥣":"&uHar;","ú":"&uacute;","ў":"&ubrcy;","ŭ":"&ubreve;","û":"&ucirc;","у":"&ucy;","ű":"&udblac;","⥾":"&ufisht;","𝔲":"&ufr;","ù":"&ugrave;","▀":"&uhblk;","⌜":"&ulcorner;","⌏":"&ulcrop;","◸":"&ultri;","ū":"&umacr;","ų":"&uogon;","𝕦":"&uopf;","υ":"&upsilon;","⇈":"&uuarr;","⌝":"&urcorner;","⌎":"&urcrop;","ů":"&uring;","◹":"&urtri;","𝓊":"&uscr;","⋰":"&utdot;","ũ":"&utilde;","ü":"&uuml;","⦧":"&uwangle;","⫨":"&vBar;","⫩":"&vBarv;","⦜":"&vangrt;","⊊︀":"&vsubne;","⫋︀":"&vsubnE;","⊋︀":"&vsupne;","⫌︀":"&vsupnE;","в":"&vcy;","⊻":"&veebar;","≚":"&veeeq;","⋮":"&vellip;","𝔳":"&vfr;","𝕧":"&vopf;","𝓋":"&vscr;","⦚":"&vzigzag;","ŵ":"&wcirc;","⩟":"&wedbar;","≙":"&wedgeq;","℘":"&wp;","𝔴":"&wfr;","𝕨":"&wopf;","𝓌":"&wscr;","𝔵":"&xfr;","ξ":"&xi;","⋻":"&xnis;","𝕩":"&xopf;","𝓍":"&xscr;","ý":"&yacute;","я":"&yacy;","ŷ":"&ycirc;","ы":"&ycy;","¥":"&yen;","𝔶":"&yfr;","ї":"&yicy;","𝕪":"&yopf;","𝓎":"&yscr;","ю":"&yucy;","ÿ":"&yuml;","ź":"&zacute;","ž":"&zcaron;","з":"&zcy;","ż":"&zdot;","ζ":"&zeta;","𝔷":"&zfr;","ж":"&zhcy;","⇝":"&zigrarr;","𝕫":"&zopf;","𝓏":"&zscr;","‍":"&zwj;","‌":"&zwnj;"}}};

/***/ }),

/***/ 11946:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:true}));exports.numericUnicodeMap={0:65533,128:8364,130:8218,131:402,132:8222,133:8230,134:8224,135:8225,136:710,137:8240,138:352,139:8249,140:338,142:381,145:8216,146:8217,147:8220,148:8221,149:8226,150:8211,151:8212,152:732,153:8482,154:353,155:8250,156:339,158:382,159:376};

/***/ }),

/***/ 4265:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
Object.defineProperty(exports, "__esModule", ({value:true}));exports.fromCodePoint=String.fromCodePoint||function(astralCodePoint){return String.fromCharCode(Math.floor((astralCodePoint-65536)/1024)+55296,(astralCodePoint-65536)%1024+56320)};exports.getCodePoint=String.prototype.codePointAt?function(input,position){return input.codePointAt(position)}:function(input,position){return(input.charCodeAt(position)-55296)*1024+input.charCodeAt(position+1)-56320+65536};exports.highSurrogateFrom=55296;exports.highSurrogateTo=56319;

/***/ }),

/***/ 14383:
/***/ (function(module) {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.abs;


/***/ }),

/***/ 45736:
/***/ (function(module) {

"use strict";


/** @type {import('./floor')} */
module.exports = Math.floor;


/***/ }),

/***/ 68806:
/***/ (function(module) {

"use strict";


/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),

/***/ 27130:
/***/ (function(module) {

"use strict";


/** @type {import('./max')} */
module.exports = Math.max;


/***/ }),

/***/ 22400:
/***/ (function(module) {

"use strict";


/** @type {import('./min')} */
module.exports = Math.min;


/***/ }),

/***/ 23654:
/***/ (function(module) {

"use strict";


/** @type {import('./pow')} */
module.exports = Math.pow;


/***/ }),

/***/ 96890:
/***/ (function(module) {

"use strict";


/** @type {import('./round')} */
module.exports = Math.round;


/***/ }),

/***/ 82026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(68806);

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};


/***/ }),

/***/ 38002:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ withUrqlClient; }
});

// UNUSED EXPORTS: initUrqlClient

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/react-ssr-prepass/dist/react-ssr-prepass.es.js


function _extends() {
  _extends = Object.assign || function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t) {
        if (Object.prototype.hasOwnProperty.call(t, n)) {
          e[n] = t[n];
        }
      }
    }
    return e;
  };
  return _extends.apply(this, arguments);
}

var n = 60103;

var u = 60106;

var o = 60107;

var a = 60108;

var i = 60114;

var c = 60109;

var l = 60110;

var f = 60111;

var s = 60112;

var v = 60113;

var p = 60115;

var d = 60116;

if ("function" == typeof Symbol && Symbol.for) {
  var m = Symbol.for;
  n = m("react.element");
  u = m("react.portal");
  o = m("react.fragment");
  a = m("react.strict_mode");
  i = m("react.profiler");
  c = m("react.provider");
  l = m("react.context");
  f = Symbol.for("react.concurrent_mode");
  s = m("react.forward_ref");
  v = m("react.suspense");
  p = m("react.memo");
  d = m("react.lazy");
}

var h = n;

var y = u;

var _ = o;

var S = a;

var x = i;

var b = c;

var M = l;

var g = f;

var k = s;

var w = v;

var F = p;

var I = d;

var q = react.Children.toArray;

var isAbstractElement = function(e) {
  return null !== e && "object" == typeof e;
};

var getChildrenArray = function(e) {
  return q(e).filter(isAbstractElement);
};

var computeProps = function(e, r) {
  return "object" == typeof r ? _extends({}, r, e) : e;
};

var E = new Map;

var C = {};

var D = void 0;

var P = void 0;

var getCurrentContextMap = function() {
  return _extends({}, C);
};

var getCurrentContextStore = function() {
  return new Map(E);
};

var flushPrevContextMap = function() {
  var e = D;
  D = void 0;
  return e;
};

var flushPrevContextStore = function() {
  var e = P;
  P = void 0;
  return e;
};

var restoreContextMap = function(e) {
  if (void 0 !== e) {
    _extends(C, e);
  }
};

var restoreContextStore = function(e) {
  if (void 0 !== e) {
    E.set(e[0], e[1]);
  }
};

var setCurrentContextMap = function(e) {
  D = void 0;
  C = e;
};

var setCurrentContextStore = function(e) {
  P = void 0;
  E = e;
};

var readContextValue = function(e) {
  var r = E.get(e);
  if (void 0 !== r) {
    return r;
  }
  return e._currentValue;
};

var R = {};

var maskContext = function(e) {
  var r = e.contextType;
  var t = e.contextTypes;
  if (r) {
    return readContextValue(r);
  } else if (!t) {
    return R;
  }
  var n = {};
  for (var u in t) {
    n[u] = C[u];
  }
  return n;
};

var z = null;

var getCurrentErrorFrame = function() {
  return z;
};

var setCurrentErrorFrame = function(e) {
  z = e || null;
};

var O = {
  current: {
    uniqueID: 0
  }
};

var W = "function" == typeof Object.is ? Object.is : function is(e, r) {
  return e === r && (0 !== e || 1 / e == 1 / r) || e != e && r != r;
};

var j = null;

var setCurrentIdentity = function(e) {
  j = e;
};

var getCurrentIdentity = function() {
  if (null === j) {
    throw new Error("[react-ssr-prepass] Hooks can only be called inside the body of a function component. (https://fb.me/react-invalid-hook-call)");
  }
  return j;
};

var H = null;

var T = null;

var U = !1;

var $ = null;

var A = 0;

var setFirstHook = function(e) {
  H = e;
};

function createWorkInProgressHook() {
  if (null === T) {
    if (null === H) {
      return H = T = {
        memoizedState: null,
        queue: null,
        next: null
      };
    } else {
      return T = H;
    }
  } else if (null === T.next) {
    return T = T.next = {
      memoizedState: null,
      queue: null,
      next: null
    };
  } else {
    return T = T.next;
  }
}

function basicStateReducer(e, r) {
  return "function" == typeof r ? r(e) : r;
}

function useReducer(e, r, t) {
  var n = getCurrentIdentity();
  if (null === (T = createWorkInProgressHook()).queue) {
    var u;
    if (e === basicStateReducer) {
      u = "function" == typeof r ? r() : r;
    } else {
      u = void 0 !== t ? t(r) : r;
    }
    T.memoizedState = u;
  }
  var o = T.queue || (T.queue = {
    last: null,
    dispatch: null
  });
  var a = o.dispatch || (o.dispatch = dispatchAction.bind(null, n, o));
  if (null !== $) {
    var i = $.get(o);
    if (void 0 !== i) {
      $.delete(o);
      var c = T.memoizedState;
      var l = i;
      do {
        c = e(c, l.action);
        l = l.next;
      } while (null !== l);
      T.memoizedState = c;
    }
  }
  return [ T.memoizedState, a ];
}

function useMemo(e, r) {
  getCurrentIdentity();
  var t = void 0 === r ? null : r;
  var n = (T = createWorkInProgressHook()).memoizedState;
  if (null !== n && null !== t) {
    if (function areHookInputsEqual(e, r) {
      if (null === r) {
        return !1;
      }
      for (var t = 0; t < r.length && t < e.length; t++) {
        if (!W(e[t], r[t])) {
          return !1;
        }
      }
      return !0;
    }(t, n[1])) {
      return n[0];
    }
  }
  var u = e();
  T.memoizedState = [ u, t ];
  return u;
}

function useOpaqueIdentifier() {
  getCurrentIdentity();
  if (!(T = createWorkInProgressHook()).memoizedState) {
    T.memoizedState = "R:" + (O.current.uniqueID++).toString(36);
  }
  return T.memoizedState;
}

function dispatchAction(e, r, t) {
  if (e === j) {
    U = !0;
    var n = {
      action: t,
      next: null
    };
    if (null === $) {
      $ = new Map;
    }
    var u = $.get(r);
    if (void 0 === u) {
      $.set(r, n);
    } else {
      var o = u;
      while (null !== o.next) {
        o = o.next;
      }
      o.next = n;
    }
  }
}

function noop() {}

function _ref$2(e) {
  e();
}

var N = {
  readContext: function readContext(e, r) {
    return readContextValue(e);
  },
  useSyncExternalStore: function useSyncExternalStore(e, r, t) {
    return r();
  },
  useContext: function useContext(e, r) {
    getCurrentIdentity();
    return readContextValue(e);
  },
  useMemo: useMemo,
  useReducer: useReducer,
  useRef: function useRef(e) {
    getCurrentIdentity();
    var r = (T = createWorkInProgressHook()).memoizedState;
    if (null === r) {
      var t = {
        current: e
      };
      T.memoizedState = t;
      return t;
    } else {
      return r;
    }
  },
  useState: function useState(e) {
    return useReducer(basicStateReducer, e);
  },
  useCallback: function useCallback(e, r) {
    return useMemo((function() {
      return e;
    }), r);
  },
  useMutableSource: function useMutableSource(e, r, t) {
    getCurrentIdentity();
    return r(e._source);
  },
  useTransition: function useTransition() {
    return [ _ref$2, !1 ];
  },
  useDeferredValue: function useDeferredValue(e) {
    return e;
  },
  useOpaqueIdentifier: useOpaqueIdentifier,
  useId: useOpaqueIdentifier,
  unstable_useId: useOpaqueIdentifier,
  unstable_useOpaqueIdentifier: useOpaqueIdentifier,
  useLayoutEffect: noop,
  useImperativeHandle: noop,
  useEffect: noop,
  useDebugValue: noop
};

var resolve = function(e) {
  var r = e._payload || e;
  if (0 === r._status) {
    return r._result;
  } else if (1 === r._status) {
    return Promise.resolve(r._result);
  } else if (2 === r._status) {
    return Promise.reject(r._result);
  }
  r._status = 0;
  return r._result = (r._ctor || r._result)().then((function(e) {
    r._result = e;
    if ("function" == typeof e) {
      r._status = 1;
    } else if (null !== e && "object" == typeof e && "function" == typeof e.default) {
      r._result = e.default;
      r._status = 1;
    } else {
      r._status = 2;
    }
  })).catch((function(e) {
    r._status = 2;
    r._result = e;
    return Promise.reject(e);
  }));
};

var render$3 = function(e, r, n) {
  var u = e._payload || e;
  if (1 === u._status) {
    return (0,react.createElement)(u._result, r);
  }
  return null;
};

var makeFrame$1 = function(e, r, t) {
  return {
    contextMap: getCurrentContextMap(),
    contextStore: getCurrentContextStore(),
    id: getCurrentIdentity(),
    hook: H,
    kind: "frame.hooks",
    errorFrame: getCurrentErrorFrame(),
    thenable: t,
    props: r,
    type: e
  };
};

var render$2 = function(e, r, t) {
  try {
    return function renderWithHooks(e, r, t) {
      T = null;
      var n = e(r, t);
      while (A < 25 && U) {
        U = !1;
        A += 1;
        T = null;
        n = e(r, t);
      }
      A = 0;
      $ = null;
      T = null;
      return n;
    }(e, computeProps(r, e.defaultProps), maskContext(e));
  } catch (n) {
    if ("function" != typeof n.then) {
      throw n;
    }
    t.push(makeFrame$1(e, r, n));
    return null;
  }
};

function _ref$1() {
  return !1;
}

function _ref2() {
  return null;
}

var createInstance = function(e, r) {
  var t = {
    _thrown: 0,
    queue: n = [],
    isMounted: _ref$1,
    enqueueForceUpdate: _ref2,
    enqueueReplaceState: function(e, r) {
      if (e._isMounted) {
        n.length = 0;
        n.push(r);
      }
    },
    enqueueSetState: function(e, r) {
      if (e._isMounted) {
        n.push(r);
      }
    }
  };
  var n;
  var u = computeProps(r, e.defaultProps);
  var o = maskContext(e);
  var a = new e(u, o, t);
  a.props = u;
  a.context = o;
  a.updater = t;
  a._isMounted = !0;
  if (void 0 === a.state) {
    a.state = null;
  }
  if ("function" == typeof a.componentDidCatch || "function" == typeof e.getDerivedStateFromError) {
    var i = makeFrame(e, a, null);
    i.errorFrame = i;
    setCurrentErrorFrame(i);
  }
  if ("function" == typeof e.getDerivedStateFromProps) {
    var c = (0, e.getDerivedStateFromProps)(a.props, a.state);
    if (null != c) {
      a.state = _extends({}, a.state, c);
    }
  } else if ("function" == typeof a.componentWillMount) {
    a.componentWillMount();
  } else if ("function" == typeof a.UNSAFE_componentWillMount) {
    a.UNSAFE_componentWillMount();
  }
  return a;
};

var makeFrame = function(e, r, t) {
  return {
    contextMap: getCurrentContextMap(),
    contextStore: getCurrentContextStore(),
    errorFrame: getCurrentErrorFrame(),
    thenable: t,
    kind: "frame.class",
    error: null,
    instance: r,
    type: e
  };
};

var render$1 = function(e, r, t) {
  !function(e) {
    var r = e.updater.queue;
    if (r.length > 0) {
      var t = _extends({}, e.state);
      for (var n = 0, u = r.length; n < u; n++) {
        var o = r[n];
        var a = "function" == typeof o ? o.call(e, t, e.props, e.context) : o;
        if (null !== a) {
          _extends(t, a);
        }
      }
      e.state = t;
      r.length = 0;
    }
  }(r);
  var n = null;
  try {
    n = r.render();
  } catch (n) {
    if ("function" != typeof n.then) {
      throw n;
    }
    t.push(makeFrame(e, r, n));
    return null;
  }
  if (void 0 !== e.childContextTypes && "function" == typeof r.getChildContext) {
    var u = r.getChildContext();
    if (null !== u && "object" == typeof u) {
      !function(e) {
        D = {};
        for (var r in e) {
          D[r] = C[r];
          C[r] = e[r];
        }
      }(u);
    }
  }
  if ("function" != typeof r.getDerivedStateFromProps && ("function" == typeof r.componentWillMount || "function" == typeof r.UNSAFE_componentWillMount) && "function" == typeof r.componentWillUnmount) {
    try {
      r.componentWillUnmount();
    } catch (e) {}
  }
  r._isMounted = !1;
  return n;
};

var L = react.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;

var V = "function" == typeof setImmediate;

var render = function(e, r, t, n, u) {
  return (o = e).prototype && o.prototype.isReactComponent ? function(e, r, t, n, u) {
    setCurrentIdentity(null);
    var o = createInstance(e, r);
    var a = n(u, o);
    if (a) {
      t.push(makeFrame(e, o, a));
      return null;
    }
    return render$1(e, o, t);
  }(e, r, t, n, u) : function(e, r, t, n, u) {
    setFirstHook(null);
    setCurrentIdentity({});
    var o = n(u);
    if (o) {
      t.push(makeFrame$1(e, r, o));
      return null;
    }
    return render$2(e, r, t);
  }(e, r, t, n, u);
  var o;
};

var visitElement = function(e, r, n) {
  switch (function(e) {
    switch (e.$$typeof) {
     case y:
      return y;

     case h:
      switch (e.type) {
       case g:
        return g;

       case _:
        return _;

       case x:
        return x;

       case S:
        return S;

       case w:
        return w;

       default:
        switch (e.type && e.type.$$typeof) {
         case I:
          return I;

         case F:
          return F;

         case M:
          return M;

         case b:
          return b;

         case k:
          return k;

         default:
          return h;
        }
      }

     default:
      return;
    }
  }(e)) {
   case w:
   case S:
   case g:
   case x:
   case _:
    return getChildrenArray(e.props.children);

   case b:
    var u = e.props;
    var o = u.children;
    !function(e, r) {
      P = [ e, E.get(e) ];
      E.set(e, r);
    }(e.type._context, u.value);
    return getChildrenArray(o);

   case M:
    var a = e.props.children;
    if ("function" == typeof a) {
      var i = e.type;
      var c = readContextValue("object" == typeof i._context ? i._context : i);
      return getChildrenArray(a(c));
    } else {
      return [];
    }

   case I:
    var l = function(e, r, t) {
      if ((e._payload || e)._status <= 0) {
        t.push({
          kind: "frame.lazy",
          contextMap: getCurrentContextMap(),
          contextStore: getCurrentContextStore(),
          errorFrame: getCurrentErrorFrame(),
          thenable: resolve(e),
          props: r,
          type: e
        });
        return null;
      }
      return render$3(e, r);
    }(e.type, e.props, r);
    return getChildrenArray(l);

   case F:
    var f = (0,react.createElement)(e.type.type, e.props);
    return getChildrenArray(f);

   case k:
    var s = e.type;
    var v = s.render;
    var p = computeProps(e.props, s.defaultProps);
    var d = (0,react.createElement)(v, p);
    return getChildrenArray(d);

   case h:
    if ("string" == typeof e.type) {
      return getChildrenArray(e.props.children);
    } else {
      var m = render(e.type, e.props, r, n, e);
      return getChildrenArray(m);
    }

   default:
    return [];
  }
};

var visitLoop = function(e, r, t, n, u, o) {
  var a = L.current;
  var i = Date.now();
  try {
    L.current = N;
    while (e.length > 0) {
      var c = e[e.length - 1].shift();
      if (void 0 !== c) {
        var l = visitElement(c, u, o);
        e.push(l);
        r.push(flushPrevContextMap());
        t.push(flushPrevContextStore());
        n.push(getCurrentErrorFrame());
      } else {
        e.pop();
        restoreContextMap(r.pop());
        restoreContextStore(t.pop());
        setCurrentErrorFrame(n.pop());
      }
      if (V && Date.now() - i > 5) {
        return !0;
      }
    }
    return !1;
  } catch (e) {
    var f = getCurrentErrorFrame();
    if (!f) {
      throw e;
    }
    f.error = e;
    u.unshift(f);
    return !1;
  } finally {
    L.current = a;
  }
};

var makeYieldFrame = function(e, r, t, n) {
  return {
    contextMap: getCurrentContextMap(),
    contextStore: getCurrentContextStore(),
    errorFrame: getCurrentErrorFrame(),
    thenable: null,
    kind: "frame.yield",
    traversalChildren: e,
    traversalMap: r,
    traversalStore: t,
    traversalErrorFrame: n
  };
};

var visit = function(e, r, t) {
  var n = [ e ];
  var u = [ flushPrevContextMap() ];
  var o = [ flushPrevContextStore() ];
  var a = [ getCurrentErrorFrame() ];
  if (visitLoop(n, u, o, a, r, t)) {
    r.unshift(makeYieldFrame(n, u, o, a));
  }
};

var update = function(e, r, t) {
  if ("frame.yield" === e.kind) {
    setCurrentIdentity(null);
    setCurrentContextMap(e.contextMap);
    setCurrentContextStore(e.contextStore);
    setCurrentErrorFrame(e.errorFrame);
    if (visitLoop(e.traversalChildren, e.traversalMap, e.traversalStore, e.traversalErrorFrame, r, t)) {
      r.unshift(makeYieldFrame(e.traversalChildren, e.traversalMap, e.traversalStore, e.traversalErrorFrame));
    }
  } else {
    var n = L.current;
    var u = null;
    L.current = N;
    try {
      if ("frame.class" === e.kind) {
        u = function(e, r) {
          setCurrentIdentity(null);
          setCurrentContextMap(r.contextMap);
          setCurrentContextStore(r.contextStore);
          setCurrentErrorFrame(r.errorFrame);
          if (r.error) {
            if (++r.instance.updater._thrown >= 25) {
              return null;
            }
            r.instance._isMounted = !0;
            if ("function" == typeof r.instance.componentDidCatch) {
              r.instance.componentDidCatch(r.error);
            }
            if ("function" == typeof r.type.getDerivedStateFromError) {
              r.instance.updater.enqueueSetState(r.instance, r.type.getDerivedStateFromError(r.error));
            }
          }
          return render$1(r.type, r.instance, e);
        }(r, e);
      } else if ("frame.hooks" === e.kind) {
        u = function(e, r) {
          setFirstHook(r.hook);
          setCurrentIdentity(r.id);
          setCurrentContextMap(r.contextMap);
          setCurrentContextStore(r.contextStore);
          setCurrentErrorFrame(r.errorFrame);
          return render$2(r.type, r.props, e);
        }(r, e);
      } else if ("frame.lazy" === e.kind) {
        u = function(e, r) {
          setCurrentIdentity(null);
          setCurrentContextMap(r.contextMap);
          setCurrentContextStore(r.contextStore);
          setCurrentErrorFrame(r.errorFrame);
          return render$3(r.type, r.props);
        }(0, e);
      }
    } catch (e) {
      var o = getCurrentErrorFrame();
      if (!o) {
        throw e;
      }
      o.error = e;
      r.unshift(o);
      u = null;
    } finally {
      L.current = n;
    }
    visit(getChildrenArray(u), r, t);
  }
};

function _ref(e, r) {
  setImmediate(e);
}

var flushFrames = function(e, r, t) {
  var n = e.shift();
  if (!n) {
    return Promise.resolve();
  }
  if (V && "frame.yield" === n.kind) {
    n.thenable = new Promise(_ref);
  }
  return Promise.resolve(n.thenable).then((function() {
    !function(e) {
      O.current = e;
    }(t);
    update(n, e, r);
    return flushFrames(e, r, t);
  }), (function(t) {
    if (!n.errorFrame) {
      throw t;
    }
    n.errorFrame.error = t;
    update(n.errorFrame, e, r);
  }));
};

var defaultVisitor = function() {
  return;
};

var renderPrepass = function(e, r) {
  if (!r) {
    r = defaultVisitor;
  }
  var t = [];
  var n = O.current = {
    uniqueID: 0
  };
  setCurrentContextMap({});
  setCurrentContextStore(new Map);
  setCurrentErrorFrame(null);
  try {
    visit(getChildrenArray(e), t, r);
  } catch (e) {
    return Promise.reject(e);
  }
  return flushFrames(t, r, n);
};


//# sourceMappingURL=react-ssr-prepass.es.js.map

// EXTERNAL MODULE: ../../node_modules/urql/node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(54569);
// EXTERNAL MODULE: ../../node_modules/urql/dist/urql.es.js
var urql_es = __webpack_require__(26806);
// EXTERNAL MODULE: ../../node_modules/@urql/core/dist/urql-core.mjs
var dist_urql_core = __webpack_require__(93466);
;// CONCATENATED MODULE: ../../node_modules/next-urql/dist/next-urql.es.js








var next_urql_es_f = null;

function resetClient() {
  next_urql_es_f = null;
}

function initUrqlClient(e, t) {
  var r = "undefined" == typeof window;
  if (r || !next_urql_es_f) {
    (next_urql_es_f = (0,dist_urql_core/* createClient */.eI)({
      ...e,
      suspense: t && (r || e.suspense)
    })).toJSON = () => null;
  }
  return next_urql_es_f;
}

var next_urql_es_v;

function withUrqlClient(p, f) {
  if (!f) {
    f = {};
  }
  return d => {
    var q = Boolean((d.getInitialProps || f.ssr) && !f.neverSuspend);
    var WithUrql = ({pageProps: n, urqlClient: C, urqlState: g, ...w}) => {
      var [c, m] = (0,react.useReducer)((e => e + 1), 0);
      var h = n && n.urqlState || g;
      var y = (0,react.useMemo)((() => {
        if (C && !c) {
          return C;
        }
        if (!next_urql_es_v || "undefined" == typeof window) {
          next_urql_es_v = (0,urql_core/* ssrExchange */.$Y)({
            initialState: h,
            isClient: !0,
            staleWhileRevalidate: "undefined" != typeof window ? f.staleWhileRevalidate : void 0
          });
        } else if (!c) {
          next_urql_es_v.restoreData(h);
        }
        var e = p(next_urql_es_v);
        if (!e.exchanges) {
          e.exchanges = [ urql_core/* dedupExchange */.B5, urql_core/* cacheExchange */.HG, next_urql_es_v, urql_core/* fetchExchange */.Ek ];
        }
        return initUrqlClient(e, q);
      }), [ C, h, c ]);
      var S = (0,react.useCallback)((() => {
        resetClient();
        next_urql_es_v = (0,urql_core/* ssrExchange */.$Y)({
          initialState: void 0
        });
        m();
      }), []);
      return (0,react.createElement)(urql_es/* Provider */.zt, {
        value: y
      }, (0,react.createElement)(d, {
        ...w,
        pageProps: n,
        urqlClient: y,
        resetUrqlClient: S
      }));
    };
    WithUrql.displayName = `withUrqlClient(${d.displayName || d.name || "Component"})`;
    if (d.getLayout) {
      WithUrql.getLayout = d.getLayout;
    }
    if (d.getInitialProps || f.ssr) {
      WithUrql.getInitialProps = async t => {
        var r = t.AppTree;
        var i = !!t.Component;
        var u = i ? t.ctx : t;
        var v = (0,urql_core/* ssrExchange */.$Y)({
          initialState: void 0
        });
        var q = p(v, u);
        if (!q.exchanges) {
          q.exchanges = [ urql_core/* dedupExchange */.B5, urql_core/* cacheExchange */.HG, v, urql_core/* fetchExchange */.Ek ];
        }
        var C = initUrqlClient(q, !f.neverSuspend);
        if (C) {
          u.urqlClient = C;
        }
        var g = {};
        if (d.getInitialProps) {
          g = await d.getInitialProps(t);
          if (u.res && (u.res.writableEnded || u.res.finished)) {
            return {
              ...g,
              urqlClient: C
            };
          }
        }
        if ("undefined" != typeof window) {
          return {
            ...g,
            urqlClient: C
          };
        }
        var w = {
          ...g,
          urqlClient: C
        };
        var c = i ? {
          pageProps: {},
          ...w
        } : {
          pageProps: w
        };
        if (!f.neverSuspend) {
          await renderPrepass((0,react.createElement)(r, c));
        }
        return {
          ...g,
          urqlState: v ? v.extractData() : void 0,
          urqlClient: C
        };
      };
    }
    return WithUrql;
  };
}


//# sourceMappingURL=next-urql.es.js.map


/***/ }),

/***/ 12041:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(88381)


/***/ }),

/***/ 93542:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) == null ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) == null ? void 0 : ref1.env) === "object" ? __webpack_require__.g.process : __webpack_require__(60500);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 86570:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(77552);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77552:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ _app; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../packages/sdk/dist/index.mjs + 1 modules
var dist = __webpack_require__(80684);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/queryClient.mjs + 4 modules
var lib_queryClient = __webpack_require__(57634);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(55830);
// EXTERNAL MODULE: ../../node_modules/next-urql/dist/next-urql.es.js + 1 modules
var next_urql_es = __webpack_require__(38002);
// EXTERNAL MODULE: ../../node_modules/next/app.js
var app = __webpack_require__(12041);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js + 2 modules
var redux_saga_core_npm_proxy_esm = __webpack_require__(91199);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(89961);
;// CONCATENATED MODULE: ./.environment-register.json
var _environment_register_namespaceObject = JSON.parse('[{"name":"w_i_l_d_c_a_r_d","env":["dev","staging","sandbox","production"]},{"name":"graeters","env":["sandbox","production"]},{"name":"modpizza","env":["staging","sandbox","production"]},{"name":"peiwei","env":["sandbox","production"]},{"name":"pollocampero","env":["sandbox","production"]},{"name":"pollocamperocatering","env":["sandbox","production"]},{"name":"salsaritas","env":["sandbox","production"]},{"name":"salsaritascatering","env":["sandbox","production"]},{"name":"wabagrill","env":["sandbox","production"]},{"name":"willys","env":["sandbox","production"]},{"name":"koala-labs","env":["dev","staging","sandbox","production"]}]');
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(56580);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(36304);
// EXTERNAL MODULE: ./src/utils/stringHelpers.ts
var stringHelpers = __webpack_require__(60738);
;// CONCATENATED MODULE: ./src/components/meta/default.tsx





function MetaDefault(param) {
    var config = param.config;
    var organization = (0,es.useSelector)(function(state) {
        return state.app.organization;
    }).organization;
    var pageName = "";
    if (true) {
        pageName = (0,global/* derivePageNameFromPath */.kd)(window.location.pathname);
    }
    var stringsToInterpolate = {
        brandName: organization.label
    };
    var seoTitle = (0,stringHelpers/* interpolateIntoString */.vk)(config.seo.title, stringsToInterpolate);
    var seoDescription = (0,stringHelpers/* interpolateIntoString */.vk)(config.seo.description, stringsToInterpolate);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                children: "".concat(pageName).concat(seoTitle)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "description",
                content: seoDescription
            }, "description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:description",
                content: seoDescription
            }, "og:description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:description",
                content: seoDescription
            }, "twitter:description"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:title",
                content: "".concat(pageName).concat(seoTitle)
            }, "og:title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:title",
                content: "".concat(pageName).concat(seoTitle)
            }, "twitter:title"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                property: "og:image",
                content: config.seo.image
            }, "og:image"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "twitter:image",
                content: config.seo.image
            }, "twitter:image")
        ]
    });
}

// EXTERNAL MODULE: ./src/constants/envConfig.ts + 1 modules
var envConfig = __webpack_require__(73690);
// EXTERNAL MODULE: ./src/constants/global.ts
var constants_global = __webpack_require__(66686);
;// CONCATENATED MODULE: ./src/components/meta/site.tsx







function MetaSite(param) {
    var config = param.config, organization = param.organization;
    var router = (0,next_router.useRouter)();
    var alternateDataLayerName = "ga4DataLayer";
    var driverId = organization.ordering_driver_id;
    var _favicon;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1"
            }),
            config.integrations.cookieyes_id && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                id: "cookieyes",
                type: "text/javascript",
                src: "https://cdn-cookieyes.com/client_data/".concat(config.integrations.cookieyes_id, "/script.js")
            }),
            envConfig/* ENV */.Vi === "production" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: (0,global/* getCanonicalUrl */.Z2)(config.seo.base_url, router)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: (0,global/* getCanonicalUrl */.Z2)(config.seo.base_url, router)
                    }, "og:url")
                ]
            }),
            config.integrations.facebook_pixel && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: "\n                  window.koalaFacebookPixelConfigured = true;\n                  !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod? n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');\n                  fbq('init', ".concat(JSON.stringify(config.integrations.facebook_pixel), ");\n                ")
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "og:site_name",
                content: config.seo.site_name
            }, "og:site_name"),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                rel: "icon",
                type: "image/png",
                // @ts-expect-error: `fallbackConfig.global.favicon` is a valid string, but the return type conforms to WebConfiguration which marks the favicon as potentially null
                href: (_favicon = config.global.favicon) !== null && _favicon !== void 0 ? _favicon : dist/* fallbackConfig.global.favicon */.fC.global.favicon
            }),
            config.integrations.apple_itunes_app_id && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "apple-itunes-app",
                content: "app-id=".concat(config.integrations.apple_itunes_app_id)
            }, "apple-itunes-app"),
            config.google.site_verification && /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                name: "google-site-verification",
                content: config.google.site_verification
            }, "google-site-verification"),
            config.google.analytics_id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        async: true,
                        src: "/static/scripts/autotrack.js"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        dangerouslySetInnerHTML: {
                            __html: "\n        (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){\n        (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),\n        m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)\n        })(window,document,'script','https://www.google-analytics.com/analytics.js','ga');\n        ga('create', '".concat(config.google.analytics_id, "', {'siteSpeedSampleRate': 100});\n        ").concat(config.google.ecommerce && "ga('t0.require', 'ec');", "\n        ga('require', 'maxScrollTracker', {\n          maxScrollMetricIndex: 1,\n        });\n      ")
                        }
                    })
                ]
            }),
            config.google.gtag_id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        async: true,
                        src: "https://www.googletagmanager.com/gtag/js?id=".concat(config.google.gtag_id, "&l=").concat(alternateDataLayerName)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        dangerouslySetInnerHTML: {
                            __html: "\n        window.".concat(alternateDataLayerName, " = window.").concat(alternateDataLayerName, " || [];\n        function gtag(){").concat(alternateDataLayerName, ".push(arguments);}\n        gtag('js', new Date());\n        gtag('config', '").concat(config.google.gtag_id, "');\n      ")
                        }
                    })
                ]
            }),
            config.google.tag_manager_id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        dangerouslySetInnerHTML: {
                            __html: "window.koalaGoogleTagManagerConfigured = true;\n  (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n  })(window,document,'script','dataLayer', ".concat(JSON.stringify(config.google.tag_manager_id), ");\n  ")
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("noscript", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                            src: "https://www.googletagmanager.com/ns.html?id=".concat(config.google.tag_manager_id),
                            height: "0",
                            width: "0",
                            style: {
                                display: "none",
                                visibility: "hidden"
                            }
                        })
                    })
                ]
            }),
            config.integrations.userway_id && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        dangerouslySetInnerHTML: {
                            __html: 'var _userway_config = { account: "'.concat(config.integrations.userway_id, '" };')
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                        type: "text/javascript",
                        src: "https://cdn.userway.org/widget.js"
                    })
                ]
            }),
            config.integrations.branch_id && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: '\n                (function(b,r,a,n,c,h,_,s,d,k){if(!b[n]||!b[n]._q){for(;s<_.length;)c(h,_[s++]);d=r.createElement(a);d.async=1;d.src="https://cdn.branch.io/branch-latest.min.js";k=r.getElementsByTagName(a)[0];k.parentNode.insertBefore(d,k);b[n]=h}})(window,document,"script","branch",function(b,r){b[r]=function(){b._q.push([r,arguments])}},{_q:[],_v:1},"addListener applyCode autoAppIndex banner closeBanner closeJourney creditHistory credits data deepview deepviewCta first getCode init link logout redeem referrals removeListener sendSMS setBranchViewData setIdentity track validateCode trackCommerceEvent logEvent disableTracking".split(" "), 0);\n                  branch.init(\''.concat(config.integrations.branch_id, "');\n                ")
                }
            }),
            config.integrations.roku_pixel_id && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: '\n              !function(e,r){if(!e.rkp){var t=e.rkp=function(){\n              var e=Array.prototype.slice.call(arguments)\n              ;e.push(Date.now()),t.eventProcessor?t.eventProcessor.apply(t,e):t.queue.push(e)\n              };t.initiatorVersion="1.0",t.queue=[],t.load=function(e){\n              var t=r.createElement("script");t.async=!0,t.src=e\n              ;var n=r.getElementsByTagName("script")[0]\n              ;(n?n.parentNode:r.body).insertBefore(t,n)},rkp.load("https://cdn.ravm.tv/ust/dist/rkp.loader.js")}\n              }(window,document);\n              rkp("init","'.concat(config.integrations.roku_pixel_id, "\"),rkp('event', 'PAGE_VIEW');\n            ")
                }
            }),
            envConfig/* ENV */.Vi === "production" && driverId === constants_global/* SMB_DRIVER_ID */.Kp && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                    __html: '\n              window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};\n              heap.load("3745098455");\n            '
                }
            }),
            envConfig/* ENV */.Vi === "sandbox" && driverId === constants_global/* SMB_DRIVER_ID */.Kp && /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "text/javascript",
                dangerouslySetInnerHTML: {
                    __html: '\n            window.heap=window.heap||[],heap.load=function(e,t){window.heap.appid=e,window.heap.config=t=t||{};var r=document.createElement("script");r.type="text/javascript",r.async=!0,r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js";var a=document.getElementsByTagName("script")[0];a.parentNode.insertBefore(r,a);for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},p=["addEventProperties","addUserProperties","clearEventProperties","identify","resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],o=0;o<p.length;o++)heap[p[o]]=n(p[o])};\n            heap.load("3177339425");\n          '
                }
            })
        ]
    });
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react-redux-loading-bar/build/index.js
var build = __webpack_require__(22299);
// EXTERNAL MODULE: ./src/analytics/events/index.ts + 4 modules
var events = __webpack_require__(45003);
// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(25643);
// EXTERNAL MODULE: ./src/redux/auth/actions.ts
var actions = __webpack_require__(45479);
// EXTERNAL MODULE: ./src/redux/global/actions.ts
var global_actions = __webpack_require__(79118);
// EXTERNAL MODULE: ./src/redux/me/actions.ts
var me_actions = __webpack_require__(47290);
// EXTERNAL MODULE: ./src/services/recommendations.service.ts
var recommendations_service = __webpack_require__(20321);
;// CONCATENATED MODULE: ./src/components/routeHandler/index.tsx












/**
 * Global event handlers that dispatch Redux actions based on route changes.
 *
 * @returns null
 */ var RouteHandler = function() {
    var dispatch = (0,es.useDispatch)();
    var router = (0,next_router.useRouter)();
    var activeTagIds = (0,es.useSelector)(function(state) {
        return state.app.tags.activeTagIds;
    });
    var basketOpen = (0,es.useSelector)(function(state) {
        return state.app.global.basketOpen;
    });
    var ref = (0,es.useSelector)(function(state) {
        return state.app.global.routerStatus;
    }), persistentParameters = ref.persistentParameters, currentPath = ref.currentPath;
    // Triggered when a route starts to change.
    var handleRouteChangeStart = function() {
        dispatch((0,build/* showLoading */.QP)("page-transition"));
        // Close account dropdown modal on route change
        dispatch(me_actions/* default.toggleAccountDropdown */.Z.toggleAccountDropdown(false));
        // Close fulfillment modal on route change
        dispatch(global_actions/* default.toggleFulfillmentModal */.Z.toggleFulfillmentModal(false));
        // Close delivery modal on route change
        dispatch(me_actions/* default.toggleReorderReceipt */.Z.toggleReorderReceipt(false));
    };
    // Triggered when a route change is completed.
    var handleRouteChangeComplete = function() {
        if (currentPath !== window.location.pathname) {
            dispatch(global_actions/* default.setRouterPathname */.Z.setRouterPathname(window.location.pathname));
        }
        var showBasket = false;
        if (router.route === routes/* ROUTES.STORE */.Z6.STORE) {
            if (basketOpen || router.query.openCart === String(true)) {
                showBasket = true;
            }
        }
        /**
     * We reset the selected popular product if the user navigates
     * outside of the page -> store locator -> single store flow
     *
     * The store locator can exist at `/` or `/locations`, so we check both
     */ if (![
            routes/* ROUTES.STORE */.Z6.STORE,
            routes/* ROUTES.LOCATIONS */.Z6.LOCATIONS,
            routes/* ROUTES.HOMEPAGE */.Z6.HOMEPAGE
        ].includes(router.route)) {
            (0,recommendations_service/* removeSelectedPopularItem */.Sh)();
        }
        // Ensure cart is always closed on route change unless it has the cartOpen query param
        dispatch(global_actions/* default.toggleBasket */.Z.toggleBasket(showBasket));
        if ( true && window.location) {
            // Consolidated pageview events
            (0,events/* pageViewEventHandler */.f)();
        }
        appendRouteParameters();
        window.setTimeout(function() {
            dispatch((0,build/* hideLoading */.Zk)("page-transition"));
        }, 300);
    };
    (0,react.useEffect)(function() {
        // Listen to routeChangeStart and routeChangeComplete router events.
        router.events.on("routeChangeStart", handleRouteChangeStart);
        router.events.on("routeChangeComplete", handleRouteChangeComplete);
        dispatch(global_actions/* default.hydratePersistentParameters */.Z.hydratePersistentParameters(router.query));
        if (true) {
            window.onload = function() {
                dispatch(global_actions/* default.setRouterPathname */.Z.setRouterPathname(window.location.pathname));
                dispatch(actions/* default.reloadUser */.Z.reloadUser());
            };
        }
        // Clean up the router listeners when the component unmounts.
        return function() {
            router.events.off("routeChangeStart", handleRouteChangeStart);
            router.events.off("routeChangeComplete", handleRouteChangeComplete);
        };
    }, [
        router
    ]);
    (0,react.useEffect)(function() {
        appendRouteParameters();
    }, [
        persistentParameters,
        activeTagIds
    ]);
    var appendRouteParameters = function() {
        if ("URLSearchParams" in window) {
            var newParameters = (0,_object_spread/* default */.Z)({}, persistentParameters, activeTagIds && router.pathname === routes/* ROUTES.STORE */.Z6.STORE && {
                filter: activeTagIds
            });
            var newParameterKeys = Object.keys(newParameters);
            // ONLY append additional URL parameters if we have new persistent parameters or filter tags to work with
            if (newParameterKeys.length > 0) {
                var url = new URL(window.location.href);
                var params = new URLSearchParams(url.search);
                newParameterKeys.forEach(function(param) {
                    // @ts-expect-error `param` can't index `newParameters`.
                    params.set(param, newParameters[param]);
                });
                var as = "".concat(url.pathname, "?").concat(params.toString());
                var newWindowHistoryState = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, window.history.state), {
                    as: as
                });
                // replace this point in browser history with updated 'as' value so you may click the back button as one would expect
                window.history.replaceState(newWindowHistoryState, "", as);
            }
        }
    };
    // This component doesn't need to return anything.
    return null;
};

// EXTERNAL MODULE: ./src/constants/events.ts
var constants_events = __webpack_require__(26654);
// EXTERNAL MODULE: ./src/features/configs/configs.ts
var configs = __webpack_require__(74380);
// EXTERNAL MODULE: ./src/features/configs/organization.ts
var configs_organization = __webpack_require__(5981);
// EXTERNAL MODULE: ./src/features/configs/strings.ts
var configs_strings = __webpack_require__(18971);
// EXTERNAL MODULE: ./src/redux/index.ts
var redux = __webpack_require__(86879);
// EXTERNAL MODULE: ./src/redux/basket/actions.ts
var basket_actions = __webpack_require__(29682);
// EXTERNAL MODULE: ./src/redux/cmsConfig/actions.ts
var cmsConfig_actions = __webpack_require__(27085);
// EXTERNAL MODULE: ./src/redux/organization/actions.ts
var organization_actions = __webpack_require__(8460);
// EXTERNAL MODULE: ./src/redux/store.ts + 51 modules
var store = __webpack_require__(36429);
// EXTERNAL MODULE: ./src/services/content.service.ts + 1 modules
var content_service = __webpack_require__(44973);
// EXTERNAL MODULE: ./src/services/client.ts + 1 modules
var client = __webpack_require__(44277);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(32210);
// EXTERNAL MODULE: ./src/utils/errorReporter.ts
var errorReporter = __webpack_require__(19663);
// EXTERNAL MODULE: ./src/utils/koalaAnalytics.ts + 1 modules
var koalaAnalytics = __webpack_require__(61216);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
;// CONCATENATED MODULE: ./src/utils/google-fonts.ts




var androidFonts = [
    "Merriweather",
    "Playfair Display",
    "Libre Baskeville",
    "Roboto Slab",
    "Patrick Hand",
    "Indie Flower",
    "Roboto",
    "Open Sans",
    "Lato",
    "Montserrat",
    "Oswald",
    "Source Sans Pro",
    "Raleway",
    "Nunito Sans",
    "Work Sans",
    "Inter",
    "Poppins",
    "Barlow", 
];
function getSafeFontName(font) {
    return font.replace(" ", "+");
}
function buildStringFromWeights(weights) {
    var sortedWeights = weights.sort();
    var nonItalicWeights = sortedWeights.map(function(value) {
        return "0,".concat(value);
    }).join(";");
    var italicWeights = sortedWeights.map(function(value) {
        return "1,".concat(value);
    }).join(";");
    return "".concat(nonItalicWeights, ";").concat(italicWeights);
}
function buildStringFromFonts(fonts) {
    var normalizedFonts = {};
    fonts.forEach(function(font) {
        if (font.family in normalizedFonts) {
            normalizedFonts = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, normalizedFonts), (0,_define_property/* default */.Z)({}, font.family, {
                weights: normalizedFonts[font.family].weights.concat([
                    font.weight
                ])
            }));
        } else {
            normalizedFonts = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, normalizedFonts), (0,_define_property/* default */.Z)({}, font.family, {
                weights: [
                    font.weight
                ]
            }));
        }
    });
    return Object.entries(normalizedFonts).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), fontName = _param[0], font = _param[1];
        return "family=".concat(getSafeFontName(fontName), ":ital,wght@").concat(buildStringFromWeights(font.weights));
    }).join("&");
}
function getGoogleFontsCssUrl(webConfig) {
    var matchingFonts = [];
    var key;
    for(key in webConfig){
        var properties = webConfig[key];
        for(var subKey in properties){
            // @ts-expect-error: see next line
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            var subProperties = properties[subKey];
            if (subProperties && typeof subProperties === "object") {
                if ("font_family" in subProperties && "font_weight" in subProperties && "font_style" in subProperties) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    var family = String(subProperties.font_family).replace(/\,( )?(sans-)?serif/g, "").replace(/"/g, "");
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
                    var weight = String(subProperties.font_weight);
                    if (androidFonts.includes(family)) {
                        matchingFonts = matchingFonts.concat([
                            {
                                family: family,
                                weight: weight
                            }, 
                        ]);
                    }
                }
            }
        }
    }
    matchingFonts = matchingFonts.map(function(font) {
        return JSON.stringify(font);
    }).filter(function(value, index, array) {
        return array.indexOf(value) === index;
    }).map(function(font) {
        return JSON.parse(font);
    });
    if (matchingFonts.length) {
        var fontFamilies = buildStringFromFonts(matchingFonts);
        return "https://fonts.googleapis.com/css2?".concat(fontFamilies, "&display=swap");
    }
}
// WARNING: This function can only be used on the client side
// In our case, we are calling it in a `useEffect` within the `_app.tsx` file: apps/web-ordering/pages/_app.tsx
function maybeReloadGoogleFonts(url) {
    var stylesheet = document.getElementById("google-font-url");
    // google fonts are not always used
    if (!stylesheet) {
        return;
    }
    // if the url is the same, we don't need to do anything
    if (stylesheet.getAttribute("href") === url) {
        return;
    }
    stylesheet.setAttribute("href", url);
}

;// CONCATENATED MODULE: ./pages/_app.tsx



































var INVALID_ORIGIN_PHRASE = "Invalid or unrecognized origin domain";
function isInvalidOriginError(rawError, errorResponse) {
    var ref, ref1, ref2, ref3;
    var rawErrorObject = rawError && typeof rawError === "object" ? rawError : null;
    var rawErrorDescription = rawErrorObject === null || rawErrorObject === void 0 ? void 0 : (ref = rawErrorObject.error) === null || ref === void 0 ? void 0 : ref.error_description;
    var rawErrorCode = rawErrorObject === null || rawErrorObject === void 0 ? void 0 : (ref1 = rawErrorObject.error) === null || ref1 === void 0 ? void 0 : ref1.error;
    var rawMessage = rawErrorObject === null || rawErrorObject === void 0 ? void 0 : rawErrorObject.message;
    var preparedDescription = (ref2 = errorResponse.error) === null || ref2 === void 0 ? void 0 : ref2.error_description;
    var preparedCode = (ref3 = errorResponse.error) === null || ref3 === void 0 ? void 0 : ref3.error;
    var candidates = [
        rawErrorDescription,
        preparedDescription,
        errorResponse.message,
        rawMessage, 
    ].filter(function(value) {
        return typeof value === "string";
    });
    var hasInvalidOriginPhrase = candidates.some(function(value) {
        return value.includes(INVALID_ORIGIN_PHRASE);
    });
    var isInvalidCredentials = rawErrorCode === "invalid_credentials" || preparedCode === "invalid_credentials";
    var isUnauthorized = (rawErrorObject === null || rawErrorObject === void 0 ? void 0 : rawErrorObject.status) === 401 || (rawErrorObject === null || rawErrorObject === void 0 ? void 0 : rawErrorObject.statusCode) === 401;
    return hasInvalidOriginPhrase && (isInvalidCredentials || isUnauthorized);
}
var KOALA_ORDERING_HOST_REGEX = RegExp("^(?<brand>[^.]+)(?:\\.(?<env>dev|staging|sandbox))?\\.order\\.koala\\.io$", "i");
var allowedBrandsByEnv = _environment_register_namespaceObject.reduce(function(acc, entry) {
    entry.env.forEach(function(env) {
        var key = env.toLowerCase();
        if (!acc[key]) {
            acc[key] = new Set();
        }
        acc[key].add(entry.name.toLowerCase());
    });
    return acc;
}, {});
function normalizeHost(rawHost) {
    var ref, ref1;
    if (!rawHost) {
        return null;
    }
    var ref2;
    var host = (ref2 = (ref = rawHost.split(",")[0]) === null || ref === void 0 ? void 0 : ref.trim()) !== null && ref2 !== void 0 ? ref2 : "";
    if (!host) {
        return null;
    }
    var ref3;
    return (ref3 = (ref1 = host.split(":")[0]) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) !== null && ref3 !== void 0 ? ref3 : null;
}
function getRequestHost(context) {
    var ref;
    if (true) {
        return window.location.hostname.toLowerCase();
    }
    var headers = (ref = context.ctx.req) === null || ref === void 0 ? void 0 : ref.headers;
    var forwardedHost = headers === null || headers === void 0 ? void 0 : headers["x-forwarded-host"];
    var originalHost = headers === null || headers === void 0 ? void 0 : headers["x-original-host"];
    var hostHeader = headers === null || headers === void 0 ? void 0 : headers.host;
    if (typeof forwardedHost === "string") {
        return normalizeHost(forwardedHost);
    }
    if (typeof originalHost === "string") {
        return normalizeHost(originalHost);
    }
    if (typeof hostHeader === "string") {
        return normalizeHost(hostHeader);
    }
    if (Array.isArray(forwardedHost)) {
        return normalizeHost(forwardedHost[0]);
    }
    if (Array.isArray(originalHost)) {
        return normalizeHost(originalHost[0]);
    }
    if (Array.isArray(hostHeader)) {
        return normalizeHost(hostHeader[0]);
    }
    return null;
}
function isIpHost(host) {
    return /^(?:\d{1,3}\.){3}\d{1,3}$/.test(host);
}
function shouldShortCircuitHost(host) {
    var ref;
    if (false) {}
    if (isIpHost(host)) {
        return true;
    }
    var match = host.match(KOALA_ORDERING_HOST_REGEX);
    if (!(match === null || match === void 0 ? void 0 : (ref = match.groups) === null || ref === void 0 ? void 0 : ref.brand)) {
        return false;
    }
    var _env;
    var env = ((_env = match.groups.env) !== null && _env !== void 0 ? _env : "production").toLowerCase();
    var brand = match.groups.brand.toLowerCase();
    var allowed = allowedBrandsByEnv[env];
    if (!allowed) {
        return false;
    }
    return !allowed.has(brand);
}
/**
 * A custom `App` component that wraps every page in the application.
 *
 * @see https://nextjs.org/docs/advanced-features/custom-app
 */ var OrderingApp = function(param) {
    var Component = param.Component, pageProps = param.pageProps;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,redux/* useDispatch */.I0)();
    // Get the brand config from the store.
    var initialConfig = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.cmsConfig.webConfig;
    });
    var organization = (0,redux/* useSelector */.v9)(function(state) {
        return state.app.organization;
    }).organization;
    var ref = (0,react.useState)(function() {
        return new lib_queryClient/* QueryClient */.S();
    }), queryClient = ref[0];
    // Set up error reporting.
    (0,react.useEffect)(function() {
        errorReporter/* initialize */.j2(organization.label);
    }, [
        organization.label
    ]);
    // DO NOT REMOVE
    // This code ensures configs are hydrated on the client to avoid CloudFront caching issues
    (0,react.useEffect)(function() {
        var origin = (0,utils/* getOrigin */.P$)(window.location.host);
        var timeoutMs = 1500;
        Promise.race([
            (0,client/* primeClientToken */.UX)({
                origin: origin
            }),
            new Promise(function(resolve) {
                return setTimeout(resolve, timeoutMs);
            }), 
        ]).catch(function() {
            return undefined;
        }).finally(function() {
            dispatch(cmsConfig_actions/* default.fetchConfigs */.Z.fetchConfigs("fetchClient", queryClient));
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Whenever the config slice is updated, refetch google fonts
    (0,react.useEffect)(function() {
        var googleFontUrl = getGoogleFontsCssUrl(initialConfig);
        if (googleFontUrl) {
            maybeReloadGoogleFonts(googleFontUrl);
        }
    }, [
        initialConfig
    ]);
    (0,react.useEffect)(function hydrateClientState() {
        // If a basket exists in localStorage check that it's is still fresh and valid
        dispatch(basket_actions/* default.initializeLocalStorageBasket */.Z.initializeLocalStorageBasket());
        // check logged-in status
        dispatch(me_actions/* default.fetchMe */.Z.fetchMe());
    }, [
        router.pathname,
        dispatch
    ]);
    // If the component is rendered on the client, derive the page name and instantiate Koala Analytics.
    if (true) {
        (0,koalaAnalytics/* initializeKoalaAnalytics */.X1)(organization.id, organization.label);
        // Retrieve rwg_token from the URL query string
        var conversionTracker = new dist/* ConversionTrackingHelper */.jJ();
        conversionTracker.setTrackingKey();
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaSite, {
                config: initialConfig,
                organization: organization
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaDefault, {
                config: initialConfig
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(styled_components_browser_esm/* ThemeProvider */.f6, {
                theme: initialConfig,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(QueryClientProvider/* QueryClientProvider */.aH, {
                    client: queryClient,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RouteHandler, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Component, (0,_object_spread/* default */.Z)({}, pageProps))
                    ]
                })
            })
        ]
    });
};
/**
 * Fetching the brand config is a blocking data requirement for every page,
 * so we need to opt-out of Next's automatic static optimization and run
 * the following dispatch on every page.
 */ OrderingApp.getInitialProps = store/* wrapper.getInitialAppProps */.Y.getInitialAppProps(function(store) {
    return function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(context) {
            var ref, queryClient, requestHost, origin, ref1, webConfig, strings, organization, error, rawError, errorResponse, isInvalidOrigin, _error, ref2, _message, ref3, appInitialProps, ref4, /**
         * Set the cache header to re-enable SRR page caching in Next@12+.
         * @see https://nextjs.org/docs/going-to-production#caching
         */ ref5;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        queryClient = new lib_queryClient/* QueryClient */.S();
                        requestHost = getRequestHost(context);
                        if (requestHost && shouldShortCircuitHost(requestHost)) {
                            if (true) {
                                window.location.href = "https://chowly.com";
                                return [
                                    2,
                                    {
                                        pageProps: {}
                                    }
                                ];
                            }
                            if (context.ctx.res) {
                                context.ctx.res.writeHead(302, {
                                    Location: "https://chowly.com"
                                });
                                context.ctx.res.end();
                            }
                            return [
                                2,
                                {
                                    pageProps: {}
                                }
                            ];
                        }
                        if (true) {
                            origin = (0,utils/* getOrigin */.P$)(window.location.host);
                        } else {}
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            6
                        ]);
                        return [
                            4,
                            (0,client/* primeClientToken */.UX)({
                                origin: origin
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            Promise.all([
                                (0,configs/* getConfigs */.G_)(queryClient, origin),
                                (0,configs_strings/* getStrings */.F)(queryClient, origin),
                                (0,configs_organization/* getOrganization */.X)(queryClient, origin)
                            ])
                        ];
                    case 3:
                        ref1 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            3
                        ]), webConfig = ref1[0], strings = ref1[1], organization = ref1[2];
                        // Store success responses
                        store.dispatch(cmsConfig_actions/* default.fetchConfigsSuccess */.Z.fetchConfigsSuccess("fetchServer", "webConfig", webConfig));
                        store.dispatch(cmsConfig_actions/* default.fetchConfigsSuccess */.Z.fetchConfigsSuccess("fetchServer", "strings", strings));
                        store.dispatch(// @ts-expect-error: mismatched types
                        organization_actions/* default.fetchOrganizationSuccess */.Z.fetchOrganizationSuccess(organization));
                        return [
                            3,
                            6
                        ];
                    case 4:
                        error = _state.sent();
                        rawError = error;
                        return [
                            4,
                            (0,global/* prepareErrorMessage */.Xr)(null, error)
                        ];
                    case 5:
                        errorResponse = _state.sent();
                        isInvalidOrigin = isInvalidOriginError(rawError, errorResponse);
                        if (isInvalidOrigin) {
                            // Any invalid-origin failure => redirect to chowly (fail fast to avoid 504s)
                            // eslint-disable-next-line no-console
                            console.error("Invalid origin check - errorResponse", errorResponse);
                            ;
                            // eslint-disable-next-line no-console
                            console.log("[invalid-origin] redirecting to chowly.com (SSR)", JSON.stringify({
                                origin: origin,
                                status: rawError === null || rawError === void 0 ? void 0 : rawError.status,
                                statusCode: rawError === null || rawError === void 0 ? void 0 : rawError.statusCode,
                                error: (ref2 = (_error = errorResponse.error) !== null && _error !== void 0 ? _error : rawError === null || rawError === void 0 ? void 0 : rawError.error) !== null && ref2 !== void 0 ? ref2 : null,
                                message: (ref3 = (_message = errorResponse.message) !== null && _message !== void 0 ? _message : rawError === null || rawError === void 0 ? void 0 : rawError.message) !== null && ref3 !== void 0 ? ref3 : null
                            }));
                            if (true) {
                                // eslint-disable-next-line no-console
                                console.log("[invalid-origin] redirecting to chowly.com (client)");
                                window.location.href = "https://chowly.com";
                                return [
                                    2,
                                    {
                                        pageProps: {}
                                    }
                                ];
                            }
                            if (context.ctx.res) {
                                context.ctx.res.writeHead(302, {
                                    Location: "https://chowly.com"
                                });
                                context.ctx.res.end();
                            }
                            return [
                                2,
                                {
                                    pageProps: {}
                                }
                            ];
                        }
                        store.dispatch(organization_actions/* default.fetchOrganizationFail */.Z.fetchOrganizationFail());
                        // KA Events
                        (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_BATCH_CONFIGS_ERROR */.RZ.FETCH_BATCH_CONFIGS_ERROR, error, errorResponse);
                        return [
                            3,
                            6
                        ];
                    case 6:
                        return [
                            4,
                            app["default"].getInitialProps(context)
                        ];
                    case 7:
                        appInitialProps = _state.sent();
                        if (!context.ctx.req) return [
                            3,
                            9
                        ];
                        try {
                            ;
                            (ref5 = context.ctx.res) === null || ref5 === void 0 ? void 0 : ref5.setHeader("Cache-Control", constants_global/* DEFAULT_SSR_CACHE_POLICY */.ao);
                        } catch (error1) {
                            // setting the cache header can fail for 404 redirects
                            console.error(error1);
                        }
                        // Wait for all sagas to run before returning.
                        store.dispatch(redux_saga_core_npm_proxy_esm/* END */.uR);
                        return [
                            4,
                            (ref4 = store.sagaTask) === null || ref4 === void 0 ? void 0 : ref4.toPromise()
                        ];
                    case 8:
                        _state.sent();
                        _state.label = 9;
                    case 9:
                        /**
     * Return the page's initial props. If props from _app.getInitialProps, were
     * added, those would have to be spread onto appInitialProps.
     */ return [
                            2,
                            appInitialProps
                        ];
                }
            });
        });
        return function(context) {
            return _ref.apply(this, arguments);
        };
    }();
});
/**
 * Wrap the OrderingApp component in the `next-redux-wrapper`. Wrapping _app
 * will provide the store to the entire application and reconcile store state
 * across client- and server-side rendered components.
 *
 * One important note: when using `getInitialProps` or `getServerSideProps`,
 * you must use the versions exposed by the wrapper. Client-side components
 * can use `connect` or `useDispatch` / `useStore` as usual.
 *
 * @see https://nextjs.org/docs/advanced-features/custom-app
 * @see https://github.com/kirill-konshin/next-redux-wrapper#usage
 */ /* harmony default export */ var _app = ((0,next_urql_es/* withUrqlClient */.X)(function(ssrExchange, ctx) {
    var ref;
    var meta = undefined;
    if (true) {
        meta = (0,utils/* getRequestOrigin */.vi)(window.location.host);
    } else {}
    return (0,content_service/* contentSetupAPIRequests */.XG)(ssrExchange, meta);
}, {
    neverSuspend: true
})(store/* wrapper.withRedux */.Y.withRedux(OrderingApp)));


/***/ }),

/***/ 94889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dk": function() { return /* binding */ fireGACommerceAddShippingInfoEvent; },
/* harmony export */   "F$": function() { return /* binding */ fireGACommerceAddPaymentInfoEvent; },
/* harmony export */   "FP": function() { return /* binding */ addProductEventsGoogle; },
/* harmony export */   "RU": function() { return /* binding */ fireGACommerceSelectPromotionEvent; },
/* harmony export */   "RW": function() { return /* binding */ fireGACommerceLoginEvent; },
/* harmony export */   "Rd": function() { return /* binding */ GOOGLE_COMMERCE_CHECKOUT_STEPS; },
/* harmony export */   "T4": function() { return /* binding */ fireGACommerceStep; },
/* harmony export */   "cg": function() { return /* binding */ clickProductEventsGoogle; },
/* harmony export */   "eM": function() { return /* binding */ addCategoryViewGoogle; },
/* harmony export */   "f1": function() { return /* binding */ fireGACommerceViewCartEvent; },
/* harmony export */   "gM": function() { return /* binding */ fireGACommerceBeginCheckoutEvent; },
/* harmony export */   "kl": function() { return /* binding */ viewProductEventsGoogle; },
/* harmony export */   "mI": function() { return /* binding */ fireGACommercePurchaseEvent; },
/* harmony export */   "pi": function() { return /* binding */ addImpressionsGoogle; },
/* harmony export */   "v3": function() { return /* binding */ removeProductEventsGoogle; }
/* harmony export */ });
/* unused harmony export buildCommerceProduct */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47842);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _koala_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80684);
/* harmony import */ var _constants_checkout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80420);
/* harmony import */ var _utils_basket__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1227);
/* harmony import */ var _utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87809);






//Google UA commerce actions
var GOOGLE_COMMERCE_ACTIONS = {
    click: "click",
    detail: "detail",
    add: "add",
    remove: "remove",
    checkout: "checkout",
    checkout_option: "checkout_option",
    purchase: "purchase",
    refund: "refund",
    promo_click: "promo_click"
};
//Google Enhanced UA Commerce events pushed through GTM
var GOOGLE_COMMERCE_EVENTS = {
    productClick: "productClick",
    productView: "productView",
    addToCart: "addToCart",
    removeFromCart: "removeFromCart",
    promotionClick: "promotionClick",
    checkout: "checkout",
    purchase: "purchase",
    productImpression: "productImpression"
};
// Checkout steps reported through GTM
var GOOGLE_COMMERCE_CHECKOUT_STEPS = {
    1: "Checkout Page Reached",
    2: "User Details Set",
    3: "Basket Staged",
    4: "Payment Set",
    5: "Order Submission Started",
    6: "Receipt Received"
};
//Maps UA and GTM commerce actions to Gtag.js commerce event names
var commerceToGTagMap = new Map([
    [
        GOOGLE_COMMERCE_ACTIONS.click,
        "select_item"
    ],
    [
        GOOGLE_COMMERCE_ACTIONS.detail,
        "view_item"
    ],
    [
        GOOGLE_COMMERCE_ACTIONS.add,
        "add_to_cart"
    ],
    [
        GOOGLE_COMMERCE_ACTIONS.remove,
        "remove_from_cart"
    ],
    [
        GOOGLE_COMMERCE_ACTIONS.checkout,
        "begin_checkout"
    ],
    [
        GOOGLE_COMMERCE_ACTIONS.purchase,
        "purchase"
    ],
    [
        GOOGLE_COMMERCE_ACTIONS.refund,
        "refund"
    ],
    [
        GOOGLE_COMMERCE_ACTIONS.promo_click,
        "select_promotion"
    ],
    [
        GOOGLE_COMMERCE_EVENTS.productClick,
        "select_item"
    ],
    [
        GOOGLE_COMMERCE_EVENTS.productView,
        "view_item"
    ],
    [
        GOOGLE_COMMERCE_EVENTS.addToCart,
        "add_to_cart"
    ],
    [
        GOOGLE_COMMERCE_EVENTS.removeFromCart,
        "remove_from_cart"
    ],
    [
        GOOGLE_COMMERCE_EVENTS.promotionClick,
        "select_promotion"
    ],
    [
        GOOGLE_COMMERCE_EVENTS.checkout,
        "begin_checkout"
    ],
    [
        GOOGLE_COMMERCE_EVENTS.purchase,
        "purchase"
    ],
    [
        GOOGLE_COMMERCE_EVENTS.productImpression,
        "view_item"
    ], 
]);
/**
 * Google Analytics ecommerce channel support
 */ /** @deprecated The hasUA() check will not be relevant after UA is deprecated on July 1, 2023 */ var hasUA = function() {
    return typeof (window === null || window === void 0 ? void 0 : window.ga) === "function";
};
var hasGtm = function() {
    var ref;
    return window.koalaGoogleTagManagerConfigured === true && typeof (window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push) === "function";
};
var hasGtag = function() {
    return typeof (window === null || window === void 0 ? void 0 : window.gtag) === "function";
};
/**
 * Assemble a standard Google Commerce product
 *
 */ var buildCommerceProduct = function(menuProduct, category, location, item) {
    if (!menuProduct) {
        return null;
    }
    // Default menu product values - i.e. clicking on a menu product or viewing a menu item
    var productVariant = "";
    var productCost = menuProduct.cost;
    // If we have a working version of the item - i.e. have applied modifiers via customization
    if (item === null || item === void 0 ? void 0 : item.options.length) {
        var ref;
        var ref1, ref2;
        //Build a comma-separated list of product option names for the product variant field
        productVariant = item.options.map(function(option) {
            var ref //Fallback to the option group name found in the menu
            ;
            return (ref2 = option === null || option === void 0 ? void 0 : option.name) !== null && ref2 !== void 0 ? ref2 : (ref = (0,_utils_basket__WEBPACK_IMPORTED_MODULE_2__/* .findOptionByOptionId */ .yY)(option === null || option === void 0 ? void 0 : option.id, (ref1 = menuProduct === null || menuProduct === void 0 ? void 0 : menuProduct.option_groups) !== null && ref1 !== void 0 ? ref1 : [])) === null || ref === void 0 ? void 0 : ref.name;
        }).filter(function(name) {
            return name;
        }).join(", ");
        var ref3;
        productCost = (ref3 = (ref = (0,_utils_basket__WEBPACK_IMPORTED_MODULE_2__/* .recreateCustomizerProductFromMenuProduct */ .RR)(menuProduct, item.options)) === null || ref === void 0 ? void 0 : ref.final_cost) !== null && ref3 !== void 0 ? ref3 : 0;
    }
    var ref4, ref5, ref6, ref7, ref8;
    var commerceProduct = {
        id: (ref5 = (ref4 = menuProduct === null || menuProduct === void 0 ? void 0 : menuProduct.id) !== null && ref4 !== void 0 ? ref4 : item === null || item === void 0 ? void 0 : item.id) !== null && ref5 !== void 0 ? ref5 : "",
        name: (ref7 = (ref6 = menuProduct === null || menuProduct === void 0 ? void 0 : menuProduct.name) !== null && ref6 !== void 0 ? ref6 : item === null || item === void 0 ? void 0 : item.product.name) !== null && ref7 !== void 0 ? ref7 : "",
        category: category,
        brand: "",
        variant: productVariant,
        price: parseFloat((0,_utils_basket__WEBPACK_IMPORTED_MODULE_2__/* .toDollars */ .DV)(productCost)),
        quantity: (ref8 = item === null || item === void 0 ? void 0 : item.quantity) !== null && ref8 !== void 0 ? ref8 : 1
    };
    if (location) {
        commerceProduct.brand = location.label;
        var _id;
        commerceProduct.affiliation = "Store: ".concat((_id = location.id) !== null && _id !== void 0 ? _id : "", " - ").concat(location.label);
    }
    return commerceProduct;
};
/**
 * Translates an item built for reporting through a GTM action to a GTag item
 * @param commerceProduct
 * @return ICommerceProduct
 */ var translateCommerceProductToGTagItem = function(commerceProduct) {
    return {
        item_id: commerceProduct.id,
        item_name: commerceProduct.name,
        item_category: commerceProduct.category,
        item_brand: commerceProduct.brand || undefined,
        item_variant: commerceProduct.variant || undefined,
        price: commerceProduct.price,
        quantity: commerceProduct.quantity,
        index: commerceProduct === null || commerceProduct === void 0 ? void 0 : commerceProduct.position,
        item_list_name: commerceProduct === null || commerceProduct === void 0 ? void 0 : commerceProduct.list
    };
};
/**
 * Derive commerce list value from PRODUCT_LOCATION_LABELS
 *
 * Basically the list value will be the label, unless coming from the Menu,
 * in which case we also append the product category name
 */ var deriveProductList = function(label, categoryName) {
    return label === _constants_checkout__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_LOCATION_LABELS.MENU */ .X.MENU ? "".concat(label, ": ").concat(categoryName !== null && categoryName !== void 0 ? categoryName : "") : label;
};
/**
 * Google Add Product Impression pushed through UA ECommerce and GTM.
 * An impression for each menu category product are triggered when the first time a
 * menu category is visible per page view. Impressions are reported through UA and GTM.
 */ var addImpressionsGoogle = function(menuProduct, categoryName, location, index) {
    var product = buildCommerceProduct(menuProduct, categoryName, location);
    if (!product) {
        return;
    }
    product.position = index + 1;
    product.list = deriveProductList(_constants_checkout__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_LOCATION_LABELS.MENU */ .X.MENU, categoryName);
    if (hasUA()) {
        window.ga("".concat(_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .GOOGLE_TRACKER_NAME */ .Kx, "ec:addImpression"), product);
    }
    if (hasGtm()) {
        // Push into GTM DataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: GOOGLE_COMMERCE_EVENTS.productImpression,
            ecommerce: {
                impressions: [
                    product
                ]
            }
        });
    }
/**
   * No events are reported through gtag for product impressions.
   * Gtag.js expects the category products consolidated under the "view_item_list" event.
   * See addCategoryViewGoogle().
   */ };
/**
 * Google Add Category View pushed through gtag
 */ var addCategoryViewGoogle = function(category, location) {
    if (hasGtag()) {
        var categoryProducts = category.products.map(function(menuProduct) {
            return(//Abuse the existing GTM commerce item translation function
            buildCommerceProduct(menuProduct, category.name, location));
        }).map(function(commerceProduct) {
            return commerceProduct ? translateCommerceProductToGTagItem(commerceProduct) : null;
        }).filter(function(item) {
            return item;
        });
        if (categoryProducts.length) {
            window.gtag("event", "view_item_list", {
                item_list_id: category.global_id,
                item_list_name: category.name,
                items: categoryProducts
            });
        }
    }
};
/**
 * Google Click Product Events are reported through UA, GTM, Gtag.js
 * @param menuProduct
 * @param categoryName
 * @param location
 * @param label
 * @param index
 */ var clickProductEventsGoogle = function(menuProduct, categoryName, location, label, index) {
    var product = buildCommerceProduct(menuProduct, categoryName, location);
    if (!product) {
        return;
    }
    product.position = index + 1;
    fireGaCommerceProductEvent(GOOGLE_COMMERCE_ACTIONS.click, product, deriveProductList(label, categoryName), location, GOOGLE_COMMERCE_EVENTS.productClick);
    /**
   * Google Analytics
   */ var action = label === _constants_checkout__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_LOCATION_LABELS.CROSS_SELL */ .X.CROSS_SELL ? _utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .gaActions.clickCrossSelllItem */ .cE.clickCrossSelllItem : _utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .gaActions.clickMenuItem */ .cE.clickMenuItem;
    (0,_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .fireGaEvent */ .d4)(_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .gaCats.order */ .m1.order, action, {
        label: menuProduct.name
    });
};
/**
 * Google Add Product Events pushed through UA, GTM, Gtag.js
 * - Commerce does not account for updating an existing basket item
 *
 * @param menuProduct
 * @param location
 * @param label
 * @param menu
 */ var viewProductEventsGoogle = function(menuProduct, location, label, menu) {
    /**
   * Google Analytics
   */ (0,_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .fireGaEvent */ .d4)(_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .gaCats.order */ .m1.order, _utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .gaActions.viewProductDetail */ .cE.viewProductDetail, {
        label: menuProduct.name
    });
    /**
   * Google Commerce
   */ var menuProductWithCategory = _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkUtils.findMenuItemById */ .fH.findMenuItemById(menuProduct.id, menu);
    if (menuProductWithCategory) {
        var categoryName = menuProductWithCategory.category.name;
        fireGaCommerceProductEvent(GOOGLE_COMMERCE_ACTIONS.detail, buildCommerceProduct(menuProduct, categoryName, location), deriveProductList(label, categoryName), location, GOOGLE_COMMERCE_EVENTS.productView);
    }
};
/**
 * Google Add Product Events sent through all three methods
 */ var addProductEventsGoogle = function(item, location, basketMenu, label) {
    var ref;
    /**
   * Google Commerce
   */ // Find product in basket menu
    var menuProductWithCategory = _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkUtils.findMenuItemById */ .fH.findMenuItemById(item.product.id, basketMenu);
    if (!menuProductWithCategory) {
        return;
    }
    var ref1;
    var categoryName = (ref1 = (ref = item.product) === null || ref === void 0 ? void 0 : ref.category_label) !== null && ref1 !== void 0 ? ref1 : "";
    // Fire GC Events, only if we are not modifying a basket product
    if (label !== _constants_checkout__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_LOCATION_LABELS.BASKET */ .X.BASKET) {
        var product = buildCommerceProduct(menuProductWithCategory, categoryName, location, item);
        fireGaCommerceProductEvent(GOOGLE_COMMERCE_ACTIONS.add, product, deriveProductList(label, categoryName), location, GOOGLE_COMMERCE_EVENTS.addToCart);
    }
    /**
   * Google Analytics
   */ // Derive GA Action from product labels
    var eventAction = _utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .gaActions.addToBasket */ .cE.addToBasket;
    if (label === _constants_checkout__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_LOCATION_LABELS.BASKET */ .X.BASKET) {
        eventAction = _utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .gaActions.editItem */ .cE.editItem;
    } else if (label === _constants_checkout__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_LOCATION_LABELS.CROSS_SELL */ .X.CROSS_SELL) {
        eventAction = _utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .gaActions.addCrossSell */ .cE.addCrossSell;
    }
    // Fire GA Event
    (0,_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .fireGaEvent */ .d4)(_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .gaCats.order */ .m1.order, eventAction, {
        label: item.product.name
    });
};
/**
 * Google Remove Products sent through all three methods
 */ var removeProductEventsGoogle = function(item, location, basketMenu) {
    var ref, ref1;
    var menuItem = _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkUtils.findMenuItemById */ .fH.findMenuItemById(item.product.id, basketMenu);
    var _name, ref2;
    var categoryName = (ref2 = (_name = menuItem === null || menuItem === void 0 ? void 0 : menuItem.category.name) !== null && _name !== void 0 ? _name : item === null || item === void 0 ? void 0 : (ref = item.product) === null || ref === void 0 ? void 0 : ref.category_label) !== null && ref2 !== void 0 ? ref2 : _constants_checkout__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_LOCATION_LABELS.BASKET */ .X.BASKET;
    var product = buildCommerceProduct(menuItem, categoryName, location, item);
    /**
   * Google Commerce
   */ fireGaCommerceProductEvent(GOOGLE_COMMERCE_ACTIONS.remove, product, deriveProductList(_constants_checkout__WEBPACK_IMPORTED_MODULE_1__/* .PRODUCT_LOCATION_LABELS.BASKET */ .X.BASKET), location, GOOGLE_COMMERCE_EVENTS.removeFromCart);
    /**
   * Google Analytics
   */ (0,_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .fireGaEvent */ .d4)(_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .gaCats.order */ .m1.order, _utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .gaActions.removeItem */ .cE.removeItem, {
        label: (ref1 = item.product) === null || ref1 === void 0 ? void 0 : ref1.name
    });
};
/**
 * GA Commerce Product Events
 *
 * Limited actions: https://developers.google.com/analytics/devguides/collection/analyticsjs/enhanced-ecommerce#action-types
 *
 */ var fireGaCommerceProductEvent = function(action, product, list, location, event) {
    if (!product) {
        return;
    }
    /**
   * Google Commerce
   */ if (hasUA()) {
        window.ga("".concat(_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .GOOGLE_TRACKER_NAME */ .Kx, "ec:addProduct"), product);
        window.ga("".concat(_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .GOOGLE_TRACKER_NAME */ .Kx, "ec:setAction"), action, {
            list: list
        });
    }
    if (hasGtm()) {
        // Push into GTM DataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: event,
            ecommerce: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, action, {
                actionField: {
                    list: list
                },
                products: [
                    product
                ]
            })
        });
    }
    //Make sure the event is also sent to gtag with the correct name and format
    if (hasGtag() && commerceToGTagMap.has(event !== null && event !== void 0 ? event : action)) {
        var translatedEventName = commerceToGTagMap.get(event !== null && event !== void 0 ? event : action);
        var gtagItem = translateCommerceProductToGTagItem(product);
        switch(translatedEventName){
            case "view_item":
            case "select_item":
                window.gtag("event", translatedEventName, {
                    item_list_id: list,
                    item_list_name: list,
                    items: [
                        gtagItem
                    ]
                });
                break;
            case "add_to_cart":
                window.gtag("event", translatedEventName, {
                    currency: determineCurrencyCodeFromLocation(location),
                    value: gtagItem.price,
                    items: [
                        gtagItem
                    ]
                });
                break;
            case "remove_from_cart":
                window.gtag("event", translatedEventName, {
                    items: [
                        gtagItem
                    ]
                });
                break;
        }
    }
};
/**
 * Fire Generic Commerce Checkout Step
 */ var fireGACommerceStep = function(step, stepOption) {
    // @ts-expect-error `step` can't index `GOOGLE_COMMERCE_CHECKOUT_STEPS`.
    var option = stepOption !== null && stepOption !== void 0 ? stepOption : GOOGLE_COMMERCE_CHECKOUT_STEPS[step];
    /**
   * Google Commerce
   */ if (hasUA()) {
        window.ga("".concat(_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .GOOGLE_TRACKER_NAME */ .Kx, "ec:setAction"), "checkout", {
            step: step,
            option: option
        });
    }
    if (hasGtm()) {
        // Push into GTM DataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: GOOGLE_COMMERCE_EVENTS.checkout,
            ecommerce: {
                checkout: {
                    actionField: {
                        step: step,
                        option: option
                    }
                }
            }
        });
    }
    /**
   * Google Analytics
   */ (0,_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .fireGaEvent */ .d4)(_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .gaCats.checkout */ .m1.checkout, option, {
        label: "Step: ".concat(step)
    });
};
/**
 * Push begin checkout event through gtag
 * @param basket
 * @param basketMenu
 * @param coupon
 */ var fireGACommerceViewCartEvent = function(basket, basketMenu, coupon) {
    if (hasGtag()) {
        window.gtag("event", "view_cart", buildCommerceBaseCheckoutEventPayload(basket, basketMenu, coupon));
    }
};
/**
 * Push begin checkout event through gtag
 * @param basket
 * @param basketMenu
 * @param coupon
 */ var fireGACommerceBeginCheckoutEvent = function(basket, basketMenu, coupon) {
    if (hasGtag()) {
        window.gtag("event", "begin_checkout", buildCommerceBaseCheckoutEventPayload(basket, basketMenu, coupon));
    }
};
/**
 * Push add shipping info event (delivery address is entered) through gtag
 * @param basket
 * @param basketMenu
 * @param coupon
 * @param shippingMethod
 */ var fireGACommerceAddShippingInfoEvent = function(basket, basketMenu, coupon, shippingMethod) {
    if (hasGtag()) {
        window.gtag("event", "add_shipping_info", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buildCommerceBaseCheckoutEventPayload(basket, basketMenu, coupon), {
            shipping_tier: shippingMethod
        }));
    }
};
/**
 * Push add select promo event (coupon code added or reward selected) through gtag
 * @param basket
 * @param basketMenu
 * @param coupon
 */ var fireGACommerceSelectPromotionEvent = function(basket, basketMenu, coupon) {
    if (hasGtag()) {
        window.gtag("event", "select_promotion", buildCommerceBasePromoEventPayload(basket, basketMenu, coupon));
    }
};
/**
 * Push add payment info event (payment method is selected during checkout) through gtag
 * @param basket
 * @param basketMenu
 * @param paymentMethod
 * @param coupon
 */ var fireGACommerceAddPaymentInfoEvent = function(basket, basketMenu, paymentMethod, coupon) {
    if (hasGtag()) {
        window.gtag("event", "payment_info_applied", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, buildCommerceBaseCheckoutEventPayload(basket, basketMenu, coupon), {
            payment_type: paymentMethod
        }));
    }
};
/**
 * Fire Commerce Purchase Event through all three methods
 */ function fireGACommercePurchaseEvent(orderDetails, basket, basketMenu, coupon) {
    var ref, ref1;
    var content = basket.content, location = basket.location;
    var _location_id, ref2, ref3;
    // Assemble purchase object
    var purchaseObject = {
        id: orderDetails.order_data.order.order_number,
        affiliation: "Store: ".concat((_location_id = location.location_id) !== null && _location_id !== void 0 ? _location_id : "", " - ").concat(location.label),
        revenue: (0,_utils_basket__WEBPACK_IMPORTED_MODULE_2__/* .toDollars */ .DV)(orderDetails.order_data.order.total + ((ref2 = (ref = orderDetails.order_data.order) === null || ref === void 0 ? void 0 : ref.promo_discount) !== null && ref2 !== void 0 ? ref2 : 0)),
        tax: (0,_utils_basket__WEBPACK_IMPORTED_MODULE_2__/* .toDollars */ .DV)(orderDetails.order_data.order.sales_tax),
        delivery: (0,_utils_basket__WEBPACK_IMPORTED_MODULE_2__/* .toDollars */ .DV)((ref3 = (ref1 = basket.checkoutBasket) === null || ref1 === void 0 ? void 0 : ref1.delivery_fee) !== null && ref3 !== void 0 ? ref3 : 0),
        coupon: coupon
    };
    // Assemble products array
    var products = buildCommerceProductListFromBasketItems(content.basket_items, basketMenu, location);
    if (hasUA()) {
        // Fire Commerce Purchase Event
        window.ga("".concat(_utils_googleAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .GOOGLE_TRACKER_NAME */ .Kx, "ec:setAction"), "purchase", purchaseObject);
    }
    if (hasGtm()) {
        // Push purchaseObject into dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: GOOGLE_COMMERCE_EVENTS.purchase,
            ecommerce: {
                purchase: {
                    actionField: purchaseObject,
                    products: products
                }
            }
        });
    }
    // Conditionally send gtag purchase event if gtag is defined
    if (hasGtag()) {
        var gtagPurchaseObject = {
            transaction_id: purchaseObject.id,
            value: parseFloat(purchaseObject.revenue),
            currency: determineCurrencyCodeFromLocation(basket.checkoutBasket.location),
            tax: parseFloat(purchaseObject.tax),
            shipping: parseFloat(purchaseObject.delivery),
            coupon: purchaseObject.coupon,
            items: products.map(function(product) {
                return translateCommerceProductToGTagItem(product);
            })
        };
        window.gtag("event", "purchase", gtagPurchaseObject);
    }
}
function fireGACommerceLoginEvent(loginMethod) {
    if (hasGtag()) {
        window.gtag("event", "login", {
            method: loginMethod
        });
    }
}
/**
 * Build a basic gtag commerce event payload that contains the currency, value, coupon, and items
 * @param basket
 * @param basketMenu
 * @param coupon
 */ function buildCommerceBaseCheckoutEventPayload(basket, basketMenu, coupon) {
    var ref, ref1;
    var ref2, ref3;
    return {
        currency: determineCurrencyCodeFromLocation(basket === null || basket === void 0 ? void 0 : basket.location),
        value: parseFloat((0,_utils_basket__WEBPACK_IMPORTED_MODULE_2__/* .toDollars */ .DV)((ref2 = basket === null || basket === void 0 ? void 0 : (ref = basket.checkoutBasket) === null || ref === void 0 ? void 0 : ref.subtotal) !== null && ref2 !== void 0 ? ref2 : 0)),
        coupon: !coupon ? undefined : coupon,
        items: buildCommerceProductListFromBasketItems((ref3 = basket === null || basket === void 0 ? void 0 : (ref1 = basket.content) === null || ref1 === void 0 ? void 0 : ref1.basket_items) !== null && ref3 !== void 0 ? ref3 : [], basketMenu, basket.location).map(function(product) {
            return translateCommerceProductToGTagItem(product);
        })
    };
}
/**
 * Build a basic gtag commerce event payload that contains the added promo code and basket items
 * @param basket
 * @param basketMenu
 * @param coupon
 */ function buildCommerceBasePromoEventPayload(basket, basketMenu, coupon) {
    var ref;
    var ref1;
    var items = buildCommerceProductListFromBasketItems((ref1 = basket === null || basket === void 0 ? void 0 : (ref = basket.content) === null || ref === void 0 ? void 0 : ref.basket_items) !== null && ref1 !== void 0 ? ref1 : [], basketMenu, basket.location).map(function(product) {
        return translateCommerceProductToGTagItem(product);
    });
    return {
        promotions: [
            {
                promotion_id: coupon
            }, 
        ],
        items: items.filter(function(product) {
            return !product;
        })
    };
}
/**
 * Build a basic gtag commerce event payload that contains the currency, value, coupon, and items contained in a basket
 * @param basketItems
 * @param basketMenu
 * @param location
 */ function buildCommerceProductListFromBasketItems(basketItems, basketMenu, location) {
    // Assemble products array
    var products = [];
    basketItems.forEach(function(item) {
        var menuProduct = _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkUtils.findMenuItemById */ .fH.findMenuItemById(item.product.id, basketMenu);
        if (menuProduct) {
            var product = buildCommerceProduct(menuProduct, menuProduct === null || menuProduct === void 0 ? void 0 : menuProduct.category.name, location, item);
            if (product) {
                products.push(product);
            }
        }
    });
    return products;
}
/**
 * Determines the currency code to report based on the location.
 * @param location: Location | undefined | null
 * @return string | undefined
 */ function determineCurrencyCodeFromLocation(location) {
    if (!location) {
        return undefined;
    }
    switch(location === null || location === void 0 ? void 0 : location.country.toUpperCase()){
        case "US":
        case "USA":
            return "USD";
        case "CA":
        case "CAN":
            return "CAD";
        default:
            return undefined; //Default to undefined instead of incorrectly reporting USD in analytics data
    }
}


/***/ }),

/***/ 45048:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ EventNames; },
/* harmony export */   "x": function() { return /* binding */ GlobalEvents; }
/* harmony export */ });
var GlobalEvents;
(function(GlobalEvents) {
    GlobalEvents["ACCOUNT__ADD_FAVORITE_LOCATION"] = "ACCOUNT__ADD_FAVORITE_LOCATION";
    GlobalEvents["ACCOUNT__REMOVE_FAVORITE_LOCATION"] = "ACCOUNT__REMOVE_FAVORITE_LOCATION";
    GlobalEvents["ACCOUNT__STORED_ADDRESS_DELETED"] = "ACCOUNT__STORED_ADDRESS_DELETED";
    GlobalEvents["ARRIVAL__CONFIRM_ARRIVAL_SUCCESS"] = "ARRIVAL__CONFIRM_ARRIVAL_SUCCESS";
    GlobalEvents["AUTH__CLICK_FORGOT_PASSWORD"] = "AUTH__CLICK_FORGOT_PASSWORD";
    GlobalEvents["AUTH__CLICK_GUEST_CHECKOUT"] = "AUTH__CLICK_GUEST_CHECKOUT";
    GlobalEvents["AUTH__CLICK_LOGOUT"] = "AUTH__CLICK_LOGOUT";
    GlobalEvents["AUTH__CLICK_SIGN_IN"] = "AUTH__CLICK_SIGN_IN";
    GlobalEvents["AUTH__CLICK_SIGN_UP"] = "AUTH__CLICK_SIGN_UP";
    GlobalEvents["AUTH__SIGN_IN_SUCCESS"] = "AUTH__SIGN_IN_SUCCESS";
    GlobalEvents["AUTH__SIGN_UP_SUCCESS"] = "AUTH__SIGN_UP_SUCCESS";
    GlobalEvents["BASKET__CUSTOMIZED"] = "BASKET__CUSTOMIZED";
    GlobalEvents["CHECKOUT__CHECKOUT_VIEW"] = "CHECKOUT__CHECKOUT_VIEW";
    GlobalEvents["DELIVERY__TOGGLE"] = "DELIVERY__TOGGLE";
    GlobalEvents["GENERIC__CTA"] = "GENERIC__CTA";
    GlobalEvents["HEADER__CLOSE_BASKET"] = "HEADER__CLOSE_BASKET";
    GlobalEvents["HEADER__VIEW_BASKET"] = "HEADER__VIEW_BASKET";
    GlobalEvents["LOCATIONS__FAVORITE_LOCATION_CTA"] = "LOCATIONS__FAVORITE_LOCATION_CTA";
    GlobalEvents["LOCATIONS__LOCATION_SEARCH_NOT_FOUND"] = "LOCATIONS__LOCATION_SEARCH_NOT_FOUND";
    GlobalEvents["LOCATIONS__PRIMARY_LOCATION_CTA"] = "LOCATIONS__PRIMARY_LOCATION_CTA";
    GlobalEvents["LOCATIONS__SEARCH_LOCATIONS"] = "LOCATIONS__SEARCH_LOCATIONS";
    GlobalEvents["LOCATIONS__TOGGLE_MOBILE_DISPLAY"] = "LOCATIONS__TOGGLE_MOBILE_DISPLAY";
    GlobalEvents["LOCATIONS__TRIGGER_DELIVERY_MODAL"] = "LOCATIONS__TRIGGER_DELIVERY_MODAL";
    GlobalEvents["LOCATIONS__VIEW_ALL_LOCATIONS"] = "LOCATIONS__VIEW_ALL_LOCATIONS";
    GlobalEvents["LOCATION_RECOMMENDATIONS_SURFACED"] = "LOCATION_RECOMMENDATIONS_SURFACED";
    GlobalEvents["STORE__BASKET_RECONCILIATION"] = "STORE__BASKET_RECONCILIATION";
    GlobalEvents["STORE__CART_VIEW"] = "STORE__CART_VIEW";
    GlobalEvents["STORE__MENU_VIEW"] = "STORE__MENU_VIEW";
    GlobalEvents["STORE__PRODUCT_VIEW"] = "STORE__PRODUCT_VIEW";
    GlobalEvents["VIEW__REWARDS"] = "VIEW__REWARDS";
    GlobalEvents["VIEW__ORDER_HISTORY"] = "VIEW__ORDER_HISTORY";
    GlobalEvents["VIEW__FAVORITES"] = "VIEW__FAVORITES";
    GlobalEvents["VIEW__STORE_LOCATOR"] = "VIEW__STORE_LOCATOR";
    GlobalEvents["VIEW__INBOX"] = "VIEW__INBOX";
    GlobalEvents["VIEW__DISPATCH_TRACKING"] = "VIEW__DISPATCH_TRACKING";
    GlobalEvents["WANTED_AT_SELECTED"] = "WANTED_AT_SELECTED";
})(GlobalEvents || (GlobalEvents = {}));
var EventNames;
(function(EventNames) {
    EventNames["ORDER_NOW"] = "Order Now";
    EventNames["HOW_REWARDS_WORK"] = "How Rewards Work";
    EventNames["UTENSILS_SET"] = "Set Basket Utensils";
    EventNames["CHANGE_LOCATION"] = "Change Location Button";
    EventNames["CHANGE_DELIVERY_ADDRESS"] = "Change Delivery Address Button";
    EventNames["BACK_TO_MENU"] = "Back To Menu";
    EventNames["RESTART_ORDER"] = "Restart Order";
    EventNames["APPLY_NEW_WANTED_TIME"] = "Apply New Wanted Time";
    EventNames["APPEND_USER_PHONE"] = "Append User Phone";
    EventNames["CONFIRM_ARRIVAL"] = "Confirm Customer Arrival";
    EventNames["ANDROID_NAVIGATION"] = "Navigation Drawer";
    EventNames["ANDROID_HOME"] = "Welcome screen";
    EventNames["LOCATIONS_SURFACED_GEOLOCATION"] = "GEOLOCATION";
    EventNames["LOCATIONS_SURFACED_IPADDRESS"] = "IP_ADDRESS";
    EventNames["LOCATIONS_SURFACED_DEFAULT"] = "ALL_LOCATIONS";
    EventNames["DISPATCH_TRACKING_ROUTING_FROM_CHECKOUT"] = "DISPATCH_TRACKING_ROUTING_FROM_CHECKOUT";
    EventNames["DISPATCH_TRACKING_ROUTING_DIRECT_URL"] = "DISPATCH_TRACKING_ROUTING_DIRECT_URL";
})(EventNames || (EventNames = {}));


/***/ }),

/***/ 45003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O": function() { return /* binding */ genericEventHandler; },
  "f": function() { return /* binding */ pageViewEventHandler; }
});

// EXTERNAL MODULE: ./src/analytics/integrations/branch/index.ts
var branch = __webpack_require__(81425);
// EXTERNAL MODULE: ./src/analytics/integrations/facebook/index.ts
var facebook = __webpack_require__(1371);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ./src/utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__(87809);
;// CONCATENATED MODULE: ./src/analytics/integrations/google/analytics.ts

/** @deprecated Google Universal Analytics will cease to collect data on July 1, 2023 */ var fireGaPageView = function(page) {
    if (typeof (window === null || window === void 0 ? void 0 : window.ga) !== "function") {
        return;
    }
    window.ga("".concat(googleAnalytics/* GOOGLE_TRACKER_NAME */.Kx, "send"), {
        hitType: "pageview",
        page: page
    });
};
/** @deprecated Google Universal Analytics will cease to collect data on July 1, 2023 */ var fireGaGenericEvent = function(event, context) {
    if (typeof (window === null || window === void 0 ? void 0 : window.ga) !== "function") {
        return;
    }
    // Google actions should map to the static eventName, unless it is not defined this
    // means the action should be dynamic, in which case, use the context.name
    var eventAction = event.eventName || context.name;
    // If the eventName is undefined, we've used the context.name as the action
    // meaning we should use the context.details as the label
    var eventLabel = event.eventName ? context.name : context.details;
    var mergedParams = {
        hitType: "event",
        eventCategory: event.eventCategory,
        eventAction: eventAction,
        eventLabel: eventLabel
    };
    window.ga("".concat(googleAnalytics/* GOOGLE_TRACKER_NAME */.Kx, "send"), mergedParams);
};

;// CONCATENATED MODULE: ./src/analytics/integrations/google/tagManager.ts
var pushDataLayerPageView = function(path) {
    if (!window.koalaGoogleTagManagerConfigured) {
        return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "pageview",
        page: {
            path: path
        }
    });
};
var pushDataLayerGenericEvent = function(event, context) {
    if (!window.koalaGoogleTagManagerConfigured) {
        return;
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: event.eventName || context.name
    });
};

;// CONCATENATED MODULE: ./src/analytics/integrations/google/gtagjs.ts
var pushGTagGenericEvent = function(event, context) {
    var _eventName;
    var eventName = (_eventName = event.eventName) !== null && _eventName !== void 0 ? _eventName : context.name;
    if (eventName && typeof (window === null || window === void 0 ? void 0 : window.gtag) === "function") {
        window === null || window === void 0 ? void 0 : window.gtag("event", eventName, event);
    }
};

;// CONCATENATED MODULE: ./src/analytics/integrations/google/index.ts




// Generic Events
var GoogleCategories = {
    CTA: "CTA",
    AUTH: "Auth",
    ORDER: "Order",
    LOCATIONS: "Locations",
    ACCOUNT: "Account"
};
var GoogleEvents = {
    HEADER__VIEW_BASKET: {
        eventName: "View Basket",
        eventCategory: GoogleCategories.ORDER
    },
    HEADER__CLOSE_BASKET: {
        eventName: "Close Basket",
        eventCategory: GoogleCategories.ORDER
    },
    AUTH__CLICK_SIGN_UP: {
        eventName: "Click Sign Up",
        eventCategory: GoogleCategories.AUTH
    },
    AUTH__CLICK_SIGN_IN: {
        eventName: "Click Sign In",
        eventCategory: GoogleCategories.AUTH
    },
    AUTH__CLICK_FORGOT_PASSWORD: {
        eventName: "Click Forgot Password",
        eventCategory: GoogleCategories.AUTH
    },
    AUTH__CLICK_GUEST_CHECKOUT: {
        eventName: "Click Guest Checkout",
        eventCategory: GoogleCategories.AUTH
    },
    AUTH__SIGN_UP_SUCCESS: {
        eventName: "Sign Up Success",
        eventCategory: GoogleCategories.AUTH
    },
    AUTH__SIGN_IN_SUCCESS: {
        eventName: "Sign In Success",
        eventCategory: GoogleCategories.AUTH
    },
    LOCATIONS__VIEW_ALL_LOCATIONS: {
        eventName: "View All Locations",
        eventCategory: GoogleCategories.LOCATIONS
    },
    LOCATIONS__SEARCH_LOCATIONS: {
        eventName: "Address Search",
        eventCategory: GoogleCategories.LOCATIONS
    },
    LOCATIONS__TOGGLE_MOBILE_DISPLAY: {
        eventName: "Toggle Mobile Display",
        eventCategory: GoogleCategories.LOCATIONS
    },
    LOCATIONS__TRIGGER_DELIVERY_MODAL: {
        eventName: "Trigger Delivery Modal",
        eventCategory: GoogleCategories.LOCATIONS
    },
    LOCATIONS__PRIMARY_LOCATION_CTA: {
        eventName: "Primary Location CTA",
        eventCategory: GoogleCategories.LOCATIONS
    },
    GENERIC__CTA: {
        eventName: null,
        eventCategory: GoogleCategories.CTA
    },
    AUTH__CLICK_LOGOUT: {
        eventName: "Click Logout",
        eventCategory: GoogleCategories.CTA
    },
    ACCOUNT__ADD_FAVORITE_LOCATION: {
        eventName: "Favorite Shop",
        eventCategory: GoogleCategories.ACCOUNT
    },
    ACCOUNT__REMOVE_FAVORITE_LOCATION: {
        eventName: "Unfavorite Shop",
        eventCategory: GoogleCategories.ACCOUNT
    },
    DELIVERY__TOGGLE: {
        eventName: "Delivery Toggle",
        eventCategory: GoogleCategories.CTA
    }
};
/**
 * Google Analytics
 */ var GoogleAnalytics = /*#__PURE__*/ function() {
    "use strict";
    function GoogleAnalytics() {
        (0,_class_call_check/* default */.Z)(this, GoogleAnalytics);
    }
    /**
   * Page View Event
   */ GoogleAnalytics.pageView = function pageView(page) {
        // GA
        fireGaPageView(page);
        // GTM
        pushDataLayerPageView(page);
    // Gtag.js automatically tracks page views
    };
    /**
   * Generic Events
   */ GoogleAnalytics.genericEvent = function genericEvent(globalEvent, context) {
        /**
     * @TODO: Consolidate use of src/utils/googleAnalytics.js into this file. There are
     *  numerous places where generic events are being fired through methods specific for
     *  each analytics platform (Koala, Google, Facebook, etc.) and fired through the
     *  collective "branch" analytics handler.
     * @TODO: Add Ecommerce events to the list of generic events in IGlobalEvents and treat
     *  Ecommerce as a "branch" analytics handler that listens only to those events.
     */ var event = GoogleEvents === null || GoogleEvents === void 0 ? void 0 : GoogleEvents[globalEvent];
        if (event) {
            // GA
            /** @TODO ensure that the event is defined. */ fireGaGenericEvent(event, context);
            // GTM
            /** @TODO ensure that the event is defined. */ pushDataLayerGenericEvent(event, context);
            // Gtag.js
            pushGTagGenericEvent(event, context);
        }
    };
    return GoogleAnalytics;
}();

// EXTERNAL MODULE: ./src/utils/koalaAnalytics.ts + 1 modules
var koalaAnalytics = __webpack_require__(61216);
;// CONCATENATED MODULE: ./src/analytics/events/index.ts
// Integrations




var pageViewEventHandler = function(page) {
    var path = page || window.location.pathname;
    // Google
    GoogleAnalytics.pageView(path);
    // Branch
    branch/* BranchAnalytics.pageView */.y.pageView();
    // Facebook
    facebook/* FacebookAnalytics.pageView */.Z.pageView();
    // Koala Analytics
    koalaAnalytics/* GenericKoalaAnalyticsWrapper.pageView */.b2.pageView(path);
    // React Native
    if ( true && window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(path);
    }
};
var genericEventHandler = function(eventName) {
    var eventContext = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    // Google
    GoogleAnalytics.genericEvent(eventName, eventContext);
    // Branch
    branch/* BranchAnalytics.genericEvent */.y.genericEvent(eventName, eventContext);
    // Koala Analytics
    koalaAnalytics/* GenericKoalaAnalyticsWrapper.genericEvent */.b2.genericEvent(eventName, eventContext);
};


/***/ }),

/***/ 81425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ BranchAnalytics; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90581);
/* harmony import */ var _utils_basket__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1227);


// Generic Events
var BranchEvents = {
    HEADER__VIEW_BASKET: {
        eventName: "VIEW_CART"
    }
};
/**
 * Branch
 */ var hasBranch = function() {
    return typeof window.branch !== "undefined";
};
var BranchAnalytics = /*#__PURE__*/ function() {
    "use strict";
    function BranchAnalytics() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, BranchAnalytics);
    }
    /**
   * Page View Event
   */ BranchAnalytics.pageView = function pageView() {
        if (!hasBranch()) {
            return;
        }
        window.branch.track("pageview");
    };
    /**
   * Generic Events
   */ BranchAnalytics.genericEvent = function genericEvent(globalEvent, context) {
        if (!hasBranch()) {
            return;
        }
        if (!BranchEvents[globalEvent]) {
            return;
        }
        /** @TODO ensure that the event name is defined. */ // @ts-ignore
        window.branch.logEvent(BranchEvents[globalEvent].eventName, context);
    };
    /**
   * Commerce Events
   */ BranchAnalytics.addProduct = function addProduct(item, location) {
        if (!hasBranch()) {
            return;
        }
        window.branch.logEvent("ADD_TO_CART", {
            productName: item.product.name,
            location: location.label
        });
    };
    BranchAnalytics.paymentSet = function paymentSet() {
        if (!hasBranch()) {
            return;
        }
        window.branch.logEvent("ADD_PAYMENT_INFO");
    };
    BranchAnalytics.purchase = function purchase(orderDetails, state) {
        if (!hasBranch()) {
            return;
        }
        var location = state.app.basket.location;
        var coupon = state.app.promoCode.applied;
        /** @TODO ensure that `promo_discount` is defined. */ window.branch.logEvent("PURCHASE", {
            id: orderDetails.order_data.order.order_number,
            affiliation: "Store: ".concat(location.location_id, " - ").concat(location.label),
            revenue: (0,_utils_basket__WEBPACK_IMPORTED_MODULE_0__/* .toDollars */ .DV)(orderDetails.order_data.order.total + // @ts-ignore
            orderDetails.order_data.order.promo_discount),
            tax: (0,_utils_basket__WEBPACK_IMPORTED_MODULE_0__/* .toDollars */ .DV)(orderDetails.order_data.order.sales_tax),
            coupon: coupon
        });
    };
    return BranchAnalytics;
}();


/***/ }),

/***/ 1371:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ FacebookAnalytics; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(90581);
/* harmony import */ var _utils_basket__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1227);


/**
 * Facebook
 */ var hasFacebook = function() {
    return window.koalaFacebookPixelConfigured === true && typeof window.fbq !== "undefined";
};
var FacebookAnalytics = /*#__PURE__*/ function() {
    "use strict";
    function FacebookAnalytics() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(this, FacebookAnalytics);
    }
    /**
   * Page View Event
   */ FacebookAnalytics.pageView = function pageView() {
        if (!hasFacebook()) {
            return;
        }
        window.fbq("track", "PageView");
    };
    /**
   * Commerce Events
   */ FacebookAnalytics.purchase = function purchase(orderDetails) {
        if (!hasFacebook()) {
            return;
        }
        var eventId = orderDetails.order_id || orderDetails.id;
        var orderNumber = orderDetails.order_data.order.order_number || orderDetails.order_number || orderDetails.order_id;
        window === null || window === void 0 ? void 0 : window.fbq("track", "Purchase", {
            value: (0,_utils_basket__WEBPACK_IMPORTED_MODULE_0__/* .toDollars */ .DV)(orderDetails.order_data.order.total),
            currency: FacebookAnalytics.determineCurrencyCodeFromLocation(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.location),
            order_id: orderNumber
        }, {
            eventID: eventId
        });
    };
    /**
   * Determines the currency code to report based on the location's 2-letter or 3-letter country code.
   * @param location: Location | undefined | null
   * @return string | undefined
   */ FacebookAnalytics.determineCurrencyCodeFromLocation = function determineCurrencyCodeFromLocation(location) {
        if (!location) {
            return undefined;
        }
        switch(location === null || location === void 0 ? void 0 : location.country.toUpperCase()){
            case "US":
            case "USA":
                return "USD";
            case "CA":
            case "CAN":
                return "CAD";
            default:
                return undefined; //Default to undefined instead of incorrectly reporting USD in analytics data
        }
    };
    return FacebookAnalytics;
}();


/***/ }),

/***/ 5125:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZV": function() { return /* binding */ SIGNUP_OPTIONAL_FIELDS; },
/* harmony export */   "dD": function() { return /* binding */ EXTERNAL_AUTH_FEATURES; },
/* harmony export */   "g7": function() { return /* binding */ DEFAULT_PASSWORD_LOGIN_EXTRA_PAYLOAD; },
/* harmony export */   "i5": function() { return /* binding */ CAPTCHA_CONFIG; },
/* harmony export */   "sq": function() { return /* binding */ DEFAULT_SOCIAL_EXTRA_PAYLOAD; }
/* harmony export */ });
/* unused harmony export CAPTCHA_ACTIONS */
var DEFAULT_SOCIAL_EXTRA_PAYLOAD = {
    flow_type: "implicit"
};
var DEFAULT_PASSWORD_LOGIN_EXTRA_PAYLOAD = {
    flow_type: "password"
};
var CAPTCHA_ACTIONS;
(function(CAPTCHA_ACTIONS) {
    CAPTCHA_ACTIONS["LOGIN"] = "login";
    CAPTCHA_ACTIONS["REGISTER"] = "register";
    CAPTCHA_ACTIONS["STORED_VALUE_BALANCE"] = "stored_value_balance";
    CAPTCHA_ACTIONS["SUBMISSION"] = "submission";
})(CAPTCHA_ACTIONS || (CAPTCHA_ACTIONS = {}));
var CAPTCHA_CONFIG = {
    FIELD_NAME: "captcha_response",
    API_ACTIONS: CAPTCHA_ACTIONS
};
var SIGNUP_OPTIONAL_FIELDS;
(function(SIGNUP_OPTIONAL_FIELDS) {
    SIGNUP_OPTIONAL_FIELDS["TERMS_AND_CONDITIONS"] = "terms_and_conditions";
    SIGNUP_OPTIONAL_FIELDS["OPT_IN"] = "opt_in";
    SIGNUP_OPTIONAL_FIELDS["BIRTHDAY"] = "birthday";
    SIGNUP_OPTIONAL_FIELDS["REFERRAL_CODE"] = "invite_code";
    SIGNUP_OPTIONAL_FIELDS["ZIP_CODE"] = "zip_code";
})(SIGNUP_OPTIONAL_FIELDS || (SIGNUP_OPTIONAL_FIELDS = {}));
var EXTERNAL_AUTH_FEATURES;
(function(EXTERNAL_AUTH_FEATURES) {
    EXTERNAL_AUTH_FEATURES["REQUIRES_EMAIL_VERIFICATION"] = "requiresEmailVerification";
    EXTERNAL_AUTH_FEATURES["SUPPORT_FOR_LOGIN_WITH_SOCIAL"] = "supportForLoginWithSocial";
    EXTERNAL_AUTH_FEATURES["SUPPORTS_STORED_CARDS"] = "supportsStoredCards";
    EXTERNAL_AUTH_FEATURES["SUPPORTS_SINGLE_FAVORITE_LOCATIONS"] = "supportsSingleFavoriteLocations";
    EXTERNAL_AUTH_FEATURES["SUPPORTS_STORED_ADDRESSES"] = "supportsStoredAddresses";
    EXTERNAL_AUTH_FEATURES["UPDATE_STORED_ADDRESSES"] = "updateStoredAddresses";
    EXTERNAL_AUTH_FEATURES["LIST_STORED_ADDRESSES"] = "listStoredAddresses";
    EXTERNAL_AUTH_FEATURES["DELETE_STORED_ADDRESSES"] = "deleteStoredAddresses";
    EXTERNAL_AUTH_FEATURES["SUPPORTS_ACCOUNT_DELETION"] = "supportsAccountDeletion";
})(EXTERNAL_AUTH_FEATURES || (EXTERNAL_AUTH_FEATURES = {}));


/***/ }),

/***/ 65001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bv": function() { return /* binding */ DELIVERY_STATUS_POLLING_INTERVAL; },
/* harmony export */   "R0": function() { return /* binding */ InitializationErrorTypes; },
/* harmony export */   "l6": function() { return /* binding */ DRIVER_NAME_DEFAULT_VALUE; },
/* harmony export */   "lY": function() { return /* binding */ InitializationSteps; },
/* harmony export */   "oC": function() { return /* binding */ INITIALIZATION_ERRORS; }
/* harmony export */ });
var InitializationSteps;
(function(InitializationSteps) {
    InitializationSteps["CREATE_BASKET"] = "CREATE_BASKET";
    InitializationSteps["SET_WANTED_AT"] = "SET_WANTED_AT";
    InitializationSteps["SET_CONVEYANCE"] = "SET_CONVEYANCE";
    InitializationSteps["VALIDATE"] = "VALIDATE";
})(InitializationSteps || (InitializationSteps = {}));
var InitializationErrorTypes;
(function(InitializationErrorTypes) {
    InitializationErrorTypes["THROTTLING"] = "throttling";
    InitializationErrorTypes["HANDLED"] = "handled";
    InitializationErrorTypes["UNHANDLED"] = "unhandled";
    InitializationErrorTypes["LOCK"] = "lock";
    InitializationErrorTypes["PHONE"] = "phone";
})(InitializationErrorTypes || (InitializationErrorTypes = {}));
var INITIALIZATION_ERRORS = {
    // THROTTLING
    // GOOP
    "There are lots of orders coming in": InitializationErrorTypes.THROTTLING,
    "please choose another time": InitializationErrorTypes.THROTTLING,
    "There are lots of orders coming in at goop Kitchen - Santa Monica and we can't start your order quite yet. Thank you for your patience and understanding. Please try again later.": InitializationErrorTypes.THROTTLING,
    // MOD
    "MOD Pizza is currently experiencing high order volume for this location. Please select a later time.": InitializationErrorTypes.THROTTLING,
    // P.F. Changs
    "experiencing a high order volume and cannot immediately start your order. Please select another time for pickup or delivery.": InitializationErrorTypes.THROTTLING,
    // Pancheros
    "is experiencing high order volume and cannot immediately start your order.": InitializationErrorTypes.THROTTLING,
    "high order volume and cannot prepare your order": InitializationErrorTypes.THROTTLING,
    // Scratch
    "We're sorry your order cannot be placed. The kitchen is really busy right now so please choose a time slot at least 30 minutes from now for us to prepare your food.": InitializationErrorTypes.THROTTLING,
    // Global
    "Sorry, it looks like your delivery destination is out of range, or there isn't an available driver for the delivery time you selected. Please schedule your delivery for another time or place your order for pickup.": InitializationErrorTypes.THROTTLING,
    "Delivery is not currently available to your address. Please try again later or order for Pickup!": InitializationErrorTypes.THROTTLING,
    "No delivery services are available to handle this order at this time.": InitializationErrorTypes.THROTTLING,
    "Please schedule your order for another time or select another order type.": InitializationErrorTypes.THROTTLING,
    "Please schedule your order for another time.": InitializationErrorTypes.THROTTLING,
    "A future date is required.": InitializationErrorTypes.THROTTLING,
    "There was an issue setting your desired ready time.": InitializationErrorTypes.THROTTLING,
    // HANDLED
    // KOALA
    "Please ensure that your delivery zip code is not longer than 6 digits.": InitializationErrorTypes.HANDLED,
    // OLO
    "More than one result was returned for this address. Please make this address as specific as possible.": InitializationErrorTypes.HANDLED,
    "not available for delivery orders": InitializationErrorTypes.HANDLED,
    "currently unavailable.": InitializationErrorTypes.HANDLED,
    "Choose between": InitializationErrorTypes.HANDLED,
    "Your address is either outside of range or a driver isn't available at this time. Please select another method to receive your order.": InitializationErrorTypes.HANDLED,
    "A delivery address is required for this order.": InitializationErrorTypes.HANDLED,
    "We're sorry, some items in your cart are no longer available. Please review your cart and try again.": InitializationErrorTypes.HANDLED,
    "We're sorry - you're attempting to order delivery from too far away. You can still place your order for pick-up!": InitializationErrorTypes.HANDLED,
    "You have selected an item that is temporarily unavailable for online ordering.": InitializationErrorTypes.HANDLED,
    "remove any unavailable items": InitializationErrorTypes.HANDLED,
    "Only orders above": InitializationErrorTypes.HANDLED,
    // LOCK
    "Oops, we're having trouble loading this page. Please try again soon": InitializationErrorTypes.LOCK,
    "Bad Gateway": InitializationErrorTypes.LOCK,
    "The special instructions must be a string., The location.id field is required when from order id is not present., The basket items field is required when from order id is not present.": InitializationErrorTypes.LOCK,
    "Unable to set conveyance": InitializationErrorTypes.LOCK,
    // PHONE
    "The phone number field is required.": InitializationErrorTypes.PHONE
};
/** In Milliseconds. */ var DELIVERY_STATUS_POLLING_INTERVAL = 60000;
var DRIVER_NAME_DEFAULT_VALUE = "Your Driver";


/***/ }),

/***/ 80420:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ CHECKOUT_AUTH_TYPES; },
/* harmony export */   "X": function() { return /* binding */ PRODUCT_LOCATION_LABELS; }
/* harmony export */ });
var CHECKOUT_AUTH_TYPES = {
    DEFAULT: "default",
    LOGIN: "login",
    SIGNUP: "signup",
    GUEST: "guest",
    USER_INFO: "user info",
    UNVERIFIED_EMAIL: "unverified_email"
};
var PRODUCT_LOCATION_LABELS;
(function(PRODUCT_LOCATION_LABELS) {
    PRODUCT_LOCATION_LABELS["BASKET"] = "Basket";
    PRODUCT_LOCATION_LABELS["CROSS_SELL"] = "Cross-sell";
    PRODUCT_LOCATION_LABELS["MENU"] = "Menu";
})(PRODUCT_LOCATION_LABELS || (PRODUCT_LOCATION_LABELS = {}));


/***/ }),

/***/ 32159:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ CTA; }
/* harmony export */ });
var CTA = {
    PICKUP_URL: "$pickupUrl$",
    DELIVERY_URL: "$deliveryUrl$"
};


/***/ }),

/***/ 81584:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ DATE_FORMAT; }
/* harmony export */ });
var DATE_FORMAT = {
    HOURS_WITH_MINUTES: "h:mmaaa",
    MONTH_WITH_YEAR: "MM/yy",
    WEEKDAY: "EEEE",
    MONTH_DAY_YEAR: "MM/dd/yyyy",
    MONTH_DAY_YEAR_DASHED: "MM-dd-yyyy",
    WRITTEN_OUT_DATE: "MMMM dd, yyyy",
    SHORT_WRITTEN_DATE: "MMM dd, yyyy",
    YEAR_MONTH_DAY_DASHED: "yyyy-MM-dd",
    YEAR_MONTH_DAY: "yyyyMMdd",
    YEAR: "yyyy",
    LABEL: "eee, MMM d",
    FULFILLMENT_TIME: "eee, MMM d 'at' h:mmaaa",
    UTC_OFFSET: "x",
    ISO_DATE: "yyyy-MM-dd'T'HH:mm:ssXXX",
    DAY_MONTH_TIME: "MM/dd, h:mmaaa"
};


/***/ }),

/***/ 73690:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bS": function() { return /* binding */ BUILD_VERSION; },
  "Vi": function() { return /* binding */ ENV; },
  "oj": function() { return /* binding */ SENTRY_DSN; },
  "I4": function() { return /* binding */ clientId; },
  "Gs": function() { return /* binding */ clientSecret; }
});

// EXTERNAL MODULE: ../../packages/sdk/dist/index.mjs + 1 modules
var dist = __webpack_require__(80684);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ./src/utils/android.ts
var android = __webpack_require__(90484);
;// CONCATENATED MODULE: ./package.json
var package_namespaceObject = {"i8":"1.69.0"};
;// CONCATENATED MODULE: ./src/constants/envConfig.ts




var runtimeCredentials = lib.z.object({
    ENV: dist/* KoalaEnv */.dI,
    clientId: lib.z.string(),
    clientSecret: lib.z.string()
});
/**
 * Returns the correct environment, Client ID, & Secret for the build.
 * The returned values depend on a few different factors:
 * 1. Are we in local development mode (i.e. running `yarn start:ordering`)?
 * 2. Are we in the Android Kotlin shell?
 * 3. Are we running in a deployed build?
 */ function setup() {
    var env = dist/* KoalaEnv.parse */.dI.parse("production");
    // If we're in the Android Kotlin shell, use its Client ID & Secret.
    if ((0,android/* isAndroidShell */.Y2)()) {
        var config = runtimeCredentials.parse({
            ENV: env,
            clientId: window.KoalaAndroidShell.getClientId(),
            clientSecret: window.KoalaAndroidShell.getClientSecret()
        });
        return config;
    }
    /**
   * Otherwise, the build is deployed. The Client ID & Secret share
   * the same environment variable names across all environments.
   */ var config1 = runtimeCredentials.parse({
        ENV: env,
        clientId: "Ukd4B0hn9uGdkWoTM1AfqYEb8u5BDhHF3XBKMGEbQ3wCcrf0mmvEslXPSt12WkbpxUKg7T9CTfVeVsCCK28a9sot6FWdGGoWQbbktFYapSxpWFxw523lgwLS",
        clientSecret: "NAWT2Wn0JyxyfBmADpEGpstJ6TlbAmNUrqcWThgxnCiqKe3TOX1AAXd4X3BHz2EN9OnIVMWkpNN6su2l1ZneBSpIc7gx4NmUSkQWiXRqGcoX165jtRB7o6ZX"
    });
    return config1;
}
var ref = setup();
var ENV = ref.ENV, clientId = ref.clientId, clientSecret = ref.clientSecret;
var BUILD_VERSION = package_namespaceObject.i8;
var SENTRY_DSN = "https://22cecf8f927247b29a79adc234f9d8b8@o141334.ingest.sentry.io/4504572378808320";


/***/ }),

/***/ 26654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AH": function() { return /* binding */ K_ANALYTICS_EVENTS; },
/* harmony export */   "CA": function() { return /* binding */ K_ANALYTICS_PLATFORMS; },
/* harmony export */   "RZ": function() { return /* binding */ ERROR_MESSAGES; },
/* harmony export */   "oO": function() { return /* binding */ BASKET_ORDER_KEYS; },
/* harmony export */   "tG": function() { return /* binding */ K_ANALYTICS_CTA_LOCATIONS; },
/* harmony export */   "tQ": function() { return /* binding */ API_CONVEYANCE_TYPES; },
/* harmony export */   "yX": function() { return /* binding */ LOG_EVENTS; },
/* harmony export */   "zr": function() { return /* binding */ MODAL; }
/* harmony export */ });
// Koala Analytics Event Screens
var K_ANALYTICS_EVENTS = {
    ACCOUNT_CREATED: "ACCOUNT_CREATED",
    BARCODE_APPLY: "BARCODE_APPLY",
    BASKET_CUSTOMIZED: "BASKET_CUSTOMIZED",
    BASKET_EDIT_TRIGGER: "BASKET_EDIT_TRIGGER",
    BASKET_INSTRUCTIONS_SET: "BASKET_INSTRUCTIONS_SET",
    BASKET_RECONCILIATION: "BASKET_RECONCILIATION",
    BASKET_STAGED: "BASKET_STAGED",
    BASKET_UPDATE: "BASKET_UPDATE",
    BASKET_WANTED_AT_UPDATE: "BASKET_WANTED_AT_UPDATE",
    CART_PERSISTED: "CART_PERSISTED",
    CART_RESET: "CART_RESET",
    CART_VIEW: "CART_VIEW",
    CHECKOUT_VIEW: "CHECKOUT_VIEW",
    CONFIRM_ARRIVAL_SUCCESS: "CONFIRM_ARRIVAL_SUCCESS",
    CONVEYANCE_TOGGLE: "CONVEYANCE_TOGGLE",
    CREDIT_CARD_DELETED: "CREDIT_CARD_DELETED",
    CREDIT_CARD_SAVED: "CREDIT_CARD_SAVED",
    CROSS_SELL_PRESENTED: "CROSS_SELL_PRESENTED",
    CTA: "CTA",
    DELIVERY_ADDRESS_VALIDATED: "DELIVERY_ADDRESS_VALIDATED",
    DELIVERY_TOGGLE: "DELIVERY_TOGGLE",
    DIETARY_PREFERENCES_UPDATED: "DIETARY_PREFERENCES_UPDATED",
    ERROR: "ERROR",
    FIRST_PRODUCT_ADDED: "FIRST_PRODUCT_ADDED",
    GEOLOCATION_SEARCH: "GEOLOCATION_SEARCH",
    GIFT_CARD_APPLIED: "GIFT_CARD_APPLIED",
    GIFT_CARD_REMOVED: "GIFT_CARD_REMOVED",
    ITEMS_NOT_AVAILABLE: "ITEMS_NOT_AVAILABLE",
    LOCATION_CHANGE: "LOCATION_CHANGE",
    LOCATION_CTA: "LOCATION_CTA",
    LOCATION_FAVORITE_CTA: "LOCATION_FAVORITE_CTA",
    LOCATION_FAVORITED: "LOCATION_FAVORITED",
    LOCATION_SEARCH_NOT_FOUND: "LOCATION_SEARCH_NOT_FOUND",
    LOCATION_SEARCH: "LOCATION_SEARCH",
    LOCATION_UNFAVORITED: "LOCATION_UNFAVORITED",
    LOCATION_VIEW_TOGGLE: "LOCATION_VIEW_TOGGLE",
    LOCATION_RECOMMENDATIONS_SURFACED: "LOCATION_RECOMMENDATIONS_SURFACED",
    LOG: "LOG",
    LOGIN: "LOGIN",
    LOGOUT: "LOGOUT",
    LOYALTY_MESSAGE_DELETE: "LOYALTY_MESSAGE_DELETE",
    LOYALTY_MESSAGE_READ: "LOYALTY_MESSAGE_READ",
    MASTER_CATEGORY_SELECTED: "MASTER_CATEGORY_SELECTED",
    MENU_SEARCH: "MENU_SEARCH",
    MENU_VIEW: "MENU_VIEW",
    ORDER_FAVORITED: "ORDER_FAVORITED",
    ORDER_SUBMISSION_STARTED: "ORDER_SUBMISSION_STARTED",
    ORDER_SUBMISSION_TRIGGERED: "ORDER_SUBMISSION_TRIGGERED",
    ORDER_SUBMITTED: "ORDER_SUBMITTED",
    ORDER_UNFAVORITED: "ORDER_UNFAVORITED",
    PRODUCT_VIEW: "PRODUCT_VIEW",
    PROMO_CODE_APPLIED: "PROMO_CODE_APPLIED",
    PROMO_CODE_REMOVED: "PROMO_CODE_REMOVED",
    QR_MEMBERSHIP_VIEW: "QR_MEMBERSHIP_VIEW",
    QR_OFFER_VIEW: "QR_OFFER_VIEW",
    QR_REWARD_VIEW: "QR_REWARD_VIEW",
    REORDER_ERROR: "REORDER_ERROR",
    REORDER: "REORDER",
    REWARD_APPLIED: "REWARD_APPLIED",
    REWARD_REMOVED: "REWARD_REMOVED",
    SCREEN: "SCREEN",
    SESSION_START_WITH_EXISTING_BASKET: "SESSION_START_WITH_EXISTING_BASKET",
    SESSION_START: "SESSION_START",
    SHOW_TOOLTIP: "SHOW_TOOLTIP",
    STORED_ADDRESS_DELETED: "STORED_ADDRESS_DELETED",
    TIP_ADDED: "TIP_ADDED",
    USER_UPDATE: "USER_UPDATE",
    UTENSILS_SET: "UTENSILS_SET",
    VIEW_ALL_LOCATIONS: "VIEW_ALL_LOCATIONS",
    VIEW_LOCATION_INFO: "VIEW_LOCATION_INFO",
    VIEW_REWARDS: "REWARDS_VIEW",
    VIEW_ORDER_HISTORY: "ORDER_HISTORY_VIEW",
    VIEW_FAVORITES: "FAVORITES_VIEW",
    VIEW_STORE_LOCATOR: "STORE_LOCATOR_VIEW",
    VIEW_INBOX: "INBOX_VIEW",
    VIEW_DISPATCH_TRACKING: "DISPATCH_TRACKING_VIEW",
    WANTED_AT_SELECTED: "WANTED_AT_SELECTED",
    ORDER_SUBMISSION_FAILED: "ORDER_SUBMISSION_FAILED"
};
var K_ANALYTICS_PLATFORMS;
(function(K_ANALYTICS_PLATFORMS) {
    K_ANALYTICS_PLATFORMS["DESKTOP_WEB"] = "desktop_web";
    K_ANALYTICS_PLATFORMS["MOBILE_WEB"] = "mobile_web";
    K_ANALYTICS_PLATFORMS[// Android is for use when the web app is a web-view inside our Android Kotlin shell
    "ANDROID"] = "mobile_android";
})(K_ANALYTICS_PLATFORMS || (K_ANALYTICS_PLATFORMS = {}));
// Used in `fireGenericOrderEventsHandler`
var BASKET_ORDER_KEYS = {
    TRANSACTION: "transaction",
    ORDER: "order",
    BASKET_PRODUCTS: "basket_products"
};
var ERROR_MESSAGES = {
    APPLICATION_ERROR: "Application Error",
    BASKET_VALIDATION_ERROR: "Basket Validation Error",
    LOGIN_FAILURE: "Login Failure",
    LOGOUT_FAILURE: "Logout Failure",
    CREATE_ACCOUNT_FAILURE: "Create Account Failure",
    RESTART_USER_SESSION_FAILURE: "Restart User Session Failure",
    FORGOT_PASSWORD_FAILURE: "Forgot Password Failure",
    PASSWORD_RESET_FAILURE: "Password Reset Failure",
    VALIDATE_DELIVERY_ADDRESS_ERROR: "Validate Delivery Address Error",
    SET_DELIVERY_ADDRESS_ERROR: "Set Delivery Address Error",
    SET_WANTED_TIME_ERROR: "Set Wanted Time Error",
    FETCH_LOCATIONS_FAILURE: "Fetch Locations Failure",
    FETCH_MORE_LOCATIONS_FAILURE: "Fetch More Locations Failure",
    INVALID_ZIP_ERROR: "Invalid Zip Error",
    SEARCH_LOCATION_ERROR: "Search Location Error",
    FETCH_LOCATION_ERROR: "Fetch Location Error",
    HYDRATE_LOCATION_ERROR: "Hydrate Location Error",
    FETCH_REWARDS_ERROR: "Fetch Rewards Error",
    FETCH_SAVED_CARDS_FAILURE: "Fetch Saved Cards Failure",
    ADD_REWARDS_FAILURE: "Add Rewards Failure",
    REWARD_NOT_VALID: "Reward Not Valid",
    ADD_PROMO_FAILURE: "Add Promo Failure",
    CANNOT_FIND_PROMO_TO_REMOVE: "Cannot Find Promo To Remove",
    REMOVE_PROMO_FAILURE: "Remove Promo Failure",
    REMOVE_REWARDS_FAILURE: "Remove Rewards Failure",
    SET_PICKUP_TIME_ERROR: "Set Pickup Time Error",
    SET_CONVEYANCE_ERROR: "Set Conveyance Failure",
    SET_CONVEYANCE_ERROR_ERROR: "Error Setting Conveyance Failure",
    REMOVE_PICKUP_TIME_ERROR: "Remove Pickup Time Error",
    ADD_TIP_ERROR: "Add Tip Error",
    ADD_ITEM_TOAST_ERROR: "Add Item Toast Error",
    CROSS_SELL_QUICK_ADD_TOAST_ERROR: "Cross Sell Quick Add Toast Error",
    FETCH_USER_DETAILS_ERROR: "Fetch User Details Error",
    FETCH_FAVORITE_LOCATIONS_ERROR: "Fetch Favorite Locations Error",
    UPDATE_ME_FAILURE: "Update Me Failure",
    FETCH_FAVORITE_ORDERS_ERROR: "Fetch Favorite Orders Error",
    FETCH_ORDER_HISTORY_ERROR: "Fetch Order History Error",
    FETCH_PAYMENT_INFORMATION_ERROR: "Fetch Payment Information Error",
    FETCH_ALL_LOCATIONS_CC_ERROR: "Fetch All Locations Credit Cards Error",
    FETCH_ORDER_DETAILS_ERROR: "Fetch Order Details Error",
    DELETE_CREDIT_CARD_ERROR: "Delete Credit Card Error",
    UNFAVORITE_LOCATION_ERROR: "Unfavorite Location Error",
    FAVORITE_LOCATION_ERROR: "Favorite Location Error",
    UNFAVORITE_ORDER_ERROR: "Unfavorite Order Error",
    FAVORITE_ORDER_ERROR: "Favorite Order Error",
    FETCH_MENU_ERROR: "Fetch Menu Error",
    FETCH_HANDOFF_TIMES_BY_LOCATION_ERROR: "Fetch Handoff Times by Location Error",
    FETCH_HANDOFF_TIMES_BY_BASKET_ERROR: "Fetch Handoff Times by Basket Error",
    SIDECART_OPENED_BEFORE_MENU_LOAD: "Sidecart was opened before menu finished loading",
    FETCH_BASKET_MENU_ERROR: "Fetch Basket Menu Error",
    BASKET_MENU_MISMATCH: "Mismatch between basket items and sessionStorage menu",
    BASKET_MENU_NOT_FOUND: "There is no store menu associated with a user's current cart items",
    CHECK_DELIVERY_COVERAGE_ERROR: "Check Delivery Coverage error",
    FETCH_BATCH_CONFIGS_ERROR: "Error batch fetching configs",
    FETCH_CONFIG_ERROR: "Error batch fetching configs",
    FETCH_ORG_ERROR: "Error fetching organization",
    REDEEM_BARCODE_ERROR: "Error redeeming receipt barcode",
    REDEEM_REWARD_ERROR: "Error redeeming reward",
    REDEEM_OFFER_ERROR: "Error redeeming offer",
    FETCH_LOYALTY_STATE_ERROR: "Error fetching loyalty state",
    FETCH_MESSAGES_ERROR: "Error fetching messages",
    FETCH_REWARDS_HISTORY_ERROR: "Error fetching rewards history",
    MARK_AS_READ_ERROR: "Error marking message as read",
    DELETE_MESSAGE_ERROR: "Error deleting message",
    FETCH_REDEMPTIONS_ERROR: "Error fetching redemptions",
    REORDER_ERROR: "Error reordering basket",
    FETCH_TAGS_ERROR: "Error fetching tags",
    FETCH_STORED_ADDRESSES_ERROR: "Error fetching stored addresses",
    DELETE_STORED_ADDRESS_ERROR: "Error deleting stored address",
    SET_DEFAULT_STORED_ADDRESS_ERROR: "Error setting default stored address",
    UPDATE_STORE_MENU_URL_ERROR: "Error assembling and updating store menu URL with an invalid store ID",
    // Auth Errors
    SIGNUP_LOGIN_FAILURE: "Login failure after account creation",
    // Checkout Errors
    INIT_CHECKOUT_HANDLED_FAILURE: "Init Checkout Handled Failure",
    INIT_CHECKOUT_LOCK_FAILURE: "Init Checkout Lock Failure",
    INIT_CHECKOUT_UNHANDLED_FAILURE: "Init Checkout Unhandled Failure",
    INIT_CHECKOUT_THROTTLING_FAILURE: "Init Checkout Throttling Failure",
    INIT_CHECKOUT_PHONE_FAILURE: "Init Checkout Phone Failure",
    INIT_CHECKOUT_UNHANDLED_CONVEYANCE_FAILURE: "Init Checkout Unhandled Conveyance Failure",
    INIT_CHECKOUT_UNHANDLED_WANTED_AT_FAILURE: "Init Checkout Unhandled Wanted At Failure",
    INIT_CHECKOUT_UNHANDLED_BASKET_FAILURE: "Init Checkout Unhandled Basket Failure",
    POST_INIT_CHECKOUT_FAILURE: "Post-init Checkout Failure",
    PAYMENT_TYPES_GET_ERROR: "Error getting basket payment types",
    SUBMIT_EVENTS_ERROR: "Error submitting checkout events",
    UTENSILS_ERROR: "Error setting utensils",
    BASKET_INSTRUCTIONS_ERROR: "Error setting basket instructions",
    BASKET_STAGED_EVENTS_ERROR: "Error submitting basket staged events",
    KA_PRODUCT_OPTIONS_UNDEFINED: "Koala product options undefined",
    KA_PRODUCT_OPTIONS_NOT_FOUND: "Product option not found in KA dict",
    PCI_PROXY_UNCAUGHT_ERROR: "PCI Proxy Uncaught Error",
    PCI_PROXY_SLOW_IFRAME_LOAD: "PCI Proxy iFrame Slow To Load",
    PCI_PROXY_IFRAME_FAILED_TO_LOAD: "PCI Proxy iFrame Failed To Load",
    TRIGGER_SUBMIT_CHECKOUT_ERROR: "Trigger Submit Checkout Error",
    POST_STORED_VALUE_ERROR: "Error getting stored value",
    PAYMENT_TOGGLE_SAGA_ERROR: "Error toggling payment type",
    BASKET_VALIDATION_POST_TIP_REWARD: "Basket validation error after tip/reward add",
    ADD_USER_PHONE_ERROR: "Error adding user phone number",
    // Basket submission errors
    BASKET_NOT_VALID: "Basket Not Valid",
    LOCATION_NOT_AVAILABLE: "Online Ordering Not Available",
    PAYMENT_DENIED_ERROR: "Payment Denied Error",
    SUBMIT_CHECKOUT_ERROR: "Submit Checkout Error",
    // Commerce Errors
    ERROR_LOGGING_COMMERCE_EVENT: "Error logging commerce event",
    // Handoff-Based Search Results
    SEARCH_DELIVERY_COVERAGE_ERROR: "Error searching for delivery locations",
    // Google Maps/Places
    GOOGLE_PLACES_INIT_ERROR: "Error initializing Google Places",
    // Apple Sign-In
    APPLE_SIGN_IN_ERROR: "Error with Apple Sign In",
    // Customer Arrival Notification
    ARRIVAL_CONFIRM_ERROR: "Error confirming customer arrival",
    ARRIVAL_FETCH_ERROR: "Error fetching arrival status"
};
var LOG_EVENTS = {
    SESSION_PERSISTED: "SESSION_PERSISTED",
    PERSISTED_WANTED_AT_UNAVAILABLE: "PERSISTED_WANTED_AT_UNAVAILABLE",
    GOOGLE_PLACES_INITIALIZED: "GOOGLE_PLACES_INITIALIZED",
    GOOGLE_ADDRESS_NOT_SELECTED: "GOOGLE_ADDRESS_NOT_SELECTED",
    USER_PHONE_ADDED: "USER_PHONE_ADDED",
    FACEBOOK_LOGIN_CLICK: "FACEBOOK_LOGIN_CLICK",
    GOOGLE_LOGIN_CLICK: "GOOGLE_LOGIN_CLICK",
    APPLE_LOGIN_CLICK: "APPLE_LOGIN_CLICK",
    MENU_SSR_FETCHED: "MENU_SSR_FETCHED",
    MENU_CSR_FETCHED: "MENU_CSR_FETCHED"
};
var K_ANALYTICS_CTA_LOCATIONS = {
    SIDECART: "Sidecart",
    DETAIL_MODAL: "Store Detail Modal"
};
var MODAL = {
    DIETARY_PREFERENCES_MODAL: "Dietary Preference Modal",
    CART_MIGRATION_MODAL: "Cart Migration Modal",
    CTA_OVERFLOW: "CTA Overflow Modal",
    FULFILLMENT_MANAGER: "Fulfillment Manager Modal",
    MANAGE_PAYMENT_METHODS: "Manage Payment Methods Modal",
    CART_MIGRATION_ACCEPTED: "Accepted - Cart Migration",
    CART_MIGRATION_DISMISSED: "Dismissed - Cart Migration",
    CART_MIGRATION_NOTICES_MODAL: "Cart Migration Notices Modal",
    CANNOT_DELIVER_TO_ADDRESS_MODAL: "Cannot Deliver to Address Modal",
    REWARDS_HISTORY: "Rewards History Modal",
    ACCOUNT_DROPDOWN: "Account Dropdown",
    REDEEM_IN_STORE: "Redeem In Store Modal",
    BARCODE_RECEIPT: "Barcode Receipt Modal",
    FAVORITE_LOCATION: "Favorite Location Modal",
    REORDER_PAST_ORDER: "Reorder Past Order Modal"
};
var API_CONVEYANCE_TYPES;
(function(API_CONVEYANCE_TYPES) {
    API_CONVEYANCE_TYPES["DELIVERY"] = "delivery";
    API_CONVEYANCE_TYPES["PICKUP"] = "pick_up";
    API_CONVEYANCE_TYPES["CURBSIDE"] = "curbside";
    API_CONVEYANCE_TYPES["DINEIN"] = "dine_in";
    API_CONVEYANCE_TYPES["DRIVETHRU"] = "drive_thru";
    API_CONVEYANCE_TYPES["DRIVEIN"] = "drive_in";
})(API_CONVEYANCE_TYPES || (API_CONVEYANCE_TYPES = {}));


/***/ }),

/***/ 51710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Az": function() { return /* binding */ FLAG_RELATIONSHIP; },
/* harmony export */   "v2": function() { return /* binding */ FALLBACK_FEATURE_BAG; },
/* harmony export */   "y8": function() { return /* binding */ FEATURE_FLAGS; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47842);

var FEATURE_FLAGS;
(function(FEATURE_FLAGS) {
    FEATURE_FLAGS["GLOBAL__LOCATIONS_PAGE"] = "GLOBAL__LOCATIONS_PAGE";
    FEATURE_FLAGS["STORE__FULFILLMENT_TOGGLE"] = "STORE__FULFILLMENT_TOGGLE";
    FEATURE_FLAGS["STORE__MENU_SEARCH"] = "STORE__MENU_SEARCH";
    FEATURE_FLAGS["STORE__DIETARY_PREFERENCES"] = "STORE__DIETARY_PREFERENCES";
    FEATURE_FLAGS["ACCOUNT__INBOX"] = "ACCOUNT__INBOX";
    FEATURE_FLAGS["ACCOUNT__REWARDS"] = "ACCOUNT__REWARDS";
    FEATURE_FLAGS["ACCOUNT__ORDER_HISTORY"] = "ACCOUNT__ORDER_HISTORY";
    FEATURE_FLAGS["ACCOUNT__FAVORITES"] = "ACCOUNT__FAVORITES";
    FEATURE_FLAGS["ACCOUNT__FAVORITE_LOCATIONS_ENABLED"] = "ACCOUNT__FAVORITE_LOCATIONS_ENABLED";
    FEATURE_FLAGS["ANDROID__FAVORITES"] = "ANDROID__FAVORITES";
    FEATURE_FLAGS["ANDROID__REORDER"] = "ANDROID__REORDER";
    FEATURE_FLAGS["ANDROID__REORDER_LIST"] = "ANDROID__REORDER_LIST";
    FEATURE_FLAGS["ANDROID__REORDER_CTA"] = "ANDROID__REORDER_CTA";
    FEATURE_FLAGS["ME__REORDER"] = "ME__REORDER";
    FEATURE_FLAGS["CART__CHANGE_LOCATION"] = "CART__CHANGE_LOCATION";
    FEATURE_FLAGS["CHECKOUT__HANDOFF_DETAILS"] = "CHECKOUT__HANDOFF_DETAILS";
    FEATURE_FLAGS["CHECKOUT__HANDOFF_DINE_IN_INSTRUCTIONS"] = "CHECKOUT__HANDOFF_DINE_IN_INSTRUCTIONS";
    FEATURE_FLAGS["CHECKOUT__WANTED_AT_TIME"] = "CHECKOUT__WANTED_AT_TIME";
    FEATURE_FLAGS["CHECKOUT__ESCAPE_LOCKED_CONVEYANCE"] = "CHECKOUT__ESCAPE_LOCKED_CONVEYANCE";
    FEATURE_FLAGS["DELIVERY_STATUS_ENABLED"] = "DELIVERY_STATUS_ENABLED";
})(FEATURE_FLAGS || (FEATURE_FLAGS = {}));
var _obj;
var FALLBACK_FEATURE_BAG = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.GLOBAL__LOCATIONS_PAGE, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.STORE__FULFILLMENT_TOGGLE, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.STORE__MENU_SEARCH, false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.STORE__DIETARY_PREFERENCES, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.ACCOUNT__REWARDS, false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.ACCOUNT__INBOX, false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.ACCOUNT__ORDER_HISTORY, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.ACCOUNT__FAVORITES, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.ANDROID__FAVORITES, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.ACCOUNT__FAVORITE_LOCATIONS_ENABLED, false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.ANDROID__REORDER, false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.ANDROID__REORDER_LIST, false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.ANDROID__REORDER_CTA, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.ME__REORDER, false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.CART__CHANGE_LOCATION, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.CHECKOUT__HANDOFF_DETAILS, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.CHECKOUT__HANDOFF_DINE_IN_INSTRUCTIONS, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.CHECKOUT__WANTED_AT_TIME, true), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.CHECKOUT__ESCAPE_LOCKED_CONVEYANCE, false), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_obj, FEATURE_FLAGS.DELIVERY_STATUS_ENABLED, false), _obj);
var FLAG_RELATIONSHIP;
(function(FLAG_RELATIONSHIP) {
    FLAG_RELATIONSHIP["AND"] = "AND";
    FLAG_RELATIONSHIP["OR"] = "OR";
})(FLAG_RELATIONSHIP || (FLAG_RELATIONSHIP = {}));


/***/ }),

/***/ 66686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JT": function() { return /* binding */ ALLERGEN_CARD_MODE; },
/* harmony export */   "Kp": function() { return /* binding */ SMB_DRIVER_ID; },
/* harmony export */   "LU": function() { return /* binding */ TIMESLOT_TYPES; },
/* harmony export */   "NX": function() { return /* binding */ API_FOR_CONVEYANCE_TYPES_SWAP; },
/* harmony export */   "OH": function() { return /* binding */ LOCKED_FLOW_CONVEYANCE_TYPES; },
/* harmony export */   "PV": function() { return /* binding */ ALLOWED_URL_PARAMETER_VALUES; },
/* harmony export */   "Ue": function() { return /* binding */ ALLOWED_URL_PARAMETER_KEYS; },
/* harmony export */   "Yv": function() { return /* binding */ GOOGLE_LIBRARIES; },
/* harmony export */   "ao": function() { return /* binding */ DEFAULT_SSR_CACHE_POLICY; },
/* harmony export */   "hC": function() { return /* binding */ DELIVERY_TIME_WANTED_MODES; },
/* harmony export */   "iy": function() { return /* binding */ KOALA_SESSION_STORAGE_KEYS; },
/* harmony export */   "j_": function() { return /* binding */ ERROR_DISPLAY_DURATION; },
/* harmony export */   "uh": function() { return /* binding */ MAX_LENGTH; }
/* harmony export */ });
/* unused harmony export ALLERGEN_TAG_LOCATIONS */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47842);
/* harmony import */ var _events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26654);


// TODO - deprecate
var API_FOR_CONVEYANCE_TYPES_SWAP = {
    pick_up: "Pickup",
    delivery: "Delivery",
    curbside: "Curbside",
    dine_in: "Dine-In",
    drive_thru: "Drive-Thru",
    drive_in: "Drive-In"
};
var LOCKED_FLOW_CONVEYANCE_TYPES = [
    _events__WEBPACK_IMPORTED_MODULE_0__/* .API_CONVEYANCE_TYPES.DINEIN */ .tQ.DINEIN
];
var DELIVERY_TIME_WANTED_MODES = {
    ASAP: "asap",
    ADVANCE: "advance"
};
var ALLERGEN_CARD_MODE = {
    DETAIL: "detail",
    MENU: "menu",
    OPTIONS: "options"
};
var ALLERGEN_TAG_LOCATIONS = {
    MENU_ITEM: "menu-item",
    ITEM_DETAIL: "item-detail",
    ITEM_OPTION_IMAGE: "item-option-image",
    ITEM_OPTION_NO_IMAGE: "item-option-no-image",
    CART: "cart"
};
var ERROR_DISPLAY_DURATION = {
    FIVE: 5000
};
var TIMESLOT_TYPES = {
    BASKET_TIMES: "basketTimes",
    LOCATION_TIMES: "locationTimes"
};
var MAX_LENGTH = {
    DELIVERY_INSTRUCTIONS: 128,
    ITEM_RECIPIENT: 32
};
var GOOGLE_LIBRARIES;
(function(GOOGLE_LIBRARIES) {
    GOOGLE_LIBRARIES["PLACES"] = "places";
})(GOOGLE_LIBRARIES || (GOOGLE_LIBRARIES = {}));
var ALLOWED_URL_PARAMETER_KEYS = {
    HANDOFF: "handoff",
    TABLE_NUMBER: "table_number"
};
var _obj;
var ALLOWED_URL_PARAMETER_VALUES = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ALLOWED_URL_PARAMETER_KEYS.HANDOFF, [
    "dine_in"
]), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_obj, ALLOWED_URL_PARAMETER_KEYS.TABLE_NUMBER, []), _obj);
var KOALA_SESSION_STORAGE_KEYS;
(function(KOALA_SESSION_STORAGE_KEYS) {
    KOALA_SESSION_STORAGE_KEYS["METADATA"] = "koalaMetadata";
    KOALA_SESSION_STORAGE_KEYS["PARAMETERS"] = "koalaRouteParameters";
})(KOALA_SESSION_STORAGE_KEYS || (KOALA_SESSION_STORAGE_KEYS = {}));
/**
 * Next v12 changed the default cache policy for server-rendered pages to
 * `no-cache, no-store, max-age=0, must-revalidate`, effectively disabling
 * all server-side caching. Since web-ordering currently doesn't support
 * server-side auth, we can set a pretty aggressive cache policy.
 * @see https://nextjs.org/docs/going-to-production#caching
 */ var DEFAULT_SSR_CACHE_POLICY = "public, max-age=86400";
var SMB_DRIVER_ID = 7;


/***/ }),

/***/ 56296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HQ": function() { return /* binding */ SECONDARY_CTA_MAPPINGS; },
/* harmony export */   "Jl": function() { return /* binding */ CART_MIGRATION_TYPES; },
/* harmony export */   "NB": function() { return /* binding */ LOCATION_ATTRIBUTE_POSITIONS; },
/* harmony export */   "WU": function() { return /* binding */ SUPPORTED_COUNTRIES; },
/* harmony export */   "pr": function() { return /* binding */ LOCATION_OPTIONS; },
/* harmony export */   "qX": function() { return /* binding */ LOCATION_STATUSES; },
/* harmony export */   "u": function() { return /* binding */ LOCATIONS_CONFIG; },
/* harmony export */   "w6": function() { return /* binding */ LOCATION_VIEW_STATES; }
/* harmony export */ });
/* unused harmony export GOOGLE_MAP_MARKER_ICON_PATHS */
var SUPPORTED_COUNTRIES;
(function(SUPPORTED_COUNTRIES) {
    SUPPORTED_COUNTRIES["CANADA"] = "CA";
    SUPPORTED_COUNTRIES["USA"] = "US";
})(SUPPORTED_COUNTRIES || (SUPPORTED_COUNTRIES = {}));
var LOCATION_OPTIONS = {
    defaultSearchRadius: 10
};
var LOCATION_STATUSES = {
    ACTIVE: 4,
    HIDDEN: 11,
    INACTIVE: 5
};
var LOCATION_ATTRIBUTE_POSITIONS = {
    PRIMARY_ORDER_CTA: 1,
    SECONDARY_ORDER_CTA: 2,
    THIRD_ORDER_CTA: 3,
    FOURTH_ORDER_CTA: 4,
    STORE_DETAIL_HERO: 5,
    FIFTH_ORDER_CTA: 7,
    SIXTH_ORDER_CTA: 8,
    SEVENTH_ORDER_CTA: 9,
    EIGHTH_ORDER_CTA: 10,
    NINTH_ORDER_CTA: 11,
    STORE_BANNER: 12
};
var LOCATIONS_CONFIG = {
    ALL_DISPLAY: {
        GROUP_BY_STATE: "group",
        LIST: "list"
    }
};
var LOCATION_VIEW_STATES;
(function(LOCATION_VIEW_STATES) {
    LOCATION_VIEW_STATES["SEARCH"] = "search";
    LOCATION_VIEW_STATES["VIEW_ALL"] = "view_all";
})(LOCATION_VIEW_STATES || (LOCATION_VIEW_STATES = {}));
var SECONDARY_CTA_MAPPINGS = [
    {
        accessor: "third",
        position: LOCATION_ATTRIBUTE_POSITIONS.THIRD_ORDER_CTA
    },
    {
        accessor: "fourth",
        position: LOCATION_ATTRIBUTE_POSITIONS.FOURTH_ORDER_CTA
    },
    {
        accessor: "fifth",
        position: LOCATION_ATTRIBUTE_POSITIONS.FIFTH_ORDER_CTA
    },
    {
        accessor: "sixth",
        position: LOCATION_ATTRIBUTE_POSITIONS.SIXTH_ORDER_CTA
    },
    {
        accessor: "seventh",
        position: LOCATION_ATTRIBUTE_POSITIONS.SEVENTH_ORDER_CTA
    },
    {
        accessor: "eighth",
        position: LOCATION_ATTRIBUTE_POSITIONS.EIGHTH_ORDER_CTA
    },
    {
        accessor: "ninth",
        position: LOCATION_ATTRIBUTE_POSITIONS.NINTH_ORDER_CTA
    }, 
];
var CART_MIGRATION_TYPES = {
    MIGRATE: "Cart Migrate",
    RESET: "Cart Reset"
};
var GOOGLE_MAP_MARKER_ICON_PATHS;
(function(GOOGLE_MAP_MARKER_ICON_PATHS) {
    GOOGLE_MAP_MARKER_ICON_PATHS["driver"] = "/static/img/google-map-marker-icons/driver-google-map-marker.svg";
    GOOGLE_MAP_MARKER_ICON_PATHS["customer"] = "/static/img/google-map-marker-icons/customer-google-map-marker.svg";
    GOOGLE_MAP_MARKER_ICON_PATHS["store"] = "/static/img/google-map-marker-icons/store-google-map-marker.svg";
})(GOOGLE_MAP_MARKER_ICON_PATHS || (GOOGLE_MAP_MARKER_ICON_PATHS = {}));


/***/ }),

/***/ 92106:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ MESSAGE_HERO_TYPES; },
/* harmony export */   "$r": function() { return /* binding */ MESSAGE_CTA_TYPES; },
/* harmony export */   "GA": function() { return /* binding */ LOYALTY_MESSAGE_TYPES; },
/* harmony export */   "Hx": function() { return /* binding */ REWARD_TYPE; },
/* harmony export */   "Mo": function() { return /* binding */ LOYALTY_ACCESSOR_TYPES; },
/* harmony export */   "c3": function() { return /* binding */ LOYALTY_ROUTE_FEATURE_MAP; },
/* harmony export */   "cI": function() { return /* binding */ PROGRAM_TYPES; },
/* harmony export */   "lw": function() { return /* binding */ LOYALTY_FEATURES; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47842);
/* harmony import */ var _features__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(51710);
/* harmony import */ var _routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25643);



var LOYALTY_MESSAGE_TYPES = {
    BUSINESS: "business_wide",
    PERSONAL: "user_specific"
};
var REWARD_TYPE = {
    REWARD: "redeemable_id",
    OFFER: "reward_id"
};
var MESSAGE_CTA_TYPES = {
    DEEP_LINK: "deep_link",
    DRILL_DOWN: "drill_down",
    WEB_LINK: "external_web_link"
};
var MESSAGE_HERO_TYPES = {
    IMAGE: "image",
    VIDEO: "video"
};
var PROGRAM_TYPES = {
    // Punchh
    POINTS_CONVERT_REDEEMABLES: "points_convert_redeemables",
    POINTS_CONVERT_CURRENCY: "points_convert_currency",
    POINTS_CONVERT_REWARDS: "points_convert_rewards",
    // Spendgo
    SP_POINTS_CONVERT_REWARDS: "sp_points_convert_rewards"
};
var LOYALTY_ACCESSOR_TYPES;
(function(LOYALTY_ACCESSOR_TYPES) {
    LOYALTY_ACCESSOR_TYPES[LOYALTY_ACCESSOR_TYPES["FEATURE"] = 0] = "FEATURE";
    LOYALTY_ACCESSOR_TYPES[LOYALTY_ACCESSOR_TYPES["ROUTE"] = 1] = "ROUTE";
})(LOYALTY_ACCESSOR_TYPES || (LOYALTY_ACCESSOR_TYPES = {}));
var LOYALTY_FEATURES;
(function(LOYALTY_FEATURES) {
    LOYALTY_FEATURES["GET_AVAILABLE_REWARDS"] = "getAvailableRewards";
    LOYALTY_FEATURES["APPLY_REWARDS"] = "applyRewards";
    LOYALTY_FEATURES["GET_APPLIED_REWARDS"] = "getAppliedRewards";
    LOYALTY_FEATURES["DESTROY_REWARD"] = "destroyReward";
    LOYALTY_FEATURES["CLAIM_REWARDS"] = "claimRewards";
    LOYALTY_FEATURES["CLAIM_REWARDS_BY_RECEIPT"] = "claimRewardsByReceipt";
    LOYALTY_FEATURES["INDEX_MY_REWARDS"] = "indexMyRewards";
    LOYALTY_FEATURES["INDEX_REDEEMABLES"] = "indexRedeemables";
    LOYALTY_FEATURES["INDEX_REDEMPTIONS"] = "indexRedemptions";
    LOYALTY_FEATURES["CREATE_REDEMPTION_USING_REDEEMABLE"] = "createRedemptionUsingRedeemable";
    LOYALTY_FEATURES["CREATE_REDEMPTION_USING_REWARD"] = "createRedemptionUsingReward";
    LOYALTY_FEATURES["SHOW_LOYALTY_HISTORY"] = "showLoyaltyHistory";
    LOYALTY_FEATURES["INDEX_LOYALTY_MESSAGES"] = "indexLoyaltyMessages";
    LOYALTY_FEATURES["DESTROY_LOYALTY_MESSAGE"] = "destroyLoyaltyMessage";
    LOYALTY_FEATURES["MARK_READ_LOYALTY_MESSAGE"] = "markReadLoyaltyMessage";
    LOYALTY_FEATURES["SHOW_LOYALTY_STATE"] = "showLoyaltyState";
    LOYALTY_FEATURES["SUPPORTS_QR"] = "supportsQR";
})(LOYALTY_FEATURES || (LOYALTY_FEATURES = {}));
var _obj;
var LOYALTY_ROUTE_FEATURE_MAP = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.ORDER_HISTORY */ .xM.ORDER_HISTORY, _features__WEBPACK_IMPORTED_MODULE_0__/* .FEATURE_FLAGS.ACCOUNT__ORDER_HISTORY */ .y8.ACCOUNT__ORDER_HISTORY), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, _routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.FAVORITES */ .xM.FAVORITES, _features__WEBPACK_IMPORTED_MODULE_0__/* .FEATURE_FLAGS.ACCOUNT__FAVORITES */ .y8.ACCOUNT__FAVORITES), _obj);


/***/ }),

/***/ 25643:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z6": function() { return /* binding */ ROUTES; },
/* harmony export */   "qf": function() { return /* binding */ API_ROUTES; },
/* harmony export */   "xM": function() { return /* binding */ LOYALTY_ROUTES; }
/* harmony export */ });
var ROUTES = {
    HOMEPAGE: "/",
    ANDROID: "/android",
    ACCOUNT: "/account",
    CHECKOUT: "/checkout",
    FIND_A_LOCATION: "/find-a-location",
    FORGOT_PASSWORD: "/forgot-password",
    ORDER_CONFIRMATION: "/order-confirmation/[[...id]]",
    ORDER_DETAIL: "/account/order-detail/[id]",
    SIGN_UP: "/sign-up",
    LOGIN: "/login",
    STORE: "/store/[...id]",
    PAGE: "/[...id]",
    LOCATIONS: "/locations",
    ARRIVAL_CONFIRMATION: "/arrival-confirmation/[id]",
    NOT_FOUND: "/not-found"
};
var LOYALTY_ROUTES;
(function(LOYALTY_ROUTES) {
    LOYALTY_ROUTES["REWARDS"] = "/account/rewards";
    LOYALTY_ROUTES["INBOX"] = "/account/inbox";
    LOYALTY_ROUTES["FAVORITES"] = "/account/favorites";
    LOYALTY_ROUTES["ORDER_HISTORY"] = "/account/order-history";
    LOYALTY_ROUTES["ACCOUNT"] = "/account";
})(LOYALTY_ROUTES || (LOYALTY_ROUTES = {}));
var API_ROUTES;
(function(API_ROUTES) {
    API_ROUTES["KOALA_ANALYTICS"] = "/api/proxy/koalaAnalytics";
    API_ROUTES["PAYMENT_SUBMIT_RISK"] = "/api/proxy/payment/submitRiskData";
    API_ROUTES["PAYMENT_UPDATE_RISK"] = "/api/proxy/payment/updateRiskData";
})(API_ROUTES || (API_ROUTES = {}));


/***/ }),

/***/ 87183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ SESSION_STORAGE_KEYS; }
/* harmony export */ });
var SESSION_STORAGE_KEYS = {
    SESSION_ID: "koalaSessionId",
    SESSION_START: "koalaSessionStartTime"
};


/***/ }),

/***/ 38885:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "mL": function() { return /* binding */ REGEX; },
/* harmony export */   "r7": function() { return /* binding */ REGEX_VALIDATION_STRINGS; },
/* harmony export */   "xz": function() { return /* binding */ VALIDATION_STRINGS; }
/* harmony export */ });
var REGEX = {
    ALPHANUMERIC: /^[a-zA-Z0-9 ]*$/,
    NAMES: /^[a-zA-Z- ]*$/,
    MM_DD_YYYY_DASHES_SLASHES: /^(0[1-9]|1[012])[-/.](0[1-9]|[12][0-9]|3[01])[-/.](19|20)\d\d$/,
    ZIP_CODE_USA_AND_POSTAL_CODE_CANADA: /^((\d{5}-\d{4})|(\d{5})|([AaBbCcEeGgHhJjKkLlMmNnPpRrSsTtVvXxYy]\d[A-Za-z]\s?\d[A-Za-z]\d))$/,
    EMAIL: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
    PASSWORD: /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
    PHONE: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/
};
var REGEX_VALIDATION_STRINGS = {
    ALPHANUMERIC: "Alphanumeric characters only",
    NAMES: "Only letters, spaces, and dashes allowed",
    MM_DD_YYYY_DASHES_SLASHES: "Must be in format MM/DD/YYYY or MM-DD-YYYY",
    ZIP_CODE_USA_AND_POSTAL_CODE_CANADA: "Invalid zip/postal code",
    EMAIL: "Invalid email address",
    PASSWORD: "Must include a number, an uppercase letter, a lowercase letter, and a special character",
    PHONE: "Invalid phone number"
};
var VALIDATION_STRINGS = {
    REQUIRED: "Required",
    EMAIL: "Invalid email address",
    PHONE: "Invalid phone number",
    PASSWORD_LENGTH: "Password must be at least 8 characters long",
    PASSWORD_MISMATCH: "Passwords do not match"
};


/***/ }),

/***/ 74380:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$E": function() { return /* binding */ useConfigOverride; },
/* harmony export */   "B_": function() { return /* binding */ useConfigs; },
/* harmony export */   "G_": function() { return /* binding */ getConfigs; }
/* harmony export */ });
/* unused harmony export getConfigOverride */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22970);
/* harmony import */ var _koala_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80684);
/* harmony import */ var _koala_sdk_v4__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40024);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47661);
/* harmony import */ var _organization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5981);
/* harmony import */ var _queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80320);
/* harmony import */ var _services_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44277);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32210);









/**
 * A cache supported hook for retrieving the current brand's web configs
 * _powered by react query_
 *
 * @returns `Strings`
 */ function useConfigs() {
    var ref;
    var ref1 = (0,_organization__WEBPACK_IMPORTED_MODULE_2__/* .useOrganization */ .o)(), orgData = ref1.data;
    /**
   * Make sure that `useFooterQuery` is prefetched before
   * this component renders, otherwise it will explode!
   * @see __DANGEROUS_EMPTY_REQUEST_ORIGIN
   */ var origin;
    if (true) {
        origin = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .getOrigin */ .P$)(window.location.host);
    } else {}
    var data = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__/* .useQuery */ .a)({
        queryKey: [
            _queries__WEBPACK_IMPORTED_MODULE_3__/* .queryKeys.webConfig */ .a.webConfig
        ],
        queryFn: function() {
            return (0,_koala_sdk_v4__WEBPACK_IMPORTED_MODULE_1__/* .getWebConfig */ .IO)({
                client: (0,_services_client__WEBPACK_IMPORTED_MODULE_4__/* .createHttpClient */ .d9)({
                    origin: origin
                })
            });
        },
        enabled: Boolean(orgData === null || orgData === void 0 ? void 0 : (ref = orgData.organization) === null || ref === void 0 ? void 0 : ref.id),
        refetchOnWindowFocus: false
    }).data;
    if (!data) {
        return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .fallbackConfig */ .fC;
    }
    return data;
}
/**
 *
 * A cache supported hook for retrieving a slice of the current brand's web configs
 *
 * @param slice
 * @returns `WebConfig[T]`
 */ function useConfigOverride(slice) {
    var data = useConfigs();
    return data[slice];
}
/**
 * A cache supported function for retrieving the current brand's web configs
 * _powered by react query_
 *
 * @returns `Promise<WebConfig>`
 */ function getConfigs(queryClient, origin) {
    return _getConfigs.apply(this, arguments);
}
function _getConfigs() {
    _getConfigs = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(queryClient, origin) {
        var data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.fetchQuery([
                            _queries__WEBPACK_IMPORTED_MODULE_3__/* .queryKeys.webConfig */ .a.webConfig
                        ], function() {
                            return (0,_koala_sdk_v4__WEBPACK_IMPORTED_MODULE_1__/* .getWebConfig */ .IO)({
                                client: (0,_services_client__WEBPACK_IMPORTED_MODULE_4__/* .createHttpClient */ .d9)({
                                    origin: origin
                                })
                            });
                        }, {
                            staleTime: 60000
                        })
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return _getConfigs.apply(this, arguments);
}
/**
 * A cache supported function for retrieving a slice of the current brand's web configs
 *
 * @param slice
 * @returns `Promise<WebConfig[T]`
 */ function getConfigOverride(slice, queryClient, origin) {
    return _getConfigOverride.apply(this, arguments);
}
function _getConfigOverride() {
    _getConfigOverride = _async_to_generator(function(slice, queryClient, origin) {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        getConfigs(queryClient, origin)
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        data[slice]
                    ];
            }
        });
    });
    return _getConfigOverride.apply(this, arguments);
}


/***/ }),

/***/ 5981:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ getOrganization; },
/* harmony export */   "o": function() { return /* binding */ useOrganization; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22970);
/* harmony import */ var _koala_sdk_v4__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40024);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47661);
/* harmony import */ var _queries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80320);
/* harmony import */ var _services_client__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(44277);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32210);







// fetch the organization, which is needed so we can pass the org id into the config request
// this may be cached depending on if its the first or nth time this request is being made
function useOrganization() {
    /**
   * Make sure that `useFooterQuery` is prefetched before
   * this component renders, otherwise it will explode!
   * @see __DANGEROUS_EMPTY_REQUEST_ORIGIN
   */ var origin;
    if (true) {
        origin = (0,_utils__WEBPACK_IMPORTED_MODULE_3__/* .getOrigin */ .P$)(window.location.host);
    } else {}
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_4__/* .useQuery */ .a)({
        queryKey: [
            _queries__WEBPACK_IMPORTED_MODULE_1__/* .queryKeys.organization */ .a.organization
        ],
        queryFn: function() {
            return (0,_koala_sdk_v4__WEBPACK_IMPORTED_MODULE_0__/* .getOrgConfig */ .RB)({
                client: (0,_services_client__WEBPACK_IMPORTED_MODULE_2__/* .createHttpClient */ .d9)({
                    origin: origin
                })
            });
        }
    });
}
// fetch the organization, which is needed so we can pass the org id into the config request
// this may be cached depending on if its the first or nth time this request is being made
function getOrganization(queryClient, origin) {
    return _getOrganization.apply(this, arguments);
}
function _getOrganization() {
    _getOrganization = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(function(queryClient, origin) {
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_6__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.fetchQuery([
                            _queries__WEBPACK_IMPORTED_MODULE_1__/* .queryKeys.organization */ .a.organization
                        ], function() {
                            return (0,_koala_sdk_v4__WEBPACK_IMPORTED_MODULE_0__/* .getOrgConfig */ .RB)({
                                client: (0,_services_client__WEBPACK_IMPORTED_MODULE_2__/* .createHttpClient */ .d9)({
                                    origin: origin
                                })
                            });
                        }, {
                            staleTime: 60000
                        } // set a 1 hour stale time to prevent duplicate network calls
                        )
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    });
    return _getOrganization.apply(this, arguments);
}


/***/ }),

/***/ 80320:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ queryKeys; }
/* harmony export */ });
var queryKeys = {
    organization: "org-config",
    webConfig: "web-config",
    strings: "web-strings",
    stripeObject: "stripe-object",
    squareObject: "square-object"
};


/***/ }),

/***/ 18971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ useStrings; },
/* harmony export */   "F": function() { return /* binding */ getStrings; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(22970);
/* harmony import */ var _koala_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80684);
/* harmony import */ var _koala_sdk_v4__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40024);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(47661);
/* harmony import */ var _organization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5981);
/* harmony import */ var _queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80320);
/* harmony import */ var _services_client__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(44277);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(32210);









/**
 * A cache supported hook for retrieving the current brand's string configs
 * _powered by react query_
 *
 * @returns `Strings`
 */ function useStrings() {
    var ref;
    var ref1 = (0,_organization__WEBPACK_IMPORTED_MODULE_2__/* .useOrganization */ .o)(), orgData = ref1.data;
    /**
   * Make sure that `useFooterQuery` is prefetched before
   * this component renders, otherwise it will explode!
   * @see __DANGEROUS_EMPTY_REQUEST_ORIGIN
   */ var origin;
    if (true) {
        origin = (0,_utils__WEBPACK_IMPORTED_MODULE_5__/* .getOrigin */ .P$)(window.location.host);
    } else {}
    var data = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_6__/* .useQuery */ .a)({
        queryKey: [
            _queries__WEBPACK_IMPORTED_MODULE_3__/* .queryKeys.strings */ .a.strings
        ],
        queryFn: function() {
            return (0,_koala_sdk_v4__WEBPACK_IMPORTED_MODULE_1__/* .getStrings */ .Fx)({
                client: (0,_services_client__WEBPACK_IMPORTED_MODULE_4__/* .createHttpClient */ .d9)({
                    origin: origin
                })
            });
        },
        enabled: Boolean(orgData === null || orgData === void 0 ? void 0 : (ref = orgData.organization) === null || ref === void 0 ? void 0 : ref.id),
        refetchOnWindowFocus: false
    }).data;
    if (!data) {
        return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .fallbackStrings */ .hL;
    }
    return data;
}
/**
 * A cache supported function for retrieving the current brand's web configs
 * _powered by react query_
 *
 * @returns `Promise<WebConfig>`
 */ function getStrings(queryClient, origin) {
    return _getStrings.apply(this, arguments);
}
function _getStrings() {
    _getStrings = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(function(queryClient, origin) {
        var data;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_8__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        queryClient.fetchQuery([
                            _queries__WEBPACK_IMPORTED_MODULE_3__/* .queryKeys.strings */ .a.strings
                        ], function() {
                            return (0,_koala_sdk_v4__WEBPACK_IMPORTED_MODULE_1__/* .getStrings */ .Fx)({
                                client: (0,_services_client__WEBPACK_IMPORTED_MODULE_4__/* .createHttpClient */ .d9)({
                                    origin: origin
                                })
                            });
                        }, {
                            staleTime: 60000
                        })
                    ];
                case 1:
                    data = _state.sent();
                    return [
                        2,
                        data
                    ];
            }
        });
    });
    return _getStrings.apply(this, arguments);
}


/***/ }),

/***/ 65242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "JS": function() { return /* binding */ getAvailableDays; },
/* harmony export */   "bv": function() { return /* binding */ getTimeslot; },
/* harmony export */   "et": function() { return /* binding */ getMappedConveyanceType; }
/* harmony export */ });
/* harmony import */ var _koala_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80684);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63761);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97361);
/* harmony import */ var _constants_dates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81584);
/* harmony import */ var _constants_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66686);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63654);
/* harmony import */ var _utils_stringHelpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60738);






/**
 * @param input.canOrderAhead Does the location support ordering for future days?
 * @param input.advanceDays The number of days in advance an order can be made for.
 */ function getAvailableDays(input) {
    var today = new Date();
    // If ordering ahead is enabled, create an array of orderable future days.
    if (input.canOrderAhead) {
        return Array.from({
            length: input.advanceDays + 1
        }, function(_, i) {
            var day = (0,date_fns__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(today, i);
            return {
                label: (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(day, _constants_dates__WEBPACK_IMPORTED_MODULE_1__/* .DATE_FORMAT.LABEL */ .z.LABEL),
                value: (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(day, _constants_dates__WEBPACK_IMPORTED_MODULE_1__/* .DATE_FORMAT.YEAR_MONTH_DAY_DASHED */ .z.YEAR_MONTH_DAY_DASHED)
            };
        });
    }
    return [
        {
            label: (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(today, _constants_dates__WEBPACK_IMPORTED_MODULE_1__/* .DATE_FORMAT.LABEL */ .z.LABEL),
            value: (0,date_fns__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(today, _constants_dates__WEBPACK_IMPORTED_MODULE_1__/* .DATE_FORMAT.YEAR_MONTH_DAY_DASHED */ .z.YEAR_MONTH_DAY_DASHED)
        }, 
    ];
}
var getTimeslot = function(strings, checkoutBasket) {
    return function(value) {
        if (value === _constants_global__WEBPACK_IMPORTED_MODULE_2__/* .DELIVERY_TIME_WANTED_MODES.ASAP */ .hC.ASAP) {
            var label = (0,_utils_stringHelpers__WEBPACK_IMPORTED_MODULE_3__/* .safelyGetString */ .bc)(strings, "handoff_time.asap_select_option_text");
            return {
                label: (checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.time_estimate_minutes) ? "".concat(label, " (").concat(checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.time_estimate_minutes, " min)") : label,
                value: value
            };
        }
        return {
            label: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_6__/* .formatDate */ .p6)(value, _constants_dates__WEBPACK_IMPORTED_MODULE_1__/* .DATE_FORMAT.HOURS_WITH_MINUTES */ .z.HOURS_WITH_MINUTES),
            value: value
        };
    };
};
/*
 * Conveyance modes are types using multiple Enum values
 * which are difficult to pass around in the code, so we map them
 * all to CONVEYANCE_TYPES. These enums should eventually be reconciled
 * and use `as const` instead of an Enum, which work poorly in JavaScript
 */ function getMappedConveyanceType(type) {
    switch(type){
        case "delivery":
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.DELIVERY */ .P8.DELIVERY;
        case "Delivery":
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.DELIVERY */ .P8.DELIVERY;
        case "pick_up":
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.PICKUP */ .P8.PICKUP;
        case "Pickup":
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.PICKUP */ .P8.PICKUP;
        case "curbside":
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.CURBSIDE */ .P8.CURBSIDE;
        case "Curbside":
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.CURBSIDE */ .P8.CURBSIDE;
        case "dine_in":
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.DINEIN */ .P8.DINEIN;
        case "Dine-In":
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.DINEIN */ .P8.DINEIN;
        case "drive_thru":
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.DRIVETHRU */ .P8.DRIVETHRU;
        case "Drive-Thru":
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.DRIVETHRU */ .P8.DRIVETHRU;
        case "drive_in":
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.DRIVEIN */ .P8.DRIVEIN;
        case "Drive-In":
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.DRIVEIN */ .P8.DRIVEIN;
        default:
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.PICKUP */ .P8.PICKUP;
    }
}


/***/ }),

/***/ 92153:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var allergenActions = {
    FETCH_ALLERGENS: "/koala/meta/FETCH_ALLERGENS",
    TOGGLE_ALLERGEN: "/koala/meta/TOGGLE_ALLERGEN",
    UPDATE_ALLERGENS: "/koala/meta/UPDATE_ALLERGENS",
    ALLERGENS_SUCCESS: "/koala/meta/ALLERGENS_SUCCESS",
    ALLERGENS_FAIL: "/koala/meta/ALLERGENS_FAIL",
    fetchAllergens: function() {
        return {
            type: allergenActions.FETCH_ALLERGENS
        };
    },
    updateAllergens: function(updatedAllergenIds) {
        return {
            type: allergenActions.UPDATE_ALLERGENS,
            updatedAllergens: updatedAllergenIds
        };
    },
    toggleAllergen: function(id) {
        return {
            type: allergenActions.TOGGLE_ALLERGEN,
            id: id
        };
    },
    allergensSuccess: function(detail) {
        return {
            type: allergenActions.ALLERGENS_SUCCESS,
            detail: detail
        };
    },
    allergensFail: function() {
        return {
            type: allergenActions.ALLERGENS_FAIL
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (allergenActions);


/***/ }),

/***/ 20756:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var arrivalStatusActions = {
    FETCH_ARRIVAL_STATUS: "/koala/basket/FETCH_ARRIVAL_STATUS",
    FETCH_ARRIVAL_STATUS_SUCCESS: "/koala/basket/FETCH_ARRIVAL_STATUS_SUCCESS",
    FETCH_ARRIVAL_STATUS_FAILURE: "/koala/basket/FETCH_ARRIVAL_STATUS_FAILURE",
    UPDATE_ARRIVAL_STATUS: "/koala/basket/UPDATE_ARRIVAL_STATUS",
    UPDATE_ARRIVAL_STATUS_SUCCESS: "/koala/basket/UPDATE_ARRIVAL_STATUS_SUCCESS",
    UPDATE_ARRIVAL_STATUS_FAILURE: "/koala/basket/UPDATE_ARRIVAL_STATUS_FAILURE",
    CLEAR_ARRIVAL_STATUS: "/koala/basket/CLEAR_ARRIVAL_STATUS",
    fetchArrivalStatus: function(orderId, label) {
        return {
            type: arrivalStatusActions.FETCH_ARRIVAL_STATUS,
            orderId: orderId,
            label: label
        };
    },
    fetchArrivalStatusSuccess: function(orderDetails, label) {
        return {
            type: arrivalStatusActions.FETCH_ARRIVAL_STATUS_SUCCESS,
            orderDetails: orderDetails,
            label: label
        };
    },
    fetchArrivalStatusError: function(error) {
        return {
            type: arrivalStatusActions.FETCH_ARRIVAL_STATUS_FAILURE,
            error: error
        };
    },
    updateArrivalStatus: function(orderId, label, externalOrder, message) {
        return {
            type: arrivalStatusActions.UPDATE_ARRIVAL_STATUS,
            orderId: orderId,
            label: label,
            externalOrder: externalOrder,
            message: message
        };
    },
    updateArrivalStatusSuccess: function(arrivalResponse, label) {
        return {
            type: arrivalStatusActions.UPDATE_ARRIVAL_STATUS_SUCCESS,
            arrivalResponse: arrivalResponse,
            label: label
        };
    },
    updateArrivalStatusFail: function() {
        return {
            type: arrivalStatusActions.UPDATE_ARRIVAL_STATUS_FAILURE
        };
    },
    clearArrivalStatus: function() {
        return {
            type: arrivalStatusActions.CLEAR_ARRIVAL_STATUS
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (arrivalStatusActions);


/***/ }),

/***/ 45479:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var authActions = {
    RELOAD_USER: "/koala/auth/RELOAD_USER",
    LOGIN_REQUEST: "/koala/auth/LOGIN_REQUEST",
    SOCIAL_LOGIN_REQUEST: "/koala/auth/SOCIAL_LOGIN_REQUEST",
    AUTH_FAILURE: "/koala/auth/AUTH_FAILURE",
    AUTH_SUCCESS: "/koala/auth/AUTH_SUCCESS",
    LOGOUT: "/koala/auth/LOGOUT",
    LOGOUT_SUCCESS: "/koala/auth/LOGOUT_SUCCESS",
    LOGOUT_FAILURE: "/koala/auth/LOGOUT_FAILURE",
    SIGN_UP_REQUEST: "/koala/auth/SIGN_UP_REQUEST",
    SIGN_UP_SUCCESS: "/koala-auth/SIGN_UP_SUCCESS",
    SIGN_UP_FAILURE: "/koala-auth/SIGN_UP_FAILURE",
    RESET_PASSWORD: "/koala-auth/RESET_PASSWORD",
    RESET_PASSWORD_SUCCESS: "/koala-auth/RESET_PASSWORD_SUCCESS",
    RESET_PASSWORD_FAIL: "/koala-auth/RESET_PASSWORD_FAIL",
    FORGOT_PASSWORD: "koala-auth/FORGOT_PASSWORD",
    FORGOT_PASSWORD_SUCCESS: "koala/FORGOT_PASSWORD_SUCCESS",
    FORGOT_PASSWORD_FAIL: "koala/FORGOT_PASSWORD_FAIL",
    CHECKOUT_AS_GUEST: "koala/CHECKOUT_AS_GUEST",
    TOGGLE_EMAIL_VERIFICATION: "/koala/auth/TOGGLE_EMAIL_VERIFICATION",
    reloadUser: function() {
        return {
            type: authActions.RELOAD_USER
        };
    },
    login: function(params, referrer, signUpChain) {
        return {
            type: authActions.LOGIN_REQUEST,
            params: params,
            referrer: referrer,
            signUpChain: signUpChain
        };
    },
    signUp: function(params, referrer) {
        return {
            type: authActions.SIGN_UP_REQUEST,
            params: params,
            referrer: referrer
        };
    },
    signUpSuccess: function() {
        return {
            type: authActions.SIGN_UP_SUCCESS
        };
    },
    signUpFailure: function() {
        return {
            type: authActions.SIGN_UP_FAILURE
        };
    },
    logout: function(cancelRedirect) {
        return {
            type: authActions.LOGOUT,
            cancelRedirect: cancelRedirect
        };
    },
    authFailure: function() {
        return {
            type: authActions.AUTH_FAILURE
        };
    },
    authSuccess: function() {
        return {
            type: authActions.AUTH_SUCCESS
        };
    },
    resetPassword: function(params) {
        return {
            type: authActions.RESET_PASSWORD,
            params: params
        };
    },
    resetPasswordSuccess: function() {
        return {
            type: authActions.RESET_PASSWORD_SUCCESS
        };
    },
    resetPasswordFail: function() {
        return {
            type: authActions.RESET_PASSWORD_FAIL
        };
    },
    forgotPassword: function(email) {
        return {
            type: authActions.FORGOT_PASSWORD,
            email: email
        };
    },
    forgotPasswordSuccess: function() {
        return {
            type: authActions.FORGOT_PASSWORD_SUCCESS
        };
    },
    forgotPasswordFail: function() {
        return {
            type: authActions.FORGOT_PASSWORD_FAIL
        };
    },
    checkoutAsGuest: function(payload) {
        return {
            type: authActions.CHECKOUT_AS_GUEST,
            payload: payload
        };
    },
    toggleEmailVerification: function(toggleEmailVerification) {
        return {
            type: authActions.TOGGLE_EMAIL_VERIFICATION,
            toggleEmailVerification: toggleEmailVerification
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (authActions);


/***/ }),

/***/ 7481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$K": function() { return /* binding */ authSliceSelector; },
/* harmony export */   "I8": function() { return /* binding */ auth; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45479);

var initialState = {
    loading: false,
    params: null,
    error: false,
    guestUser: null,
    emailVerificationToggle: false
};
var auth = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SIGN_UP_REQUEST */ .Z.SIGN_UP_REQUEST:
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].LOGOUT */ .Z.LOGOUT:
            return Object.assign({}, state, {
                loading: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].LOGIN_REQUEST */ .Z.LOGIN_REQUEST:
            return Object.assign({}, state, {
                loading: true,
                params: action.params
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].AUTH_SUCCESS */ .Z.AUTH_SUCCESS:
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].LOGOUT_SUCCESS */ .Z.LOGOUT_SUCCESS:
            return Object.assign({}, state, {
                loading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].AUTH_FAILURE */ .Z.AUTH_FAILURE:
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].LOGOUT_FAILURE */ .Z.LOGOUT_FAILURE:
            return Object.assign({}, state, {
                loading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SIGN_UP_FAILURE */ .Z.SIGN_UP_FAILURE:
            return Object.assign({}, state, {
                error: true,
                loading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].RESET_PASSWORD */ .Z.RESET_PASSWORD:
            return Object.assign({}, state, {
                loading: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].RESET_PASSWORD_SUCCESS */ .Z.RESET_PASSWORD_SUCCESS:
            return Object.assign({}, state, {
                loading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].RESET_PASSWORD_FAIL */ .Z.RESET_PASSWORD_FAIL:
            return Object.assign({}, state, {
                loading: false,
                error: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CHECKOUT_AS_GUEST */ .Z.CHECKOUT_AS_GUEST:
            return Object.assign({}, state, {
                loading: false,
                guestUser: action.payload
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].TOGGLE_EMAIL_VERIFICATION */ .Z.TOGGLE_EMAIL_VERIFICATION:
            return Object.assign({}, state, {
                emailVerificationToggle: action.toggleEmailVerification,
                loading: false
            });
        default:
            return state;
    }
};
var authSliceSelector = function(state) {
    return state.app.auth;
};


/***/ }),

/***/ 29682:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var basketActions = {
    INIT_NEW_BASKET: "/koala/basket/INIT_NEW_BASKET",
    INIT_LOCAL_STORAGE_BASKET: "/koala/basket/INIT_LOCAL_STORAGE_BASKET",
    BASKET_ITEMS_SYNCED_WITH_STORE: "/koala/basket/BASKET_ITEMS_SYNCED_WITH_STORE",
    HYDRATE_BASKET: "/koala/basket/HYDRATE_BASKET",
    CLEAR_BASKET: "/koala/basket/CLEAR_BASKET",
    DEPERSONALIZE_BASKET: "/koala/basket/DEPERSONALIZE_BASKET",
    REMOVE_ITEM: "/koala/basket/REMOVE_ITEM",
    ADD_ITEM: "/koala/basket/ADD_ITEM",
    ADD_ITEM_TOAST: "/koala/basket/ADD_ITEM_TOAST",
    REPLACE_BASKET: "/koala/basket/REPLACE_BASKET",
    SUBMIT_CHECKOUT: "/koala/basket/SUBMIT_CHECKOUT",
    SUBMIT_CHECKOUT_TRIGGERED: "/koala/basket/SUBMIT_CHECKOUT_TRIGGERED",
    ADD_REWARDS: "/koala/basket/ADD_REWARDS",
    REWARDS_SUCCESS: "/koala/basket/REWARDS_SUCCESS",
    REMOVE_REWARD: "/koala/basket/REMOVE_REWARD",
    PROMO_SUCCESS: "/koala/basket/PROMO_SUCCESS",
    REMOVE_PROMO: "/koala/basket/REMOVE_PROMO",
    REWARDS: "/koala/basket/REWARDS",
    BASKET_SUCCESS: "/koala/basket/BASKET_SUCCESS",
    COMPLETED: "/koala/basket/COMPLETED",
    ORDER_CONFIRMATION: "/koala/basket/ORDER_CONFIRMATION",
    VALIDATE_BASKET: "/koala/basket/VALIDATE_BASKET",
    ADD_PICKUP_TIME: "/koala/basket/ADD_PICKUP_TIME",
    REMOVE_PICKUP_TIME: "/koala/basket/REMOVE_PICKUP_TIME",
    REHYDRATE_LOCAL_STORAGE_LOCATION: "/koala/basket/REHYDRATE_LOCAL_STORAGE_LOCATION",
    UPDATE_BASKET_FULFILLMENT: "/koala/basket/UPDATE_BASKET_FULFILLMENT",
    REVALIDATE_BASKET_ITEMS: "/koala/basket/REVALIDATE_BASKET_ITEMS",
    REVALIDATE_BASKET_ITEMS_SUCCESS: "/koala/basket/REVALIDATE_BASKET_ITEMS_SUCCESS",
    DESTROY_BASKET: "/koala/basket/DESTROY_BASKET",
    REORDER_BASKET: "/koala/basket/REORDER_BASKET",
    REORDER_BASKET_SUBMIT: "/koala/basket/REORDER_BASKET_SUBMIT",
    REORDER_BASKET_SUCCESS: "/koala/basket/REORDER_BASKET_SUCCESS",
    REORDER_BASKET_FAILURE: "/koala/basket/REORDER_BASKET_FAILURE",
    REORDER_BASKET_REVIEW_MISSING_ITEMS: "REORDER_BASKET_REVIEW_MISSING_ITEMS",
    REORDER_BASKET_CONFIRM_MISSING_ITEMS: "REORDER_BASKET_CONFIRM_MISSING_ITEMS",
    BASKET_ITEM_SUCCESS: "/koala/basket/BASKET_ITEM_SUCCESS",
    basketItemsSyncedWithStore: function(items) {
        return {
            payload: items,
            type: basketActions.BASKET_ITEMS_SYNCED_WITH_STORE
        };
    },
    initBasket: function(location, menuCategories, basketItems, address, time_wanted, referral_tracking_code) {
        return {
            type: basketActions.INIT_NEW_BASKET,
            location: location,
            menuCategories: menuCategories,
            basketItems: basketItems,
            address: address,
            time_wanted: time_wanted,
            referral_tracking_code: referral_tracking_code
        };
    },
    initializeLocalStorageBasket: function() {
        return {
            type: basketActions.INIT_LOCAL_STORAGE_BASKET
        };
    },
    clearBasket: function() {
        return {
            type: basketActions.CLEAR_BASKET
        };
    },
    depersonalizeBasket: function() {
        return {
            type: basketActions.DEPERSONALIZE_BASKET
        };
    },
    hydrateBasket: function() {
        return {
            type: basketActions.HYDRATE_BASKET
        };
    },
    removeItem: function(index, item) {
        return {
            type: basketActions.REMOVE_ITEM,
            index: index,
            item: item
        };
    },
    addItem: function(item, label, index) {
        return {
            type: basketActions.ADD_ITEM,
            item: item,
            label: label,
            index: index
        };
    },
    addItemToast: function(item, index) {
        return {
            type: basketActions.ADD_ITEM_TOAST,
            item: item,
            index: index
        };
    },
    replaceBasket: function(basketItems, location, menuCategories, createdAt, address) {
        return {
            type: basketActions.REPLACE_BASKET,
            basketItems: basketItems,
            location: location,
            menuCategories: menuCategories,
            createdAt: createdAt,
            address: address
        };
    },
    addRewards: function(basketId, rewardCodes, locationId) {
        return {
            type: basketActions.ADD_REWARDS,
            basketId: basketId,
            rewardCodes: rewardCodes,
            locationId: locationId
        };
    },
    returnAvailableRewards: function(rewards) {
        return {
            // the available rewards returned from OLO
            type: basketActions.REWARDS,
            rewards: rewards
        };
    },
    setAppliedRewardCodes: function(appliedRewards) {
        return {
            // the rewards codes applied to the basket
            type: basketActions.REWARDS_SUCCESS,
            appliedRewards: appliedRewards
        };
    },
    removeReward: function(basketId, rewardCode, appliedRewards, locationId) {
        return {
            type: basketActions.REMOVE_REWARD,
            basketId: basketId,
            rewardCode: rewardCode,
            appliedRewards: appliedRewards,
            locationId: locationId
        };
    },
    setAppliedPromoCode: function(appliedPromo) {
        return {
            type: basketActions.PROMO_SUCCESS,
            appliedPromo: appliedPromo
        };
    },
    removePromo: function(basketId, promoCode, locationId) {
        return {
            type: basketActions.REMOVE_PROMO,
            basketId: basketId,
            promoCode: promoCode,
            locationId: locationId
        };
    },
    submitCheckoutTriggered: function(orderSubmitting) {
        return {
            type: basketActions.SUBMIT_CHECKOUT_TRIGGERED,
            orderSubmitting: orderSubmitting
        };
    },
    submitCheckout: function(basketId, locationId, orderData) {
        return {
            type: basketActions.SUBMIT_CHECKOUT,
            basketId: basketId,
            locationId: locationId,
            orderData: orderData
        };
    },
    success: function(checkoutBasket) {
        return {
            type: basketActions.BASKET_SUCCESS,
            checkoutBasket: checkoutBasket
        };
    },
    completed: function() {
        return {
            type: basketActions.COMPLETED
        };
    },
    confirmation: function() {
        return {
            type: basketActions.ORDER_CONFIRMATION
        };
    },
    setPickupTime: function(basketId, locationId, wantedAt) {
        return {
            type: basketActions.ADD_PICKUP_TIME,
            basketId: basketId,
            locationId: locationId,
            wantedAt: wantedAt
        };
    },
    removePickupTime: function(basketId, locationId) {
        return {
            type: basketActions.REMOVE_PICKUP_TIME,
            basketId: basketId,
            locationId: locationId
        };
    },
    rehydrateLocalStorageLocation: function(location) {
        return {
            type: basketActions.REHYDRATE_LOCAL_STORAGE_LOCATION,
            location: location
        };
    },
    updateBasketFulfillment: function(fulfillment) {
        return {
            type: basketActions.UPDATE_BASKET_FULFILLMENT,
            fulfillment: fulfillment
        };
    },
    revalidateBasketItems: function(menuCategories) {
        return {
            type: basketActions.REVALIDATE_BASKET_ITEMS,
            menuCategories: menuCategories
        };
    },
    revalidateBasketItemsSuccess: function(basket) {
        return {
            type: basketActions.REVALIDATE_BASKET_ITEMS_SUCCESS,
            basket: basket
        };
    },
    destroyBasket: function() {
        return {
            type: basketActions.DESTROY_BASKET
        };
    },
    reorderBasket: function(order, label) {
        var routeToCheckout = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, skipUnavailable = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        return {
            type: basketActions.REORDER_BASKET,
            order: order,
            label: label,
            routeToCheckout: routeToCheckout,
            skipUnavailable: skipUnavailable
        };
    },
    reorderBasketSubmit: function(order, label, address) {
        var routeToCheckout = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, skipUnavailable = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        return {
            type: basketActions.REORDER_BASKET_SUBMIT,
            order: order,
            label: label,
            address: address,
            routeToCheckout: routeToCheckout,
            skipUnavailable: skipUnavailable
        };
    },
    reorderBasketSuccess: function(order) {
        var routeToCheckout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        return {
            type: basketActions.REORDER_BASKET_SUCCESS,
            order: order,
            routeToCheckout: routeToCheckout
        };
    },
    reorderBasketReviewMissingItems: function() {
        return {
            type: basketActions.REORDER_BASKET_REVIEW_MISSING_ITEMS
        };
    },
    basketItemSuccess: function(value) {
        return {
            type: basketActions.BASKET_ITEM_SUCCESS,
            value: value
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (basketActions);


/***/ }),

/***/ 52912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ selectBasketSlice; }
/* harmony export */ });
var selectBasketSlice = function(state) {
    return state.app.basket;
};


/***/ }),

/***/ 31387:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ BASKET_MESSAGE; },
/* harmony export */   "Y": function() { return /* binding */ BASKET_ERROR; }
/* harmony export */ });
var BASKET_ERROR = {
    initCheckoutSaga: "Oops, an error occurred creating the checkout basket.  Please reload.",
    submitCheckoutSaga: "Oops, an error occurred submitting the checkout basket.",
    fetchSavedCardSaga: "Oops, an error occurred fetching saved payment info.  Please reload.",
    fetchRewardsSaga: "Oops, an error occurred fetching available rewards: ",
    addRewardsSaga: "Oops, an error occurred applying a reward to the checkout basket: ",
    removeRewardSaga: "Oops, an error occurred removing a reward from the checkout basket: ",
    getPickupTimesSaga: "Oops, an error occurred loading the available times for the order. Please try reloading.",
    setPickupTimeSaga: "Oops, an error occurred setting the selected time for the order.",
    addPromoSaga: "Oops, an error occurred applying a coupon to the checkout basket: ",
    removePromoSaga: "Oops, an error occurred clearing a coupon from the checkout basket.",
    applyAllergensSaga: "Oops, an error occurred applying applying allergens to the basket.",
    addItemErrorToastSaga: "Oops, an error occurred adding an item to your basket",
    pleaseReload: "Please try reloading.",
    genericErrorSaga: "Oops, an error occurred: ",
    addTipSaga: "Oops, an error occurred applying a tip to your order: "
};
var BASKET_MESSAGE = {
    addItemToastSaga: "An item was added to your basket",
    addItemsToastSaga: "items were added to your basket",
    updateItemToastSaga: "An item was updated in your basket",
    updateItemsToastSaga: "items were updated in your basket"
};


/***/ }),

/***/ 62152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "KY": function() { return /* binding */ selectCart; },
/* harmony export */   "a3": function() { return /* binding */ basket; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(50930);
/* harmony import */ var _koala_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80684);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5994);
/* harmony import */ var _global_actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79118);
/* harmony import */ var _orderStatus_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76750);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(29682);
/* harmony import */ var _utils_basket__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1227);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63654);
/* harmony import */ var _utils_global__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36304);











var initialState = {
    /** @TODO decouple `content` from SDK response type. */ content: {
        // @ts-expect-error
        location: {
            id: null
        },
        basket_items: [],
        // @ts-expect-error
        special_instructions: null
    },
    /**
   * This empty object type is a shim because models are no longer constructed
   * as empty classes. The app doesn't currently handle `undefined` locations
   * even though that should be the _actual_ empty state.
   *
   * @TODO handle `undefined` location initial state gracefully.
   */ // @ts-expect-error
    location: {},
    orderSubmitting: false,
    rewardsLoading: false,
    checkoutBasket: null,
    checkoutOrder: null,
    appliedRewards: [],
    orderCompleted: false,
    fulfillment: null,
    createdAt: null,
    reorderBasketId: "",
    loading: false,
    orderConfirmMissingItems: false,
    itemAdded: false
};
/**
 *
 * Since local basket items are synced more regularly with the ordering provider,
 * we need to ensure that some data that *isn't* returned from the Ordering API
 * is persisted even when local basket items are overwritten by those from the
 * ordering provider. This function carries over: the `cross_sell_id`,
 * `category_id`, and `category_label` properties.
 */ function persistBasketItemDetails(localItem, remoteItem) {
    if (!remoteItem) {
        return localItem;
    }
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, remoteItem), {
        product: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, remoteItem.product), {
            category_id: localItem.product.category_id,
            category_label: localItem.product.category_label,
            cross_sell_id: localItem.product.cross_sell_id
        })
    });
}
var basket = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].INIT_NEW_BASKET */ .Z.INIT_NEW_BASKET:
            _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.set */ .fn.basket.set(Object.assign({}, initialState, {
                content: {
                    location: {
                        id: action.location && action.location.id
                    },
                    basket_items: action.basketItems || []
                },
                location: action.location,
                fulfillment: {
                    type: (0,_utils_basket__WEBPACK_IMPORTED_MODULE_4__/* .determineBasketFulfillment */ .Pp)(action.address),
                    address: action.address || null,
                    time_wanted: action.time_wanted
                },
                createdAt: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_8__/* .getISODate */ .Zf)(),
                referral_tracking_code: action.referral_tracking_code
            }));
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.get */ .fn.basket.get();
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].CLEAR_BASKET */ .Z.CLEAR_BASKET:
            var clearBasket = _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.get */ .fn.basket.get();
            _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.set */ .fn.basket.set(Object.assign({}, clearBasket, {
                content: Object.assign({}, clearBasket.content, {
                    basket_items: []
                })
            }));
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.get */ .fn.basket.get();
        // TODO - deprecate
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].DEPERSONALIZE_BASKET */ .Z.DEPERSONALIZE_BASKET:
            var depersonalizeBasket = _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.get */ .fn.basket.get();
            if (depersonalizeBasket) {
                depersonalizeBasket.appliedRewards = initialState.appliedRewards;
                _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.set */ .fn.basket.set(depersonalizeBasket);
                return depersonalizeBasket;
            }
            return state;
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].HYDRATE_BASKET */ .Z.HYDRATE_BASKET:
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.get */ .fn.basket.get() || initialState;
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ADD_ITEM */ .Z.ADD_ITEM:
            var basket = _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.get */ .fn.basket.get();
            var basketItems = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(basket.content.basket_items);
            if (typeof action.index === "undefined") {
                basketItems.push(action.item);
            } else {
                basketItems[action.index] = persistBasketItemDetails(basketItems[action.index], action.item);
            }
            _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.set */ .fn.basket.set(Object.assign({}, basket, {
                content: Object.assign({}, basket.content, {
                    basket_items: basketItems
                })
            }));
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.get */ .fn.basket.get();
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].REMOVE_ITEM */ .Z.REMOVE_ITEM:
            var basketContent = _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.get */ .fn.basket.get().content;
            basketContent.basket_items.splice(action.index, 1);
            _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.set */ .fn.basket.set(Object.assign({}, _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.get */ .fn.basket.get(), {
                content: Object.assign({}, basketContent, {
                    basket_items: basketContent.basket_items
                })
            }));
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.get */ .fn.basket.get();
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].REPLACE_BASKET */ .Z.REPLACE_BASKET:
            _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.set */ .fn.basket.set(Object.assign({}, initialState, {
                content: {
                    location: {
                        id: action.location.id
                    },
                    basket_items: action.basketItems.length ? action.basketItems : []
                },
                location: action.location,
                fulfillment: {
                    type: action.address ? _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.DELIVERY */ .P8.DELIVERY : _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.PICKUP */ .P8.PICKUP,
                    address: action.address || null
                },
                createdAt: action.createdAt
            }));
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.get */ .fn.basket.get();
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ADD_REWARDS */ .Z.ADD_REWARDS:
            return Object.assign({}, state, {
                rewardsLoading: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].REWARDS_SUCCESS */ .Z.REWARDS_SUCCESS:
            return Object.assign({}, state, {
                rewardsLoading: false,
                appliedRewards: action.appliedRewards
            });
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].REMOVE_REWARD */ .Z.REMOVE_REWARD:
            return Object.assign({}, state, {
                appliedRewards: []
            });
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].UPDATE_BASKET_FULFILLMENT */ .Z.UPDATE_BASKET_FULFILLMENT:
            // Updating basket fulfillment needs to be persisted in both localStorage
            // as well as the current redux store - where ephemeral, checkout-screen
            // specific information is stored and then cleared when a user navigates
            // away from checkout.
            var newState = Object.assign({}, state, {
                fulfillment: action.fulfillment
            });
            _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.set */ .fn.basket.set(Object.assign({}, _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.get */ .fn.basket.get(), {
                fulfillment: action.fulfillment
            }));
            return newState;
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].BASKET_ITEMS_SYNCED_WITH_STORE */ .Z.BASKET_ITEMS_SYNCED_WITH_STORE:
            var remoteBasketItems = action.payload;
            var updatedState = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                content: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state.content), {
                    basket_items: state.content.basket_items.map(function(item) {
                        // a local basket and a remote basket are not guaranteed to be in the same order
                        // need to search for matching remote item
                        var remoteItem = remoteBasketItems.find(function(remote) {
                            return (0,_utils_basket__WEBPACK_IMPORTED_MODULE_4__/* .checkEqualityBetweenLocalAndRemoteBasketItems */ .zk)(item, remote);
                        });
                        return persistBasketItemDetails(item, remoteItem);
                    })
                })
            });
            var localBasket = _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.get */ .fn.basket.get();
            _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.set */ .fn.basket.set((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, localBasket), {
                content: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, localBasket.content), {
                    basket_items: localBasket.content.basket_items.map(function(item) {
                        // a local basket and a remote basket are not guaranteed to be in the same order
                        // need to search for matching remote item
                        var remoteItem = remoteBasketItems.find(function(remote) {
                            return (0,_utils_basket__WEBPACK_IMPORTED_MODULE_4__/* .checkEqualityBetweenLocalAndRemoteBasketItems */ .zk)(item, remote);
                        });
                        return persistBasketItemDetails(item, remoteItem);
                    })
                })
            }));
            return updatedState;
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].BASKET_SUCCESS */ .Z.BASKET_SUCCESS:
            _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.set */ .fn.basket.set(Object.assign({}, _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.get */ .fn.basket.get(), {
                checkoutBasket: action.checkoutBasket
            }));
            return Object.assign({}, state, {
                checkoutBasket: action.checkoutBasket
            });
        // This will fire whenever a basket call fails
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].COMPLETED */ .Z.COMPLETED:
            return Object.assign({}, state, {
                orderSubmitting: false
            });
        // Order Submission Actions
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].SUBMIT_CHECKOUT_TRIGGERED */ .Z.SUBMIT_CHECKOUT_TRIGGERED:
            return Object.assign({}, state, {
                orderSubmitting: action.orderSubmitting
            });
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ORDER_CONFIRMATION */ .Z.ORDER_CONFIRMATION:
            var order = _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.get */ .fn.basket.get();
            _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.set */ .fn.basket.set(Object.assign({}, order, {
                orderSubmitting: false,
                orderCompleted: true
            }));
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.get */ .fn.basket.get();
        // Basket Rehydration
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].REHYDRATE_LOCAL_STORAGE_LOCATION */ .Z.REHYDRATE_LOCAL_STORAGE_LOCATION:
            _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.set */ .fn.basket.set(Object.assign({}, _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.get */ .fn.basket.get(), {
                location: action.location
            }));
            return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.get */ .fn.basket.get();
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].REVALIDATE_BASKET_ITEMS_SUCCESS */ .Z.REVALIDATE_BASKET_ITEMS_SUCCESS:
            _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.set */ .fn.basket.set(action.basket);
            return action.basket; // necessary to coerce types
        case _orderStatus_actions__WEBPACK_IMPORTED_MODULE_2__/* ["default"].DESTROY_ORDER */ .Z.DESTROY_ORDER:
            return Object.assign({}, state, {
                checkoutBasket: initialState.checkoutBasket
            });
        // Destroy Basket
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].DESTROY_BASKET */ .Z.DESTROY_BASKET:
            // Remove the basket from localStorage
            _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.basket.remove */ .fn.basket.remove();
            // Reset redux
            return initialState;
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].REORDER_BASKET */ .Z.REORDER_BASKET:
            return Object.assign({}, state, {
                reorderBasketId: action.order.id,
                loading: true
            });
        case _global_actions__WEBPACK_IMPORTED_MODULE_1__/* ["default"].TOGGLE_FULFILLMENT_MODAL */ .Z.TOGGLE_FULFILLMENT_MODAL:
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].REORDER_BASKET_SUCCESS */ .Z.REORDER_BASKET_SUCCESS:
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].REORDER_BASKET_FAILURE */ .Z.REORDER_BASKET_FAILURE:
            return Object.assign({}, state, {
                reorderBasketId: "",
                loading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].REORDER_BASKET_REVIEW_MISSING_ITEMS */ .Z.REORDER_BASKET_REVIEW_MISSING_ITEMS:
            return Object.assign({}, state, {
                orderConfirmMissingItems: true,
                loading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].BASKET_ITEM_SUCCESS */ .Z.BASKET_ITEM_SUCCESS:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, state), {
                itemAdded: action.value
            });
        default:
            return state;
    }
};
var selectCart = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_10__/* .createSelector */ .P1)(function(state) {
    return state.app.global;
}, function(state) {
    return state.app.organization;
}, function(state) {
    return state.app.basket;
}, function(state) {
    return state.app.cmsConfig;
}, function(state) {
    return state.app.menu;
}, function(global, organization, basket, config, menu) {
    var ref, ref1, ref2, ref3;
    var showUpsells = Boolean(organization.organization.upsell_driver_id);
    var items = (0,_utils_basket__WEBPACK_IMPORTED_MODULE_4__/* .basketProductsWithOptionPricing */ .W6)(basket.content, menu.basketMenu);
    var showFoodHalls = config.webConfig.admin.food_hall;
    var groupedItems = showFoodHalls && // @ts-expect-error
    (0,_utils_global__WEBPACK_IMPORTED_MODULE_5__/* .genericGroupItemsByKey */ .sW)(items, "final.filter_tags[0].label").filtersObject;
    var subtotal = (0,_utils_basket__WEBPACK_IMPORTED_MODULE_4__/* .getCartSubtotal */ .vP)(items);
    var ref4;
    var deliveryMinNotMet = ((ref = basket.fulfillment) === null || ref === void 0 ? void 0 : ref.type) === _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.DELIVERY */ .P8.DELIVERY && subtotal < ((ref4 = basket === null || basket === void 0 ? void 0 : (ref1 = basket.location) === null || ref1 === void 0 ? void 0 : ref1.delivery_minimum) !== null && ref4 !== void 0 ? ref4 : 0);
    var deliveryOnlyNoAddress = !((ref2 = basket.fulfillment) === null || ref2 === void 0 ? void 0 : ref2.address) && basket.location.is_delivery_only;
    var isCheckoutDisabled = deliveryMinNotMet || deliveryOnlyNoAddress;
    var ref5;
    return {
        basketOpen: global.basketOpen,
        deliveryMinimum: (0,_utils_basket__WEBPACK_IMPORTED_MODULE_4__/* .toDollars */ .DV)((ref5 = (ref3 = basket.location) === null || ref3 === void 0 ? void 0 : ref3.delivery_minimum) !== null && ref5 !== void 0 ? ref5 : 0),
        groupedItems: groupedItems,
        isCheckoutDisabled: isCheckoutDisabled,
        items: items,
        requiresDeliveryMinimum: deliveryMinNotMet,
        showDietaryPreferences: config.webConfig.menu.dietary_preferences_enabled,
        showSpecialInstructions: config.webConfig.product_detail.special_instructions_enabled,
        showProductImages: config.webConfig.sidecart.show_product_images,
        showFoodHalls: showFoodHalls,
        showUpsells: showUpsells,
        subtotal: subtotal
    };
});


/***/ }),

/***/ 24348:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var basketRewardsActions = {
    GET_REWARDS: "/koala/basketRewards/GET_REWARDs",
    ADD_REWARD: "/koala/basketRewards/ADD_REWARD",
    REMOVE_REWARD: "/koala/basketRewards/REMOVE_REWARD",
    SET_AVAILABLE_REWARDS: "/koala/basketRewards/SET_AVAILABLE_REWARDS",
    SET_APPLIED_REWARDS: "/koala/basketRewards/SET_APPLIED_REWARDS",
    SET_PENDING_REWARD: "/koala/basketRewards/SET_PENDING_REWARD",
    SET_UNAVAILABLE_REWARD: "/koala/basketRewards/SET_UNAVAILABLE_REWARD",
    RESET_BASKET_REWARDS: "/koala/basketRewards/RESET_BASKET_REWARDS",
    RESET_UNAVAILABLE_REWARDS: "koala/basketRewards/RESET_UNAVAILABLE_REWARDS",
    getRewards: function() {
        return {
            type: basketRewardsActions.GET_REWARDS
        };
    },
    setAvailableRewards: function(rewardsAvailable) {
        return {
            type: basketRewardsActions.SET_AVAILABLE_REWARDS,
            rewardsAvailable: rewardsAvailable
        };
    },
    setAppliedRewards: function(rewardsApplied) {
        return {
            type: basketRewardsActions.SET_APPLIED_REWARDS,
            rewardsApplied: rewardsApplied
        };
    },
    addReward: function(reward) {
        return {
            type: basketRewardsActions.ADD_REWARD,
            reward: reward
        };
    },
    setPendingReward: function(id) {
        return {
            type: basketRewardsActions.SET_PENDING_REWARD,
            id: id
        };
    },
    removeReward: function(reward) {
        return {
            type: basketRewardsActions.REMOVE_REWARD,
            reward: reward
        };
    },
    setUnavailableReward: function(reward) {
        return {
            type: basketRewardsActions.SET_UNAVAILABLE_REWARD,
            reward: reward
        };
    },
    resetUnavailableRewards: function() {
        return {
            type: basketRewardsActions.RESET_UNAVAILABLE_REWARDS
        };
    },
    resetBasketRewards: function() {
        return {
            type: basketRewardsActions.RESET_BASKET_REWARDS
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (basketRewardsActions);


/***/ }),

/***/ 27085:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var cmsConfigActions = {
    // Fetch all app configs
    FETCH_CONFIGS: "/koala/cmsConfig/FETCH_CONFIGS",
    FETCH_CONFIGS_SUCCESS: "/koala/cmsConfig/FETCH_CONFIGS_SUCCESS",
    FETCH_CONFIGS_FAILURE: "/koala/cmsConfig/FETCH_CONFIGS_FAILURE",
    // Fetch a single app config
    FETCH_CONFIG: "/koala/cmsConfig/FETCH_CONFIG",
    fetchConfigs: function(clientOrServer, queryClient) {
        return {
            type: cmsConfigActions.FETCH_CONFIGS,
            clientOrServer: clientOrServer,
            queryClient: queryClient
        };
    },
    fetchConfigsSuccess: function(clientOrServer, configType, configContent) {
        return {
            type: cmsConfigActions.FETCH_CONFIGS_SUCCESS,
            clientOrServer: clientOrServer,
            configType: configType,
            configContent: configContent
        };
    },
    fetchConfigsFailure: function(clientOrServer) {
        return {
            type: cmsConfigActions.FETCH_CONFIGS_FAILURE,
            clientOrServer: clientOrServer
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (cmsConfigActions);


/***/ }),

/***/ 57588:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var commerceActions = {
    // Product Events
    COMMERCE_ITEM_IMPRESSION: "/koala/commerce/COMMERCE_ITEM_IMPRESSION",
    COMMERCE_VIEW_CATEGORY: "/koala/commerce/COMMERCE_VIEW_CATEGORY",
    COMMERCE_ITEM_CLICK: "/koala/commerce/COMMERCE_ITEM_CLICK",
    COMMERCE_ITEM_CROSS_SELL_CLICK: "/koala/commerce/COMMERCE_ITEM_CROSS_SELL_CLICK",
    // Checkout Events
    COMMERCE_CHECKOUT_BASKET_STAGED: "/koala/commerce/COMMERCE_CHECKOUT_BASKET_STAGED",
    COMMERCE_CHECKOUT_PURCHASE: "/koala/commerce/COMMERCE_CHECKOUT_PURCHASE",
    // Item Impression
    commerceItemImpression: function(item, categoryName, index) {
        return {
            type: commerceActions.COMMERCE_ITEM_IMPRESSION,
            item: item,
            categoryName: categoryName,
            index: index
        };
    },
    // View Category
    commerceCategoryView: function(category, location) {
        return {
            type: commerceActions.COMMERCE_VIEW_CATEGORY,
            category: category,
            location: location
        };
    },
    // Item Click
    commerceItemClick: function(item, categoryName, index) {
        return {
            type: commerceActions.COMMERCE_ITEM_CLICK,
            item: item,
            categoryName: categoryName,
            index: index
        };
    },
    // Cross Sell Item Click
    commerceItemCrossSellClick: function(item, index) {
        return {
            type: commerceActions.COMMERCE_ITEM_CROSS_SELL_CLICK,
            item: item,
            index: index
        };
    },
    // Checkout Basket Staged Event
    commerceCheckoutBasketStaged: function(basketContent, checkoutBasket, conveyanceType) {
        return {
            type: commerceActions.COMMERCE_CHECKOUT_BASKET_STAGED,
            basketContent: basketContent,
            checkoutBasket: checkoutBasket,
            conveyanceType: conveyanceType
        };
    },
    // Checkout Complete Order Event
    commerceCheckoutPurchase: function(orderDetails) {
        return {
            type: commerceActions.COMMERCE_CHECKOUT_PURCHASE,
            orderDetails: orderDetails
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (commerceActions);


/***/ }),

/***/ 38534:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var conveyanceModeActions = {
    CHECK_DELIVERY_ADDRESS: "/koala/conveyanceMode/CHECK_DELIVERY_ADDRESS",
    CHECK_DELIVERY_ADDRESS_SUCCESS: "/koala/conveyanceMode/CHECK_DELIVERY_ADDRESS_SUCCESS",
    CHECK_DELIVERY_ADDRESS_FAILURE: "/koala/conveyanceMode/CHECK_DELIVERY_ADDRESS_FAILURE",
    SET_DELIVERY_ADDRESS: "/koala/conveyanceMode/SET_DELIVERY_ADDRESS",
    SET_DELIVERY_ADDRESS_SUCCESS: "/koala/conveyanceMode/SET_DELIVERY_ADDRESS_SUCCESS",
    DELIVERY_ADDRESS_VALID: "/koala/conveyanceMode/DELIVERY_ADDRESS_VALID",
    DELIVERY_ADDRESS_INVALID: "/koala/conveyanceMode/DELIVERY_ADDRESS_INVALID",
    SET_DELIVERY_ADDRESS_FAILURE: "/koala/conveyanceMode/SET_DELIVERY_ADDRESS_FAILURE",
    SET_DELIVERY_ADDRESS_CONTINUE: "/koala/conveyanceMode/SET_DELIVERY_ADDRESS_CONTINUE",
    CLEAR_DELIVERY_ADDRESS: "/koala/conveyanceMode/CLEAR_DELIVERY_ADDRESS",
    SET_WANTED_TIME: "/koala/conveyanceMode/SET_WANTED_TIME",
    HANDLE_CONVEYANCE_FAILURE: "/koala/conveyanceMode/HANDLE_CONVEYANCE_FAILURE",
    HANDOFF_TYPE_TOGGLE: "/koala/conveyanceMode/HANDOFF_TYPE_TOGGLE",
    HANDOFF_DETAILS_SET: "/koala/conveyanceMode/HANDOFF_DETAILS_SET",
    RESET_LOCKED_CONVEYANCE_MODE: "/koala/conveyanceMode/RESET_LOCKED_CONVEYANCE_MODE",
    CONVEYANCE_MODE_SET: "/koala/conveyanceMode/CONVEYANCE_MODE_SET",
    // Delivery
    checkDeliveryAddress: function(address, location, revalidate, shouldAutoRedirect) {
        return {
            type: conveyanceModeActions.CHECK_DELIVERY_ADDRESS,
            address: address,
            location: location,
            revalidate: revalidate,
            shouldAutoRedirect: shouldAutoRedirect
        };
    },
    setDeliveryAddress: function(address, location, revalidate, /** Should the user automatically be redirected to the correct store page? */ shouldAutoRedirect) {
        return {
            type: conveyanceModeActions.SET_DELIVERY_ADDRESS,
            address: address,
            location: location,
            revalidate: revalidate,
            shouldAutoRedirect: shouldAutoRedirect
        };
    },
    setWantedTime: function(wantedAt, locationId, type) {
        return {
            type: conveyanceModeActions.SET_WANTED_TIME,
            wantedAt: wantedAt,
            locationId: locationId,
            conveyanceType: type
        };
    },
    setDeliveryAddressSuccess: function(address, fulfillmentModalStoreId) {
        return {
            type: conveyanceModeActions.SET_DELIVERY_ADDRESS_SUCCESS,
            address: address,
            fulfillmentModalStoreId: fulfillmentModalStoreId
        };
    },
    // Triggered when the user clicks the "Continue" button after entering their address.
    setDeliveryAddressContinue: function() {
        return {
            type: conveyanceModeActions.SET_DELIVERY_ADDRESS_CONTINUE
        };
    },
    clearDeliveryAddress: function(locationId) {
        return {
            type: conveyanceModeActions.CLEAR_DELIVERY_ADDRESS,
            locationId: locationId
        };
    },
    // Curbside & Pickup
    toggleHandoff: function(conveyanceType) {
        return {
            type: conveyanceModeActions.HANDOFF_TYPE_TOGGLE,
            conveyanceType: conveyanceType
        };
    },
    handoffDetailsSet: function(conveyanceType, handoffDetails) {
        return {
            type: conveyanceModeActions.HANDOFF_DETAILS_SET,
            conveyanceType: conveyanceType,
            handoffDetails: handoffDetails
        };
    },
    // All
    handleConveyanceFailure: function(error, conveyanceType) {
        return {
            type: conveyanceModeActions.HANDLE_CONVEYANCE_FAILURE,
            error: error,
            conveyanceType: conveyanceType
        };
    },
    // Reset a locked conveyance mode to pickup
    clearLockedConveyanceMode: function() {
        return {
            type: conveyanceModeActions.RESET_LOCKED_CONVEYANCE_MODE
        };
    },
    conveyanceModeSet: function(mode, wantedAt, locationId) {
        return {
            type: conveyanceModeActions.CONVEYANCE_MODE_SET,
            conveyanceType: mode.type,
            conveyanceDetails: mode.details,
            wantedAt: wantedAt,
            locationId: locationId
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (conveyanceModeActions);


/***/ }),

/***/ 16440:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DP": function() { return /* binding */ conveyanceMode; },
/* harmony export */   "Fr": function() { return /* binding */ selectConveyance; }
/* harmony export */ });
/* unused harmony exports initialState, conveyanceSliceSelector */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var _koala_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80684);
/* harmony import */ var _reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5994);
/* harmony import */ var _basket_actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29682);
/* harmony import */ var _orderStatus_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(76750);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38534);
/* harmony import */ var _constants_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66686);
/* harmony import */ var _redux_basket__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(52912);
/* harmony import */ var _redux_locations_reducer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3071);
/* harmony import */ var _redux_orderDetails_reducer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60329);











var initialState = {
    type: _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.PICKUP */ .P8.PICKUP,
    handoffDetails: null,
    loading: false,
    address: null
};
var conveyanceMode = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].CHECK_DELIVERY_ADDRESS */ .Z.CHECK_DELIVERY_ADDRESS:
            return Object.assign({}, state, {
                loading: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].CHECK_DELIVERY_ADDRESS_SUCCESS */ .Z.CHECK_DELIVERY_ADDRESS_SUCCESS:
            return Object.assign({}, state, {
                loading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].SET_DELIVERY_ADDRESS */ .Z.SET_DELIVERY_ADDRESS:
            return Object.assign({}, state, {
                loading: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].SET_DELIVERY_ADDRESS_SUCCESS */ .Z.SET_DELIVERY_ADDRESS_SUCCESS:
            return Object.assign({}, state, {
                type: action.address ? _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.DELIVERY */ .P8.DELIVERY : _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.PICKUP */ .P8.PICKUP,
                address: action.address || null,
                fulfillmentModalStoreId: action.fulfillmentModalStoreId,
                loading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].SET_WANTED_TIME */ .Z.SET_WANTED_TIME:
            // time_wanted can be undefined, but delivery address assumes null or a string
            if (action.conveyanceType === _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.DELIVERY */ .P8.DELIVERY && action.wantedAt) {
                return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                    address: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state.address), {
                        time_wanted: action.wantedAt
                    })
                });
            }
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, state), {
                time_wanted: action.wantedAt
            });
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].HANDOFF_TYPE_TOGGLE */ .Z.HANDOFF_TYPE_TOGGLE:
            return Object.assign({}, state, {
                type: action.conveyanceType,
                handoffDetails: null,
                address: null,
                loading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].HANDOFF_DETAILS_SET */ .Z.HANDOFF_DETAILS_SET:
            return Object.assign({}, state, {
                type: action.conveyanceType,
                handoffDetails: action.handoffDetails || null
            });
        case _basket_actions__WEBPACK_IMPORTED_MODULE_1__/* ["default"].REPLACE_BASKET */ .Z.REPLACE_BASKET:
            return Object.assign({}, state, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, action.conveyanceType));
        case _orderStatus_actions__WEBPACK_IMPORTED_MODULE_2__/* ["default"].INITIALIZE_ORDER */ .Z.INITIALIZE_ORDER:
        case _basket_actions__WEBPACK_IMPORTED_MODULE_1__/* ["default"].INIT_NEW_BASKET */ .Z.INIT_NEW_BASKET:
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].SET_DELIVERY_ADDRESS_FAILURE */ .Z.SET_DELIVERY_ADDRESS_FAILURE:
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].CHECK_DELIVERY_ADDRESS_FAILURE */ .Z.CHECK_DELIVERY_ADDRESS_FAILURE:
            return initialState;
        case _actions__WEBPACK_IMPORTED_MODULE_3__/* ["default"].CLEAR_DELIVERY_ADDRESS */ .Z.CLEAR_DELIVERY_ADDRESS:
            return Object.assign({}, state, {
                address: null,
                loading: false,
                type: null
            });
        default:
            return state;
    }
};
var conveyanceSliceSelector = function(state) {
    return state.app.conveyanceMode;
};
function getTimeWanted(conveyance, basket, activeConveyance) {
    var ref;
    // keeping time wanted in the address object for Deliveries at this time
    /** @TODO move delivery time wanted out of the address object */ if (activeConveyance === _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.DELIVERY */ .P8.DELIVERY) {
        var ref1, ref2, ref3;
        if ((ref1 = conveyance.address) === null || ref1 === void 0 ? void 0 : ref1.time_wanted) {
            return conveyance.address.time_wanted;
        } else if ((ref2 = basket.fulfillment) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.address) === null || ref3 === void 0 ? void 0 : ref3.time_wanted) {
            return basket.fulfillment.address.time_wanted;
        } else {
            return;
        }
    }
    if (conveyance.time_wanted) {
        return conveyance.time_wanted;
    } else if ((ref = basket.fulfillment) === null || ref === void 0 ? void 0 : ref.time_wanted) {
        return basket.fulfillment.time_wanted;
    } else {
        return _constants_global__WEBPACK_IMPORTED_MODULE_4__/* .DELIVERY_TIME_WANTED_MODES.ASAP */ .hC.ASAP;
    }
}
var selectConveyance = (0,_reduxjs_toolkit__WEBPACK_IMPORTED_MODULE_9__/* .createSelector */ .P1)(conveyanceSliceSelector, _redux_orderDetails_reducer__WEBPACK_IMPORTED_MODULE_6__/* .orderDetailsSelector */ .Ms, _redux_locations_reducer__WEBPACK_IMPORTED_MODULE_5__/* .locationsSliceSelector */ .iz, _redux_basket__WEBPACK_IMPORTED_MODULE_10__/* .selectBasketSlice */ .p, function(conveyance, order, activeLocation, basket) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var orderConveyance = _constants_global__WEBPACK_IMPORTED_MODULE_4__/* .API_FOR_CONVEYANCE_TYPES_SWAP */ .NX[(ref = order.order_data.basket.conveyance_type) === null || ref === void 0 ? void 0 : ref.type];
    var ref7;
    /**
     * @TODO:
     * this is the wrong way to handle this (temporary conveyance is a very annoying feature)
     * we should instantiate a basket whenever a basket intent happens and remove this slice:
     *
     * - delivery or pickup intent is specifically set by the guest
     * - time wanted is updated by the guest
     * - an initial item is added
     * */ var activeConveyance = (ref7 = (ref1 = basket.fulfillment) === null || ref1 === void 0 ? void 0 : ref1.type) !== null && ref7 !== void 0 ? ref7 : conveyance.type;
    var ref8, ref9;
    return {
        basket: {
            basket: basket,
            type: (ref8 = (ref2 = basket.fulfillment) === null || ref2 === void 0 ? void 0 : ref2.type) !== null && ref8 !== void 0 ? ref8 : _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.PICKUP */ .P8.PICKUP
        },
        type: activeConveyance,
        order: {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
            matchesCurrent: orderConveyance === activeConveyance,
            type: orderConveyance !== null && orderConveyance !== void 0 ? orderConveyance : _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.PICKUP */ .P8.PICKUP
        },
        address: (ref9 = (ref3 = basket.fulfillment) === null || ref3 === void 0 ? void 0 : ref3.address) !== null && ref9 !== void 0 ? ref9 : conveyance.address,
        time_wanted: getTimeWanted(conveyance, basket, activeConveyance),
        // if there's a basket location, use that for information
        // otherwise, default to the location slice, which already
        // includes some property defaults.
        location: (basket === null || basket === void 0 ? void 0 : (ref4 = basket.location) === null || ref4 === void 0 ? void 0 : ref4.id) ? basket === null || basket === void 0 ? void 0 : (ref5 = basket.location) === null || ref5 === void 0 ? void 0 : ref5.id : activeLocation === null || activeLocation === void 0 ? void 0 : (ref6 = activeLocation.detail) === null || ref6 === void 0 ? void 0 : ref6.id
    };
});


/***/ }),

/***/ 40646:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var customizeActions = {
    SET_PRODUCT_TO_CUSTOMIZE: "/koala/customize/SET_PRODUCT_TO_CUSTOMIZE",
    SET_CROSS_SELL_QUICK_ADD: "/koala/customize/SET_CROSS_SELL_QUICK_ADD",
    INCREMENT_OPTION: "/koala/customize/INCREMENT_OPTION",
    DECREMENT_OPTION: "/koala/customize/DECREMENT_OPTION",
    CLEAR_PRODUCT_TO_CUSTOMIZE: "/koala/customize/CLEAR_PRODUCT_TO_CUSTOMIZE",
    TOGGLE_QUANTITY: "/koala/customize/TOGGLE_QUANTITY",
    DISPLAY_OPTIONS_ERRORS: "/koala/customize/DISPLAY_OPTIONS_ERRORS",
    TRIGGER_TOAST_OPTIONS_ERROR: "/koala/customize/TRIGGER_TOAST_OPTIONS_ERROR",
    TOGGLE_TOAST_OPTIONS_ERROR: "/koala/customize/DISPLAY_TOAST_OPTIONS_ERROR",
    setProduct: function(payload) {
        return {
            type: customizeActions.SET_PRODUCT_TO_CUSTOMIZE,
            payload: payload
        };
    },
    setCrossSellQuickAdd: function(product, menuCategories, upsellId) {
        return {
            type: customizeActions.SET_CROSS_SELL_QUICK_ADD,
            payload: {
                product: product,
                upsellId: upsellId,
                menuCategories: menuCategories
            }
        };
    },
    clearProduct: function() {
        return {
            type: customizeActions.CLEAR_PRODUCT_TO_CUSTOMIZE
        };
    },
    incrementOption: function(id) {
        return {
            type: customizeActions.INCREMENT_OPTION,
            payload: {
                id: id
            }
        };
    },
    decrementOption: function(id, setToZero) {
        return {
            type: customizeActions.DECREMENT_OPTION,
            payload: {
                id: id,
                setToZero: setToZero
            }
        };
    },
    toggleQuantity: function(quantity) {
        return {
            type: customizeActions.TOGGLE_QUANTITY,
            payload: {
                quantity: quantity
            }
        };
    },
    displayOptionsErrors: function(bool) {
        return {
            type: customizeActions.DISPLAY_OPTIONS_ERRORS,
            displayOptionsErrors: bool
        };
    },
    triggerToastOptionsError: function() {
        return {
            type: customizeActions.TRIGGER_TOAST_OPTIONS_ERROR
        };
    },
    toggleToastOptionsError: function(bool) {
        return {
            type: customizeActions.TOGGLE_TOAST_OPTIONS_ERROR,
            toggleToastOptionsError: bool
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (customizeActions);


/***/ }),

/***/ 37615:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ deliveryStatusActions; },
/* harmony export */   "m": function() { return /* binding */ deliveryStatusActionTypes; }
/* harmony export */ });
var deliveryStatusActionTypes;
(function(deliveryStatusActionTypes) {
    deliveryStatusActionTypes["FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER"] = "/koala/deliveryStatus/FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER";
    deliveryStatusActionTypes["FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER_SUCCESS"] = "/koala/deliveryStatus/FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER_SUCCESS";
    deliveryStatusActionTypes["FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER_FAIL"] = "/koala/deliveryStatus/FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER_FAIL";
    deliveryStatusActionTypes["CLEAR_DELIVERY_STATUS_STATE"] = "/koala/deliveryStatus/CLEAR_DELIVERY_STATUS_STATE";
})(deliveryStatusActionTypes || (deliveryStatusActionTypes = {}));
var deliveryStatusActions = {
    fetchDeliveryStatusByOrderNumber: function(orderNumber) {
        return {
            type: deliveryStatusActionTypes.FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER,
            order_number: orderNumber
        };
    },
    fetchDeliveryStatusByOrderNumberSuccess: function(data) {
        return {
            data: data,
            type: deliveryStatusActionTypes.FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER_SUCCESS
        };
    },
    fetchDeliveryStatusByOrderNumberFail: function(error) {
        return {
            type: deliveryStatusActionTypes.FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER_FAIL,
            error: error
        };
    },
    clearDeliveryStatusState: function() {
        return {
            type: deliveryStatusActionTypes.CLEAR_DELIVERY_STATUS_STATE
        };
    }
};


/***/ }),

/***/ 79118:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var globalActions = {
    TOGGLE_BASKET: "/koala/global/TOGGLE_BASKET",
    TOGGLE_FULFILLMENT_MODAL: "/koala/global/TOGGLE_FULFILLMENT_MODAL",
    DELIVERY_ADDRESS_VALID: "/koala/global/DELIVERY_ADDRESS_VALID",
    DELIVERY_ADDRESS_INVALID: "/koala/global/DELIVERY_ADDRESS_INVALID",
    DISPLAY_TOAST: "koala/global/DISPLAY_TOAST",
    DISMISS_TOAST: "koala/global/DISMISS_TOAST",
    RENDER_POST_ITEM_ADD_COMPONENT: "koala/global/RENDER_POST_ITEM_ADD_COMPONENT",
    SET_CART_MIGRATION: "koala/global/SET_CART_MIGRATION",
    HYDRATE_PERSISTENT_PARAMETERS: "koala/global/HYDRATE_PERSISTENT_PARAMETERS",
    SET_PERSISTENT_PARAMETERS: "koala/global/SET_PERSISTENT_PARAMETERS",
    CLEAR_PERSISTENT_PARAMETERS: "koala/global/CLEAR_PERSISTENT_PARAMETERS",
    CLEAR_PERSISTENT_PARAMETERS_SUCCESS: "koala/global/CLEAR_PERSISTENT_PARAMETERS_SUCCESS",
    SET_ROUTER_PATH: "koala/global/SET_ROUTER_PATH",
    GENERATE_FEATURE_BAG: "koala/global/GENERATE_FEATURE_BAG",
    UPDATE_FEATURE_BAG: "koala/global/UPDATE_FEATURE_BAG",
    UPDATE_FEATURE_BAG_FLAG: "koala/global/UPDATE_FEATURE_BAG_FLAG",
    CLEAR_FEATURE_BAG: "koala/global/CLEAR_FEATURE_BAG",
    toggleBasket: function(show) {
        return {
            type: globalActions.TOGGLE_BASKET,
            show: show
        };
    },
    toggleFulfillmentModal: function(show, location, fulfillmentType, confirm, timeslotOverride, revalidate, disableModalClose, miniConveyanceSwitch) {
        return {
            type: globalActions.TOGGLE_FULFILLMENT_MODAL,
            show: show,
            location: location,
            fulfillmentType: fulfillmentType,
            confirm: confirm,
            timeslotOverride: timeslotOverride,
            revalidate: revalidate,
            disableModalClose: disableModalClose,
            miniConveyanceSwitch: miniConveyanceSwitch
        };
    },
    displayToast: function(message, forceDismiss) {
        return {
            type: globalActions.DISPLAY_TOAST,
            message: message,
            status: "success",
            forceDismiss: forceDismiss
        };
    },
    displayErrorToast: function(error, forceDismiss) {
        return {
            type: globalActions.DISPLAY_TOAST,
            message: error,
            status: "error",
            forceDismiss: forceDismiss
        };
    },
    dismissToast: function() {
        return {
            type: globalActions.DISMISS_TOAST
        };
    },
    setCartMigration: function(type, pendingItem) {
        return {
            type: globalActions.SET_CART_MIGRATION,
            cartMigration: {
                type: type,
                pendingItem: pendingItem
            }
        };
    },
    renderPostItemAddComponent: function(item, index) {
        return {
            type: globalActions.RENDER_POST_ITEM_ADD_COMPONENT,
            item: item,
            index: index
        };
    },
    hydratePersistentParameters: function(routeParameters) {
        return {
            type: globalActions.HYDRATE_PERSISTENT_PARAMETERS,
            routeParameters: routeParameters
        };
    },
    setPersistentParameters: function(routeParameters) {
        return {
            type: globalActions.SET_PERSISTENT_PARAMETERS,
            routeParameters: routeParameters
        };
    },
    clearPersistentParameters: function() {
        return {
            type: globalActions.CLEAR_PERSISTENT_PARAMETERS
        };
    },
    setRouterPathname: function(pathname) {
        return {
            type: globalActions.SET_ROUTER_PATH,
            pathname: pathname
        };
    },
    generateFeatureBag: function() {
        return {
            type: globalActions.GENERATE_FEATURE_BAG
        };
    },
    updateFeatureBag: function(featureBag) {
        return {
            type: globalActions.UPDATE_FEATURE_BAG,
            featureBag: featureBag
        };
    },
    updateFeatureBagFlag: function(featureFlag) {
        return {
            type: globalActions.UPDATE_FEATURE_BAG_FLAG,
            featureFlag: featureFlag
        };
    },
    clearFeatureBag: function() {
        return {
            type: globalActions.CLEAR_FEATURE_BAG
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (globalActions);


/***/ }),

/***/ 83626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CO": function() { return /* binding */ global; },
/* harmony export */   "lp": function() { return /* binding */ globalSliceSelector; },
/* harmony export */   "xP": function() { return /* binding */ useGlobalDispatch; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79118);
/* harmony import */ var _constants_features__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51710);
/* harmony import */ var _redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86879);
/* harmony import */ var _utils_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36304);






var initialState = {
    basketOpen: false,
    scrollDisabled: false,
    fulfillmentModal: {
        display: false,
        location: null,
        type: null,
        confirm: false,
        addressValidity: null,
        timeslotOverride: null,
        errorMessage: null,
        revalidate: null,
        disableModalClose: false,
        miniConveyanceSwitch: false
    },
    toast: {
        display: false,
        message: "",
        status: null,
        forceDismiss: false
    },
    postAdd: {
        item: null,
        index: null
    },
    cartMigration: {
        type: null,
        pendingItem: null
    },
    routerStatus: {
        persistentParameters: {},
        currentPath: ""
    },
    featureBag: _constants_features__WEBPACK_IMPORTED_MODULE_1__/* .FALLBACK_FEATURE_BAG */ .v2
};
var global = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].TOGGLE_BASKET */ .Z.TOGGLE_BASKET:
            var basketOpen = typeof action.show !== "undefined" ? action.show : !state.basketOpen;
            // Disable / enable body scrolling
            (0,_utils_global__WEBPACK_IMPORTED_MODULE_3__/* .toggleBodyScroll */ .R0)(!basketOpen);
            return Object.assign({}, state, {
                basketOpen: typeof action.show !== "undefined" ? action.show : !state.basketOpen
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].TOGGLE_FULFILLMENT_MODAL */ .Z.TOGGLE_FULFILLMENT_MODAL:
            // Disable / enable body scrolling
            (0,_utils_global__WEBPACK_IMPORTED_MODULE_3__/* .toggleBodyScroll */ .R0)(!action.show);
            return Object.assign({}, state, {
                fulfillmentModal: {
                    display: action.show,
                    location: action.location,
                    type: action.fulfillmentType,
                    confirm: action.confirm || false,
                    addressValidity: null,
                    timeslotOverride: action.timeslotOverride,
                    revalidate: action.revalidate,
                    disableModalClose: action.disableModalClose || false,
                    miniConveyanceSwitch: action.miniConveyanceSwitch || false
                }
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DELIVERY_ADDRESS_VALID */ .Z.DELIVERY_ADDRESS_VALID:
            return Object.assign({}, state, {
                fulfillmentModal: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state.fulfillmentModal), {
                    addressValidity: true,
                    disableModalClose: false
                })
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DELIVERY_ADDRESS_INVALID */ .Z.DELIVERY_ADDRESS_INVALID:
            return Object.assign({}, state, {
                fulfillmentModal: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state.fulfillmentModal), {
                    addressValidity: false,
                    errorMessage: action.errorMessage
                })
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DISPLAY_TOAST */ .Z.DISPLAY_TOAST:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                toast: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state.toast), {
                    display: true,
                    status: action.status,
                    message: action.message,
                    forceDismiss: action.forceDismiss
                })
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DISMISS_TOAST */ .Z.DISMISS_TOAST:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                toast: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state.toast), {
                    display: false,
                    message: "",
                    status: null,
                    forceDismiss: false
                })
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].RENDER_POST_ITEM_ADD_COMPONENT */ .Z.RENDER_POST_ITEM_ADD_COMPONENT:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                postAdd: {
                    item: action.item,
                    index: action.index
                }
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SET_CART_MIGRATION */ .Z.SET_CART_MIGRATION:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                cartMigration: {
                    type: action.cartMigration.type || null,
                    pendingItem: action.cartMigration.pendingItem || null
                }
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SET_PERSISTENT_PARAMETERS */ .Z.SET_PERSISTENT_PARAMETERS:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                routerStatus: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state.routerStatus), {
                    persistentParameters: action.routeParameters
                })
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CLEAR_PERSISTENT_PARAMETERS */ .Z.CLEAR_PERSISTENT_PARAMETERS:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                routerStatus: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state.routerStatus), {
                    persistentParameters: {}
                })
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SET_ROUTER_PATH */ .Z.SET_ROUTER_PATH:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                routerStatus: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state.routerStatus), {
                    currentPath: action.pathname
                })
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].HYDRATE_PERSISTENT_PARAMETERS */ .Z.HYDRATE_PERSISTENT_PARAMETERS:
            return state;
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].UPDATE_FEATURE_BAG */ .Z.UPDATE_FEATURE_BAG:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                featureBag: action.featureBag
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CLEAR_FEATURE_BAG */ .Z.CLEAR_FEATURE_BAG:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, state), {
                featureBag: _constants_features__WEBPACK_IMPORTED_MODULE_1__/* .FALLBACK_FEATURE_BAG */ .v2
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].GENERATE_FEATURE_BAG */ .Z.GENERATE_FEATURE_BAG:
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].UPDATE_FEATURE_BAG_FLAG */ .Z.UPDATE_FEATURE_BAG_FLAG:
        default:
            return state;
    }
};
var globalSliceSelector = function(state) {
    return state.app.global;
};
var useGlobalDispatch = function() {
    var dispatch = (0,_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        dispatch: dispatch
    }, _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);
};


/***/ }),

/***/ 86879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I0": function() { return /* reexport safe */ react_redux__WEBPACK_IMPORTED_MODULE_0__.useDispatch; },
/* harmony export */   "v9": function() { return /* binding */ typedUseSelector; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56580);
/* eslint-disable import/export */ /** Disabled because we're intentionally overriding `useSelector`. */ 
// Automatically annotate the useSelector hook with our RootState type.
var typedUseSelector = react_redux__WEBPACK_IMPORTED_MODULE_0__.useSelector;
// re-export everything from React-Redux.

// ...but override useSelector with our typed version.



/***/ }),

/***/ 17464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ locationActionTypes; },
/* harmony export */   "b": function() { return /* binding */ locationsActions; }
/* harmony export */ });
var locationActionTypes;
(function(locationActionTypes) {
    locationActionTypes["FETCH_LOCATIONS"] = "/koala/locations/FETCH_LOCATIONS";
    locationActionTypes["FETCH_MORE_LOCATIONS"] = "/koala/locations/FETCH_MORE_LOCATIONS";
    locationActionTypes["FETCH_ALL_LOCATIONS"] = "/koala/locations/FETCH_ALL_LOCATIONS";
    locationActionTypes["FETCH_LOCATION"] = "/koala/locations/FETCH_LOCATION";
    locationActionTypes["FETCH_LOCATION_IF_MODIFIED"] = "/koala/locations/FETCH_LOCATION_IF_MODIFIED";
    locationActionTypes["FETCH_LOCATION_NOT_MODIFIED"] = "/koala/locations/FETCH_LOCATION_NOT_MODIFIED";
    locationActionTypes["HYDRATE_LOCATION"] = "/koala/locations/HYDRATE_LOCATION";
    locationActionTypes["LOCATIONS_FAIL"] = "/koala/locations/LOCATIONS_FAIL";
    locationActionTypes["LOCATIONS_SUCCESS"] = "/koala/locations/LOCATIONS_SUCCESS";
    locationActionTypes["LOCATION_SUCCESS"] = "/koala/locations/LOCATION_SUCCESS";
    locationActionTypes["MORE_LOCATIONS_SUCCESS"] = "/koala/locations/MORE_LOCATIONS_SUCCESS";
    locationActionTypes["ALL_LOCATIONS_SUCCESS"] = "/koala/locations/ALL_LOCATIONS_SUCCESS";
    locationActionTypes["SEARCH_LOCATIONS"] = "/koala/locations/SEARCH_LOCATIONS";
    locationActionTypes["SEARCH_LOCATIONS_SUCCESS"] = "/koala/locations/SEARCH_LOCATIONS_SUCCESS";
    locationActionTypes["SET_ACTIVE_LOCATION"] = "/koala/locations/SET_ACTIVE_LOCATION";
    locationActionTypes["CLEAR_LOCATIONS"] = "/koala/locations/CLEAR_LOCATIONS";
    locationActionTypes["REFRESH_BASKET_LOCATION"] = "/koala/locations/REFRESH_BASKET_LOCATION";
    locationActionTypes["SEARCH_DELIVERY_COVERAGE"] = "/koala/locations/SEARCH_DELIVERY_COVERAGE";
    locationActionTypes["SEARCH_DELIVERY_COVERAGE_SUCCESS"] = "/koala/locations/SEARCH_DELIVERY_COVERAGE_SUCCESS";
    locationActionTypes["SEARCH_DELIVERY_COVERAGE_FAILURE"] = "/koala/locations/SEARCH_DELIVERY_COVERAGE_FAILURE";
    locationActionTypes["SEARCH_DELIVERY_COVERAGE_NO_RESULTS"] = "/koala/locations/SEARCH_DELIVERY_COVERAGE_NO_RESULTS";
    locationActionTypes["CLEAR_DELIVERY_SEARCH_ERRORS"] = "/koala/locations/CLEAR_DELIVERY_SEARCH_ERRORS";
    locationActionTypes["SHOW_DELIVERY_ADDRESS_INVALID_ERROR"] = "/koala/locations/SHOW_DELIVERY_ADDRESS_INVALID_ERROR";
    locationActionTypes["SHOW_GOOGLE_ADDRESS_NOT_SELECTED_ERROR"] = "/koala/locations/SHOW_GOOGLE_ADDRESS_NOT_SELECTED_ERROR";
})(locationActionTypes || (locationActionTypes = {}));
var locationsActions = {
    fetchLocations: function(magicBox) {
        return {
            magicBox: magicBox,
            type: locationActionTypes.FETCH_LOCATIONS
        };
    },
    fetchMoreLocations: function(magicBox) {
        return {
            magicBox: magicBox,
            type: locationActionTypes.FETCH_MORE_LOCATIONS
        };
    },
    fetchAllLocations: function(magicBox, results) {
        return {
            magicBox: magicBox,
            results: results,
            type: locationActionTypes.FETCH_ALL_LOCATIONS
        };
    },
    fetchLocation: function(id) {
        return {
            id: id,
            type: locationActionTypes.FETCH_LOCATION
        };
    },
    fetchLocationIfModified: function(id, lastUpdatedAt) {
        return {
            type: locationActionTypes.FETCH_LOCATION_IF_MODIFIED,
            id: id,
            lastUpdatedAt: lastUpdatedAt
        };
    },
    fetchLocationNotModified: function() {
        return {
            type: locationActionTypes.FETCH_LOCATION_NOT_MODIFIED
        };
    },
    hydrateLocation: function(location) {
        return {
            location: location,
            type: locationActionTypes.HYDRATE_LOCATION
        };
    },
    searchLocations: function(magicBox, params, previousAction, conveyanceType) {
        return {
            params: params,
            magicBox: magicBox,
            previousAction: previousAction,
            type: locationActionTypes.SEARCH_LOCATIONS,
            conveyanceType: conveyanceType
        };
    },
    setActiveLocation: function(id) {
        return {
            id: id,
            type: locationActionTypes.SET_ACTIVE_LOCATION
        };
    },
    clearLocations: function() {
        return {
            type: locationActionTypes.CLEAR_LOCATIONS
        };
    },
    refreshBasketLocation: function(id) {
        return {
            type: locationActionTypes.REFRESH_BASKET_LOCATION,
            id: id
        };
    },
    searchDeliveryCoverage: function(address) {
        return {
            type: locationActionTypes.SEARCH_DELIVERY_COVERAGE,
            address: address
        };
    },
    clearDeliverySearchErrors: function() {
        return {
            type: locationActionTypes.CLEAR_DELIVERY_SEARCH_ERRORS
        };
    },
    showDeliveryAddressInvalidError: function() {
        return {
            type: locationActionTypes.SHOW_DELIVERY_ADDRESS_INVALID_ERROR
        };
    },
    showGoogleAddressNotSelectedError: function() {
        return {
            type: locationActionTypes.SHOW_GOOGLE_ADDRESS_NOT_SELECTED_ERROR
        };
    },
    searchLocationsSuccess: function(list, meta, params) {
        return {
            type: locationActionTypes.SEARCH_LOCATIONS_SUCCESS,
            list: list,
            meta: meta,
            params: params
        };
    },
    fetchLocationsSuccess: function(list, meta, params) {
        return {
            type: locationActionTypes.LOCATIONS_SUCCESS,
            list: list,
            meta: meta,
            params: params
        };
    },
    searchLocationsFail: function() {
        return {
            type: locationActionTypes.LOCATIONS_FAIL
        };
    },
    fetchAllLocationsSuccess: function(list) {
        return {
            type: locationActionTypes.ALL_LOCATIONS_SUCCESS,
            list: list
        };
    },
    fetchMoreLocationsSuccess: function(newList, meta, params) {
        return {
            type: locationActionTypes.MORE_LOCATIONS_SUCCESS,
            newList: newList,
            meta: meta,
            params: params
        };
    },
    fetchLocationSuccess: function(detail) {
        return {
            type: locationActionTypes.LOCATION_SUCCESS,
            detail: detail
        };
    },
    searchDeliveryCoverageSuccess: function() {
        return {
            type: locationActionTypes.SEARCH_DELIVERY_COVERAGE_SUCCESS
        };
    },
    searchDeliveryCoverageNoResults: function() {
        return {
            type: locationActionTypes.SEARCH_DELIVERY_COVERAGE_NO_RESULTS
        };
    },
    searchDeliveryCoverageFail: function() {
        return {
            type: locationActionTypes.SEARCH_DELIVERY_COVERAGE_FAILURE
        };
    }
};


/***/ }),

/***/ 3071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kl": function() { return /* binding */ locations; },
/* harmony export */   "iz": function() { return /* binding */ locationsSliceSelector; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50930);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(17464);
/* harmony import */ var _constants_locations__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56296);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63654);






var initialState = {
    activeLocationId: null,
    error: false,
    // @ts-expect-error
    list: null,
    /**
   * This empty object type is a shim because models are no longer constructed
   * as empty classes. The app doesn't currently handle `undefined` locations
   * even though that should be the _actual_ empty state.
   *
   * @TODO handle `undefined` location initial state gracefully.
   */ // @ts-expect-error
    detail: {},
    loading: false,
    meta: {
        lastUpdatedAt: null,
        pagination: null,
        retrieved_at: null
    },
    params: null,
    searchLoading: false,
    moreLocationsLoading: false,
    searchTimestamp: null,
    viewState: _constants_locations__WEBPACK_IMPORTED_MODULE_1__/* .LOCATION_VIEW_STATES.SEARCH */ .w6.SEARCH,
    noDeliveryLocationsFound: false,
    invalidDeliverySearchAddress: false,
    googleAddressNotSelected: false
};
var locations = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.FETCH_LOCATIONS */ .N.FETCH_LOCATIONS:
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.FETCH_LOCATION */ .N.FETCH_LOCATION:
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.FETCH_ALL_LOCATIONS */ .N.FETCH_ALL_LOCATIONS:
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.HYDRATE_LOCATION */ .N.HYDRATE_LOCATION:
            return Object.assign({}, state, {
                error: false,
                loading: true,
                noDeliveryLocationsFound: false,
                meta: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, state.meta), {
                    lastUpdatedAt: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__/* .getISODateInUTC */ .j4)()
                })
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.SEARCH_LOCATIONS */ .N.SEARCH_LOCATIONS:
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.SEARCH_DELIVERY_COVERAGE */ .N.SEARCH_DELIVERY_COVERAGE:
            return Object.assign({}, state, {
                error: false,
                searchLoading: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.SEARCH_DELIVERY_COVERAGE_NO_RESULTS */ .N.SEARCH_DELIVERY_COVERAGE_NO_RESULTS:
            return Object.assign({}, state, {
                error: true,
                searchLoading: false,
                noDeliveryLocationsFound: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.SHOW_DELIVERY_ADDRESS_INVALID_ERROR */ .N.SHOW_DELIVERY_ADDRESS_INVALID_ERROR:
            return Object.assign({}, state, {
                error: true,
                searchLoading: false,
                invalidDeliverySearchAddress: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.SHOW_GOOGLE_ADDRESS_NOT_SELECTED_ERROR */ .N.SHOW_GOOGLE_ADDRESS_NOT_SELECTED_ERROR:
            return Object.assign({}, state, {
                error: true,
                searchLoading: false,
                invalidDeliverySearchAddress: false,
                googleAddressNotSelected: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.SEARCH_DELIVERY_COVERAGE_SUCCESS */ .N.SEARCH_DELIVERY_COVERAGE_SUCCESS:
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.SEARCH_DELIVERY_COVERAGE_FAILURE */ .N.SEARCH_DELIVERY_COVERAGE_FAILURE:
            return Object.assign({}, state, {
                error: false,
                searchLoading: false,
                noDeliveryLocationsFound: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.FETCH_MORE_LOCATIONS */ .N.FETCH_MORE_LOCATIONS:
            return Object.assign({}, state, {
                error: false,
                moreLocationsLoading: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.LOCATIONS_SUCCESS */ .N.LOCATIONS_SUCCESS:
            return Object.assign({}, state, {
                error: false,
                list: action.list,
                loading: false,
                meta: action.meta,
                searchTimestamp: new Date(),
                viewState: _constants_locations__WEBPACK_IMPORTED_MODULE_1__/* .LOCATION_VIEW_STATES.SEARCH */ .w6.SEARCH
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.ALL_LOCATIONS_SUCCESS */ .N.ALL_LOCATIONS_SUCCESS:
            return Object.assign({}, state, {
                error: false,
                list: action.list,
                loading: false,
                meta: action.meta,
                searchTimestamp: new Date(),
                viewState: _constants_locations__WEBPACK_IMPORTED_MODULE_1__/* .LOCATION_VIEW_STATES.VIEW_ALL */ .w6.VIEW_ALL
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.MORE_LOCATIONS_SUCCESS */ .N.MORE_LOCATIONS_SUCCESS:
            return Object.assign({}, state, {
                error: false,
                list: (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(state.list).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(action.newList)),
                moreLocationsLoading: false,
                meta: action.meta,
                searchTimestamp: new Date(),
                viewState: _constants_locations__WEBPACK_IMPORTED_MODULE_1__/* .LOCATION_VIEW_STATES.SEARCH */ .w6.SEARCH
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.SEARCH_LOCATIONS_SUCCESS */ .N.SEARCH_LOCATIONS_SUCCESS:
            return Object.assign({}, state, {
                error: false,
                list: action.list,
                searchLoading: false,
                meta: action.meta,
                params: action.params,
                searchTimestamp: new Date(),
                viewState: _constants_locations__WEBPACK_IMPORTED_MODULE_1__/* .LOCATION_VIEW_STATES.SEARCH */ .w6.SEARCH
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.LOCATION_SUCCESS */ .N.LOCATION_SUCCESS:
            return Object.assign({}, state, {
                error: false,
                detail: action.detail,
                loading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.LOCATIONS_FAIL */ .N.LOCATIONS_FAIL:
            return Object.assign({}, state, {
                error: true,
                loading: false,
                searchLoading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.SET_ACTIVE_LOCATION */ .N.SET_ACTIVE_LOCATION:
            return Object.assign({}, state, {
                activeLocationId: action.id
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.CLEAR_DELIVERY_SEARCH_ERRORS */ .N.CLEAR_DELIVERY_SEARCH_ERRORS:
            return Object.assign({}, state, {
                noDeliveryLocationsFound: false,
                invalidDeliverySearchAddress: false,
                googleAddressNotSelected: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .locationActionTypes.CLEAR_LOCATIONS */ .N.CLEAR_LOCATIONS:
            return Object.assign({}, initialState, {
                detail: state.detail
            });
        default:
            return state;
    }
};
var locationsSliceSelector = function(state) {
    return state.app.locations;
};


/***/ }),

/***/ 47290:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var meActions = {
    FETCH_ME: "/koala/me/FETCH_ME",
    ME_SUCCESS: "/koala/me/ME_SUCCESS",
    ME_FAIL: "/koala/me/ME_FAIL",
    CLEAR_ME: "koala/me/CLEAR_ME",
    ME_STOP_LOADING: "koala/me/ME_STOP_LOADING",
    UPDATE_ME: "/koala/me/UPDATE_ME",
    UPDATE_ME_SUCCESS: "/koala/me/UPDATE_ME_SUCCESS",
    UPDATE_ME_FAIL: "/koala/me/UPDATE_ME_FAIL",
    FETCH_ME_FAVORITE_LOCATIONS: "/koala/me/FETCH_ME_FAVORITE_LOCATIONS",
    DELETE_ME_FAVORITE_LOCATION_SUCCESS: "/koala/FAVORITE_LOCATION_SUCCESS",
    DELETE_ME_FAVORITE_LOCATION_FAIL: "/koala/FAVORITE_LOCATION_FAIL",
    ME_FAVORITE_LOCATIONS_SUCCESS: "/koala/me/ME_FAVORITE_LOCATIONS_SUCCESS",
    ADD_FAVORITE_LOCATION: "/koala/me/ADD_FAVORITE_LOCATION",
    REMOVE_FAVORITE_LOCATION: "/koala/me/REMOVE_FAVORITE_LOCATION",
    FETCH_ME_FAVORITE_ORDERS: "/koala/me/FETCH_ME_FAVORITE_ORDERS",
    FETCH_ME_FAVORITE_ORDERS_SUCCESS: "/koala/me/FETCH_ME_FAVORITE_ORDERS_SUCCESS",
    DELETE_ME_FAVORITE_ORDER_SUCCESS: "/koala/FAVORITE_ORDER_SUCCESS",
    DELETE_ME_FAVORITE_ORDER_FAIL: "/koala/FAVORITE_ORDER_FAIL",
    ADD_FAVORITE_ORDER: "/koala/me/ADD_FAVORITE_ORDER",
    REMOVE_FAVORITE_ORDER: "/koala/me/REMOVE_FAVORITE_ORDER",
    ADD_ME_FAVORITE_ORDER_SUCCESS: "/koala/FAVORITE_ORDER_SUCCESS",
    ADD_ME_FAVORITE_ORDER_FAIL: "/koala/FAVORITE_ORDER_FAIL",
    FETCH_ME_PAST_ORDERS: "/koala/me/FETCH_ME_PAST_ORDERS",
    FETCH_ME_PAST_ORDERS_SUCCESS: "/koala/me/FETCH_ME_PAST_ORDERS_SUCCESS",
    FETCH_ME_ORDER_DETAILS: "/koala/me/FETCH_ME_ORDER_DETAILS",
    FETCH_ME_ORDER_DETAILS_SUCCESS: "/koala/me/FETCH_ME_ORDER_DETAILS_SUCCESS",
    FETCH_ME_ORDER_DETAILS_FAIL: "/koala/me/FETCH_ME_ORDER_DETAILS_FAIL",
    CLEAR_ME_ORDER_DETAILS: "/koala/me/CLEAR_ME_ORDER_DETAILS",
    TOGGLE_REORDER_RECEIPT: "/koala/me/TOGGLE_REORDER_RECEIPT",
    FETCH_ME_CREDIT_CARDS: "/koala/me/FETCH_ME_CREDIT_CARDS",
    FETCH_ME_CREDIT_CARDS_SUCCESS: "/koala/FETCH_ME_CREDIT_CARDS_SUCCESS",
    FETCH_ME_CREDIT_CARDS_FAIL: "/koala/FETCH_ME_CREDIT_CARDS_FAIL",
    FETCH_ALL_LOCATIONS_CREDIT_CARDS: "/koala/me/FETCH_ALL_LOCATIONS_CREDIT_CARDS",
    FETCH_ALL_LOCATIONS_CREDIT_CARDS_SUCCESS: "/koala/FETCH_ALL_LOCATIONS_CREDIT_CARDS_SUCCESS",
    DELETE_ME_CREDIT_CARD: "/koala/DELETE_ME_CREDIT_CARD",
    DELETE_ME_CREDIT_CARD_SUCCESS: "/koala/CREDIT_CARD_SUCCESS",
    DELETE_ME_CREDIT_CARD_FAIL: "/koala/CREDIT_CARD_FAIL",
    SET_ME_CREDIT_CARDS_LOADING_TO_INIT_STATE: "/koala/me/SET_ME_CREDIT_CARDS_LOADING_TO_INIT_STATE",
    FETCH_OFFERS: "/koala/me/FETCH_OFFERS",
    FETCH_OFFERS_SUCCESS: "/koala/FETCH_OFFERS_SUCCESS",
    FETCH_ADDRESSES: "/koala/me/FETCH_ADDRESSES",
    FETCH_ADDRESSES_SUCCESS: "/koala/FETCH_ADDRESSES_SUCCESS",
    DELETE_ADDRESS: "/koala/me/DELETE_ADDRESS",
    DEFAULT_ADDRESS: "/koala/me/DEFAULT_ADDRESS",
    TOGGLE_STORED_ADDRESSES_MENU: "/koala/me/TOGGLE_STORED_ADDRESSES_MENU",
    SET_ACTIVE_STORED_ADDRESS: "/koala/me/SET_ACTIVE_STORED_ADDRESS",
    APPEND_USER_PHONE: "/koala/me/APPEND_USER_PHONE",
    // Punchh V2 only
    FETCH_LOYALTY_STATE: "/koala/me/FETCH_LOYALTY_STATE",
    FETCH_LOYALTY_STATE_SUCCESS: "/koala/me/FETCH_LOYALTY_STATE_SUCCESS",
    FETCH_REDEEMABLES: "/koala/me/FETCH_REDEEMABLES",
    FETCH_REDEEMABLES_SUCCESS: "/koala/me/FETCH_REDEEMABLES_SUCCESS",
    FETCH_MESSAGES: "/koala/me/FETCH_MESSAGES",
    FETCH_MESSAGES_SUCCESS: "/koala/me/FETCH_MESSAGES_SUCCESS",
    FETCH_REWARDS_HISTORY: "/koala/me/FETCH_REWARDS_HISTORY",
    FETCH_REWARDS_HISTORY_SUCCESS: "/koala/me/FETCH_REWARDS_HISTORY_SUCCESS",
    MARK_MESSAGE_AS_READ: "/koala/me/MARK_MESSAGE_AS_READ",
    MARK_MESSAGE_AS_READ_SUCCESS: "/koala/me/MARK_MESSAGE_AS_READ_SUCCESS",
    DELETE_MESSAGE: "/koala/me/DELETE_MESSAGE",
    DELETE_MESSAGE_SUCCESS: "/koala/me/DELETE_MESSAGE_SUCCESS",
    CREATE_REDEMPTION: "/koala/me/CREATE_REDEMPTION",
    CREATE_REDEMPTION_SUCCESS: "/koala/me/CREATE_REDEMPTION_SUCCESS",
    CREATE_REDEMPTION_FAILURE: "/koala/me/CREATE_REDEMPTION_FAILURE",
    CLEAR_ACTIVE_REDEMPTION: "/koala/me/CLEAR_ACTIVE_REDEMPTION",
    FETCH_REDEMPTIONS: "/koala/me/FETCH_REDEMPTIONS",
    FETCH_REDEMPTIONS_SUCCESS: "/koala/me/FETCH_REDEMPTIONS_SUCCESS",
    TOGGLE_ACCOUNT_DROPDOWN: "/koala/me/TOGGLE_ACCOUNT_DROPDOWN",
    REDEEM_RECEIPT_BARCODE: "/koala/me/REDEEM_RECEIPT_BARCODE",
    REDEEM_RECEIPT_BARCODE_SUCCESS: "/koala/me/REDEEM_RECEIPT_BARCODE_SUCCESS",
    REDEEM_RECEIPT_BARCODE_FAILURE: "/koala/me/REDEEM_RECEIPT_BARCODE_FAILURE",
    fetchMe: function() {
        return {
            type: meActions.FETCH_ME
        };
    },
    fetchMeFavoriteLocations: function() {
        return {
            type: meActions.FETCH_ME_FAVORITE_LOCATIONS
        };
    },
    fetchMeFavoriteLocationsSuccess: function(favoriteLocations) {
        return {
            type: meActions.ME_FAVORITE_LOCATIONS_SUCCESS,
            favoriteLocations: favoriteLocations
        };
    },
    deleteMeFavoriteLocationSuccess: function() {
        return {
            type: meActions.DELETE_ME_FAVORITE_LOCATION_SUCCESS
        };
    },
    deleteMeFavoriteLocationFail: function() {
        return {
            type: meActions.DELETE_ME_FAVORITE_LOCATION_FAIL
        };
    },
    deleteMeFavoriteOrderSuccess: function() {
        return {
            type: meActions.DELETE_ME_FAVORITE_ORDER_SUCCESS
        };
    },
    deleteMeFavoriteOrderFail: function() {
        return {
            type: meActions.DELETE_ME_FAVORITE_ORDER_FAIL
        };
    },
    addMeFavoriteOrderSuccess: function() {
        return {
            type: meActions.ADD_ME_FAVORITE_ORDER_SUCCESS
        };
    },
    addMeFavoriteOrderFail: function() {
        return {
            type: meActions.ADD_ME_FAVORITE_ORDER_FAIL
        };
    },
    fetchMeFavoriteOrders: function() {
        return {
            type: meActions.FETCH_ME_FAVORITE_ORDERS
        };
    },
    fetchMeFavoriteOrdersSuccess: function(favoriteOrders) {
        return {
            type: meActions.FETCH_ME_FAVORITE_ORDERS_SUCCESS,
            favoriteOrders: favoriteOrders
        };
    },
    fetchMePastOrders: function() {
        return {
            type: meActions.FETCH_ME_PAST_ORDERS
        };
    },
    fetchMePastOrdersSuccess: function(pastOrders) {
        return {
            type: meActions.FETCH_ME_PAST_ORDERS_SUCCESS,
            pastOrders: pastOrders
        };
    },
    fetchMeOrderDetails: function(id, pastOrders) {
        return {
            type: meActions.FETCH_ME_ORDER_DETAILS,
            id: id,
            pastOrders: pastOrders
        };
    },
    fetchMeOrderDetailsSuccess: function(orderDetails) {
        return {
            type: meActions.FETCH_ME_ORDER_DETAILS_SUCCESS,
            orderDetails: orderDetails
        };
    },
    fetchMeOrderDetailsFail: function() {
        return {
            type: meActions.FETCH_ME_ORDER_DETAILS_FAIL
        };
    },
    clearMeOrderDetails: function() {
        return {
            type: meActions.CLEAR_ME_ORDER_DETAILS
        };
    },
    toggleReorderReceipt: function(show) {
        return {
            type: meActions.TOGGLE_REORDER_RECEIPT,
            show: show
        };
    },
    fetchMeCreditCards: function(basketId) {
        return {
            type: meActions.FETCH_ME_CREDIT_CARDS,
            basketId: basketId
        };
    },
    fetchMeCreditCardsSuccess: function(cards) {
        return {
            type: meActions.FETCH_ME_CREDIT_CARDS_SUCCESS,
            cards: cards
        };
    },
    fetchMeCreditCardsFail: function() {
        return {
            type: meActions.FETCH_ME_CREDIT_CARDS_FAIL
        };
    },
    fetchAllLocationsCreditCards: function(pastOrders) {
        return {
            type: meActions.FETCH_ALL_LOCATIONS_CREDIT_CARDS,
            pastOrders: pastOrders
        };
    },
    fetchAllLocationsCreditCardsSuccess: function(allLocationsCards) {
        return {
            type: meActions.FETCH_ALL_LOCATIONS_CREDIT_CARDS_SUCCESS,
            allLocationsCards: allLocationsCards
        };
    },
    deleteMeCreditCard: function(id) {
        return {
            type: meActions.DELETE_ME_CREDIT_CARD,
            id: id
        };
    },
    deleteMeCreditCardSuccess: function() {
        return {
            type: meActions.DELETE_ME_CREDIT_CARD_SUCCESS
        };
    },
    deleteMeCreditCardFail: function() {
        return {
            type: meActions.DELETE_ME_CREDIT_CARD_FAIL
        };
    },
    clearMe: function() {
        return {
            type: meActions.CLEAR_ME
        };
    },
    updateMe: function(params) {
        return {
            type: meActions.UPDATE_ME,
            params: params
        };
    },
    updateMeSuccess: function() {
        return {
            type: meActions.UPDATE_ME_SUCCESS
        };
    },
    updateMeFail: function() {
        return {
            type: meActions.UPDATE_ME_FAIL
        };
    },
    addFavoriteLocation: function(id) {
        return {
            id: id,
            type: meActions.ADD_FAVORITE_LOCATION
        };
    },
    removeFavoriteLocation: function(id, label) {
        return {
            id: id,
            label: label,
            type: meActions.REMOVE_FAVORITE_LOCATION
        };
    },
    addFavoriteOrder: function(id) {
        return {
            id: id,
            type: meActions.ADD_FAVORITE_ORDER
        };
    },
    removeFavoriteOrder: function(id) {
        return {
            id: id,
            type: meActions.REMOVE_FAVORITE_ORDER
        };
    },
    fetchOffers: function() {
        return {
            type: meActions.FETCH_OFFERS
        };
    },
    fetchOffersSuccess: function(rewards) {
        return {
            type: meActions.FETCH_OFFERS_SUCCESS,
            rewards: rewards
        };
    },
    appendUserPhone: function(phone) {
        return {
            type: meActions.APPEND_USER_PHONE,
            phone: phone
        };
    },
    fetchAddresses: function() {
        return {
            type: meActions.FETCH_ADDRESSES
        };
    },
    deleteAddress: function(id) {
        return {
            type: meActions.DELETE_ADDRESS,
            id: id
        };
    },
    defaultAddress: function(id) {
        return {
            type: meActions.DEFAULT_ADDRESS,
            id: id
        };
    },
    toggleStoredAddressesMenu: function(show) {
        return {
            type: meActions.TOGGLE_STORED_ADDRESSES_MENU,
            show: show
        };
    },
    setActiveStoredAddress: function(addressId) {
        return {
            type: meActions.SET_ACTIVE_STORED_ADDRESS,
            addressId: addressId
        };
    },
    // Punchh V2 only
    fetchLoyaltyState: function() {
        return {
            type: meActions.FETCH_LOYALTY_STATE
        };
    },
    fetchRedeemables: function() {
        return {
            type: meActions.FETCH_REDEEMABLES
        };
    },
    fetchMessages: function() {
        return {
            type: meActions.FETCH_MESSAGES
        };
    },
    fetchRewardsHistory: function() {
        return {
            type: meActions.FETCH_REWARDS_HISTORY
        };
    },
    markMessageAsRead: function(messageId) {
        return {
            type: meActions.MARK_MESSAGE_AS_READ,
            messageId: messageId
        };
    },
    deleteMessage: function(messageId) {
        return {
            type: meActions.DELETE_MESSAGE,
            messageId: messageId
        };
    },
    createRedemption: function(rewardId, rewardType) {
        return {
            type: meActions.CREATE_REDEMPTION,
            rewardId: rewardId,
            rewardType: rewardType
        };
    },
    createRedemptionSuccess: function(redemption, rewardType) {
        return {
            type: meActions.CREATE_REDEMPTION_SUCCESS,
            activeRedemption: redemption,
            rewardType: rewardType
        };
    },
    createRedemptionFailure: function(error, rewardType) {
        return {
            type: meActions.CREATE_REDEMPTION_FAILURE,
            error: error,
            rewardType: rewardType
        };
    },
    clearActiveRedemption: function() {
        return {
            type: meActions.CLEAR_ACTIVE_REDEMPTION
        };
    },
    fetchRedemptions: function() {
        return {
            type: meActions.FETCH_REDEMPTIONS
        };
    },
    toggleAccountDropdown: function(show) {
        return {
            type: meActions.TOGGLE_ACCOUNT_DROPDOWN,
            show: show
        };
    },
    redeemReceiptBarcode: function(barcode) {
        return {
            type: meActions.REDEEM_RECEIPT_BARCODE,
            barcode: barcode
        };
    },
    setMeCreditCardsLoadingToInitState: function() {
        return {
            type: meActions.SET_ME_CREDIT_CARDS_LOADING_TO_INIT_STATE
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (meActions);


/***/ }),

/***/ 17426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ meSliceSelector; },
/* harmony export */   "me": function() { return /* binding */ me; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47290);
/* harmony import */ var _constants_dates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81584);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63654);
/* harmony import */ var _utils_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36304);






var initialState = {
    data: null,
    error: false,
    loading: false,
    cardsLoading: "init",
    cardDeleting: false,
    favoriteLocations: null,
    favoriteLocationsLoading: false,
    favoriteOrders: [],
    pastOrders: [],
    reorderModalOpen: false,
    paymentInfoLoading: false,
    cards: [],
    allLocationsCards: [],
    orderDetails: null,
    myOffers: [],
    myAddresses: [],
    storedAddressesMenuOpen: false,
    storedAddressId: null,
    // Punchh V2 only
    loyaltyState: null,
    redeemables: [],
    messages: null,
    rewardsHistory: [],
    redemptions: [],
    accountDropdownOpen: false,
    activeRedemption: null,
    receiptBarcodeLoading: false,
    favoriteLocationFormOpen: false,
    favoriteLocationMenuOpen: false,
    favoriteLocationId: null
};
var me = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_ME */ .Z.FETCH_ME:
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_LOYALTY_STATE */ .Z.FETCH_LOYALTY_STATE:
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_REDEEMABLES */ .Z.FETCH_REDEEMABLES:
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_MESSAGES */ .Z.FETCH_MESSAGES:
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_REWARDS_HISTORY */ .Z.FETCH_REWARDS_HISTORY:
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_REDEMPTIONS */ .Z.FETCH_REDEMPTIONS:
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CREATE_REDEMPTION */ .Z.CREATE_REDEMPTION:
            return Object.assign({}, state, {
                error: false,
                loading: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_ME_FAVORITE_LOCATIONS */ .Z.FETCH_ME_FAVORITE_LOCATIONS:
            return Object.assign({}, state, {
                error: false,
                favoriteLocationsLoading: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CLEAR_ME */ .Z.CLEAR_ME:
            return initialState;
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ME_SUCCESS */ .Z.ME_SUCCESS:
            var successResult = Object.assign({}, state, {
                data: action.data,
                loading: false
            });
            return successResult;
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].UPDATE_ME_FAIL */ .Z.UPDATE_ME_FAIL:
            var result = Object.assign({}, state, {
                loading: false
            });
            return result;
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_ME_ORDER_DETAILS_SUCCESS */ .Z.FETCH_ME_ORDER_DETAILS_SUCCESS:
            return Object.assign({}, state, {
                orderDetails: action.orderDetails
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CLEAR_ME_ORDER_DETAILS */ .Z.CLEAR_ME_ORDER_DETAILS:
            return Object.assign({}, state, {
                orderDetails: null
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ME_FAVORITE_LOCATIONS_SUCCESS */ .Z.ME_FAVORITE_LOCATIONS_SUCCESS:
            return Object.assign({}, state, {
                favoriteLocations: action.favoriteLocations,
                favoriteLocationsLoading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_ME_FAVORITE_ORDERS_SUCCESS */ .Z.FETCH_ME_FAVORITE_ORDERS_SUCCESS:
            return Object.assign({}, state, {
                favoriteOrders: action.favoriteOrders
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_ME_PAST_ORDERS_SUCCESS */ .Z.FETCH_ME_PAST_ORDERS_SUCCESS:
            return Object.assign({}, state, {
                pastOrders: action.pastOrders
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].TOGGLE_REORDER_RECEIPT */ .Z.TOGGLE_REORDER_RECEIPT:
            return Object.assign({}, state, {
                reorderModalOpen: action.show
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_ME_CREDIT_CARDS */ .Z.FETCH_ME_CREDIT_CARDS:
            return Object.assign({}, state, {
                cardsLoading: "fetching"
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_ME_CREDIT_CARDS_SUCCESS */ .Z.FETCH_ME_CREDIT_CARDS_SUCCESS:
            return Object.assign({}, state, {
                cardsLoading: "success",
                cards: action.cards
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_ME_CREDIT_CARDS_FAIL */ .Z.FETCH_ME_CREDIT_CARDS_FAIL:
            return Object.assign({}, state, {
                cardsLoading: "failure",
                cards: []
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_ADDRESSES_SUCCESS */ .Z.FETCH_ADDRESSES_SUCCESS:
            return Object.assign({}, state, {
                myAddresses: action.myAddresses
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].TOGGLE_STORED_ADDRESSES_MENU */ .Z.TOGGLE_STORED_ADDRESSES_MENU:
            return Object.assign({}, state, {
                storedAddressesMenuOpen: action.show
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SET_ACTIVE_STORED_ADDRESS */ .Z.SET_ACTIVE_STORED_ADDRESS:
            return Object.assign({}, state, {
                storedAddressId: action.addressId
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_ALL_LOCATIONS_CREDIT_CARDS */ .Z.FETCH_ALL_LOCATIONS_CREDIT_CARDS:
            return Object.assign({}, state, {
                paymentInfoLoading: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_ALL_LOCATIONS_CREDIT_CARDS_SUCCESS */ .Z.FETCH_ALL_LOCATIONS_CREDIT_CARDS_SUCCESS:
            return Object.assign({}, state, {
                paymentInfoLoading: false,
                allLocationsCards: action.allLocationsCards
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DELETE_ME_CREDIT_CARD */ .Z.DELETE_ME_CREDIT_CARD:
            return Object.assign({}, state, {
                cardDeleting: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].DELETE_ME_CREDIT_CARD_SUCCESS */ .Z.DELETE_ME_CREDIT_CARD_SUCCESS:
            return Object.assign({}, state, {
                cardDeleting: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ME_FAIL */ .Z.ME_FAIL:
            return Object.assign({}, state, {
                error: true,
                loading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].ME_STOP_LOADING */ .Z.ME_STOP_LOADING:
            return Object.assign({}, state, {
                loading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].UPDATE_ME */ .Z.UPDATE_ME:
            return Object.assign({}, state, {
                loading: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].UPDATE_ME_SUCCESS */ .Z.UPDATE_ME_SUCCESS:
            return Object.assign({}, state, {
                loading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_OFFERS_SUCCESS */ .Z.FETCH_OFFERS_SUCCESS:
            return Object.assign({}, state, {
                myOffers: action.rewards
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].APPEND_USER_PHONE */ .Z.APPEND_USER_PHONE:
            return Object.assign({}, state, {
                data: Object.assign({}, state.data, {
                    phone: action.phone
                })
            });
        // Punchh V2 only
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_LOYALTY_STATE_SUCCESS */ .Z.FETCH_LOYALTY_STATE_SUCCESS:
            return Object.assign({}, state, {
                loyaltyState: action.data,
                loading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_REDEEMABLES_SUCCESS */ .Z.FETCH_REDEEMABLES_SUCCESS:
            return Object.assign({}, state, {
                redeemables: action.redeemables,
                loading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_MESSAGES_SUCCESS */ .Z.FETCH_MESSAGES_SUCCESS:
            return Object.assign({}, state, {
                messages: action.messages
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].MARK_MESSAGE_AS_READ */ .Z.MARK_MESSAGE_AS_READ:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state), {
                messages: state.messages ? state.messages.map(function(message) {
                    if (message.id !== action.messageId) {
                        return message;
                    }
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, message), {
                        read_at: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_5__/* .formatDate */ .p6)(null, _constants_dates__WEBPACK_IMPORTED_MODULE_1__/* .DATE_FORMAT.ISO_DATE */ .z.ISO_DATE)
                    });
                }) : null
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_REWARDS_HISTORY_SUCCESS */ .Z.FETCH_REWARDS_HISTORY_SUCCESS:
            return Object.assign({}, state, {
                rewardsHistory: action.rewardsHistory,
                loading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_REDEMPTIONS_SUCCESS */ .Z.FETCH_REDEMPTIONS_SUCCESS:
            return Object.assign({}, state, {
                redemptions: action.redemptions
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CREATE_REDEMPTION_SUCCESS */ .Z.CREATE_REDEMPTION_SUCCESS:
            return Object.assign({}, state, {
                activeRedemption: action.activeRedemption,
                loading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CREATE_REDEMPTION_FAILURE */ .Z.CREATE_REDEMPTION_FAILURE:
            return Object.assign({}, state, {
                loading: false,
                error: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].CLEAR_ACTIVE_REDEMPTION */ .Z.CLEAR_ACTIVE_REDEMPTION:
            return Object.assign({}, state, {
                activeRedemption: null
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].TOGGLE_ACCOUNT_DROPDOWN */ .Z.TOGGLE_ACCOUNT_DROPDOWN:
            var accountDropdownOpen = typeof action.show !== "undefined" ? action.show : !state.accountDropdownOpen;
            // Disable / enable body scrolling
            (0,_utils_global__WEBPACK_IMPORTED_MODULE_2__/* .toggleBodyScroll */ .R0)(!accountDropdownOpen);
            return Object.assign({}, state, {
                accountDropdownOpen: typeof action.show !== "undefined" ? action.show : !state.accountDropdownOpen
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].REDEEM_RECEIPT_BARCODE */ .Z.REDEEM_RECEIPT_BARCODE:
            return Object.assign({}, state, {
                receiptBarcodeLoading: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].REDEEM_RECEIPT_BARCODE_SUCCESS */ .Z.REDEEM_RECEIPT_BARCODE_SUCCESS:
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].REDEEM_RECEIPT_BARCODE_FAILURE */ .Z.REDEEM_RECEIPT_BARCODE_FAILURE:
            return Object.assign({}, state, {
                receiptBarcodeLoading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SET_ME_CREDIT_CARDS_LOADING_TO_INIT_STATE */ .Z.SET_ME_CREDIT_CARDS_LOADING_TO_INIT_STATE:
            return Object.assign({}, state, {
                cardsLoading: "init"
            });
        default:
            return state;
    }
};
var meSliceSelector = function(state) {
    return state.app.me;
};


/***/ }),

/***/ 22354:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var menuActions = {
    // Basket Menu
    FETCH_BASKET_MENU: "/koala/menu/FETCH_BASKET_MENU",
    FETCH_BASKET_MENU_ERROR: "/koala/menu/FETCH_BASKET_ERROR",
    SET_BASKET_MENU: "/koala/menu/SET_BASKET_MENU",
    SET_BASKET_MENU_FROM_STORAGE: "/koala/menu/SET_BASKET_MENU_FROM_STORAGE",
    HYDRATE_BASKET_MENU: "/koala/menu/HYDRATE_BASKET_MENU",
    PUSH_NAVIGATION_STATUS: "/koala/menu/PUSH_NAVIGATION_STATUS",
    REQUEST_NAVIGATION_UPDATE: "/koala/menu/REQUEST_NAVIGATION_UPDATE",
    refreshBasketMenu: function(id, wantedAt) {
        return {
            type: menuActions.FETCH_BASKET_MENU,
            id: id,
            wantedAt: wantedAt
        };
    },
    hydrateBasketMenu: function() {
        return {
            type: menuActions.HYDRATE_BASKET_MENU
        };
    },
    setBasketMenu: function(menuCategories, compressedCategories) {
        return {
            type: menuActions.SET_BASKET_MENU,
            menuCategories: menuCategories,
            compressedCategories: compressedCategories
        };
    },
    setBasketMenuFromStorage: function(menuCategories) {
        return {
            type: menuActions.SET_BASKET_MENU_FROM_STORAGE,
            menuCategories: menuCategories
        };
    },
    pushNavigationStatus: function(categoryId) {
        return {
            type: menuActions.PUSH_NAVIGATION_STATUS,
            categoryId: categoryId
        };
    },
    requestNavigationUpdate: function(categoryId) {
        return {
            type: menuActions.REQUEST_NAVIGATION_UPDATE,
            categoryId: categoryId
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (menuActions);


/***/ }),

/***/ 88068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GI": function() { return /* binding */ menu; },
/* harmony export */   "e_": function() { return /* binding */ selectMenuSlice; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96670);
/* harmony import */ var _basket_actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29682);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22354);
/* harmony import */ var _utils_menu__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(682);





var initialState = {
    // menu associated with a localStorage basket, if one exists
    basketMenu: [],
    basketMenuLoading: false,
    navigationStatus: "",
    requestedNavigationUpdate: ""
};
var menu = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case _actions__WEBPACK_IMPORTED_MODULE_1__/* ["default"].SET_BASKET_MENU_FROM_STORAGE */ .Z.SET_BASKET_MENU_FROM_STORAGE:
            return Object.assign({}, state, {
                basketMenu: action.menuCategories
            });
        // Cases that set the menu associated with the current basket in redux
        case _actions__WEBPACK_IMPORTED_MODULE_1__/* ["default"].FETCH_BASKET_MENU */ .Z.FETCH_BASKET_MENU:
            return Object.assign({}, state, {
                basketMenuLoading: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_1__/* ["default"].SET_BASKET_MENU */ .Z.SET_BASKET_MENU:
        case _basket_actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].INIT_NEW_BASKET */ .Z.INIT_NEW_BASKET:
        case _basket_actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].REPLACE_BASKET */ .Z.REPLACE_BASKET:
            // Set either the compressed menu or the normal menu, depending on the config
            var menu = {
                compressed: true,
                categories: action.compressedCategories
            };
            // Set menu in session storage
            (0,_utils_menu__WEBPACK_IMPORTED_MODULE_2__/* .setMenuInStorage */ .$F)(menu);
            return Object.assign({}, state, {
                basketMenu: action.menuCategories,
                basketMenuLoading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_1__/* ["default"].FETCH_BASKET_MENU_ERROR */ .Z.FETCH_BASKET_MENU_ERROR:
            return Object.assign({}, state, {
                basketMenuLoading: false
            });
        case _actions__WEBPACK_IMPORTED_MODULE_1__/* ["default"].PUSH_NAVIGATION_STATUS */ .Z.PUSH_NAVIGATION_STATUS:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state), {
                navigationStatus: action.categoryId
            });
        case _actions__WEBPACK_IMPORTED_MODULE_1__/* ["default"].REQUEST_NAVIGATION_UPDATE */ .Z.REQUEST_NAVIGATION_UPDATE:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, state), {
                requestedNavigationUpdate: action.categoryId
            });
        default:
            return state;
    }
};
var selectMenuSlice = function(state) {
    return state.app.menu;
};


/***/ }),

/***/ 82765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ orderDetailsActions; },
/* harmony export */   "b": function() { return /* binding */ orderDetailsActionTypes; }
/* harmony export */ });
var orderDetailsActionTypes;
(function(orderDetailsActionTypes) {
    orderDetailsActionTypes["FETCH_ORDER_DETAILS_BY_ORDER_ID"] = "/koala/orderDetails/FETCH_ORDER_DETAILS_BY_ORDER_ID";
    orderDetailsActionTypes["FETCH_ORDER_DETAILS_BY_ORDER_ID_SUCCESS"] = "/koala/orderDetails/FETCH_ORDER_DETAILS_BY_ORDER_ID_SUCCESS";
    orderDetailsActionTypes["FETCH_ORDER_DETAILS_BY_ORDER_ID_FAIL"] = "/koala/orderDetails/FETCH_ORDER_DETAILS_BY_ORDER_ID_FAIL";
    orderDetailsActionTypes["CLEAR_ORDER_DETAILS_STATE"] = "/koala/orderDetails/CLEAR_ORDER_DETAILS_STATE";
    orderDetailsActionTypes["ADD_ORDER_DETAILS_STATE"] = "/koala/orderDetails/ADD_ORDER_DETAILS_STATE";
})(orderDetailsActionTypes || (orderDetailsActionTypes = {}));
var orderDetailsActions = {
    fetchOrderDetailsByOrderId: function(orderId) {
        return {
            type: orderDetailsActionTypes.FETCH_ORDER_DETAILS_BY_ORDER_ID,
            order_id: orderId
        };
    },
    fetchOrderDetailsByOrderIdSuccess: function(data) {
        return {
            data: data,
            type: orderDetailsActionTypes.FETCH_ORDER_DETAILS_BY_ORDER_ID_SUCCESS
        };
    },
    fetchOrderDetailsByOrderIdFail: function(error) {
        return {
            type: orderDetailsActionTypes.FETCH_ORDER_DETAILS_BY_ORDER_ID_FAIL,
            error: error
        };
    },
    clearOrderDetailsState: function() {
        return {
            type: orderDetailsActionTypes.CLEAR_ORDER_DETAILS_STATE
        };
    },
    addOrderDetailsState: function(data) {
        return {
            type: orderDetailsActionTypes.ADD_ORDER_DETAILS_STATE,
            data: data
        };
    }
};


/***/ }),

/***/ 60329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ms": function() { return /* binding */ orderDetailsSelector; },
/* harmony export */   "cW": function() { return /* binding */ orderDetails; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82765);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(63654);



/** @TODO decouple IOrderDetailsState from the SDK response type. */ // @ts-expect-error
var initialState = {
    organization_id: null,
    store_location_id: null,
    store_location: null,
    order_id: null,
    basket_id: null,
    balance: null,
    ready_at: null,
    total: null,
    status_id: null,
    client_id: null,
    is_complete: null,
    order_data: {
        customer: {
            first_name: null,
            last_name: null,
            email: null,
            contact_number: null
        },
        order: {
            id: null,
            subtotal: null,
            sales_tax: null,
            total: null,
            ordered_at: null,
            order_number: null,
            order_items: null,
            payment_card: null,
            payment_card_type: null,
            promo_discount: null,
            ready_at: null,
            arrival_status: null
        },
        basket: {
            id: null,
            special_instructions: null,
            tip: null,
            subtotal: null,
            sales_tax: null,
            total: null,
            time_estimate_minutes: null,
            promo_discount: null,
            wanted_at: null,
            conveyance_type: null,
            location: null,
            basket_items: null
        },
        payment: null
    },
    id: null,
    updated_at: null,
    created_at: null,
    ip: null,
    arrival_status: null,
    meta: {
        loading: false,
        error: null,
        params: null,
        lastUpdatedAt: null
    }
};
var orderDetails = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .orderDetailsActionTypes.FETCH_ORDER_DETAILS_BY_ORDER_ID */ .b.FETCH_ORDER_DETAILS_BY_ORDER_ID:
            {
                var partialState = {
                    order_id: action.order_id,
                    meta: {
                        error: null,
                        loading: true,
                        params: null
                    }
                };
                return Object.assign({}, state, partialState);
            }
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .orderDetailsActionTypes.FETCH_ORDER_DETAILS_BY_ORDER_ID_SUCCESS */ .b.FETCH_ORDER_DETAILS_BY_ORDER_ID_SUCCESS:
            {
                var partialState1 = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                    meta: {
                        error: null,
                        loading: false,
                        params: null,
                        lastUpdatedAt: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .getISODateInUTC */ .j4)()
                    }
                }, action.data);
                return Object.assign({}, state, partialState1);
            }
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .orderDetailsActionTypes.FETCH_ORDER_DETAILS_BY_ORDER_ID_FAIL */ .b.FETCH_ORDER_DETAILS_BY_ORDER_ID_FAIL:
            {
                var partialState2 = {
                    meta: {
                        error: action.error,
                        loading: false,
                        params: null,
                        lastUpdatedAt: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .getISODateInUTC */ .j4)()
                    }
                };
                return Object.assign({}, state, partialState2);
            }
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .orderDetailsActionTypes.ADD_ORDER_DETAILS_STATE */ .b.ADD_ORDER_DETAILS_STATE:
            {
                var partialState3 = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                    meta: {
                        error: null,
                        loading: false,
                        params: null,
                        lastUpdatedAt: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_2__/* .getISODateInUTC */ .j4)()
                    }
                }, action.data);
                return Object.assign({}, state, partialState3);
            }
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* .orderDetailsActionTypes.CLEAR_ORDER_DETAILS_STATE */ .b.CLEAR_ORDER_DETAILS_STATE:
            return Object.assign({}, initialState);
        default:
            return state;
    }
};
var orderDetailsSelector = function(state) {
    return state.app.orderDetails;
};


/***/ }),

/***/ 76750:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var orderStatusActions = {
    ORDER_STATUS_MESSAGE_CLEAR: "/koala/orderStatus/ORDER_STATUS_MESSAGE_CLEAR",
    ORDER_STATUS_MESSAGE_ERROR_SET: "/koala/orderStatus/ORDER_STATUS_MESSAGE_ERROR_SET",
    ORDER_NOT_INITIALIZED: "/koala/orderStatus/ORDER_NOT_INITIALIZED",
    ORDER_PENDING: "/koala/orderStatus/ORDER_PENDING",
    INITIALIZE_ORDER: "/koala/orderStatus/INITIALIZE_ORDER",
    INITIALIZE_ORDER_ERROR: "/koala/orderStatus/INITIALIZE_ORDER_ERROR",
    INITIALIZE_ORDER_RECONCILIATION: "/koala/orderStatus/INITIALIZE_ORDER_RECONCILIATION",
    POST_INITIALIZE_ORDER: "/koala/orderStatus/POST_INITIALIZE_ORDER",
    DESTROY_ORDER: "/koala/orderStatus/DESTROY_ORDER",
    VALIDATE_ORDER: "/koala/orderStatus/VALIDATE_ORDER",
    PROMO_CODE_ADD: "/koala/orderStatus/PROMO_CODE_ADD",
    PROMO_CODE_REMOVE: "/koala/orderStatus/PROMO_CODE_REMOVE",
    BASKET_REWARDS_GET: "/koala/orderStatus/BASKET_REWARDS_GET",
    BASKET_REWARDS_ADD: "/koala/orderStatus/BASKET_REWARDS_ADD",
    BASKET_REWARDS_REMOVE: "/koala/orderStatus/BASKET_REWARDS_REMOVE",
    TIP_ADD: "/koala/orderStatus/TIP_ADD",
    UTENSILS_SET: "/koala/orderStatus/UTENSILS_SET",
    BASKET_INSTRUCTIONS_SET: "/koala/orderStatus/BASKET_INSTRUCTIONS_SET",
    CONVEYANCE_SET: "/koala/orderStatus/CONVEYANCE_SET",
    CONVEYANCE_DELIVERY_SET: "/koala/orderStatus/CONVEYANCE_DELIVERY_SET",
    WANTED_AT_BASKET_SET: "/koala/orderStatus/WANTED_AT_BASKET_SET",
    WANTED_AT_BASKET_REMOVE: "/koala/orderStatus/WANTED_AT_BASKET_REMOVE",
    ORDER_SUBMISSION_TRIGGER: "/koala/orderStatus/ORDER_SUBMISSION_TRIGGER",
    ORDER_SUBMISSION_PCI_ERROR: "/koala/orderStatus/ORDER_SUBMISSION_PCI_ERROR",
    ORDER_SUBMISSION_PCI_FAILURE: "/koala/orderStatus/ORDER_SUBMISSION_PCI_FAILURE",
    ORDER_SUBMISSION_START: "/koala/orderStatus/ORDER_SUBMISSION_START",
    ORDER_SUBMISSION_ERROR: "/koala/orderStatus/ORDER_SUBMISSION_ERROR",
    STORED_VALUE_POST: "/koala/orderStatus/STORED_VALUE_POST",
    ORDER_SUBMISSION_DIGITAL_WALLET_TRIGGER: "/koala/orderStatus/ORDER_SUBMISSION_DIGITAL_WALLET_TRIGGER",
    orderStatusMessageClear: function() {
        return {
            type: orderStatusActions.ORDER_STATUS_MESSAGE_CLEAR
        };
    },
    orderStatusMessageErrorSet: function(message) {
        return {
            type: orderStatusActions.ORDER_STATUS_MESSAGE_ERROR_SET,
            message: message
        };
    },
    orderPending: function() {
        return {
            type: orderStatusActions.ORDER_PENDING
        };
    },
    orderNotInitialized: function() {
        return {
            type: orderStatusActions.ORDER_NOT_INITIALIZED
        };
    },
    initializeOrder: function(basketOrder, locationId, wantedAt) {
        return {
            type: orderStatusActions.INITIALIZE_ORDER,
            basketOrder: basketOrder,
            locationId: locationId,
            wantedAt: wantedAt
        };
    },
    initializeOrderError: function(message) {
        return {
            type: orderStatusActions.INITIALIZE_ORDER_ERROR,
            message: message
        };
    },
    initializeOrderReconciliation: function(message) {
        return {
            type: orderStatusActions.INITIALIZE_ORDER_RECONCILIATION,
            message: message
        };
    },
    postInitializeOrder: function(basketOrder, basket, fulfillmentType, wantedAtDay, wantedAt) {
        return {
            type: orderStatusActions.POST_INITIALIZE_ORDER,
            basketOrder: basketOrder,
            basket: basket,
            fulfillmentType: fulfillmentType,
            wantedAtDay: wantedAtDay,
            wantedAt: wantedAt
        };
    },
    destroyOrder: function() {
        return {
            type: orderStatusActions.DESTROY_ORDER
        };
    },
    validateOrder: function(basketId, locationId) {
        return {
            type: orderStatusActions.VALIDATE_ORDER,
            basketId: basketId,
            locationId: locationId
        };
    },
    promoCodeAdd: function(promoCode) {
        return {
            type: orderStatusActions.PROMO_CODE_ADD,
            promoCode: promoCode
        };
    },
    promoCodeRemove: function() {
        return {
            type: orderStatusActions.PROMO_CODE_REMOVE
        };
    },
    conveyanceSet: function() {
        return {
            type: orderStatusActions.CONVEYANCE_SET
        };
    },
    conveyanceDeliverySet: function(instructions, staleId) {
        return {
            type: orderStatusActions.CONVEYANCE_DELIVERY_SET,
            instructions: instructions,
            staleId: staleId
        };
    },
    wantedAtBasketSet: function(wantedAt, basketId, locationId) {
        return {
            type: orderStatusActions.WANTED_AT_BASKET_SET,
            wantedAt: wantedAt,
            basketId: basketId,
            locationId: locationId
        };
    },
    wantedAtBasketRemove: function() {
        return {
            type: orderStatusActions.WANTED_AT_BASKET_REMOVE
        };
    },
    basketRewardsGet: function() {
        return {
            type: orderStatusActions.BASKET_REWARDS_GET
        };
    },
    basketRewardsAdd: function() {
        return {
            type: orderStatusActions.BASKET_REWARDS_ADD
        };
    },
    basketRewardsRemove: function() {
        return {
            type: orderStatusActions.BASKET_REWARDS_REMOVE
        };
    },
    tipAdd: function(tipAmount, isCustom) {
        return {
            type: orderStatusActions.TIP_ADD,
            tipAmount: tipAmount,
            isCustom: isCustom
        };
    },
    utensilsSet: function(utensils) {
        return {
            type: orderStatusActions.UTENSILS_SET,
            utensils: utensils
        };
    },
    basketInstructionsSet: function(basketInstructions) {
        return {
            type: orderStatusActions.BASKET_INSTRUCTIONS_SET,
            basketInstructions: basketInstructions
        };
    },
    storedValuePost: function(cardNumber, pin, captcha) {
        return {
            type: orderStatusActions.STORED_VALUE_POST,
            cardNumber: cardNumber,
            pin: pin,
            captcha: captcha
        };
    },
    orderSubmissionTrigger: function(message, captcha) {
        return {
            type: orderStatusActions.ORDER_SUBMISSION_TRIGGER,
            message: message,
            captcha: captcha
        };
    },
    orderSubmissionPciError: function(message) {
        return {
            type: orderStatusActions.ORDER_SUBMISSION_PCI_ERROR,
            message: message
        };
    },
    orderSubmissionPciFailure: function() {
        return {
            type: orderStatusActions.ORDER_SUBMISSION_PCI_FAILURE
        };
    },
    orderSubmissionStart: function(submitBasketData, captcha) {
        return {
            type: orderStatusActions.ORDER_SUBMISSION_START,
            submitBasketData: submitBasketData,
            captcha: captcha
        };
    },
    orderSubmissionError: function(message) {
        return {
            type: orderStatusActions.ORDER_SUBMISSION_ERROR,
            message: message
        };
    },
    orderDigitalWalletTrigger: function(paymentDetails, message, captcha) {
        return {
            type: orderStatusActions.ORDER_SUBMISSION_DIGITAL_WALLET_TRIGGER,
            message: message,
            paymentDetails: paymentDetails,
            captcha: captcha
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (orderStatusActions);


/***/ }),

/***/ 8460:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var organizationActions = {
    FETCH_ORGANIZATION: "/koala/organization/FETCH_ORGANIZATION",
    FETCH_ORGANIZATION_SUCCESS: "/koala/organization/FETCH_ORGANIZATION_SUCCESS",
    FETCH_ORGANIZATION_FAIL: "/koala/organization/FETCH_ORGANIZATION_FAIL",
    fetchOrganization: function() {
        return {
            type: organizationActions.FETCH_ORGANIZATION
        };
    },
    fetchOrganizationSuccess: function(organizationConfig) {
        return {
            type: organizationActions.FETCH_ORGANIZATION_SUCCESS,
            organizationConfig: organizationConfig
        };
    },
    fetchOrganizationFail: function() {
        return {
            type: organizationActions.FETCH_ORGANIZATION_FAIL
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (organizationActions);


/***/ }),

/***/ 63212:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F5": function() { return /* binding */ organizationSliceSelector; },
/* harmony export */   "cO": function() { return /* binding */ organization; }
/* harmony export */ });
/* unused harmony export initialState */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70865);
/* harmony import */ var _actions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8460);


/** @TODO decouple IOrganizationState from the SDK response type. */ var initialState = {
    loading: false,
    // @ts-ignore
    id: null,
    ordering: {
        // @ts-ignore
        driver_id: null,
        // @ts-ignore
        label: null,
        environment: "sandbox"
    },
    organization: {
        // @ts-ignore
        id: null,
        created_at: "",
        updated_at: "",
        deleted_at: "",
        label: "",
        // @ts-ignore
        ordering_driver_id: null,
        loyalty_driver_id: null,
        // @ts-ignore
        external_provider_id: null,
        last_synced_at: "",
        nutrition_url: "",
        // @ts-ignore
        upsell_driver_id: null
    },
    payment: {
        // @ts-ignore
        driver_id: null,
        label: "",
        meta: []
    },
    loyalty: {
        // @ts-ignore
        driver_id: null,
        label: "",
        // @ts-ignore
        features: null,
        // @ts-ignore
        program_type: null
    },
    external_auth: {
        // @ts-ignore
        driver_id: null,
        label: "",
        // @ts-ignore
        registration_fields: null,
        // @ts-ignore
        updatable_fields: null,
        // @ts-ignore
        readonly_fields: null,
        // @ts-ignore
        features: null
    }
};
var organization = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_ORGANIZATION */ .Z.FETCH_ORGANIZATION:
            return Object.assign({}, state, {
                loading: true
            });
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_ORGANIZATION_SUCCESS */ .Z.FETCH_ORGANIZATION_SUCCESS:
            var ref;
            return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
                loading: false,
                id: (ref = action.organizationConfig) === null || ref === void 0 ? void 0 : ref.organization.id
            }, action.organizationConfig);
        case _actions__WEBPACK_IMPORTED_MODULE_0__/* ["default"].FETCH_ORGANIZATION_FAIL */ .Z.FETCH_ORGANIZATION_FAIL:
            return Object.assign({}, state, {
                loading: false
            });
        default:
            return state;
    }
};
var organizationSliceSelector = function(state) {
    return state.app.organization;
};


/***/ }),

/***/ 81895:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var paymentActions = {
    CREDIT_CARD_TRANSACTION_ID_GET: "/koala/payment/CREDIT_CARD_TRANSACTION_ID_GET",
    // Stored Value
    STORED_VALUE_TOGGLE: "/koala/payment/STORED_VALUE_TOGGLE",
    DIGITAL_WALLET_TOGGLE: "/koala/payment/DIGITAL_WALLET_TOGGLE",
    STORED_VALUE_CLEAR: "/koala/payment/STORED_VALUE_CLEAR",
    STORED_VALUE_SET: "/koala/payment/STORED_VALUE_SET",
    STORED_VALUE_ERROR: "/koala/payment/STORED_VALUE_ERROR",
    BILLING_ACCOUNT_SET: "/koala/payment/BILLING_ACCOUNT_SET",
    CREDIT_CARD_SET: "/koala/payment/CREDIT_CARD_SET",
    PAY_IN_STORE_SET: "/koala/payment/PAY_IN_STORE_SET",
    PAYMENT_TYPE_RESET: "/koala/payment/PAYMENT_TYPE_RESET",
    // Credit card exchanges
    creditCardTransactionIdGet: function(creditCard) {
        return {
            type: paymentActions.CREDIT_CARD_TRANSACTION_ID_GET,
            creditCard: creditCard
        };
    },
    // Set payment types
    billingAccountSet: function(savedAccountId) {
        return {
            type: paymentActions.BILLING_ACCOUNT_SET,
            savedAccountId: savedAccountId
        };
    },
    creditCardSet: function(creditCard) {
        return {
            type: paymentActions.CREDIT_CARD_SET,
            creditCard: creditCard
        };
    },
    payInStoreSet: function() {
        return {
            type: paymentActions.PAY_IN_STORE_SET
        };
    },
    storedValueToggle: function() {
        return {
            type: paymentActions.STORED_VALUE_TOGGLE
        };
    },
    digitalWalletToggle: function() {
        return {
            type: paymentActions.DIGITAL_WALLET_TOGGLE
        };
    },
    // Reset paymentType
    paymentTypeReset: function() {
        return {
            type: paymentActions.PAYMENT_TYPE_RESET
        };
    },
    // Stored Value
    storedValueSet: function(storedValue) {
        return {
            type: paymentActions.STORED_VALUE_SET,
            storedValue: storedValue
        };
    },
    storedValueError: function(message) {
        return {
            type: paymentActions.STORED_VALUE_ERROR,
            message: message
        };
    },
    storedValueClear: function() {
        return {
            type: paymentActions.STORED_VALUE_CLEAR
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (paymentActions);


/***/ }),

/***/ 67461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B_": function() { return /* binding */ storedValueErrors; },
/* harmony export */   "FI": function() { return /* binding */ StoredValueFields; },
/* harmony export */   "wO": function() { return /* binding */ storedValueMessages; }
/* harmony export */ });
var StoredValueFields;
(function(StoredValueFields) {
    StoredValueFields["PIN"] = "pin";
    StoredValueFields["CARD"] = "card";
})(StoredValueFields || (StoredValueFields = {}));
var storedValueMessages = {
    "PIN field is required.": StoredValueFields.PIN,
    "Oops, gift card not found": StoredValueFields.CARD
};
// Whitelisted API errors
var storedValueErrors = {
    PIN_REQUIRED: "PIN field is required.",
    CAPTCHA: "Oops, we could not validate this gift card. Please try again.",
    DEFAULT: "Oops, gift card not found"
};


/***/ }),

/***/ 95225:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var paymentActions = {
    PAYMENT_TYPES_GET: "/koala/paymentTypes/PAYMENT_TYPES_GET",
    PAYMENT_TYPES_GET_SUCCESS: "/koala/paymentTypes/PAYMENT_TYPES_GET_SUCCESS",
    PAYMENT_TYPES_CLEAR: "/koala/paymentTypes/PAYMENT_TYPES_CLEAR",
    paymentTypesGet: function(basketId, locationId) {
        return {
            type: paymentActions.PAYMENT_TYPES_GET,
            basketId: basketId,
            locationId: locationId
        };
    },
    paymentTypesGetSuccess: function(paymentTypes) {
        return {
            type: paymentActions.PAYMENT_TYPES_GET_SUCCESS,
            paymentTypes: paymentTypes
        };
    },
    paymentTypesClear: function() {
        return {
            type: paymentActions.PAYMENT_TYPES_CLEAR
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (paymentActions);


/***/ }),

/***/ 36429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ wrapper; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/react-redux/es/index.js + 21 modules
var es = __webpack_require__(56580);
;// CONCATENATED MODULE: ../../node_modules/next-redux-wrapper/es6/index.js
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (undefined && undefined.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};


/**
 * Quick note on Next.js return types:
 *
 * Page.getInitialProps https://nextjs.org/docs/api-reference/data-fetching/getInitialProps
 * as-is
 *
 * App.getInitialProps: AppInitialProps https://nextjs.org/docs/advanced-features/custom-app
 * {pageProps: any}
 *
 * getStaticProps https://nextjs.org/docs/basic-features/data-fetching#getstaticprops-static-generation
 * {props: any}
 *
 * getServerSideProps https://nextjs.org/docs/basic-features/data-fetching#getserversideprops-server-side-rendering
 * {props: any}
 */
var HYDRATE = '__NEXT_REDUX_WRAPPER_HYDRATE__';
var getIsServer = function () { return typeof window === 'undefined'; };
var getDeserializedState = function (initialState, _a) {
    var _b = _a === void 0 ? {} : _a, deserializeState = _b.deserializeState;
    return deserializeState ? deserializeState(initialState) : initialState;
};
var getSerializedState = function (state, _a) {
    var _b = _a === void 0 ? {} : _a, serializeState = _b.serializeState;
    return serializeState ? serializeState(state) : state;
};
var store;
var initStore = function (_a) {
    var makeStore = _a.makeStore, context = _a.context;
    var createStore = function () { return makeStore(context); };
    if (getIsServer()) {
        var c = context;
        var req = void 0;
        if (c.req)
            req = c.req;
        if (c.ctx && c.ctx.req)
            req = c.ctx.req;
        if (req) {
            // ATTENTION! THIS IS INTERNAL, DO NOT ACCESS DIRECTLY ANYWHERE ELSE
            // @see https://github.com/kirill-konshin/next-redux-wrapper/pull/196#issuecomment-611673546
            if (!req.__nextReduxWrapperStore)
                req.__nextReduxWrapperStore = createStore();
            return req.__nextReduxWrapperStore;
        }
        return createStore();
    }
    // Memoize store if client
    if (!store) {
        store = createStore();
    }
    return store;
};
var createWrapper = function (makeStore, config) {
    if (config === void 0) { config = {}; }
    var makeProps = function (_a) {
        var callback = _a.callback, context = _a.context;
        return __awaiter(void 0, void 0, void 0, function () {
            var store, nextCallback, initialProps, _b, state;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        store = initStore({ context: context, makeStore: makeStore });
                        if (config.debug)
                            console.log("1. getProps created store with state", store.getState());
                        nextCallback = callback && callback(store);
                        _b = nextCallback;
                        if (!_b) return [3 /*break*/, 2];
                        return [4 /*yield*/, nextCallback(context)];
                    case 1:
                        _b = (_c.sent());
                        _c.label = 2;
                    case 2:
                        initialProps = (_b) || {};
                        if (config.debug)
                            console.log("3. getProps after dispatches has store state", store.getState());
                        state = store.getState();
                        return [2 /*return*/, {
                                initialProps: initialProps,
                                initialState: getIsServer() ? getSerializedState(state, config) : state,
                            }];
                }
            });
        });
    };
    var getInitialPageProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if ('getState' in context) {
                return [2 /*return*/, callback && callback(context)];
            }
            return [2 /*return*/, makeProps({ callback: callback, context: context })];
        });
    }); }; };
    var getInitialAppProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, initialProps, initialState;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                case 1:
                    _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
                    return [2 /*return*/, __assign(__assign({}, initialProps), { initialState: initialState })];
            }
        });
    }); }; };
    var getStaticProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, initialProps, initialState;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, makeProps({ callback: callback, context: context })];
                case 1:
                    _a = _b.sent(), initialProps = _a.initialProps, initialState = _a.initialState;
                    return [2 /*return*/, __assign(__assign({}, initialProps), { props: __assign(__assign({}, initialProps.props), { initialState: initialState }) })];
            }
        });
    }); }; };
    var getServerSideProps = function (callback) { return function (context) { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getStaticProps(callback)(context)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    }); }); }; }; // just not to repeat myself
    var withRedux = function (Component) {
        var _a;
        var displayName = "withRedux(" + (Component.displayName || Component.name || 'Component') + ")";
        var hasInitialProps = 'getInitialProps' in Component;
        //TODO Check if pages/_app was wrapped so there's no need to wrap a page itself
        return _a = /** @class */ (function (_super) {
                __extends(Wrapper, _super);
                function Wrapper(props, context) {
                    var _this = _super.call(this, props, context) || this;
                    _this.store = null;
                    _this.hydrate(props, context);
                    return _this;
                }
                Wrapper.prototype.hydrate = function (_a, context) {
                    var _b;
                    var initialState = _a.initialState, initialProps = _a.initialProps, props = __rest(_a, ["initialState", "initialProps"]);
                    // this happens when App has page with getServerSideProps/getStaticProps, initialState will be dumped twice:
                    // one incomplete and one complete
                    var initialStateFromGSPorGSSR = (_b = props === null || props === void 0 ? void 0 : props.pageProps) === null || _b === void 0 ? void 0 : _b.initialState;
                    if (!this.store) {
                        this.store = initStore({ makeStore: makeStore, context: context });
                        if (config.debug)
                            console.log('4. WrappedApp created new store with', displayName, {
                                initialState: initialState,
                                initialStateFromGSPorGSSR: initialStateFromGSPorGSSR,
                            });
                    }
                    if (initialState)
                        this.store.dispatch({
                            type: HYDRATE,
                            payload: getDeserializedState(initialState, config),
                        });
                    // ATTENTION! This code assumes that Page's getServerSideProps is executed after App.getInitialProps
                    // so we dispatch in this order
                    if (initialStateFromGSPorGSSR)
                        this.store.dispatch({
                            type: HYDRATE,
                            payload: getDeserializedState(initialStateFromGSPorGSSR, config),
                        });
                };
                Wrapper.prototype.shouldComponentUpdate = function (nextProps, nextState, nextContext) {
                    var _a, _b, _c, _d;
                    if (((_a = nextProps === null || nextProps === void 0 ? void 0 : nextProps.pageProps) === null || _a === void 0 ? void 0 : _a.initialState) !== ((_c = (_b = this.props) === null || _b === void 0 ? void 0 : _b.pageProps) === null || _c === void 0 ? void 0 : _c.initialState) ||
                        (nextProps === null || nextProps === void 0 ? void 0 : nextProps.initialState) !== ((_d = this.props) === null || _d === void 0 ? void 0 : _d.initialState)) {
                        this.hydrate(nextProps, nextContext);
                    }
                    return true;
                };
                Wrapper.prototype.render = function () {
                    var _a, _b;
                    var _c = this.props, initialState = _c.initialState, initialProps = _c.initialProps, props = __rest(_c, ["initialState", "initialProps"]);
                    var resultProps = props;
                    // order is important! Next.js overwrites props from pages/_app with getStaticProps from page
                    // @see https://github.com/zeit/next.js/issues/11648
                    if (initialProps && initialProps.pageProps)
                        resultProps.pageProps = __assign(__assign({}, initialProps.pageProps), props.pageProps);
                    var initialStateFromGSPorGSSR = (_a = props === null || props === void 0 ? void 0 : props.pageProps) === null || _a === void 0 ? void 0 : _a.initialState;
                    // just some cleanup to prevent passing it as props, we need to clone props to safely delete initialState
                    if (initialStateFromGSPorGSSR) {
                        resultProps = __assign(__assign({}, props), { pageProps: __assign({}, props.pageProps) });
                        delete resultProps.pageProps.initialState;
                    }
                    // unwrap getInitialPageProps
                    if ((_b = resultProps === null || resultProps === void 0 ? void 0 : resultProps.pageProps) === null || _b === void 0 ? void 0 : _b.initialProps) {
                        resultProps.pageProps = __assign(__assign({}, resultProps.pageProps), resultProps.pageProps.initialProps);
                        delete resultProps.pageProps.initialProps;
                    }
                    return (react.createElement(es.Provider, { store: this.store },
                        react.createElement(Component, __assign({}, initialProps, resultProps))));
                };
                return Wrapper;
            }(react.Component)),
            _a.displayName = displayName,
            _a.getInitialProps = hasInitialProps ? Component.getInitialProps : undefined,
            _a;
    };
    return {
        getServerSideProps: getServerSideProps,
        getStaticProps: getStaticProps,
        getInitialAppProps: getInitialAppProps,
        getInitialPageProps: getInitialPageProps,
        withRedux: withRedux,
    };
};
// Legacy
/* harmony default export */ var es6 = (function (makeStore, config) {
    if (config === void 0) { config = {}; }
    console.warn('/!\\ You are using legacy implementaion. Please update your code: use createWrapper() and wrapper.withRedux().');
    return createWrapper(makeStore, config).withRedux;
});
//# sourceMappingURL=index.js.map
// EXTERNAL MODULE: ../../node_modules/redux/es/redux.js + 1 modules
var redux = __webpack_require__(38726);
// EXTERNAL MODULE: ../../node_modules/redux-devtools-extension/index.js
var redux_devtools_extension = __webpack_require__(58267);
// EXTERNAL MODULE: ../../node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js + 2 modules
var redux_saga_core_npm_proxy_esm = __webpack_require__(91199);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/react-redux-loading-bar/build/index.js
var build = __webpack_require__(22299);
// EXTERNAL MODULE: ../../node_modules/redux-form/lib/reducer.js
var reducer = __webpack_require__(9891);
// EXTERNAL MODULE: ./src/redux/allergens/actions.ts
var actions = __webpack_require__(92153);
;// CONCATENATED MODULE: ./src/redux/allergens/reducer.ts

var initialState = {
    allergens: [],
    activeAllergens: []
};
var allergens = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case actions/* default.FETCH_ALLERGENS */.Z.FETCH_ALLERGENS:
            return state;
        case actions/* default.ALLERGENS_SUCCESS */.Z.ALLERGENS_SUCCESS:
            return Object.assign({}, state, {
                allergens: action.detail ? action.detail.slice(0) : []
            });
        case actions/* default.UPDATE_ALLERGENS */.Z.UPDATE_ALLERGENS:
            return Object.assign({}, state, {
                activeAllergens: action.updatedAllergens ? action.updatedAllergens.slice(0) : []
            });
        case actions/* default.TOGGLE_ALLERGEN */.Z.TOGGLE_ALLERGEN:
            var activeAllergens = state.activeAllergens.slice(0);
            var index = activeAllergens.indexOf(action.id);
            if (index > -1) {
                activeAllergens.splice(index, 1);
            } else {
                activeAllergens.push(action.id);
            }
            return Object.assign({}, state, {
                activeAllergens: activeAllergens
            });
        case actions/* default.ALLERGENS_FAIL */.Z.ALLERGENS_FAIL:
            return state;
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./src/redux/arrivalStatus/actions.ts
var arrivalStatus_actions = __webpack_require__(20756);
;// CONCATENATED MODULE: ./src/redux/arrivalStatus/reducer.ts

var reducer_initialState = {
    loading: false,
    data: null,
    error: false,
    orderDetails: null
};
var arrivalStatus = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case arrivalStatus_actions/* default.FETCH_ARRIVAL_STATUS */.Z.FETCH_ARRIVAL_STATUS:
            return Object.assign({}, state, {
                loading: true
            });
        case arrivalStatus_actions/* default.FETCH_ARRIVAL_STATUS_SUCCESS */.Z.FETCH_ARRIVAL_STATUS_SUCCESS:
            return Object.assign({}, state, {
                orderDetails: action.orderDetails,
                loading: false
            });
        case arrivalStatus_actions/* default.FETCH_ARRIVAL_STATUS_FAILURE */.Z.FETCH_ARRIVAL_STATUS_FAILURE:
            return Object.assign({}, state, {
                error: action.error,
                loading: false
            });
        case arrivalStatus_actions/* default.UPDATE_ARRIVAL_STATUS */.Z.UPDATE_ARRIVAL_STATUS:
            return Object.assign({}, state, {
                loading: true
            });
        case arrivalStatus_actions/* default.UPDATE_ARRIVAL_STATUS_SUCCESS */.Z.UPDATE_ARRIVAL_STATUS_SUCCESS:
            return Object.assign({}, state, {
                data: action.arrivalResponse,
                error: false,
                loading: false
            });
        case arrivalStatus_actions/* default.UPDATE_ARRIVAL_STATUS_FAILURE */.Z.UPDATE_ARRIVAL_STATUS_FAILURE:
            return Object.assign({}, state, {
                error: true,
                loading: false
            });
        case arrivalStatus_actions/* default.CLEAR_ARRIVAL_STATUS */.Z.CLEAR_ARRIVAL_STATUS:
            return reducer_initialState;
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./src/redux/auth/reducer.ts
var auth_reducer = __webpack_require__(7481);
// EXTERNAL MODULE: ./src/redux/basket/reducer.ts
var basket_reducer = __webpack_require__(62152);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ./src/redux/basketRewards/actions.ts
var basketRewards_actions = __webpack_require__(24348);
;// CONCATENATED MODULE: ./src/redux/basketRewards/reducer.ts



var basketRewards_reducer_initialState = {
    rewardsApplied: [],
    rewardsAvailable: [],
    rewardStatus: "",
    unavailableRewards: [],
    rewardPending: null
};
var basketRewards = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : basketRewards_reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        // Basket Rewards Set
        case basketRewards_actions/* default.SET_AVAILABLE_REWARDS */.Z.SET_AVAILABLE_REWARDS:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                rewardsAvailable: action.rewardsAvailable
            });
        // Basket Rewards Set
        case basketRewards_actions/* default.SET_APPLIED_REWARDS */.Z.SET_APPLIED_REWARDS:
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    rewardsApplied: action.rewardsApplied
                });
            }
        case basketRewards_actions/* default.SET_PENDING_REWARD */.Z.SET_PENDING_REWARD:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                rewardPending: action === null || action === void 0 ? void 0 : action.id
            });
        case basketRewards_actions/* default.SET_UNAVAILABLE_REWARD */.Z.SET_UNAVAILABLE_REWARD:
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    unavailableRewards: state.unavailableRewards.concat([
                        action.reward
                    ])
                });
            }
        case basketRewards_actions/* default.RESET_UNAVAILABLE_REWARDS */.Z.RESET_UNAVAILABLE_REWARDS:
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    unavailableRewards: []
                });
            }
        case basketRewards_actions/* default.RESET_BASKET_REWARDS */.Z.RESET_BASKET_REWARDS:
            {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    rewardsApplied: [],
                    unavailableRewards: []
                });
            }
        default:
            return state;
    }
};

;// CONCATENATED MODULE: ./src/redux/checkout/paymentHandler/actions.ts
var paymentHandlerActions = {
    RESET_CARD_DATA: "/koala/paymentHandler/RESET_CARD_DATA",
    TRIGGER_GET_PAYMENT: "/koala/paymentHandler/TRIGGER_GET_PAYMENT",
    START_SUBMIT_PAYMENT: "/koala/paymentHandler/START_SUBMIT_PAYMENT",
    START_SQUARE_SUBMIT_PAYMENT: "/koala/paymentHandler/START_SQUARE_SUBMIT_PAYMENT",
    resetCardData: function() {
        return {
            type: paymentHandlerActions.RESET_CARD_DATA
        };
    },
    triggerGetPayment: function() {
        return {
            type: paymentHandlerActions.TRIGGER_GET_PAYMENT
        };
    },
    startSubmitPayment: function() {
        return {
            type: paymentHandlerActions.START_SUBMIT_PAYMENT
        };
    },
    startSquareSubmitPayment: function(nonce) {
        return {
            type: paymentHandlerActions.START_SQUARE_SUBMIT_PAYMENT,
            nonce: nonce
        };
    }
};
/* harmony default export */ var paymentHandler_actions = (paymentHandlerActions);

;// CONCATENATED MODULE: ./src/redux/checkout/paymentHandler/reducer.ts

var paymentHandler_reducer_initialState = {
    getPayment: false,
    paymentData: null
};
var paymentHandler = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : paymentHandler_reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case paymentHandler_actions.RESET_CARD_DATA:
            return Object.assign({}, state, {
                getPayment: false
            });
        case paymentHandler_actions.TRIGGER_GET_PAYMENT:
            return Object.assign({}, state, {
                getPayment: true
            });
        case paymentHandler_actions.START_SUBMIT_PAYMENT:
            return Object.assign({}, state, {
                getPayment: false
            });
        case paymentHandler_actions.START_SQUARE_SUBMIT_PAYMENT:
            return Object.assign({}, state, {
                getPayment: false,
                paymentData: {
                    id: action.nonce
                }
            });
        default:
            return state;
    }
};

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../packages/sdk/dist/index.mjs + 1 modules
var dist = __webpack_require__(80684);
// EXTERNAL MODULE: ./src/redux/cmsConfig/actions.ts
var cmsConfig_actions = __webpack_require__(27085);
;// CONCATENATED MODULE: ./src/redux/cmsConfig/reducer.ts



var cmsConfig_reducer_initialState = {
    loading: false,
    fetchServer: false,
    fetchClient: false,
    strings: dist/* fallbackStrings */.hL,
    webConfig: dist/* fallbackConfig */.fC
};
var cmsConfig = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : cmsConfig_reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case cmsConfig_actions/* default.FETCH_CONFIGS */.Z.FETCH_CONFIGS:
            return Object.assign({}, state, {
                loading: true
            });
        case cmsConfig_actions/* default.FETCH_CONFIGS_SUCCESS */.Z.FETCH_CONFIGS_SUCCESS:
            var _obj;
            return Object.assign({}, state, (_obj = {}, (0,_define_property/* default */.Z)(_obj, action.clientOrServer, true), (0,_define_property/* default */.Z)(_obj, action.configType, action.configContent), (0,_define_property/* default */.Z)(_obj, "loading", false), _obj));
        case cmsConfig_actions/* default.FETCH_CONFIGS_FAILURE */.Z.FETCH_CONFIGS_FAILURE:
            var _obj1;
            return Object.assign({}, state, (_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, action.clientOrServer, false), (0,_define_property/* default */.Z)(_obj1, "loading", false), _obj1));
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./src/redux/conveyanceMode/reducer.ts
var conveyanceMode_reducer = __webpack_require__(16440);
// EXTERNAL MODULE: ./src/redux/customize/actions.ts
var customize_actions = __webpack_require__(40646);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(36304);
;// CONCATENATED MODULE: ./src/redux/customize/reducer.ts





var customize_reducer_initialState = {
    customize: null,
    canonicalProduct: null,
    index: null,
    final: null,
    label: null,
    open: false,
    options: [],
    product: null,
    quantity: 1,
    upsellId: null,
    displayOptionsErrors: false,
    toggleToastOptionsError: false
};
var customize = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : customize_reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case customize_actions/* default.SET_PRODUCT_TO_CUSTOMIZE */.Z.SET_PRODUCT_TO_CUSTOMIZE:
            {
                if (action.payload && action.payload.product) {
                    var customize = new dist/* Customizer */.Nc(action.payload.product, action.payload.existingOptions);
                    var product = customize.getProduct();
                    // Disable body scroll
                    (0,global/* toggleBodyScroll */.R0)(false);
                    return {
                        customize: customize,
                        canonicalProduct: action.payload.product,
                        index: action.payload.index,
                        final: product,
                        label: action.payload.label,
                        product: product,
                        options: product.options,
                        open: typeof action.payload.open !== "undefined" ? action.payload.open : true,
                        quantity: action.payload.item ? action.payload.item.quantity : action.payload.product.min_quantity || customize_reducer_initialState.quantity,
                        upsellId: action.payload.upsellId
                    };
                }
                return state;
            }
        case customize_actions/* default.CLEAR_PRODUCT_TO_CUSTOMIZE */.Z.CLEAR_PRODUCT_TO_CUSTOMIZE:
            // Re-enable body scroll
            (0,global/* toggleBodyScroll */.R0)(true);
            return (0,_object_spread/* default */.Z)({}, customize_reducer_initialState);
        case customize_actions/* default.INCREMENT_OPTION */.Z.INCREMENT_OPTION:
            {
                if (action.payload && action.payload.id) {
                    state.customize.incrementOption(action.payload.id);
                    var product1 = state.customize.getProduct();
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        product: product1,
                        options: product1.options,
                        final: product1
                    });
                }
                return state;
            }
        case customize_actions/* default.DECREMENT_OPTION */.Z.DECREMENT_OPTION:
            {
                if (action.payload && action.payload.id) {
                    state.customize.decrementOption(action.payload.id, action.payload.setToZero);
                    var product2 = state.customize.getProduct();
                    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                        product: product2,
                        options: product2.options,
                        final: product2
                    });
                }
                return state;
            }
        case customize_actions/* default.DISPLAY_OPTIONS_ERRORS */.Z.DISPLAY_OPTIONS_ERRORS:
            return Object.assign({}, state, {
                displayOptionsErrors: action.displayOptionsErrors
            });
        case customize_actions/* default.TOGGLE_TOAST_OPTIONS_ERROR */.Z.TOGGLE_TOAST_OPTIONS_ERROR:
            return Object.assign({}, state, {
                toggleToastOptionsError: action.toggleToastOptionsError
            });
        case customize_actions/* default.TOGGLE_QUANTITY */.Z.TOGGLE_QUANTITY:
            if (action.payload) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                    quantity: action.payload.quantity
                });
            }
            return state;
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./src/redux/deliveryStatus/actions.ts
var deliveryStatus_actions = __webpack_require__(37615);
// EXTERNAL MODULE: ./src/utils/dates.ts + 59 modules
var dates = __webpack_require__(63654);
;// CONCATENATED MODULE: ./src/redux/deliveryStatus/reducer.ts



/** @TODO decouple IDeliveryStatusState from the SDK response type. */ var deliveryStatus_reducer_initialState = {
    // @ts-ignore
    order_id: null,
    // @ts-ignore
    order_number: null,
    // @ts-ignore
    delivery_service: null,
    // @ts-ignore
    driver_name: null,
    // @ts-ignore
    driver_number: null,
    // @ts-ignore
    status: null,
    // @ts-ignore
    estimated_pick_up_time: null,
    // @ts-ignore
    estimated_drop_off_time: null,
    // @ts-ignore
    pick_up_time: null,
    // @ts-ignore
    drop_off_time: null,
    // @ts-ignore
    cancelled_at_time: null,
    // @ts-ignore
    cancelled_reason: null,
    // @ts-ignore
    lat: null,
    // @ts-ignore
    long: null,
    meta: {
        loading: false,
        error: null,
        params: null,
        // @ts-ignore
        lastUpdatedAt: null
    }
};
var deliveryStatus = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : deliveryStatus_reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case deliveryStatus_actions/* deliveryStatusActionTypes.FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER */.m.FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER:
            {
                var partialState = {
                    order_number: action.order_number,
                    meta: {
                        error: null,
                        loading: true,
                        params: null
                    }
                };
                return Object.assign({}, state, partialState);
            }
        case deliveryStatus_actions/* deliveryStatusActionTypes.FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER_SUCCESS */.m.FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER_SUCCESS:
            {
                var partialState1 = (0,_object_spread/* default */.Z)({
                    meta: {
                        error: null,
                        loading: false,
                        params: null,
                        lastUpdatedAt: (0,dates/* getISODateInUTC */.j4)()
                    }
                }, action.data);
                return Object.assign({}, state, partialState1);
            }
        case deliveryStatus_actions/* deliveryStatusActionTypes.FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER_FAIL */.m.FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER_FAIL:
            {
                var partialState2 = {
                    meta: {
                        error: action.error,
                        loading: false,
                        params: null,
                        lastUpdatedAt: (0,dates/* getISODateInUTC */.j4)()
                    }
                };
                return Object.assign({}, state, partialState2);
            }
        case deliveryStatus_actions/* deliveryStatusActionTypes.CLEAR_DELIVERY_STATUS_STATE */.m.CLEAR_DELIVERY_STATUS_STATE:
            return Object.assign({}, deliveryStatus_reducer_initialState);
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./src/redux/global/reducer.ts
var global_reducer = __webpack_require__(83626);
// EXTERNAL MODULE: ./src/redux/locations/reducer.ts
var locations_reducer = __webpack_require__(3071);
// EXTERNAL MODULE: ./src/redux/me/reducer.ts
var me_reducer = __webpack_require__(17426);
// EXTERNAL MODULE: ./src/redux/menu/reducer.ts
var menu_reducer = __webpack_require__(88068);
// EXTERNAL MODULE: ./src/redux/orderDetails/reducer.ts
var orderDetails_reducer = __webpack_require__(60329);
// EXTERNAL MODULE: ./src/redux/orderStatus/actions.ts
var orderStatus_actions = __webpack_require__(76750);
// EXTERNAL MODULE: ./src/types/orderStatus.ts
var orderStatus = __webpack_require__(74337);
;// CONCATENATED MODULE: ./src/redux/orderStatus/reducer.ts


var orderStatus_reducer_initialState = {
    type: orderStatus/* OrderStatusTypes.OK */.E5.OK,
    message: null,
    status: orderStatus/* OrderStatuses.ORDER_NOT_INITIALIZED */.pf.ORDER_NOT_INITIALIZED
};
var reducer_orderStatus = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : orderStatus_reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        // Message Actions
        case orderStatus_actions/* default.ORDER_STATUS_MESSAGE_CLEAR */.Z.ORDER_STATUS_MESSAGE_CLEAR:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.OK */.E5.OK,
                message: orderStatus_reducer_initialState.message
            });
        case orderStatus_actions/* default.ORDER_STATUS_MESSAGE_ERROR_SET */.Z.ORDER_STATUS_MESSAGE_ERROR_SET:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.ERROR */.E5.ERROR,
                message: action.message
            });
        // Generic Actions
        case orderStatus_actions/* default.ORDER_PENDING */.Z.ORDER_PENDING:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.OK */.E5.OK,
                message: null,
                status: orderStatus/* OrderStatuses.ORDER_PENDING */.pf.ORDER_PENDING
            });
        case orderStatus_actions/* default.ORDER_NOT_INITIALIZED */.Z.ORDER_NOT_INITIALIZED:
            return orderStatus_reducer_initialState;
        // Initialization Sequence
        case orderStatus_actions/* default.INITIALIZE_ORDER */.Z.INITIALIZE_ORDER:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.UPDATING */.E5.UPDATING,
                message: null,
                status: orderStatus/* OrderStatuses.INITIALIZING_ORDER */.pf.INITIALIZING_ORDER
            });
        case orderStatus_actions/* default.INITIALIZE_ORDER_ERROR */.Z.INITIALIZE_ORDER_ERROR:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.ERROR */.E5.ERROR,
                message: action.message,
                status: orderStatus/* OrderStatuses.ORDER_NOT_INITIALIZED */.pf.ORDER_NOT_INITIALIZED
            });
        case orderStatus_actions/* default.INITIALIZE_ORDER_RECONCILIATION */.Z.INITIALIZE_ORDER_RECONCILIATION:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.RECONCILIATION */.E5.RECONCILIATION,
                message: action.message,
                status: orderStatus/* OrderStatuses.ORDER_NOT_INITIALIZED */.pf.ORDER_NOT_INITIALIZED
            });
        // Promo Code
        case orderStatus_actions/* default.PROMO_CODE_ADD */.Z.PROMO_CODE_ADD:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.UPDATING */.E5.UPDATING,
                message: null,
                status: orderStatus/* OrderStatuses.PROMO_CODE_ADDING */.pf.PROMO_CODE_ADDING
            });
        case orderStatus_actions/* default.PROMO_CODE_REMOVE */.Z.PROMO_CODE_REMOVE:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.UPDATING */.E5.UPDATING,
                message: null,
                status: orderStatus/* OrderStatuses.PROMO_CODE_REMOVING */.pf.PROMO_CODE_REMOVING
            });
        // Set Conveyance
        case orderStatus_actions/* default.CONVEYANCE_SET */.Z.CONVEYANCE_SET:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.UPDATING */.E5.UPDATING,
                message: null,
                status: orderStatus/* OrderStatuses.CONVEYANCE_SETTING */.pf.CONVEYANCE_SETTING
            });
        case orderStatus_actions/* default.CONVEYANCE_DELIVERY_SET */.Z.CONVEYANCE_DELIVERY_SET:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.UPDATING */.E5.UPDATING,
                message: null,
                status: orderStatus/* OrderStatuses.CONVEYANCE_DELIVERY_SETTING */.pf.CONVEYANCE_DELIVERY_SETTING
            });
        // Set Wanted At
        case orderStatus_actions/* default.WANTED_AT_BASKET_SET */.Z.WANTED_AT_BASKET_SET:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.UPDATING */.E5.UPDATING,
                message: null,
                status: orderStatus/* OrderStatuses.WANTED_AT_BASKET_SETTING */.pf.WANTED_AT_BASKET_SETTING
            });
        case orderStatus_actions/* default.WANTED_AT_BASKET_REMOVE */.Z.WANTED_AT_BASKET_REMOVE:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.UPDATING */.E5.UPDATING,
                message: null,
                status: orderStatus/* OrderStatuses.WANTED_AT_BASKET_REMOVING */.pf.WANTED_AT_BASKET_REMOVING
            });
        // Basket Rewards
        case orderStatus_actions/* default.BASKET_REWARDS_GET */.Z.BASKET_REWARDS_GET:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.UPDATING */.E5.UPDATING,
                message: null,
                status: orderStatus/* OrderStatuses.BASKET_REWARDS_GETTING */.pf.BASKET_REWARDS_GETTING
            });
        case orderStatus_actions/* default.BASKET_REWARDS_ADD */.Z.BASKET_REWARDS_ADD:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.UPDATING */.E5.UPDATING,
                message: null,
                status: orderStatus/* OrderStatuses.BASKET_REWARDS_ADDING */.pf.BASKET_REWARDS_ADDING
            });
        case orderStatus_actions/* default.BASKET_REWARDS_REMOVE */.Z.BASKET_REWARDS_REMOVE:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.UPDATING */.E5.UPDATING,
                message: null,
                status: orderStatus/* OrderStatuses.BASKET_REWARDS_REMOVING */.pf.BASKET_REWARDS_REMOVING
            });
        // Tip
        case orderStatus_actions/* default.TIP_ADD */.Z.TIP_ADD:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.UPDATING */.E5.UPDATING,
                message: null,
                status: orderStatus/* OrderStatuses.TIP_ADDING */.pf.TIP_ADDING
            });
        // Tip
        case orderStatus_actions/* default.UTENSILS_SET */.Z.UTENSILS_SET:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.UPDATING */.E5.UPDATING,
                message: null,
                status: orderStatus/* OrderStatuses.UTENSILS_SETTING */.pf.UTENSILS_SETTING
            });
        // Basket Instructions
        case orderStatus_actions/* default.BASKET_INSTRUCTIONS_SET */.Z.BASKET_INSTRUCTIONS_SET:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.UPDATING */.E5.UPDATING,
                message: null,
                status: orderStatus/* OrderStatuses.BASKET_INSTRUCTIONS_SETTING */.pf.BASKET_INSTRUCTIONS_SETTING
            });
        // Stored Value
        case orderStatus_actions/* default.STORED_VALUE_POST */.Z.STORED_VALUE_POST:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.UPDATING */.E5.UPDATING,
                message: null,
                status: orderStatus/* OrderStatuses.STORED_VALUE_POSTING */.pf.STORED_VALUE_POSTING
            });
        // Submission Sequence
        case orderStatus_actions/* default.ORDER_SUBMISSION_TRIGGER */.Z.ORDER_SUBMISSION_TRIGGER:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.TRANSMITTING */.E5.TRANSMITTING,
                message: action.message,
                captcha: action.captcha,
                status: orderStatus/* OrderStatuses.ORDER_SUBMISSION_TRIGGERED */.pf.ORDER_SUBMISSION_TRIGGERED
            });
        case orderStatus_actions/* default.ORDER_SUBMISSION_PCI_ERROR */.Z.ORDER_SUBMISSION_PCI_ERROR:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.ERROR */.E5.ERROR,
                status: orderStatus/* OrderStatuses.ORDER_PENDING */.pf.ORDER_PENDING,
                message: action.message
            });
        case orderStatus_actions/* default.ORDER_SUBMISSION_PCI_FAILURE */.Z.ORDER_SUBMISSION_PCI_FAILURE:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.ERROR */.E5.ERROR,
                status: orderStatus/* OrderStatuses.ORDER_SUBMISSION_PCI_FAILURE */.pf.ORDER_SUBMISSION_PCI_FAILURE,
                message: action.message
            });
        case orderStatus_actions/* default.ORDER_SUBMISSION_ERROR */.Z.ORDER_SUBMISSION_ERROR:
            return Object.assign({}, state, {
                type: orderStatus/* OrderStatusTypes.ERROR */.E5.ERROR,
                status: orderStatus/* OrderStatuses.ORDER_PENDING */.pf.ORDER_PENDING,
                message: action.message
            });
        case orderStatus_actions/* default.DESTROY_ORDER */.Z.DESTROY_ORDER:
            return orderStatus_reducer_initialState;
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./src/redux/organization/reducer.ts
var organization_reducer = __webpack_require__(63212);
// EXTERNAL MODULE: ./src/redux/payment/actions.ts
var payment_actions = __webpack_require__(81895);
;// CONCATENATED MODULE: ./src/redux/payment/reducer.ts




var payment_reducer_initialState = {
    storedValueError: "",
    storedValue: null,
    paymentType: null
};
var payment = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : payment_reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case payment_actions/* default.BILLING_ACCOUNT_SET */.Z.BILLING_ACCOUNT_SET:
            return Object.assign({}, state, {
                paymentType: {
                    type: dist/* PAYMENT_TYPES.BILLING_ACCOUNT */.G4.BILLING_ACCOUNT,
                    saved_account_id: action.savedAccountId
                }
            });
        case payment_actions/* default.CREDIT_CARD_SET */.Z.CREDIT_CARD_SET:
            return Object.assign({}, state, {
                paymentType: (0,_object_spread/* default */.Z)({}, action.creditCard)
            });
        case payment_actions/* default.PAY_IN_STORE_SET */.Z.PAY_IN_STORE_SET:
            return Object.assign({}, state, {
                paymentType: {
                    type: dist/* PAYMENT_TYPES.CASH */.G4.CASH
                }
            });
        case payment_actions/* default.STORED_VALUE_TOGGLE */.Z.STORED_VALUE_TOGGLE:
            return Object.assign({}, state, {
                paymentType: {
                    type: dist/* PAYMENT_TYPES.STORED_VALUE */.G4.STORED_VALUE
                }
            });
        case payment_actions/* default.DIGITAL_WALLET_TOGGLE */.Z.DIGITAL_WALLET_TOGGLE:
            return Object.assign({}, state, {
                paymentType: {
                    type: dist/* PAYMENT_TYPES.DIGITAL_WALLET */.G4.DIGITAL_WALLET
                }
            });
        case payment_actions/* default.PAYMENT_TYPE_RESET */.Z.PAYMENT_TYPE_RESET:
            return Object.assign({}, state, {
                paymentType: payment_reducer_initialState.paymentType
            });
        case payment_actions/* default.STORED_VALUE_SET */.Z.STORED_VALUE_SET:
            return Object.assign({}, state, {
                storedValue: action.storedValue,
                storedValueError: payment_reducer_initialState.storedValueError
            });
        case payment_actions/* default.STORED_VALUE_ERROR */.Z.STORED_VALUE_ERROR:
            return Object.assign({}, state, {
                storedValue: payment_reducer_initialState.storedValue,
                storedValueError: action.message
            });
        case payment_actions/* default.STORED_VALUE_CLEAR */.Z.STORED_VALUE_CLEAR:
        case orderStatus_actions/* default.STORED_VALUE_POST */.Z.STORED_VALUE_POST:
            return Object.assign({}, state, {
                storedValue: payment_reducer_initialState.storedValue,
                storedValueError: payment_reducer_initialState.storedValueError
            });
        case orderStatus_actions/* default.INITIALIZE_ORDER */.Z.INITIALIZE_ORDER:
        case orderStatus_actions/* default.DESTROY_ORDER */.Z.DESTROY_ORDER:
            return payment_reducer_initialState;
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./src/redux/paymentTypes/actions.ts
var paymentTypes_actions = __webpack_require__(95225);
;// CONCATENATED MODULE: ./src/redux/paymentTypes/reducer.ts

var paymentTypes_reducer_initialState = null;
var paymentTypes = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : paymentTypes_reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case paymentTypes_actions/* default.PAYMENT_TYPES_GET_SUCCESS */.Z.PAYMENT_TYPES_GET_SUCCESS:
            return action.paymentTypes;
        case paymentTypes_actions/* default.PAYMENT_TYPES_CLEAR */.Z.PAYMENT_TYPES_CLEAR:
            return paymentTypes_reducer_initialState;
        default:
            return state;
    }
};

;// CONCATENATED MODULE: ./src/redux/promoCode/actions.ts
var promoCodeActions = {
    PROMO_CODE_SET: "/koala/promoCode/PROMO_CODE_SET",
    PROMO_CODE_ERROR: "/koala/promoCode/PROMO_CODE_ERROR",
    promoCodeSet: function(promoCode) {
        return {
            type: promoCodeActions.PROMO_CODE_SET,
            promoCode: promoCode
        };
    },
    promoCodeError: function(message) {
        return {
            type: promoCodeActions.PROMO_CODE_ERROR,
            message: message
        };
    }
};
/* harmony default export */ var promoCode_actions = (promoCodeActions);

;// CONCATENATED MODULE: ./src/redux/promoCode/reducer.ts




var promoCode_reducer_initialState = {
    applied: "",
    error: ""
};
var promoCode = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : promoCode_reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case promoCode_actions.PROMO_CODE_SET:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                applied: action.promoCode,
                error: promoCode_reducer_initialState.error
            });
        case promoCode_actions.PROMO_CODE_ERROR:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: promoCode_reducer_initialState.error
            });
        case orderStatus_actions/* default.PROMO_CODE_ADD */.Z.PROMO_CODE_ADD:
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, state), {
                error: action.message
            });
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./src/redux/tags/actions.ts
var tags_actions = __webpack_require__(28799);
;// CONCATENATED MODULE: ./src/redux/tags/reducer.ts

var tags_reducer_initialState = {
    activeTagIds: null
};
var tags = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : tags_reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case tags_actions/* default.SET_ACTIVE_TAG */.Z.SET_ACTIVE_TAG:
            return Object.assign({}, state, {
                activeTagIds: [
                    action.id
                ]
            });
        default:
            return state;
    }
};

;// CONCATENATED MODULE: ./src/redux/timeslots/actions.ts
var timeslotActions = {
    FETCH_HANDOFF_TIMES_BY_BASKET: "/koala/timeslots/FETCH_HANDOFF_TIMES_BY_BASKET",
    FETCH_HANDOFF_TIMES_BY_LOCATION: "/koala/timeslots/FETCH_HANDOFF_TIMES_BY_LOCATION",
    FETCH_HANDOFF_TIMES_SUCCESS: "/koala/timeslots/FETCH_HANDOFF_TIMES_SUCCESS",
    FETCH_HANDOFF_TIMES_FAILURE: "/koala/timeslots/FETCH_HANDOFF_TIMES_FAILURE",
    CLEAR_HANDOFF_TIMES: "/koala/timeslots/CLEAR_HANDOFF_TIMES",
    SET_WANTED_AT: "/koala/timeslots/SET_WANTED_AT",
    fetchHandoffTimesByLocation: function(locationId, hoursType, includeAsap, wantedAtDay) {
        return {
            type: timeslotActions.FETCH_HANDOFF_TIMES_BY_LOCATION,
            locationId: locationId,
            hoursType: hoursType,
            includeAsap: includeAsap,
            wantedAtDay: wantedAtDay
        };
    },
    fetchHandoffTimesByBasket: function(basketId, locationId, hoursType, includeAsap, wantedAtDay, previousAction, wantedAt) {
        return {
            type: timeslotActions.FETCH_HANDOFF_TIMES_BY_BASKET,
            basketId: basketId,
            locationId: locationId,
            hoursType: hoursType,
            includeAsap: includeAsap,
            wantedAtDay: wantedAtDay,
            previousAction: previousAction,
            wantedAt: wantedAt
        };
    },
    fetchHandoffTimesSuccess: function(timeslotType, timeslots, wantedAtDay) {
        return {
            type: timeslotActions.FETCH_HANDOFF_TIMES_SUCCESS,
            timeslotType: timeslotType,
            timeslots: timeslots,
            wantedAtDay: wantedAtDay
        };
    },
    setWantedAt: function(wantedAt, error) {
        return {
            type: timeslotActions.SET_WANTED_AT,
            wantedAt: wantedAt,
            error: error
        };
    },
    clearHandoffTimes: function() {
        return {
            type: timeslotActions.CLEAR_HANDOFF_TIMES
        };
    }
};
/* harmony default export */ var timeslots_actions = (timeslotActions);

;// CONCATENATED MODULE: ./src/redux/timeslots/reducer.ts


var timeslots_reducer_initialState = {
    basketTimes: [],
    locationTimes: [],
    wantedAt: null,
    loading: false,
    error: false
};
var timeslots = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : timeslots_reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case timeslots_actions.FETCH_HANDOFF_TIMES_BY_LOCATION:
        case timeslots_actions.FETCH_HANDOFF_TIMES_BY_BASKET:
            return Object.assign({}, state, {
                loading: true
            });
        case timeslots_actions.SET_WANTED_AT:
            return Object.assign({}, state, {
                wantedAt: action.wantedAt,
                error: action.error || timeslots_reducer_initialState.error
            });
        case timeslots_actions.FETCH_HANDOFF_TIMES_SUCCESS:
            var _obj;
            return Object.assign({}, state, (_obj = {}, (0,_define_property/* default */.Z)(_obj, action.timeslotType, action.timeslots), (0,_define_property/* default */.Z)(_obj, "loading", false), _obj));
        case timeslots_actions.FETCH_HANDOFF_TIMES_FAILURE:
            return Object.assign({}, state, {
                loading: false
            });
        case timeslots_actions.CLEAR_HANDOFF_TIMES:
            return timeslots_reducer_initialState;
        default:
            return state;
    }
};

// EXTERNAL MODULE: ./src/redux/upsells/actions.ts
var upsells_actions = __webpack_require__(38024);
;// CONCATENATED MODULE: ./src/redux/upsells/reducer.ts

var upsells_reducer_initialState = {
    error: false,
    detail: null,
    loading: false,
    fetchTimestamp: null
};
var upsells = function() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : upsells_reducer_initialState, action = arguments.length > 1 ? arguments[1] : void 0;
    switch(action.type){
        case upsells_actions/* default.FETCH_UPSELLS */.Z.FETCH_UPSELLS:
            return Object.assign({}, state, {
                error: false,
                loading: true
            });
        case upsells_actions/* default.UPSELLS_SUCCESS */.Z.UPSELLS_SUCCESS:
            return Object.assign({}, state, {
                error: false,
                loading: false,
                fetchTimestamp: new Date(),
                detail: action.detail
            });
        case upsells_actions/* default.UPSELLS_FAIL */.Z.UPSELLS_FAIL:
            return Object.assign({}, state, {
                error: true,
                loading: false
            });
        default:
            return state;
    }
};

;// CONCATENATED MODULE: ./src/redux/reducers.tsx




























var combinedReducers = (0,redux/* combineReducers */.UY)({
    app: (0,redux/* combineReducers */.UY)({
        allergens: allergens,
        arrivalStatus: arrivalStatus,
        auth: auth_reducer/* auth */.I8,
        // TODO: Reconcile SDK & Store basket state.
        // @ts-expect-error: Reconcile SDK & Store basket state.
        basket: basket_reducer/* basket */.a3,
        basketRewards: basketRewards,
        cmsConfig: cmsConfig,
        conveyanceMode: conveyanceMode_reducer/* conveyanceMode */.DP,
        customize: customize,
        deliveryStatus: deliveryStatus,
        global: global_reducer/* global */.CO,
        locations: locations_reducer/* locations */.Kl,
        me: me_reducer.me,
        menu: menu_reducer/* menu */.GI,
        orderDetails: orderDetails_reducer/* orderDetails */.cW,
        orderStatus: reducer_orderStatus,
        organization: organization_reducer/* organization */.cO,
        payment: payment,
        paymentHandler: paymentHandler,
        paymentTypes: paymentTypes,
        promoCode: promoCode,
        tags: tags,
        timeslots: timeslots,
        upsells: upsells
    }),
    form: reducer/* default */.Z,
    loadingBar: build/* loadingBarReducer */.N$
});
var rootReducer = function(state, action) {
    if (action.type === HYDRATE) {
        /**
     * next-redux-wrapper will override the entire store when
     * navigating between serverSideProp powered routes
     */ // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        var nextState = (0,_object_spread/* default */.Z)({}, state, action.payload);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return nextState;
    } else {
        return combinedReducers(state, action);
    }
};
// Combines all reducers to a single reducer function
/* harmony default export */ var reducers = (rootReducer);

// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/@redux-saga/is/dist/redux-saga-is.esm.js
var redux_saga_is_esm = __webpack_require__(83594);
// EXTERNAL MODULE: ../../node_modules/@redux-saga/core/dist/io-22ea0cf9.js + 1 modules
var io_22ea0cf9 = __webpack_require__(8459);
;// CONCATENATED MODULE: ../../node_modules/@redux-saga/core/dist/redux-saga-effects.esm.js







var done = function done(value) {
  return {
    done: true,
    value: value
  };
};

var qEnd = {};
function safeName(patternOrChannel) {
  if ((0,redux_saga_is_esm/* channel */.CE)(patternOrChannel)) {
    return 'channel';
  }

  if ((0,redux_saga_is_esm/* stringableFunc */.eR)(patternOrChannel)) {
    return String(patternOrChannel);
  }

  if ((0,redux_saga_is_esm/* func */.Yl)(patternOrChannel)) {
    return patternOrChannel.name;
  }

  return String(patternOrChannel);
}
function fsmIterator(fsm, startState, name) {
  var stateUpdater,
      errorState,
      effect,
      nextState = startState;

  function next(arg, error) {
    if (nextState === qEnd) {
      return done(arg);
    }

    if (error && !errorState) {
      nextState = qEnd;
      throw error;
    } else {
      stateUpdater && stateUpdater(arg);
      var currentState = error ? fsm[errorState](error) : fsm[nextState]();
      nextState = currentState.nextState;
      effect = currentState.effect;
      stateUpdater = currentState.stateUpdater;
      errorState = currentState.errorState;
      return nextState === qEnd ? done(arg) : effect;
    }
  }

  return (0,io_22ea0cf9.q)(next, function (error) {
    return next(null, error);
  }, name);
}

function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: take(patternOrChannel)
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: fork.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var action,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q1',
        effect: yFork(action)
      };
    }
  }, 'q1', "takeEvery(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: (0,io_22ea0cf9.L)(patternOrChannel)
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: io_22ea0cf9.M.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yCancel = function yCancel(task) {
    return {
      done: false,
      value: (0,io_22ea0cf9.N)(task)
    };
  };

  var task, action;

  var setTask = function setTask(t) {
    return task = t;
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return task ? {
        nextState: 'q3',
        effect: yCancel(task)
      } : {
        nextState: 'q1',
        effect: yFork(action),
        stateUpdater: setTask
      };
    },
    q3: function q3() {
      return {
        nextState: 'q1',
        effect: yFork(action),
        stateUpdater: setTask
      };
    }
  }, 'q1', "takeLatest(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function takeLeading(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: take(patternOrChannel)
  };

  var yCall = function yCall(ac) {
    return {
      done: false,
      value: call.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var action;

  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q1',
        effect: yCall(action)
      };
    }
  }, 'q1', "takeLeading(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function throttle(delayLength, patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action, channel$1;

  var yTake = function yTake() {
    return {
      done: false,
      value: (0,io_22ea0cf9.L)(channel$1)
    };
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: io_22ea0cf9.M.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yDelay = {
    done: false,
    value: (0,io_22ea0cf9.Q)(delayLength)
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  var setChannel = function setChannel(ch) {
    return channel$1 = ch;
  };

  var needsChannel = !(0,redux_saga_is_esm/* channel */.CE)(patternOrChannel);

  if (!needsChannel) {
    setChannel(patternOrChannel);
  }

  return fsmIterator({
    q1: function q1() {
      var yActionChannel = {
        done: false,
        value: (0,io_22ea0cf9.U)(patternOrChannel, (0,io_22ea0cf9.V)(1))
      };
      return {
        nextState: 'q2',
        effect: yActionChannel,
        stateUpdater: setChannel
      };
    },
    q2: function q2() {
      return {
        nextState: 'q3',
        effect: yTake(),
        stateUpdater: setAction
      };
    },
    q3: function q3() {
      return {
        nextState: 'q4',
        effect: yFork(action)
      };
    },
    q4: function q4() {
      return {
        nextState: 'q2',
        effect: yDelay
      };
    }
  }, needsChannel ? 'q1' : 'q2', "throttle(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function retry(maxTries, delayLength, fn) {
  var counter = maxTries;

  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var yCall = {
    done: false,
    value: call.apply(void 0, [fn].concat(args))
  };
  var yDelay = {
    done: false,
    value: delay(delayLength)
  };
  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yCall,
        errorState: 'q10'
      };
    },
    q2: function q2() {
      return {
        nextState: qEnd
      };
    },
    q10: function q10(error) {
      counter -= 1;

      if (counter <= 0) {
        throw error;
      }

      return {
        nextState: 'q1',
        effect: yDelay
      };
    }
  }, 'q1', "retry(" + fn.name + ")");
}

function debounceHelper(delayLength, patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action, raceOutput;
  var yTake = {
    done: false,
    value: take(patternOrChannel)
  };
  var yRace = {
    done: false,
    value: race({
      action: take(patternOrChannel),
      debounce: delay(delayLength)
    })
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: fork.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yNoop = function yNoop(value) {
    return {
      done: false,
      value: value
    };
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  var setRaceOutput = function setRaceOutput(ro) {
    return raceOutput = ro;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q3',
        effect: yRace,
        stateUpdater: setRaceOutput
      };
    },
    q3: function q3() {
      return raceOutput.debounce ? {
        nextState: 'q1',
        effect: yFork(action)
      } : {
        nextState: 'q2',
        effect: yNoop(raceOutput.action),
        stateUpdater: setAction
      };
    }
  }, 'q1', "debounce(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

var validateTakeEffect = function validateTakeEffect(fn, patternOrChannel, worker) {
  check(patternOrChannel, notUndef, fn.name + " requires a pattern or channel");
  check(worker, notUndef, fn.name + " requires a saga parameter");
};

function takeEvery$1(patternOrChannel, worker) {
  if (false) {}

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return fork.apply(void 0, [takeEvery, patternOrChannel, worker].concat(args));
}
function takeLatest$1(patternOrChannel, worker) {
  if (false) {}

  for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return io_22ea0cf9.M.apply(void 0, [takeLatest, patternOrChannel, worker].concat(args));
}
function takeLeading$1(patternOrChannel, worker) {
  if (false) {}

  for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    args[_key3 - 2] = arguments[_key3];
  }

  return fork.apply(void 0, [takeLeading, patternOrChannel, worker].concat(args));
}
function throttle$1(ms, patternOrChannel, worker) {
  if (false) {}

  for (var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
    args[_key4 - 3] = arguments[_key4];
  }

  return io_22ea0cf9.M.apply(void 0, [throttle, ms, patternOrChannel, worker].concat(args));
}
function retry$1(maxTries, delayLength, worker) {
  for (var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++) {
    args[_key5 - 3] = arguments[_key5];
  }

  return call.apply(void 0, [retry, maxTries, delayLength, worker].concat(args));
}
function debounce(delayLength, pattern, worker) {
  for (var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++) {
    args[_key6 - 3] = arguments[_key6];
  }

  return fork.apply(void 0, [debounceHelper, delayLength, pattern, worker].concat(args));
}



;// CONCATENATED MODULE: ../../node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js


// EXTERNAL MODULE: ../../packages/sdk/dist/v4/index.mjs + 8 modules
var v4 = __webpack_require__(40024);
// EXTERNAL MODULE: ./src/services/client.ts + 1 modules
var services_client = __webpack_require__(44277);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(32210);
;// CONCATENATED MODULE: ./src/redux/allergens/saga.ts






function fetchAllergensSaga() {
    var origin, client, response, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    5
                ]);
                origin = (0,utils/* getOrigin */.P$)(window.location.host);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: origin
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getAllergens */.qU, {
                        perPage: 15
                    }, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)(actions/* default.allergensSuccess */.Z.allergensSuccess(response))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 3:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(actions/* default.allergensFail */.Z.allergensFail())
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(actions/* default.FETCH_ALLERGENS */.Z.FETCH_ALLERGENS, fetchAllergensSaga)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./src/redux/global/actions.ts
var global_actions = __webpack_require__(79118);
// EXTERNAL MODULE: ./src/analytics/events/index.ts + 4 modules
var events = __webpack_require__(45003);
// EXTERNAL MODULE: ./src/analytics/events/constants.ts
var constants = __webpack_require__(45048);
// EXTERNAL MODULE: ./src/constants/events.ts
var constants_events = __webpack_require__(26654);
// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(25643);
// EXTERNAL MODULE: ./src/utils/koalaAnalytics.ts + 1 modules
var koalaAnalytics = __webpack_require__(61216);
;// CONCATENATED MODULE: ./src/redux/arrivalStatus/saga.ts














function fetchArrivalStatusSaga(action) {
    var client, response, error, ref, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    10
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getOrderSummary */.Q2, action.orderId, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(arrivalStatus_actions/* default.fetchArrivalStatusSuccess */.Z.fetchArrivalStatusSuccess(response, action.label))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 3:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error checking the status of your order. Please try again.", error)
                ];
            case 4:
                errorResponse = _state.sent();
                if (!((errorResponse === null || errorResponse === void 0 ? void 0 : (ref = errorResponse.error) === null || ref === void 0 ? void 0 : ref.error) === "access_denied")) return [
                    3,
                    6
                ];
                void router_default().push(routes/* ROUTES.HOMEPAGE */.Z6.HOMEPAGE);
                return [
                    4,
                    (0,io_22ea0cf9.Z)(arrivalStatus_actions/* default.fetchArrivalStatusError */.Z.fetchArrivalStatusError(false))
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    8
                ];
            case 6:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(arrivalStatus_actions/* default.fetchArrivalStatusError */.Z.fetchArrivalStatusError(true))
                ];
            case 7:
                _state.sent();
                _state.label = 8;
            case 8:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 9:
                _state.sent();
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.ARRIVAL_FETCH_ERROR */.RZ.ARRIVAL_FETCH_ERROR, error, errorResponse);
                return [
                    3,
                    10
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function updateArrivalStatusSaga(action) {
    var client, error, ref, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    10
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* updateArrivalStatus */.Jv, {
                        orderId: action.orderId,
                        externalOrder: action.externalOrder,
                        message: action.message
                    }, {
                        client: client
                    })
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(arrivalStatus_actions/* default.updateArrivalStatusSuccess */.Z.updateArrivalStatusSuccess({
                        arrival_status: v4/* ARRIVAL_STATUS.ARRIVED */.ke.ARRIVED
                    }, action.label))
                ];
            case 2:
                _state.sent();
                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.ARRIVAL__CONFIRM_ARRIVAL_SUCCESS */.x.ARRIVAL__CONFIRM_ARRIVAL_SUCCESS, {
                    name: action.label,
                    details: action.orderId
                });
                return [
                    3,
                    10
                ];
            case 3:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error notifying the restaurant. Please try again.", error)
                ];
            case 4:
                errorResponse = _state.sent();
                if (!(((ref = errorResponse.error) === null || ref === void 0 ? void 0 : ref.error_description) === "Customer already claimed arrival for this Order")) return [
                    3,
                    6
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(arrivalStatus_actions/* default.updateArrivalStatusSuccess */.Z.updateArrivalStatusSuccess({
                        arrival_status: v4/* ARRIVAL_STATUS.ARRIVED */.ke.ARRIVED
                    }, action.label))
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 6:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(arrivalStatus_actions/* default.updateArrivalStatusFail */.Z.updateArrivalStatusFail())
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 8:
                _state.sent();
                _state.label = 9;
            case 9:
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.ARRIVAL_CONFIRM_ERROR */.RZ.ARRIVAL_CONFIRM_ERROR, error, errorResponse);
                return [
                    3,
                    10
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(arrivalStatus_actions/* default.FETCH_ARRIVAL_STATUS */.Z.FETCH_ARRIVAL_STATUS, fetchArrivalStatusSaga)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    takeLatest$1(arrivalStatus_actions/* default.UPDATE_ARRIVAL_STATUS */.Z.UPDATE_ARRIVAL_STATUS, updateArrivalStatusSaga)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

// EXTERNAL MODULE: ./src/redux/basket/actions.ts
var basket_actions = __webpack_require__(29682);
// EXTERNAL MODULE: ./src/redux/conveyanceMode/actions.ts
var conveyanceMode_actions = __webpack_require__(38534);
// EXTERNAL MODULE: ./src/redux/me/actions.ts
var me_actions = __webpack_require__(47290);
// EXTERNAL MODULE: ./src/redux/auth/actions.ts
var auth_actions = __webpack_require__(45479);
// EXTERNAL MODULE: ./src/analytics/commerce/google.ts
var google = __webpack_require__(94889);
// EXTERNAL MODULE: ./src/constants/authentication.ts
var authentication = __webpack_require__(5125);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/cookies-next/lib/index.js
var lib = __webpack_require__(35196);
;// CONCATENATED MODULE: ./src/services/auth.service.ts






function login(payload, origin) {
    return _login.apply(this, arguments);
}
function _login() {
    _login = (0,_async_to_generator/* default */.Z)(function(payload, origin) {
        var token;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,services_client/* getLoyaltyToken */.qm)(payload, {
                            origin: origin
                        })
                    ];
                case 1:
                    token = _state.sent();
                    (0,v4/* persistToken */.s8)({
                        origin: origin,
                        token: token
                    });
                    return [
                        2
                    ];
            }
        });
    });
    return _login.apply(this, arguments);
}
function isExternalUserTokenValid() {
    return (0,v4/* validateLoyaltyToken */.XA)((0,utils/* getOrigin */.P$)(window.location.host));
}
function getExternalCookie() {
    if ((0,lib.getCookie)("_paytronix_auth_code")) {
        return {
            cookie: (0,lib.getCookie)("_paytronix_auth_code"),
            provider: "paytronix"
        };
    }
    return null;
}
function clearExternalCookie() {
    (0,lib.deleteCookie)("_paytronix_auth_code");
}

// EXTERNAL MODULE: ./src/utils/android.ts
var android = __webpack_require__(90484);
// EXTERNAL MODULE: ./src/utils/auth.ts + 1 modules
var auth = __webpack_require__(10606);
// EXTERNAL MODULE: ./src/utils/checkout.ts
var checkout = __webpack_require__(47080);
;// CONCATENATED MODULE: ./src/redux/auth/saga.ts




























function fetchUserSaga(action) {
    var request, origin, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    5,
                    ,
                    14
                ]);
                request = (0,auth/* addOptionalPushNotificationToken */.Nf)(action.params);
                origin = (0,utils/* getOrigin */.P$)(window.location.host);
                return [
                    4,
                    (0,io_22ea0cf9.O)(login, request, origin)
                ];
            case 1:
                _state.sent();
                // Push to the url location that user tried to enter before being
                // authenticated do not do anything if a referrer is not set
                if (action.referrer) {
                    /** @TODO ensure that `referrer` is not an array. */ // @ts-expect-error
                    void router_default().push(action.referrer);
                }
                // // dispatch AUTH_SUCCESS
                return [
                    4,
                    (0,io_22ea0cf9.Z)(auth_actions/* default.authSuccess */.Z.authSuccess())
                ];
            case 2:
                _state.sent();
                // Fetch User Details
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.fetchMe */.Z.fetchMe())
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.generateFeatureBag */.Z.generateFeatureBag())
                ];
            case 4:
                _state.sent();
                // KA Event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.LOGIN */.AH.LOGIN, {
                    name: (router_default()).pathname
                });
                // Generic Events
                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.AUTH__SIGN_IN_SUCCESS */.x.AUTH__SIGN_IN_SUCCESS);
                //@TODO: Surface the login SSO method - Apple, Facebook, Google, etc.
                (0,google/* fireGACommerceLoginEvent */.RW)(action.params.flow_type === "implicit" ? "sso" : "password");
                return [
                    3,
                    14
                ];
            case 5:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "Could not login: ", error)
                ];
            case 6:
                errorResponse = _state.sent();
                if (!!action.signUpChain) return [
                    3,
                    8
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, false))
                ];
            case 7:
                _state.sent();
                return [
                    3,
                    11
                ];
            case 8:
                // If the login call fails after an account has been created successfully,
                // push them to login. This is likely a recaptcha issue
                return [
                    4,
                    router_default().push(routes/* ROUTES.LOGIN */.Z6.LOGIN)
                ];
            case 9:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayToast */.Z.displayToast("Please login to continue."))
                ];
            case 10:
                _state.sent();
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.ERROR */.AH.ERROR, {
                    name: constants_events/* ERROR_MESSAGES.SIGNUP_LOGIN_FAILURE */.RZ.SIGNUP_LOGIN_FAILURE
                });
                _state.label = 11;
            case 11:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(auth_actions/* default.authFailure */.Z.authFailure())
                ];
            case 12:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.clearMe */.Z.clearMe())
                ];
            case 13:
                _state.sent();
                // Clear customer/guest data on our Koala Analytics class before logging in
                if (true) {
                    window.KoalaAnalytics.setCustomerData(null);
                }
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.LOGIN_FAILURE */.RZ.LOGIN_FAILURE, error, errorResponse);
                return [
                    3,
                    14
                ];
            case 14:
                return [
                    2
                ];
        }
    });
}
function createUserSaga(action) {
    var loginCaptchaResponse, client, request, identifier, secret, loginPayload, payload, externalAuthFeatureFlags, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                loginCaptchaResponse = action.params[authentication/* CAPTCHA_CONFIG.FIELD_NAME */.i5.FIELD_NAME];
                delete action.params[authentication/* CAPTCHA_CONFIG.FIELD_NAME */.i5.FIELD_NAME];
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    10,
                    ,
                    15
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                request = (0,auth/* addOptionalPushNotificationToken */.Nf)(action.params);
                // Register the user
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* register */.z2, request, {
                        client: client
                    })
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(auth_actions/* default.signUpSuccess */.Z.signUpSuccess())
                ];
            case 3:
                _state.sent();
                identifier = action.params.email;
                secret = action.params.password;
                loginPayload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, authentication/* DEFAULT_PASSWORD_LOGIN_EXTRA_PAYLOAD */.g7), {
                    identifier: identifier,
                    secret: secret
                });
                payload = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, loginPayload), (0,_define_property/* default */.Z)({}, authentication/* CAPTCHA_CONFIG.FIELD_NAME */.i5.FIELD_NAME, loginCaptchaResponse));
                return [
                    4,
                    (0,io_22ea0cf9.a4)(auth/* getExternalAuthInfoFromState */.bz)
                ];
            case 4:
                externalAuthFeatureFlags = _state.sent().externalAuthFeatureFlags;
                if (!(externalAuthFeatureFlags === null || externalAuthFeatureFlags === void 0 ? void 0 : externalAuthFeatureFlags[authentication/* EXTERNAL_AUTH_FEATURES.REQUIRES_EMAIL_VERIFICATION */.dD.REQUIRES_EMAIL_VERIFICATION])) return [
                    3,
                    6
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(auth_actions/* default.toggleEmailVerification */.Z.toggleEmailVerification(true))
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    8
                ];
            case 6:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(auth_actions/* default.login */.Z.login(payload, action.referrer, true))
                ];
            case 7:
                _state.sent();
                _state.label = 8;
            case 8:
                // Success Notification
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayToast */.Z.displayToast("Account successfully created."))
                ];
            case 9:
                _state.sent();
                // Generic Events
                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.AUTH__SIGN_UP_SUCCESS */.x.AUTH__SIGN_UP_SUCCESS);
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.ACCOUNT_CREATED */.AH.ACCOUNT_CREATED, {
                    name: (router_default()).pathname
                });
                return [
                    3,
                    15
                ];
            case 10:
                error = _state.sent();
                // Error Notification
                return [
                    4,
                    (0,io_22ea0cf9.Z)(auth_actions/* default.signUpFailure */.Z.signUpFailure())
                ];
            case 11:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(auth_actions/* default.toggleEmailVerification */.Z.toggleEmailVerification(false))
                ];
            case 12:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "Could not create account: ", error)
                ];
            case 13:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 14:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.CREATE_ACCOUNT_FAILURE */.RZ.CREATE_ACCOUNT_FAILURE, error, errorResponse);
                return [
                    3,
                    15
                ];
            case 15:
                return [
                    2
                ];
        }
    });
}
function reloadUserSaga() {
    var origin, externalCookie, cookie, provider, payload, error, error1, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                origin = (0,utils/* getOrigin */.P$)(window.location.host);
                externalCookie = getExternalCookie();
                if (!(externalCookie && !isExternalUserTokenValid())) return [
                    3,
                    6
                ];
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    3,
                    4,
                    6
                ]);
                cookie = externalCookie.cookie, provider = externalCookie.provider;
                payload = {
                    provider: provider,
                    flow_type: "implicit",
                    identifier: cookie,
                    secret: cookie
                };
                return [
                    4,
                    (0,io_22ea0cf9.O)(login, payload, origin)
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 3:
                error = _state.sent();
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.RESTART_USER_SESSION_FAILURE */.RZ.RESTART_USER_SESSION_FAILURE, error, {
                    message: "External cookie session restart failed",
                    // @ts-expect-error
                    error: error
                });
                return [
                    3,
                    6
                ];
            case 4:
                return [
                    4,
                    (0,io_22ea0cf9.O)(clearExternalCookie)
                ];
            case 5:
                _state.sent();
                return [
                    7
                ];
            case 6:
                if (!(0,v4/* validateLoyaltyToken */.XA)(origin)) return [
                    3,
                    13
                ];
                _state.label = 7;
            case 7:
                _state.trys.push([
                    7,
                    9,
                    ,
                    13
                ]);
                // Fetch User Details
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.fetchMe */.Z.fetchMe())
                ];
            case 8:
                _state.sent();
                return [
                    3,
                    13
                ];
            case 9:
                error1 = _state.sent();
                // Clear user
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.clearMe */.Z.clearMe())
                ];
            case 10:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "It looks like there was an error restarting your user session.", error1)
                ];
            case 11:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 12:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.RESTART_USER_SESSION_FAILURE */.RZ.RESTART_USER_SESSION_FAILURE, error1, errorResponse);
                return [
                    3,
                    13
                ];
            case 13:
                return [
                    2
                ];
        }
    });
}
function doLogoutSaga(action) {
    var origin, client, state, conveyanceMode, deliveryAddress, location, loggedOutAddress, error, errorResponse, state1, deliveryAddress1, additionalDetails;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    14,
                    ,
                    19
                ]);
                origin = (0,utils/* getOrigin */.P$)(window.location.host);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: origin
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* logout */.kS, {
                        client: client
                    })
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,services_client/* resetLoyaltyToken */.I0)({
                        origin: origin
                    })
                ];
            case 2:
                _state.sent();
                // Clear user
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.clearMe */.Z.clearMe())
                ];
            case 3:
                _state.sent();
                // Clear user specific data from cart
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.depersonalizeBasket */.Z.depersonalizeBasket())
                ];
            case 4:
                _state.sent();
                // Clear things like rewards from cart
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.destroyOrder */.Z.destroyOrder())
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 6:
                state = _state.sent();
                conveyanceMode = state.app.conveyanceMode.type;
                if (!(conveyanceMode === dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY)) return [
                    3,
                    8
                ];
                deliveryAddress = (0,checkout/* assembleDeliveryObjectFromState */.Of)(state);
                if (!(deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.id)) return [
                    3,
                    8
                ];
                location = (0,checkout/* getLocationFromState */.ip)(state);
                loggedOutAddress = Object.assign({}, deliveryAddress);
                delete loggedOutAddress.id;
                delete loggedOutAddress.default;
                /**
         * @TODO reconcile IConveyanceDeliveryAddress and
         * the SDK `DeliveryAddress` types.
         */ return [
                    4,
                    (0,io_22ea0cf9.Z)(conveyanceMode_actions/* default.setDeliveryAddress */.Z.setDeliveryAddress(// @ts-expect-error
                    loggedOutAddress, location, false))
                ];
            case 7:
                _state.sent();
                _state.label = 8;
            case 8:
                // Clear customer data on our Koala Analytics class
                if (true) {
                    window.KoalaAnalytics.setCustomerData(null);
                }
                // Fire Generic Event
                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.AUTH__CLICK_LOGOUT */.x.AUTH__CLICK_LOGOUT, {
                    name: (router_default()).pathname
                });
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: auth_actions/* default.LOGOUT_SUCCESS */.Z.LOGOUT_SUCCESS
                    })
                ];
            case 9:
                _state.sent();
                if (!!action.cancelRedirect) return [
                    3,
                    13
                ];
                if (!(0,android/* isAndroidShell */.Y2)()) return [
                    3,
                    11
                ];
                return [
                    4,
                    router_default().push(routes/* ROUTES.ANDROID */.Z6.ANDROID)
                ];
            case 10:
                _state.sent();
                return [
                    3,
                    13
                ];
            case 11:
                return [
                    4,
                    router_default().push(routes/* ROUTES.HOMEPAGE */.Z6.HOMEPAGE)
                ];
            case 12:
                _state.sent();
                _state.label = 13;
            case 13:
                return [
                    3,
                    19
                ];
            case 14:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error logging you out. Please try again", error)
                ];
            case 15:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 16:
                _state.sent();
                // Stop loading
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: auth_actions/* default.LOGOUT_FAILURE */.Z.LOGOUT_FAILURE
                    })
                ];
            case 17:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 18:
                state1 = _state.sent();
                deliveryAddress1 = (0,checkout/* assembleDeliveryObjectFromState */.Of)(state1);
                additionalDetails = "";
                if (deliveryAddress1 === null || deliveryAddress1 === void 0 ? void 0 : deliveryAddress1.id) {
                    additionalDetails = "Stored Address ID: ".concat(deliveryAddress1.id);
                }
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.LOGOUT_FAILURE */.RZ.LOGOUT_FAILURE, error, errorResponse, additionalDetails);
                return [
                    3,
                    19
                ];
            case 19:
                return [
                    2
                ];
        }
    });
}
function forgotPasswordSaga(action) {
    var client, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    4,
                    ,
                    8
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* forgotPassword */.gF, action.email, {
                        client: client
                    })
                ];
            case 1:
                _state.sent();
                // Notify success
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayToast */.Z.displayToast("Please check your email for instructions on how to reset your password."))
                ];
            case 2:
                _state.sent();
                // Stop loading state
                return [
                    4,
                    (0,io_22ea0cf9.Z)(auth_actions/* default.forgotPasswordSuccess */.Z.forgotPasswordSuccess())
                ];
            case 3:
                _state.sent();
                return [
                    3,
                    8
                ];
            case 4:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(auth_actions/* default.forgotPasswordFail */.Z.forgotPasswordFail())
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "It looks like there was an error processing your request. ", error)
                ];
            case 6:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 7:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FORGOT_PASSWORD_FAILURE */.RZ.FORGOT_PASSWORD_FAILURE, error, errorResponse);
                return [
                    3,
                    8
                ];
            case 8:
                return [
                    2
                ];
        }
    });
}
function resetPasswordSaga(action) {
    var client, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    5,
                    ,
                    9
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* resetPassword */.c0, action.params, {
                        client: client
                    })
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: auth_actions/* default.RESET_PASSWORD_SUCCESS */.Z.RESET_PASSWORD_SUCCESS
                    })
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayToast */.Z.displayToast("Your password has been successfully reset."))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    router_default().push(routes/* ROUTES.LOGIN */.Z6.LOGIN)
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 5:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: auth_actions/* default.RESET_PASSWORD_FAIL */.Z.RESET_PASSWORD_FAIL
                    })
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "Failed to reset password. ", error)
                ];
            case 7:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 8:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.PASSWORD_RESET_FAILURE */.RZ.PASSWORD_RESET_FAILURE, error, errorResponse);
                return [
                    3,
                    9
                ];
            case 9:
                return [
                    2
                ];
        }
    });
}
function auth_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(auth_actions/* default.RELOAD_USER */.Z.RELOAD_USER, reloadUserSaga)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    takeLatest$1(auth_actions/* default.LOGIN_REQUEST */.Z.LOGIN_REQUEST, fetchUserSaga)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    takeLatest$1(auth_actions/* default.SIGN_UP_REQUEST */.Z.SIGN_UP_REQUEST, createUserSaga)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    takeLatest$1(auth_actions/* default.FORGOT_PASSWORD */.Z.FORGOT_PASSWORD, forgotPasswordSaga)
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    takeLatest$1(auth_actions/* default.RESET_PASSWORD */.Z.RESET_PASSWORD, resetPasswordSaga)
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    takeLatest$1(auth_actions/* default.LOGOUT */.Z.LOGOUT, doLogoutSaga)
                ];
            case 6:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./src/redux/locations/actions.ts
var locations_actions = __webpack_require__(17464);
// EXTERNAL MODULE: ./src/redux/menu/actions.ts
var menu_actions = __webpack_require__(22354);
// EXTERNAL MODULE: ./src/redux/basket/messages.ts
var messages = __webpack_require__(31387);
// EXTERNAL MODULE: ./src/constants/checkout.ts
var constants_checkout = __webpack_require__(80420);
// EXTERNAL MODULE: ./src/utils/basket.ts
var utils_basket = __webpack_require__(1227);
// EXTERNAL MODULE: ./src/utils/breakpoints.ts
var breakpoints = __webpack_require__(32197);
// EXTERNAL MODULE: ./src/utils/events.ts
var utils_events = __webpack_require__(41762);
// EXTERNAL MODULE: ./src/utils/googleAnalytics.ts
var googleAnalytics = __webpack_require__(87809);
// EXTERNAL MODULE: ./src/utils/locations.ts + 2 modules
var locations = __webpack_require__(52591);
;// CONCATENATED MODULE: ./src/redux/basket/saga.ts





























/**
 * Initialize and verify localStorage baskets to ensure it is in-sync with redux
 * and can work with a fresh menu and a fresh location
 */ function initializeLocalStorageBasket() {
    var ref, basket, sevenDaysAgo, basketLocationId, ref1, ref2, wantedAt, ref3, ref4, ref5;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                basket = dist/* sdkStorage.basket.get */.fn.basket.get();
                sevenDaysAgo = (0,dates/* subtractTime */.U2)(null, 7, "days");
                if (!(basket && (0,dates/* getDaysBetweenTwoDates */.ZL)(basket.createdAt, sevenDaysAgo) < 0)) return [
                    3,
                    2
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.destroyBasket */.Z.destroyBasket())
                ];
            case 1:
                _state.sent();
                (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.global */.m1.global, googleAnalytics/* gaActions.basketExpired */.cE.basketExpired);
                return [
                    2
                ];
            case 2:
                basketLocationId = basket === null || basket === void 0 ? void 0 : (ref = basket.location) === null || ref === void 0 ? void 0 : ref.id;
                if (!basketLocationId) return [
                    3,
                    6
                ];
                wantedAt = undefined;
                if ((ref1 = basket.checkoutBasket) === null || ref1 === void 0 ? void 0 : ref1.wanted_at) {
                    wantedAt = basket.checkoutBasket.wanted_at;
                } else if (basket === null || basket === void 0 ? void 0 : basket.fulfillment) {
                    ;
                    // @ts-expect-error: address is an object
                    if ((ref3 = basket.fulfillment.address) === null || ref3 === void 0 ? void 0 : ref3.time_wanted) {
                        // @ts-expect-error: address is an object
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        wantedAt = basket.fulfillment.address.time_wanted;
                    } else if ((ref4 = basket.fulfillment) === null || ref4 === void 0 ? void 0 : ref4.time_wanted) {
                        // @ts-expect-error: time_wanted is a string in this case
                        wantedAt = basket.fulfillment.time_wanted;
                    }
                }
                return [
                    4,
                    (0,io_22ea0cf9.$)([
                        // 1. Sync the localStorage basket with redux to avoid showing an empty state
                        (0,io_22ea0cf9.Z)(basket_actions/* default.hydrateBasket */.Z.hydrateBasket()),
                        // 2. Sync the localStorage menu with the basket menu in redux
                        (0,io_22ea0cf9.Z)(menu_actions/* default.hydrateBasketMenu */.Z.hydrateBasketMenu())
                    ])
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.$)([
                        // 3. Fetch a fresh menu to refresh the localStorage basket and ensure all the items are valid
                        //    TODO we could avoid re-fetching the menu if we could verify the localStorage menu is fresh
                        //    but to do that we need to add a `createdAt` date to the localStorage menu first
                        // @ts-expect-error
                        (0,io_22ea0cf9.Z)(menu_actions/* default.refreshBasketMenu */.Z.refreshBasketMenu(basketLocationId, wantedAt)),
                        // 4. Fetch a fresh location to refresh the localStorage basket and ensure our location data is accurate
                        // @ts-expect-error
                        (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.refreshBasketLocation */.b.refreshBasketLocation(basketLocationId))
                    ])
                ];
            case 4:
                _state.sent();
                // 5. finally, we sync with redux again to reflect the new the menu & location
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.hydrateBasket */.Z.hydrateBasket())
                ];
            case 5:
                _state.sent();
                // 6. Fire some analytics events
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.CART_PERSISTED */.AH.CART_PERSISTED);
                if ((ref2 = basket.fulfillment) === null || ref2 === void 0 ? void 0 : ref2.type) {
                    ;
                    (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.global */.m1.global, googleAnalytics/* gaActions.basketFulfillmenSet */.cE.basketFulfillmenSet, {
                        label: (ref5 = basket.fulfillment) === null || ref5 === void 0 ? void 0 : ref5.type
                    });
                }
                _state.label = 6;
            case 6:
                return [
                    2
                ];
        }
    });
}
function addItemToastSaga(action) {
    var msg;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                if (!action.item) return [
                    3,
                    2
                ];
                msg = action.item.quantity > 1 ? "".concat(action.item.quantity, " ").concat(messages/* BASKET_MESSAGE.addItemsToastSaga */.F.addItemsToastSaga) : messages/* BASKET_MESSAGE.addItemToastSaga */.F.addItemToastSaga;
                if (typeof action.index === "number") {
                    msg = action.item.quantity > 1 ? "".concat(action.item.quantity, " ").concat(messages/* BASKET_MESSAGE.updateItemsToastSaga */.F.updateItemsToastSaga) : messages/* BASKET_MESSAGE.updateItemToastSaga */.F.updateItemToastSaga;
                }
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayToast */.Z.displayToast(msg))
                ];
            case 1:
                _state.sent();
                return [
                    3,
                    4
                ];
            case 2:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(messages/* BASKET_ERROR.addItemErrorToastSaga */.Y.addItemErrorToastSaga))
                ];
            case 3:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.ERROR */.AH.ERROR, {
                    name: constants_events/* ERROR_MESSAGES.ADD_ITEM_TOAST_ERROR */.RZ.ADD_ITEM_TOAST_ERROR
                });
                _state.label = 4;
            case 4:
                return [
                    2
                ];
        }
    });
}
function postAddItemSaga(action) {
    var ref, localBasket, client, checkoutBasket, content, res, res1, _index, e;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                localBasket = dist/* sdkStorage.basket.get */.fn.basket.get();
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                if (!((ref = localBasket.checkoutBasket) === null || ref === void 0 ? void 0 : ref.id)) return [
                    3,
                    6
                ];
                checkoutBasket = localBasket.checkoutBasket, content = localBasket.content;
                if (!(typeof action.index === "number")) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,io_22ea0cf9.O)(// @ts-expect-error ensure that action.item.id is defined.
                    v4/* updateBasketItem */.B6, {
                        basketId: checkoutBasket.id,
                        locationId: checkoutBasket.location.id,
                        itemId: content.basket_items[action.index].id,
                        item: (0,utils_basket/* patchProductOptions */.kF)(action.item)
                    }, {
                        client: client
                    })
                ];
            case 1:
                res = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.success */.Z.success(res))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 3:
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* addBasketItem */.zW, {
                        basketId: checkoutBasket.id,
                        locationId: checkoutBasket.location.id,
                        item: (0,utils_basket/* patchProductOptions */.kF)(action.item)
                    }, {
                        client: client
                    })
                ];
            case 4:
                res1 = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.$)([
                        (0,io_22ea0cf9.Z)(basket_actions/* default.success */.Z.success(res1)),
                        (0,io_22ea0cf9.Z)(basket_actions/* default.basketItemsSyncedWithStore */.Z.basketItemsSyncedWithStore(res1.basket_items))
                    ])
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                _state.trys.push([
                    6,
                    10,
                    ,
                    11
                ]);
                if (!(0,breakpoints/* isBreakpointSizeMin */.H)("medium")) return [
                    3,
                    8
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.addItemToast */.Z.addItemToast(action.item, (_index = action.index) !== null && _index !== void 0 ? _index : undefined))
                ];
            case 7:
                _state.sent();
                _state.label = 8;
            case 8:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.basketItemSuccess */.Z.basketItemSuccess(true))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    11
                ];
            case 10:
                e = _state.sent();
                console.log(e);
                return [
                    3,
                    11
                ];
            case 11:
                return [
                    2
                ];
        }
    });
}
function reorderDeliveryBasketSaga(action) {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1([
                        global_actions/* default.DELIVERY_ADDRESS_VALID */.Z.DELIVERY_ADDRESS_VALID,
                        conveyanceMode_actions/* default.CLEAR_DELIVERY_ADDRESS */.Z.CLEAR_DELIVERY_ADDRESS
                    ], function() {
                        var ref, state, updatedFulfillment, save;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        (0,io_22ea0cf9.a4)()
                                    ];
                                case 1:
                                    state = _state.sent();
                                    updatedFulfillment = state.app.conveyanceMode.address || ((ref = state.app.basket.fulfillment) === null || ref === void 0 ? void 0 : ref.address);
                                    return [
                                        4,
                                        (0,io_22ea0cf9.W)({
                                            save: (0,io_22ea0cf9.L)(conveyanceMode_actions/* default.SET_DELIVERY_ADDRESS_CONTINUE */.Z.SET_DELIVERY_ADDRESS_CONTINUE),
                                            cancel: (0,io_22ea0cf9.L)(global_actions/* default.TOGGLE_FULFILLMENT_MODAL */.Z.TOGGLE_FULFILLMENT_MODAL)
                                        })
                                    ];
                                case 2:
                                    save = _state.sent().save;
                                    if (!save) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        (0,io_22ea0cf9.Z)(basket_actions/* default.reorderBasketSubmit */.Z.reorderBasketSubmit(action.order, action.label, updatedFulfillment, action.routeToCheckout, action.skipUnavailable))
                                    ];
                                case 3:
                                    _state.sent();
                                    _state.label = 4;
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    })
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function reorderBasketSaga(action) {
    var state, deliveryReorderTask, error, ref, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                _state.label = 2;
            case 2:
                _state.trys.push([
                    2,
                    11,
                    ,
                    15
                ]);
                if (!(action.order.order_data.basket.conveyance_type.type === "delivery")) return [
                    3,
                    8
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.toggleReorderReceipt */.Z.toggleReorderReceipt(false))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.toggleFulfillmentModal */.Z.toggleFulfillmentModal(true, /** @TODO ensure that `store_location` is non-nullable. */ // @ts-expect-error
                    action.order.store_location, dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY, false, null, true, false, true))
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.M)(reorderDeliveryBasketSaga, action)
                ];
            case 5:
                deliveryReorderTask = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.L)([
                        basket_actions/* default.REORDER_BASKET_SUCCESS */.Z.REORDER_BASKET_SUCCESS,
                        basket_actions/* default.REORDER_BASKET_FAILURE */.Z.REORDER_BASKET_FAILURE
                    ])
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.N)(deliveryReorderTask)
                ];
            case 7:
                _state.sent(); // Remove effect on reorder basket success or failure
                return [
                    3,
                    10
                ];
            case 8:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.reorderBasketSubmit */.Z.reorderBasketSubmit(action.order, action.label, /** @TODO allow for a nullable address. */ // @ts-expect-error
                    null, action.routeToCheckout, action.skipUnavailable))
                ];
            case 9:
                _state.sent();
                _state.label = 10;
            case 10:
                return [
                    3,
                    15
                ];
            case 11:
                error = _state.sent();
                switch(error){
                    case dist/* MenuGetError */.lo:
                        error.message = "There was an error reordering this basket. Unable to retrieve the menu for this location.";
                        break;
                    case dist/* InvalidBasket */.yU:
                        error.message = "We're sorry, none of the items in this purchase are currently available. Please view the menu to <a href=\"/store/".concat((0,locations/* getLocationId */.By)(action.order.location, state.app.cmsConfig.webConfig), "/").concat(action.order.location.label, '">start a new order</a>.');
                        break;
                    default:
                        break;
                }
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error reordering this basket.", error)
                ];
            case 12:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 13:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: basket_actions/* default.REORDER_BASKET_FAILURE */.Z.REORDER_BASKET_FAILURE
                    })
                ];
            case 14:
                _state.sent();
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.REORDER_ERROR */.RZ.REORDER_ERROR, error, errorResponse);
                // TODO: Currently being used as an urgent generic reorder failure event. To be renamed later
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.REORDER_ERROR */.AH.REORDER_ERROR, {
                    name: action.label,
                    details: errorResponse === null || errorResponse === void 0 ? void 0 : (ref = errorResponse.error) === null || ref === void 0 ? void 0 : ref.error_description
                });
                return [
                    3,
                    15
                ];
            case 15:
                return [
                    2
                ];
        }
    });
}
function reorderBasketSubmitSaga(action) {
    var client, pastOrder, ref, categories, availableBasketItems, error, ref1, ref2, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    7,
                    ,
                    16
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* createBasketFromOrderId */.YY, {
                        orderId: action.order.id,
                        locationId: action.order.store_location_id,
                        skipUnavailable: action.skipUnavailable
                    }, {
                        client: client
                    })
                ];
            case 1:
                pastOrder = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getMenu */.r7, {
                        id: pastOrder.location.id
                    }, {
                        client: client
                    })
                ];
            case 2:
                ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                    _state.sent(),
                    1
                ]), categories = ref[0];
                availableBasketItems = dist/* sdkUtils.filterAvailableItems */.fH.filterAvailableItems(// @ts-expect-error
                pastOrder, categories);
                if (!(availableBasketItems.length !== pastOrder.basket_items.length)) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast("Some items are not currently available and have been removed from your basket.", false))
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                // Initialize basket and fire KA event
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.initBasket */.Z.initBasket(// @ts-expect-error
                    action.order.store_location, categories, availableBasketItems, action === null || action === void 0 ? void 0 : action.address))
                ];
            case 5:
                _state.sent();
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.FIRST_PRODUCT_ADDED */.AH.FIRST_PRODUCT_ADDED, {
                    name: constants_events/* K_ANALYTICS_EVENTS.REORDER */.AH.REORDER,
                    details: null
                });
                (0,utils_events/* fireGenericOrderEventsHandler */.CK)(constants_events/* K_ANALYTICS_EVENTS.REORDER */.AH.REORDER, /** @TODO reconcile special_instructions to ensure it's defined. */ // @ts-expect-error
                action.order.order_data.basket, action.order, [
                    constants_events/* BASKET_ORDER_KEYS.TRANSACTION */.oO.TRANSACTION,
                    constants_events/* BASKET_ORDER_KEYS.ORDER */.oO.ORDER,
                    constants_events/* BASKET_ORDER_KEYS.BASKET_PRODUCTS */.oO.BASKET_PRODUCTS
                ], action.label);
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.reorderBasketSuccess */.Z.reorderBasketSuccess(action.order, action.routeToCheckout))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    16
                ];
            case 7:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error reordering this basket.", error)
                ];
            case 8:
                errorResponse = _state.sent();
                if (!(((ref1 = errorResponse.error) === null || ref1 === void 0 ? void 0 : ref1.error) === "could_not_create_basket_items_unavailable")) return [
                    3,
                    11
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.toggleReorderReceipt */.Z.toggleReorderReceipt(true))
                ];
            case 9:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.reorderBasketReviewMissingItems */.Z.reorderBasketReviewMissingItems())
                ];
            case 10:
                _state.sent();
                return [
                    3,
                    14
                ];
            case 11:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.toggleReorderReceipt */.Z.toggleReorderReceipt(false))
                ];
            case 12:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 13:
                _state.sent();
                _state.label = 14;
            case 14:
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: basket_actions/* default.REORDER_BASKET_FAILURE */.Z.REORDER_BASKET_FAILURE
                    })
                ];
            case 15:
                _state.sent();
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.REORDER_ERROR */.RZ.REORDER_ERROR, error, errorResponse);
                // TODO: Currently being used as an urgent generic reorder failure event. To be renamed later
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.REORDER_ERROR */.AH.REORDER_ERROR, {
                    name: action.label,
                    details: errorResponse === null || errorResponse === void 0 ? void 0 : (ref2 = errorResponse.error) === null || ref2 === void 0 ? void 0 : ref2.error_description
                });
                return [
                    3,
                    16
                ];
            case 16:
                return [
                    2
                ];
        }
    });
}
function reorderBasketSuccessSaga(action) {
    var // Fire ecommerce add to cart events for each product in the basket resulting from the reorder
    ref, ref1, ref2, state, ref3;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                ((ref3 = (ref = action.order) === null || ref === void 0 ? void 0 : (ref1 = ref.order_data) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.basket) === null || ref2 === void 0 ? void 0 : ref2.basket_items) !== null && ref3 !== void 0 ? ref3 : []).forEach(function(item) {
                    return (0,google/* addProductEventsGoogle */.FP)(//@ts-expect-error TODO: update type of function
                    item, action.order.location, state.app.menu.basketMenu, constants_checkout/* PRODUCT_LOCATION_LABELS.MENU */.X.MENU);
                });
                // If we are required to route the user to checkout (ex: Order History reorder flow), route the user to checkout
                if (action.routeToCheckout) {
                    void router_default().push(routes/* ROUTES.CHECKOUT */.Z6.CHECKOUT);
                    return [
                        2
                    ];
                }
                // If we are not on the store page, route the user to the store page with an open cart
                if ((router_default()).pathname !== routes/* ROUTES.STORE */.Z6.STORE) {
                    void router_default().push("/store/".concat((0,locations/* getLocationId */.By)(// @ts-expect-error ensure that `store_location` is non-nullable.
                    action.order.store_location, state.app.cmsConfig.webConfig), "?openCart=true"));
                    return [
                        2
                    ];
                }
                // If we are on the store page, open the cart with no additional routing
                // TODO: I don't like messing with the UI here but I would rather not reload the page in this use case
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.toggleBasket */.Z.toggleBasket(true))
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.toggleReorderReceipt */.Z.toggleReorderReceipt(false))
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function removeItemSaga(action) {
    var ref, localBasket, client, checkoutBasket, res;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                localBasket = dist/* sdkStorage.basket.get */.fn.basket.get();
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                if (!((ref = localBasket.checkoutBasket) === null || ref === void 0 ? void 0 : ref.id)) return [
                    3,
                    3
                ];
                checkoutBasket = localBasket.checkoutBasket;
                return [
                    4,
                    (0,io_22ea0cf9.O)(// @ts-expect-error ensure that action.item.id is defined.
                    v4/* removeBasketItem */.yN, {
                        basketId: checkoutBasket.id,
                        locationId: checkoutBasket.location.id,
                        itemId: action.item.id
                    }, {
                        client: client
                    })
                ];
            case 1:
                res = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.success */.Z.success(res))
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                return [
                    2
                ];
        }
    });
}
function revalidateBasketItemsSaga(action) {
    var localBasket, validatedItems;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                localBasket = dist/* sdkStorage.basket.get */.fn.basket.get();
                validatedItems = (0,utils_basket/* removeInvalidItemsFromCart */.LC)(localBasket.content.basket_items, action.menuCategories);
                if (!(validatedItems.length !== localBasket.content.basket_items.length)) return [
                    3,
                    2
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.revalidateBasketItemsSuccess */.Z.revalidateBasketItemsSuccess((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, localBasket), {
                        content: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, localBasket.content), {
                            basket_items: validatedItems
                        })
                    })))
                ];
            case 1:
                _state.sent();
                return [
                    3,
                    4
                ];
            case 2:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.revalidateBasketItemsSuccess */.Z.revalidateBasketItemsSuccess(localBasket))
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                return [
                    2
                ];
        }
    });
}
function basket_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(basket_actions/* default.INIT_LOCAL_STORAGE_BASKET */.Z.INIT_LOCAL_STORAGE_BASKET, initializeLocalStorageBasket)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    takeLatest$1(basket_actions/* default.ADD_ITEM */.Z.ADD_ITEM, postAddItemSaga)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    takeLatest$1(basket_actions/* default.REMOVE_ITEM */.Z.REMOVE_ITEM, removeItemSaga)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    takeLatest$1(basket_actions/* default.ADD_ITEM_TOAST */.Z.ADD_ITEM_TOAST, addItemToastSaga)
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    takeLatest$1(basket_actions/* default.REORDER_BASKET */.Z.REORDER_BASKET, reorderBasketSaga)
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    takeLatest$1(basket_actions/* default.REORDER_BASKET_SUBMIT */.Z.REORDER_BASKET_SUBMIT, reorderBasketSubmitSaga)
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    takeLatest$1(basket_actions/* default.REORDER_BASKET_SUCCESS */.Z.REORDER_BASKET_SUCCESS, reorderBasketSuccessSaga)
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    takeLatest$1(basket_actions/* default.REVALIDATE_BASKET_ITEMS */.Z.REVALIDATE_BASKET_ITEMS, revalidateBasketItemsSaga)
                ];
            case 8:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

;// CONCATENATED MODULE: ./src/constants/basketRewards.ts
var BASKET_REWARDS_ERROR_STATUS = {
    UNAVAILABLE: "unable_to_add_rewards",
    UNABLE_TO_APPLY: "basket_not_valid"
};

// EXTERNAL MODULE: ./src/constants/loyalty.ts
var loyalty = __webpack_require__(92106);
// EXTERNAL MODULE: ./src/utils/loyalty.ts
var utils_loyalty = __webpack_require__(53174);
;// CONCATENATED MODULE: ./src/redux/basketRewards/saga.ts

















/** Get basket rewards */ function getRewardsSaga() {
    var state, organization, loyaltyFeatureFlags, ref, basketId, locationId, client, ref1, availableRewards, appliedRewards, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.basketRewardsGet */.Z.basketRewardsGet())
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                _state.trys.push([
                    2,
                    8,
                    ,
                    10
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 3:
                state = _state.sent();
                organization = state.app.organization;
                if (!organization.organization.loyalty_driver_id) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 4:
                loyaltyFeatureFlags = _state.sent().loyaltyFeatureFlags;
                if (!(loyaltyFeatureFlags === null || loyaltyFeatureFlags === void 0 ? void 0 : loyaltyFeatureFlags[loyalty/* LOYALTY_FEATURES.GET_AVAILABLE_REWARDS */.lw.GET_AVAILABLE_REWARDS])) {
                    return [
                        2
                    ];
                }
                ref = (0,checkout/* getIdsFromState */.jw)(state), basketId = ref.basketId, locationId = ref.locationId;
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.$)([
                        (0,io_22ea0cf9.O)(v4/* getBasketRewards */.FQ, {
                            basketId: basketId,
                            locationId: locationId
                        }, {
                            client: client
                        }),
                        (0,io_22ea0cf9.O)(v4/* getAppliedRewards */.fs, {
                            basketId: basketId,
                            locationId: locationId
                        }, {
                            client: client
                        })
                    ])
                ];
            case 5:
                ref1 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                    _state.sent(),
                    2
                ]), availableRewards = ref1[0], appliedRewards = ref1[1];
                return [
                    4,
                    (0,io_22ea0cf9.$)([
                        (0,io_22ea0cf9.Z)(basketRewards_actions/* default.setAvailableRewards */.Z.setAvailableRewards(availableRewards)),
                        (0,io_22ea0cf9.Z)(basketRewards_actions/* default.setAppliedRewards */.Z.setAppliedRewards(appliedRewards))
                    ])
                ];
            case 6:
                _state.sent();
                _state.label = 7;
            case 7:
                return [
                    3,
                    10
                ];
            case 8:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, null, error)
                ];
            case 9:
                errorResponse = _state.sent();
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_REWARDS_ERROR */.RZ.FETCH_REWARDS_ERROR, error, errorResponse);
                return [
                    3,
                    10
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
/**
 * Add basket rewards
 *
 */ function addRewardSaga(action) {
    var ref, state, ref1, basketId, locationId, loyaltyFeatureFlags, client, response, appliedRewards, error, ref2, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.basketRewardsAdd */.Z.basketRewardsAdd())
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basketRewards_actions/* default.setPendingReward */.Z.setPendingReward(action === null || action === void 0 ? void 0 : (ref = action.reward) === null || ref === void 0 ? void 0 : ref.id))
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    10,
                    ,
                    16
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 4:
                state = _state.sent();
                ref1 = (0,checkout/* getIdsFromState */.jw)(state), basketId = ref1.basketId, locationId = ref1.locationId;
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 5:
                loyaltyFeatureFlags = _state.sent().loyaltyFeatureFlags;
                // Check if loyalty provider supports applying/destroying a reward or getting all applied rewards
                if (!(loyaltyFeatureFlags === null || loyaltyFeatureFlags === void 0 ? void 0 : loyaltyFeatureFlags[loyalty/* LOYALTY_FEATURES.APPLY_REWARDS */.lw.APPLY_REWARDS]) || !(loyaltyFeatureFlags === null || loyaltyFeatureFlags === void 0 ? void 0 : loyaltyFeatureFlags[loyalty/* LOYALTY_FEATURES.GET_APPLIED_REWARDS */.lw.GET_APPLIED_REWARDS]) || !(loyaltyFeatureFlags === null || loyaltyFeatureFlags === void 0 ? void 0 : loyaltyFeatureFlags[loyalty/* LOYALTY_FEATURES.DESTROY_REWARD */.lw.DESTROY_REWARD])) {
                    return [
                        2
                    ];
                }
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* addRewards */.yt, {
                        basketId: basketId,
                        rewardCodes: [
                            action.reward.id.toString()
                        ],
                        locationId: locationId,
                        validate: true
                    }, {
                        client: client
                    })
                ];
            case 6:
                response = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.success */.Z.success(response))
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getAppliedRewards */.fs, {
                        basketId: basketId,
                        locationId: locationId
                    }, {
                        client: client
                    })
                ];
            case 8:
                appliedRewards = _state.sent();
                // If validation works, apply the reward
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basketRewards_actions/* default.setAppliedRewards */.Z.setAppliedRewards(appliedRewards))
                ];
            case 9:
                _state.sent();
                // Fire event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.REWARD_APPLIED */.AH.REWARD_APPLIED, {
                    name: action.reward.label
                });
                return [
                    3,
                    16
                ];
            case 10:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, orderStatus/* OrderStatusMessages.BASKET_REWARDS_ADDING_ERROR */.bJ.BASKET_REWARDS_ADDING_ERROR, error)
                ];
            case 11:
                errorResponse = _state.sent();
                if (!((errorResponse === null || errorResponse === void 0 ? void 0 : (ref2 = errorResponse.error) === null || ref2 === void 0 ? void 0 : ref2.error) === BASKET_REWARDS_ERROR_STATUS.UNAVAILABLE)) return [
                    3,
                    13
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basketRewards_actions/* default.setUnavailableReward */.Z.setUnavailableReward(action.reward))
                ];
            case 12:
                _state.sent();
                return [
                    3,
                    15
                ];
            case 13:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderStatusMessageErrorSet */.Z.orderStatusMessageErrorSet(errorResponse.message))
                ];
            case 14:
                _state.sent();
                _state.label = 15;
            case 15:
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.ADD_REWARDS_FAILURE */.RZ.ADD_REWARDS_FAILURE, error, errorResponse);
                return [
                    3,
                    16
                ];
            case 16:
                // Reset order status
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basketRewards_actions/* default.setPendingReward */.Z.setPendingReward(null))
                ];
            case 17:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 18:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function removeRewardSaga(action) {
    var state, ref, basketId, locationId, loyaltyFeatureFlags, client, appliedRewards, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.basketRewardsRemove */.Z.basketRewardsRemove())
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                _state.trys.push([
                    2,
                    11,
                    ,
                    14
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 3:
                state = _state.sent();
                ref = (0,checkout/* getIdsFromState */.jw)(state), basketId = ref.basketId, locationId = ref.locationId;
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 4:
                loyaltyFeatureFlags = _state.sent().loyaltyFeatureFlags;
                // Check if loyalty provider supports destroying a reward or getting all applied rewards
                if (!(loyaltyFeatureFlags === null || loyaltyFeatureFlags === void 0 ? void 0 : loyaltyFeatureFlags[loyalty/* LOYALTY_FEATURES.GET_APPLIED_REWARDS */.lw.GET_APPLIED_REWARDS]) || !(loyaltyFeatureFlags === null || loyaltyFeatureFlags === void 0 ? void 0 : loyaltyFeatureFlags[loyalty/* LOYALTY_FEATURES.DESTROY_REWARD */.lw.DESTROY_REWARD])) {
                    return [
                        2
                    ];
                }
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* removeReward */.j6, {
                        basketId: basketId,
                        rewardCode: action.reward.id.toString(),
                        locationId: locationId
                    }, {
                        client: client
                    })
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getAppliedRewards */.fs, {
                        basketId: basketId,
                        locationId: locationId
                    }, {
                        client: client
                    })
                ];
            case 6:
                appliedRewards = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basketRewards_actions/* default.setAppliedRewards */.Z.setAppliedRewards(appliedRewards))
                ];
            case 7:
                _state.sent();
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basketRewards_actions/* default.resetUnavailableRewards */.Z.resetUnavailableRewards())
                ];
            case 9:
                _state.sent();
                // Silently validate basket
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.validateOrder */.Z.validateOrder(basketId, locationId))
                ];
            case 10:
                _state.sent();
                // Events
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.REWARD_REMOVED */.AH.REWARD_REMOVED, {
                    name: action.reward.label
                });
                return [
                    3,
                    14
                ];
            case 11:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, orderStatus/* OrderStatusMessages.BASKET_REWARDS_REMOVING_ERROR */.bJ.BASKET_REWARDS_REMOVING_ERROR, error)
                ];
            case 12:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderStatusMessageErrorSet */.Z.orderStatusMessageErrorSet(errorResponse.message))
                ];
            case 13:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.REMOVE_REWARDS_FAILURE */.RZ.REMOVE_REWARDS_FAILURE, error, errorResponse);
                return [
                    3,
                    14
                ];
            case 14:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 15:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function resetRewardSaga() {
    var state, rewardsApplied;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                rewardsApplied = state.app.basketRewards.rewardsApplied;
                return [
                    4,
                    rewardsApplied.forEach(function(reward) {
                        (0,io_22ea0cf9.Z)(basketRewards_actions/* default.removeReward */.Z.removeReward(reward));
                    })
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function basketRewards_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(basketRewards_actions/* default.GET_REWARDS */.Z.GET_REWARDS, getRewardsSaga)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    takeLatest$1(basketRewards_actions/* default.ADD_REWARD */.Z.ADD_REWARD, addRewardSaga)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    takeLatest$1(basketRewards_actions/* default.REMOVE_REWARD */.Z.REMOVE_REWARD, removeRewardSaga)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    takeLatest$1(basketRewards_actions/* default.RESET_BASKET_REWARDS */.Z.RESET_BASKET_REWARDS, resetRewardSaga)
                ];
            case 4:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

// EXTERNAL MODULE: ./src/features/configs/configs.ts
var configs = __webpack_require__(74380);
// EXTERNAL MODULE: ./src/features/configs/organization.ts
var configs_organization = __webpack_require__(5981);
// EXTERNAL MODULE: ./src/features/configs/strings.ts
var configs_strings = __webpack_require__(18971);
// EXTERNAL MODULE: ./src/redux/organization/actions.ts
var organization_actions = __webpack_require__(8460);
;// CONCATENATED MODULE: ./src/redux/cmsConfig/saga.ts












function fetchConfigsSaga(action) {
    var origin, ref, organization, strings, webConfig, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    6
                ]);
                origin = (0,utils/* getOrigin */.P$)(window.location.host);
                return [
                    4,
                    (0,io_22ea0cf9.$)([
                        (0,io_22ea0cf9.O)(configs_organization/* getOrganization */.X, action.queryClient, origin),
                        (0,io_22ea0cf9.O)(configs_strings/* getStrings */.F, action.queryClient, origin),
                        (0,io_22ea0cf9.O)(configs/* getConfigs */.G_, action.queryClient, origin)
                    ])
                ];
            case 1:
                ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                    _state.sent(),
                    3
                ]), organization = ref[0], strings = ref[1], webConfig = ref[2];
                return [
                    4,
                    (0,io_22ea0cf9.$)([
                        (0,io_22ea0cf9.Z)(cmsConfig_actions/* default.fetchConfigsSuccess */.Z.fetchConfigsSuccess(action.clientOrServer, "webConfig", webConfig)),
                        (0,io_22ea0cf9.Z)(cmsConfig_actions/* default.fetchConfigsSuccess */.Z.fetchConfigsSuccess(action.clientOrServer, "strings", strings)),
                        // @ts-expect-error `organizationConfig` is mistyped.
                        (0,io_22ea0cf9.Z)(organization_actions/* default.fetchOrganizationSuccess */.Z.fetchOrganizationSuccess(organization))
                    ])
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 3:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.$)([
                        (0,io_22ea0cf9.Z)(cmsConfig_actions/* default.fetchConfigsFailure */.Z.fetchConfigsFailure(action.clientOrServer)),
                        (0,io_22ea0cf9.Z)(organization_actions/* default.fetchOrganizationFail */.Z.fetchOrganizationFail())
                    ])
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, null, error)
                ];
            case 5:
                errorResponse = _state.sent();
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_BATCH_CONFIGS_ERROR */.RZ.FETCH_BATCH_CONFIGS_ERROR, error, errorResponse);
                return [
                    3,
                    6
                ];
            case 6:
                return [
                    2
                ];
        }
    });
}
function cmsConfig_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(cmsConfig_actions/* default.FETCH_CONFIGS */.Z.FETCH_CONFIGS, fetchConfigsSaga)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

;// CONCATENATED MODULE: ./src/analytics/commerce/koala.ts




/**
 * Koala Add Products
 * - FIRST_PRODUCT_ADDED
 * - BASKET_UPDATE
 *
 */ var addProductEventsKoala = function(basketOrder) {
    var kaEvent = constants_events/* K_ANALYTICS_EVENTS.BASKET_UPDATE */.AH.BASKET_UPDATE;
    // KA Event if we are adding first item in basket
    if (basketOrder.basket_items.length === 1) {
        kaEvent = constants_events/* K_ANALYTICS_EVENTS.FIRST_PRODUCT_ADDED */.AH.FIRST_PRODUCT_ADDED;
    }
    (0,utils_events/* fireGenericOrderEventsHandler */.CK)(kaEvent, basketOrder, null, [
        constants_events/* BASKET_ORDER_KEYS.BASKET_PRODUCTS */.oO.BASKET_PRODUCTS, 
    ]);
};
/**
 * Koala Remove Products
 * - BASKET_UPDATE
 *
 */ var removeProductEventsKoala = function(basketOrder) {
    (0,utils_events/* fireGenericOrderEventsHandler */.CK)(constants_events/* K_ANALYTICS_EVENTS.BASKET_UPDATE */.AH.BASKET_UPDATE, basketOrder, null, [
        constants_events/* BASKET_ORDER_KEYS.BASKET_PRODUCTS */.oO.BASKET_PRODUCTS
    ]);
};
/**
 * completeOrderEventsKoala
 *
 * Passes slightly modified data, needs to be separate function from generic handler
 */ var basketStagedEventsKoala = function(basketContent, checkoutBasket, conveyanceType) {
    try {
        // Koala Event
        (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.BASKET_STAGED */.AH.BASKET_STAGED, {
            order: {
                promo_discount: checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.promo_discount,
                promo_code_applied: false,
                reward_applied: false,
                id: checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.id,
                order_number: null,
                ready_time: null,
                subtotal: checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.subtotal,
                sales_tax: [
                    {
                        label: "Tax",
                        tax_cents: checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.sales_tax
                    }, 
                ],
                ordered_at: null,
                total: checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.total,
                // @ts-expect-error `conveyanceType` can't index API_CONVEYANCE_TYPES.
                conveyance_type: constants_events/* API_CONVEYANCE_TYPES */.tQ[conveyanceType.toUpperCase()]
            },
            basket_products: (0,koalaAnalytics/* coerceBasketProductsForKA */.Ww)(basketContent.basket_items)
        });
    } catch (e) {
        // KA event
        (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.ERROR */.AH.ERROR, {
            name: constants_events/* ERROR_MESSAGES.BASKET_STAGED_EVENTS_ERROR */.RZ.BASKET_STAGED_EVENTS_ERROR,
            details: e.message
        });
    }
};
/**
 * completeOrderEventsKoala
 *
 * Takes nextProps and distributes the data across
 * Google analytics, Google Commerce, and Koala Analytics events
 */ var completeOrderEventsKoala = function(state, orderDetails) {
    try {
        var ref;
        var basketContent = state.app.basket.content;
        var promoCode = state.app.promoCode;
        var rewards = state.app.basketRewards.rewardsApplied;
        var table_number = // @ts-expect-error `table_tent_number` could exist if conveyance_type is `dine_in`.
        orderDetails.order_data.basket.conveyance_type.table_tent_number || null;
        // Koala Event
        (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.ORDER_SUBMITTED */.AH.ORDER_SUBMITTED, {
            details: table_number && "Table number: ".concat(table_number) || null,
            transaction: {
                id: orderDetails.id,
                time_taken: null,
                type: (ref = orderDetails.order_data.payment) === null || ref === void 0 ? void 0 : ref.map(function(payment) {
                    return payment.type;
                })
            },
            order: {
                promo_discount: orderDetails.order_data.order.promo_discount,
                promo_code_applied: !!promoCode.applied,
                reward_applied: !!rewards.length,
                id: orderDetails.order_id,
                order_number: orderDetails.order_data.order.order_number,
                ready_time: (0,dates/* getISODateInUTC */.j4)(orderDetails.order_data.order.ready_at),
                subtotal: orderDetails.order_data.order.subtotal,
                sales_tax: [
                    {
                        label: "Tax",
                        tax_cents: orderDetails.order_data.order.sales_tax
                    }, 
                ],
                ordered_at: (0,dates/* getISODateInUTC */.j4)(orderDetails.order_data.order.ordered_at),
                total: orderDetails.order_data.order.total,
                conveyance_type: orderDetails.order_data.basket.conveyance_type.type,
                table_tent_number: // @ts-expect-error `table_tent_number` could exist if conveyance_type is `dine_in`.
                orderDetails.order_data.basket.conveyance_type.table_tent_number,
                wanted_at: orderDetails.order_data.basket.wanted_at
            },
            basket_products: (0,koalaAnalytics/* coerceBasketProductsForKA */.Ww)(basketContent.basket_items)
        });
    } catch (e) {
        // KA event
        (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.ERROR */.AH.ERROR, {
            name: constants_events/* ERROR_MESSAGES.SUBMIT_EVENTS_ERROR */.RZ.SUBMIT_EVENTS_ERROR,
            details: e.message
        });
    }
};

// EXTERNAL MODULE: ./src/analytics/integrations/branch/index.ts
var branch = __webpack_require__(81425);
// EXTERNAL MODULE: ./src/analytics/integrations/facebook/index.ts
var facebook = __webpack_require__(1371);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
;// CONCATENATED MODULE: ./src/analytics/integrations/roku/index.ts

var hasRoku = function() {
    return  true && window.rkp;
};
var RokuAnalytics = /*#__PURE__*/ function() {
    "use strict";
    function RokuAnalytics() {
        (0,_class_call_check/* default */.Z)(this, RokuAnalytics);
    }
    /**
   * Maps our conveyance types to Roku's delivery categories
   */ RokuAnalytics.mapDeliveryCategory = function mapDeliveryCategory(conveyanceType) {
        switch(conveyanceType){
            case "pick_up":
                return "in_store";
            case "curbside":
                return "curbside";
            case "delivery":
                return "home_delivery";
            default:
                return undefined;
        }
    };
    /**
   * Page View Event
   */ RokuAnalytics.pageView = function pageView() {
        if (!hasRoku()) {
            return;
        }
        window.rkp("event", "PAGE_VIEW");
    };
    /**
   * Commerce Events
   */ RokuAnalytics.purchase = function purchase(orderDetails) {
        if (!hasRoku()) {
            return;
        }
        var deliveryCategory = RokuAnalytics.mapDeliveryCategory(orderDetails.order_data.basket.conveyance_type.type);
        // Convert basket items to Roku content format
        var contents = orderDetails.order_data.basket.basket_items.map(function(item) {
            var contentItem = {
                id: item.product.id.toString(),
                quantity: item.quantity
            };
            // Only include delivery_category if it's defined
            if (deliveryCategory) {
                contentItem.delivery_category = deliveryCategory.toUpperCase();
            }
            return contentItem;
        });
        window.rkp("event", "PURCHASE", {
            value: orderDetails.order_data.order.total / 100,
            order_id: orderDetails.order_data.order.id,
            contents: contents
        });
    };
    return RokuAnalytics;
}();

// EXTERNAL MODULE: ./src/redux/commerce/actions.ts
var commerce_actions = __webpack_require__(57588);
;// CONCATENATED MODULE: ./src/redux/commerce/saga.ts
















/**
 * Generic Commerce Error Event
 */ var fireCommerceError = function(details) {
    (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.ERROR */.AH.ERROR, {
        name: constants_events/* ERROR_MESSAGES.ERROR_LOGGING_COMMERCE_EVENT */.RZ.ERROR_LOGGING_COMMERCE_EVENT,
        details: details
    });
};
/**
 * Add Product Impressions
 */ function commerceItemImpressionSaga(action) {
    var state, location, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    4,
                    ,
                    5
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                location = state.app.locations.detail;
                if (!location) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,io_22ea0cf9.O)(google/* addImpressionsGoogle */.pi, action.item, action.categoryName, location, action.index)
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                return [
                    3,
                    5
                ];
            case 4:
                error = _state.sent();
                fireCommerceError("Set Impression - ".concat(error.message));
                return [
                    3,
                    5
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
/**
 * View Category
 */ function commerceViewCategorySaga(action) {
    var error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    2,
                    ,
                    3
                ]);
                /**
     * Google Commerce
     */ return [
                    4,
                    (0,io_22ea0cf9.O)(google/* addCategoryViewGoogle */.eM, action.category, action.location)
                ];
            case 1:
                _state.sent();
                return [
                    3,
                    3
                ];
            case 2:
                error = _state.sent();
                fireCommerceError("Set Impression - ".concat(error.message));
                return [
                    3,
                    3
                ];
            case 3:
                return [
                    2
                ];
        }
    });
}
/**
 * Menu Item Clicks
 */ function commerceItemClickSaga(action) {
    var state, _detail, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    4
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                /**
     * Google
     */ return [
                    4,
                    (0,io_22ea0cf9.O)(google/* clickProductEventsGoogle */.cg, action.item, action.categoryName, (_detail = state.app.locations.detail) !== null && _detail !== void 0 ? _detail : state.app.basket.location, constants_checkout/* PRODUCT_LOCATION_LABELS.MENU */.X.MENU, action.index)
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    4
                ];
            case 3:
                error = _state.sent();
                fireCommerceError("Click Menu Item - ".concat(error.message));
                return [
                    3,
                    4
                ];
            case 4:
                return [
                    2
                ];
        }
    });
}
/**
 * Cross-sell Item Clicks
 */ function commerceItemCrossSellClickSaga(action) {
    var state, _detail, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    4
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                /**
     * Google
     */ return [
                    4,
                    (0,io_22ea0cf9.O)(google/* clickProductEventsGoogle */.cg, action.item, constants_checkout/* PRODUCT_LOCATION_LABELS.CROSS_SELL */.X.CROSS_SELL, (_detail = state.app.locations.detail) !== null && _detail !== void 0 ? _detail : state.app.basket.location, constants_checkout/* PRODUCT_LOCATION_LABELS.CROSS_SELL */.X.CROSS_SELL, action.index)
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    4
                ];
            case 3:
                error = _state.sent();
                fireCommerceError("Click Cross-Sell Item - ".concat(error.message));
                return [
                    3,
                    4
                ];
            case 4:
                return [
                    2
                ];
        }
    });
}
/**
 * View Item Detail
 */ function commerceItemViewSaga(action) {
    var state, _payload, product, label, // Prioritize the current location to correctly track when a user is clicking products in a location without transferring their basket
    _detail, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    4,
                    ,
                    5
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                _payload = action.payload, product = _payload.product, label = _payload.label;
                /**
     * Google
     */ // User use basket location if we're viewing a basket item, otherwise use menu location
                return [
                    4,
                    (0,io_22ea0cf9.O)(google/* viewProductEventsGoogle */.kl, product, (_detail = state.app.locations.detail) !== null && _detail !== void 0 ? _detail : state.app.basket.location, label, action.payload.menuCategories)
                ];
            case 2:
                _state.sent();
                /**
     * Page Views
     */ return [
                    4,
                    (0,io_22ea0cf9.O)(events/* pageViewEventHandler */.f)
                ];
            case 3:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 4:
                error = _state.sent();
                fireCommerceError("View Item - ".concat(error.message));
                return [
                    3,
                    5
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
/**
 * Add Item to Basket
 */ function commerceItemAddSaga(action) {
    var state, _basket, content, location, basketMenu, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    5,
                    ,
                    6
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                _basket = state.app.basket, content = _basket.content, location = _basket.location;
                basketMenu = state.app.menu.basketMenu;
                /**
     * Google
     */ return [
                    4,
                    (0,io_22ea0cf9.O)(google/* addProductEventsGoogle */.FP, action.item, location, basketMenu, action.label)
                ];
            case 2:
                _state.sent();
                /**
     * Branch
     */ return [
                    4,
                    (0,io_22ea0cf9.O)(branch/* BranchAnalytics.addProduct */.y.addProduct, action.item, location)
                ];
            case 3:
                _state.sent();
                /**
     * Koala
     */ return [
                    4,
                    (0,io_22ea0cf9.O)(addProductEventsKoala, content)
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 5:
                error = _state.sent();
                fireCommerceError("Add Item - ".concat(error.message));
                return [
                    3,
                    6
                ];
            case 6:
                return [
                    2
                ];
        }
    });
}
/**
 * Remove Item from
 */ function commerceItemRemoveSaga(action) {
    var state, _basket, content, location, basketMenu, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    4,
                    ,
                    5
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                _basket = state.app.basket, content = _basket.content, location = _basket.location;
                basketMenu = state.app.menu.basketMenu;
                /**
     * Google
     */ return [
                    4,
                    (0,io_22ea0cf9.O)(google/* removeProductEventsGoogle */.v3, action.item, location, basketMenu)
                ];
            case 2:
                _state.sent();
                /**
     * Koala
     */ return [
                    4,
                    (0,io_22ea0cf9.O)(removeProductEventsKoala, content)
                ];
            case 3:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 4:
                error = _state.sent();
                fireCommerceError("Remove Item - ".concat(error.message));
                return [
                    3,
                    5
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
/**
 * Checkout Step Two: User Details Set
 */ function checkoutStepTwoSaga() {
    var ref, state, userType, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    4
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                userType = ((ref = state.app.me.data) === null || ref === void 0 ? void 0 : ref.id) ? "User" : "Guest";
                return [
                    4,
                    (0,io_22ea0cf9.O)(google/* fireGACommerceStep */.T4, 2, userType)
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    4
                ];
            case 3:
                error = _state.sent();
                fireCommerceError("".concat(google/* GOOGLE_COMMERCE_CHECKOUT_STEPS.2 */.Rd[2], " - ").concat(error.message));
                return [
                    3,
                    4
                ];
            case 4:
                return [
                    2
                ];
        }
    });
}
/**
 * Checkout Step Three: Basket Staged
 */ function checkoutStepThreeSaga(action) {
    var error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    4
                ]);
                /**
     * Google Commerce
     */ return [
                    4,
                    (0,io_22ea0cf9.O)(google/* fireGACommerceStep */.T4, 3)
                ];
            case 1:
                _state.sent();
                /**
     * Koala
     */ return [
                    4,
                    (0,io_22ea0cf9.O)(basketStagedEventsKoala, action.basketContent, action.checkoutBasket, action.conveyanceType)
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    4
                ];
            case 3:
                error = _state.sent();
                fireCommerceError("".concat(google/* GOOGLE_COMMERCE_CHECKOUT_STEPS.3 */.Rd[3], " - ").concat(error.message));
                return [
                    3,
                    4
                ];
            case 4:
                return [
                    2
                ];
        }
    });
}
/**
 * Checkout Step Four: Payment Set
 */ function checkoutStepFourSaga() {
    var ref, ref1, state, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    6,
                    ,
                    7
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                if (!((ref = state.app.payment) === null || ref === void 0 ? void 0 : (ref1 = ref.paymentType) === null || ref1 === void 0 ? void 0 : ref1.type)) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,io_22ea0cf9.O)(google/* fireGACommerceStep */.T4, 4, state.app.payment.paymentType.type)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(google/* fireGACommerceAddPaymentInfoEvent */.F$, state.app.basket, state.app.menu.basketMenu, state.app.payment.paymentType.type, state.app.promoCode.applied)
                ];
            case 3:
                _state.sent();
                _state.label = 4;
            case 4:
                /**
     * Branch
     */ return [
                    4,
                    (0,io_22ea0cf9.O)(branch/* BranchAnalytics.paymentSet */.y.paymentSet)
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    7
                ];
            case 6:
                error = _state.sent();
                fireCommerceError("".concat(google/* GOOGLE_COMMERCE_CHECKOUT_STEPS.4 */.Rd[4], " - ").concat(error.message));
                return [
                    3,
                    7
                ];
            case 7:
                return [
                    2
                ];
        }
    });
}
/**
 * Checkout Step Five: Order Submission Staged
 */ function checkoutStepFiveSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                /**
   * Google
   */ return [
                    4,
                    (0,io_22ea0cf9.O)(google/* fireGACommerceStep */.T4, 5)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
/**
 * Checkout Step Six: Order Receipt Received
 */ function checkoutStepSixSaga(action) {
    var state, error, error1, error2, error3, error4;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                _state.label = 2;
            case 2:
                _state.trys.push([
                    2,
                    5,
                    ,
                    6
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.O)(google/* fireGACommerceStep */.T4, 6)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(google/* fireGACommercePurchaseEvent */.mI, action.orderDetails, state.app.basket, state.app.menu.basketMenu, state.app.promoCode.applied)
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 5:
                error = _state.sent();
                fireCommerceError("[Google] ".concat(google/* GOOGLE_COMMERCE_CHECKOUT_STEPS.6 */.Rd[6], " - ").concat(error.message));
                return [
                    3,
                    6
                ];
            case 6:
                _state.trys.push([
                    6,
                    8,
                    ,
                    9
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.O)(completeOrderEventsKoala, state, action.orderDetails)
                ];
            case 7:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 8:
                error1 = _state.sent();
                fireCommerceError("[Koala] ".concat(google/* GOOGLE_COMMERCE_CHECKOUT_STEPS.6 */.Rd[6], " - ").concat(error1.message));
                return [
                    3,
                    9
                ];
            case 9:
                _state.trys.push([
                    9,
                    11,
                    ,
                    12
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.O)(facebook/* FacebookAnalytics.purchase */.Z.purchase, action.orderDetails)
                ];
            case 10:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 11:
                error2 = _state.sent();
                fireCommerceError("[Facebook] ".concat(google/* GOOGLE_COMMERCE_CHECKOUT_STEPS.6 */.Rd[6], " - ").concat(error2.message));
                return [
                    3,
                    12
                ];
            case 12:
                _state.trys.push([
                    12,
                    14,
                    ,
                    15
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.O)(branch/* BranchAnalytics.purchase */.y.purchase, action.orderDetails, state)
                ];
            case 13:
                _state.sent();
                return [
                    3,
                    15
                ];
            case 14:
                error3 = _state.sent();
                fireCommerceError("[Branch] ".concat(google/* GOOGLE_COMMERCE_CHECKOUT_STEPS.6 */.Rd[6], " - ").concat(error3.message));
                return [
                    3,
                    15
                ];
            case 15:
                _state.trys.push([
                    15,
                    17,
                    ,
                    18
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.O)(RokuAnalytics.purchase, action.orderDetails)
                ];
            case 16:
                _state.sent();
                return [
                    3,
                    18
                ];
            case 17:
                error4 = _state.sent();
                fireCommerceError("[Roku] ".concat(google/* GOOGLE_COMMERCE_CHECKOUT_STEPS.6 */.Rd[6], " - ").concat(error4.message));
                return [
                    3,
                    18
                ];
            case 18:
                return [
                    2
                ];
        }
    });
}
function commerce_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                // Product Events
                return [
                    4,
                    takeLatest$1(commerce_actions/* default.COMMERCE_ITEM_IMPRESSION */.Z.COMMERCE_ITEM_IMPRESSION, commerceItemImpressionSaga)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    takeLatest$1(commerce_actions/* default.COMMERCE_VIEW_CATEGORY */.Z.COMMERCE_VIEW_CATEGORY, commerceViewCategorySaga)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    takeLatest$1(commerce_actions/* default.COMMERCE_ITEM_CLICK */.Z.COMMERCE_ITEM_CLICK, commerceItemClickSaga)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    takeLatest$1(commerce_actions/* default.COMMERCE_ITEM_CROSS_SELL_CLICK */.Z.COMMERCE_ITEM_CROSS_SELL_CLICK, commerceItemCrossSellClickSaga)
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    takeLatest$1(customize_actions/* default.SET_PRODUCT_TO_CUSTOMIZE */.Z.SET_PRODUCT_TO_CUSTOMIZE, commerceItemViewSaga)
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    takeLatest$1(basket_actions/* default.ADD_ITEM */.Z.ADD_ITEM, commerceItemAddSaga)
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    takeLatest$1(basket_actions/* default.REMOVE_ITEM */.Z.REMOVE_ITEM, commerceItemRemoveSaga)
                ];
            case 7:
                _state.sent();
                // Checkout Events
                return [
                    4,
                    takeLatest$1(orderStatus_actions/* default.INITIALIZE_ORDER */.Z.INITIALIZE_ORDER, checkoutStepTwoSaga)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    takeLatest$1(commerce_actions/* default.COMMERCE_CHECKOUT_BASKET_STAGED */.Z.COMMERCE_CHECKOUT_BASKET_STAGED, checkoutStepThreeSaga)
                ];
            case 9:
                _state.sent();
                return [
                    4,
                    takeLatest$1(payment_actions/* default.BILLING_ACCOUNT_SET */.Z.BILLING_ACCOUNT_SET, checkoutStepFourSaga)
                ];
            case 10:
                _state.sent();
                return [
                    4,
                    takeLatest$1(payment_actions/* default.CREDIT_CARD_SET */.Z.CREDIT_CARD_SET, checkoutStepFourSaga)
                ];
            case 11:
                _state.sent();
                return [
                    4,
                    takeLatest$1(payment_actions/* default.PAY_IN_STORE_SET */.Z.PAY_IN_STORE_SET, checkoutStepFourSaga)
                ];
            case 12:
                _state.sent();
                return [
                    4,
                    takeLatest$1(orderStatus_actions/* default.ORDER_SUBMISSION_START */.Z.ORDER_SUBMISSION_START, checkoutStepFiveSaga)
                ];
            case 13:
                _state.sent();
                return [
                    4,
                    takeLatest$1(commerce_actions/* default.COMMERCE_CHECKOUT_PURCHASE */.Z.COMMERCE_CHECKOUT_PURCHASE, checkoutStepSixSaga)
                ];
            case 14:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

// EXTERNAL MODULE: ./src/constants/global.ts
var constants_global = __webpack_require__(66686);
// EXTERNAL MODULE: ./src/features/handoff/time-picker/utils.ts
var time_picker_utils = __webpack_require__(65242);
// EXTERNAL MODULE: ./src/utils/fulfillment.ts
var fulfillment = __webpack_require__(89744);
;// CONCATENATED MODULE: ./src/redux/conveyanceMode/saga.ts
























function checkDeliveryAddressSaga(action) {
    var client, coercedAddress, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    8,
                    ,
                    12
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                coercedAddress = (0,fulfillment/* coerceAddressValidationPayload */.U8)(action.address);
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* checkDeliveryCoverage */.ts, action.location.id, coercedAddress, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                if (!(response === null || response === void 0 ? void 0 : response.data.can_deliver)) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(conveyanceMode_actions/* default.setDeliveryAddress */.Z.setDeliveryAddress(action.address, action.location, action.revalidate, action.shouldAutoRedirect))
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: global_actions/* default.DELIVERY_ADDRESS_VALID */.Z.DELIVERY_ADDRESS_VALID
                    })
                ];
            case 3:
                _state.sent();
                return [
                    3,
                    7
                ];
            case 4:
                // If not valid
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: global_actions/* default.DELIVERY_ADDRESS_INVALID */.Z.DELIVERY_ADDRESS_INVALID,
                        errorMessage: response === null || response === void 0 ? void 0 : response.data.message
                    })
                ];
            case 5:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.ERROR */.AH.ERROR, {
                    name: constants_events/* ERROR_MESSAGES.CHECK_DELIVERY_COVERAGE_ERROR */.RZ.CHECK_DELIVERY_COVERAGE_ERROR,
                    details: response === null || response === void 0 ? void 0 : response.data.message
                });
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: conveyanceMode_actions/* default.CHECK_DELIVERY_ADDRESS_FAILURE */.Z.CHECK_DELIVERY_ADDRESS_FAILURE
                    })
                ];
            case 6:
                _state.sent();
                _state.label = 7;
            case 7:
                return [
                    3,
                    12
                ];
            case 8:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: conveyanceMode_actions/* default.CHECK_DELIVERY_ADDRESS_FAILURE */.Z.CHECK_DELIVERY_ADDRESS_FAILURE
                    })
                ];
            case 9:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast("There was an error validating your delivery address. Please try again in a few minutes.", true))
                ];
            case 10:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, null, error)
                ];
            case 11:
                errorResponse = _state.sent();
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.VALIDATE_DELIVERY_ADDRESS_ERROR */.RZ.VALIDATE_DELIVERY_ADDRESS_ERROR, error, errorResponse);
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
function setDeliveryAddressSaga(action) {
    var state, basketId, storedAddressesEnabled, useAddressId, addressObject, koalaOrderJSON, currentDeliveryInstructions, ref, ref1, state1, ref2, ref3, save, ref4, isDeliveryAddressStored, eventDetails, error, state2, deliveryAddress, additionalDetails, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                basketId = (0,checkout/* getIdsFromState */.jw)(state).basketId;
                storedAddressesEnabled = state.app.cmsConfig.webConfig.accounts.stored_addresses;
                useAddressId = storedAddressesEnabled && (0,auth/* userLoggedIn */.nD)() ? true : false;
                addressObject = Object.assign({}, action.address);
                _state.label = 2;
            case 2:
                _state.trys.push([
                    2,
                    18,
                    ,
                    22
                ]);
                koalaOrderJSON = dist/* sdkStorage.basket.get */.fn.basket.get();
                if (!(koalaOrderJSON && koalaOrderJSON.location.id === action.location.id)) return [
                    3,
                    7
                ];
                // Delete address id and stale_id from payload if not relevant for stored addresses
                if (!useAddressId) {
                    /** @TODO unravel type issues with the `id` and `stale_id`. */ delete addressObject.id;
                    delete addressObject.stale_id;
                }
                // Reset conveyance on existing baskets
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.updateBasketFulfillment */.Z.updateBasketFulfillment({
                        address: addressObject,
                        type: v4/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY
                    }))
                ];
            case 3:
                _state.sent();
                if (!basketId) return [
                    3,
                    5
                ];
                currentDeliveryInstructions = addressObject.special_instructions;
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.conveyanceDeliverySet */.Z.conveyanceDeliverySet(currentDeliveryInstructions, addressObject.stale_id))
                ];
            case 4:
                _state.sent();
                _state.label = 5;
            case 5:
                // If basket exists AND the basket is the same location as the new fulfillment, re-update the basket
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.updateBasketFulfillment */.Z.updateBasketFulfillment({
                        address: addressObject,
                        type: v4/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY
                    }))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 7:
                // Else, update redux
                return [
                    4,
                    (0,io_22ea0cf9.Z)(// @ts-expect-error
                    conveyanceMode_actions/* default.setDeliveryAddressSuccess */.Z.setDeliveryAddressSuccess(addressObject, action.location.id))
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 9:
                state1 = _state.sent();
                if ((ref = state1.app.delivery) === null || ref === void 0 ? void 0 : (ref1 = ref.deliveryType) === null || ref1 === void 0 ? void 0 : ref1.type) {
                    ;
                    (0,google/* fireGACommerceAddShippingInfoEvent */.Dk)(state1.app.basket, state1.app.menu.basketMenu, state1.app.promoCode.applied, (ref2 = state1.app.delivery) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.deliveryType) === null || ref3 === void 0 ? void 0 : ref3.type);
                }
                _state.label = 10;
            case 10:
                if (!action.shouldAutoRedirect) return [
                    3,
                    12
                ];
                // Automatically redirect the user to the correct store page.
                return [
                    4,
                    router_default().push(routes/* ROUTES.STORE */.Z6.STORE, "/store/".concat((0,locations/* getLocationId */.By)(action.location, state.app.cmsConfig.webConfig), "/").concat(action.location.label))
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    15
                ];
            case 12:
                return [
                    4,
                    (0,io_22ea0cf9.W)({
                        save: (0,io_22ea0cf9.L)(conveyanceMode_actions/* default.SET_DELIVERY_ADDRESS_CONTINUE */.Z.SET_DELIVERY_ADDRESS_CONTINUE),
                        cancel: (0,io_22ea0cf9.L)(global_actions/* default.TOGGLE_FULFILLMENT_MODAL */.Z.TOGGLE_FULFILLMENT_MODAL)
                    })
                ];
            case 13:
                save = _state.sent().save;
                if (!save) return [
                    3,
                    15
                ];
                isDeliveryAddressStored = !!action.address.id;
                eventDetails = isDeliveryAddressStored ? "Stored address" : "Non-stored address";
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.DELIVERY_ADDRESS_VALIDATED */.AH.DELIVERY_ADDRESS_VALIDATED, {
                    name: (ref4 = action.location) === null || ref4 === void 0 ? void 0 : ref4.label,
                    details: eventDetails
                });
                return [
                    4,
                    router_default().push(routes/* ROUTES.STORE */.Z6.STORE, "/store/".concat((0,locations/* getLocationId */.By)(action.location, state.app.cmsConfig.webConfig), "/").concat(action.location.label))
                ];
            case 14:
                _state.sent();
                _state.label = 15;
            case 15:
                if (!action.revalidate) return [
                    3,
                    17
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: global_actions/* default.DELIVERY_ADDRESS_VALID */.Z.DELIVERY_ADDRESS_VALID
                    })
                ];
            case 16:
                _state.sent();
                _state.label = 17;
            case 17:
                return [
                    3,
                    22
                ];
            case 18:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: conveyanceMode_actions/* default.SET_DELIVERY_ADDRESS_FAILURE */.Z.SET_DELIVERY_ADDRESS_FAILURE
                    })
                ];
            case 19:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 20:
                state2 = _state.sent();
                deliveryAddress = (0,checkout/* assembleDeliveryObjectFromState */.Of)(state2);
                if (deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.id) {
                    additionalDetails = "Stored Address ID: ".concat(deliveryAddress.id);
                }
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, null, error)
                ];
            case 21:
                errorResponse = _state.sent();
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.SET_DELIVERY_ADDRESS_ERROR */.RZ.SET_DELIVERY_ADDRESS_ERROR, error, errorResponse, additionalDetails);
                return [
                    3,
                    22
                ];
            case 22:
                return [
                    2
                ];
        }
    });
}
function setWantedTimeSaga(action) {
    var state, fulfillment, koalaOrderJSON, _address, address, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                fulfillment = state.app.basket.fulfillment;
                _state.label = 2;
            case 2:
                _state.trys.push([
                    2,
                    7,
                    ,
                    9
                ]);
                koalaOrderJSON = dist/* sdkStorage.basket.get */.fn.basket.get();
                if (!(koalaOrderJSON && koalaOrderJSON.location.id === action.locationId)) return [
                    3,
                    6
                ];
                if (!(action.conveyanceType === v4/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY && action.wantedAt)) return [
                    3,
                    4
                ];
                address = (_address = fulfillment.address) !== null && _address !== void 0 ? _address : {};
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.updateBasketFulfillment */.Z.updateBasketFulfillment((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fulfillment), {
                        type: action.conveyanceType,
                        // @ts-expect-error: address will be an object, but typescript doesn't know that
                        address: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, address), {
                            time_wanted: action.wantedAt
                        })
                    })))
                ];
            case 3:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 4:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.updateBasketFulfillment */.Z.updateBasketFulfillment((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fulfillment), {
                        type: action.conveyanceType,
                        time_wanted: action.wantedAt
                    })))
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                return [
                    3,
                    9
                ];
            case 7:
                error = _state.sent();
                console.warn(error);
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, null, error)
                ];
            case 8:
                errorResponse = _state.sent();
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.SET_WANTED_TIME_ERROR */.RZ.SET_WANTED_TIME_ERROR, error, errorResponse);
                return [
                    3,
                    9
                ];
            case 9:
                return [
                    2
                ];
        }
    });
}
function clearDeliveryAddressSaga(action) {
    var koalaOrderJSON, ref, ref1, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    4
                ]);
                koalaOrderJSON = dist/* sdkStorage.basket.get */.fn.basket.get();
                if (!(koalaOrderJSON && koalaOrderJSON.location.id === action.locationId)) return [
                    3,
                    2
                ];
                // If basket exists, ensure this is also reset
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: basket_actions/* default.UPDATE_BASKET_FULFILLMENT */.Z.UPDATE_BASKET_FULFILLMENT,
                        fulfillment: {
                            address: null,
                            type: v4/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP,
                            // @ts-expect-error: guarded time_wanted, and it can be undefined
                            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                            time_wanted: (ref = koalaOrderJSON.fulfillment) === null || ref === void 0 ? void 0 : (ref1 = ref.address) === null || ref1 === void 0 ? void 0 : ref1.time_wanted
                        }
                    })
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                return [
                    3,
                    4
                ];
            case 3:
                error = _state.sent();
                console.log("Error clearing delivery address: ", error);
                return [
                    3,
                    4
                ];
            case 4:
                return [
                    2
                ];
        }
    });
}
function conveyanceSetSaga(action) {
    var client, ref, basketId, basketLocationId, locationId, basketResponse, // we called `setConveyanceMode` in a lot of places, some need to explicitly pass a location id
    // due to the context of where they are displayed (ex: menu availability in the header)
    _locationId, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    10,
                    ,
                    12
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.a4)(checkout/* getIdsFromState */.jw)
                ];
            case 1:
                ref = _state.sent(), basketId = ref.basketId, basketLocationId = ref.locationId;
                return [
                    4,
                    (0,io_22ea0cf9.a4)(function(state) {
                        return state.app.locations.detail.id;
                    })
                ];
            case 2:
                locationId = _state.sent();
                if (!(basketId && basketLocationId)) return [
                    3,
                    6
                ];
                return [
                    4,
                    (0,io_22ea0cf9.O)(// @ts-expect-error ensure that `action.conveyanceDetails` is defined.
                    v4/* setConveyance */.rp, {
                        basketId: basketId,
                        locationId: basketLocationId,
                        type: action.conveyanceType,
                        data: action.conveyanceDetails
                    }, {
                        client: client
                    })
                ];
            case 3:
                basketResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.success */.Z.success(basketResponse))
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                // Update handoff details
                // TODO! - this is bad
                return [
                    4,
                    (0,io_22ea0cf9.Z)(conveyanceMode_actions/* default.handoffDetailsSet */.Z.handoffDetailsSet(constants_global/* API_FOR_CONVEYANCE_TYPES_SWAP */.NX[action.conveyanceType], // @ts-expect-error
                    action.conveyanceDetails))
                ];
            case 7:
                _state.sent();
                // Ensure the local basket wanted at time is valid
                return [
                    4,
                    (0,io_22ea0cf9.Z)(conveyanceMode_actions/* default.setWantedTime */.Z.setWantedTime(action.wantedAt, (_locationId = action.locationId) !== null && _locationId !== void 0 ? _locationId : locationId, (0,time_picker_utils/* getMappedConveyanceType */.et)(action.conveyanceType)))
                ];
            case 8:
                _state.sent();
                // @IMPLEMENTATION-TODO:
                // remove in favor of hooks in `<FeatureAccessor />` after Next upgrade
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.generateFeatureBag */.Z.generateFeatureBag())
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 10:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(conveyanceMode_actions/* default.handleConveyanceFailure */.Z.handleConveyanceFailure(error, action.conveyanceType))
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
function conveyanceDeliverySetSaga(action) {
    var client, state, ref, basketId, locationId, deliveryAddress, basketResponse, ref1, ref2, ref3, ref4, ref5, newDeliveryAddress, basketDeliveryAddress, newBasketDeliveryAddress, _instructions, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    10,
                    ,
                    12
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 2:
                state = _state.sent();
                ref = (0,checkout/* getIdsFromState */.jw)(state), basketId = ref.basketId, locationId = ref.locationId;
                deliveryAddress = (0,checkout/* assembleDeliveryObjectFromState */.Of)(state, action.instructions, action.staleId);
                return [
                    4,
                    (0,io_22ea0cf9.O)(// @ts-expect-error ensure that `deliveryAddress` is defined.
                    v4/* setConveyance */.rp, {
                        basketId: basketId,
                        locationId: locationId,
                        type: constants_events/* API_CONVEYANCE_TYPES.DELIVERY */.tQ.DELIVERY,
                        data: deliveryAddress
                    }, {
                        client: client
                    })
                ];
            case 3:
                basketResponse = _state.sent();
                if (!(deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.stale_id)) return [
                    3,
                    6
                ];
                newDeliveryAddress = Object.assign({}, deliveryAddress, {
                    id: basketResponse === null || basketResponse === void 0 ? void 0 : (ref1 = basketResponse.conveyance_type) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.delivery_address) === null || ref2 === void 0 ? void 0 : ref2.id
                });
                // Now delete the stale ID
                delete newDeliveryAddress.stale_id;
                return [
                    4,
                    (0,io_22ea0cf9.O)(// @ts-expect-error
                    v4/* setConveyance */.rp, {
                        basketId: basketId,
                        locationId: locationId,
                        type: constants_events/* API_CONVEYANCE_TYPES.DELIVERY */.tQ.DELIVERY,
                        data: newDeliveryAddress
                    }, {
                        client: client
                    })
                ];
            case 4:
                // Trigger yet another basket response with the NEW address ID
                basketResponse = _state.sent();
                basketDeliveryAddress = basketResponse === null || basketResponse === void 0 ? void 0 : (ref3 = basketResponse.conveyance_type) === null || ref3 === void 0 ? void 0 : ref3.delivery_address;
                newBasketDeliveryAddress = Object.assign({}, basketDeliveryAddress, {
                    zip_code: basketResponse === null || basketResponse === void 0 ? void 0 : (ref4 = basketResponse.conveyance_type) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.delivery_address) === null || ref5 === void 0 ? void 0 : ref5.zip_code
                });
                // Update basket fulfillment with the new address
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: basket_actions/* default.UPDATE_BASKET_FULFILLMENT */.Z.UPDATE_BASKET_FULFILLMENT,
                        fulfillment: {
                            address: newBasketDeliveryAddress,
                            type: v4/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY
                        }
                    })
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.success */.Z.success(basketResponse))
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 8:
                _state.sent();
                // Update handoff details
                return [
                    4,
                    (0,io_22ea0cf9.Z)(conveyanceMode_actions/* default.handoffDetailsSet */.Z.handoffDetailsSet(v4/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY, {
                        instructions: (_instructions = action.instructions) !== null && _instructions !== void 0 ? _instructions : ""
                    }))
                ];
            case 9:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 10:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(conveyanceMode_actions/* default.handleConveyanceFailure */.Z.handleConveyanceFailure(error, v4/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY))
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
function handleConveyanceFailureSaga(action) {
    var errorResponse, errorMessage, state, deliveryAddress, additionalDetails, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                // Place order in pending state
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 1:
                _state.sent();
                _state.label = 2;
            case 2:
                _state.trys.push([
                    2,
                    6,
                    ,
                    7
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "", action.error)
                ];
            case 3:
                errorResponse = _state.sent();
                errorMessage = errorResponse.message;
                // Curbside setting fails
                if (action.conveyanceType === constants_events/* API_CONVEYANCE_TYPES.CURBSIDE */.tQ.CURBSIDE) {
                    errorMessage = "Oops. There was an issue setting your curbside details. ".concat(errorResponse.message);
                }
                // Show error
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderStatusMessageErrorSet */.Z.orderStatusMessageErrorSet(errorMessage))
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 5:
                state = _state.sent();
                deliveryAddress = (0,checkout/* assembleDeliveryObjectFromState */.Of)(state);
                additionalDetails = "";
                if (deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.id) {
                    additionalDetails = "Stored Address ID: ".concat(deliveryAddress.id);
                }
                // KA error event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.SET_CONVEYANCE_ERROR */.RZ.SET_CONVEYANCE_ERROR, action.error, errorResponse, additionalDetails);
                return [
                    3,
                    7
                ];
            case 6:
                error = _state.sent();
                // KA error event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.ERROR */.AH.ERROR, {
                    name: constants_events/* ERROR_MESSAGES.SET_CONVEYANCE_ERROR_ERROR */.RZ.SET_CONVEYANCE_ERROR_ERROR,
                    details: error.message
                });
                return [
                    3,
                    7
                ];
            case 7:
                return [
                    2
                ];
        }
    });
}
function clearLockedConveyanceModeSaga() {
    var state;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                /**
   * In order to clear a locked in conveyance mode, we need to do several things:
   *
   * 1. Clear out persistent route parameters otherwise they will keep informing the
   *    feature flagging system to keep certain features locked down
   * 2. Reset conveyanceMode to pickup
   * 3. Switch the checkout basket fulfillment to pickup
   * 4. Update the basket fulfillment to pickup in Redux as well as localStorage
   * 5. re-generate the feature bag
   * 6. Finally, clear the route parameters from the URL
   */ return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.clearPersistentParameters */.Z.clearPersistentParameters())
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.L)([
                        global_actions/* default.CLEAR_PERSISTENT_PARAMETERS_SUCCESS */.Z.CLEAR_PERSISTENT_PARAMETERS_SUCCESS
                    ])
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(conveyanceMode_actions/* default.toggleHandoff */.Z.toggleHandoff(v4/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.conveyanceSet */.Z.conveyanceSet())
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(conveyanceMode_actions/* default.conveyanceModeSet */.Z.conveyanceModeSet({
                        type: constants_events/* API_CONVEYANCE_TYPES.PICKUP */.tQ.PICKUP,
                        details: []
                    }))
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.updateBasketFulfillment */.Z.updateBasketFulfillment({
                        type: v4/* CONVEYANCE_TYPES.PICKUP */.P8.PICKUP
                    }))
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.generateFeatureBag */.Z.generateFeatureBag())
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 8:
                state = _state.sent();
                if (!Object.keys(state.app.global.routerStatus.persistentParameters).length) {
                    void router_default().push(routes/* ROUTES.CHECKOUT */.Z6.CHECKOUT);
                }
                return [
                    2
                ];
        }
    });
}
function setDeliveryAddressSuccessSaga() {
    var ref, ref1, state, ref2, ref3;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                if ((ref = state.app.delivery) === null || ref === void 0 ? void 0 : (ref1 = ref.deliveryType) === null || ref1 === void 0 ? void 0 : ref1.type) {
                    ;
                    (0,google/* fireGACommerceAddShippingInfoEvent */.Dk)(state.app.basket, state.app.menu.basketMenu, state.app.promoCode.applied, (ref2 = state.app.delivery) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.deliveryType) === null || ref3 === void 0 ? void 0 : ref3.type);
                }
                return [
                    2
                ];
        }
    });
}
// @IMPLEMENTATION-TODO:
// remove in favor of hooks in `<FeatureAccessor />` after Next upgrade
function handoffTypeToggleSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.generateFeatureBag */.Z.generateFeatureBag())
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function conveyanceMode_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(conveyanceMode_actions/* default.CHECK_DELIVERY_ADDRESS */.Z.CHECK_DELIVERY_ADDRESS, checkDeliveryAddressSaga)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    takeLatest$1(conveyanceMode_actions/* default.SET_DELIVERY_ADDRESS */.Z.SET_DELIVERY_ADDRESS, setDeliveryAddressSaga)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    takeLatest$1(conveyanceMode_actions/* default.CLEAR_DELIVERY_ADDRESS */.Z.CLEAR_DELIVERY_ADDRESS, clearDeliveryAddressSaga)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    takeLatest$1(conveyanceMode_actions/* default.SET_WANTED_TIME */.Z.SET_WANTED_TIME, setWantedTimeSaga)
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    takeLatest$1(conveyanceMode_actions/* default.HANDLE_CONVEYANCE_FAILURE */.Z.HANDLE_CONVEYANCE_FAILURE, handleConveyanceFailureSaga)
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    takeLatest$1(conveyanceMode_actions/* default.RESET_LOCKED_CONVEYANCE_MODE */.Z.RESET_LOCKED_CONVEYANCE_MODE, clearLockedConveyanceModeSaga)
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    takeLatest$1(conveyanceMode_actions/* default.HANDOFF_TYPE_TOGGLE */.Z.HANDOFF_TYPE_TOGGLE, handoffTypeToggleSaga)
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    takeLatest$1(conveyanceMode_actions/* default.CONVEYANCE_MODE_SET */.Z.CONVEYANCE_MODE_SET, conveyanceSetSaga)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    takeLatest$1(orderStatus_actions/* default.CONVEYANCE_DELIVERY_SET */.Z.CONVEYANCE_DELIVERY_SET, conveyanceDeliverySetSaga)
                ];
            case 9:
                _state.sent();
                return [
                    4,
                    takeLatest$1(conveyanceMode_actions/* default.SET_DELIVERY_ADDRESS_SUCCESS */.Z.SET_DELIVERY_ADDRESS_SUCCESS, setDeliveryAddressSuccessSaga)
                ];
            case 10:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

;// CONCATENATED MODULE: ./src/redux/customize/saga.ts











function triggerToastOptionErrorsSaga() {
    var error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    4,
                    ,
                    5
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.Z)(customize_actions/* default.toggleToastOptionsError */.Z.toggleToastOptionsError(true))
                ];
            case 1:
                _state.sent();
                // Hide toast message after 5 seconds
                return [
                    4,
                    (0,io_22ea0cf9.Q)(constants_global/* ERROR_DISPLAY_DURATION.FIVE */.j_.FIVE)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(customize_actions/* default.toggleToastOptionsError */.Z.toggleToastOptionsError(false))
                ];
            case 3:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 4:
                error = _state.sent();
                console.log(error, "Error displaying toast options error");
                return [
                    3,
                    5
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function setCrossSellQuickAddSaga(action) {
    var ref, state, _customize, product, options, quantity, upsellId, canonicalProduct, final, surfaceable_option_groups, productCategory, productCategoryLabel, productCategoryId, basketProduct, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    6,
                    ,
                    8
                ]);
                // Set product in the Customizer, but don't open the PDP modal
                return [
                    4,
                    (0,io_22ea0cf9.Z)(customize_actions/* default.setProduct */.Z.setProduct({
                        product: action.payload.product,
                        menuCategories: action.payload.menuCategories,
                        label: constants_checkout/* PRODUCT_LOCATION_LABELS.CROSS_SELL */.X.CROSS_SELL,
                        upsellId: action.payload.upsellId,
                        open: false
                    }))
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 2:
                state = _state.sent();
                _customize = state.app.customize, product = _customize.product, options = _customize.options, quantity = _customize.quantity, upsellId = _customize.upsellId, canonicalProduct = _customize.canonicalProduct, final = _customize.final;
                surfaceable_option_groups = final.surfaceable_option_groups;
                productCategory = dist/* sdkUtils.findProductCategory */.fH.findProductCategory(/** @TODO ensure that `product` is non-nullable. */ // @ts-expect-error
                product.id, action.payload.menuCategories);
                productCategoryLabel = productCategory === null || productCategory === void 0 ? void 0 : productCategory.name;
                productCategoryId = productCategory === null || productCategory === void 0 ? void 0 : productCategory.global_id;
                basketProduct = {
                    /** @TODO ensure that `product` is non-nullable. */ product: {
                        // @ts-expect-error
                        id: product.id,
                        // @ts-expect-error
                        global_id: product.global_id,
                        // @ts-expect-error
                        name: product.name,
                        cross_sell_id: upsellId || null,
                        // @ts-expect-error
                        cost: canonicalProduct.cost * quantity,
                        category_id: productCategoryId,
                        category_label: productCategoryLabel,
                        filter_tags: product === null || product === void 0 ? void 0 : (ref = product.filter_tags) === null || ref === void 0 ? void 0 : ref.map(function(tag) {
                            return {
                                id: String(tag === null || tag === void 0 ? void 0 : tag.id),
                                label: tag === null || tag === void 0 ? void 0 : tag.label
                            };
                        })
                    },
                    options: options,
                    quantity: quantity,
                    // These fields are not supported for Quick Add - however, they can update this from the sidecart
                    special_instructions: "",
                    recipient: ""
                };
                if (!!surfaceable_option_groups.every(function(optionGroup) {
                    return optionGroup.valid;
                })) return [
                    3,
                    4
                ];
                console.log("in surfaceable", surfaceable_option_groups);
                // If so, open PDP to prompt user to make selections
                return [
                    4,
                    (0,io_22ea0cf9.Z)(customize_actions/* default.setProduct */.Z.setProduct({
                        product: action.payload.product,
                        menuCategories: action.payload.menuCategories,
                        label: constants_checkout/* PRODUCT_LOCATION_LABELS.CROSS_SELL */.X.CROSS_SELL,
                        upsellId: action.payload.upsellId,
                        open: true
                    }))
                ];
            case 3:
                _state.sent();
                return [
                    2
                ];
            case 4:
                // If not, add straight to the basket!
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.addItem */.Z.addItem(// @ts-expect-error
                    basketProduct, constants_checkout/* PRODUCT_LOCATION_LABELS.CROSS_SELL */.X.CROSS_SELL, undefined))
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    8
                ];
            case 6:
                error = _state.sent();
                console.log({
                    error: error
                });
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(messages/* BASKET_ERROR.addItemErrorToastSaga */.Y.addItemErrorToastSaga))
                ];
            case 7:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.ERROR */.AH.ERROR, {
                    name: constants_events/* ERROR_MESSAGES.CROSS_SELL_QUICK_ADD_TOAST_ERROR */.RZ.CROSS_SELL_QUICK_ADD_TOAST_ERROR
                });
                return [
                    3,
                    8
                ];
            case 8:
                return [
                    2
                ];
        }
    });
}
function customize_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(customize_actions/* default.TRIGGER_TOAST_OPTIONS_ERROR */.Z.TRIGGER_TOAST_OPTIONS_ERROR, triggerToastOptionErrorsSaga)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    takeLatest$1(customize_actions/* default.SET_CROSS_SELL_QUICK_ADD */.Z.SET_CROSS_SELL_QUICK_ADD, setCrossSellQuickAddSaga)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

// EXTERNAL MODULE: ./src/utils/errorReporter.ts
var errorReporter = __webpack_require__(19663);
;// CONCATENATED MODULE: ./src/redux/deliveryStatus/saga.ts









function fetchDeliveryStatusByOrderNumberSaga(action) {
    var origin, client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    7
                ]);
                origin = (0,utils/* getOrigin */.P$)(window.location.host);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: origin
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getOrderDeliveryStatus */.GI, action.order_number, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                // Write menu into redux
                return [
                    4,
                    (0,io_22ea0cf9.Z)(deliveryStatus_actions/* deliveryStatusActions.fetchDeliveryStatusByOrderNumberSuccess */._.fetchDeliveryStatusByOrderNumberSuccess(response))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    7
                ];
            case 3:
                error = _state.sent();
                console.error(error);
                return [
                    4,
                    (0,io_22ea0cf9.Z)(deliveryStatus_actions/* deliveryStatusActions.fetchDeliveryStatusByOrderNumberFail */._.fetchDeliveryStatusByOrderNumberFail(error))
                ];
            case 4:
                _state.sent();
                // Error Notification
                errorReporter/* captureException */.Tb(error);
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error fetching order delivery status by external order id", error)
                ];
            case 5:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    7
                ];
            case 7:
                return [
                    2
                ];
        }
    });
}
function deliveryStatus_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(deliveryStatus_actions/* deliveryStatusActionTypes.FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER */.m.FETCH_DELIVERY_STATUS_BY_ORDER_NUMBER, fetchDeliveryStatusByOrderNumberSaga)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

// EXTERNAL MODULE: ./src/utils/features.ts + 1 modules
var features = __webpack_require__(38732);
;// CONCATENATED MODULE: ./src/utils/urls.ts


/**
 * Return a URLObject with a list of provided parameters removed
 *
 * @param {params} array
 *
 * @return {URLObject}
 */ var removeURLParams = function(params) {
    var currentURL = new URL(window.location.href);
    var currentParams = new URLSearchParams(currentURL.search);
    params.forEach(function(param) {
        currentParams.delete(param);
    });
    var url = "".concat(currentURL.pathname, "?").concat(currentParams.toString());
    return {
        data: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, window.history.state), {
            as: url
        }),
        url: url
    };
};
/**
 * Return a boolean of whether the passed in param is in the URL
 *
 * @param {param} string
 *
 * @return {boolean}
 */ var getURLParam = function(url, param) {
    var currentURL = new URL(url);
    var currentParams = new URLSearchParams(currentURL.search);
    return currentParams.get(param) ? true : false;
};

;// CONCATENATED MODULE: ./src/redux/global/saga.ts















function hydratePersistentParametersSaga(action) {
    var sessionStorageData, parameters;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                sessionStorageData = sessionStorage.getItem(constants_global/* KOALA_SESSION_STORAGE_KEYS.PARAMETERS */.iy.PARAMETERS);
                parameters = sessionStorageData ? JSON.parse(sessionStorageData) : (0,global/* derivePersistentURLParameters */.IW)(action.routeParameters);
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.setPersistentParameters */.Z.setPersistentParameters(parameters))
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function setPersistentParametersSaga(action) {
    return (0,tslib_es6.__generator)(this, function(_state) {
        if (Object.keys(action.routeParameters).length > 0) {
            sessionStorage.setItem(constants_global/* KOALA_SESSION_STORAGE_KEYS.PARAMETERS */.iy.PARAMETERS, JSON.stringify(action.routeParameters));
        }
        return [
            2
        ];
    });
}
function clearPersistentParametersSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                sessionStorage.removeItem(constants_global/* KOALA_SESSION_STORAGE_KEYS.PARAMETERS */.iy.PARAMETERS);
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: global_actions/* default.CLEAR_PERSISTENT_PARAMETERS_SUCCESS */.Z.CLEAR_PERSISTENT_PARAMETERS_SUCCESS
                    })
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function generateFeatureBagSaga() {
    var state, newFeatureBag, FeatureHandler;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                newFeatureBag = (0,_object_spread/* default */.Z)({}, state.app.global.featureBag);
                FeatureHandler = new features/* KoalaFeatureHandler */.n(state.app);
                Object.keys(newFeatureBag).forEach(function(featureFlag) {
                    // @ts-expect-error `featureFlag` can't index `newFeatureBag`.
                    newFeatureBag[featureFlag] = FeatureHandler.isFeatureAllowed(featureFlag);
                });
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.updateFeatureBag */.Z.updateFeatureBag(newFeatureBag))
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function updateFeatureBagFlagSaga(action) {
    var state, newFeatureBag, FeatureHandler;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                newFeatureBag = (0,_object_spread/* default */.Z)({}, state.app.global.featureBag);
                FeatureHandler = new features/* KoalaFeatureHandler */.n(state.app);
                newFeatureBag[action.featureFlag] = FeatureHandler.isFeatureAllowed(action.featureFlag);
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.updateFeatureBag */.Z.updateFeatureBag(newFeatureBag))
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function toggleBasketSaga(action) {
    var show, state, basket, basketMenu, navLogo, urlData;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                show = action.show;
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                basket = state.app.basket;
                basketMenu = state.app.menu.basketMenu;
                if (show) {
                    (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.HEADER__VIEW_BASKET */.x.HEADER__VIEW_BASKET);
                    (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.STORE__CART_VIEW */.x.STORE__CART_VIEW);
                    (0,google/* fireGACommerceViewCartEvent */.f1)(basket, basketMenu);
                } else if (!show) {
                    navLogo = document.getElementById("nav-logo");
                    (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.HEADER__CLOSE_BASKET */.x.HEADER__CLOSE_BASKET);
                    if (getURLParam(window.location.href, "openCart")) {
                        urlData = removeURLParams([
                            "openCart"
                        ]);
                        void router_default().replace(urlData.url, "", {
                            shallow: true
                        });
                    }
                    if (navLogo) {
                        navLogo.focus();
                    }
                }
                return [
                    2
                ];
        }
    });
}
function global_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(global_actions/* default.HYDRATE_PERSISTENT_PARAMETERS */.Z.HYDRATE_PERSISTENT_PARAMETERS, hydratePersistentParametersSaga)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    takeLatest$1(global_actions/* default.SET_PERSISTENT_PARAMETERS */.Z.SET_PERSISTENT_PARAMETERS, setPersistentParametersSaga)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    takeLatest$1(global_actions/* default.CLEAR_PERSISTENT_PARAMETERS */.Z.CLEAR_PERSISTENT_PARAMETERS, clearPersistentParametersSaga)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    takeLatest$1([
                        global_actions/* default.GENERATE_FEATURE_BAG */.Z.GENERATE_FEATURE_BAG,
                        global_actions/* default.SET_PERSISTENT_PARAMETERS */.Z.SET_PERSISTENT_PARAMETERS,
                        me_actions/* default.FETCH_ME_PAST_ORDERS_SUCCESS */.Z.FETCH_ME_PAST_ORDERS_SUCCESS,
                        me_actions/* default.CLEAR_ME */.Z.CLEAR_ME,
                        cmsConfig_actions/* default.FETCH_CONFIGS_SUCCESS */.Z.FETCH_CONFIGS_SUCCESS,
                        orderStatus_actions/* default.POST_INITIALIZE_ORDER */.Z.POST_INITIALIZE_ORDER
                    ], generateFeatureBagSaga)
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    takeLatest$1(global_actions/* default.UPDATE_FEATURE_BAG_FLAG */.Z.UPDATE_FEATURE_BAG_FLAG, updateFeatureBagFlagSaga)
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    takeLatest$1(global_actions/* default.TOGGLE_BASKET */.Z.TOGGLE_BASKET, toggleBasketSaga)
                ];
            case 6:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

// EXTERNAL MODULE: ./node_modules/lodash/orderBy.js
var orderBy = __webpack_require__(75472);
var orderBy_default = /*#__PURE__*/__webpack_require__.n(orderBy);
// EXTERNAL MODULE: ./src/services/locations.service.ts
var locations_service = __webpack_require__(19658);
;// CONCATENATED MODULE: ./src/redux/locations/saga.ts




















function fetchAllLocationsSaga(action) {
    var ref, client, queryArgs, response, locations, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    4,
                    ,
                    6
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                queryArgs = {
                    paginate: false
                };
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* listLocations */.Jp, action.magicBox ? (0,_object_spread/* default */.Z)({}, action.magicBox, queryArgs) : queryArgs, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                locations = action.results ? action.results.concat(response.data) : response.data;
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.fetchAllLocationsSuccess */.b.fetchAllLocationsSuccess(locations))
                ];
            case 2:
                _state.sent();
                // Set default active location index
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.setActiveLocation */.b.setActiveLocation((ref = locations[0]) === null || ref === void 0 ? void 0 : ref.id))
                ];
            case 3:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 4:
                error = _state.sent();
                console.log(error);
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.searchLocationsFail */.b.searchLocationsFail())
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 6:
                return [
                    2
                ];
        }
    });
}
function fetchLocationsSaga(action) {
    var ref, client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    7,
                    ,
                    11
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                if (!(action.magicBox.page > 1)) return [
                    3,
                    3
                ];
                /** @TODO ensure that `magicBox` is defined. */ // @ts-expect-error
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.fetchMoreLocations */.b.fetchMoreLocations(action.magicBox))
                ];
            case 1:
                _state.sent();
                // Stop locations loading
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.searchLocationsFail */.b.searchLocationsFail())
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
            case 3:
                return [
                    4,
                    (0,io_22ea0cf9.O)(/** @TODO ensure that `magicBox` is defined. */ // @ts-expect-error
                    v4/* listLocations */.Jp, action.magicBox, {
                        client: client
                    })
                ];
            case 4:
                response = _state.sent();
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.fetchLocationsSuccess */.b.fetchLocationsSuccess(response.data, response.meta, action.params))
                ];
            case 5:
                _state.sent();
                // Set default active location index
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.setActiveLocation */.b.setActiveLocation((ref = response.data[0]) === null || ref === void 0 ? void 0 : ref.id))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    11
                ];
            case 7:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.searchLocationsFail */.b.searchLocationsFail())
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, null, error)
                ];
            case 9:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 10:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_LOCATIONS_FAILURE */.RZ.FETCH_LOCATIONS_FAILURE, error, errorResponse);
                return [
                    3,
                    11
                ];
            case 11:
                return [
                    2
                ];
        }
    });
}
function fetchMoreLocationsSaga(action) {
    var client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    7
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(/** @TODO ensure that `magicBox` is defined. */ // @ts-expect-error
                    v4/* listLocations */.Jp, action.magicBox, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.fetchMoreLocationsSuccess */.b.fetchMoreLocationsSuccess(response.data, response.meta, action.params))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    7
                ];
            case 3:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.searchLocationsFail */.b.searchLocationsFail())
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, null, error)
                ];
            case 5:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 6:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_MORE_LOCATIONS_FAILURE */.RZ.FETCH_MORE_LOCATIONS_FAILURE, error, errorResponse);
                return [
                    3,
                    7
                ];
            case 7:
                return [
                    2
                ];
        }
    });
}
function searchLocationsSaga(action) {
    var ref, ref1, ref2, ref3, client, search, ref4, response, sortedLocations, ref5, ref6, ref7, ref8, inputtedAddress, isZip, details, expandedParams, error, errorResponse, errorResponse1;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    7,
                    ,
                    15
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                search = {};
                if ((ref = action.params) === null || ref === void 0 ? void 0 : ref.address) {
                    search = {
                        address: action.params.address
                    };
                } else if (((ref1 = action.params) === null || ref1 === void 0 ? void 0 : ref1.latitude) && ((ref2 = action.params) === null || ref2 === void 0 ? void 0 : ref2.longitude)) {
                    search = {
                        latitude: action.params.latitude,
                        longitude: action.params.longitude
                    };
                } else {}
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* listLocations */.Jp, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, action.magicBox), {
                        search: search,
                        distance: (ref4 = action === null || action === void 0 ? void 0 : (ref3 = action.params) === null || ref3 === void 0 ? void 0 : ref3.distance) !== null && ref4 !== void 0 ? ref4 : 10
                    }), {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                sortedLocations = orderBy_default()(response.data, "distance_miles", "asc");
                if (!(response.data.length || action.previousAction)) return [
                    3,
                    4
                ];
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.searchLocationsSuccess */.b.searchLocationsSuccess(sortedLocations, response.meta, action.params))
                ];
            case 2:
                _state.sent();
                // Set default active location index
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.setActiveLocation */.b.setActiveLocation((ref5 = response.data[0]) === null || ref5 === void 0 ? void 0 : ref5.id))
                ];
            case 3:
                _state.sent();
                inputtedAddress = (ref8 = (ref6 = action.params) === null || ref6 === void 0 ? void 0 : ref6.address) !== null && ref8 !== void 0 ? ref8 : "";
                isZip = (0,locations/* isValidZip */.h9)(inputtedAddress);
                details = isZip ? "zip_code; ".concat(sortedLocations.length) : sortedLocations === null || sortedLocations === void 0 ? void 0 : (ref7 = sortedLocations.length) === null || ref7 === void 0 ? void 0 : ref7.toString();
                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.LOCATIONS__SEARCH_LOCATIONS */.x.LOCATIONS__SEARCH_LOCATIONS, {
                    name: action.conveyanceType,
                    details: details
                });
                return [
                    3,
                    6
                ];
            case 4:
                expandedParams = Object.assign({}, action.params, {
                    distance: 25
                });
                return [
                    4,
                    (0,io_22ea0cf9.Z)(/** @TODO ensure that `magicBox` is defined. */ // @ts-expect-error
                    locations_actions/* locationsActions.searchLocations */.b.searchLocations(action.magicBox, expandedParams, action.type))
                ];
            case 5:
                _state.sent();
                _state.label = 6;
            case 6:
                return [
                    3,
                    15
                ];
            case 7:
                error = _state.sent();
                if (!(error.status === 404)) return [
                    3,
                    10
                ];
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, null, error)
                ];
            case 8:
                errorResponse = _state.sent();
                // Error Notification
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast("Oops. Please enter a valid city, zip or address."))
                ];
            case 9:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.INVALID_ZIP_ERROR */.RZ.INVALID_ZIP_ERROR, error, errorResponse);
                return [
                    3,
                    13
                ];
            case 10:
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "Oops. Search locations had a problem.", error)
                ];
            case 11:
                errorResponse1 = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse1.message, true))
                ];
            case 12:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.SEARCH_LOCATION_ERROR */.RZ.SEARCH_LOCATION_ERROR, error, errorResponse1);
                _state.label = 13;
            case 13:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.searchLocationsFail */.b.searchLocationsFail())
                ];
            case 14:
                _state.sent();
                return [
                    3,
                    15
                ];
            case 15:
                return [
                    2
                ];
        }
    });
}
function fetchLocationSaga(action) {
    var client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    10
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(/** @TODO ensure that `id` is defined. */ // @ts-expect-error
                    locations_service/* fetchLocation */.Kx, {
                        id: action.id,
                        lastUpdatedAt: action.lastUpdatedAt
                    }, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.fetchLocationSuccess */.b.fetchLocationSuccess(response.data))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 3:
                error = _state.sent();
                if (!((error === null || error === void 0 ? void 0 : error.status) === 304)) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.fetchLocationNotModified */.b.fetchLocationNotModified())
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 5:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.searchLocationsFail */.b.searchLocationsFail())
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "Oops. Fetch location had a problem.", error)
                ];
            case 7:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 8:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_LOCATION_ERROR */.RZ.FETCH_LOCATION_ERROR, error, errorResponse);
                _state.label = 9;
            case 9:
                return [
                    3,
                    10
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function hydrateLocationSaga(action) {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: locations_actions/* locationActionTypes.LOCATION_SUCCESS */.N.LOCATION_SUCCESS,
                        detail: action.location
                    })
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function refreshBasketLocationSaga(action) {
    var client, response, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    4
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(/** @TODO ensure that `id` is defined. */ // @ts-expect-error
                    locations_service/* fetchLocation */.Kx, {
                        id: action.id
                    }, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.rehydrateLocalStorageLocation */.Z.rehydrateLocalStorageLocation(response.data))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    4
                ];
            case 3:
                error = _state.sent();
                console.log("Rehydrating local storage location failed");
                return [
                    3,
                    4
                ];
            case 4:
                return [
                    2
                ];
        }
    });
}
function searchDeliveryCoverageSaga(action) {
    var client, response, location, ref, ref1, isDeliveryAddressStored, eventDetails, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    5,
                    ,
                    11
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(/** @TODO ensure that `address` is defined. */ // @ts-expect-error
                    v4/* getDeliveryCoverage */.Zm, action.address, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                location = response.data;
                if (!location) return [
                    3,
                    4
                ];
                isDeliveryAddressStored = !!((ref = action.address) === null || ref === void 0 ? void 0 : ref.id);
                eventDetails = isDeliveryAddressStored ? "Stored address" : "Non-stored address";
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.DELIVERY_ADDRESS_VALIDATED */.AH.DELIVERY_ADDRESS_VALIDATED, {
                    name: (ref1 = action.location) === null || ref1 === void 0 ? void 0 : ref1.label,
                    details: eventDetails
                });
                // Set delivery address on redux and then redirect to the store page.
                return [
                    4,
                    (0,io_22ea0cf9.Z)(conveyanceMode_actions/* default.setDeliveryAddress */.Z.setDeliveryAddress(/** @TODO ensure that `address` is defined. */ // @ts-expect-error
                    action.address, location, false, true))
                ];
            case 2:
                _state.sent();
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.searchDeliveryCoverageSuccess */.b.searchDeliveryCoverageSuccess())
                ];
            case 3:
                _state.sent();
                // KA event
                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.LOCATIONS__SEARCH_LOCATIONS */.x.LOCATIONS__SEARCH_LOCATIONS, {
                    name: dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY
                });
                _state.label = 4;
            case 4:
                return [
                    3,
                    11
                ];
            case 5:
                error = _state.sent();
                // Failure
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.searchDeliveryCoverageFail */.b.searchDeliveryCoverageFail())
                ];
            case 6:
                _state.sent();
                if (!(error.status === 404)) return [
                    3,
                    8
                ];
                // Error Message
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.searchDeliveryCoverageNoResults */.b.searchDeliveryCoverageNoResults())
                ];
            case 7:
                _state.sent();
                // KA event
                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.LOCATIONS__LOCATION_SEARCH_NOT_FOUND */.x.LOCATIONS__LOCATION_SEARCH_NOT_FOUND, {
                    name: dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY
                });
                return [
                    3,
                    10
                ];
            case 8:
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, null, error)
                ];
            case 9:
                errorResponse = _state.sent();
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.SEARCH_DELIVERY_COVERAGE_ERROR */.RZ.SEARCH_DELIVERY_COVERAGE_ERROR, error, errorResponse);
                _state.label = 10;
            case 10:
                return [
                    3,
                    11
                ];
            case 11:
                return [
                    2
                ];
        }
    });
}
function locations_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(locations_actions/* locationActionTypes.FETCH_LOCATIONS */.N.FETCH_LOCATIONS, fetchLocationsSaga)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    takeLatest$1(locations_actions/* locationActionTypes.FETCH_ALL_LOCATIONS */.N.FETCH_ALL_LOCATIONS, fetchAllLocationsSaga)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    takeLatest$1(locations_actions/* locationActionTypes.FETCH_LOCATION */.N.FETCH_LOCATION, fetchLocationSaga)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    takeLatest$1(locations_actions/* locationActionTypes.FETCH_LOCATION_IF_MODIFIED */.N.FETCH_LOCATION_IF_MODIFIED, fetchLocationSaga)
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    takeLatest$1(locations_actions/* locationActionTypes.HYDRATE_LOCATION */.N.HYDRATE_LOCATION, hydrateLocationSaga)
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    takeLatest$1(locations_actions/* locationActionTypes.SEARCH_LOCATIONS */.N.SEARCH_LOCATIONS, searchLocationsSaga)
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    takeLatest$1(locations_actions/* locationActionTypes.FETCH_MORE_LOCATIONS */.N.FETCH_MORE_LOCATIONS, fetchMoreLocationsSaga)
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    takeLatest$1(locations_actions/* locationActionTypes.REFRESH_BASKET_LOCATION */.N.REFRESH_BASKET_LOCATION, refreshBasketLocationSaga)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    takeLatest$1(locations_actions/* locationActionTypes.SEARCH_DELIVERY_COVERAGE */.N.SEARCH_DELIVERY_COVERAGE, searchDeliveryCoverageSaga)
                ];
            case 9:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

// EXTERNAL MODULE: ./src/utils/orders.ts
var orders = __webpack_require__(40274);
// EXTERNAL MODULE: ./src/utils/stringHelpers.ts
var stringHelpers = __webpack_require__(60738);
;// CONCATENATED MODULE: ./src/redux/me/saga.ts




















function fetchMeSaga() {
    var origin, client, response, state, reordersEnabled, androidReordersEnabled, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    11,
                    ,
                    13
                ]);
                origin = (0,utils/* getOrigin */.P$)(window.location.host);
                if (!!(0,v4/* validateLoyaltyToken */.XA)(origin)) return [
                    3,
                    2
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.ME_STOP_LOADING */.Z.ME_STOP_LOADING
                    })
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
            case 2:
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: origin
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getUser */.PR, {
                        client: client
                    })
                ];
            case 3:
                response = _state.sent();
                if (!(response.data === undefined)) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.ME_STOP_LOADING */.Z.ME_STOP_LOADING
                    })
                ];
            case 4:
                _state.sent();
                return [
                    2
                ];
            case 5:
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 6:
                state = _state.sent();
                reordersEnabled = state.app.cmsConfig.webConfig.accounts.reorders;
                androidReordersEnabled = state.app.cmsConfig.webConfig.android_features.reorders;
                return [
                    4,
                    (0,io_22ea0cf9.$)([
                        (0,io_22ea0cf9.Z)({
                            type: me_actions/* default.FETCH_LOYALTY_STATE */.Z.FETCH_LOYALTY_STATE
                        }),
                        (0,io_22ea0cf9.Z)({
                            type: me_actions/* default.FETCH_MESSAGES */.Z.FETCH_MESSAGES
                        }),
                        (0,io_22ea0cf9.Z)({
                            type: me_actions/* default.FETCH_REDEEMABLES */.Z.FETCH_REDEEMABLES
                        }),
                        (0,io_22ea0cf9.Z)({
                            type: me_actions/* default.FETCH_OFFERS */.Z.FETCH_OFFERS
                        })
                    ])
                ];
            case 7:
                _state.sent();
                if (!(reordersEnabled || androidReordersEnabled)) return [
                    3,
                    9
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.FETCH_ME_PAST_ORDERS */.Z.FETCH_ME_PAST_ORDERS
                    })
                ];
            case 8:
                _state.sent();
                _state.label = 9;
            case 9:
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.ME_SUCCESS */.Z.ME_SUCCESS,
                        data: response.data
                    })
                ];
            case 10:
                _state.sent();
                // // Set customer data on our Koala Analytics class
                if (true) {
                    window.KoalaAnalytics.setCustomerData(response.data);
                }
                return [
                    3,
                    13
                ];
            case 11:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.ME_FAIL */.Z.ME_FAIL
                    })
                ];
            case 12:
                _state.sent();
                return [
                    3,
                    13
                ];
            case 13:
                return [
                    2
                ];
        }
    });
}
function fetchMeFavoriteLocationsSaga() {
    var ref, client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    4,
                    ,
                    8
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getFavoriteLocations */.j4, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.fetchMeFavoriteLocationsSuccess */.Z.fetchMeFavoriteLocationsSuccess(response.data))
                ];
            case 2:
                _state.sent();
                // Set default active location index
                return [
                    4,
                    (0,io_22ea0cf9.Z)(locations_actions/* locationsActions.setActiveLocation */.b.setActiveLocation(((ref = response.data) === null || ref === void 0 ? void 0 : ref[0]) ? response.data[0].id : 0))
                ];
            case 3:
                _state.sent();
                return [
                    3,
                    8
                ];
            case 4:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.ME_FAIL */.Z.ME_FAIL
                    })
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error fetching your favorite locations.", error)
                ];
            case 6:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 7:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_FAVORITE_LOCATIONS_ERROR */.RZ.FETCH_FAVORITE_LOCATIONS_ERROR, error, errorResponse);
                return [
                    3,
                    8
                ];
            case 8:
                return [
                    2
                ];
        }
    });
}
function updateMeSaga(action) {
    var updatedParams, client, error, ref, errorResponse, errorMessage, errorMessagesArray;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                updatedParams = Object.assign({}, action.params);
                Object.keys(updatedParams).forEach(// @ts-expect-error `key` can't index `LoyaltyUserUpdateInfo`.
                function(key) {
                    return updatedParams[key] === null && delete updatedParams[key];
                });
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    6,
                    ,
                    10
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* updateMe */.DO, updatedParams, {
                        client: client
                    })
                ];
            case 2:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.USER_UPDATE */.AH.USER_UPDATE);
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.updateMeSuccess */.Z.updateMeSuccess())
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.fetchMe */.Z.fetchMe())
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayToast */.Z.displayToast("Your profile was successfully updated!"))
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    10
                ];
            case 6:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error updating your profile.", error)
                ];
            case 7:
                errorResponse = _state.sent();
                errorMessage = errorResponse.message;
                if ((errorResponse === null || errorResponse === void 0 ? void 0 : (ref = errorResponse.error) === null || ref === void 0 ? void 0 : ref.error) === "bad_request") {
                    if (errorResponse.error.error_data && errorResponse.error.error_data.failures) {
                        errorMessagesArray = Object.values(errorResponse.error.error_data.failures);
                        errorMessage += "<br/>" + errorMessagesArray.join(", ");
                    }
                }
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.updateMeFail */.Z.updateMeFail())
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorMessage))
                ];
            case 9:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.UPDATE_ME_FAILURE */.RZ.UPDATE_ME_FAILURE, error, errorResponse);
                return [
                    3,
                    10
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function appendUserPhoneSaga(action) {
    var ref, client, state, ref1, basketId, locationId, organization, fulfillmentType, deliveryAddress, response, error, ref2, errorResponse, errorEvent;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    7,
                    ,
                    10
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                ref1 = (0,checkout/* getIdsFromState */.jw)(state), basketId = ref1.basketId, locationId = ref1.locationId;
                organization = state.app.organization;
                fulfillmentType = (0,utils_basket/* determineBasketFulfillment */.Pp)((ref = state.app.basket.fulfillment) === null || ref === void 0 ? void 0 : ref.address);
                if (!organization.organization.loyalty_driver_id) return [
                    3,
                    6
                ];
                // Silently attempt to update the user
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* updateMe */.DO, {
                        phone: action.phone
                    }, {
                        client: client
                    })
                ];
            case 2:
                _state.sent();
                if (!(fulfillmentType === v4/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY)) return [
                    3,
                    5
                ];
                deliveryAddress = (0,checkout/* assembleDeliveryObjectFromState */.Of)(state);
                return [
                    4,
                    (0,io_22ea0cf9.O)(// @ts-expect-error
                    v4/* setConveyance */.rp, {
                        basketId: basketId,
                        locationId: locationId,
                        type: constants_events/* API_CONVEYANCE_TYPES.DELIVERY */.tQ.DELIVERY,
                        data: deliveryAddress
                    }, {
                        client: client
                    })
                ];
            case 3:
                response = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* validateBasket */.J5, {
                        basketId: response.id,
                        locationId: locationId
                    }, {
                        client: client
                    })
                ];
            case 4:
                _state.sent();
                _state.label = 5;
            case 5:
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.LOG */.AH.LOG, {
                    name: constants_events/* LOG_EVENTS.USER_PHONE_ADDED */.yX.USER_PHONE_ADDED
                });
                _state.label = 6;
            case 6:
                return [
                    3,
                    10
                ];
            case 7:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, null, error)
                ];
            case 8:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.initializeOrderReconciliation */.Z.initializeOrderReconciliation(errorResponse.message))
                ];
            case 9:
                _state.sent();
                errorEvent = (errorResponse === null || errorResponse === void 0 ? void 0 : (ref2 = errorResponse.error) === null || ref2 === void 0 ? void 0 : ref2.error) === "unable_to_update_user" ? constants_events/* ERROR_MESSAGES.ADD_USER_PHONE_ERROR */.RZ.ADD_USER_PHONE_ERROR : constants_events/* ERROR_MESSAGES.INIT_CHECKOUT_UNHANDLED_CONVEYANCE_FAILURE */.RZ.INIT_CHECKOUT_UNHANDLED_CONVEYANCE_FAILURE;
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(errorEvent, error, errorResponse);
                return [
                    3,
                    10
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
function fetchMeFavoriteOrdersSaga() {
    var client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    6
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* favoriteOrders */.ML, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.fetchMeFavoriteOrdersSuccess */.Z.fetchMeFavoriteOrdersSuccess(response.data))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 3:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error fetching your favorite orders.", error)
                ];
            case 4:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 5:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_FAVORITE_ORDERS_ERROR */.RZ.FETCH_FAVORITE_ORDERS_ERROR, error, errorResponse);
                return [
                    3,
                    6
                ];
            case 6:
                return [
                    2
                ];
        }
    });
}
function fetchMePastOrdersSaga() {
    var client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    6
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* pastOrders */.Hd, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.fetchMePastOrdersSuccess */.Z.fetchMePastOrdersSuccess(response.data))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 3:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error fetching your order history.", error)
                ];
            case 4:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 5:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_ORDER_HISTORY_ERROR */.RZ.FETCH_ORDER_HISTORY_ERROR, error, errorResponse);
                return [
                    3,
                    6
                ];
            case 6:
                return [
                    2
                ];
        }
    });
}
function fetchMeCreditCardsSaga(action) {
    var origin, client, savedCards, savedCreditCards, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    6
                ]);
                origin = (0,utils/* getOrigin */.P$)(window.location.host);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: origin
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getSavedCards */.Gu, action.basketId, {
                        client: client
                    })
                ];
            case 1:
                savedCards = _state.sent();
                savedCreditCards = savedCards.filter(function(card) {
                    return card.type === "creditcard";
                });
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.fetchMeCreditCardsSuccess */.Z.fetchMeCreditCardsSuccess(savedCreditCards))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 3:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.fetchMeCreditCardsFail */.Z.fetchMeCreditCardsFail())
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error fetching your payment information.", error)
                ];
            case 5:
                errorResponse = _state.sent();
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_PAYMENT_INFORMATION_ERROR */.RZ.FETCH_PAYMENT_INFORMATION_ERROR, error, errorResponse);
                return [
                    3,
                    6
                ];
            case 6:
                return [
                    2
                ];
        }
    });
}
function fetchAddressesSaga() {
    var client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    5
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getStoredAddresses */.I8, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.FETCH_ADDRESSES_SUCCESS */.Z.FETCH_ADDRESSES_SUCCESS,
                        myAddresses: response.data
                    })
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 3:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error fetching your addresses.", error)
                ];
            case 4:
                errorResponse = _state.sent();
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_STORED_ADDRESSES_ERROR */.RZ.FETCH_STORED_ADDRESSES_ERROR, error, errorResponse);
                return [
                    3,
                    5
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function deleteAddressSaga(action) {
    var client, state, strings, successString, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    6,
                    ,
                    9
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.toggleStoredAddressesMenu */.Z.toggleStoredAddressesMenu(false))
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* deleteStoredAddress */.r6, action.id, {
                        client: client
                    })
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.FETCH_ADDRESSES */.Z.FETCH_ADDRESSES
                    })
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 4:
                state = _state.sent();
                strings = state.app.cmsConfig.strings;
                successString = (0,stringHelpers/* safelyGetString */.bc)(strings, "account.addresses_delete_success_message");
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayToast */.Z.displayToast(successString))
                ];
            case 5:
                _state.sent();
                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.ACCOUNT__STORED_ADDRESS_DELETED */.x.ACCOUNT__STORED_ADDRESS_DELETED, {
                    name: action.id.toString()
                });
                return [
                    3,
                    9
                ];
            case 6:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error deleting your address. Please try again.", error)
                ];
            case 7:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 8:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.DELETE_STORED_ADDRESS_ERROR */.RZ.DELETE_STORED_ADDRESS_ERROR, error, errorResponse);
                return [
                    3,
                    9
                ];
            case 9:
                return [
                    2
                ];
        }
    });
}
function defaultAddressSaga(action) {
    var client, state, strings, successString, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    6,
                    ,
                    9
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.toggleStoredAddressesMenu */.Z.toggleStoredAddressesMenu(false))
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* defaultStoredAddress */.eC, action.id, {
                        client: client
                    })
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.FETCH_ADDRESSES */.Z.FETCH_ADDRESSES
                    })
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 4:
                state = _state.sent();
                strings = state.app.cmsConfig.strings;
                successString = (0,stringHelpers/* safelyGetString */.bc)(strings, "account.addresses_set_default_success_message");
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayToast */.Z.displayToast(successString))
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 6:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error setting your default address. Please try again.", error)
                ];
            case 7:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 8:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.SET_DEFAULT_STORED_ADDRESS_ERROR */.RZ.SET_DEFAULT_STORED_ADDRESS_ERROR, error, errorResponse);
                return [
                    3,
                    9
                ];
            case 9:
                return [
                    2
                ];
        }
    });
}
function fetchAllLocationsCreditCardsSaga(action) {
    var pastOrders, origin, client, locationBaskets, locationsCreditCards, foundCards, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, order, key, savedCards, locationCreditCards, err, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    11,
                    ,
                    14
                ]);
                pastOrders = action.pastOrders.slice(0);
                origin = (0,utils/* getOrigin */.P$)(window.location.host);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: origin
                });
                locationBaskets = {};
                locationsCreditCards = [];
                foundCards = [];
                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    7,
                    8,
                    9
                ]);
                _iterator = pastOrders[Symbol.iterator]();
                _state.label = 2;
            case 2:
                if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                    3,
                    6
                ];
                order = _step.value;
                key = "basket_".concat(order.store_location_id);
                if (!!locationBaskets[key]) return [
                    3,
                    4
                ];
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getSavedCards */.Gu, // @ts-expect-error order_data is mistyped.
                    order.order_data.basket.id, {
                        client: client
                    })
                ];
            case 3:
                savedCards = _state.sent();
                // @ts-expect-error
                locationBaskets[key] = order.order_data.basket.id;
                // If the location has cards
                if (savedCards.length) {
                    locationCreditCards = {
                        // @ts-expect-error
                        locationLabel: order.store_location.label,
                        // @ts-expect-error
                        basketId: order.order_data.basket.id,
                        savedCards: savedCards.filter(function(card) {
                            // Only add creditcard type that hasn't been found yet.
                            if (card.type === "creditcard") {
                                if (foundCards.includes(card.id)) {
                                    return false;
                                }
                                foundCards.push(card.id);
                                return true;
                            }
                        })
                    };
                    // If after filtering there's still cards for the location.
                    if (locationCreditCards.savedCards.length) {
                        locationsCreditCards.push(locationCreditCards);
                    }
                }
                _state.label = 4;
            case 4:
                // One basket id is enough now.
                return [
                    3,
                    6
                ];
            case 5:
                _iteratorNormalCompletion = true;
                return [
                    3,
                    2
                ];
            case 6:
                return [
                    3,
                    9
                ];
            case 7:
                err = _state.sent();
                _didIteratorError = true;
                _iteratorError = err;
                return [
                    3,
                    9
                ];
            case 8:
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
                return [
                    7
                ];
            case 9:
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.fetchAllLocationsCreditCardsSuccess */.Z.fetchAllLocationsCreditCardsSuccess(locationsCreditCards))
                ];
            case 10:
                _state.sent();
                return [
                    3,
                    14
                ];
            case 11:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error fetching your payment information.", error)
                ];
            case 12:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 13:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_ALL_LOCATIONS_CC_ERROR */.RZ.FETCH_ALL_LOCATIONS_CC_ERROR, error, errorResponse);
                return [
                    3,
                    14
                ];
            case 14:
                return [
                    2
                ];
        }
    });
}
function fetchMeOrderDetailsSaga(action) {
    var response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    6
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.O)(orders/* fetchOrderDetails */.gP, action.id, action.pastOrders)
                ];
            case 1:
                response = _state.sent();
                // @ts-expect-error
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.fetchMeOrderDetailsSuccess */.Z.fetchMeOrderDetailsSuccess(response))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 3:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error fetching your order details.", error)
                ];
            case 4:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 5:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_ORDER_DETAILS_ERROR */.RZ.FETCH_ORDER_DETAILS_ERROR, error, errorResponse);
                return [
                    3,
                    6
                ];
            case 6:
                return [
                    2
                ];
        }
    });
}
function deleteMeCreditCardSaga(action) {
    var state, basketId, origin, client, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    5,
                    ,
                    9
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                basketId = (0,checkout/* getIdsFromState */.jw)(state).basketId;
                origin = (0,utils/* getOrigin */.P$)(window.location.host);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: origin
                });
                // Delete Card
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* removeSavedCard */.jG, action.id, {
                        client: client
                    })
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.deleteMeCreditCardSuccess */.Z.deleteMeCreditCardSuccess())
                ];
            case 3:
                _state.sent();
                // Refetch cards
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.fetchMeCreditCards */.Z.fetchMeCreditCards(basketId))
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 5:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.deleteMeCreditCardFail */.Z.deleteMeCreditCardFail())
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error removing this credit card.", error)
                ];
            case 7:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 8:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.DELETE_CREDIT_CARD_ERROR */.RZ.DELETE_CREDIT_CARD_ERROR, error, errorResponse);
                return [
                    3,
                    9
                ];
            case 9:
                return [
                    2
                ];
        }
    });
}
function deleteFavoriteLocationSaga(action) {
    var client, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    4,
                    ,
                    8
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* deleteFavoriteLocation */.ml, action.id, {
                        client: client
                    })
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.deleteMeFavoriteLocationSuccess */.Z.deleteMeFavoriteLocationSuccess())
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.fetchMeFavoriteLocations */.Z.fetchMeFavoriteLocations())
                ];
            case 3:
                _state.sent();
                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.ACCOUNT__REMOVE_FAVORITE_LOCATION */.x.ACCOUNT__REMOVE_FAVORITE_LOCATION, {
                    name: action.label,
                    // @ts-expect-error
                    details: action.id
                });
                return [
                    3,
                    8
                ];
            case 4:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.deleteMeFavoriteLocationFail */.Z.deleteMeFavoriteLocationFail())
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error unfavoriting this location.", error)
                ];
            case 6:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 7:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.UNFAVORITE_LOCATION_ERROR */.RZ.UNFAVORITE_LOCATION_ERROR, error, errorResponse);
                return [
                    3,
                    8
                ];
            case 8:
                return [
                    2
                ];
        }
    });
}
function addFavoriteLocationSaga(action) {
    var client, state, locations, locationLabel, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    4,
                    ,
                    7
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* saveFavoriteLocation */.nB, action.id, {
                        client: client
                    })
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(fetchMeFavoriteLocationsSaga)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 3:
                state = _state.sent();
                locations = state.app.locations.list;
                locationLabel = locations.find(function(location) {
                    return location.id === action.id;
                }).label;
                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.ACCOUNT__ADD_FAVORITE_LOCATION */.x.ACCOUNT__ADD_FAVORITE_LOCATION, {
                    name: locationLabel,
                    // @ts-expect-error
                    details: action.id
                });
                return [
                    3,
                    7
                ];
            case 4:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error favoriting this location.", error)
                ];
            case 5:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 6:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FAVORITE_LOCATION_ERROR */.RZ.FAVORITE_LOCATION_ERROR, error, errorResponse);
                return [
                    3,
                    7
                ];
            case 7:
                return [
                    2
                ];
        }
    });
}
function deleteFavoriteOrderSaga(action) {
    var client, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    5,
                    ,
                    9
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* favoritesDelete */.vJ, action.id, {
                        client: client
                    })
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.deleteMeFavoriteOrderSuccess */.Z.deleteMeFavoriteOrderSuccess())
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.fetchMeFavoriteOrders */.Z.fetchMeFavoriteOrders())
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayToast */.Z.displayToast("This order was successfully removed from your favorites!"))
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 5:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(me_actions/* default.deleteMeFavoriteOrderFail */.Z.deleteMeFavoriteOrderFail())
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error unfavoriting this order.", error)
                ];
            case 7:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 8:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.UNFAVORITE_ORDER_ERROR */.RZ.UNFAVORITE_ORDER_ERROR, error, errorResponse);
                return [
                    3,
                    9
                ];
            case 9:
                return [
                    2
                ];
        }
    });
}
function addFavoriteOrderSaga(action) {
    var client, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    6
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* favoritesSave */.WY, action.id, {
                        client: client
                    })
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(fetchMeFavoriteOrdersSaga)
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 3:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error favoriting this order.", error)
                ];
            case 4:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 5:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FAVORITE_ORDER_ERROR */.RZ.FAVORITE_ORDER_ERROR, error, errorResponse);
                return [
                    3,
                    6
                ];
            case 6:
                return [
                    2
                ];
        }
    });
}
function fetchOffersSaga() {
    var loyaltyDriverId, loyaltyFeatureFlags, client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 1:
                loyaltyDriverId = _state.sent().loyaltyDriverId;
                if (!loyaltyDriverId) {
                    return [
                        2
                    ];
                }
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 2:
                loyaltyFeatureFlags = _state.sent().loyaltyFeatureFlags;
                if (!(loyaltyFeatureFlags === null || loyaltyFeatureFlags === void 0 ? void 0 : loyaltyFeatureFlags[loyalty/* LOYALTY_FEATURES.INDEX_MY_REWARDS */.lw.INDEX_MY_REWARDS])) {
                    return [
                        2
                    ];
                }
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    6,
                    ,
                    9
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getRewards */.rl, {
                        client: client
                    })
                ];
            case 4:
                response = _state.sent();
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.FETCH_OFFERS_SUCCESS */.Z.FETCH_OFFERS_SUCCESS,
                        rewards: response.data
                    })
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 6:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error fetching your rewards.", error)
                ];
            case 7:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 8:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_REWARDS_ERROR */.RZ.FETCH_REWARDS_ERROR, error, errorResponse);
                return [
                    3,
                    9
                ];
            case 9:
                return [
                    2
                ];
        }
    });
}
// Punchh V2 only
function fetchLoyaltyStateSaga() {
    var loyaltyDriverId, loyaltyFeatureFlags, client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 1:
                loyaltyDriverId = _state.sent().loyaltyDriverId;
                if (!loyaltyDriverId) {
                    return [
                        2
                    ];
                }
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 2:
                loyaltyFeatureFlags = _state.sent().loyaltyFeatureFlags;
                /** @TODO ensure that `SHOW_LOYALTY_STATE` flag is defined. */ // @ts-expect-error
                if (!(loyaltyFeatureFlags === null || loyaltyFeatureFlags === void 0 ? void 0 : loyaltyFeatureFlags[loyalty/* LOYALTY_FEATURES.SHOW_LOYALTY_STATE */.lw.SHOW_LOYALTY_STATE])) {
                    return [
                        2
                    ];
                }
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    6,
                    ,
                    8
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* fetchLoyaltyState */.hO, {
                        client: client
                    })
                ];
            case 4:
                response = _state.sent();
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.FETCH_LOYALTY_STATE_SUCCESS */.Z.FETCH_LOYALTY_STATE_SUCCESS,
                        data: response.data
                    })
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    8
                ];
            case 6:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error fetching loyalty state:", error)
                ];
            case 7:
                errorResponse = _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_LOYALTY_STATE_ERROR */.RZ.FETCH_LOYALTY_STATE_ERROR, error, errorResponse);
                return [
                    3,
                    8
                ];
            case 8:
                return [
                    2
                ];
        }
    });
}
function fetchRedeemablesSaga() {
    var loyaltyDriverId, loyaltyFeatureFlags, client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 1:
                loyaltyDriverId = _state.sent().loyaltyDriverId;
                if (!loyaltyDriverId) {
                    return [
                        2
                    ];
                }
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 2:
                loyaltyFeatureFlags = _state.sent().loyaltyFeatureFlags;
                if (!(loyaltyFeatureFlags === null || loyaltyFeatureFlags === void 0 ? void 0 : loyaltyFeatureFlags[loyalty/* LOYALTY_FEATURES.INDEX_REDEEMABLES */.lw.INDEX_REDEEMABLES])) {
                    return [
                        2
                    ];
                }
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    6,
                    ,
                    9
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* fetchRedeemables */.v, {
                        client: client
                    })
                ];
            case 4:
                response = _state.sent();
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.FETCH_REDEEMABLES_SUCCESS */.Z.FETCH_REDEEMABLES_SUCCESS,
                        redeemables: response.data
                    })
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 6:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error fetching your rewards.", error)
                ];
            case 7:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 8:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_REWARDS_ERROR */.RZ.FETCH_REWARDS_ERROR, error, errorResponse);
                return [
                    3,
                    9
                ];
            case 9:
                return [
                    2
                ];
        }
    });
}
function fetchMessagesSaga() {
    var loyaltyDriverId, loyaltyFeatureFlags, client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 1:
                loyaltyDriverId = _state.sent().loyaltyDriverId;
                if (!loyaltyDriverId) {
                    return [
                        2
                    ];
                }
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 2:
                loyaltyFeatureFlags = _state.sent().loyaltyFeatureFlags;
                if (!(loyaltyFeatureFlags === null || loyaltyFeatureFlags === void 0 ? void 0 : loyaltyFeatureFlags[loyalty/* LOYALTY_FEATURES.INDEX_LOYALTY_MESSAGES */.lw.INDEX_LOYALTY_MESSAGES])) {
                    return [
                        2
                    ];
                }
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    6,
                    ,
                    9
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* fetchMessages */.W4, {
                        client: client
                    })
                ];
            case 4:
                response = _state.sent();
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.FETCH_MESSAGES_SUCCESS */.Z.FETCH_MESSAGES_SUCCESS,
                        messages: response.data
                    })
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 6:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error fetching your messages.", error)
                ];
            case 7:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 8:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_MESSAGES_ERROR */.RZ.FETCH_MESSAGES_ERROR, error, errorResponse);
                return [
                    3,
                    9
                ];
            case 9:
                return [
                    2
                ];
        }
    });
}
function fetchRewardsHistorySaga() {
    var loyaltyDriverId, loyaltyFeatureFlags, client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 1:
                loyaltyDriverId = _state.sent().loyaltyDriverId;
                if (!loyaltyDriverId) {
                    return [
                        2
                    ];
                }
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 2:
                loyaltyFeatureFlags = _state.sent().loyaltyFeatureFlags;
                if (!(loyaltyFeatureFlags === null || loyaltyFeatureFlags === void 0 ? void 0 : loyaltyFeatureFlags[loyalty/* LOYALTY_FEATURES.SHOW_LOYALTY_HISTORY */.lw.SHOW_LOYALTY_HISTORY])) {
                    return [
                        2
                    ];
                }
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    6,
                    ,
                    9
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* fetchRewardsHistory */.U8, {
                        client: client
                    })
                ];
            case 4:
                response = _state.sent();
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.FETCH_REWARDS_HISTORY_SUCCESS */.Z.FETCH_REWARDS_HISTORY_SUCCESS,
                        rewardsHistory: response.data
                    })
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 6:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error fetching your points history.", error)
                ];
            case 7:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 8:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_REWARDS_HISTORY_ERROR */.RZ.FETCH_REWARDS_HISTORY_ERROR, error, errorResponse);
                return [
                    3,
                    9
                ];
            case 9:
                return [
                    2
                ];
        }
    });
}
function markMessageAsReadSaga(action) {
    var loyaltyDriverId, loyaltyFeatureFlags, client, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 1:
                loyaltyDriverId = _state.sent().loyaltyDriverId;
                if (!loyaltyDriverId) {
                    return [
                        2
                    ];
                }
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 2:
                loyaltyFeatureFlags = _state.sent().loyaltyFeatureFlags;
                if (!(loyaltyFeatureFlags === null || loyaltyFeatureFlags === void 0 ? void 0 : loyaltyFeatureFlags[loyalty/* LOYALTY_FEATURES.MARK_READ_LOYALTY_MESSAGE */.lw.MARK_READ_LOYALTY_MESSAGE])) {
                    return [
                        2
                    ];
                }
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    5,
                    ,
                    7
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* markMessageAsRead */.RC, action.messageId, {
                        client: client
                    })
                ];
            case 4:
                _state.sent();
                // KA Event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.LOYALTY_MESSAGE_READ */.AH.LOYALTY_MESSAGE_READ);
                return [
                    3,
                    7
                ];
            case 5:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error marking message as read.", error)
                ];
            case 6:
                errorResponse = _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.MARK_AS_READ_ERROR */.RZ.MARK_AS_READ_ERROR, error, errorResponse);
                return [
                    3,
                    7
                ];
            case 7:
                // Always re-fetch messages in case some error happened that resets the read at state
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.FETCH_MESSAGES */.Z.FETCH_MESSAGES
                    })
                ];
            case 8:
                _state.sent();
                return [
                    2
                ];
        }
    });
}
function deleteMessageSaga(action) {
    var loyaltyDriverId, loyaltyFeatureFlags, client, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 1:
                loyaltyDriverId = _state.sent().loyaltyDriverId;
                if (!loyaltyDriverId) {
                    return [
                        2
                    ];
                }
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 2:
                loyaltyFeatureFlags = _state.sent().loyaltyFeatureFlags;
                if (!(loyaltyFeatureFlags === null || loyaltyFeatureFlags === void 0 ? void 0 : loyaltyFeatureFlags[loyalty/* LOYALTY_FEATURES.DESTROY_LOYALTY_MESSAGE */.lw.DESTROY_LOYALTY_MESSAGE])) {
                    return [
                        2
                    ];
                }
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    6,
                    ,
                    9
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* deleteMessage */.$Z, action.messageId, {
                        client: client
                    })
                ];
            case 4:
                _state.sent();
                // KA Event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.LOYALTY_MESSAGE_DELETE */.AH.LOYALTY_MESSAGE_DELETE);
                // Fetch messages on successs
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.FETCH_MESSAGES */.Z.FETCH_MESSAGES
                    })
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 6:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error deleting message.", error)
                ];
            case 7:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 8:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.DELETE_MESSAGE_ERROR */.RZ.DELETE_MESSAGE_ERROR, error, errorResponse);
                return [
                    3,
                    9
                ];
            case 9:
                return [
                    2
                ];
        }
    });
}
function createRedemptionSagaSuccess(action) {
    var redemptionAnalyticsLabel, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    2,
                    ,
                    5
                ]);
                redemptionAnalyticsLabel = action.rewardType === loyalty/* REWARD_TYPE.OFFER */.Hx.OFFER ? constants_events/* K_ANALYTICS_EVENTS.QR_OFFER_VIEW */.AH.QR_OFFER_VIEW : constants_events/* K_ANALYTICS_EVENTS.QR_REWARD_VIEW */.AH.QR_REWARD_VIEW;
                // KA Event - New Redemption
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(redemptionAnalyticsLabel, {
                    name: action.activeRedemption.label
                });
                // Fetch redemptions, loyalty state, and rewards history on successs
                return [
                    4,
                    (0,io_22ea0cf9.$)([
                        (0,io_22ea0cf9.Z)({
                            type: me_actions/* default.FETCH_REDEMPTIONS */.Z.FETCH_REDEMPTIONS
                        }),
                        (0,io_22ea0cf9.Z)({
                            type: me_actions/* default.FETCH_LOYALTY_STATE */.Z.FETCH_LOYALTY_STATE
                        }),
                        (0,io_22ea0cf9.Z)({
                            type: me_actions/* default.FETCH_REWARDS_HISTORY */.Z.FETCH_REWARDS_HISTORY
                        })
                    ])
                ];
            case 1:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 2:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "Encountered an unexpected error while fetching redemptions, loyalty state and rewards history", error)
                ];
            case 3:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function createRedemptionFailureSaga(action) {
    var errorResponse, redemptionErrorEventLabel;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error redeeming reward.", action.error)
                ];
            case 1:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 2:
                _state.sent();
                redemptionErrorEventLabel = action.rewardType === loyalty/* REWARD_TYPE.OFFER */.Hx.OFFER ? constants_events/* ERROR_MESSAGES.REDEEM_OFFER_ERROR */.RZ.REDEEM_OFFER_ERROR : constants_events/* ERROR_MESSAGES.REDEEM_REWARD_ERROR */.RZ.REDEEM_REWARD_ERROR;
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(redemptionErrorEventLabel, action.error, errorResponse);
                return [
                    2
                ];
        }
    });
}
function createRedemptionSaga(action) {
    var loyaltyDriverId, loyaltyFeatureFlags, client, redemptionAnalyticsLabel, myOffers, foundOffer, existingOfferRedemption, redemptions, existingRedemption, newRedemption, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 1:
                loyaltyDriverId = _state.sent().loyaltyDriverId;
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 2:
                loyaltyFeatureFlags = _state.sent().loyaltyFeatureFlags;
                if (!loyaltyDriverId) {
                    return [
                        2
                    ];
                }
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    12,
                    ,
                    14
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                redemptionAnalyticsLabel = action.rewardType === loyalty/* REWARD_TYPE.OFFER */.Hx.OFFER ? constants_events/* K_ANALYTICS_EVENTS.QR_OFFER_VIEW */.AH.QR_OFFER_VIEW : constants_events/* K_ANALYTICS_EVENTS.QR_REWARD_VIEW */.AH.QR_REWARD_VIEW;
                if (!(action.rewardType === loyalty/* REWARD_TYPE.OFFER */.Hx.OFFER)) return [
                    3,
                    6
                ];
                // Only allow offer redemption if feature supported
                if (/** @TODO ensure that `CREATE_REDEMPTION_USING_REWARD` flag is defined. */ // @ts-expect-error
                !(loyaltyFeatureFlags === null || loyaltyFeatureFlags === void 0 ? void 0 : loyaltyFeatureFlags[loyalty/* LOYALTY_FEATURES.CREATE_REDEMPTION_USING_REWARD */.lw.CREATE_REDEMPTION_USING_REWARD])) {
                    return [
                        2
                    ];
                }
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getRewards */.rl, {
                        client: client
                    })
                ];
            case 4:
                myOffers = _state.sent();
                foundOffer = myOffers.data.filter(function(offer) {
                    return offer.id === action.rewardId;
                });
                existingOfferRedemption = foundOffer.length > 0 && foundOffer[0].redemption;
                if (!existingOfferRedemption) return [
                    3,
                    6
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.CREATE_REDEMPTION_SUCCESS */.Z.CREATE_REDEMPTION_SUCCESS,
                        activeRedemption: existingOfferRedemption
                    })
                ];
            case 5:
                _state.sent();
                // KA Event - Existing Offer Redemption
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(redemptionAnalyticsLabel, {
                    name: existingOfferRedemption.label
                });
                return [
                    2
                ];
            case 6:
                if (!(action.rewardType === loyalty/* REWARD_TYPE.REWARD */.Hx.REWARD)) return [
                    3,
                    9
                ];
                // Only allow reward redemption if feature supported
                if (/** @TODO ensure that `CREATE_REDEMPTION_USING_REDEEMABLE` flag is defined. */ // @ts-expect-error
                !(loyaltyFeatureFlags === null || loyaltyFeatureFlags === void 0 ? void 0 : loyaltyFeatureFlags[loyalty/* LOYALTY_FEATURES.CREATE_REDEMPTION_USING_REDEEMABLE */.lw.CREATE_REDEMPTION_USING_REDEEMABLE]) || !(loyaltyFeatureFlags === null || loyaltyFeatureFlags === void 0 ? void 0 : loyaltyFeatureFlags[loyalty/* LOYALTY_FEATURES.INDEX_REDEMPTIONS */.lw.INDEX_REDEMPTIONS])) {
                    return [
                        2
                    ];
                }
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* fetchRedemptions */.by, {
                        client: client
                    })
                ];
            case 7:
                redemptions = _state.sent();
                existingRedemption = redemptions.data.find(function(redemption) {
                    return redemption.redeemable_id === +action.rewardId;
                });
                if (!existingRedemption) return [
                    3,
                    9
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.CREATE_REDEMPTION_SUCCESS */.Z.CREATE_REDEMPTION_SUCCESS,
                        activeRedemption: existingRedemption
                    })
                ];
            case 8:
                _state.sent();
                // KA Event - Existing Reward redemption
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(redemptionAnalyticsLabel, {
                    name: existingRedemption.label
                });
                return [
                    2
                ];
            case 9:
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* createRedemption */.J, action.rewardId, action.rewardType, {
                        client: client
                    })
                ];
            case 10:
                newRedemption = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.CREATE_REDEMPTION_SUCCESS */.Z.CREATE_REDEMPTION_SUCCESS,
                        activeRedemption: newRedemption.data,
                        rewardType: action.rewardType
                    })
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    14
                ];
            case 12:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.CREATE_REDEMPTION_FAILURE */.Z.CREATE_REDEMPTION_FAILURE,
                        error: error,
                        rewardType: action.rewardType
                    })
                ];
            case 13:
                _state.sent();
                return [
                    3,
                    14
                ];
            case 14:
                return [
                    2
                ];
        }
    });
}
function fetchRedemptionsSaga() {
    var loyaltyDriverId, loyaltyFeatureFlags, client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 1:
                loyaltyDriverId = _state.sent().loyaltyDriverId;
                if (!loyaltyDriverId) {
                    return [
                        2
                    ];
                }
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 2:
                loyaltyFeatureFlags = _state.sent().loyaltyFeatureFlags;
                if (!(loyaltyFeatureFlags === null || loyaltyFeatureFlags === void 0 ? void 0 : loyaltyFeatureFlags[loyalty/* LOYALTY_FEATURES.INDEX_REDEMPTIONS */.lw.INDEX_REDEMPTIONS])) {
                    return [
                        2
                    ];
                }
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    6,
                    ,
                    8
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* fetchRedemptions */.by, {
                        client: client
                    })
                ];
            case 4:
                response = _state.sent();
                // Fetch redemptions on successs
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.FETCH_REDEMPTIONS_SUCCESS */.Z.FETCH_REDEMPTIONS_SUCCESS,
                        redemptions: response.data
                    })
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    8
                ];
            case 6:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error fetching redemptions.", error)
                ];
            case 7:
                errorResponse = _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_REDEMPTIONS_ERROR */.RZ.FETCH_REDEMPTIONS_ERROR, error, errorResponse);
                return [
                    3,
                    8
                ];
            case 8:
                return [
                    2
                ];
        }
    });
}
function redeemReceiptBarcodeSaga(action) {
    var loyaltyDriverId, loyaltyFeatureFlags, client, points_earned, state, strings, successString, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 1:
                loyaltyDriverId = _state.sent().loyaltyDriverId;
                if (!loyaltyDriverId) {
                    return [
                        2
                    ];
                }
                return [
                    4,
                    (0,io_22ea0cf9.a4)(utils_loyalty/* getLoyaltyInfoFromState */.vO)
                ];
            case 2:
                loyaltyFeatureFlags = _state.sent().loyaltyFeatureFlags;
                if (!(loyaltyFeatureFlags === null || loyaltyFeatureFlags === void 0 ? void 0 : loyaltyFeatureFlags[loyalty/* LOYALTY_FEATURES.CLAIM_REWARDS_BY_RECEIPT */.lw.CLAIM_REWARDS_BY_RECEIPT])) {
                    return [
                        2
                    ];
                }
                _state.label = 3;
            case 3:
                _state.trys.push([
                    3,
                    10,
                    ,
                    14
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* redeemReceiptBarcode */.$1, action.barcode, {
                        client: client
                    })
                ];
            case 4:
                points_earned = _state.sent().points_earned;
                if (!(points_earned > 0)) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 5:
                state = _state.sent();
                strings = state.app.cmsConfig.strings;
                successString = (0,stringHelpers/* safelyGetString */.bc)(strings, "rewards.barcode_success_message", {
                    points: points_earned
                });
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayToast */.Z.displayToast(successString))
                ];
            case 6:
                _state.sent();
                _state.label = 7;
            case 7:
                // Fetch messages and close form on successs
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.REDEEM_RECEIPT_BARCODE_SUCCESS */.Z.REDEEM_RECEIPT_BARCODE_SUCCESS
                    })
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.FETCH_LOYALTY_STATE */.Z.FETCH_LOYALTY_STATE
                    })
                ];
            case 9:
                _state.sent();
                // Fire KA Event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.BARCODE_APPLY */.AH.BARCODE_APPLY);
                return [
                    3,
                    14
                ];
            case 10:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: me_actions/* default.REDEEM_RECEIPT_BARCODE_FAILURE */.Z.REDEEM_RECEIPT_BARCODE_FAILURE
                    })
                ];
            case 11:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error entering this receipt barcode.", error)
                ];
            case 12:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 13:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.REDEEM_BARCODE_ERROR */.RZ.REDEEM_BARCODE_ERROR, error, errorResponse);
                return [
                    3,
                    14
                ];
            case 14:
                return [
                    2
                ];
        }
    });
}
function me_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(me_actions/* default.FETCH_ME */.Z.FETCH_ME, fetchMeSaga)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.FETCH_ME_FAVORITE_LOCATIONS */.Z.FETCH_ME_FAVORITE_LOCATIONS, fetchMeFavoriteLocationsSaga)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.ADD_FAVORITE_LOCATION */.Z.ADD_FAVORITE_LOCATION, addFavoriteLocationSaga)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.REMOVE_FAVORITE_LOCATION */.Z.REMOVE_FAVORITE_LOCATION, deleteFavoriteLocationSaga)
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.FETCH_ME_FAVORITE_ORDERS */.Z.FETCH_ME_FAVORITE_ORDERS, fetchMeFavoriteOrdersSaga)
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.ADD_FAVORITE_ORDER */.Z.ADD_FAVORITE_ORDER, addFavoriteOrderSaga)
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.REMOVE_FAVORITE_ORDER */.Z.REMOVE_FAVORITE_ORDER, deleteFavoriteOrderSaga)
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.FETCH_ME_PAST_ORDERS */.Z.FETCH_ME_PAST_ORDERS, fetchMePastOrdersSaga)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.UPDATE_ME */.Z.UPDATE_ME, updateMeSaga)
                ];
            case 9:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.APPEND_USER_PHONE */.Z.APPEND_USER_PHONE, appendUserPhoneSaga)
                ];
            case 10:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.FETCH_ME_CREDIT_CARDS */.Z.FETCH_ME_CREDIT_CARDS, fetchMeCreditCardsSaga)
                ];
            case 11:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.FETCH_ALL_LOCATIONS_CREDIT_CARDS */.Z.FETCH_ALL_LOCATIONS_CREDIT_CARDS, fetchAllLocationsCreditCardsSaga)
                ];
            case 12:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.DELETE_ME_CREDIT_CARD */.Z.DELETE_ME_CREDIT_CARD, deleteMeCreditCardSaga)
                ];
            case 13:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.FETCH_ME_ORDER_DETAILS */.Z.FETCH_ME_ORDER_DETAILS, fetchMeOrderDetailsSaga)
                ];
            case 14:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.FETCH_OFFERS */.Z.FETCH_OFFERS, fetchOffersSaga)
                ];
            case 15:
                _state.sent();
                // Punchh V2 only
                return [
                    4,
                    takeLatest$1(me_actions/* default.FETCH_LOYALTY_STATE */.Z.FETCH_LOYALTY_STATE, fetchLoyaltyStateSaga)
                ];
            case 16:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.FETCH_REDEEMABLES */.Z.FETCH_REDEEMABLES, fetchRedeemablesSaga)
                ];
            case 17:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.FETCH_MESSAGES */.Z.FETCH_MESSAGES, fetchMessagesSaga)
                ];
            case 18:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.FETCH_REWARDS_HISTORY */.Z.FETCH_REWARDS_HISTORY, fetchRewardsHistorySaga)
                ];
            case 19:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.MARK_MESSAGE_AS_READ */.Z.MARK_MESSAGE_AS_READ, markMessageAsReadSaga)
                ];
            case 20:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.DELETE_MESSAGE */.Z.DELETE_MESSAGE, deleteMessageSaga)
                ];
            case 21:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.CREATE_REDEMPTION */.Z.CREATE_REDEMPTION, createRedemptionSaga)
                ];
            case 22:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.FETCH_REDEMPTIONS */.Z.FETCH_REDEMPTIONS, fetchRedemptionsSaga)
                ];
            case 23:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.REDEEM_RECEIPT_BARCODE */.Z.REDEEM_RECEIPT_BARCODE, redeemReceiptBarcodeSaga)
                ];
            case 24:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.FETCH_ADDRESSES */.Z.FETCH_ADDRESSES, fetchAddressesSaga)
                ];
            case 25:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.DELETE_ADDRESS */.Z.DELETE_ADDRESS, deleteAddressSaga)
                ];
            case 26:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.DEFAULT_ADDRESS */.Z.DEFAULT_ADDRESS, defaultAddressSaga)
                ];
            case 27:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.CREATE_REDEMPTION_SUCCESS */.Z.CREATE_REDEMPTION_SUCCESS, createRedemptionSagaSuccess)
                ];
            case 28:
                _state.sent();
                return [
                    4,
                    takeLatest$1(me_actions/* default.CREATE_REDEMPTION_FAILURE */.Z.CREATE_REDEMPTION_FAILURE, createRedemptionFailureSaga)
                ];
            case 29:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

// EXTERNAL MODULE: ./src/utils/menu.ts
var menu = __webpack_require__(682);
;// CONCATENATED MODULE: ./src/redux/menu/saga.ts













function refreshBasketMenuSaga(action) {
    var client, wantedAt, ref, response, compressedMenu, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    4,
                    ,
                    7
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                wantedAt = undefined;
                if (action.wantedAt && action.wantedAt !== constants_global/* DELIVERY_TIME_WANTED_MODES.ASAP */.hC.ASAP) {
                    wantedAt = action.wantedAt;
                }
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getMenu */.r7, {
                        id: action.id,
                        ifModifiedSince: undefined,
                        compressed: true,
                        wantedAt: wantedAt
                    }, {
                        client: client
                    })
                ];
            case 1:
                ref = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                    _state.sent(),
                    2
                ]), response = ref[0], compressedMenu = ref[1];
                // @ts-expect-error
                return [
                    4,
                    (0,io_22ea0cf9.Z)(menu_actions/* default.setBasketMenu */.Z.setBasketMenu(response, compressedMenu))
                ];
            case 2:
                _state.sent();
                // Ensure that the cart doesn't contain any items no longer in the menu
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.revalidateBasketItems */.Z.revalidateBasketItems(response))
                ];
            case 3:
                _state.sent();
                return [
                    3,
                    7
                ];
            case 4:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: menu_actions/* default.FETCH_BASKET_MENU_ERROR */.Z.FETCH_BASKET_MENU_ERROR
                    })
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, null, error)
                ];
            case 6:
                errorResponse = _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_BASKET_MENU_ERROR */.RZ.FETCH_BASKET_MENU_ERROR, error, errorResponse);
                return [
                    3,
                    7
                ];
            case 7:
                return [
                    2
                ];
        }
    });
}
function hydrateBasketMenuFromStorageSaga() {
    var menuFromStorage, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    2,
                    ,
                    3
                ]);
                menuFromStorage = (0,menu/* getMenuFromStorage */.uz)();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(menu_actions/* default.setBasketMenuFromStorage */.Z.setBasketMenuFromStorage(menuFromStorage))
                ];
            case 1:
                _state.sent();
                return [
                    3,
                    3
                ];
            case 2:
                error = _state.sent();
                console.log("Error getting menu from storage");
                console.log(error);
                return [
                    3,
                    3
                ];
            case 3:
                return [
                    2
                ];
        }
    });
}
function menu_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(menu_actions/* default.HYDRATE_BASKET_MENU */.Z.HYDRATE_BASKET_MENU, hydrateBasketMenuFromStorageSaga)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    takeLatest$1(menu_actions/* default.FETCH_BASKET_MENU */.Z.FETCH_BASKET_MENU, refreshBasketMenuSaga)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

// EXTERNAL MODULE: ./src/redux/orderDetails/actions.ts
var orderDetails_actions = __webpack_require__(82765);
;// CONCATENATED MODULE: ./src/redux/orderDetails/saga.ts









function fetchOrderDetailsByOrderIdSaga(action) {
    var client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    7
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(// @ts-expect-error ensure that `action.order_id` is defined.
                    v4/* getOrderSummary */.Q2, action.order_id, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                // Write menu into redux
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderDetails_actions/* orderDetailsActions.fetchOrderDetailsByOrderIdSuccess */.E.fetchOrderDetailsByOrderIdSuccess(response))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    7
                ];
            case 3:
                error = _state.sent();
                console.error(error);
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderDetails_actions/* orderDetailsActions.fetchOrderDetailsByOrderIdFail */.E.fetchOrderDetailsByOrderIdFail(error))
                ];
            case 4:
                _state.sent();
                // Error Notification
                errorReporter/* captureException */.Tb(error);
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, "There was an error fetching order details external order id", error)
                ];
            case 5:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 6:
                _state.sent();
                return [
                    3,
                    7
                ];
            case 7:
                return [
                    2
                ];
        }
    });
}
function orderDetails_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(orderDetails_actions/* orderDetailsActionTypes.FETCH_ORDER_DETAILS_BY_ORDER_ID */.b.FETCH_ORDER_DETAILS_BY_ORDER_ID, fetchOrderDetailsByOrderIdSaga)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

// EXTERNAL MODULE: ./src/constants/basket.ts
var constants_basket = __webpack_require__(65001);
// EXTERNAL MODULE: ./src/constants/dates.ts
var constants_dates = __webpack_require__(81584);
;// CONCATENATED MODULE: ./src/utils/wantedAt.ts



// TODO - test
var deriveDeliveryDates = function(locationOrderAhead, locationAdvanceOrderDays) {
    var dates = [];
    var daysAhead = 1;
    // Days to order ahead, assuming the location supports advanced ordering
    if (locationOrderAhead) {
        daysAhead = daysAhead + locationAdvanceOrderDays;
    }
    for(var i = 0; i < daysAhead; i++){
        var day = addTime(new Date(), i, "days");
        dates.push({
            value: formatDate(day, DATE_FORMAT.YEAR_MONTH_DAY_DASHED),
            label: formatDate(day, DATE_FORMAT.LABEL)
        });
    }
    return dates;
};
// TODO - test
var determineHourType = function(type) {
    return type === dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY ? "delivery_hours" : "operating_hours";
};

;// CONCATENATED MODULE: ./src/redux/orderStatus/saga.ts































/**
 * Initialize Basket
 *
 */ function initializeOrderSaga(action) {
    var response, wantedAtDay, fulfillmentType, initializationStep, basketId, ref, ref1, state, localBasket, client, basket, ref2, deliveryAddress, ref3, table_tent_number, error, preparedErrorResponse, errorEvent, errorMessage, initErrorType, state1, deliveryAddress1, additionalDetails, location, loggedOutAddress;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                initializationStep = constants_basket/* InitializationSteps.CREATE_BASKET */.lY.CREATE_BASKET;
                _state.label = 1;
            case 1:
                _state.trys.push([
                    1,
                    21,
                    ,
                    43
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 2:
                state = _state.sent();
                localBasket = dist/* sdkStorage.basket.get */.fn.basket.get();
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                // Determine checkout order fulfillment type
                fulfillmentType = (0,utils_basket/* determineBasketFulfillment */.Pp)((ref = state.app.basket.fulfillment) === null || ref === void 0 ? void 0 : ref.address);
                if (!((ref1 = localBasket.checkoutBasket) === null || ref1 === void 0 ? void 0 : ref1.id)) return [
                    3,
                    3
                ];
                basketId = localBasket.checkoutBasket.id;
                return [
                    3,
                    5
                ];
            case 3:
                basket = (0,utils_basket/* patchBasketProductOptions */.B$)(action.basketOrder);
                if (localBasket.referral_tracking_code) {
                    basket.referral_tracking_code = localBasket.referral_tracking_code;
                }
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* createBasket */.Y6, basket, action.locationId, {
                        client: client
                    })
                ];
            case 4:
                response = _state.sent();
                basketId = response.id;
                _state.label = 5;
            case 5:
                if (!(action.wantedAt && action.wantedAt !== constants_global/* DELIVERY_TIME_WANTED_MODES.ASAP */.hC.ASAP)) return [
                    3,
                    8
                ];
                if (!(0,dates/* isDateSameOrAfter */.U$)(action.wantedAt, new Date())) return [
                    3,
                    8
                ];
                // Format wantedAtDay from wantedAt timestamp so that we
                // can request basket hours for the appropriate day
                wantedAtDay = (0,dates/* formatDate */.p6)(action.wantedAt, constants_dates/* DATE_FORMAT.YEAR_MONTH_DAY */.z.YEAR_MONTH_DAY);
                initializationStep = constants_basket/* InitializationSteps.SET_WANTED_AT */.lY.SET_WANTED_AT;
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* setPickupTime */.cq, {
                        basketId: basketId,
                        locationId: action.locationId,
                        wanted_at: action.wantedAt
                    }, {
                        client: client
                    })
                ];
            case 6:
                _state.sent();
                // If call succeeds, update the timeslots reducer
                return [
                    4,
                    (0,io_22ea0cf9.Z)(timeslots_actions.setWantedAt(action.wantedAt))
                ];
            case 7:
                _state.sent();
                _state.label = 8;
            case 8:
                switch(fulfillmentType){
                    case dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY:
                        return [
                            3,
                            9
                        ];
                    case dist/* CONVEYANCE_TYPES.DINEIN */.P8.DINEIN:
                        return [
                            3,
                            12
                        ];
                }
                return [
                    3,
                    16
                ];
            case 9:
                deliveryAddress = (0,checkout/* assembleDeliveryObjectFromState */.Of)(state);
                // Catch any outstanding issues with zip code length
                /** @TODO nail down delivery address type to ensure zip_code is present. */ // @ts-expect-error
                if (((ref2 = deliveryAddress.zip_code) === null || ref2 === void 0 ? void 0 : ref2.length) > 6) {
                    throw new Error("Please ensure that your delivery zip code is not longer than 6 digits.");
                }
                /** @TODO nail down delivery address type. */ // @ts-expect-error
                if (!deliveryAddress.phone_number) {
                    return [
                        3,
                        17
                    ];
                }
                initializationStep = constants_basket/* InitializationSteps.SET_CONVEYANCE */.lY.SET_CONVEYANCE;
                return [
                    4,
                    (0,io_22ea0cf9.O)(// @ts-expect-error ensure that `deliveryAddress` is defined.
                    v4/* setConveyance */.rp, {
                        basketId: basketId,
                        locationId: action.locationId,
                        type: constants_events/* API_CONVEYANCE_TYPES.DELIVERY */.tQ.DELIVERY,
                        data: deliveryAddress
                    }, {
                        client: client
                    })
                ];
            case 10:
                response = _state.sent();
                // Update handoff details in redux
                return [
                    4,
                    (0,io_22ea0cf9.Z)(conveyanceMode_actions/* default.handoffDetailsSet */.Z.handoffDetailsSet(dist/* CONVEYANCE_TYPES.DELIVERY */.P8.DELIVERY, {
                        instructions: (ref3 = deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.special_instructions) !== null && ref3 !== void 0 ? ref3 : ""
                    }))
                ];
            case 11:
                _state.sent();
                return [
                    3,
                    17
                ];
            case 12:
                table_tent_number = (0,global/* getPersistentParameterValue */.Fc)(constants_global/* ALLOWED_URL_PARAMETER_KEYS.TABLE_NUMBER */.Ue.TABLE_NUMBER);
                if (!table_tent_number) return [
                    3,
                    15
                ];
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* setConveyance */.rp, {
                        basketId: basketId,
                        locationId: action.locationId,
                        type: constants_events/* API_CONVEYANCE_TYPES.DINEIN */.tQ.DINEIN,
                        data: {
                            table_tent_number: table_tent_number
                        }
                    }, {
                        client: client
                    })
                ];
            case 13:
                _state.sent();
                // Update handoff details in redux
                return [
                    4,
                    (0,io_22ea0cf9.Z)(conveyanceMode_actions/* default.handoffDetailsSet */.Z.handoffDetailsSet(dist/* CONVEYANCE_TYPES.DINEIN */.P8.DINEIN, {
                        table_tent_number: table_tent_number
                    }))
                ];
            case 14:
                _state.sent();
                _state.label = 15;
            case 15:
                return [
                    3,
                    17
                ];
            case 16:
                return [
                    3,
                    17
                ];
            case 17:
                /**
     * 4. Validate the basket
     *
     */ initializationStep = constants_basket/* InitializationSteps.VALIDATE */.lY.VALIDATE;
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* validateBasket */.J5, {
                        basketId: basketId,
                        locationId: action.locationId
                    }, {
                        client: client
                    })
                ];
            case 18:
                response = _state.sent();
                // Update checkoutBasket in redux
                return [
                    4,
                    (0,io_22ea0cf9.$)([
                        (0,io_22ea0cf9.Z)(basket_actions/* default.success */.Z.success(response)),
                        (0,io_22ea0cf9.Z)(basket_actions/* default.basketItemsSyncedWithStore */.Z.basketItemsSyncedWithStore(response.basket_items))
                    ])
                ];
            case 19:
                _state.sent();
                // Trigger post-initialization calls
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.postInitializeOrder */.Z.postInitializeOrder(action.basketOrder, response, fulfillmentType, wantedAtDay, action.wantedAt))
                ];
            case 20:
                _state.sent();
                return [
                    3,
                    43
                ];
            case 21:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, orderStatus/* OrderStatusMessages.INITIALIZING_ORDER_ERROR */.bJ.INITIALIZING_ORDER_ERROR, error)
                ];
            case 22:
                preparedErrorResponse = _state.sent();
                errorMessage = preparedErrorResponse.message;
                initErrorType = (0,checkout/* getInitializationErrorType */.Tc)(errorMessage);
                switch(initErrorType){
                    case constants_basket/* InitializationErrorTypes.HANDLED */.R0.HANDLED:
                        return [
                            3,
                            23
                        ];
                    case constants_basket/* InitializationErrorTypes.THROTTLING */.R0.THROTTLING:
                        return [
                            3,
                            24
                        ];
                    case constants_basket/* InitializationErrorTypes.PHONE */.R0.PHONE:
                        return [
                            3,
                            25
                        ];
                    case constants_basket/* InitializationErrorTypes.LOCK */.R0.LOCK:
                        return [
                            3,
                            26
                        ];
                    case constants_basket/* InitializationErrorTypes.UNHANDLED */.R0.UNHANDLED:
                        return [
                            3,
                            27
                        ];
                }
                return [
                    3,
                    37
                ];
            case 23:
                // If it is a handled reconciliation-specific error
                errorEvent = constants_events/* ERROR_MESSAGES.INIT_CHECKOUT_HANDLED_FAILURE */.RZ.INIT_CHECKOUT_HANDLED_FAILURE;
                return [
                    3,
                    37
                ];
            case 24:
                // If it is a throttling-specific error
                errorEvent = constants_events/* ERROR_MESSAGES.INIT_CHECKOUT_THROTTLING_FAILURE */.RZ.INIT_CHECKOUT_THROTTLING_FAILURE;
                return [
                    3,
                    37
                ];
            case 25:
                // If it is a handled reconciliation-specific error
                errorEvent = constants_events/* ERROR_MESSAGES.INIT_CHECKOUT_PHONE_FAILURE */.RZ.INIT_CHECKOUT_PHONE_FAILURE;
                return [
                    3,
                    37
                ];
            case 26:
                // If it is a lock-specific error, update log event
                errorEvent = constants_events/* ERROR_MESSAGES.INIT_CHECKOUT_LOCK_FAILURE */.RZ.INIT_CHECKOUT_LOCK_FAILURE;
                return [
                    3,
                    37
                ];
            case 27:
                switch(initializationStep){
                    case constants_basket/* InitializationSteps.CREATE_BASKET */.lY.CREATE_BASKET:
                        return [
                            3,
                            28
                        ];
                    case constants_basket/* InitializationSteps.SET_WANTED_AT */.lY.SET_WANTED_AT:
                        return [
                            3,
                            29
                        ];
                    case constants_basket/* InitializationSteps.SET_CONVEYANCE */.lY.SET_CONVEYANCE:
                        return [
                            3,
                            30
                        ];
                }
                return [
                    3,
                    31
                ];
            case 28:
                // Create basket failures cannot proceed
                errorEvent = constants_events/* ERROR_MESSAGES.INIT_CHECKOUT_UNHANDLED_BASKET_FAILURE */.RZ.INIT_CHECKOUT_UNHANDLED_BASKET_FAILURE;
                return [
                    3,
                    36
                ];
            case 29:
                // Wanted at failures cannot proceed
                errorMessage = "There was an issue setting your desired ready time. ".concat(errorMessage);
                errorEvent = constants_events/* ERROR_MESSAGES.INIT_CHECKOUT_UNHANDLED_WANTED_AT_FAILURE */.RZ.INIT_CHECKOUT_UNHANDLED_WANTED_AT_FAILURE;
                return [
                    3,
                    36
                ];
            case 30:
                // Conveyance failures cannot proceed
                errorEvent = constants_events/* ERROR_MESSAGES.INIT_CHECKOUT_UNHANDLED_CONVEYANCE_FAILURE */.RZ.INIT_CHECKOUT_UNHANDLED_CONVEYANCE_FAILURE;
                return [
                    3,
                    36
                ];
            case 31:
                // Otherwise, attempt to proceed normally by updating checkoutBasket in redux
                /** @TODO modify request changing flow to ensure `response` is defined. */ // Update checkoutBasket in redux
                // @ts-expect-error ensure `response` is defined.
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.success */.Z.success(response))
                ];
            case 32:
                _state.sent();
                if (!(response === null || response === void 0 ? void 0 : response.basket_items)) return [
                    3,
                    34
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.basketItemsSyncedWithStore */.Z.basketItemsSyncedWithStore(response.basket_items))
                ];
            case 33:
                _state.sent();
                _state.label = 34;
            case 34:
                // Fire necessary postInitializaOrder calls
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.postInitializeOrder */.Z.postInitializeOrder(action.basketOrder, /** @TODO modify request changing flow to ensure `response` is defined. */ // @ts-expect-error
                    response, /** @TODO modify request changing flow to ensure `fulfillmentType` is defined. */ // @ts-expect-error
                    fulfillmentType, wantedAtDay, action.wantedAt))
                ];
            case 35:
                _state.sent();
                _state.label = 36;
            case 36:
                return [
                    3,
                    37
                ];
            case 37:
                if (!errorEvent) return [
                    3,
                    39
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.initializeOrderReconciliation */.Z.initializeOrderReconciliation(errorMessage))
                ];
            case 38:
                _state.sent();
                _state.label = 39;
            case 39:
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 40:
                state1 = _state.sent();
                deliveryAddress1 = (0,checkout/* assembleDeliveryObjectFromState */.Of)(state1);
                if (!(deliveryAddress1 === null || deliveryAddress1 === void 0 ? void 0 : deliveryAddress1.id)) return [
                    3,
                    42
                ];
                additionalDetails = "Stored Address ID: ".concat(deliveryAddress1.id);
                if (!((0,checkout/* getInitializationErrorType */.Tc)(errorMessage) === constants_basket/* InitializationErrorTypes.LOCK */.R0.LOCK)) return [
                    3,
                    42
                ];
                errorReporter/* captureMessage */.uT("User encountered error checking out with a stored address", "info", {
                    additionalDetails: additionalDetails,
                    errorMessage: errorMessage
                });
                location = (0,checkout/* getLocationFromState */.ip)(state1);
                loggedOutAddress = Object.assign({}, deliveryAddress1);
                delete loggedOutAddress.id;
                delete loggedOutAddress.default;
                /**
         * @TODO reconcile IConveyanceDeliveryAddress and
         * the SDK `DeliveryAddress` types.
         */ return [
                    4,
                    (0,io_22ea0cf9.Z)(conveyanceMode_actions/* default.setDeliveryAddress */.Z.setDeliveryAddress(// @ts-expect-error
                    loggedOutAddress, location, false))
                ];
            case 41:
                _state.sent();
                _state.label = 42;
            case 42:
                // KA event
                errorEvent = errorEvent || constants_events/* ERROR_MESSAGES.INIT_CHECKOUT_UNHANDLED_FAILURE */.RZ.INIT_CHECKOUT_UNHANDLED_FAILURE;
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(errorEvent, error, preparedErrorResponse, // @ts-expect-error
                additionalDetails);
                return [
                    3,
                    43
                ];
            case 43:
                return [
                    2
                ];
        }
    });
}
/**
 * Post-initialization API calls
 *
 */ function postInitializeOrderSaga(action) {
    var error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    5
                ]);
                // Fetch wanted times for the basket
                return [
                    4,
                    (0,io_22ea0cf9.Z)(timeslots_actions.fetchHandoffTimesByBasket(action.basket.id, action.basket.location.id, determineHourType(action.fulfillmentType), action.basket.order_asap, // @ts-expect-error
                    action.wantedAtDay, action.type, action.wantedAt))
                ];
            case 1:
                _state.sent();
                // Commerce Events
                return [
                    4,
                    (0,io_22ea0cf9.Z)(commerce_actions/* default.commerceCheckoutBasketStaged */.Z.commerceCheckoutBasketStaged(action.basketOrder, action.basket, action.fulfillmentType))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 3:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, null, error)
                ];
            case 4:
                errorResponse = _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.POST_INIT_CHECKOUT_FAILURE */.RZ.POST_INIT_CHECKOUT_FAILURE, error, errorResponse);
                return [
                    3,
                    5
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
/**
 * Validate Basket
 *
 */ function validateOrderSaga(action) {
    var client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    4,
                    ,
                    6
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* validateBasket */.J5, {
                        basketId: action.basketId,
                        locationId: action.locationId
                    }, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.success */.Z.success(response))
                ];
            case 2:
                _state.sent();
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 3:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 4:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, null, error)
                ];
            case 5:
                errorResponse = _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.BASKET_VALIDATION_ERROR */.RZ.BASKET_VALIDATION_ERROR, error, errorResponse);
                return [
                    3,
                    6
                ];
            case 6:
                return [
                    2
                ];
        }
    });
}
/**
 * Add Tip
 *
 */ function tipAddSaga(action) {
    var state, client, ref, basketId, locationId, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    6,
                    ,
                    10
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                ref = (0,checkout/* getIdsFromState */.jw)(state), basketId = ref.basketId, locationId = ref.locationId;
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* addTip */.h9, {
                        basketId: basketId,
                        locationId: locationId,
                        tipAmount: action.tipAmount
                    }, {
                        client: client
                    })
                ];
            case 2:
                response = _state.sent();
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.success */.Z.success(response))
                ];
            case 4:
                _state.sent();
                // Silently validate basket
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.validateOrder */.Z.validateOrder(basketId, locationId))
                ];
            case 5:
                _state.sent();
                // KA Events
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.TIP_ADDED */.AH.TIP_ADDED, {
                    name: action.isCustom ? "custom" : "predefined",
                    details: (0,utils_basket/* toDollars */.DV)(action.tipAmount)
                });
                return [
                    3,
                    10
                ];
            case 6:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, orderStatus/* OrderStatusMessages.TIP_ADDING_ERROR */.bJ.TIP_ADDING_ERROR, error)
                ];
            case 8:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderStatusMessageErrorSet */.Z.orderStatusMessageErrorSet(errorResponse.message))
                ];
            case 9:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.ADD_TIP_ERROR */.RZ.ADD_TIP_ERROR, error, errorResponse);
                return [
                    3,
                    10
                ];
            case 10:
                return [
                    2
                ];
        }
    });
}
/**
 * Set Utensils
 *
 */ function utensilsSetSaga(action) {
    var state, client, ref, basketId, locationId, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    5,
                    ,
                    9
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                ref = (0,checkout/* getIdsFromState */.jw)(state), basketId = ref.basketId, locationId = ref.locationId;
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* setUtensils */.Ip, {
                        basketId: basketId,
                        locationId: locationId,
                        preference: action.utensils
                    }, {
                        client: client
                    })
                ];
            case 2:
                response = _state.sent();
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.success */.Z.success(response))
                ];
            case 4:
                _state.sent();
                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.GENERIC__CTA */.x.GENERIC__CTA, {
                    name: constants/* EventNames.UTENSILS_SET */.V.UTENSILS_SET,
                    details: action.utensils ? "Added" : "Removed"
                });
                (0,events/* genericEventHandler */.O)(constants/* GlobalEvents.BASKET__CUSTOMIZED */.x.BASKET__CUSTOMIZED, {
                    name: constants/* EventNames.UTENSILS_SET */.V.UTENSILS_SET,
                    details: action.utensils ? "Added" : "Removed"
                });
                return [
                    3,
                    9
                ];
            case 5:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, orderStatus/* OrderStatusMessages.UTENSIL_SETTING_ERROR */.bJ.UTENSIL_SETTING_ERROR, error)
                ];
            case 7:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderStatusMessageErrorSet */.Z.orderStatusMessageErrorSet(errorResponse.message))
                ];
            case 8:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.UTENSILS_ERROR */.RZ.UTENSILS_ERROR, error, errorResponse);
                return [
                    3,
                    9
                ];
            case 9:
                return [
                    2
                ];
        }
    });
}
/**
 * Set Basket Instructions
 *
 */ function basketInstructionsSetSaga(action) {
    var state, ref, basketId, locationId, client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    5,
                    ,
                    9
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                ref = (0,checkout/* getIdsFromState */.jw)(state), basketId = ref.basketId, locationId = ref.locationId;
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* setInstructions */.ZR, {
                        basketId: basketId,
                        locationId: locationId,
                        basket_instructions: action.basketInstructions
                    }, {
                        client: client
                    })
                ];
            case 2:
                response = _state.sent();
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.success */.Z.success(response))
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    9
                ];
            case 5:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, orderStatus/* OrderStatusMessages.BASKET_INSTRUCTIONS_SETTING_ERROR */.bJ.BASKET_INSTRUCTIONS_SETTING_ERROR, error)
                ];
            case 7:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderStatusMessageErrorSet */.Z.orderStatusMessageErrorSet(errorResponse.message))
                ];
            case 8:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.BASKET_INSTRUCTIONS_ERROR */.RZ.BASKET_INSTRUCTIONS_ERROR, error, errorResponse);
                return [
                    3,
                    9
                ];
            case 9:
                return [
                    2
                ];
        }
    });
}
function orderSubmissionDigitalWalletTriggerSaga(action) {
    var err, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    5
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.Z)(payment_actions/* default.creditCardSet */.Z.creditCardSet(action.paymentDetails))
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderSubmissionTrigger */.Z.orderSubmissionTrigger(action.message, action.captcha))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 3:
                err = _state.sent();
                error = err;
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderSubmissionError */.Z.orderSubmissionError(error.message))
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
/**
 * Trigger Order Submission
 *
 */ function orderSubmissionTriggerSaga(action) {
    var state, orderData, submissionTriggerProps, err, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    5
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                orderData = (0,checkout/* assembleOrderDataFromState */.c3)(state);
                submissionTriggerProps = orderStatus_actions/* default.orderSubmissionTrigger */.Z.orderSubmissionTrigger(action.message, action.captcha);
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderSubmissionStart */.Z.orderSubmissionStart(orderData, submissionTriggerProps.captcha))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 3:
                err = _state.sent();
                error = err;
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderSubmissionError */.Z.orderSubmissionError(error.message))
                ];
            case 4:
                _state.sent();
                // Fire KA Event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.ERROR */.AH.ERROR, {
                    name: constants_events/* ERROR_MESSAGES.TRIGGER_SUBMIT_CHECKOUT_ERROR */.RZ.TRIGGER_SUBMIT_CHECKOUT_ERROR,
                    details: error.message
                });
                return [
                    3,
                    5
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
/**
 * Start Order Submission
 *
 */ function orderSubmissionStartSaga(action) {
    var state, client, ref, basketId, locationId, orderDetails, urlObj, error, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, errorResponse, errorType, userFacingErrorMessage, gaAction, kaEventName, ref10;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                _state.label = 2;
            case 2:
                _state.trys.push([
                    2,
                    9,
                    ,
                    15
                ]);
                ref = (0,checkout/* getIdsFromState */.jw)(state), basketId = ref.basketId, locationId = ref.locationId;
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* submitOrder */.pm, {
                        basketId: basketId,
                        locationId: locationId,
                        orderData: action.submitBasketData,
                        captcha: action.captcha
                    }, {
                        client: client
                    })
                ];
            case 3:
                orderDetails = _state.sent();
                // Write submitted basket to redux
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.confirmation */.Z.confirmation())
                ];
            case 4:
                _state.sent();
                // Write order details to redux for further use in order-confirmation page
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.clearFeatureBag */.Z.clearFeatureBag())
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderDetails_actions/* orderDetailsActions.clearOrderDetailsState */.E.clearOrderDetailsState())
                ];
            case 6:
                _state.sent();
                // @ts-expect-error
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderDetails_actions/* orderDetailsActions.addOrderDetailsState */.E.addOrderDetailsState(orderDetails))
                ];
            case 7:
                _state.sent();
                // Fire complete order events
                // @ts-expect-error
                return [
                    4,
                    (0,io_22ea0cf9.Z)(commerce_actions/* default.commerceCheckoutPurchase */.Z.commerceCheckoutPurchase(orderDetails))
                ];
            case 8:
                _state.sent();
                urlObj = {
                    pathname: routes/* ROUTES.ORDER_CONFIRMATION */.Z6.ORDER_CONFIRMATION,
                    // @ts-expect-error
                    query: {
                        id: orderDetails.order_id
                    }
                };
                void router_default().push(urlObj);
                // remove the conversion tracker after this order is submitted.
                new dist/* ConversionTrackingHelper */.jJ().clearTrackingKey();
                return [
                    3,
                    15
                ];
            case 9:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, orderStatus/* OrderStatusMessages.ORDER_SUBMISSION_ERROR */.bJ.ORDER_SUBMISSION_ERROR, error)
                ];
            case 10:
                errorResponse = _state.sent();
                errorType = errorResponse === null || errorResponse === void 0 ? void 0 : (ref1 = errorResponse.error) === null || ref1 === void 0 ? void 0 : ref1.error;
                userFacingErrorMessage = ((ref2 = errorResponse.message) === null || ref2 === void 0 ? void 0 : ref2.indexOf("Payment(s) must fund Basket total.")) > -1 ? "There was an issue applying your tip. Please reset your tip value and try again." : errorResponse.message;
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderSubmissionError */.Z.orderSubmissionError(userFacingErrorMessage))
                ];
            case 11:
                _state.sent();
                gaAction = googleAnalytics/* gaActions.checkoutError */.cE.checkoutError;
                kaEventName = constants_events/* ERROR_MESSAGES.SUBMIT_CHECKOUT_ERROR */.RZ.SUBMIT_CHECKOUT_ERROR;
                if (!(((ref3 = errorResponse.message) === null || ref3 === void 0 ? void 0 : ref3.indexOf("payment")) > -1 || ((ref4 = errorResponse.message) === null || ref4 === void 0 ? void 0 : ref4.indexOf("Declined")) > -1 || ((ref5 = errorResponse.message) === null || ref5 === void 0 ? void 0 : ref5.indexOf("expired")) > -1 || ((ref6 = errorResponse.message) === null || ref6 === void 0 ? void 0 : ref6.indexOf("expiry")) > -1 || ((ref7 = errorResponse.message) === null || ref7 === void 0 ? void 0 : ref7.indexOf("Unsuccessful Payment Transaction")) > -1)) return [
                    3,
                    14
                ];
                if (!((ref10 = state.app.paymentTypes) === null || ref10 === void 0 ? void 0 : ref10.credit_card_token.supported)) return [
                    3,
                    13
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(payment_actions/* default.paymentTypeReset */.Z.paymentTypeReset())
                ];
            case 12:
                _state.sent();
                _state.label = 13;
            case 13:
                gaAction = googleAnalytics/* gaActions.paymentDenied */.cE.paymentDenied;
                kaEventName = constants_events/* ERROR_MESSAGES.PAYMENT_DENIED_ERROR */.RZ.PAYMENT_DENIED_ERROR;
                _state.label = 14;
            case 14:
                // Ordering not available at location
                // e.g. location_not_available: Online ordering is unavailable at this time. Please use the location finder to try another location nearby.
                // e.g. Your order could not be placed. Please visit this location directly to place your order.
                if (errorType === "location_not_available" || ((ref8 = errorResponse.message) === null || ref8 === void 0 ? void 0 : ref8.indexOf("Your order could not be placed. Please visit this location directly to place your order.")) > -1 || ((ref9 = errorResponse.message) === null || ref9 === void 0 ? void 0 : ref9.indexOf("We are currently unable to take your order.")) > -1) {
                    gaAction = googleAnalytics/* gaActions.locationNotAvailable */.cE.locationNotAvailable;
                    kaEventName = constants_events/* ERROR_MESSAGES.LOCATION_NOT_AVAILABLE */.RZ.LOCATION_NOT_AVAILABLE;
                }
                // Basket is invalid
                // e.g. Your order cannot be ready by 8:30pm due to the time it will take to prepare your order. Please choose another available time.
                // e.g. Apologies, there is a problem on this order. Please update your order to remove any unavailable items to try this order again. "Vanilla" is not currently available on "Shakes".
                if (errorType === "basket_not_valid") {
                    gaAction = googleAnalytics/* gaActions.basketNotValid */.cE.basketNotValid;
                    kaEventName = constants_events/* ERROR_MESSAGES.BASKET_NOT_VALID */.RZ.BASKET_NOT_VALID;
                }
                // GA Event
                (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.order */.m1.order, gaAction, {
                    label: "".concat(errorType, ": ").concat(errorResponse.message)
                });
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.ORDER_SUBMISSION_FAILED */.AH.ORDER_SUBMISSION_FAILED, {
                    name: kaEventName,
                    error: errorResponse,
                    // @ts-expect-error
                    detail: error
                });
                return [
                    3,
                    15
                ];
            case 15:
                return [
                    2
                ];
        }
    });
}
function orderStatus_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(orderStatus_actions/* default.INITIALIZE_ORDER */.Z.INITIALIZE_ORDER, initializeOrderSaga)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    takeLatest$1(orderStatus_actions/* default.POST_INITIALIZE_ORDER */.Z.POST_INITIALIZE_ORDER, postInitializeOrderSaga)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    takeLatest$1(orderStatus_actions/* default.VALIDATE_ORDER */.Z.VALIDATE_ORDER, validateOrderSaga)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    takeLatest$1(orderStatus_actions/* default.TIP_ADD */.Z.TIP_ADD, tipAddSaga)
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    takeLatest$1(orderStatus_actions/* default.UTENSILS_SET */.Z.UTENSILS_SET, utensilsSetSaga)
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    takeLatest$1(orderStatus_actions/* default.BASKET_INSTRUCTIONS_SET */.Z.BASKET_INSTRUCTIONS_SET, basketInstructionsSetSaga)
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    takeLatest$1(orderStatus_actions/* default.ORDER_SUBMISSION_START */.Z.ORDER_SUBMISSION_START, orderSubmissionStartSaga)
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    takeLatest$1(orderStatus_actions/* default.ORDER_SUBMISSION_DIGITAL_WALLET_TRIGGER */.Z.ORDER_SUBMISSION_DIGITAL_WALLET_TRIGGER, orderSubmissionDigitalWalletTriggerSaga)
                ];
            case 8:
                _state.sent();
                return [
                    4,
                    takeLatest$1(orderStatus_actions/* default.ORDER_SUBMISSION_TRIGGER */.Z.ORDER_SUBMISSION_TRIGGER, orderSubmissionTriggerSaga)
                ];
            case 9:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

;// CONCATENATED MODULE: ./src/redux/organization/saga.ts









function fetchOrganizationSaga() {
    var client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    6
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getOrgConfig */.RB, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                // Success
                // @ts-expect-error
                return [
                    4,
                    (0,io_22ea0cf9.Z)(organization_actions/* default.fetchOrganizationSuccess */.Z.fetchOrganizationSuccess(response))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 3:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(organization_actions/* default.fetchOrganizationFail */.Z.fetchOrganizationFail())
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, null, error)
                ];
            case 5:
                errorResponse = _state.sent();
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_ORG_ERROR */.RZ.FETCH_ORG_ERROR, error, errorResponse);
                return [
                    3,
                    6
                ];
            case 6:
                return [
                    2
                ];
        }
    });
}
function organization_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(organization_actions/* default.FETCH_ORGANIZATION */.Z.FETCH_ORGANIZATION, fetchOrganizationSaga)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

// EXTERNAL MODULE: ./src/redux/basket/index.ts
var basket = __webpack_require__(52912);
// EXTERNAL MODULE: ./src/redux/payment/constants.ts
var payment_constants = __webpack_require__(67461);
;// CONCATENATED MODULE: ./src/redux/payment/saga.ts















/**
 * Payment type toggle
 *
 */ function paymentTypeToggleSaga() {
    var state, checkoutBasket, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    4,
                    ,
                    5
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                checkoutBasket = state.app.basket.checkoutBasket;
                if (!!(checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.location.supports_split_payment)) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(payment_actions/* default.storedValueClear */.Z.storedValueClear())
                ];
            case 2:
                _state.sent();
                _state.label = 3;
            case 3:
                return [
                    3,
                    5
                ];
            case 4:
                error = _state.sent();
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.ERROR */.AH.ERROR, {
                    name: constants_events/* ERROR_MESSAGES.PAYMENT_TOGGLE_SAGA_ERROR */.RZ.PAYMENT_TOGGLE_SAGA_ERROR
                });
                return [
                    3,
                    5
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
/**
 * Exchange transaction id for card aliases
 *
 */ function creditCardTransactionIdSaga(action) {
    var origin, client, checkoutBasket, res, creditCardWithAlias, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    4,
                    ,
                    6
                ]);
                origin = (0,utils/* getOrigin */.P$)(window.location.host);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: origin
                });
                return [
                    4,
                    (0,io_22ea0cf9.a4)(basket/* selectBasketSlice */.p)
                ];
            case 1:
                checkoutBasket = _state.sent().checkoutBasket;
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getTokenizedCreditCard */.Z4, {
                        basketId: checkoutBasket.id,
                        locationId: checkoutBasket.location.id,
                        transactionId: action.creditCard.id
                    }, {
                        client: client
                    })
                ];
            case 2:
                res = _state.sent();
                creditCardWithAlias = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, action.creditCard), {
                    alias_cc: res.alias_cc,
                    alias_cvv: res.alias_cvv,
                    country: res.country,
                    last_four: res.last_four,
                    masked_card: res.masked_card
                });
                return [
                    4,
                    (0,io_22ea0cf9.Z)(payment_actions/* default.creditCardSet */.Z.creditCardSet(creditCardWithAlias))
                ];
            case 3:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 4:
                error = _state.sent();
                /**
     * If exchanging the Transaction ID for the tokenized card fails, store
     * the untokenized card and the Ordering API will re-attempt the exchange.
     */ return [
                    4,
                    (0,io_22ea0cf9.Z)(payment_actions/* default.creditCardSet */.Z.creditCardSet(action.creditCard))
                ];
            case 5:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 6:
                return [
                    2
                ];
        }
    });
}
/**
 * Get stored value
 *
 */ function storeValuePostSaga(action) {
    var ref, state, checkoutBasket, client, response, error, // @ts-expect-error
    ref1, // @ts-expect-error
    ref2, errorResponse, errorMessage;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    5,
                    ,
                    9
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                checkoutBasket = state.app.basket.checkoutBasket;
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getStoredValue */.mM, {
                        basketId: checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.id,
                        locationId: checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.location.id,
                        cardNumber: action.cardNumber,
                        pin: action.pin,
                        captcha: action.captcha
                    }, {
                        client: client
                    })
                ];
            case 2:
                response = _state.sent();
                // If split-payment is not supported and the gift card balance does not cover the order total
                if (!(checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.location.supports_split_payment) && response.balance < ((ref = state.app.basket.checkoutBasket) === null || ref === void 0 ? void 0 : ref.total)) {
                    throw new Error("Oops, card balance $".concat((0,utils_basket/* toDollars */.DV)(response.balance), " does not cover order total."));
                }
                // Send response to payment saga for calculation/processing
                return [
                    4,
                    (0,io_22ea0cf9.Z)(payment_actions/* default.storedValueSet */.Z.storedValueSet({
                        balance: response.balance,
                        card_number: action.cardNumber,
                        pin: action.pin
                    }))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 4:
                _state.sent();
                // KA Event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.GIFT_CARD_APPLIED */.AH.GIFT_CARD_APPLIED);
                return [
                    3,
                    9
                ];
            case 5:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 6:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, null, error)
                ];
            case 7:
                errorResponse = _state.sent();
                errorMessage = errorResponse.error ? payment_constants/* storedValueErrors.DEFAULT */.B_.DEFAULT : error.message;
                // Additional check for PIN requirement errors
                if ((errorResponse === null || errorResponse === void 0 ? void 0 : (ref1 = errorResponse.error) === null || ref1 === void 0 ? void 0 : ref1.error_description.indexOf("This billing scheme requires a PIN")) > -1) {
                    errorMessage = payment_constants/* storedValueErrors.PIN_REQUIRED */.B_.PIN_REQUIRED;
                }
                // Additional check for captcha errors
                if ((errorResponse === null || errorResponse === void 0 ? void 0 : (ref2 = errorResponse.error) === null || ref2 === void 0 ? void 0 : ref2.error_description.indexOf("We could not validate the authenticity of your request")) > -1) {
                    errorMessage = payment_constants/* storedValueErrors.CAPTCHA */.B_.CAPTCHA;
                }
                return [
                    4,
                    (0,io_22ea0cf9.Z)(payment_actions/* default.storedValueError */.Z.storedValueError(errorMessage))
                ];
            case 8:
                _state.sent();
                // Fire event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.POST_STORED_VALUE_ERROR */.RZ.POST_STORED_VALUE_ERROR, error, errorResponse);
                return [
                    3,
                    9
                ];
            case 9:
                return [
                    2
                ];
        }
    });
}
function payment_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    throttle$1(1500, payment_actions/* default.CREDIT_CARD_TRANSACTION_ID_GET */.Z.CREDIT_CARD_TRANSACTION_ID_GET, creditCardTransactionIdSaga)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    takeLatest$1(orderStatus_actions/* default.STORED_VALUE_POST */.Z.STORED_VALUE_POST, storeValuePostSaga)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    takeLatest$1(payment_actions/* default.STORED_VALUE_TOGGLE */.Z.STORED_VALUE_TOGGLE, paymentTypeToggleSaga)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    takeLatest$1(payment_actions/* default.BILLING_ACCOUNT_SET */.Z.BILLING_ACCOUNT_SET, paymentTypeToggleSaga)
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    takeLatest$1(payment_actions/* default.PAY_IN_STORE_SET */.Z.PAY_IN_STORE_SET, paymentTypeToggleSaga)
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    takeLatest$1(payment_actions/* default.PAYMENT_TYPE_RESET */.Z.PAYMENT_TYPE_RESET, paymentTypeToggleSaga)
                ];
            case 6:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

;// CONCATENATED MODULE: ./src/redux/paymentTypes/saga.ts










/**
 * Get payment
 *
 */ function paymentTypesGetSaga(action) {
    var client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    4,
                    ,
                    6
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getSupportedPaymentTypes */.k6, {
                        locationId: action.locationId,
                        basketId: action.basketId
                    }, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(paymentTypes_actions/* default.paymentTypesGetSuccess */.Z.paymentTypesGetSuccess(response))
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 3:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 4:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, null, error)
                ];
            case 5:
                errorResponse = _state.sent();
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.PAYMENT_TYPES_GET_ERROR */.RZ.PAYMENT_TYPES_GET_ERROR, error, errorResponse);
                return [
                    3,
                    6
                ];
            case 6:
                return [
                    2
                ];
        }
    });
}
function paymentTypes_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(paymentTypes_actions/* default.PAYMENT_TYPES_GET */.Z.PAYMENT_TYPES_GET, paymentTypesGetSaga)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

;// CONCATENATED MODULE: ./src/redux/promoCode/saga.ts















/**
 * Add promo code
 *
 */ function promoCodeAddSaga(action) {
    var state, client, ref, basketId, locationId, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    7,
                    ,
                    11
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                ref = (0,checkout/* getIdsFromState */.jw)(state), basketId = ref.basketId, locationId = ref.locationId;
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* addPromo */.fu, {
                        basketId: basketId,
                        locationId: locationId,
                        promoCode: action.promoCode
                    }, {
                        client: client
                    })
                ];
            case 2:
                response = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.success */.Z.success(response))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(promoCode_actions.promoCodeSet(action.promoCode))
                ];
            case 5:
                _state.sent();
                // Silently get validate basket
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.validateOrder */.Z.validateOrder(response.id, locationId))
                ];
            case 6:
                _state.sent();
                // Events
                (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.order */.m1.order, googleAnalytics/* gaActions.couponApplied */.cE.couponApplied, {
                    label: action.promoCode
                });
                (0,google/* fireGACommerceSelectPromotionEvent */.RU)(state.app.basket, state.app.menu.basketMenu, action.promoCode);
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.PROMO_CODE_APPLIED */.AH.PROMO_CODE_APPLIED);
                return [
                    3,
                    11
                ];
            case 7:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, null, error)
                ];
            case 8:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 9:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 10:
                _state.sent();
                // Events
                (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.order */.m1.order, googleAnalytics/* gaActions.couponDenied */.cE.couponDenied, {
                    label: action.promoCode
                });
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.ADD_PROMO_FAILURE */.RZ.ADD_PROMO_FAILURE, error, errorResponse);
                return [
                    3,
                    11
                ];
            case 11:
                return [
                    2
                ];
        }
    });
}
/**
 * Remove promo code
 *
 */ function promoCodeRemoveSaga(action) {
    var state, client, ref, basketId, locationId, promoCode, ref1, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    10,
                    ,
                    14
                ]);
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 1:
                state = _state.sent();
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                ref = (0,checkout/* getIdsFromState */.jw)(state), basketId = ref.basketId, locationId = ref.locationId;
                promoCode = state.app.promoCode.applied;
                if (!promoCode) return [
                    3,
                    7
                ];
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* removePromo */.fW, {
                        basketId: basketId,
                        promoCode: promoCode,
                        locationId: locationId
                    }, {
                        client: client
                    })
                ];
            case 2:
                response = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.success */.Z.success(response))
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(promoCode_actions.promoCodeSet(""))
                ];
            case 5:
                _state.sent();
                // Silently get validate basket
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.validateOrder */.Z.validateOrder(response.id, (ref1 = response.location) === null || ref1 === void 0 ? void 0 : ref1.id))
                ];
            case 6:
                _state.sent();
                // Events
                (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.order */.m1.order, googleAnalytics/* gaActions.couponRemoved */.cE.couponRemoved, {
                    // @ts-expect-error
                    label: action.promoCode
                });
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.PROMO_CODE_REMOVED */.AH.PROMO_CODE_REMOVED);
                return [
                    3,
                    9
                ];
            case 7:
                // Not sure how we'd end up here but should probably log it
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 8:
                _state.sent();
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.ERROR */.AH.ERROR, {
                    name: constants_events/* ERROR_MESSAGES.CANNOT_FIND_PROMO_TO_REMOVE */.RZ.CANNOT_FIND_PROMO_TO_REMOVE
                });
                _state.label = 9;
            case 9:
                return [
                    3,
                    14
                ];
            case 10:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, null, error)
                ];
            case 11:
                errorResponse = _state.sent();
                // yield put(globalActions.displayErrorToast(errorResponse.message, true));
                return [
                    4,
                    (0,io_22ea0cf9.Z)(promoCode_actions.promoCodeError(errorResponse.message))
                ];
            case 12:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 13:
                _state.sent();
                // Events
                (0,googleAnalytics/* fireGaEvent */.d4)(googleAnalytics/* gaCats.order */.m1.order, googleAnalytics/* gaActions.couponRemovalFailed */.cE.couponRemovalFailed, {
                    // @ts-expect-error
                    label: action.promoCode
                });
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.REMOVE_PROMO_FAILURE */.RZ.REMOVE_PROMO_FAILURE, error, errorResponse);
                return [
                    3,
                    14
                ];
            case 14:
                return [
                    2
                ];
        }
    });
}
function promoCode_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(orderStatus_actions/* default.PROMO_CODE_ADD */.Z.PROMO_CODE_ADD, promoCodeAddSaga)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    takeLatest$1(orderStatus_actions/* default.PROMO_CODE_REMOVE */.Z.PROMO_CODE_REMOVE, promoCodeRemoveSaga)
                ];
            case 2:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

;// CONCATENATED MODULE: ./src/redux/tags/saga.ts





function setActiveTagSaga(action) {
    return (0,tslib_es6.__generator)(this, function(_state) {
        (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.MASTER_CATEGORY_SELECTED */.AH.MASTER_CATEGORY_SELECTED, {
            name: action.label
        });
        return [
            2
        ];
    });
}
function tags_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(tags_actions/* default.SET_ACTIVE_TAG */.Z.SET_ACTIVE_TAG, setActiveTagSaga)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(42838);
;// CONCATENATED MODULE: ./src/redux/timeslots/saga.ts




















function fetchHandoffTimesByLocationSaga(action) {
    var client, response, error, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    7
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getPickupTime */.Wq, {
                        locationId: action.locationId,
                        wantedAtType: action.hoursType,
                        dayWanted: action.wantedAtDay
                    }, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                // Include asap here to avoid mutations downstream
                if (action.includeAsap) {
                    response.unshift(constants_global/* DELIVERY_TIME_WANTED_MODES.ASAP */.hC.ASAP);
                }
                return [
                    4,
                    (0,io_22ea0cf9.Z)(timeslots_actions.fetchHandoffTimesSuccess(constants_global/* TIMESLOT_TYPES.LOCATION_TIMES */.LU.LOCATION_TIMES, response, action.wantedAtDay))
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    7
                ];
            case 3:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, messages/* BASKET_ERROR.getPickupTimesSaga */.Y.getPickupTimesSaga, error)
                ];
            case 4:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 5:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: timeslots_actions.FETCH_HANDOFF_TIMES_FAILURE
                    })
                ];
            case 6:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_HANDOFF_TIMES_BY_LOCATION_ERROR */.RZ.FETCH_HANDOFF_TIMES_BY_LOCATION_ERROR, error, errorResponse);
                return [
                    3,
                    7
                ];
            case 7:
                return [
                    2
                ];
        }
    });
}
function fetchHandoffTimesByBasketSaga(action) {
    var client, response, wantedAt, error, wantedAtDay, strings, errorString, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    11,
                    ,
                    19
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getPickupTimeByBasket */.gk, {
                        basketId: action.basketId,
                        locationId: action.locationId,
                        hoursType: action.hoursType,
                        dayWanted: action.wantedAtDay
                    }, {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                // Include asap here to avoid mutations downstream
                if (action.includeAsap) {
                    response.unshift(constants_global/* DELIVERY_TIME_WANTED_MODES.ASAP */.hC.ASAP);
                }
                if (!(action.previousAction !== orderStatus_actions/* default.POST_INITIALIZE_ORDER */.Z.POST_INITIALIZE_ORDER)) return [
                    3,
                    6
                ];
                if (!(response[0] === constants_global/* DELIVERY_TIME_WANTED_MODES.ASAP */.hC.ASAP)) return [
                    3,
                    3
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.wantedAtBasketRemove */.Z.wantedAtBasketRemove())
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 3:
                if (!response[0]) return [
                    3,
                    5
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.wantedAtBasketSet */.Z.wantedAtBasketSet(response[0]))
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    6
                ];
            case 5:
                // We have no new valid response times--most likely the store is closed.
                // Throw an error to stop execution of this saga, revert to previous wanted at time + basket times,
                // and display a toast error to notify the user.
                throw new dist/* NotModified */.Xm();
            case 6:
                // Store handoff times
                return [
                    4,
                    (0,io_22ea0cf9.Z)(timeslots_actions.fetchHandoffTimesSuccess(constants_global/* TIMESLOT_TYPES.BASKET_TIMES */.LU.BASKET_TIMES, response, action.wantedAtDay))
                ];
            case 7:
                _state.sent();
                if (!(action.previousAction === orderStatus_actions/* default.POST_INITIALIZE_ORDER */.Z.POST_INITIALIZE_ORDER)) return [
                    3,
                    10
                ];
                wantedAt = action.wantedAt || constants_global/* DELIVERY_TIME_WANTED_MODES.ASAP */.hC.ASAP;
                if (!!response.includes(wantedAt)) return [
                    3,
                    10
                ];
                if (!(response[0] !== constants_global/* DELIVERY_TIME_WANTED_MODES.ASAP */.hC.ASAP && response[0])) return [
                    3,
                    9
                ];
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.wantedAtBasketSet */.Z.wantedAtBasketSet(response[0]))
                ];
            case 8:
                _state.sent();
                _state.label = 9;
            case 9:
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.LOG */.AH.LOG, {
                    name: constants_events/* LOG_EVENTS.PERSISTED_WANTED_AT_UNAVAILABLE */.yX.PERSISTED_WANTED_AT_UNAVAILABLE,
                    details: action.wantedAt
                });
                _state.label = 10;
            case 10:
                return [
                    3,
                    19
                ];
            case 11:
                error = _state.sent();
                if (!(0,_instanceof/* default */.Z)(error, dist/* NotModified */.Xm)) return [
                    3,
                    14
                ];
                wantedAtDay = (0,dates/* getFormattedDateInTimezone */.vl)(action.wantedAtDay, constants_dates/* DATE_FORMAT.WRITTEN_OUT_DATE */.z.WRITTEN_OUT_DATE, "+00:00");
                return [
                    4,
                    (0,io_22ea0cf9.a4)(function(state) {
                        return state.app.cmsConfig.strings;
                    })
                ];
            case 12:
                strings = _state.sent();
                errorString = (0,stringHelpers/* safelyGetString */.bc)(strings, "handoff_time.no_available_basket_times", {
                    date: wantedAtDay
                });
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorString, false))
                ];
            case 13:
                _state.sent();
                return [
                    3,
                    17
                ];
            case 14:
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, messages/* BASKET_ERROR.getPickupTimesSaga */.Y.getPickupTimesSaga, error)
                ];
            case 15:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(global_actions/* default.displayErrorToast */.Z.displayErrorToast(errorResponse.message, true))
                ];
            case 16:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.FETCH_HANDOFF_TIMES_BY_BASKET_ERROR */.RZ.FETCH_HANDOFF_TIMES_BY_BASKET_ERROR, error, errorResponse);
                _state.label = 17;
            case 17:
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: timeslots_actions.FETCH_HANDOFF_TIMES_FAILURE
                    })
                ];
            case 18:
                _state.sent();
                return [
                    3,
                    19
                ];
            case 19:
                return [
                    2
                ];
        }
    });
}
function wantedAtBasketSetSaga(action) {
    var state, client, ref, basketId, locationId, response, error, ref1, state1, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    6,
                    ,
                    12
                ]);
                // Eagerly store wanted at in redux, pre-API call
                return [
                    4,
                    (0,io_22ea0cf9.Z)(timeslots_actions.setWantedAt(action.wantedAt))
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 2:
                state = _state.sent();
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                ref = (0,checkout/* getIdsFromState */.jw)(state), basketId = ref.basketId, locationId = ref.locationId;
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* setPickupTime */.cq, {
                        basketId: basketId,
                        locationId: locationId,
                        wanted_at: action.wantedAt
                    }, {
                        client: client
                    })
                ];
            case 3:
                response = _state.sent();
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.success */.Z.success(response))
                ];
            case 5:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.BASKET_WANTED_AT_UPDATE */.AH.BASKET_WANTED_AT_UPDATE);
                return [
                    3,
                    12
                ];
            case 6:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 8:
                state1 = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(timeslots_actions.setWantedAt((ref1 = state1.app.basket.checkoutBasket) === null || ref1 === void 0 ? void 0 : ref1.wanted_at, true))
                ];
            case 9:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, messages/* BASKET_ERROR.setPickupTimeSaga */.Y.setPickupTimeSaga, error)
                ];
            case 10:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderStatusMessageErrorSet */.Z.orderStatusMessageErrorSet(errorResponse.message))
                ];
            case 11:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.SET_PICKUP_TIME_ERROR */.RZ.SET_PICKUP_TIME_ERROR, error, errorResponse);
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
function wantedAtBasketRemoveSaga() {
    var state, client, ref, basketId, locationId, response, error, ref1, state1, errorResponse;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    6,
                    ,
                    12
                ]);
                // Eagerly store wanted at in redux, pre-API call
                return [
                    4,
                    (0,io_22ea0cf9.Z)(timeslots_actions.setWantedAt(null))
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 2:
                state = _state.sent();
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                ref = (0,checkout/* getIdsFromState */.jw)(state), basketId = ref.basketId, locationId = ref.locationId;
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* removePickupTime */.Di, {
                        basketId: basketId,
                        locationId: locationId
                    }, {
                        client: client
                    })
                ];
            case 3:
                response = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 4:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(basket_actions/* default.success */.Z.success(response))
                ];
            case 5:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsEvent */.G)(constants_events/* K_ANALYTICS_EVENTS.BASKET_WANTED_AT_UPDATE */.AH.BASKET_WANTED_AT_UPDATE);
                return [
                    3,
                    12
                ];
            case 6:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderPending */.Z.orderPending())
                ];
            case 7:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.a4)()
                ];
            case 8:
                state1 = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(timeslots_actions.setWantedAt((ref1 = state1.app.basket.checkoutBasket) === null || ref1 === void 0 ? void 0 : ref1.wanted_at, true))
                ];
            case 9:
                _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.O)(global/* prepareErrorMessage */.Xr, messages/* BASKET_ERROR.setPickupTimeSaga */.Y.setPickupTimeSaga, error)
                ];
            case 10:
                errorResponse = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)(orderStatus_actions/* default.orderStatusMessageErrorSet */.Z.orderStatusMessageErrorSet(errorResponse.message))
                ];
            case 11:
                _state.sent();
                // KA event
                (0,koalaAnalytics/* fireKAnalyticsError */.hN)(constants_events/* ERROR_MESSAGES.REMOVE_PICKUP_TIME_ERROR */.RZ.REMOVE_PICKUP_TIME_ERROR, error, errorResponse);
                return [
                    3,
                    12
                ];
            case 12:
                return [
                    2
                ];
        }
    });
}
function timeslots_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(timeslots_actions.FETCH_HANDOFF_TIMES_BY_BASKET, fetchHandoffTimesByBasketSaga)
                ];
            case 1:
                _state.sent();
                return [
                    4,
                    takeLatest$1(timeslots_actions.FETCH_HANDOFF_TIMES_BY_LOCATION, fetchHandoffTimesByLocationSaga)
                ];
            case 2:
                _state.sent();
                return [
                    4,
                    takeLatest$1(orderStatus_actions/* default.WANTED_AT_BASKET_SET */.Z.WANTED_AT_BASKET_SET, wantedAtBasketSetSaga)
                ];
            case 3:
                _state.sent();
                return [
                    4,
                    takeLatest$1(orderStatus_actions/* default.WANTED_AT_BASKET_REMOVE */.Z.WANTED_AT_BASKET_REMOVE, wantedAtBasketRemoveSaga)
                ];
            case 4:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

;// CONCATENATED MODULE: ./src/redux/upsells/saga.ts









function fetchUpsellsSaga(action) {
    var client, response, error;
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                _state.trys.push([
                    0,
                    3,
                    ,
                    5
                ]);
                client = (0,services_client/* createHttpClient */.d9)({
                    origin: (0,utils/* getOrigin */.P$)(window.location.host)
                });
                return [
                    4,
                    (0,io_22ea0cf9.O)(v4/* getCrossSells */.o, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, action.params), {
                        wanted_at: action.params.wanted_at === constants_global/* DELIVERY_TIME_WANTED_MODES.ASAP */.hC.ASAP ? undefined : action.params.wanted_at
                    }), {
                        client: client
                    })
                ];
            case 1:
                response = _state.sent();
                // Success
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: upsells_actions/* default.UPSELLS_SUCCESS */.Z.UPSELLS_SUCCESS,
                        detail: response.data
                    })
                ];
            case 2:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 3:
                error = _state.sent();
                return [
                    4,
                    (0,io_22ea0cf9.Z)({
                        type: upsells_actions/* default.UPSELLS_FAIL */.Z.UPSELLS_FAIL
                    })
                ];
            case 4:
                _state.sent();
                return [
                    3,
                    5
                ];
            case 5:
                return [
                    2
                ];
        }
    });
}
function upsells_saga_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    takeLatest$1(upsells_actions/* default.FETCH_UPSELLS */.Z.FETCH_UPSELLS, fetchUpsellsSaga)
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

;// CONCATENATED MODULE: ./src/redux/sagas.tsx

























function sagas_rootSaga() {
    return (0,tslib_es6.__generator)(this, function(_state) {
        switch(_state.label){
            case 0:
                return [
                    4,
                    (0,io_22ea0cf9.$)([
                        saga_rootSaga(),
                        auth_saga_rootSaga(),
                        basket_saga_rootSaga(),
                        basketRewards_saga_rootSaga(),
                        commerce_saga_rootSaga(),
                        cmsConfig_saga_rootSaga(),
                        global_saga_rootSaga(),
                        locations_saga_rootSaga(),
                        me_saga_rootSaga(),
                        menu_saga_rootSaga(),
                        rootSaga(),
                        paymentTypes_saga_rootSaga(),
                        payment_saga_rootSaga(),
                        promoCode_saga_rootSaga(),
                        upsells_saga_rootSaga(),
                        orderStatus_saga_rootSaga(),
                        organization_saga_rootSaga(),
                        conveyanceMode_saga_rootSaga(),
                        timeslots_saga_rootSaga(),
                        tags_saga_rootSaga(),
                        customize_saga_rootSaga(),
                        deliveryStatus_saga_rootSaga(),
                        orderDetails_saga_rootSaga()
                    ])
                ];
            case 1:
                _state.sent();
                return [
                    2
                ];
        }
    });
}

// EXTERNAL MODULE: ./src/constants/envConfig.ts + 1 modules
var envConfig = __webpack_require__(73690);
;// CONCATENATED MODULE: ./src/redux/store.ts








/**
 * Applies middleware to the Redux Store and conditionally sets up Redux
 * DevTools in development environments.
 *
 * @param middleware Redux middleware to apply to the store.
 * @returns A Store enhancer with middleware applied.
 */ var bindMiddleware = function(middleware) {
    /**
   * Redux DevTools are only enabled in these deployment environments.
   *
   * @TODO always enable DevTools when developing locally, regardless of env.
   */ var shouldEnableDevTools = [
        "local",
        "dev",
        "staging",
        "sandbox"
    ].includes(envConfig/* ENV */.Vi);
    if (shouldEnableDevTools) {
        return (0,redux_devtools_extension/* composeWithDevTools */.Uo)(redux/* applyMiddleware.apply */.md.apply(void 0, (0,_to_consumable_array/* default */.Z)(middleware)));
    }
    return redux/* applyMiddleware.apply */.md.apply(void 0, (0,_to_consumable_array/* default */.Z)(middleware));
};
/**
 * Configures a Redux Store for use in the app including
 * Redux-Saga middleware and DevTools.
 *
 * @returns a configured Redux Store.
 */ var configureStore = function() {
    /**
   * The Saga middleware must be instantiated for every `configureStore` call
   * in order for Next's Server-Side Rendering to work properly.
   */ var sagaMiddleware = (0,redux_saga_core_npm_proxy_esm/* default */.ZP)();
    // Set up the Redux Store and configure it to use the Saga middleware.
    // @ts-ignore
    var store = (0,redux/* createStore */.MT)(reducers, bindMiddleware([
        sagaMiddleware
    ]));
    // Run the Redux-Saga middleware.
    store.sagaTask = sagaMiddleware.run(sagas_rootSaga);
    return store;
};
/**
 * The Redux Store wrapped by `next-redux-wrapper`. This wrapper acts as the
 * store provider and also reconciles the client and server stores to support
 * Next's server-side & static rendering.
 *
 * One important note: when using `getInitialProps` or `getServerSideProps`,
 * you must use the versions exposed by the wrapper. Client-side components
 * can use `connect` or `useDispatch` / `useStore` as usual.
 *
 * @see https://github.com/kirill-konshin/next-redux-wrapper#getserversideprops
 * @see https://github.com/vercel/next.js/tree/canary/examples/with-redux-saga
 */ var wrapper = createWrapper(configureStore);


/***/ }),

/***/ 28799:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var tagsActions = {
    SET_ACTIVE_TAG: "/koala/tags/SET_ACTIVE_TAG",
    setActiveTag: function(tag) {
        return {
            type: tagsActions.SET_ACTIVE_TAG,
            id: tag.id,
            label: tag.label
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (tagsActions);


/***/ }),

/***/ 38024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ upsellsActions; }
/* harmony export */ });
var upsellsActions = {
    FETCH_UPSELLS: "/koala/upsells/FETCH_UPSELLS",
    UPSELLS_SUCCESS: "/koala/upsells/UPSELLS_SUCCESS",
    UPSELLS_FAIL: "/koala/upsells/UPSELLS_FAIL",
    fetchUpsells: function(params) {
        return {
            params: params,
            type: upsellsActions.FETCH_UPSELLS
        };
    }
};
/* harmony default export */ __webpack_exports__["Z"] = (upsellsActions);


/***/ }),

/***/ 44277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "d9": function() { return /* binding */ createHttpClient; },
  "kp": function() { return /* binding */ getClientToken; },
  "qm": function() { return /* binding */ getLoyaltyToken; },
  "UX": function() { return /* binding */ primeClientToken; },
  "I0": function() { return /* binding */ resetLoyaltyToken; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../packages/sdk/dist/v4/index.mjs + 8 modules
var v4 = __webpack_require__(40024);
// EXTERNAL MODULE: ./src/constants/envConfig.ts + 1 modules
var envConfig = __webpack_require__(73690);
;// CONCATENATED MODULE: ./src/services/token-cache.ts
var tokenCache = new Map();
function isValidToken(entry) {
    if (!entry) {
        return false;
    }
    return entry.expiresAt > Date.now();
}
function getCachedToken(origin) {
    var entry = tokenCache.get(origin);
    if (!isValidToken(entry)) {
        if (entry) {
            tokenCache.delete(origin);
        }
        return null;
    }
    return entry.token;
}
function setCachedToken(origin, token) {
    var expiresAt = Date.now() + token.expires_in * 1000;
    tokenCache.set(origin, {
        token: token,
        expiresAt: expiresAt
    });
}

// EXTERNAL MODULE: ./src/utils/android.ts
var android = __webpack_require__(90484);
;// CONCATENATED MODULE: ./src/services/client.ts








var inFlightTokens = new Map();
function createHttpClient(param) {
    var origin = param.origin;
    var androidDeviceId = (0,android/* getAndroidShellDeviceId */.lj)();
    var androidVersion = (0,android/* getAndroidShellVersion */.i)();
    var persistedToken = (0,v4/* getPersistedToken */.Pc)({
        origin: origin
    });
    var cachedToken = persistedToken ? null : getCachedToken(origin);
    return (0,v4/* httpClient */.Mb)({
        credentials: {
            clientId: envConfig/* clientId */.I4,
            clientSecret: envConfig/* clientSecret */.Gs
        },
        env: envConfig/* ENV */.Vi,
        headers: (0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, androidDeviceId && {
            androidDeviceId: androidDeviceId
        }, androidVersion && {
            androidVersion: androidVersion
        }), {
            serviceLabel: "Koala Web Ordering / ".concat(envConfig/* BUILD_VERSION */.bS)
        }), cachedToken && {
            Authorization: "Bearer ".concat(cachedToken.access_token)
        }),
        origin: origin
    });
}
function getClientToken(_) {
    return _getClientToken.apply(this, arguments);
}
function _getClientToken() {
    _getClientToken = (0,_async_to_generator/* default */.Z)(function(param) {
        var origin, androidDeviceId, androidVersion;
        return (0,tslib_es6.__generator)(this, function(_state) {
            origin = param.origin;
            androidDeviceId = (0,android/* getAndroidShellDeviceId */.lj)();
            androidVersion = (0,android/* getAndroidShellVersion */.i)();
            return [
                2,
                (0,v4/* fetchClientToken */.Es)({
                    credentials: {
                        clientId: envConfig/* clientId */.I4,
                        clientSecret: envConfig/* clientSecret */.Gs
                    },
                    env: envConfig/* ENV */.Vi,
                    headers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, androidDeviceId && {
                        androidDeviceId: androidDeviceId
                    }, androidVersion && {
                        androidVersion: androidVersion
                    }), {
                        serviceLabel: "Koala Web Ordering / ".concat(envConfig/* BUILD_VERSION */.bS)
                    }),
                    origin: origin
                })
            ];
        });
    });
    return _getClientToken.apply(this, arguments);
}
function primeClientToken(_) {
    return _primeClientToken.apply(this, arguments);
}
function _primeClientToken() {
    _primeClientToken = (0,_async_to_generator/* default */.Z)(function(param) {
        var origin, persistedToken, cachedToken, inflight, androidDeviceId, androidVersion, tokenPromise;
        return (0,tslib_es6.__generator)(this, function(_state) {
            origin = param.origin;
            persistedToken = (0,v4/* getPersistedToken */.Pc)({
                origin: origin
            });
            if (persistedToken) {
                setCachedToken(origin, persistedToken);
                return [
                    2,
                    persistedToken
                ];
            }
            cachedToken = getCachedToken(origin);
            if (cachedToken) {
                return [
                    2,
                    cachedToken
                ];
            }
            inflight = inFlightTokens.get(origin);
            if (inflight) {
                return [
                    2,
                    inflight
                ];
            }
            androidDeviceId = (0,android/* getAndroidShellDeviceId */.lj)();
            androidVersion = (0,android/* getAndroidShellVersion */.i)();
            tokenPromise = (0,v4/* fetchClientToken */.Es)({
                credentials: {
                    clientId: envConfig/* clientId */.I4,
                    clientSecret: envConfig/* clientSecret */.Gs
                },
                env: envConfig/* ENV */.Vi,
                headers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, androidDeviceId && {
                    androidDeviceId: androidDeviceId
                }, androidVersion && {
                    androidVersion: androidVersion
                }), {
                    serviceLabel: "Koala Web Ordering / ".concat(envConfig/* BUILD_VERSION */.bS)
                }),
                origin: origin
            }).then(function(token) {
                setCachedToken(origin, token);
                (0,v4/* persistToken */.s8)({
                    origin: origin,
                    token: token
                });
                return token;
            }).finally(function() {
                inFlightTokens.delete(origin);
            });
            inFlightTokens.set(origin, tokenPromise);
            return [
                2,
                tokenPromise
            ];
        });
    });
    return _primeClientToken.apply(this, arguments);
}
function getLoyaltyToken(payload, _) {
    return _getLoyaltyToken.apply(this, arguments);
}
function _getLoyaltyToken() {
    _getLoyaltyToken = (0,_async_to_generator/* default */.Z)(function(payload, param) {
        var origin, androidDeviceId, androidVersion;
        return (0,tslib_es6.__generator)(this, function(_state) {
            origin = param.origin;
            androidDeviceId = (0,android/* getAndroidShellDeviceId */.lj)();
            androidVersion = (0,android/* getAndroidShellVersion */.i)();
            return [
                2,
                (0,v4/* fetchLoyaltyToken */.y$)({
                    credentials: {
                        clientId: envConfig/* clientId */.I4,
                        clientSecret: envConfig/* clientSecret */.Gs
                    },
                    env: envConfig/* ENV */.Vi,
                    headers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, androidDeviceId && {
                        androidDeviceId: androidDeviceId
                    }, androidVersion && {
                        androidVersion: androidVersion
                    }), {
                        serviceLabel: "Koala Web Ordering / ".concat(envConfig/* BUILD_VERSION */.bS)
                    }),
                    origin: origin,
                    payload: payload
                })
            ];
        });
    });
    return _getLoyaltyToken.apply(this, arguments);
}
function resetLoyaltyToken(param) {
    var origin = param.origin;
    var androidDeviceId = (0,android/* getAndroidShellDeviceId */.lj)();
    var androidVersion = (0,android/* getAndroidShellVersion */.i)();
    return (0,v4/* resetToken */.Eu)({
        credentials: {
            clientId: envConfig/* clientId */.I4,
            clientSecret: envConfig/* clientSecret */.Gs
        },
        env: envConfig/* ENV */.Vi,
        headers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, androidDeviceId && {
            androidDeviceId: androidDeviceId
        }, androidVersion && {
            androidVersion: androidVersion
        }), {
            serviceLabel: "Koala Web Ordering / ".concat(envConfig/* BUILD_VERSION */.bS)
        }),
        origin: origin
    });
}


/***/ }),

/***/ 44973:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X7": function() { return /* binding */ WindowMessageEvents; },
  "AA": function() { return /* binding */ contentGetCmsUrl; },
  "XG": function() { return /* binding */ contentSetupAPIRequests; },
  "PO": function() { return /* binding */ useWindowMessaging; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ../../node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(22970);
// EXTERNAL MODULE: ../../node_modules/wonka/dist/wonka.mjs
var wonka = __webpack_require__(94177);
// EXTERNAL MODULE: ../../node_modules/@urql/core/dist/urql-core.mjs
var urql_core = __webpack_require__(93466);
// EXTERNAL MODULE: ../../node_modules/@urql/core/dist/urql-core-chunk.mjs + 1 modules
var urql_core_chunk = __webpack_require__(97123);
;// CONCATENATED MODULE: ../../node_modules/@urql/exchange-auth/dist/urql-exchange-auth.mjs




const addAuthAttemptToOperation = (t, e) => (0,urql_core/* makeOperation */.vx)(t.kind, t, {
  ...t.context,
  authAttempt: e
});

function authExchange({addAuthToOperation: m, getAuth: p, didAuthError: k, willAuthError: w}) {
  return ({client: x, forward: y}) => {
    const A = new Map;
    const {source: E, next: S} = (0,wonka/* makeSubject */.nN)();
    let g = null;
    return t => {
      function mutate(t, e, n) {
        const o = x.createRequestOperation("mutation", (0,urql_core_chunk.h)(t, e), n);
        return (0,wonka/* toPromise */.Vi)((0,wonka/* take */.qn)(1)((0,wonka/* filter */.hX)((t => t.operation.key === o.key))((0,wonka/* onStart */.Hr)((() => S(o)))(R))));
      }
      const updateAuthState = t => {
        g = t;
        q = void 0;
        A.forEach(S);
        A.clear();
      };
      let q = Promise.resolve().then((() => p({
        authState: g,
        mutate
      }))).then(updateAuthState);
      const refreshAuth = t => {
        t = addAuthAttemptToOperation(t, !0);
        A.set(t.key, t);
        if (!q) {
          q = p({
            authState: g,
            mutate
          }).then(updateAuthState).catch((() => updateAuthState(null)));
        }
      };
      const v = (0,wonka/* share */.BN)(t);
      const O = (0,wonka/* filter */.hX)((t => "teardown" === t.kind))(v);
      const M = (0,wonka/* filter */.hX)((t => "teardown" !== t.kind))(v);
      const P = (0,wonka/* map */.UI)((t => m({
        operation: t,
        authState: g
      })))((0,wonka/* merge */.TS)([ E, (0,wonka/* mergeMap */.zg)((t => {
        if (A.has(t.key)) {
          return wonka/* empty */.cS;
        }
        if (!q && w && w({
          operation: t,
          authState: g
        })) {
          refreshAuth(t);
          return wonka/* empty */.cS;
        } else if (!q) {
          return (0,wonka/* fromValue */._A)(addAuthAttemptToOperation(t, !1));
        }
        const e = (0,wonka/* filter */.hX)((e => "teardown" === e.kind && e.key === t.key))(v);
        return (0,wonka/* takeUntil */.Rs)(e)((0,wonka/* map */.UI)((() => addAuthAttemptToOperation(t, !1)))((0,wonka/* fromPromise */.p4)(q)));
      }))(M) ]));
      const R = (0,wonka/* share */.BN)(y((0,wonka/* merge */.TS)([ P, O ])));
      return (0,wonka/* filter */.hX)((({error: t, operation: e}) => {
        if (t && k && k({
          error: t,
          authState: g
        })) {
          if (!e.context.authAttempt) {
            refreshAuth(e);
            return !1;
          }
        }
        return !0;
      }))(R);
    };
  };
}


//# sourceMappingURL=urql-exchange-auth.mjs.map

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/urql/node_modules/@urql/core/dist/urql-core.mjs
var dist_urql_core = __webpack_require__(54569);
// EXTERNAL MODULE: ./src/services/client.ts + 1 modules
var client = __webpack_require__(44277);
// EXTERNAL MODULE: ./src/constants/envConfig.ts + 1 modules
var envConfig = __webpack_require__(73690);
;// CONCATENATED MODULE: ./src/services/content.service.ts










function contentGetApiUrl(env) {
    switch(env){
        case "dev":
            return "https://dev.api.koala.io/content/graphql";
        case "staging":
            return "https://staging.api.koala.io/content/graphql";
        case "sandbox":
            return "https://sandbox.api.koala.io/content/graphql";
        case "production":
            return "https://api.koala.io/content/graphql";
    }
}
function contentGetCmsUrl() {
    if (true) {
        switch(envConfig/* ENV */.Vi){
            case "dev":
                return "https://dev.cms.koala.io";
            case "staging":
                return "https://staging.cms.koala.io";
            case "sandbox":
                return "https://sandbox.cms.koala.io";
            case "production":
                return "https://cms.koala.io";
        }
    }
    return "http://localhost:3001";
}
function contentSetupAPIRequests(ssr, meta) {
    var url = contentGetApiUrl(envConfig/* ENV */.Vi);
    return {
        url: url,
        // URQL version mismatch between urql and @urql/core packages - using 'as any' casts
        exchanges: [
            dist_urql_core/* dedupExchange */.B5,
            dist_urql_core/* cacheExchange */.HG,
            ssr,
            authExchange({
                addAuthToOperation: function(param) {
                    var authState = param.authState, operation = param.operation;
                    if (!(authState === null || authState === void 0 ? void 0 : authState.token)) {
                        return operation;
                    }
                    var _token = authState.token, token_type = _token.token_type, access_token = _token.access_token;
                    var fetchOptions = typeof operation.context.fetchOptions === "function" ? operation.context.fetchOptions() : operation.context.fetchOptions || {};
                    return (0,dist_urql_core/* makeOperation */.vx)(operation.kind, operation, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, operation.context), {
                        fetchOptions: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fetchOptions), {
                            headers: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, fetchOptions.headers), {
                                Authorization: "".concat(token_type, " ").concat(access_token)
                            })
                        })
                    }));
                },
                getAuth: function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
                        var authState, token;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    authState = param.authState;
                                    if (!(!authState && meta)) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        (0,client/* getClientToken */.kp)({
                                            origin: meta.headers["x-request-origin"]
                                        })
                                    ];
                                case 1:
                                    token = _state.sent();
                                    return [
                                        2,
                                        {
                                            token: token
                                        }
                                    ];
                                case 2:
                                    return [
                                        2,
                                        null
                                    ];
                            }
                        });
                    });
                    return function(_) {
                        return _ref.apply(this, arguments);
                    };
                }()
            }),
            dist_urql_core/* fetchExchange */.Ek, 
        ]
    };
}
var WindowMessageEvents;
(function(WindowMessageEvents) {
    WindowMessageEvents["createConnection"] = "create_connection";
    WindowMessageEvents["requestRefresh"] = "request_refresh";
    WindowMessageEvents["confirmRefresh"] = "confirm_refresh";
    WindowMessageEvents["setId"] = "set_id";
    WindowMessageEvents["receivedId"] = "confirm_set_id";
    WindowMessageEvents["selectModule"] = "select_module";
    WindowMessageEvents["highlightModule"] = "highlight_module";
})(WindowMessageEvents || (WindowMessageEvents = {}));
/**
 * A reactified way to do window.postMessage events via a custom hook
 *
 * - The hook handles setting up message events and captures them in a local variable
 * - This implementation is based on being embedded via an iframe, so we expose a `sendParentMessage` function that will post back to the window.parent
 * - A dependency list of stateful items affected by the messaging system can be passed in to ensure everything stays up to date
 * ```
 * const { origin, message } = useWindowMessaging(
 *  "https://cms.koala.io",
 *  [someId]
 * );
 * ```
 * @param windowOrigin
 * @param dependencies
 */ function useWindowMessaging(windowOrigin) {
    var dependencies = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var callback = function callback(event) {
        if (event.origin !== origin) {
            return;
        }
        setMessage((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, event.data), {
            sendBack: function(value) {
                event.source.postMessage(value, event.origin);
            }
        }));
    };
    var ref = (0,react.useState)(), message = ref[0], setMessage = ref[1];
    var ref1 = (0,react.useState)(windowOrigin), origin = ref1[0], setOrigin = ref1[1];
    var listener = (0,react.useCallback)(callback, (0,_to_consumable_array/* default */.Z)(dependencies).concat([
        origin
    ]));
    (0,react.useEffect)(function() {
        window.addEventListener("message", listener);
        return function() {
            window.removeEventListener("message", listener);
        };
    });
    return {
        origin: origin,
        message: message,
        setOrigin: setOrigin,
        sendParentMessage: function(value) {
            try {
                if (!origin) {
                    throw "unable to send message";
                }
                window.parent.postMessage(value, origin);
            } catch (error) {
                console.error(error);
            }
        }
    };
}


/***/ }),

/***/ 19658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kx": function() { return /* binding */ fetchLocation; },
/* harmony export */   "Zy": function() { return /* binding */ fetchMenu; },
/* harmony export */   "vo": function() { return /* binding */ fetchLocationByBrandId; }
/* harmony export */ });
/* harmony import */ var _koala_sdk_v4__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40024);
/* harmony import */ var _services_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44277);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32210);



function fetchLocation(param, param1) {
    var id = param.id, lastUpdatedAt = param.lastUpdatedAt, client = param1.client;
    return (0,_koala_sdk_v4__WEBPACK_IMPORTED_MODULE_0__/* .getLocation */ .k$)({
        id: id,
        meta: {
            include: [
                "operating_hours",
                "attributes",
                "delivery_hours",
                "business_hours", 
            ]
        },
        ifModifiedSince: lastUpdatedAt
    }, {
        client: client
    });
}
function fetchLocationByBrandId(brand_id, param) {
    var client = param.client;
    return (0,_koala_sdk_v4__WEBPACK_IMPORTED_MODULE_0__/* .getLocationByBrandId */ .g9)({
        brand_id: brand_id,
        meta: {
            include: [
                "operating_hours",
                "attributes",
                "delivery_hours",
                "business_hours", 
            ]
        }
    }, {
        client: client
    });
}
function fetchMenu(param) {
    var id = param.id, wantedAt = param.wantedAt;
    var client = (0,_services_client__WEBPACK_IMPORTED_MODULE_1__/* .createHttpClient */ .d9)({
        origin: (0,_utils__WEBPACK_IMPORTED_MODULE_2__/* .getOrigin */ .P$)(window.location.host)
    });
    return (0,_koala_sdk_v4__WEBPACK_IMPORTED_MODULE_0__/* .getMenu */ .r7)({
        id: id,
        wantedAt: wantedAt
    }, {
        client: client
    });
}


/***/ }),

/***/ 20321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sh": function() { return /* binding */ removeSelectedPopularItem; },
/* harmony export */   "U7": function() { return /* binding */ getSelectedPopularItem; },
/* harmony export */   "w8": function() { return /* binding */ setSelectedPopularItem; }
/* harmony export */ });
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35196);
/* harmony import */ var cookies_next__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(cookies_next__WEBPACK_IMPORTED_MODULE_0__);

function setSelectedPopularItem(id) {
    (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.setCookie)("selected-popular-item", id, {
        maxAge: 300
    }); // expires after 5 minutes
}
function getSelectedPopularItem() {
    return (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.getCookie)("selected-popular-item");
}
function removeSelectedPopularItem() {
    (0,cookies_next__WEBPACK_IMPORTED_MODULE_0__.deleteCookie)("selected-popular-item");
}


/***/ }),

/***/ 74337:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E5": function() { return /* binding */ OrderStatusTypes; },
/* harmony export */   "bJ": function() { return /* binding */ OrderStatusMessages; },
/* harmony export */   "pf": function() { return /* binding */ OrderStatuses; }
/* harmony export */ });
var OrderStatusTypes;
(function(OrderStatusTypes) {
    OrderStatusTypes["OK"] = "ok";
    OrderStatusTypes["WARNING"] = "warning";
    OrderStatusTypes["ERROR"] = "error";
    OrderStatusTypes["UPDATING"] = "updating";
    OrderStatusTypes["RECONCILIATION"] = "reconciliation";
    OrderStatusTypes["TRANSMITTING"] = "transmitting";
})(OrderStatusTypes || (OrderStatusTypes = {}));
var OrderStatuses;
(function(OrderStatuses) {
    OrderStatuses["ORDER_NOT_INITIALIZED"] = "orderNotInitialized";
    OrderStatuses["ORDER_PENDING"] = "orderPending";
    OrderStatuses["INITIALIZING_ORDER"] = "initializingOrder";
    OrderStatuses["INITIALIZING_ORDER_ERROR"] = "initializingOrderError";
    OrderStatuses["VALIDATING_ORDER"] = "validatingOrder";
    OrderStatuses["PAYMENT_TYPES_GETTING"] = "paymentTypesGetting";
    OrderStatuses["PROMO_CODE_ADDING"] = "promoCodeAdding";
    OrderStatuses["PROMO_CODE_REMOVING"] = "promoCodeRemoving";
    OrderStatuses["BASKET_REWARDS_GETTING"] = "basketRewardsGetting";
    OrderStatuses["BASKET_REWARDS_ADDING"] = "basketRewardsAdding";
    OrderStatuses["BASKET_REWARDS_REMOVING"] = "basketRewardsRemoving";
    OrderStatuses["TIP_ADDING"] = "tipAdding";
    OrderStatuses["UTENSILS_SETTING"] = "utensilsSetting";
    OrderStatuses["BASKET_INSTRUCTIONS_SETTING"] = "basketInstructionsSetting";
    OrderStatuses["CONVEYANCE_SETTING"] = "conveyanceSetting";
    OrderStatuses["CONVEYANCE_DELIVERY_SETTING"] = "conveyanceDeliverySetting";
    OrderStatuses["STORED_VALUE_POSTING"] = "storedValuePosting";
    OrderStatuses["WANTED_AT_BASKET_SETTING"] = "wantedAtBasketSetting";
    OrderStatuses["WANTED_AT_BASKET_REMOVING"] = "wantedAtBasketRemoving";
    OrderStatuses["GETTING_PAYMENT_TOKEN"] = "gettingPaymentToken";
    OrderStatuses["GETTING_PAYMENT_TOKEN_ERROR"] = "gettingPaymentTokenError";
    OrderStatuses["ORDER_SUBMISSION_TRIGGERED"] = "orderSubmissionTriggered";
    OrderStatuses["ORDER_SUBMISSION_PCI_FAILURE"] = "orderSubmissionPciFailure";
    OrderStatuses["ORDER_SUBMISSION_STARTED"] = "orderSubmissionStarted";
    OrderStatuses["ORDER_SUBMISSION_ERROR"] = "orderSubmissionError";
    OrderStatuses["ORDER_COMPLETE"] = "orderComplete";
})(OrderStatuses || (OrderStatuses = {}));
var OrderStatusMessages;
(function(OrderStatusMessages) {
    OrderStatusMessages["INITIALIZING_ORDER_ERROR"] = "An error occurred starting your order.";
    OrderStatusMessages["BASKET_REWARDS_ADDING_ERROR"] = "Oops, an error occurred adding the reward to your order.";
    OrderStatusMessages["BASKET_REWARDS_REMOVING_ERROR"] = "Oops, an error occurred removing the reward from your order.";
    OrderStatusMessages["TIP_ADDING_ERROR"] = "Oops, an error occurred adding a tip to your order.";
    OrderStatusMessages["UTENSIL_SETTING_ERROR"] = "Oops, an error occurred adding utensils to your order.";
    OrderStatusMessages["BASKET_INSTRUCTIONS_SETTING_ERROR"] = "Oops, an error occurred adding your basket instructions.";
    OrderStatusMessages["ORDER_SUBMISSION_ERROR"] = "Oops, an error occurred submitting your order.";
})(OrderStatusMessages || (OrderStatusMessages = {}));


/***/ }),

/***/ 90484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NC": function() { return /* binding */ getAndroidShellPushNotificationToken; },
/* harmony export */   "Y2": function() { return /* binding */ isAndroidShell; },
/* harmony export */   "i": function() { return /* binding */ getAndroidShellVersion; },
/* harmony export */   "lj": function() { return /* binding */ getAndroidShellDeviceId; },
/* harmony export */   "n2": function() { return /* binding */ requestAndroidShellRatingsModal; },
/* harmony export */   "rT": function() { return /* binding */ setAndroidCurrentPage; }
/* harmony export */ });
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25643);

var isAndroidShell = function() {
    return  true && window.KoalaAndroidShell ? true : false;
};
var getAndroidShellPushNotificationToken = function() {
    return isAndroidShell() ? {
        fcm_token: window.KoalaAndroidShell.getPushNotificationsToken()
    } : {};
};
var requestAndroidShellRatingsModal = function() {
    if (isAndroidShell()) {
        window.KoalaAndroidShell.showRatingsModal();
    }
};
var getAndroidShellVersion = function() {
    return isAndroidShell() ? "v".concat(window.KoalaAndroidShell.getVersionName()) : "v1.0.0";
};
var getAndroidShellDeviceId = function() {
    if (!isAndroidShell()) return null;
    // Try to call `getKoalaDeviceId` first
    if (typeof window.KoalaAndroidShell.getKoalaDeviceId === "function") {
        try {
            return window.KoalaAndroidShell.getKoalaDeviceId();
        } catch (e) {
            console.error("Error calling getKoalaDeviceId:", e);
        }
    }
    // Fallback to `getDeviceId` if `getKoalaDeviceId` is not available
    if (typeof window.KoalaAndroidShell.getDeviceId === "function") {
        try {
            return String(window.KoalaAndroidShell.getDeviceId());
        } catch (e1) {
            console.error("Error calling getDeviceId:", e1);
        }
    }
    // Fallback to a random string if neither method works
    console.warn("Falling back to a random device ID.");
    return Math.random().toString(36);
};
var setAndroidCurrentPage = function(pathname, back, push) {
    if ([
        _constants_routes__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.ORDER_CONFIRMATION */ .Z6.ORDER_CONFIRMATION,
        _constants_routes__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.LOGIN */ .Z6.LOGIN,
        _constants_routes__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.HOMEPAGE */ .Z6.HOMEPAGE
    ].includes(pathname)) {
        push(_constants_routes__WEBPACK_IMPORTED_MODULE_0__/* .ROUTES.ANDROID */ .Z6.ANDROID);
    } else {
        back();
    }
};


/***/ }),

/***/ 10606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Nf": function() { return /* binding */ addOptionalPushNotificationToken; },
  "bz": function() { return /* binding */ getExternalAuthInfoFromState; },
  "TQ": function() { return /* binding */ getExtraSignupPayload; },
  "KF": function() { return /* binding */ getParsedJwt; },
  "A5": function() { return /* binding */ getSignupOptionalFields; },
  "Js": function() { return /* binding */ getUserFullName; },
  "NU": function() { return /* binding */ isUser; },
  "mt": function() { return /* binding */ isUserLoggedInForCheckout; },
  "ni": function() { return /* binding */ phoneNumberFormatter; },
  "nD": function() { return /* binding */ userLoggedIn; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../packages/sdk/dist/v4/index.mjs + 8 modules
var v4 = __webpack_require__(40024);
// EXTERNAL MODULE: ./src/constants/authentication.ts
var authentication = __webpack_require__(5125);
;// CONCATENATED MODULE: ./src/types/constants/global_config.ts
// Extend window interface
var AuthProviderLoyaltyIDs;
(function(AuthProviderLoyaltyIDs) {
    AuthProviderLoyaltyIDs[AuthProviderLoyaltyIDs["PUNCHH"] = 2] = "PUNCHH";
    AuthProviderLoyaltyIDs[AuthProviderLoyaltyIDs["PAYTRONIX"] = 3] = "PAYTRONIX";
    AuthProviderLoyaltyIDs[AuthProviderLoyaltyIDs["SPENDGO"] = 4] = "SPENDGO";
    AuthProviderLoyaltyIDs[AuthProviderLoyaltyIDs["OLO"] = 5] = "OLO";
})(AuthProviderLoyaltyIDs || (AuthProviderLoyaltyIDs = {}));

// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(32210);
// EXTERNAL MODULE: ./src/utils/android.ts
var android = __webpack_require__(90484);
// EXTERNAL MODULE: ./src/utils/errorReporter.ts
var errorReporter = __webpack_require__(19663);
;// CONCATENATED MODULE: ./src/utils/auth.ts







var isUserLoggedInForCheckout = function(me, guestUser) {
    return Boolean(me === null || me === void 0 ? void 0 : me.id) || Boolean(guestUser);
};
var userLoggedIn = function() {
    return (0,v4/* validateLoyaltyToken */.XA)((0,utils/* getOrigin */.P$)(window.location.host));
};
var isUser = function(user) {
    return !!(user === null || user === void 0 ? void 0 : user.id);
};
var phoneNumberFormatter = function(phone) {
    phone = phone.replace(/[^\d]/g, "");
    if (phone.length === 10) {
        return phone.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
    }
    return null;
};
var getSignupOptionalFields = function(loyaltyDriverId) {
    switch(loyaltyDriverId){
        case AuthProviderLoyaltyIDs.PAYTRONIX:
        case AuthProviderLoyaltyIDs.SPENDGO:
            return [
                authentication/* SIGNUP_OPTIONAL_FIELDS.OPT_IN */.ZV.OPT_IN,
                authentication/* SIGNUP_OPTIONAL_FIELDS.BIRTHDAY */.ZV.BIRTHDAY,
                authentication/* SIGNUP_OPTIONAL_FIELDS.TERMS_AND_CONDITIONS */.ZV.TERMS_AND_CONDITIONS, 
            ];
        case AuthProviderLoyaltyIDs.PUNCHH:
            return [
                authentication/* SIGNUP_OPTIONAL_FIELDS.TERMS_AND_CONDITIONS */.ZV.TERMS_AND_CONDITIONS,
                authentication/* SIGNUP_OPTIONAL_FIELDS.BIRTHDAY */.ZV.BIRTHDAY,
                authentication/* SIGNUP_OPTIONAL_FIELDS.REFERRAL_CODE */.ZV.REFERRAL_CODE, 
            ];
        default:
            return [
                authentication/* SIGNUP_OPTIONAL_FIELDS.ZIP_CODE */.ZV.ZIP_CODE,
                authentication/* SIGNUP_OPTIONAL_FIELDS.TERMS_AND_CONDITIONS */.ZV.TERMS_AND_CONDITIONS, 
            ];
    }
};
var getExtraSignupPayload = function(loyaltyDriverId) {
    switch(loyaltyDriverId){
        // Punchh V2
        case 2:
            return {
                signup_channel: (0,android/* isAndroidShell */.Y2)() ? "MobileEmail" : "WebEmail"
            };
        default:
            return {};
    }
};
/* Fetch feature flags for use in sagas */ var getExternalAuthInfoFromState = function(state) {
    var ref;
    return {
        externalAuthFeatureFlags: (ref = state.app.organization.external_auth) === null || ref === void 0 ? void 0 : ref.features
    };
};
var addOptionalPushNotificationToken = function(values) {
    return (0,_object_spread/* default */.Z)({}, values, (0,android/* getAndroidShellPushNotificationToken */.NC)());
};
var getParsedJwt = function(token) {
    try {
        // https://developer.mozilla.org/en-US/docs/Web/API/atob
        // Disabling eslint for current line as atob is valid way of parsing token in browser environment
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return JSON.parse(atob(token.split(".")[1]));
    } catch (e) {
        errorReporter/* captureException */.Tb(e);
        return;
    }
};
var getUserFullName = function(user) {
    if (user) {
        return "".concat(user.first_name, " ").concat(user.last_name);
    }
    return "";
};


/***/ }),

/***/ 1227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B$": function() { return /* binding */ patchBasketProductOptions; },
/* harmony export */   "DV": function() { return /* binding */ toDollars; },
/* harmony export */   "EI": function() { return /* binding */ prepareExistingOptionsObject; },
/* harmony export */   "HX": function() { return /* binding */ migrateBasketItems; },
/* harmony export */   "IJ": function() { return /* binding */ deriveBasketModifiersList; },
/* harmony export */   "LC": function() { return /* binding */ removeInvalidItemsFromCart; },
/* harmony export */   "Mf": function() { return /* binding */ deriveBasketItemsList; },
/* harmony export */   "Pp": function() { return /* binding */ determineBasketFulfillment; },
/* harmony export */   "RR": function() { return /* binding */ recreateCustomizerProductFromMenuProduct; },
/* harmony export */   "W6": function() { return /* binding */ basketProductsWithOptionPricing; },
/* harmony export */   "Ym": function() { return /* binding */ getTotalTaxesAndFees; },
/* harmony export */   "a4": function() { return /* binding */ invertNumberIfOptionInverted; },
/* harmony export */   "ji": function() { return /* binding */ basketCheckInvalidItems; },
/* harmony export */   "kF": function() { return /* binding */ patchProductOptions; },
/* harmony export */   "ti": function() { return /* binding */ getBasketItemsCountWithQuantity; },
/* harmony export */   "vP": function() { return /* binding */ getCartSubtotal; },
/* harmony export */   "yY": function() { return /* binding */ findOptionByOptionId; },
/* harmony export */   "zk": function() { return /* binding */ checkEqualityBetweenLocalAndRemoteBasketItems; }
/* harmony export */ });
/* unused harmony export getOptionsDictionary */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(96670);
/* harmony import */ var _koala_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80684);
/* harmony import */ var lodash_each__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66073);
/* harmony import */ var lodash_each__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_each__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_fp_flow__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8816);
/* harmony import */ var lodash_fp_flow__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_flow__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var lodash_fp_map__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88846);
/* harmony import */ var lodash_fp_map__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_map__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var lodash_fp_sum__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15919);
/* harmony import */ var lodash_fp_sum__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_fp_sum__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_remove__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82729);
/* harmony import */ var lodash_remove__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_remove__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36304);
/* harmony import */ var _constants_events__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26654);
/* harmony import */ var _constants_global__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66686);
/* harmony import */ var _utils_koalaAnalytics__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(61216);












/**
 * Get subtotal for an array of cart items
 *
 * @param {Array} products - assumes format matches the nullItem
 */ var getCartSubtotal = function(basketItems) {
    // does not currently account for the cost of selected modifiers --> SDK!
    return lodash_fp_flow__WEBPACK_IMPORTED_MODULE_2___default()([
        lodash_fp_map__WEBPACK_IMPORTED_MODULE_3___default()(function(basketItem) {
            // If we have a null item, the product id in our cart no longer exists in the menu
            // This condition will return a price of 0 for the null item so it at least doesn't crash the cart
            // However, the invalid item will still exist in localStorage
            // invalid items are removed from localStorage when INIT_LOCAL_STORAGE_BASKET is fired
            if (!basketItem) {
                return 0;
            }
            if (basketItem.final.final_cost) {
                return basketItem.final.final_cost * basketItem.item.quantity;
            }
            return basketItem.final.cost;
        }),
        (lodash_fp_sum__WEBPACK_IMPORTED_MODULE_4___default()), 
    ])(basketItems);
};
var toDollars = function(x) {
    var quantity = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    if (typeof x === "number") {
        return (x * quantity / 100).toFixed(2);
    }
    return "";
};
var invertNumberIfOptionInverted = function(value, isInverted) {
    if (!isInverted || value === 0) {
        return value;
    }
    return value > 0 ? value * -1 : Math.abs(value);
};
/**
 * Get Taxes & Fees Totals
 *
 */ var getTotalTaxesAndFees = function(checkoutBasket) {
    var total = (checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.sales_tax) + (checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.delivery_fee);
    lodash_each__WEBPACK_IMPORTED_MODULE_1___default()(checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.fees, function(fee) {
        total += fee.amount;
    });
    return (total / 100).toFixed(2);
};
/**
 * Find a MenuProduct by global_id given a menu
 *
 * @param {itemGlobalId} string
 * @param {menuCategories} array
 */ var findMenuItemByGlobalId = function(itemGlobalId, menuCategories) {
    var product;
    lodash_each__WEBPACK_IMPORTED_MODULE_1___default()(menuCategories, function(category) {
        lodash_each__WEBPACK_IMPORTED_MODULE_1___default()(category.products, function(menuProduct) {
            if (menuProduct.global_id === itemGlobalId) {
                product = menuProduct;
                return false;
            }
            return;
        });
        if (product && product.id) {
            return false;
        }
        return;
    });
    return product;
};
var getOptionsDictionary = function(selectedOptions) {
    var newOptionsDictionary = {};
    var _option_id;
    selectedOptions.forEach(function(option) {
        return typeof option === "object" ? newOptionsDictionary[(_option_id = option.option_id) !== null && _option_id !== void 0 ? _option_id : option.id] = option : newOptionsDictionary[option] = {
            id: option,
            quantity: 1
        };
    });
    return newOptionsDictionary;
};
/**
 * @param  {BasketItem["options"]} basketItemOptions - collections of the basket item options selected by user
 * @param  {MenuProductOptionGroup[]} currentLocationProductOptionGroups - collection of option groups of the product that was fetch by product id (per location)
 * @param  {MenuProductOptionGroup[]} newLocationProductOptionGroups - collection of option groups of the product that was fetch by global product id (per brand)
 */ var migrateOptions = function(basketItemOptions, currentLocationProductOptionGroups, newLocationProductOptionGroups) {
    // Create a dictionary of IDs to better keep track of quantities
    var newOptionsDictionary = getOptionsDictionary(basketItemOptions);
    var selectedOptionIdsOnly = Object.keys(newOptionsDictionary);
    var globalOptions = [];
    var migratedOptions = [];
    // Recursive function to search through all the product options until all of the selected options are found.
    /** @TODO improve typing of `currentOptionGroups`. */ var loopThroughOptionGroups = function(currentLocationProductOptionGroups) {
        // Loop through the option groups
        lodash_each__WEBPACK_IMPORTED_MODULE_1___default()(currentLocationProductOptionGroups, function(og) {
            // Loop through the option group options
            lodash_each__WEBPACK_IMPORTED_MODULE_1___default()(og.options, function(productOption) {
                // Base Case for recursion
                // Stop if we've eliminated all the selected options
                if (selectedOptionIdsOnly.length === 0) {
                    return false;
                }
                if (selectedOptionIdsOnly.includes(productOption.id)) {
                    var containsSubOptions = !!productOption.option_groups.length;
                    globalOptions.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, productOption), {
                        quantity: newOptionsDictionary[productOption.id].quantity
                    }));
                    // Remove the found option
                    lodash_remove__WEBPACK_IMPORTED_MODULE_5___default()(selectedOptionIdsOnly, function(selectedOptionId) {
                        return selectedOptionId === productOption.id;
                    });
                    // If the selected option has sub options, search those
                    if (containsSubOptions) {
                        loopThroughOptionGroups(productOption.option_groups);
                    }
                }
            });
            // Stop if we've eliminated all the selected options
            if (selectedOptionIdsOnly.length === 0) {
                return false;
            }
        });
    };
    // Recursive function to search through all the product options until all of the selected options are found.
    var loopThroughNewOptionGroups = function(newLocationProductOptionGroups) {
        // Loop through the option groups
        lodash_each__WEBPACK_IMPORTED_MODULE_1___default()(newLocationProductOptionGroups, function(og) {
            if (og) // Loop through the option group options
            lodash_each__WEBPACK_IMPORTED_MODULE_1___default()(og.options, function(globalProductOption) {
                // Stop if we've eliminated all the selected options
                if (globalOptions.length === 0) {
                    return false;
                }
                var foundGlobalOption = globalOptions.find(function(opt) {
                    return opt.global_option_id === globalProductOption.global_option_id;
                });
                if (foundGlobalOption) {
                    var containsSubOptions = !!globalProductOption.option_groups.length;
                    migratedOptions.push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, globalProductOption), {
                        quantity: foundGlobalOption.quantity
                    }));
                    // Remove the found option
                    lodash_remove__WEBPACK_IMPORTED_MODULE_5___default()(globalOptions, function(so) {
                        return so.global_option_id === globalProductOption.global_option_id;
                    });
                    // If the selected option has sub options, search those
                    if (containsSubOptions) {
                        loopThroughNewOptionGroups(globalProductOption.option_groups);
                    }
                }
            });
            // Stop if we've eliminated all the selected options
            if (globalOptions.length === 0) {
                return false;
            }
        });
    };
    // Start the search for global options
    loopThroughOptionGroups(currentLocationProductOptionGroups);
    // Match the global options with the new options group.
    loopThroughNewOptionGroups(newLocationProductOptionGroups);
    return migratedOptions;
};
/**
 * Find a Option by option id given a option group
 *
 * @param optionId
 * @param optionGroups
 * @TODO improve typing of optionGroups.
 */ var findOptionByOptionId = function(optionId, optionGroups) {
    var optionGroupOption;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        //Search through option groups for the option
        for(var _iterator = optionGroups[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var og = _step.value;
            if (optionGroupOption) {
                break;
            }
            optionGroupOption = og.options.find(function(o) {
                return o.id === optionId;
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return optionGroupOption;
};
var migrateBasketItems = function(basketItems, menuCategories, newMenuCategories) {
    var productsNotMatched = [];
    var migratedBasketItems = basketItems.map(function(item) {
        var migratedItem = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, item);
        var currentLocationProduct = _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkUtils.findMenuItemById */ .fH.findMenuItemById(migratedItem.product.id, menuCategories);
        // Logic:
        // 1. we get current location product from menu by product id that user put in basket
        // 2. if that product found -> we try to find same product by global id for future location
        // 3. once that product found in new location menu we try to migrate options and apply them to existing basket item
        // 4. else we push current location product to not matched products collection
        if (currentLocationProduct) {
            var newLocationProduct = findMenuItemByGlobalId(currentLocationProduct.global_id, newMenuCategories);
            if (newLocationProduct) {
                var migratedOptions = migrateOptions(item.options, currentLocationProduct.option_groups, newLocationProduct.option_groups);
                migratedItem.product.id = newLocationProduct.id;
                var _quantity;
                // TODO: remove that mapping when we sync Basket Item Option model with Product Option Model
                migratedItem.options = migratedOptions.map(function(productOption) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, productOption), {
                        quantity: (_quantity = productOption.quantity) !== null && _quantity !== void 0 ? _quantity : 0
                    });
                });
                return migratedItem;
            }
        } else {
            // This indicates that there is a mismatch between the current basket location and the localStorage menu
            (0,_utils_koalaAnalytics__WEBPACK_IMPORTED_MODULE_9__/* .fireKAnalyticsEvent */ .G)(_constants_events__WEBPACK_IMPORTED_MODULE_7__/* .K_ANALYTICS_EVENTS.ERROR */ .AH.ERROR, {
                name: _constants_events__WEBPACK_IMPORTED_MODULE_7__/* .ERROR_MESSAGES.BASKET_MENU_MISMATCH */ .RZ.BASKET_MENU_MISMATCH
            });
        }
        // Not Found
        if (currentLocationProduct) {
            productsNotMatched.push(currentLocationProduct);
        }
    }).filter(function(item) {
        return item !== undefined;
    });
    return {
        migratedBasketItems: migratedBasketItems,
        productsNotMatched: productsNotMatched
    };
};
function patchProductOptions(basketItem) {
    var _option_id;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, basketItem), {
        options: basketItem.options.map(function(option) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, option), {
                option_id: (_option_id = option.option_id) !== null && _option_id !== void 0 ? _option_id : option.id
            });
        })
    });
}
var patchBasketProductOptions = function(basketOrder) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, basketOrder), {
        basket_items: basketOrder.basket_items.map(patchProductOptions)
    });
};
var basketCheckInvalidItems = function(basketItems, menuCategories) {
    return basketItems.filter(function(item) {
        return !_koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkUtils.findMenuItemById */ .fH.findMenuItemById(item.product.id, menuCategories);
    });
};
// Method to remove cart items that can not be found in the menu categories.
// whoever calls this method should use it to update in localStorage
var removeInvalidItemsFromCart = function(basketItems, menuCategories) {
    var validItems = [];
    basketItems.forEach(function(item) {
        var menuProduct = _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkUtils.findMenuItemById */ .fH.findMenuItemById(item.product.id, menuCategories);
        if (menuProduct) {
            validItems.push(item);
        }
    });
    return validItems;
};
/*
 * Recreates a Customizer product with existingOptions passed in (for editing a product)
 */ var recreateCustomizerProductFromMenuProduct = function(product, options) {
    // Recreate existingOptions object
    var existingOptions = prepareExistingOptionsObject(options);
    // Create new Customizer product with existingOptions
    var customize = new _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .Customizer */ .Nc(product, existingOptions);
    return customize.getProduct();
};
/*
 * Creates `existingOptions` object to pass to Customizer
 *
 * It seems that this function create object with basket item option id and its quantity.
 * The problem function is trying to solve is that at some point options are passed whether as:
 * - array of string
 * - BasketItemOption without option_id and id matching id of menu option
 * - BasketItemOption with option_id that matches id of menu option and id that is unique and does not match id of menu option
 *
 * TODO: This function needs to be refactored.
 * We need to narrow down why and where Basket Item options are populated and set.
 * Why {options} can be passed as array of strings or array of BasketItemOption.
 * We need to make it consistent and end up using one model BasketItemOption where potentially option_id AND id
 * are optional parameters that are set on creating Basket Item option on basket.
 */ var prepareExistingOptionsObject = function(options) {
    var existingOptions = {};
    options.map(function(option) {
        // TODO: Remove casting of option to any when option_id is added to BasketItemOption
        var optionId = typeof option === "string" ? option : (option === null || option === void 0 ? void 0 : option.option_id) ? option === null || option === void 0 ? void 0 : option.option_id : option.id;
        var optionQuantity = typeof option === "string" ? 1 : option.quantity;
        // Create dictionary of existing options and quantities
        existingOptions[optionId] = {
            id: optionId,
            quantity: optionQuantity
        };
    });
    return existingOptions;
};
/* basketProducts is an array of all the selected products trimmed down to their options
 similar to the customization page
 just need to iterate over every branch of the product options to render
 */ var basketProductsWithOptionPricing = function(basketContent, menuCategories) {
    return basketContent.basket_items.map(function(item) {
        var menuProduct = _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkUtils.findMenuItemById */ .fH.findMenuItemById(item.product.id, menuCategories);
        if (menuProduct) {
            var final = recreateCustomizerProductFromMenuProduct(menuProduct, item.options);
            return {
                item: item,
                final: final,
                menuProduct: menuProduct
            };
        }
        return null;
    });
};
/**
 * Determines a basket's fulfillment type based on the priorities, in order of importance:
 *
 * 1. Whether or not the user is in a locked conveyance flow (should always take precedence)
 * 2. Whether or not an address is present
 *
 * @param address deliveryAddress
 * @returns CONVEYANCE_TYPES
 */ var determineBasketFulfillment = function(address) {
    var sessionConveyanceType = (0,_global__WEBPACK_IMPORTED_MODULE_6__/* .getPersistentParameterValue */ .Fc)(_constants_global__WEBPACK_IMPORTED_MODULE_8__/* .ALLOWED_URL_PARAMETER_KEYS.HANDOFF */ .Ue.HANDOFF);
    if (sessionConveyanceType && _constants_global__WEBPACK_IMPORTED_MODULE_8__/* .LOCKED_FLOW_CONVEYANCE_TYPES.includes */ .OH.includes(sessionConveyanceType)) {
        // @ts-expect-error sessionConveyanceType can't index API_FOR_CONVEYANCE_TYPES_SWAP.
        return _constants_global__WEBPACK_IMPORTED_MODULE_8__/* .API_FOR_CONVEYANCE_TYPES_SWAP */ .NX[sessionConveyanceType];
    }
    return address ? _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.DELIVERY */ .P8.DELIVERY : _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.PICKUP */ .P8.PICKUP;
};
/**
 * Derive a comma-separated string of a list of basket items with basket item quantities
 *
 * @param basketItems BasketItem[]
 * @returns string (name and quantity of basket item)
 */ var deriveBasketItemsList = function(basketItems) {
    var formattedBasketItems = basketItems.map(function(basketItem) {
        var name = basketItem.product.name;
        var quantity = basketItem.quantity > 1 ? " x".concat(basketItem.quantity) : "";
        return "".concat(name).concat(quantity);
    });
    return formattedBasketItems.join(", ");
};
/**
 * Derive a comma-separated string of a list of basket item modifiers
 *
 * @param basketItem BasketItem
 * @returns string (list of comma-separated basket items)
 */ var deriveBasketModifiersList = function(basketItem) {
    var modifiers = [];
    basketItem === null || basketItem === void 0 ? void 0 : basketItem.options.map(function(option) {
        return (option === null || option === void 0 ? void 0 : option.name) && modifiers.push(option.name);
    });
    return modifiers.join(", ");
};
var getBasketItemsCountWithQuantity = function(basketItems) {
    var count = 0;
    basketItems.forEach(function(item) {
        count += item.quantity;
    });
    return count;
};
/**
 * A local basket and a remote basket item are almost identical except a local item has no id.
 * This makes checking equality between a remote basket item and a local basket item very difficult.
 * So as a work-around we can compare the following
 * - the product ids match
 * - the option ids match (these are product options like toppings, exclusings, etc)
 * - the recipeint names match (defaults to an empty string)
 * - the special instructions match (defaults to an emptry string)
 *
 * Essentially, we are cross referencing every unique value possible since we don't have per basket unique ids
 *
 * THIS IS NOT A FULLY ACCURATE COMPARISON!
 * ONLY USE WHEN COMPARING LOCAL ITEMS WITH REMOTE ITEMS!
 */ function checkEqualityBetweenLocalAndRemoteBasketItems(localItem, remoteItem) {
    var _option_id;
    return localItem.product.id === remoteItem.product.id && localItem.recipient === remoteItem.recipient && localItem.special_instructions === remoteItem.special_instructions && localItem.options.map(function(o) {
        return (_option_id = o.option_id) !== null && _option_id !== void 0 ? _option_id : o.id;
    }).sort().join() === remoteItem.options.map(function(o) {
        return o.option_id;
    }).sort().join();
}


/***/ }),

/***/ 32197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ isBreakpointSizeMin; }
/* harmony export */ });
var isBreakpointSizeMin = function(size) {
    if (false) {}
    switch(size){
        case "small":
            return window.matchMedia("(min-width: 576px)").matches;
        case "medium":
            return window.matchMedia("(min-width: 768px)").matches;
        case "large":
            return window.matchMedia("(min-width: 1025px)").matches;
        default:
            return false;
    }
};


/***/ }),

/***/ 47080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Of": function() { return /* binding */ assembleDeliveryObjectFromState; },
/* harmony export */   "R5": function() { return /* binding */ assignPaymentAmounts; },
/* harmony export */   "Tc": function() { return /* binding */ getInitializationErrorType; },
/* harmony export */   "Tn": function() { return /* binding */ formatExpiry; },
/* harmony export */   "UC": function() { return /* binding */ normalizeExpiry; },
/* harmony export */   "VW": function() { return /* binding */ assemblePayment; },
/* harmony export */   "c3": function() { return /* binding */ assembleOrderDataFromState; },
/* harmony export */   "dJ": function() { return /* binding */ handlePciProxyIFrameChangeEvent; },
/* harmony export */   "ip": function() { return /* binding */ getLocationFromState; },
/* harmony export */   "jw": function() { return /* binding */ getIdsFromState; },
/* harmony export */   "y": function() { return /* binding */ isGuestOrUser; }
/* harmony export */ });
/* unused harmony export assignPaymentTips */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96670);
/* harmony import */ var _koala_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80684);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36304);
/* harmony import */ var _constants_basket__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65001);
/* harmony import */ var _constants_events__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26654);
/* harmony import */ var _constants_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66686);
/* harmony import */ var _utils_basket__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1227);
/* harmony import */ var _utils_validation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78080);









var isGuestOrUser = function(guestUser, me) {
    return !!guestUser || !!(me === null || me === void 0 ? void 0 : me.id);
};
var getIdsFromState = function(state) {
    var ref, ref1, ref2;
    var locationId = (ref = state.app.basket.checkoutBasket) === null || ref === void 0 ? void 0 : (ref1 = ref.location) === null || ref1 === void 0 ? void 0 : ref1.id;
    var basketId = (ref2 = state.app.basket.checkoutBasket) === null || ref2 === void 0 ? void 0 : ref2.id;
    return {
        basketId: basketId,
        locationId: locationId
    };
};
var getLocationFromState = function(state) {
    var ref;
    return (ref = state.app.basket) === null || ref === void 0 ? void 0 : ref.location;
};
var normalizeExpiry = function(value, previousValue) {
    if (value) {
        var expires = value.replace(/\D/g, "").substr(0, 4);
        var length = value.length;
        // Allow the user to type in the /
        if (length === 3 && value.slice(2) === "/") {
            return value;
        }
        // User can delete the /
        if (previousValue && length === 2 && previousValue.slice(2) === "/") {
            return expires;
        }
        // Or just add / for them
        if (expires.length > 1) {
            expires = expires.substr(0, 2) + "/" + expires.substr(2);
        }
        // return a single digit
        return expires;
    }
    return "";
};
var formatExpiry = function(expiry) {
    var expParts = expiry ? expiry.split("/") : [];
    return {
        expiry_month: parseInt(expParts[0], 0),
        expiry_year: parseInt("20".concat(expParts[1]), 0)
    };
};
/** @TODO refactor this component to remove recursion. */ var capturePhone = function(reconciledPhone) {
    var validationMessage = reconciledPhone !== null ? "\n10 digits without spaces or dashes." : "";
    reconciledPhone = prompt("Whoops, we need a phone number in order to check out! ".concat(validationMessage), reconciledPhone || "");
    if (reconciledPhone) {
        reconciledPhone = reconciledPhone.replace(/[^0-9.]/g, "");
    }
    if (reconciledPhone !== null && (0,_utils_validation__WEBPACK_IMPORTED_MODULE_6__/* .invalidPhone */ .Dj)(reconciledPhone)) {
        return capturePhone(reconciledPhone);
    }
    return reconciledPhone;
};
var assemblePayment = function(payment, storedValue, customerDetails, checkoutBasket) {
    if (!payment && !storedValue) {
        throw new Error("Oops, please ensure you've added a payment method.");
    }
    var assembledPayment = [];
    var ref;
    var storedValueBalance = (ref = storedValue === null || storedValue === void 0 ? void 0 : storedValue.balance) !== null && ref !== void 0 ? ref : 0;
    var ref1 = assignPaymentAmounts(checkoutBasket.total, storedValueBalance), paymentMethodAmount = ref1.paymentMethodAmount, storedValueAmount = ref1.storedValueAmount;
    var ref2 = assignPaymentTips(checkoutBasket.tip, storedValue === null || storedValue === void 0 ? void 0 : storedValue.balance), paymentMethodTip = ref2.paymentMethodTip, storedValueTip = ref2.storedValueTip;
    // If a positive stored value has been applied to an order
    if (storedValue && storedValueAmount > 0) {
        var storedValuePayload = getStoredValuePaymentType(storedValue, storedValueAmount, storedValueTip, customerDetails);
        // Another check to ensure the gift card covers the order total
        // in cases where split payment is disabled
        if (!checkoutBasket.location.supports_split_payment && storedValueAmount < checkoutBasket.total) {
            throw new Error("Gift Card balance $".concat((0,_utils_basket__WEBPACK_IMPORTED_MODULE_5__/* .toDollars */ .DV)(storedValueAmount), " does not cover order total. Please try another gift card or a different payment method."));
        }
        // Yet another check to ensure the gift card covers the order total
        // in cases where split payment is ENABLED
        // if the total is greater than the gift card balance and we haven't applied any other payment methods
        if (checkoutBasket.location.supports_split_payment && storedValueAmount < checkoutBasket.total && !(payment === null || payment === void 0 ? void 0 : payment.type)) {
            throw new Error("Gift card balance $".concat((0,_utils_basket__WEBPACK_IMPORTED_MODULE_5__/* .toDollars */ .DV)(storedValueAmount), " does not cover order total. Please cover the remaining balance with another payment method to proceed."));
        }
        assembledPayment.push(storedValuePayload);
    }
    // If there is no remaining balance on the order,
    // do not attempt to assemble the payment method object
    if (paymentMethodAmount === 0) {
        return assembledPayment;
    }
    // This case will only be true if split-payment is disabled
    // and gift card is an option in the payment toggle
    if ((payment === null || payment === void 0 ? void 0 : payment.type) === _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .PAYMENT_TYPES.STORED_VALUE */ .G4.STORED_VALUE && !(storedValue === null || storedValue === void 0 ? void 0 : storedValue.card_number)) {
        throw new Error("Review your gift card or payment method to proceed.");
    }
    if (!payment) {
        throw new Error("Please ensure you've added a payment method.");
    }
    var paymentMethod = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, payment), {
        amount: paymentMethodAmount,
        tip: paymentMethodTip,
        customer: customerDetails
    });
    // Push primary payment method
    assembledPayment.push(paymentMethod);
    return assembledPayment;
};
var getStoredValuePaymentType = function(storedValue, storedValueAmount, storedValueTip, customerDetails) {
    // Assemble stored value reqs
    var storedValueRequirements = [
        {
            name: "number",
            value: storedValue === null || storedValue === void 0 ? void 0 : storedValue.card_number
        }, 
    ];
    // If we have a pin, push that into the payload
    if (storedValue === null || storedValue === void 0 ? void 0 : storedValue.pin) {
        storedValueRequirements.push({
            name: "pin",
            value: storedValue === null || storedValue === void 0 ? void 0 : storedValue.pin
        });
    }
    return {
        type: _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .PAYMENT_TYPES.STORED_VALUE */ .G4.STORED_VALUE,
        amount: storedValueAmount,
        tip: storedValueTip,
        stored_value_requirements: storedValueRequirements,
        customer: customerDetails
    };
};
var getUserDataFromState = function(state) {
    var me = state.app.me.data;
    var guestUser = state.app.auth.guestUser;
    return guestUser !== null && guestUser !== void 0 ? guestUser : (me === null || me === void 0 ? void 0 : me.id) ? me : null;
};
var assembleDeliveryObjectFromState = function(state, instructions, staleId) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var userData = getUserDataFromState(state);
    var basketFulfillment = (ref = state.app.basket) === null || ref === void 0 ? void 0 : ref.fulfillment;
    if (!basketFulfillment) {
        return null;
    }
    var ref12;
    /** @TODO reconcile the IConveyanceDeliveryAddress type. */ var addressObj = {
        id: (ref12 = (ref1 = basketFulfillment.address) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref12 !== void 0 ? ref12 : undefined,
        stale_id: staleId || ((ref2 = basketFulfillment.address) === null || ref2 === void 0 ? void 0 : ref2.stale_id),
        // @ts-expect-error
        day_wanted: (ref3 = basketFulfillment.address) === null || ref3 === void 0 ? void 0 : ref3.day_wanted,
        // @ts-expect-error
        time_wanted: (ref4 = basketFulfillment.address) === null || ref4 === void 0 ? void 0 : ref4.time_wanted,
        // @ts-expect-error
        city: (ref5 = basketFulfillment.address) === null || ref5 === void 0 ? void 0 : ref5.city,
        // @ts-expect-error
        state: (ref6 = basketFulfillment.address) === null || ref6 === void 0 ? void 0 : ref6.state,
        // @ts-expect-error
        street_address: (ref7 = basketFulfillment.address) === null || ref7 === void 0 ? void 0 : ref7.street_address,
        street_address_2: ((ref8 = basketFulfillment.address) === null || ref8 === void 0 ? void 0 : ref8.street_address_2) || null,
        // @ts-expect-error
        zip_code: (ref9 = basketFulfillment.address) === null || ref9 === void 0 ? void 0 : ref9.zip_code,
        // @ts-expect-error
        phone_number: userData === null || userData === void 0 ? void 0 : userData.phone,
        special_instructions: instructions || ((ref10 = basketFulfillment.address) === null || ref10 === void 0 ? void 0 : ref10.special_instructions) || "",
        default: (ref11 = basketFulfillment.address) === null || ref11 === void 0 ? void 0 : ref11.default
    };
    if (addressObj.stale_id) {
        delete addressObj.id;
    }
    return addressObj;
};
var assembleOrderDataFromState = function(state) {
    var ref, ref1;
    var conveyanceModeState = state.app.conveyanceMode;
    var paymentTypeState = state.app.payment.paymentType;
    var storedValueState = state.app.payment.storedValue;
    var checkoutBasket = state.app.basket.checkoutBasket;
    var userData = getUserDataFromState(state);
    // Don't allow basket to be submitted without a phone number
    var reconciledPhone = "";
    if ((0,_utils_validation__WEBPACK_IMPORTED_MODULE_6__/* .invalidPhone */ .Dj)(userData === null || userData === void 0 ? void 0 : userData.phone)) {
        reconciledPhone = capturePhone((userData === null || userData === void 0 ? void 0 : userData.phone) ? userData.phone : null);
        if (!reconciledPhone) {
            throw new Error("Oops, please provide your phone number.");
        }
    }
    // Don't allow basket submission if we are in a locked dine in conveyance with no table number
    // AND location supports_dine_in_table_number
    if ((0,_global__WEBPACK_IMPORTED_MODULE_1__/* .getPersistentParameterValue */ .Fc)(_constants_global__WEBPACK_IMPORTED_MODULE_4__/* .ALLOWED_URL_PARAMETER_KEYS.HANDOFF */ .Ue.HANDOFF) === _constants_events__WEBPACK_IMPORTED_MODULE_3__/* .API_CONVEYANCE_TYPES.DINEIN */ .tQ.DINEIN && !(checkoutBasket === null || checkoutBasket === void 0 ? void 0 : (ref = checkoutBasket.conveyance_type) === null || ref === void 0 ? void 0 : ref.table_tent_number) && (checkoutBasket === null || checkoutBasket === void 0 ? void 0 : checkoutBasket.location.supports_dine_in_table_number)) {
        throw new Error("Oops, please ensure you've entered your table number for dine in.");
    }
    // Don't allow basket submission if there are conveyance mismatches
    if ((conveyanceModeState === null || conveyanceModeState === void 0 ? void 0 : conveyanceModeState.type) !== // @ts-expect-error `conveyance_type.type` can't index `API_FOR_CONVEYANCE_TYPES_SWAP`.
    _constants_global__WEBPACK_IMPORTED_MODULE_4__/* .API_FOR_CONVEYANCE_TYPES_SWAP */ .NX[checkoutBasket === null || checkoutBasket === void 0 ? void 0 : (ref1 = checkoutBasket.conveyance_type) === null || ref1 === void 0 ? void 0 : ref1.type]) {
        if ((conveyanceModeState === null || conveyanceModeState === void 0 ? void 0 : conveyanceModeState.type) === _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.CURBSIDE */ .P8.CURBSIDE) {
            throw new Error("Oops, please ensure you've submitted your vehicle details for curbside pickup.");
        }
        throw new Error("Oops, there was an error setting your handoff mode. Please refresh this page and try again.");
    }
    /** @TODO reconcile the CustomerDetails type. */ var customerDetails = {
        // @ts-expect-error
        first_name: userData === null || userData === void 0 ? void 0 : userData.first_name,
        // @ts-expect-error
        last_name: userData === null || userData === void 0 ? void 0 : userData.last_name,
        // @ts-expect-error
        email: userData === null || userData === void 0 ? void 0 : userData.email,
        contact_number: (userData === null || userData === void 0 ? void 0 : userData.phone) || reconciledPhone
    };
    var orderData = {
        payment: assemblePayment(paymentTypeState, storedValueState, customerDetails, checkoutBasket),
        customer: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, customerDetails), {
            opt_in: userData === null || userData === void 0 ? void 0 : userData.opt_in,
            email_receipt: false
        }),
        allergies: []
    };
    return orderData;
};
var assignPaymentAmounts = function(checkoutTotal, storedValueBalance) {
    // Payment type covers the current checkout total by default
    var paymentMethodAmount = checkoutTotal;
    var storedValueAmount = 0;
    var storedValueRemaining = 0;
    // If we have a gift card
    if (storedValueBalance > 0) {
        var checkoutTotalSansGiftCard = checkoutTotal - storedValueBalance;
        // If there is remaining checkout total after subtracting the gift card,
        // - calculate the remaining payment type amount
        // - assign the storedValueBalance to the storedValueAmount for checkout
        if (checkoutTotalSansGiftCard > 0) {
            paymentMethodAmount = checkoutTotalSansGiftCard;
            storedValueAmount = storedValueBalance;
        }
        // If the gift card balance exceeds the cost of checkout
        // - there is no amount obligation on the payment type
        // - set the gift card remaining and the gift card amount
        if (checkoutTotalSansGiftCard <= 0) {
            paymentMethodAmount = 0;
            storedValueAmount = checkoutTotal;
            storedValueRemaining = storedValueBalance - checkoutTotal;
        }
    }
    return {
        paymentMethodAmount: paymentMethodAmount,
        storedValueAmount: storedValueAmount,
        storedValueRemaining: storedValueRemaining
    };
};
var assignPaymentTips = function(tipAmount, storedValueBalance) {
    // Default tip assignments to 0
    var paymentMethodTip = 0;
    var storedValueTip = 0;
    // If stored value exists assign the tip to the stored value
    if (storedValueBalance) {
        storedValueTip = tipAmount;
        // If the stored value balance cannot cover the tip, assign the remander to the payment method
        if (storedValueBalance < tipAmount) {
            storedValueTip = storedValueBalance;
            paymentMethodTip = tipAmount - storedValueBalance;
        }
    }
    return {
        paymentMethodTip: paymentMethodTip,
        storedValueTip: storedValueTip
    };
};
/**
 * Given a basket initialization error determine
 * the means by which it should be handled
 */ var getInitializationErrorType = function(message) {
    var initErrorKey = Object.keys(_constants_basket__WEBPACK_IMPORTED_MODULE_2__/* .INITIALIZATION_ERRORS */ .oC).find(function(key) {
        return message === null || message === void 0 ? void 0 : message.includes(key);
    });
    var initErrorType = initErrorKey ? _constants_basket__WEBPACK_IMPORTED_MODULE_2__/* .INITIALIZATION_ERRORS */ .oC[initErrorKey] : _constants_basket__WEBPACK_IMPORTED_MODULE_2__/* .InitializationErrorTypes.UNHANDLED */ .R0.UNHANDLED;
    return initErrorType;
};
/**
 * Process a PCI Proxy change event and extract some non-sensitive card information
 * mainly the card type and the expiration date
 * see: https://docs.pci-proxy.com/collect-and-store-cards/capture-iframes/events
 *
 * @param data PCI Proxy iFrame change event payload
 * @param current state of payment data (mainly expiry)
 * @returns updated state
 */ var handlePciProxyIFrameChangeEvent = function(data, param) {
    var expiry = param.expiry;
    // currently we only handle the autocomplete event and only for
    if (data.event.type === "autocomplete") {
        var ref, ref1;
        // the expire date is stored as a short date (e.g. 12/25)
        // so splitting at the slash gives month and year
        var date = (expiry || "/").split("/");
        var month = ((ref = date[0]) === null || ref === void 0 ? void 0 : ref.trim()) || "";
        var year = ((ref1 = date[1]) === null || ref1 === void 0 ? void 0 : ref1.trim()) || "";
        switch(data.event.field){
            case "expiryMonth":
                expiry = "".concat(data.event.value, "/").concat(year);
                break;
            case "expiryYear":
                var ref2;
                // grab only the last two digits for the year
                expiry = "".concat(month, "/").concat((ref2 = data.event.value) === null || ref2 === void 0 ? void 0 : ref2.slice(-2));
                break;
            default:
                break;
        }
    }
    var cardType = data.fields.cardNumber.paymentMethod;
    return {
        cardType: cardType,
        expiry: expiry
    };
};


/***/ }),

/***/ 19257:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "i": function() { return /* binding */ supportsBrandId; }
/* harmony export */ });
/** Has the brand chosen Koala IDs and Brand (Olo/Chowly) IDs for their Location URLs. */ function supportsBrandId(config) {
    return config.locations.location_id_source === "brand_id";
}


/***/ }),

/***/ 63654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "yG": function() { return /* binding */ addTime; },
  "p6": function() { return /* binding */ formatDate; },
  "QK": function() { return /* binding */ getClientOffset; },
  "_3": function() { return /* binding */ getDate; },
  "ZL": function() { return /* binding */ getDaysBetweenTwoDates; },
  "vl": function() { return /* binding */ getFormattedDateInTimezone; },
  "rf": function() { return /* binding */ getFormattedDateInTimezoneName; },
  "Zf": function() { return /* binding */ getISODate; },
  "j4": function() { return /* binding */ getISODateInUTC; },
  "UG": function() { return /* binding */ getSanitizedOffset; },
  "EA": function() { return /* binding */ getUTCDate; },
  "hF": function() { return /* binding */ isDateBefore; },
  "zx": function() { return /* binding */ isDateBetween; },
  "U$": function() { return /* binding */ isDateSameOrAfter; },
  "jP": function() { return /* binding */ isDaySame; },
  "qb": function() { return /* binding */ isValidDate; },
  "U2": function() { return /* binding */ subtractTime; }
});

// UNUSED EXPORTS: formatDateLocally, getDateFromStartOfDay, getDateObject, getEndOfDay, getISOWeekDay, getWeekDay, isDateSame, isDateSameOrBefore

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(42838);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js

function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}

// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/defaultLocale/index.js + 10 modules
var defaultLocale = __webpack_require__(15344);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/subMilliseconds/index.js + 1 modules
var subMilliseconds = __webpack_require__(89248);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(66700);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/assign/index.js
function assign_assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }
  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      ;
      target[property] = object[property];
    }
  }
  return target;
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/format/longFormatters/index.js
var longFormatters = __webpack_require__(60429);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getTimezoneOffsetInMilliseconds/index.js
var getTimezoneOffsetInMilliseconds = __webpack_require__(1645);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/protectedTokens/index.js
var protectedTokens = __webpack_require__(13503);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/toInteger/index.js
var toInteger = __webpack_require__(42765);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(19785);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(80753);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
var setPrototypeOf = __webpack_require__(88960);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/inherits.js

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && (0,setPrototypeOf/* default */.Z)(t, e);
}

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(95058);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
var isNativeReflectConstruct = __webpack_require__(70352);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(t, e) {
  if (e && ("object" == (0,esm_typeof/* default */.Z)(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return (0,assertThisInitialized/* default */.Z)(t);
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/createSuper.js



function _createSuper(t) {
  var r = (0,isNativeReflectConstruct/* default */.Z)();
  return function () {
    var e,
      o = (0,getPrototypeOf/* default */.Z)(t);
    if (r) {
      var s = (0,getPrototypeOf/* default */.Z)(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(87371);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/Setter.js






var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/function () {
  function Setter() {
    _classCallCheck(this, Setter);
    (0,defineProperty/* default */.Z)(this, "priority", void 0);
    (0,defineProperty/* default */.Z)(this, "subPriority", 0);
  }
  (0,createClass/* default */.Z)(Setter, [{
    key: "validate",
    value: function validate(_utcDate, _options) {
      return true;
    }
  }]);
  return Setter;
}();
var ValueSetter = /*#__PURE__*/function (_Setter) {
  _inherits(ValueSetter, _Setter);
  var _super = _createSuper(ValueSetter);
  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
    var _this;
    _classCallCheck(this, ValueSetter);
    _this = _super.call(this);
    _this.value = value;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;
    if (subPriority) {
      _this.subPriority = subPriority;
    }
    return _this;
  }
  (0,createClass/* default */.Z)(ValueSetter, [{
    key: "validate",
    value: function validate(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set(utcDate, flags, options) {
      return this.setValue(utcDate, flags, this.value, options);
    }
  }]);
  return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/function (_Setter2) {
  _inherits(DateToSystemTimezoneSetter, _Setter2);
  var _super2 = _createSuper(DateToSystemTimezoneSetter);
  function DateToSystemTimezoneSetter() {
    var _this2;
    _classCallCheck(this, DateToSystemTimezoneSetter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this2), "subPriority", -1);
    return _this2;
  }
  (0,createClass/* default */.Z)(DateToSystemTimezoneSetter, [{
    key: "set",
    value: function set(date, flags) {
      if (flags.timestampIsSet) {
        return date;
      }
      var convertedDate = new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);
  return DateToSystemTimezoneSetter;
}(Setter);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/Parser.js




var Parser = /*#__PURE__*/function () {
  function Parser() {
    _classCallCheck(this, Parser);
    (0,defineProperty/* default */.Z)(this, "incompatibleTokens", void 0);
    (0,defineProperty/* default */.Z)(this, "priority", void 0);
    (0,defineProperty/* default */.Z)(this, "subPriority", void 0);
  }
  (0,createClass/* default */.Z)(Parser, [{
    key: "run",
    value: function run(dateString, token, match, options) {
      var result = this.parse(dateString, token, match, options);
      if (!result) {
        return null;
      }
      return {
        setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);
  return Parser;
}();
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/EraParser.js







var EraParser = /*#__PURE__*/function (_Parser) {
  _inherits(EraParser, _Parser);
  var _super = _createSuper(EraParser);
  function EraParser() {
    var _this;
    _classCallCheck(this, EraParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 140);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(EraParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
        // A, B
        case 'GGGGG':
          return match.era(dateString, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ
        case 'GGGG':
        default:
          return match.era(dateString, {
            width: 'wide'
          }) || match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return EraParser;
}(Parser);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/constants/index.js
var constants = __webpack_require__(64312);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/constants.js
var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59

  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999

  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};

var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/utils.js


function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }

  // Input is 'Z'
  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * constants/* millisecondsInHour */.vh + minutes * constants/* millisecondsInMinute */.yJ + seconds * constants/* millisecondsInSecond */.qk),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case 'morning':
      return 4;
    case 'evening':
      return 17;
    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;
    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/YearParser.js








// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
var YearParser = /*#__PURE__*/function (_Parser) {
  _inherits(YearParser, _Parser);
  var _super = _createSuper(YearParser);
  function YearParser() {
    var _this;
    _classCallCheck(this, YearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 130);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(YearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };
      switch (token) {
        case 'y':
          return mapValue(parseNDigits(4, dateString), valueCallback);
        case 'yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      var currentYear = date.getUTCFullYear();
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return YearParser;
}(Parser);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getUTCWeekYear/index.js
var getUTCWeekYear = __webpack_require__(72763);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCWeek/index.js
var startOfUTCWeek = __webpack_require__(52329);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekYearParser.js










// Local week-numbering year
var LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalWeekYearParser, _Parser);
  var _super = _createSuper(LocalWeekYearParser);
  function LocalWeekYearParser() {
    var _this;
    _classCallCheck(this, LocalWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 130);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(LocalWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };
      switch (token) {
        case 'Y':
          return mapValue(parseNDigits(4, dateString), valueCallback);
        case 'Yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value, options) {
      var currentYear = (0,getUTCWeekYear/* default */.Z)(date, options);
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return (0,startOfUTCWeek/* default */.Z)(date, options);
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return (0,startOfUTCWeek/* default */.Z)(date, options);
    }
  }]);
  return LocalWeekYearParser;
}(Parser);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/startOfUTCISOWeek/index.js
var startOfUTCISOWeek = __webpack_require__(55143);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekYearParser.js








 // ISO week-numbering year
var ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOWeekYearParser, _Parser);
  var _super = _createSuper(ISOWeekYearParser);
  function ISOWeekYearParser() {
    var _this;
    _classCallCheck(this, ISOWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 130);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(ISOWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'R') {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return (0,startOfUTCISOWeek/* default */.Z)(firstWeekOfYear);
    }
  }]);
  return ISOWeekYearParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/ExtendedYearParser.js








var ExtendedYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(ExtendedYearParser, _Parser);
  var _super = _createSuper(ExtendedYearParser);
  function ExtendedYearParser() {
    var _this;
    _classCallCheck(this, ExtendedYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 130);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(ExtendedYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'u') {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ExtendedYearParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/QuarterParser.js








var QuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits(QuarterParser, _Parser);
  var _super = _createSuper(QuarterParser);
  function QuarterParser() {
    var _this;
    _classCallCheck(this, QuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 120);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(QuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case 'Qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'QQQ':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'QQQQQ':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...
        case 'QQQQ':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return QuarterParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/StandAloneQuarterParser.js








var StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneQuarterParser, _Parser);
  var _super = _createSuper(StandAloneQuarterParser);
  function StandAloneQuarterParser() {
    var _this;
    _classCallCheck(this, StandAloneQuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 120);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(StandAloneQuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case 'qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'qqq':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'qqqqq':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...
        case 'qqqq':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneQuarterParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/MonthParser.js









var MonthParser = /*#__PURE__*/function (_Parser) {
  _inherits(MonthParser, _Parser);
  var _super = _createSuper(MonthParser);
  function MonthParser() {
    var _this;
    _classCallCheck(this, MonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 110);
    return _this;
  }
  (0,createClass/* default */.Z)(MonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12
        case 'MM':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Mo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec
        case 'MMM':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D
        case 'MMMMM':
          return match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December
        case 'MMMM':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return MonthParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/StandAloneMonthParser.js









var StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneMonthParser, _Parser);
  var _super = _createSuper(StandAloneMonthParser);
  function StandAloneMonthParser() {
    var _this;
    _classCallCheck(this, StandAloneMonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 110);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(StandAloneMonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12
        case 'LL':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Lo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec
        case 'LLL':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D
        case 'LLLLL':
          return match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December
        case 'LLLL':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneMonthParser;
}(Parser);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getUTCWeek/index.js + 1 modules
var getUTCWeek = __webpack_require__(10663);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/setUTCWeek/index.js




function setUTCWeek(dirtyDate, dirtyWeek, options) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var week = (0,toInteger/* default */.Z)(dirtyWeek);
  var diff = (0,getUTCWeek/* default */.Z)(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/LocalWeekParser.js










 // Local week of year
var LocalWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalWeekParser, _Parser);
  var _super = _createSuper(LocalWeekParser);
  function LocalWeekParser() {
    var _this;
    _classCallCheck(this, LocalWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 100);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(LocalWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, dateString);
        case 'wo':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      return (0,startOfUTCWeek/* default */.Z)(setUTCWeek(date, value, options), options);
    }
  }]);
  return LocalWeekParser;
}(Parser);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/getUTCISOWeek/index.js + 1 modules
var getUTCISOWeek = __webpack_require__(17898);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/setUTCISOWeek/index.js




function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var isoWeek = (0,toInteger/* default */.Z)(dirtyISOWeek);
  var diff = (0,getUTCISOWeek/* default */.Z)(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/ISOWeekParser.js










 // ISO week of year
var ISOWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOWeekParser, _Parser);
  var _super = _createSuper(ISOWeekParser);
  function ISOWeekParser() {
    var _this;
    _classCallCheck(this, ISOWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 100);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(ISOWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, dateString);
        case 'Io':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      return (0,startOfUTCISOWeek/* default */.Z)(setUTCISOWeek(date, value));
    }
  }]);
  return ISOWeekParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/DateParser.js









var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

// Day of the month
var DateParser = /*#__PURE__*/function (_Parser) {
  _inherits(DateParser, _Parser);
  var _super = _createSuper(DateParser);
  function DateParser() {
    var _this;
    _classCallCheck(this, DateParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 90);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "subPriority", 1);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(DateParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, dateString);
        case 'do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      var month = date.getUTCMonth();
      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DateParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/DayOfYearParser.js









var DayOfYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayOfYearParser, _Parser);
  var _super = _createSuper(DayOfYearParser);
  function DayOfYearParser() {
    var _this;
    _classCallCheck(this, DayOfYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 90);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "subpriority", 1);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(DayOfYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, dateString);
        case 'Do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex(year);
      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayOfYearParser;
}(Parser);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/defaultOptions/index.js
var _lib_defaultOptions = __webpack_require__(18667);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/setUTCDay/index.js




function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  (0,requiredArgs/* default */.Z)(2, arguments);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var day = (0,toInteger/* default */.Z)(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/DayParser.js







 // Day of week
var DayParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayParser, _Parser);
  var _super = _createSuper(DayParser);
  function DayParser() {
    var _this;
    _classCallCheck(this, DayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 90);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(DayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T
        case 'EEEEE':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'EEEEEE':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday
        case 'EEEE':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/LocalDayParser.js








 // Local day of week
var LocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalDayParser, _Parser);
  var _super = _createSuper(LocalDayParser);
  function LocalDayParser() {
    var _this;
    _classCallCheck(this, LocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 90);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(LocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd
        case 'eo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue
        case 'eee':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T
        case 'eeeee':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'eeeeee':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday
        case 'eeee':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return LocalDayParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/StandAloneLocalDayParser.js








 // Stand-alone local day of week
var StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneLocalDayParser, _Parser);
  var _super = _createSuper(StandAloneLocalDayParser);
  function StandAloneLocalDayParser() {
    var _this;
    _classCallCheck(this, StandAloneLocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 90);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(StandAloneLocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd
        case 'co':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue
        case 'ccc':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // T
        case 'ccccc':
          return match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu
        case 'cccccc':
          return match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday
        case 'cccc':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneLocalDayParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/_lib/setUTCISODay/index.js



function setUTCISODay(dirtyDate, dirtyDay) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var day = (0,toInteger/* default */.Z)(dirtyDay);
  if (day % 7 === 0) {
    day = day - 7;
  }
  var weekStartsOn = 1;
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/ISODayParser.js








 // ISO day of week
var ISODayParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISODayParser, _Parser);
  var _super = _createSuper(ISODayParser);
  function ISODayParser() {
    var _this;
    _classCallCheck(this, ISODayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 90);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(ISODayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }
        return value;
      };
      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, dateString);
        // 2nd
        case 'io':
          return match.ordinalNumber(dateString, {
            unit: 'day'
          });
        // Tue
        case 'iii':
          return mapValue(match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // T
        case 'iiiii':
          return mapValue(match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tu
        case 'iiiiii':
          return mapValue(match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tuesday
        case 'iiii':
        default:
          return mapValue(match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 7;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date = setUTCISODay(date, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ISODayParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/AMPMParser.js








var AMPMParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMParser, _Parser);
  var _super = _createSuper(AMPMParser);
  function AMPMParser() {
    var _this;
    _classCallCheck(this, AMPMParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 80);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(AMPMParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaaa':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaa':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/AMPMMidnightParser.js








var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMMidnightParser, _Parser);
  var _super = _createSuper(AMPMMidnightParser);
  function AMPMMidnightParser() {
    var _this;
    _classCallCheck(this, AMPMMidnightParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 80);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(AMPMMidnightParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbbb':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbb':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMMidnightParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/DayPeriodParser.js







 // in the morning, in the afternoon, in the evening, at night
var DayPeriodParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayPeriodParser, _Parser);
  var _super = _createSuper(DayPeriodParser);
  function DayPeriodParser() {
    var _this;
    _classCallCheck(this, DayPeriodParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 80);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(DayPeriodParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBBB':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBB':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return DayPeriodParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/Hour1to12Parser.js









var Hour1to12Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour1to12Parser, _Parser);
  var _super = _createSuper(Hour1to12Parser);
  function Hour1to12Parser() {
    var _this;
    _classCallCheck(this, Hour1to12Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 70);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(Hour1to12Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, dateString);
        case 'ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 12;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour1to12Parser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/Hour0to23Parser.js









var Hour0to23Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour0to23Parser, _Parser);
  var _super = _createSuper(Hour0to23Parser);
  function Hour0to23Parser() {
    var _this;
    _classCallCheck(this, Hour0to23Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 70);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(Hour0to23Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, dateString);
        case 'Ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 23;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    }
  }]);
  return Hour0to23Parser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/Hour0To11Parser.js









var Hour0To11Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour0To11Parser, _Parser);
  var _super = _createSuper(Hour0To11Parser);
  function Hour0To11Parser() {
    var _this;
    _classCallCheck(this, Hour0To11Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 70);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(Hour0To11Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, dateString);
        case 'Ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour0To11Parser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/Hour1To24Parser.js









var Hour1To24Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour1To24Parser, _Parser);
  var _super = _createSuper(Hour1To24Parser);
  function Hour1To24Parser() {
    var _this;
    _classCallCheck(this, Hour1To24Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 70);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(Hour1To24Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, dateString);
        case 'ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 24;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);
  return Hour1To24Parser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/MinuteParser.js









var MinuteParser = /*#__PURE__*/function (_Parser) {
  _inherits(MinuteParser, _Parser);
  var _super = _createSuper(MinuteParser);
  function MinuteParser() {
    var _this;
    _classCallCheck(this, MinuteParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 60);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(MinuteParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, dateString);
        case 'mo':
          return match.ordinalNumber(dateString, {
            unit: 'minute'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    }
  }]);
  return MinuteParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/SecondParser.js









var SecondParser = /*#__PURE__*/function (_Parser) {
  _inherits(SecondParser, _Parser);
  var _super = _createSuper(SecondParser);
  function SecondParser() {
    var _this;
    _classCallCheck(this, SecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 50);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(SecondParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, dateString);
        case 'so':
          return match.ordinalNumber(dateString, {
            unit: 'second'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCSeconds(value, 0);
      return date;
    }
  }]);
  return SecondParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/FractionOfSecondParser.js








var FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
  _inherits(FractionOfSecondParser, _Parser);
  var _super = _createSuper(FractionOfSecondParser);
  function FractionOfSecondParser() {
    var _this;
    _classCallCheck(this, FractionOfSecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 30);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  (0,createClass/* default */.Z)(FractionOfSecondParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      var valueCallback = function valueCallback(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };
      return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMilliseconds(value);
      return date;
    }
  }]);
  return FractionOfSecondParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneWithZParser.js








 // Timezone (ISO-8601. +00:00 is `'Z'`)
var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneWithZParser, _Parser);
  var _super = _createSuper(ISOTimezoneWithZParser);
  function ISOTimezoneWithZParser() {
    var _this;
    _classCallCheck(this, ISOTimezoneWithZParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 10);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['t', 'T', 'x']);
    return _this;
  }
  (0,createClass/* default */.Z)(ISOTimezoneWithZParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneWithZParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/ISOTimezoneParser.js








 // Timezone (ISO-8601)
var ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneParser, _Parser);
  var _super = _createSuper(ISOTimezoneParser);
  function ISOTimezoneParser() {
    var _this;
    _classCallCheck(this, ISOTimezoneParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 10);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", ['t', 'T', 'X']);
    return _this;
  }
  (0,createClass/* default */.Z)(ISOTimezoneParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/TimestampSecondsParser.js








var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampSecondsParser, _Parser);
  var _super = _createSuper(TimestampSecondsParser);
  function TimestampSecondsParser() {
    var _this;
    _classCallCheck(this, TimestampSecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 40);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", '*');
    return _this;
  }
  (0,createClass/* default */.Z)(TimestampSecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampSecondsParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/TimestampMillisecondsParser.js








var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampMillisecondsParser, _Parser);
  var _super = _createSuper(TimestampMillisecondsParser);
  function TimestampMillisecondsParser() {
    var _this;
    _classCallCheck(this, TimestampMillisecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "priority", 20);
    (0,defineProperty/* default */.Z)((0,assertThisInitialized/* default */.Z)(_this), "incompatibleTokens", '*');
    return _this;
  }
  (0,createClass/* default */.Z)(TimestampMillisecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampMillisecondsParser;
}(Parser);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/_lib/parsers/index.js































/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */
var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/parse/index.js













 // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  (0,requiredArgs/* default */.Z)(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions = (0,_lib_defaultOptions/* getDefaultOptions */.j)();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale/* default */.Z;
  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }
  var firstWeekContainsDate = (0,toInteger/* default */.Z)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = (0,toInteger/* default */.Z)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (formatString === '') {
    if (dateString === '') {
      return (0,toDate/* default */.Z)(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }
  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  };

  // If timezone isn't specified, it will be set to the system timezone
  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter in longFormatters/* default */.Z) {
      var longFormatter = longFormatters/* default */.Z[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];
  var _iterator = _createForOfIteratorHelper(tokens),
    _step;
  try {
    var _loop = function _loop() {
      var token = _step.value;
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0,protectedTokens/* isProtectedWeekYearToken */.Do)(token)) {
        (0,protectedTokens/* throwProtectedError */.qp)(token, formatString, dirtyDateString);
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0,protectedTokens/* isProtectedDayOfYearToken */.Iu)(token)) {
        (0,protectedTokens/* throwProtectedError */.qp)(token, formatString, dirtyDateString);
      }
      var firstCharacter = token[0];
      var parser = parsers[firstCharacter];
      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;
        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function (usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });
          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
        }
        usedTokens.push({
          token: firstCharacter,
          fullToken: token
        });
        var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
        if (!parseResult) {
          return {
            v: new Date(NaN)
          };
        }
        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        }

        // Replace two single quote characters with one single quote character
        if (token === "''") {
          token = "'";
        } else if (firstCharacter === "'") {
          token = cleanEscapedString(token);
        }

        // Cut token from string, or, if string doesn't match the token, return Invalid Date
        if (dateString.indexOf(token) === 0) {
          dateString = dateString.slice(token.length);
        } else {
          return {
            v: new Date(NaN)
          };
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();
      if ((0,esm_typeof/* default */.Z)(_ret) === "object") return _ret.v;
    }

    // Check if the remaining input contains something other than whitespace
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }
  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = (0,toDate/* default */.Z)(dirtyReferenceDate);
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  var utcDate = (0,subMilliseconds/* default */.Z)(date, (0,getTimezoneOffsetInMilliseconds/* default */.Z)(date));
  var flags = {};
  var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var setter = _step2.value;
      if (!setter.validate(utcDate, subFnOptions)) {
        return new Date(NaN);
      }
      var result = setter.set(utcDate, flags, subFnOptions);
      // Result is tuple (date, flags)
      if (Array.isArray(result)) {
        utcDate = result[0];
        assign_assign(flags, result[1]);
        // Result is date
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return utcDate;
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/format/index.js + 3 modules
var format = __webpack_require__(97361);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/addLeadingZeros/index.js
var addLeadingZeros = __webpack_require__(36012);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/formatISO/index.js



/**
 * @name formatISO
 * @category Common Helpers
 * @summary Format the date according to the ISO 8601 standard (https://support.sas.com/documentation/cdl/en/lrdict/64316/HTML/default/viewer.htm#a003169814.htm).
 *
 * @description
 * Return the formatted date string in ISO 8601 format. Options may be passed to control the parts and notations of the date.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {'extended'|'basic'} [options.format='extended'] - if 'basic', hide delimiters between date and time values.
 * @param {'complete'|'date'|'time'} [options.representation='complete'] - format date, time with local time zone, or both.
 * @returns {String} the formatted date string (in local time zone)
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.format` must be 'extended' or 'basic'
 * @throws {RangeError} `options.representation` must be 'date', 'time' or 'complete'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52))
 * //=> '2019-09-18T19:00:52Z'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601, short format (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { format: 'basic' })
 * //=> '20190918T190052'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, date only:
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'date' })
 * //=> '2019-09-18'
 *
 * @example
 * // Represent 18 September 2019 in ISO 8601 format, time only (local time zone is UTC):
 * const result = formatISO(new Date(2019, 8, 18, 19, 0, 52), { representation: 'time' })
 * //=> '19:00:52Z'
 */
function formatISO(date, options) {
  var _options$format, _options$representati;
  (0,requiredArgs/* default */.Z)(1, arguments);
  var originalDate = (0,toDate/* default */.Z)(date);
  if (isNaN(originalDate.getTime())) {
    throw new RangeError('Invalid time value');
  }
  var format = String((_options$format = options === null || options === void 0 ? void 0 : options.format) !== null && _options$format !== void 0 ? _options$format : 'extended');
  var representation = String((_options$representati = options === null || options === void 0 ? void 0 : options.representation) !== null && _options$representati !== void 0 ? _options$representati : 'complete');
  if (format !== 'extended' && format !== 'basic') {
    throw new RangeError("format must be 'extended' or 'basic'");
  }
  if (representation !== 'date' && representation !== 'time' && representation !== 'complete') {
    throw new RangeError("representation must be 'date', 'time', or 'complete'");
  }
  var result = '';
  var tzOffset = '';
  var dateDelimiter = format === 'extended' ? '-' : '';
  var timeDelimiter = format === 'extended' ? ':' : '';

  // Representation is either 'date' or 'complete'
  if (representation !== 'time') {
    var day = (0,addLeadingZeros/* default */.Z)(originalDate.getDate(), 2);
    var month = (0,addLeadingZeros/* default */.Z)(originalDate.getMonth() + 1, 2);
    var year = (0,addLeadingZeros/* default */.Z)(originalDate.getFullYear(), 4);

    // yyyyMMdd or yyyy-MM-dd.
    result = "".concat(year).concat(dateDelimiter).concat(month).concat(dateDelimiter).concat(day);
  }

  // Representation is either 'time' or 'complete'
  if (representation !== 'date') {
    // Add the timezone.
    var offset = originalDate.getTimezoneOffset();
    if (offset !== 0) {
      var absoluteOffset = Math.abs(offset);
      var hourOffset = (0,addLeadingZeros/* default */.Z)(Math.floor(absoluteOffset / 60), 2);
      var minuteOffset = (0,addLeadingZeros/* default */.Z)(absoluteOffset % 60, 2);
      // If less than 0, the sign is +, because it is ahead of time.
      var sign = offset < 0 ? '+' : '-';
      tzOffset = "".concat(sign).concat(hourOffset, ":").concat(minuteOffset);
    } else {
      tzOffset = 'Z';
    }
    var hour = (0,addLeadingZeros/* default */.Z)(originalDate.getHours(), 2);
    var minute = (0,addLeadingZeros/* default */.Z)(originalDate.getMinutes(), 2);
    var second = (0,addLeadingZeros/* default */.Z)(originalDate.getSeconds(), 2);

    // If there's also date, separate it with time with 'T'
    var separator = result === '' ? '' : 'T';

    // Creates a time string consisting of hour, minute, and second, separated by delimiters, if defined.
    var time = [hour, minute, second].join(timeDelimiter);

    // HHmmss or HH:mm:ss.
    result = "".concat(result).concat(separator).concat(time).concat(tzOffset);
  }
  return result;
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/startOfDay/index.js
var esm_startOfDay = __webpack_require__(10405);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/differenceInCalendarDays/index.js



var MILLISECONDS_IN_DAY = 86400000;

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var startOfDayLeft = (0,esm_startOfDay/* default */.Z)(dirtyDateLeft);
  var startOfDayRight = (0,esm_startOfDay/* default */.Z)(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - (0,getTimezoneOffsetInMilliseconds/* default */.Z)(startOfDayRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/differenceInDays/index.js


 // Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full days according to the local timezone
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * const result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
//=> 92
 */
function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var dateLeft = (0,toDate/* default */.Z)(dirtyDateLeft);
  var dateRight = (0,toDate/* default */.Z)(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference);

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = Number(compareLocalAsc(dateLeft, dateRight) === -sign);
  var result = sign * (difference - isLastDayNotFull);
  // Prevent negative zero
  return result === 0 ? 0 : result;
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isSameDay/index.js
var isSameDay = __webpack_require__(82276);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(63761);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/addMonths/index.js



/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  var dayOfMonth = date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/add/index.js






/**
 * @name add
 * @category Common Helpers
 * @summary Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @description
 * Add the specified years, months, weeks, days, hours, minutes and seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 *
 * | Key            | Description                        |
 * |----------------|------------------------------------|
 * | years          | Amount of years to be added        |
 * | months         | Amount of months to be added       |
 * | weeks          | Amount of weeks to be added        |
 * | days           | Amount of days to be added         |
 * | hours          | Amount of hours to be added        |
 * | minutes        | Amount of minutes to be added      |
 * | seconds        | Amount of seconds to be added      |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add the following duration to 1 September 2014, 10:19:50
 * const result = add(new Date(2014, 8, 1, 10, 19, 50), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30,
 * })
 * //=> Thu Jun 15 2017 15:29:20
 */
function add(dirtyDate, duration) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  if (!duration || (0,esm_typeof/* default */.Z)(duration) !== 'object') return new Date(NaN);
  var years = duration.years ? (0,toInteger/* default */.Z)(duration.years) : 0;
  var months = duration.months ? (0,toInteger/* default */.Z)(duration.months) : 0;
  var weeks = duration.weeks ? (0,toInteger/* default */.Z)(duration.weeks) : 0;
  var days = duration.days ? (0,toInteger/* default */.Z)(duration.days) : 0;
  var hours = duration.hours ? (0,toInteger/* default */.Z)(duration.hours) : 0;
  var minutes = duration.minutes ? (0,toInteger/* default */.Z)(duration.minutes) : 0;
  var seconds = duration.seconds ? (0,toInteger/* default */.Z)(duration.seconds) : 0;

  // Add years and months
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var dateWithMonths = months || years ? addMonths(date, months + years * 12) : date;

  // Add weeks and days
  var dateWithDays = days || weeks ? (0,addDays/* default */.Z)(dateWithMonths, days + weeks * 7) : dateWithMonths;

  // Add days, hours, minutes and seconds
  var minutesToAdd = minutes + hours * 60;
  var secondsToAdd = seconds + minutesToAdd * 60;
  var msToAdd = secondsToAdd * 1000;
  var finalDate = new Date(dateWithDays.getTime() + msToAdd);
  return finalDate;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/subDays/index.js



/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return (0,addDays/* default */.Z)(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/subMonths/index.js



/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths(dirtyDate, dirtyAmount) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var amount = (0,toInteger/* default */.Z)(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/sub/index.js





/**
 * @name sub
 * @category Common Helpers
 * @summary Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @description
 * Subtract the specified years, months, weeks, days, hours, minutes and seconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Duration} duration - the object with years, months, weeks, days, hours, minutes and seconds to be subtracted
 *
 * | Key     | Description                        |
 * |---------|------------------------------------|
 * | years   | Amount of years to be subtracted   |
 * | months  | Amount of months to be subtracted  |
 * | weeks   | Amount of weeks to be subtracted   |
 * | days    | Amount of days to be subtracted    |
 * | hours   | Amount of hours to be subtracted   |
 * | minutes | Amount of minutes to be subtracted |
 * | seconds | Amount of seconds to be subtracted |
 *
 * All values default to 0
 *
 * @returns {Date} the new date with the seconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract the following duration from 15 June 2017 15:29:20
 * const result = sub(new Date(2017, 5, 15, 15, 29, 20), {
 *   years: 2,
 *   months: 9,
 *   weeks: 1,
 *   days: 7,
 *   hours: 5,
 *   minutes: 9,
 *   seconds: 30
 * })
 * //=> Mon Sep 1 2014 10:19:50
 */
function sub(date, duration) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  if (!duration || (0,esm_typeof/* default */.Z)(duration) !== 'object') return new Date(NaN);
  var years = duration.years ? (0,toInteger/* default */.Z)(duration.years) : 0;
  var months = duration.months ? (0,toInteger/* default */.Z)(duration.months) : 0;
  var weeks = duration.weeks ? (0,toInteger/* default */.Z)(duration.weeks) : 0;
  var days = duration.days ? (0,toInteger/* default */.Z)(duration.days) : 0;
  var hours = duration.hours ? (0,toInteger/* default */.Z)(duration.hours) : 0;
  var minutes = duration.minutes ? (0,toInteger/* default */.Z)(duration.minutes) : 0;
  var seconds = duration.seconds ? (0,toInteger/* default */.Z)(duration.seconds) : 0;

  // Subtract years and months
  var dateWithoutMonths = subMonths(date, months + years * 12);

  // Subtract weeks and days
  var dateWithoutDays = subDays(dateWithoutMonths, days + weeks * 7);

  // Subtract hours, minutes and seconds
  var minutestoSub = minutes + hours * 60;
  var secondstoSub = seconds + minutestoSub * 60;
  var mstoSub = secondstoSub * 1000;
  var finalDate = new Date(dateWithoutDays.getTime() - mstoSub);
  return finalDate;
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/isBefore/index.js


/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(dirtyDate, dirtyDateToCompare) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var dateToCompare = (0,toDate/* default */.Z)(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/isAfter/index.js


/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(dirtyDate, dirtyDateToCompare) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var date = (0,toDate/* default */.Z)(dirtyDate);
  var dateToCompare = (0,toDate/* default */.Z)(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isValid/index.js + 1 modules
var isValid = __webpack_require__(31200);
// EXTERNAL MODULE: ../../node_modules/date-fns-tz/index.js
var date_fns_tz = __webpack_require__(22601);
;// CONCATENATED MODULE: ./src/utils/dates.ts





/**
 * @param   {number} utcOffset
 * @returns {string} a valid offset formatted as HH:MM (ex: -8 to -08:00, 5.5 to +05:30)
 */ var getSanitizedOffset = function(utcOffset) {
    if (utcOffset === 0) {
        return "+00";
    }
    // we are converting a numeric offset (ex: -8, 5.5, 0, etc)
    // into a string so first we see if it's a positive or negative integer
    var prepend = utcOffset < 0 ? "-" : "+";
    // next, we use Math.abs to ensure all values are position and split them to test for timezone offsets like 5.5
    var ref = (0,_sliced_to_array/* default */.Z)(Math.abs(utcOffset).toString().split("."), 2), hours = ref[0], minutes = ref[1];
    var padding = hours.length === 1 ? "0" : "";
    // if we have minutes, it means the value was something like 1.5 or 5.5,
    // so we compute and output the minutes to the minutes value (otherwise, we default to 00)
    var append = minutes !== undefined ? 60 * (Number(minutes) / 10) : "00";
    return "".concat(prepend).concat(padding).concat(hours, ":").concat(append);
};
/**
 * getTimezoneOffset gets the offset in minutes from UTC time
 * for example: Central Standard Time is -360
 *
 * However, during Daylight Savings Time (DST) we jump ahead an hour and CST is now -300
 * This function checks January 1st's offset (a date we know is not DST)
 * and the offset of a passed in date.
 *
 * The value is either 0 or -1, which can then be applied to a date to subtract 0 or 1 hours
 *
 * @param   {Date} date
 * @returns {number} either 0 (non DST dates) or -1 (DST dates) depending on if DST is active for a date
 */ var getDSTOffset = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Date();
    var jan = new Date(date.getFullYear(), 0, 1);
    return (date.getTimezoneOffset() - jan.getTimezoneOffset()) / 60;
};
/**
 * @returns {string} a matching timezone offset formatted as HH (example: "-08")
 */ var getClientOffset = function() {
    return getSanitizedOffset(getDSTOffset() + new Date().getTimezoneOffset() / -60);
};
/**
 * @param   {DateObject} date
 * @returns {Date} a date object with either the current or passed in date and time
 */ var getDateObject = function(date) {
    if ((0,_instanceof/* default */.Z)(date, Date)) {
        return date;
    }
    return date ? new Date(date) : new Date();
};
/**
 * @param   {DateObject} date
 * @returns {Date} a date object with the passed in date and time
 */ var getDate = function(date, format) {
    return format ? parse(date, format, new Date()) : getDateObject(date);
};
/**
 * @param   {DateObject} date
 * @param   {string}     dateFormat
 * @returns {string} a date string matching the provided format
 */ var formatDate = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, dateFormat = arguments.length > 1 ? arguments[1] : void 0;
    return (0,format/* default */.Z)(getDateObject(date), dateFormat);
};
/**
 * @param   {DateObject} date
 * @returns {string} an ISO date string
 */ var getISODate = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return formatISO(getDateObject(date));
};
/**
 * @param   {DateObject} date
 * @returns {string} an ISO date string in UTC time
 */ var getISODateInUTC = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return formatISO(getUTCDate(date));
};
/**
 * @param   {DateObject} date
 * @param   {DateObject} comparedTo
 * @returns {number} the number of days between two dates
 */ var getDaysBetweenTwoDates = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, comparedTo = arguments.length > 1 ? arguments[1] : void 0;
    return differenceInDays(getDateObject(date), getDateObject(comparedTo));
};
/**
 * @param   {DateObject} date
 * @param   {DateObject} comparedTo
 * @returns {boolean} whether the date is the same or after the date it's being compared to
 */ var isDateSameOrAfter = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, comparedTo = arguments.length > 1 ? arguments[1] : void 0;
    return getDateObject(date).getTime() >= getDateObject(comparedTo).getTime();
};
/**
 * @param   {DateObject} date
 * @param   {DateObject} comparedTo
 * @returns {boolean} whether the date is before the date it's being compared to
 */ var isDateBefore = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, comparedTo = arguments.length > 1 ? arguments[1] : void 0;
    return getDateObject(date).getTime() < getDateObject(comparedTo).getTime();
};
/**
 * @param   {DateObject} date
 * @param   {DateObject} comparedTo
 * @returns {boolean} whether the date is the same or before the date it's being compared to
 */ var isDateSameOrBefore = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, comparedTo = arguments.length > 1 ? arguments[1] : void 0;
    return getDateObject(date).getTime() <= getDateObject(comparedTo).getTime();
};
/**
 * @param   {DateObject}       date
 * @param   {DateObject}       comparedTo
 * @returns {boolean} whether two dates are the same based on the untis parameter (same day, same month, etc)
 */ var isDateSame = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, comparedTo = arguments.length > 1 ? arguments[1] : void 0;
    return getDateObject(date).getTime() === getDateObject(comparedTo).getTime();
};
/**
 * @param   {DateObject} date
 * @param   {DateObject} comparedTo
 * @returns {boolean} whether two dates are the same day
 */ var isDaySame = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, comparedTo = arguments.length > 1 ? arguments[1] : void 0;
    return (0,isSameDay/* default */.Z)(getDateObject(date), getDateObject(comparedTo));
};
/**
 * @param   {DateObject} date
 * @param   {number}     amount
 * @param   {string}     units
 * @returns {Date} adds the specified units to a date
 */ var addTime = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, amount = arguments.length > 1 ? arguments[1] : void 0, units = arguments.length > 2 ? arguments[2] : void 0;
    return add(getDateObject(date), (0,_define_property/* default */.Z)({}, units, amount));
};
/**
 * @param   {DateObject} date
 * @param   {number}     amount
 * @param   {string}     units
 * @returns {Date} subtracts the specified units from a date
 */ var subtractTime = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, amount = arguments.length > 1 ? arguments[1] : void 0, units = arguments.length > 2 ? arguments[2] : void 0;
    return sub(getDateObject(date), (0,_define_property/* default */.Z)({}, units, amount));
};
/**
 * @param   {DateObject} date
 * @returns {Date} represents a date at the beginning of the day
 */ var getDateFromStartOfDay = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return startOfDay(getDateObject(date));
};
/**
 * @param   {DateObject} date
 * @returns {Date} represents a date at the end of the day
 */ var getEndOfDay = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return endOfDay(getDateObject(date));
};
/**
 * @param   {DateObject} date
 * @returns {number} gets the day of the week from an ISO valid date
 */ var getISOWeekDay = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return getISODay(getDateObject(date));
};
/**
 * @param   {DateObject} date
 * @returns {number} gets the day of the week the date is on
 */ var getWeekDay = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    return getDay(getDateObject(date));
};
/**
 * @param   {DateObject} date
 * @returns {Date} returns a utc date to compare universally
 */ var getUTCDate = function(date) {
    return new Date(getDateObject(date).toUTCString());
};
/**
 * @param   {DateObject} date
 * @param   {DateObject} start
 * @param   {DateObject} end
 * @returns {boolean} returns whether a date is in between two other dates
 */ var isDateBetween = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    var dateObject = getDateObject(date);
    var startObject = getDateObject(start);
    var endObject = getDateObject(end);
    return isBefore(dateObject, endObject) && isAfter(dateObject, startObject);
};
/**
 * @param   {DateObject}                 date
 * @param   {Intl.DateTimeFormatOptions} format
 * @returns {string} returns a string date formatted in various ways per the [Intl.DateTimeFormat](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat) spec
 */ var formatDateLocally = function() {
    var date = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, formatting = arguments.length > 1 ? arguments[1] : void 0;
    var dateObject = getDateObject(date);
    return Intl.DateTimeFormat("en-us", formatting).format(dateObject);
};
/**
 * @param   {string} date
 * @param   {string} offset
 * @returns {string} returns a javascript Date matching a timezone offset
 */ var getDateInTimezone = function(date, offset) {
    var dstOffset = getDSTOffset(new Date(date));
    var dstOffsetDate = sub(new Date(date), {
        hours: Math.abs(dstOffset)
    });
    var utcDate = (0,date_fns_tz.zonedTimeToUtc)(dstOffsetDate, getClientOffset());
    return (0,date_fns_tz.utcToZonedTime)((0,format/* default */.Z)(utcDate, "yyyy-MM-dd'T'HH:mm:ssXXX"), offset);
};
/**
 * @param   {string} date
 * @param   {string} format
 * @param   {string} offset
 * @returns {string} returns a formatted string date matching a timezone offset
 */ var getFormattedDateInTimezone = function(date, formatting, offset) {
    var utcDate = getDateInTimezone(date, offset);
    return (0,format/* default */.Z)(utcDate, formatting);
};
/**
 * @param   {string} date
 * @param   {string} format
 * @param   {string} timeZone
 * @returns {string} returns a formatted string date matching an IANA timezone
 */ var getFormattedDateInTimezoneName = function(date, formatting, timeZone) {
    var zonedDate = (0,date_fns_tz.utcToZonedTime)(date, timeZone);
    return (0,format/* default */.Z)(zonedDate, formatting);
};
var isValidDate = function(date) {
    return (0,isValid/* default */.Z)(date);
};


/***/ }),

/***/ 19663:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "j2": function() { return /* binding */ initialize; },
/* harmony export */   "uT": function() { return /* binding */ captureMessage; }
/* harmony export */ });
/* harmony import */ var _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92642);

/**
 * Dispatch a captured message to Sentry.
 */ function captureMessage(message, level) {
    var extra = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (true) {
        console.warn(message, {
            level: level,
            extra: extra
        });
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .captureMessage */ .uT(message, {
            level: level,
            extra: extra
        });
    }
}
/**
 * Dispatch a captured exception to Sentry.
 */ function captureException(exception, level) {
    var extra = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (true) {
        console.error(exception);
        _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .captureException */ .Tb(exception, {
            level: level,
            extra: extra
        });
    }
}
/** Tag the brand name in Sentry and set up any extra event listeners. */ function initialize(brand) {
    // Apply the brand name tag to events.
    _sentry_nextjs__WEBPACK_IMPORTED_MODULE_0__/* .setTag */ .YA("brand", brand);
    /**
   * Listens for Google Maps authentication errors.
   * For some insane reason, Google doesn't provide additional context
   * to this error handler so all we know is that something failed.
   * @see https://developers.google.com/maps/documentation/javascript/events#auth-errors
   */ window.gm_authFailure = function() {
        captureMessage("Google Maps Authentication Error!", "fatal");
    };
}


/***/ }),

/***/ 41762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CK": function() { return /* binding */ fireGenericOrderEventsHandler; },
/* harmony export */   "d5": function() { return /* binding */ objectifyOptions; },
/* harmony export */   "mY": function() { return /* binding */ safelyGetValueForKA; }
/* harmony export */ });
/* harmony import */ var _koala_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80684);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants_events__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26654);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63654);
/* harmony import */ var _utils_koalaAnalytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61216);





// Creates `transaction` object used in `fireGenericOrderEventsHandler` below
var transactionHandler = function(orderDetails) {
    return {
        id: orderDetails.id,
        card_brand: orderDetails.order_data.order.payment_card_type,
        last_four_digits: orderDetails.order_data.order.payment_card,
        time_taken: null
    };
};
// Creates `order` object used in `fireGenericOrderEventsHandler` below
var orderHandler = function(orderDetails) {
    return {
        promo_discount: orderDetails.order_data.order.promo_discount,
        id: orderDetails.order_id,
        order_number: orderDetails.order_data.order.order_number,
        ready_time: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__/* .getISODateInUTC */ .j4)(orderDetails.order_data.order.ready_at),
        subtotal: orderDetails.order_data.order.subtotal,
        sales_tax: [
            {
                label: "Tax",
                tax_cents: orderDetails.order_data.order.sales_tax
            }, 
        ],
        ordered_at: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_4__/* .getISODateInUTC */ .j4)(orderDetails.order_data.order.ordered_at),
        total: orderDetails.order_data.order.total,
        conveyance_type: orderDetails.order_data.basket.conveyance_type.type
    };
};
/*
Use this method for any events that pass the generic `transaction`, `order`, and `basket_products` objects with NO modifications
*/ var fireGenericOrderEventsHandler = function(eventName, basketContent, orderDetails, dataObjects, details) {
    try {
        var customizedDataObject = {};
        // Build customized data object based on the keys we pass in
        dataObjects === null || dataObjects === void 0 ? void 0 : dataObjects.map(function(entry) {
            switch(entry){
                case _constants_events__WEBPACK_IMPORTED_MODULE_2__/* .BASKET_ORDER_KEYS.TRANSACTION */ .oO.TRANSACTION:
                    // @ts-expect-error string can't index `customizedDataObject`.
                    customizedDataObject[entry] = transactionHandler(orderDetails);
                    break;
                case _constants_events__WEBPACK_IMPORTED_MODULE_2__/* .BASKET_ORDER_KEYS.ORDER */ .oO.ORDER:
                    // @ts-expect-error string can't index `customizedDataObject`.
                    customizedDataObject[entry] = orderHandler(orderDetails);
                    break;
                case _constants_events__WEBPACK_IMPORTED_MODULE_2__/* .BASKET_ORDER_KEYS.BASKET_PRODUCTS */ .oO.BASKET_PRODUCTS:
                    // @ts-expect-error string can't index `customizedDataObject`.
                    customizedDataObject[entry] = (0,_utils_koalaAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .coerceBasketProductsForKA */ .Ww)(basketContent.basket_items);
                    break;
            }
        });
        // If we have optional 'details', include them here
        if (details) {
            customizedDataObject.details = details;
        }
        // Koala Event with passing our customized fields
        (0,_utils_koalaAnalytics__WEBPACK_IMPORTED_MODULE_3__/* .fireKAnalyticsEvent */ .G)(eventName, customizedDataObject);
    } catch (e) {
        console.log("Error dispatching checkout events.");
        console.log(e);
    }
};
// Loop through the options recursively every time we fetch a menu and set the object on the KA class
var objectifyOptions = function(menuCategories) {
    // Only run if we're on the client
    if (false) {}
    var optionsObject = _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkUtils.objectifyOptionsMenuLevel */ .fH.objectifyOptionsMenuLevel(menuCategories);
    // Set our new optionObjects on our Koala Analytics class
    if (Object.keys(optionsObject).length && "KoalaAnalytics" in window) {
        window.KoalaAnalytics.setMenuProductOptions(optionsObject);
    }
};
// Find specific value from an array for Analytics
var safelyGetValueForKA = function(dataArray, keyToCompare1, keyToCompare2, keyToReturn) {
    // Find entry from the array using our two keys to compare - i.e. IDs
    var newEntry = dataArray.find(// @ts-expect-error string can't index `entry` object.
    function(entry) {
        return entry[keyToCompare1].toString() === keyToCompare2.toString();
    });
    if (newEntry) {
        // If entry is found, search for the key we want to return - i.e. label
        return lodash_get__WEBPACK_IMPORTED_MODULE_1___default()(newEntry, "".concat(keyToReturn), null);
    }
    return null;
};


/***/ }),

/***/ 38732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "n": function() { return /* binding */ KoalaFeatureHandler; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../packages/sdk/dist/index.mjs + 1 modules
var dist = __webpack_require__(80684);
// EXTERNAL MODULE: ./src/constants/events.ts
var events = __webpack_require__(26654);
// EXTERNAL MODULE: ./src/constants/features.ts
var features = __webpack_require__(51710);
// EXTERNAL MODULE: ./src/constants/global.ts
var global = __webpack_require__(66686);
;// CONCATENATED MODULE: ./src/constants/reorders.ts
var REORDER_APP_VIEWS = {
    CTA: "CTA",
    LIST: "List"
};

// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(25643);
// EXTERNAL MODULE: ./src/utils/loyalty.ts
var loyalty = __webpack_require__(53174);
;// CONCATENATED MODULE: ./src/utils/features.ts








/**
 * Provides methods to determine whether or not a feature should be enabled or disabled.
 *
 * @IMPLEMENTATION-TODO
 * As of 12/21/21: Without upgraded Next/React/Redux packages, we cannot yet use the following
 * alternatives to requiring global state in the constructor:
 * - useSelector()
 * - useStore()
 * - useReducer()
 * - react-redux context
 * - exporting store from 'redux/store' (SSR limitations and also this is a dirty way of doing this)
 */ var KoalaFeatureHandler = /*#__PURE__*/ function() {
    "use strict";
    function KoalaFeatureHandler(globalState) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, KoalaFeatureHandler);
        /**
   * Determine if a conveyance type is a locked conveyance flow
   *
   * @param conveyanceType API_CONVEYANCE_TYPES
   * @returns boolean
   */ this.isLockedConveyanceFlow = function(conveyanceType) {
            var // @ts-expect-error: TODO: 'string' can't be used to index type '{}'
            ref;
            var handoffParam = ((ref = _this.globalState.global.routerStatus.persistentParameters) === null || ref === void 0 ? void 0 : ref[global/* ALLOWED_URL_PARAMETER_KEYS.HANDOFF */.Ue.HANDOFF]) || "";
            return handoffParam === conveyanceType && global/* LOCKED_FLOW_CONVEYANCE_TYPES.includes */.OH.includes(conveyanceType);
        };
        this.globalState = globalState;
    }
    var _proto = KoalaFeatureHandler.prototype;
    /**
   * Determine if a feature flag is enabled or not
   *
   * @param featureFlag FEATURE_FLAGS
   * @returns boolean
   */ _proto.isFeatureAllowed = function isFeatureAllowed(featureFlag) {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var hasPastOrders = ((ref = this.globalState.me) === null || ref === void 0 ? void 0 : (ref1 = ref.pastOrders) === null || ref1 === void 0 ? void 0 : ref1.length) > 0;
        var isDineInFlow = this.isLockedConveyanceFlow(events/* API_CONVEYANCE_TYPES.DINEIN */.tQ.DINEIN);
        var loyaltyDriverID = (ref2 = this.globalState.organization.organization) === null || ref2 === void 0 ? void 0 : ref2.loyalty_driver_id;
        var ref6;
        var androidReordersEnabled = (ref6 = (ref3 = this.globalState.cmsConfig.webConfig.android_features) === null || ref3 === void 0 ? void 0 : ref3.reorders) !== null && ref6 !== void 0 ? ref6 : false;
        var ref7;
        var androidReordersView = (ref7 = (ref4 = this.globalState.cmsConfig.webConfig.android_features) === null || ref4 === void 0 ? void 0 : ref4.reorders_view) !== null && ref7 !== void 0 ? ref7 : false;
        var ref8;
        var loggedIn = (ref8 = (ref5 = this.globalState.me) === null || ref5 === void 0 ? void 0 : ref5.data) !== null && ref8 !== void 0 ? ref8 : false;
        switch(featureFlag){
            case features/* FEATURE_FLAGS.GLOBAL__LOCATIONS_PAGE */.y8.GLOBAL__LOCATIONS_PAGE:
                // Hide the locations page when it is disabled or if the user is in a locked conveyance flow and should not change locations
                var locationsDisabled = this.globalState.cmsConfig.webConfig.locations.disable_locations_page;
                return !(isDineInFlow || locationsDisabled);
            case features/* FEATURE_FLAGS.STORE__FULFILLMENT_TOGGLE */.y8.STORE__FULFILLMENT_TOGGLE:
                // Hide the fulfillment toggle if the user is in a delivery-only flow or a locked dine_in flow
                var locationDetail = this.globalState.locations.detail;
                var deliveryOnlyOrNoDelivery = !(locationDetail === null || locationDetail === void 0 ? void 0 : locationDetail.supports_delivery) || (locationDetail === null || locationDetail === void 0 ? void 0 : locationDetail.is_delivery_only);
                return !(deliveryOnlyOrNoDelivery !== null && deliveryOnlyOrNoDelivery !== void 0 ? deliveryOnlyOrNoDelivery : isDineInFlow);
            case features/* FEATURE_FLAGS.STORE__MENU_SEARCH */.y8.STORE__MENU_SEARCH:
                return this.globalState.cmsConfig.webConfig.menu.menu_search;
            case features/* FEATURE_FLAGS.STORE__DIETARY_PREFERENCES */.y8.STORE__DIETARY_PREFERENCES:
                var ref9;
                return this.globalState.cmsConfig.webConfig.menu.dietary_preferences_enabled && ((ref9 = this.globalState.allergens) === null || ref9 === void 0 ? void 0 : ref9.allergens.length) > 0;
            case features/* FEATURE_FLAGS.ANDROID__REORDER */.y8.ANDROID__REORDER:
                return hasPastOrders && !isDineInFlow && androidReordersEnabled;
            case features/* FEATURE_FLAGS.ANDROID__REORDER_LIST */.y8.ANDROID__REORDER_LIST:
                return hasPastOrders && !isDineInFlow && androidReordersEnabled && androidReordersView === REORDER_APP_VIEWS.LIST;
            case features/* FEATURE_FLAGS.ANDROID__REORDER_CTA */.y8.ANDROID__REORDER_CTA:
                return hasPastOrders && !isDineInFlow && androidReordersEnabled && androidReordersView === REORDER_APP_VIEWS.CTA;
            case features/* FEATURE_FLAGS.ME__REORDER */.y8.ME__REORDER:
                var reordersEnabled = this.globalState.cmsConfig.webConfig.accounts.reorders;
                return hasPastOrders && !isDineInFlow && reordersEnabled;
            case features/* FEATURE_FLAGS.ACCOUNT__REWARDS */.y8.ACCOUNT__REWARDS:
                return (0,loyalty/* allowedLoyaltyRoutes */.kz)(loyaltyDriverID).includes(routes/* LOYALTY_ROUTES.REWARDS */.xM.REWARDS);
            case features/* FEATURE_FLAGS.ACCOUNT__INBOX */.y8.ACCOUNT__INBOX:
                return (0,loyalty/* allowedLoyaltyRoutes */.kz)(loyaltyDriverID).includes(routes/* LOYALTY_ROUTES.INBOX */.xM.INBOX);
            case features/* FEATURE_FLAGS.ACCOUNT__ORDER_HISTORY */.y8.ACCOUNT__ORDER_HISTORY:
                // Hide these features if the user is in a locked dine_in flow
                return !isDineInFlow;
            case features/* FEATURE_FLAGS.ACCOUNT__FAVORITES */.y8.ACCOUNT__FAVORITES:
                // Hide these features if the user is in a locked dine_in flow
                return !isDineInFlow;
            case features/* FEATURE_FLAGS.CHECKOUT__HANDOFF_DETAILS */.y8.CHECKOUT__HANDOFF_DETAILS:
                // Hide these features if the user is in a locked dine_in flow
                return !isDineInFlow;
            case features/* FEATURE_FLAGS.CHECKOUT__WANTED_AT_TIME */.y8.CHECKOUT__WANTED_AT_TIME:
                // Hide these features if the user is in a locked dine_in flow
                return !isDineInFlow;
            case features/* FEATURE_FLAGS.ANDROID__FAVORITES */.y8.ANDROID__FAVORITES:
                return loggedIn && !(0,loyalty/* allowedLoyaltyRoutes */.kz)(loyaltyDriverID).includes(routes/* LOYALTY_ROUTES.INBOX */.xM.INBOX);
            case features/* FEATURE_FLAGS.CHECKOUT__HANDOFF_DINE_IN_INSTRUCTIONS */.y8.CHECKOUT__HANDOFF_DINE_IN_INSTRUCTIONS:
                // Hide this feature if the user is not in a locked dine_in flow and
                // if the conveyance mode is not dine in or the location does NOT support table numbers
                var isDineInConveyance = this.globalState.conveyanceMode.type === dist/* CONVEYANCE_TYPES.DINEIN */.P8.DINEIN;
                var supportsTableNumbers = this.globalState.basket.location.supports_dine_in_table_number;
                if (!supportsTableNumbers) {
                    return false;
                }
                return isDineInFlow || isDineInConveyance;
            case features/* FEATURE_FLAGS.CHECKOUT__ESCAPE_LOCKED_CONVEYANCE */.y8.CHECKOUT__ESCAPE_LOCKED_CONVEYANCE:
                // Only enable this feature if the user is in a locked dine_in flow
                return isDineInFlow;
            case features/* FEATURE_FLAGS.CART__CHANGE_LOCATION */.y8.CART__CHANGE_LOCATION:
                // Hide the change location CTA in the cart if there is no string present
                return this.globalState.cmsConfig.strings.cart_checkout.change_location_cta ? true : false;
            case features/* FEATURE_FLAGS.ACCOUNT__FAVORITE_LOCATIONS_ENABLED */.y8.ACCOUNT__FAVORITE_LOCATIONS_ENABLED:
                var ref10, ref11, ref12;
                var supportsSingleFavoriteLocations = !!((ref10 = this.globalState.organization) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.external_auth) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.features) === null || ref12 === void 0 ? void 0 : ref12.supportsSingleFavoriteLocations);
                var isFavoriteLocationEnabled = this.globalState.cmsConfig.webConfig.accounts.favorite_location !== "disabled";
                return supportsSingleFavoriteLocations && isFavoriteLocationEnabled;
            case features/* FEATURE_FLAGS.DELIVERY_STATUS_ENABLED */.y8.DELIVERY_STATUS_ENABLED:
                {
                    var ref13, ref14, ref15, ref16, ref17;
                    var orderDetails = (ref13 = this.globalState) === null || ref13 === void 0 ? void 0 : ref13.orderDetails;
                    var conveyanceType = orderDetails === null || orderDetails === void 0 ? void 0 : (ref14 = orderDetails.order_data) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.basket) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.conveyance_type) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.type) === null || ref17 === void 0 ? void 0 : ref17.toLowerCase();
                    var isDeliveryConveyanceType = conveyanceType === events/* API_CONVEYANCE_TYPES.DELIVERY.toLowerCase */.tQ.DELIVERY.toLowerCase();
                    var isDispatchTrackingEnabled = !!(orderDetails === null || orderDetails === void 0 ? void 0 : orderDetails.order_number) && isDeliveryConveyanceType && this.globalState.cmsConfig.webConfig.dispatch_tracking.dispatch_tracking_enabled;
                    return isDispatchTrackingEnabled;
                }
            default:
                // return individual flag default/fallback state or false if no fallback is provided
                return features/* FALLBACK_FEATURE_BAG */.v2[featureFlag] || false;
        }
    };
    return KoalaFeatureHandler;
}();


/***/ }),

/***/ 89744:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kk": function() { return /* binding */ showManualDeliveryFormConditions; },
/* harmony export */   "P1": function() { return /* binding */ determineFulfillment; },
/* harmony export */   "U8": function() { return /* binding */ coerceAddressValidationPayload; }
/* harmony export */ });
/* harmony import */ var _koala_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80684);
/* harmony import */ var _constants_global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66686);
/* harmony import */ var _utils_errorReporter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19663);



var coerceAddressValidationPayload = function(address) {
    // Concatenating the date and time
    var isASAP = address.time_wanted === _constants_global__WEBPACK_IMPORTED_MODULE_1__/* .DELIVERY_TIME_WANTED_MODES.ASAP */ .hC.ASAP;
    // Cocerce form values for submission to Olo
    var deliveryAddressPayload = Object.assign({}, address, {
        time_wanted: isASAP ? null : address.time_wanted,
        time_wanted_mode: isASAP ? _constants_global__WEBPACK_IMPORTED_MODULE_1__/* .DELIVERY_TIME_WANTED_MODES.ASAP */ .hC.ASAP : _constants_global__WEBPACK_IMPORTED_MODULE_1__/* .DELIVERY_TIME_WANTED_MODES.ADVANCE */ .hC.ADVANCE
    });
    return deliveryAddressPayload;
};
/**
 * Determine the current fulfillment mode (delivery versus pickup)
 *
 * @param {DeliveryAddress} deliveryAddress
 * @param {Location} locationDetail
 * @param {Location} basketLocation
 * @param {object} basketFulfillment
 *
 * @return {CONVEYANCE_TYPES}
 */ var determineFulfillment = function(deliveryAddress, locationDetail, basketLocation, basketFulfillment) {
    // If location is delivery only, return delivery conveyance type and skip remaining logic
    if (locationDetail.is_delivery_only) {
        return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.DELIVERY */ .P8.DELIVERY;
    }
    /**
   * TODO:
   * After completion of 4569, the conveyance type should be available to us earlier
   * which will allow us room to refactor the below logic.
   */ var activeOrderMode = _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CONVEYANCE_TYPES.PICKUP */ .P8.PICKUP;
    // If a deliveryAddress exists in redux
    if (deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.address) {
        // Ensure store ID from the fulfillment modal matches the store we're on
        // If so, that is the activeOrderMode
        if (deliveryAddress.fulfillmentModalStoreId === locationDetail.id) {
            activeOrderMode = deliveryAddress.type;
        } else {
            // If the IDs don't match, log in error reporter
            _utils_errorReporter__WEBPACK_IMPORTED_MODULE_2__/* .captureMessage */ .uT("Store id in redux does not match current location id", "info", {
                deliveryAddress: deliveryAddress,
                storeId: locationDetail.id,
                basketLocationId: basketLocation.id
            });
        }
    }
    // If a basket exists in location storage, that should be the canonical activeOrderMode
    // Assuming the basketLocation matches the store we're on
    if (basketLocation.id === locationDetail.id && basketFulfillment) {
        activeOrderMode = basketFulfillment.type;
    }
    return activeOrderMode;
};
// Logic for whether to display the manual delivery form
var showManualDeliveryFormConditions = function(displayStoredAddresses, storedAddressSelected, formValues) {
    // Stored addresses not enabled or no stored addresses exist
    // Could also mean user not logged in
    if (!displayStoredAddresses) {
        return true;
    }
    // User has selected a stored address
    if (displayStoredAddresses && storedAddressSelected) {
        return false;
    }
    // No stored address selected and empty form
    if (displayStoredAddresses && !storedAddressSelected && !(formValues === null || formValues === void 0 ? void 0 : formValues.street_address)) {
        return false;
    }
    // User has entered a manual address OR started with a stored address and then edited it
    if ((formValues === null || formValues === void 0 ? void 0 : formValues.street_address) && !(formValues === null || formValues === void 0 ? void 0 : formValues.id)) {
        return true;
    }
    return false;
};


/***/ }),

/***/ 36304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Fc": function() { return /* binding */ getPersistentParameterValue; },
/* harmony export */   "IW": function() { return /* binding */ derivePersistentURLParameters; },
/* harmony export */   "Jz": function() { return /* binding */ isScriptInDOM; },
/* harmony export */   "PA": function() { return /* binding */ parseReferrer; },
/* harmony export */   "PB": function() { return /* binding */ removeScriptFromDOM; },
/* harmony export */   "R0": function() { return /* binding */ toggleBodyScroll; },
/* harmony export */   "UT": function() { return /* binding */ addScriptToDOM; },
/* harmony export */   "Xr": function() { return /* binding */ prepareErrorMessage; },
/* harmony export */   "Z2": function() { return /* binding */ getCanonicalUrl; },
/* harmony export */   "Zl": function() { return /* binding */ deriveErrorMessage; },
/* harmony export */   "k5": function() { return /* binding */ deriveReferrer; },
/* harmony export */   "kd": function() { return /* binding */ derivePageNameFromPath; },
/* harmony export */   "pW": function() { return /* binding */ getElementOffset; },
/* harmony export */   "sW": function() { return /* binding */ genericGroupItemsByKey; },
/* harmony export */   "vQ": function() { return /* binding */ copyToClipboard; }
/* harmony export */ });
/* unused harmony exports scrollToOffset, isPersistentParameterAllowed */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42838);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(22970);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75472);
/* harmony import */ var lodash_orderBy__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_orderBy__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66686);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25643);









// Generic method to group an array of objects by a specific key
// currently used to group locations by state and cart items by filter tag
/** @TODO refactor this utility to correctly use generics. */ var genericGroupItemsByKey = function(array, stringPathToKey, uniqueBy) {
    // `stringPathToKey` is the path to the key you want to sort by - accessible via the lodash 'get' method
    var filtersObject = {};
    var itemDict = {};
    // @ts-expect-error
    var filtersArray = [];
    if (!array) {
        // @ts-expect-error
        return {
            filtersArray: filtersArray,
            filtersObject: filtersObject
        };
    }
    array.forEach(function(arrayItem, index) {
        var entry = lodash_get__WEBPACK_IMPORTED_MODULE_0___default()(arrayItem, stringPathToKey, false);
        // Don't push duplicate items if a uniqueBy property is defined
        if (uniqueBy) {
            // @ts-expect-error
            if (itemDict[arrayItem[uniqueBy]]) {
                return;
            }
            // @ts-expect-error
            itemDict[arrayItem[uniqueBy]] = true;
        }
        // @ts-expect-error
        filtersObject[entry] = filtersObject[entry] || [];
        // @ts-expect-error
        filtersObject[entry].push((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, arrayItem), {
            index: index
        }));
    });
    // Derive an array of key strings
    filtersArray = Object.keys(filtersObject);
    filtersArray.sort();
    // Order the entries within each filtersObject key
    Object.keys(filtersObject).forEach(function(key) {
        // @ts-expect-error
        filtersObject[key] = lodash_orderBy__WEBPACK_IMPORTED_MODULE_1___default()(// @ts-expect-error
        filtersObject[key], [
            "entry",
            "label"
        ], [
            "asc",
            "asc"
        ]);
    });
    return {
        filtersArray: filtersArray,
        filtersObject: filtersObject
    };
};
/**
 * Disable body scroll when scrollable / fixed overlays appear
 *
 * @param {Boolean} scroll
 */ var toggleBodyScroll = function(scroll) {
    // Add the 'no-scroll' class via vanilla JS since not sure how to pass redux state to _document
    if (!scroll) {
        document.body.classList.add("no-scroll");
    } else {
        document.body.classList.remove("no-scroll");
    }
};
/**
 * Calculate the scrollTo offset dependent on which header style is used.
 */ var scrollToOffset = function() {
    var elementTop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, additionalOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    if (false) {}
    return elementTop + window.pageYOffset - additionalOffset;
};
/**
 * Calculate the x & y offsets of an document element
 */ var getElementOffset = function(el) {
    var _x = 0;
    var _y = 0;
    while(el && !isNaN(el.offsetLeft) && !isNaN(el.offsetTop)){
        _x += el.offsetLeft - el.scrollLeft;
        _y += el.offsetTop - el.scrollTop;
        // @ts-expect-error assigning Element to HTMLElement
        el = el.offsetParent;
    }
    return {
        top: _y,
        left: _x
    };
};
var deriveErrorMessage = function(error) {
    if (!error) {
        return "";
    }
    var message = "";
    if (typeof error.error_description === "string") {
        message += "".concat(error.error_description, " ");
    }
    if (error.error_data && typeof error.error_data.failures === "object") {
        message += Object.values(error.error_data.failures).join(", ");
    } else if (typeof error.error_description === "object" && typeof error.error === "string") {
        message += error.error;
    }
    return message;
};
function isResponse(error) {
    return typeof error.text === "function";
}
function prepareErrorMessage(staticMessage, errorResponse) {
    return _prepareErrorMessage.apply(this, arguments);
}
function _prepareErrorMessage() {
    _prepareErrorMessage = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(function(staticMessage, errorResponse) {
        var message, error, e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_7__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    message = staticMessage !== null && staticMessage !== void 0 ? staticMessage : "";
                    error = null;
                    if (!isResponse(errorResponse)) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        errorResponse.text()// eslint-disable-next-line @typescript-eslint/no-unsafe-return
                        .then(function(text) {
                            return text ? JSON.parse(text) : {};
                        })
                    ];
                case 2:
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                    error = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    console.error(e, errorResponse.text());
                    return [
                        3,
                        4
                    ];
                case 4:
                    message += " ".concat(deriveErrorMessage(error));
                    return [
                        3,
                        6
                    ];
                case 5:
                    if (errorResponse && typeof errorResponse === "object" && "text" in errorResponse) {
                        // @ts-expect-error: typing issues
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                        error = JSON.parse(errorResponse.text);
                        message += deriveErrorMessage(error);
                    } else {
                        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                        message += " ".concat(errorResponse);
                    }
                    _state.label = 6;
                case 6:
                    return [
                        2,
                        {
                            message: message,
                            error: error
                        }
                    ];
            }
        });
    });
    return _prepareErrorMessage.apply(this, arguments);
}
/**
 * Given a pathname, derive a user-facing page title
 */ var derivePageNameFromPath = function(pathname) {
    var pageName = "";
    if (!pathname) {
        return pageName;
    }
    // Iterate through a pathname array
    pathname.split("/").forEach(function(pathParam) {
        if (pathParam) {
            // Remove all dashes
            var sanitizedPathParam = pathParam.replace(/-/g, " ");
            // Uppercase first letter & add pipe
            pageName += "".concat(sanitizedPathParam.charAt(0).toUpperCase()).concat(sanitizedPathParam.slice(1), " | ");
        }
    });
    return decodeURI(pageName);
};
/**
 * Return a valid referrer for use on post sign-up or login
 */ var deriveReferrer = function(router) {
    var ref;
    // Default to homepage redirect
    var referrer = _constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .ROUTES.HOMEPAGE */ .Z6.HOMEPAGE;
    // /checkout or /store/[...id] are valid referrer pages
    if ([
        _constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .ROUTES.CHECKOUT */ .Z6.CHECKOUT,
        _constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .ROUTES.STORE */ .Z6.STORE,
        _constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .ROUTES.ANDROID */ .Z6.ANDROID,
        _constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .LOYALTY_ROUTES.REWARDS */ .xM.REWARDS,
        _constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .LOYALTY_ROUTES.FAVORITES */ .xM.FAVORITES, 
    ].includes(router === null || router === void 0 ? void 0 : router.pathname)) {
        referrer = router === null || router === void 0 ? void 0 : router.pathname;
        // If it's a store page, we have to swap the pathname (/store/[...id]) for the asPath (/store/{storeId}/{storeName})
        if (router.pathname === _constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .ROUTES.STORE */ .Z6.STORE) {
            referrer = router === null || router === void 0 ? void 0 : router.asPath;
        }
    }
    // BUT! if we have an existing referrer, lets just pass that along
    return encodeURIComponent((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.referrer) || referrer);
};
/**
 * Return a valid referrer for use on post sign-up or login
 */ var parseReferrer = function(router) {
    var ref;
    // Either we'll use the existing referrer or the homepage
    var referrer = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.referrer) || _constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .ROUTES.HOMEPAGE */ .Z6.HOMEPAGE;
    // If we're on the checkout page, we do not want to redirect
    if (_constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .ROUTES.CHECKOUT */ .Z6.CHECKOUT === router.pathname) {
        referrer = "";
    }
    return referrer;
};
var copyToClipboard = function(str) {
    if (!str) {
        return;
    }
    // Works for all browsers except IE
    var copySuccess = navigator.clipboard.writeText(str).then(function() {
        return /* clipboard successfully set */ true;
    }, function() {
        return /* clipboard write failed */ false;
    });
    return copySuccess;
};
var getCanonicalUrl = function(baseUrl, router) {
    // Remove hashes and query params from url
    var path = router.asPath.split(/[?#]/)[0];
    // Standardize store urls
    if (router.pathname === _constants_routes__WEBPACK_IMPORTED_MODULE_3__/* .ROUTES.STORE */ .Z6.STORE) {
        /** @TODO guard to ensure that query.id is defined. */ // @ts-expect-error
        path = "/store/".concat(router.query.id[0]);
    }
    return "".concat(baseUrl).concat(path);
};
/**
 * Derive a collection of persistable parameters from a given collection of URL parameters.
 *
 * @param parameters Record<string, string>
 * @param allowUnlisted boolean
 * @returns Record<string, string>
 */ var derivePersistentURLParameters = function(parameters) {
    var derivedParameters = {};
    Object.keys(parameters).forEach(function(param) {
        /** @TODO ensure that `parameters[param]` is defined before use. */ // @ts-expect-error
        if (isPersistentParameterAllowed(param, parameters[param].toString())) {
            derivedParameters[param] = parameters[param];
        }
    });
    return derivedParameters;
};
/**
 * Determine if a parameter and its value are allowed to persist
 *
 * @param parameter string
 * @param value string
 * @return boolean;
 */ var isPersistentParameterAllowed = function(parameter, value) {
    if (!Object.values(_constants_global__WEBPACK_IMPORTED_MODULE_2__/* .ALLOWED_URL_PARAMETER_KEYS */ .Ue).includes(parameter)) {
        return false;
    }
    // Check if value is valid (empty [] indicate any value is acceptable and is also valid)
    if (_constants_global__WEBPACK_IMPORTED_MODULE_2__/* .ALLOWED_URL_PARAMETER_VALUES */ .PV[parameter].includes(value) || _constants_global__WEBPACK_IMPORTED_MODULE_2__/* .ALLOWED_URL_PARAMETER_VALUES */ .PV[parameter].length === 0) {
        return true;
    }
    return false;
};
/**
 * Get a persistent parameter value from session storage
 *
 * @param parameter string
 * @returns string
 */ var getPersistentParameterValue = function(parameter) {
    try {
        var sessionParameters = JSON.parse(sessionStorage.getItem(_constants_global__WEBPACK_IMPORTED_MODULE_2__/* .KOALA_SESSION_STORAGE_KEYS.PARAMETERS */ .iy.PARAMETERS) || "{}");
        return sessionParameters[parameter];
    } catch (err) {
        if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(err, Error)) {
            // This is the same error that Safari private browsing will return
            if (err.name === "QUOTA_EXCEEDED_ERR") {
                console.error("We have exceeded the allowed storage quota");
            }
        }
        console.error(err);
        return "";
    }
};
function removeScriptFromDOM(scriptSource) {
    var ref;
    var script = document.querySelector('script[src="'.concat(scriptSource, '"]'));
    script === null || script === void 0 ? void 0 : (ref = script.parentNode) === null || ref === void 0 ? void 0 : ref.removeChild(script);
}
function isScriptInDOM(scriptSource) {
    return Boolean(document.querySelector('script[src="'.concat(scriptSource, '"]')));
}
function addScriptToDOM(scriptSource, callBackOnLoad) {
    var script = document.createElement("script");
    script.src = scriptSource;
    //script is executed when the page has finished parsing.
    //https://developer.mozilla.org/en-US/docs/Web/API/Window/DOMContentLoaded_event
    script.defer = true;
    script.onload = callBackOnLoad;
    script.onerror = function(event) {
        var // But in current context it is a HTMLScriptElement
        ref;
        var src = typeof event === "string" ? scriptSource : (ref = event.target) === null || ref === void 0 ? void 0 : ref.src;
        console.warn('The script "'.concat(src, "\" didn't load correctly."));
    };
    document.body.appendChild(script);
}


/***/ }),

/***/ 87809:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Kx": function() { return /* binding */ GOOGLE_TRACKER_NAME; },
/* harmony export */   "cE": function() { return /* binding */ gaActions; },
/* harmony export */   "d4": function() { return /* binding */ fireGaEvent; },
/* harmony export */   "m1": function() { return /* binding */ gaCats; }
/* harmony export */ });
/**
 * GA Actions
 */ var gaActions = {
    addToBasket: "Add to Basket",
    addCrossSell: "Add Cross-sell",
    asapTimeSelected: "ASAP Pickup Time Selected",
    basketNotValid: "Basket not valid",
    basketExpired: "Basket Expired",
    basketStructureInvalid: "Basket Structure Invalid",
    basketFulfillmentNotSet: "Basket fulfillment not set on existing basket",
    basketFulfillmenSet: "Basket fulfillment set on existing basket",
    backToMenu: "Back to Menu",
    cancelGuestCheckout: "Cancel Guest Checkout",
    cancelSignInCheckout: "Cancel Sign In Checkout",
    cancelSignUpCheckout: "Cancel Sign Up Checkout",
    changeLocation: "Change Location",
    checkoutAbandoned: "Checkout Abandoned",
    checkoutError: "Checkout Error",
    clickCategory: "Click Category",
    clickCheckOut: "Click Check Out",
    collapseShopDetails: "Collapse Shop Details",
    couponApplied: "Coupon applied",
    couponDenied: "Coupon denied",
    couponRemoved: "Coupon removed",
    couponRemovalFailed: "Coupon removal failed",
    dietaryPreferencesUpdated: "Dietary preferences updated",
    editItem: "Edit Item",
    editContactInfo: "Edit Contact Info",
    exitItemModifier: "Exit Item Modifier",
    expandShopDetails: "Expand Shop Details",
    geolocationSearch: "Geolocation Search",
    leftSite: "Left Site",
    locations: "Locations",
    locationNotAvailable: "Online Ordering Not Available",
    mapSearchArea: "Search Map Area",
    menuSearch: "Menu Search",
    nutritionInfo: "Nutrition Info",
    orderDelivery: "Order Delivery",
    orderConfirmation: "Order Confirmation",
    orderFavorited: "Order Favorited",
    orderUnfavorited: "Order Unfavorited",
    mapPrimaryCta: "Map Primary CTA",
    mapSecondaryCta: "Map Secondary CTA",
    mapTertiaryCta: "Map Tertiary CTA",
    mapQuaternaryCta: "Map Quaternary CTA",
    paymentApplied: "Payment applied",
    paymentDenied: "Payment denied",
    pciProxyTokenFailure: "Error exchanging PCI Proxy token for aliased card data",
    pciProxyApplied: "PCI Proxy applied",
    pciProxyFailed: "PCI Proxy failed",
    pickupTimeSelected: "Pickup Time Selected",
    removeItem: "Remove Item",
    saveCard: "Save Card",
    savedPaymentSelected: "Saved Payment Selected",
    scanCard: "Scan Card",
    submitOrder: "Submit Order",
    viewAccount: "View Account",
    viewMenu: "View Menu",
    viewOrder: "View Order",
    viewPendingOrder: "View Pending Order",
    viewProductDetail: "View Product Detail",
    clickMenuItem: "Click Menu Item",
    clickCrossSelllItem: "Click Cross-Sell Item",
    clickLocationCardTertiaryCta: "Click Location Card Tertiary CTA"
};
/**
 * GA Categories
 */ var gaCats = {
    account: "Account",
    browse: "Browse",
    category: "Category where event should roll up to",
    checkout: "Checkout Flow",
    global: "Global",
    findShop: "Find Shop",
    nutrition: "Nutrition",
    order: "Order",
    orderHistory: "Order History",
    orderStatus: "Order Status"
};
/**
 * GA Tracker Name
 */ var GOOGLE_TRACKER_NAME = "t0.";
/*
  Fire a GA event

  @param {String} category
  @param {String} action
  @param {Object} params
                    label
                    value
                    nonInteraction
                    transport
*/ var fireGaEvent = function(category, action, params) {
    var ref;
    if (typeof (window === null || window === void 0 ? void 0 : (ref = window.dataLayer) === null || ref === void 0 ? void 0 : ref.push) === "function") {
        // Push into dataLayer
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: action
        });
    }
    // Conditionally fire GA
    //@TODO: This should be removed after UA is deprecated on July 1, 2023
    if (typeof (window === null || window === void 0 ? void 0 : window.ga) === "function") {
        var mergedParams = {
            hitType: "event",
            eventCategory: category,
            eventAction: action,
            eventLabel: params === null || params === void 0 ? void 0 : params.label,
            eventValue: params === null || params === void 0 ? void 0 : params.value
        };
        window.ga("".concat(GOOGLE_TRACKER_NAME, "send"), mergedParams);
    }
    //Conditionally fire gtag.js when a tag id is present
    if (window === null || window === void 0 ? void 0 : window.gtag) {
        window.gtag("event", action, {
            eventCategory: category,
            eventLabel: params === null || params === void 0 ? void 0 : params.label,
            eventValue: params === null || params === void 0 ? void 0 : params.value
        });
    }
};


/***/ }),

/***/ 32210:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P$": function() { return /* binding */ getOrigin; },
/* harmony export */   "_v": function() { return /* binding */ sleep; },
/* harmony export */   "vi": function() { return /* binding */ getRequestOrigin; }
/* harmony export */ });
/* unused harmony exports __DEV, __DANGEROUS_EMPTY_REQUEST_ORIGIN */
/* harmony import */ var _koala_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80684);
/* harmony import */ var zod__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30195);
/* provided dependency */ var process = __webpack_require__(93542);


/** Shorthand for checking if we're running in local development mode. */ var __DEV = "production" === "development";
/** zzz */ function sleep(ms) {
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
}
/**
 * There's a limitation with the way we're able to fetch a request's origin
 * header in server-side-rendered components using React Query.
 *
 * Since the `NextRequest` object (which contains the header we need) is only
 * available within `getServerSideProps` functions in Next@12, we aren't
 * able to easily pass it down to child components rendered on the server.
 *
 * HOWEVER, in practice this isn't actually an issue because all server-side
 * React-Query queries should be pre-fetched using `queryClient.prefetchQuery`
 * inside of `getServerSideProps` — meaning that they will have access to
 * the `NextRequest`. When the `useQuery` hook runs server-side, it will
 * use the cached response from the prefetched query and not actually make
 * a network request with the empty request header.
 *
 * Let's look at the example below:
 * ```ts
 * let meta: RequestMeta;
 * if (typeof window !== "undefined") {
 *   meta = getRequestOrigin(window.location.host);
 * } else {
 *   meta = getRequestOrigin(__DANGEROUS_EMPTY_REQUEST_ORIGIN);
 * }
 * ```
 *
 * This code will run safely in 2 contexts:
 * ✅ On client-side route transitions — `window` will be defined.
 * ✅ On SSR — React Query will return a cached response and not hit the network.
 * ❌ This only fails if the query isn't pre-fetched before an SSR pass.
 *
 * @TODO a less fragile approach would be to:
 * 1. Create a new context/store/atom/etc. that wraps `_app.tsx`
 * 2. Pass the request origin header from `getInitialProps` to that context.
 * 3. Consume the request origin via that context in all components.
 */ var __DANGEROUS_EMPTY_REQUEST_ORIGIN = "";
function getOrigin(origin) {
    /** FOR LOCAL DEVELOPMENT ONLY! */ if (__DEV) {
        var brand;
        var environment;
        try {
            brand = zod__WEBPACK_IMPORTED_MODULE_1__.z.string().parse(process.env.NEXT_PUBLIC_DEV_BRAND);
            environment = _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .KoalaEnv.parse */ .dI.parse("production");
        } catch (e) {
            throw new Error("\uD83D\uDEA8 Invalid environment or brand!\n      ——————————————————————————————————————————————————————————————\n      Please check your .env.local file and ensure that both\n      `NEXT_PUBLIC_ENV` and `NEXT_PUBLIC_DEV_BRAND` are set.\n      ——————————————————————————————————————————————————————————————");
        }
        var _$origin = environment === "production" ? "".concat(brand, ".order.koala.io") : "".concat(brand, ".").concat(environment, ".order.koala.io");
        return _$origin;
    }
    return origin;
}
function getRequestOrigin(origin) {
    var originString = getOrigin(origin);
    if (__DEV) {
        return {
            headers: {
                "x-request-origin": originString,
                "x-local-dev": "true"
            }
        };
    }
    return {
        headers: {
            "x-request-origin": originString
        }
    };
}


/***/ }),

/***/ 61216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "b2": function() { return /* binding */ GenericKoalaAnalyticsWrapper; },
  "Ww": function() { return /* binding */ coerceBasketProductsForKA; },
  "ZP": function() { return /* binding */ koalaAnalytics; },
  "hN": function() { return /* binding */ fireKAnalyticsError; },
  "G": function() { return /* binding */ fireKAnalyticsEvent; },
  "xq": function() { return /* binding */ fireKAnalyticsUpsellEvent; },
  "X1": function() { return /* binding */ initializeKoalaAnalytics; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(90581);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../packages/sdk/dist/index.mjs + 1 modules
var dist = __webpack_require__(80684);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ../../node_modules/nanoid/index.browser.js
var index_browser = __webpack_require__(37164);
// EXTERNAL MODULE: ./src/constants/envConfig.ts + 1 modules
var envConfig = __webpack_require__(73690);
// EXTERNAL MODULE: ./src/constants/events.ts
var events = __webpack_require__(26654);
// EXTERNAL MODULE: ./src/constants/storageKeys.ts
var storageKeys = __webpack_require__(87183);
// EXTERNAL MODULE: ./src/constants/routes.ts
var routes = __webpack_require__(25643);
;// CONCATENATED MODULE: ./src/services/analytics.service.ts

function fireKoalaAnalyticsEvent(data) {
    return fetch(routes/* API_ROUTES.KOALA_ANALYTICS */.qf.KOALA_ANALYTICS, {
        method: "POST",
        body: JSON.stringify(data)
    }).then(function(response) {
        return response.json();
    });
}

// EXTERNAL MODULE: ./src/utils/android.ts
var android = __webpack_require__(90484);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(36304);
;// CONCATENATED MODULE: ./src/utils/koalaAnalytics.ts











// Generic Events
var KoalaEvents = {
    LOCATIONS__VIEW_ALL_LOCATIONS: {
        eventName: events/* K_ANALYTICS_EVENTS.VIEW_ALL_LOCATIONS */.AH.VIEW_ALL_LOCATIONS
    },
    LOCATIONS__SEARCH_LOCATIONS: {
        eventName: events/* K_ANALYTICS_EVENTS.LOCATION_SEARCH */.AH.LOCATION_SEARCH
    },
    LOCATIONS__TOGGLE_MOBILE_DISPLAY: {
        eventName: events/* K_ANALYTICS_EVENTS.LOCATION_VIEW_TOGGLE */.AH.LOCATION_VIEW_TOGGLE
    },
    LOCATIONS__TRIGGER_DELIVERY_MODAL: {
        eventName: events/* K_ANALYTICS_EVENTS.LOCATION_CTA */.AH.LOCATION_CTA
    },
    LOCATIONS__PRIMARY_LOCATION_CTA: {
        eventName: events/* K_ANALYTICS_EVENTS.LOCATION_CTA */.AH.LOCATION_CTA
    },
    LOCATIONS__FAVORITE_LOCATION_CTA: {
        eventName: events/* K_ANALYTICS_EVENTS.LOCATION_FAVORITE_CTA */.AH.LOCATION_FAVORITE_CTA
    },
    LOCATIONS__LOCATION_SEARCH_NOT_FOUND: {
        eventName: events/* K_ANALYTICS_EVENTS.LOCATION_SEARCH_NOT_FOUND */.AH.LOCATION_SEARCH_NOT_FOUND
    },
    LOCATION_RECOMMENDATIONS_SURFACED: {
        eventName: events/* K_ANALYTICS_EVENTS.LOCATION_RECOMMENDATIONS_SURFACED */.AH.LOCATION_RECOMMENDATIONS_SURFACED
    },
    GENERIC__CTA: {
        eventName: events/* K_ANALYTICS_EVENTS.CTA */.AH.CTA
    },
    AUTH__CLICK_LOGOUT: {
        eventName: events/* K_ANALYTICS_EVENTS.LOGOUT */.AH.LOGOUT
    },
    ACCOUNT__ADD_FAVORITE_LOCATION: {
        eventName: events/* K_ANALYTICS_EVENTS.LOCATION_FAVORITED */.AH.LOCATION_FAVORITED
    },
    ACCOUNT__REMOVE_FAVORITE_LOCATION: {
        eventName: events/* K_ANALYTICS_EVENTS.LOCATION_UNFAVORITED */.AH.LOCATION_UNFAVORITED
    },
    ACCOUNT__STORED_ADDRESS_DELETED: {
        eventName: events/* K_ANALYTICS_EVENTS.STORED_ADDRESS_DELETED */.AH.STORED_ADDRESS_DELETED
    },
    STORE__MENU_VIEW: {
        eventName: events/* K_ANALYTICS_EVENTS.MENU_VIEW */.AH.MENU_VIEW
    },
    STORE__CART_VIEW: {
        eventName: events/* K_ANALYTICS_EVENTS.CART_VIEW */.AH.CART_VIEW
    },
    STORE__PRODUCT_VIEW: {
        eventName: events/* K_ANALYTICS_EVENTS.PRODUCT_VIEW */.AH.PRODUCT_VIEW
    },
    STORE__BASKET_RECONCILIATION: {
        eventName: events/* K_ANALYTICS_EVENTS.BASKET_RECONCILIATION */.AH.BASKET_RECONCILIATION
    },
    CHECKOUT__CHECKOUT_VIEW: {
        eventName: events/* K_ANALYTICS_EVENTS.CHECKOUT_VIEW */.AH.CHECKOUT_VIEW
    },
    ARRIVAL__CONFIRM_ARRIVAL_SUCCESS: {
        eventName: events/* K_ANALYTICS_EVENTS.CONFIRM_ARRIVAL_SUCCESS */.AH.CONFIRM_ARRIVAL_SUCCESS
    },
    BASKET__CUSTOMIZED: {
        eventName: events/* K_ANALYTICS_EVENTS.BASKET_CUSTOMIZED */.AH.BASKET_CUSTOMIZED
    },
    DELIVERY__TOGGLE: {
        eventName: events/* K_ANALYTICS_EVENTS.DELIVERY_TOGGLE */.AH.DELIVERY_TOGGLE
    },
    VIEW__REWARDS: {
        eventName: events/* K_ANALYTICS_EVENTS.VIEW_REWARDS */.AH.VIEW_REWARDS
    },
    VIEW__ORDER_HISTORY: {
        eventName: events/* K_ANALYTICS_EVENTS.VIEW_ORDER_HISTORY */.AH.VIEW_ORDER_HISTORY
    },
    VIEW__FAVORITES: {
        eventName: events/* K_ANALYTICS_EVENTS.VIEW_FAVORITES */.AH.VIEW_FAVORITES
    },
    VIEW__STORE_LOCATOR: {
        eventName: events/* K_ANALYTICS_EVENTS.VIEW_STORE_LOCATOR */.AH.VIEW_STORE_LOCATOR
    },
    VIEW__INBOX: {
        eventName: events/* K_ANALYTICS_EVENTS.VIEW_INBOX */.AH.VIEW_INBOX
    },
    VIEW__DISPATCH_TRACKING: {
        eventName: events/* K_ANALYTICS_EVENTS.VIEW_DISPATCH_TRACKING */.AH.VIEW_DISPATCH_TRACKING
    },
    WANTED_AT_SELECTED: {
        eventName: events/* K_ANALYTICS_EVENTS.WANTED_AT_SELECTED */.AH.WANTED_AT_SELECTED
    }
};
/**
 * Koala
 */ var GenericKoalaAnalyticsWrapper = /*#__PURE__*/ function() {
    "use strict";
    function GenericKoalaAnalyticsWrapper() {
        (0,_class_call_check/* default */.Z)(this, GenericKoalaAnalyticsWrapper);
    }
    /**
   * Page View Event
   */ GenericKoalaAnalyticsWrapper.pageView = function pageView(path) {
        window.KoalaAnalytics.fireScreenEvent(path);
    };
    /**
   * Generic Events
   */ GenericKoalaAnalyticsWrapper.genericEvent = function genericEvent(globalEvent, context) {
        if (!KoalaEvents[globalEvent]) {
            return;
        }
        /** @TODO ensure that the event name is defined. */ // @ts-expect-error
        fireKAnalyticsEvent(KoalaEvents[globalEvent].eventName, {
            name: context.name,
            details: context.details
        });
    };
    return GenericKoalaAnalyticsWrapper;
}();
/**
 * Initialize Koala Analytics, create a new user session ID,
 * and add KA to the window object
 *
 * @returns void
 */ var initializeKoalaAnalytics = function(orgId, brandName) {
    if ( true && !window.KoalaAnalytics) {
        var sessionId = window.sessionStorage.getItem(storageKeys/* SESSION_STORAGE_KEYS.SESSION_ID */.s.SESSION_ID);
        var sessionStart = window.sessionStorage.getItem(storageKeys/* SESSION_STORAGE_KEYS.SESSION_START */.s.SESSION_START);
        var newSession = !sessionId;
        // If no session exists, create one
        if (newSession) {
            sessionId = (0,index_browser/* nanoid */.x0)();
            sessionStart = new Date().toISOString();
            initializeAppSession(sessionId, sessionStart);
        }
        // Ensure the KoalaAnalytics class is always created on app load
        window.KoalaAnalytics = new KoalaAnalytics(/** @TODO rework control flow so TS knows that `sessionId` is defined. */ // @ts-expect-error
        sessionId, sessionStart, orgId, brandName);
        if (newSession) {
            window.KoalaAnalytics.fireSessionStartEvent();
        } else {
            // If a session exists, but Koala analytics hasn't been instantiated
            // it likely means the user has refreshed the page
            fireKAnalyticsEvent(events/* K_ANALYTICS_EVENTS.LOG */.AH.LOG, {
                name: events/* LOG_EVENTS.SESSION_PERSISTED */.yX.SESSION_PERSISTED
            });
        }
        // Consolidated pageview events
        GenericKoalaAnalyticsWrapper.pageView(window.location.pathname);
    }
};
/**
 * Initialize the application session with a supplied session ID
 *
 * @param sessionId string
 * @param sessionStart string
 * @returns void
 */ var initializeAppSession = function(sessionId, sessionStart) {
    // Set the session id
    window.sessionStorage.setItem(storageKeys/* SESSION_STORAGE_KEYS.SESSION_ID */.s.SESSION_ID, sessionId);
    window.sessionStorage.setItem(storageKeys/* SESSION_STORAGE_KEYS.SESSION_START */.s.SESSION_START, sessionStart);
};
/**
 * safelyAccessClass
 *
 */ var safelyAccessClass = function() {
    if (false) {}
    if (!window.KoalaAnalytics) {
        console.warn("KoalaAnalytics is not defined");
        return false;
    }
    return true;
};
/**
 * coerceBasketProducts
 *
 */ var coerceBasketProductsForKA = function(basketProducts) {
    return basketProducts.map(function(basketItem) {
        var ref;
        return {
            id: basketItem.product.id,
            global_id: basketItem.product.global_id,
            name: basketItem.product.name,
            quantity: basketItem.quantity,
            cost: basketItem.product.cost,
            cross_sell_id: basketItem.product.cross_sell_id || null,
            selected_options: basketItem.options.map(function(option) {
                return {
                    id: option.id,
                    global_id: option.global_option_id,
                    total_cost_cents: option.cost,
                    quantity: option.quantity,
                    name: option.name
                };
            }),
            category_id: basketItem.product.category_id,
            category_label: basketItem.product.category_label,
            filter_tags: (ref = basketItem.product.filter_tags) === null || ref === void 0 ? void 0 : ref.map(function(tag) {
                return {
                    id: String(tag === null || tag === void 0 ? void 0 : tag.id),
                    label: tag === null || tag === void 0 ? void 0 : tag.label
                };
            })
        };
    });
};
/**
 * Formats KA error object for `ERROR` event
 * @TODO improve `error` argument typing.
 */ var prepareKAErrorObject = function(error, errorResponse) {
    var ref, ref1, ref2;
    var errorType = (errorResponse === null || errorResponse === void 0 ? void 0 : (ref = errorResponse.error) === null || ref === void 0 ? void 0 : ref.error) || null;
    var errorDescription = (0,global/* deriveErrorMessage */.Zl)(errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.error) || (error === null || error === void 0 ? void 0 : error.message);
    var koalaRequestId = (error === null || error === void 0 ? void 0 : (ref1 = error.headers) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.map) === null || ref2 === void 0 ? void 0 : ref2["x-request-id"]) || null;
    return {
        type: errorType,
        message: errorDescription,
        koala_request_id: koalaRequestId,
        status_code: error.status
    };
};
/*
 * Fires the ERROR event with an error object
 */ var fireKAnalyticsError = function(message, error, response, additionalDetails) {
    fireKAnalyticsEvent(events/* K_ANALYTICS_EVENTS.ERROR */.AH.ERROR, {
        name: message,
        error: prepareKAErrorObject(error, response),
        details: additionalDetails
    });
};
/**
 * fireKAnalyticsEvent
 *
 */ var fireKAnalyticsEvent = function(type, eventDetails, additionalData, additionalEventData, breadcrumbs) {
    if (safelyAccessClass()) {
        var newEventDetails = Object.assign({}, eventDetails, {
            name: get_default()(eventDetails, "name", type),
            details: get_default()(eventDetails, "details", null)
        });
        window.KoalaAnalytics.fireEvent(type, newEventDetails, additionalData, additionalEventData, breadcrumbs);
    }
};
/**
 * fireKoalaUpsellEvent
 *
 */ var fireKAnalyticsUpsellEvent = function(upsellId, upsellProducts) {
    if (!upsellProducts || !upsellProducts.length) {
        return;
    }
    // Assemble upsells presented array
    var displayedUpsells = [];
    upsellProducts.forEach(function(upsellOffer) {
        displayedUpsells.push({
            action: "display",
            product: {
                id: upsellOffer.id,
                global_id: upsellOffer.global_id,
                name: upsellOffer.name
            }
        });
    });
    if (displayedUpsells.length) {
        // Grab global IDs from displayedUpsells
        var upsellGlobalIDsArray = [];
        displayedUpsells.map(function(entry) {
            return upsellGlobalIDsArray.push(entry.product.global_id);
        });
        // Join array into a string
        var upsellGlobalIDsString = upsellGlobalIDsArray.join(", ");
        // KA Event
        fireKAnalyticsEvent(events/* K_ANALYTICS_EVENTS.CROSS_SELL_PRESENTED */.AH.CROSS_SELL_PRESENTED, {
            name: upsellId,
            details: upsellGlobalIDsString
        });
    }
};
/**
 * Koala Analytics
 */ var KoalaAnalytics = /*#__PURE__*/ function() {
    "use strict";
    function KoalaAnalytics(sessionId, sessionStart, orgId, brandName) {
        var _this = this;
        (0,_class_call_check/* default */.Z)(this, KoalaAnalytics);
        this.fireSessionStartEvent = function() {
            // Fire the session start event
            _this.fireEvent(events/* K_ANALYTICS_EVENTS.SESSION_START */.AH.SESSION_START, {
                name: window.location.pathname,
                details: null
            });
        };
        this.fireScreenEvent = function(name) {
            return _this.fireEvent(events/* K_ANALYTICS_EVENTS.SCREEN */.AH.SCREEN, {
                name: name
            });
        };
        /*
   * Set customer data as soon as we get it
   */ this.setCustomerData = function(customerData) {
            // If we have customer data, set it
            if (customerData) {
                var id = customerData.id, first_name = customerData.first_name, last_name = customerData.last_name, phone = customerData.phone, email = customerData.email, opt_in = customerData.opt_in;
                _this.customerId = id;
                _this.customerFirstName = first_name;
                _this.customerLastName = last_name;
                _this.customerPhone = phone;
                _this.customerEmail = email;
                _this.customerOptIn = opt_in;
            } else {
                // else clear customer data
                _this.customerId = null;
                _this.customerFirstName = null;
                _this.customerLastName = null;
                _this.customerPhone = null;
                _this.customerEmail = null;
                _this.customerOptIn = null;
            }
        };
        /**
   * Set menu product options whenever we fetch a menu
   * @TODO improve typing of `optionsObject`.
   */ this.setMenuProductOptions = function(optionsObject) {
            return _this.menuProductOptions = optionsObject;
        };
        /*
   * Push breadcrumbs into the analytics class
   */ this.pushDebugBreadcrumb = function(breadcrumb) {
            return _this.debugBreadcrumbs.push(breadcrumb);
        };
        this.detectName = function() {
            return (0,android/* isAndroidShell */.Y2)() ? "koala-ordering-android-shell" : "koala-ordering-webapp";
        };
        this.detectPlatform = function() {
            // Detect if we are running inside an Android app as a web-view
            if ((0,android/* isAndroidShell */.Y2)()) {
                return events/* K_ANALYTICS_PLATFORMS.ANDROID */.CA.ANDROID;
            }
            // the original mobile-detect implemenation's `isPhoneSized` method checked if the window was less than 600px
            // so we do the same, but with a css media query
            return window.matchMedia("(max-width: 600px)").matches ? events/* K_ANALYTICS_PLATFORMS.MOBILE_WEB */.CA.MOBILE_WEB : events/* K_ANALYTICS_PLATFORMS.DESKTOP_WEB */.CA.DESKTOP_WEB;
        };
        this.sessionId = sessionId;
        this.sessionStart = sessionStart;
        this.env = envConfig/* ENV */.Vi;
        this.orgId = orgId;
        this.orgLabel = brandName;
        this.userAgent = window.navigator.userAgent;
        this.name = this.detectName();
        this.platform = this.detectPlatform();
        // Instantiate customer data
        this.customerId = null;
        this.customerFirstName = null;
        this.customerLastName = null;
        this.customerPhone = null;
        this.customerEmail = null;
        this.customerOptIn = null;
        // Instantiate menu product options
        this.menuProductOptions = null;
        // Instantiate breadcrumbs
        this.debugBreadcrumbs = [];
    }
    var _proto = KoalaAnalytics.prototype;
    /**
   * retrieveLocation
   *
   */ _proto.retrieveLocation = function retrieveLocation() {
        // Attempt to retrieve the location id from the current order, if one exists
        // We don't write this to the class in case a user changes their order location
        var koalaOrder = dist/* sdkStorage.basket.get */.fn.basket.get();
        if (koalaOrder === null || koalaOrder === void 0 ? void 0 : koalaOrder.location) {
            var ref, ref1, ref2;
            return {
                id: (ref = koalaOrder.location) === null || ref === void 0 ? void 0 : (ref1 = ref.id) === null || ref1 === void 0 ? void 0 : ref1.toString(),
                label: (ref2 = koalaOrder.location) === null || ref2 === void 0 ? void 0 : ref2.label
            };
        }
        return null;
    };
    /**
   * fireEvent
   *
   */ _proto.fireEvent = function fireEvent(type, eventDetails, additionalData, additionalEventData) {
        // Derive location id
        var locationId = get_default()(this.retrieveLocation(), "id", null);
        var locationLabel = get_default()(this.retrieveLocation(), "label", null);
        // Set base event object
        var eventData = {
            type: type,
            data: eventDetails,
            // Pass debug_breadcrumbs on error events
            debug_breadcrumbs: type === events/* K_ANALYTICS_EVENTS.ERROR */.AH.ERROR ? this.debugBreadcrumbs : []
        };
        // Set organization data
        var organizationData = {
            label: this.orgLabel,
            id: this.orgId
        };
        // Set customer details
        var customerData = {
            id: this.customerId,
            first_name: this.customerFirstName,
            last_name: this.customerLastName,
            phone: this.customerPhone,
            email: this.customerEmail,
            opt_in: this.customerOptIn
        };
        // Set source data
        var sourceData = {
            id: this.userAgent,
            name: this.name,
            session: {
                started_at: this.sessionStart,
                id: this.sessionId,
                referrer: document === null || document === void 0 ? void 0 : document.referrer
            },
            type: this.platform,
            location_id: locationId,
            location_label: locationLabel,
            build_version: envConfig/* BUILD_VERSION */.bS,
            env: this.env
        };
        // Set base data object
        var data = {
            date: new Date().toISOString(),
            event: Object.assign({}, eventData, (0,_object_spread/* default */.Z)({}, additionalEventData)),
            organization: organizationData,
            customer: customerData,
            source: sourceData
        };
        // Assemble final event payload
        var koalaEvent = {
            data: [
                Object.assign({}, data, (0,_object_spread/* default */.Z)({}, additionalData)), 
            ]
        };
        fireKoalaAnalyticsEvent(koalaEvent).catch(console.log);
    };
    return KoalaAnalytics;
}();
/* harmony default export */ var koalaAnalytics = (KoalaAnalytics);


/***/ }),

/***/ 52591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Tg": function() { return /* binding */ ORDER_ASAP; },
  "uD": function() { return /* binding */ checkLocationStatus; },
  "S2": function() { return /* binding */ deriveFormattedDateTimeString; },
  "he": function() { return /* binding */ deriveTodaysHours; },
  "gS": function() { return /* binding */ deriveWeeklyHours; },
  "Zs": function() { return /* binding */ getLocationDataForDropdown; },
  "By": function() { return /* binding */ getLocationId; },
  "t": function() { return /* binding */ getNextHourSlots; },
  "kL": function() { return /* binding */ getOperatingHoursForLocation; },
  "Y_": function() { return /* binding */ googleMapsUrl; },
  "OM": function() { return /* binding */ isStoreCurrentlyOpen; },
  "h9": function() { return /* binding */ isValidZip; },
  "tS": function() { return /* binding */ parseLocationRouteParams; },
  "I9": function() { return /* binding */ splitLocationsByCountry; }
});

// UNUSED EXPORTS: getFormattedSlotHours, getOperatingHoursString, getTodaysHourSlots, supportsStoreHours

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isSameDay/index.js
var isSameDay = __webpack_require__(82276);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/startOfDay/index.js
var startOfDay = __webpack_require__(10405);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/startOfToday/index.js

/**
 * @name startOfToday
 * @category Day Helpers
 * @summary Return the start of today.
 * @pure false
 *
 * @description
 * Return the start of today.
 *
 * > ⚠️ Please note that this function is not present in the FP submodule as
 * > it uses `Date.now()` internally hence impure and can't be safely curried.
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * const result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */
function startOfToday() {
  return (0,startOfDay/* default */.Z)(Date.now());
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/addDays/index.js
var addDays = __webpack_require__(63761);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/parseISO/index.js
var parseISO = __webpack_require__(31807);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/toDate/index.js
var toDate = __webpack_require__(66700);
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/_lib/requiredArgs/index.js
var requiredArgs = __webpack_require__(19785);
;// CONCATENATED MODULE: ../../node_modules/date-fns/esm/isWithinInterval/index.js


/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  (0,requiredArgs/* default */.Z)(2, arguments);
  var time = (0,toDate/* default */.Z)(dirtyDate).getTime();
  var startTime = (0,toDate/* default */.Z)(interval.start).getTime();
  var endTime = (0,toDate/* default */.Z)(interval.end).getTime();

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }
  return time >= startTime && time <= endTime;
}
// EXTERNAL MODULE: ../../node_modules/date-fns/esm/isToday/index.js
var isToday = __webpack_require__(82236);
// EXTERNAL MODULE: ../../node_modules/zod/lib/index.mjs
var lib = __webpack_require__(30195);
// EXTERNAL MODULE: ./src/utils/config.ts
var config = __webpack_require__(19257);
// EXTERNAL MODULE: ./src/constants/dates.ts
var dates = __webpack_require__(81584);
// EXTERNAL MODULE: ./src/constants/locations.ts
var constants_locations = __webpack_require__(56296);
// EXTERNAL MODULE: ./src/constants/validation.ts
var validation = __webpack_require__(38885);
// EXTERNAL MODULE: ./src/utils/dates.ts + 59 modules
var utils_dates = __webpack_require__(63654);
;// CONCATENATED MODULE: ./src/utils/locations.ts








var ORDER_ASAP = "asap";
var googleMapsUrl = function(cachedData) {
    return cachedData ? "https://www.google.com/maps/place/".concat(encodeURIComponent("".concat(cachedData.street_address, ", ").concat(cachedData.state, " ").concat(cachedData.zip))) : "#";
};
/**
 * Derive today's operating hours
 *
 * @param {operatingHours} array
 *
 * @return {LocationOperatingHours[]}
 */ var getTodaysHourSlots = function(operatingHours) {
    return operatingHours.filter(function(slot) {
        return (0,isSameDay/* default */.Z)((0,utils_dates/* getUTCDate */.EA)(), (0,utils_dates/* getUTCDate */.EA)(slot.start));
    });
};
/**
 * Derive future operating hours including today
 *
 * @param {operatingHours} array
 * @param {utcOffset} number
 *
 * @return {LocationOperatingHours[]}
 */ var getNextHourSlots = function(operatingHours) {
    return operatingHours.filter(function(slot) {
        return (0,utils_dates/* isDateSameOrAfter */.U$)((0,utils_dates/* getUTCDate */.EA)(slot.start), (0,utils_dates/* getUTCDate */.EA)());
    });
};
/**
 * Derive today's operating hours
 *
 * @param {operatingHours} array
 *
 * @return {string}
 */ var deriveTodaysHours = function(location, utcOffset) {
    var operatingHours = getOperatingHoursForLocation(location);
    // Find all of todays whose type is 'operating_hours' (i.e. not delivery)
    var todaysSlots = getTodaysHourSlots(operatingHours);
    // If no available today slots or too many
    if (!todaysSlots.length || todaysSlots.length > 1) {
        return "";
    }
    var startTime = todaysSlots[0].start;
    var endTime = todaysSlots[0].end;
    var timeFormat = dates/* DATE_FORMAT.HOURS_WITH_MINUTES */.z.HOURS_WITH_MINUTES;
    var offset = (0,utils_dates/* getSanitizedOffset */.UG)(utcOffset);
    var closingTime = (0,utils_dates/* getFormattedDateInTimezone */.vl)(endTime, timeFormat, offset);
    if ((0,utils_dates/* isDateBetween */.zx)((0,utils_dates/* getUTCDate */.EA)(), startTime, endTime)) {
        return "".concat(getOperatingHoursString(location), " until ").concat(closingTime);
    }
    return "".concat(getOperatingHoursString(location), " from ").concat((0,utils_dates/* getFormattedDateInTimezone */.vl)(startTime, timeFormat, offset), " to ").concat(closingTime);
};
/**
 * Derive formatted date/time string
 *
 * @param {string} timestamp
 * @param {string} dateFormat
 * @param {number} utcOffset
 *
 * @return {string}
 */ var deriveFormattedDateTimeString = function(timestamp, format) {
    var offset = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "+00";
    if (!timestamp || !format) {
        return "";
    }
    return (0,utils_dates/* getFormattedDateInTimezone */.vl)(timestamp, format, offset);
};
var getFormattedSlotHours = function(start, end, formatting, offset) {
    return {
        start: getFormattedDateInTimezone(start, formatting, offset).toLowerCase().replace(" ", ""),
        end: getFormattedDateInTimezone(end, formatting, offset).toLowerCase().replace(" ", "")
    };
};
function formatOperatingHoursSlot(hours, utcOffset) {
    return {
        start: (0,utils_dates/* getFormattedDateInTimezone */.vl)(hours.start, dates/* DATE_FORMAT.HOURS_WITH_MINUTES */.z.HOURS_WITH_MINUTES, utcOffset).toLowerCase().replace(" ", ""),
        end: (0,utils_dates/* getFormattedDateInTimezone */.vl)(hours.end, dates/* DATE_FORMAT.HOURS_WITH_MINUTES */.z.HOURS_WITH_MINUTES, utcOffset).toLowerCase().replace(" ", "")
    };
}
/**
 * Accepts a list of a store's hours and returns a list of all operating
 * hours in the next week, formatted in the user's local timezone.
 *
 * @param operatingHours list of operating hours.
 * @param locationUtcOffset the store location's UTC offset.
 */ function deriveWeeklyHours(operatingHours, locationUtcOffset) {
    if (!operatingHours) {
        return null;
    }
    // Prepare the location's UTC offset so it can be used to format
    // the location's hours in the user's local timezone.
    var sanitizedOffset = (0,utils_dates/* getSanitizedOffset */.UG)(locationUtcOffset);
    var today = startOfToday();
    var nextWeek = (0,addDays/* default */.Z)(today, 7);
    // Store hours keyed by weekday for easy retrieval.
    var hoursByWeekday = {};
    operatingHours.forEach(function(h) {
        var startTime = (0,parseISO/* default */.Z)(h.start);
        // If the hours *start* in the next week...
        if (isWithinInterval(startTime, {
            start: today,
            end: nextWeek
        })) {
            // Format the slot and store it by weekday. Eg: `{ Wednesday: [] }`
            if (h.day_of_week in hoursByWeekday) {
                hoursByWeekday[h.day_of_week].push(formatOperatingHoursSlot(h, sanitizedOffset));
            } else {
                hoursByWeekday[h.day_of_week] = [
                    formatOperatingHoursSlot(h, sanitizedOffset), 
                ];
            }
        }
    });
    // Return an array of 7 days starting with today and corresponding hour slots.
    return Array.from({
        length: 7
    }, function(_, i) {
        var day = (0,addDays/* default */.Z)(today, i);
        var weekday = (0,utils_dates/* formatDate */.p6)(day, dates/* DATE_FORMAT.WEEKDAY */.z.WEEKDAY);
        var _weekday;
        return {
            weekday: weekday,
            slots: (_weekday = hoursByWeekday[weekday]) !== null && _weekday !== void 0 ? _weekday : [],
            isSelected: (0,isToday/* default */.Z)(day)
        };
    });
}
/**
 * Determine if store is currently open
 *
 * @param {operatingHours} LocationOperatingHours[]
 *
 * @return {LocationOperatingHours | undefined}
 */ var isStoreCurrentlyOpen = function(operatingHours) {
    var date = new Date();
    var dateISO = date.toISOString();
    return operatingHours === null || operatingHours === void 0 ? void 0 : operatingHours.find(function(day) {
        return dateISO >= day.start && dateISO < day.end;
    });
};
/**
 * Determine if a location is currently active
 *
 * @param {location} Location
 *
 */ var checkLocationStatus = function(location) {
    if (location.status_id === constants_locations/* LOCATION_STATUSES.INACTIVE */.qX.INACTIVE) {
        window.location.href = "/";
    }
};
/** Returns the canonical ID for a location depending on the ID source. */ function getLocationId(loc, cfg) {
    // @ts-expect-error either the location ID or brand ID will be present.
    return (0,config/* supportsBrandId */.i)(cfg) ? loc.brand_id : loc.id;
}
/**
 * Splits a list of locations by country—Canada or USA.
 *
 * @param locations locations to split.
 */ function splitLocationsByCountry(locations) {
    var canadianLocations = [];
    var usLocations = [];
    locations.forEach(function(loc) {
        var ref, ref1;
        if (((ref = loc.cached_data) === null || ref === void 0 ? void 0 : ref.country.toLocaleUpperCase()) === "CA") {
            canadianLocations.push(loc);
        } else if (((ref1 = loc.cached_data) === null || ref1 === void 0 ? void 0 : ref1.country.toLocaleUpperCase()) === "US") {
            usLocations.push(loc);
        }
    });
    var _obj;
    return _obj = {}, (0,_define_property/* default */.Z)(_obj, constants_locations/* SUPPORTED_COUNTRIES.CANADA */.WU.CANADA, canadianLocations), (0,_define_property/* default */.Z)(_obj, constants_locations/* SUPPORTED_COUNTRIES.USA */.WU.USA, usLocations), _obj;
}
/**
 * Function that checks if given value is valid US zip code or a Canadian postal code
 */ function isValidZip(value) {
    return validation/* REGEX.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA.test */.mL.ZIP_CODE_USA_AND_POSTAL_CODE_CANADA.test(value);
}
var getLocationDataForDropdown = function(locations) {
    // Assemble options array for the select, with label and value
    return locations.map(function(location) {
        return {
            label: location.label,
            value: location.id
        };
    }).sort(function(a, b) {
        return a.label < b.label ? -1 : 1;
    });
};
var storeRouteParamsSchema = lib.z.string().array().nonempty();
function parseLocationRouteParams(q) {
    var parsed = storeRouteParamsSchema.parse(q.id);
    return {
        id: parsed[0],
        name: parsed[1],
        catId: parsed[2],
        catName: parsed[3],
        productId: parsed[4],
        productName: parsed[5]
    };
}
var ref, ref1;
/**
 * Get the operating hours for a location.
 * `business_hours` will be the same as the `operating_hours` for Olo and Square locations.
 * Chowly locations will have only `operating_hours`.
 */ var getOperatingHoursForLocation = function(location) {
    return supportsStoreHours(location) ? (ref = location === null || location === void 0 ? void 0 : location.business_hours) !== null && ref !== void 0 ? ref : [] : (ref1 = location === null || location === void 0 ? void 0 : location.operating_hours) !== null && ref1 !== void 0 ? ref1 : [];
};
/**
 * Determine if location supports store hours (business_hours)
 */ var supportsStoreHours = function(location) {
    return Boolean((location === null || location === void 0 ? void 0 : location.business_hours) && (location === null || location === void 0 ? void 0 : location.business_hours.length) > 0);
};
/**
 * Get string for location's operating hours based on if location supports store hours  (business_hours)
 */ var getOperatingHoursString = function(location) {
    return supportsStoreHours(location) ? "Open" : "Online ordering available";
};


/***/ }),

/***/ 53174:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xy": function() { return /* binding */ getUnreadPersonalMessagesLength; },
/* harmony export */   "gx": function() { return /* binding */ getActiveRewardsAndOffersLength; },
/* harmony export */   "kz": function() { return /* binding */ allowedLoyaltyRoutes; },
/* harmony export */   "vO": function() { return /* binding */ getLoyaltyInfoFromState; },
/* harmony export */   "vh": function() { return /* binding */ dateFormatter; },
/* harmony export */   "yI": function() { return /* binding */ routePunchhDeepLinks; }
/* harmony export */ });
/* harmony import */ var _constants_loyalty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92106);
/* harmony import */ var _constants_routes__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25643);


/*
Paths come from here: https://docs.google.com/document/d/1ZHSp3060q1ClNJaS5y_AManinMqFrxDOitK2Kv1J7zo/edit
*/ var routePunchhDeepLinks = function(cta) {
    // Find the keyword after the last slash in URL
    var splitURL = cta.url.split("/");
    var keyword = splitURL[splitURL.length - 1];
    switch(keyword){
        case "account-history":
            return _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.ORDER_HISTORY */ .xM.ORDER_HISTORY;
        case "edit-profile":
            return _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.ACCOUNT */ .xM.ACCOUNT;
        case "invite-friends":
            return _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.ACCOUNT */ .xM.ACCOUNT;
        case "locations":
            return _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.LOCATIONS */ .Z6.LOCATIONS;
        case "menu":
            return _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.LOCATIONS */ .Z6.LOCATIONS;
        case "news":
            return _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.INBOX */ .xM.INBOX;
        case "offers":
            return _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.REWARDS */ .xM.REWARDS;
        case "order":
            return _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.LOCATIONS */ .Z6.LOCATIONS;
        default:
            return _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.LOCATIONS */ .Z6.LOCATIONS;
    }
};
/**
 * Calculate number of unread personal messages for counters
 * @TODO restrict `myMessages` to a non-nullable/optional array.
 */ var getUnreadPersonalMessagesLength = function(myMessages) {
    if (!myMessages) {
        return 0;
    }
    return myMessages.filter(function(message) {
        return message.type === _constants_loyalty__WEBPACK_IMPORTED_MODULE_0__/* .LOYALTY_MESSAGE_TYPES.PERSONAL */ .GA.PERSONAL;
    }).filter(function(personalMsg) {
        return !personalMsg.read_at;
    }).length;
};
/*
Calculate active rewards and offers
*/ var getActiveRewardsAndOffersLength = function(myRedeemables, myOffers, currentPoints) {
    var myAvailableRedeemables = myRedeemables.filter(function(reward) {
        return reward.points_required <= currentPoints;
    });
    return myAvailableRedeemables.length + myOffers.length;
};
/*
Determine allowed routes based on loyalty driver ID
*/ var allowedLoyaltyRoutes = function(loyaltyDriverId) {
    switch(loyaltyDriverId){
        // Punchh V2
        case 2:
            return [
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.REWARDS */ .xM.REWARDS,
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.INBOX */ .xM.INBOX,
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.FAVORITES */ .xM.FAVORITES,
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.ORDER_HISTORY */ .xM.ORDER_HISTORY,
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.ACCOUNT */ .xM.ACCOUNT,
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.ORDER_DETAIL */ .Z6.ORDER_DETAIL, 
            ];
        // Paytronix
        case 3:
            return [
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.FAVORITES */ .xM.FAVORITES,
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.ORDER_HISTORY */ .xM.ORDER_HISTORY,
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.ACCOUNT */ .xM.ACCOUNT,
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.ORDER_DETAIL */ .Z6.ORDER_DETAIL, 
            ];
        // Spendgo
        case 4:
            return [
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.ORDER_HISTORY */ .xM.ORDER_HISTORY,
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.REWARDS */ .xM.REWARDS,
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.FAVORITES */ .xM.FAVORITES,
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.ACCOUNT */ .xM.ACCOUNT,
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.ORDER_DETAIL */ .Z6.ORDER_DETAIL, 
            ];
        default:
            return [
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.FAVORITES */ .xM.FAVORITES,
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.ORDER_HISTORY */ .xM.ORDER_HISTORY,
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .LOYALTY_ROUTES.ACCOUNT */ .xM.ACCOUNT,
                _constants_routes__WEBPACK_IMPORTED_MODULE_1__/* .ROUTES.ORDER_DETAIL */ .Z6.ORDER_DETAIL, 
            ];
    }
};
/* Format the date strings returned by Punchh - TODO make this more global or deprecate */ var dateFormatter = function(dateString) {
    return "MM/DD/YYYY".replace("MM", dateString.substr(5, 2)).replace("DD", dateString.substr(8, 2)).replace("YYYY", dateString.substr(0, 4));
};
/* Fetch feature flags and loyalty driver ID for use in sagas */ var getLoyaltyInfoFromState = function(state) {
    var ref;
    return {
        loyaltyDriverId: state.app.organization.organization.loyalty_driver_id,
        loyaltyFeatureFlags: (ref = state.app.organization.loyalty) === null || ref === void 0 ? void 0 : ref.features
    };
};


/***/ }),

/***/ 682:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$9": function() { return /* binding */ filterCategoriesByTagId; },
/* harmony export */   "$F": function() { return /* binding */ setMenuInStorage; },
/* harmony export */   "Aj": function() { return /* binding */ filterProductsByTagId; },
/* harmony export */   "HH": function() { return /* binding */ setOptionQuantityRequirementsText; },
/* harmony export */   "JZ": function() { return /* binding */ filterTagsByUnavailableProducts; },
/* harmony export */   "MM": function() { return /* binding */ doesGroupHaveImages; },
/* harmony export */   "PS": function() { return /* binding */ updateStoreMenuUrl; },
/* harmony export */   "P_": function() { return /* binding */ augmentMenuProduct; },
/* harmony export */   "UP": function() { return /* binding */ deriveCategoryNavId; },
/* harmony export */   "XH": function() { return /* binding */ getAllProductOptionAllergens; },
/* harmony export */   "Zq": function() { return /* binding */ deriveCalorieDisplay; },
/* harmony export */   "Zy": function() { return /* binding */ resolveExternalMenuLink; },
/* harmony export */   "bL": function() { return /* binding */ formatDisplayPriceByCountry; },
/* harmony export */   "uz": function() { return /* binding */ getMenuFromStorage; }
/* harmony export */ });
/* unused harmony exports getParameterByName, encodeURIComponentSafe */
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50930);
/* harmony import */ var _koala_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80684);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13311);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _constants_global__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66686);
/* harmony import */ var _utils_basket__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1227);





// TODO
var deriveCategoryNavId = function(categoryId, context) {
    return "Category-nav-link-".concat(context, "-").concat(categoryId.replace(/\s/g, ""));
};
/**
 * Determine whether any options in the modifier group have images.
 *
 * @param group modifier group to check
 * @returns boolean
 */ var doesGroupHaveImages = function(group) {
    return group.options.some(function(opt) {
        var ref;
        return (ref = opt.images) === null || ref === void 0 ? void 0 : ref.image_url_1_by_1;
    });
};
/**
 * Extract explicit query parameters from the URL
 *
 */ var getParameterByName = function(name, url) {
    var regex = new RegExp("[?&]".concat(name.replace(/[\[\]]/g, "\\$&"), "(=([^&#]*)|&|#|$)"));
    var results = regex.exec(url || window.location.href);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return "";
    }
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};
/**
 * Safely encode url strings that contain % signs which would otherwise not be correctly encoded by `encodeURIComponent`
 *
 * @param uri string
 * @returns string
 */ var encodeURIComponentSafe = function(uri) {
    // replace any % signs not followed by a HEX code with %25
    // see: https://stackoverflow.com/questions/7449588/why-does-decodeuricomponent-lock-up-my-browser
    return encodeURIComponent(uri.replace(/%(?![0-9][0-9a-fA-F]+)/g, "%25"));
};
/** Returns a new store menu based on the given route params and tags. */ var updateStoreMenuUrl = function(routeParams, tags) {
    var url = "/store/".concat(routeParams.id);
    if (routeParams.name) {
        url = "".concat(url, "/").concat(encodeURIComponentSafe(routeParams.name));
    }
    if (routeParams.catId && routeParams.catName) {
        url = "".concat(url, "/").concat(routeParams.catId, "/").concat(encodeURIComponentSafe(routeParams.catName));
    }
    if (routeParams.productId && routeParams.productName) {
        url = "".concat(url, "/").concat(routeParams.productId, "/").concat(encodeURIComponentSafe(routeParams.productName));
    }
    if (tags) {
        url = "".concat(url, "?filter=").concat(tags.join());
    }
    return url;
};
/** Resolve the configured external menu link for a specific location. */ var resolveExternalMenuLink = function(config, location) {
    if (!(config === null || config === void 0 ? void 0 : config.enabled) || !config.label || !config.url_template) {
        return null;
    }
    var ref;
    var tokens = (ref = config.url_template.match(/\$.*?\$/g)) !== null && ref !== void 0 ? ref : [];
    var url = config.url_template;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = tokens[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var token = _step.value;
            if (token !== "$brand_id$" || !location.brand_id) {
                return null;
            }
            url = url.split(token).join(encodeURIComponent(location.brand_id));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    try {
        var parsedUrl = new URL(url);
        if (parsedUrl.protocol !== "https:") {
            return null;
        }
    } catch (e) {
        return null;
    }
    return {
        label: config.label,
        url: url
    };
};
/**
 * Get the product tags
 * Method to get the allergen tags based on default modifiers or selectedOption values.
 * If selectedOptions is empty then defaults will be shown.  IE menu has defaults / detail as selections
 *
 * @product: MenuProduct A valid product to extract active allergen tags from
 * @selectedOptions: number[] an array of selected optons from the customize props.
 */ var getAllProductOptionAllergens = function(product) {
    var selectedOptions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], mode = arguments.length > 2 ? arguments[2] : void 0;
    // Check if selections are provided
    var selectionsAvailable = selectedOptions.length;
    var max_recursion = 10;
    var current_recursion = 0;
    // Internal Method to recursive loop over a MenuProduct option groups and options
    var optionAllergens = function(option_groups, allergensArray) {
        // This would happen if allergens is enabled in the cms, but the menu feature has not been turned on
        if (!allergensArray) {
            console.log("Augments allergens not enabled.");
            return [];
        }
        if (!option_groups || !option_groups.length) {
            return allergensArray;
        }
        option_groups.map(function(group) {
            // With defaults we only care about groups with min selection.
            // Or when we have selections we need to check all the groups.
            if (group.min_selections && group.min_selections > 0 || selectionsAvailable) {
                // foundDefault - I thought all the groups would have default options, but that's not true, this is set true when the group has one.
                var foundDefault = false;
                group.options.map(function(option) {
                    // Test the option for allergens if it is selected or if no selections check for defaults
                    var selected = selectionsAvailable && lodash_find__WEBPACK_IMPORTED_MODULE_1___default()(selectedOptions, {
                        id: option.id.toString()
                    });
                    var ref;
                    // Test the option for allergens if it is selected or no selected and a default.
                    var optionAllergensArray = (ref = option === null || option === void 0 ? void 0 : option.allergens) !== null && ref !== void 0 ? ref : [];
                    if (selected || !selected && (optionAllergensArray === null || optionAllergensArray === void 0 ? void 0 : optionAllergensArray.length)) {
                        if (selected || option.is_default) {
                            // Found a default in this group!
                            foundDefault = true;
                            // We don't want "removal tags" is a selected option
                            allergensArray = allergensArray.concat(optionAllergensArray.filter(function(a) {
                                return !a.is_removal;
                            }));
                        } else if (!selected) {
                            // If we don't find a default or selected option we display "removal tags" if found
                            allergensArray = allergensArray.concat(optionAllergensArray.filter(function(a) {
                                return a.is_removal;
                            }));
                        }
                    }
                    // OHH, here we go again, this opton contains more group_options
                    if (option.option_groups && option.option_groups.length) {
                        current_recursion++;
                        if (current_recursion < max_recursion) {
                            var subAllergensArray = optionAllergens(option.option_groups, []);
                            if (subAllergensArray.length) {
                                allergensArray = allergensArray.concat(subAllergensArray);
                            }
                        }
                    }
                });
                // Don't include 0 index defaults on the menu
                if (mode !== _constants_global__WEBPACK_IMPORTED_MODULE_2__/* .ALLERGEN_CARD_MODE.MENU */ .JT.MENU) {
                    var ref;
                    var ref1;
                    // Finally, if nothing is selected, and there is no group options we need to select something because group.min_selections > 0
                    var firstOptionAllergens = (ref1 = (ref = group === null || group === void 0 ? void 0 : group.options[0]) === null || ref === void 0 ? void 0 : ref.allergens) !== null && ref1 !== void 0 ? ref1 : [];
                    if (!selectionsAvailable && !foundDefault && (firstOptionAllergens === null || firstOptionAllergens === void 0 ? void 0 : firstOptionAllergens.length)) {
                        var ref2;
                        // A made up "default" selection doesn't show "removal tags"
                        allergensArray = allergensArray.concat(firstOptionAllergens.filter(function(a) {
                            return !a.is_removal;
                        }));
                        // were we go again, this opton contains more group_options
                        if ((ref2 = group === null || group === void 0 ? void 0 : group.options[0]) === null || ref2 === void 0 ? void 0 : ref2.option_groups) {
                            current_recursion++;
                            if (current_recursion < max_recursion) {
                                var subAllergensArray = optionAllergens(group.options[0].option_groups, []);
                                if (subAllergensArray.length) {
                                    allergensArray = allergensArray.concat(subAllergensArray);
                                }
                            }
                        }
                    }
                }
            }
        });
        return allergensArray;
    };
    return optionAllergens(product.option_groups, product.allergens);
};
var filterProductsByTagId = function(tags, activeTagIds) {
    // If no activeTagId, just return all the products
    if (!activeTagIds || !activeTagIds.length) {
        return true;
    }
    // Product filter tags should never be null
    // If they are, change to empty array to prevent crashing
    if (!tags) {
        tags = [];
        console.warn("ERROR: Product-level filter tags should never be null");
    }
    return tags.map(function(tag) {
        return tag === null || tag === void 0 ? void 0 : tag.id;
    }).some(function(id) {
        return activeTagIds.includes(id);
    });
};
var filterCategoriesByTagId = function(category, activeTagIds) {
    // If no activeTagIds, return all categories
    if (!activeTagIds || !activeTagIds.length) {
        return true;
    }
    var tagIds = category.products.flatMap(function(product) {
        return product === null || product === void 0 ? void 0 : product.filter_tags;
    }).filter(function(tag) {
        return (tag === null || tag === void 0 ? void 0 : tag.id) !== undefined;
    }).map(function(tag) {
        return Number(tag === null || tag === void 0 ? void 0 : tag.id);
    });
    var categoryTagsIds = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(new Set(tagIds)); // filter only unique values
    return categoryTagsIds.some(function(id) {
        return activeTagIds.includes(id);
    });
};
var setMenuInStorage = function(menu) {
    return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.menu.set */ .fn.menu.set(menu);
};
/**
 * Retrieve a menu from localStorage
 *
 */ var getMenuFromStorage = function() {
    return _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkStorage.menu.get */ .fn.menu.get();
};
var setOptionQuantityRequirementsText = function(minSelection, maxSelection, minAggregate, maxAggregate) {
    var pluralize = function(str, rule) {
        return rule === 1 ? str : str + "s";
    };
    // Case 1 (label for Jest tests)
    // Option group has min_selection greater than 0 but no max selection and no aggregate quantity requirements.
    if (minSelection && minSelection > 0 && !maxSelection && !minAggregate && !maxAggregate) {
        return pluralize("Select ".concat(minSelection, " option"), minSelection);
    }
    // Case 2
    // Option group has max_selection greater than 0 but no min selection and no aggregate quantity requirements.
    if (!minSelection && maxSelection && maxSelection > 0 && !minAggregate && !maxAggregate) {
        return pluralize("Select up to ".concat(maxSelection, " option"), maxSelection);
    }
    // Case 3
    // Option group has no min or max selections, but max_aggregate_quantity must be greater than 0, and min_aggregate must be less than max_aggregate_quantity.
    if (!minSelection && !maxSelection && maxAggregate && maxAggregate > 0 && // @ts-expect-error
    minAggregate < maxAggregate) {
        return "Select up to ".concat(maxAggregate);
    }
    // Case 4
    // Both min_selections and max_selections must be greater than zero, with min being less than max_selection. However, no aggregate requirements.
    if (minSelection && maxSelection && minSelection > 0 && maxSelection > 0 && minSelection < maxSelection && !minAggregate && !maxAggregate) {
        return pluralize("Select between ".concat(minSelection, " and ").concat(maxSelection, " option"), maxSelection);
    }
    // Case 5
    // Min_selection and max_selection must both be greater than 0 and equal each other. No aggregate requirements.
    if (minSelection && maxSelection && minSelection > 0 && maxSelection > 0 && minSelection === maxSelection && !minAggregate && !maxAggregate) {
        return pluralize("Select ".concat(minSelection, " option"), minSelection);
    }
    // Case 6
    // No min or max selections, but min_aggregate must equal max_aggregate, and both must be greater than 0.
    if (!minSelection && !maxSelection && minAggregate && maxAggregate && minAggregate > 0 && maxAggregate > 0 && minAggregate === maxAggregate) {
        return "Select ".concat(maxAggregate);
    }
    // Case 7
    // Either min_selection OR max_selection is equal to 1, and BOTH min_aggregate and max_aggregate are equal to 1.
    if ((minSelection || maxSelection) === 1 && minAggregate === 1 && maxAggregate === 1) {
        return "Select 1";
    }
    // Case 8
    // Min_selection is greater than 0, but no max_selection. Min_aggregate must equal max_aggregate.
    if (minSelection && minSelection > 0 && !maxSelection && minAggregate === maxAggregate) {
        return pluralize("Make ".concat(minAggregate, " selections from at least ").concat(minSelection, " option"), minSelection);
    }
    // Case 9
    // No min_selection, but max_selection is greater than zero OR max_selection is greater than min_selection (i.e. min_selection can be null) AND min_aggregate and max_aggregate are both greater than zero and equal each other.
    if ((!minSelection && maxSelection && maxSelection > 0 || minSelection && maxSelection && minSelection < maxSelection) && minAggregate && maxAggregate && minAggregate === maxAggregate) {
        return pluralize("Make ".concat(minAggregate, " selection"), minAggregate) + pluralize(" from up to ".concat(maxSelection, " option"), maxSelection);
    }
    // Case 10
    // Min_selection and max_selection are both greater than 0 and equal each other AND min_aggregate and max_aggregate are equal.
    if (minSelection && minSelection > 0 && maxSelection && maxSelection > 0 && minSelection === maxSelection && minAggregate && maxAggregate && minAggregate === maxAggregate) {
        return pluralize("Make ".concat(minAggregate, " selection"), minAggregate) + pluralize(" from ".concat(minSelection, " option"), minSelection);
    }
    // Else, option quantity helper text is not needed
    return null;
};
/**
 * Derive option calorie display string
 *
 */ var deriveCalorieDisplay = function(calories, maxCalories, calorieSeparator, isInverted, calorieDisplayOverride, option) {
    var ref;
    // Always show display override if it exists.
    if (calorieDisplayOverride && calorieDisplayOverride > 0) {
        return "".concat(calorieDisplayOverride, " ").concat(_koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CALS_IDENTIFIER */ .DF);
    }
    // If the option contains advanced nested mod options and is not selected we should show the calories of the default nested modifiers.
    if ((option === null || option === void 0 ? void 0 : option.contains_adv_nested_modifiers) && (calories === null || calories === 0) && !maxCalories) {
        var ref1;
        var advancedModOptionGroup = option.option_groups.find(function(og) {
            return og.is_adv_nested_modifier;
        });
        var cals = (ref1 = advancedModOptionGroup === null || advancedModOptionGroup === void 0 ? void 0 : advancedModOptionGroup.options.find(function(opt) {
            return opt.is_default;
        })) === null || ref1 === void 0 ? void 0 : ref1.calories;
        if (cals) return "".concat(cals, " ").concat(_koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CALS_IDENTIFIER */ .DF);
        return "";
    }
    // If calories are null, there are no calories or max calories
    if (calories === null) {
        return "";
    }
    // If calories are 0 and there are no max calories, we also display nothing
    if (calories === 0 && !maxCalories) {
        return "";
    }
    // Start with base calories
    var calorieString = (ref = (0,_utils_basket__WEBPACK_IMPORTED_MODULE_3__/* .invertNumberIfOptionInverted */ .a4)(calories, isInverted)) === null || ref === void 0 ? void 0 : ref.toString();
    // If there are max calories, assemble the whole thing
    if (maxCalories) {
        calorieString = "".concat(calorieString).concat(calorieSeparator).concat((0,_utils_basket__WEBPACK_IMPORTED_MODULE_3__/* .invertNumberIfOptionInverted */ .a4)(maxCalories, isInverted));
    }
    // Return string with cal identifier
    return "".concat(calorieString, " ").concat(_koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .CALS_IDENTIFIER */ .DF);
};
var filterTagsByUnavailableProducts = function(tags, categories) {
    var acceptedTagIDs = new Set();
    categories.forEach(function(category) {
        category.products.forEach(function(product) {
            var // safely handle cases where filter tags are null
            // TODO: enable strictNullChecks to ensure this is caught by the compiler
            ref;
            (ref = product.filter_tags) === null || ref === void 0 ? void 0 : ref.forEach(function(tag) {
                return acceptedTagIDs.add(tag.id);
            });
        });
    });
    return tags.filter(function(tag) {
        return acceptedTagIDs.has(tag.id);
    });
};
/**
 * ⚠️ Hack Alert ⚠️
 * Reformats a product's `pretty_price` to include the Canadian Dollars
 * symbol prefix. For a more thorough explanation, see the MenuCard component.
 *
 * @param prettyPrice USD-formatted product price string.
 * @param country country that the currency should be formatted to match.
 * @returns localized product display price.
 *
 * @TODO remove this utility function and move to the SDK.
 */ function formatDisplayPriceByCountry(prettyPrice, country) {
    if (!prettyPrice) {
        return null;
    }
    return country.toLocaleUpperCase() === "CA" ? "$CA".concat(prettyPrice.slice(1)) : prettyPrice;
}
var augmentMenuProduct = _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .sdkUtils.augmentMenuProduct */ .fH.augmentMenuProduct;


/***/ }),

/***/ 40274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "WJ": function() { return /* binding */ deriveOrdersByLocationID; },
/* harmony export */   "bY": function() { return /* binding */ isOrderFavorited; },
/* harmony export */   "gP": function() { return /* binding */ fetchOrderDetails; }
/* harmony export */ });
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13311);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_0__);

function fetchOrderDetails(orderId, pastOrders) {
    return lodash_find__WEBPACK_IMPORTED_MODULE_0___default()(pastOrders, {
        order_data: {
            order: {
                order_number: orderId
            }
        }
    });
}
var isOrderFavorited = function(orderId, meFavoriteOrders) {
    if (!meFavoriteOrders || !meFavoriteOrders.length) {
        return false;
    }
    return meFavoriteOrders.some(function(order) {
        return order.id === orderId;
    });
};
/**
 * Derive an array of orders by optional location ID and specified length
 *
 * @param pastOrders OrderDetails[]
 * @returns OrderDetails[]
 */ var deriveOrdersByLocationID = function(pastOrders, locationID) {
    // If a location ID is provided, specifically filter reorders by this ID
    if (locationID) {
        return pastOrders.filter(function(order) {
            return order.store_location_id === locationID;
        });
    }
    return pastOrders;
};


/***/ }),

/***/ 60738:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K6": function() { return /* binding */ safelyGetConfig; },
/* harmony export */   "bc": function() { return /* binding */ safelyGetString; },
/* harmony export */   "fB": function() { return /* binding */ pluralizeString; },
/* harmony export */   "fm": function() { return /* binding */ capitalizeFirstLetter; },
/* harmony export */   "hF": function() { return /* binding */ interpolateLocationCtaValue; },
/* harmony export */   "vk": function() { return /* binding */ interpolateIntoString; },
/* harmony export */   "zS": function() { return /* binding */ reconcileCustomAttributeWithGlobalValue; }
/* harmony export */ });
/* unused harmony export toTitleCase */
/* harmony import */ var _koala_sdk__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(80684);
/* harmony import */ var html_entities__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59392);
/* harmony import */ var html_entities__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(html_entities__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13311);
/* harmony import */ var lodash_find__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash_find__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _config__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19257);
/* harmony import */ var _constants_cta__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32159);






/**
 * Interpolate variables from a data object into a string
 * assuming the text to swap within the string are wrapped
 * in the $ character and the inner text is a key that
 * exists within the data object
 *
 * @param {string} string
 * @param {data} object
 *
 * @returns {string}
 * @TODO determine if `string` could actually be null in practice.
 * @TODO rework this function to not mutate the input value.
 */ var interpolateIntoString = function(string, data, disableDataObjEncode) {
    if (!string) {
        return "";
    }
    // Interpolate values from a resource passed in - i.e. $label$ or $location_id$ from locationDetail
    var substring = string.match(/\$.*?\$/g);
    if (substring && data) {
        substring.map(function(entry) {
            // find the variable between the two dollar signs
            var key = entry.slice(1, -1);
            // optionally encode HTML special characters
            /** @TODO improve the typing of the data object. */ // @ts-expect-error
            var targetValue = disableDataObjEncode ? data[key] : (0,html_entities__WEBPACK_IMPORTED_MODULE_4__.encode)(data[key]);
            // find the associated key on the object if it exists
            /** @TODO improve the typing of the data object. */ // @ts-expect-error
            if (data[key]) {
                // replace $var$ with the value from the data
                // @ts-expect-error
                string = string.replace(entry, targetValue);
            }
        });
    }
    return string;
};
// Interpolate variables into strings
var safelyGetString = function(webStrings, accessor, dataObj, disableDataObjEncode) {
    var strings = webStrings || _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .fallbackStrings */ .hL;
    // Default to returning an empty string.
    var str = lodash_get__WEBPACK_IMPORTED_MODULE_2___default()(strings, accessor, "") || "";
    return interpolateIntoString(str, dataObj, disableDataObjEncode);
};
// Get color, image, icon strings from web config
var safelyGetConfig = function(webConfig, accessor) {
    var config = webConfig;
    // If the web config has failed to load, the fallback should come from the defaults
    if (!webConfig) {
        config = _koala_sdk__WEBPACK_IMPORTED_MODULE_0__/* .fallbackConfig */ .fC;
    }
    return lodash_get__WEBPACK_IMPORTED_MODULE_2___default()(config, accessor, "");
};
// Interpolate location CTA Value
var interpolateLocationCtaValue = function(value, location, config) {
    var newValue = value;
    // @ts-expect-error brand_id or id will always exist on location.
    var locationId = (0,_config__WEBPACK_IMPORTED_MODULE_5__/* .supportsBrandId */ .i)(config) ? location.brand_id : location.id;
    if (value) {
        switch(value.trim()){
            case _constants_cta__WEBPACK_IMPORTED_MODULE_3__/* .CTA.PICKUP_URL */ .M.PICKUP_URL:
                newValue = "/store/".concat(locationId, "/").concat(location.label);
                break;
            default:
                break;
        }
    }
    return {
        finalValue: newValue
    };
};
var reconcileCustomAttributeWithGlobalValue = function(attributes, positionId, globalValue, globalLabel) {
    var displayAttributes = {
        label: globalLabel,
        value: globalValue
    };
    // Attempt to find location attribute
    var relevantAttribute = lodash_find__WEBPACK_IMPORTED_MODULE_1___default()(attributes, {
        position: {
            id: positionId
        }
    });
    if (relevantAttribute) {
        // Override global attribute values if the value is not an empty string
        if (relevantAttribute.value !== "") {
            displayAttributes.value = relevantAttribute.value;
        }
        if (relevantAttribute.label !== "") {
            displayAttributes.label = relevantAttribute.label;
        }
    }
    return displayAttributes;
};
// Remove special characters and capitalize a string
var toTitleCase = function(str) {
    if (!str) {
        return "";
    }
    return str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    });
};
/**
 * Check if string ends in an 's' before adding another 's'. Accepts an optional condition to pluralize against.
 *
 * @param str string
 * @param condition boolean
 * @returns string
 */ var pluralizeString = function(str, condition) {
    if (!str) {
        return "";
    }
    if (str.endsWith("s") || condition === false) {
        return str;
    }
    return str + "s";
};
var capitalizeFirstLetter = function(string) {
    return "".concat(string.charAt(0).toUpperCase()).concat(string.slice(1));
};


/***/ }),

/***/ 78080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dj": function() { return /* binding */ invalidPhone; },
/* harmony export */   "l8": function() { return /* binding */ isCreditCardExpiryValid; }
/* harmony export */ });
/* unused harmony exports inInclusionArray, creditCardExpiryErrors */
/* harmony import */ var libphonenumber_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54140);
/* harmony import */ var lodash_filter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63105);
/* harmony import */ var lodash_filter__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_filter__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_dates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(81584);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63654);




// Phone Validation
var invalidPhone = function(phoneNumber) {
    var invalid = true;
    if (phoneNumber) {
        phoneNumber = phoneNumber.replace(/\D/g, "").substring(0, 10);
    }
    var parsedNumber = (0,libphonenumber_js__WEBPACK_IMPORTED_MODULE_2__/* .parse */ .Q)("+1".concat(phoneNumber), "US");
    if ("phone" in parsedNumber) {
        phoneNumber = parsedNumber.phone;
        invalid = false;
    }
    return invalid;
};
// Check to see if a page's window.location.pathname is included in the INCLUSIONS array in
// component_config by doing a substring check items in the array relative to the current path
var inInclusionArray = function(inclusionArray, currentPath) {
    if (inclusionArray && !filter(inclusionArray, function(path) {
        return currentPath.indexOf(path) !== -1;
    }).length) {
        return false;
    }
    return true;
};
var creditCardExpiryErrors = {
    REQUIRED: "Exp MM/YY required",
    FORMAT: "Format must be MM/YY",
    EXPIRED: "Expiry date must be in the future"
};
var isCreditCardExpiryValid = function(expiry) {
    // Existence check
    if (!expiry) {
        return creditCardExpiryErrors.REQUIRED;
    }
    // Format check
    if (!/^(0[1-9]|1[0-2])\/\d{2}$/.test(expiry)) {
        return creditCardExpiryErrors.FORMAT;
    }
    // Ensure exp is in the future (inclusive of current month)
    var expires = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .addTime */ .yG)((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .getDate */ ._3)(expiry, _constants_dates__WEBPACK_IMPORTED_MODULE_1__/* .DATE_FORMAT.MONTH_WITH_YEAR */ .z.MONTH_WITH_YEAR), 1, "months");
    var today = new Date();
    if ((0,_utils_dates__WEBPACK_IMPORTED_MODULE_3__/* .isDateBefore */ .hF)(expires, today)) {
        return creditCardExpiryErrors.EXPIRED;
    }
    return null;
};


/***/ }),

/***/ 12527:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/constants/envConfig.ts + 1 modules
var envConfig = __webpack_require__(73690);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */
function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i] ;
    const fn = ops[i + 1] ;
    i += 2;
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
      return;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => (value ).call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}

// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }


//# sourceMappingURL=_optionalChain.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/core/esm/hub.js + 6 modules
var hub = __webpack_require__(16845);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/core/esm/utils/hasTracingEnabled.js


// Treeshakable guard to remove all code related to tracing

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) {
    return false;
  }

  const client = (0,hub/* getCurrentHub */.Gd)().getClient();
  const options = maybeOptions || (client && client.getOptions());
  return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}


//# sourceMappingURL=hasTracingEnabled.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/integrations/node_modules/@sentry/utils/esm/path.js
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  let up = 0;
  for (let i = parts.length - 1; i >= 0; i--) {
    const last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */
function splitPath(filename) {
  // Truncate files names greater than 1024 characters to avoid regex dos
  // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
  const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
  const parts = splitPathRe.exec(truncated);
  return parts ? parts.slice(1) : [];
}

// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve(...args) {
  let resolvedPath = '';
  let resolvedAbsolute = false;

  for (let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    const path = i >= 0 ? args[i] : '/';

    // Skip empty entries
    if (!path) {
      continue;
    }

    resolvedPath = `${path}/${resolvedPath}`;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(
    resolvedPath.split('/').filter(p => !!p),
    !resolvedAbsolute,
  ).join('/');

  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}

/** JSDoc */
function trim(arr) {
  let start = 0;
  for (; start < arr.length; start++) {
    if (arr[start] !== '') {
      break;
    }
  }

  let end = arr.length - 1;
  for (; end >= 0; end--) {
    if (arr[end] !== '') {
      break;
    }
  }

  if (start > end) {
    return [];
  }
  return arr.slice(start, end - start + 1);
}

// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
  /* eslint-disable no-param-reassign */
  from = resolve(from).slice(1);
  to = resolve(to).slice(1);
  /* eslint-enable no-param-reassign */

  const fromParts = trim(from.split('/'));
  const toParts = trim(to.split('/'));

  const length = Math.min(fromParts.length, toParts.length);
  let samePartsLength = length;
  for (let i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  let outputParts = [];
  for (let i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
}

// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
  const isPathAbsolute = isAbsolute(path);
  const trailingSlash = path.slice(-1) === '/';

  // Normalize the path
  let normalizedPath = normalizeArray(
    path.split('/').filter(p => !!p),
    !isPathAbsolute,
  ).join('/');

  if (!normalizedPath && !isPathAbsolute) {
    normalizedPath = '.';
  }
  if (normalizedPath && trailingSlash) {
    normalizedPath += '/';
  }

  return (isPathAbsolute ? '/' : '') + normalizedPath;
}

// posix version
/** JSDoc */
function isAbsolute(path) {
  return path.charAt(0) === '/';
}

// posix version
/** JSDoc */
function join(...args) {
  return normalizePath(args.join('/'));
}

/** JSDoc */
function dirname(path) {
  const result = splitPath(path);
  const root = result[0];
  let dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
  }

  return root + dir;
}

/** JSDoc */
function basename(path, ext) {
  let f = splitPath(path)[2];
  if (ext && f.slice(ext.length * -1) === ext) {
    f = f.slice(0, f.length - ext.length);
  }
  return f;
}


//# sourceMappingURL=path.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/integrations/esm/rewriteframes.js


/** Rewrite event frames paths */
class RewriteFrames  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'RewriteFrames';}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   constructor(options = {}) {RewriteFrames.prototype.__init.call(this);
    this.name = RewriteFrames.id;

    if (options.root) {
      this._root = options.root;
    }
    this._prefix = options.prefix || 'app:///';
    if (options.iteratee) {
      this._iteratee = options.iteratee;
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(_addGlobaleventProcessor, _getCurrentHub) {
    // noop
  }

  /** @inheritDoc */
   processEvent(event) {
    return this.process(event);
  }

  /**
   * TODO (v8): Make this private/internal
   */
   process(originalEvent) {
    let processedEvent = originalEvent;

    if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
      processedEvent = this._processExceptionsEvent(processedEvent);
    }

    return processedEvent;
  }

  /**
   * @inheritDoc
   */
    __init() {this._iteratee = (frame) => {
    if (!frame.filename) {
      return frame;
    }
    // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
    const isWindowsFrame =
      /^[a-zA-Z]:\\/.test(frame.filename) ||
      // or the presence of a backslash without a forward slash (which are not allowed on Windows)
      (frame.filename.includes('\\') && !frame.filename.includes('/'));
    // Check if the frame filename begins with `/`
    const startsWithSlash = /^\//.test(frame.filename);
    if (isWindowsFrame || startsWithSlash) {
      const filename = isWindowsFrame
        ? frame.filename
            .replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
        : frame.filename;
      const base = this._root ? relative(this._root, filename) : basename(filename);
      frame.filename = `${this._prefix}${base}`;
    }
    return frame;
  };}

  /** JSDoc */
   _processExceptionsEvent(event) {
    try {
      return {
        ...event,
        exception: {
          ...event.exception,
          // The check for this is performed inside `process` call itself, safe to skip here
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          values: event.exception.values.map(value => ({
            ...value,
            ...(value.stacktrace && { stacktrace: this._processStacktrace(value.stacktrace) }),
          })),
        },
      };
    } catch (_oO) {
      return event;
    }
  }

  /** JSDoc */
   _processStacktrace(stacktrace) {
    return {
      ...stacktrace,
      frames: stacktrace && stacktrace.frames && stacktrace.frames.map(f => this._iteratee(f)),
    };
  }
} RewriteFrames.__initStatic();


//# sourceMappingURL=rewriteframes.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/version.js
var version = __webpack_require__(91476);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(58536);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(63699);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(39660);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/debug-build.js
var debug_build = __webpack_require__(73232);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/eventProcessors.js
var eventProcessors = __webpack_require__(8589);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/hub.js
var esm_hub = __webpack_require__(66465);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/integration.js






const installedIntegrations = [];

/** Map of integrations assigned to a client */

/**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */
function filterDuplicates(integrations) {
  const integrationsByName = {};

  integrations.forEach(currentInstance => {
    const { name } = currentInstance;

    const existingInstance = integrationsByName[name];

    // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
    // default instance to overwrite an existing user instance
    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
      return;
    }

    integrationsByName[name] = currentInstance;
  });

  return Object.keys(integrationsByName).map(k => integrationsByName[k]);
}

/** Gets integrations to install */
function getIntegrationsToSetup(options) {
  const defaultIntegrations = options.defaultIntegrations || [];
  const userIntegrations = options.integrations;

  // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
  defaultIntegrations.forEach(integration => {
    integration.isDefaultInstance = true;
  });

  let integrations;

  if (Array.isArray(userIntegrations)) {
    integrations = [...defaultIntegrations, ...userIntegrations];
  } else if (typeof userIntegrations === 'function') {
    integrations = (0,misc/* arrayify */.lE)(userIntegrations(defaultIntegrations));
  } else {
    integrations = defaultIntegrations;
  }

  const finalIntegrations = filterDuplicates(integrations);

  // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
  // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
  // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
  // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
  const debugIndex = findIndex(finalIntegrations, integration => integration.name === 'Debug');
  if (debugIndex !== -1) {
    const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
    finalIntegrations.push(debugInstance);
  }

  return finalIntegrations;
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(client, integrations) {
  const integrationIndex = {};

  integrations.forEach(integration => {
    // guard against empty provided integrations
    if (integration) {
      setupIntegration(client, integration, integrationIndex);
    }
  });

  return integrationIndex;
}

/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */
function afterSetupIntegrations(client, integrations) {
  for (const integration of integrations) {
    // guard against empty provided integrations
    if (integration && integration.afterAllSetup) {
      integration.afterAllSetup(client);
    }
  }
}

/** Setup a single integration.  */
function setupIntegration(client, integration, integrationIndex) {
  if (integrationIndex[integration.name]) {
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`Integration skipped because it was already installed: ${integration.name}`);
    return;
  }
  integrationIndex[integration.name] = integration;

  // `setupOnce` is only called the first time
  if (installedIntegrations.indexOf(integration.name) === -1) {
    // eslint-disable-next-line deprecation/deprecation
    integration.setupOnce(eventProcessors/* addGlobalEventProcessor */.cc, esm_hub/* getCurrentHub */.Gd);
    installedIntegrations.push(integration.name);
  }

  // `setup` is run for each client
  if (integration.setup && typeof integration.setup === 'function') {
    integration.setup(client);
  }

  if (client.on && typeof integration.preprocessEvent === 'function') {
    const callback = integration.preprocessEvent.bind(integration) ;
    client.on('preprocessEvent', (event, hint) => callback(event, hint, client));
  }

  if (client.addEventProcessor && typeof integration.processEvent === 'function') {
    const callback = integration.processEvent.bind(integration) ;

    const processor = Object.assign((event, hint) => callback(event, hint, client), {
      id: integration.name,
    });

    client.addEventProcessor(processor);
  }

  debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`Integration installed: ${integration.name}`);
}

/** Add an integration to the current hub's client. */
function addIntegration(integration) {
  const client = getClient();

  if (!client || !client.addIntegration) {
    DEBUG_BUILD && logger.warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
    return;
  }

  client.addIntegration(integration);
}

// Polyfill for Array.findIndex(), which is not supported in ES5
function findIndex(arr, callback) {
  for (let i = 0; i < arr.length; i++) {
    if (callback(arr[i]) === true) {
      return i;
    }
  }

  return -1;
}

/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */
function convertIntegrationFnToClass(
  name,
  fn,
) {
  return Object.assign(
    function ConvertedIntegration(...args) {
      return fn(...args);
    },
    { id: name },
  ) ;
}

/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */
function defineIntegration(fn) {
  return fn;
}


//# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/integrations/inboundfilters.js




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const DEFAULT_IGNORE_ERRORS = [
  /^Script error\.?$/,
  /^Javascript error: Script error\.? on line 0$/,
  /^ResizeObserver loop completed with undelivered notifications.$/,
  /^Cannot redefine property: googletag$/,
];

const DEFAULT_IGNORE_TRANSACTIONS = [
  /^.*\/healthcheck$/,
  /^.*\/healthy$/,
  /^.*\/live$/,
  /^.*\/ready$/,
  /^.*\/heartbeat$/,
  /^.*\/health$/,
  /^.*\/healthz$/,
];

/** Options for the InboundFilters integration */

const INTEGRATION_NAME = 'InboundFilters';
const _inboundFiltersIntegration = ((options = {}) => {
  return {
    name: INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    processEvent(event, _hint, client) {
      const clientOptions = client.getOptions();
      const mergedOptions = _mergeOptions(options, clientOptions);
      return _shouldDropEvent(event, mergedOptions) ? null : event;
    },
  };
}) ;

const inboundFiltersIntegration = defineIntegration(_inboundFiltersIntegration);

/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const InboundFilters = convertIntegrationFnToClass(
  INTEGRATION_NAME,
  inboundFiltersIntegration,
)

;

function _mergeOptions(
  internalOptions = {},
  clientOptions = {},
) {
  return {
    allowUrls: [...(internalOptions.allowUrls || []), ...(clientOptions.allowUrls || [])],
    denyUrls: [...(internalOptions.denyUrls || []), ...(clientOptions.denyUrls || [])],
    ignoreErrors: [
      ...(internalOptions.ignoreErrors || []),
      ...(clientOptions.ignoreErrors || []),
      ...(internalOptions.disableErrorDefaults ? [] : DEFAULT_IGNORE_ERRORS),
    ],
    ignoreTransactions: [
      ...(internalOptions.ignoreTransactions || []),
      ...(clientOptions.ignoreTransactions || []),
      ...(internalOptions.disableTransactionDefaults ? [] : DEFAULT_IGNORE_TRANSACTIONS),
    ],
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
  };
}

function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.warn */.kg.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`,
      );
    return true;
  }
  if (_isIgnoredTransaction(event, options.ignoreTransactions)) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`,
      );
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  return false;
}

function _isIgnoredError(event, ignoreErrors) {
  // If event.type, this is not an error
  if (event.type || !ignoreErrors || !ignoreErrors.length) {
    return false;
  }

  return _getPossibleEventMessages(event).some(message => (0,string/* stringMatchesSomePattern */.U0)(message, ignoreErrors));
}

function _isIgnoredTransaction(event, ignoreTransactions) {
  if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) {
    return false;
  }

  const name = event.transaction;
  return name ? (0,string/* stringMatchesSomePattern */.U0)(name, ignoreTransactions) : false;
}

function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  const url = _getEventFilterUrl(event);
  return !url ? false : (0,string/* stringMatchesSomePattern */.U0)(url, denyUrls);
}

function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  const url = _getEventFilterUrl(event);
  return !url ? true : (0,string/* stringMatchesSomePattern */.U0)(url, allowUrls);
}

function _getPossibleEventMessages(event) {
  const possibleMessages = [];

  if (event.message) {
    possibleMessages.push(event.message);
  }

  let lastException;
  try {
    // @ts-expect-error Try catching to save bundle size
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    lastException = event.exception.values[event.exception.values.length - 1];
  } catch (e) {
    // try catching to save bundle size checking existence of variables
  }

  if (lastException) {
    if (lastException.value) {
      possibleMessages.push(lastException.value);
      if (lastException.type) {
        possibleMessages.push(`${lastException.type}: ${lastException.value}`);
      }
    }
  }

  if (debug_build/* DEBUG_BUILD */.X && possibleMessages.length === 0) {
    esm_logger/* logger.error */.kg.error(`Could not extract message for event ${(0,misc/* getEventDescription */.jH)(event)}`);
  }

  return possibleMessages;
}

function _isSentryError(event) {
  try {
    // @ts-expect-error can't be a sentry error if undefined
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return event.exception.values[0].type === 'SentryError';
  } catch (e) {
    // ignore
  }
  return false;
}

function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    const frame = frames[i];

    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }

  return null;
}

function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      // @ts-expect-error we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
      // ignore
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.error */.kg.error(`Cannot extract url for event ${(0,misc/* getEventDescription */.jH)(event)}`);
    return null;
  }
}


//# sourceMappingURL=inboundfilters.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(21995);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(92642);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/integrations/functiontostring.js




let originalFunctionToString;

const functiontostring_INTEGRATION_NAME = 'FunctionToString';

const SETUP_CLIENTS = new WeakMap();

const _functionToStringIntegration = (() => {
  return {
    name: functiontostring_INTEGRATION_NAME,
    setupOnce() {
      // eslint-disable-next-line @typescript-eslint/unbound-method
      originalFunctionToString = Function.prototype.toString;

      // intrinsics (like Function.prototype) might be immutable in some environments
      // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function ( ...args) {
          const originalFunction = (0,object/* getOriginalFunction */.HK)(this);
          const context =
            SETUP_CLIENTS.has((0,esm_exports/* getClient */.s3)() ) && originalFunction !== undefined ? originalFunction : this;
          return originalFunctionToString.apply(context, args);
        };
      } catch (e) {
        // ignore errors here, just don't patch this
      }
    },
    setup(client) {
      SETUP_CLIENTS.set(client, true);
    },
  };
}) ;

/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */
const functionToStringIntegration = defineIntegration(_functionToStringIntegration);

/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const FunctionToString = convertIntegrationFnToClass(
  functiontostring_INTEGRATION_NAME,
  functionToStringIntegration,
) ;

// eslint-disable-next-line deprecation/deprecation


//# sourceMappingURL=functiontostring.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/sdk.js





/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(
  clientClass,
  options,
) {
  if (options.debug === true) {
    if (debug_build/* DEBUG_BUILD */.X) {
      esm_logger/* logger.enable */.kg.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
      (0,esm_logger/* consoleSandbox */.Cf)(() => {
        // eslint-disable-next-line no-console
        console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
      });
    }
  }
  const scope = (0,esm_exports/* getCurrentScope */.nZ)();
  scope.update(options.initialScope);

  const client = new clientClass(options);
  setCurrentClient(client);
  initializeClient(client);
}

/**
 * Make the given client the current client.
 */
function setCurrentClient(client) {
  // eslint-disable-next-line deprecation/deprecation
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  // eslint-disable-next-line deprecation/deprecation
  const top = hub.getStackTop();
  top.client = client;
  top.scope.setClient(client);
}

/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */
function initializeClient(client) {
  if (client.init) {
    client.init();
    // TODO v8: Remove this fallback
    // eslint-disable-next-line deprecation/deprecation
  } else if (client.setupIntegrations) {
    // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
  }
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(69038);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/debug-build.js
var esm_debug_build = __webpack_require__(51982);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(90063);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/supports.js




// eslint-disable-next-line deprecation/deprecation
const supports_WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-expect-error It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in supports_WINDOW)) {
    return false;
  }

  try {
    new Headers();
    new Request('http://www.example.com');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (typeof EdgeRuntime === 'string') {
    return true;
  }

  if (!supportsFetch()) {
    return false;
  }

  // Fast path to avoid DOM I/O
  // eslint-disable-next-line @typescript-eslint/unbound-method
  if (isNativeFetch(supports_WINDOW.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  const doc = supports_WINDOW.document;
  // eslint-disable-next-line deprecation/deprecation
  if (doc && typeof (doc.createElement ) === 'function') {
    try {
      const sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      esm_debug_build/* DEBUG_BUILD */.X &&
        esm_logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in supports_WINDOW;
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin' ,
    });
    return true;
  } catch (e) {
    return false;
  }
}


//# sourceMappingURL=supports.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/vendor/supportsHistory.js


// Based on https://github.com/angular/angular.js/pull/13945/files

// eslint-disable-next-line deprecation/deprecation
const supportsHistory_WINDOW = (0,worldwide/* getGlobalObject */.Rf)();

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chromeVar = (supportsHistory_WINDOW ).chrome;
  const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
  /* eslint-enable @typescript-eslint/no-unsafe-member-access */
  const hasHistoryApi = 'history' in supportsHistory_WINDOW && !!supportsHistory_WINDOW.history.pushState && !!supportsHistory_WINDOW.history.replaceState;

  return !isChromePackagedApp && hasHistoryApi;
}


//# sourceMappingURL=supportsHistory.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/instrument/_handlers.js




// We keep the handlers globally
const handlers = {};
const instrumented = {};

/** Add a handler function. */
function addHandler(type, handler) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(handler);
}

/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */
function resetInstrumentationHandlers() {
  Object.keys(handlers).forEach(key => {
    handlers[key ] = undefined;
  });
}

/** Maybe run an instrumentation function, unless it was already called. */
function maybeInstrument(type, instrumentFn) {
  if (!instrumented[type]) {
    instrumentFn();
    instrumented[type] = true;
  }
}

/** Trigger handlers for a given instrumentation type. */
function triggerHandlers(type, data) {
  const typeHandlers = type && handlers[type];
  if (!typeHandlers) {
    return;
  }

  for (const handler of typeHandlers) {
    try {
      handler(data);
    } catch (e) {
      esm_debug_build/* DEBUG_BUILD */.X &&
        esm_logger/* logger.error */.kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,stacktrace/* getFunctionName */.$P)(handler)}\nError:`,
          e,
        );
    }
  }
}


//# sourceMappingURL=_handlers.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/instrument/history.js







const history_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

let lastHref;

/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addHistoryInstrumentationHandler(handler) {
  const type = 'history';
  addHandler(type, handler);
  maybeInstrument(type, instrumentHistory);
}

function instrumentHistory() {
  if (!supportsHistory()) {
    return;
  }

  const oldOnPopState = history_WINDOW.onpopstate;
  history_WINDOW.onpopstate = function ( ...args) {
    const to = history_WINDOW.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    const from = lastHref;
    lastHref = to;
    const handlerData = { from, to };
    triggerHandlers('history', handlerData);
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };

  function historyReplacementFunction(originalHistoryFunction) {
    return function ( ...args) {
      const url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        const from = lastHref;
        const to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        const handlerData = { from, to };
        triggerHandlers('history', handlerData);
      }
      return originalHistoryFunction.apply(this, args);
    };
  }

  (0,object/* fill */.hl)(history_WINDOW.history, 'pushState', historyReplacementFunction);
  (0,object/* fill */.hl)(history_WINDOW.history, 'replaceState', historyReplacementFunction);
}


//# sourceMappingURL=history.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/dsn.js



/** Regular expression used to parse a Dsn. */
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsn_dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */
function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);

  if (!match) {
    // This should be logged to the console
    (0,esm_logger/* consoleSandbox */.Cf)(() => {
      // eslint-disable-next-line no-console
      console.error(`Invalid Sentry Dsn: ${str}`);
    });
    return undefined;
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  const split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function validateDsn(dsn) {
  if (!esm_debug_build/* DEBUG_BUILD */.X) {
    return true;
  }

  const { port, projectId, protocol } = dsn;

  const requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  const hasMissingRequiredComponent = requiredComponents.find(component => {
    if (!dsn[component]) {
      esm_logger/* logger.error */.kg.error(`Invalid Sentry Dsn: ${component} missing`);
      return true;
    }
    return false;
  });

  if (hasMissingRequiredComponent) {
    return false;
  }

  if (!projectId.match(/^\d+$/)) {
    esm_logger/* logger.error */.kg.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
    return false;
  }

  if (!isValidProtocol(protocol)) {
    esm_logger/* logger.error */.kg.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
    return false;
  }

  if (port && isNaN(parseInt(port, 10))) {
    esm_logger/* logger.error */.kg.error(`Invalid Sentry Dsn: Invalid port ${port}`);
    return false;
  }

  return true;
}

/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */
function dsn_makeDsn(from) {
  const components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
  if (!components || !validateDsn(components)) {
    return undefined;
  }
  return components;
}


//# sourceMappingURL=dsn.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(81757);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(97946);
// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/normalize.js + 1 modules
var normalize = __webpack_require__(64017);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/envelope.js




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items = []) {
  return [headers, items] ;
}

/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]] ;
}

/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */
function forEachEnvelopeItem(
  envelope,
  callback,
) {
  const envelopeItems = envelope[1];

  for (const envelopeItem of envelopeItems) {
    const envelopeItemType = envelopeItem[0].type;
    const result = callback(envelopeItem, envelopeItemType);

    if (result) {
      return true;
    }
  }

  return false;
}

/**
 * Returns true if the envelope contains any of the given envelope item types
 */
function envelopeContainsItemType(envelope, types) {
  return forEachEnvelopeItem(envelope, (_, type) => types.includes(type));
}

/**
 * Encode a string to UTF8.
 */
function encodeUTF8(input, textEncoder) {
  const utf8 = textEncoder || new TextEncoder();
  return utf8.encode(input);
}

/**
 * Serializes an envelope.
 */
function serializeEnvelope(envelope, textEncoder) {
  const [envHeaders, items] = envelope;

  // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
  let parts = JSON.stringify(envHeaders);

  function append(next) {
    if (typeof parts === 'string') {
      parts = typeof next === 'string' ? parts + next : [encodeUTF8(parts, textEncoder), next];
    } else {
      parts.push(typeof next === 'string' ? encodeUTF8(next, textEncoder) : next);
    }
  }

  for (const item of items) {
    const [itemHeaders, payload] = item;

    append(`\n${JSON.stringify(itemHeaders)}\n`);

    if (typeof payload === 'string' || payload instanceof Uint8Array) {
      append(payload);
    } else {
      let stringifiedPayload;
      try {
        stringifiedPayload = JSON.stringify(payload);
      } catch (e) {
        // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
        // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
        // performance impact but in this case a performance hit is better than throwing.
        stringifiedPayload = JSON.stringify((0,normalize/* normalize */.Fv)(payload));
      }
      append(stringifiedPayload);
    }
  }

  return typeof parts === 'string' ? parts : concatBuffers(parts);
}

function concatBuffers(buffers) {
  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);

  const merged = new Uint8Array(totalLength);
  let offset = 0;
  for (const buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }

  return merged;
}

/**
 * Parses an envelope
 */
function parseEnvelope(
  env,
  textEncoder,
  textDecoder,
) {
  let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;

  function readBinary(length) {
    const bin = buffer.subarray(0, length);
    // Replace the buffer with the remaining data excluding trailing newline
    buffer = buffer.subarray(length + 1);
    return bin;
  }

  function readJson() {
    let i = buffer.indexOf(0xa);
    // If we couldn't find a newline, we must have found the end of the buffer
    if (i < 0) {
      i = buffer.length;
    }

    return JSON.parse(textDecoder.decode(readBinary(i))) ;
  }

  const envelopeHeader = readJson();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const items = [];

  while (buffer.length) {
    const itemHeader = readJson();
    const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;

    items.push([itemHeader, binaryLength ? readBinary(binaryLength) : readJson()]);
  }

  return [envelopeHeader, items];
}

/**
 * Creates attachment envelope items
 */
function createAttachmentEnvelopeItem(
  attachment,
  textEncoder,
) {
  const buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data, textEncoder) : attachment.data;

  return [
    (0,object/* dropUndefinedKeys */.Jr)({
      type: 'attachment',
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType,
    }),
    buffer,
  ];
}

const ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
  profile: 'profile',
  replay_event: 'replay',
  replay_recording: 'replay',
  check_in: 'monitor',
  feedback: 'feedback',
  span: 'span',
  statsd: 'metric_bucket',
};

/**
 * Maps the type of an envelope item to a data category.
 */
function envelopeItemTypeToDataCategory(type) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}

/** Extracts the minimal SDK info from the metadata or an events */
function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
  if (!metadataOrEvent || !metadataOrEvent.sdk) {
    return;
  }
  const { name, version } = metadataOrEvent.sdk;
  return { name, version };
}

/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */
function createEventEnvelopeHeaders(
  event,
  sdkInfo,
  tunnel,
  dsn,
) {
  const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
  return {
    event_id: event.event_id ,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && dsn && { dsn: dsn_dsnToString(dsn) }),
    ...(dynamicSamplingContext && {
      trace: (0,object/* dropUndefinedKeys */.Jr)({ ...dynamicSamplingContext }),
    }),
  };
}


//# sourceMappingURL=envelope.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/error.js
/** An error emitted by Sentry SDKs and related utilities. */
class SentryError extends Error {
  /** Display name of this error instance. */

   constructor( message, logLevel = 'warn') {
    super(message);this.message = message;
    this.name = new.target.prototype.constructor.name;
    // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
    // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
    // instances of `SentryError` fail `obj instanceof SentryError` checks.
    Object.setPrototypeOf(this, new.target.prototype);
    this.logLevel = logLevel;
  }
}


//# sourceMappingURL=error.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/api.js


const SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
  const port = dsn.port ? `:${dsn.port}` : '';
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  return (0,object/* urlEncode */._j)({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION,
    ...(sdkInfo && { sentry_client: `${sdkInfo.name}/${sdkInfo.version}` }),
  });
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(
  dsn,
  // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
  // options: ClientOptions = {} as ClientOptions,
  tunnelOrOptions = {} ,
) {
  // TODO (v8): Use this code instead
  // const { tunnel, _metadata = {} } = options;
  // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;

  const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
  const sdkInfo =
    typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;

  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}

/** Returns the url to the report dialog endpoint. */
function api_getReportDialogEndpoint(
  dsnLike,
  dialogOptions

,
) {
  const dsn = makeDsn(dsnLike);
  if (!dsn) {
    return '';
  }

  const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;

  let encodedOptions = `dsn=${dsnToString(dsn)}`;
  for (const key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }

    if (key === 'onClose') {
      continue;
    }

    if (key === 'user') {
      const user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key] )}`;
    }
  }

  return `${endpoint}?${encodedOptions}`;
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/envelope.js


/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

/** Creates an envelope from a Session */
function createSessionEnvelope(
  session,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  const envelopeHeaders = {
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && dsn && { dsn: dsn_dsnToString(dsn) }),
  };

  const envelopeItem =
    'aggregates' in session ? [{ type: 'sessions' }, session] : [{ type: 'session' }, session.toJSON()];

  return createEnvelope(envelopeHeaders, [envelopeItem]);
}

/**
 * Create an Envelope from an event.
 */
function createEventEnvelope(
  event,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);

  /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */
  const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';

  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);

  const envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete event.sdkProcessingMetadata;

  const eventItem = [{ type: eventType }, event];
  return createEnvelope(envelopeHeaders, [eventItem]);
}


//# sourceMappingURL=envelope.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/metrics/utils.js


/**
 * Generate bucket key from metric properties.
 */
function getBucketKey(
  metricType,
  name,
  unit,
  tags,
) {
  const stringifiedTags = Object.entries(dropUndefinedKeys(tags)).sort((a, b) => a[0].localeCompare(b[0]));
  return `${metricType}${name}${unit}${stringifiedTags}`;
}

/* eslint-disable no-bitwise */
/**
 * Simple hash function for strings.
 */
function simpleHash(s) {
  let rv = 0;
  for (let i = 0; i < s.length; i++) {
    const c = s.charCodeAt(i);
    rv = (rv << 5) - rv + c;
    rv &= rv;
  }
  return rv >>> 0;
}
/* eslint-enable no-bitwise */

/**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */
function serializeMetricBuckets(metricBucketItems) {
  let out = '';
  for (const item of metricBucketItems) {
    const tagEntries = Object.entries(item.tags);
    const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value]) => `${key}:${value}`).join(',')}` : '';
    out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
  }
  return out;
}

/** Sanitizes units */
function sanitizeUnit(unit) {
  return unit.replace(/[^\w]+/gi, '_');
}

/** Sanitizes metric keys */
function sanitizeMetricKey(key) {
  return key.replace(/[^\w\-.]+/gi, '_');
}

function sanitizeTagKey(key) {
  return key.replace(/[^\w\-./]+/gi, '');
}

const tagValueReplacements = (/* unused pure expression or super */ null && ([
  ['\n', '\\n'],
  ['\r', '\\r'],
  ['\t', '\\t'],
  ['\\', '\\\\'],
  ['|', '\\u{7c}'],
  [',', '\\u{2c}'],
]));

function getCharOrReplacement(input) {
  for (const [search, replacement] of tagValueReplacements) {
    if (input === search) {
      return replacement;
    }
  }

  return input;
}

function sanitizeTagValue(value) {
  return [...value].reduce((acc, char) => acc + getCharOrReplacement(char), '');
}

/**
 * Sanitizes tags.
 */
function sanitizeTags(unsanitizedTags) {
  const tags = {};
  for (const key in unsanitizedTags) {
    if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
      const sanitizedKey = sanitizeTagKey(key);
      tags[sanitizedKey] = sanitizeTagValue(String(unsanitizedTags[key]));
    }
  }
  return tags;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/metrics/envelope.js



/**
 * Create envelope from a metric aggregate.
 */
function createMetricEnvelope(
  metricBucketItems,
  dsn,
  metadata,
  tunnel,
) {
  const headers = {
    sent_at: new Date().toISOString(),
  };

  if (metadata && metadata.sdk) {
    headers.sdk = {
      name: metadata.sdk.name,
      version: metadata.sdk.version,
    };
  }

  if (!!tunnel && dsn) {
    headers.dsn = dsn_dsnToString(dsn);
  }

  const item = createMetricEnvelopeItem(metricBucketItems);
  return createEnvelope(headers, [item]);
}

function createMetricEnvelopeItem(metricBucketItems) {
  const payload = serializeMetricBuckets(metricBucketItems);
  const metricHeaders = {
    type: 'statsd',
    length: payload.length,
  };
  return [metricHeaders, payload];
}


//# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/session.js
var esm_session = __webpack_require__(48364);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/tracing/dynamicSamplingContext.js
var tracing_dynamicSamplingContext = __webpack_require__(92980);
// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/prepareEvent.js
var prepareEvent = __webpack_require__(48738);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/baseclient.js












const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
class BaseClient {
  /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */

  /** Options passed to the SDK. */

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

  /** Array of set up integrations. */

  /** Indicates whether this client's integrations have been set up. */

  /** Number of calls being processed */

  /** Holds flushable  */

  // eslint-disable-next-line @typescript-eslint/ban-types

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
   constructor(options) {
    this._options = options;
    this._integrations = {};
    this._integrationsInitialized = false;
    this._numProcessing = 0;
    this._outcomes = {};
    this._hooks = {};
    this._eventProcessors = [];

    if (options.dsn) {
      this._dsn = dsn_makeDsn(options.dsn);
    } else {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn('No DSN provided, client will not send events.');
    }

    if (this._dsn) {
      const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options);
      this._transport = options.transport({
        tunnel: this._options.tunnel,
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url,
      });
    }
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint, scope) {
    // ensure we haven't captured this very object before
    if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this.eventFromException(exception, hint)
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
    scope,
  ) {
    let eventId = hint && hint.event_id;

    const eventMessage = (0,is/* isParameterizedString */.Le)(message) ? message : String(message);

    const promisedEvent = (0,is/* isPrimitive */.pt)(message)
      ? this.eventFromMessage(eventMessage, level, hint)
      : this.eventFromException(message, hint);

    this._process(
      promisedEvent
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint, scope) {
    // ensure we haven't captured this very object before
    if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
    const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;

    this._process(
      this._captureEvent(event, hint, capturedSpanScope || scope).then(result => {
        eventId = result;
      }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureSession(session) {
    if (!(typeof session.release === 'string')) {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
    } else {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      (0,esm_session/* updateSession */.CT)(session, { init: false });
    }
  }

  /**
   * @inheritDoc
   */
   getDsn() {
    return this._dsn;
  }

  /**
   * @inheritDoc
   */
   getOptions() {
    return this._options;
  }

  /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */
   getSdkMetadata() {
    return this._options._metadata;
  }

  /**
   * @inheritDoc
   */
   getTransport() {
    return this._transport;
  }

  /**
   * @inheritDoc
   */
   flush(timeout) {
    const transport = this._transport;
    if (transport) {
      if (this.metricsAggregator) {
        this.metricsAggregator.flush();
      }
      return this._isClientDoneProcessing(timeout).then(clientFinished => {
        return transport.flush(timeout).then(transportFlushed => clientFinished && transportFlushed);
      });
    } else {
      return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    }
  }

  /**
   * @inheritDoc
   */
   close(timeout) {
    return this.flush(timeout).then(result => {
      this.getOptions().enabled = false;
      if (this.metricsAggregator) {
        this.metricsAggregator.close();
      }
      return result;
    });
  }

  /** Get all installed event processors. */
   getEventProcessors() {
    return this._eventProcessors;
  }

  /** @inheritDoc */
   addEventProcessor(eventProcessor) {
    this._eventProcessors.push(eventProcessor);
  }

  /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */
   setupIntegrations(forceInitialize) {
    if ((forceInitialize && !this._integrationsInitialized) || (this._isEnabled() && !this._integrationsInitialized)) {
      this._setupIntegrations();
    }
  }

  /** @inheritdoc */
   init() {
    if (this._isEnabled()) {
      this._setupIntegrations();
    }
  }

  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */
   getIntegrationById(integrationId) {
    return this.getIntegrationByName(integrationId);
  }

  /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */
   getIntegrationByName(integrationName) {
    return this._integrations[integrationName] ;
  }

  /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */
   getIntegration(integration) {
    try {
      return (this._integrations[integration.id] ) || null;
    } catch (_oO) {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn(`Cannot retrieve integration ${integration.id} from the current Client`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   addIntegration(integration) {
    const isAlreadyInstalled = this._integrations[integration.name];

    // This hook takes care of only installing if not already installed
    setupIntegration(this, integration, this._integrations);
    // Here we need to check manually to make sure to not run this multiple times
    if (!isAlreadyInstalled) {
      afterSetupIntegrations(this, [integration]);
    }
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint = {}) {
    this.emit('beforeSendEvent', event, hint);

    let env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);

    for (const attachment of hint.attachments || []) {
      env = addItemToEnvelope(
        env,
        createAttachmentEnvelopeItem(
          attachment,
          this._options.transportOptions && this._options.transportOptions.textEncoder,
        ),
      );
    }

    const promise = this._sendEnvelope(env);
    if (promise) {
      promise.then(sendResponse => this.emit('afterSendEvent', event, sendResponse), null);
    }
  }

  /**
   * @inheritDoc
   */
   sendSession(session) {
    const env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);

    // _sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this._sendEnvelope(env);
  }

  /**
   * @inheritDoc
   */
   recordDroppedEvent(reason, category, eventOrCount) {
    if (this._options.sendClientReports) {
      // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
      // If event is passed as third argument, we assume this is a count of 1
      const count = typeof eventOrCount === 'number' ? eventOrCount : 1;

      // We want to track each category (error, transaction, session, replay_event) separately
      // but still keep the distinction between different type of outcomes.
      // We could use nested maps, but it's much easier to read and type this way.
      // A correct type for map-based implementation if we want to go that route
      // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
      // With typescript 4.1 we could even use template literal types
      const key = `${reason}:${category}`;
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
      this._outcomes[key] = (this._outcomes[key] || 0) + count;
    }
  }

  /**
   * @inheritDoc
   */
   captureAggregateMetrics(metricBucketItems) {
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
    const metricsEnvelope = createMetricEnvelope(
      metricBucketItems,
      this._dsn,
      this._options._metadata,
      this._options.tunnel,
    );

    // _sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this._sendEnvelope(metricsEnvelope);
  }

  // Keep on() & emit() signatures in sync with types' client.ts interface
  /* eslint-disable @typescript-eslint/unified-signatures */

  /** @inheritdoc */

  /** @inheritdoc */
   on(hook, callback) {
    if (!this._hooks[hook]) {
      this._hooks[hook] = [];
    }

    // @ts-expect-error We assue the types are correct
    this._hooks[hook].push(callback);
  }

  /** @inheritdoc */

  /** @inheritdoc */
   emit(hook, ...rest) {
    if (this._hooks[hook]) {
      this._hooks[hook].forEach(callback => callback(...rest));
    }
  }

  /* eslint-enable @typescript-eslint/unified-signatures */

  /** Setup integrations for this client. */
   _setupIntegrations() {
    const { integrations } = this._options;
    this._integrations = setupIntegrations(this, integrations);
    afterSetupIntegrations(this, integrations);

    // TODO v8: We don't need this flag anymore
    this._integrationsInitialized = true;
  }

  /** Updates existing session based on the provided event */
   _updateSessionFromEvent(session, event) {
    let crashed = false;
    let errored = false;
    const exceptions = event.exception && event.exception.values;

    if (exceptions) {
      errored = true;

      for (const ex of exceptions) {
        const mechanism = ex.mechanism;
        if (mechanism && mechanism.handled === false) {
          crashed = true;
          break;
        }
      }
    }

    // A session is updated and that session update is sent in only one of the two following scenarios:
    // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
    // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
    const sessionNonTerminal = session.status === 'ok';
    const shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);

    if (shouldUpdateAndSend) {
      (0,esm_session/* updateSession */.CT)(session, {
        ...(crashed && { status: 'crashed' }),
        errors: session.errors || Number(errored || crashed),
      });
      this.captureSession(session);
    }
  }

  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
   _isClientDoneProcessing(timeout) {
    return new syncpromise/* SyncPromise */.cW(resolve => {
      let ticked = 0;
      const tick = 1;

      const interval = setInterval(() => {
        if (this._numProcessing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;
          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  }

  /** Determines whether this SDK is enabled and a transport is present. */
   _isEnabled() {
    return this.getOptions().enabled !== false && this._transport !== undefined;
  }

  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
   _prepareEvent(
    event,
    hint,
    scope,
    isolationScope = (0,esm_hub/* getIsolationScope */.aF)(),
  ) {
    const options = this.getOptions();
    const integrations = Object.keys(this._integrations);
    if (!hint.integrations && integrations.length > 0) {
      hint.integrations = integrations;
    }

    this.emit('preprocessEvent', event, hint);

    return (0,prepareEvent/* prepareEvent */.R)(options, event, hint, scope, this, isolationScope).then(evt => {
      if (evt === null) {
        return evt;
      }

      const propagationContext = {
        ...isolationScope.getPropagationContext(),
        ...(scope ? scope.getPropagationContext() : undefined),
      };

      const trace = evt.contexts && evt.contexts.trace;
      if (!trace && propagationContext) {
        const { traceId: trace_id, spanId, parentSpanId, dsc } = propagationContext;
        evt.contexts = {
          trace: {
            trace_id,
            span_id: spanId,
            parent_span_id: parentSpanId,
          },
          ...evt.contexts,
        };

        const dynamicSamplingContext = dsc ? dsc : (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromClient */._)(trace_id, this, scope);

        evt.sdkProcessingMetadata = {
          dynamicSamplingContext,
          ...evt.sdkProcessingMetadata,
        };
      }
      return evt;
    });
  }

  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
   _captureEvent(event, hint = {}, scope) {
    return this._processEvent(event, hint, scope).then(
      finalEvent => {
        return finalEvent.event_id;
      },
      reason => {
        if (debug_build/* DEBUG_BUILD */.X) {
          // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
          // control flow, log just the message (no stack) as a log-level log.
          const sentryError = reason ;
          if (sentryError.logLevel === 'log') {
            esm_logger/* logger.log */.kg.log(sentryError.message);
          } else {
            esm_logger/* logger.warn */.kg.warn(sentryError);
          }
        }
        return undefined;
      },
    );
  }

  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
   _processEvent(event, hint, scope) {
    const options = this.getOptions();
    const { sampleRate } = options;

    const isTransaction = isTransactionEvent(event);
    const isError = isErrorEvent(event);
    const eventType = event.type || 'error';
    const beforeSendLabel = `before send for type \`${eventType}\``;

    // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else
    if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
      this.recordDroppedEvent('sample_rate', 'error', event);
      return (0,syncpromise/* rejectedSyncPromise */.$2)(
        new SentryError(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`,
          'log',
        ),
      );
    }

    const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;

    const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
    const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;

    return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope)
      .then(prepared => {
        if (prepared === null) {
          this.recordDroppedEvent('event_processor', dataCategory, event);
          throw new SentryError('An event processor returned `null`, will not send event.', 'log');
        }

        const isInternalException = hint.data && (hint.data ).__sentry__ === true;
        if (isInternalException) {
          return prepared;
        }

        const result = processBeforeSend(options, prepared, hint);
        return _validateBeforeSendResult(result, beforeSendLabel);
      })
      .then(processedEvent => {
        if (processedEvent === null) {
          this.recordDroppedEvent('before_send', dataCategory, event);
          if (isTransaction) {
            const spans = event.spans || [];
            // the transaction itself counts as one span, plus all the child spans that are added
            const spanCount = 1 + spans.length;
            this.recordDroppedEvent('before_send', 'span', spanCount);
          }
          throw new SentryError(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
        }

        const session = scope && scope.getSession();
        if (!isTransaction && session) {
          this._updateSessionFromEvent(session, processedEvent);
        }

        if (isTransaction) {
          const spanCountBefore =
            (processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing) ||
            0;
          const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;

          const droppedSpanCount = spanCountBefore - spanCountAfter;
          if (droppedSpanCount > 0) {
            this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
          }
        }

        // None of the Sentry built event processor will update transaction name,
        // so if the transaction name has been changed by an event processor, we know
        // it has to come from custom event processor added by a user
        const transactionInfo = processedEvent.transaction_info;
        if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
          const source = 'custom';
          processedEvent.transaction_info = {
            ...transactionInfo,
            source,
          };
        }

        this.sendEvent(processedEvent, hint);
        return processedEvent;
      })
      .then(null, reason => {
        if (reason instanceof SentryError) {
          throw reason;
        }

        this.captureException(reason, {
          data: {
            __sentry__: true,
          },
          originalException: reason,
        });
        throw new SentryError(
          `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`,
        );
      });
  }

  /**
   * Occupies the client with processing and event
   */
   _process(promise) {
    this._numProcessing++;
    void promise.then(
      value => {
        this._numProcessing--;
        return value;
      },
      reason => {
        this._numProcessing--;
        return reason;
      },
    );
  }

  /**
   * @inheritdoc
   */
   _sendEnvelope(envelope) {
    this.emit('beforeEnvelope', envelope);

    if (this._isEnabled() && this._transport) {
      return this._transport.send(envelope).then(null, reason => {
        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.error */.kg.error('Error while sending event:', reason);
      });
    } else {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.error */.kg.error('Transport disabled');
    }
  }

  /**
   * Clears outcomes on this client and returns them.
   */
   _clearOutcomes() {
    const outcomes = this._outcomes;
    this._outcomes = {};
    return Object.keys(outcomes).map(key => {
      const [reason, category] = key.split(':') ;
      return {
        reason,
        category,
        quantity: outcomes[key],
      };
    });
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types

}

/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */
function _validateBeforeSendResult(
  beforeSendResult,
  beforeSendLabel,
) {
  const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
  if ((0,is/* isThenable */.J8)(beforeSendResult)) {
    return beforeSendResult.then(
      event => {
        if (!(0,is/* isPlainObject */.PO)(event) && event !== null) {
          throw new SentryError(invalidValueError);
        }
        return event;
      },
      e => {
        throw new SentryError(`${beforeSendLabel} rejected with ${e}`);
      },
    );
  } else if (!(0,is/* isPlainObject */.PO)(beforeSendResult) && beforeSendResult !== null) {
    throw new SentryError(invalidValueError);
  }
  return beforeSendResult;
}

/**
 * Process the matching `beforeSendXXX` callback.
 */
function processBeforeSend(
  options,
  event,
  hint,
) {
  const { beforeSend, beforeSendTransaction } = options;

  if (isErrorEvent(event) && beforeSend) {
    return beforeSend(event, hint);
  }

  if (isTransactionEvent(event) && beforeSendTransaction) {
    if (event.spans) {
      // We store the # of spans before processing in SDK metadata,
      // so we can compare it afterwards to determine how many spans were dropped
      const spanCountBefore = event.spans.length;
      event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        spanCountBeforeProcessing: spanCountBefore,
      };
    }
    return beforeSendTransaction(event, hint);
  }

  return event;
}

function isErrorEvent(event) {
  return event.type === undefined;
}

function isTransactionEvent(event) {
  return event.type === 'transaction';
}

/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */
function addEventProcessor(callback) {
  const client = getClient();

  if (!client || !client.addEventProcessor) {
    return;
  }

  client.addEventProcessor(callback);
}


//# sourceMappingURL=baseclient.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/utils/sdkMetadata.js


/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */
function applySdkMetadata(options, name, names = [name], source = 'npm') {
  const metadata = options._metadata || {};

  if (!metadata.sdk) {
    metadata.sdk = {
      name: `sentry.javascript.${name}`,
      packages: names.map(name => ({
        name: `${source}:@sentry/${name}`,
        version: version/* SDK_VERSION */.J,
      })),
      version: version/* SDK_VERSION */.J,
    };
  }

  options._metadata = metadata;
}


//# sourceMappingURL=sdkMetadata.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/env.js
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

/**
 * Get source of SDK.
 */
function getSDKSource() {
  // @ts-expect-error "npm" is injected by rollup during build process
  return "npm";
}


//# sourceMappingURL=env.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/time.js
var esm_time = __webpack_require__(7790);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/clientreport.js



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(
  discarded_events,
  dsn,
  timestamp,
) {
  const clientReportItem = [
    { type: 'client_report' },
    {
      timestamp: timestamp || (0,esm_time/* dateTimestampInSeconds */.yW)(),
      discarded_events,
    },
  ];
  return createEnvelope(dsn ? { dsn } : {}, [clientReportItem]);
}


//# sourceMappingURL=clientreport.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/debug-build.js
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const debug_build_DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);


//# sourceMappingURL=debug-build.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/eventbuilder.js



/**
 * This function creates an exception from a JavaScript Error
 */
function exceptionFromError(stackParser, ex) {
  // Get the frames first since Opera can lose the stack if we touch anything else first
  const frames = parseStackFrames(stackParser, ex);

  const exception = {
    type: ex && ex.name,
    value: extractMessage(ex),
  };

  if (frames.length) {
    exception.stacktrace = { frames };
  }

  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }

  return exception;
}

/**
 * @hidden
 */
function eventFromPlainObject(
  stackParser,
  exception,
  syntheticException,
  isUnhandledRejection,
) {
  const client = (0,esm_exports/* getClient */.s3)();
  const normalizeDepth = client && client.getOptions().normalizeDepth;

  const event = {
    exception: {
      values: [
        {
          type: (0,is/* isEvent */.cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
          value: getNonErrorObjectExceptionValue(exception, { isUnhandledRejection }),
        },
      ],
    },
    extra: {
      __serialized__: (0,normalize/* normalizeToSize */.Qy)(exception, normalizeDepth),
    },
  };

  if (syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      // event.exception.values[0] has been set above
      (event.exception ).values[0].stacktrace = { frames };
    }
  }

  return event;
}

/**
 * @hidden
 */
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)],
    },
  };
}

/** Parses stack frames from an error */
function parseStackFrames(
  stackParser,
  ex,
) {
  // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.
  const stacktrace = ex.stacktrace || ex.stack || '';

  const popSize = getPopSize(ex);

  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
    // no-empty
  }

  return [];
}

// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const reactMinifiedRegexp = /Minified React error #\d+;/i;

function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === 'number') {
      return ex.framesToPop;
    }

    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }

  return 0;
}

/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
  const message = ex && ex.message;
  if (!message) {
    return 'No error message';
  }
  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }
  return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(
  stackParser,
  exception,
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  (0,misc/* addExceptionMechanism */.EG)(event); // defaults to { type: 'generic', handled: true }
  event.level = 'error';
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(
  stackParser,
  message,
  // eslint-disable-next-line deprecation/deprecation
  level = 'info',
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * @hidden
 */
function eventFromUnknownInput(
  stackParser,
  exception,
  syntheticException,
  attachStacktrace,
  isUnhandledRejection,
) {
  let event;

  if ((0,is/* isErrorEvent */.VW)(exception ) && (exception ).error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    const errorEvent = exception ;
    return eventFromError(stackParser, errorEvent.error );
  }

  // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
  // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
  // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
  //
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness
  if ((0,is/* isDOMError */.TX)(exception) || (0,is/* isDOMException */.fm)(exception )) {
    const domException = exception ;

    if ('stack' in (exception )) {
      event = eventFromError(stackParser, exception );
    } else {
      const name = domException.name || ((0,is/* isDOMError */.TX)(domException) ? 'DOMError' : 'DOMException');
      const message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      (0,misc/* addExceptionTypeValue */.Db)(event, message);
    }
    if ('code' in domException) {
      // eslint-disable-next-line deprecation/deprecation
      event.tags = { ...event.tags, 'DOMException.code': `${domException.code}` };
    }

    return event;
  }
  if ((0,is/* isError */.VZ)(exception)) {
    // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
  }
  if ((0,is/* isPlainObject */.PO)(exception) || (0,is/* isEvent */.cO)(exception)) {
    // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
    // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
    // group on any key/value change.
    const objectException = exception ;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    (0,misc/* addExceptionMechanism */.EG)(event, {
      synthetic: true,
    });
    return event;
  }

  // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:
  event = eventFromString(stackParser, exception , syntheticException, attachStacktrace);
  (0,misc/* addExceptionTypeValue */.Db)(event, `${exception}`, undefined);
  (0,misc/* addExceptionMechanism */.EG)(event, {
    synthetic: true,
  });

  return event;
}

/**
 * @hidden
 */
function eventFromString(
  stackParser,
  message,
  syntheticException,
  attachStacktrace,
) {
  const event = {};

  if (attachStacktrace && syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: message, stacktrace: { frames } }],
      };
    }
  }

  if ((0,is/* isParameterizedString */.Le)(message)) {
    const { __sentry_template_string__, __sentry_template_values__ } = message;

    event.logentry = {
      message: __sentry_template_string__,
      params: __sentry_template_values__,
    };
    return event;
  }

  event.message = message;
  return event;
}

function getNonErrorObjectExceptionValue(
  exception,
  { isUnhandledRejection },
) {
  const keys = (0,object/* extractExceptionKeysForMessage */.zf)(exception);
  const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';

  // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
  // We still want to try to get a decent message for these cases
  if ((0,is/* isErrorEvent */.VW)(exception)) {
    return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
  }

  if ((0,is/* isEvent */.cO)(exception)) {
    const className = getObjectClassName(exception);
    return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
  }

  return `Object captured as ${captureType} with keys: ${keys}`;
}

function getObjectClassName(obj) {
  try {
    const prototype = Object.getPrototypeOf(obj);
    return prototype ? prototype.constructor.name : undefined;
  } catch (e) {
    // ignore errors here
  }
}


//# sourceMappingURL=eventbuilder.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/helpers.js




const helpers_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

let ignoreOnError = 0;

/**
 * @hidden
 */
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}

/**
 * @hidden
 */
function ignoreNextOnError() {
  // onerror should trigger before setTimeout
  ignoreOnError++;
  setTimeout(() => {
    ignoreOnError--;
  });
}

/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(
  fn,
  options

 = {},
  before,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // for future readers what this does is wrap a function and then create
  // a bi-directional wrapping between them.
  //
  // example: wrapped = wrap(original);
  //  original.__sentry_wrapped__ -> wrapped
  //  wrapped.__sentry_original__ -> original

  if (typeof fn !== 'function') {
    return fn;
  }

  try {
    // if we're dealing with a function that was previously wrapped, return
    // the original wrapper.
    const wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      if (typeof wrapper === 'function') {
        return wrapper;
      } else {
        // If we find that the `__sentry_wrapped__` function is not a function at the time of accessing it, it means
        // that something messed with it. In that case we want to return the originally passed function.
        return fn;
      }
    }

    // We don't wanna wrap it twice
    if ((0,object/* getOriginalFunction */.HK)(fn)) {
      return fn;
    }
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    // Bail on wrapping and return the function as-is (defers to window.onerror).
    return fn;
  }

  /* eslint-disable prefer-rest-params */
  // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
  const sentryWrapped = function () {
    const args = Array.prototype.slice.call(arguments);

    try {
      if (before && typeof before === 'function') {
        before.apply(this, arguments);
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      const wrappedArguments = args.map((arg) => wrap(arg, options));

      // Attempt to invoke user-land function
      // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
      //       means the sentry.javascript SDK caught an error invoking your application code. This
      //       is expected behavior and NOT indicative of a bug with sentry.javascript.
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();

      (0,esm_exports/* withScope */.$e)(scope => {
        scope.addEventProcessor(event => {
          if (options.mechanism) {
            (0,misc/* addExceptionTypeValue */.Db)(event, undefined, undefined);
            (0,misc/* addExceptionMechanism */.EG)(event, options.mechanism);
          }

          event.extra = {
            ...event.extra,
            arguments: args,
          };

          return event;
        });

        (0,esm_exports/* captureException */.Tb)(ex);
      });

      throw ex;
    }
  };
  /* eslint-enable prefer-rest-params */

  // Accessing some objects may throw
  // ref: https://github.com/getsentry/sentry-javascript/issues/1168
  try {
    for (const property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (_oO) {} // eslint-disable-line no-empty

  // Signal that this function has been wrapped/filled already
  // for both debugging and to prevent it to being wrapped/filled twice
  (0,object/* markFunctionWrapped */.$Q)(sentryWrapped, fn);

  (0,object/* addNonEnumerableProperty */.xp)(fn, '__sentry_wrapped__', sentryWrapped);

  // Restore original function name (not all browsers allow that)
  try {
    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name') ;
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, 'name', {
        get() {
          return fn.name;
        },
      });
    }
    // eslint-disable-next-line no-empty
  } catch (_oO) {}

  return sentryWrapped;
}


//# sourceMappingURL=helpers.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/userfeedback.js


/**
 * Creates an envelope from a user feedback.
 */
function createUserFeedbackEnvelope(
  feedback,
  {
    metadata,
    tunnel,
    dsn,
  }

,
) {
  const headers = {
    event_id: feedback.event_id,
    sent_at: new Date().toISOString(),
    ...(metadata &&
      metadata.sdk && {
        sdk: {
          name: metadata.sdk.name,
          version: metadata.sdk.version,
        },
      }),
    ...(!!tunnel && !!dsn && { dsn: dsn_dsnToString(dsn) }),
  };
  const item = createUserFeedbackEnvelopeItem(feedback);

  return createEnvelope(headers, [item]);
}

function createUserFeedbackEnvelopeItem(feedback) {
  const feedbackHeaders = {
    type: 'user_report',
  };
  return [feedbackHeaders, feedback];
}


//# sourceMappingURL=userfeedback.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/client.js







/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends BaseClient {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
   constructor(options) {
    const sdkSource = helpers_WINDOW.SENTRY_SDK_SOURCE || getSDKSource();
    applySdkMetadata(options, 'browser', ['browser'], sdkSource);

    super(options);

    if (options.sendClientReports && helpers_WINDOW.document) {
      helpers_WINDOW.document.addEventListener('visibilitychange', () => {
        if (helpers_WINDOW.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }

  /**
   * @inheritDoc
   */
   eventFromException(exception, hint) {
    return eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   eventFromMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level = 'info',
    hint,
  ) {
    return eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }

  /**
   * Sends user feedback to Sentry.
   */
   captureUserFeedback(feedback) {
    if (!this._isEnabled()) {
      debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('SDK not enabled, will not capture user feedback.');
      return;
    }

    const envelope = createUserFeedbackEnvelope(feedback, {
      metadata: this.getSdkMetadata(),
      dsn: this.getDsn(),
      tunnel: this.getOptions().tunnel,
    });

    // _sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this._sendEnvelope(envelope);
  }

  /**
   * @inheritDoc
   */
   _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }

  /**
   * Sends client reports as an envelope.
   */
   _flushOutcomes() {
    const outcomes = this._clearOutcomes();

    if (outcomes.length === 0) {
      debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('No outcomes to send');
      return;
    }

    // This is really the only place where we want to check for a DSN and only send outcomes then
    if (!this._dsn) {
      debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('No dsn provided, will not send outcomes');
      return;
    }

    debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('Sending outcomes:', outcomes);

    const envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsn_dsnToString(this._dsn));

    // _sendEnvelope should not throw
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    this._sendEnvelope(envelope);
  }
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/instrument/console.js





/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addConsoleInstrumentationHandler(handler) {
  const type = 'console';
  addHandler(type, handler);
  maybeInstrument(type, instrumentConsole);
}

function instrumentConsole() {
  if (!("console" in worldwide/* GLOBAL_OBJ */.n2)) {
    return;
  }

  esm_logger/* CONSOLE_LEVELS.forEach */.RU.forEach(function (level) {
    if (!(level in worldwide/* GLOBAL_OBJ.console */.n2.console)) {
      return;
    }

    (0,object/* fill */.hl)(worldwide/* GLOBAL_OBJ.console */.n2.console, level, function (originalConsoleMethod) {
      esm_logger/* originalConsoleMethods */.LD[level] = originalConsoleMethod;

      return function (...args) {
        const handlerData = { args, level };
        triggerHandlers('console', handlerData);

        const log = esm_logger/* originalConsoleMethods */.LD[level];
        log && log.apply(worldwide/* GLOBAL_OBJ.console */.n2.console, args);
      };
    });
  });
}


//# sourceMappingURL=console.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/instrument/dom.js





const dom_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;
const DEBOUNCE_DURATION = 1000;

let debounceTimerID;
let lastCapturedEventType;
let lastCapturedEventTargetId;

/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addClickKeypressInstrumentationHandler(handler) {
  const type = 'dom';
  addHandler(type, handler);
  maybeInstrument(type, instrumentDOM);
}

/** Exported for tests only. */
function instrumentDOM() {
  if (!dom_WINDOW.document) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  const triggerDOMHandler = triggerHandlers.bind(null, 'dom');
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  dom_WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
  dom_WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach((target) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = (dom_WINDOW )[target] && (dom_WINDOW )[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }

    (0,object/* fill */.hl)(proto, 'addEventListener', function (originalAddEventListener) {
      return function (

        type,
        listener,
        options,
      ) {
        if (type === 'click' || type == 'keypress') {
          try {
            const el = this ;
            const handlers = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
            const handlerForType = (handlers[type] = handlers[type] || { refCount: 0 });

            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }

            handlerForType.refCount++;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    });

    (0,object/* fill */.hl)(
      proto,
      'removeEventListener',
      function (originalRemoveEventListener) {
        return function (

          type,
          listener,
          options,
        ) {
          if (type === 'click' || type == 'keypress') {
            try {
              const el = this ;
              const handlers = el.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers[type];

              if (handlerForType) {
                handlerForType.refCount--;
                // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = undefined;
                  delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                }

                // If there are no longer any custom handlers of any type on this element, cleanup everything.
                if (Object.keys(handlers).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
              // Accessing dom properties is always fragile.
              // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
            }
          }

          return originalRemoveEventListener.call(this, type, listener, options);
        };
      },
    );
  });
}

/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */
function isSimilarToLastCapturedEvent(event) {
  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (event.type !== lastCapturedEventType) {
    return false;
  }

  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (!event.target || (event.target )._sentryId !== lastCapturedEventTargetId) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return true;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(eventType, target) {
  // We are only interested in filtering `keypress` events for now.
  if (eventType !== 'keypress') {
    return false;
  }

  if (!target || !target.tagName) {
    return true;
  }

  // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
  // e.g.tabbing through elements, hotkeys, etc.
  if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
    return false;
  }

  return true;
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 */
function makeDOMEventHandler(
  handler,
  globalListener = false,
) {
  return (event) => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || event['_sentryCaptured']) {
      return;
    }

    const target = getEventTarget(event);

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event.type, target)) {
      return;
    }

    // Mark event as "seen"
    (0,object/* addNonEnumerableProperty */.xp)(event, '_sentryCaptured', true);

    if (target && !target._sentryId) {
      // Add UUID to event target so we can identify if
      (0,object/* addNonEnumerableProperty */.xp)(target, '_sentryId', (0,misc/* uuid4 */.DM)());
    }

    const name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
    // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    if (!isSimilarToLastCapturedEvent(event)) {
      const handlerData = { event, name, global: globalListener };
      handler(handlerData);
      lastCapturedEventType = event.type;
      lastCapturedEventTargetId = target ? target._sentryId : undefined;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = dom_WINDOW.setTimeout(() => {
      lastCapturedEventTargetId = undefined;
      lastCapturedEventType = undefined;
    }, DEBOUNCE_DURATION);
  };
}

function getEventTarget(event) {
  try {
    return event.target ;
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    return null;
  }
}


//# sourceMappingURL=dom.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/instrument/xhr.js





const xhr_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

const SENTRY_XHR_DATA_KEY = '__sentry_xhr_v3__';

/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addXhrInstrumentationHandler(handler) {
  const type = 'xhr';
  addHandler(type, handler);
  maybeInstrument(type, instrumentXHR);
}

/** Exported only for tests. */
function instrumentXHR() {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (!(xhr_WINDOW ).XMLHttpRequest) {
    return;
  }

  const xhrproto = XMLHttpRequest.prototype;

  (0,object/* fill */.hl)(xhrproto, 'open', function (originalOpen) {
    return function ( ...args) {
      const startTimestamp = Date.now();

      // open() should always be called with two or more arguments
      // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
      const method = (0,is/* isString */.HD)(args[0]) ? args[0].toUpperCase() : undefined;
      const url = parseUrl(args[1]);

      if (!method || !url) {
        return originalOpen.apply(this, args);
      }

      this[SENTRY_XHR_DATA_KEY] = {
        method,
        url,
        request_headers: {},
      };

      // if Sentry key appears in URL, don't capture it as a request
      if (method === 'POST' && url.match(/sentry_key/)) {
        this.__sentry_own_request__ = true;
      }

      const onreadystatechangeHandler = () => {
        // For whatever reason, this is not the same instance here as from the outer method
        const xhrInfo = this[SENTRY_XHR_DATA_KEY];

        if (!xhrInfo) {
          return;
        }

        if (this.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = this.status;
          } catch (e) {
            /* do nothing */
          }

          const handlerData = {
            args: [method, url],
            endTimestamp: Date.now(),
            startTimestamp,
            xhr: this,
          };
          triggerHandlers('xhr', handlerData);
        }
      };

      if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') {
        (0,object/* fill */.hl)(this, 'onreadystatechange', function (original) {
          return function ( ...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(this, readyStateArgs);
          };
        });
      } else {
        this.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      // Intercepting `setRequestHeader` to access the request headers of XHR instance.
      // This will only work for user/library defined headers, not for the default/browser-assigned headers.
      // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
      (0,object/* fill */.hl)(this, 'setRequestHeader', function (original) {
        return function ( ...setRequestHeaderArgs) {
          const [header, value] = setRequestHeaderArgs;

          const xhrInfo = this[SENTRY_XHR_DATA_KEY];

          if (xhrInfo && (0,is/* isString */.HD)(header) && (0,is/* isString */.HD)(value)) {
            xhrInfo.request_headers[header.toLowerCase()] = value;
          }

          return original.apply(this, setRequestHeaderArgs);
        };
      });

      return originalOpen.apply(this, args);
    };
  });

  (0,object/* fill */.hl)(xhrproto, 'send', function (originalSend) {
    return function ( ...args) {
      const sentryXhrData = this[SENTRY_XHR_DATA_KEY];

      if (!sentryXhrData) {
        return originalSend.apply(this, args);
      }

      if (args[0] !== undefined) {
        sentryXhrData.body = args[0];
      }

      const handlerData = {
        args: [sentryXhrData.method, sentryXhrData.url],
        startTimestamp: Date.now(),
        xhr: this,
      };
      triggerHandlers('xhr', handlerData);

      return originalSend.apply(this, args);
    };
  });
}

function parseUrl(url) {
  if ((0,is/* isString */.HD)(url)) {
    return url;
  }

  try {
    // url can be a string or URL
    // but since URL is not available in IE11, we do not check for it,
    // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
    // If that fails, we just return undefined
    return (url ).toString();
  } catch (e2) {} // eslint-disable-line no-empty

  return undefined;
}


//# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/instrument/fetch.js





/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addFetchInstrumentationHandler(handler) {
  const type = 'fetch';
  addHandler(type, handler);
  maybeInstrument(type, instrumentFetch);
}

function instrumentFetch() {
  if (!supportsNativeFetch()) {
    return;
  }

  (0,object/* fill */.hl)(worldwide/* GLOBAL_OBJ */.n2, 'fetch', function (originalFetch) {
    return function (...args) {
      const { method, url } = parseFetchArgs(args);

      const handlerData = {
        args,
        fetchData: {
          method,
          url,
        },
        startTimestamp: Date.now(),
      };

      triggerHandlers('fetch', {
        ...handlerData,
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return originalFetch.apply(worldwide/* GLOBAL_OBJ */.n2, args).then(
        (response) => {
          const finishedHandlerData = {
            ...handlerData,
            endTimestamp: Date.now(),
            response,
          };

          triggerHandlers('fetch', finishedHandlerData);
          return response;
        },
        (error) => {
          const erroredHandlerData = {
            ...handlerData,
            endTimestamp: Date.now(),
            error,
          };

          triggerHandlers('fetch', erroredHandlerData);
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the sentry.javascript SDK caught an error invoking your application code.
          //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
          throw error;
        },
      );
    };
  });
}

function hasProp(obj, prop) {
  return !!obj && typeof obj === 'object' && !!(obj )[prop];
}

function getUrlFromResource(resource) {
  if (typeof resource === 'string') {
    return resource;
  }

  if (!resource) {
    return '';
  }

  if (hasProp(resource, 'url')) {
    return resource.url;
  }

  if (resource.toString) {
    return resource.toString();
  }

  return '';
}

/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */
function parseFetchArgs(fetchArgs) {
  if (fetchArgs.length === 0) {
    return { method: 'GET', url: '' };
  }

  if (fetchArgs.length === 2) {
    const [url, options] = fetchArgs ;

    return {
      url: getUrlFromResource(url),
      method: hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET',
    };
  }

  const arg = fetchArgs[0];
  return {
    url: getUrlFromResource(arg ),
    method: hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET',
  };
}


//# sourceMappingURL=fetch.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(54194);
;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/severity.js
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.

const validSeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug'];

/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
  return severityLevelFromString(level) ;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */
function severityLevelFromString(level) {
  return (level === 'warn' ? 'warning' : validSeverityLevels.includes(level) ? level : 'log') ;
}


//# sourceMappingURL=severity.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/url.js
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function url_parseUrl(url) {
  if (!url) {
    return {};
  }

  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  const query = match[6] || '';
  const fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    search: query,
    hash: fragment,
    relative: match[5] + query + fragment, // everything minus origin
  };
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
  // eslint-disable-next-line no-useless-escape
  return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Returns number of URL segments of a passed string URL.
 */
function getNumberOfUrlSegments(url) {
  // split at '/' or at '\/' to split regex urls correctly
  return url.split(/\\?\//).filter(s => s.length > 0 && s !== ',').length;
}

/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */
function getSanitizedUrlString(url) {
  const { protocol, host, path } = url;

  const filteredHost =
    (host &&
      host
        // Always filter out authority
        .replace(/^.*@/, '[filtered]:[filtered]@')
        // Don't show standard :80 (http) and :443 (https) ports to reduce the noise
        // TODO: Use new URL global if it exists
        .replace(/(:80)$/, '')
        .replace(/(:443)$/, '')) ||
    '';

  return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}


//# sourceMappingURL=url.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/breadcrumbs.js





/* eslint-disable max-lines */

/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */
const MAX_ALLOWED_STRING_LENGTH = 1024;

const breadcrumbs_INTEGRATION_NAME = 'Breadcrumbs';

const _breadcrumbsIntegration = ((options = {}) => {
  const _options = {
    console: true,
    dom: true,
    fetch: true,
    history: true,
    sentry: true,
    xhr: true,
    ...options,
  };

  return {
    name: breadcrumbs_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    setup(client) {
      if (_options.console) {
        addConsoleInstrumentationHandler(_getConsoleBreadcrumbHandler(client));
      }
      if (_options.dom) {
        addClickKeypressInstrumentationHandler(_getDomBreadcrumbHandler(client, _options.dom));
      }
      if (_options.xhr) {
        addXhrInstrumentationHandler(_getXhrBreadcrumbHandler(client));
      }
      if (_options.fetch) {
        addFetchInstrumentationHandler(_getFetchBreadcrumbHandler(client));
      }
      if (_options.history) {
        addHistoryInstrumentationHandler(_getHistoryBreadcrumbHandler(client));
      }
      if (_options.sentry && client.on) {
        client.on('beforeSendEvent', _getSentryBreadcrumbHandler(client));
      }
    },
  };
}) ;

const breadcrumbsIntegration = defineIntegration(_breadcrumbsIntegration);

/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const Breadcrumbs = convertIntegrationFnToClass(breadcrumbs_INTEGRATION_NAME, breadcrumbsIntegration)

;

/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */
function _getSentryBreadcrumbHandler(client) {
  return function addSentryBreadcrumb(event) {
    if ((0,esm_exports/* getClient */.s3)() !== client) {
      return;
    }

    (0,esm_exports/* addBreadcrumb */.n_)(
      {
        category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
        event_id: event.event_id,
        level: event.level,
        message: (0,misc/* getEventDescription */.jH)(event),
      },
      {
        event,
      },
    );
  };
}

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
function _getDomBreadcrumbHandler(
  client,
  dom,
) {
  return function _innerDomBreadcrumb(handlerData) {
    if ((0,esm_exports/* getClient */.s3)() !== client) {
      return;
    }

    let target;
    let componentName;
    let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;

    let maxStringLength =
      typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
      debug_build_DEBUG_BUILD &&
        esm_logger/* logger.warn */.kg.warn(
          `\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`,
        );
      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
    }

    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    }

    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
      const event = handlerData.event ;
      const element = _isEvent(event) ? event.target : event;

      target = (0,browser/* htmlTreeAsString */.Rt)(element, { keyAttrs, maxStringLength });
      componentName = (0,browser/* getComponentName */.iY)(element);
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    const breadcrumb = {
      category: `ui.${handlerData.name}`,
      message: target,
    };

    if (componentName) {
      breadcrumb.data = { 'ui.component_name': componentName };
    }

    (0,esm_exports/* addBreadcrumb */.n_)(breadcrumb, {
      event: handlerData.event,
      name: handlerData.name,
      global: handlerData.global,
    });
  };
}

/**
 * Creates breadcrumbs from console API calls
 */
function _getConsoleBreadcrumbHandler(client) {
  return function _consoleBreadcrumb(handlerData) {
    if ((0,esm_exports/* getClient */.s3)() !== client) {
      return;
    }

    const breadcrumb = {
      category: 'console',
      data: {
        arguments: handlerData.args,
        logger: 'console',
      },
      level: severityLevelFromString(handlerData.level),
      message: (0,string/* safeJoin */.nK)(handlerData.args, ' '),
    };

    if (handlerData.level === 'assert') {
      if (handlerData.args[0] === false) {
        breadcrumb.message = `Assertion failed: ${(0,string/* safeJoin */.nK)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
        breadcrumb.data.arguments = handlerData.args.slice(1);
      } else {
        // Don't capture a breadcrumb for passed assertions
        return;
      }
    }

    (0,esm_exports/* addBreadcrumb */.n_)(breadcrumb, {
      input: handlerData.args,
      level: handlerData.level,
    });
  };
}

/**
 * Creates breadcrumbs from XHR API calls
 */
function _getXhrBreadcrumbHandler(client) {
  return function _xhrBreadcrumb(handlerData) {
    if ((0,esm_exports/* getClient */.s3)() !== client) {
      return;
    }

    const { startTimestamp, endTimestamp } = handlerData;

    const sentryXhrData = handlerData.xhr[SENTRY_XHR_DATA_KEY];

    // We only capture complete, non-sentry requests
    if (!startTimestamp || !endTimestamp || !sentryXhrData) {
      return;
    }

    const { method, url, status_code, body } = sentryXhrData;

    const data = {
      method,
      url,
      status_code,
    };

    const hint = {
      xhr: handlerData.xhr,
      input: body,
      startTimestamp,
      endTimestamp,
    };

    (0,esm_exports/* addBreadcrumb */.n_)(
      {
        category: 'xhr',
        data,
        type: 'http',
      },
      hint,
    );
  };
}

/**
 * Creates breadcrumbs from fetch API calls
 */
function _getFetchBreadcrumbHandler(client) {
  return function _fetchBreadcrumb(handlerData) {
    if ((0,esm_exports/* getClient */.s3)() !== client) {
      return;
    }

    const { startTimestamp, endTimestamp } = handlerData;

    // We only capture complete fetch requests
    if (!endTimestamp) {
      return;
    }

    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
      // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
      return;
    }

    if (handlerData.error) {
      const data = handlerData.fetchData;
      const hint = {
        data: handlerData.error,
        input: handlerData.args,
        startTimestamp,
        endTimestamp,
      };

      (0,esm_exports/* addBreadcrumb */.n_)(
        {
          category: 'fetch',
          data,
          level: 'error',
          type: 'http',
        },
        hint,
      );
    } else {
      const response = handlerData.response ;
      const data = {
        ...handlerData.fetchData,
        status_code: response && response.status,
      };
      const hint = {
        input: handlerData.args,
        response,
        startTimestamp,
        endTimestamp,
      };
      (0,esm_exports/* addBreadcrumb */.n_)(
        {
          category: 'fetch',
          data,
          type: 'http',
        },
        hint,
      );
    }
  };
}

/**
 * Creates breadcrumbs from history API calls
 */
function _getHistoryBreadcrumbHandler(client) {
  return function _historyBreadcrumb(handlerData) {
    if ((0,esm_exports/* getClient */.s3)() !== client) {
      return;
    }

    let from = handlerData.from;
    let to = handlerData.to;
    const parsedLoc = url_parseUrl(helpers_WINDOW.location.href);
    let parsedFrom = from ? url_parseUrl(from) : undefined;
    const parsedTo = url_parseUrl(to);

    // Initial pushState doesn't provide `from` information
    if (!parsedFrom || !parsedFrom.path) {
      parsedFrom = parsedLoc;
    }

    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
      to = parsedTo.relative;
    }
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
      from = parsedFrom.relative;
    }

    (0,esm_exports/* addBreadcrumb */.n_)({
      category: 'navigation',
      data: {
        from,
        to,
      },
    });
  };
}

function _isEvent(event) {
  return !!event && !!(event ).target;
}


//# sourceMappingURL=breadcrumbs.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/dedupe.js




const dedupe_INTEGRATION_NAME = 'Dedupe';

const _dedupeIntegration = (() => {
  let previousEvent;

  return {
    name: dedupe_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    processEvent(currentEvent) {
      // We want to ignore any non-error type events, e.g. transactions or replays
      // These should never be deduped, and also not be compared against as _previousEvent.
      if (currentEvent.type) {
        return currentEvent;
      }

      // Juuust in case something goes wrong
      try {
        if (dedupe_shouldDropEvent(currentEvent, previousEvent)) {
          debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('Event dropped due to being a duplicate of previously captured event.');
          return null;
        }
      } catch (_oO) {} // eslint-disable-line no-empty

      return (previousEvent = currentEvent);
    },
  };
}) ;

const dedupeIntegration = defineIntegration(_dedupeIntegration);

/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const Dedupe = convertIntegrationFnToClass(dedupe_INTEGRATION_NAME, dedupeIntegration)

;

function dedupe_shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }

  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }

  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }

  return false;
}

function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
    return false;
  }

  if (currentMessage !== previousMessage) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);

  if (!previousException || !currentException) {
    return false;
  }

  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
    return false;
  }

  currentFrames = currentFrames ;
  previousFrames = previousFrames ;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    const frameA = previousFrames[i];
    const frameB = currentFrames[i];

    if (
      frameA.filename !== frameB.filename ||
      frameA.lineno !== frameB.lineno ||
      frameA.colno !== frameB.colno ||
      frameA.function !== frameB.function
    ) {
      return false;
    }
  }

  return true;
}

function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
    return false;
  }

  currentFingerprint = currentFingerprint ;
  previousFingerprint = previousFingerprint ;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}

function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

function _getFramesFromEvent(event) {
  const exception = event.exception;

  if (exception) {
    try {
      // @ts-expect-error Object could be undefined
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


//# sourceMappingURL=dedupe.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/instrument/globalError.js



let _oldOnErrorHandler = null;

/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addGlobalErrorInstrumentationHandler(handler) {
  const type = 'error';
  addHandler(type, handler);
  maybeInstrument(type, instrumentError);
}

function instrumentError() {
  _oldOnErrorHandler = worldwide/* GLOBAL_OBJ.onerror */.n2.onerror;

  worldwide/* GLOBAL_OBJ.onerror */.n2.onerror = function (
    msg,
    url,
    line,
    column,
    error,
  ) {
    const handlerData = {
      column,
      error,
      line,
      msg,
      url,
    };
    triggerHandlers('error', handlerData);

    if (_oldOnErrorHandler && !_oldOnErrorHandler.__SENTRY_LOADER__) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };

  worldwide/* GLOBAL_OBJ.onerror.__SENTRY_INSTRUMENTED__ */.n2.onerror.__SENTRY_INSTRUMENTED__ = true;
}


//# sourceMappingURL=globalError.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/instrument/globalUnhandledRejection.js



let _oldOnUnhandledRejectionHandler = null;

/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addGlobalUnhandledRejectionInstrumentationHandler(
  handler,
) {
  const type = 'unhandledrejection';
  addHandler(type, handler);
  maybeInstrument(type, instrumentUnhandledRejection);
}

function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = worldwide/* GLOBAL_OBJ.onunhandledrejection */.n2.onunhandledrejection;

  worldwide/* GLOBAL_OBJ.onunhandledrejection */.n2.onunhandledrejection = function (e) {
    const handlerData = e;
    triggerHandlers('unhandledrejection', handlerData);

    if (_oldOnUnhandledRejectionHandler && !_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };

  worldwide/* GLOBAL_OBJ.onunhandledrejection.__SENTRY_INSTRUMENTED__ */.n2.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}


//# sourceMappingURL=globalUnhandledRejection.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/globalhandlers.js






/* eslint-disable @typescript-eslint/no-unsafe-member-access */

const globalhandlers_INTEGRATION_NAME = 'GlobalHandlers';

const _globalHandlersIntegration = ((options = {}) => {
  const _options = {
    onerror: true,
    onunhandledrejection: true,
    ...options,
  };

  return {
    name: globalhandlers_INTEGRATION_NAME,
    setupOnce() {
      Error.stackTraceLimit = 50;
    },
    setup(client) {
      if (_options.onerror) {
        _installGlobalOnErrorHandler(client);
        globalHandlerLog('onerror');
      }
      if (_options.onunhandledrejection) {
        _installGlobalOnUnhandledRejectionHandler(client);
        globalHandlerLog('onunhandledrejection');
      }
    },
  };
}) ;

const globalHandlersIntegration = defineIntegration(_globalHandlersIntegration);

/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const GlobalHandlers = convertIntegrationFnToClass(
  globalhandlers_INTEGRATION_NAME,
  globalHandlersIntegration,
)

;

function _installGlobalOnErrorHandler(client) {
  addGlobalErrorInstrumentationHandler(data => {
    const { stackParser, attachStacktrace } = getOptions();

    if ((0,esm_exports/* getClient */.s3)() !== client || shouldIgnoreOnError()) {
      return;
    }

    const { msg, url, line, column, error } = data;

    const event =
      error === undefined && (0,is/* isString */.HD)(msg)
        ? _eventFromIncompleteOnError(msg, url, line, column)
        : _enhanceEventWithInitialFrame(
            eventFromUnknownInput(stackParser, error || msg, undefined, attachStacktrace, false),
            url,
            line,
            column,
          );

    event.level = 'error';

    (0,esm_exports/* captureEvent */.eN)(event, {
      originalException: error,
      mechanism: {
        handled: false,
        type: 'onerror',
      },
    });
  });
}

function _installGlobalOnUnhandledRejectionHandler(client) {
  addGlobalUnhandledRejectionInstrumentationHandler(e => {
    const { stackParser, attachStacktrace } = getOptions();

    if ((0,esm_exports/* getClient */.s3)() !== client || shouldIgnoreOnError()) {
      return;
    }

    const error = _getUnhandledRejectionError(e );

    const event = (0,is/* isPrimitive */.pt)(error)
      ? _eventFromRejectionWithPrimitive(error)
      : eventFromUnknownInput(stackParser, error, undefined, attachStacktrace, true);

    event.level = 'error';

    (0,esm_exports/* captureEvent */.eN)(event, {
      originalException: error,
      mechanism: {
        handled: false,
        type: 'onunhandledrejection',
      },
    });
  });
}

function _getUnhandledRejectionError(error) {
  if ((0,is/* isPrimitive */.pt)(error)) {
    return error;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const e = error ;

  // dig the object of the rejection out of known event types
  try {
    // PromiseRejectionEvents store the object of the rejection under 'reason'
    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
    if ('reason' in e) {
      return e.reason;
    }

    // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
    // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
    // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
    // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
    // https://github.com/getsentry/sentry-javascript/issues/2380
    else if ('detail' in e && 'reason' in e.detail) {
      return e.detail.reason;
    }
  } catch (e2) {} // eslint-disable-line no-empty

  return error;
}

/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: 'UnhandledRejection',
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`,
        },
      ],
    },
  };
}

/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
  const ERROR_TYPES_RE =
    /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;

  // If 'message' is ErrorEvent, get real message from inside
  let message = (0,is/* isErrorEvent */.VW)(msg) ? msg.message : msg;
  let name = 'Error';

  const groups = message.match(ERROR_TYPES_RE);
  if (groups) {
    name = groups[1];
    message = groups[2];
  }

  const event = {
    exception: {
      values: [
        {
          type: name,
          value: message,
        },
      ],
    },
  };

  return _enhanceEventWithInitialFrame(event, url, line, column);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  const e = (event.exception = event.exception || {});
  // event.exception.values
  const ev = (e.values = e.values || []);
  // event.exception.values[0]
  const ev0 = (ev[0] = ev[0] || {});
  // event.exception.values[0].stacktrace
  const ev0s = (ev0.stacktrace = ev0.stacktrace || {});
  // event.exception.values[0].stacktrace.frames
  const ev0sf = (ev0s.frames = ev0s.frames || []);

  const colno = isNaN(parseInt(column, 10)) ? undefined : column;
  const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
  const filename = (0,is/* isString */.HD)(url) && url.length > 0 ? url : (0,browser/* getLocationHref */.l4)();

  // event.exception.values[0].stacktrace.frames
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: '?',
      in_app: true,
      lineno,
    });
  }

  return event;
}

function globalHandlerLog(type) {
  debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log(`Global Handler attached: ${type}`);
}

function getOptions() {
  const client = (0,esm_exports/* getClient */.s3)();
  const options = (client && client.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: false,
  };
  return options;
}


//# sourceMappingURL=globalhandlers.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/httpcontext.js



const httpcontext_INTEGRATION_NAME = 'HttpContext';

const _httpContextIntegration = (() => {
  return {
    name: httpcontext_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    preprocessEvent(event) {
      // if none of the information we want exists, don't bother
      if (!helpers_WINDOW.navigator && !helpers_WINDOW.location && !helpers_WINDOW.document) {
        return;
      }

      // grab as much info as exists and add it to the event
      const url = (event.request && event.request.url) || (helpers_WINDOW.location && helpers_WINDOW.location.href);
      const { referrer } = helpers_WINDOW.document || {};
      const { userAgent } = helpers_WINDOW.navigator || {};

      const headers = {
        ...(event.request && event.request.headers),
        ...(referrer && { Referer: referrer }),
        ...(userAgent && { 'User-Agent': userAgent }),
      };
      const request = { ...event.request, ...(url && { url }), headers };

      event.request = request;
    },
  };
}) ;

const httpContextIntegration = defineIntegration(_httpContextIntegration);

/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const HttpContext = convertIntegrationFnToClass(httpcontext_INTEGRATION_NAME, httpContextIntegration)

;


//# sourceMappingURL=httpcontext.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/aggregate-errors.js



/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */
function applyAggregateErrorsToEvent(
  exceptionFromErrorImplementation,
  parser,
  maxValueLimit = 250,
  key,
  limit,
  event,
  hint,
) {
  if (!event.exception || !event.exception.values || !hint || !(0,is/* isInstanceOf */.V9)(hint.originalException, Error)) {
    return;
  }

  // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
  const originalException =
    event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;

  // We only create exception grouping if there is an exception in the event.
  if (originalException) {
    event.exception.values = truncateAggregateExceptions(
      aggregateExceptionsFromError(
        exceptionFromErrorImplementation,
        parser,
        limit,
        hint.originalException ,
        key,
        event.exception.values,
        originalException,
        0,
      ),
      maxValueLimit,
    );
  }
}

function aggregateExceptionsFromError(
  exceptionFromErrorImplementation,
  parser,
  limit,
  error,
  key,
  prevExceptions,
  exception,
  exceptionId,
) {
  if (prevExceptions.length >= limit + 1) {
    return prevExceptions;
  }

  let newExceptions = [...prevExceptions];

  // Recursively call this function in order to walk down a chain of errors
  if ((0,is/* isInstanceOf */.V9)(error[key], Error)) {
    applyExceptionGroupFieldsForParentException(exception, exceptionId);
    const newException = exceptionFromErrorImplementation(parser, error[key]);
    const newExceptionId = newExceptions.length;
    applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
    newExceptions = aggregateExceptionsFromError(
      exceptionFromErrorImplementation,
      parser,
      limit,
      error[key],
      key,
      [newException, ...newExceptions],
      newException,
      newExceptionId,
    );
  }

  // This will create exception grouping for AggregateErrors
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
  if (Array.isArray(error.errors)) {
    error.errors.forEach((childError, i) => {
      if ((0,is/* isInstanceOf */.V9)(childError, Error)) {
        applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, childError);
        const newExceptionId = newExceptions.length;
        applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
        newExceptions = aggregateExceptionsFromError(
          exceptionFromErrorImplementation,
          parser,
          limit,
          childError,
          key,
          [newException, ...newExceptions],
          newException,
          newExceptionId,
        );
      }
    });
  }

  return newExceptions;
}

function applyExceptionGroupFieldsForParentException(exception, exceptionId) {
  // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
  exception.mechanism = exception.mechanism || { type: 'generic', handled: true };

  exception.mechanism = {
    ...exception.mechanism,
    ...(exception.type === 'AggregateError' && { is_exception_group: true }),
    exception_id: exceptionId,
  };
}

function applyExceptionGroupFieldsForChildException(
  exception,
  source,
  exceptionId,
  parentId,
) {
  // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
  exception.mechanism = exception.mechanism || { type: 'generic', handled: true };

  exception.mechanism = {
    ...exception.mechanism,
    type: 'chained',
    source,
    exception_id: exceptionId,
    parent_id: parentId,
  };
}

/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */
function truncateAggregateExceptions(exceptions, maxValueLength) {
  return exceptions.map(exception => {
    if (exception.value) {
      exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
    }
    return exception;
  });
}


//# sourceMappingURL=aggregate-errors.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/linkederrors.js




const DEFAULT_KEY = 'cause';
const DEFAULT_LIMIT = 5;

const linkederrors_INTEGRATION_NAME = 'LinkedErrors';

const _linkedErrorsIntegration = ((options = {}) => {
  const limit = options.limit || DEFAULT_LIMIT;
  const key = options.key || DEFAULT_KEY;

  return {
    name: linkederrors_INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce() {}, // eslint-disable-line @typescript-eslint/no-empty-function
    preprocessEvent(event, hint, client) {
      const options = client.getOptions();

      applyAggregateErrorsToEvent(
        // This differs from the LinkedErrors integration in core by using a different exceptionFromError function
        exceptionFromError,
        options.stackParser,
        options.maxValueLength,
        key,
        limit,
        event,
        hint,
      );
    },
  };
}) ;

const linkedErrorsIntegration = defineIntegration(_linkedErrorsIntegration);

/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const LinkedErrors = convertIntegrationFnToClass(linkederrors_INTEGRATION_NAME, linkedErrorsIntegration)

;


//# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/integrations/trycatch.js




const DEFAULT_EVENT_TARGET = [
  'EventTarget',
  'Window',
  'Node',
  'ApplicationCache',
  'AudioTrackList',
  'BroadcastChannel',
  'ChannelMergerNode',
  'CryptoOperation',
  'EventSource',
  'FileReader',
  'HTMLUnknownElement',
  'IDBDatabase',
  'IDBRequest',
  'IDBTransaction',
  'KeyOperation',
  'MediaController',
  'MessagePort',
  'ModalWindow',
  'Notification',
  'SVGElementInstance',
  'Screen',
  'SharedWorker',
  'TextTrack',
  'TextTrackCue',
  'TextTrackList',
  'WebSocket',
  'WebSocketWorker',
  'Worker',
  'XMLHttpRequest',
  'XMLHttpRequestEventTarget',
  'XMLHttpRequestUpload',
];

const trycatch_INTEGRATION_NAME = 'TryCatch';

const _browserApiErrorsIntegration = ((options = {}) => {
  const _options = {
    XMLHttpRequest: true,
    eventTarget: true,
    requestAnimationFrame: true,
    setInterval: true,
    setTimeout: true,
    ...options,
  };

  return {
    name: trycatch_INTEGRATION_NAME,
    // TODO: This currently only works for the first client this is setup
    // We may want to adjust this to check for client etc.
    setupOnce() {
      if (_options.setTimeout) {
        (0,object/* fill */.hl)(helpers_WINDOW, 'setTimeout', _wrapTimeFunction);
      }

      if (_options.setInterval) {
        (0,object/* fill */.hl)(helpers_WINDOW, 'setInterval', _wrapTimeFunction);
      }

      if (_options.requestAnimationFrame) {
        (0,object/* fill */.hl)(helpers_WINDOW, 'requestAnimationFrame', _wrapRAF);
      }

      if (_options.XMLHttpRequest && "XMLHttpRequest" in helpers_WINDOW) {
        (0,object/* fill */.hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
      }

      const eventTargetOption = _options.eventTarget;
      if (eventTargetOption) {
        const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
        eventTarget.forEach(_wrapEventTarget);
      }
    },
  };
}) ;

const browserApiErrorsIntegration = defineIntegration(_browserApiErrorsIntegration);

/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
const TryCatch = convertIntegrationFnToClass(
  trycatch_INTEGRATION_NAME,
  browserApiErrorsIntegration,
)

;

function _wrapTimeFunction(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    const originalCallback = args[0];
    args[0] = wrap(originalCallback, {
      mechanism: {
        data: { function: (0,stacktrace/* getFunctionName */.$P)(original) },
        handled: false,
        type: 'instrument',
      },
    });
    return original.apply(this, args);
  };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( callback) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return original.apply(this, [
      wrap(callback, {
        mechanism: {
          data: {
            function: 'requestAnimationFrame',
            handler: (0,stacktrace/* getFunctionName */.$P)(original),
          },
          handled: false,
          type: 'instrument',
        },
      }),
    ]);
  };
}

function _wrapXHR(originalSend) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const xhr = this;
    const xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];

    xmlHttpRequestProps.forEach(prop => {
      if (prop in xhr && typeof xhr[prop] === 'function') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0,object/* fill */.hl)(xhr, prop, function (original) {
          const wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: (0,stacktrace/* getFunctionName */.$P)(original),
              },
              handled: false,
              type: 'instrument',
            },
          };

          // If Instrument integration has been called before TryCatch, get the name of original function
          const originalFunction = (0,object/* getOriginalFunction */.HK)(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = (0,stacktrace/* getFunctionName */.$P)(originalFunction);
          }

          // Otherwise wrap directly
          return wrap(original, wrapOptions);
        });
      }
    });

    return originalSend.apply(this, args);
  };
}

function _wrapEventTarget(target) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalObject = helpers_WINDOW ;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const proto = globalObject[target] && globalObject[target].prototype;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
  if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
    return;
  }

  (0,object/* fill */.hl)(proto, 'addEventListener', function (original,)

 {
    return function (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any

      eventName,
      fn,
      options,
    ) {
      try {
        if (typeof fn.handleEvent === 'function') {
          // ESlint disable explanation:
          //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
          //  introduce a bug here, because bind returns a new function that doesn't have our
          //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
          //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
          // eslint-disable-next-line @typescript-eslint/unbound-method
          fn.handleEvent = wrap(fn.handleEvent, {
            mechanism: {
              data: {
                function: 'handleEvent',
                handler: (0,stacktrace/* getFunctionName */.$P)(fn),
                target,
              },
              handled: false,
              type: 'instrument',
            },
          });
        }
      } catch (err) {
        // can sometimes get 'Permission denied to access property "handle Event'
      }

      return original.apply(this, [
        eventName,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        wrap(fn , {
          mechanism: {
            data: {
              function: 'addEventListener',
              handler: (0,stacktrace/* getFunctionName */.$P)(fn),
              target,
            },
            handled: false,
            type: 'instrument',
          },
        }),
        options,
      ]);
    };
  });

  (0,object/* fill */.hl)(
    proto,
    'removeEventListener',
    function (
      originalRemoveEventListener,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) {
      return function (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any

        eventName,
        fn,
        options,
      ) {
        /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */
        const wrappedEventHandler = fn ;
        try {
          const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        } catch (e) {
          // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
        }
        return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
      };
    },
  );
}


//# sourceMappingURL=trycatch.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/stack-parsers.js


// global reference to slice
const UNKNOWN_FUNCTION = '?';

const OPERA10_PRIORITY = 10;
const OPERA11_PRIORITY = 20;
const CHROME_PRIORITY = 30;
const WINJS_PRIORITY = 40;
const GECKO_PRIORITY = 50;

function createFrame(filename, func, lineno, colno) {
  const frame = {
    filename,
    function: func,
    in_app: true, // All browser frames are considered in_app
  };

  if (lineno !== undefined) {
    frame.lineno = lineno;
  }

  if (colno !== undefined) {
    frame.colno = colno;
  }

  return frame;
}

// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const chromeRegex =
  /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;

// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const chromeStackParserFn = line => {
  const parts = chromeRegex.exec(line);

  if (parts) {
    const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

    if (isEval) {
      const subMatch = chromeEvalRegex.exec(parts[2]);

      if (subMatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = subMatch[1]; // url
        parts[3] = subMatch[2]; // line
        parts[4] = subMatch[3]; // column
      }
    }

    // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
    // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
    const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);

    return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
  }

  return;
};

const chromeStackLineParser = [CHROME_PRIORITY, chromeStackParserFn];

// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const geckoREgex =
  /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

const gecko = line => {
  const parts = geckoREgex.exec(line);

  if (parts) {
    const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    if (isEval) {
      const subMatch = geckoEvalRegex.exec(parts[3]);

      if (subMatch) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || 'eval';
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = ''; // no column when eval
      }
    }

    let filename = parts[3];
    let func = parts[1] || UNKNOWN_FUNCTION;
    [func, filename] = extractSafariExtensionDetails(func, filename);

    return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
  }

  return;
};

const geckoStackLineParser = [GECKO_PRIORITY, gecko];

const winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

const winjs = line => {
  const parts = winjsRegex.exec(line);

  return parts
    ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
    : undefined;
};

const winjsStackLineParser = [WINJS_PRIORITY, winjs];

const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;

const opera10 = line => {
  const parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};

const opera10StackLineParser = [OPERA10_PRIORITY, opera10];

const opera11Regex =
  / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;

const opera11 = line => {
  const parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};

const opera11StackLineParser = [OPERA11_PRIORITY, opera11];

const defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser, winjsStackLineParser];

const defaultStackParser = (0,stacktrace/* createStackParser */.pE)(...defaultStackLineParsers);

/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
const extractSafariExtensionDetails = (func, filename) => {
  const isSafariExtension = func.indexOf('safari-extension') !== -1;
  const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;

  return isSafariExtension || isSafariWebExtension
    ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`,
      ]
    : [func, filename];
};


//# sourceMappingURL=stack-parsers.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/promisebuffer.js



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
  const buffer = [];

  function isReady() {
    return limit === undefined || buffer.length < limit;
  }

  /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */
  function remove(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0];
  }

  /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */
  function add(taskProducer) {
    if (!isReady()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('Not adding Promise because buffer limit was reached.'));
    }

    // start the task and add its promise to the queue
    const task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task
      .then(() => remove(task))
      // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
      // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
      // have promises, so TS has to polyfill when down-compiling.)
      .then(null, () =>
        remove(task).then(null, () => {
          // We have to add another catch here because `remove()` starts a new promise chain.
        }),
      );
    return task;
  }

  /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */
  function drain(timeout) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      let counter = buffer.length;

      if (!counter) {
        return resolve(true);
      }

      // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
      const capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);

      // if all promises resolve in time, cancel the timer and resolve to `true`
      buffer.forEach(item => {
        void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(() => {
          if (!--counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }

  return {
    $: buffer,
    add,
    drain,
  };
}


//# sourceMappingURL=promisebuffer.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/utils/esm/ratelimit.js
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

const DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now = Date.now()) {
  const headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }

  const headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }

  return DEFAULT_RETRY_AFTER;
}

/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */
function disabledUntil(limits, dataCategory) {
  return limits[dataCategory] || limits.all || 0;
}

/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, dataCategory, now = Date.now()) {
  return disabledUntil(limits, dataCategory) > now;
}

/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */
function updateRateLimits(
  limits,
  { statusCode, headers },
  now = Date.now(),
) {
  const updatedRateLimits = {
    ...limits,
  };

  // "The name is case-insensitive."
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
  const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
  const retryAfterHeader = headers && headers['retry-after'];

  if (rateLimitHeader) {
    /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */
    for (const limit of rateLimitHeader.trim().split(',')) {
      const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
      const headerDelay = parseInt(retryAfter, 10);
      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (const category of categories.split(';')) {
          if (category === 'metric_bucket') {
            // namespaces will be present when category === 'metric_bucket'
            if (!namespaces || namespaces.split(';').includes('custom')) {
              updatedRateLimits[category] = now + delay;
            }
          } else {
            updatedRateLimits[category] = now + delay;
          }
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1000;
  }

  return updatedRateLimits;
}


//# sourceMappingURL=ratelimit.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/transports/base.js



const DEFAULT_TRANSPORT_BUFFER_SIZE = 30;

/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(
  options,
  makeRequest,
  buffer = makePromiseBuffer(
    options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE,
  ),
) {
  let rateLimits = {};
  const flush = (timeout) => buffer.drain(timeout);

  function send(envelope) {
    const filteredEnvelopeItems = [];

    // Drop rate limited items from envelope
    forEachEnvelopeItem(envelope, (item, type) => {
      const dataCategory = envelopeItemTypeToDataCategory(type);
      if (isRateLimited(rateLimits, dataCategory)) {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });

    // Skip sending if envelope is empty after filtering out rate limited events
    if (filteredEnvelopeItems.length === 0) {
      return (0,syncpromise/* resolvedSyncPromise */.WD)();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filteredEnvelope = createEnvelope(envelope[0], filteredEnvelopeItems );

    // Creates client report for each item in an envelope
    const recordEnvelopeLoss = (reason) => {
      forEachEnvelopeItem(filteredEnvelope, (item, type) => {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent(reason, envelopeItemTypeToDataCategory(type), event);
      });
    };

    const requestTask = () =>
      makeRequest({ body: serializeEnvelope(filteredEnvelope, options.textEncoder) }).then(
        response => {
          // We don't want to throw on NOK responses, but we want to at least log them
          if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
            debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
          }

          rateLimits = updateRateLimits(rateLimits, response);
          return response;
        },
        error => {
          recordEnvelopeLoss('network_error');
          throw error;
        },
      );

    return buffer.add(requestTask).then(
      result => result,
      error => {
        if (error instanceof SentryError) {
          debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.error */.kg.error('Skipped sending event because buffer is full.');
          recordEnvelopeLoss('queue_overflow');
          return (0,syncpromise/* resolvedSyncPromise */.WD)();
        } else {
          throw error;
        }
      },
    );
  }

  // We use this to identifify if the transport is the base transport
  // TODO (v8): Remove this again as we'll no longer need it
  send.__sentry__baseTransport__ = true;

  return {
    send,
    flush,
  };
}

function getEventForEnvelopeItem(item, type) {
  if (type !== 'event' && type !== 'transaction') {
    return undefined;
  }

  return Array.isArray(item) ? (item )[1] : undefined;
}


//# sourceMappingURL=base.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/transports/utils.js




let cachedFetchImpl = undefined;

/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
  if (cachedFetchImpl) {
    return cachedFetchImpl;
  }

  /* eslint-disable @typescript-eslint/unbound-method */

  // Fast path to avoid DOM I/O
  if (isNativeFetch(helpers_WINDOW.fetch)) {
    return (cachedFetchImpl = helpers_WINDOW.fetch.bind(helpers_WINDOW));
  }

  const document = helpers_WINDOW.document;
  let fetchImpl = helpers_WINDOW.fetch;
  // eslint-disable-next-line deprecation/deprecation
  if (document && typeof document.createElement === 'function') {
    try {
      const sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow.fetch) {
        fetchImpl = contentWindow.fetch;
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
  }

  return (cachedFetchImpl = fetchImpl.bind(helpers_WINDOW));
  /* eslint-enable @typescript-eslint/unbound-method */
}

/** Clears cached fetch impl */
function clearCachedFetchImplementation() {
  cachedFetchImpl = undefined;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/transports/fetch.js




/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(
  options,
  nativeFetch = getNativeFetchImplementation(),
) {
  let pendingBodySize = 0;
  let pendingCount = 0;

  function makeRequest(request) {
    const requestSize = request.body.length;
    pendingBodySize += requestSize;
    pendingCount++;

    const requestOptions = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
      //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
      //   We will therefore only activate the flag when we're below that limit.
      // There is also a limit of requests that can be open at the same time, so we also limit this to 15
      // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
      keepalive: pendingBodySize <= 60000 && pendingCount < 15,
      ...options.fetchOptions,
    };

    try {
      return nativeFetch(options.url, requestOptions).then(response => {
        pendingBodySize -= requestSize;
        pendingCount--;
        return {
          statusCode: response.status,
          headers: {
            'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
            'retry-after': response.headers.get('Retry-After'),
          },
        };
      });
    } catch (e) {
      clearCachedFetchImplementation();
      pendingBodySize -= requestSize;
      pendingCount--;
      return (0,syncpromise/* rejectedSyncPromise */.$2)(e);
    }
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/transports/xhr.js



/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
const XHR_READYSTATE_DONE = 4;

/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeXHRTransport(options) {
  function makeRequest(request) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.onerror = reject;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XHR_READYSTATE_DONE) {
          resolve({
            statusCode: xhr.status,
            headers: {
              'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
              'retry-after': xhr.getResponseHeader('Retry-After'),
            },
          });
        }
      };

      xhr.open('POST', options.url);

      for (const header in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }

      xhr.send(request.body);
    });
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/browser/esm/sdk.js















/** @deprecated Use `getDefaultIntegrations(options)` instead. */
const defaultIntegrations = [
  inboundFiltersIntegration(),
  functionToStringIntegration(),
  browserApiErrorsIntegration(),
  breadcrumbsIntegration(),
  globalHandlersIntegration(),
  linkedErrorsIntegration(),
  dedupeIntegration(),
  httpContextIntegration(),
];

/** Get the default integrations for the browser SDK. */
function getDefaultIntegrations(_options) {
  // We return a copy of the defaultIntegrations here to avoid mutating this
  return [
    // eslint-disable-next-line deprecation/deprecation
    ...defaultIntegrations,
  ];
}

/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options = {}) {
  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = getDefaultIntegrations();
  }
  if (options.release === undefined) {
    // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
    if (typeof __SENTRY_RELEASE__ === 'string') {
      options.release = __SENTRY_RELEASE__;
    }

    // This supports the variable that sentry-webpack-plugin injects
    if (helpers_WINDOW.SENTRY_RELEASE && helpers_WINDOW.SENTRY_RELEASE.id) {
      options.release = helpers_WINDOW.SENTRY_RELEASE.id;
    }
  }
  if (options.autoSessionTracking === undefined) {
    options.autoSessionTracking = true;
  }
  if (options.sendClientReports === undefined) {
    options.sendClientReports = true;
  }

  const clientOptions = {
    ...options,
    stackParser: (0,stacktrace/* stackParserFromStackParserOptions */.Sq)(options.stackParser || defaultStackParser),
    integrations: getIntegrationsToSetup(options),
    transport: options.transport || (supportsFetch() ? makeFetchTransport : makeXHRTransport),
  };

  initAndBind(BrowserClient, clientOptions);

  if (options.autoSessionTracking) {
    startSessionTracking();
  }
}

const showReportDialog = (
  // eslint-disable-next-line deprecation/deprecation
  options = {},
  // eslint-disable-next-line deprecation/deprecation
  hub = getCurrentHub(),
) => {
  // doesn't work without a document (React Native)
  if (!WINDOW.document) {
    DEBUG_BUILD && logger.error('Global document not defined in showReportDialog call');
    return;
  }

  // eslint-disable-next-line deprecation/deprecation
  const { client, scope } = hub.getStackTop();
  const dsn = options.dsn || (client && client.getDsn());
  if (!dsn) {
    DEBUG_BUILD && logger.error('DSN not configured for showReportDialog call');
    return;
  }

  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user,
    };
  }

  if (!options.eventId) {
    // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
  }

  const script = WINDOW.document.createElement('script');
  script.async = true;
  script.crossOrigin = 'anonymous';
  script.src = getReportDialogEndpoint(dsn, options);

  if (options.onLoad) {
    script.onload = options.onLoad;
  }

  const { onClose } = options;
  if (onClose) {
    const reportDialogClosedMessageHandler = (event) => {
      if (event.data === '__sentry_reportdialog_closed__') {
        try {
          onClose();
        } finally {
          WINDOW.removeEventListener('message', reportDialogClosedMessageHandler);
        }
      }
    };
    WINDOW.addEventListener('message', reportDialogClosedMessageHandler);
  }

  const injectionPoint = WINDOW.document.head || WINDOW.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    DEBUG_BUILD && logger.error('Not injecting report dialog. No injection point found in HTML');
  }
};

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
  // Noop
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
  callback();
}

/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function sdk_wrap(fn) {
  return wrap$1(fn)();
}

/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
  if (typeof helpers_WINDOW.document === 'undefined') {
    debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
    return;
  }

  // The session duration for browser sessions does not track a meaningful
  // concept that can be used as a metric.
  // Automatically captured sessions are akin to page views, and thus we
  // discard their duration.
  (0,esm_exports/* startSession */.yj)({ ignoreDuration: true });
  (0,esm_exports/* captureSession */.cg)();

  // We want to create a session for every navigation as well
  addHistoryInstrumentationHandler(({ from, to }) => {
    // Don't create an additional session for the initial route or if the location did not change
    if (from !== undefined && from !== to) {
      (0,esm_exports/* startSession */.yj)({ ignoreDuration: true });
      (0,esm_exports/* captureSession */.cg)();
    }
  });
}

/**
 * Captures user feedback and sends it to Sentry.
 */
function captureUserFeedback(feedback) {
  const client = getClient();
  if (client) {
    client.captureUserFeedback(feedback);
  }
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/react/esm/sdk.js


/**
 * Inits the React SDK
 */
function sdk_init(options) {
  const opts = {
    _metadata: {} ,
    ...options,
  };

  opts._metadata.sdk = opts._metadata.sdk || {
    name: 'sentry.javascript.react',
    packages: [
      {
        name: 'npm:@sentry/react',
        version: version/* SDK_VERSION */.J,
      },
    ],
    version: version/* SDK_VERSION */.J,
  };
  init(opts);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(43002);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/metrics/metric-summary.js






/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */

let SPAN_METRIC_SUMMARY;

function getMetricStorageForSpan(span) {
  return SPAN_METRIC_SUMMARY ? SPAN_METRIC_SUMMARY.get(span) : undefined;
}

/**
 * Fetches the metric summary if it exists for the passed span
 */
function getMetricSummaryJsonForSpan(span) {
  const storage = getMetricStorageForSpan(span);

  if (!storage) {
    return undefined;
  }
  const output = {};

  for (const [, [exportKey, summary]] of storage) {
    if (!output[exportKey]) {
      output[exportKey] = [];
    }

    output[exportKey].push((0,object/* dropUndefinedKeys */.Jr)(summary));
  }

  return output;
}

/**
 * Updates the metric summary on the currently active span
 */
function updateMetricSummaryOnActiveSpan(
  metricType,
  sanitizedName,
  value,
  unit,
  tags,
  bucketKey,
) {
  const span = getActiveSpan();
  if (span) {
    const storage = getMetricStorageForSpan(span) || new Map();

    const exportKey = `${metricType}:${sanitizedName}@${unit}`;
    const bucketItem = storage.get(bucketKey);

    if (bucketItem) {
      const [, summary] = bucketItem;
      storage.set(bucketKey, [
        exportKey,
        {
          min: Math.min(summary.min, value),
          max: Math.max(summary.max, value),
          count: (summary.count += 1),
          sum: (summary.sum += value),
          tags: summary.tags,
        },
      ]);
    } else {
      storage.set(bucketKey, [
        exportKey,
        {
          min: value,
          max: value,
          count: 1,
          sum: value,
          tags,
        },
      ]);
    }

    if (!SPAN_METRIC_SUMMARY) {
      SPAN_METRIC_SUMMARY = new WeakMap();
    }

    SPAN_METRIC_SUMMARY.set(span, storage);
  }
}


//# sourceMappingURL=metric-summary.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/semanticAttributes.js
/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */
const SEMANTIC_ATTRIBUTE_SENTRY_SOURCE = 'sentry.source';

/**
 * Use this attribute to represent the sample rate used for a span.
 */
const SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE = 'sentry.sample_rate';

/**
 * Use this attribute to represent the operation of a span.
 */
const SEMANTIC_ATTRIBUTE_SENTRY_OP = 'sentry.op';

/**
 * Use this attribute to represent the origin of a span.
 */
const SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN = 'sentry.origin';

/**
 * The id of the profile that this span occured in.
 */
const SEMANTIC_ATTRIBUTE_PROFILE_ID = 'profile_id';


//# sourceMappingURL=semanticAttributes.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/core/esm/utils/getRootSpan.js
var getRootSpan = __webpack_require__(85112);
;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/spanstatus.js
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */
var SpanStatus; (function (SpanStatus) {
  /** The operation completed successfully. */
  const Ok = 'ok'; SpanStatus["Ok"] = Ok;
  /** Deadline expired before operation could complete. */
  const DeadlineExceeded = 'deadline_exceeded'; SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
  /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */
  const Unauthenticated = 'unauthenticated'; SpanStatus["Unauthenticated"] = Unauthenticated;
  /** 403 Forbidden */
  const PermissionDenied = 'permission_denied'; SpanStatus["PermissionDenied"] = PermissionDenied;
  /** 404 Not Found. Some requested entity (file or directory) was not found. */
  const NotFound = 'not_found'; SpanStatus["NotFound"] = NotFound;
  /** 429 Too Many Requests */
  const ResourceExhausted = 'resource_exhausted'; SpanStatus["ResourceExhausted"] = ResourceExhausted;
  /** Client specified an invalid argument. 4xx. */
  const InvalidArgument = 'invalid_argument'; SpanStatus["InvalidArgument"] = InvalidArgument;
  /** 501 Not Implemented */
  const Unimplemented = 'unimplemented'; SpanStatus["Unimplemented"] = Unimplemented;
  /** 503 Service Unavailable */
  const Unavailable = 'unavailable'; SpanStatus["Unavailable"] = Unavailable;
  /** Other/generic 5xx. */
  const InternalError = 'internal_error'; SpanStatus["InternalError"] = InternalError;
  /** Unknown. Any non-standard HTTP status code. */
  const UnknownError = 'unknown_error'; SpanStatus["UnknownError"] = UnknownError;
  /** The operation was cancelled (typically by the user). */
  const Cancelled = 'cancelled'; SpanStatus["Cancelled"] = Cancelled;
  /** Already exists (409) */
  const AlreadyExists = 'already_exists'; SpanStatus["AlreadyExists"] = AlreadyExists;
  /** Operation was rejected because the system is not in a state required for the operation's */
  const FailedPrecondition = 'failed_precondition'; SpanStatus["FailedPrecondition"] = FailedPrecondition;
  /** The operation was aborted, typically due to a concurrency issue. */
  const Aborted = 'aborted'; SpanStatus["Aborted"] = Aborted;
  /** Operation was attempted past the valid range. */
  const OutOfRange = 'out_of_range'; SpanStatus["OutOfRange"] = OutOfRange;
  /** Unrecoverable data loss or corruption */
  const DataLoss = 'data_loss'; SpanStatus["DataLoss"] = DataLoss;
})(SpanStatus || (SpanStatus = {}));

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function getSpanStatusFromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return 'ok';
  }

  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return 'unauthenticated';
      case 403:
        return 'permission_denied';
      case 404:
        return 'not_found';
      case 409:
        return 'already_exists';
      case 413:
        return 'failed_precondition';
      case 429:
        return 'resource_exhausted';
      default:
        return 'invalid_argument';
    }
  }

  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return 'unimplemented';
      case 503:
        return 'unavailable';
      case 504:
        return 'deadline_exceeded';
      default:
        return 'internal_error';
    }
  }

  return 'unknown_error';
}

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @deprecated Use {@link spanStatusFromHttpCode} instead.
 * This export will be removed in v8 as the signature contains a typo.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
const spanStatusfromHttpCode = (/* unused pure expression or super */ null && (getSpanStatusFromHttpCode));

/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */
function setHttpStatus(span, httpStatus) {
  // TODO (v8): Remove these calls
  // Relay does not require us to send the status code as a tag
  // For now, just because users might expect it to land as a tag we keep sending it.
  // Same with data.
  // In v8, we replace both, simply with
  // span.setAttribute('http.response.status_code', httpStatus);

  // eslint-disable-next-line deprecation/deprecation
  span.setTag('http.status_code', String(httpStatus));
  // eslint-disable-next-line deprecation/deprecation
  span.setData('http.response.status_code', httpStatus);

  const spanStatus = getSpanStatusFromHttpCode(httpStatus);
  if (spanStatus !== 'unknown_error') {
    span.setStatus(spanStatus);
  }
}


//# sourceMappingURL=spanstatus.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/span.js








/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
class SpanRecorder {

   constructor(maxlen = 1000) {
    this._maxlen = maxlen;
    this.spans = [];
  }

  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
   add(span) {
    if (this.spans.length > this._maxlen) {
      // eslint-disable-next-line deprecation/deprecation
      span.spanRecorder = undefined;
    } else {
      this.spans.push(span);
    }
  }
}

/**
 * Span contains all data about a span
 */
class Span  {
  /**
   * Tags for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */

  /**
   * Data for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any

  /**
   * List of spans that were finalized
   *
   * @deprecated This property will no longer be public. Span recording will be handled internally.
   */

  /**
   * @inheritDoc
   * @deprecated Use top level `Sentry.getRootSpan()` instead
   */

  /**
   * The instrumenter that created this span.
   *
   * TODO (v8): This can probably be replaced by an `instanceOf` check of the span class.
   *            the instrumenter can only be sentry or otel so we can check the span instance
   *            to verify which one it is and remove this field entirely.
   *
   * @deprecated This field will be removed.
   */

  /** Epoch timestamp in seconds when the span started. */

  /** Epoch timestamp in seconds when the span ended. */

  /** Internal keeper of the status */

  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(spanContext = {}) {
    this._traceId = spanContext.traceId || (0,misc/* uuid4 */.DM)();
    this._spanId = spanContext.spanId || (0,misc/* uuid4 */.DM)().substring(16);
    this._startTime = spanContext.startTimestamp || (0,esm_time/* timestampInSeconds */.ph)();
    // eslint-disable-next-line deprecation/deprecation
    this.tags = spanContext.tags ? { ...spanContext.tags } : {};
    // eslint-disable-next-line deprecation/deprecation
    this.data = spanContext.data ? { ...spanContext.data } : {};
    // eslint-disable-next-line deprecation/deprecation
    this.instrumenter = spanContext.instrumenter || 'sentry';

    this._attributes = {};
    this.setAttributes({
      [SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanContext.origin || 'manual',
      [SEMANTIC_ATTRIBUTE_SENTRY_OP]: spanContext.op,
      ...spanContext.attributes,
    });

    // eslint-disable-next-line deprecation/deprecation
    this._name = spanContext.name || spanContext.description;

    if (spanContext.parentSpanId) {
      this._parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this._sampled = spanContext.sampled;
    }
    if (spanContext.status) {
      this._status = spanContext.status;
    }
    if (spanContext.endTimestamp) {
      this._endTime = spanContext.endTimestamp;
    }
    if (spanContext.exclusiveTime !== undefined) {
      this._exclusiveTime = spanContext.exclusiveTime;
    }
    this._measurements = spanContext.measurements ? { ...spanContext.measurements } : {};
  }

  // This rule conflicts with another eslint rule :(
  /* eslint-disable @typescript-eslint/member-ordering */

  /**
   * An alias for `description` of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
   get name() {
    return this._name || '';
  }

  /**
   * Update the name of the span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
   set name(name) {
    this.updateName(name);
  }

  /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
   get description() {
    return this._name;
  }

  /**
   * Get the description of the Span.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
   set description(description) {
    this._name = description;
  }

  /**
   * The ID of the trace.
   * @deprecated Use `spanContext().traceId` instead.
   */
   get traceId() {
    return this._traceId;
  }

  /**
   * The ID of the trace.
   * @deprecated You cannot update the traceId of a span after span creation.
   */
   set traceId(traceId) {
    this._traceId = traceId;
  }

  /**
   * The ID of the span.
   * @deprecated Use `spanContext().spanId` instead.
   */
   get spanId() {
    return this._spanId;
  }

  /**
   * The ID of the span.
   * @deprecated You cannot update the spanId of a span after span creation.
   */
   set spanId(spanId) {
    this._spanId = spanId;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `startSpan` functions instead.
   */
   set parentSpanId(string) {
    this._parentSpanId = string;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).parent_span_id` instead.
   */
   get parentSpanId() {
    return this._parentSpanId;
  }

  /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated Use `isRecording()` instead.
   */
   get sampled() {
    return this._sampled;
  }

  /**
   * Was this span chosen to be sent as part of the sample?
   * @deprecated You cannot update the sampling decision of a span after span creation.
   */
   set sampled(sampled) {
    this._sampled = sampled;
  }

  /**
   * Attributes for the span.
   * @deprecated Use `spanToJSON(span).atttributes` instead.
   */
   get attributes() {
    return this._attributes;
  }

  /**
   * Attributes for the span.
   * @deprecated Use `setAttributes()` instead.
   */
   set attributes(attributes) {
    this._attributes = attributes;
  }

  /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated Use `spanToJSON()` instead.
   */
   get startTimestamp() {
    return this._startTime;
  }

  /**
   * Timestamp in seconds (epoch time) indicating when the span started.
   * @deprecated In v8, you will not be able to update the span start time after creation.
   */
   set startTimestamp(startTime) {
    this._startTime = startTime;
  }

  /**
   * Timestamp in seconds when the span ended.
   * @deprecated Use `spanToJSON()` instead.
   */
   get endTimestamp() {
    return this._endTime;
  }

  /**
   * Timestamp in seconds when the span ended.
   * @deprecated Set the end time via `span.end()` instead.
   */
   set endTimestamp(endTime) {
    this._endTime = endTime;
  }

  /**
   * The status of the span.
   *
   * @deprecated Use `spanToJSON().status` instead to get the status.
   */
   get status() {
    return this._status;
  }

  /**
   * The status of the span.
   *
   * @deprecated Use `.setStatus()` instead to set or update the status.
   */
   set status(status) {
    this._status = status;
  }

  /**
   * Operation of the span
   *
   * @deprecated Use `spanToJSON().op` to read the op instead.
   */
   get op() {
    return this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_OP] ;
  }

  /**
   * Operation of the span
   *
   * @deprecated Use `startSpan()` functions to set or `span.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, 'op')
   *             to update the span instead.
   */
   set op(op) {
    this.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_OP, op);
  }

  /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `spanToJSON().origin` to read the origin instead.
   */
   get origin() {
    return this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN] ;
  }

  /**
   * The origin of the span, giving context about what created the span.
   *
   * @deprecated Use `startSpan()` functions to set the origin instead.
   */
   set origin(origin) {
    this.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN, origin);
  }

  /* eslint-enable @typescript-eslint/member-ordering */

  /** @inheritdoc */
   spanContext() {
    const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
    return {
      spanId,
      traceId,
      traceFlags: sampled ? spanUtils/* TRACE_FLAG_SAMPLED */.i0 : spanUtils/* TRACE_FLAG_NONE */.ve,
    };
  }

  /**
   * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
   * Also the `sampled` decision will be inherited.
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */
   startChild(
    spanContext,
  ) {
    const childSpan = new Span({
      ...spanContext,
      parentSpanId: this._spanId,
      sampled: this._sampled,
      traceId: this._traceId,
    });

    // eslint-disable-next-line deprecation/deprecation
    childSpan.spanRecorder = this.spanRecorder;
    // eslint-disable-next-line deprecation/deprecation
    if (childSpan.spanRecorder) {
      // eslint-disable-next-line deprecation/deprecation
      childSpan.spanRecorder.add(childSpan);
    }

    const rootSpan = (0,getRootSpan/* getRootSpan */.G)(this);
    // TODO: still set span.transaction here until we have a more permanent solution
    // Probably similarly to the weakmap we hold in node-experimental
    // eslint-disable-next-line deprecation/deprecation
    childSpan.transaction = rootSpan ;

    if (debug_build/* DEBUG_BUILD */.X && rootSpan) {
      const opStr = (spanContext && spanContext.op) || '< unknown op >';
      const nameStr = (0,spanUtils/* spanToJSON */.XU)(childSpan).description || '< unknown name >';
      const idStr = rootSpan.spanContext().spanId;

      const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
      esm_logger/* logger.log */.kg.log(logMessage);
      this._logMessage = logMessage;
    }

    return childSpan;
  }

  /**
   * Sets the tag attribute on the current span.
   *
   * Can also be used to unset a tag, by passing `undefined`.
   *
   * @param key Tag key
   * @param value Tag value
   * @deprecated Use `setAttribute()` instead.
   */
   setTag(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    this.tags = { ...this.tags, [key]: value };
    return this;
  }

  /**
   * Sets the data attribute on the current span
   * @param key Data key
   * @param value Data value
   * @deprecated Use `setAttribute()` instead.
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setData(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    this.data = { ...this.data, [key]: value };
    return this;
  }

  /** @inheritdoc */
   setAttribute(key, value) {
    if (value === undefined) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._attributes[key];
    } else {
      this._attributes[key] = value;
    }
  }

  /** @inheritdoc */
   setAttributes(attributes) {
    Object.keys(attributes).forEach(key => this.setAttribute(key, attributes[key]));
  }

  /**
   * @inheritDoc
   */
   setStatus(value) {
    this._status = value;
    return this;
  }

  /**
   * @inheritDoc
   * @deprecated Use top-level `setHttpStatus()` instead.
   */
   setHttpStatus(httpStatus) {
    setHttpStatus(this, httpStatus);
    return this;
  }

  /**
   * @inheritdoc
   *
   * @deprecated Use `.updateName()` instead.
   */
   setName(name) {
    this.updateName(name);
  }

  /**
   * @inheritDoc
   */
   updateName(name) {
    this._name = name;
    return this;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON(span).status === 'ok'` instead.
   */
   isSuccess() {
    return this._status === 'ok';
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `.end()` instead.
   */
   finish(endTimestamp) {
    return this.end(endTimestamp);
  }

  /** @inheritdoc */
   end(endTimestamp) {
    // If already ended, skip
    if (this._endTime) {
      return;
    }
    const rootSpan = (0,getRootSpan/* getRootSpan */.G)(this);
    if (
      debug_build/* DEBUG_BUILD */.X &&
      // Don't call this for transactions
      rootSpan &&
      rootSpan.spanContext().spanId !== this._spanId
    ) {
      const logMessage = this._logMessage;
      if (logMessage) {
        esm_logger/* logger.log */.kg.log((logMessage ).replace('Starting', 'Finishing'));
      }
    }

    this._endTime = (0,spanUtils/* spanTimeInputToSeconds */.$k)(endTimestamp);
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceHeader()` instead.
   */
   toTraceparent() {
    return (0,spanUtils/* spanToTraceHeader */.Hb)(this);
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToJSON()` or access the fields directly instead.
   */
   toContext() {
    return (0,object/* dropUndefinedKeys */.Jr)({
      data: this._getData(),
      description: this._name,
      endTimestamp: this._endTime,
      // eslint-disable-next-line deprecation/deprecation
      op: this.op,
      parentSpanId: this._parentSpanId,
      sampled: this._sampled,
      spanId: this._spanId,
      startTimestamp: this._startTime,
      status: this._status,
      // eslint-disable-next-line deprecation/deprecation
      tags: this.tags,
      traceId: this._traceId,
    });
  }

  /**
   * @inheritDoc
   *
   * @deprecated Update the fields directly instead.
   */
   updateWithContext(spanContext) {
    // eslint-disable-next-line deprecation/deprecation
    this.data = spanContext.data || {};
    // eslint-disable-next-line deprecation/deprecation
    this._name = spanContext.name || spanContext.description;
    this._endTime = spanContext.endTimestamp;
    // eslint-disable-next-line deprecation/deprecation
    this.op = spanContext.op;
    this._parentSpanId = spanContext.parentSpanId;
    this._sampled = spanContext.sampled;
    this._spanId = spanContext.spanId || this._spanId;
    this._startTime = spanContext.startTimestamp || this._startTime;
    this._status = spanContext.status;
    // eslint-disable-next-line deprecation/deprecation
    this.tags = spanContext.tags || {};
    this._traceId = spanContext.traceId || this._traceId;

    return this;
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use `spanToTraceContext()` util function instead.
   */
   getTraceContext() {
    return (0,spanUtils/* spanToTraceContext */.wy)(this);
  }

  /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */
   getSpanJSON() {
    return (0,object/* dropUndefinedKeys */.Jr)({
      data: this._getData(),
      description: this._name,
      op: this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_OP] ,
      parent_span_id: this._parentSpanId,
      span_id: this._spanId,
      start_timestamp: this._startTime,
      status: this._status,
      // eslint-disable-next-line deprecation/deprecation
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      timestamp: this._endTime,
      trace_id: this._traceId,
      origin: this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN] ,
      _metrics_summary: getMetricSummaryJsonForSpan(this),
      profile_id: this._attributes[SEMANTIC_ATTRIBUTE_PROFILE_ID] ,
      exclusive_time: this._exclusiveTime,
      measurements: Object.keys(this._measurements).length > 0 ? this._measurements : undefined,
    });
  }

  /** @inheritdoc */
   isRecording() {
    return !this._endTime && !!this._sampled;
  }

  /**
   * Convert the object to JSON.
   * @deprecated Use `spanToJSON(span)` instead.
   */
   toJSON() {
    return this.getSpanJSON();
  }

  /**
   * Get the merged data for this span.
   * For now, this combines `data` and `attributes` together,
   * until eventually we can ingest `attributes` directly.
   */
   _getData()

 {
    // eslint-disable-next-line deprecation/deprecation
    const { data, _attributes: attributes } = this;

    const hasData = Object.keys(data).length > 0;
    const hasAttributes = Object.keys(attributes).length > 0;

    if (!hasData && !hasAttributes) {
      return undefined;
    }

    if (hasData && hasAttributes) {
      return {
        ...data,
        ...attributes,
      };
    }

    return hasData ? data : attributes;
  }
}


//# sourceMappingURL=span.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/utils/hasTracingEnabled.js


// Treeshakable guard to remove all code related to tracing

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled_hasTracingEnabled(
  maybeOptions,
) {
  if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) {
    return false;
  }

  const client = (0,esm_exports/* getClient */.s3)();
  const options = maybeOptions || (client && client.getOptions());
  return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}


//# sourceMappingURL=hasTracingEnabled.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/trace.js











/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 *
 * This function is meant to be used internally and may break at any time. Use at your own risk.
 *
 * @internal
 * @private
 *
 * @deprecated Use `startSpan` instead.
 */
function trace(
  context,
  callback,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onError = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  afterFinish = () => {},
) {
  // eslint-disable-next-line deprecation/deprecation
  const hub = getCurrentHub();
  const scope = getCurrentScope();
  // eslint-disable-next-line deprecation/deprecation
  const parentSpan = scope.getSpan();

  const spanContext = normalizeContext(context);
  const activeSpan = createChildSpanOrTransaction(hub, {
    parentSpan,
    spanContext,
    forceTransaction: false,
    scope,
  });

  // eslint-disable-next-line deprecation/deprecation
  scope.setSpan(activeSpan);

  return handleCallbackErrors(
    () => callback(activeSpan),
    error => {
      activeSpan && activeSpan.setStatus('internal_error');
      onError(error, activeSpan);
    },
    () => {
      activeSpan && activeSpan.end();
      // eslint-disable-next-line deprecation/deprecation
      scope.setSpan(parentSpan);
      afterFinish();
    },
  );
}

/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */
function startSpan(context, callback) {
  const spanContext = normalizeContext(context);

  return runWithAsyncContext(() => {
    return withScope(context.scope, scope => {
      // eslint-disable-next-line deprecation/deprecation
      const hub = getCurrentHub();
      // eslint-disable-next-line deprecation/deprecation
      const parentSpan = scope.getSpan();

      const shouldSkipSpan = context.onlyIfParent && !parentSpan;
      const activeSpan = shouldSkipSpan
        ? undefined
        : createChildSpanOrTransaction(hub, {
            parentSpan,
            spanContext,
            forceTransaction: context.forceTransaction,
            scope,
          });

      return handleCallbackErrors(
        () => callback(activeSpan),
        () => {
          // Only update the span status if it hasn't been changed yet
          if (activeSpan) {
            const { status } = spanToJSON(activeSpan);
            if (!status || status === 'ok') {
              activeSpan.setStatus('internal_error');
            }
          }
        },
        () => activeSpan && activeSpan.end(),
      );
    });
  });
}

/**
 * @deprecated Use {@link startSpan} instead.
 */
const startActiveSpan = (/* unused pure expression or super */ null && (startSpan));

/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */
function startSpanManual(
  context,
  callback,
) {
  const spanContext = normalizeContext(context);

  return runWithAsyncContext(() => {
    return withScope(context.scope, scope => {
      // eslint-disable-next-line deprecation/deprecation
      const hub = getCurrentHub();
      // eslint-disable-next-line deprecation/deprecation
      const parentSpan = scope.getSpan();

      const shouldSkipSpan = context.onlyIfParent && !parentSpan;
      const activeSpan = shouldSkipSpan
        ? undefined
        : createChildSpanOrTransaction(hub, {
            parentSpan,
            spanContext,
            forceTransaction: context.forceTransaction,
            scope,
          });

      function finishAndSetSpan() {
        activeSpan && activeSpan.end();
      }

      return handleCallbackErrors(
        () => callback(activeSpan, finishAndSetSpan),
        () => {
          // Only update the span status if it hasn't been changed yet, and the span is not yet finished
          if (activeSpan && activeSpan.isRecording()) {
            const { status } = spanToJSON(activeSpan);
            if (!status || status === 'ok') {
              activeSpan.setStatus('internal_error');
            }
          }
        },
      );
    });
  });
}

/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * Note that if you have not enabled tracing extensions via `addTracingExtensions`
 * or you didn't set `tracesSampleRate` or `tracesSampler`, this function will not generate spans
 * and the `span` returned from the callback will be undefined.
 */
function startInactiveSpan(context) {
  if (!hasTracingEnabled_hasTracingEnabled()) {
    return undefined;
  }

  const spanContext = normalizeContext(context);
  // eslint-disable-next-line deprecation/deprecation
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const parentSpan = context.scope
    ? // eslint-disable-next-line deprecation/deprecation
      context.scope.getSpan()
    : trace_getActiveSpan();

  const shouldSkipSpan = context.onlyIfParent && !parentSpan;

  if (shouldSkipSpan) {
    return undefined;
  }

  const scope = context.scope || (0,esm_exports/* getCurrentScope */.nZ)();

  // Even though we don't actually want to make this span active on the current scope,
  // we need to make it active on a temporary scope that we use for event processing
  // as otherwise, it won't pick the correct span for the event when processing it
  const temporaryScope = (scope ).clone();

  return createChildSpanOrTransaction(hub, {
    parentSpan,
    spanContext,
    forceTransaction: context.forceTransaction,
    scope: temporaryScope,
  });
}

/**
 * Returns the currently active span.
 */
function trace_getActiveSpan() {
  // eslint-disable-next-line deprecation/deprecation
  return (0,esm_exports/* getCurrentScope */.nZ)().getSpan();
}

const continueTrace = (
  {
    sentryTrace,
    baggage,
  }

,
  callback,
) => {
  // TODO(v8): Change this function so it doesn't do anything besides setting the propagation context on the current scope:
  /*
    return withScope((scope) => {
      const propagationContext = propagationContextFromHeaders(sentryTrace, baggage);
      scope.setPropagationContext(propagationContext);
      return callback();
    })
  */

  const currentScope = getCurrentScope();

  // eslint-disable-next-line deprecation/deprecation
  const { traceparentData, dynamicSamplingContext, propagationContext } = tracingContextFromHeaders(
    sentryTrace,
    baggage,
  );

  currentScope.setPropagationContext(propagationContext);

  if (DEBUG_BUILD && traceparentData) {
    logger.log(`[Tracing] Continuing trace ${traceparentData.traceId}.`);
  }

  const transactionContext = {
    ...traceparentData,
    metadata: dropUndefinedKeys({
      dynamicSamplingContext,
    }),
  };

  if (!callback) {
    return transactionContext;
  }

  return runWithAsyncContext(() => {
    return callback(transactionContext);
  });
};

function createChildSpanOrTransaction(
  // eslint-disable-next-line deprecation/deprecation
  hub,
  {
    parentSpan,
    spanContext,
    forceTransaction,
    scope,
  }

,
) {
  if (!hasTracingEnabled_hasTracingEnabled()) {
    return undefined;
  }

  const isolationScope = (0,esm_hub/* getIsolationScope */.aF)();

  let span;
  if (parentSpan && !forceTransaction) {
    // eslint-disable-next-line deprecation/deprecation
    span = parentSpan.startChild(spanContext);
  } else if (parentSpan) {
    // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
    const dsc = (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(parentSpan);
    const { traceId, spanId: parentSpanId } = parentSpan.spanContext();
    const sampled = (0,spanUtils/* spanIsSampled */.Tt)(parentSpan);

    // eslint-disable-next-line deprecation/deprecation
    span = hub.startTransaction({
      traceId,
      parentSpanId,
      parentSampled: sampled,
      ...spanContext,
      metadata: {
        dynamicSamplingContext: dsc,
        // eslint-disable-next-line deprecation/deprecation
        ...spanContext.metadata,
      },
    });
  } else {
    const { traceId, dsc, parentSpanId, sampled } = {
      ...isolationScope.getPropagationContext(),
      ...scope.getPropagationContext(),
    };

    // eslint-disable-next-line deprecation/deprecation
    span = hub.startTransaction({
      traceId,
      parentSpanId,
      parentSampled: sampled,
      ...spanContext,
      metadata: {
        dynamicSamplingContext: dsc,
        // eslint-disable-next-line deprecation/deprecation
        ...spanContext.metadata,
      },
    });
  }

  // We always set this as active span on the scope
  // In the case of this being an inactive span, we ensure to pass a detached scope in here in the first place
  // But by having this here, we can ensure that the lookup through `getCapturedScopesOnSpan` results in the correct scope & span combo
  // eslint-disable-next-line deprecation/deprecation
  scope.setSpan(span);

  setCapturedScopesOnSpan(span, scope, isolationScope);

  return span;
}

/**
 * This converts StartSpanOptions to TransactionContext.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */
function normalizeContext(context) {
  if (context.startTime) {
    const ctx = { ...context };
    ctx.startTimestamp = (0,spanUtils/* spanTimeInputToSeconds */.$k)(context.startTime);
    delete ctx.startTime;
    return ctx;
  }

  return context;
}

const SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';

function setCapturedScopesOnSpan(span, scope, isolationScope) {
  if (span) {
    (0,object/* addNonEnumerableProperty */.xp)(span, ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
    (0,object/* addNonEnumerableProperty */.xp)(span, SCOPE_ON_START_SPAN_FIELD, scope);
  }
}

/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */
function getCapturedScopesOnSpan(span) {
  return {
    scope: (span )[SCOPE_ON_START_SPAN_FIELD],
    isolationScope: (span )[ISOLATION_SCOPE_ON_START_SPAN_FIELD],
  };
}


//# sourceMappingURL=trace.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/transaction.js










/** JSDoc */
class Transaction extends Span  {
  /**
   * The reference to the current hub.
   */
  // eslint-disable-next-line deprecation/deprecation

  // DO NOT yet remove this property, it is used in a hack for v7 backwards compatibility.

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   *
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */
  // eslint-disable-next-line deprecation/deprecation
   constructor(transactionContext, hub) {
    super(transactionContext);
    this._contexts = {};

    // eslint-disable-next-line deprecation/deprecation
    this._hub = hub || (0,esm_hub/* getCurrentHub */.Gd)();

    this._name = transactionContext.name || '';

    this._metadata = {
      // eslint-disable-next-line deprecation/deprecation
      ...transactionContext.metadata,
    };

    this._trimEnd = transactionContext.trimEnd;

    // this is because transactions are also spans, and spans have a transaction pointer
    // TODO (v8): Replace this with another way to set the root span
    // eslint-disable-next-line deprecation/deprecation
    this.transaction = this;

    // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
    // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
    const incomingDynamicSamplingContext = this._metadata.dynamicSamplingContext;
    if (incomingDynamicSamplingContext) {
      // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
      this._frozenDynamicSamplingContext = { ...incomingDynamicSamplingContext };
    }
  }

  // This sadly conflicts with the getter/setter ordering :(
  /* eslint-disable @typescript-eslint/member-ordering */

  /**
   * Getter for `name` property.
   * @deprecated Use `spanToJSON(span).description` instead.
   */
   get name() {
    return this._name;
  }

  /**
   * Setter for `name` property, which also sets `source` as custom.
   * @deprecated Use `updateName()` and `setMetadata()` instead.
   */
   set name(newName) {
    // eslint-disable-next-line deprecation/deprecation
    this.setName(newName);
  }

  /**
   * Get the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */
   get metadata() {
    // We merge attributes in for backwards compatibility
    return {
      // Defaults
      // eslint-disable-next-line deprecation/deprecation
      source: 'custom',
      spanMetadata: {},

      // Legacy metadata
      ...this._metadata,

      // From attributes
      ...(this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] && {
        source: this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE] ,
      }),
      ...(this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] && {
        sampleRate: this._attributes[SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE] ,
      }),
    };
  }

  /**
   * Update the metadata for this transaction.
   * @deprecated Use `spanGetMetadata(transaction)` instead.
   */
   set metadata(metadata) {
    this._metadata = metadata;
  }

  /* eslint-enable @typescript-eslint/member-ordering */

  /**
   * Setter for `name` property, which also sets `source` on the metadata.
   *
   * @deprecated Use `.updateName()` and `.setAttribute()` instead.
   */
   setName(name, source = 'custom') {
    this._name = name;
    this.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SOURCE, source);
  }

  /** @inheritdoc */
   updateName(name) {
    this._name = name;
    return this;
  }

  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
   initSpanRecorder(maxlen = 1000) {
    // eslint-disable-next-line deprecation/deprecation
    if (!this.spanRecorder) {
      // eslint-disable-next-line deprecation/deprecation
      this.spanRecorder = new SpanRecorder(maxlen);
    }
    // eslint-disable-next-line deprecation/deprecation
    this.spanRecorder.add(this);
  }

  /**
   * Set the context of a transaction event.
   * @deprecated Use either `.setAttribute()`, or set the context on the scope before creating the transaction.
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }
  }

  /**
   * @inheritDoc
   *
   * @deprecated Use top-level `setMeasurement()` instead.
   */
   setMeasurement(name, value, unit = '') {
    this._measurements[name] = { value, unit };
  }

  /**
   * Store metadata on this transaction.
   * @deprecated Use attributes or store data on the scope instead.
   */
   setMetadata(newMetadata) {
    this._metadata = { ...this._metadata, ...newMetadata };
  }

  /**
   * @inheritDoc
   */
   end(endTimestamp) {
    const timestampInS = (0,spanUtils/* spanTimeInputToSeconds */.$k)(endTimestamp);
    const transaction = this._finishTransaction(timestampInS);
    if (!transaction) {
      return undefined;
    }
    // eslint-disable-next-line deprecation/deprecation
    return this._hub.captureEvent(transaction);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    // eslint-disable-next-line deprecation/deprecation
    const spanContext = super.toContext();

    return (0,object/* dropUndefinedKeys */.Jr)({
      ...spanContext,
      name: this._name,
      trimEnd: this._trimEnd,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(transactionContext) {
    // eslint-disable-next-line deprecation/deprecation
    super.updateWithContext(transactionContext);

    this._name = transactionContext.name || '';
    this._trimEnd = transactionContext.trimEnd;

    return this;
  }

  /**
   * @inheritdoc
   *
   * @experimental
   *
   * @deprecated Use top-level `getDynamicSamplingContextFromSpan` instead.
   */
   getDynamicSamplingContext() {
    return (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(this);
  }

  /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */
  // eslint-disable-next-line deprecation/deprecation
   setHub(hub) {
    this._hub = hub;
  }

  /**
   * Get the profile id of the transaction.
   */
   getProfileId() {
    if (this._contexts !== undefined && this._contexts['profile'] !== undefined) {
      return this._contexts['profile'].profile_id ;
    }
    return undefined;
  }

  /**
   * Finish the transaction & prepare the event to send to Sentry.
   */
   _finishTransaction(endTimestamp) {
    // This transaction is already finished, so we should not flush it again.
    if (this._endTime !== undefined) {
      return undefined;
    }

    if (!this._name) {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this._name = '<unlabeled transaction>';
    }

    // just sets the end timestamp
    super.end(endTimestamp);

    // eslint-disable-next-line deprecation/deprecation
    const client = this._hub.getClient();
    if (client && client.emit) {
      client.emit('finishTransaction', this);
    }

    if (this._sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

      if (client) {
        client.recordDroppedEvent('sample_rate', 'transaction');
      }

      return undefined;
    }

    // eslint-disable-next-line deprecation/deprecation
    const finishedSpans = this.spanRecorder
      ? // eslint-disable-next-line deprecation/deprecation
        this.spanRecorder.spans.filter(span => span !== this && (0,spanUtils/* spanToJSON */.XU)(span).timestamp)
      : [];

    if (this._trimEnd && finishedSpans.length > 0) {
      const endTimes = finishedSpans.map(span => (0,spanUtils/* spanToJSON */.XU)(span).timestamp).filter(Boolean) ;
      this._endTime = endTimes.reduce((prev, current) => {
        return prev > current ? prev : current;
      });
    }

    const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = getCapturedScopesOnSpan(this);

    // eslint-disable-next-line deprecation/deprecation
    const { metadata } = this;
    // eslint-disable-next-line deprecation/deprecation
    const { source } = metadata;

    const transaction = {
      contexts: {
        ...this._contexts,
        // We don't want to override trace context
        trace: (0,spanUtils/* spanToTraceContext */.wy)(this),
      },
      // TODO: Pass spans serialized via `spanToJSON()` here instead in v8.
      spans: finishedSpans,
      start_timestamp: this._startTime,
      // eslint-disable-next-line deprecation/deprecation
      tags: this.tags,
      timestamp: this._endTime,
      transaction: this._name,
      type: 'transaction',
      sdkProcessingMetadata: {
        ...metadata,
        capturedSpanScope,
        capturedSpanIsolationScope,
        ...(0,object/* dropUndefinedKeys */.Jr)({
          dynamicSamplingContext: (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(this),
        }),
      },
      _metrics_summary: getMetricSummaryJsonForSpan(this),
      ...(source && {
        transaction_info: {
          source,
        },
      }),
    };

    const hasMeasurements = Object.keys(this._measurements).length > 0;

    if (hasMeasurements) {
      debug_build/* DEBUG_BUILD */.X &&
        esm_logger/* logger.log */.kg.log(
          '[Measurements] Adding measurements to transaction',
          JSON.stringify(this._measurements, undefined, 2),
        );
      transaction.measurements = this._measurements;
    }

    // eslint-disable-next-line deprecation/deprecation
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`[Tracing] Finishing ${this.op} transaction: ${this._name}.`);

    return transaction;
  }
}


//# sourceMappingURL=transaction.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/idletransaction.js






const TRACING_DEFAULTS = {
  idleTimeout: 1000,
  finalTimeout: 30000,
  heartbeatInterval: 5000,
};

const FINISH_REASON_TAG = 'finishReason';

const IDLE_TRANSACTION_FINISH_REASONS = [
  'heartbeatFailed',
  'idleTimeout',
  'documentHidden',
  'finalTimeout',
  'externalFinish',
  'cancelled',
];

/**
 * @inheritDoc
 */
class IdleTransactionSpanRecorder extends SpanRecorder {
   constructor(
      _pushActivity,
      _popActivity,
     transactionSpanId,
    maxlen,
  ) {
    super(maxlen);this._pushActivity = _pushActivity;this._popActivity = _popActivity;this.transactionSpanId = transactionSpanId;  }

  /**
   * @inheritDoc
   */
   add(span) {
    // We should make sure we do not push and pop activities for
    // the transaction that this span recorder belongs to.
    if (span.spanContext().spanId !== this.transactionSpanId) {
      // We patch span.end() to pop an activity after setting an endTimestamp.
      // eslint-disable-next-line @typescript-eslint/unbound-method
      const originalEnd = span.end;
      span.end = (...rest) => {
        this._popActivity(span.spanContext().spanId);
        return originalEnd.apply(span, rest);
      };

      // We should only push new activities if the span does not have an end timestamp.
      if ((0,spanUtils/* spanToJSON */.XU)(span).timestamp === undefined) {
        this._pushActivity(span.spanContext().spanId);
      }
    }

    super.add(span);
  }
}

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
class IdleTransaction extends Transaction {
  // Activities store a list of active spans

  // Track state of activities in previous heartbeat

  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.

  // We should not use heartbeat if we finished a transaction

  // Idle timeout was canceled and we should finish the transaction with the last span end.

  /**
   * Timer that tracks Transaction idleTimeout
   */

  /**
   * @deprecated Transactions will be removed in v8. Use spans instead.
   */
   constructor(
    transactionContext,
    // eslint-disable-next-line deprecation/deprecation
      _idleHub,
    /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */
      _idleTimeout = TRACING_DEFAULTS.idleTimeout,
    /**
     * The final value in ms that a transaction cannot exceed
     */
      _finalTimeout = TRACING_DEFAULTS.finalTimeout,
      _heartbeatInterval = TRACING_DEFAULTS.heartbeatInterval,
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
      _onScope = false,
    /**
     * When set to `true`, will disable the idle timeout (`_idleTimeout` option) and heartbeat mechanisms (`_heartbeatInterval`
     * option) until the `sendAutoFinishSignal()` method is called. The final timeout mechanism (`_finalTimeout` option)
     * will not be affected by this option, meaning the transaction will definitely be finished when the final timeout is
     * reached, no matter what this option is configured to.
     *
     * Defaults to `false`.
     */
    delayAutoFinishUntilSignal = false,
  ) {
    super(transactionContext, _idleHub);this._idleHub = _idleHub;this._idleTimeout = _idleTimeout;this._finalTimeout = _finalTimeout;this._heartbeatInterval = _heartbeatInterval;this._onScope = _onScope;
    this.activities = {};
    this._heartbeatCounter = 0;
    this._finished = false;
    this._idleTimeoutCanceledPermanently = false;
    this._beforeFinishCallbacks = [];
    this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[4];
    this._autoFinishAllowed = !delayAutoFinishUntilSignal;

    if (_onScope) {
      // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`Setting idle transaction on scope. Span ID: ${this.spanContext().spanId}`);
      // eslint-disable-next-line deprecation/deprecation
      _idleHub.getScope().setSpan(this);
    }

    if (!delayAutoFinishUntilSignal) {
      this._restartIdleTimeout();
    }

    setTimeout(() => {
      if (!this._finished) {
        this.setStatus('deadline_exceeded');
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[3];
        this.end();
      }
    }, this._finalTimeout);
  }

  /** {@inheritDoc} */
   end(endTimestamp) {
    const endTimestampInS = (0,spanUtils/* spanTimeInputToSeconds */.$k)(endTimestamp);

    this._finished = true;
    this.activities = {};

    // eslint-disable-next-line deprecation/deprecation
    if (this.op === 'ui.action.click') {
      this.setAttribute(FINISH_REASON_TAG, this._finishReason);
    }

    // eslint-disable-next-line deprecation/deprecation
    if (this.spanRecorder) {
      debug_build/* DEBUG_BUILD */.X &&
        // eslint-disable-next-line deprecation/deprecation
        esm_logger/* logger.log */.kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestampInS * 1000).toISOString(), this.op);

      for (const callback of this._beforeFinishCallbacks) {
        callback(this, endTimestampInS);
      }

      // eslint-disable-next-line deprecation/deprecation
      this.spanRecorder.spans = this.spanRecorder.spans.filter((span) => {
        // If we are dealing with the transaction itself, we just return it
        if (span.spanContext().spanId === this.spanContext().spanId) {
          return true;
        }

        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
        if (!(0,spanUtils/* spanToJSON */.XU)(span).timestamp) {
          span.setStatus('cancelled');
          span.end(endTimestampInS);
          debug_build/* DEBUG_BUILD */.X &&
            esm_logger/* logger.log */.kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
        }

        const { start_timestamp: startTime, timestamp: endTime } = (0,spanUtils/* spanToJSON */.XU)(span);
        const spanStartedBeforeTransactionFinish = startTime && startTime < endTimestampInS;

        // Add a delta with idle timeout so that we prevent false positives
        const timeoutWithMarginOfError = (this._finalTimeout + this._idleTimeout) / 1000;
        const spanEndedBeforeFinalTimeout = endTime && startTime && endTime - startTime < timeoutWithMarginOfError;

        if (debug_build/* DEBUG_BUILD */.X) {
          const stringifiedSpan = JSON.stringify(span, undefined, 2);
          if (!spanStartedBeforeTransactionFinish) {
            esm_logger/* logger.log */.kg.log('[Tracing] discarding Span since it happened after Transaction was finished', stringifiedSpan);
          } else if (!spanEndedBeforeFinalTimeout) {
            esm_logger/* logger.log */.kg.log('[Tracing] discarding Span since it finished after Transaction final timeout', stringifiedSpan);
          }
        }

        return spanStartedBeforeTransactionFinish && spanEndedBeforeFinalTimeout;
      });

      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log('[Tracing] flushing IdleTransaction');
    } else {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log('[Tracing] No active IdleTransaction');
    }

    // if `this._onScope` is `true`, the transaction put itself on the scope when it started
    if (this._onScope) {
      // eslint-disable-next-line deprecation/deprecation
      const scope = this._idleHub.getScope();
      // eslint-disable-next-line deprecation/deprecation
      if (scope.getTransaction() === this) {
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(undefined);
      }
    }

    return super.end(endTimestamp);
  }

  /**
   * Register a callback function that gets executed before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
   registerBeforeFinishCallback(callback) {
    this._beforeFinishCallbacks.push(callback);
  }

  /**
   * @inheritDoc
   */
   initSpanRecorder(maxlen) {
    // eslint-disable-next-line deprecation/deprecation
    if (!this.spanRecorder) {
      const pushActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._pushActivity(id);
      };
      const popActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._popActivity(id);
      };

      // eslint-disable-next-line deprecation/deprecation
      this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanContext().spanId, maxlen);

      // Start heartbeat so that transactions do not run forever.
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log('Starting heartbeat');
      this._pingHeartbeat();
    }
    // eslint-disable-next-line deprecation/deprecation
    this.spanRecorder.add(this);
  }

  /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */
   cancelIdleTimeout(
    endTimestamp,
    {
      restartOnChildSpanChange,
    }

 = {
      restartOnChildSpanChange: true,
    },
  ) {
    this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
    if (this._idleTimeoutID) {
      clearTimeout(this._idleTimeoutID);
      this._idleTimeoutID = undefined;

      if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
        this.end(endTimestamp);
      }
    }
  }

  /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */
   setFinishReason(reason) {
    this._finishReason = reason;
  }

  /**
   * Permits the IdleTransaction to automatically end itself via the idle timeout and heartbeat mechanisms when the `delayAutoFinishUntilSignal` option was set to `true`.
   */
   sendAutoFinishSignal() {
    if (!this._autoFinishAllowed) {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log('[Tracing] Received finish signal for idle transaction.');
      this._restartIdleTimeout();
      this._autoFinishAllowed = true;
    }
  }

  /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */
   _restartIdleTimeout(endTimestamp) {
    this.cancelIdleTimeout();
    this._idleTimeoutID = setTimeout(() => {
      if (!this._finished && Object.keys(this.activities).length === 0) {
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[1];
        this.end(endTimestamp);
      }
    }, this._idleTimeout);
  }

  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
   _pushActivity(spanId) {
    this.cancelIdleTimeout(undefined, { restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently });
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`[Tracing] pushActivity: ${spanId}`);
    this.activities[spanId] = true;
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
  }

  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
   _popActivity(spanId) {
    if (this.activities[spanId]) {
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`[Tracing] popActivity ${spanId}`);
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this.activities[spanId];
      debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }

    if (Object.keys(this.activities).length === 0) {
      const endTimestamp = (0,esm_time/* timestampInSeconds */.ph)();
      if (this._idleTimeoutCanceledPermanently) {
        if (this._autoFinishAllowed) {
          this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[5];
          this.end(endTimestamp);
        }
      } else {
        // We need to add the timeout here to have the real endtimestamp of the transaction
        // Remember timestampInSeconds is in seconds, timeout is in ms
        this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
      }
    }
  }

  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
   _beat() {
    // We should not be running heartbeat if the idle transaction is finished.
    if (this._finished) {
      return;
    }

    const heartbeatString = Object.keys(this.activities).join('');

    if (heartbeatString === this._prevHeartbeatString) {
      this._heartbeatCounter++;
    } else {
      this._heartbeatCounter = 1;
    }

    this._prevHeartbeatString = heartbeatString;

    if (this._heartbeatCounter >= 3) {
      if (this._autoFinishAllowed) {
        debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
        this.setStatus('deadline_exceeded');
        this._finishReason = IDLE_TRANSACTION_FINISH_REASONS[0];
        this.end();
      }
    } else {
      this._pingHeartbeat();
    }
  }

  /**
   * Pings the heartbeat
   */
   _pingHeartbeat() {
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
    setTimeout(() => {
      this._beat();
    }, this._heartbeatInterval);
  }
}


//# sourceMappingURL=idletransaction.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/utils.js




/**
 * Grabs active transaction off scope.
 *
 * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
 */
// eslint-disable-next-line deprecation/deprecation
function getActiveTransaction(maybeHub) {
  // eslint-disable-next-line deprecation/deprecation
  const hub = maybeHub || (0,esm_hub/* getCurrentHub */.Gd)();
  // eslint-disable-next-line deprecation/deprecation
  const scope = hub.getScope();
  // eslint-disable-next-line deprecation/deprecation
  return scope.getTransaction() ;
}

/**
 * The `extractTraceparentData` function and `TRACEPARENT_REGEXP` constant used
 * to be declared in this file. It was later moved into `@sentry/utils` as part of a
 * move to remove `@sentry/tracing` dependencies from `@sentry/node` (`extractTraceparentData`
 * is the only tracing function used by `@sentry/node`).
 *
 * These exports are kept here for backwards compatability's sake.
 *
 * See https://github.com/getsentry/sentry-javascript/issues/4642 for more details.
 *
 * @deprecated Import this function from `@sentry/utils` instead
 */
const extractTraceparentData = (/* unused pure expression or super */ null && (extractTraceparentData$1));


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/errors.js




let errorsInstrumented = false;

/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
  if (errorsInstrumented) {
    return;
  }

  errorsInstrumented = true;
  addGlobalErrorInstrumentationHandler(errorCallback);
  addGlobalUnhandledRejectionInstrumentationHandler(errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
  // eslint-disable-next-line deprecation/deprecation
  const activeTransaction = getActiveTransaction();
  if (activeTransaction) {
    const status = 'internal_error';
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.log */.kg.log(`[Tracing] Transaction: ${status} -> Global error occured`);
    activeTransaction.setStatus(status);
  }
}

// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
errorCallback.tag = 'sentry_tracingErrorCallback';


//# sourceMappingURL=errors.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/sampling.js






/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * This method muttes the given `transaction` and will set the `sampled` value on it.
 * It returns the same transaction, for convenience.
 */
function sampleTransaction(
  transaction,
  options,
  samplingContext,
) {
  // nothing to do if tracing is not enabled
  if (!hasTracingEnabled_hasTracingEnabled(options)) {
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = false;
    return transaction;
  }

  // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
  // eslint-disable-next-line deprecation/deprecation
  if (transaction.sampled !== undefined) {
    // eslint-disable-next-line deprecation/deprecation
    transaction.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE, Number(transaction.sampled));
    return transaction;
  }

  // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
  // work; prefer the hook if so
  let sampleRate;
  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(samplingContext);
    transaction.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE, Number(sampleRate));
  } else if (samplingContext.parentSampled !== undefined) {
    sampleRate = samplingContext.parentSampled;
  } else if (typeof options.tracesSampleRate !== 'undefined') {
    sampleRate = options.tracesSampleRate;
    transaction.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE, Number(sampleRate));
  } else {
    // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    transaction.setAttribute(SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE, sampleRate);
  }

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(sampleRate)) {
    debug_build/* DEBUG_BUILD */.X && esm_logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = false;
    return transaction;
  }

  // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
  if (!sampleRate) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because ${
          typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'
        }`,
      );
    // eslint-disable-next-line deprecation/deprecation
    transaction.sampled = false;
    return transaction;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  // eslint-disable-next-line deprecation/deprecation
  transaction.sampled = Math.random() < (sampleRate );

  // if we're not going to keep it, we're done
  // eslint-disable-next-line deprecation/deprecation
  if (!transaction.sampled) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
          sampleRate,
        )})`,
      );
    return transaction;
  }

  debug_build/* DEBUG_BUILD */.X &&
    // eslint-disable-next-line deprecation/deprecation
    esm_logger/* logger.log */.kg.log(`[Tracing] starting ${transaction.op} transaction - ${(0,spanUtils/* spanToJSON */.XU)(transaction).description}`);
  return transaction;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.warn */.kg.warn(
        `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.warn */.kg.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}


//# sourceMappingURL=sampling.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/hubextensions.js









/** Returns all trace headers that are currently on the top scope. */
// eslint-disable-next-line deprecation/deprecation
function traceHeaders() {
  // eslint-disable-next-line deprecation/deprecation
  const scope = this.getScope();
  // eslint-disable-next-line deprecation/deprecation
  const span = scope.getSpan();

  return span
    ? {
        'sentry-trace': (0,spanUtils/* spanToTraceHeader */.Hb)(span),
      }
    : {};
}

/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(
  // eslint-disable-next-line deprecation/deprecation

  transactionContext,
  customSamplingContext,
) {
  // eslint-disable-next-line deprecation/deprecation
  const client = this.getClient();
  const options = (client && client.getOptions()) || {};

  const configInstrumenter = options.instrumenter || 'sentry';
  const transactionInstrumenter = transactionContext.instrumenter || 'sentry';

  if (configInstrumenter !== transactionInstrumenter) {
    debug_build/* DEBUG_BUILD */.X &&
      esm_logger/* logger.error */.kg.error(
        `A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`,
      );

    // eslint-disable-next-line deprecation/deprecation
    transactionContext.sampled = false;
  }

  // eslint-disable-next-line deprecation/deprecation
  let transaction = new Transaction(transactionContext, this);
  transaction = sampleTransaction(transaction, options, {
    name: transactionContext.name,
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    attributes: {
      // eslint-disable-next-line deprecation/deprecation
      ...transactionContext.data,
      ...transactionContext.attributes,
    },
    ...customSamplingContext,
  });
  if (transaction.isRecording()) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  if (client && client.emit) {
    client.emit('startTransaction', transaction);
  }
  return transaction;
}

/**
 * Create new idle transaction.
 */
function startIdleTransaction(
  // eslint-disable-next-line deprecation/deprecation
  hub,
  transactionContext,
  idleTimeout,
  finalTimeout,
  onScope,
  customSamplingContext,
  heartbeatInterval,
  delayAutoFinishUntilSignal = false,
) {
  // eslint-disable-next-line deprecation/deprecation
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {};

  // eslint-disable-next-line deprecation/deprecation
  let transaction = new IdleTransaction(
    transactionContext,
    hub,
    idleTimeout,
    finalTimeout,
    heartbeatInterval,
    onScope,
    delayAutoFinishUntilSignal,
  );
  transaction = sampleTransaction(transaction, options, {
    name: transactionContext.name,
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    attributes: {
      // eslint-disable-next-line deprecation/deprecation
      ...transactionContext.data,
      ...transactionContext.attributes,
    },
    ...customSamplingContext,
  });
  if (transaction.isRecording()) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  if (client && client.emit) {
    client.emit('startTransaction', transaction);
  }
  return transaction;
}

/**
 * Adds tracing extensions to the global hub.
 */
function addTracingExtensions() {
  const carrier = (0,esm_hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }
  carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
  if (!carrier.__SENTRY__.extensions.startTransaction) {
    carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
  }
  if (!carrier.__SENTRY__.extensions.traceHeaders) {
    carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
  }

  registerErrorInstrumentation();
}


//# sourceMappingURL=hubextensions.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/tracing.js
var tracing = __webpack_require__(49691);
;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/common/debug-build.js
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const common_debug_build_DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);


//# sourceMappingURL=debug-build.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/types.js


const types_WINDOW = worldwide/* GLOBAL_OBJ */.n2

;


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/backgroundtab.js





/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (types_WINDOW.document) {
    types_WINDOW.document.addEventListener('visibilitychange', () => {
      // eslint-disable-next-line deprecation/deprecation
      const activeTransaction = getActiveTransaction() ;
      if (types_WINDOW.document.hidden && activeTransaction) {
        const statusType = 'cancelled';

        const { op, status } = (0,spanUtils/* spanToJSON */.XU)(activeTransaction);

        common_debug_build_DEBUG_BUILD &&
          esm_logger/* logger.log */.kg.log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${op}`);
        // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.
        if (!status) {
          activeTransaction.setStatus(statusType);
        }
        // TODO: Can we rewrite this to an attribute?
        // eslint-disable-next-line deprecation/deprecation
        activeTransaction.setTag('visibilitychange', 'document.hidden');
        activeTransaction.end();
      }
    });
  } else {
    common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}


//# sourceMappingURL=backgroundtab.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/bindReporter.js
const bindReporter = (
  callback,
  metric,
  reportAllChanges,
) => {
  let prevValue;
  let delta;
  return (forceReport) => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        delta = metric.value - (prevValue || 0);

        // Report the metric if there's a non-zero delta or if no previous
        // value exists (which can happen in the case of the document becoming
        // hidden when the metric value is 0).
        // See: https://github.com/GoogleChrome/web-vitals/issues/14
        if (delta || prevValue === undefined) {
          prevValue = metric.value;
          metric.delta = delta;
          callback(metric);
        }
      }
    }
  };
};


//# sourceMappingURL=bindReporter.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
const generateUniqueID = () => {
  return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


//# sourceMappingURL=generateUniqueID.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getNavigationEntry.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getNavigationEntryFromPerformanceTiming = () => {
  // eslint-disable-next-line deprecation/deprecation
  const timing = types_WINDOW.performance.timing;
  // eslint-disable-next-line deprecation/deprecation
  const type = types_WINDOW.performance.navigation.type;

  const navigationEntry = {
    entryType: 'navigation',
    startTime: 0,
    type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate',
  };

  for (const key in timing) {
    if (key !== 'navigationStart' && key !== 'toJSON') {
      // eslint-disable-next-line deprecation/deprecation
      navigationEntry[key] = Math.max((timing[key ] ) - timing.navigationStart, 0);
    }
  }
  return navigationEntry ;
};

const getNavigationEntry = () => {
  if (types_WINDOW.__WEB_VITALS_POLYFILL__) {
    return (
      types_WINDOW.performance &&
      ((performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) ||
        getNavigationEntryFromPerformanceTiming())
    );
  } else {
    return types_WINDOW.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  }
};


//# sourceMappingURL=getNavigationEntry.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getActivationStart.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getActivationStart = () => {
  const navEntry = getNavigationEntry();
  return (navEntry && navEntry.activationStart) || 0;
};


//# sourceMappingURL=getActivationStart.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/initMetric.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const initMetric = (name, value) => {
  const navEntry = getNavigationEntry();
  let navigationType = 'navigate';

  if (navEntry) {
    if ((types_WINDOW.document && types_WINDOW.document.prerendering) || getActivationStart() > 0) {
      navigationType = 'prerender';
    } else {
      navigationType = navEntry.type.replace(/_/g, '-') ;
    }
  }

  return {
    name,
    value: typeof value === 'undefined' ? -1 : value,
    rating: 'good', // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: generateUniqueID(),
    navigationType,
  };
};


//# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/observe.js
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
const observe = (
  type,
  callback,
  opts,
) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      const po = new PerformanceObserver(list => {
        callback(list.getEntries() );
      });
      po.observe(
        Object.assign(
          {
            type,
            buffered: true,
          },
          opts || {},
        ) ,
      );
      return po;
    }
  } catch (e) {
    // Do nothing.
  }
  return;
};


//# sourceMappingURL=observe.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/onHidden.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const onHidden = (cb, once) => {
  const onHiddenOrPageHide = (event) => {
    if (event.type === 'pagehide' || types_WINDOW.document.visibilityState === 'hidden') {
      cb(event);
      if (once) {
        removeEventListener('visibilitychange', onHiddenOrPageHide, true);
        removeEventListener('pagehide', onHiddenOrPageHide, true);
      }
    }
  };

  if (types_WINDOW.document) {
    addEventListener('visibilitychange', onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener('pagehide', onHiddenOrPageHide, true);
  }
};


//# sourceMappingURL=onHidden.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getCLS.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onCLS = (
  onReport,
  options = {},
) => {
  const metric = initMetric('CLS', 0);
  let report;

  let sessionValue = 0;
  let sessionEntries = [];

  // const handleEntries = (entries: Metric['entries']) => {
  const handleEntries = (entries) => {
    entries.forEach(entry => {
      // Only count layout shifts without recent user input.
      if (!entry.hadRecentInput) {
        const firstSessionEntry = sessionEntries[0];
        const lastSessionEntry = sessionEntries[sessionEntries.length - 1];

        // If the entry occurred less than 1 second after the previous entry and
        // less than 5 seconds after the first entry in the session, include the
        // entry in the current session. Otherwise, start a new session.
        if (
          sessionValue &&
          sessionEntries.length !== 0 &&
          entry.startTime - lastSessionEntry.startTime < 1000 &&
          entry.startTime - firstSessionEntry.startTime < 5000
        ) {
          sessionValue += entry.value;
          sessionEntries.push(entry);
        } else {
          sessionValue = entry.value;
          sessionEntries = [entry];
        }

        // If the current session value is larger than the current CLS value,
        // update CLS and the entries contributing to it.
        if (sessionValue > metric.value) {
          metric.value = sessionValue;
          metric.entries = sessionEntries;
          if (report) {
            report();
          }
        }
      }
    });
  };

  const po = observe('layout-shift', handleEntries);
  if (po) {
    report = bindReporter(onReport, metric, options.reportAllChanges);

    const stopListening = () => {
      handleEntries(po.takeRecords() );
      report(true);
    };

    onHidden(stopListening);

    return stopListening;
  }

  return;
};


//# sourceMappingURL=getCLS.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let firstHiddenTime = -1;

const initHiddenTime = () => {
  // If the document is hidden and not prerendering, assume it was always
  // hidden and the page was loaded in the background.
  if (types_WINDOW.document && types_WINDOW.document.visibilityState) {
    firstHiddenTime = types_WINDOW.document.visibilityState === 'hidden' && !types_WINDOW.document.prerendering ? 0 : Infinity;
  }
};

const trackChanges = () => {
  // Update the time if/when the document becomes hidden.
  onHidden(({ timeStamp }) => {
    firstHiddenTime = timeStamp;
  }, true);
};

const getVisibilityWatcher = (

) => {
  if (firstHiddenTime < 0) {
    // If the document is hidden when this code runs, assume it was hidden
    // since navigation start. This isn't a perfect heuristic, but it's the
    // best we can do until an API is available to support querying past
    // visibilityState.
    initHiddenTime();
    trackChanges();
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    },
  };
};


//# sourceMappingURL=getVisibilityWatcher.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getFID.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */
const onFID = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('FID');
  // eslint-disable-next-line prefer-const
  let report;

  const handleEntry = (entry) => {
    // Only report if the page wasn't hidden prior to the first input.
    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
      metric.value = entry.processingStart - entry.startTime;
      metric.entries.push(entry);
      report(true);
    }
  };

  const handleEntries = (entries) => {
    (entries ).forEach(handleEntry);
  };

  const po = observe('first-input', handleEntries);
  report = bindReporter(onReport, metric);

  if (po) {
    onHidden(() => {
      handleEntries(po.takeRecords() );
      po.disconnect();
    }, true);
  }
};


//# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/lib/polyfills/interactionCountPolyfill.js


let interactionCountEstimate = 0;
let minKnownInteractionId = Infinity;
let maxKnownInteractionId = 0;

const updateEstimate = (entries) => {
  (entries ).forEach(e => {
    if (e.interactionId) {
      minKnownInteractionId = Math.min(minKnownInteractionId, e.interactionId);
      maxKnownInteractionId = Math.max(maxKnownInteractionId, e.interactionId);

      interactionCountEstimate = maxKnownInteractionId ? (maxKnownInteractionId - minKnownInteractionId) / 7 + 1 : 0;
    }
  });
};

let po;

/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */
const getInteractionCount = () => {
  return po ? interactionCountEstimate : performance.interactionCount || 0;
};

/**
 * Feature detects native support or initializes the polyfill if needed.
 */
const initInteractionCountPolyfill = () => {
  if ('interactionCount' in performance || po) return;

  po = observe('event', updateEstimate, {
    type: 'event',
    buffered: true,
    durationThreshold: 0,
  } );
};


//# sourceMappingURL=interactionCountPolyfill.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getINP.js






/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */
const getInteractionCountForNavigation = () => {
  return getInteractionCount();
};

// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const MAX_INTERACTIONS_TO_CONSIDER = 10;

// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const longestInteractionList = [];

// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const longestInteractionMap = {};

/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */
const processEntry = (entry) => {
  // The least-long of the 10 longest interactions.
  const minLongestInteraction = longestInteractionList[longestInteractionList.length - 1];

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const existingInteraction = longestInteractionMap[entry.interactionId];

  // Only process the entry if it's possibly one of the ten longest,
  // or if it's part of an existing interaction.
  if (
    existingInteraction ||
    longestInteractionList.length < MAX_INTERACTIONS_TO_CONSIDER ||
    entry.duration > minLongestInteraction.latency
  ) {
    // If the interaction already exists, update it. Otherwise create one.
    if (existingInteraction) {
      existingInteraction.entries.push(entry);
      existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
    } else {
      const interaction = {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        id: entry.interactionId,
        latency: entry.duration,
        entries: [entry],
      };
      longestInteractionMap[interaction.id] = interaction;
      longestInteractionList.push(interaction);
    }

    // Sort the entries by latency (descending) and keep only the top ten.
    longestInteractionList.sort((a, b) => b.latency - a.latency);
    longestInteractionList.splice(MAX_INTERACTIONS_TO_CONSIDER).forEach(i => {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete longestInteractionMap[i.id];
    });
  }
};

/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */
const estimateP98LongestInteraction = () => {
  const candidateInteractionIndex = Math.min(
    longestInteractionList.length - 1,
    Math.floor(getInteractionCountForNavigation() / 50),
  );

  return longestInteractionList[candidateInteractionIndex];
};

/**
 * Calculates the [INP](https://web.dev/responsiveness/) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/inp/#what-is-a-good-inp-score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onINP = (onReport, opts) => {
  // Set defaults
  // eslint-disable-next-line no-param-reassign
  opts = opts || {};

  // https://web.dev/inp/#what's-a-%22good%22-inp-value
  // const thresholds = [200, 500];

  // TODO(philipwalton): remove once the polyfill is no longer needed.
  initInteractionCountPolyfill();

  const metric = initMetric('INP');
  // eslint-disable-next-line prefer-const
  let report;

  const handleEntries = (entries) => {
    entries.forEach(entry => {
      if (entry.interactionId) {
        processEntry(entry);
      }

      // Entries of type `first-input` don't currently have an `interactionId`,
      // so to consider them in INP we have to first check that an existing
      // entry doesn't match the `duration` and `startTime`.
      // Note that this logic assumes that `event` entries are dispatched
      // before `first-input` entries. This is true in Chrome but it is not
      // true in Firefox; however, Firefox doesn't support interactionId, so
      // it's not an issue at the moment.
      // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
      if (entry.entryType === 'first-input') {
        const noMatchingEntry = !longestInteractionList.some(interaction => {
          return interaction.entries.some(prevEntry => {
            return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
          });
        });
        if (noMatchingEntry) {
          processEntry(entry);
        }
      }
    });

    const inp = estimateP98LongestInteraction();

    if (inp && inp.latency !== metric.value) {
      metric.value = inp.latency;
      metric.entries = inp.entries;
      report();
    }
  };

  const po = observe('event', handleEntries, {
    // Event Timing entries have their durations rounded to the nearest 8ms,
    // so a duration of 40ms would be any event that spans 2.5 or more frames
    // at 60Hz. This threshold is chosen to strike a balance between usefulness
    // and performance. Running this callback for any interaction that spans
    // just one or two frames is likely not worth the insight that could be
    // gained.
    durationThreshold: opts.durationThreshold || 40,
  } );

  report = bindReporter(onReport, metric, opts.reportAllChanges);

  if (po) {
    // Also observe entries of type `first-input`. This is useful in cases
    // where the first interaction is less than the `durationThreshold`.
    po.observe({ type: 'first-input', buffered: true });

    onHidden(() => {
      handleEntries(po.takeRecords() );

      // If the interaction count shows that there were interactions but
      // none were captured by the PerformanceObserver, report a latency of 0.
      if (metric.value < 0 && getInteractionCountForNavigation() > 0) {
        metric.value = 0;
        metric.entries = [];
      }

      report(true);
    });
  }
};


//# sourceMappingURL=getINP.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/getLCP.js








/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const reportedMetricIDs = {};

/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */
const onLCP = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('LCP');
  let report;

  const handleEntries = (entries) => {
    const lastEntry = entries[entries.length - 1] ;
    if (lastEntry) {
      // The startTime attribute returns the value of the renderTime if it is
      // not 0, and the value of the loadTime otherwise. The activationStart
      // reference is used because LCP should be relative to page activation
      // rather than navigation start if the page was prerendered.
      const value = Math.max(lastEntry.startTime - getActivationStart(), 0);

      // Only report if the page wasn't hidden prior to LCP.
      if (value < visibilityWatcher.firstHiddenTime) {
        metric.value = value;
        metric.entries = [lastEntry];
        report();
      }
    }
  };

  const po = observe('largest-contentful-paint', handleEntries);

  if (po) {
    report = bindReporter(onReport, metric);

    const stopListening = () => {
      if (!reportedMetricIDs[metric.id]) {
        handleEntries(po.takeRecords() );
        po.disconnect();
        reportedMetricIDs[metric.id] = true;
        report(true);
      }
    };

    // Stop listening after input. Note: while scrolling is an input that
    // stop LCP observation, it's unreliable since it can be programmatically
    // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
    ['keydown', 'click'].forEach(type => {
      if (types_WINDOW.document) {
        addEventListener(type, stopListening, { once: true, capture: true });
      }
    });

    onHidden(stopListening, true);

    return stopListening;
  }

  return;
};


//# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/web-vitals/onTTFB.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */
const whenReady = (callback) => {
  if (!types_WINDOW.document) {
    return;
  }

  if (types_WINDOW.document.prerendering) {
    addEventListener('prerenderingchange', () => whenReady(callback), true);
  } else if (types_WINDOW.document.readyState !== 'complete') {
    addEventListener('load', () => whenReady(callback), true);
  } else {
    // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
  }
};

/**
 * Calculates the [TTFB](https://web.dev/time-to-first-byte/) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */
const onTTFB = (onReport, opts) => {
  // Set defaults
  // eslint-disable-next-line no-param-reassign
  opts = opts || {};

  // https://web.dev/ttfb/#what-is-a-good-ttfb-score
  // const thresholds = [800, 1800];

  const metric = initMetric('TTFB');
  const report = bindReporter(onReport, metric, opts.reportAllChanges);

  whenReady(() => {
    const navEntry = getNavigationEntry() ;

    if (navEntry) {
      // The activationStart reference is used because TTFB should be
      // relative to page activation rather than navigation start if the
      // page was prerendered. But in cases where `activationStart` occurs
      // after the first byte is received, this time should be clamped at 0.
      metric.value = Math.max(navEntry.responseStart - getActivationStart(), 0);

      // In some cases the value reported is negative or is larger
      // than the current page time. Ignore these cases:
      // https://github.com/GoogleChrome/web-vitals/issues/137
      // https://github.com/GoogleChrome/web-vitals/issues/162
      if (metric.value < 0 || metric.value > performance.now()) return;

      metric.entries = [navEntry];

      report(true);
    }
  });
};


//# sourceMappingURL=onTTFB.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/instrument.js









const instrument_handlers = {};
const instrument_instrumented = {};

let _previousCls;
let _previousFid;
let _previousLcp;
let _previousTtfb;
let _previousInp;

/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */
function addClsInstrumentationHandler(
  callback,
  stopOnCallback = false,
) {
  return addMetricObserver('cls', callback, instrumentCls, _previousCls, stopOnCallback);
}

/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */
function addLcpInstrumentationHandler(
  callback,
  stopOnCallback = false,
) {
  return addMetricObserver('lcp', callback, instrumentLcp, _previousLcp, stopOnCallback);
}

/**
 * Add a callback that will be triggered when a FID metric is available.
 */
function addTtfbInstrumentationHandler(callback) {
  return addMetricObserver('ttfb', callback, instrumentTtfb, _previousTtfb);
}

/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addFidInstrumentationHandler(callback) {
  return addMetricObserver('fid', callback, instrumentFid, _previousFid);
}

/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addInpInstrumentationHandler(
  callback,
) {
  return addMetricObserver('inp', callback, instrumentInp, _previousInp);
}

/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */
function addPerformanceInstrumentationHandler(
  type,
  callback,
) {
  instrument_addHandler(type, callback);

  if (!instrument_instrumented[type]) {
    instrumentPerformanceObserver(type);
    instrument_instrumented[type] = true;
  }

  return getCleanupCallback(type, callback);
}

/** Trigger all handlers of a given type. */
function instrument_triggerHandlers(type, data) {
  const typeHandlers = instrument_handlers[type];

  if (!typeHandlers || !typeHandlers.length) {
    return;
  }

  for (const handler of typeHandlers) {
    try {
      handler(data);
    } catch (e) {
      common_debug_build_DEBUG_BUILD &&
        esm_logger/* logger.error */.kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,stacktrace/* getFunctionName */.$P)(handler)}\nError:`,
          e,
        );
    }
  }
}

function instrumentCls() {
  return onCLS(
    metric => {
      instrument_triggerHandlers('cls', {
        metric,
      });
      _previousCls = metric;
    },
    { reportAllChanges: true },
  );
}

function instrumentFid() {
  return onFID(metric => {
    instrument_triggerHandlers('fid', {
      metric,
    });
    _previousFid = metric;
  });
}

function instrumentLcp() {
  return onLCP(metric => {
    instrument_triggerHandlers('lcp', {
      metric,
    });
    _previousLcp = metric;
  });
}

function instrumentTtfb() {
  return onTTFB(metric => {
    instrument_triggerHandlers('ttfb', {
      metric,
    });
    _previousTtfb = metric;
  });
}

function instrumentInp() {
  return onINP(metric => {
    instrument_triggerHandlers('inp', {
      metric,
    });
    _previousInp = metric;
  });
}

function addMetricObserver(
  type,
  callback,
  instrumentFn,
  previousValue,
  stopOnCallback = false,
) {
  instrument_addHandler(type, callback);

  let stopListening;

  if (!instrument_instrumented[type]) {
    stopListening = instrumentFn();
    instrument_instrumented[type] = true;
  }

  if (previousValue) {
    callback({ metric: previousValue });
  }

  return getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}

function instrumentPerformanceObserver(type) {
  const options = {};

  // Special per-type options we want to use
  if (type === 'event') {
    options.durationThreshold = 0;
  }

  observe(
    type,
    entries => {
      instrument_triggerHandlers(type, { entries });
    },
    options,
  );
}

function instrument_addHandler(type, handler) {
  instrument_handlers[type] = instrument_handlers[type] || [];
  (instrument_handlers[type] ).push(handler);
}

// Get a callback which can be called to remove the instrumentation handler
function getCleanupCallback(
  type,
  callback,
  stopListening,
) {
  return () => {
    if (stopListening) {
      stopListening();
    }

    const typeHandlers = instrument_handlers[type];

    if (!typeHandlers) {
      return;
    }

    const index = typeHandlers.indexOf(callback);
    if (index !== -1) {
      typeHandlers.splice(index, 1);
    }
  };
}


//# sourceMappingURL=instrument.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/span.js


/**
 * Create envelope from Span item.
 */
function createSpanEnvelope(spans, dsn) {
  const headers = {
    sent_at: new Date().toISOString(),
  };

  if (dsn) {
    headers.dsn = dsn_dsnToString(dsn);
  }

  const items = spans.map(createSpanItem);
  return createEnvelope(headers, items);
}

function createSpanItem(span) {
  const spanHeaders = {
    type: 'span',
  };
  return [spanHeaders, span];
}


//# sourceMappingURL=span.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/core/esm/tracing/measurement.js


/**
 * Adds a measurement to the current active transaction.
 */
function setMeasurement(name, value, unit) {
  // eslint-disable-next-line deprecation/deprecation
  const transaction = getActiveTransaction();
  if (transaction) {
    // eslint-disable-next-line deprecation/deprecation
    transaction.setMeasurement(name, value, unit);
  }
}


//# sourceMappingURL=measurement.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 *
 * Note: this will not be possible anymore in v8,
 * unless we do some special handling for browser here...
 */
function _startChild(transaction, { startTimestamp, ...ctx }) {
  // eslint-disable-next-line deprecation/deprecation
  if (startTimestamp && transaction.startTimestamp > startTimestamp) {
    // eslint-disable-next-line deprecation/deprecation
    transaction.startTimestamp = startTimestamp;
  }

  // eslint-disable-next-line deprecation/deprecation
  return transaction.startChild({
    startTimestamp,
    ...ctx,
  });
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/metrics/index.js









const MAX_INT_AS_BYTES = 2147483647;

/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
  return time / 1000;
}

function getBrowserPerformanceAPI() {
  // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
  return types_WINDOW && types_WINDOW.addEventListener && types_WINDOW.performance;
}

let _performanceCursor = 0;

let _measurements = {};
let _lcpEntry;
let _clsEntry;

/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */
function startTrackingWebVitals() {
  const performance = getBrowserPerformanceAPI();
  if (performance && esm_time/* browserPerformanceTimeOrigin */.Z1) {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    if (performance.mark) {
      types_WINDOW.performance.mark('sentry-tracing-init');
    }
    const fidCallback = _trackFID();
    const clsCallback = _trackCLS();
    const lcpCallback = _trackLCP();
    const ttfbCallback = _trackTtfb();

    return () => {
      fidCallback();
      clsCallback();
      lcpCallback();
      ttfbCallback();
    };
  }

  return () => undefined;
}

/**
 * Start tracking long tasks.
 */
function startTrackingLongTasks() {
  addPerformanceInstrumentationHandler('longtask', ({ entries }) => {
    for (const entry of entries) {
      // eslint-disable-next-line deprecation/deprecation
      const transaction = getActiveTransaction() ;
      if (!transaction) {
        return;
      }
      const startTime = msToSec((esm_time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
      const duration = msToSec(entry.duration);

      // eslint-disable-next-line deprecation/deprecation
      transaction.startChild({
        description: 'Main UI thread blocked',
        op: 'ui.long-task',
        origin: 'auto.ui.browser.metrics',
        startTimestamp: startTime,
        endTimestamp: startTime + duration,
      });
    }
  });
}

/**
 * Start tracking interaction events.
 */
function startTrackingInteractions() {
  addPerformanceInstrumentationHandler('event', ({ entries }) => {
    for (const entry of entries) {
      // eslint-disable-next-line deprecation/deprecation
      const transaction = getActiveTransaction() ;
      if (!transaction) {
        return;
      }

      if (entry.name === 'click') {
        const startTime = msToSec((esm_time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
        const duration = msToSec(entry.duration);

        const span = {
          description: (0,browser/* htmlTreeAsString */.Rt)(entry.target),
          op: `ui.interaction.${entry.name}`,
          origin: 'auto.ui.browser.metrics',
          startTimestamp: startTime,
          endTimestamp: startTime + duration,
        };

        const componentName = (0,browser/* getComponentName */.iY)(entry.target);
        if (componentName) {
          span.attributes = { 'ui.component_name': componentName };
        }

        // eslint-disable-next-line deprecation/deprecation
        transaction.startChild(span);
      }
    }
  });
}

/**
 * Start tracking INP webvital events.
 */
function startTrackingINP(
  interactionIdtoRouteNameMapping,
  interactionsSampleRate,
) {
  const performance = getBrowserPerformanceAPI();
  if (performance && esm_time/* browserPerformanceTimeOrigin */.Z1) {
    const inpCallback = _trackINP(interactionIdtoRouteNameMapping, interactionsSampleRate);

    return () => {
      inpCallback();
    };
  }

  return () => undefined;
}

/** Starts tracking the Cumulative Layout Shift on the current page. */
function _trackCLS() {
  return addClsInstrumentationHandler(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }

    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS');
    _measurements['cls'] = { value: metric.value, unit: '' };
    _clsEntry = entry ;
  }, true);
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP() {
  return addLcpInstrumentationHandler(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }

    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP');
    _measurements['lcp'] = { value: metric.value, unit: 'millisecond' };
    _lcpEntry = entry ;
  }, true);
}

/** Starts tracking the First Input Delay on the current page. */
function _trackFID() {
  return addFidInstrumentationHandler(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }

    const timeOrigin = msToSec(esm_time/* browserPerformanceTimeOrigin */.Z1 );
    const startTime = msToSec(entry.startTime);
    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Measurements] Adding FID');
    _measurements['fid'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.fid'] = { value: timeOrigin + startTime, unit: 'second' };
  });
}

function _trackTtfb() {
  return addTtfbInstrumentationHandler(({ metric }) => {
    const entry = metric.entries[metric.entries.length - 1];
    if (!entry) {
      return;
    }

    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
    _measurements['ttfb'] = { value: metric.value, unit: 'millisecond' };
  });
}

const INP_ENTRY_MAP = {
  click: 'click',
  pointerdown: 'click',
  pointerup: 'click',
  mousedown: 'click',
  mouseup: 'click',
  touchstart: 'click',
  touchend: 'click',
  mouseover: 'hover',
  mouseout: 'hover',
  mouseenter: 'hover',
  mouseleave: 'hover',
  pointerover: 'hover',
  pointerout: 'hover',
  pointerenter: 'hover',
  pointerleave: 'hover',
  dragstart: 'drag',
  dragend: 'drag',
  drag: 'drag',
  dragenter: 'drag',
  dragleave: 'drag',
  dragover: 'drag',
  drop: 'drag',
  keydown: 'press',
  keyup: 'press',
  keypress: 'press',
  input: 'press',
};

/** Starts tracking the Interaction to Next Paint on the current page. */
function _trackINP(
  interactionIdToRouteNameMapping,
  interactionsSampleRate,
) {
  return addInpInstrumentationHandler(({ metric }) => {
    if (metric.value === undefined) {
      return;
    }
    const entry = metric.entries.find(
      entry => entry.duration === metric.value && INP_ENTRY_MAP[entry.name] !== undefined,
    );
    const client = (0,esm_exports/* getClient */.s3)();
    if (!entry || !client) {
      return;
    }
    const interactionType = INP_ENTRY_MAP[entry.name];
    const options = client.getOptions();
    /** Build the INP span, create an envelope from the span, and then send the envelope */
    const startTime = msToSec((esm_time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
    const duration = msToSec(metric.value);
    const interaction =
      entry.interactionId !== undefined ? interactionIdToRouteNameMapping[entry.interactionId] : undefined;
    if (interaction === undefined) {
      return;
    }
    const { routeName, parentContext, activeTransaction, user, replayId } = interaction;
    const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
    // eslint-disable-next-line deprecation/deprecation
    const profileId = activeTransaction !== undefined ? activeTransaction.getProfileId() : undefined;
    const span = new Span({
      startTimestamp: startTime,
      endTimestamp: startTime + duration,
      op: `ui.interaction.${interactionType}`,
      name: (0,browser/* htmlTreeAsString */.Rt)(entry.target),
      attributes: {
        release: options.release,
        environment: options.environment,
        transaction: routeName,
        ...(userDisplay !== undefined && userDisplay !== '' ? { user: userDisplay } : {}),
        ...(profileId !== undefined ? { profile_id: profileId } : {}),
        ...(replayId !== undefined ? { replay_id: replayId } : {}),
      },
      exclusiveTime: metric.value,
      measurements: {
        inp: { value: metric.value, unit: 'millisecond' },
      },
    });

    /** Check to see if the span should be sampled */
    const sampleRate = getSampleRate(parentContext, options, interactionsSampleRate);

    if (!sampleRate) {
      return;
    }

    if (Math.random() < (sampleRate )) {
      const envelope = span ? createSpanEnvelope([span], client.getDsn()) : undefined;
      const transport = client && client.getTransport();
      if (transport && envelope) {
        transport.send(envelope).then(null, reason => {
          common_debug_build_DEBUG_BUILD && esm_logger/* logger.error */.kg.error('Error while sending interaction:', reason);
        });
      }
      return;
    }
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(transaction) {
  const performance = getBrowserPerformanceAPI();
  if (!performance || !types_WINDOW.performance.getEntries || !esm_time/* browserPerformanceTimeOrigin */.Z1) {
    // Gatekeeper if performance API not available
    return;
  }

  common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
  const timeOrigin = msToSec(esm_time/* browserPerformanceTimeOrigin */.Z1);

  const performanceEntries = performance.getEntries();

  const { op, start_timestamp: transactionStartTime } = (0,spanUtils/* spanToJSON */.XU)(transaction);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  performanceEntries.slice(_performanceCursor).forEach((entry) => {
    const startTime = msToSec(entry.startTime);
    const duration = msToSec(entry.duration);

    // eslint-disable-next-line deprecation/deprecation
    if (transaction.op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) {
      return;
    }

    switch (entry.entryType) {
      case 'navigation': {
        _addNavigationSpans(transaction, entry, timeOrigin);
        break;
      }
      case 'mark':
      case 'paint':
      case 'measure': {
        _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);

        // capture web vitals
        const firstHidden = getVisibilityWatcher();
        // Only report if the page wasn't hidden prior to the web vital.
        const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;

        if (entry.name === 'first-paint' && shouldRecord) {
          common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Measurements] Adding FP');
          _measurements['fp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        if (entry.name === 'first-contentful-paint' && shouldRecord) {
          common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Measurements] Adding FCP');
          _measurements['fcp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        break;
      }
      case 'resource': {
        _addResourceSpans(transaction, entry, entry.name , startTime, duration, timeOrigin);
        break;
      }
      // Ignore other entry types.
    }
  });

  _performanceCursor = Math.max(performanceEntries.length - 1, 0);

  _trackNavigator(transaction);

  // Measurements are only available for pageload transactions
  if (op === 'pageload') {
    _addTtfbRequestTimeToMeasurements(_measurements);

    ['fcp', 'fp', 'lcp'].forEach(name => {
      if (!_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) {
        return;
      }
      // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
      // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
      // to be adjusted to be relative to transaction.startTimestamp.
      const oldValue = _measurements[name].value;
      const measurementTimestamp = timeOrigin + msToSec(oldValue);

      // normalizedValue should be in milliseconds
      const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
      const delta = normalizedValue - oldValue;

      common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
      _measurements[name].value = normalizedValue;
    });

    const fidMark = _measurements['mark.fid'];
    if (fidMark && _measurements['fid']) {
      // create span for FID
      _startChild(transaction, {
        description: 'first input delay',
        endTimestamp: fidMark.value + msToSec(_measurements['fid'].value),
        op: 'ui.action',
        origin: 'auto.ui.browser.metrics',
        startTimestamp: fidMark.value,
      });

      // Delete mark.fid as we don't want it to be part of final payload
      delete _measurements['mark.fid'];
    }

    // If FCP is not recorded we should not record the cls value
    // according to the new definition of CLS.
    if (!('fcp' in _measurements)) {
      delete _measurements.cls;
    }

    Object.keys(_measurements).forEach(measurementName => {
      setMeasurement(measurementName, _measurements[measurementName].value, _measurements[measurementName].unit);
    });

    _tagMetricInfo(transaction);
  }

  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/** Create measure related spans */
function _addMeasureSpans(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  startTime,
  duration,
  timeOrigin,
) {
  const measureStartTimestamp = timeOrigin + startTime;
  const measureEndTimestamp = measureStartTimestamp + duration;

  _startChild(transaction, {
    description: entry.name ,
    endTimestamp: measureEndTimestamp,
    op: entry.entryType ,
    origin: 'auto.resource.browser.metrics',
    startTimestamp: measureStartTimestamp,
  });

  return measureStartTimestamp;
}

/** Instrument navigation entries */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(event => {
    _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
  _addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
  _addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(transaction, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  event,
  timeOrigin,
  description,
  eventEnd,
) {
  const end = eventEnd ? (entry[eventEnd] ) : (entry[`${event}End`] );
  const start = entry[`${event}Start`] ;
  if (!start || !end) {
    return;
  }
  _startChild(transaction, {
    op: 'browser',
    origin: 'auto.browser.browser.metrics',
    description: description || event,
    startTimestamp: timeOrigin + msToSec(start),
    endTimestamp: timeOrigin + msToSec(end),
  });
}

/** Create request and response related spans */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction, entry, timeOrigin) {
  if (entry.responseEnd) {
    // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
    // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
    // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
    // these spans when the responseEnd value is available. The backend (Relay) would drop the entire transaction if it contained faulty spans.
    _startChild(transaction, {
      op: 'browser',
      origin: 'auto.browser.browser.metrics',
      description: 'request',
      startTimestamp: timeOrigin + msToSec(entry.requestStart ),
      endTimestamp: timeOrigin + msToSec(entry.responseEnd ),
    });

    _startChild(transaction, {
      op: 'browser',
      origin: 'auto.browser.browser.metrics',
      description: 'response',
      startTimestamp: timeOrigin + msToSec(entry.responseStart ),
      endTimestamp: timeOrigin + msToSec(entry.responseEnd ),
    });
  }
}

/** Create resource-related spans */
function _addResourceSpans(
  transaction,
  entry,
  resourceUrl,
  startTime,
  duration,
  timeOrigin,
) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }

  const parsedUrl = url_parseUrl(resourceUrl);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = {};
  setResourceEntrySizeData(data, entry, 'transferSize', 'http.response_transfer_size');
  setResourceEntrySizeData(data, entry, 'encodedBodySize', 'http.response_content_length');
  setResourceEntrySizeData(data, entry, 'decodedBodySize', 'http.decoded_response_content_length');

  if ('renderBlockingStatus' in entry) {
    data['resource.render_blocking_status'] = entry.renderBlockingStatus;
  }
  if (parsedUrl.protocol) {
    data['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
  }

  if (parsedUrl.host) {
    data['server.address'] = parsedUrl.host;
  }

  data['url.same_origin'] = resourceUrl.includes(types_WINDOW.location.origin);

  const startTimestamp = timeOrigin + startTime;
  const endTimestamp = startTimestamp + duration;

  _startChild(transaction, {
    description: resourceUrl.replace(types_WINDOW.location.origin, ''),
    endTimestamp,
    op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
    origin: 'auto.resource.browser.metrics',
    startTimestamp,
    data,
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(transaction) {
  const navigator = types_WINDOW.navigator ;
  if (!navigator) {
    return;
  }

  // track network connectivity
  const connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      transaction.setTag('effectiveConnectionType', connection.effectiveType);
    }

    if (connection.type) {
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      transaction.setTag('connectionType', connection.type);
    }

    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = { value: connection.rtt, unit: 'millisecond' };
    }
  }

  if (isMeasurementValue(navigator.deviceMemory)) {
    // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
  }

  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to transaction to allow debugging */
function _tagMetricInfo(transaction) {
  if (_lcpEntry) {
    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');

    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.Rt)(_lcpEntry.element));
    }

    if (_lcpEntry.id) {
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      transaction.setTag('lcp.id', _lcpEntry.id);
    }

    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      transaction.setTag('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }

    // TODO: Can we rewrite this to an attribute?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setTag('lcp.size', _lcpEntry.size);
  }

  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
  if (_clsEntry && _clsEntry.sources) {
    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
    _clsEntry.sources.forEach((source, index) =>
      // TODO: Can we rewrite this to an attribute?
      // eslint-disable-next-line deprecation/deprecation
      transaction.setTag(`cls.source.${index + 1}`, (0,browser/* htmlTreeAsString */.Rt)(source.node)),
    );
  }
}

function setResourceEntrySizeData(
  data,
  entry,
  key,
  dataKey,
) {
  const entryVal = entry[key];
  if (entryVal != null && entryVal < MAX_INT_AS_BYTES) {
    data[dataKey] = entryVal;
  }
}

/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */
function _addTtfbRequestTimeToMeasurements(_measurements) {
  const navEntry = getNavigationEntry();
  if (!navEntry) {
    return;
  }

  const { responseStart, requestStart } = navEntry;

  if (requestStart <= responseStart) {
    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log('[Measurements] Adding TTFB Request Time');
    _measurements['ttfb.requestTime'] = {
      value: responseStart - requestStart,
      unit: 'millisecond',
    };
  }
}

/** Taken from @sentry/core sampling.ts */
function getSampleRate(
  transactionContext,
  options,
  interactionsSampleRate,
) {
  if (!hasTracingEnabled_hasTracingEnabled(options)) {
    return false;
  }
  let sampleRate;
  if (transactionContext !== undefined && typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler({
      transactionContext,
      name: transactionContext.name,
      parentSampled: transactionContext.parentSampled,
      attributes: {
        // eslint-disable-next-line deprecation/deprecation
        ...transactionContext.data,
        ...transactionContext.attributes,
      },
      location: types_WINDOW.location,
    });
  } else if (transactionContext !== undefined && transactionContext.sampled !== undefined) {
    sampleRate = transactionContext.sampled;
  } else if (typeof options.tracesSampleRate !== 'undefined') {
    sampleRate = options.tracesSampleRate;
  } else {
    sampleRate = 1;
  }
  if (!isValidSampleRate(sampleRate)) {
    common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('[Tracing] Discarding interaction span because of invalid sample rate.');
    return false;
  }
  if (sampleRate === true) {
    return interactionsSampleRate;
  } else if (sampleRate === false) {
    return 0;
  }
  return sampleRate * interactionsSampleRate;
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/utils/esm/baggage.js
var baggage = __webpack_require__(46990);
;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/common/fetch.js



/**
 * Create and track fetch request spans for usage in combination with `addInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */
function instrumentFetchRequest(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
  spanOrigin = 'auto.http.browser',
) {
  if (!hasTracingEnabled_hasTracingEnabled() || !handlerData.fetchData) {
    return undefined;
  }

  const shouldCreateSpanResult = shouldCreateSpan(handlerData.fetchData.url);

  if (handlerData.endTimestamp && shouldCreateSpanResult) {
    const spanId = handlerData.fetchData.__span;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      endSpan(span, handlerData);
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return undefined;
  }

  const scope = (0,esm_exports/* getCurrentScope */.nZ)();
  const client = (0,esm_exports/* getClient */.s3)();

  const { method, url } = handlerData.fetchData;

  const fullUrl = getFullURL(url);
  const host = fullUrl ? url_parseUrl(fullUrl).host : undefined;

  const span = shouldCreateSpanResult
    ? startInactiveSpan({
        name: `${method} ${url}`,
        onlyIfParent: true,
        attributes: {
          url,
          type: 'fetch',
          'http.method': method,
          'http.url': fullUrl,
          'server.address': host,
          [SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: spanOrigin,
        },
        op: 'http.client',
      })
    : undefined;

  if (span) {
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
  }

  if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
    const request = handlerData.args[0];

    // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
    handlerData.args[1] = handlerData.args[1] || {};

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const options = handlerData.args[1];

    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
    options.headers = addTracingHeadersToFetchRequest(request, client, scope, options, span);
  }

  return span;
}

/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */
function addTracingHeadersToFetchRequest(
  request, // unknown is actually type Request but we can't export DOM types from this package,
  client,
  scope,
  options

,
  requestSpan,
) {
  // eslint-disable-next-line deprecation/deprecation
  const span = requestSpan || scope.getSpan();

  const isolationScope = (0,esm_hub/* getIsolationScope */.aF)();

  const { traceId, spanId, sampled, dsc } = {
    ...isolationScope.getPropagationContext(),
    ...scope.getPropagationContext(),
  };

  const sentryTraceHeader = span ? (0,spanUtils/* spanToTraceHeader */.Hb)(span) : (0,tracing/* generateSentryTraceHeader */.$p)(traceId, spanId, sampled);

  const sentryBaggageHeader = (0,baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(
    dsc ||
      (span ? (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(span) : (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromClient */._)(traceId, client, scope)),
  );

  const headers =
    options.headers ||
    (typeof Request !== 'undefined' && (0,is/* isInstanceOf */.V9)(request, Request) ? (request ).headers : undefined);

  if (!headers) {
    return { 'sentry-trace': sentryTraceHeader, baggage: sentryBaggageHeader };
  } else if (typeof Headers !== 'undefined' && (0,is/* isInstanceOf */.V9)(headers, Headers)) {
    const newHeaders = new Headers(headers );

    newHeaders.append('sentry-trace', sentryTraceHeader);

    if (sentryBaggageHeader) {
      // If the same header is appended multiple times the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.append(baggage/* BAGGAGE_HEADER_NAME */.bU, sentryBaggageHeader);
    }

    return newHeaders ;
  } else if (Array.isArray(headers)) {
    const newHeaders = [...headers, ['sentry-trace', sentryTraceHeader]];

    if (sentryBaggageHeader) {
      // If there are multiple entries with the same key, the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.push([baggage/* BAGGAGE_HEADER_NAME */.bU, sentryBaggageHeader]);
    }

    return newHeaders ;
  } else {
    const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
    const newBaggageHeaders = [];

    if (Array.isArray(existingBaggageHeader)) {
      newBaggageHeaders.push(...existingBaggageHeader);
    } else if (existingBaggageHeader) {
      newBaggageHeaders.push(existingBaggageHeader);
    }

    if (sentryBaggageHeader) {
      newBaggageHeaders.push(sentryBaggageHeader);
    }

    return {
      ...(headers ),
      'sentry-trace': sentryTraceHeader,
      baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined,
    };
  }
}

function getFullURL(url) {
  try {
    const parsed = new URL(url);
    return parsed.href;
  } catch (e) {
    return undefined;
  }
}

function endSpan(span, handlerData) {
  if (handlerData.response) {
    setHttpStatus(span, handlerData.response.status);

    const contentLength =
      handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');

    if (contentLength) {
      const contentLengthNum = parseInt(contentLength);
      if (contentLengthNum > 0) {
        span.setAttribute('http.response_content_length', contentLengthNum);
      }
    }
  } else if (handlerData.error) {
    span.setStatus('internal_error');
  }
  span.end();
}


//# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/request.js






/* eslint-disable max-lines */

const DEFAULT_TRACE_PROPAGATION_TARGETS = ['localhost', /^\/(?!\/)/];

/** Options for Request Instrumentation */

const defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  enableHTTPTimings: true,
  // TODO (v8): Remove this property
  tracingOrigins: DEFAULT_TRACE_PROPAGATION_TARGETS,
  tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS,
};

/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
  const {
    traceFetch,
    traceXHR,
    // eslint-disable-next-line deprecation/deprecation
    tracePropagationTargets,
    // eslint-disable-next-line deprecation/deprecation
    tracingOrigins,
    shouldCreateSpanForRequest,
    enableHTTPTimings,
  } = {
    traceFetch: defaultRequestInstrumentationOptions.traceFetch,
    traceXHR: defaultRequestInstrumentationOptions.traceXHR,
    ..._options,
  };

  const shouldCreateSpan =
    typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_) => true;

  // TODO(v8) Remove tracingOrigins here
  // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
  // and we don't want to break the API. We can remove it in v8.
  const shouldAttachHeadersWithTargets = (url) =>
    shouldAttachHeaders(url, tracePropagationTargets || tracingOrigins);

  const spans = {};

  if (traceFetch) {
    addFetchInstrumentationHandler(handlerData => {
      const createdSpan = instrumentFetchRequest(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
      // We cannot use `window.location` in the generic fetch instrumentation,
      // but we need it for reliable `server.address` attribute.
      // so we extend this in here
      if (createdSpan) {
        const fullUrl = request_getFullURL(handlerData.fetchData.url);
        const host = fullUrl ? url_parseUrl(fullUrl).host : undefined;
        createdSpan.setAttributes({
          'http.url': fullUrl,
          'server.address': host,
        });
      }

      if (enableHTTPTimings && createdSpan) {
        addHTTPTimings(createdSpan);
      }
    });
  }

  if (traceXHR) {
    addXhrInstrumentationHandler(handlerData => {
      const createdSpan = xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
      if (enableHTTPTimings && createdSpan) {
        addHTTPTimings(createdSpan);
      }
    });
  }
}

function isPerformanceResourceTiming(entry) {
  return (
    entry.entryType === 'resource' &&
    'initiatorType' in entry &&
    typeof (entry ).nextHopProtocol === 'string' &&
    (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest')
  );
}

/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */
function addHTTPTimings(span) {
  const { url } = (0,spanUtils/* spanToJSON */.XU)(span).data || {};

  if (!url || typeof url !== 'string') {
    return;
  }

  const cleanup = addPerformanceInstrumentationHandler('resource', ({ entries }) => {
    entries.forEach(entry => {
      if (isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
        const spanData = resourceTimingEntryToSpanData(entry);
        spanData.forEach(data => span.setAttribute(...data));
        // In the next tick, clean this handler up
        // We have to wait here because otherwise this cleans itself up before it is fully done
        setTimeout(cleanup);
      }
    });
  });
}

/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */
function extractNetworkProtocol(nextHopProtocol) {
  let name = 'unknown';
  let version = 'unknown';
  let _name = '';
  for (const char of nextHopProtocol) {
    // http/1.1 etc.
    if (char === '/') {
      [name, version] = nextHopProtocol.split('/');
      break;
    }
    // h2, h3 etc.
    if (!isNaN(Number(char))) {
      name = _name === 'h' ? 'http' : _name;
      version = nextHopProtocol.split(_name)[1];
      break;
    }
    _name += char;
  }
  if (_name === nextHopProtocol) {
    // webrtc, ftp, etc.
    name = _name;
  }
  return { name, version };
}

function getAbsoluteTime(time = 0) {
  return ((esm_time/* browserPerformanceTimeOrigin */.Z1 || performance.timeOrigin) + time) / 1000;
}

function resourceTimingEntryToSpanData(resourceTiming) {
  const { name, version } = extractNetworkProtocol(resourceTiming.nextHopProtocol);

  const timingSpanData = [];

  timingSpanData.push(['network.protocol.version', version], ['network.protocol.name', name]);

  if (!esm_time/* browserPerformanceTimeOrigin */.Z1) {
    return timingSpanData;
  }
  return [
    ...timingSpanData,
    ['http.request.redirect_start', getAbsoluteTime(resourceTiming.redirectStart)],
    ['http.request.fetch_start', getAbsoluteTime(resourceTiming.fetchStart)],
    ['http.request.domain_lookup_start', getAbsoluteTime(resourceTiming.domainLookupStart)],
    ['http.request.domain_lookup_end', getAbsoluteTime(resourceTiming.domainLookupEnd)],
    ['http.request.connect_start', getAbsoluteTime(resourceTiming.connectStart)],
    ['http.request.secure_connection_start', getAbsoluteTime(resourceTiming.secureConnectionStart)],
    ['http.request.connection_end', getAbsoluteTime(resourceTiming.connectEnd)],
    ['http.request.request_start', getAbsoluteTime(resourceTiming.requestStart)],
    ['http.request.response_start', getAbsoluteTime(resourceTiming.responseStart)],
    ['http.request.response_end', getAbsoluteTime(resourceTiming.responseEnd)],
  ];
}

/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */
function shouldAttachHeaders(url, tracePropagationTargets) {
  return (0,string/* stringMatchesSomePattern */.U0)(url, tracePropagationTargets || DEFAULT_TRACE_PROPAGATION_TARGETS);
}

/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */
// eslint-disable-next-line complexity
function xhrCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  const xhr = handlerData.xhr;
  const sentryXhrData = xhr && xhr[SENTRY_XHR_DATA_KEY];

  if (!hasTracingEnabled_hasTracingEnabled() || !xhr || xhr.__sentry_own_request__ || !sentryXhrData) {
    return undefined;
  }

  const shouldCreateSpanResult = shouldCreateSpan(sentryXhrData.url);

  // check first if the request has finished and is tracked by an existing span which should now end
  if (handlerData.endTimestamp && shouldCreateSpanResult) {
    const spanId = xhr.__sentry_xhr_span_id__;
    if (!spanId) return;

    const span = spans[spanId];
    if (span && sentryXhrData.status_code !== undefined) {
      setHttpStatus(span, sentryXhrData.status_code);
      span.end();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return undefined;
  }

  const scope = (0,esm_exports/* getCurrentScope */.nZ)();
  const isolationScope = (0,esm_hub/* getIsolationScope */.aF)();

  const fullUrl = request_getFullURL(sentryXhrData.url);
  const host = fullUrl ? url_parseUrl(fullUrl).host : undefined;

  const span = shouldCreateSpanResult
    ? startInactiveSpan({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        onlyIfParent: true,
        attributes: {
          type: 'xhr',
          'http.method': sentryXhrData.method,
          'http.url': fullUrl,
          url: sentryXhrData.url,
          'server.address': host,
          [SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN]: 'auto.http.browser',
        },
        op: 'http.client',
      })
    : undefined;

  if (span) {
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
  }

  const client = (0,esm_exports/* getClient */.s3)();

  if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) {
    const { traceId, spanId, sampled, dsc } = {
      ...isolationScope.getPropagationContext(),
      ...scope.getPropagationContext(),
    };

    const sentryTraceHeader = span ? (0,spanUtils/* spanToTraceHeader */.Hb)(span) : (0,tracing/* generateSentryTraceHeader */.$p)(traceId, spanId, sampled);

    const sentryBaggageHeader = (0,baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(
      dsc ||
        (span ? (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(span) : (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromClient */._)(traceId, client, scope)),
    );

    setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
  }

  return span;
}

function setHeaderOnXhr(
  xhr,
  sentryTraceHeader,
  sentryBaggageHeader,
) {
  try {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
    if (sentryBaggageHeader) {
      // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
      // We can therefore simply set a baggage header without checking what was there before
      // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      xhr.setRequestHeader(baggage/* BAGGAGE_HEADER_NAME */.bU, sentryBaggageHeader);
    }
  } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
  }
}

function request_getFullURL(url) {
  try {
    // By adding a base URL to new URL(), this will also work for relative urls
    // If `url` is a full URL, the base URL is ignored anyhow
    const parsed = new URL(url, types_WINDOW.location.origin);
    return parsed.href;
  } catch (e) {
    return undefined;
  }
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/router.js




/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(
  customStartTransaction,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  if (!types_WINDOW || !types_WINDOW.location) {
    common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
    return;
  }

  let startingUrl = types_WINDOW.location.href;

  let activeTransaction;
  if (startTransactionOnPageLoad) {
    activeTransaction = customStartTransaction({
      name: types_WINDOW.location.pathname,
      // pageload should always start at timeOrigin (and needs to be in s, not ms)
      startTimestamp: esm_time/* browserPerformanceTimeOrigin */.Z1 ? esm_time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
      op: 'pageload',
      origin: 'auto.pageload.browser',
      metadata: { source: 'url' },
    });
  }

  if (startTransactionOnLocationChange) {
    addHistoryInstrumentationHandler(({ to, from }) => {
      /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */
      if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
        startingUrl = undefined;
        return;
      }

      if (from !== to) {
        startingUrl = undefined;
        if (activeTransaction) {
          common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
          // If there's an open transaction on the scope, we need to finish it before creating an new one.
          activeTransaction.end();
        }
        activeTransaction = customStartTransaction({
          name: types_WINDOW.location.pathname,
          op: 'navigation',
          origin: 'auto.navigation.browser',
          metadata: { source: 'url' },
        });
      }
    });
  }
}


//# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry-internal/tracing/esm/browser/browsertracing.js










const BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

const DEFAULT_BROWSER_TRACING_OPTIONS = {
  ...TRACING_DEFAULTS,
  markBackgroundTransactions: true,
  routingInstrumentation: instrumentRoutingWithDefaults,
  startTransactionOnLocationChange: true,
  startTransactionOnPageLoad: true,
  enableLongTask: true,
  enableInp: false,
  interactionsSampleRate: 1,
  _experiments: {},
  ...defaultRequestInstrumentationOptions,
};

/** We store up to 10 interaction candidates max to cap memory usage. This is the same cap as getINP from web-vitals */
const MAX_INTERACTIONS = 10;

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 *
 * @deprecated Use `browserTracingIntegration()` instead.
 */
class BrowserTracing  {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.

  /** Browser Tracing integration options */

  /**
   * @inheritDoc
   */

  // eslint-disable-next-line deprecation/deprecation

   constructor(_options) {
    this.name = BROWSER_TRACING_INTEGRATION_ID;
    this._hasSetTracePropagationTargets = false;

    addTracingExtensions();

    if (common_debug_build_DEBUG_BUILD) {
      this._hasSetTracePropagationTargets = !!(
        _options &&
        // eslint-disable-next-line deprecation/deprecation
        (_options.tracePropagationTargets || _options.tracingOrigins)
      );
    }

    this.options = {
      ...DEFAULT_BROWSER_TRACING_OPTIONS,
      ..._options,
    };

    // Special case: enableLongTask can be set in _experiments
    // TODO (v8): Remove this in v8
    if (this.options._experiments.enableLongTask !== undefined) {
      this.options.enableLongTask = this.options._experiments.enableLongTask;
    }

    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) {
      // eslint-disable-next-line deprecation/deprecation
      this.options.tracePropagationTargets = _options.tracingOrigins;
    }

    this._collectWebVitals = startTrackingWebVitals();
    /** Stores a mapping of interactionIds from PerformanceEventTimings to the origin interaction path */
    this._interactionIdToRouteNameMapping = {};

    if (this.options.enableInp) {
      startTrackingINP(this._interactionIdToRouteNameMapping, this.options.interactionsSampleRate);
    }
    if (this.options.enableLongTask) {
      startTrackingLongTasks();
    }
    if (this.options._experiments.enableInteractions) {
      startTrackingInteractions();
    }

    this._latestRoute = {
      name: undefined,
      context: undefined,
    };
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line deprecation/deprecation
   setupOnce(_, getCurrentHub) {
    this._getCurrentHub = getCurrentHub;
    const hub = getCurrentHub();
    // eslint-disable-next-line deprecation/deprecation
    const client = hub.getClient();
    const clientOptions = client && client.getOptions();

    const {
      routingInstrumentation: instrumentRouting,
      startTransactionOnLocationChange,
      startTransactionOnPageLoad,
      markBackgroundTransactions,
      traceFetch,
      traceXHR,
      shouldCreateSpanForRequest,
      enableHTTPTimings,
      _experiments,
    } = this.options;

    const clientOptionsTracePropagationTargets = clientOptions && clientOptions.tracePropagationTargets;
    // There are three ways to configure tracePropagationTargets:
    // 1. via top level client option `tracePropagationTargets`
    // 2. via BrowserTracing option `tracePropagationTargets`
    // 3. via BrowserTracing option `tracingOrigins` (deprecated)
    //
    // To avoid confusion, favour top level client option `tracePropagationTargets`, and fallback to
    // BrowserTracing option `tracePropagationTargets` and then `tracingOrigins` (deprecated).
    // This is done as it minimizes bundle size (we don't have to have undefined checks).
    //
    // If both 1 and either one of 2 or 3 are set (from above), we log out a warning.
    // eslint-disable-next-line deprecation/deprecation
    const tracePropagationTargets = clientOptionsTracePropagationTargets || this.options.tracePropagationTargets;
    if (common_debug_build_DEBUG_BUILD && this._hasSetTracePropagationTargets && clientOptionsTracePropagationTargets) {
      esm_logger/* logger.warn */.kg.warn(
        '[Tracing] The `tracePropagationTargets` option was set in the BrowserTracing integration and top level `Sentry.init`. The top level `Sentry.init` value is being used.',
      );
    }

    instrumentRouting(
      (context) => {
        const transaction = this._createRouteTransaction(context);

        this.options._experiments.onStartRouteTransaction &&
          this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);

        return transaction;
      },
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
    );

    if (markBackgroundTransactions) {
      registerBackgroundTabDetection();
    }

    if (_experiments.enableInteractions) {
      this._registerInteractionListener();
    }

    if (this.options.enableInp) {
      this._registerInpInteractionListener();
    }

    instrumentOutgoingRequests({
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
      enableHTTPTimings,
    });
  }

  /** Create routing idle transaction. */
   _createRouteTransaction(context) {
    if (!this._getCurrentHub) {
      common_debug_build_DEBUG_BUILD &&
        esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
      return undefined;
    }

    const hub = this._getCurrentHub();

    const { beforeNavigate, idleTimeout, finalTimeout, heartbeatInterval } = this.options;

    const isPageloadTransaction = context.op === 'pageload';

    let expandedContext;
    if (isPageloadTransaction) {
      const sentryTrace = isPageloadTransaction ? getMetaContent('sentry-trace') : '';
      const baggage = isPageloadTransaction ? getMetaContent('baggage') : undefined;
      const { traceId, dsc, parentSpanId, sampled } = (0,tracing/* propagationContextFromHeaders */.pT)(sentryTrace, baggage);
      expandedContext = {
        traceId,
        parentSpanId,
        parentSampled: sampled,
        ...context,
        metadata: {
          // eslint-disable-next-line deprecation/deprecation
          ...context.metadata,
          dynamicSamplingContext: dsc,
        },
        trimEnd: true,
      };
    } else {
      expandedContext = {
        trimEnd: true,
        ...context,
      };
    }

    const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;

    // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
    // from being sent to Sentry).
    const finalContext = modifiedContext === undefined ? { ...expandedContext, sampled: false } : modifiedContext;

    // If `beforeNavigate` set a custom name, record that fact
    // eslint-disable-next-line deprecation/deprecation
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? // eslint-disable-next-line deprecation/deprecation
          { ...finalContext.metadata, source: 'custom' }
        : // eslint-disable-next-line deprecation/deprecation
          finalContext.metadata;

    this._latestRoute.name = finalContext.name;
    this._latestRoute.context = finalContext;

    // eslint-disable-next-line deprecation/deprecation
    if (finalContext.sampled === false) {
      common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    common_debug_build_DEBUG_BUILD && esm_logger/* logger.log */.kg.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    const { location } = types_WINDOW;

    const idleTransaction = startIdleTransaction(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
      heartbeatInterval,
      isPageloadTransaction, // should wait for finish signal if it's a pageload transaction
    );

    if (isPageloadTransaction) {
      if (types_WINDOW.document) {
        types_WINDOW.document.addEventListener('readystatechange', () => {
          if (['interactive', 'complete'].includes(types_WINDOW.document.readyState)) {
            idleTransaction.sendAutoFinishSignal();
          }
        });

        if (['interactive', 'complete'].includes(types_WINDOW.document.readyState)) {
          idleTransaction.sendAutoFinishSignal();
        }
      }
    }

    idleTransaction.registerBeforeFinishCallback(transaction => {
      this._collectWebVitals();
      addPerformanceEntries(transaction);
    });

    return idleTransaction ;
  }

  /** Start listener for interaction transactions */
   _registerInteractionListener() {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = () => {
      const { idleTimeout, finalTimeout, heartbeatInterval } = this.options;
      const op = 'ui.action.click';

      // eslint-disable-next-line deprecation/deprecation
      const currentTransaction = getActiveTransaction();
      if (currentTransaction && currentTransaction.op && ['navigation', 'pageload'].includes(currentTransaction.op)) {
        common_debug_build_DEBUG_BUILD &&
          esm_logger/* logger.warn */.kg.warn(
            `[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`,
          );
        return undefined;
      }

      if (inflightInteractionTransaction) {
        inflightInteractionTransaction.setFinishReason('interactionInterrupted');
        inflightInteractionTransaction.end();
        inflightInteractionTransaction = undefined;
      }

      if (!this._getCurrentHub) {
        common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
        return undefined;
      }

      if (!this._latestRoute.name) {
        common_debug_build_DEBUG_BUILD && esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
        return undefined;
      }

      const hub = this._getCurrentHub();
      const { location } = types_WINDOW;

      const context = {
        name: this._latestRoute.name,
        op,
        trimEnd: true,
        data: {
          [SEMANTIC_ATTRIBUTE_SENTRY_SOURCE]: this._latestRoute.context
            ? getSource(this._latestRoute.context)
            : 'url',
        },
      };

      inflightInteractionTransaction = startIdleTransaction(
        hub,
        context,
        idleTimeout,
        finalTimeout,
        true,
        { location }, // for use in the tracesSampler
        heartbeatInterval,
      );
    };

    ['click'].forEach(type => {
      if (types_WINDOW.document) {
        addEventListener(type, registerInteractionTransaction, { once: false, capture: true });
      }
    });
  }

  /** Creates a listener on interaction entries, and maps interactionIds to the origin path of the interaction */
   _registerInpInteractionListener() {
    const handleEntries = ({ entries }) => {
      const client = (0,esm_exports/* getClient */.s3)();
      // We need to get the replay, user, and activeTransaction from the current scope
      // so that we can associate replay id, profile id, and a user display to the span
      const replay =
        client !== undefined && client.getIntegrationByName !== undefined
          ? (client.getIntegrationByName('Replay') )
          : undefined;
      const replayId = replay !== undefined ? replay.getReplayId() : undefined;
      // eslint-disable-next-line deprecation/deprecation
      const activeTransaction = getActiveTransaction();
      const currentScope = (0,esm_exports/* getCurrentScope */.nZ)();
      const user = currentScope !== undefined ? currentScope.getUser() : undefined;
      entries.forEach(entry => {
        if (isPerformanceEventTiming(entry)) {
          const interactionId = entry.interactionId;
          if (interactionId === undefined) {
            return;
          }
          const existingInteraction = this._interactionIdToRouteNameMapping[interactionId];
          const duration = entry.duration;
          const startTime = entry.startTime;
          const keys = Object.keys(this._interactionIdToRouteNameMapping);
          const minInteractionId =
            keys.length > 0
              ? keys.reduce((a, b) => {
                  return this._interactionIdToRouteNameMapping[a].duration <
                    this._interactionIdToRouteNameMapping[b].duration
                    ? a
                    : b;
                })
              : undefined;
          // For a first input event to be considered, we must check that an interaction event does not already exist with the same duration and start time.
          // This is also checked in the web-vitals library.
          if (entry.entryType === 'first-input') {
            const matchingEntry = keys
              .map(key => this._interactionIdToRouteNameMapping[key])
              .some(interaction => {
                return interaction.duration === duration && interaction.startTime === startTime;
              });
            if (matchingEntry) {
              return;
            }
          }
          // Interactions with an id of 0 and are not first-input are not valid.
          if (!interactionId) {
            return;
          }
          // If the interaction already exists, we want to use the duration of the longest entry, since that is what the INP metric uses.
          if (existingInteraction) {
            existingInteraction.duration = Math.max(existingInteraction.duration, duration);
          } else if (
            keys.length < MAX_INTERACTIONS ||
            minInteractionId === undefined ||
            duration > this._interactionIdToRouteNameMapping[minInteractionId].duration
          ) {
            // If the interaction does not exist, we want to add it to the mapping if there is space, or if the duration is longer than the shortest entry.
            const routeName = this._latestRoute.name;
            const parentContext = this._latestRoute.context;
            if (routeName && parentContext) {
              if (minInteractionId && Object.keys(this._interactionIdToRouteNameMapping).length >= MAX_INTERACTIONS) {
                // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
                delete this._interactionIdToRouteNameMapping[minInteractionId];
              }
              this._interactionIdToRouteNameMapping[interactionId] = {
                routeName,
                duration,
                parentContext,
                user,
                activeTransaction,
                replayId,
                startTime,
              };
            }
          }
        }
      });
    };
    addPerformanceInstrumentationHandler('event', handleEntries);
    addPerformanceInstrumentationHandler('first-input', handleEntries);
  }
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  const metaTag = (0,browser/* getDomElement */.qT)(`meta[name=${metaName}]`);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return metaTag ? metaTag.getAttribute('content') : undefined;
}

function getSource(context) {
  const sourceFromAttributes = context.attributes && context.attributes[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
  // eslint-disable-next-line deprecation/deprecation
  const sourceFromData = context.data && context.data[SEMANTIC_ATTRIBUTE_SENTRY_SOURCE];
  // eslint-disable-next-line deprecation/deprecation
  const sourceFromMetadata = context.metadata && context.metadata.source;

  return sourceFromAttributes || sourceFromData || sourceFromMetadata;
}

function isPerformanceEventTiming(entry) {
  return 'duration' in entry;
}


//# sourceMappingURL=browsertracing.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/userIntegrations.js
/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setNestedKey(obj, keyPath, value) {
  // Ex. foo.bar.zoop will extract foo and bar.zoop
  const match = keyPath.match(/([a-z_]+)\.(.*)/i);
  // The match will be null when there's no more recursing to do, i.e., when we've reached the right level of the object
  if (match === null) {
    obj[keyPath] = value;
  } else {
    // `match[1]` is the initial segment of the path, and `match[2]` is the remainder of the path
    const innerObj = obj[match[1]];
    setNestedKey(innerObj, match[2], value);
  }
}

/**
 * Enforces inclusion of a given integration with specified options in an integration array originally determined by the
 * user, by either including the given default instance or by patching an existing user instance with the given options.
 *
 * Ideally this would happen when integrations are set up, but there isn't currently a mechanism there for merging
 * options from a default integration instance with those from a user-provided instance of the same integration, only
 * for allowing the user to override a default instance entirely. (TODO: Fix that.)
 *
 * @param defaultIntegrationInstance An instance of the integration with the correct options already set
 * @param userIntegrations Integrations defined by the user.
 * @param forcedOptions Options with which to patch an existing user-derived instance on the integration.
 * @returns A final integrations array.
 */
function addOrUpdateIntegration(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions = {},
) {
  return (
    Array.isArray(userIntegrations)
      ? addOrUpdateIntegrationInArray(defaultIntegrationInstance, userIntegrations, forcedOptions)
      : addOrUpdateIntegrationInFunction(
          defaultIntegrationInstance,
          // Somehow TS can't figure out that not being an array makes this necessarily a function
          userIntegrations ,
          forcedOptions,
        )
  ) ;
}

function addOrUpdateIntegrationInArray(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions,
) {
  const userInstance = userIntegrations.find(integration => integration.name === defaultIntegrationInstance.name);

  if (userInstance) {
    for (const [keyPath, value] of Object.entries(forcedOptions)) {
      setNestedKey(userInstance, keyPath, value);
    }

    return userIntegrations;
  }

  return [...userIntegrations, defaultIntegrationInstance];
}

function addOrUpdateIntegrationInFunction(
  defaultIntegrationInstance,
  userIntegrationsFunc,
  forcedOptions,
) {
  const wrapper = defaultIntegrations => {
    const userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);

    // There are instances where we want the user to be able to prevent an integration from appearing at all, which they
    // would do by providing a function which filters out the integration in question. If that's happened in one of
    // those cases, don't add our default back in.
    if (defaultIntegrationInstance.allowExclusionByUser) {
      const userFinalInstance = userFinalIntegrations.find(
        integration => integration.name === defaultIntegrationInstance.name,
      );
      if (!userFinalInstance) {
        return userFinalIntegrations;
      }
    }

    return addOrUpdateIntegrationInArray(defaultIntegrationInstance, userFinalIntegrations, forcedOptions);
  };

  return wrapper;
}


//# sourceMappingURL=userIntegrations.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/getVercelEnv.js
/* provided dependency */ var process = __webpack_require__(93542);
/**
 * Returns an environment setting value determined by Vercel's `VERCEL_ENV` environment variable.
 *
 * @param isClient Flag to indicate whether to use the `NEXT_PUBLIC_` prefixed version of the environment variable.
 */
function getVercelEnv(isClient) {
  const vercelEnvVar = isClient ? process.env.NEXT_PUBLIC_VERCEL_ENV : process.env.VERCEL_ENV;
  return vercelEnvVar ? `vercel-${vercelEnvVar}` : undefined;
}


//# sourceMappingURL=getVercelEnv.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/core/esm/version.js
const SDK_VERSION = '7.77.0';


//# sourceMappingURL=version.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/common/metadata.js


const PACKAGE_NAME_PREFIX = 'npm:@sentry/';

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
  options._metadata = options._metadata || {};
  options._metadata.sdk =
    options._metadata.sdk ||
    ({
      name: 'sentry.javascript.nextjs',
      packages: names.map(name => ({
        name: `${PACKAGE_NAME_PREFIX}${name}`,
        version: SDK_VERSION,
      })),
      version: SDK_VERSION,
    } );
}


//# sourceMappingURL=metadata.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/logger.js
var utils_esm_logger = __webpack_require__(32797);
// EXTERNAL MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/is.js
var esm_is = __webpack_require__(42008);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/baggage.js



const BAGGAGE_HEADER_NAME = 'baggage';

const SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
const MAX_BAGGAGE_STRING_LENGTH = 8192;

/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */
function baggageHeaderToDynamicSamplingContext(
  // Very liberal definition of what any incoming header might look like
  baggageHeader,
) {
  if (!(0,esm_is/* isString */.HD)(baggageHeader) && !Array.isArray(baggageHeader)) {
    return undefined;
  }

  // Intermediary object to store baggage key value pairs of incoming baggage headers on.
  // It is later used to read Sentry-DSC-values from.
  let baggageObject = {};

  if (Array.isArray(baggageHeader)) {
    // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggageHeaderToObject(curr);
      return {
        ...acc,
        ...currBaggageObject,
      };
    }, {});
  } else {
    // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
    // this is how we choose to handle it)
    if (!baggageHeader) {
      return undefined;
    }

    baggageObject = baggageHeaderToObject(baggageHeader);
  }

  // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});

  // Only return a dynamic sampling context object if there are keys in it.
  // A keyless object means there were no sentry values on the header, which means that there is no DSC.
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext ;
  } else {
    return undefined;
  }
}

/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */
function dynamicSamplingContextToSentryBaggageHeader(
  // this also takes undefined for convenience and bundle size in other places
  dynamicSamplingContext,
) {
  if (!dynamicSamplingContext) {
    return undefined;
  }

  // Prefix all DSC keys with "sentry-" and put them into a new object
  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(
    (acc, [dscKey, dscValue]) => {
      if (dscValue) {
        acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
      }
      return acc;
    },
    {},
  );

  return objectToBaggageHeader(sentryPrefixedDSC);
}

/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */
function baggageHeaderToObject(baggageHeader) {
  return baggageHeader
    .split(',')
    .map(baggageEntry => baggageEntry.split('=').map(keyOrValue => decodeURIComponent(keyOrValue.trim())))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
}

/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */
function objectToBaggageHeader(object) {
  if (Object.keys(object).length === 0) {
    // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
  }

  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
    if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        logger.warn(
          `Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`,
        );
      return baggageHeader;
    } else {
      return newBaggageHeader;
    }
  }, '');
}


//# sourceMappingURL=baggage.js.map

// EXTERNAL MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/misc.js
var esm_misc = __webpack_require__(16894);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/tracing.js



const TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function tracing_extractTraceparentData(traceparent) {
  if (!traceparent) {
    return undefined;
  }

  const matches = traceparent.match(TRACEPARENT_REGEXP);
  if (!matches) {
    return undefined;
  }

  let parentSampled;
  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2],
  };
}

/**
 * Create tracing context from incoming headers.
 */
function tracing_tracingContextFromHeaders(
  sentryTrace,
  baggage,
)

 {
  const traceparentData = tracing_extractTraceparentData(sentryTrace);
  const dynamicSamplingContext = baggageHeaderToDynamicSamplingContext(baggage);

  const { traceId, parentSpanId, parentSampled } = traceparentData || {};

  const propagationContext = {
    traceId: traceId || (0,esm_misc/* uuid4 */.DM)(),
    spanId: (0,esm_misc/* uuid4 */.DM)().substring(16),
    sampled: parentSampled,
  };

  if (parentSpanId) {
    propagationContext.parentSpanId = parentSpanId;
  }

  if (dynamicSamplingContext) {
    propagationContext.dsc = dynamicSamplingContext ;
  }

  return {
    traceparentData,
    dynamicSamplingContext,
    propagationContext,
  };
}

/**
 * Create sentry-trace header from span context values.
 */
function generateSentryTraceHeader(
  traceId = uuid4(),
  spanId = uuid4().substring(16),
  sampled,
) {
  let sampledString = '';
  if (sampled !== undefined) {
    sampledString = sampled ? '-1' : '-0';
  }
  return `${traceId}-${spanId}${sampledString}`;
}


//# sourceMappingURL=tracing.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/url.js
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function esm_url_parseUrl(url) {
  if (!url) {
    return {};
  }

  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  const query = match[6] || '';
  const fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    search: query,
    hash: fragment,
    relative: match[5] + query + fragment, // everything minus origin
  };
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function url_stripUrlQueryAndFragment(urlPath) {
  // eslint-disable-next-line no-useless-escape
  return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Returns number of URL segments of a passed string URL.
 */
function url_getNumberOfUrlSegments(url) {
  // split at '/' or at '\/' to split regex urls correctly
  return url.split(/\\?\//).filter(s => s.length > 0 && s !== ',').length;
}

/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */
function url_getSanitizedUrlString(url) {
  const { protocol, host, path } = url;

  const filteredHost =
    (host &&
      host
        // Always filter out authority
        .replace(/^.*@/, '[filtered]:[filtered]@')
        // Don't show standard :80 (http) and :443 (https) ports to reduce the noise
        .replace(':80', '')
        .replace(':443', '')) ||
    '';

  return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}


//# sourceMappingURL=url.js.map

// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/client/performance.js





const globalObject = helpers_WINDOW

;

/**
 * Every Next.js page (static and dynamic ones) comes with a script tag with the id "__NEXT_DATA__". This script tag
 * contains a JSON object with data that was either generated at build time for static pages (`getStaticProps`), or at
 * runtime with data fetchers like `getServerSideProps.`.
 *
 * We can use this information to:
 * - Always get the parameterized route we're in when loading a page.
 * - Send trace information (trace-id, baggage) from the server to the client.
 *
 * This function extracts this information.
 */
function extractNextDataTagInformation() {
  let nextData;
  // Let's be on the safe side and actually check first if there is really a __NEXT_DATA__ script tag on the page.
  // Theoretically this should always be the case though.
  const nextDataTag = globalObject.document.getElementById('__NEXT_DATA__');
  if (nextDataTag && nextDataTag.innerHTML) {
    try {
      nextData = JSON.parse(nextDataTag.innerHTML);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && utils_esm_logger/* logger.warn */.kg.warn('Could not extract __NEXT_DATA__');
    }
  }

  if (!nextData) {
    return {};
  }

  const nextDataTagInfo = {};

  const { page, query, props } = nextData;

  // `nextData.page` always contains the parameterized route - except for when an error occurs in a data fetching
  // function, then it is "/_error", but that isn't a problem since users know which route threw by looking at the
  // parent transaction
  // TODO: Actually this is a problem (even though it is not that big), because the DSC and the transaction payload will contain
  // a different transaction name. Maybe we can fix this. Idea: Also send transaction name via pageProps when available.
  nextDataTagInfo.route = page;
  nextDataTagInfo.params = query;

  if (props && props.pageProps) {
    nextDataTagInfo.sentryTrace = props.pageProps._sentryTraceData;
    nextDataTagInfo.baggage = props.pageProps._sentryBaggage;
  }

  return nextDataTagInfo;
}

const DEFAULT_TAGS = {
  'routing.instrumentation': 'next-router',
} ;

// We keep track of the active transaction so we can finish it when we start a navigation transaction.
let activeTransaction = undefined;

// We keep track of the previous location name so we can set the `from` field on navigation transactions.
// This is either a route or a pathname.
let prevLocationName = undefined;

const client = (0,hub/* getCurrentHub */.Gd)().getClient();

/**
 * Creates routing instrumention for Next Router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function nextRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  const { route, params, sentryTrace, baggage } = extractNextDataTagInformation();
  const { traceparentData, dynamicSamplingContext, propagationContext } = tracing_tracingContextFromHeaders(
    sentryTrace,
    baggage,
  );

  (0,hub/* getCurrentHub */.Gd)().getScope().setPropagationContext(propagationContext);
  prevLocationName = route || globalObject.location.pathname;

  if (startTransactionOnPageLoad) {
    const source = route ? 'route' : 'url';
    activeTransaction = startTransactionCb({
      name: prevLocationName,
      op: 'pageload',
      tags: DEFAULT_TAGS,
      ...(params && client && client.getOptions().sendDefaultPii && { data: params }),
      ...traceparentData,
      metadata: {
        source,
        dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
    });
  }

  if (startTransactionOnLocationChange) {
    router_default().events.on('routeChangeStart', (navigationTarget) => {
      const strippedNavigationTarget = url_stripUrlQueryAndFragment(navigationTarget);
      const matchedRoute = getNextRouteFromPathname(strippedNavigationTarget);

      let transactionName;
      let transactionSource;

      if (matchedRoute) {
        transactionName = matchedRoute;
        transactionSource = 'route';
      } else {
        transactionName = strippedNavigationTarget;
        transactionSource = 'url';
      }

      const tags = {
        ...DEFAULT_TAGS,
        from: prevLocationName,
      };

      prevLocationName = transactionName;

      if (activeTransaction) {
        activeTransaction.finish();
      }

      const navigationTransaction = startTransactionCb({
        name: transactionName,
        op: 'navigation',
        tags,
        metadata: { source: transactionSource },
      });

      if (navigationTransaction) {
        // In addition to the navigation transaction we're also starting a span to mark Next.js's `routeChangeStart`
        // and `routeChangeComplete` events.
        // We don't want to finish the navigation transaction on `routeChangeComplete`, since users might want to attach
        // spans to that transaction even after `routeChangeComplete` is fired (eg. HTTP requests in some useEffect
        // hooks). Instead, we'll simply let the navigation transaction finish itself (it's an `IdleTransaction`).
        const nextRouteChangeSpan = navigationTransaction.startChild({
          op: 'ui.nextjs.route-change',
          description: 'Next.js Route Change',
          origin: 'auto.navigation.nextjs',
        });

        const finishRouteChangeSpan = () => {
          nextRouteChangeSpan.finish();
          router_default().events.off('routeChangeComplete', finishRouteChangeSpan);
        };

        router_default().events.on('routeChangeComplete', finishRouteChangeSpan);
      }
    });
  }
}

function getNextRouteFromPathname(pathname) {
  const pageRoutes = (globalObject.__BUILD_MANIFEST || {}).sortedPages;

  // Page route should in 99.999% of the cases be defined by now but just to be sure we make a check here
  if (!pageRoutes) {
    return;
  }

  return pageRoutes.find(route => {
    const routeRegExp = convertNextRouteToRegExp(route);
    return pathname.match(routeRegExp);
  });
}

/**
 * Converts a Next.js style route to a regular expression that matches on pathnames (no query params or URL fragments).
 *
 * In general this involves replacing any instances of square brackets in a route with a wildcard:
 * e.g. "/users/[id]/info" becomes /\/users\/([^/]+?)\/info/
 *
 * Some additional edgecases need to be considered:
 * - All routes have an optional slash at the end, meaning users can navigate to "/users/[id]/info" or
 *   "/users/[id]/info/" - both will be resolved to "/users/[id]/info".
 * - Non-optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[...params]").
 * - Optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[[...params]]").
 *
 * @param route A Next.js style route as it is found in `global.__BUILD_MANIFEST.sortedPages`
 */
function convertNextRouteToRegExp(route) {
  // We can assume a route is at least "/".
  const routeParts = route.split('/');

  let optionalCatchallWildcardRegex = '';
  if (routeParts[routeParts.length - 1].match(/^\[\[\.\.\..+\]\]$/)) {
    // If last route part has pattern "[[...xyz]]" we pop the latest route part to get rid of the required trailing
    // slash that would come before it if we didn't pop it.
    routeParts.pop();
    optionalCatchallWildcardRegex = '(?:/(.+?))?';
  }

  const rejoinedRouteParts = routeParts
    .map(
      routePart =>
        routePart
          .replace(/^\[\.\.\..+\]$/, '(.+?)') // Replace catch all wildcard with regex wildcard
          .replace(/^\[.*\]$/, '([^/]+?)'), // Replace route wildcards with lazy regex wildcards
    )
    .join('/');

  return new RegExp(
    `^${rejoinedRouteParts}${optionalCatchallWildcardRegex}(?:/)?$`, // optional slash at the end
  );
}


//# sourceMappingURL=performance.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/node_modules/@sentry/utils/esm/dsn.js


/** Regular expression used to parse a Dsn. */
const dsn_DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function dsn_isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function esm_dsn_dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */
function dsn_dsnFromString(str) {
  const match = dsn_DSN_REGEX.exec(str);

  if (!match) {
    // This should be logged to the console
    // eslint-disable-next-line no-console
    console.error(`Invalid Sentry Dsn: ${str}`);
    return undefined;
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  const split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsn_dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsn_dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function dsn_validateDsn(dsn) {
  if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    return true;
  }

  const { port, projectId, protocol } = dsn;

  const requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  const hasMissingRequiredComponent = requiredComponents.find(component => {
    if (!dsn[component]) {
      logger.error(`Invalid Sentry Dsn: ${component} missing`);
      return true;
    }
    return false;
  });

  if (hasMissingRequiredComponent) {
    return false;
  }

  if (!projectId.match(/^\d+$/)) {
    logger.error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
    return false;
  }

  if (!dsn_isValidProtocol(protocol)) {
    logger.error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
    return false;
  }

  if (port && isNaN(parseInt(port, 10))) {
    logger.error(`Invalid Sentry Dsn: Invalid port ${port}`);
    return false;
  }

  return true;
}

/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */
function esm_dsn_makeDsn(from) {
  const components = typeof from === 'string' ? dsn_dsnFromString(from) : dsn_dsnFromComponents(from);
  if (!components || !dsn_validateDsn(components)) {
    return undefined;
  }
  return components;
}


//# sourceMappingURL=dsn.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/client/tunnelRoute.js


const globalWithInjectedValues = __webpack_require__.g

;

/**
 * Applies the `tunnel` option to the Next.js SDK options based on `withSentryConfig`'s `tunnelRoute` option.
 */
function applyTunnelRouteOption(options) {
  const tunnelRouteOption = globalWithInjectedValues.__sentryRewritesTunnelPath__;
  if (tunnelRouteOption && options.dsn) {
    const dsnComponents = dsn_dsnFromString(options.dsn);
    if (!dsnComponents) {
      return;
    }
    const sentrySaasDsnMatch = dsnComponents.host.match(/^o(\d+)\.ingest\.sentry\.io$/);
    if (sentrySaasDsnMatch) {
      const orgId = sentrySaasDsnMatch[1];
      const tunnelPath = `${tunnelRouteOption}?o=${orgId}&p=${dsnComponents.projectId}`;
      options.tunnel = tunnelPath;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && utils_esm_logger/* logger.info */.kg.info(`Tunneling events to "${tunnelPath}"`);
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && utils_esm_logger/* logger.warn */.kg.warn('Provided DSN is not a Sentry SaaS DSN. Will not tunnel events.');
    }
  }
}


//# sourceMappingURL=tunnelRoute.js.map

;// CONCATENATED MODULE: ../../node_modules/@sentry/nextjs/esm/client/index.js


























// Treeshakable guard to remove all code related to tracing

const client_globalWithInjectedValues = __webpack_require__.g

;

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function client_init(options) {
  const opts = {
    environment: getVercelEnv(true) || "production",
    ...options,
  };

  applyTunnelRouteOption(opts);
  buildMetadata(opts, ['nextjs', 'react']);

  addClientIntegrations(opts);

  sdk_init(opts);

  (0,esm_exports/* configureScope */.e)(scope => {
    scope.setTag('runtime', 'browser');
    const filterTransactions = event =>
      event.type === 'transaction' && event.transaction === '/404' ? null : event;
    filterTransactions.id = 'NextClient404Filter';
    scope.addEventProcessor(filterTransactions);

    if (false) {}
  });
}

function addClientIntegrations(options) {
  let integrations = options.integrations || [];

  // This value is injected at build time, based on the output directory specified in the build config. Though a default
  // is set there, we set it here as well, just in case something has gone wrong with the injection.
  const assetPrefixPath = client_globalWithInjectedValues.__rewriteFramesAssetPrefixPath__ || '';

  const defaultRewriteFramesIntegration = new RewriteFrames({
    // Turn `<origin>/<path>/_next/static/...` into `app:///_next/static/...`
    iteratee: frame => {
      try {
        const { origin } = new URL(frame.filename );
        frame.filename = _optionalChain([frame, 'access', _ => _.filename, 'optionalAccess', _2 => _2.replace, 'call', _3 => _3(origin, 'app://'), 'access', _4 => _4.replace, 'call', _5 => _5(assetPrefixPath, '')]);
      } catch (err) {
        // Filename wasn't a properly formed URL, so there's nothing we can do
      }

      // We need to URI-decode the filename because Next.js has wildcard routes like "/users/[id].js" which show up as "/users/%5id%5.js" in Error stacktraces.
      // The corresponding sources that Next.js generates have proper brackets so we also need proper brackets in the frame so that source map resolving works.
      if (frame.filename && frame.filename.startsWith('app:///_next')) {
        frame.filename = decodeURI(frame.filename);
      }

      if (
        frame.filename &&
        frame.filename.match(
          /^app:\/\/\/_next\/static\/chunks\/(main-|main-app-|polyfills-|webpack-|framework-|framework\.)[0-9a-f]+\.js$/,
        )
      ) {
        // We don't care about these frames. It's Next.js internal code.
        frame.in_app = false;
      }

      return frame;
    },
  });
  integrations = addOrUpdateIntegration(defaultRewriteFramesIntegration, integrations);

  // This evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false", in which case everything inside
  // will get treeshaken away
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    if (hasTracingEnabled(options)) {
      const defaultBrowserTracingIntegration = new BrowserTracing({
        // eslint-disable-next-line deprecation/deprecation
        tracingOrigins: [...defaultRequestInstrumentationOptions.tracingOrigins, /^(api\/)/],
        routingInstrumentation: nextRouterInstrumentation,
      });

      integrations = addOrUpdateIntegration(defaultBrowserTracingIntegration, integrations, {
        'options.routingInstrumentation': nextRouterInstrumentation,
      });
    }
  }

  options.integrations = integrations;
}

/**
 * Just a passthrough in case this is imported from the client.
 */
function withSentryConfig(exportedUserNextConfig) {
  return exportedUserNextConfig;
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
;// CONCATENATED MODULE: ./sentry.filters.js

var INVALID_ORIGIN_PHRASE = "Invalid or unrecognized origin domain";
function getExceptionMessages(event) {
    var ref;
    var ref1;
    return ((ref1 = (ref = event.exception) === null || ref === void 0 ? void 0 : ref.values) !== null && ref1 !== void 0 ? ref1 : []).map(function(value) {
        return value === null || value === void 0 ? void 0 : value.value;
    }).filter(function(value) {
        return typeof value === "string";
    });
}
function getEventMessages(event) {
    return [
        event.message
    ].concat((0,_to_consumable_array/* default */.Z)(getExceptionMessages(event))).filter(function(value) {
        return typeof value === "string";
    });
}
function shouldDropSentryEvent(event) {
    return getEventMessages(event).some(function(message) {
        return message.includes(INVALID_ORIGIN_PHRASE);
    });
}
function beforeSend(event) {
    if (shouldDropSentryEvent(event)) {
        return null;
    }
    return event;
}

;// CONCATENATED MODULE: ./sentry.client.config.js
/* provided dependency */ var sentry_client_config_process = __webpack_require__(93542);
var _sentryCollisionFreeGlobalObject =  false ? 0 : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {
    "id": "1.69.0"
};
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";



/**
 * @TODO investigate mechanisms to declutter Sentry if we log a lot of junk.
 * @see https://docs.sentry.io/clients/javascript/tips/
 */ client_init({
    dsn: envConfig/* SENTRY_DSN */.oj,
    environment: envConfig/* ENV */.Vi,
    release: sentry_client_config_process.env.SENTRY_RELEASE,
    beforeSend: beforeSend,
    // Disable tracing for now since it's not used in upstream services.
    tracesSampleRate: 0,
    denyUrls: [
        "https://siteimproveanalytics.com",
        "https://maps.googleapis.com"
    ]
});


/***/ }),

/***/ 60500:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={229:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(229);module.exports=r})();

/***/ }),

/***/ 97729:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(75913)


/***/ }),

/***/ 5632:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(93642)


/***/ }),

/***/ 99500:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hasMap = typeof Map === 'function' && Map.prototype;
var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
var mapForEach = hasMap && Map.prototype.forEach;
var hasSet = typeof Set === 'function' && Set.prototype;
var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
var setForEach = hasSet && Set.prototype.forEach;
var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
var booleanValueOf = Boolean.prototype.valueOf;
var objectToString = Object.prototype.toString;
var functionToString = Function.prototype.toString;
var $match = String.prototype.match;
var $slice = String.prototype.slice;
var $replace = String.prototype.replace;
var $toUpperCase = String.prototype.toUpperCase;
var $toLowerCase = String.prototype.toLowerCase;
var $test = RegExp.prototype.test;
var $concat = Array.prototype.concat;
var $join = Array.prototype.join;
var $arrSlice = Array.prototype.slice;
var $floor = Math.floor;
var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var gOPS = Object.getOwnPropertySymbols;
var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
    ? Symbol.toStringTag
    : null;
var isEnumerable = Object.prototype.propertyIsEnumerable;

var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
    [].__proto__ === Array.prototype // eslint-disable-line no-proto
        ? function (O) {
            return O.__proto__; // eslint-disable-line no-proto
        }
        : null
);

function addNumericSeparator(num, str) {
    if (
        num === Infinity
        || num === -Infinity
        || num !== num
        || (num && num > -1000 && num < 1000)
        || $test.call(/e/, str)
    ) {
        return str;
    }
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $slice.call(str, intStr.length + 1);
            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $replace.call(str, sepRegex, '$&_');
}

var utilInspect = __webpack_require__(53260);
var inspectCustom = utilInspect.custom;
var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;

var quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};

module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};

    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
        throw new TypeError('option "quoteStyle" must be "single" or "double"');
    }
    if (
        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
            : opts.maxStringLength !== null
        )
    ) {
        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    }
    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    }

    if (
        has(opts, 'indent')
        && opts.indent !== null
        && opts.indent !== '\t'
        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
    ) {
        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    }
    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    }
    var numericSeparator = opts.numericSeparator;

    if (typeof obj === 'undefined') {
        return 'undefined';
    }
    if (obj === null) {
        return 'null';
    }
    if (typeof obj === 'boolean') {
        return obj ? 'true' : 'false';
    }

    if (typeof obj === 'string') {
        return inspectString(obj, opts);
    }
    if (typeof obj === 'number') {
        if (obj === 0) {
            return Infinity / obj > 0 ? '0' : '-0';
        }
        var str = String(obj);
        return numericSeparator ? addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }

    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') { depth = 0; }
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
        return isArray(obj) ? '[Array]' : '[Object]';
    }

    var indent = getIndent(opts, depth);

    if (typeof seen === 'undefined') {
        seen = [];
    } else if (indexOf(seen, obj) >= 0) {
        return '[Circular]';
    }

    function inspect(value, from, noIndent) {
        if (from) {
            seen = $arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if (has(opts, 'quoteStyle')) {
                newOpts.quoteStyle = opts.quoteStyle;
            }
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }

    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
        var name = nameOf(obj);
        var keys = arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
    }
    if (isSymbol(obj)) {
        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
    }
    if (isElement(obj)) {
        var s = '<' + $toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for (var i = 0; i < attrs.length; i++) {
            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
        }
        s += '>';
        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if (isArray(obj)) {
        if (obj.length === 0) { return '[]'; }
        var xs = arrObjKeys(obj, inspect);
        if (indent && !singleLineValues(xs)) {
            return '[' + indentedJoin(xs, indent) + ']';
        }
        return '[ ' + $join.call(xs, ', ') + ' ]';
    }
    if (isError(obj)) {
        var parts = arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        }
        if (parts.length === 0) { return '[' + String(obj) + ']'; }
        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
            return utilInspect(obj, { depth: maxDepth - depth });
        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
            return obj.inspect();
        }
    }
    if (isMap(obj)) {
        var mapParts = [];
        if (mapForEach) {
            mapForEach.call(obj, function (value, key) {
                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
            });
        }
        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
    }
    if (isSet(obj)) {
        var setParts = [];
        if (setForEach) {
            setForEach.call(obj, function (value) {
                setParts.push(inspect(value, obj));
            });
        }
        return collectionOf('Set', setSize.call(obj), setParts, indent);
    }
    if (isWeakMap(obj)) {
        return weakCollectionOf('WeakMap');
    }
    if (isWeakSet(obj)) {
        return weakCollectionOf('WeakSet');
    }
    if (isWeakRef(obj)) {
        return weakCollectionOf('WeakRef');
    }
    if (isNumber(obj)) {
        return markBoxed(inspect(Number(obj)));
    }
    if (isBigInt(obj)) {
        return markBoxed(inspect(bigIntValueOf.call(obj)));
    }
    if (isBoolean(obj)) {
        return markBoxed(booleanValueOf.call(obj));
    }
    if (isString(obj)) {
        return markBoxed(inspect(String(obj)));
    }
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */
    if (typeof window !== 'undefined' && obj === window) {
        return '{ [object Window] }';
    }
    if (
        (typeof globalThis !== 'undefined' && obj === globalThis)
        || (typeof __webpack_require__.g !== 'undefined' && obj === __webpack_require__.g)
    ) {
        return '{ [object globalThis] }';
    }
    if (!isDate(obj) && !isRegExp(obj)) {
        var ys = arrObjKeys(obj, inspect);
        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) { return tag + '{}'; }
        if (indent) {
            return tag + '{' + indentedJoin(ys, indent) + '}';
        }
        return tag + '{ ' + $join.call(ys, ', ') + ' }';
    }
    return String(obj);
};

function wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = quotes[style];
    return quoteChar + s + quoteChar;
}

function quote(s) {
    return $replace.call(String(s), /"/g, '&quot;');
}

function canTrustToString(obj) {
    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
}
function isArray(obj) { return toStr(obj) === '[object Array]' && canTrustToString(obj); }
function isDate(obj) { return toStr(obj) === '[object Date]' && canTrustToString(obj); }
function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && canTrustToString(obj); }
function isError(obj) { return toStr(obj) === '[object Error]' && canTrustToString(obj); }
function isString(obj) { return toStr(obj) === '[object String]' && canTrustToString(obj); }
function isNumber(obj) { return toStr(obj) === '[object Number]' && canTrustToString(obj); }
function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && canTrustToString(obj); }

// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function isSymbol(obj) {
    if (hasShammedSymbols) {
        return obj && typeof obj === 'object' && obj instanceof Symbol;
    }
    if (typeof obj === 'symbol') {
        return true;
    }
    if (!obj || typeof obj !== 'object' || !symToString) {
        return false;
    }
    try {
        symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}

function isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
        return false;
    }
    try {
        bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}

var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
function has(obj, key) {
    return hasOwn.call(obj, key);
}

function toStr(obj) {
    return objectToString.call(obj);
}

function nameOf(f) {
    if (f.name) { return f.name; }
    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) { return m[1]; }
    return null;
}

function indexOf(xs, x) {
    if (xs.indexOf) { return xs.indexOf(x); }
    for (var i = 0, l = xs.length; i < l; i++) {
        if (xs[i] === x) { return i; }
    }
    return -1;
}

function isMap(x) {
    if (!mapSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        mapSize.call(x);
        try {
            setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakMap(x) {
    if (!weakMapHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakMapHas.call(x, weakMapHas);
        try {
            weakSetHas.call(x, weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakRef(x) {
    if (!weakRefDeref || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}

function isSet(x) {
    if (!setSize || !x || typeof x !== 'object') {
        return false;
    }
    try {
        setSize.call(x);
        try {
            mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isWeakSet(x) {
    if (!weakSetHas || !x || typeof x !== 'object') {
        return false;
    }
    try {
        weakSetHas.call(x, weakSetHas);
        try {
            weakMapHas.call(x, weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}

function isElement(x) {
    if (!x || typeof x !== 'object') { return false; }
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
        return true;
    }
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}

function inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
    return wrapQuotes(s, 'single', opts);
}

function lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) { return '\\' + x; }
    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
}

function markBoxed(str) {
    return 'Object(' + str + ')';
}

function weakCollectionOf(type) {
    return type + ' { ? }';
}

function collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}

function singleLineValues(xs) {
    for (var i = 0; i < xs.length; i++) {
        if (indexOf(xs[i], '\n') >= 0) {
            return false;
        }
    }
    return true;
}

function getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') {
        baseIndent = '\t';
    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
        baseIndent = $join.call(Array(opts.indent + 1), ' ');
    } else {
        return null;
    }
    return {
        base: baseIndent,
        prev: $join.call(Array(depth + 1), baseIndent)
    };
}

function indentedJoin(xs, indent) {
    if (xs.length === 0) { return ''; }
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}

function arrObjKeys(obj, inspect) {
    var isArr = isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for (var i = 0; i < obj.length; i++) {
            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
        }
    }
    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
    var symMap;
    if (hasShammedSymbols) {
        symMap = {};
        for (var k = 0; k < syms.length; k++) {
            symMap['$' + syms[k]] = syms[k];
        }
    }

    for (var key in obj) { // eslint-disable-line no-restricted-syntax
        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
            continue; // eslint-disable-line no-restricted-syntax, no-continue
        } else if ($test.call(/[^\w$]/, key)) {
            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        } else {
            xs.push(key + ': ' + inspect(obj[key], obj));
        }
    }
    if (typeof gOPS === 'function') {
        for (var j = 0; j < syms.length; j++) {
            if (isEnumerable.call(obj, syms[j])) {
                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
            }
        }
    }
    return xs;
}


/***/ }),

/***/ 68262:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(23586);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 13980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(68262)();
}


/***/ }),

/***/ 23586:
/***/ (function(module) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 85527:
/***/ (function(module) {

"use strict";


var replace = String.prototype.replace;
var percentTwenties = /%20/g;

var Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

module.exports = {
    'default': Format.RFC3986,
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return String(value);
        }
    },
    RFC1738: Format.RFC1738,
    RFC3986: Format.RFC3986
};


/***/ }),

/***/ 19126:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var stringify = __webpack_require__(66845);
var parse = __webpack_require__(29166);
var formats = __webpack_require__(85527);

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};


/***/ }),

/***/ 29166:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(12493);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    duplicates: 'combine',
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false,
    throwOnLimitExceeded: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

var parseArrayValue = function (val, options, currentArrayLength) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
        return val.split(',');
    }

    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) {
        throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
    }

    return val;
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = { __proto__: null };

    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');

    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(
        options.delimiter,
        options.throwOnLimitExceeded ? limit + 1 : limit
    );

    if (options.throwOnLimitExceeded && parts.length > limit) {
        throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
    }

    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key;
        var val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');

            if (key !== null) {
                val = utils.maybeMap(
                    parseArrayValue(
                        part.slice(pos + 1),
                        options,
                        isArray(obj[key]) ? obj[key].length : 0
                    ),
                    function (encodedVal) {
                        return options.decoder(encodedVal, defaults.decoder, charset, 'value');
                    }
                );
            }
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(String(val));
        }

        if (part.indexOf('[]=') > -1) {
            val = isArray(val) ? [val] : val;
        }

        if (key !== null) {
            var existing = has.call(obj, key);
            if (existing && options.duplicates === 'combine') {
                obj[key] = utils.combine(
                    obj[key],
                    val,
                    options.arrayLimit,
                    options.plainObjects
                );
            } else if (!existing || options.duplicates === 'last') {
                obj[key] = val;
            }
        }
    }

    return obj;
};

var parseObject = function (chain, val, options, valuesParsed) {
    var currentArrayLength = 0;
    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
        var parentKey = chain.slice(0, -1).join('');
        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
    }

    var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength);

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            if (utils.isOverflow(leaf)) {
                // leaf is already an overflow object, preserve it
                obj = leaf;
            } else {
                obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
                    ? []
                    : utils.combine(
                        [],
                        leaf,
                        options.arrayLimit,
                        options.plainObjects
                    );
            }
        } else {
            obj = options.plainObjects ? { __proto__: null } : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== decodedRoot
                && String(index) === decodedRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== '__proto__') {
                obj[decodedRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var splitKeyIntoSegments = function splitKeyIntoSegments(givenKey, options) {
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    if (options.depth <= 0) {
        if (!options.plainObjects && has.call(Object.prototype, key)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        return [key];
    }

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    var keys = [];

    if (parent) {
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;

        var segmentContent = segment[1].slice(1, -1);
        if (!options.plainObjects && has.call(Object.prototype, segmentContent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(segment[1]);
    }

    if (segment) {
        if (options.strictDepth === true) {
            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
        }

        keys.push('[' + key.slice(segment.index) + ']');
    }

    return keys;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) {
        return;
    }

    var keys = splitKeyIntoSegments(givenKey, options);

    if (!keys) {
        return;
    }

    return parseObject(keys, val, options, valuesParsed);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') {
        throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
    }

    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;

    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
        throw new TypeError('The duplicates option must be either combine, first, or last');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling,
        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? { __proto__: null } : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? { __proto__: null } : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = utils.merge(obj, newObj, options);
    }

    if (options.allowSparse === true) {
        return obj;
    }

    return utils.compact(obj);
};


/***/ }),

/***/ 66845:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var getSideChannel = __webpack_require__(13103);
var utils = __webpack_require__(12493);
var formats = __webpack_require__(85527);
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaultFormat = formats['default'];
var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: 'indices',
    charset: 'utf-8',
    charsetSentinel: false,
    commaRoundTrip: false,
    delimiter: '&',
    encode: true,
    encodeDotInKeys: false,
    encoder: utils.encode,
    encodeValuesOnly: false,
    filter: void undefined,
    format: defaultFormat,
    formatter: formats.formatters[defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string'
        || typeof v === 'number'
        || typeof v === 'boolean'
        || typeof v === 'symbol'
        || typeof v === 'bigint';
};

var sentinel = {};

var stringify = function stringify(
    object,
    prefix,
    generateArrayPrefix,
    commaRoundTrip,
    allowEmptyArrays,
    strictNullHandling,
    skipNulls,
    encodeDotInKeys,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    format,
    formatter,
    encodeValuesOnly,
    charset,
    sideChannel
) {
    var obj = object;

    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) {
                throw new RangeError('Cyclic object value');
            } else {
                findFlag = true; // Break while
            }
        }
        if (typeof tmpSc.get(sentinel) === 'undefined') {
            step = 0;
        }
    }

    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = utils.maybeMap(obj, function (value) {
            if (value instanceof Date) {
                return serializeDate(value);
            }
            return value;
        });
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix;
        }

        obj = '';
    }

    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (generateArrayPrefix === 'comma' && isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) {
            obj = utils.maybeMap(obj, encoder);
        }
        objKeys = [{ value: obj.length > 0 ? obj.join(',') || null : void undefined }];
    } else if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    var encodedPrefix = encodeDotInKeys ? String(prefix).replace(/\./g, '%2E') : String(prefix);

    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;

    if (allowEmptyArrays && isArray(obj) && obj.length === 0) {
        return adjustedPrefix + '[]';
    }

    for (var j = 0; j < objKeys.length; ++j) {
        var key = objKeys[j];
        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
            ? key.value
            : obj[key];

        if (skipNulls && value === null) {
            continue;
        }

        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
        var keyPrefix = isArray(obj)
            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');

        sideChannel.set(object, step);
        var valueSideChannel = getSideChannel();
        valueSideChannel.set(sentinel, sideChannel);
        pushToArray(values, stringify(
            value,
            keyPrefix,
            generateArrayPrefix,
            commaRoundTrip,
            allowEmptyArrays,
            strictNullHandling,
            skipNulls,
            encodeDotInKeys,
            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
            filter,
            sort,
            allowDots,
            serializeDate,
            format,
            formatter,
            encodeValuesOnly,
            charset,
            valueSideChannel
        ));
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
    }

    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
    }

    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    var arrayFormat;
    if (opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if ('indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = defaults.arrayFormat;
    }

    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    }

    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        commaRoundTrip: !!opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    var sideChannel = getSideChannel();
    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];
        var value = obj[key];

        if (options.skipNulls && value === null) {
            continue;
        }
        pushToArray(keys, stringify(
            value,
            key,
            generateArrayPrefix,
            commaRoundTrip,
            options.allowEmptyArrays,
            options.strictNullHandling,
            options.skipNulls,
            options.encodeDotInKeys,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.format,
            options.formatter,
            options.encodeValuesOnly,
            options.charset,
            sideChannel
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};


/***/ }),

/***/ 12493:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var formats = __webpack_require__(85527);
var getSideChannel = __webpack_require__(13103);

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

// Track objects created from arrayLimit overflow using side-channel
// Stores the current max numeric index for O(1) lookup
var overflowChannel = getSideChannel();

var markOverflow = function markOverflow(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
    return obj;
};

var isOverflow = function isOverflow(obj) {
    return overflowChannel.has(obj);
};

var getMaxIndex = function getMaxIndex(obj) {
    return overflowChannel.get(obj);
};

var setMaxIndex = function setMaxIndex(obj, maxIndex) {
    overflowChannel.set(obj, maxIndex);
};

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? { __proto__: null } : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */
    if (!source) {
        return target;
    }

    if (typeof source !== 'object' && typeof source !== 'function') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if (isOverflow(target)) {
                // Add at next numeric index for overflow objects
                var newIndex = getMaxIndex(target) + 1;
                target[newIndex] = source;
                setMaxIndex(target, newIndex);
            } else if (
                (options && (options.plainObjects || options.allowPrototypes))
                || !has.call(Object.prototype, source)
            ) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        if (isOverflow(source)) {
            // Create new object with target at 0, source values shifted by 1
            var sourceKeys = Object.keys(source);
            var result = options && options.plainObjects
                ? { __proto__: null, 0: target }
                : { 0: target };
            for (var m = 0; m < sourceKeys.length; m++) {
                var oldKey = parseInt(sourceKeys[m], 10);
                result[oldKey + 1] = source[sourceKeys[m]];
            }
            return markOverflow(result, getMaxIndex(source) + 1);
        }
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, defaultDecoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var limit = 1024;

/* eslint operator-linebreak: [2, "before"] */

var encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = str;
    if (typeof str === 'symbol') {
        string = Symbol.prototype.toString.call(str);
    } else if (typeof str !== 'string') {
        string = String(str);
    }

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var j = 0; j < string.length; j += limit) {
        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
        var arr = [];

        for (var i = 0; i < segment.length; ++i) {
            var c = segment.charCodeAt(i);
            if (
                c === 0x2D // -
                || c === 0x2E // .
                || c === 0x5F // _
                || c === 0x7E // ~
                || (c >= 0x30 && c <= 0x39) // 0-9
                || (c >= 0x41 && c <= 0x5A) // a-z
                || (c >= 0x61 && c <= 0x7A) // A-Z
                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }

            if (c < 0x80) {
                arr[arr.length] = hexTable[c];
                continue;
            }

            if (c < 0x800) {
                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
                    + hexTable[0x80 | (c & 0x3F)];
                continue;
            }

            i += 1;
            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));

            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
                + hexTable[0x80 | ((c >> 12) & 0x3F)]
                + hexTable[0x80 | ((c >> 6) & 0x3F)]
                + hexTable[0x80 | (c & 0x3F)];
        }

        out += arr.join('');
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b, arrayLimit, plainObjects) {
    // If 'a' is already an overflow object, add to it
    if (isOverflow(a)) {
        var newIndex = getMaxIndex(a) + 1;
        a[newIndex] = b;
        setMaxIndex(a, newIndex);
        return a;
    }

    var result = [].concat(a, b);
    if (result.length > arrayLimit) {
        return markOverflow(arrayToObject(result, { plainObjects: plainObjects }), result.length - 1);
    }
    return result;
};

var maybeMap = function maybeMap(val, fn) {
    if (isArray(val)) {
        var mapped = [];
        for (var i = 0; i < val.length; i += 1) {
            mapped.push(fn(val[i]));
        }
        return mapped;
    }
    return fn(val);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isOverflow: isOverflow,
    isRegExp: isRegExp,
    maybeMap: maybeMap,
    merge: merge
};


/***/ }),

/***/ 13103:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(5408);
var inspect = __webpack_require__(99500);
var getSideChannelList = __webpack_require__(12642);
var getSideChannelMap = __webpack_require__(46623);
var getSideChannelWeakMap = __webpack_require__(42207);

var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;

/** @type {import('.')} */
module.exports = function getSideChannel() {
	/** @typedef {ReturnType<typeof getSideChannel>} Channel */

	/** @type {Channel | undefined} */ var $channelData;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			return !!$channelData && $channelData['delete'](key);
		},
		get: function (key) {
			return $channelData && $channelData.get(key);
		},
		has: function (key) {
			return !!$channelData && $channelData.has(key);
		},
		set: function (key, value) {
			if (!$channelData) {
				$channelData = makeChannel();
			}

			$channelData.set(key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),

/***/ 66866:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 48570:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(66866);
} else {}


/***/ }),

/***/ 46847:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "polyfill": function() { return /* binding */ polyfill; }
/* harmony export */ });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),

/***/ 24108:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _reactRedux = __webpack_require__(56580);

var _loading_bar = __webpack_require__(86411);

var _loading_bar_ducks = __webpack_require__(88429);

var mapImmutableStateToProps = function mapImmutableStateToProps(state, ownProps) {
  return {
    loading: state.get('loadingBar')[ownProps.scope || _loading_bar_ducks.DEFAULT_SCOPE]
  };
};

var _default = (0, _reactRedux.connect)(mapImmutableStateToProps)(_loading_bar.LoadingBar);

exports["default"] = _default;

/***/ }),

/***/ 22299:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

__webpack_unused_export__ = ({
  value: true
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _loading_bar.LoadingBar;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _loading_bar_middleware["default"];
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _loading_bar_ducks.DEFAULT_SCOPE;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _loading_bar_ducks.HIDE;
  }
});
Object.defineProperty(exports, "Zk", ({
  enumerable: true,
  get: function get() {
    return _loading_bar_ducks.hideLoading;
  }
}));
Object.defineProperty(exports, "N$", ({
  enumerable: true,
  get: function get() {
    return _loading_bar_ducks.loadingBarReducer;
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _loading_bar_ducks.RESET;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _loading_bar_ducks.resetLoading;
  }
});
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _loading_bar_ducks.SHOW;
  }
});
Object.defineProperty(exports, "QP", ({
  enumerable: true,
  get: function get() {
    return _loading_bar_ducks.showLoading;
  }
}));
__webpack_unused_export__ = ({
  enumerable: true,
  get: function get() {
    return _immutable["default"];
  }
});
exports.ZP = void 0;

var _loading_bar = _interopRequireWildcard(__webpack_require__(86411));

var _loading_bar_middleware = _interopRequireDefault(__webpack_require__(78408));

var _loading_bar_ducks = __webpack_require__(88429);

var _immutable = _interopRequireDefault(__webpack_require__(24108));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = _loading_bar["default"];
exports.ZP = _default;

/***/ }),

/***/ 86411:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = exports.LoadingBar = exports.TERMINATING_ANIMATION_DURATION = exports.ANIMATION_DURATION = exports.PROGRESS_INCREASE = exports.MAX_PROGRESS = exports.UPDATE_TIME = void 0;

var _react = _interopRequireWildcard(__webpack_require__(2784));

var _reactLifecyclesCompat = __webpack_require__(46847);

var _propTypes = __webpack_require__(13980);

var _reactRedux = __webpack_require__(56580);

var _loading_bar_ducks = __webpack_require__(88429);

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var UPDATE_TIME = 400;
exports.UPDATE_TIME = UPDATE_TIME;
var MAX_PROGRESS = 99;
exports.MAX_PROGRESS = MAX_PROGRESS;
var PROGRESS_INCREASE = 20;
exports.PROGRESS_INCREASE = PROGRESS_INCREASE;
var ANIMATION_DURATION = UPDATE_TIME * 2;
exports.ANIMATION_DURATION = ANIMATION_DURATION;
var TERMINATING_ANIMATION_DURATION = UPDATE_TIME / 2;
exports.TERMINATING_ANIMATION_DURATION = TERMINATING_ANIMATION_DURATION;
var initialState = {
  percent: 0,
  status: 'hidden'
};

var LoadingBar = /*#__PURE__*/function (_Component) {
  _inherits(LoadingBar, _Component);

  var _super = _createSuper(LoadingBar);

  _createClass(LoadingBar, null, [{
    key: "shouldStart",
    value: function shouldStart(props, state) {
      return props.loading > 0 && ['hidden', 'stopping'].indexOf(state.status) >= 0;
    }
  }, {
    key: "shouldStop",
    value: function shouldStop(props, state) {
      return props.loading === 0 && ['starting', 'running'].indexOf(state.status) >= 0;
    }
  }, {
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, prevState) {
      if (LoadingBar.shouldStart(nextProps, prevState)) {
        return {
          status: 'starting'
        };
      }

      if (LoadingBar.shouldStop(nextProps, prevState)) {
        return {
          status: 'stopping'
        };
      }

      return null;
    }
  }]);

  function LoadingBar(props) {
    var _this;

    _classCallCheck(this, LoadingBar);

    _this = _super.call(this, props);

    _this.reset = function () {
      _this.terminatingAnimationTimeoutId = null;

      _this.setState(initialState);
    };

    _this.newPercent = function (percent, progressIncrease) {
      // Use cosine as a smoothing function
      // It could be any function to slow down progress near the ending 100%
      var smoothedProgressIncrease = progressIncrease * Math.cos(percent * (Math.PI / 2 / 100));
      return percent + smoothedProgressIncrease;
    };

    _this.simulateProgress = function () {
      _this.setState(function (prevState, _ref) {
        var maxProgress = _ref.maxProgress,
            progressIncrease = _ref.progressIncrease;
        var percent = prevState.percent;

        var newPercent = _this.newPercent(percent, progressIncrease);

        if (newPercent <= maxProgress) {
          percent = newPercent;
        }

        return {
          percent: percent
        };
      });
    };

    _this.state = _objectSpread({}, initialState);
    return _this;
  }

  _createClass(LoadingBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var status = this.state.status;

      if (status === 'starting') {
        this.start();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var status = this.state.status;

      if (prevState.status !== status) {
        if (status === 'starting') {
          this.start();
        }

        if (status === 'stopping') {
          this.stop();
        }
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.progressIntervalId);
      clearTimeout(this.terminatingAnimationTimeoutId);
    }
  }, {
    key: "start",
    value: function start() {
      // There could be previous termination animation going, so we need to
      // cancel it and forcefully reset the Loading Bar before starting
      // the progress simulation from 0
      if (this.terminatingAnimationTimeoutId) {
        clearTimeout(this.terminatingAnimationTimeoutId);
        this.reset();
      }

      var updateTime = this.props.updateTime;
      this.progressIntervalId = setInterval(this.simulateProgress, updateTime);
      this.setState({
        status: 'running'
      });
    }
  }, {
    key: "stop",
    value: function stop() {
      var showFastActions = this.props.showFastActions;
      clearInterval(this.progressIntervalId);
      this.progressIntervalId = null;
      var terminatingAnimationDuration = this.isShown() || showFastActions ? TERMINATING_ANIMATION_DURATION : 0;
      this.terminatingAnimationTimeoutId = setTimeout(this.reset, terminatingAnimationDuration);
      this.setState({
        percent: 100
      });
    }
  }, {
    key: "isShown",
    value: function isShown() {
      var percent = this.state.percent;
      return percent > 0 && percent <= 100;
    }
  }, {
    key: "buildStyle",
    value: function buildStyle() {
      var _this$state = this.state,
          status = _this$state.status,
          percent = _this$state.percent;
      var _this$props = this.props,
          className = _this$props.className,
          customStyle = _this$props.style;
      var animationDuration = status === 'stopping' ? TERMINATING_ANIMATION_DURATION : ANIMATION_DURATION;
      var style = {
        width: "".concat(percent, "%"),
        transition: "width ".concat(animationDuration, "ms linear 0s"),
        msTransition: "width ".concat(animationDuration, "ms linear 0s"),
        WebkitTransition: "width ".concat(animationDuration, "ms linear 0s"),
        MozTransition: "width ".concat(animationDuration, "ms linear 0s"),
        OTransition: "width ".concat(animationDuration, "ms linear 0s"),
        willChange: 'width, opacity'
      }; // Use default styling if there's no CSS class applied

      if (!className) {
        style.height = '3px';
        style.backgroundColor = 'red';
        style.position = 'absolute';
      }

      if (this.isShown()) {
        style.opacity = '1';
      } else {
        style.opacity = '0';
      }

      return _objectSpread(_objectSpread({}, style), customStyle);
    }
  }, {
    key: "render",
    value: function render() {
      var status = this.state.status;
      var _this$props2 = this.props,
          direction = _this$props2.direction,
          className = _this$props2.className;

      if (status === 'hidden') {
        return /*#__PURE__*/_react["default"].createElement("div", null);
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          direction: direction
        }
      }, /*#__PURE__*/_react["default"].createElement("div", {
        style: this.buildStyle(),
        className: className
      }), /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          display: 'table',
          clear: 'both'
        }
      }));
    }
  }]);

  return LoadingBar;
}(_react.Component);

exports.LoadingBar = LoadingBar;
LoadingBar.propTypes = {
  className: _propTypes.string,
  direction: _propTypes.string,
  loading: _propTypes.number,
  maxProgress: _propTypes.number,
  progressIncrease: _propTypes.number,
  scope: _propTypes.string,
  showFastActions: _propTypes.bool,
  style: _propTypes.object,
  updateTime: _propTypes.number
};
LoadingBar.defaultProps = {
  className: '',
  direction: 'ltr',
  loading: 0,
  maxProgress: MAX_PROGRESS,
  progressIncrease: PROGRESS_INCREASE,
  scope: _loading_bar_ducks.DEFAULT_SCOPE,
  showFastActions: false,
  style: {},
  updateTime: UPDATE_TIME
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  return {
    loading: state.loadingBar[ownProps.scope || _loading_bar_ducks.DEFAULT_SCOPE]
  };
};

(0, _reactLifecyclesCompat.polyfill)(LoadingBar);
var ConnectedLoadingBar = (0, _reactRedux.connect)(mapStateToProps)(LoadingBar);
exports["default"] = ConnectedLoadingBar;

/***/ }),

/***/ 88429:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.showLoading = showLoading;
exports.hideLoading = hideLoading;
exports.resetLoading = resetLoading;
exports.loadingBarReducer = loadingBarReducer;
exports.DEFAULT_SCOPE = exports.RESET = exports.HIDE = exports.SHOW = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SHOW = 'loading-bar/SHOW';
exports.SHOW = SHOW;
var HIDE = 'loading-bar/HIDE';
exports.HIDE = HIDE;
var RESET = 'loading-bar/RESET';
exports.RESET = RESET;
var DEFAULT_SCOPE = 'default';
exports.DEFAULT_SCOPE = DEFAULT_SCOPE;

function showLoading() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SCOPE;
  return {
    type: SHOW,
    payload: {
      scope: scope
    }
  };
}

function hideLoading() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SCOPE;
  return {
    type: HIDE,
    payload: {
      scope: scope
    }
  };
}

function resetLoading() {
  var scope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SCOPE;
  return {
    type: RESET,
    payload: {
      scope: scope
    }
  };
}

function loadingBarReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref = action.payload || {},
      _ref$scope = _ref.scope,
      scope = _ref$scope === void 0 ? DEFAULT_SCOPE : _ref$scope;

  switch (action.type) {
    case SHOW:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, scope, (state[scope] || 0) + 1));

    case HIDE:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, scope, Math.max(0, (state[scope] || 1) - 1)));

    case RESET:
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, scope, 0));

    default:
      return state;
  }
}

/***/ }),

/***/ 78408:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = loadingBarMiddleware;

var _loading_bar_ducks = __webpack_require__(88429);

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var defaultTypeSuffixes = ['PENDING', 'FULFILLED', 'REJECTED'];

function loadingBarMiddleware() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var promiseTypeSuffixes = config.promiseTypeSuffixes || defaultTypeSuffixes;
  var scope = config.scope || _loading_bar_ducks.DEFAULT_SCOPE;
  return function (_ref) {
    var dispatch = _ref.dispatch;
    return function (next) {
      return function (action) {
        if (action.type) {
          var _promiseTypeSuffixes = _slicedToArray(promiseTypeSuffixes, 3),
              PENDING = _promiseTypeSuffixes[0],
              FULFILLED = _promiseTypeSuffixes[1],
              REJECTED = _promiseTypeSuffixes[2];

          var isPending = new RegExp("".concat(PENDING, "$"), 'g');
          var isFulfilled = new RegExp("".concat(FULFILLED, "$"), 'g');
          var isRejected = new RegExp("".concat(REJECTED, "$"), 'g');
          var actionScope = action.meta && action.meta.scope || action.scope || scope;

          if (action.type.match(isPending)) {
            dispatch((0, _loading_bar_ducks.showLoading)(actionScope));
          } else if (action.type.match(isFulfilled) || action.type.match(isRejected)) {
            dispatch((0, _loading_bar_ducks.hideLoading)(actionScope));
          }
        }

        return next(action);
      };
    };
  };
}

/***/ }),

/***/ 56580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Provider": function() { return /* reexport */ components_Provider; },
  "ReactReduxContext": function() { return /* reexport */ ReactReduxContext; },
  "batch": function() { return /* reexport */ react_dom.unstable_batchedUpdates; },
  "connect": function() { return /* reexport */ components_connect; },
  "createDispatchHook": function() { return /* reexport */ createDispatchHook; },
  "createSelectorHook": function() { return /* reexport */ createSelectorHook; },
  "createStoreHook": function() { return /* reexport */ createStoreHook; },
  "shallowEqual": function() { return /* reexport */ shallowEqual; },
  "useDispatch": function() { return /* reexport */ useDispatch; },
  "useSelector": function() { return /* reexport */ useSelector; },
  "useStore": function() { return /* reexport */ useStore_useStore; }
});

// EXTERNAL MODULE: ../../node_modules/use-sync-external-store/shim/index.js
var shim = __webpack_require__(43100);
// EXTERNAL MODULE: ../../node_modules/use-sync-external-store/shim/with-selector.js
var with_selector = __webpack_require__(41110);
// EXTERNAL MODULE: ../../node_modules/react-dom/index.js
var react_dom = __webpack_require__(28316);
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/reactBatchedUpdates.js

;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

let batch = defaultNoopBatch; // Allow injecting another batching function later

const setBatch = newBatch => batch = newBatch; // Supply a getter just to skip dealing with ESM bindings

const getBatch = () => batch;
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/components/Context.js

const ContextKey = Symbol.for(`react-redux-context`);
const gT = typeof globalThis !== "undefined" ? globalThis :
/* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
{};

function getContext() {
  var _gT$ContextKey;

  if (!react.createContext) return {};
  const contextMap = (_gT$ContextKey = gT[ContextKey]) != null ? _gT$ContextKey : gT[ContextKey] = new Map();
  let realContext = contextMap.get(react.createContext);

  if (!realContext) {
    realContext = react.createContext(null);

    if (false) {}

    contextMap.set(react.createContext, realContext);
  }

  return realContext;
}

const ReactReduxContext = /*#__PURE__*/getContext();
/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (ReactReduxContext)));
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/hooks/useReduxContext.js



/**
 * Hook factory, which creates a `useReduxContext` hook bound to a given context. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useReduxContext` hook bound to the specified context.
 */
function createReduxContextHook(context = ReactReduxContext) {
  return function useReduxContext() {
    const contextValue = (0,react.useContext)(context);

    if (false) {}

    return contextValue;
  };
}
/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

const useReduxContext_useReduxContext = /*#__PURE__*/createReduxContextHook();
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/useSyncExternalStore.js
const notInitialized = () => {
  throw new Error('uSES not initialized!');
};
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/hooks/useSelector.js




let useSyncExternalStoreWithSelector = notInitialized;
const initializeUseSelector = fn => {
  useSyncExternalStoreWithSelector = fn;
};

const refEquality = (a, b) => a === b;
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context = ReactReduxContext) {
  const useReduxContext = context === ReactReduxContext ? useReduxContext_useReduxContext : createReduxContextHook(context);
  return function useSelector(selector, equalityFnOrOptions = {}) {
    const {
      equalityFn = refEquality,
      stabilityCheck = undefined,
      noopCheck = undefined
    } = typeof equalityFnOrOptions === 'function' ? {
      equalityFn: equalityFnOrOptions
    } : equalityFnOrOptions;

    if (false) {}

    const {
      store,
      subscription,
      getServerState,
      stabilityCheck: globalStabilityCheck,
      noopCheck: globalNoopCheck
    } = useReduxContext();
    const firstRun = (0,react.useRef)(true);
    const wrappedSelector = (0,react.useCallback)({
      [selector.name](state) {
        const selected = selector(state);

        if (false) {}

        return selected;
      }

    }[selector.name], [selector, globalStabilityCheck, stabilityCheck]);
    const selectedState = useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

const useSelector = /*#__PURE__*/createSelectorHook();
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(73463);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ../../node_modules/react-redux/node_modules/react-is/index.js
var react_is = __webpack_require__(63920);
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/connect/selectorFactory.js

const _excluded = ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"];

function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, {
  areStatesEqual,
  areOwnPropsEqual,
  areStatePropsEqual
}) {
  let hasRunAtLeastOnce = false;
  let state;
  let ownProps;
  let stateProps;
  let dispatchProps;
  let mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    const nextStateProps = mapStateToProps(state, ownProps);
    const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
}
// TODO: Add more comments
// The selector returned by selectorFactory will memoize its results,
// allowing connect's shouldComponentUpdate to return false if final
// props have not changed.
function finalPropsSelectorFactory(dispatch, _ref) {
  let {
    initMapStateToProps,
    initMapDispatchToProps,
    initMergeProps
  } = _ref,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, _excluded);

  const mapStateToProps = initMapStateToProps(dispatch, options);
  const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  const mergeProps = initMergeProps(dispatch, options);

  if (false) {}

  return pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/bindActionCreators.js
function bindActionCreators(actionCreators, dispatch) {
  const boundActionCreators = {};

  for (const key in actionCreators) {
    const actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = (...args) => dispatch(actionCreator(...args));
    }
  }

  return boundActionCreators;
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant( // * Note:
//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
  return function initConstantSelector(dispatch) {
    const constant = getConstant(dispatch);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
// TODO Can this get pulled out so that we can subscribe directly to the store if we don't need ownProps?

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, {
    displayName
  }) {
    const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      let props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) {}
      return props;
    };

    return proxy;
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/connect/invalidArgFactory.js
function createInvalidArgFactory(arg, name) {
  return (dispatch, options) => {
    throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
  };
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/connect/mapDispatchToProps.js



function mapDispatchToPropsFactory(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(dispatch => // @ts-ignore
  bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? wrapMapToPropsConstant(dispatch => ({
    dispatch
  })) : typeof mapDispatchToProps === 'function' ? // @ts-ignore
  wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : createInvalidArgFactory(mapDispatchToProps, 'mapDispatchToProps');
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/connect/mapStateToProps.js


function mapStateToPropsFactory(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(() => ({})) : typeof mapStateToProps === 'function' ? // @ts-ignore
  wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : createInvalidArgFactory(mapStateToProps, 'mapStateToProps');
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/connect/mergeProps.js



function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  // @ts-ignore
  return (0,esm_extends/* default */.Z)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, {
    displayName,
    areMergedPropsEqual
  }) {
    let hasRunOnce = false;
    let mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) {}
      }

      return mergedProps;
    };
  };
}
function mergePropsFactory(mergeProps) {
  return !mergeProps ? () => defaultMergeProps : typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : createInvalidArgFactory(mergeProps, 'mergeProps');
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  const batch = getBatch();
  let first = null;
  let last = null;
  return {
    clear() {
      first = null;
      last = null;
    },

    notify() {
      batch(() => {
        let listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },

    get() {
      let listeners = [];
      let listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },

    subscribe(callback) {
      let isSubscribed = true;
      let listener = last = {
        callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }

  };
}

const nullListeners = {
  notify() {},

  get: () => []
};
function createSubscription(store, parentSub) {
  let unsubscribe;
  let listeners = nullListeners; // Reasons to keep the subscription active

  let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)

  let selfSubscribed = false;

  function addNestedSub(listener) {
    trySubscribe();
    const cleanupListener = listeners.subscribe(listener); // cleanup nested sub

    let removed = false;
    return () => {
      if (!removed) {
        removed = true;
        cleanupListener();
        tryUnsubscribe();
      }
    };
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return selfSubscribed;
  }

  function trySubscribe() {
    subscriptionsAmount++;

    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    subscriptionsAmount--;

    if (unsubscribe && subscriptionsAmount === 0) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  function trySubscribeSelf() {
    if (!selfSubscribed) {
      selfSubscribed = true;
      trySubscribe();
    }
  }

  function tryUnsubscribeSelf() {
    if (selfSubscribed) {
      selfSubscribed = false;
      tryUnsubscribe();
    }
  }

  const subscription = {
    addNestedSub,
    notifyNestedSubs,
    handleChangeWrapper,
    isSubscribed,
    trySubscribe: trySubscribeSelf,
    tryUnsubscribe: tryUnsubscribeSelf,
    getListeners: () => listeners
  };
  return subscription;
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed
// Matches logic in React's `shared/ExecutionEnvironment` file

const canUseDOM = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const useIsomorphicLayoutEffect = canUseDOM ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/utils/shallowEqual.js
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  const keysA = Object.keys(objA);
  const keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (let i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/components/connect.js


const connect_excluded = ["reactReduxForwardedRef"];

/* eslint-disable valid-jsdoc, @typescript-eslint/no-unused-vars */













let useSyncExternalStore = notInitialized;
const initializeConnect = fn => {
  useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these

const EMPTY_ARRAY = (/* unused pure expression or super */ null && ([null, 0]));
const NO_SUBSCRIPTION_ARRAY = [null, null]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message

const stringifyComponent = Comp => {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect(() => effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage


function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, // actualChildProps: unknown,
childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.


function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, // forceComponentUpdateDispatch: React.Dispatch<any>,
additionalSubscribeListener) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return () => {}; // Capture values for checking if and when this component unmounts

  let didUnsubscribe = false;
  let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  const checkForUpdates = () => {
    if (didUnsubscribe || !isMounted.current) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    } // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it


    const latestStoreState = store.getState();
    let newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
      // Trigger the React `useSyncExternalStore` subscriber

      additionalSubscribeListener();
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  const unsubscribeWrapper = () => {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer


const initStateUpdates = () => EMPTY_ARRAY;

function strictEqual(a, b) {
  return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */


let hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */

function connect(mapStateToProps, mapDispatchToProps, mergeProps, {
  // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
  // @ts-ignore
  pure,
  areStatesEqual = strictEqual,
  areOwnPropsEqual = shallowEqual,
  areStatePropsEqual = shallowEqual,
  areMergedPropsEqual = shallowEqual,
  // use React's forwardRef to expose a ref of the wrapped component
  forwardRef = false,
  // the context consumer to use
  context = ReactReduxContext
} = {}) {
  if (false) {}

  const Context = context;
  const initMapStateToProps = mapStateToPropsFactory(mapStateToProps);
  const initMapDispatchToProps = mapDispatchToPropsFactory(mapDispatchToProps);
  const initMergeProps = mergePropsFactory(mergeProps);
  const shouldHandleStateChanges = Boolean(mapStateToProps);

  const wrapWithConnect = WrappedComponent => {
    if (false) {}

    const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    const displayName = `Connect(${wrappedComponentName})`;
    const selectorFactoryOptions = {
      shouldHandleStateChanges,
      displayName,
      wrappedComponentName,
      WrappedComponent,
      // @ts-ignore
      initMapStateToProps,
      // @ts-ignore
      initMapDispatchToProps,
      initMergeProps,
      areStatesEqual,
      areStatePropsEqual,
      areOwnPropsEqual,
      areMergedPropsEqual
    };

    function ConnectFunction(props) {
      const [propsContext, reactReduxForwardedRef, wrapperProps] = react.useMemo(() => {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        const {
          reactReduxForwardedRef
        } = props,
              wrapperProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, connect_excluded);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]);
      const ContextToUse = react.useMemo(() => {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && // @ts-ignore
        (0,react_is.isContextConsumer)( /*#__PURE__*/react.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      const contextValue = react.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {} // Based on the previous check, one of these must be true


      const store = didStoreComeFromProps ? props.store : contextValue.store;
      const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
      const childPropsSelector = react.useMemo(() => {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
      }, [store]);
      const [subscription, notifyNestedSubs] = react.useMemo(() => {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        const subscription = createSubscription(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]); // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.

      const overriddenContextValue = react.useMemo(() => {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return (0,esm_extends/* default */.Z)({}, contextValue, {
          subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // Set up refs to coordinate values between the subscription effect and the render logic

      const lastChildProps = react.useRef();
      const lastWrapperProps = react.useRef(wrapperProps);
      const childPropsFromStoreUpdate = react.useRef();
      const renderIsScheduled = react.useRef(false);
      const isProcessingDispatch = react.useRef(false);
      const isMounted = react.useRef(false);
      const latestSubscriptionCallbackError = react.useRef();
      useIsomorphicLayoutEffect(() => {
        isMounted.current = true;
        return () => {
          isMounted.current = false;
        };
      }, []);
      const actualChildPropsSelector = react.useMemo(() => {
        const selector = () => {
          // Tricky logic here:
          // - This render may have been triggered by a Redux store update that produced new child props
          // - However, we may have gotten new wrapper props after that
          // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
          // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
          // So, we'll use the child props from store update only if the wrapper props are the same as last time.
          if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
            return childPropsFromStoreUpdate.current;
          } // TODO We're reading the store directly in render() here. Bad idea?
          // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
          // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
          // to determine what the child props should be.


          return childPropsSelector(store.getState(), wrapperProps);
        };

        return selector;
      }, [store, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      const subscribeForReact = react.useMemo(() => {
        const subscribe = reactListener => {
          if (!subscription) {
            return () => {};
          }

          return subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
          childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
        };

        return subscribe;
      }, [subscription]);
      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs]);
      let actualChildProps;

      try {
        actualChildProps = useSyncExternalStore( // TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
        subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
        // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
        actualChildPropsSelector, getServerState ? () => childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
      } catch (err) {
        if (latestSubscriptionCallbackError.current) {
          ;
          err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
        }

        throw err;
      }

      useIsomorphicLayoutEffect(() => {
        latestSubscriptionCallbackError.current = undefined;
        childPropsFromStoreUpdate.current = undefined;
        lastChildProps.current = actualChildProps;
      }); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      const renderedWrappedComponent = react.useMemo(() => {
        return (
          /*#__PURE__*/
          // @ts-ignore
          react.createElement(WrappedComponent, (0,esm_extends/* default */.Z)({}, actualChildProps, {
            ref: reactReduxForwardedRef
          }))
        );
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      const renderedChild = react.useMemo(() => {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/react.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    }

    const _Connect = react.memo(ConnectFunction);

    // Add a hacky cast to get the right output type
    const Connect = _Connect;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      const _forwarded = react.forwardRef(function forwardConnectRef(props, ref) {
        // @ts-ignore
        return /*#__PURE__*/react.createElement(Connect, (0,esm_extends/* default */.Z)({}, props, {
          reactReduxForwardedRef: ref
        }));
      });

      const forwarded = _forwarded;
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoist_non_react_statics_cjs_default()(forwarded, WrappedComponent);
    }

    return hoist_non_react_statics_cjs_default()(Connect, WrappedComponent);
  };

  return wrapWithConnect;
}

/* harmony default export */ var components_connect = (connect);
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/components/Provider.js





function Provider({
  store,
  context,
  children,
  serverState,
  stabilityCheck = 'once',
  noopCheck = 'once'
}) {
  const contextValue = react.useMemo(() => {
    const subscription = createSubscription(store);
    return {
      store,
      subscription,
      getServerState: serverState ? () => serverState : undefined,
      stabilityCheck,
      noopCheck
    };
  }, [store, serverState, stabilityCheck, noopCheck]);
  const previousState = react.useMemo(() => store.getState(), [store]);
  useIsomorphicLayoutEffect(() => {
    const {
      subscription
    } = contextValue;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return () => {
      subscription.tryUnsubscribe();
      subscription.onStateChange = undefined;
    };
  }, [contextValue, previousState]);
  const Context = context || ReactReduxContext; // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype

  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

/* harmony default export */ var components_Provider = (Provider);
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/hooks/useStore.js


/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context = ReactReduxContext) {
  const useReduxContext = // @ts-ignore
  context === ReactReduxContext ? useReduxContext_useReduxContext : // @ts-ignore
  createReduxContextHook(context);
  return function useStore() {
    const {
      store
    } = useReduxContext(); // @ts-ignore

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

const useStore_useStore = /*#__PURE__*/createStoreHook();
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context = ReactReduxContext) {
  const useStore = // @ts-ignore
  context === ReactReduxContext ? useStore_useStore : createStoreHook(context);
  return function useDispatch() {
    const store = useStore(); // @ts-ignore

    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

const useDispatch = /*#__PURE__*/createDispatchHook();
;// CONCATENATED MODULE: ../../node_modules/react-redux/es/exports.js









;// CONCATENATED MODULE: ../../node_modules/react-redux/es/index.js
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.






initializeUseSelector(with_selector.useSyncExternalStoreWithSelector);
initializeConnect(shim.useSyncExternalStore); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

setBatch(react_dom.unstable_batchedUpdates);



/***/ }),

/***/ 98559:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=Symbol.for("react.element"),c=Symbol.for("react.portal"),d=Symbol.for("react.fragment"),e=Symbol.for("react.strict_mode"),f=Symbol.for("react.profiler"),g=Symbol.for("react.provider"),h=Symbol.for("react.context"),k=Symbol.for("react.server_context"),l=Symbol.for("react.forward_ref"),m=Symbol.for("react.suspense"),n=Symbol.for("react.suspense_list"),p=Symbol.for("react.memo"),q=Symbol.for("react.lazy"),t=Symbol.for("react.offscreen"),u;u=Symbol.for("react.module.reference");
function v(a){if("object"===typeof a&&null!==a){var r=a.$$typeof;switch(r){case b:switch(a=a.type,a){case d:case f:case e:case m:case n:return a;default:switch(a=a&&a.$$typeof,a){case k:case h:case l:case q:case p:case g:return a;default:return r}}case c:return r}}}__webpack_unused_export__=h;__webpack_unused_export__=g;__webpack_unused_export__=b;__webpack_unused_export__=l;__webpack_unused_export__=d;__webpack_unused_export__=q;__webpack_unused_export__=p;__webpack_unused_export__=c;__webpack_unused_export__=f;__webpack_unused_export__=e;__webpack_unused_export__=m;
__webpack_unused_export__=n;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};exports.isContextConsumer=function(a){return v(a)===h};__webpack_unused_export__=function(a){return v(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return v(a)===l};__webpack_unused_export__=function(a){return v(a)===d};__webpack_unused_export__=function(a){return v(a)===q};__webpack_unused_export__=function(a){return v(a)===p};
__webpack_unused_export__=function(a){return v(a)===c};__webpack_unused_export__=function(a){return v(a)===f};__webpack_unused_export__=function(a){return v(a)===e};__webpack_unused_export__=function(a){return v(a)===m};__webpack_unused_export__=function(a){return v(a)===n};
__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===e||a===m||a===n||a===t||"object"===typeof a&&null!==a&&(a.$$typeof===q||a.$$typeof===p||a.$$typeof===g||a.$$typeof===h||a.$$typeof===l||a.$$typeof===u||void 0!==a.getModuleId)?!0:!1};__webpack_unused_export__=v;


/***/ }),

/***/ 63920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(98559);
} else {}


/***/ }),

/***/ 58267:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var compose = (__webpack_require__(38726)/* .compose */ .qC);

__webpack_unused_export__ = true;
exports.Uo =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : function () {
        if (arguments.length === 0) return undefined;
        if (typeof arguments[0] === 'object') return compose;
        return compose.apply(null, arguments);
      };

__webpack_unused_export__ =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__
    : function () {
        return function (noop) {
          return noop;
        };
      };


/***/ }),

/***/ 84261:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.__esModule = true;
exports["default"] = exports.UPDATE_SYNC_WARNINGS = exports.UPDATE_SYNC_ERRORS = exports.UNTOUCH = exports.UNREGISTER_FIELD = exports.TOUCH = exports.SUBMIT = exports.STOP_SUBMIT = exports.STOP_ASYNC_VALIDATION = exports.START_SUBMIT = exports.START_ASYNC_VALIDATION = exports.SET_SUBMIT_SUCCEEDED = exports.SET_SUBMIT_FAILED = exports.RESET_SECTION = exports.RESET = exports.REGISTER_FIELD = exports.INITIALIZE = exports.FOCUS = exports.DESTROY = exports.CLEAR_ASYNC_ERROR = exports.CLEAR_SUBMIT_ERRORS = exports.CLEAR_SUBMIT = exports.CLEAR_FIELDS = exports.CHANGE = exports.BLUR = exports.AUTOFILL = exports.ARRAY_SWAP = exports.ARRAY_UNSHIFT = exports.ARRAY_SPLICE = exports.ARRAY_SHIFT = exports.ARRAY_REMOVE_ALL = exports.ARRAY_REMOVE = exports.ARRAY_PUSH = exports.ARRAY_POP = exports.ARRAY_MOVE = exports.ARRAY_INSERT = exports.prefix = void 0;
var prefix = '@@redux-form/';
exports.prefix = prefix;
var ARRAY_INSERT = prefix + "ARRAY_INSERT";
exports.ARRAY_INSERT = ARRAY_INSERT;
var ARRAY_MOVE = prefix + "ARRAY_MOVE";
exports.ARRAY_MOVE = ARRAY_MOVE;
var ARRAY_POP = prefix + "ARRAY_POP";
exports.ARRAY_POP = ARRAY_POP;
var ARRAY_PUSH = prefix + "ARRAY_PUSH";
exports.ARRAY_PUSH = ARRAY_PUSH;
var ARRAY_REMOVE = prefix + "ARRAY_REMOVE";
exports.ARRAY_REMOVE = ARRAY_REMOVE;
var ARRAY_REMOVE_ALL = prefix + "ARRAY_REMOVE_ALL";
exports.ARRAY_REMOVE_ALL = ARRAY_REMOVE_ALL;
var ARRAY_SHIFT = prefix + "ARRAY_SHIFT";
exports.ARRAY_SHIFT = ARRAY_SHIFT;
var ARRAY_SPLICE = prefix + "ARRAY_SPLICE";
exports.ARRAY_SPLICE = ARRAY_SPLICE;
var ARRAY_UNSHIFT = prefix + "ARRAY_UNSHIFT";
exports.ARRAY_UNSHIFT = ARRAY_UNSHIFT;
var ARRAY_SWAP = prefix + "ARRAY_SWAP";
exports.ARRAY_SWAP = ARRAY_SWAP;
var AUTOFILL = prefix + "AUTOFILL";
exports.AUTOFILL = AUTOFILL;
var BLUR = prefix + "BLUR";
exports.BLUR = BLUR;
var CHANGE = prefix + "CHANGE";
exports.CHANGE = CHANGE;
var CLEAR_FIELDS = prefix + "CLEAR_FIELDS";
exports.CLEAR_FIELDS = CLEAR_FIELDS;
var CLEAR_SUBMIT = prefix + "CLEAR_SUBMIT";
exports.CLEAR_SUBMIT = CLEAR_SUBMIT;
var CLEAR_SUBMIT_ERRORS = prefix + "CLEAR_SUBMIT_ERRORS";
exports.CLEAR_SUBMIT_ERRORS = CLEAR_SUBMIT_ERRORS;
var CLEAR_ASYNC_ERROR = prefix + "CLEAR_ASYNC_ERROR";
exports.CLEAR_ASYNC_ERROR = CLEAR_ASYNC_ERROR;
var DESTROY = prefix + "DESTROY";
exports.DESTROY = DESTROY;
var FOCUS = prefix + "FOCUS";
exports.FOCUS = FOCUS;
var INITIALIZE = prefix + "INITIALIZE";
exports.INITIALIZE = INITIALIZE;
var REGISTER_FIELD = prefix + "REGISTER_FIELD";
exports.REGISTER_FIELD = REGISTER_FIELD;
var RESET = prefix + "RESET";
exports.RESET = RESET;
var RESET_SECTION = prefix + "RESET_SECTION";
exports.RESET_SECTION = RESET_SECTION;
var SET_SUBMIT_FAILED = prefix + "SET_SUBMIT_FAILED";
exports.SET_SUBMIT_FAILED = SET_SUBMIT_FAILED;
var SET_SUBMIT_SUCCEEDED = prefix + "SET_SUBMIT_SUCCEEDED";
exports.SET_SUBMIT_SUCCEEDED = SET_SUBMIT_SUCCEEDED;
var START_ASYNC_VALIDATION = prefix + "START_ASYNC_VALIDATION";
exports.START_ASYNC_VALIDATION = START_ASYNC_VALIDATION;
var START_SUBMIT = prefix + "START_SUBMIT";
exports.START_SUBMIT = START_SUBMIT;
var STOP_ASYNC_VALIDATION = prefix + "STOP_ASYNC_VALIDATION";
exports.STOP_ASYNC_VALIDATION = STOP_ASYNC_VALIDATION;
var STOP_SUBMIT = prefix + "STOP_SUBMIT";
exports.STOP_SUBMIT = STOP_SUBMIT;
var SUBMIT = prefix + "SUBMIT";
exports.SUBMIT = SUBMIT;
var TOUCH = prefix + "TOUCH";
exports.TOUCH = TOUCH;
var UNREGISTER_FIELD = prefix + "UNREGISTER_FIELD";
exports.UNREGISTER_FIELD = UNREGISTER_FIELD;
var UNTOUCH = prefix + "UNTOUCH";
exports.UNTOUCH = UNTOUCH;
var UPDATE_SYNC_ERRORS = prefix + "UPDATE_SYNC_ERRORS";
exports.UPDATE_SYNC_ERRORS = UPDATE_SYNC_ERRORS;
var UPDATE_SYNC_WARNINGS = prefix + "UPDATE_SYNC_WARNINGS";
exports.UPDATE_SYNC_WARNINGS = UPDATE_SYNC_WARNINGS;
var _default = {
  ARRAY_INSERT: ARRAY_INSERT,
  ARRAY_MOVE: ARRAY_MOVE,
  ARRAY_POP: ARRAY_POP,
  ARRAY_PUSH: ARRAY_PUSH,
  ARRAY_REMOVE: ARRAY_REMOVE,
  ARRAY_REMOVE_ALL: ARRAY_REMOVE_ALL,
  ARRAY_SHIFT: ARRAY_SHIFT,
  ARRAY_SPLICE: ARRAY_SPLICE,
  ARRAY_UNSHIFT: ARRAY_UNSHIFT,
  ARRAY_SWAP: ARRAY_SWAP,
  AUTOFILL: AUTOFILL,
  BLUR: BLUR,
  CHANGE: CHANGE,
  CLEAR_FIELDS: CLEAR_FIELDS,
  CLEAR_SUBMIT: CLEAR_SUBMIT,
  CLEAR_SUBMIT_ERRORS: CLEAR_SUBMIT_ERRORS,
  CLEAR_ASYNC_ERROR: CLEAR_ASYNC_ERROR,
  DESTROY: DESTROY,
  FOCUS: FOCUS,
  INITIALIZE: INITIALIZE,
  REGISTER_FIELD: REGISTER_FIELD,
  RESET: RESET,
  RESET_SECTION: RESET_SECTION,
  SET_SUBMIT_FAILED: SET_SUBMIT_FAILED,
  SET_SUBMIT_SUCCEEDED: SET_SUBMIT_SUCCEEDED,
  START_ASYNC_VALIDATION: START_ASYNC_VALIDATION,
  START_SUBMIT: START_SUBMIT,
  STOP_ASYNC_VALIDATION: STOP_ASYNC_VALIDATION,
  STOP_SUBMIT: STOP_SUBMIT,
  SUBMIT: SUBMIT,
  TOUCH: TOUCH,
  UNREGISTER_FIELD: UNREGISTER_FIELD,
  UNTOUCH: UNTOUCH,
  UPDATE_SYNC_ERRORS: UPDATE_SYNC_ERRORS,
  UPDATE_SYNC_WARNINGS: UPDATE_SYNC_WARNINGS
};
exports["default"] = _default;

/***/ }),

/***/ 8810:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(71600);

exports.__esModule = true;
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(15538));

var _isFunction2 = _interopRequireDefault(__webpack_require__(18371));

var _actionTypes = __webpack_require__(84261);

var _deleteInWithCleanUp = _interopRequireDefault(__webpack_require__(10599));

var _plain = _interopRequireDefault(__webpack_require__(34690));

var shouldDelete = function shouldDelete(_ref) {
  var getIn = _ref.getIn;
  return function (state, path) {
    var initialValuesPath = null;

    if (/^values/.test(path)) {
      initialValuesPath = path.replace('values', 'initial');
    }

    var initialValueComparison = initialValuesPath ? getIn(state, initialValuesPath) === undefined : true;
    return getIn(state, path) !== undefined && initialValueComparison;
  };
};

var isReduxFormAction = function isReduxFormAction(action) {
  return action && action.type && action.type.length > _actionTypes.prefix.length && action.type.substring(0, _actionTypes.prefix.length) === _actionTypes.prefix;
};

function createReducer(structure) {
  var _behaviors;

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      forEach = structure.forEach,
      getIn = structure.getIn,
      setIn = structure.setIn,
      deleteIn = structure.deleteIn,
      fromJS = structure.fromJS,
      keys = structure.keys,
      size = structure.size,
      some = structure.some,
      splice = structure.splice;
  var deleteInWithCleanUp = (0, _deleteInWithCleanUp["default"])(structure)(shouldDelete);
  var plainDeleteInWithCleanUp = (0, _deleteInWithCleanUp["default"])(_plain["default"])(shouldDelete);

  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
    var existing = getIn(state, key + "." + field);
    return existing || force ? setIn(state, key + "." + field, splice(existing, index, removeNum, value)) : state;
  };

  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
    var slice = getIn(state, key);

    var existing = _plain["default"].getIn(slice, field);

    return existing || force ? setIn(state, key, _plain["default"].setIn(slice, field, _plain["default"].splice(existing, index, removeNum, value))) : state;
  };

  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];

  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
    var result = state;
    var nonValuesValue = value != null ? empty : undefined;
    result = doSplice(result, 'values', field, index, removeNum, value, true);
    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
    return result;
  };

  var behaviors = (_behaviors = {}, _behaviors[_actionTypes.ARRAY_INSERT] = function (state, _ref2) {
    var _ref2$meta = _ref2.meta,
        field = _ref2$meta.field,
        index = _ref2$meta.index,
        payload = _ref2.payload;
    return arraySplice(state, field, index, 0, payload);
  }, _behaviors[_actionTypes.ARRAY_MOVE] = function (state, _ref3) {
    var _ref3$meta = _ref3.meta,
        field = _ref3$meta.field,
        from = _ref3$meta.from,
        to = _ref3$meta.to;
    var array = getIn(state, "values." + field);
    var length = array ? size(array) : 0;
    var result = state;

    if (length) {
      rootKeys.forEach(function (key) {
        var path = key + "." + field;

        if (getIn(result, path)) {
          var value = getIn(result, path + "[" + from + "]");
          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove

          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
        }
      });
    }

    return result;
  }, _behaviors[_actionTypes.ARRAY_POP] = function (state, _ref4) {
    var field = _ref4.meta.field;
    var array = getIn(state, "values." + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, length - 1, 1) : state;
  }, _behaviors[_actionTypes.ARRAY_PUSH] = function (state, _ref5) {
    var field = _ref5.meta.field,
        payload = _ref5.payload;
    var array = getIn(state, "values." + field);
    var length = array ? size(array) : 0;
    return arraySplice(state, field, length, 0, payload);
  }, _behaviors[_actionTypes.ARRAY_REMOVE] = function (state, _ref6) {
    var _ref6$meta = _ref6.meta,
        field = _ref6$meta.field,
        index = _ref6$meta.index;
    return arraySplice(state, field, index, 1);
  }, _behaviors[_actionTypes.ARRAY_REMOVE_ALL] = function (state, _ref7) {
    var field = _ref7.meta.field;
    var array = getIn(state, "values." + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, 0, length) : state;
  }, _behaviors[_actionTypes.ARRAY_SHIFT] = function (state, _ref8) {
    var field = _ref8.meta.field;
    return arraySplice(state, field, 0, 1);
  }, _behaviors[_actionTypes.ARRAY_SPLICE] = function (state, _ref9) {
    var _ref9$meta = _ref9.meta,
        field = _ref9$meta.field,
        index = _ref9$meta.index,
        removeNum = _ref9$meta.removeNum,
        payload = _ref9.payload;
    return arraySplice(state, field, index, removeNum, payload);
  }, _behaviors[_actionTypes.ARRAY_SWAP] = function (state, _ref10) {
    var _ref10$meta = _ref10.meta,
        field = _ref10$meta.field,
        indexA = _ref10$meta.indexA,
        indexB = _ref10$meta.indexB;
    var result = state;
    rootKeys.forEach(function (key) {
      var valueA = getIn(result, key + "." + field + "[" + indexA + "]");
      var valueB = getIn(result, key + "." + field + "[" + indexB + "]");

      if (valueA !== undefined || valueB !== undefined) {
        result = setIn(result, key + "." + field + "[" + indexA + "]", valueB);
        result = setIn(result, key + "." + field + "[" + indexB + "]", valueA);
      }
    });
    return result;
  }, _behaviors[_actionTypes.ARRAY_UNSHIFT] = function (state, _ref11) {
    var field = _ref11.meta.field,
        payload = _ref11.payload;
    return arraySplice(state, field, 0, 0, payload);
  }, _behaviors[_actionTypes.AUTOFILL] = function (state, _ref12) {
    var field = _ref12.meta.field,
        payload = _ref12.payload;
    var result = state;
    result = deleteInWithCleanUp(result, "asyncErrors." + field);
    result = deleteInWithCleanUp(result, "submitErrors." + field);
    result = setIn(result, "fields." + field + ".autofilled", true);
    result = setIn(result, "values." + field, payload);
    return result;
  }, _behaviors[_actionTypes.BLUR] = function (state, _ref13) {
    var _ref13$meta = _ref13.meta,
        field = _ref13$meta.field,
        touch = _ref13$meta.touch,
        payload = _ref13.payload;
    var result = state;
    var initial = getIn(result, "initial." + field);

    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, "values." + field);
    } else if (payload !== undefined) {
      result = setIn(result, "values." + field, payload);
    }

    if (field === getIn(result, 'active')) {
      result = deleteIn(result, 'active');
    }

    result = deleteIn(result, "fields." + field + ".active");

    if (touch) {
      result = setIn(result, "fields." + field + ".touched", true);
      result = setIn(result, 'anyTouched', true);
    }

    return result;
  }, _behaviors[_actionTypes.CHANGE] = function (state, _ref14) {
    var _ref14$meta = _ref14.meta,
        field = _ref14$meta.field,
        touch = _ref14$meta.touch,
        persistentSubmitErrors = _ref14$meta.persistentSubmitErrors,
        payload = _ref14.payload;
    var result = state;
    var initial = getIn(result, "initial." + field);

    if (initial === undefined && payload === '' || payload === undefined) {
      result = deleteInWithCleanUp(result, "values." + field);
    } else if ((0, _isFunction2["default"])(payload)) {
      var fieldCurrentValue = getIn(state, "values." + field);
      result = setIn(result, "values." + field, payload(fieldCurrentValue, state.values));
    } else {
      result = setIn(result, "values." + field, payload);
    }

    result = deleteInWithCleanUp(result, "asyncErrors." + field);

    if (!persistentSubmitErrors) {
      result = deleteInWithCleanUp(result, "submitErrors." + field);
    }

    result = deleteInWithCleanUp(result, "fields." + field + ".autofilled");

    if (touch) {
      result = setIn(result, "fields." + field + ".touched", true);
      result = setIn(result, 'anyTouched', true);
    }

    return result;
  }, _behaviors[_actionTypes.CLEAR_SUBMIT] = function (state) {
    return deleteIn(state, 'triggerSubmit');
  }, _behaviors[_actionTypes.CLEAR_SUBMIT_ERRORS] = function (state) {
    var result = state;
    result = deleteInWithCleanUp(result, 'submitErrors');
    result = deleteIn(result, 'error');
    return result;
  }, _behaviors[_actionTypes.CLEAR_ASYNC_ERROR] = function (state, _ref15) {
    var field = _ref15.meta.field;
    return deleteIn(state, "asyncErrors." + field);
  }, _behaviors[_actionTypes.CLEAR_FIELDS] = function (state, _ref16) {
    var _ref16$meta = _ref16.meta,
        keepTouched = _ref16$meta.keepTouched,
        persistentSubmitErrors = _ref16$meta.persistentSubmitErrors,
        fields = _ref16$meta.fields;
    var result = state;
    fields.forEach(function (field) {
      result = deleteInWithCleanUp(result, "asyncErrors." + field);

      if (!persistentSubmitErrors) {
        result = deleteInWithCleanUp(result, "submitErrors." + field);
      }

      result = deleteInWithCleanUp(result, "fields." + field + ".autofilled");

      if (!keepTouched) {
        result = deleteIn(result, "fields." + field + ".touched");
      }

      var values = getIn(state, "initial." + field);
      result = values ? setIn(result, "values." + field, values) : deleteInWithCleanUp(result, "values." + field);
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, "fields." + key + ".touched");
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }, _behaviors[_actionTypes.FOCUS] = function (state, _ref17) {
    var field = _ref17.meta.field;
    var result = state;
    var previouslyActive = getIn(state, 'active');
    result = deleteIn(result, "fields." + previouslyActive + ".active");
    result = setIn(result, "fields." + field + ".visited", true);
    result = setIn(result, "fields." + field + ".active", true);
    result = setIn(result, 'active', field);
    return result;
  }, _behaviors[_actionTypes.INITIALIZE] = function (state, _ref18) {
    var payload = _ref18.payload,
        _ref18$meta = _ref18.meta,
        keepDirty = _ref18$meta.keepDirty,
        keepSubmitSucceeded = _ref18$meta.keepSubmitSucceeded,
        updateUnregisteredFields = _ref18$meta.updateUnregisteredFields,
        keepValues = _ref18$meta.keepValues;
    var mapData = fromJS(payload);
    var result = empty; // clean all field state
    // persist old warnings, they will get recalculated if the new form values are different from the old values

    var warning = getIn(state, 'warning');

    if (warning) {
      result = setIn(result, 'warning', warning);
    }

    var syncWarnings = getIn(state, 'syncWarnings');

    if (syncWarnings) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    } // persist old errors, they will get recalculated if the new form values are different from the old values


    var error = getIn(state, 'error');

    if (error) {
      result = setIn(result, 'error', error);
    }

    var syncErrors = getIn(state, 'syncErrors');

    if (syncErrors) {
      result = setIn(result, 'syncErrors', syncErrors);
    }

    var registeredFields = getIn(state, 'registeredFields');

    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }

    var previousValues = getIn(state, 'values');
    var previousInitialValues = getIn(state, 'initial');
    var newInitialValues = mapData;
    var newValues = previousValues;

    if (keepDirty && registeredFields) {
      if (!deepEqual(newInitialValues, previousInitialValues)) {
        //
        // Keep the value of dirty fields while updating the value of
        // pristine fields. This way, apps can reinitialize forms while
        // avoiding stomping on user edits.
        //
        // Note 1: The initialize action replaces all initial values
        // regardless of keepDirty.
        //
        // Note 2: When a field is dirty, keepDirty is enabled, and the field
        // value is the same as the new initial value for the field, the
        // initialize action causes the field to become pristine. That effect
        // is what we want.
        //
        var overwritePristineValue = function overwritePristineValue(name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          var previousValue = getIn(previousValues, name);

          if (deepEqual(previousValue, previousInitialValue)) {
            // Overwrite the old pristine value with the new pristine value
            var newInitialValue = getIn(newInitialValues, name); // This check prevents any 'setIn' call that would create useless
            // nested objects, since the path to the new field value would
            // evaluate to the same (especially for undefined values)

            if (getIn(newValues, name) !== newInitialValue) {
              newValues = setIn(newValues, name, newInitialValue);
            }
          }
        };

        if (!updateUnregisteredFields) {
          forEach(keys(registeredFields), function (name) {
            return overwritePristineValue(name);
          });
        }

        forEach(keys(newInitialValues), function (name) {
          var previousInitialValue = getIn(previousInitialValues, name);

          if (typeof previousInitialValue === 'undefined') {
            // Add new values at the root level.
            var newInitialValue = getIn(newInitialValues, name);
            newValues = setIn(newValues, name, newInitialValue);
          }

          if (updateUnregisteredFields) {
            overwritePristineValue(name);
          }
        });
      }
    } else {
      newValues = newInitialValues;
    }

    if (keepValues) {
      forEach(keys(previousValues), function (name) {
        var previousValue = getIn(previousValues, name);
        newValues = setIn(newValues, name, previousValue);
      });
      forEach(keys(previousInitialValues), function (name) {
        var previousInitialValue = getIn(previousInitialValues, name);
        newInitialValues = setIn(newInitialValues, name, previousInitialValue);
      });
    }

    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
      result = setIn(result, 'submitSucceeded', true);
    }

    result = setIn(result, 'values', newValues);
    result = setIn(result, 'initial', newInitialValues);
    return result;
  }, _behaviors[_actionTypes.REGISTER_FIELD] = function (state, _ref19) {
    var _ref19$payload = _ref19.payload,
        name = _ref19$payload.name,
        type = _ref19$payload.type;
    var key = "registeredFields['" + name + "']";
    var field = getIn(state, key);

    if (field) {
      var count = getIn(field, 'count') + 1;
      field = setIn(field, 'count', count);
    } else {
      field = fromJS({
        name: name,
        type: type,
        count: 1
      });
    }

    return setIn(state, key, field);
  }, _behaviors[_actionTypes.RESET] = function (state) {
    var result = empty;
    var registeredFields = getIn(state, 'registeredFields');

    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }

    var values = getIn(state, 'initial');

    if (values) {
      result = setIn(result, 'values', values);
      result = setIn(result, 'initial', values);
    }

    return result;
  }, _behaviors[_actionTypes.RESET_SECTION] = function (state, _ref20) {
    var sections = _ref20.meta.sections;
    var result = state;
    sections.forEach(function (section) {
      result = deleteInWithCleanUp(result, "asyncErrors." + section);
      result = deleteInWithCleanUp(result, "submitErrors." + section);
      result = deleteInWithCleanUp(result, "fields." + section);
      var values = getIn(state, "initial." + section);
      result = values ? setIn(result, "values." + section, values) : deleteInWithCleanUp(result, "values." + section);
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, "fields." + key + ".touched");
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }, _behaviors[_actionTypes.SUBMIT] = function (state) {
    return setIn(state, 'triggerSubmit', true);
  }, _behaviors[_actionTypes.START_ASYNC_VALIDATION] = function (state, _ref21) {
    var field = _ref21.meta.field;
    return setIn(state, 'asyncValidating', field || true);
  }, _behaviors[_actionTypes.START_SUBMIT] = function (state) {
    return setIn(state, 'submitting', true);
  }, _behaviors[_actionTypes.STOP_ASYNC_VALIDATION] = function (state, _ref22) {
    var payload = _ref22.payload;
    var result = state;
    result = deleteIn(result, 'asyncValidating');

    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = (0, _objectWithoutPropertiesLoose2["default"])(payload, ["_error"]);

      if (_error) {
        result = setIn(result, 'error', _error);
      }

      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
      }
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'asyncErrors');
    }

    return result;
  }, _behaviors[_actionTypes.STOP_SUBMIT] = function (state, _ref23) {
    var payload = _ref23.payload;
    var result = state;
    result = deleteIn(result, 'submitting');
    result = deleteIn(result, 'submitFailed');
    result = deleteIn(result, 'submitSucceeded');

    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = (0, _objectWithoutPropertiesLoose2["default"])(payload, ["_error"]);

      if (_error) {
        result = setIn(result, 'error', _error);
      } else {
        result = deleteIn(result, 'error');
      }

      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
      } else {
        result = deleteIn(result, 'submitErrors');
      }

      result = setIn(result, 'submitFailed', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'submitErrors');
    }

    return result;
  }, _behaviors[_actionTypes.SET_SUBMIT_FAILED] = function (state, _ref24) {
    var fields = _ref24.meta.fields;
    var result = state;
    result = setIn(result, 'submitFailed', true);
    result = deleteIn(result, 'submitSucceeded');
    result = deleteIn(result, 'submitting');
    fields.forEach(function (field) {
      return result = setIn(result, "fields." + field + ".touched", true);
    });

    if (fields.length) {
      result = setIn(result, 'anyTouched', true);
    }

    return result;
  }, _behaviors[_actionTypes.SET_SUBMIT_SUCCEEDED] = function (state) {
    var result = state;
    result = deleteIn(result, 'submitFailed');
    result = setIn(result, 'submitSucceeded', true);
    return result;
  }, _behaviors[_actionTypes.TOUCH] = function (state, _ref25) {
    var fields = _ref25.meta.fields;
    var result = state;
    fields.forEach(function (field) {
      return result = setIn(result, "fields." + field + ".touched", true);
    });
    result = setIn(result, 'anyTouched', true);
    return result;
  }, _behaviors[_actionTypes.UNREGISTER_FIELD] = function (state, _ref26) {
    var _ref26$payload = _ref26.payload,
        name = _ref26$payload.name,
        destroyOnUnmount = _ref26$payload.destroyOnUnmount;
    var result = state;
    var key = "registeredFields['" + name + "']";
    var field = getIn(result, key);

    if (!field) {
      return result;
    }

    var count = getIn(field, 'count') - 1;

    if (count <= 0 && destroyOnUnmount) {
      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
      result = deleteIn(result, key);

      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
        result = deleteIn(result, 'registeredFields');
      }

      var syncErrors = getIn(result, 'syncErrors');

      if (syncErrors) {
        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);

        if (_plain["default"].deepEqual(syncErrors, _plain["default"].empty)) {
          result = deleteIn(result, 'syncErrors');
        } else {
          result = setIn(result, 'syncErrors', syncErrors);
        }
      }

      var syncWarnings = getIn(result, 'syncWarnings');

      if (syncWarnings) {
        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);

        if (_plain["default"].deepEqual(syncWarnings, _plain["default"].empty)) {
          result = deleteIn(result, 'syncWarnings');
        } else {
          result = setIn(result, 'syncWarnings', syncWarnings);
        }
      }

      result = deleteInWithCleanUp(result, "submitErrors." + name);
      result = deleteInWithCleanUp(result, "asyncErrors." + name);
    } else {
      field = setIn(field, 'count', count);
      result = setIn(result, key, field);
    }

    return result;
  }, _behaviors[_actionTypes.UNTOUCH] = function (state, _ref27) {
    var fields = _ref27.meta.fields;
    var result = state;
    fields.forEach(function (field) {
      return result = deleteIn(result, "fields." + field + ".touched");
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, "fields." + key + ".touched");
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }, _behaviors[_actionTypes.UPDATE_SYNC_ERRORS] = function (state, _ref28) {
    var _ref28$payload = _ref28.payload,
        syncErrors = _ref28$payload.syncErrors,
        error = _ref28$payload.error;
    var result = state;

    if (error) {
      result = setIn(result, 'error', error);
      result = setIn(result, 'syncError', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'syncError');
    }

    if (Object.keys(syncErrors).length) {
      result = setIn(result, 'syncErrors', syncErrors);
    } else {
      result = deleteIn(result, 'syncErrors');
    }

    return result;
  }, _behaviors[_actionTypes.UPDATE_SYNC_WARNINGS] = function (state, _ref29) {
    var _ref29$payload = _ref29.payload,
        syncWarnings = _ref29$payload.syncWarnings,
        warning = _ref29$payload.warning;
    var result = state;

    if (warning) {
      result = setIn(result, 'warning', warning);
    } else {
      result = deleteIn(result, 'warning');
    }

    if (Object.keys(syncWarnings).length) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    } else {
      result = deleteIn(result, 'syncWarnings');
    }

    return result;
  }, _behaviors);

  var reducer = function reducer(state, action) {
    if (state === void 0) {
      state = empty;
    }

    var behavior = behaviors[action.type];
    return behavior ? behavior(state, action) : state;
  };

  var byForm = function byForm(reducer) {
    return function (state, action) {
      if (state === void 0) {
        state = empty;
      }

      if (action === void 0) {
        action = {
          type: 'NONE'
        };
      }

      var form = action && action.meta && action.meta.form;

      if (!form || !isReduxFormAction(action)) {
        return state;
      }

      if (action.type === _actionTypes.DESTROY && action.meta && action.meta.form) {
        return action.meta.form.reduce(function (result, form) {
          return deleteInWithCleanUp(result, form);
        }, state);
      }

      var formState = getIn(state, form);
      var result = reducer(formState, action);
      return result === formState ? state : setIn(state, form, result);
    };
  };
  /**
   * Adds additional functionality to the reducer
   */


  function decorate(target) {
    target.plugin = function (reducers, config) {
      var _this = this;

      if (config === void 0) {
        config = {};
      }

      // use 'function' keyword to enable 'this'
      return decorate(function (state, action) {
        if (state === void 0) {
          state = empty;
        }

        if (action === void 0) {
          action = {
            type: 'NONE'
          };
        }

        var callPlugin = function callPlugin(processed, key) {
          var previousState = getIn(processed, key);
          var nextState = reducers[key](previousState, action, getIn(state, key));
          return nextState !== previousState ? setIn(processed, key, nextState) : processed;
        };

        var processed = _this(state, action); // run through redux-form reducer


        var form = action && action.meta && action.meta.form;

        if (form && !config.receiveAllFormActions) {
          // this is an action aimed at forms, so only give it to the specified form's plugin
          return reducers[form] ? callPlugin(processed, form) : processed;
        } else {
          // this is not a form-specific action, so send it to all the plugins
          return Object.keys(reducers).reduce(callPlugin, processed);
        }
      });
    };

    return target;
  }

  return decorate(byForm(reducer));
}

var _default = createReducer;
exports["default"] = _default;

/***/ }),

/***/ 10599:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(71600);

exports.__esModule = true;
exports["default"] = void 0;

var _toPath2 = _interopRequireDefault(__webpack_require__(94701));

function createDeleteInWithCleanUp(structure) {
  var shouldDeleteDefault = function shouldDeleteDefault(structure) {
    return function (state, path) {
      return structure.getIn(state, path) !== undefined;
    };
  };

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      deleteIn = structure.deleteIn,
      setIn = structure.setIn;
  return function (shouldDelete) {
    if (shouldDelete === void 0) {
      shouldDelete = shouldDeleteDefault;
    }

    var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
      if (path[path.length - 1] === ']') {
        // array path
        var pathTokens = (0, _toPath2["default"])(path);
        pathTokens.pop();
        var parent = getIn(state, pathTokens.join('.'));
        return parent ? setIn(state, path) : state;
      }

      var result = state;

      if (shouldDelete(structure)(state, path)) {
        result = deleteIn(state, path);
      }

      var dotIndex = path.lastIndexOf('.');

      if (dotIndex > 0) {
        var parentPath = path.substring(0, dotIndex);

        if (parentPath[parentPath.length - 1] !== ']') {
          var _parent = getIn(result, parentPath);

          if (deepEqual(_parent, empty)) {
            return deleteInWithCleanUp(result, parentPath);
          }
        }
      }

      return result;
    };

    return deleteInWithCleanUp;
  };
}

var _default = createDeleteInWithCleanUp;
exports["default"] = _default;

/***/ }),

/***/ 9891:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(71600);

__webpack_unused_export__ = true;
exports.Z = void 0;

var _createReducer = _interopRequireDefault(__webpack_require__(8810));

var _plain = _interopRequireDefault(__webpack_require__(34690));

var _default = (0, _createReducer["default"])(_plain["default"]);

exports.Z = _default;

/***/ }),

/***/ 42560:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(71600);

exports.__esModule = true;
exports["default"] = void 0;

var _isNil2 = _interopRequireDefault(__webpack_require__(87206));

var _isEqualWith2 = _interopRequireDefault(__webpack_require__(2144));

var _react = _interopRequireDefault(__webpack_require__(2784));

var isEmpty = function isEmpty(obj) {
  return (0, _isNil2["default"])(obj) || obj === '' || isNaN(obj);
};

var customizer = function customizer(obj, other) {
  if (obj === other) return true;

  if (!obj && !other) {
    return isEmpty(obj) === isEmpty(other);
  }

  if (obj && other && obj._error !== other._error) return false;
  if (obj && other && obj._warning !== other._warning) return false;
  if (_react["default"].isValidElement(obj) || _react["default"].isValidElement(other)) return false;
};

var deepEqual = function deepEqual(a, b) {
  return (0, _isEqualWith2["default"])(a, b, customizer);
};

var _default = deepEqual;
exports["default"] = _default;

/***/ }),

/***/ 25024:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(71600);

exports.__esModule = true;
exports["default"] = void 0;

var _extends3 = _interopRequireDefault(__webpack_require__(77028));

var _toPath2 = _interopRequireDefault(__webpack_require__(94701));

function deleteInWithPath(state, first) {
  if (state === undefined || state === null || first === undefined || first === null) {
    return state;
  }

  for (var _len = arguments.length, rest = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  if (rest.length) {
    if (Array.isArray(state)) {
      if (isNaN(first)) {
        throw new Error("Must access array elements with a number, not \"" + String(first) + "\".");
      }

      var firstIndex = Number(first);

      if (firstIndex < state.length) {
        var result = deleteInWithPath.apply(void 0, [state && state[firstIndex]].concat(rest));

        if (result !== state[firstIndex]) {
          var copy = [].concat(state);
          copy[firstIndex] = result;
          return copy;
        }
      }

      return state;
    }

    if (first in state) {
      var _extends2;

      var _result = deleteInWithPath.apply(void 0, [state && state[first]].concat(rest));

      return state[first] === _result ? state : (0, _extends3["default"])({}, state, (_extends2 = {}, _extends2[first] = _result, _extends2));
    }

    return state;
  }

  if (Array.isArray(state)) {
    if (isNaN(first)) {
      throw new Error("Cannot delete non-numerical index from an array. Given: \"" + String(first));
    }

    var _firstIndex = Number(first);

    if (_firstIndex < state.length) {
      var _copy = [].concat(state);

      _copy.splice(_firstIndex, 1);

      return _copy;
    }

    return state;
  }

  if (first in state) {
    var _copy2 = (0, _extends3["default"])({}, state);

    delete _copy2[first];
    return _copy2;
  }

  return state;
}

var deleteIn = function deleteIn(state, field) {
  return deleteInWithPath.apply(void 0, [state].concat((0, _toPath2["default"])(field)));
};

var _default = deleteIn;
exports["default"] = _default;

/***/ }),

/***/ 32299:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(71600);

exports.__esModule = true;
exports["default"] = void 0;

var _toPath2 = _interopRequireDefault(__webpack_require__(94701));

var getIn = function getIn(state, field) {
  if (!state) {
    return state;
  }

  var path = (0, _toPath2["default"])(field);
  var length = path.length;

  if (!length) {
    return undefined;
  }

  var result = state;

  for (var i = 0; i < length && result; ++i) {
    result = result[path[i]];
  }

  return result;
};

var _default = getIn;
exports["default"] = _default;

/***/ }),

/***/ 34690:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(71600);

exports.__esModule = true;
exports["default"] = void 0;

var _splice = _interopRequireDefault(__webpack_require__(56098));

var _getIn = _interopRequireDefault(__webpack_require__(32299));

var _setIn = _interopRequireDefault(__webpack_require__(45682));

var _deepEqual = _interopRequireDefault(__webpack_require__(42560));

var _deleteIn = _interopRequireDefault(__webpack_require__(25024));

var _keys = _interopRequireDefault(__webpack_require__(53167));

var structure = {
  allowsArrayErrors: true,
  empty: {},
  emptyList: [],
  getIn: _getIn["default"],
  setIn: _setIn["default"],
  deepEqual: _deepEqual["default"],
  deleteIn: _deleteIn["default"],
  forEach: function forEach(items, callback) {
    return items.forEach(callback);
  },
  fromJS: function fromJS(value) {
    return value;
  },
  keys: _keys["default"],
  size: function size(array) {
    return array ? array.length : 0;
  },
  some: function some(items, callback) {
    return items.some(callback);
  },
  splice: _splice["default"],
  equals: function equals(a, b) {
    return b.every(function (val) {
      return ~a.indexOf(val);
    });
  },
  orderChanged: function orderChanged(a, b) {
    return b.some(function (val, index) {
      return val !== a[index];
    });
  },
  toJS: function toJS(value) {
    return value;
  }
};
var _default = structure;
exports["default"] = _default;

/***/ }),

/***/ 53167:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.__esModule = true;
exports["default"] = void 0;

function keys(value) {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.map(function (i) {
      return i.name;
    });
  }

  return Object.keys(value);
}

var _default = keys;
exports["default"] = _default;

/***/ }),

/***/ 45682:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(71600);

exports.__esModule = true;
exports["default"] = void 0;

var _extends3 = _interopRequireDefault(__webpack_require__(77028));

var _toPath2 = _interopRequireDefault(__webpack_require__(94701));

var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
  var _extends2;

  if (pathIndex >= path.length) {
    return value;
  }

  var first = path[pathIndex];
  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
  var next = setInWithPath(firstState, value, path, pathIndex + 1);

  if (!state) {
    if (isNaN(first)) {
      var _ref;

      return _ref = {}, _ref[first] = next, _ref;
    }

    var initialized = [];
    initialized[parseInt(first, 10)] = next;
    return initialized;
  }

  if (Array.isArray(state)) {
    var copy = [].concat(state);
    copy[parseInt(first, 10)] = next;
    return copy;
  }

  return (0, _extends3["default"])({}, state, (_extends2 = {}, _extends2[first] = next, _extends2));
};

var setIn = function setIn(state, field, value) {
  return setInWithPath(state, value, (0, _toPath2["default"])(field), 0);
};

var _default = setIn;
exports["default"] = _default;

/***/ }),

/***/ 56098:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.__esModule = true;
exports["default"] = void 0;

var splice = function splice(array, index, removeNum, value) {
  array = array || [];

  if (index < array.length) {
    if (value === undefined && !removeNum) {
      // inserting undefined
      var _copy2 = [].concat(array);

      _copy2.splice(index, 0, true); // temporary placeholder


      _copy2[index] = undefined; // set to undefined

      return _copy2;
    }

    if (value != null) {
      var _copy3 = [].concat(array);

      _copy3.splice(index, removeNum, value); // removing and adding


      return _copy3;
    }

    var _copy = [].concat(array);

    _copy.splice(index, removeNum); // removing


    return _copy;
  }

  if (removeNum) {
    // trying to remove non-existant item: return original array
    return array;
  } // trying to add outside of range: just set value


  var copy = [].concat(array);
  copy[index] = value;
  return copy;
};

var _default = splice;
exports["default"] = _default;

/***/ }),

/***/ 27065:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(4233),
    root = __webpack_require__(39481);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),

/***/ 71419:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var hashClear = __webpack_require__(94519),
    hashDelete = __webpack_require__(94826),
    hashGet = __webpack_require__(80048),
    hashHas = __webpack_require__(58944),
    hashSet = __webpack_require__(19968);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),

/***/ 92868:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var listCacheClear = __webpack_require__(35821),
    listCacheDelete = __webpack_require__(32348),
    listCacheGet = __webpack_require__(23860),
    listCacheHas = __webpack_require__(83715),
    listCacheSet = __webpack_require__(71245);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),

/***/ 54972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(4233),
    root = __webpack_require__(39481);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),

/***/ 92113:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(46463),
    mapCacheDelete = __webpack_require__(9655),
    mapCacheGet = __webpack_require__(35088),
    mapCacheHas = __webpack_require__(60645),
    mapCacheSet = __webpack_require__(35154);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),

/***/ 52299:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(4233),
    root = __webpack_require__(39481);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),

/***/ 22331:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(4233),
    root = __webpack_require__(39481);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),

/***/ 92811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(92113),
    setCacheAdd = __webpack_require__(66728),
    setCacheHas = __webpack_require__(43591);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),

/***/ 96970:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(92868),
    stackClear = __webpack_require__(78771),
    stackDelete = __webpack_require__(45055),
    stackGet = __webpack_require__(62352),
    stackHas = __webpack_require__(9575),
    stackSet = __webpack_require__(14674);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),

/***/ 78216:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(39481);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 59046:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(39481);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),

/***/ 98190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(4233),
    root = __webpack_require__(39481);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),

/***/ 27433:
/***/ (function(module) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),

/***/ 1816:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(5945),
    isArguments = __webpack_require__(28339),
    isArray = __webpack_require__(77582),
    isBuffer = __webpack_require__(58252),
    isIndex = __webpack_require__(49332),
    isTypedArray = __webpack_require__(63392);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 80182:
/***/ (function(module) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),

/***/ 49967:
/***/ (function(module) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),

/***/ 3358:
/***/ (function(module) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),

/***/ 85877:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var eq = __webpack_require__(98318);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),

/***/ 45924:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayPush = __webpack_require__(49967),
    isArray = __webpack_require__(77582);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),

/***/ 70973:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(78216),
    getRawTag = __webpack_require__(14584),
    objectToString = __webpack_require__(47032);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 10523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(70973),
    isObjectLike = __webpack_require__(51520);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 18120:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(77863),
    isObjectLike = __webpack_require__(51520);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),

/***/ 77863:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Stack = __webpack_require__(96970),
    equalArrays = __webpack_require__(11079),
    equalByTag = __webpack_require__(86425),
    equalObjects = __webpack_require__(5309),
    getTag = __webpack_require__(1146),
    isArray = __webpack_require__(77582),
    isBuffer = __webpack_require__(58252),
    isTypedArray = __webpack_require__(63392);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),

/***/ 36997:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(18371),
    isMasked = __webpack_require__(26364),
    isObject = __webpack_require__(37046),
    toSource = __webpack_require__(38507);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),

/***/ 87485:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(70973),
    isLength = __webpack_require__(72595),
    isObjectLike = __webpack_require__(51520);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 84370:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(36089),
    nativeKeys = __webpack_require__(57922);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 5945:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 76787:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(78216),
    arrayMap = __webpack_require__(80182),
    isArray = __webpack_require__(77582),
    isSymbol = __webpack_require__(45348);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),

/***/ 63054:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 21313:
/***/ (function(module) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),

/***/ 86269:
/***/ (function(module) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),

/***/ 93533:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(39481);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),

/***/ 11079:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var SetCache = __webpack_require__(92811),
    arraySome = __webpack_require__(3358),
    cacheHas = __webpack_require__(21313);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),

/***/ 86425:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(78216),
    Uint8Array = __webpack_require__(59046),
    eq = __webpack_require__(98318),
    equalArrays = __webpack_require__(11079),
    mapToArray = __webpack_require__(38256),
    setToArray = __webpack_require__(55139);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),

/***/ 5309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getAllKeys = __webpack_require__(88383);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),

/***/ 37372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 88383:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(45924),
    getSymbols = __webpack_require__(37719),
    keys = __webpack_require__(8161);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),

/***/ 17269:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isKeyable = __webpack_require__(90588);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),

/***/ 4233:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsNative = __webpack_require__(36997),
    getValue = __webpack_require__(92654);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),

/***/ 14584:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(78216);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 37719:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayFilter = __webpack_require__(27433),
    stubArray = __webpack_require__(76520);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),

/***/ 1146:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var DataView = __webpack_require__(27065),
    Map = __webpack_require__(54972),
    Promise = __webpack_require__(52299),
    Set = __webpack_require__(22331),
    WeakMap = __webpack_require__(98190),
    baseGetTag = __webpack_require__(70973),
    toSource = __webpack_require__(38507);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),

/***/ 92654:
/***/ (function(module) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),

/***/ 94519:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(58718);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),

/***/ 94826:
/***/ (function(module) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),

/***/ 80048:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(58718);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),

/***/ 58944:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(58718);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),

/***/ 19968:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var nativeCreate = __webpack_require__(58718);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),

/***/ 49332:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 90588:
/***/ (function(module) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),

/***/ 26364:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var coreJsData = __webpack_require__(93533);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),

/***/ 36089:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 35821:
/***/ (function(module) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),

/***/ 32348:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(85877);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),

/***/ 23860:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(85877);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),

/***/ 83715:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(85877);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),

/***/ 71245:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(85877);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),

/***/ 46463:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Hash = __webpack_require__(71419),
    ListCache = __webpack_require__(92868),
    Map = __webpack_require__(54972);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),

/***/ 9655:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(17269);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),

/***/ 35088:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(17269);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),

/***/ 60645:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(17269);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),

/***/ 35154:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getMapData = __webpack_require__(17269);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),

/***/ 38256:
/***/ (function(module) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),

/***/ 85245:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoize = __webpack_require__(12854);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),

/***/ 58718:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var getNative = __webpack_require__(4233);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),

/***/ 57922:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(30890);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 26194:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(37372);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 47032:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 30890:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 39481:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(37372);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 66728:
/***/ (function(module) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),

/***/ 43591:
/***/ (function(module) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),

/***/ 55139:
/***/ (function(module) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),

/***/ 78771:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(92868);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),

/***/ 45055:
/***/ (function(module) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),

/***/ 62352:
/***/ (function(module) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),

/***/ 9575:
/***/ (function(module) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),

/***/ 14674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ListCache = __webpack_require__(92868),
    Map = __webpack_require__(54972),
    MapCache = __webpack_require__(92113);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),

/***/ 53983:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(85245);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),

/***/ 80088:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isSymbol = __webpack_require__(45348);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),

/***/ 38507:
/***/ (function(module) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),

/***/ 98318:
/***/ (function(module) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),

/***/ 28339:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(10523),
    isObjectLike = __webpack_require__(51520);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 77582:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 43926:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(18371),
    isLength = __webpack_require__(72595);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 58252:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(39481),
    stubFalse = __webpack_require__(22241);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 2144:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(18120);

/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
}

module.exports = isEqualWith;


/***/ }),

/***/ 18371:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(70973),
    isObject = __webpack_require__(37046);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 72595:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 87206:
/***/ (function(module) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),

/***/ 37046:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 51520:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 45348:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(70973),
    isObjectLike = __webpack_require__(51520);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),

/***/ 63392:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(87485),
    baseUnary = __webpack_require__(63054),
    nodeUtil = __webpack_require__(26194);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 8161:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(1816),
    baseKeys = __webpack_require__(84370),
    isArrayLike = __webpack_require__(43926);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 12854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var MapCache = __webpack_require__(92113);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),

/***/ 76520:
/***/ (function(module) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),

/***/ 22241:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 94701:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayMap = __webpack_require__(80182),
    copyArray = __webpack_require__(86269),
    isArray = __webpack_require__(77582),
    isSymbol = __webpack_require__(45348),
    stringToPath = __webpack_require__(53983),
    toKey = __webpack_require__(80088),
    toString = __webpack_require__(51050);

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
}

module.exports = toPath;


/***/ }),

/***/ 51050:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseToString = __webpack_require__(76787);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),

/***/ 91199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "uR": function() { return /* reexport */ END; },
  "ZP": function() { return /* binding */ redux_saga_core_npm_proxy_esm; }
});

// UNUSED EXPORTS: CANCEL, SAGA_LOCATION, buffers, channel, detach, eventChannel, isEnd, multicastChannel, runSaga, stdChannel

// EXTERNAL MODULE: ../../node_modules/@redux-saga/symbols/dist/redux-saga-symbols.esm.js
var redux_saga_symbols_esm = __webpack_require__(23143);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(31461);
// EXTERNAL MODULE: ../../node_modules/@redux-saga/is/dist/redux-saga-is.esm.js
var redux_saga_is_esm = __webpack_require__(83594);
// EXTERNAL MODULE: ../../node_modules/@redux-saga/core/dist/io-22ea0cf9.js + 1 modules
var io_22ea0cf9 = __webpack_require__(8459);
;// CONCATENATED MODULE: ../../node_modules/@redux-saga/deferred/dist/redux-saga-deferred.esm.js
function deferred() {
  var def = {};
  def.promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  return def;
}
function arrayOfDeferred(length) {
  var arr = [];

  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }

  return arr;
}

/* harmony default export */ var redux_saga_deferred_esm = (deferred);


;// CONCATENATED MODULE: ../../node_modules/@redux-saga/core/dist/redux-saga-core.esm.js










var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/

var semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/

function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}
/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/


function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    flush();
  }
}
/**
 * Puts the scheduler in a `suspended` state and executes a task immediately.
 */

function immediately(task) {
  try {
    suspend();
    return task();
  } finally {
    flush();
  }
}
/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/

function suspend() {
  semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/


function release() {
  semaphore--;
}
/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/


function flush() {
  release();
  var task;

  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

var array = function array(patterns) {
  return function (input) {
    return patterns.some(function (p) {
      return matcher(p)(input);
    });
  };
};
var predicate = function predicate(_predicate) {
  return function (input) {
    return _predicate(input);
  };
};
var string = function string(pattern) {
  return function (input) {
    return input.type === String(pattern);
  };
};
var symbol = function symbol(pattern) {
  return function (input) {
    return input.type === pattern;
  };
};
var wildcard = function wildcard() {
  return io_22ea0cf9.k;
};
function matcher(pattern) {
  // prettier-ignore
  var matcherCreator = pattern === '*' ? wildcard : (0,redux_saga_is_esm/* string */.Z_)(pattern) ? string : (0,redux_saga_is_esm/* array */.IX)(pattern) ? array : (0,redux_saga_is_esm/* stringableFunc */.eR)(pattern) ? string : (0,redux_saga_is_esm/* func */.Yl)(pattern) ? predicate : (0,redux_saga_is_esm/* symbol */.NA)(pattern) ? symbol : null;

  if (matcherCreator === null) {
    throw new Error("invalid pattern: " + pattern);
  }

  return matcherCreator(pattern);
}

var END = {
  type: redux_saga_symbols_esm/* CHANNEL_END_TYPE */.sZ
};
var isEnd = function isEnd(a) {
  return a && a.type === redux_saga_symbols_esm/* CHANNEL_END_TYPE */.sZ;
};
var CLOSED_CHANNEL_WITH_TAKERS = 'Cannot have a closed channel with pending takers';
var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = "Saga or channel was provided with an undefined action\nHints:\n  - check that your Action Creator returns a non-undefined value\n  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners";
function channel(buffer$1) {
  if (buffer$1 === void 0) {
    buffer$1 = (0,io_22ea0cf9.e)();
  }

  var closed = false;
  var takers = [];

  if (false) {}

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw (0,io_22ea0cf9.i)(CLOSED_CHANNEL_WITH_TAKERS);
    }

    if (takers.length && !buffer$1.isEmpty()) {
      throw (0,io_22ea0cf9.i)('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    if (false) {}

    if (closed) {
      return;
    }

    if (takers.length === 0) {
      return buffer$1.put(input);
    }

    var cb = takers.shift();
    cb(input);
  }

  function take(cb) {
    if (false) {}

    if (closed && buffer$1.isEmpty()) {
      cb(END);
    } else if (!buffer$1.isEmpty()) {
      cb(buffer$1.take());
    } else {
      takers.push(cb);

      cb.cancel = function () {
        (0,io_22ea0cf9.r)(takers, cb);
      };
    }
  }

  function flush(cb) {
    if (false) {}

    if (closed && buffer$1.isEmpty()) {
      cb(END);
      return;
    }

    cb(buffer$1.flush());
  }

  function close() {
    if (false) {}

    if (closed) {
      return;
    }

    closed = true;
    var arr = takers;
    takers = [];

    for (var i = 0, len = arr.length; i < len; i++) {
      var taker = arr[i];
      taker(END);
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close
  };
}
function eventChannel(subscribe, buffer) {
  if (buffer === void 0) {
    buffer = none();
  }

  var closed = false;
  var unsubscribe;
  var chan = channel(buffer);

  var close = function close() {
    if (closed) {
      return;
    }

    closed = true;

    if (func(unsubscribe)) {
      unsubscribe();
    }

    chan.close();
  };

  unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }

    chan.put(input);
  });

  if (false) {}

  unsubscribe = once(unsubscribe);

  if (closed) {
    unsubscribe();
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}
function multicastChannel() {
  var _ref;

  var closed = false;
  var currentTakers = [];
  var nextTakers = currentTakers;

  function checkForbiddenStates() {
    if (closed && nextTakers.length) {
      throw (0,io_22ea0cf9.i)(CLOSED_CHANNEL_WITH_TAKERS);
    }
  }

  var ensureCanMutateNextTakers = function ensureCanMutateNextTakers() {
    if (nextTakers !== currentTakers) {
      return;
    }

    nextTakers = currentTakers.slice();
  };

  var close = function close() {
    if (false) {}

    closed = true;
    var takers = currentTakers = nextTakers;
    nextTakers = [];
    takers.forEach(function (taker) {
      taker(END);
    });
  };

  return _ref = {}, _ref[redux_saga_symbols_esm/* MULTICAST */.AS] = true, _ref.put = function put(input) {
    if (false) {}

    if (closed) {
      return;
    }

    if (isEnd(input)) {
      close();
      return;
    }

    var takers = currentTakers = nextTakers;

    for (var i = 0, len = takers.length; i < len; i++) {
      var taker = takers[i];

      if (taker[redux_saga_symbols_esm/* MATCH */.uq](input)) {
        taker.cancel();
        taker(input);
      }
    }
  }, _ref.take = function take(cb, matcher) {
    if (matcher === void 0) {
      matcher = wildcard;
    }

    if (false) {}

    if (closed) {
      cb(END);
      return;
    }

    cb[redux_saga_symbols_esm/* MATCH */.uq] = matcher;
    ensureCanMutateNextTakers();
    nextTakers.push(cb);
    cb.cancel = (0,io_22ea0cf9.o)(function () {
      ensureCanMutateNextTakers();
      (0,io_22ea0cf9.r)(nextTakers, cb);
    });
  }, _ref.close = close, _ref;
}
function stdChannel() {
  var chan = multicastChannel();
  var put = chan.put;

  chan.put = function (input) {
    if (input[redux_saga_symbols_esm/* SAGA_ACTION */.Nm]) {
      put(input);
      return;
    }

    asap(function () {
      put(input);
    });
  };

  return chan;
}

var RUNNING = 0;
var CANCELLED = 1;
var ABORTED = 2;
var DONE = 3;

function resolvePromise(promise, cb) {
  var cancelPromise = promise[redux_saga_symbols_esm/* CANCEL */.n1];

  if ((0,redux_saga_is_esm/* func */.Yl)(cancelPromise)) {
    cb.cancel = cancelPromise;
  }

  promise.then(cb, function (error) {
    cb(error, true);
  });
}

var current = 0;
var nextSagaId = (function () {
  return ++current;
});

var _effectRunnerMap;

function getIteratorMetaInfo(iterator, fn) {
  if (iterator.isSagaIterator) {
    return {
      name: iterator.meta.name
    };
  }

  return (0,io_22ea0cf9.j)(fn);
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  // catch synchronous failures; see #152 and #441
  try {
    var result = fn.apply(context, args); // i.e. a generator function returns an iterator

    if ((0,redux_saga_is_esm/* iterator */.hZ)(result)) {
      return result;
    }

    var resolved = false;

    var next = function next(arg) {
      if (!resolved) {
        resolved = true; // Only promises returned from fork will be interpreted. See #1573

        return {
          value: result,
          done: !(0,redux_saga_is_esm/* promise */.MC)(result)
        };
      } else {
        return {
          value: arg,
          done: true
        };
      }
    };

    return (0,io_22ea0cf9.q)(next);
  } catch (err) {
    // do not bubble up synchronous failures for detached forks
    // instead create a failed task. See #152 and #441
    return (0,io_22ea0cf9.q)(function () {
      throw err;
    });
  }
}

function runPutEffect(env, _ref2, cb) {
  var channel = _ref2.channel,
      action = _ref2.action,
      resolve = _ref2.resolve;

  /**
   Schedule the put in case another saga is holding a lock.
   The put will be executed atomically. ie nested puts will execute after
   this put has terminated.
   **/
  asap(function () {
    var result;

    try {
      result = (channel ? channel.put : env.dispatch)(action);
    } catch (error) {
      cb(error, true);
      return;
    }

    if (resolve && (0,redux_saga_is_esm/* promise */.MC)(result)) {
      resolvePromise(result, cb);
    } else {
      cb(result);
    }
  }); // Put effects are non cancellables
}

function runTakeEffect(env, _ref3, cb) {
  var _ref3$channel = _ref3.channel,
      channel = _ref3$channel === void 0 ? env.channel : _ref3$channel,
      pattern = _ref3.pattern,
      maybe = _ref3.maybe;

  var takeCb = function takeCb(input) {
    if (input instanceof Error) {
      cb(input, true);
      return;
    }

    if (isEnd(input) && !maybe) {
      cb(redux_saga_symbols_esm/* TERMINATE */.EO);
      return;
    }

    cb(input);
  };

  try {
    channel.take(takeCb, (0,redux_saga_is_esm/* notUndef */.d5)(pattern) ? matcher(pattern) : null);
  } catch (err) {
    cb(err, true);
    return;
  }

  cb.cancel = takeCb.cancel;
}

function runCallEffect(env, _ref4, cb, _ref5) {
  var context = _ref4.context,
      fn = _ref4.fn,
      args = _ref4.args;
  var task = _ref5.task;

  // catch synchronous failures; see #152
  try {
    var result = fn.apply(context, args);

    if ((0,redux_saga_is_esm/* promise */.MC)(result)) {
      resolvePromise(result, cb);
      return;
    }

    if ((0,redux_saga_is_esm/* iterator */.hZ)(result)) {
      // resolve iterator
      proc(env, result, task.context, current, (0,io_22ea0cf9.j)(fn),
      /* isRoot */
      false, cb);
      return;
    }

    cb(result);
  } catch (error) {
    cb(error, true);
  }
}

function runCPSEffect(env, _ref6, cb) {
  var context = _ref6.context,
      fn = _ref6.fn,
      args = _ref6.args;

  // CPS (ie node style functions) can define their own cancellation logic
  // by setting cancel field on the cb
  // catch synchronous failures; see #152
  try {
    var cpsCb = function cpsCb(err, res) {
      if ((0,redux_saga_is_esm/* undef */.sR)(err)) {
        cb(res);
      } else {
        cb(err, true);
      }
    };

    fn.apply(context, args.concat(cpsCb));

    if (cpsCb.cancel) {
      cb.cancel = cpsCb.cancel;
    }
  } catch (error) {
    cb(error, true);
  }
}

function runForkEffect(env, _ref7, cb, _ref8) {
  var context = _ref7.context,
      fn = _ref7.fn,
      args = _ref7.args,
      detached = _ref7.detached;
  var parent = _ref8.task;
  var taskIterator = createTaskIterator({
    context: context,
    fn: fn,
    args: args
  });
  var meta = getIteratorMetaInfo(taskIterator, fn);
  immediately(function () {
    var child = proc(env, taskIterator, parent.context, current, meta, detached, undefined);

    if (detached) {
      cb(child);
    } else {
      if (child.isRunning()) {
        parent.queue.addTask(child);
        cb(child);
      } else if (child.isAborted()) {
        parent.queue.abort(child.error());
      } else {
        cb(child);
      }
    }
  }); // Fork effects are non cancellables
}

function runJoinEffect(env, taskOrTasks, cb, _ref9) {
  var task = _ref9.task;

  var joinSingleTask = function joinSingleTask(taskToJoin, cb) {
    if (taskToJoin.isRunning()) {
      var joiner = {
        task: task,
        cb: cb
      };

      cb.cancel = function () {
        if (taskToJoin.isRunning()) (0,io_22ea0cf9.r)(taskToJoin.joiners, joiner);
      };

      taskToJoin.joiners.push(joiner);
    } else {
      if (taskToJoin.isAborted()) {
        cb(taskToJoin.error(), true);
      } else {
        cb(taskToJoin.result());
      }
    }
  };

  if ((0,redux_saga_is_esm/* array */.IX)(taskOrTasks)) {
    if (taskOrTasks.length === 0) {
      cb([]);
      return;
    }

    var childCallbacks = (0,io_22ea0cf9.l)(taskOrTasks, cb);
    taskOrTasks.forEach(function (t, i) {
      joinSingleTask(t, childCallbacks[i]);
    });
  } else {
    joinSingleTask(taskOrTasks, cb);
  }
}

function cancelSingleTask(taskToCancel) {
  if (taskToCancel.isRunning()) {
    taskToCancel.cancel();
  }
}

function runCancelEffect(env, taskOrTasks, cb, _ref10) {
  var task = _ref10.task;

  if (taskOrTasks === redux_saga_symbols_esm/* SELF_CANCELLATION */.sC) {
    cancelSingleTask(task);
  } else if ((0,redux_saga_is_esm/* array */.IX)(taskOrTasks)) {
    taskOrTasks.forEach(cancelSingleTask);
  } else {
    cancelSingleTask(taskOrTasks);
  }

  cb(); // cancel effects are non cancellables
}

function runAllEffect(env, effects, cb, _ref11) {
  var digestEffect = _ref11.digestEffect;
  var effectId = current;
  var keys = Object.keys(effects);

  if (keys.length === 0) {
    cb((0,redux_saga_is_esm/* array */.IX)(effects) ? [] : {});
    return;
  }

  var childCallbacks = (0,io_22ea0cf9.l)(effects, cb);
  keys.forEach(function (key) {
    digestEffect(effects[key], effectId, childCallbacks[key], key);
  });
}

function runRaceEffect(env, effects, cb, _ref12) {
  var digestEffect = _ref12.digestEffect;
  var effectId = current;
  var keys = Object.keys(effects);
  var response = (0,redux_saga_is_esm/* array */.IX)(effects) ? (0,io_22ea0cf9.m)(keys.length) : {};
  var childCbs = {};
  var completed = false;
  keys.forEach(function (key) {
    var chCbAtKey = function chCbAtKey(res, isErr) {
      if (completed) {
        return;
      }

      if (isErr || (0,io_22ea0cf9.s)(res)) {
        // Race Auto cancellation
        cb.cancel();
        cb(res, isErr);
      } else {
        cb.cancel();
        completed = true;
        response[key] = res;
        cb(response);
      }
    };

    chCbAtKey.cancel = io_22ea0cf9.t;
    childCbs[key] = chCbAtKey;
  });

  cb.cancel = function () {
    // prevents unnecessary cancellation
    if (!completed) {
      completed = true;
      keys.forEach(function (key) {
        return childCbs[key].cancel();
      });
    }
  };

  keys.forEach(function (key) {
    if (completed) {
      return;
    }

    digestEffect(effects[key], effectId, childCbs[key], key);
  });
}

function runSelectEffect(env, _ref13, cb) {
  var selector = _ref13.selector,
      args = _ref13.args;

  try {
    var state = selector.apply(void 0, [env.getState()].concat(args));
    cb(state);
  } catch (error) {
    cb(error, true);
  }
}

function runChannelEffect(env, _ref14, cb) {
  var pattern = _ref14.pattern,
      buffer = _ref14.buffer;
  var chan = channel(buffer);
  var match = matcher(pattern);

  var taker = function taker(action) {
    if (!isEnd(action)) {
      env.channel.take(taker, match);
    }

    chan.put(action);
  };

  var close = chan.close;

  chan.close = function () {
    taker.cancel();
    close();
  };

  env.channel.take(taker, match);
  cb(chan);
}

function runCancelledEffect(env, data, cb, _ref15) {
  var task = _ref15.task;
  cb(task.isCancelled());
}

function runFlushEffect(env, channel, cb) {
  channel.flush(cb);
}

function runGetContextEffect(env, prop, cb, _ref16) {
  var task = _ref16.task;
  cb(task.context[prop]);
}

function runSetContextEffect(env, props, cb, _ref17) {
  var task = _ref17.task;
  (0,io_22ea0cf9.p)(task.context, props);
  cb();
}

var effectRunnerMap = (_effectRunnerMap = {}, _effectRunnerMap[io_22ea0cf9.T] = runTakeEffect, _effectRunnerMap[io_22ea0cf9.P] = runPutEffect, _effectRunnerMap[io_22ea0cf9.A] = runAllEffect, _effectRunnerMap[io_22ea0cf9.R] = runRaceEffect, _effectRunnerMap[io_22ea0cf9.C] = runCallEffect, _effectRunnerMap[io_22ea0cf9.a] = runCPSEffect, _effectRunnerMap[io_22ea0cf9.F] = runForkEffect, _effectRunnerMap[io_22ea0cf9.J] = runJoinEffect, _effectRunnerMap[io_22ea0cf9.b] = runCancelEffect, _effectRunnerMap[io_22ea0cf9.S] = runSelectEffect, _effectRunnerMap[io_22ea0cf9.d] = runChannelEffect, _effectRunnerMap[io_22ea0cf9.f] = runCancelledEffect, _effectRunnerMap[io_22ea0cf9.g] = runFlushEffect, _effectRunnerMap[io_22ea0cf9.G] = runGetContextEffect, _effectRunnerMap[io_22ea0cf9.h] = runSetContextEffect, _effectRunnerMap);

/**
 Used to track a parent task and its forks
 In the fork model, forked tasks are attached by default to their parent
 We model this using the concept of Parent task && main Task
 main task is the main flow of the current Generator, the parent tasks is the
 aggregation of the main tasks + all its forked tasks.
 Thus the whole model represents an execution tree with multiple branches (vs the
 linear execution tree in sequential (non parallel) programming)

 A parent tasks has the following semantics
 - It completes if all its forks either complete or all cancelled
 - If it's cancelled, all forks are cancelled as well
 - It aborts if any uncaught error bubbles up from forks
 - If it completes, the return value is the one returned by the main task
 **/

function forkQueue(mainTask, onAbort, cont) {
  var tasks = [];
  var result;
  var completed = false;
  addTask(mainTask);

  var getTasks = function getTasks() {
    return tasks;
  };

  function abort(err) {
    onAbort();
    cancelAll();
    cont(err, true);
  }

  function addTask(task) {
    tasks.push(task);

    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      (0,io_22ea0cf9.r)(tasks, task);
      task.cont = io_22ea0cf9.t;

      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }

        if (!tasks.length) {
          completed = true;
          cont(result);
        }
      }
    };
  }

  function cancelAll() {
    if (completed) {
      return;
    }

    completed = true;
    tasks.forEach(function (t) {
      t.cont = io_22ea0cf9.t;
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: getTasks
  };
}

// there can be only a single saga error created at any given moment

function formatLocation(fileName, lineNumber) {
  return fileName + "?" + lineNumber;
}

function effectLocationAsString(effect) {
  var location = (0,io_22ea0cf9.v)(effect);

  if (location) {
    var code = location.code,
        fileName = location.fileName,
        lineNumber = location.lineNumber;
    var source = code + "  " + formatLocation(fileName, lineNumber);
    return source;
  }

  return '';
}

function sagaLocationAsString(sagaMeta) {
  var name = sagaMeta.name,
      location = sagaMeta.location;

  if (location) {
    return name + "  " + formatLocation(location.fileName, location.lineNumber);
  }

  return name;
}

function cancelledTasksAsString(sagaStack) {
  var cancelledTasks = (0,io_22ea0cf9.u)(function (i) {
    return i.cancelledTasks;
  }, sagaStack);

  if (!cancelledTasks.length) {
    return '';
  }

  return ['Tasks cancelled due to error:'].concat(cancelledTasks).join('\n');
}

var crashedEffect = null;
var sagaStack = [];
var addSagaFrame = function addSagaFrame(frame) {
  frame.crashedEffect = crashedEffect;
  sagaStack.push(frame);
};
var clear = function clear() {
  crashedEffect = null;
  sagaStack.length = 0;
}; // this sets crashed effect for the soon-to-be-reported saga frame
// this slightly streatches the singleton nature of this module into wrong direction
// as it's even less obvious what's the data flow here, but it is what it is for now

var setCrashedEffect = function setCrashedEffect(effect) {
  crashedEffect = effect;
};
/**
  @returns {string}

  @example
  The above error occurred in task errorInPutSaga {pathToFile}
  when executing effect put({type: 'REDUCER_ACTION_ERROR_IN_PUT'}) {pathToFile}
      created by fetchSaga {pathToFile}
      created by rootSaga {pathToFile}
*/

var redux_saga_core_esm_toString = function toString() {
  var firstSaga = sagaStack[0],
      otherSagas = sagaStack.slice(1);
  var crashedEffectLocation = firstSaga.crashedEffect ? effectLocationAsString(firstSaga.crashedEffect) : null;
  var errorMessage = "The above error occurred in task " + sagaLocationAsString(firstSaga.meta) + (crashedEffectLocation ? " \n when executing effect " + crashedEffectLocation : '');
  return [errorMessage].concat(otherSagas.map(function (s) {
    return "    created by " + sagaLocationAsString(s.meta);
  }), [cancelledTasksAsString(sagaStack)]).join('\n');
};

function newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont) {
  var _task;

  if (cont === void 0) {
    cont = io_22ea0cf9.t;
  }

  var status = RUNNING;
  var taskResult;
  var taskError;
  var deferredEnd = null;
  var cancelledDueToErrorTasks = [];
  var context = Object.create(parentContext);
  var queue = forkQueue(mainTask, function onAbort() {
    cancelledDueToErrorTasks.push.apply(cancelledDueToErrorTasks, queue.getTasks().map(function (t) {
      return t.meta.name;
    }));
  }, end);
  /**
   This may be called by a parent generator to trigger/propagate cancellation
   cancel all pending tasks (including the main task), then end the current task.
    Cancellation propagates down to the whole execution tree held by this Parent task
   It's also propagated to all joiners of this task and their execution tree/joiners
    Cancellation is noop for terminated/Cancelled tasks tasks
   **/

  function cancel() {
    if (status === RUNNING) {
      // Setting status to CANCELLED does not necessarily mean that the task/iterators are stopped
      // effects in the iterator's finally block will still be executed
      status = CANCELLED;
      queue.cancelAll(); // Ending with a TASK_CANCEL will propagate the Cancellation to all joiners

      end(redux_saga_symbols_esm/* TASK_CANCEL */.Wd, false);
    }
  }

  function end(result, isErr) {
    if (!isErr) {
      // The status here may be RUNNING or CANCELLED
      // If the status is CANCELLED, then we do not need to change it here
      if (result === redux_saga_symbols_esm/* TASK_CANCEL */.Wd) {
        status = CANCELLED;
      } else if (status !== CANCELLED) {
        status = DONE;
      }

      taskResult = result;
      deferredEnd && deferredEnd.resolve(result);
    } else {
      status = ABORTED;
      addSagaFrame({
        meta: meta,
        cancelledTasks: cancelledDueToErrorTasks
      });

      if (task.isRoot) {
        var sagaStack = redux_saga_core_esm_toString(); // we've dumped the saga stack to string and are passing it to user's code
        // we know that it won't be needed anymore and we need to clear it

        clear();
        env.onError(result, {
          sagaStack: sagaStack
        });
      }

      taskError = result;
      deferredEnd && deferredEnd.reject(result);
    }

    task.cont(result, isErr);
    task.joiners.forEach(function (joiner) {
      joiner.cb(result, isErr);
    });
    task.joiners = null;
  }

  function setContext(props) {
    if (false) {}

    (0,io_22ea0cf9.p)(context, props);
  }

  function toPromise() {
    if (deferredEnd) {
      return deferredEnd.promise;
    }

    deferredEnd = redux_saga_deferred_esm();

    if (status === ABORTED) {
      deferredEnd.reject(taskError);
    } else if (status !== RUNNING) {
      deferredEnd.resolve(taskResult);
    }

    return deferredEnd.promise;
  }

  var task = (_task = {}, _task[redux_saga_symbols_esm/* TASK */.Cs] = true, _task.id = parentEffectId, _task.meta = meta, _task.isRoot = isRoot, _task.context = context, _task.joiners = [], _task.queue = queue, _task.cancel = cancel, _task.cont = cont, _task.end = end, _task.setContext = setContext, _task.toPromise = toPromise, _task.isRunning = function isRunning() {
    return status === RUNNING;
  }, _task.isCancelled = function isCancelled() {
    return status === CANCELLED || status === RUNNING && mainTask.status === CANCELLED;
  }, _task.isAborted = function isAborted() {
    return status === ABORTED;
  }, _task.result = function result() {
    return taskResult;
  }, _task.error = function error() {
    return taskError;
  }, _task);
  return task;
}

function proc(env, iterator$1, parentContext, parentEffectId, meta, isRoot, cont) {
  if (false) {}

  var finalRunEffect = env.finalizeRunEffect(runEffect);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/

  next.cancel = io_22ea0cf9.t;
  /** Creates a main task to track the main flow */

  var mainTask = {
    meta: meta,
    cancel: cancelMain,
    status: RUNNING
  };
  /**
   Creates a new task descriptor for this generator.
   A task is the aggregation of it's mainTask and all it's forked tasks.
   **/

  var task = newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont);
  var executingContext = {
    task: task,
    digestEffect: digestEffect
  };
  /**
    cancellation of the main task. We'll simply resume the Generator with a TASK_CANCEL
  **/

  function cancelMain() {
    if (mainTask.status === RUNNING) {
      mainTask.status = CANCELLED;
      next(redux_saga_symbols_esm/* TASK_CANCEL */.Wd);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/


  if (cont) {
    cont.cancel = task.cancel;
  } // kicks up the generator


  next(); // then return the task descriptor to the caller

  return task;
  /**
   * This is the generator driver
   * It's a recursive async/continuation function which calls itself
   * until the generator terminates or throws
   * @param {internal commands(TASK_CANCEL | TERMINATE) | any} arg - value, generator will be resumed with.
   * @param {boolean} isErr - the flag shows if effect finished with an error
   *
   * receives either (command | effect result, false) or (any thrown thing, true)
   */

  function next(arg, isErr) {
    try {
      var result;

      if (isErr) {
        result = iterator$1.throw(arg); // user handled the error, we can clear bookkept values

        clear();
      } else if ((0,io_22ea0cf9.y)(arg)) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.status = CANCELLED;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/

        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/

        result = (0,redux_saga_is_esm/* func */.Yl)(iterator$1.return) ? iterator$1.return(redux_saga_symbols_esm/* TASK_CANCEL */.Wd) : {
          done: true,
          value: redux_saga_symbols_esm/* TASK_CANCEL */.Wd
        };
      } else if ((0,io_22ea0cf9.z)(arg)) {
        // We get TERMINATE flag, i.e. by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = (0,redux_saga_is_esm/* func */.Yl)(iterator$1.return) ? iterator$1.return() : {
          done: true
        };
      } else {
        result = iterator$1.next(arg);
      }

      if (!result.done) {
        digestEffect(result.value, parentEffectId, next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        if (mainTask.status !== CANCELLED) {
          mainTask.status = DONE;
        }

        mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.status === CANCELLED) {
        throw error;
      }

      mainTask.status = ABORTED;
      mainTask.cont(error, true);
    }
  }

  function runEffect(effect, effectId, currCb) {
    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    if ((0,redux_saga_is_esm/* promise */.MC)(effect)) {
      resolvePromise(effect, currCb);
    } else if ((0,redux_saga_is_esm/* iterator */.hZ)(effect)) {
      // resolve iterator
      proc(env, effect, task.context, effectId, meta,
      /* isRoot */
      false, currCb);
    } else if (effect && effect[redux_saga_symbols_esm.IO]) {
      var effectRunner = effectRunnerMap[effect.type];
      effectRunner(env, effect.payload, currCb, executingContext);
    } else {
      // anything else returned as is
      currCb(effect);
    }
  }

  function digestEffect(effect, parentEffectId, cb, label) {
    if (label === void 0) {
      label = '';
    }

    var effectId = nextSagaId();
    env.sagaMonitor && env.sagaMonitor.effectTriggered({
      effectId: effectId,
      parentEffectId: parentEffectId,
      label: label,
      effect: effect
    });
    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/

    var effectSettled; // Completion callback passed to the appropriate effect runner

    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = io_22ea0cf9.t; // defensive measure

      if (env.sagaMonitor) {
        if (isErr) {
          env.sagaMonitor.effectRejected(effectId, res);
        } else {
          env.sagaMonitor.effectResolved(effectId, res);
        }
      }

      if (isErr) {
        setCrashedEffect(effect);
      }

      cb(res, isErr);
    } // tracks down the current cancel


    currCb.cancel = io_22ea0cf9.t; // setup cancellation logic on the parent cb

    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      currCb.cancel(); // propagates cancel downward

      currCb.cancel = io_22ea0cf9.t; // defensive measure

      env.sagaMonitor && env.sagaMonitor.effectCancelled(effectId);
    };

    finalRunEffect(effect, effectId, currCb);
  }
}

var RUN_SAGA_SIGNATURE = 'runSaga(options, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ": saga argument must be a Generator function!";
function runSaga(_ref, saga) {
  var _ref$channel = _ref.channel,
      channel = _ref$channel === void 0 ? stdChannel() : _ref$channel,
      dispatch = _ref.dispatch,
      getState = _ref.getState,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? {} : _ref$context,
      sagaMonitor = _ref.sagaMonitor,
      effectMiddlewares = _ref.effectMiddlewares,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? io_22ea0cf9.D : _ref$onError;

  if (false) {}

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator$1 = saga.apply(void 0, args);

  if (false) {}

  var effectId = nextSagaId();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.rootSagaStarted = sagaMonitor.rootSagaStarted || io_22ea0cf9.t;
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || io_22ea0cf9.t;
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || io_22ea0cf9.t;
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || io_22ea0cf9.t;
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || io_22ea0cf9.t;
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || io_22ea0cf9.t;
    sagaMonitor.rootSagaStarted({
      effectId: effectId,
      saga: saga,
      args: args
    });
  }

  if (false) { var MIDDLEWARE_TYPE_ERROR; }

  var finalizeRunEffect;

  if (effectMiddlewares) {
    var middleware = io_22ea0cf9.B.apply(void 0, effectMiddlewares);

    finalizeRunEffect = function finalizeRunEffect(runEffect) {
      return function (effect, effectId, currCb) {
        var plainRunEffect = function plainRunEffect(eff) {
          return runEffect(eff, effectId, currCb);
        };

        return middleware(plainRunEffect)(effect);
      };
    };
  } else {
    finalizeRunEffect = io_22ea0cf9.H;
  }

  var env = {
    channel: channel,
    dispatch: (0,io_22ea0cf9.E)(dispatch),
    getState: getState,
    sagaMonitor: sagaMonitor,
    onError: onError,
    finalizeRunEffect: finalizeRunEffect
  };
  return immediately(function () {
    var task = proc(env, iterator$1, context, effectId, (0,io_22ea0cf9.j)(saga),
    /* isRoot */
    true, undefined);

    if (sagaMonitor) {
      sagaMonitor.effectResolved(effectId, task);
    }

    return task;
  });
}

function sagaMiddlewareFactory(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? {} : _ref$context,
      _ref$channel = _ref.channel,
      channel = _ref$channel === void 0 ? stdChannel() : _ref$channel,
      sagaMonitor = _ref.sagaMonitor,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["context", "channel", "sagaMonitor"]);

  var boundRunSaga;

  if (false) {}

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;
    boundRunSaga = runSaga.bind(null, (0,esm_extends/* default */.Z)({}, options, {
      context: context,
      channel: channel,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor
    }));
    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }

        var result = next(action); // hit reducers

        channel.put(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    if (false) {}

    return boundRunSaga.apply(void 0, arguments);
  };

  sagaMiddleware.setContext = function (props) {
    if (false) {}

    (0,io_22ea0cf9.p)(context, props);
  };

  return sagaMiddleware;
}

/* harmony default export */ var redux_saga_core_esm = (sagaMiddlewareFactory);


;// CONCATENATED MODULE: ../../node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js





/* harmony default export */ var redux_saga_core_npm_proxy_esm = (redux_saga_core_esm);


/***/ }),

/***/ 38726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "md": function() { return /* binding */ applyMiddleware; },
  "DE": function() { return /* binding */ bindActionCreators; },
  "UY": function() { return /* binding */ combineReducers; },
  "qC": function() { return /* binding */ compose; },
  "MT": function() { return /* binding */ createStore; }
});

// UNUSED EXPORTS: __DO_NOT_USE__ActionTypes, legacy_createStore

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0,defineProperty/* default */.Z)(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

;// CONCATENATED MODULE: ../../node_modules/redux/es/redux.js


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = (/* unused pure expression or super */ null && (createStore));

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2(_objectSpread2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}




/***/ }),

/***/ 5994:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "P1": function() { return /* binding */ createSelector; }
});

// UNUSED EXPORTS: createSelectorCreator, createStructuredSelector, defaultEqualityCheck, defaultMemoize

;// CONCATENATED MODULE: ../../node_modules/reselect/es/defaultMemoize.js
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var NOT_FOUND = 'NOT_FOUND';

function createSingletonCache(equals) {
  var entry;
  return {
    get: function get(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }

      return NOT_FOUND;
    },
    put: function put(key, value) {
      entry = {
        key: key,
        value: value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = undefined;
    }
  };
}

function createLruCache(maxSize, equals) {
  var entries = [];

  function get(key) {
    var cacheIndex = entries.findIndex(function (entry) {
      return equals(key, entry.key);
    }); // We found a cached entry

    if (cacheIndex > -1) {
      var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top

      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }

      return entry.value;
    } // No entry found in cache, return sentinel


    return NOT_FOUND;
  }

  function put(key, value) {
    if (get(key) === NOT_FOUND) {
      // TODO Is unshift slow?
      entries.unshift({
        key: key,
        value: value
      });

      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }

  function getEntries() {
    return entries;
  }

  function clear() {
    entries = [];
  }

  return {
    get: get,
    put: put,
    getEntries: getEntries,
    clear: clear
  };
}

var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
  return a === b;
};
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.


    var length = prev.length;

    for (var i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }

    return true;
  };
}
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
function defaultMemoize(func, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck,
      equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa,
      _providedOptions$maxS = providedOptions.maxSize,
      maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS,
      resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons

  function memoized() {
    var value = cache.get(arguments);

    if (value === NOT_FOUND) {
      // @ts-ignore
      value = func.apply(null, arguments);

      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function (entry) {
          return resultEqualityCheck(entry.value, value);
        });

        if (matchingEntry) {
          value = matchingEntry.value;
        }
      }

      cache.put(arguments, value);
    }

    return value;
  }

  memoized.clearCache = function () {
    return cache.clear();
  };

  return memoized;
}
;// CONCATENATED MODULE: ../../node_modules/reselect/es/index.js



function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
    }).join(', ');
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
  }

  var createSelector = function createSelector() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var _recomputations = 0;

    var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
    // So, start by declaring the default value here.
    // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)


    var directlyPassedOptions = {
      memoizeOptions: undefined
    }; // Normally, the result func or "output selector" is the last arg

    var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object

    if (typeof resultFunc === 'object') {
      directlyPassedOptions = resultFunc; // and pop the real result func off

      resultFunc = funcs.pop();
    }

    if (typeof resultFunc !== 'function') {
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
    } // Determine which set of options we're using. Prefer options passed directly,
    // but fall back to options given to createSelectorCreator.


    var _directlyPassedOption = directlyPassedOptions,
        _directlyPassedOption2 = _directlyPassedOption.memoizeOptions,
        memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
    // is an array. In most libs I've looked at, it's an equality function or options object.
    // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
    // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
    // we wrap it in an array so we can apply it.

    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(void 0, [function recomputationWrapper() {
      _recomputations++; // apply arguments instead of spreading for performance.

      return resultFunc.apply(null, arguments);
    }].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.

    var selector = memoize(function dependenciesChecker() {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        // @ts-ignore
        params.push(dependencies[i].apply(null, arguments));
      } // apply arguments instead of spreading for performance.


      _lastResult = memoizedResultFunc.apply(null, params);
      return _lastResult;
    });
    Object.assign(selector, {
      resultFunc: resultFunc,
      memoizedResultFunc: memoizedResultFunc,
      dependencies: dependencies,
      lastResult: function lastResult() {
        return _lastResult;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        return _recomputations = 0;
      }
    });
    return selector;
  }; // @ts-ignore


  return createSelector;
}
var createSelector = /* #__PURE__ */createSelectorCreator(defaultMemoize);
// Manual definition of state and output arguments
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
  if (selectorCreator === void 0) {
    selectorCreator = createSelector;
  }

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
  }

  var objectKeys = Object.keys(selectors);
  var resultSelector = selectorCreator( // @ts-ignore
  objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
  return resultSelector;
};

/***/ }),

/***/ 88665:
/***/ (function(module) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),

/***/ 12642:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var inspect = __webpack_require__(99500);

var $TypeError = __webpack_require__(5408);

/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/
/** @type {import('./list.d.ts').listGetNode} */
// eslint-disable-next-line consistent-return
var listGetNode = function (list, key, isDelete) {
	/** @type {typeof list | NonNullable<(typeof list)['next']>} */
	var prev = list;
	/** @type {(typeof list)['next']} */
	var curr;
	// eslint-disable-next-line eqeqeq
	for (; (curr = prev.next) != null; prev = curr) {
		if (curr.key === key) {
			prev.next = curr.next;
			if (!isDelete) {
				// eslint-disable-next-line no-extra-parens
				curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
				list.next = curr; // eslint-disable-line no-param-reassign
			}
			return curr;
		}
	}
};

/** @type {import('./list.d.ts').listGet} */
var listGet = function (objects, key) {
	if (!objects) {
		return void undefined;
	}
	var node = listGetNode(objects, key);
	return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */
var listSet = function (objects, key, value) {
	var node = listGetNode(objects, key);
	if (node) {
		node.value = value;
	} else {
		// Prepend the new node to the beginning of the list
		objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
			key: key,
			next: objects.next,
			value: value
		});
	}
};
/** @type {import('./list.d.ts').listHas} */
var listHas = function (objects, key) {
	if (!objects) {
		return false;
	}
	return !!listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */
// eslint-disable-next-line consistent-return
var listDelete = function (objects, key) {
	if (objects) {
		return listGetNode(objects, key, true);
	}
};

/** @type {import('.')} */
module.exports = function getSideChannelList() {
	/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			var root = $o && $o.next;
			var deletedNode = listDelete($o, key);
			if (deletedNode && root && root === deletedNode) {
				$o = void undefined;
			}
			return !!deletedNode;
		},
		get: function (key) {
			return listGet($o, key);
		},
		has: function (key) {
			return listHas($o, key);
		},
		set: function (key, value) {
			if (!$o) {
				// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
				$o = {
					next: void undefined
				};
			}
			// eslint-disable-next-line no-extra-parens
			listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
		}
	};
	// @ts-expect-error TODO: figure out why this is erroring
	return channel;
};


/***/ }),

/***/ 46623:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(42732);
var callBound = __webpack_require__(8435);
var inspect = __webpack_require__(99500);

var $TypeError = __webpack_require__(5408);
var $Map = GetIntrinsic('%Map%', true);

/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
var $mapGet = callBound('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
var $mapSet = callBound('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapHas = callBound('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
var $mapDelete = callBound('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */
var $mapSize = callBound('Map.prototype.size', true);

/** @type {import('.')} */
module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
	/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
	/** @typedef {Parameters<Channel['get']>[0]} K */
	/** @typedef {Parameters<Channel['set']>[1]} V */

	/** @type {Map<K, V> | undefined} */ var $m;

	/** @type {Channel} */
	var channel = {
		assert: function (key) {
			if (!channel.has(key)) {
				throw new $TypeError('Side channel does not contain ' + inspect(key));
			}
		},
		'delete': function (key) {
			if ($m) {
				var result = $mapDelete($m, key);
				if ($mapSize($m) === 0) {
					$m = void undefined;
				}
				return result;
			}
			return false;
		},
		get: function (key) { // eslint-disable-line consistent-return
			if ($m) {
				return $mapGet($m, key);
			}
		},
		has: function (key) {
			if ($m) {
				return $mapHas($m, key);
			}
			return false;
		},
		set: function (key, value) {
			if (!$m) {
				// @ts-expect-error TS can't handle narrowing a variable inside a closure
				$m = new $Map();
			}
			$mapSet($m, key, value);
		}
	};

	// @ts-expect-error TODO: figure out why TS is erroring here
	return channel;
};


/***/ }),

/***/ 42732:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $Object = __webpack_require__(54546);

var $Error = __webpack_require__(42321);
var $EvalError = __webpack_require__(69654);
var $RangeError = __webpack_require__(48205);
var $ReferenceError = __webpack_require__(2976);
var $SyntaxError = __webpack_require__(48342);
var $TypeError = __webpack_require__(5408);
var $URIError = __webpack_require__(82885);

var abs = __webpack_require__(14383);
var floor = __webpack_require__(45736);
var max = __webpack_require__(27130);
var min = __webpack_require__(22400);
var pow = __webpack_require__(23654);
var round = __webpack_require__(96890);
var sign = __webpack_require__(82026);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(50908);
var $defineProperty = __webpack_require__(70999);

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(86225)();

var getProto = __webpack_require__(21750);
var $ObjectGPO = __webpack_require__(2938);
var $ReflectGPO = __webpack_require__(78354);

var $apply = __webpack_require__(49638);
var $call = __webpack_require__(68418);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(4090);
var hasOwn = __webpack_require__(84834);
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 90721:
/***/ (function(module) {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),

/***/ 50908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(90721);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 86225:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(71365);

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 71365:
/***/ (function(module) {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 84834:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(4090);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ 42207:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(71933);
var callBound = __webpack_require__(8435);
var inspect = __webpack_require__(99500);
var getSideChannelMap = __webpack_require__(46623);

var $TypeError = __webpack_require__(5408);
var $WeakMap = GetIntrinsic('%WeakMap%', true);

/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
var $weakMapGet = callBound('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
var $weakMapSet = callBound('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapHas = callBound('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
var $weakMapDelete = callBound('WeakMap.prototype.delete', true);

/** @type {import('.')} */
module.exports = $WeakMap
	? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
		/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */

		/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
		/** @type {Channel | undefined} */ var $m;

		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapDelete($wm, key);
					}
				} else if (getSideChannelMap) {
					if ($m) {
						return $m['delete'](key);
					}
				}
				return false;
			},
			get: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapGet($wm, key);
					}
				}
				return $m && $m.get(key);
			},
			has: function (key) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if ($wm) {
						return $weakMapHas($wm, key);
					}
				}
				return !!$m && $m.has(key);
			},
			set: function (key, value) {
				if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
					if (!$wm) {
						$wm = new $WeakMap();
					}
					$weakMapSet($wm, key, value);
				} else if (getSideChannelMap) {
					if (!$m) {
						$m = getSideChannelMap();
					}
					// eslint-disable-next-line no-extra-parens
					/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
				}
			}
		};

		// @ts-expect-error TODO: figure out why this is erroring
		return channel;
	}
	: getSideChannelMap;


/***/ }),

/***/ 71933:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var undefined;

var $Object = __webpack_require__(54546);

var $Error = __webpack_require__(42321);
var $EvalError = __webpack_require__(69654);
var $RangeError = __webpack_require__(48205);
var $ReferenceError = __webpack_require__(2976);
var $SyntaxError = __webpack_require__(48342);
var $TypeError = __webpack_require__(5408);
var $URIError = __webpack_require__(82885);

var abs = __webpack_require__(14383);
var floor = __webpack_require__(45736);
var max = __webpack_require__(27130);
var min = __webpack_require__(22400);
var pow = __webpack_require__(23654);
var round = __webpack_require__(96890);
var sign = __webpack_require__(82026);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(28409);
var $defineProperty = __webpack_require__(70999);

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(83609)();

var getProto = __webpack_require__(21750);
var $ObjectGPO = __webpack_require__(2938);
var $ReflectGPO = __webpack_require__(78354);

var $apply = __webpack_require__(49638);
var $call = __webpack_require__(68418);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(4090);
var hasOwn = __webpack_require__(46228);
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),

/***/ 79023:
/***/ (function(module) {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),

/***/ 28409:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(79023);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),

/***/ 83609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(3816);

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),

/***/ 3816:
/***/ (function(module) {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),

/***/ 46228:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(4090);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),

/***/ 26806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aM": function() { return /* binding */ useQuery; },
/* harmony export */   "zt": function() { return /* binding */ h; }
/* harmony export */ });
/* unused harmony exports Consumer, Context, Mutation, Query, Subscription, useClient, useMutation, useSubscription */
/* harmony import */ var _urql_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54569);
/* harmony import */ var _urql_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29041);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var wonka__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94177);








var p = (0,_urql_core__WEBPACK_IMPORTED_MODULE_1__/* .createClient */ .eI)({
  url: "/graphql"
});

var y = (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(p);

var h = y.Provider;

var x = y.Consumer;

y.displayName = "UrqlContext";

var g = (/* unused pure expression or super */ null && (!1));

var useClient = () => {
  var e = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(y);
  if (false) {}
  return e;
};

var b = {
  fetching: !1,
  stale: !1,
  error: void 0,
  data: void 0,
  extensions: void 0,
  operation: void 0
};

var computeNextState = (e, r) => {
  var t = {
    ...e,
    ...r,
    data: void 0 !== r.data || r.error ? r.data : e.data,
    fetching: !!r.fetching,
    stale: !!r.stale
  };
  return ((e, r) => {
    if ("object" != typeof e || "object" != typeof r) {
      return e !== r;
    }
    for (var t in e) {
      if (!(t in r)) {
        return !0;
      }
    }
    for (var n in r) {
      if (e[n] !== r[n]) {
        return !0;
      }
    }
    return !1;
  })(e, t) ? t : e;
};

var hasDepsChanged = (e, r) => {
  for (var t = 0, n = r.length; t < n; t++) {
    if (e[t] !== r[t]) {
      return !0;
    }
  }
  return !1;
};

function useMutation(e) {
  var t = a(!0);
  var n = useClient();
  var [s, v] = u(b);
  var f = i(((a, u) => {
    v({
      ...b,
      fetching: !0
    });
    return c(n.executeMutation(r(e, a), u || {})).then((e => {
      if (t.current) {
        v({
          fetching: !1,
          stale: !!e.stale,
          data: e.data,
          error: e.error,
          extensions: e.extensions,
          operation: e.operation
        });
      }
      return e;
    }));
  }), [ n, e, v ]);
  o((() => {
    t.current = !0;
    return () => {
      t.current = !1;
    };
  }), []);
  return [ s, f ];
}

function useRequest(e, t) {
  var n = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(void 0);
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)((() => {
    var a = (0,_urql_core__WEBPACK_IMPORTED_MODULE_2__.f)(e, t);
    if (void 0 !== n.current && n.current.key === a.key) {
      return n.current;
    } else {
      n.current = a;
      return a;
    }
  }), [ e, t ]);
}

function useQuery(e) {
  var r = useClient();
  var t = (e => {
    if (!e._react) {
      var r = new Set;
      var t = new Map;
      if (e.operations$) {
        (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .subscribe */ .Ld)((e => {
          if ("teardown" === e.kind && r.has(e.key)) {
            r.delete(e.key);
            t.delete(e.key);
          }
        }))(e.operations$);
      }
      e._react = {
        get: e => t.get(e),
        set(e, n) {
          r.delete(e);
          t.set(e, n);
        },
        dispose(e) {
          r.add(e);
        }
      };
    }
    return e._react;
  })(r);
  var n = ((e, r) => e.suspense && (!r || !1 !== r.suspense))(r, e.context);
  var a = useRequest(e.query, e.variables);
  var c = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)((() => {
    if (e.pause) {
      return null;
    }
    var u = r.executeQuery(a, {
      requestPolicy: e.requestPolicy,
      ...e.context
    });
    return n ? (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .onPush */ .Mq)((e => {
      t.set(a.key, e);
    }))(u) : u;
  }), [ t, r, a, n, e.pause, e.requestPolicy, e.context ]);
  var p = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(((e, r) => {
    if (!e) {
      return {
        fetching: !1
      };
    }
    var n = t.get(a.key);
    if (!n) {
      var u;
      var i = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .subscribe */ .Ld)((e => {
        n = e;
        if (u) {
          u(n);
        }
      }))((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .takeWhile */ .oE)((() => r && !u || !n))(e));
      if (null == n && r) {
        var o = new Promise((e => {
          u = e;
        }));
        t.set(a.key, o);
        throw o;
      } else {
        i.unsubscribe();
      }
    } else if (r && null != n && "then" in n) {
      throw n;
    }
    return n || {
      fetching: !0
    };
  }), [ t, a ]);
  var y = [ r, a, e.requestPolicy, e.context, e.pause ];
  var [h, x] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)((() => [ c, computeNextState(b, p(c, n)), y ]));
  var g = h[1];
  if (c !== h[0] && hasDepsChanged(h[2], y)) {
    x([ c, g = computeNextState(h[1], p(c, n)), y ]);
  }
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)((() => {
    var e = h[0];
    var r = h[2][1];
    var n = !1;
    var updateResult = e => {
      n = !0;
      x((r => {
        var t = computeNextState(r[1], e);
        return r[1] !== t ? [ r[0], t, r[2] ] : r;
      }));
    };
    if (e) {
      var a = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .subscribe */ .Ld)(updateResult)((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .onEnd */ .ok)((() => {
        updateResult({
          fetching: !1
        });
      }))(e));
      if (!n) {
        updateResult({
          fetching: !0
        });
      }
      return () => {
        t.dispose(r.key);
        a.unsubscribe();
      };
    } else {
      updateResult({
        fetching: !1
      });
    }
  }), [ t, h[0], h[2][1] ]);
  var q = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((u => {
    var i = {
      requestPolicy: e.requestPolicy,
      ...e.context,
      ...u
    };
    x((e => [ n ? (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .onPush */ .Mq)((e => {
      t.set(a.key, e);
    }))(r.executeQuery(a, i)) : r.executeQuery(a, i), e[1], y ]));
  }), [ r, t, a, n, p, e.requestPolicy, e.context ]);
  return [ g, q ];
}

function useSubscription(e, r) {
  var t = useClient();
  var n = useRequest(e.query, e.variables);
  var c = a(r);
  c.current = r;
  var f = s((() => !e.pause ? t.executeSubscription(n, e.context) : null), [ t, n, e.pause, e.context ]);
  var l = [ t, n, e.context, e.pause ];
  var [p, y] = u((() => [ f, {
    ...b,
    fetching: !!f
  }, l ]));
  var h = p[1];
  if (f !== p[0] && hasDepsChanged(p[2], l)) {
    y([ f, h = computeNextState(p[1], {
      fetching: !!f
    }), l ]);
  }
  o((() => {
    var updateResult = e => {
      y((r => {
        var t = computeNextState(r[1], e);
        if (r[1] === t) {
          return r;
        }
        if (c.current && r[1].data !== t.data) {
          t.data = c.current(r[1].data, t.data);
        }
        return [ r[0], t, r[2] ];
      }));
    };
    if (p[0]) {
      return v(updateResult)(d((() => {
        updateResult({
          fetching: !!f
        });
      }))(p[0])).unsubscribe;
    } else {
      updateResult({
        fetching: !1
      });
    }
  }), [ p[0] ]);
  var x = i((r => {
    var a = t.executeSubscription(n, {
      ...e.context,
      ...r
    });
    y((e => [ a, e[1], l ]));
  }), [ t, e.context, n ]);
  return [ h, x ];
}

function Mutation(e) {
  var r = useMutation(e.query);
  return e.children({
    ...r[0],
    executeMutation: r[1]
  });
}

function Query(e) {
  var r = useQuery(e);
  return e.children({
    ...r[0],
    executeQuery: r[1]
  });
}

function Subscription(e) {
  var r = useSubscription(e, e.handler);
  return e.children({
    ...r[0],
    executeSubscription: r[1]
  });
}


//# sourceMappingURL=urql.es.js.map


/***/ }),

/***/ 20452:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var e=__webpack_require__(2784);function h(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var k="function"===typeof Object.is?Object.is:h,l=e.useState,m=e.useEffect,n=e.useLayoutEffect,p=e.useDebugValue;function q(a,b){var d=b(),f=l({inst:{value:d,getSnapshot:b}}),c=f[0].inst,g=f[1];n(function(){c.value=d;c.getSnapshot=b;r(c)&&g({inst:c})},[a,d,b]);m(function(){r(c)&&g({inst:c});return a(function(){r(c)&&g({inst:c})})},[a]);p(d);return d}
function r(a){var b=a.getSnapshot;a=a.value;try{var d=b();return!k(a,d)}catch(f){return!0}}function t(a,b){return b()}var u="undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement?t:q;exports.useSyncExternalStore=void 0!==e.useSyncExternalStore?e.useSyncExternalStore:u;


/***/ }),

/***/ 80402:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var h=__webpack_require__(2784),n=__webpack_require__(43100);function p(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var q="function"===typeof Object.is?Object.is:p,r=n.useSyncExternalStore,t=h.useRef,u=h.useEffect,v=h.useMemo,w=h.useDebugValue;
exports.useSyncExternalStoreWithSelector=function(a,b,e,l,g){var c=t(null);if(null===c.current){var f={hasValue:!1,value:null};c.current=f}else f=c.current;c=v(function(){function a(a){if(!c){c=!0;d=a;a=l(a);if(void 0!==g&&f.hasValue){var b=f.value;if(g(b,a))return k=b}return k=a}b=k;if(q(d,a))return b;var e=l(a);if(void 0!==g&&g(b,e))return b;d=a;return k=e}var c=!1,d,k,m=void 0===e?null:e;return[function(){return a(b())},null===m?void 0:function(){return a(m())}]},[b,e,l,g]);var d=r(a,c[0],c[1]);
u(function(){f.hasValue=!0;f.value=d},[d]);w(d);return d};


/***/ }),

/***/ 43100:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(20452);
} else {}


/***/ }),

/***/ 41110:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(80402);
} else {}


/***/ }),

/***/ 53260:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 77028:
/***/ (function(module) {

function _extends() {
  return module.exports = _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _extends.apply(null, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 71600:
/***/ (function(module) {

function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 15538:
/***/ (function(module) {

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 67425:
/***/ (function(module) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports, _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 7109:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = newDateUTC;

/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */
function newDateUTC(fullYear, month, day, hour, minute, second, millisecond) {
  var utcDate = new Date(0);
  utcDate.setUTCFullYear(fullYear, month, day);
  utcDate.setUTCHours(hour, minute, second, millisecond);
  return utcDate;
}

module.exports = exports.default;

/***/ }),

/***/ 47494:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = tzIntlTimeZoneName;

/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */
function tzIntlTimeZoneName(length, date, options) {
  var dtf = getDTF(length, options.timeZone, options.locale);
  return dtf.formatToParts ? partsTimeZone(dtf, date) : hackyTimeZone(dtf, date);
}

function partsTimeZone(dtf, date) {
  var formatted = dtf.formatToParts(date);

  for (var i = formatted.length - 1; i >= 0; --i) {
    if (formatted[i].type === 'timeZoneName') {
      return formatted[i].value;
    }
  }
}

function hackyTimeZone(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, '');
  var tzNameMatch = / [\w-+ ]+$/.exec(formatted);
  return tzNameMatch ? tzNameMatch[0].substr(1) : '';
} // If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.


function getDTF(length, timeZone, locale) {
  if (locale && !locale.code) {
    throw new Error("date-fns-tz error: Please set a language code on the locale object imported from date-fns, e.g. `locale.code = 'en-US'`");
  }

  return new Intl.DateTimeFormat(locale ? [locale.code, 'en-US'] : undefined, {
    timeZone: timeZone,
    timeZoneName: length
  });
}

module.exports = exports.default;

/***/ }),

/***/ 14842:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = tzParseTimezone;

var _index = _interopRequireDefault(__webpack_require__(7327));

var _index2 = _interopRequireDefault(__webpack_require__(7109));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var patterns = {
  timezone: /([Z+-].*)$/,
  timezoneZ: /^(Z)$/,
  timezoneHH: /^([+-]\d{2})$/,
  timezoneHHMM: /^([+-]\d{2}):?(\d{2})$/
}; // Parse various time zone offset formats to an offset in milliseconds

function tzParseTimezone(timezoneString, date, isUtcDate) {
  var token;
  var absoluteOffset; // Empty string

  if (!timezoneString) {
    return 0;
  } // Z


  token = patterns.timezoneZ.exec(timezoneString);

  if (token) {
    return 0;
  }

  var hours; // ±hh

  token = patterns.timezoneHH.exec(timezoneString);

  if (token) {
    hours = parseInt(token[1], 10);

    if (!validateTimezone(hours)) {
      return NaN;
    }

    return -(hours * MILLISECONDS_IN_HOUR);
  } // ±hh:mm or ±hhmm


  token = patterns.timezoneHHMM.exec(timezoneString);

  if (token) {
    hours = parseInt(token[1], 10);
    var minutes = parseInt(token[2], 10);

    if (!validateTimezone(hours, minutes)) {
      return NaN;
    }

    absoluteOffset = Math.abs(hours) * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
    return hours > 0 ? -absoluteOffset : absoluteOffset;
  } // IANA time zone


  if (isValidTimezoneIANAString(timezoneString)) {
    date = new Date(date || Date.now());
    var utcDate = isUtcDate ? date : toUtcDate(date);
    var offset = calcOffset(utcDate, timezoneString);
    var fixedOffset = isUtcDate ? offset : fixOffset(date, offset, timezoneString);
    return -fixedOffset;
  }

  return NaN;
}

function toUtcDate(date) {
  return (0, _index2.default)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}

function calcOffset(date, timezoneString) {
  var tokens = (0, _index.default)(date, timezoneString); // ms dropped because it's not provided by tzTokenizeDate

  var asUTC = (0, _index2.default)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
  var asTS = date.getTime();
  var over = asTS % 1000;
  asTS -= over >= 0 ? over : 1000 + over;
  return asUTC - asTS;
}

function fixOffset(date, offset, timezoneString) {
  var localTS = date.getTime(); // Our UTC time is just a guess because our offset is just a guess

  var utcGuess = localTS - offset; // Test whether the zone matches the offset for this ts

  var o2 = calcOffset(new Date(utcGuess), timezoneString); // If so, offset didn't change, and we're done

  if (offset === o2) {
    return offset;
  } // If not, change the ts by the difference in the offset


  utcGuess -= o2 - offset; // If that gives us the local time we want, we're done

  var o3 = calcOffset(new Date(utcGuess), timezoneString);

  if (o2 === o3) {
    return o2;
  } // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time


  return Math.max(o2, o3);
}

function validateTimezone(hours, minutes) {
  return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}

var validIANATimezoneCache = {};

function isValidTimezoneIANAString(timeZoneString) {
  if (validIANATimezoneCache[timeZoneString]) return true;

  try {
    new Intl.DateTimeFormat(undefined, {
      timeZone: timeZoneString
    });
    validIANATimezoneCache[timeZoneString] = true;
    return true;
  } catch (error) {
    return false;
  }
}

module.exports = exports.default;

/***/ }),

/***/ 83439:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

/** Regex to identify the presence of a time zone specifier in a date string */
var tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;
var _default = tzPattern;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 7327:
/***/ (function(module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = tzTokenizeDate;

/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */
function tzTokenizeDate(date, timeZone) {
  var dtf = getDateTimeFormat(timeZone);
  return dtf.formatToParts ? partsOffset(dtf, date) : hackyOffset(dtf, date);
}

var typeToPos = {
  year: 0,
  month: 1,
  day: 2,
  hour: 3,
  minute: 4,
  second: 5
};

function partsOffset(dtf, date) {
  try {
    var formatted = dtf.formatToParts(date);
    var filled = [];

    for (var i = 0; i < formatted.length; i++) {
      var pos = typeToPos[formatted[i].type];

      if (pos >= 0) {
        filled[pos] = parseInt(formatted[i].value, 10);
      }
    }

    return filled;
  } catch (error) {
    if (error instanceof RangeError) {
      return [NaN];
    }

    throw error;
  }
}

function hackyOffset(dtf, date) {
  var formatted = dtf.format(date).replace(/\u200E/g, '');
  var parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted); // var [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
  // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]

  return [parsed[3], parsed[1], parsed[2], parsed[4], parsed[5], parsed[6]];
} // Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.


var dtfCache = {};

function getDateTimeFormat(timeZone) {
  if (!dtfCache[timeZone]) {
    // New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
    var testDateFormatted = new Intl.DateTimeFormat('en-US', {
      hour12: false,
      timeZone: 'America/New_York',
      year: 'numeric',
      month: 'numeric',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }).format(new Date('2014-06-25T04:00:00.123Z'));
    var hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === '‎06‎/‎25‎/‎2014‎ ‎00‎:‎00‎:‎00';
    dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
      hour12: false,
      timeZone: timeZone,
      year: 'numeric',
      month: 'numeric',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    }) : new Intl.DateTimeFormat('en-US', {
      hourCycle: 'h23',
      timeZone: timeZone,
      year: 'numeric',
      month: 'numeric',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit'
    });
  }

  return dtfCache[timeZone];
}

module.exports = exports.default;

/***/ }),

/***/ 50861:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = void 0;

var _index = _interopRequireDefault(__webpack_require__(47494));

var _index2 = _interopRequireDefault(__webpack_require__(14842));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_MINUTE = 60 * 1000;
var formatters = {
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, localize, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date);

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimeter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, localize, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date);

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimeter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimeter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimeter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, localize, options) {
    var timezoneOffset = getTimeZoneOffset(options.timeZone, options._originalDate || date);

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, localize, options) {
    var originalDate = options._originalDate || date;

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return (0, _index.default)('short', originalDate, options);
      // Long

      case 'zzzz':
      default:
        return (0, _index.default)('long', originalDate, options);
    }
  }
};

function getTimeZoneOffset(timeZone, originalDate) {
  var timeZoneOffset = timeZone ? (0, _index2.default)(timeZone, originalDate, true) / MILLISECONDS_IN_MINUTE : originalDate.getTimezoneOffset();

  if (Number.isNaN(timeZoneOffset)) {
    throw new RangeError('Invalid time zone specified: ' + timeZone);
  }

  return timeZoneOffset;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

function formatTimezone(offset, dirtyDelimeter) {
  var delimeter = dirtyDelimeter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(Math.floor(absOffset % 60), 2);
  return sign + hours + delimeter + minutes;
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimeter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimeter);
}

function formatTimezoneShort(offset, dirtyDelimeter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimeter = dirtyDelimeter || '';
  return sign + String(hours) + delimeter + addLeadingZeros(minutes, 2);
}

var _default = formatters;
exports["default"] = _default;
module.exports = exports.default;

/***/ }),

/***/ 18422:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = format;

var _index = _interopRequireDefault(__webpack_require__(55695));

var _index2 = _interopRequireDefault(__webpack_require__(50861));

var _index3 = _interopRequireDefault(__webpack_require__(93629));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 8     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 8     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aaa  | AM, PM                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | PDT, EST, CEST                    | 6     |
 * |                                 | zzzz    | Pacific Daylight Time             | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 05/29/1453                        | 7     |
 * |                                 | PP      | May 29, 1453                      | 7     |
 * |                                 | PPP     | May 29th, 1453                    | 7     |
 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are created using the Intl browser API. The output is determined by the
 *    preferred standard of the current locale (en-US by default) which may not always give the expected result.
 *    For this reason it is recommended to supply a `locale` in the format options when formatting a time zone name.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. These tokens are often confused with others. See: https://git.io/fxCyr
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole
 *   library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard
 *   #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table). See [this
 *   post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link
 *   https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See
 *   [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens
 *   (`yy`, `yyyy`). See: https://git.io/fxCyr
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.awareOfUnicodeTokens` must be set to `true` to use `XX` token; see:
 *   https://git.io/fxCyr
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var matches = formatStr.match(tzFormattingTokensRegExp);

  if (matches) {
    var date = (0, _index3.default)(dirtyDate, options); // Work through each match and replace the tz token in the format string with the quoted
    // formatted time zone so the remaining tokens can be filled in by date-fns#format.

    formatStr = matches.reduce(function (result, token) {
      if (token[0] === "'") {
        return result; // This is a quoted portion, matched only to ensure we don't match inside it
      }

      var pos = result.indexOf(token);
      var precededByQuotedSection = result[pos - 1] === "'";
      var replaced = result.replace(token, "'" + _index2.default[token[0]](date, token, null, options) + "'"); // If the replacement results in two adjoining quoted strings, the back to back quotes
      // are removed, so it doesn't look like an escaped quote.

      return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
    }, formatStr);
  }

  return (0, _index.default)(dirtyDate, formatStr, options);
}

module.exports = exports.default;

/***/ }),

/***/ 49553:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = formatInTimeZone;

var _index = _interopRequireDefault(__webpack_require__(98041));

var _index2 = _interopRequireDefault(__webpack_require__(18422));

var _index3 = _interopRequireDefault(__webpack_require__(19299));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name formatInTimeZone
 * @category Time Zone Helpers
 * @summary Gets the offset in milliseconds between the time zone and Universal Coordinated Time (UTC)
 *
 * @param {Date|String|Number} date - the date representing the local time / real UTC time
 * @param {String} timeZone - the time zone this date should be formatted for; can be an offset or IANA time zone
 * @param {String} formatStr - the string of tokens
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link
 *   https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See
 *   [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens
 *   (`yy`, `yyyy`). See: https://git.io/fxCyr
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @returns {String} the formatted date string
 */
function formatInTimeZone(date, timeZone, formatStr, options) {
  var extendedOptions = (0, _index.default)(options);
  extendedOptions.timeZone = timeZone;
  return (0, _index2.default)((0, _index3.default)(date, timeZone), formatStr, extendedOptions);
}

module.exports = exports.default;

/***/ }),

/***/ 55238:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = getTimezoneOffset;

var _index = _interopRequireDefault(__webpack_require__(14842));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name getTimezoneOffset
 * @category Time Zone Helpers
 * @summary Gets the offset in milliseconds between the time zone and Universal Coordinated Time (UTC)
 *
 * @description
 * Returns the time zone offset from UTC time in milliseconds for IANA time zones as well
 * as other time zone offset string formats.
 *
 * For time zones where daylight savings time is applicable a `Date` should be passed on
 * the second parameter to ensure the offset correctly accounts for DST at that time of
 * year. When omitted, the current date is used.
 *
 * @param {String} timeZone - the time zone of this local time, can be an offset or IANA time zone
 * @param {Date|Number} [date] - the date with values representing the local time
 * @returns {Number} the time zone offset in milliseconds
 *
 * @example
 * const result = getTimezoneOffset('-07:00')
 *   //=> -18000000 (-7 * 60 * 60 * 1000)
 * const result = getTimezoneOffset('Africa/Johannesburg')
 *   //=> 7200000 (2 * 60 * 60 * 1000)
 * const result = getTimezoneOffset('America/New_York', new Date(2016, 0, 1))
 *   //=> -18000000 (-5 * 60 * 60 * 1000)
 * const result = getTimezoneOffset('America/New_York', new Date(2016, 6, 1))
 *   //=> -14400000 (-4 * 60 * 60 * 1000)
 */
function getTimezoneOffset(timeZone, date) {
  return -(0, _index.default)(timeZone, date);
}

module.exports = exports.default;

/***/ }),

/***/ 22601:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


// This file is generated automatically by `scripts/build/indices.js`. Please, don't change it.
module.exports = {
  format: __webpack_require__(18422),
  formatInTimeZone: __webpack_require__(49553),
  getTimezoneOffset: __webpack_require__(55238),
  toDate: __webpack_require__(93629),
  utcToZonedTime: __webpack_require__(19299),
  zonedTimeToUtc: __webpack_require__(437)
};

/***/ }),

/***/ 93629:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = toDate;

var _index = _interopRequireDefault(__webpack_require__(65862));

var _index2 = _interopRequireDefault(__webpack_require__(4261));

var _index3 = _interopRequireDefault(__webpack_require__(14842));

var _index4 = _interopRequireDefault(__webpack_require__(83439));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
  dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
  datePattern: /^([0-9W+-]+)(.*)/,
  plainTime: /:/,
  // year tokens
  YY: /^(\d{2})$/,
  YYY: [/^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
  ],
  YYYY: /^(\d{4})/,
  YYYYY: [/^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
  ],
  // date tokens
  MM: /^-(\d{2})$/,
  DDD: /^-?(\d{3})$/,
  MMDD: /^-?(\d{2})-?(\d{2})$/,
  Www: /^-?W(\d{2})$/,
  WwwD: /^-?W(\d{2})-?(\d{1})$/,
  HH: /^(\d{2}([.,]\d*)?)$/,
  HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
  HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
  // time zone tokens (to identify the presence of a tz)
  timeZone: _index4.default
};
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 * If the function cannot parse the string or the values are invalid, it returns Invalid Date.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = toDate('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = toDate('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */

function toDate(argument, dirtyOptions) {
  if (arguments.length < 1) {
    throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
  }

  if (argument === null) {
    return new Date(NaN);
  }

  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : (0, _index.default)(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  } // Clone the date


  if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') {
    return new Date(argument);
  } else if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var parseYearResult = parseYear(dateStrings.date, additionalDigits);
  var year = parseYearResult.year;
  var restDateString = parseYearResult.restDateString;
  var date = parseDate(restDateString, year);

  if (isNaN(date)) {
    return new Date(NaN);
  }

  if (date) {
    var timestamp = date.getTime();
    var time = 0;
    var offset;

    if (dateStrings.time) {
      time = parseTime(dateStrings.time);

      if (isNaN(time)) {
        return new Date(NaN);
      }
    }

    if (dateStrings.timeZone || options.timeZone) {
      offset = (0, _index3.default)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));

      if (isNaN(offset)) {
        return new Date(NaN);
      }
    } else {
      // get offset accurate to hour in time zones that change offset
      offset = (0, _index2.default)(new Date(timestamp + time));
      offset = (0, _index2.default)(new Date(timestamp + time + offset));
    }

    return new Date(timestamp + time + offset);
  } else {
    return new Date(NaN);
  }
}

function splitDateString(dateString) {
  var dateStrings = {};
  var parts = patterns.dateTimePattern.exec(dateString);
  var timeString;

  if (!parts) {
    parts = patterns.datePattern.exec(dateString);

    if (parts) {
      dateStrings.date = parts[1];
      timeString = parts[2];
    } else {
      dateStrings.date = null;
      timeString = dateString;
    }
  } else {
    dateStrings.date = parts[1];
    timeString = parts[3];
  }

  if (timeString) {
    var token = patterns.timeZone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timeZone = token[1].trim();
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var patternYYY = patterns.YYY[additionalDigits];
  var patternYYYYY = patterns.YYYYY[additionalDigits];
  var token; // YYYY or ±YYYYY

  token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);

  if (token) {
    var yearString = token[1];
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    };
  } // YY or ±YYY


  token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);

  if (token) {
    var centuryString = token[1];
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    };
  } // Invalid ISO-formatted year


  return {
    year: null
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null;
  }

  var token;
  var date;
  var month;
  var week; // YYYY

  if (dateString.length === 0) {
    date = new Date(0);
    date.setUTCFullYear(year);
    return date;
  } // YYYY-MM


  token = patterns.MM.exec(dateString);

  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;

    if (!validateDate(year, month)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month);
    return date;
  } // YYYY-DDD or YYYYDDD


  token = patterns.DDD.exec(dateString);

  if (token) {
    date = new Date(0);
    var dayOfYear = parseInt(token[1], 10);

    if (!validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, 0, dayOfYear);
    return date;
  } // yyyy-MM-dd or YYYYMMDD


  token = patterns.MMDD.exec(dateString);

  if (token) {
    date = new Date(0);
    month = parseInt(token[1], 10) - 1;
    var day = parseInt(token[2], 10);

    if (!validateDate(year, month, day)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, day);
    return date;
  } // YYYY-Www or YYYYWww


  token = patterns.Www.exec(dateString);

  if (token) {
    week = parseInt(token[1], 10) - 1;

    if (!validateWeekDate(year, week)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week);
  } // YYYY-Www-D or YYYYWwwD


  token = patterns.WwwD.exec(dateString);

  if (token) {
    week = parseInt(token[1], 10) - 1;
    var dayOfWeek = parseInt(token[2], 10) - 1;

    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } // Invalid ISO-formatted date


  return null;
}

function parseTime(timeString) {
  var token;
  var hours;
  var minutes; // hh

  token = patterns.HH.exec(timeString);

  if (token) {
    hours = parseFloat(token[1].replace(',', '.'));

    if (!validateTime(hours)) {
      return NaN;
    }

    return hours % 24 * MILLISECONDS_IN_HOUR;
  } // hh:mm or hhmm


  token = patterns.HHMM.exec(timeString);

  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseFloat(token[2].replace(',', '.'));

    if (!validateTime(hours, minutes)) {
      return NaN;
    }

    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
  } // hh:mm:ss or hhmmss


  token = patterns.HHMMSS.exec(timeString);

  if (token) {
    hours = parseInt(token[1], 10);
    minutes = parseInt(token[2], 10);
    var seconds = parseFloat(token[3].replace(',', '.'));

    if (!validateTime(hours, minutes, seconds)) {
      return NaN;
    }

    return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
  } // Invalid ISO-formatted time


  return null;
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  week = week || 0;
  day = day || 0;
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions


var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

function validateDate(year, month, date) {
  if (month < 0 || month > 11) {
    return false;
  }

  if (date != null) {
    if (date < 1) {
      return false;
    }

    var isLeapYear = isLeapYearIndex(year);

    if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) {
      return false;
    }

    if (!isLeapYear && date > DAYS_IN_MONTH[month]) {
      return false;
    }
  }

  return true;
}

function validateDayOfYearDate(year, dayOfYear) {
  if (dayOfYear < 1) {
    return false;
  }

  var isLeapYear = isLeapYearIndex(year);

  if (isLeapYear && dayOfYear > 366) {
    return false;
  }

  if (!isLeapYear && dayOfYear > 365) {
    return false;
  }

  return true;
}

function validateWeekDate(year, week, day) {
  if (week < 0 || week > 52) {
    return false;
  }

  if (day != null && (day < 0 || day > 6)) {
    return false;
  }

  return true;
}

function validateTime(hours, minutes, seconds) {
  if (hours != null && (hours < 0 || hours >= 25)) {
    return false;
  }

  if (minutes != null && (minutes < 0 || minutes >= 60)) {
    return false;
  }

  if (seconds != null && (seconds < 0 || seconds >= 60)) {
    return false;
  }

  return true;
}

module.exports = exports.default;

/***/ }),

/***/ 19299:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = utcToZonedTime;

var _index = _interopRequireDefault(__webpack_require__(14842));

var _index2 = _interopRequireDefault(__webpack_require__(93629));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name utcToZonedTime
 * @category Time Zone Helpers
 * @summary Get a date/time representing local time in a given time zone from the UTC date
 *
 * @description
 * Returns a date instance with values representing the local time in the time zone
 * specified of the UTC time from the date provided. In other words, when the new date
 * is formatted it will show the equivalent hours in the target time zone regardless
 * of the current system time zone.
 *
 * @param {Date|String|Number} date - the date with the relevant UTC time
 * @param {String} timeZone - the time zone to get local time for, can be an offset or IANA time zone
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the equivalent time in the time zone
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // In June 10am UTC is 6am in New York (-04:00)
 * const result = utcToZonedTime('2014-06-25T10:00:00.000Z', 'America/New_York')
 * //=> Jun 25 2014 06:00:00
 */
function utcToZonedTime(dirtyDate, timeZone, options) {
  var date = (0, _index2.default)(dirtyDate, options);
  var offsetMilliseconds = (0, _index.default)(timeZone, date, true);
  var d = new Date(date.getTime() - offsetMilliseconds);
  var resultDate = new Date(0);
  resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
  resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
  return resultDate;
}

module.exports = exports.default;

/***/ }),

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports["default"] = zonedTimeToUtc;

var _index = _interopRequireDefault(__webpack_require__(98041));

var _index2 = _interopRequireDefault(__webpack_require__(93629));

var _index3 = _interopRequireDefault(__webpack_require__(83439));

var _index4 = _interopRequireDefault(__webpack_require__(14842));

var _index5 = _interopRequireDefault(__webpack_require__(7109));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name zonedTimeToUtc
 * @category Time Zone Helpers
 * @summary Get the UTC date/time from a date representing local time in a given time zone
 *
 * @description
 * Returns a date instance with the UTC time of the provided date of which the values
 * represented the local time in the time zone specified. In other words, if the input
 * date represented local time in time time zone, the timestamp of the output date will
 * give the equivalent UTC of that local time regardless of the current system time zone.
 *
 * @param {Date|String|Number} date - the date with values representing the local time
 * @param {String} timeZone - the time zone of this local time, can be an offset or IANA time zone
 * @param {OptionsWithTZ} [options] - the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @returns {Date} the new date with the equivalent time in the time zone
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // In June 10am in Los Angeles is 5pm UTC
 * const result = zonedTimeToUtc(new Date(2014, 5, 25, 10, 0, 0), 'America/Los_Angeles')
 * //=> 2014-06-25T17:00:00.000Z
 */
function zonedTimeToUtc(date, timeZone, options) {
  if (typeof date === 'string' && !date.match(_index3.default)) {
    var extendedOptions = (0, _index.default)(options);
    extendedOptions.timeZone = timeZone;
    return (0, _index2.default)(date, extendedOptions);
  }

  var d = (0, _index2.default)(date, options);
  var utc = (0, _index5.default)(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours(), d.getMinutes(), d.getSeconds(), d.getMilliseconds()).getTime();
  var offsetMilliseconds = (0, _index4.default)(timeZone, new Date(utc));
  return new Date(utc + offsetMilliseconds);
}

module.exports = exports.default;

/***/ }),

/***/ 80753:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}


/***/ }),

/***/ 87371:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32802);

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}


/***/ }),

/***/ 56666:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
/* harmony import */ var _toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(32802);

function _defineProperty(e, r, t) {
  return (r = (0,_toPropertyKey_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}


/***/ }),

/***/ 7896:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}


/***/ }),

/***/ 95058:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}


/***/ }),

/***/ 70352:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _isNativeReflectConstruct; }
/* harmony export */ });
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}


/***/ }),

/***/ 31461:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}


/***/ }),

/***/ 88960:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}


/***/ }),

/***/ 32802:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ toPropertyKey; }
});

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function toPrimitive(t, r) {
  if ("object" != (0,esm_typeof/* default */.Z)(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != (0,esm_typeof/* default */.Z)(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

;// CONCATENATED MODULE: ../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == (0,esm_typeof/* default */.Z)(i) ? i : i + "";
}


/***/ }),

/***/ 86522:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}


/***/ }),

/***/ 30630:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 98788:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _asyncToGenerator; }
/* harmony export */ });
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}


/***/ }),

/***/ 90581:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ 47842:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}


/***/ }),

/***/ 42838:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _instanceof; }
/* harmony export */ });
function _instanceof(left, right) {
  if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
    return !!right[Symbol.hasInstance](left);
  } else {
    return left instanceof right;
  }
}

/***/ }),

/***/ 33579:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 70865:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpread; }
/* harmony export */ });
/* harmony import */ var _define_property_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47842);


function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      (0,_define_property_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]);
    });
  }

  return target;
}

/***/ }),

/***/ 96670:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectSpreadProps; }
/* harmony export */ });
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}

function _objectSpreadProps(target, source) {
  source = source != null ? source : {}
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(
        target,
        key,
        Object.getOwnPropertyDescriptor(source, key)
      );
    });
  }

  return target;
}

/***/ }),

/***/ 66383:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _slicedToArray; }
});

;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_array_with_holes.mjs
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(33579);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_non_iterable_rest.mjs
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(15459);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs





function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr, i) || (0,_unsupported_iterable_to_array/* default */.Z)(arr, i) || _nonIterableRest();
}


/***/ }),

/***/ 50930:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(30630);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(33579);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(15459);
;// CONCATENATED MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 15459:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(30630);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ }),

/***/ 85289:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ focusManager; }
/* harmony export */ });
/* unused harmony export FocusManager */
/* harmony import */ var _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22436);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36370);



class FocusManager extends _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Subscribable */ .l {
  constructor() {
    super();

    this.setup = onFocus => {
      // addEventListener does not exist in React Native, but window does
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && window.addEventListener) {
        const listener = () => onFocus(); // Listen to visibillitychange and focus


        window.addEventListener('visibilitychange', listener, false);
        window.addEventListener('focus', listener, false);
        return () => {
          // Be sure to unsubscribe if a new handler is set
          window.removeEventListener('visibilitychange', listener);
          window.removeEventListener('focus', listener);
        };
      }

      return;
    };
  }

  onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  }

  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  }

  setEventListener(setup) {
    var _this$cleanup2;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(focused => {
      if (typeof focused === 'boolean') {
        this.setFocused(focused);
      } else {
        this.onFocus();
      }
    });
  }

  setFocused(focused) {
    const changed = this.focused !== focused;

    if (changed) {
      this.focused = focused;
      this.onFocus();
    }
  }

  onFocus() {
    this.listeners.forEach(({
      listener
    }) => {
      listener();
    });
  }

  isFocused() {
    if (typeof this.focused === 'boolean') {
      return this.focused;
    } // document global can be unavailable in react native


    if (typeof document === 'undefined') {
      return true;
    }

    return [undefined, 'visible', 'prerender'].includes(document.visibilityState);
  }

}
const focusManager = new FocusManager();


//# sourceMappingURL=focusManager.mjs.map


/***/ }),

/***/ 714:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ defaultLogger; }
/* harmony export */ });
const defaultLogger = console;


//# sourceMappingURL=logger.mjs.map


/***/ }),

/***/ 96278:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ getDefaultState; },
/* harmony export */   "m": function() { return /* binding */ Mutation; }
/* harmony export */ });
/* harmony import */ var _logger_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(714);
/* harmony import */ var _notifyManager_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3709);
/* harmony import */ var _removable_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(53429);
/* harmony import */ var _retryer_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3241);





// CLASS
class Mutation extends _removable_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Removable */ .F {
  constructor(config) {
    super();
    this.defaultOptions = config.defaultOptions;
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.logger = config.logger || _logger_mjs__WEBPACK_IMPORTED_MODULE_1__/* .defaultLogger */ ._;
    this.observers = [];
    this.state = config.state || getDefaultState();
    this.setOptions(config.options);
    this.scheduleGc();
  }

  setOptions(options) {
    this.options = { ...this.defaultOptions,
      ...options
    };
    this.updateCacheTime(this.options.cacheTime);
  }

  get meta() {
    return this.options.meta;
  }

  setState(state) {
    this.dispatch({
      type: 'setState',
      state
    });
  }

  addObserver(observer) {
    if (!this.observers.includes(observer)) {
      this.observers.push(observer); // Stop the mutation from being garbage collected

      this.clearGcTimeout();
      this.mutationCache.notify({
        type: 'observerAdded',
        mutation: this,
        observer
      });
    }
  }

  removeObserver(observer) {
    this.observers = this.observers.filter(x => x !== observer);
    this.scheduleGc();
    this.mutationCache.notify({
      type: 'observerRemoved',
      mutation: this,
      observer
    });
  }

  optionalRemove() {
    if (!this.observers.length) {
      if (this.state.status === 'loading') {
        this.scheduleGc();
      } else {
        this.mutationCache.remove(this);
      }
    }
  }

  continue() {
    var _this$retryer$continu, _this$retryer;

    return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
  }

  async execute() {
    const executeMutation = () => {
      var _this$options$retry;

      this.retryer = (0,_retryer_mjs__WEBPACK_IMPORTED_MODULE_2__/* .createRetryer */ .Mz)({
        fn: () => {
          if (!this.options.mutationFn) {
            return Promise.reject('No mutationFn found');
          }

          return this.options.mutationFn(this.state.variables);
        },
        onFail: (failureCount, error) => {
          this.dispatch({
            type: 'failed',
            failureCount,
            error
          });
        },
        onPause: () => {
          this.dispatch({
            type: 'pause'
          });
        },
        onContinue: () => {
          this.dispatch({
            type: 'continue'
          });
        },
        retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
        retryDelay: this.options.retryDelay,
        networkMode: this.options.networkMode
      });
      return this.retryer.promise;
    };

    const restored = this.state.status === 'loading';

    try {
      var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;

      if (!restored) {
        var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;

        this.dispatch({
          type: 'loading',
          variables: this.options.variables
        }); // Notify cache callback

        await ((_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this));
        const context = await ((_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables));

        if (context !== this.state.context) {
          this.dispatch({
            type: 'loading',
            context,
            variables: this.state.variables
          });
        }
      }

      const data = await executeMutation(); // Notify cache callback

      await ((_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this));
      await ((_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context)); // Notify cache callback

      await ((_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this));
      await ((_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context));
      this.dispatch({
        type: 'success',
        data
      });
      return data;
    } catch (error) {
      try {
        var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;

        // Notify cache callback
        await ((_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this));

        if (false) {}

        await ((_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context)); // Notify cache callback

        await ((_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, undefined, error, this.state.variables, this.state.context, this));
        await ((_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, undefined, error, this.state.variables, this.state.context));
        throw error;
      } finally {
        this.dispatch({
          type: 'error',
          error: error
        });
      }
    }
  }

  dispatch(action) {
    const reducer = state => {
      switch (action.type) {
        case 'failed':
          return { ...state,
            failureCount: action.failureCount,
            failureReason: action.error
          };

        case 'pause':
          return { ...state,
            isPaused: true
          };

        case 'continue':
          return { ...state,
            isPaused: false
          };

        case 'loading':
          return { ...state,
            context: action.context,
            data: undefined,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !(0,_retryer_mjs__WEBPACK_IMPORTED_MODULE_2__/* .canFetch */ .Kw)(this.options.networkMode),
            status: 'loading',
            variables: action.variables
          };

        case 'success':
          return { ...state,
            data: action.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: 'success',
            isPaused: false
          };

        case 'error':
          return { ...state,
            data: undefined,
            error: action.error,
            failureCount: state.failureCount + 1,
            failureReason: action.error,
            isPaused: false,
            status: 'error'
          };

        case 'setState':
          return { ...state,
            ...action.state
          };
      }
    };

    this.state = reducer(this.state);
    _notifyManager_mjs__WEBPACK_IMPORTED_MODULE_3__/* .notifyManager.batch */ .V.batch(() => {
      this.observers.forEach(observer => {
        observer.onMutationUpdate(action);
      });
      this.mutationCache.notify({
        mutation: this,
        type: 'updated',
        action
      });
    });
  }

}
function getDefaultState() {
  return {
    context: undefined,
    data: undefined,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: false,
    status: 'idle',
    variables: undefined
  };
}


//# sourceMappingURL=mutation.mjs.map


/***/ }),

/***/ 3709:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ notifyManager; }
/* harmony export */ });
/* unused harmony export createNotifyManager */
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36370);


function createNotifyManager() {
  let queue = [];
  let transactions = 0;

  let notifyFn = callback => {
    callback();
  };

  let batchNotifyFn = callback => {
    callback();
  };

  const batch = callback => {
    let result;
    transactions++;

    try {
      result = callback();
    } finally {
      transactions--;

      if (!transactions) {
        flush();
      }
    }

    return result;
  };

  const schedule = callback => {
    if (transactions) {
      queue.push(callback);
    } else {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(() => {
        notifyFn(callback);
      });
    }
  };
  /**
   * All calls to the wrapped function will be batched.
   */


  const batchCalls = callback => {
    return (...args) => {
      schedule(() => {
        callback(...args);
      });
    };
  };

  const flush = () => {
    const originalQueue = queue;
    queue = [];

    if (originalQueue.length) {
      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .scheduleMicrotask */ .A4)(() => {
        batchNotifyFn(() => {
          originalQueue.forEach(callback => {
            notifyFn(callback);
          });
        });
      });
    }
  };
  /**
   * Use this method to set a custom notify function.
   * This can be used to for example wrap notifications with `React.act` while running tests.
   */


  const setNotifyFunction = fn => {
    notifyFn = fn;
  };
  /**
   * Use this method to set a custom function to batch notifications together into a single tick.
   * By default React Query will use the batch function provided by ReactDOM or React Native.
   */


  const setBatchNotifyFunction = fn => {
    batchNotifyFn = fn;
  };

  return {
    batch,
    batchCalls,
    schedule,
    setNotifyFunction,
    setBatchNotifyFunction
  };
} // SINGLETON

const notifyManager = createNotifyManager();


//# sourceMappingURL=notifyManager.mjs.map


/***/ }),

/***/ 63240:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ onlineManager; }
/* harmony export */ });
/* unused harmony export OnlineManager */
/* harmony import */ var _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(22436);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36370);



const onlineEvents = ['online', 'offline'];
class OnlineManager extends _subscribable_mjs__WEBPACK_IMPORTED_MODULE_0__/* .Subscribable */ .l {
  constructor() {
    super();

    this.setup = onOnline => {
      // addEventListener does not exist in React Native, but window does
      // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
      if (!_utils_mjs__WEBPACK_IMPORTED_MODULE_1__/* .isServer */ .sk && window.addEventListener) {
        const listener = () => onOnline(); // Listen to online


        onlineEvents.forEach(event => {
          window.addEventListener(event, listener, false);
        });
        return () => {
          // Be sure to unsubscribe if a new handler is set
          onlineEvents.forEach(event => {
            window.removeEventListener(event, listener);
          });
        };
      }

      return;
    };
  }

  onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  }

  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;

      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = undefined;
    }
  }

  setEventListener(setup) {
    var _this$cleanup2;

    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup(online => {
      if (typeof online === 'boolean') {
        this.setOnline(online);
      } else {
        this.onOnline();
      }
    });
  }

  setOnline(online) {
    const changed = this.online !== online;

    if (changed) {
      this.online = online;
      this.onOnline();
    }
  }

  onOnline() {
    this.listeners.forEach(({
      listener
    }) => {
      listener();
    });
  }

  isOnline() {
    if (typeof this.online === 'boolean') {
      return this.online;
    }

    if (typeof navigator === 'undefined' || typeof navigator.onLine === 'undefined') {
      return true;
    }

    return navigator.onLine;
  }

}
const onlineManager = new OnlineManager();


//# sourceMappingURL=onlineManager.mjs.map


/***/ }),

/***/ 57634:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ QueryClient; }
});

// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(36370);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/logger.mjs
var logger = __webpack_require__(714);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(3709);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/retryer.mjs
var retryer = __webpack_require__(3241);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/removable.mjs
var removable = __webpack_require__(53429);
;// CONCATENATED MODULE: ../../node_modules/@tanstack/query-core/build/lib/query.mjs






// CLASS
class Query extends removable/* Removable */.F {
  constructor(config) {
    super();
    this.abortSignalConsumed = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.logger = config.logger || logger/* defaultLogger */._;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || getDefaultState(this.options);
    this.state = this.initialState;
    this.scheduleGc();
  }

  get meta() {
    return this.options.meta;
  }

  setOptions(options) {
    this.options = { ...this.defaultOptions,
      ...options
    };
    this.updateCacheTime(this.options.cacheTime);
  }

  optionalRemove() {
    if (!this.observers.length && this.state.fetchStatus === 'idle') {
      this.cache.remove(this);
    }
  }

  setData(newData, options) {
    const data = (0,utils/* replaceData */.oE)(this.state.data, newData, this.options); // Set data and mark it as cached

    this.dispatch({
      data,
      type: 'success',
      dataUpdatedAt: options == null ? void 0 : options.updatedAt,
      manual: options == null ? void 0 : options.manual
    });
    return data;
  }

  setState(state, setStateOptions) {
    this.dispatch({
      type: 'setState',
      state,
      setStateOptions
    });
  }

  cancel(options) {
    var _this$retryer;

    const promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(utils/* noop */.ZT).catch(utils/* noop */.ZT) : Promise.resolve();
  }

  destroy() {
    super.destroy();
    this.cancel({
      silent: true
    });
  }

  reset() {
    this.destroy();
    this.setState(this.initialState);
  }

  isActive() {
    return this.observers.some(observer => observer.options.enabled !== false);
  }

  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }

  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some(observer => observer.getCurrentResult().isStale);
  }

  isStaleByTime(staleTime = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !(0,utils/* timeUntilStale */.Kp)(this.state.dataUpdatedAt, staleTime);
  }

  onFocus() {
    var _this$retryer2;

    const observer = this.observers.find(x => x.shouldFetchOnWindowFocus());

    if (observer) {
      observer.refetch({
        cancelRefetch: false
      });
    } // Continue fetch if currently paused


    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  }

  onOnline() {
    var _this$retryer3;

    const observer = this.observers.find(x => x.shouldFetchOnReconnect());

    if (observer) {
      observer.refetch({
        cancelRefetch: false
      });
    } // Continue fetch if currently paused


    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  }

  addObserver(observer) {
    if (!this.observers.includes(observer)) {
      this.observers.push(observer); // Stop the query from being garbage collected

      this.clearGcTimeout();
      this.cache.notify({
        type: 'observerAdded',
        query: this,
        observer
      });
    }
  }

  removeObserver(observer) {
    if (this.observers.includes(observer)) {
      this.observers = this.observers.filter(x => x !== observer);

      if (!this.observers.length) {
        // If the transport layer does not support cancellation
        // we'll let the query continue so the result can be cached
        if (this.retryer) {
          if (this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }

        this.scheduleGc();
      }

      this.cache.notify({
        type: 'observerRemoved',
        query: this,
        observer
      });
    }
  }

  getObserversCount() {
    return this.observers.length;
  }

  invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: 'invalidate'
      });
    }
  }

  fetch(options, fetchOptions) {
    var _this$options$behavio, _context$fetchOptions;

    if (this.state.fetchStatus !== 'idle') {
      if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) {
        // Silently cancel current fetch if the user wants to cancel refetches
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;

        // make sure that retries that were potentially cancelled due to unmounts can continue
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry(); // Return current promise if we are already fetching

        return this.promise;
      }
    } // Update config if passed, otherwise the config from the last execution is used


    if (options) {
      this.setOptions(options);
    } // Use the options from the first observer with a query function if no function is found.
    // This can happen when the query is hydrated or created with setQueryData.


    if (!this.options.queryFn) {
      const observer = this.observers.find(x => x.options.queryFn);

      if (observer) {
        this.setOptions(observer.options);
      }
    }

    if (!Array.isArray(this.options.queryKey)) {
      if (false) {}
    }

    const abortController = (0,utils/* getAbortController */.G9)(); // Create query function context

    const queryFnContext = {
      queryKey: this.queryKey,
      pageParam: undefined,
      meta: this.meta
    }; // Adds an enumerable signal property to the object that
    // which sets abortSignalConsumed to true when the signal
    // is read.

    const addSignalProperty = object => {
      Object.defineProperty(object, 'signal', {
        enumerable: true,
        get: () => {
          if (abortController) {
            this.abortSignalConsumed = true;
            return abortController.signal;
          }

          return undefined;
        }
      });
    };

    addSignalProperty(queryFnContext); // Create fetch function

    const fetchFn = () => {
      if (!this.options.queryFn) {
        return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
      }

      this.abortSignalConsumed = false;
      return this.options.queryFn(queryFnContext);
    }; // Trigger behavior hook


    const context = {
      fetchOptions,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn
    };
    addSignalProperty(context);
    (_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch(context); // Store state in case the current fetch needs to be reverted

    this.revertState = this.state; // Set to fetching state if not already in it

    if (this.state.fetchStatus === 'idle' || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;

      this.dispatch({
        type: 'fetch',
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    }

    const onError = error => {
      // Optimistically update state if needed
      if (!((0,retryer/* isCancelledError */.DV)(error) && error.silent)) {
        this.dispatch({
          type: 'error',
          error: error
        });
      }

      if (!(0,retryer/* isCancelledError */.DV)(error)) {
        var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;

        // Notify cache callback
        (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null ? void 0 : _this$cache$config$on.call(_this$cache$config, error, this);
        (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null ? void 0 : _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);

        if (false) {}
      }

      if (!this.isFetchingOptimistic) {
        // Schedule query gc after fetching
        this.scheduleGc();
      }

      this.isFetchingOptimistic = false;
    }; // Try to fetch the data


    this.retryer = (0,retryer/* createRetryer */.Mz)({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
      onSuccess: data => {
        var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;

        if (typeof data === 'undefined') {
          if (false) {}

          onError(new Error(this.queryHash + " data is undefined"));
          return;
        }

        this.setData(data); // Notify cache callback

        (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null ? void 0 : _this$cache$config$on3.call(_this$cache$config3, data, this);
        (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null ? void 0 : _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);

        if (!this.isFetchingOptimistic) {
          // Schedule query gc after fetching
          this.scheduleGc();
        }

        this.isFetchingOptimistic = false;
      },
      onError,
      onFail: (failureCount, error) => {
        this.dispatch({
          type: 'failed',
          failureCount,
          error
        });
      },
      onPause: () => {
        this.dispatch({
          type: 'pause'
        });
      },
      onContinue: () => {
        this.dispatch({
          type: 'continue'
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay,
      networkMode: context.options.networkMode
    });
    this.promise = this.retryer.promise;
    return this.promise;
  }

  dispatch(action) {
    const reducer = state => {
      var _action$meta, _action$dataUpdatedAt;

      switch (action.type) {
        case 'failed':
          return { ...state,
            fetchFailureCount: action.failureCount,
            fetchFailureReason: action.error
          };

        case 'pause':
          return { ...state,
            fetchStatus: 'paused'
          };

        case 'continue':
          return { ...state,
            fetchStatus: 'fetching'
          };

        case 'fetch':
          return { ...state,
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
            fetchStatus: (0,retryer/* canFetch */.Kw)(this.options.networkMode) ? 'fetching' : 'paused',
            ...(!state.dataUpdatedAt && {
              error: null,
              status: 'loading'
            })
          };

        case 'success':
          return { ...state,
            data: action.data,
            dataUpdateCount: state.dataUpdateCount + 1,
            dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
            error: null,
            isInvalidated: false,
            status: 'success',
            ...(!action.manual && {
              fetchStatus: 'idle',
              fetchFailureCount: 0,
              fetchFailureReason: null
            })
          };

        case 'error':
          const error = action.error;

          if ((0,retryer/* isCancelledError */.DV)(error) && error.revert && this.revertState) {
            return { ...this.revertState
            };
          }

          return { ...state,
            error: error,
            errorUpdateCount: state.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: state.fetchFailureCount + 1,
            fetchFailureReason: error,
            fetchStatus: 'idle',
            status: 'error'
          };

        case 'invalidate':
          return { ...state,
            isInvalidated: true
          };

        case 'setState':
          return { ...state,
            ...action.state
          };
      }
    };

    this.state = reducer(this.state);
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.observers.forEach(observer => {
        observer.onQueryUpdate(action);
      });
      this.cache.notify({
        query: this,
        type: 'updated',
        action
      });
    });
  }

}

function getDefaultState(options) {
  const data = typeof options.initialData === 'function' ? options.initialData() : options.initialData;
  const hasData = typeof data !== 'undefined';
  const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === 'function' ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
  return {
    data,
    dataUpdateCount: 0,
    dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: false,
    status: hasData ? 'success' : 'loading',
    fetchStatus: 'idle'
  };
}


//# sourceMappingURL=query.mjs.map

// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/subscribable.mjs
var subscribable = __webpack_require__(22436);
;// CONCATENATED MODULE: ../../node_modules/@tanstack/query-core/build/lib/queryCache.mjs





// CLASS
class QueryCache extends subscribable/* Subscribable */.l {
  constructor(config) {
    super();
    this.config = config || {};
    this.queries = [];
    this.queriesMap = {};
  }

  build(client, options, state) {
    var _options$queryHash;

    const queryKey = options.queryKey;
    const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : (0,utils/* hashQueryKeyByOptions */.Rm)(queryKey, options);
    let query = this.get(queryHash);

    if (!query) {
      query = new Query({
        cache: this,
        logger: client.getLogger(),
        queryKey,
        queryHash,
        options: client.defaultQueryOptions(options),
        state,
        defaultOptions: client.getQueryDefaults(queryKey)
      });
      this.add(query);
    }

    return query;
  }

  add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: 'added',
        query
      });
    }
  }

  remove(query) {
    const queryInMap = this.queriesMap[query.queryHash];

    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter(x => x !== query);

      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }

      this.notify({
        type: 'removed',
        query
      });
    }
  }

  clear() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.queries.forEach(query => {
        this.remove(query);
      });
    });
  }

  get(queryHash) {
    return this.queriesMap[queryHash];
  }

  getAll() {
    return this.queries;
  }

  find(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);

    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.queries.find(query => (0,utils/* matchQuery */._x)(filters, query));
  }

  findAll(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);
    return Object.keys(filters).length > 0 ? this.queries.filter(query => (0,utils/* matchQuery */._x)(filters, query)) : this.queries;
  }

  notify(event) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.listeners.forEach(({
        listener
      }) => {
        listener(event);
      });
    });
  }

  onFocus() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.queries.forEach(query => {
        query.onFocus();
      });
    });
  }

  onOnline() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.queries.forEach(query => {
        query.onOnline();
      });
    });
  }

}


//# sourceMappingURL=queryCache.mjs.map

// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/mutation.mjs
var lib_mutation = __webpack_require__(96278);
;// CONCATENATED MODULE: ../../node_modules/@tanstack/query-core/build/lib/mutationCache.mjs





// CLASS
class MutationCache extends subscribable/* Subscribable */.l {
  constructor(config) {
    super();
    this.config = config || {};
    this.mutations = [];
    this.mutationId = 0;
  }

  build(client, options, state) {
    const mutation = new lib_mutation/* Mutation */.m({
      mutationCache: this,
      logger: client.getLogger(),
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : undefined
    });
    this.add(mutation);
    return mutation;
  }

  add(mutation) {
    this.mutations.push(mutation);
    this.notify({
      type: 'added',
      mutation
    });
  }

  remove(mutation) {
    this.mutations = this.mutations.filter(x => x !== mutation);
    this.notify({
      type: 'removed',
      mutation
    });
  }

  clear() {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.mutations.forEach(mutation => {
        this.remove(mutation);
      });
    });
  }

  getAll() {
    return this.mutations;
  }

  find(filters) {
    if (typeof filters.exact === 'undefined') {
      filters.exact = true;
    }

    return this.mutations.find(mutation => (0,utils/* matchMutation */.X7)(filters, mutation));
  }

  findAll(filters) {
    return this.mutations.filter(mutation => (0,utils/* matchMutation */.X7)(filters, mutation));
  }

  notify(event) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      this.listeners.forEach(({
        listener
      }) => {
        listener(event);
      });
    });
  }

  resumePausedMutations() {
    var _this$resuming;

    this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(() => {
      const pausedMutations = this.mutations.filter(x => x.state.isPaused);
      return notifyManager/* notifyManager.batch */.V.batch(() => pausedMutations.reduce((promise, mutation) => promise.then(() => mutation.continue().catch(utils/* noop */.ZT)), Promise.resolve()));
    }).then(() => {
      this.resuming = undefined;
    });
    return this.resuming;
  }

}


//# sourceMappingURL=mutationCache.mjs.map

// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/focusManager.mjs
var focusManager = __webpack_require__(85289);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/onlineManager.mjs
var onlineManager = __webpack_require__(63240);
;// CONCATENATED MODULE: ../../node_modules/@tanstack/query-core/build/lib/infiniteQueryBehavior.mjs
function infiniteQueryBehavior() {
  return {
    onFetch: context => {
      context.fetchFn = () => {
        var _context$fetchOptions, _context$fetchOptions2, _context$fetchOptions3, _context$fetchOptions4, _context$state$data, _context$state$data2;

        const refetchPage = (_context$fetchOptions = context.fetchOptions) == null ? void 0 : (_context$fetchOptions2 = _context$fetchOptions.meta) == null ? void 0 : _context$fetchOptions2.refetchPage;
        const fetchMore = (_context$fetchOptions3 = context.fetchOptions) == null ? void 0 : (_context$fetchOptions4 = _context$fetchOptions3.meta) == null ? void 0 : _context$fetchOptions4.fetchMore;
        const pageParam = fetchMore == null ? void 0 : fetchMore.pageParam;
        const isFetchingNextPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'forward';
        const isFetchingPreviousPage = (fetchMore == null ? void 0 : fetchMore.direction) === 'backward';
        const oldPages = ((_context$state$data = context.state.data) == null ? void 0 : _context$state$data.pages) || [];
        const oldPageParams = ((_context$state$data2 = context.state.data) == null ? void 0 : _context$state$data2.pageParams) || [];
        let newPageParams = oldPageParams;
        let cancelled = false;

        const addSignalProperty = object => {
          Object.defineProperty(object, 'signal', {
            enumerable: true,
            get: () => {
              var _context$signal;

              if ((_context$signal = context.signal) != null && _context$signal.aborted) {
                cancelled = true;
              } else {
                var _context$signal2;

                (_context$signal2 = context.signal) == null ? void 0 : _context$signal2.addEventListener('abort', () => {
                  cancelled = true;
                });
              }

              return context.signal;
            }
          });
        }; // Get query function


        const queryFn = context.options.queryFn || (() => Promise.reject("Missing queryFn for queryKey '" + context.options.queryHash + "'"));

        const buildNewPages = (pages, param, page, previous) => {
          newPageParams = previous ? [param, ...newPageParams] : [...newPageParams, param];
          return previous ? [page, ...pages] : [...pages, page];
        }; // Create function to fetch a page


        const fetchPage = (pages, manual, param, previous) => {
          if (cancelled) {
            return Promise.reject('Cancelled');
          }

          if (typeof param === 'undefined' && !manual && pages.length) {
            return Promise.resolve(pages);
          }

          const queryFnContext = {
            queryKey: context.queryKey,
            pageParam: param,
            meta: context.options.meta
          };
          addSignalProperty(queryFnContext);
          const queryFnResult = queryFn(queryFnContext);
          const promise = Promise.resolve(queryFnResult).then(page => buildNewPages(pages, param, page, previous));
          return promise;
        };

        let promise; // Fetch first page?

        if (!oldPages.length) {
          promise = fetchPage([]);
        } // Fetch next page?
        else if (isFetchingNextPage) {
          const manual = typeof pageParam !== 'undefined';
          const param = manual ? pageParam : getNextPageParam(context.options, oldPages);
          promise = fetchPage(oldPages, manual, param);
        } // Fetch previous page?
        else if (isFetchingPreviousPage) {
          const manual = typeof pageParam !== 'undefined';
          const param = manual ? pageParam : getPreviousPageParam(context.options, oldPages);
          promise = fetchPage(oldPages, manual, param, true);
        } // Refetch pages
        else {
          newPageParams = [];
          const manual = typeof context.options.getNextPageParam === 'undefined';
          const shouldFetchFirstPage = refetchPage && oldPages[0] ? refetchPage(oldPages[0], 0, oldPages) : true; // Fetch first page

          promise = shouldFetchFirstPage ? fetchPage([], manual, oldPageParams[0]) : Promise.resolve(buildNewPages([], oldPageParams[0], oldPages[0])); // Fetch remaining pages

          for (let i = 1; i < oldPages.length; i++) {
            promise = promise.then(pages => {
              const shouldFetchNextPage = refetchPage && oldPages[i] ? refetchPage(oldPages[i], i, oldPages) : true;

              if (shouldFetchNextPage) {
                const param = manual ? oldPageParams[i] : getNextPageParam(context.options, pages);
                return fetchPage(pages, manual, param);
              }

              return Promise.resolve(buildNewPages(pages, oldPageParams[i], oldPages[i]));
            });
          }
        }

        const finalPromise = promise.then(pages => ({
          pages,
          pageParams: newPageParams
        }));
        return finalPromise;
      };
    }
  };
}
function getNextPageParam(options, pages) {
  return options.getNextPageParam == null ? void 0 : options.getNextPageParam(pages[pages.length - 1], pages);
}
function getPreviousPageParam(options, pages) {
  return options.getPreviousPageParam == null ? void 0 : options.getPreviousPageParam(pages[0], pages);
}
/**
 * Checks if there is a next page.
 * Returns `undefined` if it cannot be determined.
 */

function hasNextPage(options, pages) {
  if (options.getNextPageParam && Array.isArray(pages)) {
    const nextPageParam = getNextPageParam(options, pages);
    return typeof nextPageParam !== 'undefined' && nextPageParam !== null && nextPageParam !== false;
  }

  return;
}
/**
 * Checks if there is a previous page.
 * Returns `undefined` if it cannot be determined.
 */

function hasPreviousPage(options, pages) {
  if (options.getPreviousPageParam && Array.isArray(pages)) {
    const previousPageParam = getPreviousPageParam(options, pages);
    return typeof previousPageParam !== 'undefined' && previousPageParam !== null && previousPageParam !== false;
  }

  return;
}


//# sourceMappingURL=infiniteQueryBehavior.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@tanstack/query-core/build/lib/queryClient.mjs









// CLASS
class QueryClient {
  constructor(config = {}) {
    this.queryCache = config.queryCache || new QueryCache();
    this.mutationCache = config.mutationCache || new MutationCache();
    this.logger = config.logger || logger/* defaultLogger */._;
    this.defaultOptions = config.defaultOptions || {};
    this.queryDefaults = [];
    this.mutationDefaults = [];
    this.mountCount = 0;

    if (false) {}
  }

  mount() {
    this.mountCount++;
    if (this.mountCount !== 1) return;
    this.unsubscribeFocus = focusManager/* focusManager.subscribe */.j.subscribe(() => {
      if (focusManager/* focusManager.isFocused */.j.isFocused()) {
        this.resumePausedMutations();
        this.queryCache.onFocus();
      }
    });
    this.unsubscribeOnline = onlineManager/* onlineManager.subscribe */.N.subscribe(() => {
      if (onlineManager/* onlineManager.isOnline */.N.isOnline()) {
        this.resumePausedMutations();
        this.queryCache.onOnline();
      }
    });
  }

  unmount() {
    var _this$unsubscribeFocu, _this$unsubscribeOnli;

    this.mountCount--;
    if (this.mountCount !== 0) return;
    (_this$unsubscribeFocu = this.unsubscribeFocus) == null ? void 0 : _this$unsubscribeFocu.call(this);
    this.unsubscribeFocus = undefined;
    (_this$unsubscribeOnli = this.unsubscribeOnline) == null ? void 0 : _this$unsubscribeOnli.call(this);
    this.unsubscribeOnline = undefined;
  }

  isFetching(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);
    filters.fetchStatus = 'fetching';
    return this.queryCache.findAll(filters).length;
  }

  isMutating(filters) {
    return this.mutationCache.findAll({ ...filters,
      fetching: true
    }).length;
  }

  getQueryData(queryKey, filters) {
    var _this$queryCache$find;

    return (_this$queryCache$find = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find.state.data;
  }

  ensureQueryData(arg1, arg2, arg3) {
    const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    const cachedData = this.getQueryData(parsedOptions.queryKey);
    return cachedData ? Promise.resolve(cachedData) : this.fetchQuery(parsedOptions);
  }

  getQueriesData(queryKeyOrFilters) {
    return this.getQueryCache().findAll(queryKeyOrFilters).map(({
      queryKey,
      state
    }) => {
      const data = state.data;
      return [queryKey, data];
    });
  }

  setQueryData(queryKey, updater, options) {
    const query = this.queryCache.find(queryKey);
    const prevData = query == null ? void 0 : query.state.data;
    const data = (0,utils/* functionalUpdate */.SE)(updater, prevData);

    if (typeof data === 'undefined') {
      return undefined;
    }

    const parsedOptions = (0,utils/* parseQueryArgs */._v)(queryKey);
    const defaultedOptions = this.defaultQueryOptions(parsedOptions);
    return this.queryCache.build(this, defaultedOptions).setData(data, { ...options,
      manual: true
    });
  }

  setQueriesData(queryKeyOrFilters, updater, options) {
    return notifyManager/* notifyManager.batch */.V.batch(() => this.getQueryCache().findAll(queryKeyOrFilters).map(({
      queryKey
    }) => [queryKey, this.setQueryData(queryKey, updater, options)]));
  }

  getQueryState(queryKey, filters) {
    var _this$queryCache$find2;

    return (_this$queryCache$find2 = this.queryCache.find(queryKey, filters)) == null ? void 0 : _this$queryCache$find2.state;
  }

  removeQueries(arg1, arg2) {
    const [filters] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2);
    const queryCache = this.queryCache;
    notifyManager/* notifyManager.batch */.V.batch(() => {
      queryCache.findAll(filters).forEach(query => {
        queryCache.remove(query);
      });
    });
  }

  resetQueries(arg1, arg2, arg3) {
    const [filters, options] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);
    const queryCache = this.queryCache;
    const refetchFilters = {
      type: 'active',
      ...filters
    };
    return notifyManager/* notifyManager.batch */.V.batch(() => {
      queryCache.findAll(filters).forEach(query => {
        query.reset();
      });
      return this.refetchQueries(refetchFilters, options);
    });
  }

  cancelQueries(arg1, arg2, arg3) {
    const [filters, cancelOptions = {}] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);

    if (typeof cancelOptions.revert === 'undefined') {
      cancelOptions.revert = true;
    }

    const promises = notifyManager/* notifyManager.batch */.V.batch(() => this.queryCache.findAll(filters).map(query => query.cancel(cancelOptions)));
    return Promise.all(promises).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  }

  invalidateQueries(arg1, arg2, arg3) {
    const [filters, options] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);
    return notifyManager/* notifyManager.batch */.V.batch(() => {
      var _ref, _filters$refetchType;

      this.queryCache.findAll(filters).forEach(query => {
        query.invalidate();
      });

      if (filters.refetchType === 'none') {
        return Promise.resolve();
      }

      const refetchFilters = { ...filters,
        type: (_ref = (_filters$refetchType = filters.refetchType) != null ? _filters$refetchType : filters.type) != null ? _ref : 'active'
      };
      return this.refetchQueries(refetchFilters, options);
    });
  }

  refetchQueries(arg1, arg2, arg3) {
    const [filters, options] = (0,utils/* parseFilterArgs */.I6)(arg1, arg2, arg3);
    const promises = notifyManager/* notifyManager.batch */.V.batch(() => this.queryCache.findAll(filters).filter(query => !query.isDisabled()).map(query => {
      var _options$cancelRefetc;

      return query.fetch(undefined, { ...options,
        cancelRefetch: (_options$cancelRefetc = options == null ? void 0 : options.cancelRefetch) != null ? _options$cancelRefetc : true,
        meta: {
          refetchPage: filters.refetchPage
        }
      });
    }));
    let promise = Promise.all(promises).then(utils/* noop */.ZT);

    if (!(options != null && options.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  }

  fetchQuery(arg1, arg2, arg3) {
    const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    const defaultedOptions = this.defaultQueryOptions(parsedOptions); // https://github.com/tannerlinsley/react-query/issues/652

    if (typeof defaultedOptions.retry === 'undefined') {
      defaultedOptions.retry = false;
    }

    const query = this.queryCache.build(this, defaultedOptions);
    return query.isStaleByTime(defaultedOptions.staleTime) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
  }

  prefetchQuery(arg1, arg2, arg3) {
    return this.fetchQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  }

  fetchInfiniteQuery(arg1, arg2, arg3) {
    const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
    parsedOptions.behavior = infiniteQueryBehavior();
    return this.fetchQuery(parsedOptions);
  }

  prefetchInfiniteQuery(arg1, arg2, arg3) {
    return this.fetchInfiniteQuery(arg1, arg2, arg3).then(utils/* noop */.ZT).catch(utils/* noop */.ZT);
  }

  resumePausedMutations() {
    return this.mutationCache.resumePausedMutations();
  }

  getQueryCache() {
    return this.queryCache;
  }

  getMutationCache() {
    return this.mutationCache;
  }

  getLogger() {
    return this.logger;
  }

  getDefaultOptions() {
    return this.defaultOptions;
  }

  setDefaultOptions(options) {
    this.defaultOptions = options;
  }

  setQueryDefaults(queryKey, options) {
    const result = this.queryDefaults.find(x => (0,utils/* hashQueryKey */.yF)(queryKey) === (0,utils/* hashQueryKey */.yF)(x.queryKey));

    if (result) {
      result.defaultOptions = options;
    } else {
      this.queryDefaults.push({
        queryKey,
        defaultOptions: options
      });
    }
  }

  getQueryDefaults(queryKey) {
    if (!queryKey) {
      return undefined;
    } // Get the first matching defaults


    const firstMatchingDefaults = this.queryDefaults.find(x => (0,utils/* partialMatchKey */.to)(queryKey, x.queryKey)); // Additional checks and error in dev mode

    if (false) {}

    return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
  }

  setMutationDefaults(mutationKey, options) {
    const result = this.mutationDefaults.find(x => (0,utils/* hashQueryKey */.yF)(mutationKey) === (0,utils/* hashQueryKey */.yF)(x.mutationKey));

    if (result) {
      result.defaultOptions = options;
    } else {
      this.mutationDefaults.push({
        mutationKey,
        defaultOptions: options
      });
    }
  }

  getMutationDefaults(mutationKey) {
    if (!mutationKey) {
      return undefined;
    } // Get the first matching defaults


    const firstMatchingDefaults = this.mutationDefaults.find(x => (0,utils/* partialMatchKey */.to)(mutationKey, x.mutationKey)); // Additional checks and error in dev mode

    if (false) {}

    return firstMatchingDefaults == null ? void 0 : firstMatchingDefaults.defaultOptions;
  }

  defaultQueryOptions(options) {
    if (options != null && options._defaulted) {
      return options;
    }

    const defaultedOptions = { ...this.defaultOptions.queries,
      ...this.getQueryDefaults(options == null ? void 0 : options.queryKey),
      ...options,
      _defaulted: true
    };

    if (!defaultedOptions.queryHash && defaultedOptions.queryKey) {
      defaultedOptions.queryHash = (0,utils/* hashQueryKeyByOptions */.Rm)(defaultedOptions.queryKey, defaultedOptions);
    } // dependent default values


    if (typeof defaultedOptions.refetchOnReconnect === 'undefined') {
      defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== 'always';
    }

    if (typeof defaultedOptions.useErrorBoundary === 'undefined') {
      defaultedOptions.useErrorBoundary = !!defaultedOptions.suspense;
    }

    return defaultedOptions;
  }

  defaultMutationOptions(options) {
    if (options != null && options._defaulted) {
      return options;
    }

    return { ...this.defaultOptions.mutations,
      ...this.getMutationDefaults(options == null ? void 0 : options.mutationKey),
      ...options,
      _defaulted: true
    };
  }

  clear() {
    this.queryCache.clear();
    this.mutationCache.clear();
  }

}


//# sourceMappingURL=queryClient.mjs.map


/***/ }),

/***/ 53429:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Removable; }
/* harmony export */ });
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36370);


class Removable {
  destroy() {
    this.clearGcTimeout();
  }

  scheduleGc() {
    this.clearGcTimeout();

    if ((0,_utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isValidTimeout */ .PN)(this.cacheTime)) {
      this.gcTimeout = setTimeout(() => {
        this.optionalRemove();
      }, this.cacheTime);
    }
  }

  updateCacheTime(newCacheTime) {
    // Default to 5 minutes (Infinity for server-side) if no cache time is set
    this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : _utils_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isServer */ .sk ? Infinity : 5 * 60 * 1000);
  }

  clearGcTimeout() {
    if (this.gcTimeout) {
      clearTimeout(this.gcTimeout);
      this.gcTimeout = undefined;
    }
  }

}


//# sourceMappingURL=removable.mjs.map


/***/ }),

/***/ 3241:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DV": function() { return /* binding */ isCancelledError; },
/* harmony export */   "Kw": function() { return /* binding */ canFetch; },
/* harmony export */   "Mz": function() { return /* binding */ createRetryer; }
/* harmony export */ });
/* unused harmony export CancelledError */
/* harmony import */ var _focusManager_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85289);
/* harmony import */ var _onlineManager_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63240);
/* harmony import */ var _utils_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36370);




function defaultRetryDelay(failureCount) {
  return Math.min(1000 * 2 ** failureCount, 30000);
}

function canFetch(networkMode) {
  return (networkMode != null ? networkMode : 'online') === 'online' ? _onlineManager_mjs__WEBPACK_IMPORTED_MODULE_0__/* .onlineManager.isOnline */ .N.isOnline() : true;
}
class CancelledError {
  constructor(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
  }

}
function isCancelledError(value) {
  return value instanceof CancelledError;
}
function createRetryer(config) {
  let isRetryCancelled = false;
  let failureCount = 0;
  let isResolved = false;
  let continueFn;
  let promiseResolve;
  let promiseReject;
  const promise = new Promise((outerResolve, outerReject) => {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });

  const cancel = cancelOptions => {
    if (!isResolved) {
      reject(new CancelledError(cancelOptions));
      config.abort == null ? void 0 : config.abort();
    }
  };

  const cancelRetry = () => {
    isRetryCancelled = true;
  };

  const continueRetry = () => {
    isRetryCancelled = false;
  };

  const shouldPause = () => !_focusManager_mjs__WEBPACK_IMPORTED_MODULE_1__/* .focusManager.isFocused */ .j.isFocused() || config.networkMode !== 'always' && !_onlineManager_mjs__WEBPACK_IMPORTED_MODULE_0__/* .onlineManager.isOnline */ .N.isOnline();

  const resolve = value => {
    if (!isResolved) {
      isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };

  const reject = value => {
    if (!isResolved) {
      isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };

  const pause = () => {
    return new Promise(continueResolve => {
      continueFn = value => {
        const canContinue = isResolved || !shouldPause();

        if (canContinue) {
          continueResolve(value);
        }

        return canContinue;
      };

      config.onPause == null ? void 0 : config.onPause();
    }).then(() => {
      continueFn = undefined;

      if (!isResolved) {
        config.onContinue == null ? void 0 : config.onContinue();
      }
    });
  }; // Create loop function


  const run = () => {
    // Do nothing if already resolved
    if (isResolved) {
      return;
    }

    let promiseOrValue; // Execute query

    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    }

    Promise.resolve(promiseOrValue).then(resolve).catch(error => {
      var _config$retry, _config$retryDelay;

      // Stop if the fetch is already resolved
      if (isResolved) {
        return;
      } // Do we need to retry the request?


      const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      const delay = typeof retryDelay === 'function' ? retryDelay(failureCount, error) : retryDelay;
      const shouldRetry = retry === true || typeof retry === 'number' && failureCount < retry || typeof retry === 'function' && retry(failureCount, error);

      if (isRetryCancelled || !shouldRetry) {
        // We are done if the query does not need to be retried
        reject(error);
        return;
      }

      failureCount++; // Notify on fail

      config.onFail == null ? void 0 : config.onFail(failureCount, error); // Delay

      (0,_utils_mjs__WEBPACK_IMPORTED_MODULE_2__/* .sleep */ .Gh)(delay) // Pause if the document is not visible or when the device is offline
      .then(() => {
        if (shouldPause()) {
          return pause();
        }

        return;
      }).then(() => {
        if (isRetryCancelled) {
          reject(error);
        } else {
          run();
        }
      });
    });
  }; // Start loop


  if (canFetch(config.networkMode)) {
    run();
  } else {
    pause().then(run);
  }

  return {
    promise,
    cancel,
    continue: () => {
      const didContinue = continueFn == null ? void 0 : continueFn();
      return didContinue ? promise : Promise.resolve();
    },
    cancelRetry,
    continueRetry
  };
}


//# sourceMappingURL=retryer.mjs.map


/***/ }),

/***/ 22436:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Subscribable; }
/* harmony export */ });
class Subscribable {
  constructor() {
    this.listeners = new Set();
    this.subscribe = this.subscribe.bind(this);
  }

  subscribe(listener) {
    const identity = {
      listener
    };
    this.listeners.add(identity);
    this.onSubscribe();
    return () => {
      this.listeners.delete(identity);
      this.onUnsubscribe();
    };
  }

  hasListeners() {
    return this.listeners.size > 0;
  }

  onSubscribe() {// Do nothing
  }

  onUnsubscribe() {// Do nothing
  }

}


//# sourceMappingURL=subscribable.mjs.map


/***/ }),

/***/ 36370:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ scheduleMicrotask; },
/* harmony export */   "G9": function() { return /* binding */ getAbortController; },
/* harmony export */   "Gh": function() { return /* binding */ sleep; },
/* harmony export */   "I6": function() { return /* binding */ parseFilterArgs; },
/* harmony export */   "Kp": function() { return /* binding */ timeUntilStale; },
/* harmony export */   "PN": function() { return /* binding */ isValidTimeout; },
/* harmony export */   "Rm": function() { return /* binding */ hashQueryKeyByOptions; },
/* harmony export */   "SE": function() { return /* binding */ functionalUpdate; },
/* harmony export */   "VS": function() { return /* binding */ shallowEqualObjects; },
/* harmony export */   "X7": function() { return /* binding */ matchMutation; },
/* harmony export */   "ZT": function() { return /* binding */ noop; },
/* harmony export */   "_v": function() { return /* binding */ parseQueryArgs; },
/* harmony export */   "_x": function() { return /* binding */ matchQuery; },
/* harmony export */   "lV": function() { return /* binding */ parseMutationArgs; },
/* harmony export */   "oE": function() { return /* binding */ replaceData; },
/* harmony export */   "sk": function() { return /* binding */ isServer; },
/* harmony export */   "to": function() { return /* binding */ partialMatchKey; },
/* harmony export */   "yF": function() { return /* binding */ hashQueryKey; }
/* harmony export */ });
/* unused harmony exports difference, isError, isPlainArray, isPlainObject, isQueryKey, parseMutationFilterArgs, partialDeepEqual, replaceAt, replaceEqualDeep */
// TYPES
// UTILS
const isServer = typeof window === 'undefined' || 'Deno' in window;
function noop() {
  return undefined;
}
function functionalUpdate(updater, input) {
  return typeof updater === 'function' ? updater(input) : updater;
}
function isValidTimeout(value) {
  return typeof value === 'number' && value >= 0 && value !== Infinity;
}
function difference(array1, array2) {
  return array1.filter(x => !array2.includes(x));
}
function replaceAt(array, index, value) {
  const copy = array.slice(0);
  copy[index] = value;
  return copy;
}
function timeUntilStale(updatedAt, staleTime) {
  return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function parseQueryArgs(arg1, arg2, arg3) {
  if (!isQueryKey(arg1)) {
    return arg1;
  }

  if (typeof arg2 === 'function') {
    return { ...arg3,
      queryKey: arg1,
      queryFn: arg2
    };
  }

  return { ...arg2,
    queryKey: arg1
  };
}
function parseMutationArgs(arg1, arg2, arg3) {
  if (isQueryKey(arg1)) {
    if (typeof arg2 === 'function') {
      return { ...arg3,
        mutationKey: arg1,
        mutationFn: arg2
      };
    }

    return { ...arg2,
      mutationKey: arg1
    };
  }

  if (typeof arg1 === 'function') {
    return { ...arg2,
      mutationFn: arg1
    };
  }

  return { ...arg1
  };
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [{ ...arg2,
    queryKey: arg1
  }, arg3] : [arg1 || {}, arg2];
}
function parseMutationFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [{ ...arg2,
    mutationKey: arg1
  }, arg3] : [arg1 || {}, arg2];
}
function matchQuery(filters, query) {
  const {
    type = 'all',
    exact,
    fetchStatus,
    predicate,
    queryKey,
    stale
  } = filters;

  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }

  if (type !== 'all') {
    const isActive = query.isActive();

    if (type === 'active' && !isActive) {
      return false;
    }

    if (type === 'inactive' && isActive) {
      return false;
    }
  }

  if (typeof stale === 'boolean' && query.isStale() !== stale) {
    return false;
  }

  if (typeof fetchStatus !== 'undefined' && fetchStatus !== query.state.fetchStatus) {
    return false;
  }

  if (predicate && !predicate(query)) {
    return false;
  }

  return true;
}
function matchMutation(filters, mutation) {
  const {
    exact,
    fetching,
    predicate,
    mutationKey
  } = filters;

  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }

    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }

  if (typeof fetching === 'boolean' && mutation.state.status === 'loading' !== fetching) {
    return false;
  }

  if (predicate && !predicate(mutation)) {
    return false;
  }

  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
/**
 * Default query keys hash function.
 * Hashes the value into a stable hash.
 */

function hashQueryKey(queryKey) {
  return JSON.stringify(queryKey, (_, val) => isPlainObject(val) ? Object.keys(val).sort().reduce((result, key) => {
    result[key] = val[key];
    return result;
  }, {}) : val);
}
/**
 * Checks if key `b` partially matches with key `a`.
 */

function partialMatchKey(a, b) {
  return partialDeepEqual(a, b);
}
/**
 * Checks if `b` partially matches with `a`.
 */

function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== typeof b) {
    return false;
  }

  if (a && b && typeof a === 'object' && typeof b === 'object') {
    return !Object.keys(b).some(key => !partialDeepEqual(a[key], b[key]));
  }

  return false;
}
/**
 * This function returns `a` if `b` is deeply equal.
 * If not, it will replace any deeply equal children of `b` with those of `a`.
 * This can be used for structural sharing between JSON values for example.
 */

function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }

  const array = isPlainArray(a) && isPlainArray(b);

  if (array || isPlainObject(a) && isPlainObject(b)) {
    const aSize = array ? a.length : Object.keys(a).length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? [] : {};
    let equalItems = 0;

    for (let i = 0; i < bSize; i++) {
      const key = array ? i : bItems[i];
      copy[key] = replaceEqualDeep(a[key], b[key]);

      if (copy[key] === a[key]) {
        equalItems++;
      }
    }

    return aSize === bSize && equalItems === aSize ? a : copy;
  }

  return b;
}
/**
 * Shallow compare objects. Only works with objects that always have the same properties.
 */

function shallowEqualObjects(a, b) {
  if (a && !b || b && !a) {
    return false;
  }

  for (const key in a) {
    if (a[key] !== b[key]) {
      return false;
    }
  }

  return true;
}
function isPlainArray(value) {
  return Array.isArray(value) && value.length === Object.keys(value).length;
} // Copied from: https://github.com/jonschlinkert/is-plain-object

function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  } // If has modified constructor


  const ctor = o.constructor;

  if (typeof ctor === 'undefined') {
    return true;
  } // If has modified prototype


  const prot = ctor.prototype;

  if (!hasObjectPrototype(prot)) {
    return false;
  } // If constructor does not have an Object-specific method


  if (!prot.hasOwnProperty('isPrototypeOf')) {
    return false;
  } // Most likely a plain Object


  return true;
}

function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === '[object Object]';
}

function isQueryKey(value) {
  return Array.isArray(value);
}
function isError(value) {
  return value instanceof Error;
}
function sleep(timeout) {
  return new Promise(resolve => {
    setTimeout(resolve, timeout);
  });
}
/**
 * Schedules a microtask.
 * This can be useful to schedule state updates after rendering.
 */

function scheduleMicrotask(callback) {
  sleep(0).then(callback);
}
function getAbortController() {
  if (typeof AbortController === 'function') {
    return new AbortController();
  }

  return;
}
function replaceData(prevData, data, options) {
  // Use prev data if an isDataEqual function is defined and returns `true`
  if (options.isDataEqual != null && options.isDataEqual(prevData, data)) {
    return prevData;
  } else if (typeof options.structuralSharing === 'function') {
    return options.structuralSharing(prevData, data);
  } else if (options.structuralSharing !== false) {
    // Structurally share data between prev and new data if needed
    return replaceEqualDeep(prevData, data);
  }

  return data;
}


//# sourceMappingURL=utils.mjs.map


/***/ }),

/***/ 55830:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "NL": function() { return /* binding */ useQueryClient; },
/* harmony export */   "aH": function() { return /* binding */ QueryClientProvider; }
/* harmony export */ });
/* unused harmony export defaultContext */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
'use client';


const defaultContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(undefined);
const QueryClientSharingContext = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createContext(false); // If we are given a context, we will use it.
// Otherwise, if contextSharing is on, we share the first and at least one
// instance of the context across the window
// to ensure that if React Query is used across
// different bundles or microfrontends they will
// all use the same **instance** of context, regardless
// of module scoping.

function getQueryClientContext(context, contextSharing) {
  if (context) {
    return context;
  }

  if (contextSharing && typeof window !== 'undefined') {
    if (!window.ReactQueryClientContext) {
      window.ReactQueryClientContext = defaultContext;
    }

    return window.ReactQueryClientContext;
  }

  return defaultContext;
}

const useQueryClient = ({
  context
} = {}) => {
  const queryClient = react__WEBPACK_IMPORTED_MODULE_0__.useContext(getQueryClientContext(context, react__WEBPACK_IMPORTED_MODULE_0__.useContext(QueryClientSharingContext)));

  if (!queryClient) {
    throw new Error('No QueryClient set, use QueryClientProvider to set one');
  }

  return queryClient;
};
const QueryClientProvider = ({
  client,
  children,
  context,
  contextSharing = false
}) => {
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(() => {
    client.mount();
    return () => {
      client.unmount();
    };
  }, [client]);

  if (false) {}

  const Context = getQueryClientContext(context, contextSharing);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(QueryClientSharingContext.Provider, {
    value: !context && contextSharing
  }, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement(Context.Provider, {
    value: client
  }, children));
};


//# sourceMappingURL=QueryClientProvider.mjs.map


/***/ }),

/***/ 47661:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ useQuery; }
});

// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(36370);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(3709);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/focusManager.mjs
var focusManager = __webpack_require__(85289);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/subscribable.mjs
var subscribable = __webpack_require__(22436);
// EXTERNAL MODULE: ../../node_modules/@tanstack/query-core/build/lib/retryer.mjs
var retryer = __webpack_require__(3241);
;// CONCATENATED MODULE: ../../node_modules/@tanstack/query-core/build/lib/queryObserver.mjs






class QueryObserver extends subscribable/* Subscribable */.l {
  constructor(client, options) {
    super();
    this.client = client;
    this.options = options;
    this.trackedProps = new Set();
    this.selectError = null;
    this.bindMethods();
    this.setOptions(options);
  }

  bindMethods() {
    this.remove = this.remove.bind(this);
    this.refetch = this.refetch.bind(this);
  }

  onSubscribe() {
    if (this.listeners.size === 1) {
      this.currentQuery.addObserver(this);

      if (shouldFetchOnMount(this.currentQuery, this.options)) {
        this.executeFetch();
      }

      this.updateTimers();
    }
  }

  onUnsubscribe() {
    if (!this.hasListeners()) {
      this.destroy();
    }
  }

  shouldFetchOnReconnect() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnReconnect);
  }

  shouldFetchOnWindowFocus() {
    return shouldFetchOn(this.currentQuery, this.options, this.options.refetchOnWindowFocus);
  }

  destroy() {
    this.listeners = new Set();
    this.clearStaleTimeout();
    this.clearRefetchInterval();
    this.currentQuery.removeObserver(this);
  }

  setOptions(options, notifyOptions) {
    const prevOptions = this.options;
    const prevQuery = this.currentQuery;
    this.options = this.client.defaultQueryOptions(options);

    if (false) {}

    if (!(0,utils/* shallowEqualObjects */.VS)(prevOptions, this.options)) {
      this.client.getQueryCache().notify({
        type: 'observerOptionsUpdated',
        query: this.currentQuery,
        observer: this
      });
    }

    if (typeof this.options.enabled !== 'undefined' && typeof this.options.enabled !== 'boolean') {
      throw new Error('Expected enabled to be a boolean');
    } // Keep previous query key if the user does not supply one


    if (!this.options.queryKey) {
      this.options.queryKey = prevOptions.queryKey;
    }

    this.updateQuery();
    const mounted = this.hasListeners(); // Fetch if there are subscribers

    if (mounted && shouldFetchOptionally(this.currentQuery, prevQuery, this.options, prevOptions)) {
      this.executeFetch();
    } // Update result


    this.updateResult(notifyOptions); // Update stale interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || this.options.staleTime !== prevOptions.staleTime)) {
      this.updateStaleTimeout();
    }

    const nextRefetchInterval = this.computeRefetchInterval(); // Update refetch interval if needed

    if (mounted && (this.currentQuery !== prevQuery || this.options.enabled !== prevOptions.enabled || nextRefetchInterval !== this.currentRefetchInterval)) {
      this.updateRefetchInterval(nextRefetchInterval);
    }
  }

  getOptimisticResult(options) {
    const query = this.client.getQueryCache().build(this.client, options);
    const result = this.createResult(query, options);

    if (shouldAssignObserverCurrentProperties(this, result, options)) {
      // this assigns the optimistic result to the current Observer
      // because if the query function changes, useQuery will be performing
      // an effect where it would fetch again.
      // When the fetch finishes, we perform a deep data cloning in order
      // to reuse objects references. This deep data clone is performed against
      // the `observer.currentResult.data` property
      // When QueryKey changes, we refresh the query and get new `optimistic`
      // result, while we leave the `observer.currentResult`, so when new data
      // arrives, it finds the old `observer.currentResult` which is related
      // to the old QueryKey. Which means that currentResult and selectData are
      // out of sync already.
      // To solve this, we move the cursor of the currentResult everytime
      // an observer reads an optimistic value.
      // When keeping the previous data, the result doesn't change until new
      // data arrives.
      this.currentResult = result;
      this.currentResultOptions = this.options;
      this.currentResultState = this.currentQuery.state;
    }

    return result;
  }

  getCurrentResult() {
    return this.currentResult;
  }

  trackResult(result) {
    const trackedResult = {};
    Object.keys(result).forEach(key => {
      Object.defineProperty(trackedResult, key, {
        configurable: false,
        enumerable: true,
        get: () => {
          this.trackedProps.add(key);
          return result[key];
        }
      });
    });
    return trackedResult;
  }

  getCurrentQuery() {
    return this.currentQuery;
  }

  remove() {
    this.client.getQueryCache().remove(this.currentQuery);
  }

  refetch({
    refetchPage,
    ...options
  } = {}) {
    return this.fetch({ ...options,
      meta: {
        refetchPage
      }
    });
  }

  fetchOptimistic(options) {
    const defaultedOptions = this.client.defaultQueryOptions(options);
    const query = this.client.getQueryCache().build(this.client, defaultedOptions);
    query.isFetchingOptimistic = true;
    return query.fetch().then(() => this.createResult(query, defaultedOptions));
  }

  fetch(fetchOptions) {
    var _fetchOptions$cancelR;

    return this.executeFetch({ ...fetchOptions,
      cancelRefetch: (_fetchOptions$cancelR = fetchOptions.cancelRefetch) != null ? _fetchOptions$cancelR : true
    }).then(() => {
      this.updateResult();
      return this.currentResult;
    });
  }

  executeFetch(fetchOptions) {
    // Make sure we reference the latest query as the current one might have been removed
    this.updateQuery(); // Fetch

    let promise = this.currentQuery.fetch(this.options, fetchOptions);

    if (!(fetchOptions != null && fetchOptions.throwOnError)) {
      promise = promise.catch(utils/* noop */.ZT);
    }

    return promise;
  }

  updateStaleTimeout() {
    this.clearStaleTimeout();

    if (utils/* isServer */.sk || this.currentResult.isStale || !(0,utils/* isValidTimeout */.PN)(this.options.staleTime)) {
      return;
    }

    const time = (0,utils/* timeUntilStale */.Kp)(this.currentResult.dataUpdatedAt, this.options.staleTime); // The timeout is sometimes triggered 1 ms before the stale time expiration.
    // To mitigate this issue we always add 1 ms to the timeout.

    const timeout = time + 1;
    this.staleTimeoutId = setTimeout(() => {
      if (!this.currentResult.isStale) {
        this.updateResult();
      }
    }, timeout);
  }

  computeRefetchInterval() {
    var _this$options$refetch;

    return typeof this.options.refetchInterval === 'function' ? this.options.refetchInterval(this.currentResult.data, this.currentQuery) : (_this$options$refetch = this.options.refetchInterval) != null ? _this$options$refetch : false;
  }

  updateRefetchInterval(nextInterval) {
    this.clearRefetchInterval();
    this.currentRefetchInterval = nextInterval;

    if (utils/* isServer */.sk || this.options.enabled === false || !(0,utils/* isValidTimeout */.PN)(this.currentRefetchInterval) || this.currentRefetchInterval === 0) {
      return;
    }

    this.refetchIntervalId = setInterval(() => {
      if (this.options.refetchIntervalInBackground || focusManager/* focusManager.isFocused */.j.isFocused()) {
        this.executeFetch();
      }
    }, this.currentRefetchInterval);
  }

  updateTimers() {
    this.updateStaleTimeout();
    this.updateRefetchInterval(this.computeRefetchInterval());
  }

  clearStaleTimeout() {
    if (this.staleTimeoutId) {
      clearTimeout(this.staleTimeoutId);
      this.staleTimeoutId = undefined;
    }
  }

  clearRefetchInterval() {
    if (this.refetchIntervalId) {
      clearInterval(this.refetchIntervalId);
      this.refetchIntervalId = undefined;
    }
  }

  createResult(query, options) {
    const prevQuery = this.currentQuery;
    const prevOptions = this.options;
    const prevResult = this.currentResult;
    const prevResultState = this.currentResultState;
    const prevResultOptions = this.currentResultOptions;
    const queryChange = query !== prevQuery;
    const queryInitialState = queryChange ? query.state : this.currentQueryInitialState;
    const prevQueryResult = queryChange ? this.currentResult : this.previousQueryResult;
    const {
      state
    } = query;
    let {
      dataUpdatedAt,
      error,
      errorUpdatedAt,
      fetchStatus,
      status
    } = state;
    let isPreviousData = false;
    let isPlaceholderData = false;
    let data; // Optimistically set result in fetching state if needed

    if (options._optimisticResults) {
      const mounted = this.hasListeners();
      const fetchOnMount = !mounted && shouldFetchOnMount(query, options);
      const fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);

      if (fetchOnMount || fetchOptionally) {
        fetchStatus = (0,retryer/* canFetch */.Kw)(query.options.networkMode) ? 'fetching' : 'paused';

        if (!dataUpdatedAt) {
          status = 'loading';
        }
      }

      if (options._optimisticResults === 'isRestoring') {
        fetchStatus = 'idle';
      }
    } // Keep previous data if needed


    if (options.keepPreviousData && !state.dataUpdatedAt && prevQueryResult != null && prevQueryResult.isSuccess && status !== 'error') {
      data = prevQueryResult.data;
      dataUpdatedAt = prevQueryResult.dataUpdatedAt;
      status = prevQueryResult.status;
      isPreviousData = true;
    } // Select data if needed
    else if (options.select && typeof state.data !== 'undefined') {
      // Memoize select result
      if (prevResult && state.data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === this.selectFn) {
        data = this.selectResult;
      } else {
        try {
          this.selectFn = options.select;
          data = options.select(state.data);
          data = (0,utils/* replaceData */.oE)(prevResult == null ? void 0 : prevResult.data, data, options);
          this.selectResult = data;
          this.selectError = null;
        } catch (selectError) {
          if (false) {}

          this.selectError = selectError;
        }
      }
    } // Use query data
    else {
      data = state.data;
    } // Show placeholder data if needed


    if (typeof options.placeholderData !== 'undefined' && typeof data === 'undefined' && status === 'loading') {
      let placeholderData; // Memoize placeholder data

      if (prevResult != null && prevResult.isPlaceholderData && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
        placeholderData = prevResult.data;
      } else {
        placeholderData = typeof options.placeholderData === 'function' ? options.placeholderData() : options.placeholderData;

        if (options.select && typeof placeholderData !== 'undefined') {
          try {
            placeholderData = options.select(placeholderData);
            this.selectError = null;
          } catch (selectError) {
            if (false) {}

            this.selectError = selectError;
          }
        }
      }

      if (typeof placeholderData !== 'undefined') {
        status = 'success';
        data = (0,utils/* replaceData */.oE)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
        isPlaceholderData = true;
      }
    }

    if (this.selectError) {
      error = this.selectError;
      data = this.selectResult;
      errorUpdatedAt = Date.now();
      status = 'error';
    }

    const isFetching = fetchStatus === 'fetching';
    const isLoading = status === 'loading';
    const isError = status === 'error';
    const result = {
      status,
      fetchStatus,
      isLoading,
      isSuccess: status === 'success',
      isError,
      isInitialLoading: isLoading && isFetching,
      data,
      dataUpdatedAt,
      error,
      errorUpdatedAt,
      failureCount: state.fetchFailureCount,
      failureReason: state.fetchFailureReason,
      errorUpdateCount: state.errorUpdateCount,
      isFetched: state.dataUpdateCount > 0 || state.errorUpdateCount > 0,
      isFetchedAfterMount: state.dataUpdateCount > queryInitialState.dataUpdateCount || state.errorUpdateCount > queryInitialState.errorUpdateCount,
      isFetching,
      isRefetching: isFetching && !isLoading,
      isLoadingError: isError && state.dataUpdatedAt === 0,
      isPaused: fetchStatus === 'paused',
      isPlaceholderData,
      isPreviousData,
      isRefetchError: isError && state.dataUpdatedAt !== 0,
      isStale: isStale(query, options),
      refetch: this.refetch,
      remove: this.remove
    };
    return result;
  }

  updateResult(notifyOptions) {
    const prevResult = this.currentResult;
    const nextResult = this.createResult(this.currentQuery, this.options);
    this.currentResultState = this.currentQuery.state;
    this.currentResultOptions = this.options; // Only notify and update result if something has changed

    if ((0,utils/* shallowEqualObjects */.VS)(nextResult, prevResult)) {
      return;
    }

    this.currentResult = nextResult; // Determine which callbacks to trigger

    const defaultNotifyOptions = {
      cache: true
    };

    const shouldNotifyListeners = () => {
      if (!prevResult) {
        return true;
      }

      const {
        notifyOnChangeProps
      } = this.options;
      const notifyOnChangePropsValue = typeof notifyOnChangeProps === 'function' ? notifyOnChangeProps() : notifyOnChangeProps;

      if (notifyOnChangePropsValue === 'all' || !notifyOnChangePropsValue && !this.trackedProps.size) {
        return true;
      }

      const includedProps = new Set(notifyOnChangePropsValue != null ? notifyOnChangePropsValue : this.trackedProps);

      if (this.options.useErrorBoundary) {
        includedProps.add('error');
      }

      return Object.keys(this.currentResult).some(key => {
        const typedKey = key;
        const changed = this.currentResult[typedKey] !== prevResult[typedKey];
        return changed && includedProps.has(typedKey);
      });
    };

    if ((notifyOptions == null ? void 0 : notifyOptions.listeners) !== false && shouldNotifyListeners()) {
      defaultNotifyOptions.listeners = true;
    }

    this.notify({ ...defaultNotifyOptions,
      ...notifyOptions
    });
  }

  updateQuery() {
    const query = this.client.getQueryCache().build(this.client, this.options);

    if (query === this.currentQuery) {
      return;
    }

    const prevQuery = this.currentQuery;
    this.currentQuery = query;
    this.currentQueryInitialState = query.state;
    this.previousQueryResult = this.currentResult;

    if (this.hasListeners()) {
      prevQuery == null ? void 0 : prevQuery.removeObserver(this);
      query.addObserver(this);
    }
  }

  onQueryUpdate(action) {
    const notifyOptions = {};

    if (action.type === 'success') {
      notifyOptions.onSuccess = !action.manual;
    } else if (action.type === 'error' && !(0,retryer/* isCancelledError */.DV)(action.error)) {
      notifyOptions.onError = true;
    }

    this.updateResult(notifyOptions);

    if (this.hasListeners()) {
      this.updateTimers();
    }
  }

  notify(notifyOptions) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      // First trigger the configuration callbacks
      if (notifyOptions.onSuccess) {
        var _this$options$onSucce, _this$options, _this$options$onSettl, _this$options2;

        (_this$options$onSucce = (_this$options = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options, this.currentResult.data);
        (_this$options$onSettl = (_this$options2 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options2, this.currentResult.data, null);
      } else if (notifyOptions.onError) {
        var _this$options$onError, _this$options3, _this$options$onSettl2, _this$options4;

        (_this$options$onError = (_this$options3 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options3, this.currentResult.error);
        (_this$options$onSettl2 = (_this$options4 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options4, undefined, this.currentResult.error);
      } // Then trigger the listeners


      if (notifyOptions.listeners) {
        this.listeners.forEach(({
          listener
        }) => {
          listener(this.currentResult);
        });
      } // Then the cache listeners


      if (notifyOptions.cache) {
        this.client.getQueryCache().notify({
          query: this.currentQuery,
          type: 'observerResultsUpdated'
        });
      }
    });
  }

}

function shouldLoadOnMount(query, options) {
  return options.enabled !== false && !query.state.dataUpdatedAt && !(query.state.status === 'error' && options.retryOnMount === false);
}

function shouldFetchOnMount(query, options) {
  return shouldLoadOnMount(query, options) || query.state.dataUpdatedAt > 0 && shouldFetchOn(query, options, options.refetchOnMount);
}

function shouldFetchOn(query, options, field) {
  if (options.enabled !== false) {
    const value = typeof field === 'function' ? field(query) : field;
    return value === 'always' || value !== false && isStale(query, options);
  }

  return false;
}

function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
  return options.enabled !== false && (query !== prevQuery || prevOptions.enabled === false) && (!options.suspense || query.state.status !== 'error') && isStale(query, options);
}

function isStale(query, options) {
  return query.isStaleByTime(options.staleTime);
} // this function would decide if we will update the observer's 'current'
// properties after an optimistic reading via getOptimisticResult


function shouldAssignObserverCurrentProperties(observer, optimisticResult, options) {
  // it is important to keep this condition like this for three reasons:
  // 1. It will get removed in the v5
  // 2. it reads: don't update the properties if we want to keep the previous
  // data.
  // 3. The opposite condition (!options.keepPreviousData) would fallthrough
  // and will result in a bad decision
  if (options.keepPreviousData) {
    return false;
  } // this means we want to put some placeholder data when pending and queryKey
  // changed.


  if (options.placeholderData !== undefined) {
    // re-assign properties only if current data is placeholder data
    // which means that data did not arrive yet, so, if there is some cached data
    // we need to "prepare" to receive it
    return optimisticResult.isPlaceholderData;
  } // if the newly created result isn't what the observer is holding as current,
  // then we'll need to update the properties as well


  if (!(0,utils/* shallowEqualObjects */.VS)(observer.getCurrentResult(), optimisticResult)) {
    return true;
  } // basically, just keep previous properties if nothing changed


  return false;
}


//# sourceMappingURL=queryObserver.mjs.map

// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/useSyncExternalStore.mjs
var useSyncExternalStore = __webpack_require__(29930);
;// CONCATENATED MODULE: ../../node_modules/@tanstack/react-query/build/lib/QueryErrorResetBoundary.mjs
'use client';


function createValue() {
  let isReset = false;
  return {
    clearReset: () => {
      isReset = false;
    },
    reset: () => {
      isReset = true;
    },
    isReset: () => {
      return isReset;
    }
  };
}

const QueryErrorResetBoundaryContext = /*#__PURE__*/react.createContext(createValue()); // HOOK

const useQueryErrorResetBoundary = () => react.useContext(QueryErrorResetBoundaryContext); // COMPONENT

const QueryErrorResetBoundary = ({
  children
}) => {
  const [value] = React.useState(() => createValue());
  return /*#__PURE__*/React.createElement(QueryErrorResetBoundaryContext.Provider, {
    value: value
  }, typeof children === 'function' ? children(value) : children);
};


//# sourceMappingURL=QueryErrorResetBoundary.mjs.map

// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(55830);
;// CONCATENATED MODULE: ../../node_modules/@tanstack/react-query/build/lib/isRestoring.mjs
'use client';


const IsRestoringContext = /*#__PURE__*/react.createContext(false);
const useIsRestoring = () => react.useContext(IsRestoringContext);
const IsRestoringProvider = IsRestoringContext.Provider;


//# sourceMappingURL=isRestoring.mjs.map

// EXTERNAL MODULE: ../../node_modules/@tanstack/react-query/build/lib/utils.mjs
var lib_utils = __webpack_require__(99189);
;// CONCATENATED MODULE: ../../node_modules/@tanstack/react-query/build/lib/errorBoundaryUtils.mjs
'use client';



const ensurePreventErrorBoundaryRetry = (options, errorResetBoundary) => {
  if (options.suspense || options.useErrorBoundary) {
    // Prevent retrying failed query if the error boundary has not been reset yet
    if (!errorResetBoundary.isReset()) {
      options.retryOnMount = false;
    }
  }
};
const useClearResetErrorBoundary = errorResetBoundary => {
  react.useEffect(() => {
    errorResetBoundary.clearReset();
  }, [errorResetBoundary]);
};
const getHasError = ({
  result,
  errorResetBoundary,
  useErrorBoundary,
  query
}) => {
  return result.isError && !errorResetBoundary.isReset() && !result.isFetching && (0,lib_utils/* shouldThrowError */.L)(useErrorBoundary, [result.error, query]);
};


//# sourceMappingURL=errorBoundaryUtils.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@tanstack/react-query/build/lib/suspense.mjs
const ensureStaleTime = defaultedOptions => {
  if (defaultedOptions.suspense) {
    // Always set stale time when using suspense to prevent
    // fetching again when directly mounting after suspending
    if (typeof defaultedOptions.staleTime !== 'number') {
      defaultedOptions.staleTime = 1000;
    }
  }
};
const willFetch = (result, isRestoring) => result.isLoading && result.isFetching && !isRestoring;
const shouldSuspend = (defaultedOptions, result, isRestoring) => (defaultedOptions == null ? void 0 : defaultedOptions.suspense) && willFetch(result, isRestoring);
const fetchOptimistic = (defaultedOptions, observer, errorResetBoundary) => observer.fetchOptimistic(defaultedOptions).then(({
  data
}) => {
  defaultedOptions.onSuccess == null ? void 0 : defaultedOptions.onSuccess(data);
  defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(data, null);
}).catch(error => {
  errorResetBoundary.clearReset();
  defaultedOptions.onError == null ? void 0 : defaultedOptions.onError(error);
  defaultedOptions.onSettled == null ? void 0 : defaultedOptions.onSettled(undefined, error);
});


//# sourceMappingURL=suspense.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@tanstack/react-query/build/lib/useBaseQuery.mjs
'use client';









function useBaseQuery(options, Observer) {
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)({
    context: options.context
  });
  const isRestoring = useIsRestoring();
  const errorResetBoundary = useQueryErrorResetBoundary();
  const defaultedOptions = queryClient.defaultQueryOptions(options); // Make sure results are optimistically set in fetching state before subscribing or updating options

  defaultedOptions._optimisticResults = isRestoring ? 'isRestoring' : 'optimistic'; // Include callbacks in batch renders

  if (defaultedOptions.onError) {
    defaultedOptions.onError = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onError);
  }

  if (defaultedOptions.onSuccess) {
    defaultedOptions.onSuccess = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSuccess);
  }

  if (defaultedOptions.onSettled) {
    defaultedOptions.onSettled = notifyManager/* notifyManager.batchCalls */.V.batchCalls(defaultedOptions.onSettled);
  }

  ensureStaleTime(defaultedOptions);
  ensurePreventErrorBoundaryRetry(defaultedOptions, errorResetBoundary);
  useClearResetErrorBoundary(errorResetBoundary);
  const [observer] = react.useState(() => new Observer(queryClient, defaultedOptions));
  const result = observer.getOptimisticResult(defaultedOptions);
  (0,useSyncExternalStore/* useSyncExternalStore */.$)(react.useCallback(onStoreChange => {
    const unsubscribe = isRestoring ? () => undefined : observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(onStoreChange)); // Update result to make sure we did not miss any query updates
    // between creating the observer and subscribing to it.

    observer.updateResult();
    return unsubscribe;
  }, [observer, isRestoring]), () => observer.getCurrentResult(), () => observer.getCurrentResult());
  react.useEffect(() => {
    // Do not notify on updates because of changes in the options because
    // these changes should already be reflected in the optimistic result.
    observer.setOptions(defaultedOptions, {
      listeners: false
    });
  }, [defaultedOptions, observer]); // Handle suspense

  if (shouldSuspend(defaultedOptions, result, isRestoring)) {
    throw fetchOptimistic(defaultedOptions, observer, errorResetBoundary);
  } // Handle error boundary


  if (getHasError({
    result,
    errorResetBoundary,
    useErrorBoundary: defaultedOptions.useErrorBoundary,
    query: observer.getCurrentQuery()
  })) {
    throw result.error;
  } // Handle result property usage tracking


  return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}


//# sourceMappingURL=useBaseQuery.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@tanstack/react-query/build/lib/useQuery.mjs
'use client';



function useQuery(arg1, arg2, arg3) {
  const parsedOptions = (0,utils/* parseQueryArgs */._v)(arg1, arg2, arg3);
  return useBaseQuery(parsedOptions, QueryObserver);
}


//# sourceMappingURL=useQuery.mjs.map


/***/ }),

/***/ 29930:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useSyncExternalStore; }
/* harmony export */ });
/* harmony import */ var use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(43100);
'use client';


const useSyncExternalStore = use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_0__.useSyncExternalStore;


//# sourceMappingURL=useSyncExternalStore.mjs.map


/***/ }),

/***/ 99189:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ shouldThrowError; }
/* harmony export */ });
function shouldThrowError(_useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary(...params);
  }

  return !!_useErrorBoundary;
}


//# sourceMappingURL=utils.mjs.map


/***/ }),

/***/ 97123:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ createRequest; }
});

// UNUSED EXPORTS: C, a, b, c, d, e, f, g, i, k, m, s

;// CONCATENATED MODULE: ../../node_modules/@0no-co/graphql.web/dist/graphql.web.mjs
var graphql_web_e = {
  NAME: "Name",
  DOCUMENT: "Document",
  OPERATION_DEFINITION: "OperationDefinition",
  VARIABLE_DEFINITION: "VariableDefinition",
  SELECTION_SET: "SelectionSet",
  FIELD: "Field",
  ARGUMENT: "Argument",
  FRAGMENT_SPREAD: "FragmentSpread",
  INLINE_FRAGMENT: "InlineFragment",
  FRAGMENT_DEFINITION: "FragmentDefinition",
  VARIABLE: "Variable",
  INT: "IntValue",
  FLOAT: "FloatValue",
  STRING: "StringValue",
  BOOLEAN: "BooleanValue",
  NULL: "NullValue",
  ENUM: "EnumValue",
  LIST: "ListValue",
  OBJECT: "ObjectValue",
  OBJECT_FIELD: "ObjectField",
  DIRECTIVE: "Directive",
  NAMED_TYPE: "NamedType",
  LIST_TYPE: "ListType",
  NON_NULL_TYPE: "NonNullType"
};

var graphql_web_r = {
  QUERY: "query",
  MUTATION: "mutation",
  SUBSCRIPTION: "subscription"
};

class GraphQLError extends Error {
  constructor(e, r, i, n, a, t, o) {
    super(e);
    this.name = "GraphQLError";
    this.message = e;
    if (a) {
      this.path = a;
    }
    if (r) {
      this.nodes = Array.isArray(r) ? r : [ r ];
    }
    if (i) {
      this.source = i;
    }
    if (n) {
      this.positions = n;
    }
    if (t) {
      this.originalError = t;
    }
    var l = o;
    if (!l && t) {
      var u = t.extensions;
      if (u && "object" == typeof u) {
        l = u;
      }
    }
    this.extensions = l || {};
  }
  toJSON() {
    return {
      ...this,
      message: this.message
    };
  }
  toString() {
    return this.message;
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
}

var i;

var graphql_web_n;

function error(e) {
  return new GraphQLError(`Syntax Error: Unexpected token at ${graphql_web_n} in ${e}`);
}

function advance(e) {
  e.lastIndex = graphql_web_n;
  if (e.test(i)) {
    return i.slice(graphql_web_n, graphql_web_n = e.lastIndex);
  }
}

var graphql_web_a = / +(?=[^\s])/y;

function blockString(e) {
  var r = e.split("\n");
  var i = "";
  var n = 0;
  var t = 0;
  var o = r.length - 1;
  for (var l = 0; l < r.length; l++) {
    graphql_web_a.lastIndex = 0;
    if (graphql_web_a.test(r[l])) {
      if (l && (!n || graphql_web_a.lastIndex < n)) {
        n = graphql_web_a.lastIndex;
      }
      t = t || l;
      o = l;
    }
  }
  for (var u = t; u <= o; u++) {
    if (u !== t) {
      i += "\n";
    }
    i += r[u].slice(n).replace(/\\"""/g, '"""');
  }
  return i;
}

function ignored() {
  for (var e = 0 | i.charCodeAt(graphql_web_n++); 9 === e || 10 === e || 13 === e || 32 === e || 35 === e || 44 === e || 65279 === e; e = 0 | i.charCodeAt(graphql_web_n++)) {
    if (35 === e) {
      while (10 !== (e = i.charCodeAt(graphql_web_n++)) && 13 !== e) {}
    }
  }
  graphql_web_n--;
}

var t = /[_A-Za-z]\w*/y;

function graphql_web_name() {
  var e;
  if (e = advance(t)) {
    return {
      kind: "Name",
      value: e
    };
  }
}

var graphql_web_o = /(?:null|true|false)/y;

var l = /\$[_A-Za-z]\w*/y;

var u = /-?\d+/y;

var v = /(?:\.\d+)?[eE][+-]?\d+|\.\d+/y;

var d = /\\/g;

var graphql_web_s = /"""(?:"""|(?:[\s\S]*?[^\\])""")/y;

var c = /"(?:"|[^\r\n]*?[^\\]")/y;

function value(e) {
  var r;
  var a;
  if (a = advance(graphql_web_o)) {
    r = "null" === a ? {
      kind: "NullValue"
    } : {
      kind: "BooleanValue",
      value: "true" === a
    };
  } else if (!e && (a = advance(l))) {
    r = {
      kind: "Variable",
      name: {
        kind: "Name",
        value: a.slice(1)
      }
    };
  } else if (a = advance(u)) {
    var f = a;
    if (a = advance(v)) {
      r = {
        kind: "FloatValue",
        value: f + a
      };
    } else {
      r = {
        kind: "IntValue",
        value: f
      };
    }
  } else if (a = advance(t)) {
    r = {
      kind: "EnumValue",
      value: a
    };
  } else if (a = advance(graphql_web_s)) {
    r = {
      kind: "StringValue",
      value: blockString(a.slice(3, -3)),
      block: !0
    };
  } else if (a = advance(c)) {
    r = {
      kind: "StringValue",
      value: d.test(a) ? JSON.parse(a) : a.slice(1, -1),
      block: !1
    };
  } else if (r = function list(e) {
    var r;
    if (91 === i.charCodeAt(graphql_web_n)) {
      graphql_web_n++;
      ignored();
      var a = [];
      while (r = value(e)) {
        a.push(r);
      }
      if (93 !== i.charCodeAt(graphql_web_n++)) {
        throw error("ListValue");
      }
      ignored();
      return {
        kind: "ListValue",
        values: a
      };
    }
  }(e) || function object(e) {
    if (123 === i.charCodeAt(graphql_web_n)) {
      graphql_web_n++;
      ignored();
      var r = [];
      var a;
      while (a = graphql_web_name()) {
        ignored();
        if (58 !== i.charCodeAt(graphql_web_n++)) {
          throw error("ObjectField");
        }
        ignored();
        var t = value(e);
        if (!t) {
          throw error("ObjectField");
        }
        r.push({
          kind: "ObjectField",
          name: a,
          value: t
        });
      }
      if (125 !== i.charCodeAt(graphql_web_n++)) {
        throw error("ObjectValue");
      }
      ignored();
      return {
        kind: "ObjectValue",
        fields: r
      };
    }
  }(e)) {
    return r;
  }
  ignored();
  return r;
}

function arguments_(e) {
  var r = [];
  ignored();
  if (40 === i.charCodeAt(graphql_web_n)) {
    graphql_web_n++;
    ignored();
    var a;
    while (a = graphql_web_name()) {
      ignored();
      if (58 !== i.charCodeAt(graphql_web_n++)) {
        throw error("Argument");
      }
      ignored();
      var t = value(e);
      if (!t) {
        throw error("Argument");
      }
      r.push({
        kind: "Argument",
        name: a,
        value: t
      });
    }
    if (!r.length || 41 !== i.charCodeAt(graphql_web_n++)) {
      throw error("Argument");
    }
    ignored();
  }
  return r;
}

function directives(e) {
  var r = [];
  ignored();
  while (64 === i.charCodeAt(graphql_web_n)) {
    graphql_web_n++;
    var a = graphql_web_name();
    if (!a) {
      throw error("Directive");
    }
    ignored();
    r.push({
      kind: "Directive",
      name: a,
      arguments: arguments_(e)
    });
  }
  return r;
}

function field() {
  var e = graphql_web_name();
  if (e) {
    ignored();
    var r;
    if (58 === i.charCodeAt(graphql_web_n)) {
      graphql_web_n++;
      ignored();
      r = e;
      if (!(e = graphql_web_name())) {
        throw error("Field");
      }
      ignored();
    }
    return {
      kind: "Field",
      alias: r,
      name: e,
      arguments: arguments_(!1),
      directives: directives(!1),
      selectionSet: selectionSet()
    };
  }
}

function type() {
  var e;
  ignored();
  if (91 === i.charCodeAt(graphql_web_n)) {
    graphql_web_n++;
    ignored();
    var r = type();
    if (!r || 93 !== i.charCodeAt(graphql_web_n++)) {
      throw error("ListType");
    }
    e = {
      kind: "ListType",
      type: r
    };
  } else if (e = graphql_web_name()) {
    e = {
      kind: "NamedType",
      name: e
    };
  } else {
    throw error("NamedType");
  }
  ignored();
  if (33 === i.charCodeAt(graphql_web_n)) {
    graphql_web_n++;
    ignored();
    return {
      kind: "NonNullType",
      type: e
    };
  } else {
    return e;
  }
}

var f = /on/y;

function typeCondition() {
  if (advance(f)) {
    ignored();
    var e = graphql_web_name();
    if (!e) {
      throw error("NamedType");
    }
    ignored();
    return {
      kind: "NamedType",
      name: e
    };
  }
}

var p = /\.\.\./y;

function fragmentSpread() {
  if (advance(p)) {
    ignored();
    var e = graphql_web_n;
    var r;
    if ((r = graphql_web_name()) && "on" !== r.value) {
      return {
        kind: "FragmentSpread",
        name: r,
        directives: directives(!1)
      };
    } else {
      graphql_web_n = e;
      var i = typeCondition();
      var a = directives(!1);
      var t = selectionSet();
      if (!t) {
        throw error("InlineFragment");
      }
      return {
        kind: "InlineFragment",
        typeCondition: i,
        directives: a,
        selectionSet: t
      };
    }
  }
}

function selectionSet() {
  var e;
  ignored();
  if (123 === i.charCodeAt(graphql_web_n)) {
    graphql_web_n++;
    ignored();
    var r = [];
    while (e = fragmentSpread() || field()) {
      r.push(e);
    }
    if (!r.length || 125 !== i.charCodeAt(graphql_web_n++)) {
      throw error("SelectionSet");
    }
    ignored();
    return {
      kind: "SelectionSet",
      selections: r
    };
  }
}

var m = /fragment/y;

function fragmentDefinition() {
  if (advance(m)) {
    ignored();
    var e = graphql_web_name();
    if (!e) {
      throw error("FragmentDefinition");
    }
    ignored();
    var r = typeCondition();
    if (!r) {
      throw error("FragmentDefinition");
    }
    var i = directives(!1);
    var n = selectionSet();
    if (!n) {
      throw error("FragmentDefinition");
    }
    return {
      kind: "FragmentDefinition",
      name: e,
      typeCondition: r,
      directives: i,
      selectionSet: n
    };
  }
}

var g = /(?:query|mutation|subscription)/y;

function operationDefinition() {
  var e;
  var r;
  var a = [];
  var t = [];
  if (e = advance(g)) {
    ignored();
    r = graphql_web_name();
    a = function variableDefinitions() {
      var e;
      var r = [];
      ignored();
      if (40 === i.charCodeAt(graphql_web_n)) {
        graphql_web_n++;
        ignored();
        while (e = advance(l)) {
          ignored();
          if (58 !== i.charCodeAt(graphql_web_n++)) {
            throw error("VariableDefinition");
          }
          var a = type();
          var t = void 0;
          if (61 === i.charCodeAt(graphql_web_n)) {
            graphql_web_n++;
            ignored();
            if (!(t = value(!0))) {
              throw error("VariableDefinition");
            }
          }
          ignored();
          r.push({
            kind: "VariableDefinition",
            variable: {
              kind: "Variable",
              name: {
                kind: "Name",
                value: e.slice(1)
              }
            },
            type: a,
            defaultValue: t,
            directives: directives(!0)
          });
        }
        if (41 !== i.charCodeAt(graphql_web_n++)) {
          throw error("VariableDefinition");
        }
        ignored();
      }
      return r;
    }();
    t = directives(!1);
  }
  var o = selectionSet();
  if (o) {
    return {
      kind: "OperationDefinition",
      operation: e || "query",
      name: r,
      variableDefinitions: a,
      directives: t,
      selectionSet: o
    };
  }
}

function parse(e, r) {
  i = "string" == typeof e.body ? e.body : e;
  graphql_web_n = 0;
  return function document() {
    var e;
    ignored();
    var r = [];
    while (e = fragmentDefinition() || operationDefinition()) {
      r.push(e);
    }
    return {
      kind: "Document",
      definitions: r
    };
  }();
}

function parseValue(e, r) {
  i = "string" == typeof e.body ? e.body : e;
  graphql_web_n = 0;
  ignored();
  var a = value(!1);
  if (!a) {
    throw error("ValueNode");
  }
  return a;
}

function parseType(e, r) {
  i = "string" == typeof e.body ? e.body : e;
  graphql_web_n = 0;
  return type();
}

var h = {};

function visit(e, r) {
  var i = [];
  var n = [];
  try {
    var a = function traverse(e, a, t) {
      var o = !1;
      var l = r[e.kind] && r[e.kind].enter || r[e.kind] || r.enter;
      var u = l && l.call(r, e, a, t, n, i);
      if (!1 === u) {
        return e;
      } else if (null === u) {
        return null;
      } else if (u === h) {
        throw h;
      } else if (u && "string" == typeof u.kind) {
        o = u !== e;
        e = u;
      }
      if (t) {
        i.push(t);
      }
      var v;
      var d = {
        ...e
      };
      for (var s in e) {
        n.push(s);
        var c = e[s];
        if (Array.isArray(c)) {
          var f = [];
          for (var p = 0; p < c.length; p++) {
            if (null != c[p] && "string" == typeof c[p].kind) {
              i.push(e);
              n.push(p);
              v = traverse(c[p], p, c);
              n.pop();
              i.pop();
              if (null == v) {
                o = !0;
              } else {
                o = o || v !== c[p];
                f.push(v);
              }
            }
          }
          c = f;
        } else if (null != c && "string" == typeof c.kind) {
          if (void 0 !== (v = traverse(c, s, e))) {
            o = o || c !== v;
            c = v;
          }
        }
        n.pop();
        if (o) {
          d[s] = c;
        }
      }
      if (t) {
        i.pop();
      }
      var m = r[e.kind] && r[e.kind].leave || r.leave;
      var g = m && m.call(r, e, a, t, n, i);
      if (g === h) {
        throw h;
      } else if (void 0 !== g) {
        return g;
      } else if (void 0 !== u) {
        return o ? d : u;
      } else {
        return o ? d : e;
      }
    }(e);
    return void 0 !== a && !1 !== a ? a : e;
  } catch (r) {
    if (r !== h) {
      throw r;
    }
    return e;
  }
}

function printString(e) {
  return JSON.stringify(e);
}

function printBlockString(e) {
  return '"""\n' + e.replace(/"""/g, '\\"""') + '\n"""';
}

var hasItems = e => !(!e || !e.length);

var y = {
  OperationDefinition(e) {
    if ("query" === e.operation && !e.name && !hasItems(e.variableDefinitions) && !hasItems(e.directives)) {
      return y.SelectionSet(e.selectionSet);
    }
    var r = e.operation;
    if (e.name) {
      r += " " + e.name.value;
    }
    if (hasItems(e.variableDefinitions)) {
      if (!e.name) {
        r += " ";
      }
      r += "(" + e.variableDefinitions.map(y.VariableDefinition).join(", ") + ")";
    }
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(y.Directive).join(" ");
    }
    return r + " " + y.SelectionSet(e.selectionSet);
  },
  VariableDefinition(e) {
    var r = y.Variable(e.variable) + ": " + print(e.type);
    if (e.defaultValue) {
      r += " = " + print(e.defaultValue);
    }
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(y.Directive).join(" ");
    }
    return r;
  },
  Field(e) {
    var r = (e.alias ? e.alias.value + ": " : "") + e.name.value;
    if (hasItems(e.arguments)) {
      var i = e.arguments.map(y.Argument);
      var n = r + "(" + i.join(", ") + ")";
      r = n.length > 80 ? r + "(\n  " + i.join("\n").replace(/\n/g, "\n  ") + "\n)" : n;
    }
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(y.Directive).join(" ");
    }
    return e.selectionSet ? r + " " + y.SelectionSet(e.selectionSet) : r;
  },
  StringValue: e => e.block ? printBlockString(e.value) : printString(e.value),
  BooleanValue: e => "" + e.value,
  NullValue: e => "null",
  IntValue: e => e.value,
  FloatValue: e => e.value,
  EnumValue: e => e.value,
  Name: e => e.value,
  Variable: e => "$" + e.name.value,
  ListValue: e => "[" + e.values.map(print).join(", ") + "]",
  ObjectValue: e => "{" + e.fields.map(y.ObjectField).join(", ") + "}",
  ObjectField: e => e.name.value + ": " + print(e.value),
  Document: e => hasItems(e.definitions) ? e.definitions.map(print).join("\n\n") : "",
  SelectionSet: e => "{\n  " + e.selections.map(print).join("\n").replace(/\n/g, "\n  ") + "\n}",
  Argument: e => e.name.value + ": " + print(e.value),
  FragmentSpread(e) {
    var r = "..." + e.name.value;
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(y.Directive).join(" ");
    }
    return r;
  },
  InlineFragment(e) {
    var r = "...";
    if (e.typeCondition) {
      r += " on " + e.typeCondition.name.value;
    }
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(y.Directive).join(" ");
    }
    return r + " " + print(e.selectionSet);
  },
  FragmentDefinition(e) {
    var r = "fragment " + e.name.value;
    r += " on " + e.typeCondition.name.value;
    if (hasItems(e.directives)) {
      r += " " + e.directives.map(y.Directive).join(" ");
    }
    return r + " " + print(e.selectionSet);
  },
  Directive(e) {
    var r = "@" + e.name.value;
    if (hasItems(e.arguments)) {
      r += "(" + e.arguments.map(y.Argument).join(", ") + ")";
    }
    return r;
  },
  NamedType: e => e.name.value,
  ListType: e => "[" + print(e.type) + "]",
  NonNullType: e => print(e.type) + "!"
};

function print(e) {
  return y[e.kind] ? y[e.kind](e) : "";
}

function valueFromASTUntyped(e, r) {
  switch (e.kind) {
   case "NullValue":
    return null;

   case "IntValue":
    return parseInt(e.value, 10);

   case "FloatValue":
    return parseFloat(e.value);

   case "StringValue":
   case "EnumValue":
   case "BooleanValue":
    return e.value;

   case "ListValue":
    var i = [];
    for (var n = 0, a = e.values; n < a.length; n += 1) {
      i.push(valueFromASTUntyped(a[n], r));
    }
    return i;

   case "ObjectValue":
    var t = Object.create(null);
    for (var o = 0, l = e.fields; o < l.length; o += 1) {
      var u = l[o];
      t[u.name.value] = valueFromASTUntyped(u.value, r);
    }
    return t;

   case "Variable":
    return r && r[e.name.value];
  }
}

function valueFromTypeNode(e, r, i) {
  if ("Variable" === e.kind) {
    return i ? valueFromTypeNode(i[e.name.value], r, i) : void 0;
  } else if ("NonNullType" === r.kind) {
    return "NullValue" !== e.kind ? valueFromTypeNode(e, r, i) : void 0;
  } else if ("NullValue" === e.kind) {
    return null;
  } else if ("ListType" === r.kind) {
    if ("ListValue" === e.kind) {
      var n = [];
      for (var a = 0, t = e.values; a < t.length; a += 1) {
        var o = valueFromTypeNode(t[a], r.type, i);
        if (void 0 === o) {
          return;
        } else {
          n.push(o);
        }
      }
      return n;
    }
  } else if ("NamedType" === r.kind) {
    switch (r.name.value) {
     case "Int":
     case "Float":
     case "String":
     case "Bool":
      return r.name.value + "Value" === e.kind ? valueFromASTUntyped(e, i) : void 0;

     default:
      return valueFromASTUntyped(e, i);
    }
  }
}


//# sourceMappingURL=graphql.web.mjs.map

;// CONCATENATED MODULE: ../../node_modules/@urql/core/dist/urql-core-chunk.mjs




var rehydrateGraphQlError = e => {
  if (e && e.message && (e.extensions || "GraphQLError" === e.name)) {
    return e;
  } else if ("object" == typeof e && e.message) {
    return new r(e.message, e.nodes, e.source, e.positions, e.path, e, e.extensions || {});
  } else {
    return new r(e);
  }
};

class CombinedError extends Error {
  constructor(r) {
    var e = (r.graphQLErrors || []).map(rehydrateGraphQlError);
    var t = ((r, e) => {
      var t = "";
      if (r) {
        return `[Network] ${r.message}`;
      }
      if (e) {
        for (var a of e) {
          if (t) {
            t += "\n";
          }
          t += `[GraphQL] ${a.message}`;
        }
      }
      return t;
    })(r.networkError, e);
    super(t);
    this.name = "CombinedError";
    this.message = t;
    this.graphQLErrors = e;
    this.networkError = r.networkError;
    this.response = r.response;
  }
  toString() {
    return this.message;
  }
}

var phash = (r, e) => {
  var t = 0 | (e || 5381);
  for (var a = 0, o = 0 | r.length; a < o; a++) {
    t = (t << 5) + t + r.charCodeAt(a);
  }
  return t;
};

var urql_core_chunk_i = new Set;

var urql_core_chunk_f = new WeakMap;

var stringify = r => {
  if (null === r || urql_core_chunk_i.has(r)) {
    return "null";
  } else if ("object" != typeof r) {
    return JSON.stringify(r) || "";
  } else if (r.toJSON) {
    return stringify(r.toJSON());
  } else if (Array.isArray(r)) {
    var e = "[";
    for (var t of r) {
      if (e.length > 1) {
        e += ",";
      }
      e += stringify(t) || "null";
    }
    return e += "]";
  } else if (urql_core_chunk_v !== NoopConstructor && r instanceof urql_core_chunk_v || urql_core_chunk_l !== NoopConstructor && r instanceof urql_core_chunk_l) {
    return "null";
  }
  var a = Object.keys(r).sort();
  if (!a.length && r.constructor && Object.getPrototypeOf(r).constructor !== Object.prototype.constructor) {
    var o = urql_core_chunk_f.get(r) || Math.random().toString(36).slice(2);
    urql_core_chunk_f.set(r, o);
    return stringify({
      __key: o
    });
  }
  urql_core_chunk_i.add(r);
  var n = "{";
  for (var s of a) {
    var c = stringify(r[s]);
    if (c) {
      if (n.length > 1) {
        n += ",";
      }
      n += stringify(s) + ":" + c;
    }
  }
  urql_core_chunk_i.delete(r);
  return n += "}";
};

var extract = (r, e, t) => {
  if (null == t || "object" != typeof t || t.toJSON || urql_core_chunk_i.has(t)) {} else if (Array.isArray(t)) {
    for (var a = 0, o = t.length; a < o; a++) {
      extract(r, `${e}.${a}`, t[a]);
    }
  } else if (t instanceof urql_core_chunk_v || t instanceof urql_core_chunk_l) {
    r.set(e, t);
  } else {
    urql_core_chunk_i.add(t);
    for (var n of Object.keys(t)) {
      extract(r, `${e}.${n}`, t[n]);
    }
  }
};

var stringifyVariables = r => {
  urql_core_chunk_i.clear();
  return stringify(r);
};

class NoopConstructor {}

var urql_core_chunk_v = "undefined" != typeof File ? File : NoopConstructor;

var urql_core_chunk_l = "undefined" != typeof Blob ? Blob : NoopConstructor;

var urql_core_chunk_c = /("{3}[\s\S]*"{3}|"(?:\\.|[^"])*")/g;

var urql_core_chunk_p = /(?:#[^\n\r]+)?(?:[\r\n]+|$)/g;

var replaceOutsideStrings = (r, e) => e % 2 == 0 ? r.replace(urql_core_chunk_p, "\n") : r;

var sanitizeDocument = r => r.split(urql_core_chunk_c).map(replaceOutsideStrings).join("").trim();

var urql_core_chunk_d = new Map;

var urql_core_chunk_u = new Map;

var stringifyDocument = r => {
  var t;
  if ("string" == typeof r) {
    t = sanitizeDocument(r);
  } else if (r.loc && urql_core_chunk_u.get(r.__key) === r) {
    t = r.loc.source.body;
  } else {
    t = urql_core_chunk_d.get(r) || sanitizeDocument(print(r));
    urql_core_chunk_d.set(r, t);
  }
  if ("string" != typeof r && !r.loc) {
    r.loc = {
      start: 0,
      end: t.length,
      source: {
        body: t,
        name: "gql",
        locationOffset: {
          line: 1,
          column: 1
        }
      }
    };
  }
  return t;
};

var hashDocument = r => {
  var e = phash(stringifyDocument(r));
  if (r.definitions) {
    var t = getOperationName(r);
    if (t) {
      e = phash(`\n# ${t}`, e);
    }
  }
  return e;
};

var keyDocument = r => {
  var e;
  var a;
  if ("string" == typeof r) {
    e = hashDocument(r);
    a = urql_core_chunk_u.get(e) || parse(r, {
      noLocation: !0
    });
  } else {
    e = r.__key || hashDocument(r);
    a = urql_core_chunk_u.get(e) || r;
  }
  if (!a.loc) {
    stringifyDocument(a);
  }
  a.__key = e;
  urql_core_chunk_u.set(e, a);
  return a;
};

var createRequest = (r, e, t) => {
  var a = e || {};
  var o = keyDocument(r);
  var n = stringifyVariables(a);
  var s = o.__key;
  if ("{}" !== n) {
    s = phash(n, s);
  }
  return {
    key: s,
    query: o,
    variables: a,
    extensions: t
  };
};

var getOperationName = r => {
  for (var e of r.definitions) {
    if (e.kind === graphql_web_e.OPERATION_DEFINITION) {
      return e.name ? e.name.value : void 0;
    }
  }
};

var getOperationType = r => {
  for (var e of r.definitions) {
    if (e.kind === a.OPERATION_DEFINITION) {
      return e.operation;
    }
  }
};

var makeResult = (r, e, t) => {
  if (!("data" in e || "errors" in e && Array.isArray(e.errors))) {
    throw new Error("No Content");
  }
  var a = "subscription" === r.kind;
  return {
    operation: r,
    data: e.data,
    error: Array.isArray(e.errors) ? new CombinedError({
      graphQLErrors: e.errors,
      response: t
    }) : void 0,
    extensions: e.extensions ? {
      ...e.extensions
    } : void 0,
    hasNext: null == e.hasNext ? a : e.hasNext,
    stale: !1
  };
};

var deepMerge = (r, e) => {
  if ("object" == typeof r && null != r) {
    if (!r.constructor || r.constructor === Object || Array.isArray(r)) {
      r = Array.isArray(r) ? [ ...r ] : {
        ...r
      };
      for (var t of Object.keys(e)) {
        r[t] = deepMerge(r[t], e[t]);
      }
      return r;
    }
  }
  return e;
};

var mergeResultPatch = (r, e, t, a) => {
  var o = r.error ? r.error.graphQLErrors : [];
  var n = !!r.extensions || !!e.extensions;
  var s = {
    ...r.extensions,
    ...e.extensions
  };
  var i = e.incremental;
  if ("path" in e) {
    i = [ e ];
  }
  var f = {
    data: r.data
  };
  if (i) {
    var _loop = function(r) {
      if (Array.isArray(r.errors)) {
        o.push(...r.errors);
      }
      if (r.extensions) {
        Object.assign(s, r.extensions);
        n = !0;
      }
      var e = "data";
      var t = f;
      var i = [];
      if (r.path) {
        i = r.path;
      } else if (a) {
        var v = a.find((e => e.id === r.id));
        if (r.subPath) {
          i = [ ...v.path, ...r.subPath ];
        } else {
          i = v.path;
        }
      }
      for (var l = 0, c = i.length; l < c; e = i[l++]) {
        t = t[e] = Array.isArray(t[e]) ? [ ...t[e] ] : {
          ...t[e]
        };
      }
      if (r.items) {
        var p = +e >= 0 ? e : 0;
        for (var d = 0, u = r.items.length; d < u; d++) {
          t[p + d] = deepMerge(t[p + d], r.items[d]);
        }
      } else if (void 0 !== r.data) {
        t[e] = deepMerge(t[e], r.data);
      }
    };
    for (var v of i) {
      _loop(v);
    }
  } else {
    f.data = e.data || r.data;
    o = e.errors || o;
  }
  return {
    operation: r.operation,
    data: f.data,
    error: o.length ? new CombinedError({
      graphQLErrors: o,
      response: t
    }) : void 0,
    extensions: n ? s : void 0,
    hasNext: null != e.hasNext ? e.hasNext : r.hasNext,
    stale: !1
  };
};

var makeErrorResult = (r, e, t) => ({
  operation: r,
  data: void 0,
  error: new CombinedError({
    networkError: e,
    response: t
  }),
  extensions: void 0,
  hasNext: !1,
  stale: !1
});

function makeFetchBody(r) {
  return {
    query: r.extensions && r.extensions.persistedQuery && !r.extensions.persistedQuery.miss ? void 0 : stringifyDocument(r.query),
    operationName: getOperationName(r.query),
    variables: r.variables || void 0,
    extensions: r.extensions
  };
}

var makeFetchURL = (r, e) => {
  var t = "query" === r.kind && r.context.preferGetMethod;
  if (!t || !e) {
    return r.context.url;
  }
  var a = new URL(r.context.url);
  for (var o in e) {
    var n = e[o];
    if (n) {
      a.searchParams.set(o, "object" == typeof n ? stringifyVariables(n) : n);
    }
  }
  var s = a.toString();
  if (s.length > 2047 && "force" !== t) {
    r.context.preferGetMethod = !1;
    return r.context.url;
  }
  return s;
};

var serializeBody = (r, e) => {
  if (e && !("query" === r.kind && !!r.context.preferGetMethod)) {
    var t = stringifyVariables(e);
    var a = (r => {
      var e = new Map;
      if (urql_core_chunk_v !== NoopConstructor || urql_core_chunk_l !== NoopConstructor) {
        urql_core_chunk_i.clear();
        extract(e, "variables", r);
      }
      return e;
    })(e.variables);
    if (a.size) {
      var o = new FormData;
      o.append("operations", t);
      o.append("map", stringifyVariables({
        ...[ ...a.keys() ].map((r => [ r ]))
      }));
      var n = 0;
      for (var s of a.values()) {
        o.append("" + n++, s);
      }
      return o;
    }
    return t;
  }
};

var makeFetchOptions = (r, e) => {
  var t = {
    accept: "subscription" === r.kind ? "text/event-stream, multipart/mixed" : "application/graphql-response+json, application/graphql+json, application/json, text/event-stream, multipart/mixed"
  };
  var a = ("function" == typeof r.context.fetchOptions ? r.context.fetchOptions() : r.context.fetchOptions) || {};
  if (a.headers) {
    for (var o in a.headers) {
      t[o.toLowerCase()] = a.headers[o];
    }
  }
  var n = serializeBody(r, e);
  if ("string" == typeof n && !t["content-type"]) {
    t["content-type"] = "application/json";
  }
  return {
    ...a,
    method: n ? "POST" : "GET",
    body: n,
    headers: t
  };
};

var urql_core_chunk_y = "undefined" != typeof TextDecoder ? new TextDecoder : null;

var urql_core_chunk_h = /boundary="?([^=";]+)"?/i;

var x = /data: ?([^\n]+)/;

var urql_core_chunk_toString = r => "Buffer" === r.constructor.name ? r.toString() : urql_core_chunk_y.decode(r);

async function* streamBody(r) {
  if (r.body[Symbol.asyncIterator]) {
    for await (var e of r.body) {
      yield urql_core_chunk_toString(e);
    }
  } else {
    var t = r.body.getReader();
    var a;
    try {
      while (!(a = await t.read()).done) {
        yield urql_core_chunk_toString(a.value);
      }
    } finally {
      t.cancel();
    }
  }
}

async function* split(r, e) {
  var t = "";
  var a;
  for await (var o of r) {
    t += o;
    while ((a = t.indexOf(e)) > -1) {
      yield t.slice(0, a);
      t = t.slice(a + e.length);
    }
  }
}

async function* fetchOperation(r, e, t) {
  var a = !0;
  var o = null;
  var n;
  try {
    yield await Promise.resolve();
    var s = (n = await (r.context.fetch || fetch)(e, t)).headers.get("Content-Type") || "";
    var i;
    if (/multipart\/mixed/i.test(s)) {
      i = async function* parseMultipartMixed(r, e) {
        var t = r.match(urql_core_chunk_h);
        var a = "--" + (t ? t[1] : "-");
        var o = !0;
        var n;
        for await (var s of split(streamBody(e), "\r\n" + a)) {
          if (o) {
            o = !1;
            var i = s.indexOf(a);
            if (i > -1) {
              s = s.slice(i + a.length);
            } else {
              continue;
            }
          }
          try {
            yield n = JSON.parse(s.slice(s.indexOf("\r\n\r\n") + 4));
          } catch (r) {
            if (!n) {
              throw r;
            }
          }
          if (n && !1 === n.hasNext) {
            break;
          }
        }
        if (n && !1 !== n.hasNext) {
          yield {
            hasNext: !1
          };
        }
      }(s, n);
    } else if (/text\/event-stream/i.test(s)) {
      i = async function* parseEventStream(r) {
        var e;
        for await (var t of split(streamBody(r), "\n\n")) {
          var a = t.match(x);
          if (a) {
            var o = a[1];
            try {
              yield e = JSON.parse(o);
            } catch (r) {
              if (!e) {
                throw r;
              }
            }
            if (e && !1 === e.hasNext) {
              break;
            }
          }
        }
        if (e && !1 !== e.hasNext) {
          yield {
            hasNext: !1
          };
        }
      }(n);
    } else if (!/text\//i.test(s)) {
      i = async function* parseJSON(r) {
        yield JSON.parse(await r.text());
      }(n);
    } else {
      i = async function* parseMaybeJSON(r) {
        var e = await r.text();
        try {
          var t = JSON.parse(e);
          if (false) {}
          yield t;
        } catch (r) {
          throw new Error(e);
        }
      }(n);
    }
    var f;
    for await (var v of i) {
      if (v.pending && !o) {
        f = v.pending;
      } else if (v.pending) {
        f = [ ...f, ...v.pending ];
      }
      o = o ? mergeResultPatch(o, v, n, f) : makeResult(r, v, n);
      a = !1;
      yield o;
      a = !0;
    }
    if (!o) {
      yield o = makeResult(r, {}, n);
    }
  } catch (e) {
    if (!a) {
      throw e;
    }
    yield makeErrorResult(r, n && (n.status < 200 || n.status >= 300) && n.statusText ? new Error(n.statusText) : e, n);
  }
}

function makeFetchSource(r, e, t) {
  var a;
  if ("undefined" != typeof AbortController) {
    t.signal = (a = new AbortController).signal;
  }
  return o((() => {
    if (a) {
      a.abort();
    }
  }))(n((r => !!r))(s(fetchOperation(r, e, t))));
}


//# sourceMappingURL=urql-core-chunk.mjs.map


/***/ }),

/***/ 93466:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "eI": function() { return /* binding */ j; },
/* harmony export */   "vx": function() { return /* binding */ makeOperation; }
/* harmony export */ });
/* unused harmony exports Client, cacheExchange, composeExchanges, debugExchange, dedupExchange, errorExchange, fetchExchange, formatDocument, gql, mapExchange, maskTypename, ssrExchange, subscriptionExchange */
/* harmony import */ var _urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97123);
/* harmony import */ var wonka__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94177);








var collectTypes = (e, r) => {
  if (Array.isArray(e)) {
    for (var t of e) {
      collectTypes(t, r);
    }
  } else if ("object" == typeof e && null !== e) {
    for (var n in e) {
      if ("__typename" === n && "string" == typeof e[n]) {
        r.add(e[n]);
      } else {
        collectTypes(e[n], r);
      }
    }
  }
  return r;
};

var formatNode = r => {
  if ("definitions" in r) {
    var t = [];
    for (var n of r.definitions) {
      var a = formatNode(n);
      t.push(a);
    }
    return {
      ...r,
      definitions: t
    };
  }
  if ("directives" in r && r.directives && r.directives.length) {
    var o = [];
    var i = {};
    for (var s of r.directives) {
      var c = s.name.value;
      if ("_" !== c[0]) {
        o.push(s);
      } else {
        c = c.slice(1);
      }
      i[c] = s;
    }
    r = {
      ...r,
      directives: o,
      _directives: i
    };
  }
  if ("selectionSet" in r) {
    var u = [];
    var p = r.kind === e.OPERATION_DEFINITION;
    if (r.selectionSet) {
      for (var d of r.selectionSet.selections || []) {
        p = p || d.kind === e.FIELD && "__typename" === d.name.value && !d.alias;
        var v = formatNode(d);
        u.push(v);
      }
      if (!p) {
        u.push({
          kind: e.FIELD,
          name: {
            kind: e.NAME,
            value: "__typename"
          },
          _generated: !0
        });
      }
      return {
        ...r,
        selectionSet: {
          ...r.selectionSet,
          selections: u
        }
      };
    }
  }
  return r;
};

var I = new Map;

var formatDocument = e => {
  var t = r(e);
  var n = I.get(t.__key);
  if (!n) {
    I.set(t.__key, n = formatNode(t));
    Object.defineProperty(n, "__key", {
      value: t.__key,
      enumerable: !1
    });
  }
  return n;
};

var maskTypename = (e, r) => {
  if (!e || "object" != typeof e) {
    return e;
  } else if (Array.isArray(e)) {
    return e.map((e => maskTypename(e)));
  } else if (e && "object" == typeof e && (r || "__typename" in e)) {
    var t = {};
    for (var n in e) {
      if ("__typename" === n) {
        Object.defineProperty(t, "__typename", {
          enumerable: !1,
          value: e.__typename
        });
      } else {
        t[n] = maskTypename(e[n]);
      }
    }
    return t;
  } else {
    return e;
  }
};

function withPromise(e) {
  var source$ = r => e(r);
  source$.toPromise = () => (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .toPromise */ .Vi)((0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .take */ .qn)(1)((0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .filter */ .hX)((e => !e.stale && !e.hasNext))(source$)));
  source$.then = (e, r) => source$.toPromise().then(e, r);
  source$.subscribe = e => (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .subscribe */ .Ld)(e)(source$);
  return source$;
}

function makeOperation(e, r, t) {
  return {
    ...r,
    kind: e,
    context: r.context ? {
      ...r.context,
      ...t
    } : t || r.context
  };
}

var addMetadata = (e, r) => makeOperation(e.kind, e, {
  meta: {
    ...e.context.meta,
    ...r
  }
});

var noop = () => {};

function gql(n) {
  var a = new Map;
  var o = [];
  var i = [];
  var s = Array.isArray(n) ? n[0] : n || "";
  for (var c = 1; c < arguments.length; c++) {
    var u = arguments[c];
    if (u && u.definitions) {
      i.push(u);
    } else {
      s += u;
    }
    s += arguments[0][c];
  }
  i.unshift(r(s));
  for (var p of i) {
    for (var d of p.definitions) {
      if (d.kind === e.FRAGMENT_DEFINITION) {
        var v = d.name.value;
        var f = t(d);
        if (!a.has(v)) {
          a.set(v, f);
          o.push(d);
        } else if (false) {}
      } else {
        o.push(d);
      }
    }
  }
  return r({
    kind: e.DOCUMENT,
    definitions: o
  });
}

var shouldSkip = ({kind: e}) => "mutation" !== e && "query" !== e;

var mapTypeNames = e => {
  var r = formatDocument(e.query);
  if (r !== e.query) {
    var t = makeOperation(e.kind, e);
    t.query = r;
    return t;
  } else {
    return e;
  }
};

var cacheExchange = ({forward: e, client: r, dispatchDebug: t}) => {
  var a = new Map;
  var o = new Map;
  var isOperationCached = e => "query" === e.kind && "network-only" !== e.context.requestPolicy && ("cache-only" === e.context.requestPolicy || a.has(e.key));
  return i => {
    var s = m((e => {
      var o = a.get(e.key);
       false && 0;
      var i = o || n(e, {
        data: null
      });
      i = {
        ...i,
        operation:  false ? 0 : e
      };
      if ("cache-and-network" === e.context.requestPolicy) {
        i.stale = !0;
        reexecuteOperation(r, e);
      }
      return i;
    }))(y((e => !shouldSkip(e) && isOperationCached(e)))(i));
    var c = x((e => {
      var {operation: n} = e;
      if (!n) {
        return;
      }
      var i = n.context.additionalTypenames || [];
      if ("subscription" !== e.operation.kind) {
        i = (e => [ ...collectTypes(e, new Set) ])(e.data).concat(i);
      }
      if ("mutation" === e.operation.kind || "subscription" === e.operation.kind) {
        var s = new Set;
         false && 0;
        for (var c = 0; c < i.length; c++) {
          var u = i[c];
          var p = o.get(u);
          if (!p) {
            o.set(u, p = new Set);
          }
          for (var d of p.values()) {
            s.add(d);
          }
          p.clear();
        }
        for (var v of s.values()) {
          if (a.has(v)) {
            n = a.get(v).operation;
            a.delete(v);
            reexecuteOperation(r, n);
          }
        }
      } else if ("query" === n.kind && e.data) {
        a.set(n.key, e);
        for (var f = 0; f < i.length; f++) {
          var l = i[f];
          var h = o.get(l);
          if (!h) {
            o.set(l, h = new Set);
          }
          h.add(n.key);
        }
      }
    }))(e(y((e => "query" !== e.kind || "cache-only" !== e.context.requestPolicy))(m((e =>  false ? 0 : e))(w([ m(mapTypeNames)(y((e => !shouldSkip(e) && !isOperationCached(e)))(i)), y((e => shouldSkip(e)))(i) ])))));
    return w([ s, c ]);
  };
};

var reexecuteOperation = (e, r) => e.reexecuteOperation(makeOperation(r.kind, r, {
  requestPolicy: "network-only"
}));

var T = new Set;

var ssrExchange = (e = {}) => {
  var r = !!e.staleWhileRevalidate;
  var t = !!e.includeExtensions;
  var n = {};
  var o = [];
  var invalidate = e => {
    o.push(e.operation.key);
    if (1 === o.length) {
      Promise.resolve().then((() => {
        var e;
        while (e = o.shift()) {
          n[e] = null;
        }
      }));
    }
  };
  var ssr = ({client: o, forward: i}) => s => {
    var c = e && "boolean" == typeof e.isClient ? !!e.isClient : !o.suspense;
    var u = i(m(mapTypeNames)(y((e => "teardown" === e.kind || !n[e.key] || !!n[e.key].hasNext || "network-only" === e.context.requestPolicy))(s)));
    var p = m((e => {
      var i = ((e, r, t) => ({
        operation: e,
        data: r.data ? JSON.parse(r.data) : void 0,
        extensions: t && r.extensions ? JSON.parse(r.extensions) : void 0,
        error: r.error ? new a({
          networkError: r.error.networkError ? new Error(r.error.networkError) : void 0,
          graphQLErrors: r.error.graphQLErrors
        }) : void 0,
        stale: !1,
        hasNext: !!r.hasNext
      }))(e, n[e.key], t);
      if (r && !T.has(e.key)) {
        i.stale = !0;
        T.add(e.key);
        reexecuteOperation(o, e);
      }
      return {
        ...i,
        operation:  false ? 0 : e
      };
    }))(y((e => "teardown" !== e.kind && !!n[e.key] && "network-only" !== e.context.requestPolicy))(s));
    if (!c) {
      u = x((e => {
        var {operation: r} = e;
        if ("mutation" !== r.kind) {
          var a = ((e, r) => {
            var t = {
              data: JSON.stringify(e.data),
              hasNext: e.hasNext
            };
            if (void 0 !== e.data) {
              t.data = JSON.stringify(e.data);
            }
            if (r && void 0 !== e.extensions) {
              t.extensions = JSON.stringify(e.extensions);
            }
            if (e.error) {
              t.error = {
                graphQLErrors: e.error.graphQLErrors.map((e => {
                  if (!e.path && !e.extensions) {
                    return e.message;
                  }
                  return {
                    message: e.message,
                    path: e.path,
                    extensions: e.extensions
                  };
                }))
              };
              if (e.error.networkError) {
                t.error.networkError = "" + e.error.networkError;
              }
            }
            return t;
          })(e, t);
          n[r.key] = a;
        }
      }))(u);
    } else {
      p = x(invalidate)(p);
    }
    return w([ u, p ]);
  };
  ssr.restoreData = e => {
    for (var r in e) {
      if (null !== n[r]) {
        n[r] = e[r];
      }
    }
  };
  ssr.extractData = () => {
    var e = {};
    for (var r in n) {
      if (null != n[r]) {
        e[r] = n[r];
      }
    }
    return e;
  };
  if (e && e.initialState) {
    ssr.restoreData(e.initialState);
  }
  return ssr;
};

var subscriptionExchange = ({forwardSubscription: e, enableAllOperations: r, isSubscriptionOperation: t}) => ({client: a, forward: i}) => {
  var u = t || (e => "subscription" === e.kind || !!r && ("query" === e.kind || "mutation" === e.kind));
  return r => {
    var t = g((t => {
      var {key: i} = t;
      var u = y((e => "teardown" === e.kind && e.key === i))(r);
      return E(u)((r => {
        var t = e(o(r), r);
        return O((e => {
          var o = !1;
          var i;
          var u;
          function nextResult(t) {
            e.next(u = u ? c(u, t) : n(r, t));
          }
          Promise.resolve().then((() => {
            if (o) {
              return;
            }
            i = t.subscribe({
              next: nextResult,
              error(t) {
                if (Array.isArray(t)) {
                  nextResult({
                    errors: t
                  });
                } else {
                  e.next(s(r, t));
                }
                e.complete();
              },
              complete() {
                if (!o) {
                  o = !0;
                  if ("subscription" === r.kind) {
                    a.reexecuteOperation(makeOperation("teardown", r, r.context));
                  }
                  if (u && u.hasNext) {
                    nextResult({
                      hasNext: !1
                    });
                  }
                  e.complete();
                }
              }
            });
          }));
          return () => {
            o = !0;
            if (i) {
              i.unsubscribe();
            }
          };
        }));
      })(t));
    }))(y((e => "teardown" !== e.kind && u(e)))(r));
    var p = i(y((e => "teardown" === e.kind || !u(e)))(r));
    return w([ t, p ]);
  };
};

var debugExchange = ({forward: e}) => {
  if (true) {
    return r => e(r);
  } else {}
};

var dedupExchange = ({forward: e}) => r => e(r);

var fetchExchange = ({forward: e, dispatchDebug: r}) => t => {
  var n = g((e => {
    var n = o(e);
    var a = u(e, n);
    var i = p(e, n);
     false && 0;
    var s = E(y((r => "teardown" === r.kind && r.key === e.key))(t))(d(e, a, i));
    if (false) {}
    return s;
  }))(y((e => "teardown" !== e.kind && ("subscription" !== e.kind || !!e.context.fetchSubscriptions)))(t));
  var a = e(y((e => "teardown" === e.kind || "subscription" === e.kind && !e.context.fetchSubscriptions))(t));
  return w([ n, a ]);
};

var composeExchanges = e => ({client: r, forward: t, dispatchDebug: n}) => e.reduceRight(((e, t) => {
  var a = !1;
  return t({
    client: r,
    forward(r) {
      if (false) {}
      return (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .share */ .BN)(e((0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .share */ .BN)(r)));
    },
    dispatchDebug(e) {
       false && 0;
    }
  });
}), t);

var mapExchange = ({onOperation: e, onResult: r, onError: t}) => ({forward: n}) => a => g((e => {
  if (t && e.error) {
    t(e.error, e.operation);
  }
  var n = r && r(e) || e;
  return "then" in n ? _(n) : q(n);
}))(n(g((r => {
  var t = e && e(r) || r;
  return "then" in t ? _(t) : q(t);
}))(a)));

var fallbackExchange = ({dispatchDebug: e}) => r => {
  if (false) {}
  return (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .filter */ .hX)((e => !1))(r);
};

var C = function Client(e) {
  if (false) {}
  var r = 0;
  var t = new Map;
  var n = new Map;
  var a = new Set;
  var o = [];
  var i = {
    url: e.url,
    fetchSubscriptions: e.fetchSubscriptions,
    fetchOptions: e.fetchOptions,
    fetch: e.fetch,
    preferGetMethod: e.preferGetMethod,
    requestPolicy: e.requestPolicy || "cache-first"
  };
  var s = (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .makeSubject */ .nN)();
  function nextOperation(e) {
    if ("mutation" === e.kind || "teardown" === e.kind || !a.has(e.key)) {
      if ("teardown" === e.kind) {
        a.delete(e.key);
      } else if ("mutation" !== e.kind) {
        a.add(e.key);
      }
      s.next(e);
    }
  }
  var c = !1;
  function dispatchOperation(e) {
    if (e) {
      nextOperation(e);
    }
    if (!c) {
      c = !0;
      while (c && (e = o.shift())) {
        nextOperation(e);
      }
      c = !1;
    }
  }
  var makeResultSource = r => {
    var i = (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .takeUntil */ .Rs)((0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .filter */ .hX)((e => "teardown" === e.kind && e.key === r.key))(s.source))((0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .filter */ .hX)((e => e.operation.kind === r.kind && e.operation.key === r.key && (!e.operation.context._instance || e.operation.context._instance === r.context._instance)))(O));
    if (e.maskTypename) {
      i = (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UI)((e => ({
        ...e,
        data: maskTypename(e.data, !0)
      })))(i);
    }
    if ("query" !== r.kind) {
      i = (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .takeWhile */ .oE)((e => !!e.hasNext), !0)(i);
    } else {
      i = (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .switchMap */ .wt)((e => {
        var t = (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .fromValue */ ._A)(e);
        return e.stale || e.hasNext ? t : (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TS)([ t, (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .map */ .UI)((() => {
          e.stale = !0;
          return e;
        }))((0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .take */ .qn)(1)((0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .filter */ .hX)((e => e.key === r.key))(s.source))) ]);
      }))(i);
    }
    if ("mutation" !== r.kind) {
      i = (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .onEnd */ .ok)((() => {
        a.delete(r.key);
        t.delete(r.key);
        n.delete(r.key);
        c = !1;
        for (var e = o.length - 1; e >= 0; e--) {
          if (o[e].key === r.key) {
            o.splice(e, 1);
          }
        }
        nextOperation(makeOperation("teardown", r, r.context));
      }))((0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .onPush */ .Mq)((e => {
        if (e.stale) {
          for (var n of o) {
            if (n.key === e.operation.key) {
              a.delete(n.key);
              break;
            }
          }
        } else if (!e.hasNext) {
          a.delete(r.key);
        }
        t.set(r.key, e);
      }))(i));
    } else {
      i = (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .onStart */ .Hr)((() => {
        nextOperation(r);
      }))(i);
    }
    return (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .share */ .BN)(i);
  };
  var u = this instanceof Client ? this : Object.create(Client.prototype);
  var p = Object.assign(u, {
    suspense: !!e.suspense,
    operations$: s.source,
    reexecuteOperation(e) {
      if ("teardown" === e.kind) {
        dispatchOperation(e);
      } else if ("mutation" === e.kind || n.has(e.key)) {
        var r = !1;
        for (var t = 0; t < o.length; t++) {
          r = r || o[t].key === e.key;
        }
        if (!r) {
          a.delete(e.key);
        }
        o.push(e);
        Promise.resolve().then(dispatchOperation);
      }
    },
    createRequestOperation(e, t, n) {
      if (!n) {
        n = {};
      }
      var a;
      if (false) {}
      return makeOperation(e, t, {
        _instance: "mutation" === e ? r = r + 1 | 0 : void 0,
        ...i,
        ...n,
        requestPolicy: n.requestPolicy || i.requestPolicy,
        suspense: n.suspense || !1 !== n.suspense && p.suspense
      });
    },
    executeRequestOperation(e) {
      if ("mutation" === e.kind) {
        return withPromise(makeResultSource(e));
      }
      return withPromise((0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .lazy */ .Vo)((() => {
        var r = n.get(e.key);
        if (!r) {
          n.set(e.key, r = makeResultSource(e));
        }
        r = (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .onStart */ .Hr)((() => {
          dispatchOperation(e);
        }))(r);
        var a = t.get(e.key);
        if ("query" === e.kind && a && (a.stale || a.hasNext)) {
          return (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .switchMap */ .wt)(wonka__WEBPACK_IMPORTED_MODULE_0__/* .fromValue */ ._A)((0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .merge */ .TS)([ r, (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .filter */ .hX)((r => r === t.get(e.key)))((0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .fromValue */ ._A)(a)) ]));
        } else {
          return r;
        }
      })));
    },
    executeQuery(e, r) {
      var t = p.createRequestOperation("query", e, r);
      return p.executeRequestOperation(t);
    },
    executeSubscription(e, r) {
      var t = p.createRequestOperation("subscription", e, r);
      return p.executeRequestOperation(t);
    },
    executeMutation(e, r) {
      var t = p.createRequestOperation("mutation", e, r);
      return p.executeRequestOperation(t);
    },
    readQuery(e, r, t) {
      var n = null;
      (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .subscribe */ .Ld)((e => {
        n = e;
      }))(p.query(e, r, t)).unsubscribe();
      return n;
    },
    query: (e, r, t) => p.executeQuery((0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.h)(e, r), t),
    subscription: (e, r, t) => p.executeSubscription((0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.h)(e, r), t),
    mutation: (e, r, t) => p.executeMutation((0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.h)(e, r), t)
  });
  var d = noop;
  if (false) { var x, l; }
  var g = composeExchanges(e.exchanges);
  var O = (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .share */ .BN)(g({
    client: p,
    dispatchDebug: d,
    forward: fallbackExchange({
      dispatchDebug: d
    })
  })(s.source));
  (0,wonka__WEBPACK_IMPORTED_MODULE_0__/* .publish */ .nY)(O);
  return p;
};

var j = C;


//# sourceMappingURL=urql-core.mjs.map


/***/ }),

/***/ 88660:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ devAssert; }
/* harmony export */ });
function devAssert(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}


/***/ }),

/***/ 92277:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ inspect; }
/* harmony export */ });
const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (typeof value) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? `[function ${value.name}]` : '[function]';

    case 'object':
      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (value === null) {
    return 'null';
  }

  if (previouslySeenValues.includes(value)) {
    return '[Circular]';
  }

  const seenValues = [...previouslySeenValues, value];

  if (isJSONable(value)) {
    const jsonValue = value.toJSON(); // check for infinite recursion

    if (jsonValue !== value) {
      return typeof jsonValue === 'string'
        ? jsonValue
        : formatValue(jsonValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function isJSONable(value) {
  return typeof value.toJSON === 'function';
}

function formatObject(object, seenValues) {
  const entries = Object.entries(object);

  if (entries.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  const properties = entries.map(
    ([key, value]) => key + ': ' + formatValue(value, seenValues),
  );
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  const len = Math.min(MAX_ARRAY_LENGTH, array.length);
  const remaining = array.length - len;
  const items = [];

  for (let i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push(`... ${remaining} more items`);
  }

  return '[' + items.join(', ') + ']';
}

function getObjectTag(object) {
  const tag = Object.prototype.toString
    .call(object)
    .replace(/^\[object /, '')
    .replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    const name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),

/***/ 90781:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UG": function() { return /* binding */ isNode; },
/* harmony export */   "WU": function() { return /* binding */ Token; },
/* harmony export */   "Ye": function() { return /* binding */ Location; },
/* harmony export */   "h8": function() { return /* binding */ QueryDocumentKeys; },
/* harmony export */   "ku": function() { return /* binding */ OperationTypeNode; }
/* harmony export */ });
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
class Location {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  constructor(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  get [Symbol.toStringTag]() {
    return 'Location';
  }

  toJSON() {
    return {
      start: this.start,
      end: this.end,
    };
  }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

class Token {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(kind, start, end, line, column, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    this.value = value;
    this.prev = null;
    this.next = null;
  }

  get [Symbol.toStringTag]() {
    return 'Token';
  }

  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column,
    };
  }
}
/**
 * The list of all possible AST node types.
 */

/**
 * @internal
 */
const QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: [
    'name',
    'variableDefinitions',
    'directives',
    'selectionSet',
  ],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: [
    'name', // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    'variableDefinitions',
    'typeCondition',
    'directives',
    'selectionSet',
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: [
    'description',
    'name',
    'type',
    'defaultValue',
    'directives',
  ],
  InterfaceTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields'],
};
const kindValues = new Set(Object.keys(QueryDocumentKeys));
/**
 * @internal
 */

function isNode(maybeNode) {
  const maybeKind =
    maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
  return typeof maybeKind === 'string' && kindValues.has(maybeKind);
}
/** Name */

var OperationTypeNode;

(function (OperationTypeNode) {
  OperationTypeNode['QUERY'] = 'query';
  OperationTypeNode['MUTATION'] = 'mutation';
  OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})(OperationTypeNode || (OperationTypeNode = {}));




/***/ }),

/***/ 95115:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Kind; }
/* harmony export */ });
/**
 * The set of allowed kind values for AST nodes.
 */
var Kind;

(function (Kind) {
  Kind['NAME'] = 'Name';
  Kind['DOCUMENT'] = 'Document';
  Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
  Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
  Kind['SELECTION_SET'] = 'SelectionSet';
  Kind['FIELD'] = 'Field';
  Kind['ARGUMENT'] = 'Argument';
  Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
  Kind['INLINE_FRAGMENT'] = 'InlineFragment';
  Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
  Kind['VARIABLE'] = 'Variable';
  Kind['INT'] = 'IntValue';
  Kind['FLOAT'] = 'FloatValue';
  Kind['STRING'] = 'StringValue';
  Kind['BOOLEAN'] = 'BooleanValue';
  Kind['NULL'] = 'NullValue';
  Kind['ENUM'] = 'EnumValue';
  Kind['LIST'] = 'ListValue';
  Kind['OBJECT'] = 'ObjectValue';
  Kind['OBJECT_FIELD'] = 'ObjectField';
  Kind['DIRECTIVE'] = 'Directive';
  Kind['NAMED_TYPE'] = 'NamedType';
  Kind['LIST_TYPE'] = 'ListType';
  Kind['NON_NULL_TYPE'] = 'NonNullType';
  Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
  Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
  Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
  Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
  Kind['FIELD_DEFINITION'] = 'FieldDefinition';
  Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
  Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
  Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
  Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
  Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
  Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
  Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
  Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
  Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
  Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
  Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
  Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
  Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
  Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})(Kind || (Kind = {}));


/**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */


/***/ }),

/***/ 58867:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vn": function() { return /* binding */ visit; }
/* harmony export */ });
/* unused harmony exports BREAK, visitInParallel, getEnterLeaveForKind, getVisitFn */
/* harmony import */ var _jsutils_devAssert_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88660);
/* harmony import */ var _jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92277);
/* harmony import */ var _ast_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90781);
/* harmony import */ var _kinds_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95115);




/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

const BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */

function visit(root, visitor, visitorKeys = _ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .QueryDocumentKeys */ .h8) {
  const enterLeaveMap = new Map();

  for (const kind of Object.values(_kinds_mjs__WEBPACK_IMPORTED_MODULE_1__/* .Kind */ .h)) {
    enterLeaveMap.set(kind, getEnterLeaveForKind(visitor, kind));
  }
  /* eslint-disable no-undef-init */

  let stack = undefined;
  let inArray = Array.isArray(root);
  let keys = [root];
  let index = -1;
  let edits = [];
  let node = root;
  let key = undefined;
  let parent = undefined;
  const path = [];
  const ancestors = [];
  /* eslint-enable no-undef-init */

  do {
    index++;
    const isLeaving = index === keys.length;
    const isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
          let editOffset = 0;

          for (const [editKey, editValue] of edits) {
            const arrayKey = editKey - editOffset;

            if (editValue === null) {
              node.splice(arrayKey, 1);
              editOffset++;
            } else {
              node[arrayKey] = editValue;
            }
          }
        } else {
          node = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(node),
          );

          for (const [editKey, editValue] of edits) {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else if (parent) {
      key = inArray ? index : keys[index];
      node = parent[key];

      if (node === null || node === undefined) {
        continue;
      }

      path.push(key);
    }

    let result;

    if (!Array.isArray(node)) {
      var _enterLeaveMap$get, _enterLeaveMap$get2;

      (0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */ .UG)(node) || (0,_jsutils_devAssert_mjs__WEBPACK_IMPORTED_MODULE_2__/* .devAssert */ .a)(false, `Invalid AST Node: ${(0,_jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_3__/* .inspect */ .X)(node)}.`);
      const visitFn = isLeaving
        ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get === void 0
          ? void 0
          : _enterLeaveMap$get.leave
        : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get2 === void 0
        ? void 0
        : _enterLeaveMap$get2.enter;
      result =
        visitFn === null || visitFn === void 0
          ? void 0
          : visitFn.call(visitor, node, key, parent, path, ancestors);

      if (result === BREAK) {
        break;
      }

      if (result === false) {
        if (!isLeaving) {
          path.pop();
          continue;
        }
      } else if (result !== undefined) {
        edits.push([key, result]);

        if (!isLeaving) {
          if ((0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */ .UG)(result)) {
            node = result;
          } else {
            path.pop();
            continue;
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _node$kind;

      stack = {
        inArray,
        index,
        keys,
        edits,
        prev: stack,
      };
      inArray = Array.isArray(node);
      keys = inArray
        ? node
        : (_node$kind = visitorKeys[node.kind]) !== null &&
          _node$kind !== void 0
        ? _node$kind
        : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    // New root
    return edits[edits.length - 1][1];
  }

  return root;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  const skipping = new Array(visitors.length).fill(null);
  const mergedVisitor = Object.create(null);

  for (const kind of Object.values(Kind)) {
    let hasVisitor = false;
    const enterList = new Array(visitors.length).fill(undefined);
    const leaveList = new Array(visitors.length).fill(undefined);

    for (let i = 0; i < visitors.length; ++i) {
      const { enter, leave } = getEnterLeaveForKind(visitors[i], kind);
      hasVisitor || (hasVisitor = enter != null || leave != null);
      enterList[i] = enter;
      leaveList[i] = leave;
    }

    if (!hasVisitor) {
      continue;
    }

    const mergedEnterLeave = {
      enter(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _enterList$i;

            const result =
              (_enterList$i = enterList[i]) === null || _enterList$i === void 0
                ? void 0
                : _enterList$i.apply(visitors[i], args);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      },

      leave(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _leaveList$i;

            const result =
              (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0
                ? void 0
                : _leaveList$i.apply(visitors[i], args);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          } else if (skipping[i] === node) {
            skipping[i] = null;
          }
        }
      },
    };
    mergedVisitor[kind] = mergedEnterLeave;
  }

  return mergedVisitor;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */

function getEnterLeaveForKind(visitor, kind) {
  const kindVisitor = visitor[kind];

  if (typeof kindVisitor === 'object') {
    // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
  } else if (typeof kindVisitor === 'function') {
    // { Kind() {} }
    return {
      enter: kindVisitor,
      leave: undefined,
    };
  } // { enter() {}, leave() {} }

  return {
    enter: visitor.enter,
    leave: visitor.leave,
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 *
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */

/* c8 ignore next 8 */

function getVisitFn(visitor, kind, isLeaving) {
  const { enter, leave } = getEnterLeaveForKind(visitor, kind);
  return isLeaving ? leave : enter;
}


/***/ }),

/***/ 54140:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Q": function() { return /* binding */ parse_parse; }
});

;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/metadata.min.json.js
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
/* harmony default export */ var metadata_min_json = ({"version":4,"country_calling_codes":{"1":["US","AG","AI","AS","BB","BM","BS","CA","DM","DO","GD","GU","JM","KN","KY","LC","MP","MS","PR","SX","TC","TT","VC","VG","VI"],"7":["RU","KZ"],"20":["EG"],"27":["ZA"],"30":["GR"],"31":["NL"],"32":["BE"],"33":["FR"],"34":["ES"],"36":["HU"],"39":["IT","VA"],"40":["RO"],"41":["CH"],"43":["AT"],"44":["GB","GG","IM","JE"],"45":["DK"],"46":["SE"],"47":["NO","SJ"],"48":["PL"],"49":["DE"],"51":["PE"],"52":["MX"],"53":["CU"],"54":["AR"],"55":["BR"],"56":["CL"],"57":["CO"],"58":["VE"],"60":["MY"],"61":["AU","CC","CX"],"62":["ID"],"63":["PH"],"64":["NZ"],"65":["SG"],"66":["TH"],"81":["JP"],"82":["KR"],"84":["VN"],"86":["CN"],"90":["TR"],"91":["IN"],"92":["PK"],"93":["AF"],"94":["LK"],"95":["MM"],"98":["IR"],"211":["SS"],"212":["MA","EH"],"213":["DZ"],"216":["TN"],"218":["LY"],"220":["GM"],"221":["SN"],"222":["MR"],"223":["ML"],"224":["GN"],"225":["CI"],"226":["BF"],"227":["NE"],"228":["TG"],"229":["BJ"],"230":["MU"],"231":["LR"],"232":["SL"],"233":["GH"],"234":["NG"],"235":["TD"],"236":["CF"],"237":["CM"],"238":["CV"],"239":["ST"],"240":["GQ"],"241":["GA"],"242":["CG"],"243":["CD"],"244":["AO"],"245":["GW"],"246":["IO"],"247":["AC"],"248":["SC"],"249":["SD"],"250":["RW"],"251":["ET"],"252":["SO"],"253":["DJ"],"254":["KE"],"255":["TZ"],"256":["UG"],"257":["BI"],"258":["MZ"],"260":["ZM"],"261":["MG"],"262":["RE","YT"],"263":["ZW"],"264":["NA"],"265":["MW"],"266":["LS"],"267":["BW"],"268":["SZ"],"269":["KM"],"290":["SH","TA"],"291":["ER"],"297":["AW"],"298":["FO"],"299":["GL"],"350":["GI"],"351":["PT"],"352":["LU"],"353":["IE"],"354":["IS"],"355":["AL"],"356":["MT"],"357":["CY"],"358":["FI","AX"],"359":["BG"],"370":["LT"],"371":["LV"],"372":["EE"],"373":["MD"],"374":["AM"],"375":["BY"],"376":["AD"],"377":["MC"],"378":["SM"],"380":["UA"],"381":["RS"],"382":["ME"],"383":["XK"],"385":["HR"],"386":["SI"],"387":["BA"],"389":["MK"],"420":["CZ"],"421":["SK"],"423":["LI"],"500":["FK"],"501":["BZ"],"502":["GT"],"503":["SV"],"504":["HN"],"505":["NI"],"506":["CR"],"507":["PA"],"508":["PM"],"509":["HT"],"590":["GP","BL","MF"],"591":["BO"],"592":["GY"],"593":["EC"],"594":["GF"],"595":["PY"],"596":["MQ"],"597":["SR"],"598":["UY"],"599":["CW","BQ"],"670":["TL"],"672":["NF"],"673":["BN"],"674":["NR"],"675":["PG"],"676":["TO"],"677":["SB"],"678":["VU"],"679":["FJ"],"680":["PW"],"681":["WF"],"682":["CK"],"683":["NU"],"685":["WS"],"686":["KI"],"687":["NC"],"688":["TV"],"689":["PF"],"690":["TK"],"691":["FM"],"692":["MH"],"850":["KP"],"852":["HK"],"853":["MO"],"855":["KH"],"856":["LA"],"880":["BD"],"886":["TW"],"960":["MV"],"961":["LB"],"962":["JO"],"963":["SY"],"964":["IQ"],"965":["KW"],"966":["SA"],"967":["YE"],"968":["OM"],"970":["PS"],"971":["AE"],"972":["IL"],"973":["BH"],"974":["QA"],"975":["BT"],"976":["MN"],"977":["NP"],"992":["TJ"],"993":["TM"],"994":["AZ"],"995":["GE"],"996":["KG"],"998":["UZ"]},"countries":{"AC":["247","00","(?:[01589]\\d|[46])\\d{4}",[5,6]],"AD":["376","00","(?:1|6\\d)\\d{7}|[135-9]\\d{5}",[6,8,9],[["(\\d{3})(\\d{3})","$1 $2",["[135-9]"]],["(\\d{4})(\\d{4})","$1 $2",["1"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]]],"AE":["971","00","(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",[5,6,7,8,9,10,11,12],[["(\\d{3})(\\d{2,9})","$1 $2",["60|8"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[236]|[479][2-8]"],"0$1"],["(\\d{3})(\\d)(\\d{5})","$1 $2 $3",["[479]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"]],"0"],"AF":["93","00","[2-7]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"]],"0"],"AG":["1","011","(?:268|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([457]\\d{6})$|1","268$1",0,"268"],"AI":["1","011","(?:264|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2457]\\d{6})$|1","264$1",0,"264"],"AL":["355","00","(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",[6,7,8,9],[["(\\d{3})(\\d{3,4})","$1 $2",["80|9"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["4[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2358][2-5]|4"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["[23578]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["6"],"0$1"]],"0"],"AM":["374","00","(?:[1-489]\\d|55|60|77)\\d{6}",[8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[89]0"],"0 $1"],["(\\d{3})(\\d{5})","$1 $2",["2|3[12]"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["1|47"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[3-9]"],"0$1"]],"0"],"AO":["244","00","[29]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[29]"]]]],"AR":["54","00","(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",[10,11],[["(\\d{4})(\\d{2})(\\d{4})","$1 $2-$3",["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])","2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["1"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[68]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2-$3",["[23]"],"0$1",1],["(\\d)(\\d{4})(\\d{2})(\\d{4})","$2 15-$3-$4",["9(?:2[2-469]|3[3-578])","9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))","9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]","9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"],"0$1",0,"$1 $2 $3-$4"],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 15-$3-$4",["91"],"0$1",0,"$1 $2 $3-$4"],["(\\d{3})(\\d{3})(\\d{5})","$1-$2-$3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 15-$3-$4",["9"],"0$1",0,"$1 $2 $3-$4"]],"0",0,"0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?","9$1"],"AS":["1","011","(?:[58]\\d\\d|684|900)\\d{7}",[10],0,"1",0,"([267]\\d{6})$|1","684$1",0,"684"],"AT":["43","00","1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",[4,5,6,7,8,9,10,11,12,13],[["(\\d)(\\d{3,12})","$1 $2",["1(?:11|[2-9])"],"0$1"],["(\\d{3})(\\d{2})","$1 $2",["517"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["5[079]"],"0$1"],["(\\d{3})(\\d{3,10})","$1 $2",["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"],"0$1"],["(\\d{4})(\\d{3,9})","$1 $2",["[2-467]|5[2-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["5"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,7})","$1 $2 $3",["5"],"0$1"]],"0"],"AU":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",[5,6,7,8,9,10,12],[["(\\d{2})(\\d{3,4})","$1 $2",["16"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,4})","$1 $2 $3",["16"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["14|4"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[2378]"],"(0$1)"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:30|[89])"]]],"0",0,"(183[12])|0",0,0,0,[["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",[9]],["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,["163\\d{2,6}",[5,6,7,8,9]],["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"AW":["297","00","(?:[25-79]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[25-9]"]]]],"AX":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",[5,6,7,8,9,10,11,12],0,"0",0,0,0,0,"18",0,"00"],"AZ":["994","00","365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[28]|2|365|46","1[28]|2|365[45]|46","1[28]|2|365(?:4|5[02])|46"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[13-9]"],"0$1"]],"0"],"BA":["387","00","6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["6[1-3]|[7-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2-$3",["[3-5]|6[56]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["6"],"0$1"]],"0"],"BB":["1","011","(?:246|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","246$1",0,"246"],"BD":["880","00","[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{4,6})","$1-$2",["31[5-8]|[459]1"],"0$1"],["(\\d{3})(\\d{3,7})","$1-$2",["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"],"0$1"],["(\\d{4})(\\d{3,6})","$1-$2",["[13-9]|22"],"0$1"],["(\\d)(\\d{7,8})","$1-$2",["2"],"0$1"]],"0"],"BE":["32","00","4\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:80|9)0"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[239]|4[23]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[15-8]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4"],"0$1"]],"0"],"BF":["226","00","[025-7]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[025-7]"]]]],"BG":["359","00","00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",[6,7,8,9,12],[["(\\d)(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["43[1-6]|70[1-9]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["(?:70|8)0"],"0$1"],["(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3",["43[1-7]|7"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[48]|9[08]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"]],"0"],"BH":["973","00","[136-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[13679]|8[02-4679]"]]]],"BI":["257","00","(?:[267]\\d|31)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2367]"]]]],"BJ":["229","00","[24-689]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-689]"]]]],"BL":["590","00","590\\d{6}|(?:69|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]],"BM":["1","011","(?:441|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","441$1",0,"441"],"BN":["673","00","[2-578]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-578]"]]]],"BO":["591","00(?:1\\d)?","(?:[2-467]\\d\\d|8001)\\d{5}",[8,9],[["(\\d)(\\d{7})","$1 $2",["[23]|4[46]"]],["(\\d{8})","$1",["[67]"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["8"]]],"0",0,"0(1\\d)?"],"BQ":["599","00","(?:[34]1|7\\d)\\d{5}",[7],0,0,0,0,0,0,"[347]"],"BR":["55","00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)","(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",[8,9,10,11],[["(\\d{4})(\\d{4})","$1-$2",["300|4(?:0[02]|37)","4(?:02|37)0|[34]00"]],["(\\d{3})(\\d{2,3})(\\d{4})","$1 $2 $3",["(?:[358]|90)0"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2-$3",["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"],"($1)"],["(\\d{2})(\\d{5})(\\d{4})","$1 $2-$3",["[16][1-9]|[2-57-9]"],"($1)"]],"0",0,"(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?","$2"],"BS":["1","011","(?:242|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([3-8]\\d{6})$|1","242$1",0,"242"],"BT":["975","00","[17]\\d{7}|[2-8]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[2-68]|7[246]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[67]|7"]]]],"BW":["267","00","(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",[7,8,10],[["(\\d{2})(\\d{5})","$1 $2",["90"]],["(\\d{3})(\\d{4})","$1 $2",["[24-6]|3[15-9]"]],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37]"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["8"]]]],"BY":["375","810","(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3})","$1 $2",["800"],"8 $1"],["(\\d{3})(\\d{2})(\\d{2,4})","$1 $2 $3",["800"],"8 $1"],["(\\d{4})(\\d{2})(\\d{3})","$1 $2-$3",["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])","1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"],"8 0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["1(?:[56]|7[467])|2[1-3]"],"8 0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-4]"],"8 0$1"],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["[89]"],"8 $1"]],"8",0,"0|80?",0,0,0,0,"8~10"],"BZ":["501","00","(?:0800\\d|[2-8])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1-$2",["[2-8]"]],["(\\d)(\\d{3})(\\d{4})(\\d{3})","$1-$2-$3-$4",["0"]]]],"CA":["1","011","(?:[2-8]\\d|90)\\d{8}|3\\d{6}",[7,10],0,"1",0,0,0,0,0,[["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",[10]],["",[10]],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",[10]],["900[2-9]\\d{6}",[10]],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",[10]],0,["310\\d{4}",[7]],0,["600[2-9]\\d{6}",[10]]]],"CC":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",[9]],["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CD":["243","00","[189]\\d{8}|[1-68]\\d{6}",[7,9],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[1-6]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]"],"0$1"]],"0"],"CF":["236","00","(?:[27]\\d{3}|8776)\\d{4}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[278]"]]]],"CG":["242","00","222\\d{6}|(?:0\\d|80)\\d{7}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[02]"]]]],"CH":["41","00","8\\d{11}|[2-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8[047]|90"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]|81"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["8"],"0$1"]],"0"],"CI":["225","00","[02]\\d{9}",[10],[["(\\d{2})(\\d{2})(\\d)(\\d{5})","$1 $2 $3 $4",["2"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3 $4",["0"]]]],"CK":["682","00","[2-578]\\d{4}",[5],[["(\\d{2})(\\d{3})","$1 $2",["[2-578]"]]]],"CL":["56","(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0","12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",[9,10,11],[["(\\d{5})(\\d{4})","$1 $2",["219","2196"],"($1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["44"]],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2[1-36]"],"($1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["9[2-9]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"],"($1)"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["60|8"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{3})(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3 $4",["60"]]]],"CM":["237","00","[26]\\d{8}|88\\d{6,7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["88"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[26]|88"]]]],"CN":["86","00|1(?:[12]\\d|79)\\d\\d00","1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",[7,8,9,10,11,12],[["(\\d{2})(\\d{5,6})","$1 $2",["(?:10|2[0-57-9])[19]","(?:10|2[0-57-9])(?:10|9[56])","10(?:10|9[56])|2[0-57-9](?:100|9[56])"],"0$1"],["(\\d{3})(\\d{5,6})","$1 $2",["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]","(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]","85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])","85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["(?:4|80)0"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|2(?:[02-57-9]|1[1-9])","10|2(?:[02-57-9]|1[1-9])","10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"],"0$1",1],["(\\d{3})(\\d{7,8})","$1 $2",["9"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["80"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[3-578]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["1[3-9]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3 $4",["[12]"],"0$1",1]],"0",0,"(1(?:[12]\\d|79)\\d\\d)|0",0,0,0,0,"00"],"CO":["57","00(?:4(?:[14]4|56)|[579])","(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",[10,11],[["(\\d{3})(\\d{7})","$1 $2",["6"],"($1)"],["(\\d{3})(\\d{7})","$1 $2",["3[0-357]|91"]],["(\\d)(\\d{3})(\\d{7})","$1-$2-$3",["1"],"0$1",0,"$1 $2 $3"]],"0",0,"0([3579]|4(?:[14]4|56))?"],"CR":["506","00","(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",[8,10],[["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[3-9]"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["[89]"]]],0,0,"(19(?:0[0-2468]|1[09]|20|66|77|99))"],"CU":["53","119","[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",[6,7,8,10],[["(\\d{2})(\\d{4,6})","$1 $2",["2[1-4]|[34]"],"(0$1)"],["(\\d)(\\d{6,7})","$1 $2",["7"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["[56]"],"0$1"],["(\\d{3})(\\d{7})","$1 $2",["8"],"0$1"]],"0"],"CV":["238","0","(?:[2-59]\\d\\d|800)\\d{4}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2-589]"]]]],"CW":["599","00","(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[3467]"]],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["9[4-8]"]]],0,0,0,0,0,"[69]"],"CX":["61","001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011","1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",[6,7,8,9,10,12],0,"0",0,"([59]\\d{7})$|0","8$1",0,0,[["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",[9]],["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",[9]],["180(?:0\\d{3}|2)\\d{3}",[7,10]],["190[0-26]\\d{6}",[10]],0,0,0,0,["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",[9]],["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",[6,8,10,12]]],"0011"],"CY":["357","00","(?:[279]\\d|[58]0)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[257-9]"]]]],"CZ":["420","00","(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]|9[015-7]"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{2})","$1 $2 $3 $4",["96"]],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]]],"DE":["49","00","[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",[4,5,6,7,8,9,10,11,12,13,14,15],[["(\\d{2})(\\d{3,13})","$1 $2",["3[02]|40|[68]9"],"0$1"],["(\\d{3})(\\d{3,12})","$1 $2",["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1","2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"],"0$1"],["(\\d{4})(\\d{2,11})","$1 $2",["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]","[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["138"],"0$1"],["(\\d{5})(\\d{2,10})","$1 $2",["3"],"0$1"],["(\\d{3})(\\d{5,11})","$1 $2",["181"],"0$1"],["(\\d{3})(\\d)(\\d{4,10})","$1 $2 $3",["1(?:3|80)|9"],"0$1"],["(\\d{3})(\\d{7,8})","$1 $2",["1[67]"],"0$1"],["(\\d{3})(\\d{7,12})","$1 $2",["8"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["185","1850","18500"],"0$1"],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["18[68]"],"0$1"],["(\\d{4})(\\d{7})","$1 $2",["15[1279]"],"0$1"],["(\\d{5})(\\d{6})","$1 $2",["15[03568]","15(?:[0568]|31)"],"0$1"],["(\\d{3})(\\d{8})","$1 $2",["18"],"0$1"],["(\\d{3})(\\d{2})(\\d{7,8})","$1 $2 $3",["1(?:6[023]|7)"],"0$1"],["(\\d{4})(\\d{2})(\\d{7})","$1 $2 $3",["15[279]"],"0$1"],["(\\d{3})(\\d{2})(\\d{8})","$1 $2 $3",["15"],"0$1"]],"0"],"DJ":["253","00","(?:2\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[27]"]]]],"DK":["45","00","[2-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-9]"]]]],"DM":["1","011","(?:[58]\\d\\d|767|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","767$1",0,"767"],"DO":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,0,0,0,"8001|8[024]9"],"DZ":["213","00","(?:[1-4]|[5-79]\\d|80)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["9"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-8]"],"0$1"]],"0"],"EC":["593","00","1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",[8,9,10,11],[["(\\d)(\\d{3})(\\d{4})","$1 $2-$3",["[2-7]"],"(0$1)",0,"$1-$2-$3"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{3})(\\d{3,4})","$1 $2 $3",["1"]]],"0"],"EE":["372","00","8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88","[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]],["(\\d{4})(\\d{3,4})","$1 $2",["[45]|8(?:00|[1-49])","[45]|8(?:00[1-9]|[1-49])"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"EG":["20","00","[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",[8,9,10],[["(\\d)(\\d{7,8})","$1 $2",["[23]"],"0$1"],["(\\d{2})(\\d{6,7})","$1 $2",["1[35]|[4-6]|8[2468]|9[235-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{8})","$1 $2",["1"],"0$1"]],"0"],"EH":["212","00","[5-8]\\d{8}",[9],0,"0",0,0,0,0,"528[89]"],"ER":["291","00","[178]\\d{6}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[178]"],"0$1"]],"0"],"ES":["34","00","[5-9]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[89]00"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-9]"]]]],"ET":["251","00","(?:11|[2-579]\\d)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-579]"],"0$1"]],"0"],"FI":["358","00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))","[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",[5,6,7,8,9,10,11,12],[["(\\d{5})","$1",["20[2-59]"],"0$1"],["(\\d{3})(\\d{3,7})","$1 $2",["(?:[1-3]0|[68])0|70[07-9]"],"0$1"],["(\\d{2})(\\d{4,8})","$1 $2",["[14]|2[09]|50|7[135]"],"0$1"],["(\\d{2})(\\d{6,10})","$1 $2",["7"],"0$1"],["(\\d)(\\d{4,9})","$1 $2",["(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"],"0$1"]],"0",0,0,0,0,"1[03-79]|[2-9]",0,"00"],"FJ":["679","0(?:0|52)","45\\d{5}|(?:0800\\d|[235-9])\\d{6}",[7,11],[["(\\d{3})(\\d{4})","$1 $2",["[235-9]|45"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]]],0,0,0,0,0,0,0,"00"],"FK":["500","00","[2-7]\\d{4}",[5]],"FM":["691","00","(?:[39]\\d\\d|820)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[389]"]]]],"FO":["298","00","[2-9]\\d{5}",[6],[["(\\d{6})","$1",["[2-9]"]]],0,0,"(10(?:01|[12]0|88))"],"FR":["33","00","[1-9]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0 $1"],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["[1-79]"],"0$1"]],"0"],"GA":["241","00","(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",[7,8],[["(\\d)(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-7]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["11|[67]"],"0$1"]],0,0,"0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})","$1"],"GB":["44","00","[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",[7,9,10],[["(\\d{3})(\\d{4})","$1 $2",["800","8001","80011","800111","8001111"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["845","8454","84546","845464"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["800"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["1(?:38|5[23]|69|76|94)","1(?:(?:38|69)7|5(?:24|39)|768|946)","1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["1(?:[2-69][02-9]|[78])"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[25]|7(?:0|6[02-9])","[25]|7(?:0|6(?:[03-9]|2[356]))"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[1389]"],"0$1"]],"0",0,0,0,0,0,[["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",[9,10]],["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]],0," x"],"GD":["1","011","(?:473|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","473$1",0,"473"],"GE":["995","00","(?:[3-57]\\d\\d|800)\\d{6}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["32"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[57]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[348]"],"0$1"]],"0"],"GF":["594","00","[56]94\\d{6}|(?:80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[56]|9[47]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[89]"],"0$1"]],"0"],"GG":["44","00","(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",[7,9,10],0,"0",0,"([25-9]\\d{5})$|0","1481$1",0,0,[["1481[25-9]\\d{5}",[10]],["7(?:(?:781|839)\\d|911[17])\\d{5}",[10]],["80[08]\\d{7}|800\\d{6}|8001111"],["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",[7,10]],["70\\d{8}",[10]],0,["(?:3[0347]|55)\\d{8}",[10]],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",[10]],["56\\d{8}",[10]]]],"GH":["233","00","(?:[235]\\d{3}|800)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[235]"],"0$1"]],"0"],"GI":["350","00","(?:[25]\\d|60)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["2"]]]],"GL":["299","00","(?:19|[2-689]\\d|70)\\d{4}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["19|[2-9]"]]]],"GM":["220","00","[2-9]\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"GN":["224","00","722\\d{6}|(?:3|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["3"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[67]"]]]],"GP":["590","00","590\\d{6}|(?:69|80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0",0,0,0,0,0,[["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]],"GQ":["240","00","222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235]"]],["(\\d{3})(\\d{6})","$1 $2",["[89]"]]]],"GR":["30","00","5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",[10,11,12],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["21|7"]],["(\\d{4})(\\d{6})","$1 $2",["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2689]"]],["(\\d{3})(\\d{3,4})(\\d{5})","$1 $2 $3",["8"]]]],"GT":["502","00","80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1 $2",["[2-8]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"GU":["1","011","(?:[58]\\d\\d|671|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","671$1",0,"671"],"GW":["245","00","[49]\\d{8}|4\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["40"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"]]]],"GY":["592","001","(?:[2-8]\\d{3}|9008)\\d{3}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"HK":["852","00(?:30|5[09]|[126-9]?)","8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",[5,6,7,8,9,11],[["(\\d{3})(\\d{2,5})","$1 $2",["900","9003"]],["(\\d{4})(\\d{4})","$1 $2",["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{3})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["9"]]],0,0,0,0,0,0,0,"00"],"HN":["504","00","8\\d{10}|[237-9]\\d{7}",[8,11],[["(\\d{4})(\\d{4})","$1-$2",["[237-9]"]]]],"HR":["385","00","(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",[6,7,8,9],[["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["6[01]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{4})(\\d{3})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-5]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"]],"0"],"HT":["509","00","(?:[2-489]\\d|55)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[2-589]"]]]],"HU":["36","00","[235-7]\\d{8}|[1-9]\\d{7}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"],"(06 $1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"06 $1"]],"06"],"ID":["62","00[89]","(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",[7,8,9,10,11,12,13],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["15"]],["(\\d{2})(\\d{5,9})","$1 $2",["2[124]|[36]1"],"(0$1)"],["(\\d{3})(\\d{5,7})","$1 $2",["800"],"0$1"],["(\\d{3})(\\d{5,8})","$1 $2",["[2-79]"],"(0$1)"],["(\\d{3})(\\d{3,4})(\\d{3})","$1-$2-$3",["8[1-35-9]"],"0$1"],["(\\d{3})(\\d{6,8})","$1 $2",["1"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["804"],"0$1"],["(\\d{3})(\\d)(\\d{3})(\\d{3})","$1 $2 $3 $4",["80"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1-$2-$3",["8"],"0$1"]],"0"],"IE":["353","00","(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["2[24-9]|47|58|6[237-9]|9[35-9]"],"(0$1)"],["(\\d{3})(\\d{5})","$1 $2",["[45]0"],"(0$1)"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["1"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2569]|4[1-69]|7[14]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["70"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["81"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[78]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["4"],"(0$1)"],["(\\d{2})(\\d)(\\d{3})(\\d{4})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"IL":["972","0(?:0|1[2-9])","1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",[7,8,9,10,11,12],[["(\\d{4})(\\d{3})","$1-$2",["125"]],["(\\d{4})(\\d{2})(\\d{2})","$1-$2-$3",["121"]],["(\\d)(\\d{3})(\\d{4})","$1-$2-$3",["[2-489]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1-$2-$3",["12"]],["(\\d{4})(\\d{6})","$1-$2",["159"]],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3-$4",["1[7-9]"]],["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})","$1-$2 $3-$4",["15"]]],"0"],"IM":["44","00","1624\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([25-8]\\d{5})$|0","1624$1",0,"74576|(?:16|7[56])24"],"IN":["91","00","(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",[8,9,10,11,12,13],[["(\\d{8})","$1",["5(?:0|2[23]|3[03]|[67]1|88)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)","5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"],0,1],["(\\d{4})(\\d{4,5})","$1 $2",["180","1800"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["140"],0,1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["11|2[02]|33|4[04]|79[1-7]|80[2-46]","11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])","11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"],"0$1",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]","1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"],"0$1",1],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807","1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]","1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"],"0$1",1],["(\\d{5})(\\d{5})","$1 $2",["[6-9]"],"0$1",1],["(\\d{4})(\\d{2,4})(\\d{4})","$1 $2 $3",["1(?:6|8[06])","1(?:6|8[06]0)"],0,1],["(\\d{4})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["18"],0,1]],"0"],"IO":["246","00","3\\d{6}",[7],[["(\\d{3})(\\d{4})","$1 $2",["3"]]]],"IQ":["964","00","(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-6]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"IR":["98","00","[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",[4,5,6,7,10],[["(\\d{4,5})","$1",["96"],"0$1"],["(\\d{2})(\\d{4,5})","$1 $2",["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["9"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["[1-8]"],"0$1"]],"0"],"IS":["354","00|1(?:0(?:01|[12]0)|100)","(?:38\\d|[4-9])\\d{6}",[7,9],[["(\\d{3})(\\d{4})","$1 $2",["[4-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["3"]]],0,0,0,0,0,0,0,"00"],"IT":["39","00","0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",[6,7,8,9,10,11],[["(\\d{2})(\\d{4,6})","$1 $2",["0[26]"]],["(\\d{3})(\\d{3,6})","$1 $2",["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])","0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]],["(\\d{4})(\\d{2,6})","$1 $2",["0(?:[13-579][2-46-8]|8[236-8])"]],["(\\d{4})(\\d{4})","$1 $2",["894"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[26]|5"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["1(?:44|[679])|[378]|43"]],["(\\d{3})(\\d{3,4})(\\d{4})","$1 $2 $3",["0[13-57-9][0159]|14"]],["(\\d{2})(\\d{4})(\\d{5})","$1 $2 $3",["0[26]"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["3"]]],0,0,0,0,0,0,[["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"],["3[2-9]\\d{7,8}|(?:31|43)\\d{8}",[9,10]],["80(?:0\\d{3}|3)\\d{3}",[6,9]],["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",[6,8,9,10]],["1(?:78\\d|99)\\d{6}",[9,10]],0,0,0,["55\\d{8}",[10]],["84(?:[08]\\d{3}|[17])\\d{3}",[6,9]]]],"JE":["44","00","1534\\d{6}|(?:[3578]\\d|90)\\d{8}",[10],0,"0",0,"([0-24-8]\\d{5})$|0","1534$1",0,0,[["1534[0-24-8]\\d{5}"],["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"],["80(?:07(?:35|81)|8901)\\d{4}"],["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"],["701511\\d{4}"],0,["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"],["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"],["56\\d{8}"]]],"JM":["1","011","(?:[58]\\d\\d|658|900)\\d{7}",[10],0,"1",0,0,0,0,"658|876"],"JO":["962","00","(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",[8,9],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2356]|87"],"(0$1)"],["(\\d{3})(\\d{5,6})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["70"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["7"],"0$1"]],"0"],"JP":["81","010","00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",[8,9,10,11,12,13,14,15,16,17],[["(\\d{3})(\\d{3})(\\d{3})","$1-$2-$3",["(?:12|57|99)0"],"0$1"],["(\\d{4})(\\d)(\\d{4})","$1-$2-$3",["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]","1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2-$3",["[36]|4(?:2[09]|7[01])","[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]","1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"],"0$1"],["(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3",["[14]|[289][2-9]|5[3-9]|7[2-4679]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1-$2-$3",["800"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[257-9]"],"0$1"]],"0",0,"(000[259]\\d{6})$|(?:(?:003768)0?)|0","$1"],"KE":["254","000","(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",[7,8,9,10],[["(\\d{2})(\\d{5,7})","$1 $2",["[24-6]"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[17]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0"],"KG":["996","00","8\\d{9}|[235-9]\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["3(?:1[346]|[24-79])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[235-79]|88"],"0$1"],["(\\d{3})(\\d{3})(\\d)(\\d{2,3})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"KH":["855","00[14-9]","1\\d{9}|[1-9]\\d{7,8}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"KI":["686","00","(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",[5,8],0,"0"],"KM":["269","00","[3478]\\d{6}",[7],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[3478]"]]]],"KN":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","869$1",0,"869"],"KP":["850","00|99","85\\d{6}|(?:19\\d|[2-7])\\d{7}",[8,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2-7]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"]],"0"],"KR":["82","00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))","00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",[5,6,8,9,10,11,12,13,14],[["(\\d{2})(\\d{3,4})","$1-$2",["(?:3[1-3]|[46][1-4]|5[1-5])1"],"0$1"],["(\\d{4})(\\d{4})","$1-$2",["1"]],["(\\d)(\\d{3,4})(\\d{4})","$1-$2-$3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1-$2-$3",["60|8"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1-$2-$3",["[1346]|5[1-5]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2-$3",["[57]"],"0$1"],["(\\d{2})(\\d{5})(\\d{4})","$1-$2-$3",["5"],"0$1"]],"0",0,"0(8(?:[1-46-8]|5\\d\\d))?"],"KW":["965","00","18\\d{5}|(?:[2569]\\d|41)\\d{6}",[7,8],[["(\\d{4})(\\d{3,4})","$1 $2",["[169]|2(?:[235]|4[1-35-9])|52"]],["(\\d{3})(\\d{5})","$1 $2",["[245]"]]]],"KY":["1","011","(?:345|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","345$1",0,"345"],"KZ":["7","810","(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",[10,14],0,"8",0,0,0,0,"33|7",0,"8~10"],"LA":["856","00","[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",[8,9,10],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2[13]|3[14]|[4-8]"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["30[013-9]"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[23]"],"0$1"]],"0"],"LB":["961","00","[27-9]\\d{7}|[13-9]\\d{6}",[7,8],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[27-9]"]]],"0"],"LC":["1","011","(?:[58]\\d\\d|758|900)\\d{7}",[10],0,"1",0,"([2-8]\\d{6})$|1","758$1",0,"758"],"LI":["423","00","[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",[7,9],[["(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3",["[2379]|8(?:0[09]|7)","[2379]|8(?:0(?:02|9)|7)"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["69"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]]],"0",0,"(1001)|0"],"LK":["94","00","[1-9]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[1-689]"],"0$1"]],"0"],"LR":["231","00","(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["4[67]|[56]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[2-578]"],"0$1"]],"0"],"LS":["266","00","(?:[256]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2568]"]]]],"LT":["370","00","(?:[3469]\\d|52|[78]0)\\d{6}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["52[0-7]"],"(8-$1)",1],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[7-9]"],"8 $1",1],["(\\d{2})(\\d{6})","$1 $2",["37|4(?:[15]|6[1-8])"],"(8-$1)",1],["(\\d{3})(\\d{5})","$1 $2",["[3-6]"],"(8-$1)",1]],"8",0,"[08]"],"LU":["352","00","35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",[4,5,6,7,8,9,10,11],[["(\\d{2})(\\d{3})","$1 $2",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["20[2-689]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4",["2(?:[0367]|4[3-8])"]],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["80[01]|90[015]"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3 $4",["20"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})","$1 $2 $3 $4 $5",["2(?:[0367]|4[3-8])"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})","$1 $2 $3 $4",["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]],0,0,"(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"],"LV":["371","00","(?:[268]\\d|90)\\d{6}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[269]|8[01]"]]]],"LY":["218","00","[2-9]\\d{8}",[9],[["(\\d{2})(\\d{7})","$1-$2",["[2-9]"],"0$1"]],"0"],"MA":["212","00","[5-8]\\d{8}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5[45]"],"0$1"],["(\\d{4})(\\d{5})","$1-$2",["5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)","5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"],"0$1"],["(\\d{2})(\\d{7})","$1-$2",["8"],"0$1"],["(\\d{3})(\\d{6})","$1-$2",["[5-7]"],"0$1"]],"0",0,0,0,0,0,[["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"],["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"],["80[0-7]\\d{6}"],["89\\d{7}"],0,0,0,0,["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]],"MC":["377","00","(?:[3489]|6\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["4"],"0$1"],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[389]"]],["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4 $5",["6"],"0$1"]],"0"],"MD":["373","00","(?:[235-7]\\d|[89]0)\\d{6}",[8],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["22|3"],"0$1"],["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["[25-7]"],"0$1"]],"0"],"ME":["382","00","(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[2-9]"],"0$1"]],"0"],"MF":["590","00","590\\d{6}|(?:69|80|9\\d)\\d{7}",[9],0,"0",0,0,0,0,0,[["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"],["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"],["80[0-5]\\d{6}"],0,0,0,0,0,["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]],"MG":["261","00","[23]\\d{8}",[9],[["(\\d{2})(\\d{2})(\\d{3})(\\d{2})","$1 $2 $3 $4",["[23]"],"0$1"]],"0",0,"([24-9]\\d{6})$|0","20$1"],"MH":["692","011","329\\d{4}|(?:[256]\\d|45)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1-$2",["[2-6]"]]],"1"],"MK":["389","00","[2-578]\\d{7}",[8],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2|34[47]|4(?:[37]7|5[47]|64)"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[347]"],"0$1"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["[58]"],"0$1"]],"0"],"ML":["223","00","[24-9]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24-9]"]]]],"MM":["95","00","1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",[6,7,8,9,10],[["(\\d)(\\d{2})(\\d{3})","$1 $2 $3",["16|2"],"0$1"],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[4-7]|8[1-35]"],"0$1"],["(\\d)(\\d{3})(\\d{4,6})","$1 $2 $3",["9(?:2[0-4]|[35-9]|4[137-9])"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["92"],"0$1"],["(\\d)(\\d{5})(\\d{4})","$1 $2 $3",["9"],"0$1"]],"0"],"MN":["976","001","[12]\\d{7,9}|[5-9]\\d{7}",[8,9,10],[["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["[12]1"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[5-9]"]],["(\\d{3})(\\d{5,6})","$1 $2",["[12]2[1-3]"],"0$1"],["(\\d{4})(\\d{5,6})","$1 $2",["[12](?:27|3[2-8]|4[2-68]|5[1-4689])","[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"],"0$1"],["(\\d{5})(\\d{4,5})","$1 $2",["[12]"],"0$1"]],"0"],"MO":["853","00","0800\\d{3}|(?:28|[68]\\d)\\d{6}",[7,8],[["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{4})(\\d{4})","$1 $2",["[268]"]]]],"MP":["1","011","[58]\\d{9}|(?:67|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","670$1",0,"670"],"MQ":["596","00","596\\d{6}|(?:69|80|9\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[569]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"MR":["222","00","(?:[2-4]\\d\\d|800)\\d{5}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-48]"]]]],"MS":["1","011","(?:[58]\\d\\d|664|900)\\d{7}",[10],0,"1",0,"([34]\\d{6})$|1","664$1",0,"664"],"MT":["356","00","3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[2357-9]"]]]],"MU":["230","0(?:0|[24-7]0|3[03])","(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",[7,8,10],[["(\\d{3})(\\d{4})","$1 $2",["[2-46]|8[013]"]],["(\\d{4})(\\d{4})","$1 $2",["[57]"]],["(\\d{5})(\\d{5})","$1 $2",["8"]]],0,0,0,0,0,0,0,"020"],"MV":["960","0(?:0|19)","(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",[7,10],[["(\\d{3})(\\d{4})","$1-$2",["[34679]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"]]],0,0,0,0,0,0,0,"00"],"MW":["265","00","(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",[7,9],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["1[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[137-9]"],"0$1"]],"0"],"MX":["52","0[09]","1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",[10,11],[["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["33|5[56]|81"],0,1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[2-9]"],0,1],["(\\d)(\\d{2})(\\d{4})(\\d{4})","$2 $3 $4",["1(?:33|5[56]|81)"],0,1],["(\\d)(\\d{3})(\\d{3})(\\d{4})","$2 $3 $4",["1"],0,1]],"01",0,"0(?:[12]|4[45])|1",0,0,0,0,"00"],"MY":["60","00","1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1-$2 $3",["[4-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1-$2 $3",["1(?:[02469]|[378][1-9]|53)|8","1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"],"0$1"],["(\\d)(\\d{4})(\\d{4})","$1-$2 $3",["3"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{4})","$1-$2-$3-$4",["1(?:[367]|80)"]],["(\\d{3})(\\d{3})(\\d{4})","$1-$2 $3",["15"],"0$1"],["(\\d{2})(\\d{4})(\\d{4})","$1-$2 $3",["1"],"0$1"]],"0"],"MZ":["258","00","(?:2|8\\d)\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2|8[2-79]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["8"]]]],"NA":["264","00","[68]\\d{7,8}",[8,9],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["88"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["87"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"NC":["687","00","(?:050|[2-57-9]\\d\\d)\\d{3}",[6],[["(\\d{2})(\\d{2})(\\d{2})","$1.$2.$3",["[02-57-9]"]]]],"NE":["227","00","[027-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["08"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[089]|2[013]|7[047]"]]]],"NF":["672","00","[13]\\d{5}",[6],[["(\\d{2})(\\d{4})","$1 $2",["1[0-3]"]],["(\\d)(\\d{5})","$1 $2",["[13]"]]],0,0,"([0-258]\\d{4})$","3$1"],"NG":["234","009","2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}",[7,8,10,11,12,13,14],[["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["78"],"0$1"],["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[12]|9(?:0[3-9]|[1-9])"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["[3-7]|8[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[7-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["20[129]"],"0$1"],["(\\d{4})(\\d{2})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{3})(\\d{4})(\\d{4,5})","$1 $2 $3",["[78]"],"0$1"],["(\\d{3})(\\d{5})(\\d{5,6})","$1 $2 $3",["[78]"],"0$1"]],"0"],"NI":["505","00","(?:1800|[25-8]\\d{3})\\d{4}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[125-8]"]]]],"NL":["31","00","(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",[5,6,7,8,9,10,11],[["(\\d{3})(\\d{4,7})","$1 $2",["[89]0"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["66"],"0$1"],["(\\d)(\\d{8})","$1 $2",["6"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-578]|91"],"0$1"],["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3",["9"],"0$1"]],"0"],"NO":["47","00","(?:0|[2-9]\\d{3})\\d{4}",[5,8],[["(\\d{3})(\\d{2})(\\d{3})","$1 $2 $3",["8"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2-79]"]]],0,0,0,0,0,"[02-689]|7[0-8]"],"NP":["977","00","(?:1\\d|9)\\d{9}|[1-9]\\d{7}",[8,10,11],[["(\\d)(\\d{7})","$1-$2",["1[2-6]"],"0$1"],["(\\d{2})(\\d{6})","$1-$2",["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"],"0$1"],["(\\d{3})(\\d{7})","$1-$2",["9"]]],"0"],"NR":["674","00","(?:444|(?:55|8\\d)\\d|666)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[4-68]"]]]],"NU":["683","00","(?:[4-7]|888\\d)\\d{3}",[4,7],[["(\\d{3})(\\d{4})","$1 $2",["8"]]]],"NZ":["64","0(?:0|161)","[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,8})","$1 $2",["8[1-79]"],"0$1"],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["50[036-8]|8|90","50(?:[0367]|88)|8|90"],"0$1"],["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["24|[346]|7[2-57-9]|9[2-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:10|74)|[589]"],"0$1"],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["1|2[028]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,5})","$1 $2 $3",["2(?:[169]|7[0-35-9])|7"],"0$1"]],"0",0,0,0,0,0,0,"00"],"OM":["968","00","(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",[7,8,9],[["(\\d{3})(\\d{4,6})","$1 $2",["[58]"]],["(\\d{2})(\\d{6})","$1 $2",["2"]],["(\\d{4})(\\d{4})","$1 $2",["[179]"]]]],"PA":["507","00","(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",[7,8,10,11],[["(\\d{3})(\\d{4})","$1-$2",["[1-57-9]"]],["(\\d{4})(\\d{4})","$1-$2",["[68]"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]]],"PE":["51","00|19(?:1[124]|77|90)00","(?:[14-8]|9\\d)\\d{7}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["80"],"(0$1)"],["(\\d)(\\d{7})","$1 $2",["1"],"(0$1)"],["(\\d{2})(\\d{6})","$1 $2",["[4-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"]]],"0",0,0,0,0,0,0,"00"," Anexo "],"PF":["689","00","4\\d{5}(?:\\d{2})?|8\\d{7,8}",[6,8,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["44"]],["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["4|8[7-9]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"PG":["675","00|140[1-3]","(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["18|[2-69]|85"]],["(\\d{4})(\\d{4})","$1 $2",["[78]"]]],0,0,0,0,0,0,0,"00"],"PH":["63","00","(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",[6,8,9,10,11,12,13],[["(\\d)(\\d{5})","$1 $2",["2"],"(0$1)"],["(\\d{4})(\\d{4,6})","$1 $2",["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2","3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"],"(0$1)"],["(\\d{5})(\\d{4})","$1 $2",["346|4(?:27|9[35])|883","3469|4(?:279|9(?:30|56))|8834"],"(0$1)"],["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["2"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|8[2-8]"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]],["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})","$1 $2 $3 $4",["1"]]],"0"],"PK":["92","00","122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,7})","$1 $2 $3",["[89]0"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["1"]],["(\\d{3})(\\d{6,7})","$1 $2",["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])","9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"],"(0$1)"],["(\\d{2})(\\d{7,8})","$1 $2",["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"],"(0$1)"],["(\\d{5})(\\d{5})","$1 $2",["58"],"(0$1)"],["(\\d{3})(\\d{7})","$1 $2",["3"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"],"(0$1)"],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[24-9]"],"(0$1)"]],"0"],"PL":["48","00","(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",[6,7,8,9,10],[["(\\d{5})","$1",["19"]],["(\\d{3})(\\d{3})","$1 $2",["11|20|64"]],["(\\d{2})(\\d{2})(\\d{3})","$1 $2 $3",["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1","(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]],["(\\d{3})(\\d{2})(\\d{2,3})","$1 $2 $3",["64"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["1[2-8]|[2-7]|8[1-79]|9[145]"]],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["8"]]]],"PM":["508","00","[45]\\d{5}|(?:708|80\\d)\\d{6}",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[45]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"],"0$1"]],"0"],"PR":["1","011","(?:[589]\\d\\d|787)\\d{7}",[10],0,"1",0,0,0,0,"787|939"],"PS":["970","00","[2489]2\\d{6}|(?:1\\d|5)\\d{8}",[8,9,10],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["[2489]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["5"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"PT":["351","00","1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["2[12]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["16|[236-9]"]]]],"PW":["680","01[12]","(?:[24-8]\\d\\d|345|900)\\d{4}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[2-9]"]]]],"PY":["595","00","59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",[6,7,8,9,10,11],[["(\\d{3})(\\d{3,6})","$1 $2",["[2-9]0"],"0$1"],["(\\d{2})(\\d{5})","$1 $2",["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"],"(0$1)"],["(\\d{3})(\\d{4,5})","$1 $2",["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["87"]],["(\\d{3})(\\d{6})","$1 $2",["9(?:[5-79]|8[1-7])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[2-8]"],"0$1"],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["9"]]],"0"],"QA":["974","00","800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",[7,8,9,11],[["(\\d{3})(\\d{4})","$1 $2",["2[16]|8"]],["(\\d{4})(\\d{4})","$1 $2",["[3-7]"]]]],"RE":["262","00","(?:26|[689]\\d)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2689]"],"0$1"]],"0",0,0,0,0,0,[["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"],["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"],["80\\d{7}"],["89[1-37-9]\\d{6}"],0,0,0,0,["9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"],["8(?:1[019]|2[0156]|84|90)\\d{6}"]]],"RO":["40","00","(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}",[6,9],[["(\\d{3})(\\d{3})","$1 $2",["2[3-6]","2[3-6]\\d9"],"0$1"],["(\\d{2})(\\d{4})","$1 $2",["219|31"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[23]1"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[236-9]"],"0$1"]],"0",0,0,0,0,0,0,0," int "],"RS":["381","00","38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",[6,7,8,9,10,11,12],[["(\\d{3})(\\d{3,9})","$1 $2",["(?:2[389]|39)0|[7-9]"],"0$1"],["(\\d{2})(\\d{5,10})","$1 $2",["[1-36]"],"0$1"]],"0"],"RU":["7","810","8\\d{13}|[347-9]\\d{9}",[10,14],[["(\\d{4})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-8]|2[1-9])","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))","7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"],"8 ($1)",1],["(\\d{5})(\\d)(\\d{2})(\\d{2})","$1 $2 $3 $4",["7(?:1[0-68]|2[1-9])","7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))","7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"8 ($1)",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2-$3-$4",["[349]|8(?:[02-7]|1[1-8])"],"8 ($1)",1],["(\\d{4})(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3 $4",["8"],"8 ($1)"]],"8",0,0,0,0,"3[04-689]|[489]",0,"8~10"],"RW":["250","00","(?:06|[27]\\d\\d|[89]00)\\d{6}",[8,9],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["0"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["2"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[7-9]"],"0$1"]],"0"],"SA":["966","00","92\\d{7}|(?:[15]|8\\d)\\d{8}",[9,10],[["(\\d{4})(\\d{5})","$1 $2",["9"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["1"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["5"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["81"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]]],"0"],"SB":["677","0[01]","(?:[1-6]|[7-9]\\d\\d)\\d{4}",[5,7],[["(\\d{2})(\\d{5})","$1 $2",["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]],"SC":["248","010|0[0-2]","800\\d{4}|(?:[249]\\d|64)\\d{5}",[7],[["(\\d)(\\d{3})(\\d{3})","$1 $2 $3",["[246]|9[57]"]]],0,0,0,0,0,0,0,"00"],"SD":["249","00","[19]\\d{8}",[9],[["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[19]"],"0$1"]],"0"],"SE":["46","00","(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",[6,7,8,9,10],[["(\\d{2})(\\d{2,3})(\\d{2})","$1-$2 $3",["20"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{4})","$1-$2",["9(?:00|39|44|9)"],"0$1",0,"$1 $2"],["(\\d{2})(\\d{3})(\\d{2})","$1-$2 $3",["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3"],["(\\d)(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2,3})(\\d{2})","$1-$2 $3",["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3"],["(\\d{3})(\\d{2,3})(\\d{3})","$1-$2 $3",["9(?:00|39|44)"],"0$1",0,"$1 $2 $3"],["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"],"0$1",0,"$1 $2 $3 $4"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4",["10|7"],"0$1",0,"$1 $2 $3 $4"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1-$2 $3 $4",["8"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1-$2 $3 $4",["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{2})(\\d{3})","$1-$2 $3 $4",["9"],"0$1",0,"$1 $2 $3 $4"],["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1-$2 $3 $4 $5",["[26]"],"0$1",0,"$1 $2 $3 $4 $5"]],"0"],"SG":["65","0[0-3]\\d","(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",[8,10,11],[["(\\d{4})(\\d{4})","$1 $2",["[369]|8(?:0[1-8]|[1-9])"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"]],["(\\d{4})(\\d{4})(\\d{3})","$1 $2 $3",["7"]],["(\\d{4})(\\d{3})(\\d{4})","$1 $2 $3",["1"]]]],"SH":["290","00","(?:[256]\\d|8)\\d{3}",[4,5],0,0,0,0,0,0,"[256]"],"SI":["386","00|10(?:22|66|88|99)","[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",[5,6,7,8],[["(\\d{2})(\\d{3,6})","$1 $2",["8[09]|9"],"0$1"],["(\\d{3})(\\d{5})","$1 $2",["59|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[37][01]|4[0139]|51|6"],"0$1"],["(\\d)(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[1-57]"],"(0$1)"]],"0",0,0,0,0,0,0,"00"],"SJ":["47","00","0\\d{4}|(?:[489]\\d|79)\\d{6}",[5,8],0,0,0,0,0,0,"79"],"SK":["421","00","[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",[6,7,9],[["(\\d)(\\d{2})(\\d{3,4})","$1 $2 $3",["21"],"0$1"],["(\\d{2})(\\d{2})(\\d{2,3})","$1 $2 $3",["[3-5][1-8]1","[3-5][1-8]1[67]"],"0$1"],["(\\d)(\\d{3})(\\d{3})(\\d{2})","$1/$2 $3 $4",["2"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[689]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1/$2 $3 $4",["[3-5]"],"0$1"]],"0"],"SL":["232","00","(?:[237-9]\\d|66)\\d{6}",[8],[["(\\d{2})(\\d{6})","$1 $2",["[236-9]"],"(0$1)"]],"0"],"SM":["378","00","(?:0549|[5-7]\\d)\\d{6}",[8,10],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[5-7]"]],["(\\d{4})(\\d{6})","$1 $2",["0"]]],0,0,"([89]\\d{5})$","0549$1"],"SN":["221","00","(?:[378]\\d|93)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[379]"]]]],"SO":["252","00","[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",[6,7,8,9],[["(\\d{2})(\\d{4})","$1 $2",["8[125]"]],["(\\d{6})","$1",["[134]"]],["(\\d)(\\d{6})","$1 $2",["[15]|2[0-79]|3[0-46-8]|4[0-7]"]],["(\\d)(\\d{7})","$1 $2",["(?:2|90)4|[67]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[348]|64|79|90"]],["(\\d{2})(\\d{5,7})","$1 $2",["1|28|6[0-35-9]|77|9[2-9]"]]],"0"],"SR":["597","00","(?:[2-5]|68|[78]\\d)\\d{5}",[6,7],[["(\\d{2})(\\d{2})(\\d{2})","$1-$2-$3",["56"]],["(\\d{3})(\\d{3})","$1-$2",["[2-5]"]],["(\\d{3})(\\d{4})","$1-$2",["[6-8]"]]]],"SS":["211","00","[19]\\d{8}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[19]"],"0$1"]],"0"],"ST":["239","00","(?:22|9\\d)\\d{5}",[7],[["(\\d{3})(\\d{4})","$1 $2",["[29]"]]]],"SV":["503","00","[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",[7,8,11],[["(\\d{3})(\\d{4})","$1 $2",["[89]"]],["(\\d{4})(\\d{4})","$1 $2",["[267]"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["[89]"]]]],"SX":["1","011","7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"(5\\d{6})$|1","721$1",0,"721"],"SY":["963","00","[1-39]\\d{8}|[1-5]\\d{7}",[8,9],[["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-5]"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1",1]],"0"],"SZ":["268","00","0800\\d{4}|(?:[237]\\d|900)\\d{6}",[8,9],[["(\\d{4})(\\d{4})","$1 $2",["[0237]"]],["(\\d{5})(\\d{4})","$1 $2",["9"]]]],"TA":["290","00","8\\d{3}",[4],0,0,0,0,0,0,"8"],"TC":["1","011","(?:[58]\\d\\d|649|900)\\d{7}",[10],0,"1",0,"([2-479]\\d{6})$|1","649$1",0,"649"],"TD":["235","00|16","(?:22|[69]\\d|77)\\d{6}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[2679]"]]],0,0,0,0,0,0,0,"00"],"TG":["228","00","[279]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[279]"]]]],"TH":["66","00[1-9]","(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",[8,9,10,13],[["(\\d)(\\d{3})(\\d{4})","$1 $2 $3",["2"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[13-9]"],"0$1"],["(\\d{4})(\\d{3})(\\d{3})","$1 $2 $3",["1"]]],"0"],"TJ":["992","810","[0-57-9]\\d{8}",[9],[["(\\d{6})(\\d)(\\d{2})","$1 $2 $3",["331","3317"]],["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["44[02-479]|[34]7"]],["(\\d{4})(\\d)(\\d{4})","$1 $2 $3",["3[1-5]"]],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[0-57-9]"]]],0,0,0,0,0,0,0,"8~10"],"TK":["690","00","[2-47]\\d{3,6}",[4,5,6,7]],"TL":["670","00","7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",[7,8],[["(\\d{3})(\\d{4})","$1 $2",["[2-489]|70"]],["(\\d{4})(\\d{4})","$1 $2",["7"]]]],"TM":["993","810","[1-6]\\d{7}",[8],[["(\\d{2})(\\d{2})(\\d{2})(\\d{2})","$1 $2-$3-$4",["12"],"(8 $1)"],["(\\d{3})(\\d)(\\d{2})(\\d{2})","$1 $2-$3-$4",["[1-5]"],"(8 $1)"],["(\\d{2})(\\d{6})","$1 $2",["6"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"TN":["216","00","[2-57-9]\\d{7}",[8],[["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-57-9]"]]]],"TO":["676","00","(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",[5,7],[["(\\d{2})(\\d{3})","$1-$2",["[2-4]|50|6[09]|7[0-24-69]|8[05]"]],["(\\d{4})(\\d{3})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[5-9]"]]]],"TR":["90","00","4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",[7,10,12,13],[["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["512|8[01589]|90"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["5(?:[0-59]|61)","5(?:[0-59]|61[06])","5(?:[0-59]|61[06]1)"],"0$1",1],["(\\d{3})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[24][1-8]|3[1-9]"],"(0$1)",1],["(\\d{3})(\\d{3})(\\d{6,7})","$1 $2 $3",["80"],"0$1",1]],"0"],"TT":["1","011","(?:[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-46-8]\\d{6})$|1","868$1",0,"868"],"TV":["688","00","(?:2|7\\d\\d|90)\\d{4}",[5,6,7],[["(\\d{2})(\\d{3})","$1 $2",["2"]],["(\\d{2})(\\d{4})","$1 $2",["90"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"TW":["886","0(?:0[25-79]|19)","[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",[7,8,9,10,11],[["(\\d{2})(\\d)(\\d{4})","$1 $2 $3",["202"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["[258]0"],"0$1"],["(\\d)(\\d{3,4})(\\d{4})","$1 $2 $3",["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]","[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[49]"],"0$1"],["(\\d{2})(\\d{4})(\\d{4,5})","$1 $2 $3",["7"],"0$1"]],"0",0,0,0,0,0,0,0,"#"],"TZ":["255","00[056]","(?:[25-8]\\d|41|90)\\d{7}",[9],[["(\\d{3})(\\d{2})(\\d{4})","$1 $2 $3",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[24]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["5"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[67]"],"0$1"]],"0"],"UA":["380","00","[89]\\d{9}|[3-9]\\d{8}",[9,10],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]","6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"],"0$1"],["(\\d{4})(\\d{5})","$1 $2",["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])","3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[3-7]|89|9[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["[89]"],"0$1"]],"0",0,0,0,0,0,0,"0~0"],"UG":["256","00[057]","800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",[9],[["(\\d{4})(\\d{5})","$1 $2",["202","2024"],"0$1"],["(\\d{3})(\\d{6})","$1 $2",["[27-9]|4(?:6[45]|[7-9])"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[34]"],"0$1"]],"0"],"US":["1","011","[2-9]\\d{9}|3\\d{6}",[10],[["(\\d{3})(\\d{4})","$1-$2",["310"],0,1],["(\\d{3})(\\d{3})(\\d{4})","($1) $2-$3",["[2-9]"],0,1,"$1-$2-$3"]],"1",0,0,0,0,0,[["(?:5056(?:[0-35-9]\\d|4[468])|7302[01]\\d)\\d{4}|(?:472[24]|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"],[""],["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"],["900[2-9]\\d{6}"],["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]],"UY":["598","0(?:0|1[3-9]\\d)","0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",[6,7,8,9,10,11,12,13],[["(\\d{3})(\\d{3,4})","$1 $2",["0"]],["(\\d{3})(\\d{4})","$1 $2",["[49]0|8"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["9"],"0$1"],["(\\d{4})(\\d{4})","$1 $2",["[124]"]],["(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3",["0"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})","$1 $2 $3 $4",["0"]]],"0",0,0,0,0,0,0,"00"," int. "],"UZ":["998","810","(?:20|33|[5-79]\\d|88)\\d{7}",[9],[["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["[235-9]"],"8 $1"]],"8",0,0,0,0,0,0,"8~10"],"VA":["39","00","0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",[6,7,8,9,10,11],0,0,0,0,0,0,"06698"],"VC":["1","011","(?:[58]\\d\\d|784|900)\\d{7}",[10],0,"1",0,"([2-7]\\d{6})$|1","784$1",0,"784"],"VE":["58","00","[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",[10],[["(\\d{3})(\\d{7})","$1-$2",["[24-689]"],"0$1"]],"0"],"VG":["1","011","(?:284|[58]\\d\\d|900)\\d{7}",[10],0,"1",0,"([2-578]\\d{6})$|1","284$1",0,"284"],"VI":["1","011","[58]\\d{9}|(?:34|90)0\\d{7}",[10],0,"1",0,"([2-9]\\d{6})$|1","340$1",0,"340"],"VN":["84","00","[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",[7,8,9,10],[["(\\d{2})(\\d{5})","$1 $2",["80"],"0$1",1],["(\\d{4})(\\d{4,6})","$1 $2",["1"],0,1],["(\\d{2})(\\d{3})(\\d{2})(\\d{2})","$1 $2 $3 $4",["6"],"0$1",1],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[357-9]"],"0$1",1],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["2[48]"],"0$1",1],["(\\d{3})(\\d{4})(\\d{3})","$1 $2 $3",["2"],"0$1",1]],"0"],"VU":["678","00","[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",[5,7],[["(\\d{3})(\\d{4})","$1 $2",["[57-9]"]]]],"WF":["681","00","(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",[6,9],[["(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3",["[478]"]],["(\\d{3})(\\d{2})(\\d{2})(\\d{2})","$1 $2 $3 $4",["8"]]]],"WS":["685","0","(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",[5,6,7,10],[["(\\d{5})","$1",["[2-5]|6[1-9]"]],["(\\d{3})(\\d{3,7})","$1 $2",["[68]"]],["(\\d{2})(\\d{5})","$1 $2",["7"]]]],"XK":["383","00","[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",[8,9],[["(\\d{3})(\\d{5})","$1 $2",["[89]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3})","$1 $2 $3",["[2-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[23]"],"0$1"]],"0"],"YE":["967","00","(?:1|7\\d)\\d{7}|[1-7]\\d{6}",[7,8,9],[["(\\d)(\\d{3})(\\d{3,4})","$1 $2 $3",["[1-6]|7(?:[24-6]|8[0-7])"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["7"],"0$1"]],"0"],"YT":["262","00","(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",[9],0,"0",0,0,0,0,0,[["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"],["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"],["80\\d{7}"],0,0,0,0,0,["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]],"ZA":["27","00","[1-79]\\d{8}|8\\d{4,9}",[5,6,7,8,9,10],[["(\\d{2})(\\d{3,4})","$1 $2",["8[1-4]"],"0$1"],["(\\d{2})(\\d{3})(\\d{2,3})","$1 $2 $3",["8[1-4]"],"0$1"],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["860"],"0$1"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["[1-9]"],"0$1"],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["8"],"0$1"]],"0"],"ZM":["260","00","800\\d{6}|(?:21|63|[79]\\d)\\d{7}",[9],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[28]"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["[79]"],"0$1"]],"0"],"ZW":["263","00","2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",[5,6,7,8,9,10],[["(\\d{3})(\\d{3,5})","$1 $2",["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"],"0$1"],["(\\d)(\\d{3})(\\d{2,4})","$1 $2 $3",["[49]"],"0$1"],["(\\d{3})(\\d{4})","$1 $2",["80"],"0$1"],["(\\d{2})(\\d{7})","$1 $2",["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2","2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"],"(0$1)"],["(\\d{2})(\\d{3})(\\d{4})","$1 $2 $3",["7"],"0$1"],["(\\d{3})(\\d{3})(\\d{3,4})","$1 $2 $3",["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)","2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"],"0$1"],["(\\d{4})(\\d{6})","$1 $2",["8"],"0$1"],["(\\d{2})(\\d{3,5})","$1 $2",["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"],"0$1"],["(\\d{2})(\\d{3})(\\d{3,4})","$1 $2 $3",["29[013-9]|39|54"],"0$1"],["(\\d{4})(\\d{3,5})","$1 $2",["(?:25|54)8","258|5483"],"0$1"]],"0"]},"nonGeographic":{"800":["800",0,"(?:00|[1-9]\\d)\\d{6}",[8],[["(\\d{4})(\\d{4})","$1 $2",["\\d"]]],0,0,0,0,0,0,[0,0,["(?:00|[1-9]\\d)\\d{6}"]]],"808":["808",0,"[1-9]\\d{7}",[8],[["(\\d{4})(\\d{4})","$1 $2",["[1-9]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,0,["[1-9]\\d{7}"]]],"870":["870",0,"7\\d{11}|[35-7]\\d{8}",[9,12],[["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["[35-7]"]]],0,0,0,0,0,0,[0,["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]],"878":["878",0,"10\\d{10}",[12],[["(\\d{2})(\\d{5})(\\d{5})","$1 $2 $3",["1"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["10\\d{10}"]]],"881":["881",0,"6\\d{9}|[0-36-9]\\d{8}",[9,10],[["(\\d)(\\d{3})(\\d{5})","$1 $2 $3",["[0-37-9]"]],["(\\d)(\\d{3})(\\d{5,6})","$1 $2 $3",["6"]]],0,0,0,0,0,0,[0,["6\\d{9}|[0-36-9]\\d{8}"]]],"882":["882",0,"[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",[7,8,9,10,11,12],[["(\\d{2})(\\d{5})","$1 $2",["16|342"]],["(\\d{2})(\\d{6})","$1 $2",["49"]],["(\\d{2})(\\d{2})(\\d{4})","$1 $2 $3",["1[36]|9"]],["(\\d{2})(\\d{4})(\\d{3})","$1 $2 $3",["3[23]"]],["(\\d{2})(\\d{3,4})(\\d{4})","$1 $2 $3",["16"]],["(\\d{2})(\\d{4})(\\d{4})","$1 $2 $3",["10|23|3(?:[15]|4[57])|4|51"]],["(\\d{3})(\\d{4})(\\d{4})","$1 $2 $3",["34"]],["(\\d{2})(\\d{4,5})(\\d{5})","$1 $2 $3",["[1-35]"]]],0,0,0,0,0,0,[0,["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",[7,8,9,10,12]],0,0,0,0,0,0,["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]],"883":["883",0,"(?:[1-4]\\d|51)\\d{6,10}",[8,9,10,11,12],[["(\\d{3})(\\d{3})(\\d{2,8})","$1 $2 $3",["[14]|2[24-689]|3[02-689]|51[24-9]"]],["(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3",["510"]],["(\\d{3})(\\d{3})(\\d{4})","$1 $2 $3",["21"]],["(\\d{4})(\\d{4})(\\d{4})","$1 $2 $3",["51[13]"]],["(\\d{3})(\\d{3})(\\d{3})(\\d{3})","$1 $2 $3 $4",["[235]"]]],0,0,0,0,0,0,[0,0,0,0,0,0,0,0,["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]],"888":["888",0,"\\d{11}",[11],[["(\\d{3})(\\d{3})(\\d{5})","$1 $2 $3"]],0,0,0,0,0,0,[0,0,0,0,0,0,["\\d{11}"]]],"979":["979",0,"[1359]\\d{8}",[9],[["(\\d)(\\d{4})(\\d{4})","$1 $2 $3",["[1359]"]]],0,0,0,0,0,0,[0,0,0,["[1359]\\d{8}"]]]}});
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/min/exports/withMetadataArgument.js
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.


function withMetadataArgument(func, _arguments) {
	var args = Array.prototype.slice.call(_arguments)
	args.push(metadata_min_json)
	return func.apply(this, args)
}
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/constants.js
// The minimum length of the national significant number.
var MIN_LENGTH_FOR_NSN = 2; // The ITU says the maximum length should be 15,
// but one can find longer numbers in Germany.

var MAX_LENGTH_FOR_NSN = 17; // The maximum length of the country calling code.

var MAX_LENGTH_COUNTRY_CODE = 3; // Digits accepted in phone numbers
// (ascii, fullwidth, arabic-indic, and eastern arabic digits).

var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9"; // `DASHES` will be right after the opening square bracket of the "character class"

var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['

var TILDES = "~\u2053\u223C\uFF5E"; // Regular expression of acceptable punctuation found in phone numbers. This
// excludes punctuation found as a leading character only. This consists of dash
// characters, white space characters, full stops, slashes, square brackets,
// parentheses and tildes. Full-width variants are also present.

var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/ParseError.js
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var ParseError = /*#__PURE__*/function (_Error) {
  _inherits(ParseError, _Error);

  var _super = _createSuper(ParseError);

  function ParseError(code) {
    var _this;

    _classCallCheck(this, ParseError);

    _this = _super.call(this, code); // Set the prototype explicitly.
    // Any subclass of FooError will have to manually set the prototype as well.

    Object.setPrototypeOf(_assertThisInitialized(_this), ParseError.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }

  return _createClass(ParseError);
}( /*#__PURE__*/_wrapNativeSuper(Error));


//# sourceMappingURL=ParseError.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/tools/semver-compare.js
// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
/* harmony default export */ function semver_compare(a, b) {
  a = a.split('-');
  b = b.split('-');
  var pa = a[0].split('.');
  var pb = b[0].split('.');

  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }

  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }

  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}
//# sourceMappingURL=semver-compare.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/isObject.js
var objectConstructor = {}.constructor;
function isObject(object) {
  return object !== undefined && object !== null && object.constructor === objectConstructor;
}
//# sourceMappingURL=isObject.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/metadata.js
function metadata_typeof(obj) { "@babel/helpers - typeof"; return metadata_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, metadata_typeof(obj); }

function metadata_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function metadata_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function metadata_createClass(Constructor, protoProps, staticProps) { if (protoProps) metadata_defineProperties(Constructor.prototype, protoProps); if (staticProps) metadata_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }


 // Added "possibleLengths" and renamed
// "country_phone_code_to_countries" to "country_calling_codes".

var V2 = '1.0.18'; // Added "idd_prefix" and "default_idd_prefix".

var V3 = '1.2.0'; // Moved `001` country code to "nonGeographic" section of metadata.

var V4 = '1.7.35';
var DEFAULT_EXT_PREFIX = ' ext. ';
var CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */

var Metadata = /*#__PURE__*/function () {
  function Metadata(metadata) {
    metadata_classCallCheck(this, Metadata);

    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }

  metadata_createClass(Metadata, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function (_) {
        return _ !== '001';
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
      // It's present in metadata generated from `1.7.35` to `1.7.37`.
      // The test case could be found by searching for "nonGeographical".

      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== undefined;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }

      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    } // Deprecated.

  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      // Supports just passing `callingCode` as the first argument.
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }

      if (countryCode && countryCode !== '001') {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }

        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }

        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = undefined;
      }

      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];

      if (countryCodes) {
        // Metadata before V4 included "non-geographic entity" calling codes
        // inside `country_calling_codes` (for example, `"881":["001"]`).
        // Now the semantics of `country_calling_codes` has changed:
        // it's specifically for "countries" now.
        // Older versions of custom metadata will simply skip parsing
        // "non-geographic entity" phone numbers with new versions
        // of this library: it's not considered a bug,
        // because such numbers are extremely rare,
        // and developers extremely rarely use custom metadata.
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }

        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);

      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);

      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }

      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];

        if (metadata) {
          return metadata;
        }
      } else {
        // A hacky workaround for old custom metadata (generated before V4).
        // In that metadata, there was no concept of "non-geographic" metadata
        // so metadata for `001` country code was stored along with other countries.
        // The test case can be found by searching for:
        // "should work around `nonGeographic` metadata not existing".
        var countryCodes = this.countryCallingCodes()[callingCode];

        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === '001') {
          return this.metadata.countries['001'];
        }
      }
    } // Deprecated.

  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    } // Deprecated.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    } // Deprecated.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    } // Deprecated.

  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    } // Deprecated.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    } // Deprecated.

  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    } // Deprecated.

  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    } // Deprecated.

  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    } // Deprecated.

  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    } // Deprecated.

  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    } // Deprecated.

  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    } // Deprecated.

  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    } // Deprecated.

  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== undefined;
    }
  }]);

  return Metadata;
}();



var NumberingPlan = /*#__PURE__*/function () {
  function NumberingPlan(metadata, globalMetadataObject) {
    metadata_classCallCheck(this, NumberingPlan);

    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }

  metadata_createClass(NumberingPlan, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    } // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.

  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    } // Is always present.

  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    } // Is only present when a country supports multiple IDD prefixes.

  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    } // "possible length" data is always present in Google's metadata.

  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    } // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "formats",
    value: function formats() {
      var _this = this;

      var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats.map(function (_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    } // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      // If `national_prefix_for_parsing` is not set explicitly,
      // then infer it from `national_prefix` (if any)
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    } // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".

  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      // Versions 1.2.0 - 1.2.4: can be `[]`.

      /* istanbul ignore next */
      if (this.types() && this.types().length === 0) {
        return false;
      } // Versions <= 1.2.4: can be `undefined`.
      // Version >= 1.2.5: can be `0`.


      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);

  return NumberingPlan;
}();

var Format = /*#__PURE__*/function () {
  function Format(format, metadata) {
    metadata_classCallCheck(this, Format);

    this._format = format;
    this.metadata = metadata;
  }

  metadata_createClass(Format, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      // National prefix is omitted if there's no national prefix formatting rule
      // set for this country, or when the national prefix formatting rule
      // contains no national prefix itself, or when this rule is set but
      // national prefix is optional for this phone number format
      // (and it is not enforced explicitly)
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    } // Checks whether national prefix formatting rule contains national prefix.

  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
      // when `national_prefix_formatting_rule` is not present.
      // So, `true` or `false` are returned explicitly here, so that
      // `0` number isn't returned.
      ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);

  return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */


var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;

var Type = /*#__PURE__*/function () {
  function Type(type, metadata) {
    metadata_classCallCheck(this, Type);

    this.type = type;
    this.metadata = metadata;
  }

  metadata_createClass(Type, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);

  return Type;
}();

function getType(types, type) {
  switch (type) {
    case 'FIXED_LINE':
      return types[0];

    case 'MOBILE':
      return types[1];

    case 'TOLL_FREE':
      return types[2];

    case 'PREMIUM_RATE':
      return types[3];

    case 'PERSONAL_NUMBER':
      return types[4];

    case 'VOICEMAIL':
      return types[5];

    case 'UAN':
      return types[6];

    case 'PAGER':
      return types[7];

    case 'VOIP':
      return types[8];

    case 'SHARED_COST':
      return types[9];
  }
}

function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error('[libphonenumber-js] `metadata` argument not passed. Check your arguments.');
  } // `country_phone_code_to_countries` was renamed to
  // `country_calling_codes` in `1.0.18`.


  if (!isObject(metadata) || !isObject(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject(metadata) ? 'an object of shape: { ' + Object.keys(metadata).join(', ') + ' }' : 'a ' + typeOf(metadata) + ': ' + metadata, "."));
  }
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".

/* istanbul ignore next */

var typeOf = function typeOf(_) {
  return metadata_typeof(_);
};
/**
 * Returns extension prefix for a country.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string?}
 * @example
 * // Returns " ext. "
 * getExtPrefix("US")
 */


function getExtPrefix(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).ext();
  }

  return DEFAULT_EXT_PREFIX;
}
/**
 * Returns "country calling code" for a country.
 * Throws an error if the country doesn't exist or isn't supported by this library.
 * @param  {string} country
 * @param  {object} metadata
 * @return {string}
 * @example
 * // Returns "44"
 * getCountryCallingCode("GB")
 */

function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);

  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }

  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata) {
  // metadata = new Metadata(metadata)
  // return metadata.hasCountry(country)
  return metadata.countries.hasOwnProperty(country);
}

function setVersion(metadata) {
  var version = metadata.version;

  if (typeof version === 'number') {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (semver_compare(version, V3) === -1) {
      this.v2 = true;
    } else if (semver_compare(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
// function isCountryCode(countryCode) {
// 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
// }
//# sourceMappingURL=metadata.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/extension/createExtensionPattern.js
 // The RFC 3966 format for extensions.

var RFC3966_EXTN_PREFIX = ';ext=';
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */

var getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
/**
 * Helper initialiser method to create the regular-expression pattern to match
 * extensions.
 * Copy-pasted from Google's `libphonenumber`:
 * https://github.com/google/libphonenumber/blob/55b2646ec9393f4d3d6661b9c82ef9e258e8b829/javascript/i18n/phonenumbers/phonenumberutil.js#L759-L766
 * @return {string} RegEx pattern to capture extensions.
 */


function createExtensionPattern(purpose) {
  // We cap the maximum length of an extension based on the ambiguity of the way
  // the extension is prefixed. As per ITU, the officially allowed length for
  // extensions is actually 40, but we don't support this since we haven't seen real
  // examples and this introduces many false interpretations as the extension labels
  // are not standardized.

  /** @type {string} */
  var extLimitAfterExplicitLabel = '20';
  /** @type {string} */

  var extLimitAfterLikelyLabel = '15';
  /** @type {string} */

  var extLimitAfterAmbiguousChar = '9';
  /** @type {string} */

  var extLimitWhenNotSure = '6';
  /** @type {string} */

  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.

  /** @type {string} */

  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  /** @type {string} */

  var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
  // patterns like "ext.".

  /** @type {string} */

  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)"; // One-character symbols that can be used to indicate an extension, and less
  // commonly used or more ambiguous extension labels.

  /** @type {string} */

  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)"; // When extension is not separated clearly.

  /** @type {string} */

  var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
  // comma as extension label may have it.

  /** @type {string} */

  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
  // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
  // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
  // button with the extension number following.

  /** @type {string} */

  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  /** @type {string} */

  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  /** @type {string} */

  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  /** @type {string} */

  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  /** @type {string} */

  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  /** @type {string} */

  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  /** @type {string} */

  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
  // using ";ext=". The second more generic where extension is mentioned with explicit
  // labels like "ext:". In both the above cases we allow more numbers in extension than
  // any other extension labels. The third one captures when single character extension
  // labels or less commonly used labels are used. In such cases we capture fewer
  // extension digits in order to reduce the chance of falsely interpreting two
  // numbers beside each other as a number + extension. The fourth one covers the
  // special case of American numbers where the extension is written with a hash
  // at the end, such as "- 503#". The fifth one is exclusively for extension
  // autodialling formats which are used when dialling and in this case we accept longer
  // extensions. The last one is more liberal on the number of commas that acts as
  // extension labels, so we have a strict cap on the number of digits in such extensions.

  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}
//# sourceMappingURL=createExtensionPattern.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/isViablePhoneNumber.js

 //  Regular expression of viable phone numbers. This is location independent.
//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//

var MIN_LENGTH_PHONE_NUMBER_PATTERN = '[' + VALID_DIGITS + ']{' + MIN_LENGTH_FOR_NSN + '}'; //
// And this is the second reg-exp:
// (see MIN_LENGTH_PHONE_NUMBER_PATTERN for a full description of this reg-exp)
//

var VALID_PHONE_NUMBER = '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){3,}' + '[' + VALID_PUNCTUATION + VALID_DIGITS + ']*'; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.

var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp('^' + '[' + PLUS_CHARS + ']{0,1}' + '(?:' + '[' + VALID_PUNCTUATION + ']*' + '[' + VALID_DIGITS + ']' + '){1,2}' + '$', 'i');
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
'(?:' + createExtensionPattern() + ')?'; // The combined regular expression for valid phone numbers:
//

var VALID_PHONE_NUMBER_PATTERN = new RegExp( // Either a short two-digit-only phone number
'^' + MIN_LENGTH_PHONE_NUMBER_PATTERN + '$' + '|' + // Or a longer fully parsed phone number (min 3 characters)
'^' + VALID_PHONE_NUMBER_WITH_EXTENSION + '$', 'i'); // Checks to see if the string of characters could possibly be a phone number at
// all. At the moment, checks to see that the string begins with at least 2
// digits, ignoring any punctuation commonly found in phone numbers. This method
// does not require the number to be normalized in advance - but does assume
// that leading non-number symbols have been removed, such as by the method
// `extract_possible_number`.
//

function isViablePhoneNumber_isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.

function isViablePhoneNumberStart(number) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}
//# sourceMappingURL=isViablePhoneNumber.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/extension/extractExtension.js
 // Regexp of all known extension prefixes used by different regions followed by
// 1 or more valid digits, for use when parsing.

var EXTN_PATTERN = new RegExp('(?:' + createExtensionPattern() + ')$', 'i'); // Strips any extension (as in, the part of the number dialled after the call is
// connected, usually indicated with extn, ext, x or similar) from the end of
// the number, and returns it.

function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);

  if (start < 0) {
    return {};
  } // If we find a potential extension, and the number preceding this is a viable
  // number, we assume it is an extension.


  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;

  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }

    i++;
  }
}
//# sourceMappingURL=extractExtension.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/parseDigits.js
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// These mappings map a character (key) to a specific digit that should
// replace it for normalization purposes. Non-European digits that
// may be used in phone numbers are mapped to a European equivalent.
//
// E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
//
var DIGITS = {
  '0': '0',
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
  '5': '5',
  '6': '6',
  '7': '7',
  '8': '8',
  '9': '9',
  "\uFF10": '0',
  // Fullwidth digit 0
  "\uFF11": '1',
  // Fullwidth digit 1
  "\uFF12": '2',
  // Fullwidth digit 2
  "\uFF13": '3',
  // Fullwidth digit 3
  "\uFF14": '4',
  // Fullwidth digit 4
  "\uFF15": '5',
  // Fullwidth digit 5
  "\uFF16": '6',
  // Fullwidth digit 6
  "\uFF17": '7',
  // Fullwidth digit 7
  "\uFF18": '8',
  // Fullwidth digit 8
  "\uFF19": '9',
  // Fullwidth digit 9
  "\u0660": '0',
  // Arabic-indic digit 0
  "\u0661": '1',
  // Arabic-indic digit 1
  "\u0662": '2',
  // Arabic-indic digit 2
  "\u0663": '3',
  // Arabic-indic digit 3
  "\u0664": '4',
  // Arabic-indic digit 4
  "\u0665": '5',
  // Arabic-indic digit 5
  "\u0666": '6',
  // Arabic-indic digit 6
  "\u0667": '7',
  // Arabic-indic digit 7
  "\u0668": '8',
  // Arabic-indic digit 8
  "\u0669": '9',
  // Arabic-indic digit 9
  "\u06F0": '0',
  // Eastern-Arabic digit 0
  "\u06F1": '1',
  // Eastern-Arabic digit 1
  "\u06F2": '2',
  // Eastern-Arabic digit 2
  "\u06F3": '3',
  // Eastern-Arabic digit 3
  "\u06F4": '4',
  // Eastern-Arabic digit 4
  "\u06F5": '5',
  // Eastern-Arabic digit 5
  "\u06F6": '6',
  // Eastern-Arabic digit 6
  "\u06F7": '7',
  // Eastern-Arabic digit 7
  "\u06F8": '8',
  // Eastern-Arabic digit 8
  "\u06F9": '9' // Eastern-Arabic digit 9

};
function parseDigit(character) {
  return DIGITS[character];
}
/**
 * Parses phone number digits from a string.
 * Drops all punctuation leaving only digits.
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * parseDigits('8 (800) 555')
 * // Outputs '8800555'.
 * ```
 */

function parseDigits(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = _createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    var digit = parseDigit(character);

    if (digit) {
      result += digit;
    }
  }

  return result;
}
//# sourceMappingURL=parseDigits.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/parseIncompletePhoneNumber.js
function parseIncompletePhoneNumber_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = parseIncompletePhoneNumber_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function parseIncompletePhoneNumber_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return parseIncompletePhoneNumber_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return parseIncompletePhoneNumber_arrayLikeToArray(o, minLen); }

function parseIncompletePhoneNumber_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


/**
 * Parses phone number characters from a string.
 * Drops all punctuation leaving only digits and the leading `+` sign (if any).
 * Also converts wide-ascii and arabic-indic numerals to conventional numerals.
 * E.g. in Iraq they don't write `+442323234` but rather `+٤٤٢٣٢٣٢٣٤`.
 * @param  {string} string
 * @return {string}
 * @example
 * ```js
 * // Outputs '8800555'.
 * parseIncompletePhoneNumber('8 (800) 555')
 * // Outputs '+7800555'.
 * parseIncompletePhoneNumber('+7 800 555')
 * ```
 */

function parseIncompletePhoneNumber(string) {
  var result = ''; // Using `.split('')` here instead of normal `for ... of`
  // because the importing application doesn't neccessarily include an ES6 polyfill.
  // The `.split('')` approach discards "exotic" UTF-8 characters
  // (the ones consisting of four bytes) but digits
  // (including non-European ones) don't fall into that range
  // so such "exotic" characters would be discarded anyway.

  for (var _iterator = parseIncompletePhoneNumber_createForOfIteratorHelperLoose(string.split('')), _step; !(_step = _iterator()).done;) {
    var character = _step.value;
    result += parsePhoneNumberCharacter(character, result) || '';
  }

  return result;
}
/**
 * Parses next character while parsing phone number digits (including a `+`)
 * from text: discards everything except `+` and digits, and `+` is only allowed
 * at the start of a phone number.
 * For example, is used in `react-phone-number-input` where it uses
 * [`input-format`](https://gitlab.com/catamphetamine/input-format).
 * @param  {string} character - Yet another character from raw input string.
 * @param  {string?} prevParsedCharacters - Previous parsed characters.
 * @param  {function?} emitEvent - An optional "emit event" function.
 * @return {string?} The parsed character.
 */

function parsePhoneNumberCharacter(character, prevParsedCharacters, emitEvent) {
  // Only allow a leading `+`.
  if (character === '+') {
    // If this `+` is not the first parsed character
    // then discard it.
    if (prevParsedCharacters) {
      // `emitEvent` argument was added to this `export`ed function on Dec 26th, 2023.
      // Any 3rd-party code that used to `import` and call this function before that
      // won't be passing any `emitEvent` argument.
      //
      // The addition of the `emitEvent` argument was to fix the slightly-weird behavior
      // of parsing an input string when the user inputs something like `"2+7"
      // https://github.com/catamphetamine/react-phone-number-input/issues/437
      //
      // If the parser encounters an unexpected `+` in a string being parsed
      // then it simply discards that out-of-place `+` and any following characters.
      //
      if (typeof emitEvent === 'function') {
        emitEvent('end');
      }

      return;
    }

    return '+';
  } // Allow digits.


  return parseDigit(character);
}
//# sourceMappingURL=parseIncompletePhoneNumber.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/mergeArrays.js
function mergeArrays_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = mergeArrays_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function mergeArrays_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return mergeArrays_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return mergeArrays_arrayLikeToArray(o, minLen); }

function mergeArrays_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * Merges two arrays.
 * @param  {*} a
 * @param  {*} b
 * @return {*}
 */
function mergeArrays(a, b) {
  var merged = a.slice();

  for (var _iterator = mergeArrays_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;) {
    var element = _step.value;

    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }

  return merged.sort(function (a, b) {
    return a - b;
  }); // ES6 version, requires Set polyfill.
  // let merged = new Set(a)
  // for (const element of b) {
  // 	merged.add(i)
  // }
  // return Array.from(merged).sort((a, b) => a - b)
}
//# sourceMappingURL=mergeArrays.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/checkNumberLength.js

function checkNumberLength(nationalNumber, metadata) {
  return checkNumberLengthForType(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
// Should only be called for the "new" metadata which has "possible lengths".

function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
  // This is declared in the XML schema.
  // For size efficiency, where a sub-description (e.g. fixed-line)
  // has the same "<possiblePengths/>" as the "general description", this is missing,
  // so we fall back to the "general description". Where no numbers of the type
  // exist at all, there is one possible length (-1) which is guaranteed
  // not to match the length of any real phone number.

  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
  // Metadata before version `1.0.18` didn't contain `possible_lengths`.

  if (!possible_lengths) {
    return 'IS_POSSIBLE';
  }

  if (type === 'FIXED_LINE_OR_MOBILE') {
    // No such country in metadata.

    /* istanbul ignore next */
    if (!metadata.type('FIXED_LINE')) {
      // The rare case has been encountered where no fixedLine data is available
      // (true for some non-geographic entities), so we just check mobile.
      return checkNumberLengthForType(nationalNumber, 'MOBILE', metadata);
    }

    var mobile_type = metadata.type('MOBILE');

    if (mobile_type) {
      // Merge the mobile data in if there was any. "Concat" creates a new
      // array, it doesn't edit possible_lengths in place, so we don't need a copy.
      // Note that when adding the possible lengths from mobile, we have
      // to again check they aren't empty since if they are this indicates
      // they are the same as the general desc and should be obtained from there.
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
      // re-sort (duplicates are okay). Sorting isn't so expensive because
      // the lists are very small.
      // if (local_lengths) {
      // 	local_lengths = mergeArrays(local_lengths, mobile_type.possibleLengthsLocal())
      // } else {
      // 	local_lengths = mobile_type.possibleLengthsLocal()
      // }
    }
  } // If the type doesn't exist then return 'INVALID_LENGTH'.
  else if (type && !type_info) {
    return 'INVALID_LENGTH';
  }

  var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
  // // This is safe because there is never an overlap beween the possible lengths
  // // and the local-only lengths; this is checked at build time.
  // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
  // {
  // 	return 'IS_POSSIBLE_LOCAL_ONLY'
  // }

  var minimum_length = possible_lengths[0];

  if (minimum_length === actual_length) {
    return 'IS_POSSIBLE';
  }

  if (minimum_length > actual_length) {
    return 'TOO_SHORT';
  }

  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return 'TOO_LONG';
  } // We skip the first element since we've already checked it.


  return possible_lengths.indexOf(actual_length, 1) >= 0 ? 'IS_POSSIBLE' : 'INVALID_LENGTH';
}
//# sourceMappingURL=checkNumberLength.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/isPossible.js


/**
 * Checks if a phone number is "possible" (basically just checks its length).
 *
 * isPossible(phoneNumberInstance, { ..., v2: true }, metadata)
 *
 * isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
 * isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
 *
 * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {string}
 */

function isPossiblePhoneNumber(input, options, metadata) {
  /* istanbul ignore if */
  if (options === undefined) {
    options = {};
  }

  metadata = new Metadata(metadata);

  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error('Invalid phone number object passed');
    }

    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }

    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }

      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error('Invalid phone number object passed');
      }

      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  } // Old metadata (< 1.0.18) had no "possible length" data.


  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
  } else {
    // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
    // were missing for "non-geographical" numbering plans.
    // Just assume the number is possible in such cases:
    // it's unlikely that anyone generated their custom metadata
    // in that short period of time (one day).
    // This code can be removed in some future major version update.
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      // "Non-geographic entities" did't have `possibleLengths`
      // due to a bug in metadata generation process.
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata) {
  //, isInternational) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'IS_POSSIBLE':
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational

    default:
      return false;
  }
}
//# sourceMappingURL=isPossible.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/matchesEntirely.js
/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */
function matchesEntirely(text, regular_expression) {
  // If assigning the `''` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  text = text || '';
  return new RegExp('^(?:' + regular_expression + ')$').test(text);
}
//# sourceMappingURL=matchesEntirely.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/getNumberType.js
function getNumberType_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = getNumberType_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function getNumberType_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return getNumberType_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return getNumberType_arrayLikeToArray(o, minLen); }

function getNumberType_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



var NON_FIXED_LINE_PHONE_TYPES = ['MOBILE', 'PREMIUM_RATE', 'TOLL_FREE', 'SHARED_COST', 'VOIP', 'PERSONAL_NUMBER', 'PAGER', 'UAN', 'VOICEMAIL']; // Finds out national phone number type (fixed line, mobile, etc)

function getNumberType(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {}; // When `parse()` returns an empty object — `{}` —
  // that means that the phone number is malformed,
  // so it can't possibly be valid.

  if (!input.country && !input.countryCallingCode) {
    return;
  }

  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
  // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
  // Is this national number even valid for this country

  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  } // Is it fixed line number


  if (isNumberTypeEqualTo(nationalNumber, 'FIXED_LINE', metadata)) {
    // Because duplicate regular expressions are removed
    // to reduce metadata size, if "mobile" pattern is ""
    // then it means it was removed due to being a duplicate of the fixed-line pattern.
    //
    if (metadata.type('MOBILE') && metadata.type('MOBILE').pattern() === '') {
      return 'FIXED_LINE_OR_MOBILE';
    } // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
    // For example, for "US" country.
    // Old metadata (< `1.0.18`) had a specific "types" data structure
    // that happened to be `undefined` for `MOBILE` in that case.
    // Newer metadata (>= `1.0.18`) has another data structure that is
    // not `undefined` for `MOBILE` in that case (it's just an empty array).
    // So this `if` is just for backwards compatibility with old metadata.


    if (!metadata.type('MOBILE')) {
      return 'FIXED_LINE_OR_MOBILE';
    } // Check if the number happens to qualify as both fixed line and mobile.
    // (no such country in the minimal metadata set)

    /* istanbul ignore if */


    if (isNumberTypeEqualTo(nationalNumber, 'MOBILE', metadata)) {
      return 'FIXED_LINE_OR_MOBILE';
    }

    return 'FIXED_LINE';
  }

  for (var _iterator = getNumberType_createForOfIteratorHelperLoose(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;) {
    var type = _step.value;

    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);

  if (!type || !type.pattern()) {
    return false;
  } // Check if any possible number lengths are present;
  // if so, we use them to avoid checking
  // the validation pattern if they don't match.
  // If they are absent, this means they match
  // the general description, which we have
  // already checked before a specific number type.


  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }

  return matchesEntirely(nationalNumber, type.pattern());
}
//# sourceMappingURL=getNumberType.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/isValid.js



/**
 * Checks if a given phone number is valid.
 *
 * isValid(phoneNumberInstance, { ..., v2: true }, metadata)
 *
 * isPossible({ phone: '8005553535', country: 'RU' }, { ... }, metadata)
 * isPossible({ phone: '8005553535', country: 'RU' }, undefined, metadata)
 *
 * If the `number` is a string, it will be parsed to an object,
 * but only if it contains only valid phone number characters (including punctuation).
 * If the `number` is an object, it is used as is.
 *
 * The optional `defaultCountry` argument is the default country.
 * I.e. it does not restrict to just that country,
 * e.g. in those cases where several countries share
 * the same phone numbering rules (NANPA, Britain, etc).
 * For example, even though the number `07624 369230`
 * belongs to the Isle of Man ("IM" country code)
 * calling `isValidNumber('07624369230', 'GB', metadata)`
 * still returns `true` because the country is not restricted to `GB`,
 * it's just that `GB` is the default one for the phone numbering rules.
 * For restricting the country see `isValidNumberForRegion()`
 * though restricting a country might not be a good idea.
 * https://github.com/googlei18n/libphonenumber/blob/master/FAQ.md#when-should-i-use-isvalidnumberforregion
 *
 * Examples:
 *
 * ```js
 * isValidNumber('+78005553535', metadata)
 * isValidNumber('8005553535', 'RU', metadata)
 * isValidNumber('88005553535', 'RU', metadata)
 * isValidNumber({ phone: '8005553535', country: 'RU' }, metadata)
 * ```
 */

function isValidNumber(input, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata);
  /**
   * Checks if a phone number is "possible" (basically just checks its length).
   *
   * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
   * @param  {object} [options]
   * @param  {object} metadata
   * @return {string}
   */

  metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
  // distinguishing different countries having the same `countryCallingCode`.

  if (metadata.hasTypes()) {
    return getNumberType(input, options, metadata.metadata) !== undefined;
  } // If there are no type regexps for this country in metadata then use
  // `nationalNumberPattern` as a "better than nothing" replacement.


  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(nationalNumber, metadata.nationalNumberPattern());
}
//# sourceMappingURL=isValid.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/getPossibleCountriesForNumber.js

/**
 * Returns a list of countries that the phone number could potentially belong to.
 * @param  {string} callingCode — Calling code.
 * @param  {string} nationalNumber — National (significant) number.
 * @param  {object} metadata — Metadata.
 * @return {string[]} A list of possible countries.
 */

function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata) {
  var _metadata = new Metadata(metadata);

  var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return [];
  }

  return possibleCountries.filter(function (country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
  });
}

function couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
  var _metadata = new Metadata(metadata);

  _metadata.selectNumberingPlan(country);

  if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) {
    return true;
  }

  return false;
}
//# sourceMappingURL=getPossibleCountriesForNumber.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/applyInternationalSeparatorStyle.js
 // Removes brackets and replaces dashes with spaces.
//
// E.g. "(999) 111-22-33" -> "999 111 22 33"
//
// For some reason Google's metadata contains `<intlFormat/>`s with brackets and dashes.
// Meanwhile, there's no single opinion about using punctuation in international phone numbers.
//
// For example, Google's `<intlFormat/>` for USA is `+1 213-373-4253`.
// And here's a quote from WikiPedia's "North American Numbering Plan" page:
// https://en.wikipedia.org/wiki/North_American_Numbering_Plan
//
// "The country calling code for all countries participating in the NANP is 1.
// In international format, an NANP number should be listed as +1 301 555 01 00,
// where 301 is an area code (Maryland)."
//
// I personally prefer the international format without any punctuation.
// For example, brackets are remnants of the old age, meaning that the
// phone number part in brackets (so called "area code") can be omitted
// if dialing within the same "area".
// And hyphens were clearly introduced for splitting local numbers into memorizable groups.
// For example, remembering "5553535" is difficult but "555-35-35" is much simpler.
// Imagine a man taking a bus from home to work and seeing an ad with a phone number.
// He has a couple of seconds to memorize that number until it passes by.
// If it were spaces instead of hyphens the man wouldn't necessarily get it,
// but with hyphens instead of spaces the grouping is more explicit.
// I personally think that hyphens introduce visual clutter,
// so I prefer replacing them with spaces in international numbers.
// In the modern age all output is done on displays where spaces are clearly distinguishable
// so hyphens can be safely replaced with spaces without losing any legibility.
//

function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), 'g'), ' ').trim();
}
//# sourceMappingURL=applyInternationalSeparatorStyle.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/formatNationalNumberUsingFormat.js
 // This was originally set to $1 but there are some countries for which the
// first group is not used in the national pattern (e.g. Argentina) so the $1
// group does not match correctly. Therefore, we use `\d`, so that the first
// group actually used in the pattern will be matched.

var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat,
      withNationalPrefix = _ref.withNationalPrefix,
      carrierCode = _ref.carrierCode,
      metadata = _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // This library doesn't use `domestic_carrier_code_formatting_rule`,
  // because that one is only used when formatting phone numbers
  // for dialing from a mobile phone, and this is not a dialing library.
  // carrierCode && format.domesticCarrierCodeFormattingRule()
  // 	// First, replace the $CC in the formatting rule with the desired carrier code.
  // 	// Then, replace the $FG in the formatting rule with the first group
  // 	// and the carrier code combined in the appropriate way.
  // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
  // 	: (
  // 		withNationalPrefix && format.nationalPrefixFormattingRule()
  // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
  // 			: format.format()
  // 	)
  withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format());

  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }

  return formattedNumber;
}
//# sourceMappingURL=formatNationalNumberUsingFormat.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/getIddPrefix.js

/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */

var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
// a preferred IDD prefix is returned.

function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);

  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }

  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}
//# sourceMappingURL=getIddPrefix.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/RFC3966.js
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || RFC3966_unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function RFC3966_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = RFC3966_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function RFC3966_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return RFC3966_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return RFC3966_arrayLikeToArray(o, minLen); }

function RFC3966_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

 // https://www.ietf.org/rfc/rfc3966.txt

/**
 * @param  {string} text - Phone URI (RFC 3966).
 * @return {object} `{ ?number, ?ext }`.
 */

function parseRFC3966(text) {
  var number;
  var ext; // Replace "tel:" with "tel=" for parsing convenience.

  text = text.replace(/^tel:/, 'tel=');

  for (var _iterator = RFC3966_createForOfIteratorHelperLoose(text.split(';')), _step; !(_step = _iterator()).done;) {
    var part = _step.value;

    var _part$split = part.split('='),
        _part$split2 = _slicedToArray(_part$split, 2),
        name = _part$split2[0],
        value = _part$split2[1];

    switch (name) {
      case 'tel':
        number = value;
        break;

      case 'ext':
        ext = value;
        break;

      case 'phone-context':
        // Only "country contexts" are supported.
        // "Domain contexts" are ignored.
        if (value[0] === '+') {
          number = value + number;
        }

        break;
    }
  } // If the phone number is not viable, then abort.


  if (!isViablePhoneNumber(number)) {
    return {};
  }

  var result = {
    number: number
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * @param  {object} - `{ ?number, ?extension }`.
 * @return {string} Phone URI (RFC 3966).
 */

function formatRFC3966(_ref) {
  var number = _ref.number,
      ext = _ref.ext;

  if (!number) {
    return '';
  }

  if (number[0] !== '+') {
    throw new Error("\"formatRFC3966()\" expects \"number\" to be in E.164 format.");
  }

  return "tel:".concat(number).concat(ext ? ';ext=' + ext : '');
}
//# sourceMappingURL=RFC3966.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/format.js
function format_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = format_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function format_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return format_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return format_arrayLikeToArray(o, minLen); }

function format_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js





var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  }
};
/**
 * Formats a phone number.
 *
 * format(phoneNumberInstance, 'INTERNATIONAL', { ..., v2: true }, metadata)
 * format(phoneNumberInstance, 'NATIONAL', { ..., v2: true }, metadata)
 *
 * format({ phone: '8005553535', country: 'RU' }, 'INTERNATIONAL', { ... }, metadata)
 * format({ phone: '8005553535', country: 'RU' }, 'NATIONAL', undefined, metadata)
 *
 * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
 * @param  {string} format
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {string}
 */

function formatNumber(input, format, options, metadata) {
  // Apply default options.
  if (options) {
    options = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
  } else {
    options = DEFAULT_OPTIONS;
  }

  metadata = new Metadata(metadata);

  if (input.country && input.country !== '001') {
    // Validate `input.country`.
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }

    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || '';

  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
  // but Babel has a bug and it says "duplicate variable declaration".

  var number;

  switch (format) {
    case 'NATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return '';
      }

      number = formatNationalNumber(nationalNumber, input.carrierCode, 'NATIONAL', metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'INTERNATIONAL':
      // Legacy argument support.
      // (`{ country: ..., phone: '' }`)
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }

      number = formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);

    case 'E.164':
      // `E.164` doesn't define "phone number extensions".
      return "+".concat(countryCallingCode).concat(nationalNumber);

    case 'RFC3966':
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?

    case 'IDD':
      if (!options.fromCountry) {
        return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
      }

      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);

    default:
      throw new Error("Unknown \"format\" argument passed to \"formatNumber()\": \"".concat(format, "\""));
  }
}

function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);

  if (!format) {
    return number;
  }

  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === 'INTERNATIONAL',
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode: carrierCode,
    metadata: metadata
  });
}

function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = format_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;) {
    var format = _step.value;

    // Validate leading digits.
    // The test case for "else path" could be found by searching for
    // "format.leadingDigitsPatterns().length === 0".
    if (format.leadingDigitsPatterns().length > 0) {
      // The last leading_digits_pattern is used here, as it is the most detailed
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format

      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    } // Check that the national number matches the phone number format regular expression


    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}

function addExtension(formattedNumber, ext, metadata, formatExtension) {
  return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}

function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata.metadata); // When calling within the same country calling code.

  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, 'NATIONAL', metadata); // For NANPA regions, return the national format for these regions
    // but prefix it with the country calling code.

    if (countryCallingCode === '1') {
      return countryCallingCode + ' ' + formattedNumber;
    } // If regions share a country calling code, the country calling code need
    // not be dialled. This also applies when dialling within a region, so this
    // if clause covers both these cases. Technically this is the case for
    // dialling from La Reunion to other overseas departments of France (French
    // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
    // this edge case for now and for those cases return the version including
    // country calling code. Details here:
    // http://www.petitfute.com/voyage/225-info-pratiques-reunion
    //


    return formattedNumber;
  }

  var iddPrefix = getIddPrefix(fromCountry, undefined, metadata.metadata);

  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, 'INTERNATIONAL', metadata));
  }
}
//# sourceMappingURL=format.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/PhoneNumber.js
function PhoneNumber_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PhoneNumber_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PhoneNumber_ownKeys(Object(source), !0).forEach(function (key) { PhoneNumber_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PhoneNumber_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function PhoneNumber_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function PhoneNumber_classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PhoneNumber_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function PhoneNumber_createClass(Constructor, protoProps, staticProps) { if (protoProps) PhoneNumber_defineProperties(Constructor.prototype, protoProps); if (staticProps) PhoneNumber_defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }



 // import checkNumberLength from './helpers/checkNumberLength.js'




var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;

var PhoneNumber = /*#__PURE__*/function () {
  /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */
  function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
    PhoneNumber_classCallCheck(this, PhoneNumber);

    if (!countryOrCountryCallingCode) {
      throw new TypeError('`country` or `countryCallingCode` not passed');
    }

    if (!nationalNumber) {
      throw new TypeError('`nationalNumber` not passed');
    }

    if (!metadata) {
      throw new TypeError('`metadata` not passed');
    }

    var _getCountryAndCountry = getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata),
        country = _getCountryAndCountry.country,
        countryCallingCode = _getCountryAndCountry.countryCallingCode;

    this.country = country;
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = '+' + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
    // so that it doesn't clutter the console output of Node.js.
    // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
    // it would output the whole internal structure of the `metadata` object.

    this.getMetadata = function () {
      return metadata;
    };
  }

  PhoneNumber_createClass(PhoneNumber, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "getPossibleCountries",
    value: function getPossibleCountries() {
      if (this.country) {
        return [this.country];
      }

      return getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new Metadata(this.getMetadata());
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }

  }, {
    key: "getType",
    value: function getType() {
      return getNumberType(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber(this, _format, options ? PhoneNumber_objectSpread(PhoneNumber_objectSpread({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format('NATIONAL', options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format('INTERNATIONAL', options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format('RFC3966', options);
    }
  }]);

  return PhoneNumber;
}();



var isCountryCode = function isCountryCode(value) {
  return /^[A-Z]{2}$/.test(value);
};

function getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
  var country;
  var countryCallingCode;
  var metadata = new Metadata(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
  // Also store the country code as `.country`.

  if (isCountryCode(countryOrCountryCallingCode)) {
    country = countryOrCountryCallingCode;
    metadata.selectNumberingPlan(country);
    countryCallingCode = metadata.countryCallingCode();
  } else {
    countryCallingCode = countryOrCountryCallingCode;
    /* istanbul ignore if */

    if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
      if (metadata.isNonGeographicCallingCode(countryCallingCode)) {
        country = '001';
      }
    }
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode
  };
}
//# sourceMappingURL=PhoneNumber.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/stripIddPrefix.js


var CAPTURING_DIGIT_PATTERN = new RegExp('([' + VALID_DIGITS + '])');
function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  } // Check if the number is IDD-prefixed.


  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());

  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  } // Strip IDD prefix.


  number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
  // then those digits are a country calling code.
  // Since no country code starts with a `0`,
  // the code below validates that the next digit (if present) is not `0`.

  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);

  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === '0') {
      return;
    }
  }

  return number;
}
//# sourceMappingURL=stripIddPrefix.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/extractNationalNumberFromPossiblyIncompleteNumber.js
/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    // See METADATA.md for the description of
    // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
    // Attempt to parse the first digits as a national prefix.
    var prefixPattern = new RegExp('^(?:' + metadata.numberingPlan.nationalPrefixForParsing() + ')');
    var prefixMatch = prefixPattern.exec(number);

    if (prefixMatch) {
      var nationalNumber;
      var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
      // If a `national_prefix_for_parsing` has any "capturing groups"
      // then it means that the national (significant) number is equal to
      // those "capturing groups" transformed via `national_prefix_transform_rule`,
      // and nothing could be said about the actual national prefix:
      // what is it and was it even there.
      // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
      // then everything it matches is a national prefix.
      // To determine whether `national_prefix_for_parsing` matched any
      // "capturing groups", the value of the result of calling `.exec()`
      // is looked at, and if it has non-undefined values where there're
      // "capturing groups" in the regular expression, then it means
      // that "capturing groups" have been matched.
      // It's not possible to tell whether there'll be any "capturing gropus"
      // before the matching process, because a `national_prefix_for_parsing`
      // could exhibit both behaviors.

      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];

      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
        // then carrier code is the second one.

        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } // If there're no "capturing groups",
      // or if there're "capturing groups" but no
      // `national_prefix_transform_rule`,
      // then just strip the national prefix from the number,
      // and possibly a carrier code.
      // Seems like there could be more.
      else {
        // `prefixBeforeNationalNumber` is the whole substring matched by
        // the `national_prefix_for_parsing` regular expression.
        // There seem to be no guarantees that it's just a national prefix.
        // For example, if there's a carrier code, it's gonna be a
        // part of `prefixBeforeNationalNumber` too.
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
        // then carrier code is the first one.

        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      } // Tries to guess whether a national prefix was present in the input.
      // This is not something copy-pasted from Google's library:
      // they don't seem to have an equivalent for that.
      // So this isn't an "officially approved" way of doing something like that.
      // But since there seems no other existing method, this library uses it.


      var nationalPrefix;

      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
        // `prefixMatch[0]` is `01115`, and `$1` is `11`,
        // and the rest of the phone number is `23456789`.
        // The national number is transformed via `9$1` to `91123456789`.
        // National prefix `0` is detected being present at the start.
        // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {

        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }

      return {
        nationalNumber: nationalNumber,
        nationalPrefix: nationalPrefix,
        carrierCode: carrierCode
      };
    }
  }

  return {
    nationalNumber: number
  };
}
//# sourceMappingURL=extractNationalNumberFromPossiblyIncompleteNumber.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/extractNationalNumber.js



/**
 * Strips national prefix and carrier code from a complete phone number.
 * The difference from the non-"FromCompleteNumber" function is that
 * it won't extract national prefix if the resultant number is too short
 * to be a complete number for the selected phone numbering plan.
 * @param  {string} number — Complete phone number digits.
 * @param  {Metadata} metadata — Metadata with a phone numbering plan selected.
 * @return {object} `{ nationalNumber: string, carrierCode: string? }`.
 */

function extractNationalNumber(number, metadata) {
  // Parsing national prefixes and carrier codes
  // is only required for local phone numbers
  // but some people don't understand that
  // and sometimes write international phone numbers
  // with national prefixes (or maybe even carrier codes).
  // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
  // Google's original library forgives such mistakes
  // and so does this library, because it has been requested:
  // https://github.com/catamphetamine/libphonenumber-js/issues/127
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata),
      carrierCode = _extractNationalNumbe.carrierCode,
      nationalNumber = _extractNationalNumbe.nationalNumber;

  if (nationalNumber !== number) {
    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) {
      // Don't strip the national prefix.
      return {
        nationalNumber: number
      };
    } // Check the national (significant) number length after extracting national prefix and carrier code.
    // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.


    if (metadata.possibleLengths()) {
      // The number remaining after stripping the national prefix and carrier code
      // should be long enough to have a possible length for the country.
      // Otherwise, don't strip the national prefix and carrier code,
      // since the original number could be a valid number.
      // This check has been copy-pasted "as is" from Google's original library:
      // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
      // It doesn't check for the "possibility" of the original `number`.
      // I guess it's fine not checking that one. It works as is anyway.
      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata)) {
        // Don't strip the national prefix.
        return {
          nationalNumber: number
        };
      }
    }
  }

  return {
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.

function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
  // The equivalent in Google's code is:
  // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
  if (matchesEntirely(nationalNumberBefore, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata.nationalNumberPattern())) {
    return false;
  } // This "is possible" national number (length) check has been commented out
  // because it's superceded by the (effectively) same check done in the
  // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
  // In other words, why run the same check twice if it could only be run once.
  // // Check the national (significant) number length after extracting national prefix and carrier code.
  // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
  // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
  // if (metadata.possibleLengths()) {
  // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
  // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
  // 		return false
  // 	}
  // }


  return true;
}

function isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case 'TOO_SHORT':
    case 'INVALID_LENGTH':
      // This library ignores "local-only" phone numbers (for simplicity).
      // See the readme for more info on what are "local-only" phone numbers.
      // case 'IS_POSSIBLE_LOCAL_ONLY':
      return false;

    default:
      return true;
  }
}
//# sourceMappingURL=extractNationalNumber.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js





/**
 * Sometimes some people incorrectly input international phone numbers
 * without the leading `+`. This function corrects such input.
 * @param  {string} number — Phone number digits.
 * @param  {string?} country
 * @param  {string?} callingCode
 * @param  {object} metadata
 * @return {object} `{ countryCallingCode: string?, number: string }`.
 */

function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata) : callingCode;

  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new Metadata(metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);

    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata),
        possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;

    var _extractNationalNumbe2 = extractNationalNumber(number, metadata),
        nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
    // or if it was too long before, we consider the number
    // with the country calling code stripped to be a better result
    // and keep that instead.
    // For example, in Germany (+49), `49` is a valid area code,
    // so if a number starts with `49`, it could be both a valid
    // national German number or an international number without
    // a leading `+`.


    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata) === 'TOO_LONG') {
      return {
        countryCallingCode: countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }

  return {
    number: number
  };
}
//# sourceMappingURL=extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCode.js




/**
 * Converts a phone number digits (possibly with a `+`)
 * into a calling code and the rest phone number digits.
 * The "rest phone number digits" could include
 * a national prefix, carrier code, and national
 * (significant) number.
 * @param  {string} number — Phone number digits (possibly with a `+`).
 * @param  {string} [country] — Default country.
 * @param  {string} [callingCode] — Default calling code (some phone numbering plans are non-geographic).
 * @param  {object} metadata
 * @return {object} `{ countryCallingCodeSource: string?, countryCallingCode: string?, number: string }`
 * @example
 * // Returns `{ countryCallingCode: "1", number: "2133734253" }`.
 * extractCountryCallingCode('2133734253', 'US', null, metadata)
 * extractCountryCallingCode('2133734253', null, '1', metadata)
 * extractCountryCallingCode('+12133734253', null, null, metadata)
 * extractCountryCallingCode('+12133734253', 'RU', null, metadata)
 */

function extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  }

  var isNumberWithIddPrefix; // If this is not an international phone number,
  // then either extract an "IDD" prefix, or extract a
  // country calling code from a number by autocorrecting it
  // by prepending a leading `+` in cases when it starts
  // with the country calling code.
  // https://wikitravel.org/en/International_dialling_prefix
  // https://github.com/catamphetamine/libphonenumber-js/issues/376

  if (number[0] !== '+') {
    // Convert an "out-of-country" dialing phone number
    // to a proper international phone number.
    var numberWithoutIDD = stripIddPrefix(number, country, callingCode, metadata); // If an IDD prefix was stripped then
    // convert the number to international one
    // for subsequent parsing.

    if (numberWithoutIDD && numberWithoutIDD !== number) {
      isNumberWithIddPrefix = true;
      number = '+' + numberWithoutIDD;
    } else {
      // Check to see if the number starts with the country calling code
      // for the default country. If so, we remove the country calling code,
      // and do some checks on the validity of the number before and after.
      // https://github.com/catamphetamine/libphonenumber-js/issues/376
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata),
            countryCallingCode = _extractCountryCallin.countryCallingCode,
            shorterNumber = _extractCountryCallin.number;

        if (countryCallingCode) {
          return {
            countryCallingCodeSource: 'FROM_NUMBER_WITHOUT_PLUS_SIGN',
            countryCallingCode: countryCallingCode,
            number: shorterNumber
          };
        }
      }

      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: number
      };
    }
  } // Fast abortion: country codes do not begin with a '0'


  if (number[1] === '0') {
    return {};
  }

  metadata = new Metadata(metadata); // The thing with country phone codes
  // is that they are orthogonal to each other
  // i.e. there's no such country phone code A
  // for which country phone code B exists
  // where B starts with A.
  // Therefore, while scanning digits,
  // if a valid country code is found,
  // that means that it is the country code.
  //

  var i = 2;

  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);

    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCodeSource: isNumberWithIddPrefix ? 'FROM_NUMBER_WITH_IDD' : 'FROM_NUMBER_WITH_PLUS_SIGN',
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }

    i++;
  }

  return {};
} // The possible values for the returned `countryCallingCodeSource` are:
//
// Copy-pasted from:
// https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
//
// // The source from which the country_code is derived. This is not set in the
// // general parsing method, but in the method that parses and keeps raw_input.
// // New fields could be added upon request.
// enum CountryCodeSource {
//  // Default value returned if this is not set, because the phone number was
//  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
//  // return false if this is the case.
//  UNSPECIFIED = 0;
//
//  // The country_code is derived based on a phone number with a leading "+",
//  // e.g. the French number "+33 1 42 68 53 00".
//  FROM_NUMBER_WITH_PLUS_SIGN = 1;
//
//  // The country_code is derived based on a phone number with a leading IDD,
//  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
//  FROM_NUMBER_WITH_IDD = 5;
//
//  // The country_code is derived based on a phone number without a leading
//  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
//  // supplied as France.
//  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
//
//  // The country_code is derived NOT based on the phone number itself, but
//  // from the defaultCountry parameter provided in the parsing function by the
//  // clients. This happens mostly for numbers written in the national format
//  // (without country code). For example, this would be set when parsing the
//  // French number "01 42 68 53 00", when defaultCountry is supplied as
//  // France.
//  FROM_DEFAULT_COUNTRY = 20;
// }
//# sourceMappingURL=extractCountryCallingCode.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/getCountryByNationalNumber.js
function getCountryByNationalNumber_createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = getCountryByNationalNumber_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function getCountryByNationalNumber_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return getCountryByNationalNumber_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return getCountryByNationalNumber_arrayLikeToArray(o, minLen); }

function getCountryByNationalNumber_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function getCountryByNationalNumber(nationalPhoneNumber, _ref) {
  var countries = _ref.countries,
      defaultCountry = _ref.defaultCountry,
      metadata = _ref.metadata;
  // Re-create `metadata` because it will be selecting a `country`.
  metadata = new Metadata(metadata);
  var matchingCountries = [];

  for (var _iterator = getCountryByNationalNumber_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;) {
    var country = _step.value;
    metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
    // By definition, matching "leading digits" is a sufficient but not a necessary
    // condition for a phone number to belong to a country.
    // The point of "leading digits" check is that it's the fastest one to get a match.
    // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
    // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
    // because of the intended use of that feature.

    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } // Else perform full validation with all of those
    // fixed-line/mobile/etc regular expressions.
    else if (getNumberType({
      phone: nationalPhoneNumber,
      country: country
    }, undefined, metadata.metadata)) {
      // If the `defaultCountry` is among the `matchingCountries` then return it.
      if (defaultCountry) {
        if (country === defaultCountry) {
          return country;
        }

        matchingCountries.push(country);
      } else {
        return country;
      }
    }
  } // Return the first ("main") one of the `matchingCountries`.


  if (matchingCountries.length > 0) {
    return matchingCountries[0];
  }
}
//# sourceMappingURL=getCountryByNationalNumber.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/getCountryByCallingCode.js

var getCountryByCallingCode_USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function getCountryByCallingCode(callingCode, _ref) {
  var nationalPhoneNumber = _ref.nationalNumber,
      defaultCountry = _ref.defaultCountry,
      metadata = _ref.metadata;

  /* istanbul ignore if */
  if (getCountryByCallingCode_USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
    if (metadata.isNonGeographicCallingCode(callingCode)) {
      return '001';
    }
  }

  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);

  if (!possibleCountries) {
    return;
  } // If there's just one country corresponding to the country code,
  // then just return it, without further phone number digits validation.


  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }

  return getCountryByNationalNumber(nationalPhoneNumber, {
    countries: possibleCountries,
    defaultCountry: defaultCountry,
    metadata: metadata.metadata
  });
}
//# sourceMappingURL=getCountryByCallingCode.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/extractPhoneContext.js
// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var PLUS_SIGN = '+';
var RFC3966_VISUAL_SEPARATOR_ = '[\\-\\.\\(\\)]?';
var RFC3966_PHONE_DIGIT_ = '(' + '[' + VALID_DIGITS + ']' + '|' + RFC3966_VISUAL_SEPARATOR_ + ')';
var RFC3966_GLOBAL_NUMBER_DIGITS_ = '^' + '\\' + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + '*' + '[' + VALID_DIGITS + ']' + RFC3966_PHONE_DIGIT_ + '*' + '$';
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */

var RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, 'g'); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS

var ALPHANUM_ = VALID_DIGITS;
var RFC3966_DOMAINLABEL_ = '[' + ALPHANUM_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
var VALID_ALPHA_ = 'a-zA-Z';
var RFC3966_TOPLABEL_ = '[' + VALID_ALPHA_ + ']+((\\-)*[' + ALPHANUM_ + '])*';
var RFC3966_DOMAINNAME_ = '^(' + RFC3966_DOMAINLABEL_ + '\\.)*' + RFC3966_TOPLABEL_ + '\\.?$';
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */

var RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, 'g');
var RFC3966_PREFIX_ = 'tel:';
var RFC3966_PHONE_CONTEXT_ = ';phone-context=';
var RFC3966_ISDN_SUBADDRESS_ = ';isub=';
/**
 * Extracts the value of the phone-context parameter of `numberToExtractFrom`,
 * following the syntax defined in RFC3966.
 *
 * @param {string} numberToExtractFrom
 * @return {string|null} the extracted string (possibly empty), or `null` if no phone-context parameter is found.
 */

function extractPhoneContext(numberToExtractFrom) {
  var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_); // If no phone-context parameter is present

  if (indexOfPhoneContext < 0) {
    return null;
  }

  var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length; // If phone-context parameter is empty

  if (phoneContextStart >= numberToExtractFrom.length) {
    return '';
  }

  var phoneContextEnd = numberToExtractFrom.indexOf(';', phoneContextStart); // If phone-context is not the last parameter

  if (phoneContextEnd >= 0) {
    return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
  } else {
    return numberToExtractFrom.substring(phoneContextStart);
  }
}
/**
 * Returns whether the value of phoneContext follows the syntax defined in RFC3966.
 *
 * @param {string|null} phoneContext
 * @return {boolean}
 */

function isPhoneContextValid(phoneContext) {
  if (phoneContext === null) {
    return true;
  }

  if (phoneContext.length === 0) {
    return false;
  } // Does phone-context value match pattern of global-number-digits or domainname.


  return RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}
//# sourceMappingURL=extractPhoneContext.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/helpers/extractFormattedPhoneNumberFromPossibleRfc3966NumberUri.js


/**
 * @param  {string} numberToParse
 * @param  {string} nationalNumber
 * @return {}
 */

function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
  var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
  var phoneContext = extractPhoneContext(numberToParse);

  if (!isPhoneContextValid(phoneContext)) {
    throw new ParseError('NOT_A_NUMBER');
  }

  var phoneNumberString;

  if (phoneContext === null) {
    // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || '';
  } else {
    phoneNumberString = ''; // If the phone context contains a phone number prefix, we need to capture
    // it, whereas domains will be ignored.

    if (phoneContext.charAt(0) === PLUS_SIGN) {
      phoneNumberString += phoneContext;
    } // Now append everything between the "tel:" prefix and the phone-context.
    // This should include the national number, an optional extension or
    // isdn-subaddress component. Note we also handle the case when "tel:" is
    // missing, as we have seen in some of the phone number inputs.
    // In that case, we append everything from the beginning.


    var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_);
    var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
    // `isPhoneContextValid()` requires it to be present.

    /* istanbul ignore else */

    if (indexOfRfc3966Prefix >= 0) {
      indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length;
    } else {
      indexOfNationalNumber = 0;
    }

    var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
    phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
  } // Delete the isdn-subaddress and everything after it if it is present.
  // Note extension won't appear at the same time with isdn-subaddress
  // according to paragraph 5.3 of the RFC3966 spec.


  var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);

  if (indexOfIsdn > 0) {
    phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
  } // If both phone context and isdn-subaddress are absent but other
  // parameters are present, the parameters are left in nationalNumber.
  // This is because we are concerned about deleting content from a potential
  // number string when there is no strong evidence that the number is
  // actually written in RFC3966.


  if (phoneNumberString !== '') {
    return phoneNumberString;
  }
}
//# sourceMappingURL=extractFormattedPhoneNumberFromPossibleRfc3966NumberUri.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/parse.js
// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js







 // import { parseRFC3966 } from './helpers/RFC3966.js'







 // We don't allow input strings for parsing to be longer than 250 chars.
// This prevents malicious input from consuming CPU.

var MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.

var PHONE_NUMBER_START_PATTERN = new RegExp('[' + PLUS_CHARS + VALID_DIGITS + ']'); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".

var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp('[^' + VALID_DIGITS + '#' + ']+$');
var parse_USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
//
// ```js
// parse('8 (800) 555-35-35', 'RU')
// parse('8 (800) 555-35-35', 'RU', metadata)
// parse('8 (800) 555-35-35', { country: { default: 'RU' } })
// parse('8 (800) 555-35-35', { country: { default: 'RU' } }, metadata)
// parse('+7 800 555 35 35')
// parse('+7 800 555 35 35', metadata)
// ```
//

/**
 * Parses a phone number.
 *
 * parse('123456789', { defaultCountry: 'RU', v2: true }, metadata)
 * parse('123456789', { defaultCountry: 'RU' }, metadata)
 * parse('123456789', undefined, metadata)
 *
 * @param  {string} input
 * @param  {object} [options]
 * @param  {object} metadata
 * @return {object|PhoneNumber?} If `options.v2: true` flag is passed, it returns a `PhoneNumber?` instance. Otherwise, returns an object of shape `{ phone: '...', country: '...' }` (or just `{}` if no phone number was parsed).
 */

function parse(text, options, metadata) {
  // If assigning the `{}` default value is moved to the arguments above,
  // code coverage would decrease for some weird reason.
  options = options || {};
  metadata = new Metadata(metadata); // Validate `defaultCountry`.

  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    throw new Error("Unknown country: ".concat(options.defaultCountry));
  } // Parse the phone number.


  var _parseInput = parseInput(text, options.v2, options.extract),
      formattedPhoneNumber = _parseInput.number,
      ext = _parseInput.ext,
      error = _parseInput.error; // If the phone number is not viable then return nothing.


  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === 'TOO_SHORT') {
        throw new ParseError('TOO_SHORT');
      }

      throw new ParseError('NOT_A_NUMBER');
    }

    return {};
  }

  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata),
      country = _parsePhoneNumber.country,
      nationalNumber = _parsePhoneNumber.nationalNumber,
      countryCallingCode = _parsePhoneNumber.countryCallingCode,
      countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource,
      carrierCode = _parsePhoneNumber.carrierCode;

  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError('INVALID_COUNTRY');
    }

    return {};
  } // Validate national (significant) number length.


  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    // Won't throw here because the regexp already demands length > 1.

    /* istanbul ignore if */
    if (options.v2) {
      throw new ParseError('TOO_SHORT');
    } // Google's demo just throws an error in this case.


    return {};
  } // Validate national (significant) number length.
  //
  // A sidenote:
  //
  // They say that sometimes national (significant) numbers
  // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
  // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
  // Such numbers will just be discarded.
  //


  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError('TOO_LONG');
    } // Google's demo just throws an error in this case.


    return {};
  }

  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);

    if (country) {
      phoneNumber.country = country;
    }

    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }

    if (ext) {
      phoneNumber.ext = ext;
    }

    phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
    return phoneNumber;
  } // Check if national phone number pattern matches the number.
  // National number pattern is different for each country,
  // even for those ones which are part of the "NANPA" group.


  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;

  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  } // isInternational: countryCallingCode !== undefined


  return {
    country: country,
    countryCallingCode: countryCallingCode,
    carrierCode: carrierCode,
    valid: valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, metadata) ? true : false,
    phone: nationalNumber,
    ext: ext
  };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */

function _extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }

  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError('TOO_LONG');
    }

    return;
  }

  if (extract === false) {
    return text;
  } // Attempt to extract a possible number from the string passed in


  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);

  if (startsAt < 0) {
    return;
  }

  return text // Trim everything to the left of the phone number
  .slice(startsAt) // Remove trailing non-numerical characters
  .replace(AFTER_PHONE_NUMBER_END_PATTERN, '');
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */


function parseInput(text, v2, extract) {
  // // Parse RFC 3966 phone number URI.
  // if (text && text.indexOf('tel:') === 0) {
  // 	return parseRFC3966(text)
  // }
  // let number = extractFormattedPhoneNumber(text, extract, v2)
  var number = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text, {
    extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
      return _extractFormattedPhoneNumber(text, extract, v2);
    }
  }); // If the phone number is not viable, then abort.

  if (!number) {
    return {};
  }

  if (!isViablePhoneNumber_isViablePhoneNumber(number)) {
    if (isViablePhoneNumberStart(number)) {
      return {
        error: 'TOO_SHORT'
      };
    }

    return {};
  } // Attempt to parse extension first, since it doesn't require region-specific
  // data and we want to have the non-normalised number here.


  var withExtensionStripped = extractExtension(number);

  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }

  return {
    number: number
  };
}
/**
 * Creates `parse()` result object.
 */


function result(country, nationalNumber, ext) {
  var result = {
    country: country,
    phone: nationalNumber
  };

  if (ext) {
    result.ext = ext;
  }

  return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */


function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  // Extract calling code from phone number.
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata),
      countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource,
      countryCallingCode = _extractCountryCallin.countryCallingCode,
      number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.


  var country;

  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  } // If `formattedPhoneNumber` is passed in "national" format
  // then `number` is defined and `countryCallingCode` is `undefined`.
  else if (number && (defaultCountry || defaultCallingCode)) {
    metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);

    if (defaultCountry) {
      country = defaultCountry;
    } else {
      /* istanbul ignore if */
      if (parse_USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(defaultCallingCode)) {
          country = '001';
        }
      }
    }

    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata.metadata);
  } else return {};

  if (!number) {
    return {
      countryCallingCodeSource: countryCallingCodeSource,
      countryCallingCode: countryCallingCode
    };
  }

  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), metadata),
      nationalNumber = _extractNationalNumbe.nationalNumber,
      carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
  // corresponding to the same country phone code
  // (e.g. NANPA countries all having `1` country phone code).
  // Therefore, to reliably determine the exact country,
  // national (significant) number should have been parsed first.
  //
  // When `metadata.json` is generated, all "ambiguous" country phone codes
  // get their countries populated with the full set of
  // "phone number type" regular expressions.
  //


  var exactCountry = getCountryByCallingCode(countryCallingCode, {
    nationalNumber: nationalNumber,
    defaultCountry: defaultCountry,
    metadata: metadata
  });

  if (exactCountry) {
    country = exactCountry;
    /* istanbul ignore if */

    if (exactCountry === '001') {// Can't happen with `USE_NON_GEOGRAPHIC_COUNTRY_CODE` being `false`.
      // If `USE_NON_GEOGRAPHIC_COUNTRY_CODE` is set to `true` for some reason,
      // then remove the "istanbul ignore if".
    } else {
      metadata.country(country);
    }
  }

  return {
    country: country,
    countryCallingCode: countryCallingCode,
    countryCallingCodeSource: countryCallingCodeSource,
    nationalNumber: nationalNumber,
    carrierCode: carrierCode
  };
}
//# sourceMappingURL=parse.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/normalizeArguments.js
function normalizeArguments_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function normalizeArguments_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? normalizeArguments_ownKeys(Object(source), !0).forEach(function (key) { normalizeArguments_defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : normalizeArguments_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function normalizeArguments_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function normalizeArguments_slicedToArray(arr, i) { return normalizeArguments_arrayWithHoles(arr) || normalizeArguments_iterableToArrayLimit(arr, i) || normalizeArguments_unsupportedIterableToArray(arr, i) || normalizeArguments_nonIterableRest(); }

function normalizeArguments_nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function normalizeArguments_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return normalizeArguments_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return normalizeArguments_arrayLikeToArray(o, minLen); }

function normalizeArguments_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function normalizeArguments_iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function normalizeArguments_arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

 // Extracts the following properties from function arguments:
// * input `text`
// * `options` object
// * `metadata` JSON

function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args),
      _Array$prototype$slic2 = normalizeArguments_slicedToArray(_Array$prototype$slic, 4),
      arg_1 = _Array$prototype$slic2[0],
      arg_2 = _Array$prototype$slic2[1],
      arg_3 = _Array$prototype$slic2[2],
      arg_4 = _Array$prototype$slic2[3];

  var text;
  var options;
  var metadata; // If the phone number is passed as a string.
  // `parsePhoneNumber('88005553535', ...)`.

  if (typeof arg_1 === 'string') {
    text = arg_1;
  } else throw new TypeError('A text for parsing must be a string.'); // If "default country" argument is being passed then move it to `options`.
  // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.


  if (!arg_2 || typeof arg_2 === 'string') {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = undefined;
      metadata = arg_3;
    }

    if (arg_2) {
      options = normalizeArguments_objectSpread({
        defaultCountry: arg_2
      }, options);
    }
  } // `defaultCountry` is not passed.
  // Example: `parsePhoneNumber('+78005553535', [options], metadata)`.
  else if (isObject(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata = arg_3;
    } else {
      metadata = arg_2;
    }
  } else throw new Error("Invalid second argument: ".concat(arg_2));

  return {
    text: text,
    options: options,
    metadata: metadata
  };
}
//# sourceMappingURL=normalizeArguments.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/es6/legacy/parse.js


function parseNumber() {
  var _normalizeArguments = normalizeArguments(arguments),
      text = _normalizeArguments.text,
      options = _normalizeArguments.options,
      metadata = _normalizeArguments.metadata;

  return parse(text, options, metadata);
}
//# sourceMappingURL=parse.js.map
;// CONCATENATED MODULE: ../../node_modules/libphonenumber-js/index.es6.exports/parse.js




function parse_parse() {
	return withMetadataArgument(parseNumber, arguments)
}


/***/ }),

/***/ 37164:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x0": function() { return /* binding */ nanoid; }
/* harmony export */ });
/* unused harmony exports customAlphabet, customRandom, random */
// This file replaces `index.js` in bundlers like webpack or Rollup,
// according to `browser` config in `package.json`.



let random = bytes => crypto.getRandomValues(new Uint8Array(bytes))

let customRandom = (alphabet, defaultSize, getRandom) => {
  // First, a bitmask is necessary to generate the ID. The bitmask makes bytes
  // values closer to the alphabet size. The bitmask calculates the closest
  // `2^31 - 1` number, which exceeds the alphabet size.
  // For example, the bitmask for the alphabet size 30 is 31 (00011111).
  // `Math.clz32` is not used, because it is not available in browsers.
  let mask = (2 << (Math.log(alphabet.length - 1) / Math.LN2)) - 1
  // Though, the bitmask solution is not perfect since the bytes exceeding
  // the alphabet size are refused. Therefore, to reliably generate the ID,
  // the random bytes redundancy has to be satisfied.

  // Note: every hardware random generator call is performance expensive,
  // because the system call for entropy collection takes a lot of time.
  // So, to avoid additional system calls, extra bytes are requested in advance.

  // Next, a step determines how many random bytes to generate.
  // The number of random bytes gets decided upon the ID size, mask,
  // alphabet size, and magic number 1.6 (using 1.6 peaks at performance
  // according to benchmarks).

  // `-~f => Math.ceil(f)` if f is a float
  // `-~i => i + 1` if i is an integer
  let step = -~((1.6 * mask * defaultSize) / alphabet.length)

  return (size = defaultSize) => {
    let id = ''
    while (true) {
      let bytes = getRandom(step)
      // A compact alternative for `for (var i = 0; i < step; i++)`.
      let j = step | 0
      while (j--) {
        // Adding `|| ''` refuses a random byte that exceeds the alphabet size.
        id += alphabet[bytes[j] & mask] || ''
        if (id.length === size) return id
      }
    }
  }
}

let customAlphabet = (alphabet, size = 21) =>
  customRandom(alphabet, size, random)

let nanoid = (size = 21) =>
  crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte) => {
    // It is incorrect to use bytes exceeding the alphabet size.
    // The following mask reduces the random byte in the 0-255 value
    // range to the 0-63 value range. Therefore, adding hacks, such
    // as empty string fallback or magic numbers, is unneccessary because
    // the bitmask trims bytes down to the alphabet size.
    byte &= 63
    if (byte < 36) {
      // `0-9a-z`
      id += byte.toString(36)
    } else if (byte < 62) {
      // `A-Z`
      id += (byte - 26).toString(36).toUpperCase()
    } else if (byte > 62) {
      id += '-'
    } else {
      id += '_'
    }
    return id
  }, '')




/***/ }),

/***/ 33654:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "rr": function() { return /* binding */ inflate_1; }
/* harmony export */ });
/* unused harmony exports Deflate, Inflate, constants, default, deflate, deflateRaw, gzip, inflateRaw, ungzip */

/*! pako 2.1.0 https://github.com/nodeca/pako @license (MIT AND Zlib) */
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

/* eslint-disable space-unary-ops */

/* Public constants ==========================================================*/
/* ===========================================================================*/


//const Z_FILTERED          = 1;
//const Z_HUFFMAN_ONLY      = 2;
//const Z_RLE               = 3;
const Z_FIXED$1               = 4;
//const Z_DEFAULT_STRATEGY  = 0;

/* Possible values of the data_type field (though see inflate()) */
const Z_BINARY              = 0;
const Z_TEXT                = 1;
//const Z_ASCII             = 1; // = Z_TEXT
const Z_UNKNOWN$1             = 2;

/*============================================================================*/


function zero$1(buf) { let len = buf.length; while (--len >= 0) { buf[len] = 0; } }

// From zutil.h

const STORED_BLOCK = 0;
const STATIC_TREES = 1;
const DYN_TREES    = 2;
/* The three kinds of block type */

const MIN_MATCH$1    = 3;
const MAX_MATCH$1    = 258;
/* The minimum and maximum match lengths */

// From deflate.h
/* ===========================================================================
 * Internal compression state.
 */

const LENGTH_CODES$1  = 29;
/* number of length codes, not counting the special END_BLOCK code */

const LITERALS$1      = 256;
/* number of literal bytes 0..255 */

const L_CODES$1       = LITERALS$1 + 1 + LENGTH_CODES$1;
/* number of Literal or Length codes, including the END_BLOCK code */

const D_CODES$1       = 30;
/* number of distance codes */

const BL_CODES$1      = 19;
/* number of codes used to transfer the bit lengths */

const HEAP_SIZE$1     = 2 * L_CODES$1 + 1;
/* maximum heap size */

const MAX_BITS$1      = 15;
/* All codes must not exceed MAX_BITS bits */

const Buf_size      = 16;
/* size of bit buffer in bi_buf */


/* ===========================================================================
 * Constants
 */

const MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */

const END_BLOCK   = 256;
/* end of block literal code */

const REP_3_6     = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */

const REPZ_3_10   = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */

const REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */

/* eslint-disable comma-spacing,array-bracket-spacing */
const extra_lbits =   /* extra bits for each length code */
  new Uint8Array([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0]);

const extra_dbits =   /* extra bits for each distance code */
  new Uint8Array([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13]);

const extra_blbits =  /* extra bits for each bit length code */
  new Uint8Array([0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7]);

const bl_order =
  new Uint8Array([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]);
/* eslint-enable comma-spacing,array-bracket-spacing */

/* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */

/* ===========================================================================
 * Local data. These are initialized only once.
 */

// We pre-fill arrays with 0 to avoid uninitialized gaps

const DIST_CODE_LEN = 512; /* see definition of array dist_code below */

// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
const static_ltree  = new Array((L_CODES$1 + 2) * 2);
zero$1(static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */

const static_dtree  = new Array(D_CODES$1 * 2);
zero$1(static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */

const _dist_code    = new Array(DIST_CODE_LEN);
zero$1(_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */

const _length_code  = new Array(MAX_MATCH$1 - MIN_MATCH$1 + 1);
zero$1(_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */

const base_length   = new Array(LENGTH_CODES$1);
zero$1(base_length);
/* First normalized length for each code (0 = MIN_MATCH) */

const base_dist     = new Array(D_CODES$1);
zero$1(base_dist);
/* First normalized distance for each code (0 = distance of 1) */


function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {

  this.static_tree  = static_tree;  /* static tree or NULL */
  this.extra_bits   = extra_bits;   /* extra bits for each code or NULL */
  this.extra_base   = extra_base;   /* base index for extra_bits */
  this.elems        = elems;        /* max number of elements in the tree */
  this.max_length   = max_length;   /* max bit length for the codes */

  // show if `static_tree` has data or dummy - needed for monomorphic objects
  this.has_stree    = static_tree && static_tree.length;
}


let static_l_desc;
let static_d_desc;
let static_bl_desc;


function TreeDesc(dyn_tree, stat_desc) {
  this.dyn_tree = dyn_tree;     /* the dynamic tree */
  this.max_code = 0;            /* largest code with non zero frequency */
  this.stat_desc = stat_desc;   /* the corresponding static tree */
}



const d_code = (dist) => {

  return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
};


/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */
const put_short = (s, w) => {
//    put_byte(s, (uch)((w) & 0xff));
//    put_byte(s, (uch)((ush)(w) >> 8));
  s.pending_buf[s.pending++] = (w) & 0xff;
  s.pending_buf[s.pending++] = (w >>> 8) & 0xff;
};


/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */
const send_bits = (s, value, length) => {

  if (s.bi_valid > (Buf_size - length)) {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    put_short(s, s.bi_buf);
    s.bi_buf = value >> (Buf_size - s.bi_valid);
    s.bi_valid += length - Buf_size;
  } else {
    s.bi_buf |= (value << s.bi_valid) & 0xffff;
    s.bi_valid += length;
  }
};


const send_code = (s, c, tree) => {

  send_bits(s, tree[c * 2]/*.Code*/, tree[c * 2 + 1]/*.Len*/);
};


/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */
const bi_reverse = (code, len) => {

  let res = 0;
  do {
    res |= code & 1;
    code >>>= 1;
    res <<= 1;
  } while (--len > 0);
  return res >>> 1;
};


/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */
const bi_flush = (s) => {

  if (s.bi_valid === 16) {
    put_short(s, s.bi_buf);
    s.bi_buf = 0;
    s.bi_valid = 0;

  } else if (s.bi_valid >= 8) {
    s.pending_buf[s.pending++] = s.bi_buf & 0xff;
    s.bi_buf >>= 8;
    s.bi_valid -= 8;
  }
};


/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */
const gen_bitlen = (s, desc) => {
//    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */

  const tree            = desc.dyn_tree;
  const max_code        = desc.max_code;
  const stree           = desc.stat_desc.static_tree;
  const has_stree       = desc.stat_desc.has_stree;
  const extra           = desc.stat_desc.extra_bits;
  const base            = desc.stat_desc.extra_base;
  const max_length      = desc.stat_desc.max_length;
  let h;              /* heap index */
  let n, m;           /* iterate over the tree elements */
  let bits;           /* bit length */
  let xbits;          /* extra bits */
  let f;              /* frequency */
  let overflow = 0;   /* number of elements with bit length too large */

  for (bits = 0; bits <= MAX_BITS$1; bits++) {
    s.bl_count[bits] = 0;
  }

  /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */
  tree[s.heap[s.heap_max] * 2 + 1]/*.Len*/ = 0; /* root of the heap */

  for (h = s.heap_max + 1; h < HEAP_SIZE$1; h++) {
    n = s.heap[h];
    bits = tree[tree[n * 2 + 1]/*.Dad*/ * 2 + 1]/*.Len*/ + 1;
    if (bits > max_length) {
      bits = max_length;
      overflow++;
    }
    tree[n * 2 + 1]/*.Len*/ = bits;
    /* We overwrite tree[n].Dad which is no longer needed */

    if (n > max_code) { continue; } /* not a leaf node */

    s.bl_count[bits]++;
    xbits = 0;
    if (n >= base) {
      xbits = extra[n - base];
    }
    f = tree[n * 2]/*.Freq*/;
    s.opt_len += f * (bits + xbits);
    if (has_stree) {
      s.static_len += f * (stree[n * 2 + 1]/*.Len*/ + xbits);
    }
  }
  if (overflow === 0) { return; }

  // Tracev((stderr,"\nbit length overflow\n"));
  /* This happens for example on obj2 and pic of the Calgary corpus */

  /* Find the first bit length which could increase: */
  do {
    bits = max_length - 1;
    while (s.bl_count[bits] === 0) { bits--; }
    s.bl_count[bits]--;      /* move one leaf down the tree */
    s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
    s.bl_count[max_length]--;
    /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */
    overflow -= 2;
  } while (overflow > 0);

  /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */
  for (bits = max_length; bits !== 0; bits--) {
    n = s.bl_count[bits];
    while (n !== 0) {
      m = s.heap[--h];
      if (m > max_code) { continue; }
      if (tree[m * 2 + 1]/*.Len*/ !== bits) {
        // Tracev((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
        s.opt_len += (bits - tree[m * 2 + 1]/*.Len*/) * tree[m * 2]/*.Freq*/;
        tree[m * 2 + 1]/*.Len*/ = bits;
      }
      n--;
    }
  }
};


/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */
const gen_codes = (tree, max_code, bl_count) => {
//    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */

  const next_code = new Array(MAX_BITS$1 + 1); /* next code value for each bit length */
  let code = 0;              /* running code value */
  let bits;                  /* bit index */
  let n;                     /* code index */

  /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */
  for (bits = 1; bits <= MAX_BITS$1; bits++) {
    code = (code + bl_count[bits - 1]) << 1;
    next_code[bits] = code;
  }
  /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */
  //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
  //        "inconsistent bit counts");
  //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

  for (n = 0;  n <= max_code; n++) {
    let len = tree[n * 2 + 1]/*.Len*/;
    if (len === 0) { continue; }
    /* Now reverse the bits */
    tree[n * 2]/*.Code*/ = bi_reverse(next_code[len]++, len);

    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
  }
};


/* ===========================================================================
 * Initialize the various 'constant' tables.
 */
const tr_static_init = () => {

  let n;        /* iterates over tree elements */
  let bits;     /* bit counter */
  let length;   /* length value */
  let code;     /* code value */
  let dist;     /* distance index */
  const bl_count = new Array(MAX_BITS$1 + 1);
  /* number of codes at each bit length for an optimal tree */

  // do check in _tr_init()
  //if (static_init_done) return;

  /* For some embedded targets, global variables are not initialized: */
/*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/

  /* Initialize the mapping length (0..255) -> length code (0..28) */
  length = 0;
  for (code = 0; code < LENGTH_CODES$1 - 1; code++) {
    base_length[code] = length;
    for (n = 0; n < (1 << extra_lbits[code]); n++) {
      _length_code[length++] = code;
    }
  }
  //Assert (length == 256, "tr_static_init: length != 256");
  /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */
  _length_code[length - 1] = code;

  /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
  dist = 0;
  for (code = 0; code < 16; code++) {
    base_dist[code] = dist;
    for (n = 0; n < (1 << extra_dbits[code]); n++) {
      _dist_code[dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: dist != 256");
  dist >>= 7; /* from now on, all distances are divided by 128 */
  for (; code < D_CODES$1; code++) {
    base_dist[code] = dist << 7;
    for (n = 0; n < (1 << (extra_dbits[code] - 7)); n++) {
      _dist_code[256 + dist++] = code;
    }
  }
  //Assert (dist == 256, "tr_static_init: 256+dist != 512");

  /* Construct the codes of the static literal tree */
  for (bits = 0; bits <= MAX_BITS$1; bits++) {
    bl_count[bits] = 0;
  }

  n = 0;
  while (n <= 143) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  while (n <= 255) {
    static_ltree[n * 2 + 1]/*.Len*/ = 9;
    n++;
    bl_count[9]++;
  }
  while (n <= 279) {
    static_ltree[n * 2 + 1]/*.Len*/ = 7;
    n++;
    bl_count[7]++;
  }
  while (n <= 287) {
    static_ltree[n * 2 + 1]/*.Len*/ = 8;
    n++;
    bl_count[8]++;
  }
  /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */
  gen_codes(static_ltree, L_CODES$1 + 1, bl_count);

  /* The static distance tree is trivial: */
  for (n = 0; n < D_CODES$1; n++) {
    static_dtree[n * 2 + 1]/*.Len*/ = 5;
    static_dtree[n * 2]/*.Code*/ = bi_reverse(n, 5);
  }

  // Now data ready and we can init static trees
  static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS$1 + 1, L_CODES$1, MAX_BITS$1);
  static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0,          D_CODES$1, MAX_BITS$1);
  static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0,         BL_CODES$1, MAX_BL_BITS);

  //static_init_done = true;
};


/* ===========================================================================
 * Initialize a new block.
 */
const init_block = (s) => {

  let n; /* iterates over tree elements */

  /* Initialize the trees. */
  for (n = 0; n < L_CODES$1;  n++) { s.dyn_ltree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < D_CODES$1;  n++) { s.dyn_dtree[n * 2]/*.Freq*/ = 0; }
  for (n = 0; n < BL_CODES$1; n++) { s.bl_tree[n * 2]/*.Freq*/ = 0; }

  s.dyn_ltree[END_BLOCK * 2]/*.Freq*/ = 1;
  s.opt_len = s.static_len = 0;
  s.sym_next = s.matches = 0;
};


/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */
const bi_windup = (s) =>
{
  if (s.bi_valid > 8) {
    put_short(s, s.bi_buf);
  } else if (s.bi_valid > 0) {
    //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
  }
  s.bi_buf = 0;
  s.bi_valid = 0;
};

/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */
const smaller = (tree, n, m, depth) => {

  const _n2 = n * 2;
  const _m2 = m * 2;
  return (tree[_n2]/*.Freq*/ < tree[_m2]/*.Freq*/ ||
         (tree[_n2]/*.Freq*/ === tree[_m2]/*.Freq*/ && depth[n] <= depth[m]));
};

/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */
const pqdownheap = (s, tree, k) => {
//    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */

  const v = s.heap[k];
  let j = k << 1;  /* left son of k */
  while (j <= s.heap_len) {
    /* Set j to the smallest of the two sons: */
    if (j < s.heap_len &&
      smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
      j++;
    }
    /* Exit if v is smaller than both sons */
    if (smaller(tree, v, s.heap[j], s.depth)) { break; }

    /* Exchange v with the smallest son */
    s.heap[k] = s.heap[j];
    k = j;

    /* And continue down the tree, setting j to the left son of k */
    j <<= 1;
  }
  s.heap[k] = v;
};


// inlined manually
// const SMALLEST = 1;

/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */
const compress_block = (s, ltree, dtree) => {
//    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */

  let dist;           /* distance of matched string */
  let lc;             /* match length or unmatched char (if dist == 0) */
  let sx = 0;         /* running index in sym_buf */
  let code;           /* the code to send */
  let extra;          /* number of extra bits to send */

  if (s.sym_next !== 0) {
    do {
      dist = s.pending_buf[s.sym_buf + sx++] & 0xff;
      dist += (s.pending_buf[s.sym_buf + sx++] & 0xff) << 8;
      lc = s.pending_buf[s.sym_buf + sx++];
      if (dist === 0) {
        send_code(s, lc, ltree); /* send a literal byte */
        //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
      } else {
        /* Here, lc is the match length - MIN_MATCH */
        code = _length_code[lc];
        send_code(s, code + LITERALS$1 + 1, ltree); /* send the length code */
        extra = extra_lbits[code];
        if (extra !== 0) {
          lc -= base_length[code];
          send_bits(s, lc, extra);       /* send the extra length bits */
        }
        dist--; /* dist is now the match distance - 1 */
        code = d_code(dist);
        //Assert (code < D_CODES, "bad d_code");

        send_code(s, code, dtree);       /* send the distance code */
        extra = extra_dbits[code];
        if (extra !== 0) {
          dist -= base_dist[code];
          send_bits(s, dist, extra);   /* send the extra distance bits */
        }
      } /* literal or match pair ? */

      /* Check that the overlay between pending_buf and sym_buf is ok: */
      //Assert(s->pending < s->lit_bufsize + sx, "pendingBuf overflow");

    } while (sx < s.sym_next);
  }

  send_code(s, END_BLOCK, ltree);
};


/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */
const build_tree = (s, desc) => {
//    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */

  const tree     = desc.dyn_tree;
  const stree    = desc.stat_desc.static_tree;
  const has_stree = desc.stat_desc.has_stree;
  const elems    = desc.stat_desc.elems;
  let n, m;          /* iterate over heap elements */
  let max_code = -1; /* largest code with non zero frequency */
  let node;          /* new node being created */

  /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */
  s.heap_len = 0;
  s.heap_max = HEAP_SIZE$1;

  for (n = 0; n < elems; n++) {
    if (tree[n * 2]/*.Freq*/ !== 0) {
      s.heap[++s.heap_len] = max_code = n;
      s.depth[n] = 0;

    } else {
      tree[n * 2 + 1]/*.Len*/ = 0;
    }
  }

  /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */
  while (s.heap_len < 2) {
    node = s.heap[++s.heap_len] = (max_code < 2 ? ++max_code : 0);
    tree[node * 2]/*.Freq*/ = 1;
    s.depth[node] = 0;
    s.opt_len--;

    if (has_stree) {
      s.static_len -= stree[node * 2 + 1]/*.Len*/;
    }
    /* node is 0 or 1 so it does not have extra bits */
  }
  desc.max_code = max_code;

  /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */
  for (n = (s.heap_len >> 1/*int /2*/); n >= 1; n--) { pqdownheap(s, tree, n); }

  /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */
  node = elems;              /* next internal node of the tree */
  do {
    //pqremove(s, tree, n);  /* n = node of least frequency */
    /*** pqremove ***/
    n = s.heap[1/*SMALLEST*/];
    s.heap[1/*SMALLEST*/] = s.heap[s.heap_len--];
    pqdownheap(s, tree, 1/*SMALLEST*/);
    /***/

    m = s.heap[1/*SMALLEST*/]; /* m = node of next least frequency */

    s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
    s.heap[--s.heap_max] = m;

    /* Create a new node father of n and m */
    tree[node * 2]/*.Freq*/ = tree[n * 2]/*.Freq*/ + tree[m * 2]/*.Freq*/;
    s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
    tree[n * 2 + 1]/*.Dad*/ = tree[m * 2 + 1]/*.Dad*/ = node;

    /* and insert the new node in the heap */
    s.heap[1/*SMALLEST*/] = node++;
    pqdownheap(s, tree, 1/*SMALLEST*/);

  } while (s.heap_len >= 2);

  s.heap[--s.heap_max] = s.heap[1/*SMALLEST*/];

  /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */
  gen_bitlen(s, desc);

  /* The field len is now set, we can generate the bit codes */
  gen_codes(tree, max_code, s.bl_count);
};


/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */
const scan_tree = (s, tree, max_code) => {
//    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */

  let n;                     /* iterates over all tree elements */
  let prevlen = -1;          /* last emitted length */
  let curlen;                /* length of current code */

  let nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  let count = 0;             /* repeat count of the current code */
  let max_count = 7;         /* max repeat count */
  let min_count = 4;         /* min repeat count */

  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }
  tree[(max_code + 1) * 2 + 1]/*.Len*/ = 0xffff; /* guard */

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      s.bl_tree[curlen * 2]/*.Freq*/ += count;

    } else if (curlen !== 0) {

      if (curlen !== prevlen) { s.bl_tree[curlen * 2]/*.Freq*/++; }
      s.bl_tree[REP_3_6 * 2]/*.Freq*/++;

    } else if (count <= 10) {
      s.bl_tree[REPZ_3_10 * 2]/*.Freq*/++;

    } else {
      s.bl_tree[REPZ_11_138 * 2]/*.Freq*/++;
    }

    count = 0;
    prevlen = curlen;

    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
};


/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */
const send_tree = (s, tree, max_code) => {
//    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */

  let n;                     /* iterates over all tree elements */
  let prevlen = -1;          /* last emitted length */
  let curlen;                /* length of current code */

  let nextlen = tree[0 * 2 + 1]/*.Len*/; /* length of next code */

  let count = 0;             /* repeat count of the current code */
  let max_count = 7;         /* max repeat count */
  let min_count = 4;         /* min repeat count */

  /* tree[max_code+1].Len = -1; */  /* guard already set */
  if (nextlen === 0) {
    max_count = 138;
    min_count = 3;
  }

  for (n = 0; n <= max_code; n++) {
    curlen = nextlen;
    nextlen = tree[(n + 1) * 2 + 1]/*.Len*/;

    if (++count < max_count && curlen === nextlen) {
      continue;

    } else if (count < min_count) {
      do { send_code(s, curlen, s.bl_tree); } while (--count !== 0);

    } else if (curlen !== 0) {
      if (curlen !== prevlen) {
        send_code(s, curlen, s.bl_tree);
        count--;
      }
      //Assert(count >= 3 && count <= 6, " 3_6?");
      send_code(s, REP_3_6, s.bl_tree);
      send_bits(s, count - 3, 2);

    } else if (count <= 10) {
      send_code(s, REPZ_3_10, s.bl_tree);
      send_bits(s, count - 3, 3);

    } else {
      send_code(s, REPZ_11_138, s.bl_tree);
      send_bits(s, count - 11, 7);
    }

    count = 0;
    prevlen = curlen;
    if (nextlen === 0) {
      max_count = 138;
      min_count = 3;

    } else if (curlen === nextlen) {
      max_count = 6;
      min_count = 3;

    } else {
      max_count = 7;
      min_count = 4;
    }
  }
};


/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */
const build_bl_tree = (s) => {

  let max_blindex;  /* index of last bit length code of non zero freq */

  /* Determine the bit length frequencies for literal and distance trees */
  scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
  scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

  /* Build the bit length tree: */
  build_tree(s, s.bl_desc);
  /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */

  /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */
  for (max_blindex = BL_CODES$1 - 1; max_blindex >= 3; max_blindex--) {
    if (s.bl_tree[bl_order[max_blindex] * 2 + 1]/*.Len*/ !== 0) {
      break;
    }
  }
  /* Update opt_len to include the bit length tree and counts */
  s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
  //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
  //        s->opt_len, s->static_len));

  return max_blindex;
};


/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */
const send_all_trees = (s, lcodes, dcodes, blcodes) => {
//    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */

  let rank;                    /* index in bl_order */

  //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
  //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
  //        "too many codes");
  //Tracev((stderr, "\nbl counts: "));
  send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
  send_bits(s, dcodes - 1,   5);
  send_bits(s, blcodes - 4,  4); /* not -3 as stated in appnote.txt */
  for (rank = 0; rank < blcodes; rank++) {
    //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1]/*.Len*/, 3);
  }
  //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
  //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

  send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
  //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
};


/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "block list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "allow list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */
const detect_data_type = (s) => {
  /* block_mask is the bit mask of block-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */
  let block_mask = 0xf3ffc07f;
  let n;

  /* Check for non-textual ("block-listed") bytes. */
  for (n = 0; n <= 31; n++, block_mask >>>= 1) {
    if ((block_mask & 1) && (s.dyn_ltree[n * 2]/*.Freq*/ !== 0)) {
      return Z_BINARY;
    }
  }

  /* Check for textual ("allow-listed") bytes. */
  if (s.dyn_ltree[9 * 2]/*.Freq*/ !== 0 || s.dyn_ltree[10 * 2]/*.Freq*/ !== 0 ||
      s.dyn_ltree[13 * 2]/*.Freq*/ !== 0) {
    return Z_TEXT;
  }
  for (n = 32; n < LITERALS$1; n++) {
    if (s.dyn_ltree[n * 2]/*.Freq*/ !== 0) {
      return Z_TEXT;
    }
  }

  /* There are no "block-listed" or "allow-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */
  return Z_BINARY;
};


let static_init_done = false;

/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */
const _tr_init$1 = (s) =>
{

  if (!static_init_done) {
    tr_static_init();
    static_init_done = true;
  }

  s.l_desc  = new TreeDesc(s.dyn_ltree, static_l_desc);
  s.d_desc  = new TreeDesc(s.dyn_dtree, static_d_desc);
  s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);

  s.bi_buf = 0;
  s.bi_valid = 0;

  /* Initialize the first block of the first file: */
  init_block(s);
};


/* ===========================================================================
 * Send a stored block
 */
const _tr_stored_block$1 = (s, buf, stored_len, last) => {
//DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */

  send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3);    /* send block type */
  bi_windup(s);        /* align on byte boundary */
  put_short(s, stored_len);
  put_short(s, ~stored_len);
  if (stored_len) {
    s.pending_buf.set(s.window.subarray(buf, buf + stored_len), s.pending);
  }
  s.pending += stored_len;
};


/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */
const _tr_align$1 = (s) => {
  send_bits(s, STATIC_TREES << 1, 3);
  send_code(s, END_BLOCK, static_ltree);
  bi_flush(s);
};


/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and write out the encoded block.
 */
const _tr_flush_block$1 = (s, buf, stored_len, last) => {
//DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */

  let opt_lenb, static_lenb;  /* opt_len and static_len in bytes */
  let max_blindex = 0;        /* index of last bit length code of non zero freq */

  /* Build the Huffman trees unless a stored block is forced */
  if (s.level > 0) {

    /* Check if the file is binary or text */
    if (s.strm.data_type === Z_UNKNOWN$1) {
      s.strm.data_type = detect_data_type(s);
    }

    /* Construct the literal and distance trees */
    build_tree(s, s.l_desc);
    // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));

    build_tree(s, s.d_desc);
    // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
    //        s->static_len));
    /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */

    /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */
    max_blindex = build_bl_tree(s);

    /* Determine the best encoding. Compute the block lengths in bytes. */
    opt_lenb = (s.opt_len + 3 + 7) >>> 3;
    static_lenb = (s.static_len + 3 + 7) >>> 3;

    // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
    //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
    //        s->sym_next / 3));

    if (static_lenb <= opt_lenb) { opt_lenb = static_lenb; }

  } else {
    // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
  }

  if ((stored_len + 4 <= opt_lenb) && (buf !== -1)) {
    /* 4: two words for the lengths */

    /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */
    _tr_stored_block$1(s, buf, stored_len, last);

  } else if (s.strategy === Z_FIXED$1 || static_lenb === opt_lenb) {

    send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
    compress_block(s, static_ltree, static_dtree);

  } else {
    send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
    send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
    compress_block(s, s.dyn_ltree, s.dyn_dtree);
  }
  // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
  /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */
  init_block(s);

  if (last) {
    bi_windup(s);
  }
  // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
  //       s->compressed_len-7*last));
};

/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */
const _tr_tally$1 = (s, dist, lc) => {
//    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */

  s.pending_buf[s.sym_buf + s.sym_next++] = dist;
  s.pending_buf[s.sym_buf + s.sym_next++] = dist >> 8;
  s.pending_buf[s.sym_buf + s.sym_next++] = lc;
  if (dist === 0) {
    /* lc is the unmatched char */
    s.dyn_ltree[lc * 2]/*.Freq*/++;
  } else {
    s.matches++;
    /* Here, lc is the match length - MIN_MATCH */
    dist--;             /* dist = match distance - 1 */
    //Assert((ush)dist < (ush)MAX_DIST(s) &&
    //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
    //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

    s.dyn_ltree[(_length_code[lc] + LITERALS$1 + 1) * 2]/*.Freq*/++;
    s.dyn_dtree[d_code(dist) * 2]/*.Freq*/++;
  }

  return (s.sym_next === s.sym_end);
};

var _tr_init_1  = _tr_init$1;
var _tr_stored_block_1 = _tr_stored_block$1;
var _tr_flush_block_1  = _tr_flush_block$1;
var _tr_tally_1 = _tr_tally$1;
var _tr_align_1 = _tr_align$1;

var trees = {
	_tr_init: _tr_init_1,
	_tr_stored_block: _tr_stored_block_1,
	_tr_flush_block: _tr_flush_block_1,
	_tr_tally: _tr_tally_1,
	_tr_align: _tr_align_1
};

// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

const adler32 = (adler, buf, len, pos) => {
  let s1 = (adler & 0xffff) |0,
      s2 = ((adler >>> 16) & 0xffff) |0,
      n = 0;

  while (len !== 0) {
    // Set limit ~ twice less than 5552, to keep
    // s2 in 31-bits, because we force signed ints.
    // in other case %= will fail.
    n = len > 2000 ? 2000 : len;
    len -= n;

    do {
      s1 = (s1 + buf[pos++]) |0;
      s2 = (s2 + s1) |0;
    } while (--n);

    s1 %= 65521;
    s2 %= 65521;
  }

  return (s1 | (s2 << 16)) |0;
};


var adler32_1 = adler32;

// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// Use ordinary array, since untyped makes no boost here
const makeTable = () => {
  let c, table = [];

  for (var n = 0; n < 256; n++) {
    c = n;
    for (var k = 0; k < 8; k++) {
      c = ((c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1));
    }
    table[n] = c;
  }

  return table;
};

// Create table on load. Just 255 signed longs. Not a problem.
const crcTable = new Uint32Array(makeTable());


const crc32 = (crc, buf, len, pos) => {
  const t = crcTable;
  const end = pos + len;

  crc ^= -1;

  for (let i = pos; i < end; i++) {
    crc = (crc >>> 8) ^ t[(crc ^ buf[i]) & 0xFF];
  }

  return (crc ^ (-1)); // >>> 0;
};


var crc32_1 = crc32;

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var messages = {
  2:      'need dictionary',     /* Z_NEED_DICT       2  */
  1:      'stream end',          /* Z_STREAM_END      1  */
  0:      '',                    /* Z_OK              0  */
  '-1':   'file error',          /* Z_ERRNO         (-1) */
  '-2':   'stream error',        /* Z_STREAM_ERROR  (-2) */
  '-3':   'data error',          /* Z_DATA_ERROR    (-3) */
  '-4':   'insufficient memory', /* Z_MEM_ERROR     (-4) */
  '-5':   'buffer error',        /* Z_BUF_ERROR     (-5) */
  '-6':   'incompatible version' /* Z_VERSION_ERROR (-6) */
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

var constants$2 = {

  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH:         0,
  Z_PARTIAL_FLUSH:    1,
  Z_SYNC_FLUSH:       2,
  Z_FULL_FLUSH:       3,
  Z_FINISH:           4,
  Z_BLOCK:            5,
  Z_TREES:            6,

  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK:               0,
  Z_STREAM_END:       1,
  Z_NEED_DICT:        2,
  Z_ERRNO:           -1,
  Z_STREAM_ERROR:    -2,
  Z_DATA_ERROR:      -3,
  Z_MEM_ERROR:       -4,
  Z_BUF_ERROR:       -5,
  //Z_VERSION_ERROR: -6,

  /* compression levels */
  Z_NO_COMPRESSION:         0,
  Z_BEST_SPEED:             1,
  Z_BEST_COMPRESSION:       9,
  Z_DEFAULT_COMPRESSION:   -1,


  Z_FILTERED:               1,
  Z_HUFFMAN_ONLY:           2,
  Z_RLE:                    3,
  Z_FIXED:                  4,
  Z_DEFAULT_STRATEGY:       0,

  /* Possible values of the data_type field (though see inflate()) */
  Z_BINARY:                 0,
  Z_TEXT:                   1,
  //Z_ASCII:                1, // = Z_TEXT (deprecated)
  Z_UNKNOWN:                2,

  /* The deflate compression method */
  Z_DEFLATED:               8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

const { _tr_init, _tr_stored_block, _tr_flush_block, _tr_tally, _tr_align } = trees;




/* Public constants ==========================================================*/
/* ===========================================================================*/

const {
  Z_NO_FLUSH: Z_NO_FLUSH$2, Z_PARTIAL_FLUSH, Z_FULL_FLUSH: Z_FULL_FLUSH$1, Z_FINISH: Z_FINISH$3, Z_BLOCK: Z_BLOCK$1,
  Z_OK: Z_OK$3, Z_STREAM_END: Z_STREAM_END$3, Z_STREAM_ERROR: Z_STREAM_ERROR$2, Z_DATA_ERROR: Z_DATA_ERROR$2, Z_BUF_ERROR: Z_BUF_ERROR$1,
  Z_DEFAULT_COMPRESSION: Z_DEFAULT_COMPRESSION$1,
  Z_FILTERED, Z_HUFFMAN_ONLY, Z_RLE, Z_FIXED, Z_DEFAULT_STRATEGY: Z_DEFAULT_STRATEGY$1,
  Z_UNKNOWN,
  Z_DEFLATED: Z_DEFLATED$2
} = constants$2;

/*============================================================================*/


const MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */
const MAX_WBITS$1 = 15;
/* 32K LZ77 window */
const DEF_MEM_LEVEL = 8;


const LENGTH_CODES  = 29;
/* number of length codes, not counting the special END_BLOCK code */
const LITERALS      = 256;
/* number of literal bytes 0..255 */
const L_CODES       = LITERALS + 1 + LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */
const D_CODES       = 30;
/* number of distance codes */
const BL_CODES      = 19;
/* number of codes used to transfer the bit lengths */
const HEAP_SIZE     = 2 * L_CODES + 1;
/* maximum heap size */
const MAX_BITS  = 15;
/* All codes must not exceed MAX_BITS bits */

const MIN_MATCH = 3;
const MAX_MATCH = 258;
const MIN_LOOKAHEAD = (MAX_MATCH + MIN_MATCH + 1);

const PRESET_DICT = 0x20;

const INIT_STATE    =  42;    /* zlib header -> BUSY_STATE */
//#ifdef GZIP
const GZIP_STATE    =  57;    /* gzip header -> BUSY_STATE | EXTRA_STATE */
//#endif
const EXTRA_STATE   =  69;    /* gzip extra block -> NAME_STATE */
const NAME_STATE    =  73;    /* gzip file name -> COMMENT_STATE */
const COMMENT_STATE =  91;    /* gzip comment -> HCRC_STATE */
const HCRC_STATE    = 103;    /* gzip header CRC -> BUSY_STATE */
const BUSY_STATE    = 113;    /* deflate -> FINISH_STATE */
const FINISH_STATE  = 666;    /* stream complete */

const BS_NEED_MORE      = 1; /* block not completed, need more input or more output */
const BS_BLOCK_DONE     = 2; /* block flush performed */
const BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
const BS_FINISH_DONE    = 4; /* finish done, accept no more input or output */

const OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

const err = (strm, errorCode) => {
  strm.msg = messages[errorCode];
  return errorCode;
};

const rank = (f) => {
  return ((f) * 2) - ((f) > 4 ? 9 : 0);
};

const zero = (buf) => {
  let len = buf.length; while (--len >= 0) { buf[len] = 0; }
};

/* ===========================================================================
 * Slide the hash table when sliding the window down (could be avoided with 32
 * bit values at the expense of memory usage). We slide even when level == 0 to
 * keep the hash table consistent if we switch back to level > 0 later.
 */
const slide_hash = (s) => {
  let n, m;
  let p;
  let wsize = s.w_size;

  n = s.hash_size;
  p = n;
  do {
    m = s.head[--p];
    s.head[p] = (m >= wsize ? m - wsize : 0);
  } while (--n);
  n = wsize;
//#ifndef FASTEST
  p = n;
  do {
    m = s.prev[--p];
    s.prev[p] = (m >= wsize ? m - wsize : 0);
    /* If n is not on any hash chain, prev[n] is garbage but
     * its value will never be used.
     */
  } while (--n);
//#endif
};

/* eslint-disable new-cap */
let HASH_ZLIB = (s, prev, data) => ((prev << s.hash_shift) ^ data) & s.hash_mask;
// This hash causes less collisions, https://github.com/nodeca/pako/issues/135
// But breaks binary compatibility
//let HASH_FAST = (s, prev, data) => ((prev << 8) + (prev >> 8) + (data << 4)) & s.hash_mask;
let HASH = HASH_ZLIB;


/* =========================================================================
 * Flush as much pending output as possible. All deflate() output, except for
 * some deflate_stored() output, goes through this function so some
 * applications may wish to modify it to avoid allocating a large
 * strm->next_out buffer and copying into it. (See also read_buf()).
 */
const flush_pending = (strm) => {
  const s = strm.state;

  //_tr_flush_bits(s);
  let len = s.pending;
  if (len > strm.avail_out) {
    len = strm.avail_out;
  }
  if (len === 0) { return; }

  strm.output.set(s.pending_buf.subarray(s.pending_out, s.pending_out + len), strm.next_out);
  strm.next_out  += len;
  s.pending_out  += len;
  strm.total_out += len;
  strm.avail_out -= len;
  s.pending      -= len;
  if (s.pending === 0) {
    s.pending_out = 0;
  }
};


const flush_block_only = (s, last) => {
  _tr_flush_block(s, (s.block_start >= 0 ? s.block_start : -1), s.strstart - s.block_start, last);
  s.block_start = s.strstart;
  flush_pending(s.strm);
};


const put_byte = (s, b) => {
  s.pending_buf[s.pending++] = b;
};


/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */
const putShortMSB = (s, b) => {

  //  put_byte(s, (Byte)(b >> 8));
//  put_byte(s, (Byte)(b & 0xff));
  s.pending_buf[s.pending++] = (b >>> 8) & 0xff;
  s.pending_buf[s.pending++] = b & 0xff;
};


/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */
const read_buf = (strm, buf, start, size) => {

  let len = strm.avail_in;

  if (len > size) { len = size; }
  if (len === 0) { return 0; }

  strm.avail_in -= len;

  // zmemcpy(buf, strm->next_in, len);
  buf.set(strm.input.subarray(strm.next_in, strm.next_in + len), start);
  if (strm.state.wrap === 1) {
    strm.adler = adler32_1(strm.adler, buf, len, start);
  }

  else if (strm.state.wrap === 2) {
    strm.adler = crc32_1(strm.adler, buf, len, start);
  }

  strm.next_in += len;
  strm.total_in += len;

  return len;
};


/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */
const longest_match = (s, cur_match) => {

  let chain_length = s.max_chain_length;      /* max hash chain length */
  let scan = s.strstart; /* current string */
  let match;                       /* matched string */
  let len;                           /* length of current match */
  let best_len = s.prev_length;              /* best match length so far */
  let nice_match = s.nice_match;             /* stop if match long enough */
  const limit = (s.strstart > (s.w_size - MIN_LOOKAHEAD)) ?
      s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0/*NIL*/;

  const _win = s.window; // shortcut

  const wmask = s.w_mask;
  const prev  = s.prev;

  /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */

  const strend = s.strstart + MAX_MATCH;
  let scan_end1  = _win[scan + best_len - 1];
  let scan_end   = _win[scan + best_len];

  /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */
  // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

  /* Do not waste too much time if we already have a good match: */
  if (s.prev_length >= s.good_match) {
    chain_length >>= 2;
  }
  /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */
  if (nice_match > s.lookahead) { nice_match = s.lookahead; }

  // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

  do {
    // Assert(cur_match < s->strstart, "no future");
    match = cur_match;

    /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */

    if (_win[match + best_len]     !== scan_end  ||
        _win[match + best_len - 1] !== scan_end1 ||
        _win[match]                !== _win[scan] ||
        _win[++match]              !== _win[scan + 1]) {
      continue;
    }

    /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */
    scan += 2;
    match++;
    // Assert(*scan == *match, "match[2]?");

    /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */
    do {
      /*jshint noempty:false*/
    } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             _win[++scan] === _win[++match] && _win[++scan] === _win[++match] &&
             scan < strend);

    // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

    len = MAX_MATCH - (strend - scan);
    scan = strend - MAX_MATCH;

    if (len > best_len) {
      s.match_start = cur_match;
      best_len = len;
      if (len >= nice_match) {
        break;
      }
      scan_end1  = _win[scan + best_len - 1];
      scan_end   = _win[scan + best_len];
    }
  } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);

  if (best_len <= s.lookahead) {
    return best_len;
  }
  return s.lookahead;
};


/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */
const fill_window = (s) => {

  const _w_size = s.w_size;
  let n, more, str;

  //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

  do {
    more = s.window_size - s.lookahead - s.strstart;

    // JS ints have 32 bit, block below not needed
    /* Deal with !@#$% 64K limit: */
    //if (sizeof(int) <= 2) {
    //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
    //        more = wsize;
    //
    //  } else if (more == (unsigned)(-1)) {
    //        /* Very unlikely, but possible on 16 bit machine if
    //         * strstart == 0 && lookahead == 1 (input done a byte at time)
    //         */
    //        more--;
    //    }
    //}


    /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */
    if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {

      s.window.set(s.window.subarray(_w_size, _w_size + _w_size - more), 0);
      s.match_start -= _w_size;
      s.strstart -= _w_size;
      /* we now have strstart >= MAX_DIST */
      s.block_start -= _w_size;
      if (s.insert > s.strstart) {
        s.insert = s.strstart;
      }
      slide_hash(s);
      more += _w_size;
    }
    if (s.strm.avail_in === 0) {
      break;
    }

    /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */
    //Assert(more >= 2, "more < 2");
    n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
    s.lookahead += n;

    /* Initialize the hash value now that we have some input: */
    if (s.lookahead + s.insert >= MIN_MATCH) {
      str = s.strstart - s.insert;
      s.ins_h = s.window[str];

      /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
      s.ins_h = HASH(s, s.ins_h, s.window[str + 1]);
//#if MIN_MATCH != 3
//        Call update_hash() MIN_MATCH-3 more times
//#endif
      while (s.insert) {
        /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
        s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);

        s.prev[str & s.w_mask] = s.head[s.ins_h];
        s.head[s.ins_h] = str;
        str++;
        s.insert--;
        if (s.lookahead + s.insert < MIN_MATCH) {
          break;
        }
      }
    }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */

  } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

  /* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */
//  if (s.high_water < s.window_size) {
//    const curr = s.strstart + s.lookahead;
//    let init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
};

/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 *
 * In case deflateParams() is used to later switch to a non-zero compression
 * level, s->matches (otherwise unused when storing) keeps track of the number
 * of hash table slides to perform. If s->matches is 1, then one hash table
 * slide will be done when switching. If s->matches is 2, the maximum value
 * allowed here, then the hash table will be cleared, since two or more slides
 * is the same as a clear.
 *
 * deflate_stored() is written to minimize the number of times an input byte is
 * copied. It is most efficient with large input and output buffers, which
 * maximizes the opportunites to have a single copy from next_in to next_out.
 */
const deflate_stored = (s, flush) => {

  /* Smallest worthy block size when not flushing or finishing. By default
   * this is 32K. This can be as small as 507 bytes for memLevel == 1. For
   * large input and output buffers, the stored block size will be larger.
   */
  let min_block = s.pending_buf_size - 5 > s.w_size ? s.w_size : s.pending_buf_size - 5;

  /* Copy as many min_block or larger stored blocks directly to next_out as
   * possible. If flushing, copy the remaining available input to next_out as
   * stored blocks, if there is enough space.
   */
  let len, left, have, last = 0;
  let used = s.strm.avail_in;
  do {
    /* Set len to the maximum size block that we can copy directly with the
     * available input data and output space. Set left to how much of that
     * would be copied from what's left in the window.
     */
    len = 65535/* MAX_STORED */;     /* maximum deflate stored block length */
    have = (s.bi_valid + 42) >> 3;     /* number of header bytes */
    if (s.strm.avail_out < have) {         /* need room for header */
      break;
    }
      /* maximum stored block length that will fit in avail_out: */
    have = s.strm.avail_out - have;
    left = s.strstart - s.block_start;  /* bytes left in window */
    if (len > left + s.strm.avail_in) {
      len = left + s.strm.avail_in;   /* limit len to the input */
    }
    if (len > have) {
      len = have;             /* limit len to the output */
    }

    /* If the stored block would be less than min_block in length, or if
     * unable to copy all of the available input when flushing, then try
     * copying to the window and the pending buffer instead. Also don't
     * write an empty block when flushing -- deflate() does that.
     */
    if (len < min_block && ((len === 0 && flush !== Z_FINISH$3) ||
                        flush === Z_NO_FLUSH$2 ||
                        len !== left + s.strm.avail_in)) {
      break;
    }

    /* Make a dummy stored block in pending to get the header bytes,
     * including any pending bits. This also updates the debugging counts.
     */
    last = flush === Z_FINISH$3 && len === left + s.strm.avail_in ? 1 : 0;
    _tr_stored_block(s, 0, 0, last);

    /* Replace the lengths in the dummy stored block with len. */
    s.pending_buf[s.pending - 4] = len;
    s.pending_buf[s.pending - 3] = len >> 8;
    s.pending_buf[s.pending - 2] = ~len;
    s.pending_buf[s.pending - 1] = ~len >> 8;

    /* Write the stored block header bytes. */
    flush_pending(s.strm);

//#ifdef ZLIB_DEBUG
//    /* Update debugging counts for the data about to be copied. */
//    s->compressed_len += len << 3;
//    s->bits_sent += len << 3;
//#endif

    /* Copy uncompressed bytes from the window to next_out. */
    if (left) {
      if (left > len) {
        left = len;
      }
      //zmemcpy(s->strm->next_out, s->window + s->block_start, left);
      s.strm.output.set(s.window.subarray(s.block_start, s.block_start + left), s.strm.next_out);
      s.strm.next_out += left;
      s.strm.avail_out -= left;
      s.strm.total_out += left;
      s.block_start += left;
      len -= left;
    }

    /* Copy uncompressed bytes directly from next_in to next_out, updating
     * the check value.
     */
    if (len) {
      read_buf(s.strm, s.strm.output, s.strm.next_out, len);
      s.strm.next_out += len;
      s.strm.avail_out -= len;
      s.strm.total_out += len;
    }
  } while (last === 0);

  /* Update the sliding window with the last s->w_size bytes of the copied
   * data, or append all of the copied data to the existing window if less
   * than s->w_size bytes were copied. Also update the number of bytes to
   * insert in the hash tables, in the event that deflateParams() switches to
   * a non-zero compression level.
   */
  used -= s.strm.avail_in;    /* number of input bytes directly copied */
  if (used) {
    /* If any input was used, then no unused input remains in the window,
     * therefore s->block_start == s->strstart.
     */
    if (used >= s.w_size) {  /* supplant the previous history */
      s.matches = 2;     /* clear hash */
      //zmemcpy(s->window, s->strm->next_in - s->w_size, s->w_size);
      s.window.set(s.strm.input.subarray(s.strm.next_in - s.w_size, s.strm.next_in), 0);
      s.strstart = s.w_size;
      s.insert = s.strstart;
    }
    else {
      if (s.window_size - s.strstart <= used) {
        /* Slide the window down. */
        s.strstart -= s.w_size;
        //zmemcpy(s->window, s->window + s->w_size, s->strstart);
        s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
        if (s.matches < 2) {
          s.matches++;   /* add a pending slide_hash() */
        }
        if (s.insert > s.strstart) {
          s.insert = s.strstart;
        }
      }
      //zmemcpy(s->window + s->strstart, s->strm->next_in - used, used);
      s.window.set(s.strm.input.subarray(s.strm.next_in - used, s.strm.next_in), s.strstart);
      s.strstart += used;
      s.insert += used > s.w_size - s.insert ? s.w_size - s.insert : used;
    }
    s.block_start = s.strstart;
  }
  if (s.high_water < s.strstart) {
    s.high_water = s.strstart;
  }

  /* If the last block was written to next_out, then done. */
  if (last) {
    return BS_FINISH_DONE;
  }

  /* If flushing and all input has been consumed, then done. */
  if (flush !== Z_NO_FLUSH$2 && flush !== Z_FINISH$3 &&
    s.strm.avail_in === 0 && s.strstart === s.block_start) {
    return BS_BLOCK_DONE;
  }

  /* Fill the window with any remaining input. */
  have = s.window_size - s.strstart;
  if (s.strm.avail_in > have && s.block_start >= s.w_size) {
    /* Slide the window down. */
    s.block_start -= s.w_size;
    s.strstart -= s.w_size;
    //zmemcpy(s->window, s->window + s->w_size, s->strstart);
    s.window.set(s.window.subarray(s.w_size, s.w_size + s.strstart), 0);
    if (s.matches < 2) {
      s.matches++;       /* add a pending slide_hash() */
    }
    have += s.w_size;      /* more space now */
    if (s.insert > s.strstart) {
      s.insert = s.strstart;
    }
  }
  if (have > s.strm.avail_in) {
    have = s.strm.avail_in;
  }
  if (have) {
    read_buf(s.strm, s.window, s.strstart, have);
    s.strstart += have;
    s.insert += have > s.w_size - s.insert ? s.w_size - s.insert : have;
  }
  if (s.high_water < s.strstart) {
    s.high_water = s.strstart;
  }

  /* There was not enough avail_out to write a complete worthy or flushed
   * stored block to next_out. Write a stored block to pending instead, if we
   * have enough input for a worthy block, or if flushing and there is enough
   * room for the remaining input as a stored block in the pending buffer.
   */
  have = (s.bi_valid + 42) >> 3;     /* number of header bytes */
    /* maximum stored block length that will fit in pending: */
  have = s.pending_buf_size - have > 65535/* MAX_STORED */ ? 65535/* MAX_STORED */ : s.pending_buf_size - have;
  min_block = have > s.w_size ? s.w_size : have;
  left = s.strstart - s.block_start;
  if (left >= min_block ||
     ((left || flush === Z_FINISH$3) && flush !== Z_NO_FLUSH$2 &&
     s.strm.avail_in === 0 && left <= have)) {
    len = left > have ? have : left;
    last = flush === Z_FINISH$3 && s.strm.avail_in === 0 &&
         len === left ? 1 : 0;
    _tr_stored_block(s, s.block_start, len, last);
    s.block_start += len;
    flush_pending(s.strm);
  }

  /* We've done all we can with the available input and output. */
  return last ? BS_FINISH_STARTED : BS_NEED_MORE;
};


/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */
const deflate_fast = (s, flush) => {

  let hash_head;        /* head of the hash chain */
  let bflush;           /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$2) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) {
        break; /* flush the current block */
      }
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */
    if (hash_head !== 0/*NIL*/ && ((s.strstart - hash_head) <= (s.w_size - MIN_LOOKAHEAD))) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */
    }
    if (s.match_length >= MIN_MATCH) {
      // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

      /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/
      bflush = _tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;

      /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */
      if (s.match_length <= s.max_lazy_match/*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
        s.match_length--; /* string at strstart already in table */
        do {
          s.strstart++;
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
          /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */
        } while (--s.match_length !== 0);
        s.strstart++;
      } else
      {
        s.strstart += s.match_length;
        s.match_length = 0;
        s.ins_h = s.window[s.strstart];
        /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
        s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + 1]);

//#if MIN_MATCH != 3
//                Call UPDATE_HASH() MIN_MATCH-3 more times
//#endif
        /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */
      }
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s.window[s.strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = _tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = ((s.strstart < (MIN_MATCH - 1)) ? s.strstart : MIN_MATCH - 1);
  if (flush === Z_FINISH$3) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.sym_next) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
};

/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */
const deflate_slow = (s, flush) => {

  let hash_head;          /* head of hash chain */
  let bflush;              /* set if current block must be flushed */

  let max_insert;

  /* Process the input block. */
  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */
    if (s.lookahead < MIN_LOOKAHEAD) {
      fill_window(s);
      if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH$2) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */
    hash_head = 0/*NIL*/;
    if (s.lookahead >= MIN_MATCH) {
      /*** INSERT_STRING(s, s.strstart, hash_head); ***/
      s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
      hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
      s.head[s.ins_h] = s.strstart;
      /***/
    }

    /* Find the longest match, discarding those <= prev_length.
     */
    s.prev_length = s.match_length;
    s.prev_match = s.match_start;
    s.match_length = MIN_MATCH - 1;

    if (hash_head !== 0/*NIL*/ && s.prev_length < s.max_lazy_match &&
        s.strstart - hash_head <= (s.w_size - MIN_LOOKAHEAD)/*MAX_DIST(s)*/) {
      /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */
      s.match_length = longest_match(s, hash_head);
      /* longest_match() sets match_start */

      if (s.match_length <= 5 &&
         (s.strategy === Z_FILTERED || (s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096/*TOO_FAR*/))) {

        /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */
        s.match_length = MIN_MATCH - 1;
      }
    }
    /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */
    if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
      max_insert = s.strstart + s.lookahead - MIN_MATCH;
      /* Do not insert strings in hash table beyond this. */

      //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

      /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/
      bflush = _tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
      /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */
      s.lookahead -= s.prev_length - 1;
      s.prev_length -= 2;
      do {
        if (++s.strstart <= max_insert) {
          /*** INSERT_STRING(s, s.strstart, hash_head); ***/
          s.ins_h = HASH(s, s.ins_h, s.window[s.strstart + MIN_MATCH - 1]);
          hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
          s.head[s.ins_h] = s.strstart;
          /***/
        }
      } while (--s.prev_length !== 0);
      s.match_available = 0;
      s.match_length = MIN_MATCH - 1;
      s.strstart++;

      if (bflush) {
        /*** FLUSH_BLOCK(s, 0); ***/
        flush_block_only(s, false);
        if (s.strm.avail_out === 0) {
          return BS_NEED_MORE;
        }
        /***/
      }

    } else if (s.match_available) {
      /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */
      //Tracevv((stderr,"%c", s->window[s->strstart-1]));
      /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
      bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);

      if (bflush) {
        /*** FLUSH_BLOCK_ONLY(s, 0) ***/
        flush_block_only(s, false);
        /***/
      }
      s.strstart++;
      s.lookahead--;
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
    } else {
      /* There is no previous match to compare with, wait for
       * the next step to decide.
       */
      s.match_available = 1;
      s.strstart++;
      s.lookahead--;
    }
  }
  //Assert (flush != Z_NO_FLUSH, "no flush?");
  if (s.match_available) {
    //Tracevv((stderr,"%c", s->window[s->strstart-1]));
    /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
    bflush = _tr_tally(s, 0, s.window[s.strstart - 1]);

    s.match_available = 0;
  }
  s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
  if (flush === Z_FINISH$3) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.sym_next) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }

  return BS_BLOCK_DONE;
};


/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */
const deflate_rle = (s, flush) => {

  let bflush;            /* set if current block must be flushed */
  let prev;              /* byte at distance one to match */
  let scan, strend;      /* scan goes up to strend for length of run */

  const _win = s.window;

  for (;;) {
    /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */
    if (s.lookahead <= MAX_MATCH) {
      fill_window(s);
      if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH$2) {
        return BS_NEED_MORE;
      }
      if (s.lookahead === 0) { break; } /* flush the current block */
    }

    /* See how many times the previous byte repeats */
    s.match_length = 0;
    if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
      scan = s.strstart - 1;
      prev = _win[scan];
      if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
        strend = s.strstart + MAX_MATCH;
        do {
          /*jshint noempty:false*/
        } while (prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 prev === _win[++scan] && prev === _win[++scan] &&
                 scan < strend);
        s.match_length = MAX_MATCH - (strend - scan);
        if (s.match_length > s.lookahead) {
          s.match_length = s.lookahead;
        }
      }
      //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
    }

    /* Emit match if have run of MIN_MATCH or longer, else emit literal */
    if (s.match_length >= MIN_MATCH) {
      //check_match(s, s.strstart, s.strstart - 1, s.match_length);

      /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
      bflush = _tr_tally(s, 1, s.match_length - MIN_MATCH);

      s.lookahead -= s.match_length;
      s.strstart += s.match_length;
      s.match_length = 0;
    } else {
      /* No match, output a literal byte */
      //Tracevv((stderr,"%c", s->window[s->strstart]));
      /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
      bflush = _tr_tally(s, 0, s.window[s.strstart]);

      s.lookahead--;
      s.strstart++;
    }
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH$3) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.sym_next) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
};

/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */
const deflate_huff = (s, flush) => {

  let bflush;             /* set if current block must be flushed */

  for (;;) {
    /* Make sure that we have a literal to write. */
    if (s.lookahead === 0) {
      fill_window(s);
      if (s.lookahead === 0) {
        if (flush === Z_NO_FLUSH$2) {
          return BS_NEED_MORE;
        }
        break;      /* flush the current block */
      }
    }

    /* Output a literal byte */
    s.match_length = 0;
    //Tracevv((stderr,"%c", s->window[s->strstart]));
    /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
    bflush = _tr_tally(s, 0, s.window[s.strstart]);
    s.lookahead--;
    s.strstart++;
    if (bflush) {
      /*** FLUSH_BLOCK(s, 0); ***/
      flush_block_only(s, false);
      if (s.strm.avail_out === 0) {
        return BS_NEED_MORE;
      }
      /***/
    }
  }
  s.insert = 0;
  if (flush === Z_FINISH$3) {
    /*** FLUSH_BLOCK(s, 1); ***/
    flush_block_only(s, true);
    if (s.strm.avail_out === 0) {
      return BS_FINISH_STARTED;
    }
    /***/
    return BS_FINISH_DONE;
  }
  if (s.sym_next) {
    /*** FLUSH_BLOCK(s, 0); ***/
    flush_block_only(s, false);
    if (s.strm.avail_out === 0) {
      return BS_NEED_MORE;
    }
    /***/
  }
  return BS_BLOCK_DONE;
};

/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */
function Config(good_length, max_lazy, nice_length, max_chain, func) {

  this.good_length = good_length;
  this.max_lazy = max_lazy;
  this.nice_length = nice_length;
  this.max_chain = max_chain;
  this.func = func;
}

const configuration_table = [
  /*      good lazy nice chain */
  new Config(0, 0, 0, 0, deflate_stored),          /* 0 store only */
  new Config(4, 4, 8, 4, deflate_fast),            /* 1 max speed, no lazy matches */
  new Config(4, 5, 16, 8, deflate_fast),           /* 2 */
  new Config(4, 6, 32, 32, deflate_fast),          /* 3 */

  new Config(4, 4, 16, 16, deflate_slow),          /* 4 lazy matches */
  new Config(8, 16, 32, 32, deflate_slow),         /* 5 */
  new Config(8, 16, 128, 128, deflate_slow),       /* 6 */
  new Config(8, 32, 128, 256, deflate_slow),       /* 7 */
  new Config(32, 128, 258, 1024, deflate_slow),    /* 8 */
  new Config(32, 258, 258, 4096, deflate_slow)     /* 9 max compression */
];


/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */
const lm_init = (s) => {

  s.window_size = 2 * s.w_size;

  /*** CLEAR_HASH(s); ***/
  zero(s.head); // Fill with NIL (= 0);

  /* Set the default configuration parameters:
   */
  s.max_lazy_match = configuration_table[s.level].max_lazy;
  s.good_match = configuration_table[s.level].good_length;
  s.nice_match = configuration_table[s.level].nice_length;
  s.max_chain_length = configuration_table[s.level].max_chain;

  s.strstart = 0;
  s.block_start = 0;
  s.lookahead = 0;
  s.insert = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  s.ins_h = 0;
};


function DeflateState() {
  this.strm = null;            /* pointer back to this zlib stream */
  this.status = 0;            /* as the name implies */
  this.pending_buf = null;      /* output still pending */
  this.pending_buf_size = 0;  /* size of pending_buf */
  this.pending_out = 0;       /* next pending byte to output to the stream */
  this.pending = 0;           /* nb of bytes in the pending buffer */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip */
  this.gzhead = null;         /* gzip header information to write */
  this.gzindex = 0;           /* where in extra, name, or comment */
  this.method = Z_DEFLATED$2; /* can only be DEFLATED */
  this.last_flush = -1;   /* value of flush param for previous deflate call */

  this.w_size = 0;  /* LZ77 window size (32K by default) */
  this.w_bits = 0;  /* log2(w_size)  (8..16) */
  this.w_mask = 0;  /* w_size - 1 */

  this.window = null;
  /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */

  this.window_size = 0;
  /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */

  this.prev = null;
  /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */

  this.head = null;   /* Heads of the hash chains or NIL. */

  this.ins_h = 0;       /* hash index of string to be inserted */
  this.hash_size = 0;   /* number of elements in hash table */
  this.hash_bits = 0;   /* log2(hash_size) */
  this.hash_mask = 0;   /* hash_size-1 */

  this.hash_shift = 0;
  /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */

  this.block_start = 0;
  /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */

  this.match_length = 0;      /* length of best match */
  this.prev_match = 0;        /* previous match */
  this.match_available = 0;   /* set if previous match exists */
  this.strstart = 0;          /* start of string to insert */
  this.match_start = 0;       /* start of matching string */
  this.lookahead = 0;         /* number of valid bytes ahead in window */

  this.prev_length = 0;
  /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */

  this.max_chain_length = 0;
  /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */

  this.max_lazy_match = 0;
  /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */
  // That's alias to max_lazy_match, don't use directly
  //this.max_insert_length = 0;
  /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */

  this.level = 0;     /* compression level (1..9) */
  this.strategy = 0;  /* favor or force Huffman coding*/

  this.good_match = 0;
  /* Use a faster search when the previous match is longer than this */

  this.nice_match = 0; /* Stop searching when current match exceeds this */

              /* used by trees.c: */

  /* Didn't use ct_data typedef below to suppress compiler warning */

  // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
  // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
  // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

  // Use flat array of DOUBLE size, with interleaved fata,
  // because JS does not support effective
  this.dyn_ltree  = new Uint16Array(HEAP_SIZE * 2);
  this.dyn_dtree  = new Uint16Array((2 * D_CODES + 1) * 2);
  this.bl_tree    = new Uint16Array((2 * BL_CODES + 1) * 2);
  zero(this.dyn_ltree);
  zero(this.dyn_dtree);
  zero(this.bl_tree);

  this.l_desc   = null;         /* desc. for literal tree */
  this.d_desc   = null;         /* desc. for distance tree */
  this.bl_desc  = null;         /* desc. for bit length tree */

  //ush bl_count[MAX_BITS+1];
  this.bl_count = new Uint16Array(MAX_BITS + 1);
  /* number of codes at each bit length for an optimal tree */

  //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
  this.heap = new Uint16Array(2 * L_CODES + 1);  /* heap used to build the Huffman trees */
  zero(this.heap);

  this.heap_len = 0;               /* number of elements in the heap */
  this.heap_max = 0;               /* element of largest frequency */
  /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */

  this.depth = new Uint16Array(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
  zero(this.depth);
  /* Depth of each subtree used as tie breaker for trees of equal frequency
   */

  this.sym_buf = 0;        /* buffer for distances and literals/lengths */

  this.lit_bufsize = 0;
  /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */

  this.sym_next = 0;      /* running index in sym_buf */
  this.sym_end = 0;       /* symbol table full when sym_next reaches this */

  this.opt_len = 0;       /* bit length of current block with optimal trees */
  this.static_len = 0;    /* bit length of current block with static trees */
  this.matches = 0;       /* number of string matches in current block */
  this.insert = 0;        /* bytes at end of window left to insert */


  this.bi_buf = 0;
  /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */
  this.bi_valid = 0;
  /* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */

  // Used for window memory init. We safely ignore it for JS. That makes
  // sense only for pointers and memory check tools.
  //this.high_water = 0;
  /* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */
}


/* =========================================================================
 * Check for a valid deflate stream state. Return 0 if ok, 1 if not.
 */
const deflateStateCheck = (strm) => {

  if (!strm) {
    return 1;
  }
  const s = strm.state;
  if (!s || s.strm !== strm || (s.status !== INIT_STATE &&
//#ifdef GZIP
                                s.status !== GZIP_STATE &&
//#endif
                                s.status !== EXTRA_STATE &&
                                s.status !== NAME_STATE &&
                                s.status !== COMMENT_STATE &&
                                s.status !== HCRC_STATE &&
                                s.status !== BUSY_STATE &&
                                s.status !== FINISH_STATE)) {
    return 1;
  }
  return 0;
};


const deflateResetKeep = (strm) => {

  if (deflateStateCheck(strm)) {
    return err(strm, Z_STREAM_ERROR$2);
  }

  strm.total_in = strm.total_out = 0;
  strm.data_type = Z_UNKNOWN;

  const s = strm.state;
  s.pending = 0;
  s.pending_out = 0;

  if (s.wrap < 0) {
    s.wrap = -s.wrap;
    /* was made negative by deflate(..., Z_FINISH); */
  }
  s.status =
//#ifdef GZIP
    s.wrap === 2 ? GZIP_STATE :
//#endif
    s.wrap ? INIT_STATE : BUSY_STATE;
  strm.adler = (s.wrap === 2) ?
    0  // crc32(0, Z_NULL, 0)
  :
    1; // adler32(0, Z_NULL, 0)
  s.last_flush = -2;
  _tr_init(s);
  return Z_OK$3;
};


const deflateReset = (strm) => {

  const ret = deflateResetKeep(strm);
  if (ret === Z_OK$3) {
    lm_init(strm.state);
  }
  return ret;
};


const deflateSetHeader = (strm, head) => {

  if (deflateStateCheck(strm) || strm.state.wrap !== 2) {
    return Z_STREAM_ERROR$2;
  }
  strm.state.gzhead = head;
  return Z_OK$3;
};


const deflateInit2 = (strm, level, method, windowBits, memLevel, strategy) => {

  if (!strm) { // === Z_NULL
    return Z_STREAM_ERROR$2;
  }
  let wrap = 1;

  if (level === Z_DEFAULT_COMPRESSION$1) {
    level = 6;
  }

  if (windowBits < 0) { /* suppress zlib wrapper */
    wrap = 0;
    windowBits = -windowBits;
  }

  else if (windowBits > 15) {
    wrap = 2;           /* write gzip wrapper instead */
    windowBits -= 16;
  }


  if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED$2 ||
    windowBits < 8 || windowBits > 15 || level < 0 || level > 9 ||
    strategy < 0 || strategy > Z_FIXED || (windowBits === 8 && wrap !== 1)) {
    return err(strm, Z_STREAM_ERROR$2);
  }


  if (windowBits === 8) {
    windowBits = 9;
  }
  /* until 256-byte window bug fixed */

  const s = new DeflateState();

  strm.state = s;
  s.strm = strm;
  s.status = INIT_STATE;     /* to pass state test in deflateReset() */

  s.wrap = wrap;
  s.gzhead = null;
  s.w_bits = windowBits;
  s.w_size = 1 << s.w_bits;
  s.w_mask = s.w_size - 1;

  s.hash_bits = memLevel + 7;
  s.hash_size = 1 << s.hash_bits;
  s.hash_mask = s.hash_size - 1;
  s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);

  s.window = new Uint8Array(s.w_size * 2);
  s.head = new Uint16Array(s.hash_size);
  s.prev = new Uint16Array(s.w_size);

  // Don't need mem init magic for JS.
  //s.high_water = 0;  /* nothing written to s->window yet */

  s.lit_bufsize = 1 << (memLevel + 6); /* 16K elements by default */

  /* We overlay pending_buf and sym_buf. This works since the average size
   * for length/distance pairs over any compressed block is assured to be 31
   * bits or less.
   *
   * Analysis: The longest fixed codes are a length code of 8 bits plus 5
   * extra bits, for lengths 131 to 257. The longest fixed distance codes are
   * 5 bits plus 13 extra bits, for distances 16385 to 32768. The longest
   * possible fixed-codes length/distance pair is then 31 bits total.
   *
   * sym_buf starts one-fourth of the way into pending_buf. So there are
   * three bytes in sym_buf for every four bytes in pending_buf. Each symbol
   * in sym_buf is three bytes -- two for the distance and one for the
   * literal/length. As each symbol is consumed, the pointer to the next
   * sym_buf value to read moves forward three bytes. From that symbol, up to
   * 31 bits are written to pending_buf. The closest the written pending_buf
   * bits gets to the next sym_buf symbol to read is just before the last
   * code is written. At that time, 31*(n-2) bits have been written, just
   * after 24*(n-2) bits have been consumed from sym_buf. sym_buf starts at
   * 8*n bits into pending_buf. (Note that the symbol buffer fills when n-1
   * symbols are written.) The closest the writing gets to what is unread is
   * then n+14 bits. Here n is lit_bufsize, which is 16384 by default, and
   * can range from 128 to 32768.
   *
   * Therefore, at a minimum, there are 142 bits of space between what is
   * written and what is read in the overlain buffers, so the symbols cannot
   * be overwritten by the compressed data. That space is actually 139 bits,
   * due to the three-bit fixed-code block header.
   *
   * That covers the case where either Z_FIXED is specified, forcing fixed
   * codes, or when the use of fixed codes is chosen, because that choice
   * results in a smaller compressed block than dynamic codes. That latter
   * condition then assures that the above analysis also covers all dynamic
   * blocks. A dynamic-code block will only be chosen to be emitted if it has
   * fewer bits than a fixed-code block would for the same set of symbols.
   * Therefore its average symbol length is assured to be less than 31. So
   * the compressed data for a dynamic block also cannot overwrite the
   * symbols from which it is being constructed.
   */

  s.pending_buf_size = s.lit_bufsize * 4;
  s.pending_buf = new Uint8Array(s.pending_buf_size);

  // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
  //s->sym_buf = s->pending_buf + s->lit_bufsize;
  s.sym_buf = s.lit_bufsize;

  //s->sym_end = (s->lit_bufsize - 1) * 3;
  s.sym_end = (s.lit_bufsize - 1) * 3;
  /* We avoid equality with lit_bufsize*3 because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */

  s.level = level;
  s.strategy = strategy;
  s.method = method;

  return deflateReset(strm);
};

const deflateInit = (strm, level) => {

  return deflateInit2(strm, level, Z_DEFLATED$2, MAX_WBITS$1, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY$1);
};


/* ========================================================================= */
const deflate$2 = (strm, flush) => {

  if (deflateStateCheck(strm) || flush > Z_BLOCK$1 || flush < 0) {
    return strm ? err(strm, Z_STREAM_ERROR$2) : Z_STREAM_ERROR$2;
  }

  const s = strm.state;

  if (!strm.output ||
      (strm.avail_in !== 0 && !strm.input) ||
      (s.status === FINISH_STATE && flush !== Z_FINISH$3)) {
    return err(strm, (strm.avail_out === 0) ? Z_BUF_ERROR$1 : Z_STREAM_ERROR$2);
  }

  const old_flush = s.last_flush;
  s.last_flush = flush;

  /* Flush as much pending output as possible */
  if (s.pending !== 0) {
    flush_pending(strm);
    if (strm.avail_out === 0) {
      /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */
      s.last_flush = -1;
      return Z_OK$3;
    }

    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */
  } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) &&
    flush !== Z_FINISH$3) {
    return err(strm, Z_BUF_ERROR$1);
  }

  /* User must not provide more input after the first FINISH: */
  if (s.status === FINISH_STATE && strm.avail_in !== 0) {
    return err(strm, Z_BUF_ERROR$1);
  }

  /* Write the header */
  if (s.status === INIT_STATE && s.wrap === 0) {
    s.status = BUSY_STATE;
  }
  if (s.status === INIT_STATE) {
    /* zlib header */
    let header = (Z_DEFLATED$2 + ((s.w_bits - 8) << 4)) << 8;
    let level_flags = -1;

    if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
      level_flags = 0;
    } else if (s.level < 6) {
      level_flags = 1;
    } else if (s.level === 6) {
      level_flags = 2;
    } else {
      level_flags = 3;
    }
    header |= (level_flags << 6);
    if (s.strstart !== 0) { header |= PRESET_DICT; }
    header += 31 - (header % 31);

    putShortMSB(s, header);

    /* Save the adler32 of the preset dictionary: */
    if (s.strstart !== 0) {
      putShortMSB(s, strm.adler >>> 16);
      putShortMSB(s, strm.adler & 0xffff);
    }
    strm.adler = 1; // adler32(0L, Z_NULL, 0);
    s.status = BUSY_STATE;

    /* Compression must start with an empty pending buffer */
    flush_pending(strm);
    if (s.pending !== 0) {
      s.last_flush = -1;
      return Z_OK$3;
    }
  }
//#ifdef GZIP
  if (s.status === GZIP_STATE) {
    /* gzip header */
    strm.adler = 0;  //crc32(0L, Z_NULL, 0);
    put_byte(s, 31);
    put_byte(s, 139);
    put_byte(s, 8);
    if (!s.gzhead) { // s->gzhead == Z_NULL
      put_byte(s, 0);
      put_byte(s, 0);
      put_byte(s, 0);
      put_byte(s, 0);
      put_byte(s, 0);
      put_byte(s, s.level === 9 ? 2 :
                  (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                   4 : 0));
      put_byte(s, OS_CODE);
      s.status = BUSY_STATE;

      /* Compression must start with an empty pending buffer */
      flush_pending(strm);
      if (s.pending !== 0) {
        s.last_flush = -1;
        return Z_OK$3;
      }
    }
    else {
      put_byte(s, (s.gzhead.text ? 1 : 0) +
                  (s.gzhead.hcrc ? 2 : 0) +
                  (!s.gzhead.extra ? 0 : 4) +
                  (!s.gzhead.name ? 0 : 8) +
                  (!s.gzhead.comment ? 0 : 16)
      );
      put_byte(s, s.gzhead.time & 0xff);
      put_byte(s, (s.gzhead.time >> 8) & 0xff);
      put_byte(s, (s.gzhead.time >> 16) & 0xff);
      put_byte(s, (s.gzhead.time >> 24) & 0xff);
      put_byte(s, s.level === 9 ? 2 :
                  (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ?
                   4 : 0));
      put_byte(s, s.gzhead.os & 0xff);
      if (s.gzhead.extra && s.gzhead.extra.length) {
        put_byte(s, s.gzhead.extra.length & 0xff);
        put_byte(s, (s.gzhead.extra.length >> 8) & 0xff);
      }
      if (s.gzhead.hcrc) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending, 0);
      }
      s.gzindex = 0;
      s.status = EXTRA_STATE;
    }
  }
  if (s.status === EXTRA_STATE) {
    if (s.gzhead.extra/* != Z_NULL*/) {
      let beg = s.pending;   /* start of bytes to update crc */
      let left = (s.gzhead.extra.length & 0xffff) - s.gzindex;
      while (s.pending + left > s.pending_buf_size) {
        let copy = s.pending_buf_size - s.pending;
        // zmemcpy(s.pending_buf + s.pending,
        //    s.gzhead.extra + s.gzindex, copy);
        s.pending_buf.set(s.gzhead.extra.subarray(s.gzindex, s.gzindex + copy), s.pending);
        s.pending = s.pending_buf_size;
        //--- HCRC_UPDATE(beg) ---//
        if (s.gzhead.hcrc && s.pending > beg) {
          strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
        }
        //---//
        s.gzindex += copy;
        flush_pending(strm);
        if (s.pending !== 0) {
          s.last_flush = -1;
          return Z_OK$3;
        }
        beg = 0;
        left -= copy;
      }
      // JS specific: s.gzhead.extra may be TypedArray or Array for backward compatibility
      //              TypedArray.slice and TypedArray.from don't exist in IE10-IE11
      let gzhead_extra = new Uint8Array(s.gzhead.extra);
      // zmemcpy(s->pending_buf + s->pending,
      //     s->gzhead->extra + s->gzindex, left);
      s.pending_buf.set(gzhead_extra.subarray(s.gzindex, s.gzindex + left), s.pending);
      s.pending += left;
      //--- HCRC_UPDATE(beg) ---//
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      //---//
      s.gzindex = 0;
    }
    s.status = NAME_STATE;
  }
  if (s.status === NAME_STATE) {
    if (s.gzhead.name/* != Z_NULL*/) {
      let beg = s.pending;   /* start of bytes to update crc */
      let val;
      do {
        if (s.pending === s.pending_buf_size) {
          //--- HCRC_UPDATE(beg) ---//
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          //---//
          flush_pending(strm);
          if (s.pending !== 0) {
            s.last_flush = -1;
            return Z_OK$3;
          }
          beg = 0;
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.name.length) {
          val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);
      //--- HCRC_UPDATE(beg) ---//
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      //---//
      s.gzindex = 0;
    }
    s.status = COMMENT_STATE;
  }
  if (s.status === COMMENT_STATE) {
    if (s.gzhead.comment/* != Z_NULL*/) {
      let beg = s.pending;   /* start of bytes to update crc */
      let val;
      do {
        if (s.pending === s.pending_buf_size) {
          //--- HCRC_UPDATE(beg) ---//
          if (s.gzhead.hcrc && s.pending > beg) {
            strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
          }
          //---//
          flush_pending(strm);
          if (s.pending !== 0) {
            s.last_flush = -1;
            return Z_OK$3;
          }
          beg = 0;
        }
        // JS specific: little magic to add zero terminator to end of string
        if (s.gzindex < s.gzhead.comment.length) {
          val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
        } else {
          val = 0;
        }
        put_byte(s, val);
      } while (val !== 0);
      //--- HCRC_UPDATE(beg) ---//
      if (s.gzhead.hcrc && s.pending > beg) {
        strm.adler = crc32_1(strm.adler, s.pending_buf, s.pending - beg, beg);
      }
      //---//
    }
    s.status = HCRC_STATE;
  }
  if (s.status === HCRC_STATE) {
    if (s.gzhead.hcrc) {
      if (s.pending + 2 > s.pending_buf_size) {
        flush_pending(strm);
        if (s.pending !== 0) {
          s.last_flush = -1;
          return Z_OK$3;
        }
      }
      put_byte(s, strm.adler & 0xff);
      put_byte(s, (strm.adler >> 8) & 0xff);
      strm.adler = 0; //crc32(0L, Z_NULL, 0);
    }
    s.status = BUSY_STATE;

    /* Compression must start with an empty pending buffer */
    flush_pending(strm);
    if (s.pending !== 0) {
      s.last_flush = -1;
      return Z_OK$3;
    }
  }
//#endif

  /* Start a new block or continue the current one.
   */
  if (strm.avail_in !== 0 || s.lookahead !== 0 ||
    (flush !== Z_NO_FLUSH$2 && s.status !== FINISH_STATE)) {
    let bstate = s.level === 0 ? deflate_stored(s, flush) :
                 s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) :
                 s.strategy === Z_RLE ? deflate_rle(s, flush) :
                 configuration_table[s.level].func(s, flush);

    if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
      s.status = FINISH_STATE;
    }
    if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
      if (strm.avail_out === 0) {
        s.last_flush = -1;
        /* avoid BUF_ERROR next call, see above */
      }
      return Z_OK$3;
      /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */
    }
    if (bstate === BS_BLOCK_DONE) {
      if (flush === Z_PARTIAL_FLUSH) {
        _tr_align(s);
      }
      else if (flush !== Z_BLOCK$1) { /* FULL_FLUSH or SYNC_FLUSH */

        _tr_stored_block(s, 0, 0, false);
        /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */
        if (flush === Z_FULL_FLUSH$1) {
          /*** CLEAR_HASH(s); ***/             /* forget history */
          zero(s.head); // Fill with NIL (= 0);

          if (s.lookahead === 0) {
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
        }
      }
      flush_pending(strm);
      if (strm.avail_out === 0) {
        s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
        return Z_OK$3;
      }
    }
  }

  if (flush !== Z_FINISH$3) { return Z_OK$3; }
  if (s.wrap <= 0) { return Z_STREAM_END$3; }

  /* Write the trailer */
  if (s.wrap === 2) {
    put_byte(s, strm.adler & 0xff);
    put_byte(s, (strm.adler >> 8) & 0xff);
    put_byte(s, (strm.adler >> 16) & 0xff);
    put_byte(s, (strm.adler >> 24) & 0xff);
    put_byte(s, strm.total_in & 0xff);
    put_byte(s, (strm.total_in >> 8) & 0xff);
    put_byte(s, (strm.total_in >> 16) & 0xff);
    put_byte(s, (strm.total_in >> 24) & 0xff);
  }
  else
  {
    putShortMSB(s, strm.adler >>> 16);
    putShortMSB(s, strm.adler & 0xffff);
  }

  flush_pending(strm);
  /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */
  if (s.wrap > 0) { s.wrap = -s.wrap; }
  /* write the trailer only once! */
  return s.pending !== 0 ? Z_OK$3 : Z_STREAM_END$3;
};


const deflateEnd = (strm) => {

  if (deflateStateCheck(strm)) {
    return Z_STREAM_ERROR$2;
  }

  const status = strm.state.status;

  strm.state = null;

  return status === BUSY_STATE ? err(strm, Z_DATA_ERROR$2) : Z_OK$3;
};


/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */
const deflateSetDictionary = (strm, dictionary) => {

  let dictLength = dictionary.length;

  if (deflateStateCheck(strm)) {
    return Z_STREAM_ERROR$2;
  }

  const s = strm.state;
  const wrap = s.wrap;

  if (wrap === 2 || (wrap === 1 && s.status !== INIT_STATE) || s.lookahead) {
    return Z_STREAM_ERROR$2;
  }

  /* when using zlib wrappers, compute Adler-32 for provided dictionary */
  if (wrap === 1) {
    /* adler32(strm->adler, dictionary, dictLength); */
    strm.adler = adler32_1(strm.adler, dictionary, dictLength, 0);
  }

  s.wrap = 0;   /* avoid computing Adler-32 in read_buf */

  /* if dictionary would fill window, just replace the history */
  if (dictLength >= s.w_size) {
    if (wrap === 0) {            /* already empty otherwise */
      /*** CLEAR_HASH(s); ***/
      zero(s.head); // Fill with NIL (= 0);
      s.strstart = 0;
      s.block_start = 0;
      s.insert = 0;
    }
    /* use the tail */
    // dictionary = dictionary.slice(dictLength - s.w_size);
    let tmpDict = new Uint8Array(s.w_size);
    tmpDict.set(dictionary.subarray(dictLength - s.w_size, dictLength), 0);
    dictionary = tmpDict;
    dictLength = s.w_size;
  }
  /* insert dictionary into window and hash */
  const avail = strm.avail_in;
  const next = strm.next_in;
  const input = strm.input;
  strm.avail_in = dictLength;
  strm.next_in = 0;
  strm.input = dictionary;
  fill_window(s);
  while (s.lookahead >= MIN_MATCH) {
    let str = s.strstart;
    let n = s.lookahead - (MIN_MATCH - 1);
    do {
      /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
      s.ins_h = HASH(s, s.ins_h, s.window[str + MIN_MATCH - 1]);

      s.prev[str & s.w_mask] = s.head[s.ins_h];

      s.head[s.ins_h] = str;
      str++;
    } while (--n);
    s.strstart = str;
    s.lookahead = MIN_MATCH - 1;
    fill_window(s);
  }
  s.strstart += s.lookahead;
  s.block_start = s.strstart;
  s.insert = s.lookahead;
  s.lookahead = 0;
  s.match_length = s.prev_length = MIN_MATCH - 1;
  s.match_available = 0;
  strm.next_in = next;
  strm.input = input;
  strm.avail_in = avail;
  s.wrap = wrap;
  return Z_OK$3;
};


var deflateInit_1 = deflateInit;
var deflateInit2_1 = deflateInit2;
var deflateReset_1 = deflateReset;
var deflateResetKeep_1 = deflateResetKeep;
var deflateSetHeader_1 = deflateSetHeader;
var deflate_2$1 = deflate$2;
var deflateEnd_1 = deflateEnd;
var deflateSetDictionary_1 = deflateSetDictionary;
var deflateInfo = 'pako deflate (from Nodeca project)';

/* Not implemented
module.exports.deflateBound = deflateBound;
module.exports.deflateCopy = deflateCopy;
module.exports.deflateGetDictionary = deflateGetDictionary;
module.exports.deflateParams = deflateParams;
module.exports.deflatePending = deflatePending;
module.exports.deflatePrime = deflatePrime;
module.exports.deflateTune = deflateTune;
*/

var deflate_1$2 = {
	deflateInit: deflateInit_1,
	deflateInit2: deflateInit2_1,
	deflateReset: deflateReset_1,
	deflateResetKeep: deflateResetKeep_1,
	deflateSetHeader: deflateSetHeader_1,
	deflate: deflate_2$1,
	deflateEnd: deflateEnd_1,
	deflateSetDictionary: deflateSetDictionary_1,
	deflateInfo: deflateInfo
};

const _has = (obj, key) => {
  return Object.prototype.hasOwnProperty.call(obj, key);
};

var assign = function (obj /*from1, from2, from3, ...*/) {
  const sources = Array.prototype.slice.call(arguments, 1);
  while (sources.length) {
    const source = sources.shift();
    if (!source) { continue; }

    if (typeof source !== 'object') {
      throw new TypeError(source + 'must be non-object');
    }

    for (const p in source) {
      if (_has(source, p)) {
        obj[p] = source[p];
      }
    }
  }

  return obj;
};


// Join array of chunks to single array.
var flattenChunks = (chunks) => {
  // calculate data length
  let len = 0;

  for (let i = 0, l = chunks.length; i < l; i++) {
    len += chunks[i].length;
  }

  // join chunks
  const result = new Uint8Array(len);

  for (let i = 0, pos = 0, l = chunks.length; i < l; i++) {
    let chunk = chunks[i];
    result.set(chunk, pos);
    pos += chunk.length;
  }

  return result;
};

var common = {
	assign: assign,
	flattenChunks: flattenChunks
};

// String encode/decode helpers


// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
let STR_APPLY_UIA_OK = true;

try { String.fromCharCode.apply(null, new Uint8Array(1)); } catch (__) { STR_APPLY_UIA_OK = false; }


// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
const _utf8len = new Uint8Array(256);
for (let q = 0; q < 256; q++) {
  _utf8len[q] = (q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1);
}
_utf8len[254] = _utf8len[254] = 1; // Invalid sequence start


// convert string to array (typed, when possible)
var string2buf = (str) => {
  if (typeof TextEncoder === 'function' && TextEncoder.prototype.encode) {
    return new TextEncoder().encode(str);
  }

  let buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;

  // count binary size
  for (m_pos = 0; m_pos < str_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
  }

  // allocate buffer
  buf = new Uint8Array(buf_len);

  // convert
  for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
    c = str.charCodeAt(m_pos);
    if ((c & 0xfc00) === 0xd800 && (m_pos + 1 < str_len)) {
      c2 = str.charCodeAt(m_pos + 1);
      if ((c2 & 0xfc00) === 0xdc00) {
        c = 0x10000 + ((c - 0xd800) << 10) + (c2 - 0xdc00);
        m_pos++;
      }
    }
    if (c < 0x80) {
      /* one byte */
      buf[i++] = c;
    } else if (c < 0x800) {
      /* two bytes */
      buf[i++] = 0xC0 | (c >>> 6);
      buf[i++] = 0x80 | (c & 0x3f);
    } else if (c < 0x10000) {
      /* three bytes */
      buf[i++] = 0xE0 | (c >>> 12);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    } else {
      /* four bytes */
      buf[i++] = 0xf0 | (c >>> 18);
      buf[i++] = 0x80 | (c >>> 12 & 0x3f);
      buf[i++] = 0x80 | (c >>> 6 & 0x3f);
      buf[i++] = 0x80 | (c & 0x3f);
    }
  }

  return buf;
};

// Helper
const buf2binstring = (buf, len) => {
  // On Chrome, the arguments in a function call that are allowed is `65534`.
  // If the length of the buffer is smaller than that, we can use this optimization,
  // otherwise we will take a slower path.
  if (len < 65534) {
    if (buf.subarray && STR_APPLY_UIA_OK) {
      return String.fromCharCode.apply(null, buf.length === len ? buf : buf.subarray(0, len));
    }
  }

  let result = '';
  for (let i = 0; i < len; i++) {
    result += String.fromCharCode(buf[i]);
  }
  return result;
};


// convert array to string
var buf2string = (buf, max) => {
  const len = max || buf.length;

  if (typeof TextDecoder === 'function' && TextDecoder.prototype.decode) {
    return new TextDecoder().decode(buf.subarray(0, max));
  }

  let i, out;

  // Reserve max possible length (2 words per char)
  // NB: by unknown reasons, Array is significantly faster for
  //     String.fromCharCode.apply than Uint16Array.
  const utf16buf = new Array(len * 2);

  for (out = 0, i = 0; i < len;) {
    let c = buf[i++];
    // quick process ascii
    if (c < 0x80) { utf16buf[out++] = c; continue; }

    let c_len = _utf8len[c];
    // skip 5 & 6 byte codes
    if (c_len > 4) { utf16buf[out++] = 0xfffd; i += c_len - 1; continue; }

    // apply mask on first byte
    c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
    // join the rest
    while (c_len > 1 && i < len) {
      c = (c << 6) | (buf[i++] & 0x3f);
      c_len--;
    }

    // terminated by end of string?
    if (c_len > 1) { utf16buf[out++] = 0xfffd; continue; }

    if (c < 0x10000) {
      utf16buf[out++] = c;
    } else {
      c -= 0x10000;
      utf16buf[out++] = 0xd800 | ((c >> 10) & 0x3ff);
      utf16buf[out++] = 0xdc00 | (c & 0x3ff);
    }
  }

  return buf2binstring(utf16buf, out);
};


// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var utf8border = (buf, max) => {

  max = max || buf.length;
  if (max > buf.length) { max = buf.length; }

  // go back from last position, until start of sequence found
  let pos = max - 1;
  while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) { pos--; }

  // Very small and broken sequence,
  // return max, because we should return something anyway.
  if (pos < 0) { return max; }

  // If we came to start of buffer - that means buffer is too small,
  // return max too.
  if (pos === 0) { return max; }

  return (pos + _utf8len[buf[pos]] > max) ? pos : max;
};

var strings = {
	string2buf: string2buf,
	buf2string: buf2string,
	utf8border: utf8border
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function ZStream() {
  /* next input byte */
  this.input = null; // JS specific, because we have no pointers
  this.next_in = 0;
  /* number of bytes available at input */
  this.avail_in = 0;
  /* total number of input bytes read so far */
  this.total_in = 0;
  /* next output byte should be put there */
  this.output = null; // JS specific, because we have no pointers
  this.next_out = 0;
  /* remaining free space at output */
  this.avail_out = 0;
  /* total number of bytes output so far */
  this.total_out = 0;
  /* last error message, NULL if no error */
  this.msg = ''/*Z_NULL*/;
  /* not visible by applications */
  this.state = null;
  /* best guess about the data type: binary or text */
  this.data_type = 2/*Z_UNKNOWN*/;
  /* adler32 value of the uncompressed data */
  this.adler = 0;
}

var zstream = ZStream;

const toString$1 = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

const {
  Z_NO_FLUSH: Z_NO_FLUSH$1, Z_SYNC_FLUSH, Z_FULL_FLUSH, Z_FINISH: Z_FINISH$2,
  Z_OK: Z_OK$2, Z_STREAM_END: Z_STREAM_END$2,
  Z_DEFAULT_COMPRESSION,
  Z_DEFAULT_STRATEGY,
  Z_DEFLATED: Z_DEFLATED$1
} = constants$2;

/* ===========================================================================*/


/**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/

/* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/

/**
 * Deflate.result -> Uint8Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param).
 **/

/**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/

/**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/


/**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 *   , chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/
function Deflate$1(options) {
  this.options = common.assign({
    level: Z_DEFAULT_COMPRESSION,
    method: Z_DEFLATED$1,
    chunkSize: 16384,
    windowBits: 15,
    memLevel: 8,
    strategy: Z_DEFAULT_STRATEGY
  }, options || {});

  let opt = this.options;

  if (opt.raw && (opt.windowBits > 0)) {
    opt.windowBits = -opt.windowBits;
  }

  else if (opt.gzip && (opt.windowBits > 0) && (opt.windowBits < 16)) {
    opt.windowBits += 16;
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm = new zstream();
  this.strm.avail_out = 0;

  let status = deflate_1$2.deflateInit2(
    this.strm,
    opt.level,
    opt.method,
    opt.windowBits,
    opt.memLevel,
    opt.strategy
  );

  if (status !== Z_OK$2) {
    throw new Error(messages[status]);
  }

  if (opt.header) {
    deflate_1$2.deflateSetHeader(this.strm, opt.header);
  }

  if (opt.dictionary) {
    let dict;
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      // If we need to compress text, change encoding to utf8.
      dict = strings.string2buf(opt.dictionary);
    } else if (toString$1.call(opt.dictionary) === '[object ArrayBuffer]') {
      dict = new Uint8Array(opt.dictionary);
    } else {
      dict = opt.dictionary;
    }

    status = deflate_1$2.deflateSetDictionary(this.strm, dict);

    if (status !== Z_OK$2) {
      throw new Error(messages[status]);
    }

    this._dict_set = true;
  }
}

/**
 * Deflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must
 * have `flush_mode` Z_FINISH (or `true`). That will flush internal pending
 * buffers and call [[Deflate#onEnd]].
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Deflate$1.prototype.push = function (data, flush_mode) {
  const strm = this.strm;
  const chunkSize = this.options.chunkSize;
  let status, _flush_mode;

  if (this.ended) { return false; }

  if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
  else _flush_mode = flush_mode === true ? Z_FINISH$2 : Z_NO_FLUSH$1;

  // Convert data if needed
  if (typeof data === 'string') {
    // If we need to compress text, change encoding to utf8.
    strm.input = strings.string2buf(data);
  } else if (toString$1.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  for (;;) {
    if (strm.avail_out === 0) {
      strm.output = new Uint8Array(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    // Make sure avail_out > 6 to avoid repeating markers
    if ((_flush_mode === Z_SYNC_FLUSH || _flush_mode === Z_FULL_FLUSH) && strm.avail_out <= 6) {
      this.onData(strm.output.subarray(0, strm.next_out));
      strm.avail_out = 0;
      continue;
    }

    status = deflate_1$2.deflate(strm, _flush_mode);

    // Ended => flush and finish
    if (status === Z_STREAM_END$2) {
      if (strm.next_out > 0) {
        this.onData(strm.output.subarray(0, strm.next_out));
      }
      status = deflate_1$2.deflateEnd(this.strm);
      this.onEnd(status);
      this.ended = true;
      return status === Z_OK$2;
    }

    // Flush if out buffer full
    if (strm.avail_out === 0) {
      this.onData(strm.output);
      continue;
    }

    // Flush if requested and has data
    if (_flush_mode > 0 && strm.next_out > 0) {
      this.onData(strm.output.subarray(0, strm.next_out));
      strm.avail_out = 0;
      continue;
    }

    if (strm.avail_in === 0) break;
  }

  return true;
};


/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array): output data.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Deflate$1.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Deflate$1.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK$2) {
    this.result = common.flattenChunks(this.chunks);
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * deflate(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const data = new Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/
function deflate$1(input, options) {
  const deflator = new Deflate$1(options);

  deflator.push(input, true);

  // That will never happens, if you don't cheat with options :)
  if (deflator.err) { throw deflator.msg || messages[deflator.err]; }

  return deflator.result;
}


/**
 * deflateRaw(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function deflateRaw$1(input, options) {
  options = options || {};
  options.raw = true;
  return deflate$1(input, options);
}


/**
 * gzip(data[, options]) -> Uint8Array
 * - data (Uint8Array|ArrayBuffer|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/
function gzip$1(input, options) {
  options = options || {};
  options.gzip = true;
  return deflate$1(input, options);
}


var Deflate_1$1 = Deflate$1;
var deflate_2 = deflate$1;
var deflateRaw_1$1 = deflateRaw$1;
var gzip_1$1 = gzip$1;
var constants$1 = constants$2;

var deflate_1$1 = {
	Deflate: Deflate_1$1,
	deflate: deflate_2,
	deflateRaw: deflateRaw_1$1,
	gzip: gzip_1$1,
	constants: constants$1
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

// See state defs from inflate.js
const BAD$1 = 16209;       /* got a data error -- remain here until reset */
const TYPE$1 = 16191;      /* i: waiting for type bits, including last-flag bit */

/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */
var inffast = function inflate_fast(strm, start) {
  let _in;                    /* local strm.input */
  let last;                   /* have enough input while in < last */
  let _out;                   /* local strm.output */
  let beg;                    /* inflate()'s initial strm.output */
  let end;                    /* while out < end, enough space available */
//#ifdef INFLATE_STRICT
  let dmax;                   /* maximum distance from zlib header */
//#endif
  let wsize;                  /* window size or zero if not using window */
  let whave;                  /* valid bytes in the window */
  let wnext;                  /* window write index */
  // Use `s_window` instead `window`, avoid conflict with instrumentation tools
  let s_window;               /* allocated sliding window, if wsize != 0 */
  let hold;                   /* local strm.hold */
  let bits;                   /* local strm.bits */
  let lcode;                  /* local strm.lencode */
  let dcode;                  /* local strm.distcode */
  let lmask;                  /* mask for first level of length codes */
  let dmask;                  /* mask for first level of distance codes */
  let here;                   /* retrieved table entry */
  let op;                     /* code bits, operation, extra bits, or */
                              /*  window position, window bytes to copy */
  let len;                    /* match length, unused bytes */
  let dist;                   /* match distance */
  let from;                   /* where to copy match from */
  let from_source;


  let input, output; // JS specific, because we have no pointers

  /* copy state to local variables */
  const state = strm.state;
  //here = state.here;
  _in = strm.next_in;
  input = strm.input;
  last = _in + (strm.avail_in - 5);
  _out = strm.next_out;
  output = strm.output;
  beg = _out - (start - strm.avail_out);
  end = _out + (strm.avail_out - 257);
//#ifdef INFLATE_STRICT
  dmax = state.dmax;
//#endif
  wsize = state.wsize;
  whave = state.whave;
  wnext = state.wnext;
  s_window = state.window;
  hold = state.hold;
  bits = state.bits;
  lcode = state.lencode;
  dcode = state.distcode;
  lmask = (1 << state.lenbits) - 1;
  dmask = (1 << state.distbits) - 1;


  /* decode literals and length/distances until end-of-block or not enough
     input data or output space */

  top:
  do {
    if (bits < 15) {
      hold += input[_in++] << bits;
      bits += 8;
      hold += input[_in++] << bits;
      bits += 8;
    }

    here = lcode[hold & lmask];

    dolen:
    for (;;) { // Goto emulation
      op = here >>> 24/*here.bits*/;
      hold >>>= op;
      bits -= op;
      op = (here >>> 16) & 0xff/*here.op*/;
      if (op === 0) {                          /* literal */
        //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
        //        "inflate:         literal '%c'\n" :
        //        "inflate:         literal 0x%02x\n", here.val));
        output[_out++] = here & 0xffff/*here.val*/;
      }
      else if (op & 16) {                     /* length base */
        len = here & 0xffff/*here.val*/;
        op &= 15;                           /* number of extra bits */
        if (op) {
          if (bits < op) {
            hold += input[_in++] << bits;
            bits += 8;
          }
          len += hold & ((1 << op) - 1);
          hold >>>= op;
          bits -= op;
        }
        //Tracevv((stderr, "inflate:         length %u\n", len));
        if (bits < 15) {
          hold += input[_in++] << bits;
          bits += 8;
          hold += input[_in++] << bits;
          bits += 8;
        }
        here = dcode[hold & dmask];

        dodist:
        for (;;) { // goto emulation
          op = here >>> 24/*here.bits*/;
          hold >>>= op;
          bits -= op;
          op = (here >>> 16) & 0xff/*here.op*/;

          if (op & 16) {                      /* distance base */
            dist = here & 0xffff/*here.val*/;
            op &= 15;                       /* number of extra bits */
            if (bits < op) {
              hold += input[_in++] << bits;
              bits += 8;
              if (bits < op) {
                hold += input[_in++] << bits;
                bits += 8;
              }
            }
            dist += hold & ((1 << op) - 1);
//#ifdef INFLATE_STRICT
            if (dist > dmax) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD$1;
              break top;
            }
//#endif
            hold >>>= op;
            bits -= op;
            //Tracevv((stderr, "inflate:         distance %u\n", dist));
            op = _out - beg;                /* max distance in output */
            if (dist > op) {                /* see if copy from window */
              op = dist - op;               /* distance back in window */
              if (op > whave) {
                if (state.sane) {
                  strm.msg = 'invalid distance too far back';
                  state.mode = BAD$1;
                  break top;
                }

// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//                if (len <= op - whave) {
//                  do {
//                    output[_out++] = 0;
//                  } while (--len);
//                  continue top;
//                }
//                len -= op - whave;
//                do {
//                  output[_out++] = 0;
//                } while (--op > whave);
//                if (op === 0) {
//                  from = _out - dist;
//                  do {
//                    output[_out++] = output[from++];
//                  } while (--len);
//                  continue top;
//                }
//#endif
              }
              from = 0; // window index
              from_source = s_window;
              if (wnext === 0) {           /* very common case */
                from += wsize - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              else if (wnext < op) {      /* wrap around window */
                from += wsize + wnext - op;
                op -= wnext;
                if (op < len) {         /* some from end of window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = 0;
                  if (wnext < len) {  /* some from start of window */
                    op = wnext;
                    len -= op;
                    do {
                      output[_out++] = s_window[from++];
                    } while (--op);
                    from = _out - dist;      /* rest from output */
                    from_source = output;
                  }
                }
              }
              else {                      /* contiguous in window */
                from += wnext - op;
                if (op < len) {         /* some from window */
                  len -= op;
                  do {
                    output[_out++] = s_window[from++];
                  } while (--op);
                  from = _out - dist;  /* rest from output */
                  from_source = output;
                }
              }
              while (len > 2) {
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                output[_out++] = from_source[from++];
                len -= 3;
              }
              if (len) {
                output[_out++] = from_source[from++];
                if (len > 1) {
                  output[_out++] = from_source[from++];
                }
              }
            }
            else {
              from = _out - dist;          /* copy direct from output */
              do {                        /* minimum length is three */
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                output[_out++] = output[from++];
                len -= 3;
              } while (len > 2);
              if (len) {
                output[_out++] = output[from++];
                if (len > 1) {
                  output[_out++] = output[from++];
                }
              }
            }
          }
          else if ((op & 64) === 0) {          /* 2nd level distance code */
            here = dcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
            continue dodist;
          }
          else {
            strm.msg = 'invalid distance code';
            state.mode = BAD$1;
            break top;
          }

          break; // need to emulate goto via "continue"
        }
      }
      else if ((op & 64) === 0) {              /* 2nd level length code */
        here = lcode[(here & 0xffff)/*here.val*/ + (hold & ((1 << op) - 1))];
        continue dolen;
      }
      else if (op & 32) {                     /* end-of-block */
        //Tracevv((stderr, "inflate:         end of block\n"));
        state.mode = TYPE$1;
        break top;
      }
      else {
        strm.msg = 'invalid literal/length code';
        state.mode = BAD$1;
        break top;
      }

      break; // need to emulate goto via "continue"
    }
  } while (_in < last && _out < end);

  /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
  len = bits >> 3;
  _in -= len;
  bits -= len << 3;
  hold &= (1 << bits) - 1;

  /* update state and return */
  strm.next_in = _in;
  strm.next_out = _out;
  strm.avail_in = (_in < last ? 5 + (last - _in) : 5 - (_in - last));
  strm.avail_out = (_out < end ? 257 + (end - _out) : 257 - (_out - end));
  state.hold = hold;
  state.bits = bits;
  return;
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

const MAXBITS = 15;
const ENOUGH_LENS$1 = 852;
const ENOUGH_DISTS$1 = 592;
//const ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

const CODES$1 = 0;
const LENS$1 = 1;
const DISTS$1 = 2;

const lbase = new Uint16Array([ /* Length codes 257..285 base */
  3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31,
  35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0
]);

const lext = new Uint8Array([ /* Length codes 257..285 extra */
  16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18,
  19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78
]);

const dbase = new Uint16Array([ /* Distance codes 0..29 base */
  1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193,
  257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145,
  8193, 12289, 16385, 24577, 0, 0
]);

const dext = new Uint8Array([ /* Distance codes 0..29 extra */
  16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22,
  23, 23, 24, 24, 25, 25, 26, 26, 27, 27,
  28, 28, 29, 29, 64, 64
]);

const inflate_table = (type, lens, lens_index, codes, table, table_index, work, opts) =>
{
  const bits = opts.bits;
      //here = opts.here; /* table entry for duplication */

  let len = 0;               /* a code's length in bits */
  let sym = 0;               /* index of code symbols */
  let min = 0, max = 0;          /* minimum and maximum code lengths */
  let root = 0;              /* number of index bits for root table */
  let curr = 0;              /* number of index bits for current table */
  let drop = 0;              /* code bits to drop for sub-table */
  let left = 0;                   /* number of prefix codes available */
  let used = 0;              /* code entries in table used */
  let huff = 0;              /* Huffman code */
  let incr;              /* for incrementing code, index */
  let fill;              /* index for replicating entries */
  let low;               /* low bits for current root entry */
  let mask;              /* mask for low root bits */
  let next;             /* next available space in table */
  let base = null;     /* base value table to use */
//  let shoextra;    /* extra bits table to use */
  let match;                  /* use base and extra for symbol >= match */
  const count = new Uint16Array(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
  const offs = new Uint16Array(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
  let extra = null;

  let here_bits, here_op, here_val;

  /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */

  /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
  for (len = 0; len <= MAXBITS; len++) {
    count[len] = 0;
  }
  for (sym = 0; sym < codes; sym++) {
    count[lens[lens_index + sym]]++;
  }

  /* bound code lengths, force root to be within code lengths */
  root = bits;
  for (max = MAXBITS; max >= 1; max--) {
    if (count[max] !== 0) { break; }
  }
  if (root > max) {
    root = max;
  }
  if (max === 0) {                     /* no symbols to code at all */
    //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
    //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
    //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;


    //table.op[opts.table_index] = 64;
    //table.bits[opts.table_index] = 1;
    //table.val[opts.table_index++] = 0;
    table[table_index++] = (1 << 24) | (64 << 16) | 0;

    opts.bits = 1;
    return 0;     /* no symbols, but wait for decoding to report error */
  }
  for (min = 1; min < max; min++) {
    if (count[min] !== 0) { break; }
  }
  if (root < min) {
    root = min;
  }

  /* check for an over-subscribed or incomplete set of lengths */
  left = 1;
  for (len = 1; len <= MAXBITS; len++) {
    left <<= 1;
    left -= count[len];
    if (left < 0) {
      return -1;
    }        /* over-subscribed */
  }
  if (left > 0 && (type === CODES$1 || max !== 1)) {
    return -1;                      /* incomplete set */
  }

  /* generate offsets into symbol table for each length for sorting */
  offs[1] = 0;
  for (len = 1; len < MAXBITS; len++) {
    offs[len + 1] = offs[len] + count[len];
  }

  /* sort symbols by length, by symbol order within each length */
  for (sym = 0; sym < codes; sym++) {
    if (lens[lens_index + sym] !== 0) {
      work[offs[lens[lens_index + sym]]++] = sym;
    }
  }

  /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */

  /* set up for code type */
  // poor man optimization - use if-else instead of switch,
  // to avoid deopts in old v8
  if (type === CODES$1) {
    base = extra = work;    /* dummy value--not used */
    match = 20;

  } else if (type === LENS$1) {
    base = lbase;
    extra = lext;
    match = 257;

  } else {                    /* DISTS */
    base = dbase;
    extra = dext;
    match = 0;
  }

  /* initialize opts for loop */
  huff = 0;                   /* starting code */
  sym = 0;                    /* starting code symbol */
  len = min;                  /* starting code length */
  next = table_index;              /* current table to fill in */
  curr = root;                /* current table index bits */
  drop = 0;                   /* current bits to drop from code for index */
  low = -1;                   /* trigger new sub-table when len > root */
  used = 1 << root;          /* use root table entries */
  mask = used - 1;            /* mask for comparing low */

  /* check available table space */
  if ((type === LENS$1 && used > ENOUGH_LENS$1) ||
    (type === DISTS$1 && used > ENOUGH_DISTS$1)) {
    return 1;
  }

  /* process all codes and make table entries */
  for (;;) {
    /* create table entry */
    here_bits = len - drop;
    if (work[sym] + 1 < match) {
      here_op = 0;
      here_val = work[sym];
    }
    else if (work[sym] >= match) {
      here_op = extra[work[sym] - match];
      here_val = base[work[sym] - match];
    }
    else {
      here_op = 32 + 64;         /* end of block */
      here_val = 0;
    }

    /* replicate for those indices with low len bits equal to huff */
    incr = 1 << (len - drop);
    fill = 1 << curr;
    min = fill;                 /* save offset to next table */
    do {
      fill -= incr;
      table[next + (huff >> drop) + fill] = (here_bits << 24) | (here_op << 16) | here_val |0;
    } while (fill !== 0);

    /* backwards increment the len-bit code huff */
    incr = 1 << (len - 1);
    while (huff & incr) {
      incr >>= 1;
    }
    if (incr !== 0) {
      huff &= incr - 1;
      huff += incr;
    } else {
      huff = 0;
    }

    /* go to next symbol, update count, len */
    sym++;
    if (--count[len] === 0) {
      if (len === max) { break; }
      len = lens[lens_index + work[sym]];
    }

    /* create new sub-table if needed */
    if (len > root && (huff & mask) !== low) {
      /* if first time, transition to sub-tables */
      if (drop === 0) {
        drop = root;
      }

      /* increment past last table */
      next += min;            /* here min is 1 << curr */

      /* determine length of next table */
      curr = len - drop;
      left = 1 << curr;
      while (curr + drop < max) {
        left -= count[curr + drop];
        if (left <= 0) { break; }
        curr++;
        left <<= 1;
      }

      /* check for enough space */
      used += 1 << curr;
      if ((type === LENS$1 && used > ENOUGH_LENS$1) ||
        (type === DISTS$1 && used > ENOUGH_DISTS$1)) {
        return 1;
      }

      /* point entry in root table to sub-table */
      low = huff & mask;
      /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/
      table[low] = (root << 24) | (curr << 16) | (next - table_index) |0;
    }
  }

  /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */
  if (huff !== 0) {
    //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = ((len - drop) << 24) | (64 << 16) |0;
  }

  /* set return parameters */
  //opts.table_index += used;
  opts.bits = root;
  return 0;
};


var inftrees = inflate_table;

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.






const CODES = 0;
const LENS = 1;
const DISTS = 2;

/* Public constants ==========================================================*/
/* ===========================================================================*/

const {
  Z_FINISH: Z_FINISH$1, Z_BLOCK, Z_TREES,
  Z_OK: Z_OK$1, Z_STREAM_END: Z_STREAM_END$1, Z_NEED_DICT: Z_NEED_DICT$1, Z_STREAM_ERROR: Z_STREAM_ERROR$1, Z_DATA_ERROR: Z_DATA_ERROR$1, Z_MEM_ERROR: Z_MEM_ERROR$1, Z_BUF_ERROR,
  Z_DEFLATED
} = constants$2;


/* STATES ====================================================================*/
/* ===========================================================================*/


const    HEAD = 16180;       /* i: waiting for magic header */
const    FLAGS = 16181;      /* i: waiting for method and flags (gzip) */
const    TIME = 16182;       /* i: waiting for modification time (gzip) */
const    OS = 16183;         /* i: waiting for extra flags and operating system (gzip) */
const    EXLEN = 16184;      /* i: waiting for extra length (gzip) */
const    EXTRA = 16185;      /* i: waiting for extra bytes (gzip) */
const    NAME = 16186;       /* i: waiting for end of file name (gzip) */
const    COMMENT = 16187;    /* i: waiting for end of comment (gzip) */
const    HCRC = 16188;       /* i: waiting for header crc (gzip) */
const    DICTID = 16189;    /* i: waiting for dictionary check value */
const    DICT = 16190;      /* waiting for inflateSetDictionary() call */
const        TYPE = 16191;      /* i: waiting for type bits, including last-flag bit */
const        TYPEDO = 16192;    /* i: same, but skip check to exit inflate on new block */
const        STORED = 16193;    /* i: waiting for stored size (length and complement) */
const        COPY_ = 16194;     /* i/o: same as COPY below, but only first time in */
const        COPY = 16195;      /* i/o: waiting for input or output to copy stored block */
const        TABLE = 16196;     /* i: waiting for dynamic block table lengths */
const        LENLENS = 16197;   /* i: waiting for code length code lengths */
const        CODELENS = 16198;  /* i: waiting for length/lit and distance code lengths */
const            LEN_ = 16199;      /* i: same as LEN below, but only first time in */
const            LEN = 16200;       /* i: waiting for length/lit/eob code */
const            LENEXT = 16201;    /* i: waiting for length extra bits */
const            DIST = 16202;      /* i: waiting for distance code */
const            DISTEXT = 16203;   /* i: waiting for distance extra bits */
const            MATCH = 16204;     /* o: waiting for output space to copy string */
const            LIT = 16205;       /* o: waiting for output space to write literal */
const    CHECK = 16206;     /* i: waiting for 32-bit check value */
const    LENGTH = 16207;    /* i: waiting for 32-bit length (gzip) */
const    DONE = 16208;      /* finished check, done -- remain here until reset */
const    BAD = 16209;       /* got a data error -- remain here until reset */
const    MEM = 16210;       /* got an inflate() memory error -- remain here until reset */
const    SYNC = 16211;      /* looking for synchronization bytes to restart inflate() */

/* ===========================================================================*/



const ENOUGH_LENS = 852;
const ENOUGH_DISTS = 592;
//const ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

const MAX_WBITS = 15;
/* 32K LZ77 window */
const DEF_WBITS = MAX_WBITS;


const zswap32 = (q) => {

  return  (((q >>> 24) & 0xff) +
          ((q >>> 8) & 0xff00) +
          ((q & 0xff00) << 8) +
          ((q & 0xff) << 24));
};


function InflateState() {
  this.strm = null;           /* pointer back to this zlib stream */
  this.mode = 0;              /* current inflate mode */
  this.last = false;          /* true if processing last block */
  this.wrap = 0;              /* bit 0 true for zlib, bit 1 true for gzip,
                                 bit 2 true to validate check value */
  this.havedict = false;      /* true if dictionary provided */
  this.flags = 0;             /* gzip header method and flags (0 if zlib), or
                                 -1 if raw or no header yet */
  this.dmax = 0;              /* zlib header max distance (INFLATE_STRICT) */
  this.check = 0;             /* protected copy of check value */
  this.total = 0;             /* protected copy of output count */
  // TODO: may be {}
  this.head = null;           /* where to save gzip header information */

  /* sliding window */
  this.wbits = 0;             /* log base 2 of requested window size */
  this.wsize = 0;             /* window size or zero if not using window */
  this.whave = 0;             /* valid bytes in the window */
  this.wnext = 0;             /* window write index */
  this.window = null;         /* allocated sliding window, if needed */

  /* bit accumulator */
  this.hold = 0;              /* input bit accumulator */
  this.bits = 0;              /* number of bits in "in" */

  /* for string and stored block copying */
  this.length = 0;            /* literal or length of data to copy */
  this.offset = 0;            /* distance back to copy string from */

  /* for table and code decoding */
  this.extra = 0;             /* extra bits needed */

  /* fixed and dynamic code tables */
  this.lencode = null;          /* starting table for length/literal codes */
  this.distcode = null;         /* starting table for distance codes */
  this.lenbits = 0;           /* index bits for lencode */
  this.distbits = 0;          /* index bits for distcode */

  /* dynamic table building */
  this.ncode = 0;             /* number of code length code lengths */
  this.nlen = 0;              /* number of length code lengths */
  this.ndist = 0;             /* number of distance code lengths */
  this.have = 0;              /* number of code lengths in lens[] */
  this.next = null;              /* next available space in codes[] */

  this.lens = new Uint16Array(320); /* temporary storage for code lengths */
  this.work = new Uint16Array(288); /* work area for code table building */

  /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */
  //this.codes = new Int32Array(ENOUGH);       /* space for code tables */
  this.lendyn = null;              /* dynamic table for length/literal codes (JS specific) */
  this.distdyn = null;             /* dynamic table for distance codes (JS specific) */
  this.sane = 0;                   /* if false, allow invalid distance too far */
  this.back = 0;                   /* bits back of last unprocessed length/lit */
  this.was = 0;                    /* initial length of match */
}


const inflateStateCheck = (strm) => {

  if (!strm) {
    return 1;
  }
  const state = strm.state;
  if (!state || state.strm !== strm ||
    state.mode < HEAD || state.mode > SYNC) {
    return 1;
  }
  return 0;
};


const inflateResetKeep = (strm) => {

  if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1; }
  const state = strm.state;
  strm.total_in = strm.total_out = state.total = 0;
  strm.msg = ''; /*Z_NULL*/
  if (state.wrap) {       /* to support ill-conceived Java test suite */
    strm.adler = state.wrap & 1;
  }
  state.mode = HEAD;
  state.last = 0;
  state.havedict = 0;
  state.flags = -1;
  state.dmax = 32768;
  state.head = null/*Z_NULL*/;
  state.hold = 0;
  state.bits = 0;
  //state.lencode = state.distcode = state.next = state.codes;
  state.lencode = state.lendyn = new Int32Array(ENOUGH_LENS);
  state.distcode = state.distdyn = new Int32Array(ENOUGH_DISTS);

  state.sane = 1;
  state.back = -1;
  //Tracev((stderr, "inflate: reset\n"));
  return Z_OK$1;
};


const inflateReset = (strm) => {

  if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1; }
  const state = strm.state;
  state.wsize = 0;
  state.whave = 0;
  state.wnext = 0;
  return inflateResetKeep(strm);

};


const inflateReset2 = (strm, windowBits) => {
  let wrap;

  /* get the state */
  if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1; }
  const state = strm.state;

  /* extract wrap request from windowBits parameter */
  if (windowBits < 0) {
    wrap = 0;
    windowBits = -windowBits;
  }
  else {
    wrap = (windowBits >> 4) + 5;
    if (windowBits < 48) {
      windowBits &= 15;
    }
  }

  /* set number of window bits, free window if different */
  if (windowBits && (windowBits < 8 || windowBits > 15)) {
    return Z_STREAM_ERROR$1;
  }
  if (state.window !== null && state.wbits !== windowBits) {
    state.window = null;
  }

  /* update state and reset the rest of it */
  state.wrap = wrap;
  state.wbits = windowBits;
  return inflateReset(strm);
};


const inflateInit2 = (strm, windowBits) => {

  if (!strm) { return Z_STREAM_ERROR$1; }
  //strm.msg = Z_NULL;                 /* in case we return an error */

  const state = new InflateState();

  //if (state === Z_NULL) return Z_MEM_ERROR;
  //Tracev((stderr, "inflate: allocated\n"));
  strm.state = state;
  state.strm = strm;
  state.window = null/*Z_NULL*/;
  state.mode = HEAD;     /* to pass state test in inflateReset2() */
  const ret = inflateReset2(strm, windowBits);
  if (ret !== Z_OK$1) {
    strm.state = null/*Z_NULL*/;
  }
  return ret;
};


const inflateInit = (strm) => {

  return inflateInit2(strm, DEF_WBITS);
};


/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */
let virgin = true;

let lenfix, distfix; // We have no pointers in JS, so keep tables separate


const fixedtables = (state) => {

  /* build fixed huffman tables if first call (may not be thread safe) */
  if (virgin) {
    lenfix = new Int32Array(512);
    distfix = new Int32Array(32);

    /* literal/length table */
    let sym = 0;
    while (sym < 144) { state.lens[sym++] = 8; }
    while (sym < 256) { state.lens[sym++] = 9; }
    while (sym < 280) { state.lens[sym++] = 7; }
    while (sym < 288) { state.lens[sym++] = 8; }

    inftrees(LENS,  state.lens, 0, 288, lenfix,   0, state.work, { bits: 9 });

    /* distance table */
    sym = 0;
    while (sym < 32) { state.lens[sym++] = 5; }

    inftrees(DISTS, state.lens, 0, 32,   distfix, 0, state.work, { bits: 5 });

    /* do this just once */
    virgin = false;
  }

  state.lencode = lenfix;
  state.lenbits = 9;
  state.distcode = distfix;
  state.distbits = 5;
};


/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */
const updatewindow = (strm, src, end, copy) => {

  let dist;
  const state = strm.state;

  /* if it hasn't been done already, allocate space for the window */
  if (state.window === null) {
    state.wsize = 1 << state.wbits;
    state.wnext = 0;
    state.whave = 0;

    state.window = new Uint8Array(state.wsize);
  }

  /* copy state->wsize or less output bytes into the circular window */
  if (copy >= state.wsize) {
    state.window.set(src.subarray(end - state.wsize, end), 0);
    state.wnext = 0;
    state.whave = state.wsize;
  }
  else {
    dist = state.wsize - state.wnext;
    if (dist > copy) {
      dist = copy;
    }
    //zmemcpy(state->window + state->wnext, end - copy, dist);
    state.window.set(src.subarray(end - copy, end - copy + dist), state.wnext);
    copy -= dist;
    if (copy) {
      //zmemcpy(state->window, end - copy, copy);
      state.window.set(src.subarray(end - copy, end), 0);
      state.wnext = copy;
      state.whave = state.wsize;
    }
    else {
      state.wnext += dist;
      if (state.wnext === state.wsize) { state.wnext = 0; }
      if (state.whave < state.wsize) { state.whave += dist; }
    }
  }
  return 0;
};


const inflate$2 = (strm, flush) => {

  let state;
  let input, output;          // input/output buffers
  let next;                   /* next input INDEX */
  let put;                    /* next output INDEX */
  let have, left;             /* available input and output */
  let hold;                   /* bit buffer */
  let bits;                   /* bits in bit buffer */
  let _in, _out;              /* save starting available input and output */
  let copy;                   /* number of stored or match bytes to copy */
  let from;                   /* where to copy match bytes from */
  let from_source;
  let here = 0;               /* current decoding table entry */
  let here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
  //let last;                   /* parent table entry */
  let last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
  let len;                    /* length to copy for repeats, bits to drop */
  let ret;                    /* return code */
  const hbuf = new Uint8Array(4);    /* buffer for gzip header crc calculation */
  let opts;

  let n; // temporary variable for NEED_BITS

  const order = /* permutation of code lengths */
    new Uint8Array([ 16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15 ]);


  if (inflateStateCheck(strm) || !strm.output ||
      (!strm.input && strm.avail_in !== 0)) {
    return Z_STREAM_ERROR$1;
  }

  state = strm.state;
  if (state.mode === TYPE) { state.mode = TYPEDO; }    /* skip check */


  //--- LOAD() ---
  put = strm.next_out;
  output = strm.output;
  left = strm.avail_out;
  next = strm.next_in;
  input = strm.input;
  have = strm.avail_in;
  hold = state.hold;
  bits = state.bits;
  //---

  _in = have;
  _out = left;
  ret = Z_OK$1;

  inf_leave: // goto emulation
  for (;;) {
    switch (state.mode) {
      case HEAD:
        if (state.wrap === 0) {
          state.mode = TYPEDO;
          break;
        }
        //=== NEEDBITS(16);
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((state.wrap & 2) && hold === 0x8b1f) {  /* gzip header */
          if (state.wbits === 0) {
            state.wbits = 15;
          }
          state.check = 0/*crc32(0L, Z_NULL, 0)*/;
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32_1(state.check, hbuf, 2, 0);
          //===//

          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          state.mode = FLAGS;
          break;
        }
        if (state.head) {
          state.head.done = false;
        }
        if (!(state.wrap & 1) ||   /* check if zlib header allowed */
          (((hold & 0xff)/*BITS(8)*/ << 8) + (hold >> 8)) % 31) {
          strm.msg = 'incorrect header check';
          state.mode = BAD;
          break;
        }
        if ((hold & 0x0f)/*BITS(4)*/ !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
        len = (hold & 0x0f)/*BITS(4)*/ + 8;
        if (state.wbits === 0) {
          state.wbits = len;
        }
        if (len > 15 || len > state.wbits) {
          strm.msg = 'invalid window size';
          state.mode = BAD;
          break;
        }

        // !!! pako patch. Force use `options.windowBits` if passed.
        // Required to always use max window size by default.
        state.dmax = 1 << state.wbits;
        //state.dmax = 1 << len;

        state.flags = 0;               /* indicate zlib header */
        //Tracev((stderr, "inflate:   zlib header ok\n"));
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = hold & 0x200 ? DICTID : TYPE;
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        break;
      case FLAGS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.flags = hold;
        if ((state.flags & 0xff) !== Z_DEFLATED) {
          strm.msg = 'unknown compression method';
          state.mode = BAD;
          break;
        }
        if (state.flags & 0xe000) {
          strm.msg = 'unknown header flags set';
          state.mode = BAD;
          break;
        }
        if (state.head) {
          state.head.text = ((hold >> 8) & 1);
        }
        if ((state.flags & 0x0200) && (state.wrap & 4)) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32_1(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = TIME;
        /* falls through */
      case TIME:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.time = hold;
        }
        if ((state.flags & 0x0200) && (state.wrap & 4)) {
          //=== CRC4(state.check, hold)
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          hbuf[2] = (hold >>> 16) & 0xff;
          hbuf[3] = (hold >>> 24) & 0xff;
          state.check = crc32_1(state.check, hbuf, 4, 0);
          //===
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = OS;
        /* falls through */
      case OS:
        //=== NEEDBITS(16); */
        while (bits < 16) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if (state.head) {
          state.head.xflags = (hold & 0xff);
          state.head.os = (hold >> 8);
        }
        if ((state.flags & 0x0200) && (state.wrap & 4)) {
          //=== CRC2(state.check, hold);
          hbuf[0] = hold & 0xff;
          hbuf[1] = (hold >>> 8) & 0xff;
          state.check = crc32_1(state.check, hbuf, 2, 0);
          //===//
        }
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = EXLEN;
        /* falls through */
      case EXLEN:
        if (state.flags & 0x0400) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length = hold;
          if (state.head) {
            state.head.extra_len = hold;
          }
          if ((state.flags & 0x0200) && (state.wrap & 4)) {
            //=== CRC2(state.check, hold);
            hbuf[0] = hold & 0xff;
            hbuf[1] = (hold >>> 8) & 0xff;
            state.check = crc32_1(state.check, hbuf, 2, 0);
            //===//
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        else if (state.head) {
          state.head.extra = null/*Z_NULL*/;
        }
        state.mode = EXTRA;
        /* falls through */
      case EXTRA:
        if (state.flags & 0x0400) {
          copy = state.length;
          if (copy > have) { copy = have; }
          if (copy) {
            if (state.head) {
              len = state.head.extra_len - state.length;
              if (!state.head.extra) {
                // Use untyped array for more convenient processing later
                state.head.extra = new Uint8Array(state.head.extra_len);
              }
              state.head.extra.set(
                input.subarray(
                  next,
                  // extra field is limited to 65536 bytes
                  // - no need for additional size check
                  next + copy
                ),
                /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                len
              );
              //zmemcpy(state.head.extra + len, next,
              //        len + copy > state.head.extra_max ?
              //        state.head.extra_max - len : copy);
            }
            if ((state.flags & 0x0200) && (state.wrap & 4)) {
              state.check = crc32_1(state.check, input, copy, next);
            }
            have -= copy;
            next += copy;
            state.length -= copy;
          }
          if (state.length) { break inf_leave; }
        }
        state.length = 0;
        state.mode = NAME;
        /* falls through */
      case NAME:
        if (state.flags & 0x0800) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            // TODO: 2 or 1 bytes?
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.name_max*/)) {
              state.head.name += String.fromCharCode(len);
            }
          } while (len && copy < have);

          if ((state.flags & 0x0200) && (state.wrap & 4)) {
            state.check = crc32_1(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.name = null;
        }
        state.length = 0;
        state.mode = COMMENT;
        /* falls through */
      case COMMENT:
        if (state.flags & 0x1000) {
          if (have === 0) { break inf_leave; }
          copy = 0;
          do {
            len = input[next + copy++];
            /* use constant limit because in js we should not preallocate memory */
            if (state.head && len &&
                (state.length < 65536 /*state.head.comm_max*/)) {
              state.head.comment += String.fromCharCode(len);
            }
          } while (len && copy < have);
          if ((state.flags & 0x0200) && (state.wrap & 4)) {
            state.check = crc32_1(state.check, input, copy, next);
          }
          have -= copy;
          next += copy;
          if (len) { break inf_leave; }
        }
        else if (state.head) {
          state.head.comment = null;
        }
        state.mode = HCRC;
        /* falls through */
      case HCRC:
        if (state.flags & 0x0200) {
          //=== NEEDBITS(16); */
          while (bits < 16) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if ((state.wrap & 4) && hold !== (state.check & 0xffff)) {
            strm.msg = 'header crc mismatch';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
        }
        if (state.head) {
          state.head.hcrc = ((state.flags >> 9) & 1);
          state.head.done = true;
        }
        strm.adler = state.check = 0;
        state.mode = TYPE;
        break;
      case DICTID:
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        strm.adler = state.check = zswap32(hold);
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = DICT;
        /* falls through */
      case DICT:
        if (state.havedict === 0) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          return Z_NEED_DICT$1;
        }
        strm.adler = state.check = 1/*adler32(0L, Z_NULL, 0)*/;
        state.mode = TYPE;
        /* falls through */
      case TYPE:
        if (flush === Z_BLOCK || flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case TYPEDO:
        if (state.last) {
          //--- BYTEBITS() ---//
          hold >>>= bits & 7;
          bits -= bits & 7;
          //---//
          state.mode = CHECK;
          break;
        }
        //=== NEEDBITS(3); */
        while (bits < 3) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.last = (hold & 0x01)/*BITS(1)*/;
        //--- DROPBITS(1) ---//
        hold >>>= 1;
        bits -= 1;
        //---//

        switch ((hold & 0x03)/*BITS(2)*/) {
          case 0:                             /* stored block */
            //Tracev((stderr, "inflate:     stored block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = STORED;
            break;
          case 1:                             /* fixed block */
            fixedtables(state);
            //Tracev((stderr, "inflate:     fixed codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = LEN_;             /* decode codes */
            if (flush === Z_TREES) {
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
              break inf_leave;
            }
            break;
          case 2:                             /* dynamic block */
            //Tracev((stderr, "inflate:     dynamic codes block%s\n",
            //        state.last ? " (last)" : ""));
            state.mode = TABLE;
            break;
          case 3:
            strm.msg = 'invalid block type';
            state.mode = BAD;
        }
        //--- DROPBITS(2) ---//
        hold >>>= 2;
        bits -= 2;
        //---//
        break;
      case STORED:
        //--- BYTEBITS() ---// /* go to byte boundary */
        hold >>>= bits & 7;
        bits -= bits & 7;
        //---//
        //=== NEEDBITS(32); */
        while (bits < 32) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        if ((hold & 0xffff) !== ((hold >>> 16) ^ 0xffff)) {
          strm.msg = 'invalid stored block lengths';
          state.mode = BAD;
          break;
        }
        state.length = hold & 0xffff;
        //Tracev((stderr, "inflate:       stored length %u\n",
        //        state.length));
        //=== INITBITS();
        hold = 0;
        bits = 0;
        //===//
        state.mode = COPY_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case COPY_:
        state.mode = COPY;
        /* falls through */
      case COPY:
        copy = state.length;
        if (copy) {
          if (copy > have) { copy = have; }
          if (copy > left) { copy = left; }
          if (copy === 0) { break inf_leave; }
          //--- zmemcpy(put, next, copy); ---
          output.set(input.subarray(next, next + copy), put);
          //---//
          have -= copy;
          next += copy;
          left -= copy;
          put += copy;
          state.length -= copy;
          break;
        }
        //Tracev((stderr, "inflate:       stored end\n"));
        state.mode = TYPE;
        break;
      case TABLE:
        //=== NEEDBITS(14); */
        while (bits < 14) {
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
        }
        //===//
        state.nlen = (hold & 0x1f)/*BITS(5)*/ + 257;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ndist = (hold & 0x1f)/*BITS(5)*/ + 1;
        //--- DROPBITS(5) ---//
        hold >>>= 5;
        bits -= 5;
        //---//
        state.ncode = (hold & 0x0f)/*BITS(4)*/ + 4;
        //--- DROPBITS(4) ---//
        hold >>>= 4;
        bits -= 4;
        //---//
//#ifndef PKZIP_BUG_WORKAROUND
        if (state.nlen > 286 || state.ndist > 30) {
          strm.msg = 'too many length or distance symbols';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracev((stderr, "inflate:       table sizes ok\n"));
        state.have = 0;
        state.mode = LENLENS;
        /* falls through */
      case LENLENS:
        while (state.have < state.ncode) {
          //=== NEEDBITS(3);
          while (bits < 3) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.lens[order[state.have++]] = (hold & 0x07);//BITS(3);
          //--- DROPBITS(3) ---//
          hold >>>= 3;
          bits -= 3;
          //---//
        }
        while (state.have < 19) {
          state.lens[order[state.have++]] = 0;
        }
        // We have separate tables & no pointers. 2 commented lines below not needed.
        //state.next = state.codes;
        //state.lencode = state.next;
        // Switch to use dynamic table
        state.lencode = state.lendyn;
        state.lenbits = 7;

        opts = { bits: state.lenbits };
        ret = inftrees(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
        state.lenbits = opts.bits;

        if (ret) {
          strm.msg = 'invalid code lengths set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, "inflate:       code lengths ok\n"));
        state.have = 0;
        state.mode = CODELENS;
        /* falls through */
      case CODELENS:
        while (state.have < state.nlen + state.ndist) {
          for (;;) {
            here = state.lencode[hold & ((1 << state.lenbits) - 1)];/*BITS(state.lenbits)*/
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          if (here_val < 16) {
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.lens[state.have++] = here_val;
          }
          else {
            if (here_val === 16) {
              //=== NEEDBITS(here.bits + 2);
              n = here_bits + 2;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              if (state.have === 0) {
                strm.msg = 'invalid bit length repeat';
                state.mode = BAD;
                break;
              }
              len = state.lens[state.have - 1];
              copy = 3 + (hold & 0x03);//BITS(2);
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
            }
            else if (here_val === 17) {
              //=== NEEDBITS(here.bits + 3);
              n = here_bits + 3;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 3 + (hold & 0x07);//BITS(3);
              //--- DROPBITS(3) ---//
              hold >>>= 3;
              bits -= 3;
              //---//
            }
            else {
              //=== NEEDBITS(here.bits + 7);
              n = here_bits + 7;
              while (bits < n) {
                if (have === 0) { break inf_leave; }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              len = 0;
              copy = 11 + (hold & 0x7f);//BITS(7);
              //--- DROPBITS(7) ---//
              hold >>>= 7;
              bits -= 7;
              //---//
            }
            if (state.have + copy > state.nlen + state.ndist) {
              strm.msg = 'invalid bit length repeat';
              state.mode = BAD;
              break;
            }
            while (copy--) {
              state.lens[state.have++] = len;
            }
          }
        }

        /* handle error breaks in while */
        if (state.mode === BAD) { break; }

        /* check for end-of-block code (better have one) */
        if (state.lens[256] === 0) {
          strm.msg = 'invalid code -- missing end-of-block';
          state.mode = BAD;
          break;
        }

        /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */
        state.lenbits = 9;

        opts = { bits: state.lenbits };
        ret = inftrees(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.lenbits = opts.bits;
        // state.lencode = state.next;

        if (ret) {
          strm.msg = 'invalid literal/lengths set';
          state.mode = BAD;
          break;
        }

        state.distbits = 6;
        //state.distcode.copy(state.codes);
        // Switch to use dynamic table
        state.distcode = state.distdyn;
        opts = { bits: state.distbits };
        ret = inftrees(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
        // We have separate tables & no pointers. 2 commented lines below not needed.
        // state.next_index = opts.table_index;
        state.distbits = opts.bits;
        // state.distcode = state.next;

        if (ret) {
          strm.msg = 'invalid distances set';
          state.mode = BAD;
          break;
        }
        //Tracev((stderr, 'inflate:       codes ok\n'));
        state.mode = LEN_;
        if (flush === Z_TREES) { break inf_leave; }
        /* falls through */
      case LEN_:
        state.mode = LEN;
        /* falls through */
      case LEN:
        if (have >= 6 && left >= 258) {
          //--- RESTORE() ---
          strm.next_out = put;
          strm.avail_out = left;
          strm.next_in = next;
          strm.avail_in = have;
          state.hold = hold;
          state.bits = bits;
          //---
          inffast(strm, _out);
          //--- LOAD() ---
          put = strm.next_out;
          output = strm.output;
          left = strm.avail_out;
          next = strm.next_in;
          input = strm.input;
          have = strm.avail_in;
          hold = state.hold;
          bits = state.bits;
          //---

          if (state.mode === TYPE) {
            state.back = -1;
          }
          break;
        }
        state.back = 0;
        for (;;) {
          here = state.lencode[hold & ((1 << state.lenbits) - 1)];  /*BITS(state.lenbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if (here_bits <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if (here_op && (here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.lencode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        state.length = here_val;
        if (here_op === 0) {
          //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
          //        "inflate:         literal '%c'\n" :
          //        "inflate:         literal 0x%02x\n", here.val));
          state.mode = LIT;
          break;
        }
        if (here_op & 32) {
          //Tracevv((stderr, "inflate:         end of block\n"));
          state.back = -1;
          state.mode = TYPE;
          break;
        }
        if (here_op & 64) {
          strm.msg = 'invalid literal/length code';
          state.mode = BAD;
          break;
        }
        state.extra = here_op & 15;
        state.mode = LENEXT;
        /* falls through */
      case LENEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.length += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
        //Tracevv((stderr, "inflate:         length %u\n", state.length));
        state.was = state.length;
        state.mode = DIST;
        /* falls through */
      case DIST:
        for (;;) {
          here = state.distcode[hold & ((1 << state.distbits) - 1)];/*BITS(state.distbits)*/
          here_bits = here >>> 24;
          here_op = (here >>> 16) & 0xff;
          here_val = here & 0xffff;

          if ((here_bits) <= bits) { break; }
          //--- PULLBYTE() ---//
          if (have === 0) { break inf_leave; }
          have--;
          hold += input[next++] << bits;
          bits += 8;
          //---//
        }
        if ((here_op & 0xf0) === 0) {
          last_bits = here_bits;
          last_op = here_op;
          last_val = here_val;
          for (;;) {
            here = state.distcode[last_val +
                    ((hold & ((1 << (last_bits + last_op)) - 1))/*BITS(last.bits + last.op)*/ >> last_bits)];
            here_bits = here >>> 24;
            here_op = (here >>> 16) & 0xff;
            here_val = here & 0xffff;

            if ((last_bits + here_bits) <= bits) { break; }
            //--- PULLBYTE() ---//
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
            //---//
          }
          //--- DROPBITS(last.bits) ---//
          hold >>>= last_bits;
          bits -= last_bits;
          //---//
          state.back += last_bits;
        }
        //--- DROPBITS(here.bits) ---//
        hold >>>= here_bits;
        bits -= here_bits;
        //---//
        state.back += here_bits;
        if (here_op & 64) {
          strm.msg = 'invalid distance code';
          state.mode = BAD;
          break;
        }
        state.offset = here_val;
        state.extra = (here_op) & 15;
        state.mode = DISTEXT;
        /* falls through */
      case DISTEXT:
        if (state.extra) {
          //=== NEEDBITS(state.extra);
          n = state.extra;
          while (bits < n) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          state.offset += hold & ((1 << state.extra) - 1)/*BITS(state.extra)*/;
          //--- DROPBITS(state.extra) ---//
          hold >>>= state.extra;
          bits -= state.extra;
          //---//
          state.back += state.extra;
        }
//#ifdef INFLATE_STRICT
        if (state.offset > state.dmax) {
          strm.msg = 'invalid distance too far back';
          state.mode = BAD;
          break;
        }
//#endif
        //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
        state.mode = MATCH;
        /* falls through */
      case MATCH:
        if (left === 0) { break inf_leave; }
        copy = _out - left;
        if (state.offset > copy) {         /* copy from window */
          copy = state.offset - copy;
          if (copy > state.whave) {
            if (state.sane) {
              strm.msg = 'invalid distance too far back';
              state.mode = BAD;
              break;
            }
// (!) This block is disabled in zlib defaults,
// don't enable it for binary compatibility
//#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
//          Trace((stderr, "inflate.c too far\n"));
//          copy -= state.whave;
//          if (copy > state.length) { copy = state.length; }
//          if (copy > left) { copy = left; }
//          left -= copy;
//          state.length -= copy;
//          do {
//            output[put++] = 0;
//          } while (--copy);
//          if (state.length === 0) { state.mode = LEN; }
//          break;
//#endif
          }
          if (copy > state.wnext) {
            copy -= state.wnext;
            from = state.wsize - copy;
          }
          else {
            from = state.wnext - copy;
          }
          if (copy > state.length) { copy = state.length; }
          from_source = state.window;
        }
        else {                              /* copy from output */
          from_source = output;
          from = put - state.offset;
          copy = state.length;
        }
        if (copy > left) { copy = left; }
        left -= copy;
        state.length -= copy;
        do {
          output[put++] = from_source[from++];
        } while (--copy);
        if (state.length === 0) { state.mode = LEN; }
        break;
      case LIT:
        if (left === 0) { break inf_leave; }
        output[put++] = state.length;
        left--;
        state.mode = LEN;
        break;
      case CHECK:
        if (state.wrap) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            // Use '|' instead of '+' to make sure that result is signed
            hold |= input[next++] << bits;
            bits += 8;
          }
          //===//
          _out -= left;
          strm.total_out += _out;
          state.total += _out;
          if ((state.wrap & 4) && _out) {
            strm.adler = state.check =
                /*UPDATE_CHECK(state.check, put - _out, _out);*/
                (state.flags ? crc32_1(state.check, output, _out, put - _out) : adler32_1(state.check, output, _out, put - _out));

          }
          _out = left;
          // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
          if ((state.wrap & 4) && (state.flags ? hold : zswap32(hold)) !== state.check) {
            strm.msg = 'incorrect data check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   check matches trailer\n"));
        }
        state.mode = LENGTH;
        /* falls through */
      case LENGTH:
        if (state.wrap && state.flags) {
          //=== NEEDBITS(32);
          while (bits < 32) {
            if (have === 0) { break inf_leave; }
            have--;
            hold += input[next++] << bits;
            bits += 8;
          }
          //===//
          if ((state.wrap & 4) && hold !== (state.total & 0xffffffff)) {
            strm.msg = 'incorrect length check';
            state.mode = BAD;
            break;
          }
          //=== INITBITS();
          hold = 0;
          bits = 0;
          //===//
          //Tracev((stderr, "inflate:   length matches trailer\n"));
        }
        state.mode = DONE;
        /* falls through */
      case DONE:
        ret = Z_STREAM_END$1;
        break inf_leave;
      case BAD:
        ret = Z_DATA_ERROR$1;
        break inf_leave;
      case MEM:
        return Z_MEM_ERROR$1;
      case SYNC:
        /* falls through */
      default:
        return Z_STREAM_ERROR$1;
    }
  }

  // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

  /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */

  //--- RESTORE() ---
  strm.next_out = put;
  strm.avail_out = left;
  strm.next_in = next;
  strm.avail_in = have;
  state.hold = hold;
  state.bits = bits;
  //---

  if (state.wsize || (_out !== strm.avail_out && state.mode < BAD &&
                      (state.mode < CHECK || flush !== Z_FINISH$1))) {
    if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) ;
  }
  _in -= strm.avail_in;
  _out -= strm.avail_out;
  strm.total_in += _in;
  strm.total_out += _out;
  state.total += _out;
  if ((state.wrap & 4) && _out) {
    strm.adler = state.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
      (state.flags ? crc32_1(state.check, output, _out, strm.next_out - _out) : adler32_1(state.check, output, _out, strm.next_out - _out));
  }
  strm.data_type = state.bits + (state.last ? 64 : 0) +
                    (state.mode === TYPE ? 128 : 0) +
                    (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
  if (((_in === 0 && _out === 0) || flush === Z_FINISH$1) && ret === Z_OK$1) {
    ret = Z_BUF_ERROR;
  }
  return ret;
};


const inflateEnd = (strm) => {

  if (inflateStateCheck(strm)) {
    return Z_STREAM_ERROR$1;
  }

  let state = strm.state;
  if (state.window) {
    state.window = null;
  }
  strm.state = null;
  return Z_OK$1;
};


const inflateGetHeader = (strm, head) => {

  /* check state */
  if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1; }
  const state = strm.state;
  if ((state.wrap & 2) === 0) { return Z_STREAM_ERROR$1; }

  /* save header structure */
  state.head = head;
  head.done = false;
  return Z_OK$1;
};


const inflateSetDictionary = (strm, dictionary) => {
  const dictLength = dictionary.length;

  let state;
  let dictid;
  let ret;

  /* check state */
  if (inflateStateCheck(strm)) { return Z_STREAM_ERROR$1; }
  state = strm.state;

  if (state.wrap !== 0 && state.mode !== DICT) {
    return Z_STREAM_ERROR$1;
  }

  /* check for correct dictionary identifier */
  if (state.mode === DICT) {
    dictid = 1; /* adler32(0, null, 0)*/
    /* dictid = adler32(dictid, dictionary, dictLength); */
    dictid = adler32_1(dictid, dictionary, dictLength, 0);
    if (dictid !== state.check) {
      return Z_DATA_ERROR$1;
    }
  }
  /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */
  ret = updatewindow(strm, dictionary, dictLength, dictLength);
  if (ret) {
    state.mode = MEM;
    return Z_MEM_ERROR$1;
  }
  state.havedict = 1;
  // Tracev((stderr, "inflate:   dictionary set\n"));
  return Z_OK$1;
};


var inflateReset_1 = inflateReset;
var inflateReset2_1 = inflateReset2;
var inflateResetKeep_1 = inflateResetKeep;
var inflateInit_1 = inflateInit;
var inflateInit2_1 = inflateInit2;
var inflate_2$1 = inflate$2;
var inflateEnd_1 = inflateEnd;
var inflateGetHeader_1 = inflateGetHeader;
var inflateSetDictionary_1 = inflateSetDictionary;
var inflateInfo = 'pako inflate (from Nodeca project)';

/* Not implemented
module.exports.inflateCodesUsed = inflateCodesUsed;
module.exports.inflateCopy = inflateCopy;
module.exports.inflateGetDictionary = inflateGetDictionary;
module.exports.inflateMark = inflateMark;
module.exports.inflatePrime = inflatePrime;
module.exports.inflateSync = inflateSync;
module.exports.inflateSyncPoint = inflateSyncPoint;
module.exports.inflateUndermine = inflateUndermine;
module.exports.inflateValidate = inflateValidate;
*/

var inflate_1$2 = {
	inflateReset: inflateReset_1,
	inflateReset2: inflateReset2_1,
	inflateResetKeep: inflateResetKeep_1,
	inflateInit: inflateInit_1,
	inflateInit2: inflateInit2_1,
	inflate: inflate_2$1,
	inflateEnd: inflateEnd_1,
	inflateGetHeader: inflateGetHeader_1,
	inflateSetDictionary: inflateSetDictionary_1,
	inflateInfo: inflateInfo
};

// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.

function GZheader() {
  /* true if compressed data believed to be text */
  this.text       = 0;
  /* modification time */
  this.time       = 0;
  /* extra flags (not used when writing a gzip file) */
  this.xflags     = 0;
  /* operating system */
  this.os         = 0;
  /* pointer to extra field or Z_NULL if none */
  this.extra      = null;
  /* extra field length (valid if extra != Z_NULL) */
  this.extra_len  = 0; // Actually, we don't need it in JS,
                       // but leave for few code modifications

  //
  // Setup limits is not necessary because in js we should not preallocate memory
  // for inflate use constant limit in 65536 bytes
  //

  /* space at extra (only when reading header) */
  // this.extra_max  = 0;
  /* pointer to zero-terminated file name or Z_NULL */
  this.name       = '';
  /* space at name (only when reading header) */
  // this.name_max   = 0;
  /* pointer to zero-terminated comment or Z_NULL */
  this.comment    = '';
  /* space at comment (only when reading header) */
  // this.comm_max   = 0;
  /* true if there was or will be a header crc */
  this.hcrc       = 0;
  /* true when done reading gzip header (not used when writing a gzip file) */
  this.done       = false;
}

var gzheader = GZheader;

const toString = Object.prototype.toString;

/* Public constants ==========================================================*/
/* ===========================================================================*/

const {
  Z_NO_FLUSH, Z_FINISH,
  Z_OK, Z_STREAM_END, Z_NEED_DICT, Z_STREAM_ERROR, Z_DATA_ERROR, Z_MEM_ERROR
} = constants$2;

/* ===========================================================================*/


/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/

/* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/

/**
 * Inflate.result -> Uint8Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param).
 **/

/**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/

/**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/


/**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako')
 * const chunk1 = new Uint8Array([1,2,3,4,5,6,7,8,9])
 * const chunk2 = new Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * const inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/
function Inflate$1(options) {
  this.options = common.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ''
  }, options || {});

  const opt = this.options;

  // Force window size for `raw` data, if not set directly,
  // because we have no header for autodetect.
  if (opt.raw && (opt.windowBits >= 0) && (opt.windowBits < 16)) {
    opt.windowBits = -opt.windowBits;
    if (opt.windowBits === 0) { opt.windowBits = -15; }
  }

  // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
  if ((opt.windowBits >= 0) && (opt.windowBits < 16) &&
      !(options && options.windowBits)) {
    opt.windowBits += 32;
  }

  // Gzip header has no info about windows size, we can do autodetect only
  // for deflate. So, if window size not set, force it to max when gzip possible
  if ((opt.windowBits > 15) && (opt.windowBits < 48)) {
    // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    if ((opt.windowBits & 15) === 0) {
      opt.windowBits |= 15;
    }
  }

  this.err    = 0;      // error code, if happens (0 = Z_OK)
  this.msg    = '';     // error message
  this.ended  = false;  // used to avoid multiple onEnd() calls
  this.chunks = [];     // chunks of compressed data

  this.strm   = new zstream();
  this.strm.avail_out = 0;

  let status  = inflate_1$2.inflateInit2(
    this.strm,
    opt.windowBits
  );

  if (status !== Z_OK) {
    throw new Error(messages[status]);
  }

  this.header = new gzheader();

  inflate_1$2.inflateGetHeader(this.strm, this.header);

  // Setup dictionary
  if (opt.dictionary) {
    // Convert data if needed
    if (typeof opt.dictionary === 'string') {
      opt.dictionary = strings.string2buf(opt.dictionary);
    } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
      opt.dictionary = new Uint8Array(opt.dictionary);
    }
    if (opt.raw) { //In raw mode we need to set the dictionary early
      status = inflate_1$2.inflateSetDictionary(this.strm, opt.dictionary);
      if (status !== Z_OK) {
        throw new Error(messages[status]);
      }
    }
  }
}

/**
 * Inflate#push(data[, flush_mode]) -> Boolean
 * - data (Uint8Array|ArrayBuffer): input data
 * - flush_mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE
 *   flush modes. See constants. Skipped or `false` means Z_NO_FLUSH,
 *   `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. If end of stream detected,
 * [[Inflate#onEnd]] will be called.
 *
 * `flush_mode` is not needed for normal operation, because end of stream
 * detected automatically. You may try to use it for advanced things, but
 * this functionality was not tested.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/
Inflate$1.prototype.push = function (data, flush_mode) {
  const strm = this.strm;
  const chunkSize = this.options.chunkSize;
  const dictionary = this.options.dictionary;
  let status, _flush_mode, last_avail_out;

  if (this.ended) return false;

  if (flush_mode === ~~flush_mode) _flush_mode = flush_mode;
  else _flush_mode = flush_mode === true ? Z_FINISH : Z_NO_FLUSH;

  // Convert data if needed
  if (toString.call(data) === '[object ArrayBuffer]') {
    strm.input = new Uint8Array(data);
  } else {
    strm.input = data;
  }

  strm.next_in = 0;
  strm.avail_in = strm.input.length;

  for (;;) {
    if (strm.avail_out === 0) {
      strm.output = new Uint8Array(chunkSize);
      strm.next_out = 0;
      strm.avail_out = chunkSize;
    }

    status = inflate_1$2.inflate(strm, _flush_mode);

    if (status === Z_NEED_DICT && dictionary) {
      status = inflate_1$2.inflateSetDictionary(strm, dictionary);

      if (status === Z_OK) {
        status = inflate_1$2.inflate(strm, _flush_mode);
      } else if (status === Z_DATA_ERROR) {
        // Replace code with more verbose
        status = Z_NEED_DICT;
      }
    }

    // Skip snyc markers if more data follows and not raw mode
    while (strm.avail_in > 0 &&
           status === Z_STREAM_END &&
           strm.state.wrap > 0 &&
           data[strm.next_in] !== 0)
    {
      inflate_1$2.inflateReset(strm);
      status = inflate_1$2.inflate(strm, _flush_mode);
    }

    switch (status) {
      case Z_STREAM_ERROR:
      case Z_DATA_ERROR:
      case Z_NEED_DICT:
      case Z_MEM_ERROR:
        this.onEnd(status);
        this.ended = true;
        return false;
    }

    // Remember real `avail_out` value, because we may patch out buffer content
    // to align utf8 strings boundaries.
    last_avail_out = strm.avail_out;

    if (strm.next_out) {
      if (strm.avail_out === 0 || status === Z_STREAM_END) {

        if (this.options.to === 'string') {

          let next_out_utf8 = strings.utf8border(strm.output, strm.next_out);

          let tail = strm.next_out - next_out_utf8;
          let utf8str = strings.buf2string(strm.output, next_out_utf8);

          // move tail & realign counters
          strm.next_out = tail;
          strm.avail_out = chunkSize - tail;
          if (tail) strm.output.set(strm.output.subarray(next_out_utf8, next_out_utf8 + tail), 0);

          this.onData(utf8str);

        } else {
          this.onData(strm.output.length === strm.next_out ? strm.output : strm.output.subarray(0, strm.next_out));
        }
      }
    }

    // Must repeat iteration if out buffer is full
    if (status === Z_OK && last_avail_out === 0) continue;

    // Finalize if end of stream reached.
    if (status === Z_STREAM_END) {
      status = inflate_1$2.inflateEnd(this.strm);
      this.onEnd(status);
      this.ended = true;
      return true;
    }

    if (strm.avail_in === 0) break;
  }

  return true;
};


/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|String): output data. When string output requested,
 *   each chunk will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/
Inflate$1.prototype.onData = function (chunk) {
  this.chunks.push(chunk);
};


/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH). By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/
Inflate$1.prototype.onEnd = function (status) {
  // On success - join
  if (status === Z_OK) {
    if (this.options.to === 'string') {
      this.result = this.chunks.join('');
    } else {
      this.result = common.flattenChunks(this.chunks);
    }
  }
  this.chunks = [];
  this.err = status;
  this.msg = this.strm.msg;
};


/**
 * inflate(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * const pako = require('pako');
 * const input = pako.deflate(new Uint8Array([1,2,3,4,5,6,7,8,9]));
 * let output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err) {
 *   console.log(err);
 * }
 * ```
 **/
function inflate$1(input, options) {
  const inflator = new Inflate$1(options);

  inflator.push(input);

  // That will never happens, if you don't cheat with options :)
  if (inflator.err) throw inflator.msg || messages[inflator.err];

  return inflator.result;
}


/**
 * inflateRaw(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/
function inflateRaw$1(input, options) {
  options = options || {};
  options.raw = true;
  return inflate$1(input, options);
}


/**
 * ungzip(data[, options]) -> Uint8Array|String
 * - data (Uint8Array|ArrayBuffer): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/


var Inflate_1$1 = Inflate$1;
var inflate_2 = inflate$1;
var inflateRaw_1$1 = inflateRaw$1;
var ungzip$1 = inflate$1;
var constants = constants$2;

var inflate_1$1 = {
	Inflate: Inflate_1$1,
	inflate: inflate_2,
	inflateRaw: inflateRaw_1$1,
	ungzip: ungzip$1,
	constants: constants
};

const { Deflate, deflate, deflateRaw, gzip } = deflate_1$1;

const { Inflate, inflate, inflateRaw, ungzip } = inflate_1$1;



var Deflate_1 = Deflate;
var deflate_1 = deflate;
var deflateRaw_1 = deflateRaw;
var gzip_1 = gzip;
var Inflate_1 = Inflate;
var inflate_1 = inflate;
var inflateRaw_1 = inflateRaw;
var ungzip_1 = ungzip;
var constants_1 = constants$2;

var pako = {
	Deflate: Deflate_1,
	deflate: deflate_1,
	deflateRaw: deflateRaw_1,
	gzip: gzip_1,
	Inflate: Inflate_1,
	inflate: inflate_1,
	inflateRaw: inflateRaw_1,
	ungzip: ungzip_1,
	constants: constants_1
};




/***/ }),

/***/ 29041:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ CombinedError; },
  "b": function() { return /* binding */ makeFetchBody; },
  "c": function() { return /* binding */ makeFetchURL; },
  "d": function() { return /* binding */ makeFetchOptions; },
  "e": function() { return /* binding */ makeFetchSource; },
  "f": function() { return /* binding */ createRequest; },
  "k": function() { return /* binding */ keyDocument; }
});

// UNUSED EXPORTS: a, g, h, i, j, m, s

;// CONCATENATED MODULE: ../../node_modules/graphql/jsutils/isObjectLike.mjs
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return typeof value == 'object' && value !== null;
}

;// CONCATENATED MODULE: ../../node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(
      message != null ? message : 'Unexpected invariant triggered.',
    );
  }
}

;// CONCATENATED MODULE: ../../node_modules/graphql/language/location.mjs

const LineRegExp = /\r\n|[\n\r]/g;
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  let lastLineStart = 0;
  let line = 1;

  for (const match of source.body.matchAll(LineRegExp)) {
    typeof match.index === 'number' || invariant(false);

    if (match.index >= position) {
      break;
    }

    lastLineStart = match.index + match[0].length;
    line += 1;
  }

  return {
    line,
    column: position + 1 - lastLineStart,
  };
}

;// CONCATENATED MODULE: ../../node_modules/graphql/language/printLocation.mjs


/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(
    location.source,
    getLocation(location.source, location.start),
  );
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  const firstLineColumnOffset = source.locationOffset.column - 1;
  const body = ''.padStart(firstLineColumnOffset) + source.body;
  const lineIndex = sourceLocation.line - 1;
  const lineOffset = source.locationOffset.line - 1;
  const lineNum = sourceLocation.line + lineOffset;
  const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  const columnNum = sourceLocation.column + columnOffset;
  const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
  const lines = body.split(/\r\n|[\n\r]/g);
  const locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    const subLineIndex = Math.floor(columnNum / 80);
    const subLineColumnNum = columnNum % 80;
    const subLines = [];

    for (let i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return (
      locationStr +
      printPrefixedLines([
        [`${lineNum} |`, subLines[0]],
        ...subLines.slice(1, subLineIndex + 1).map((subLine) => ['|', subLine]),
        ['|', '^'.padStart(subLineColumnNum)],
        ['|', subLines[subLineIndex + 1]],
      ])
    );
  }

  return (
    locationStr +
    printPrefixedLines([
      // Lines specified like this: ["prefix", "string"],
      [`${lineNum - 1} |`, lines[lineIndex - 1]],
      [`${lineNum} |`, locationLine],
      ['|', '^'.padStart(columnNum)],
      [`${lineNum + 1} |`, lines[lineIndex + 1]],
    ])
  );
}

function printPrefixedLines(lines) {
  const existingLines = lines.filter(([_, line]) => line !== undefined);
  const padLen = Math.max(...existingLines.map(([prefix]) => prefix.length));
  return existingLines
    .map(([prefix, line]) => prefix.padStart(padLen) + (line ? ' ' + line : ''))
    .join('\n');
}

;// CONCATENATED MODULE: ../../node_modules/graphql/error/GraphQLError.mjs




function toNormalizedOptions(args) {
  const firstArg = args[0];

  if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) {
    return {
      nodes: firstArg,
      source: args[1],
      positions: args[2],
      path: args[3],
      originalError: args[4],
      extensions: args[5],
    };
  }

  return firstArg;
}
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

class GraphQLError extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */

  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(message, ...rawArgs) {
    var _this$nodes, _nodeLocations$, _ref;

    const { nodes, source, positions, path, originalError, extensions } =
      toNormalizedOptions(rawArgs);
    super(message);
    this.name = 'GraphQLError';
    this.path = path !== null && path !== void 0 ? path : undefined;
    this.originalError =
      originalError !== null && originalError !== void 0
        ? originalError
        : undefined; // Compute list of blame nodes.

    this.nodes = undefinedIfEmpty(
      Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined,
    );
    const nodeLocations = undefinedIfEmpty(
      (_this$nodes = this.nodes) === null || _this$nodes === void 0
        ? void 0
        : _this$nodes.map((node) => node.loc).filter((loc) => loc != null),
    ); // Compute locations in the source for the given nodes/positions.

    this.source =
      source !== null && source !== void 0
        ? source
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : (_nodeLocations$ = nodeLocations[0]) === null ||
          _nodeLocations$ === void 0
        ? void 0
        : _nodeLocations$.source;
    this.positions =
      positions !== null && positions !== void 0
        ? positions
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => loc.start);
    this.locations =
      positions && source
        ? positions.map((pos) => getLocation(source, pos))
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => getLocation(loc.source, loc.start));
    const originalExtensions = isObjectLike(
      originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions,
    )
      ? originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions
      : undefined;
    this.extensions =
      (_ref =
        extensions !== null && extensions !== void 0
          ? extensions
          : originalExtensions) !== null && _ref !== void 0
        ? _ref
        : Object.create(null); // Only properties prescribed by the spec should be enumerable.
    // Keep the rest as non-enumerable.

    Object.defineProperties(this, {
      message: {
        writable: true,
        enumerable: true,
      },
      name: {
        enumerable: false,
      },
      nodes: {
        enumerable: false,
      },
      source: {
        enumerable: false,
      },
      positions: {
        enumerable: false,
      },
      originalError: {
        enumerable: false,
      },
    }); // Include (non-enumerable) stack trace.

    /* c8 ignore start */
    // FIXME: https://github.com/graphql/graphql-js/issues/2317

    if (
      originalError !== null &&
      originalError !== void 0 &&
      originalError.stack
    ) {
      Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true,
      });
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GraphQLError);
    } else {
      Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true,
      });
    }
    /* c8 ignore stop */
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLError';
  }

  toString() {
    let output = this.message;

    if (this.nodes) {
      for (const node of this.nodes) {
        if (node.loc) {
          output += '\n\n' + printLocation(node.loc);
        }
      }
    } else if (this.source && this.locations) {
      for (const location of this.locations) {
        output += '\n\n' + printSourceLocation(this.source, location);
      }
    }

    return output;
  }

  toJSON() {
    const formattedError = {
      message: this.message,
    };

    if (this.locations != null) {
      formattedError.locations = this.locations;
    }

    if (this.path != null) {
      formattedError.path = this.path;
    }

    if (this.extensions != null && Object.keys(this.extensions).length > 0) {
      formattedError.extensions = this.extensions;
    }

    return formattedError;
  }
}

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * See: https://spec.graphql.org/draft/#sec-Errors
 */

/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 *
 * @deprecated Please use `error.toString` instead. Will be removed in v17
 */
function printError(error) {
  return error.toString();
}
/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 *
 * @deprecated Please use `error.toJSON` instead. Will be removed in v17
 */

function formatError(error) {
  return error.toJSON();
}

;// CONCATENATED MODULE: ../../node_modules/graphql/language/characterClasses.mjs
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */
function isWhiteSpace(code) {
  return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */

function isDigit(code) {
  return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */

function isLetter(code) {
  return (
    (code >= 0x0061 && code <= 0x007a) || // A-Z
    (code >= 0x0041 && code <= 0x005a) // a-z
  );
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */

function isNameStart(code) {
  return isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */

function isNameContinue(code) {
  return isLetter(code) || isDigit(code) || code === 0x005f;
}

;// CONCATENATED MODULE: ../../node_modules/graphql/language/blockString.mjs

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */

function dedentBlockStringLines(lines) {
  var _firstNonEmptyLine2;

  let commonIndent = Number.MAX_SAFE_INTEGER;
  let firstNonEmptyLine = null;
  let lastNonEmptyLine = -1;

  for (let i = 0; i < lines.length; ++i) {
    var _firstNonEmptyLine;

    const line = lines[i];
    const indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    firstNonEmptyLine =
      (_firstNonEmptyLine = firstNonEmptyLine) !== null &&
      _firstNonEmptyLine !== void 0
        ? _firstNonEmptyLine
        : i;
    lastNonEmptyLine = i;

    if (i !== 0 && indent < commonIndent) {
      commonIndent = indent;
    }
  }

  return lines // Remove common indentation from all lines but first.
    .map((line, i) => (i === 0 ? line : line.slice(commonIndent))) // Remove leading and trailing blank lines.
    .slice(
      (_firstNonEmptyLine2 = firstNonEmptyLine) !== null &&
        _firstNonEmptyLine2 !== void 0
        ? _firstNonEmptyLine2
        : 0,
      lastNonEmptyLine + 1,
    );
}

function leadingWhitespace(str) {
  let i = 0;

  while (i < str.length && isWhiteSpace(str.charCodeAt(i))) {
    ++i;
  }

  return i;
}
/**
 * @internal
 */

function isPrintableAsBlockString(value) {
  if (value === '') {
    return true; // empty string is printable
  }

  let isEmptyLine = true;
  let hasIndent = false;
  let hasCommonIndent = true;
  let seenNonEmptyLine = false;

  for (let i = 0; i < value.length; ++i) {
    switch (value.codePointAt(i)) {
      case 0x0000:
      case 0x0001:
      case 0x0002:
      case 0x0003:
      case 0x0004:
      case 0x0005:
      case 0x0006:
      case 0x0007:
      case 0x0008:
      case 0x000b:
      case 0x000c:
      case 0x000e:
      case 0x000f:
        return false;
      // Has non-printable characters

      case 0x000d:
        //  \r
        return false;
      // Has \r or \r\n which will be replaced as \n

      case 10:
        //  \n
        if (isEmptyLine && !seenNonEmptyLine) {
          return false; // Has leading new line
        }

        seenNonEmptyLine = true;
        isEmptyLine = true;
        hasIndent = false;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        hasIndent || (hasIndent = isEmptyLine);
        break;

      default:
        hasCommonIndent && (hasCommonIndent = hasIndent);
        isEmptyLine = false;
    }
  }

  if (isEmptyLine) {
    return false; // Has trailing empty lines
  }

  if (hasCommonIndent && seenNonEmptyLine) {
    return false; // Has internal indent
  }

  return true;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value, options) {
  const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.

  const lines = escapedValue.split(/\r\n|[\n\r]/g);
  const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line

  const forceLeadingNewLine =
    lines.length > 1 &&
    lines
      .slice(1)
      .every((line) => line.length === 0 || isWhiteSpace(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line

  const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line

  const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
  const hasTrailingSlash = value.endsWith('\\');
  const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
  const printAsMultipleLines =
    !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine ||
      value.length > 70 ||
      forceTrailingNewline ||
      forceLeadingNewLine ||
      hasTrailingTripleQuotes);
  let result = ''; // Format a multi-line block quote to account for leading space.

  const skipLeadingNewLine = isSingleLine && isWhiteSpace(value.charCodeAt(0));

  if ((printAsMultipleLines && !skipLeadingNewLine) || forceLeadingNewLine) {
    result += '\n';
  }

  result += escapedValue;

  if (printAsMultipleLines || forceTrailingNewline) {
    result += '\n';
  }

  return '"""' + result + '"""';
}

;// CONCATENATED MODULE: ../../node_modules/graphql/language/printString.mjs
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */
function printString(str) {
  return `"${str.replace(escapedRegExp, escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex

const escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;

function escapedReplacer(str) {
  return escapeSequences[str.charCodeAt(0)];
} // prettier-ignore

const escapeSequences = [
  '\\u0000',
  '\\u0001',
  '\\u0002',
  '\\u0003',
  '\\u0004',
  '\\u0005',
  '\\u0006',
  '\\u0007',
  '\\b',
  '\\t',
  '\\n',
  '\\u000B',
  '\\f',
  '\\r',
  '\\u000E',
  '\\u000F',
  '\\u0010',
  '\\u0011',
  '\\u0012',
  '\\u0013',
  '\\u0014',
  '\\u0015',
  '\\u0016',
  '\\u0017',
  '\\u0018',
  '\\u0019',
  '\\u001A',
  '\\u001B',
  '\\u001C',
  '\\u001D',
  '\\u001E',
  '\\u001F',
  '',
  '',
  '\\"',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 2F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 3F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 4F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\\\',
  '',
  '',
  '', // 5F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 6F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\u007F',
  '\\u0080',
  '\\u0081',
  '\\u0082',
  '\\u0083',
  '\\u0084',
  '\\u0085',
  '\\u0086',
  '\\u0087',
  '\\u0088',
  '\\u0089',
  '\\u008A',
  '\\u008B',
  '\\u008C',
  '\\u008D',
  '\\u008E',
  '\\u008F',
  '\\u0090',
  '\\u0091',
  '\\u0092',
  '\\u0093',
  '\\u0094',
  '\\u0095',
  '\\u0096',
  '\\u0097',
  '\\u0098',
  '\\u0099',
  '\\u009A',
  '\\u009B',
  '\\u009C',
  '\\u009D',
  '\\u009E',
  '\\u009F',
];

// EXTERNAL MODULE: ../../node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(58867);
;// CONCATENATED MODULE: ../../node_modules/graphql/language/printer.mjs



/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return (0,visitor/* visit */.Vn)(ast, printDocASTReducer);
}
const MAX_LINE_LENGTH = 80;
const printDocASTReducer = {
  Name: {
    leave: (node) => node.value,
  },
  Variable: {
    leave: (node) => '$' + node.name,
  },
  // Document
  Document: {
    leave: (node) => join(node.definitions, '\n\n'),
  },
  OperationDefinition: {
    leave(node) {
      const varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
      const prefix = join(
        [
          node.operation,
          join([node.name, varDefs]),
          join(node.directives, ' '),
        ],
        ' ',
      ); // Anonymous queries with no directives or variable definitions can use
      // the query short form.

      return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
    },
  },
  VariableDefinition: {
    leave: ({ variable, type, defaultValue, directives }) =>
      variable +
      ': ' +
      type +
      wrap(' = ', defaultValue) +
      wrap(' ', join(directives, ' ')),
  },
  SelectionSet: {
    leave: ({ selections }) => block(selections),
  },
  Field: {
    leave({ alias, name, arguments: args, directives, selectionSet }) {
      const prefix = wrap('', alias, ': ') + name;
      let argsLine = prefix + wrap('(', join(args, ', '), ')');

      if (argsLine.length > MAX_LINE_LENGTH) {
        argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
      }

      return join([argsLine, join(directives, ' '), selectionSet], ' ');
    },
  },
  Argument: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name, directives }) =>
      '...' + name + wrap(' ', join(directives, ' ')),
  },
  InlineFragment: {
    leave: ({ typeCondition, directives, selectionSet }) =>
      join(
        [
          '...',
          wrap('on ', typeCondition),
          join(directives, ' '),
          selectionSet,
        ],
        ' ',
      ),
  },
  FragmentDefinition: {
    leave: (
      { name, typeCondition, variableDefinitions, directives, selectionSet }, // Note: fragment variable definitions are experimental and may be changed
    ) =>
      // or removed in the future.
      `fragment ${name}${wrap('(', join(variableDefinitions, ', '), ')')} ` +
      `on ${typeCondition} ${wrap('', join(directives, ' '), ' ')}` +
      selectionSet,
  },
  // Value
  IntValue: {
    leave: ({ value }) => value,
  },
  FloatValue: {
    leave: ({ value }) => value,
  },
  StringValue: {
    leave: ({ value, block: isBlockString }) =>
      isBlockString ? printBlockString(value) : printString(value),
  },
  BooleanValue: {
    leave: ({ value }) => (value ? 'true' : 'false'),
  },
  NullValue: {
    leave: () => 'null',
  },
  EnumValue: {
    leave: ({ value }) => value,
  },
  ListValue: {
    leave: ({ values }) => '[' + join(values, ', ') + ']',
  },
  ObjectValue: {
    leave: ({ fields }) => '{' + join(fields, ', ') + '}',
  },
  ObjectField: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Directive
  Directive: {
    leave: ({ name, arguments: args }) =>
      '@' + name + wrap('(', join(args, ', '), ')'),
  },
  // Type
  NamedType: {
    leave: ({ name }) => name,
  },
  ListType: {
    leave: ({ type }) => '[' + type + ']',
  },
  NonNullType: {
    leave: ({ type }) => type + '!',
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description, directives, operationTypes }) =>
      wrap('', description, '\n') +
      join(['schema', join(directives, ' '), block(operationTypes)], ' '),
  },
  OperationTypeDefinition: {
    leave: ({ operation, type }) => operation + ': ' + type,
  },
  ScalarTypeDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') +
      join(['scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  FieldDefinition: {
    leave: ({ description, name, arguments: args, type, directives }) =>
      wrap('', description, '\n') +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      ': ' +
      type +
      wrap(' ', join(directives, ' ')),
  },
  InputValueDefinition: {
    leave: ({ description, name, type, defaultValue, directives }) =>
      wrap('', description, '\n') +
      join(
        [name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')],
        ' ',
      ),
  },
  InterfaceTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeDefinition: {
    leave: ({ description, name, directives, types }) =>
      wrap('', description, '\n') +
      join(
        ['union', name, join(directives, ' '), wrap('= ', join(types, ' | '))],
        ' ',
      ),
  },
  EnumTypeDefinition: {
    leave: ({ description, name, directives, values }) =>
      wrap('', description, '\n') +
      join(['enum', name, join(directives, ' '), block(values)], ' '),
  },
  EnumValueDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') + join([name, join(directives, ' ')], ' '),
  },
  InputObjectTypeDefinition: {
    leave: ({ description, name, directives, fields }) =>
      wrap('', description, '\n') +
      join(['input', name, join(directives, ' '), block(fields)], ' '),
  },
  DirectiveDefinition: {
    leave: ({ description, name, arguments: args, repeatable, locations }) =>
      wrap('', description, '\n') +
      'directive @' +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      (repeatable ? ' repeatable' : '') +
      ' on ' +
      join(locations, ' | '),
  },
  SchemaExtension: {
    leave: ({ directives, operationTypes }) =>
      join(
        ['extend schema', join(directives, ' '), block(operationTypes)],
        ' ',
      ),
  },
  ScalarTypeExtension: {
    leave: ({ name, directives }) =>
      join(['extend scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  InterfaceTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeExtension: {
    leave: ({ name, directives, types }) =>
      join(
        [
          'extend union',
          name,
          join(directives, ' '),
          wrap('= ', join(types, ' | ')),
        ],
        ' ',
      ),
  },
  EnumTypeExtension: {
    leave: ({ name, directives, values }) =>
      join(['extend enum', name, join(directives, ' '), block(values)], ' '),
  },
  InputObjectTypeExtension: {
    leave: ({ name, directives, fields }) =>
      join(['extend input', name, join(directives, ' '), block(fields)], ' '),
  },
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */

function join(maybeArray, separator = '') {
  var _maybeArray$filter$jo;

  return (_maybeArray$filter$jo =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.filter((x) => x).join(separator)) !== null &&
    _maybeArray$filter$jo !== void 0
    ? _maybeArray$filter$jo
    : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */

function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */

function wrap(start, maybeString, end = '') {
  return maybeString != null && maybeString !== ''
    ? start + maybeString + end
    : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function hasMultilineItems(maybeArray) {
  var _maybeArray$some;

  // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */
  return (_maybeArray$some =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.some((str) => str.includes('\n'))) !== null &&
    _maybeArray$some !== void 0
    ? _maybeArray$some
    : false;
}

;// CONCATENATED MODULE: ../../node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError(`Syntax Error: ${description}`, {
    source,
    positions: [position],
  });
}

// EXTERNAL MODULE: ../../node_modules/graphql/language/ast.mjs
var ast = __webpack_require__(90781);
;// CONCATENATED MODULE: ../../node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
var DirectiveLocation;

(function (DirectiveLocation) {
  DirectiveLocation['QUERY'] = 'QUERY';
  DirectiveLocation['MUTATION'] = 'MUTATION';
  DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
  DirectiveLocation['FIELD'] = 'FIELD';
  DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
  DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
  DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
  DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
  DirectiveLocation['SCHEMA'] = 'SCHEMA';
  DirectiveLocation['SCALAR'] = 'SCALAR';
  DirectiveLocation['OBJECT'] = 'OBJECT';
  DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
  DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
  DirectiveLocation['INTERFACE'] = 'INTERFACE';
  DirectiveLocation['UNION'] = 'UNION';
  DirectiveLocation['ENUM'] = 'ENUM';
  DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
  DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
  DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})(DirectiveLocation || (DirectiveLocation = {}));


/**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */

// EXTERNAL MODULE: ../../node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(95115);
;// CONCATENATED MODULE: ../../node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var tokenKind_TokenKind;

(function (TokenKind) {
  TokenKind['SOF'] = '<SOF>';
  TokenKind['EOF'] = '<EOF>';
  TokenKind['BANG'] = '!';
  TokenKind['DOLLAR'] = '$';
  TokenKind['AMP'] = '&';
  TokenKind['PAREN_L'] = '(';
  TokenKind['PAREN_R'] = ')';
  TokenKind['SPREAD'] = '...';
  TokenKind['COLON'] = ':';
  TokenKind['EQUALS'] = '=';
  TokenKind['AT'] = '@';
  TokenKind['BRACKET_L'] = '[';
  TokenKind['BRACKET_R'] = ']';
  TokenKind['BRACE_L'] = '{';
  TokenKind['PIPE'] = '|';
  TokenKind['BRACE_R'] = '}';
  TokenKind['NAME'] = 'Name';
  TokenKind['INT'] = 'Int';
  TokenKind['FLOAT'] = 'Float';
  TokenKind['STRING'] = 'String';
  TokenKind['BLOCK_STRING'] = 'BlockString';
  TokenKind['COMMENT'] = 'Comment';
})(tokenKind_TokenKind || (tokenKind_TokenKind = {}));


/**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */

;// CONCATENATED MODULE: ../../node_modules/graphql/language/lexer.mjs





/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

class Lexer {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  constructor(source) {
    const startOfFileToken = new ast/* Token */.WU(tokenKind_TokenKind.SOF, 0, 0, 0, 0);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }

  get [Symbol.toStringTag]() {
    return 'Lexer';
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */

  advance() {
    this.lastToken = this.token;
    const token = (this.token = this.lookahead());
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */

  lookahead() {
    let token = this.token;

    if (token.kind !== tokenKind_TokenKind.EOF) {
      do {
        if (token.next) {
          token = token.next;
        } else {
          // Read the next token and form a link in the token linked-list.
          const nextToken = readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.

          token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.

          nextToken.prev = token;
          token = nextToken;
        }
      } while (token.kind === tokenKind_TokenKind.COMMENT);
    }

    return token;
  }
}
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return (
    kind === tokenKind_TokenKind.BANG ||
    kind === tokenKind_TokenKind.DOLLAR ||
    kind === tokenKind_TokenKind.AMP ||
    kind === tokenKind_TokenKind.PAREN_L ||
    kind === tokenKind_TokenKind.PAREN_R ||
    kind === tokenKind_TokenKind.SPREAD ||
    kind === tokenKind_TokenKind.COLON ||
    kind === tokenKind_TokenKind.EQUALS ||
    kind === tokenKind_TokenKind.AT ||
    kind === tokenKind_TokenKind.BRACKET_L ||
    kind === tokenKind_TokenKind.BRACKET_R ||
    kind === tokenKind_TokenKind.BRACE_L ||
    kind === tokenKind_TokenKind.PIPE ||
    kind === tokenKind_TokenKind.BRACE_R
  );
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */

function isUnicodeScalarValue(code) {
  return (
    (code >= 0x0000 && code <= 0xd7ff) || (code >= 0xe000 && code <= 0x10ffff)
  );
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */

function isSupplementaryCodePoint(body, location) {
  return (
    isLeadingSurrogate(body.charCodeAt(location)) &&
    isTrailingSurrogate(body.charCodeAt(location + 1))
  );
}

function isLeadingSurrogate(code) {
  return code >= 0xd800 && code <= 0xdbff;
}

function isTrailingSurrogate(code) {
  return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */

function printCodePointAt(lexer, location) {
  const code = lexer.source.body.codePointAt(location);

  if (code === undefined) {
    return tokenKind_TokenKind.EOF;
  } else if (code >= 0x0020 && code <= 0x007e) {
    // Printable ASCII
    const char = String.fromCodePoint(code);
    return char === '"' ? "'\"'" : `"${char}"`;
  } // Unicode code point

  return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */

function createToken(lexer, kind, start, end, value) {
  const line = lexer.line;
  const col = 1 + start - lexer.lineStart;
  return new ast/* Token */.WU(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */

function readNextToken(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // SourceCharacter

    switch (code) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 0xfeff: // <BOM>

      case 0x0009: // \t

      case 0x0020: // <space>

      case 0x002c:
        // ,
        ++position;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"

      case 0x000a:
        // \n
        ++position;
        ++lexer.line;
        lexer.lineStart = position;
        continue;

      case 0x000d:
        // \r
        if (body.charCodeAt(position + 1) === 0x000a) {
          position += 2;
        } else {
          ++position;
        }

        ++lexer.line;
        lexer.lineStart = position;
        continue;
      // Comment

      case 0x0023:
        // #
        return readComment(lexer, position);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }

      case 0x0021:
        // !
        return createToken(lexer, tokenKind_TokenKind.BANG, position, position + 1);

      case 0x0024:
        // $
        return createToken(lexer, tokenKind_TokenKind.DOLLAR, position, position + 1);

      case 0x0026:
        // &
        return createToken(lexer, tokenKind_TokenKind.AMP, position, position + 1);

      case 0x0028:
        // (
        return createToken(lexer, tokenKind_TokenKind.PAREN_L, position, position + 1);

      case 0x0029:
        // )
        return createToken(lexer, tokenKind_TokenKind.PAREN_R, position, position + 1);

      case 0x002e:
        // .
        if (
          body.charCodeAt(position + 1) === 0x002e &&
          body.charCodeAt(position + 2) === 0x002e
        ) {
          return createToken(lexer, tokenKind_TokenKind.SPREAD, position, position + 3);
        }

        break;

      case 0x003a:
        // :
        return createToken(lexer, tokenKind_TokenKind.COLON, position, position + 1);

      case 0x003d:
        // =
        return createToken(lexer, tokenKind_TokenKind.EQUALS, position, position + 1);

      case 0x0040:
        // @
        return createToken(lexer, tokenKind_TokenKind.AT, position, position + 1);

      case 0x005b:
        // [
        return createToken(lexer, tokenKind_TokenKind.BRACKET_L, position, position + 1);

      case 0x005d:
        // ]
        return createToken(lexer, tokenKind_TokenKind.BRACKET_R, position, position + 1);

      case 0x007b:
        // {
        return createToken(lexer, tokenKind_TokenKind.BRACE_L, position, position + 1);

      case 0x007c:
        // |
        return createToken(lexer, tokenKind_TokenKind.PIPE, position, position + 1);

      case 0x007d:
        // }
        return createToken(lexer, tokenKind_TokenKind.BRACE_R, position, position + 1);
      // StringValue

      case 0x0022:
        // "
        if (
          body.charCodeAt(position + 1) === 0x0022 &&
          body.charCodeAt(position + 2) === 0x0022
        ) {
          return readBlockString(lexer, position);
        }

        return readString(lexer, position);
    } // IntValue | FloatValue (Digit | -)

    if (isDigit(code) || code === 0x002d) {
      return readNumber(lexer, position, code);
    } // Name

    if (isNameStart(code)) {
      return readName(lexer, position);
    }

    throw syntaxError(
      lexer.source,
      position,
      code === 0x0027
        ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?'
        : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position)
        ? `Unexpected character: ${printCodePointAt(lexer, position)}.`
        : `Invalid character: ${printCodePointAt(lexer, position)}.`,
    );
  }

  return createToken(lexer, tokenKind_TokenKind.EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */

function readComment(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.COMMENT,
    start,
    position,
    body.slice(start + 1, position),
  );
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */

function readNumber(lexer, start, firstCode) {
  const body = lexer.source.body;
  let position = start;
  let code = firstCode;
  let isFloat = false; // NegativeSign (-)

  if (code === 0x002d) {
    code = body.charCodeAt(++position);
  } // Zero (0)

  if (code === 0x0030) {
    code = body.charCodeAt(++position);

    if (isDigit(code)) {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid number, unexpected digit after 0: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  } else {
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Full stop (.)

  if (code === 0x002e) {
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // E e

  if (code === 0x0045 || code === 0x0065) {
    isFloat = true;
    code = body.charCodeAt(++position); // + -

    if (code === 0x002b || code === 0x002d) {
      code = body.charCodeAt(++position);
    }

    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart

  if (code === 0x002e || isNameStart(code)) {
    throw syntaxError(
      lexer.source,
      position,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        position,
      )}.`,
    );
  }

  return createToken(
    lexer,
    isFloat ? tokenKind_TokenKind.FLOAT : tokenKind_TokenKind.INT,
    start,
    position,
    body.slice(start, position),
  );
}
/**
 * Returns the new position in the source after reading one or more digits.
 */

function readDigits(lexer, start, firstCode) {
  if (!isDigit(firstCode)) {
    throw syntaxError(
      lexer.source,
      start,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        start,
      )}.`,
    );
  }

  const body = lexer.source.body;
  let position = start + 1; // +1 to skip first firstCode

  while (isDigit(body.charCodeAt(position))) {
    ++position;
  }

  return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */

function readString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  let chunkStart = position;
  let value = '';

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Quote (")

    if (code === 0x0022) {
      value += body.slice(chunkStart, position);
      return createToken(lexer, tokenKind_TokenKind.STRING, start, position + 1, value);
    } // Escape Sequence (\)

    if (code === 0x005c) {
      value += body.slice(chunkStart, position);
      const escape =
        body.charCodeAt(position + 1) === 0x0075 // u
          ? body.charCodeAt(position + 2) === 0x007b // {
            ? readEscapedUnicodeVariableWidth(lexer, position)
            : readEscapedUnicodeFixedWidth(lexer, position)
          : readEscapedCharacter(lexer, position);
      value += escape.value;
      position += escape.size;
      chunkStart = position;
      continue;
    } // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.

function readEscapedUnicodeVariableWidth(lexer, position) {
  const body = lexer.source.body;
  let point = 0;
  let size = 3; // Cannot be larger than 12 chars (\u{00000000}).

  while (size < 12) {
    const code = body.charCodeAt(position + size++); // Closing Brace (})

    if (code === 0x007d) {
      // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
      if (size < 5 || !isUnicodeScalarValue(point)) {
        break;
      }

      return {
        value: String.fromCodePoint(point),
        size,
      };
    } // Append this hex digit to the code point.

    point = (point << 4) | readHexDigit(code);

    if (point < 0) {
      break;
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(
      position,
      position + size,
    )}".`,
  );
}

function readEscapedUnicodeFixedWidth(lexer, position) {
  const body = lexer.source.body;
  const code = read16BitHexCode(body, position + 2);

  if (isUnicodeScalarValue(code)) {
    return {
      value: String.fromCodePoint(code),
      size: 6,
    };
  } // GraphQL allows JSON-style surrogate pair escape sequences, but only when
  // a valid pair is formed.

  if (isLeadingSurrogate(code)) {
    // \u
    if (
      body.charCodeAt(position + 6) === 0x005c &&
      body.charCodeAt(position + 7) === 0x0075
    ) {
      const trailingCode = read16BitHexCode(body, position + 8);

      if (isTrailingSurrogate(trailingCode)) {
        // JavaScript defines strings as a sequence of UTF-16 code units and
        // encodes Unicode code points above U+FFFF using a surrogate pair of
        // code units. Since this is a surrogate pair escape sequence, just
        // include both codes into the JavaScript string value. Had JavaScript
        // not been internally based on UTF-16, then this surrogate pair would
        // be decoded to retrieve the supplementary code point.
        return {
          value: String.fromCodePoint(code, trailingCode),
          size: 12,
        };
      }
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`,
  );
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */

function read16BitHexCode(body, position) {
  // readHexDigit() returns -1 on error. ORing a negative value with any other
  // value always produces a negative value.
  return (
    (readHexDigit(body.charCodeAt(position)) << 12) |
    (readHexDigit(body.charCodeAt(position + 1)) << 8) |
    (readHexDigit(body.charCodeAt(position + 2)) << 4) |
    readHexDigit(body.charCodeAt(position + 3))
  );
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */

function readHexDigit(code) {
  return code >= 0x0030 && code <= 0x0039 // 0-9
    ? code - 0x0030
    : code >= 0x0041 && code <= 0x0046 // A-F
    ? code - 0x0037
    : code >= 0x0061 && code <= 0x0066 // a-f
    ? code - 0x0057
    : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */

function readEscapedCharacter(lexer, position) {
  const body = lexer.source.body;
  const code = body.charCodeAt(position + 1);

  switch (code) {
    case 0x0022:
      // "
      return {
        value: '\u0022',
        size: 2,
      };

    case 0x005c:
      // \
      return {
        value: '\u005c',
        size: 2,
      };

    case 0x002f:
      // /
      return {
        value: '\u002f',
        size: 2,
      };

    case 0x0062:
      // b
      return {
        value: '\u0008',
        size: 2,
      };

    case 0x0066:
      // f
      return {
        value: '\u000c',
        size: 2,
      };

    case 0x006e:
      // n
      return {
        value: '\u000a',
        size: 2,
      };

    case 0x0072:
      // r
      return {
        value: '\u000d',
        size: 2,
      };

    case 0x0074:
      // t
      return {
        value: '\u0009',
        size: 2,
      };
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid character escape sequence: "${body.slice(
      position,
      position + 2,
    )}".`,
  );
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */

function readBlockString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let lineStart = lexer.lineStart;
  let position = start + 3;
  let chunkStart = position;
  let currentLine = '';
  const blockLines = [];

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Triple-Quote (""")

    if (
      code === 0x0022 &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);
      const token = createToken(
        lexer,
        tokenKind_TokenKind.BLOCK_STRING,
        start,
        position + 3, // Return a string of the lines joined with U+000A.
        dedentBlockStringLines(blockLines).join('\n'),
      );
      lexer.line += blockLines.length - 1;
      lexer.lineStart = lineStart;
      return token;
    } // Escaped Triple-Quote (\""")

    if (
      code === 0x005c &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022 &&
      body.charCodeAt(position + 3) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      chunkStart = position + 1; // skip only slash

      position += 4;
      continue;
    } // LineTerminator

    if (code === 0x000a || code === 0x000d) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);

      if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) {
        position += 2;
      } else {
        ++position;
      }

      currentLine = '';
      chunkStart = position;
      lineStart = position;
      continue;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */

function readName(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position);

    if (isNameContinue(code)) {
      ++position;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.NAME,
    start,
    position,
    body.slice(start, position),
  );
}

// EXTERNAL MODULE: ../../node_modules/graphql/jsutils/devAssert.mjs
var devAssert = __webpack_require__(88660);
// EXTERNAL MODULE: ../../node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(92277);
;// CONCATENATED MODULE: ../../node_modules/graphql/jsutils/instanceOf.mjs

/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 * See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
 * See: https://webpack.js.org/guides/production/
 */

const instanceOf =
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  globalThis.process && globalThis.process.env.NODE_ENV === 'production'
    ? function instanceOf(value, constructor) {
        return value instanceof constructor;
      }
    : function instanceOf(value, constructor) {
        if (value instanceof constructor) {
          return true;
        }

        if (typeof value === 'object' && value !== null) {
          var _value$constructor;

          // Prefer Symbol.toStringTag since it is immune to minification.
          const className = constructor.prototype[Symbol.toStringTag];
          const valueClassName = // We still need to support constructor's name to detect conflicts with older versions of this library.
            Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
              ? value[Symbol.toStringTag]
              : (_value$constructor = value.constructor) === null ||
                _value$constructor === void 0
              ? void 0
              : _value$constructor.name;

          if (className === valueClassName) {
            const stringifiedValue = (0,inspect/* inspect */.X)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
          }
        }

        return false;
      };

;// CONCATENATED MODULE: ../../node_modules/graphql/language/source.mjs




/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
class Source {
  constructor(
    body,
    name = 'GraphQL request',
    locationOffset = {
      line: 1,
      column: 1,
    },
  ) {
    typeof body === 'string' ||
      (0,devAssert/* devAssert */.a)(false, `Body must be a string. Received: ${(0,inspect/* inspect */.X)(body)}.`);
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 ||
      (0,devAssert/* devAssert */.a)(
        false,
        'line in locationOffset is 1-indexed and must be positive.',
      );
    this.locationOffset.column > 0 ||
      (0,devAssert/* devAssert */.a)(
        false,
        'column in locationOffset is 1-indexed and must be positive.',
      );
  }

  get [Symbol.toStringTag]() {
    return 'Source';
  }
}
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

function isSource(source) {
  return instanceOf(source, Source);
}

;// CONCATENATED MODULE: ../../node_modules/graphql/language/parser.mjs







/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  const parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Similar to parseValue(), but raises a parse error if it encounters a
 * variable. The return type will be a constant value.
 */

function parseConstValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseConstValueLiteral();
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

class Parser {
  constructor(source, options = {}) {
    const sourceObj = isSource(source) ? source : new Source(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
    this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */

  parseName() {
    const token = this.expectToken(tokenKind_TokenKind.NAME);
    return this.node(token, {
      kind: kinds/* Kind.NAME */.h.NAME,
      value: token.value,
    });
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */

  parseDocument() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.DOCUMENT */.h.DOCUMENT,
      definitions: this.many(
        tokenKind_TokenKind.SOF,
        this.parseDefinition,
        tokenKind_TokenKind.EOF,
      ),
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */

  parseDefinition() {
    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } // Many definitions begin with a description and require a lookahead.

    const hasDescription = this.peekDescription();
    const keywordToken = hasDescription
      ? this._lexer.lookahead()
      : this._lexer.token;

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }

      if (hasDescription) {
        throw syntaxError(
          this._lexer.source,
          this._lexer.token.start,
          'Unexpected description, descriptions are supported only on type definitions.',
        );
      }

      switch (keywordToken.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    }

    throw this.unexpected(keywordToken);
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */

  parseOperationDefinition() {
    const start = this._lexer.token;

    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.node(start, {
        kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
        operation: ast/* OperationTypeNode.QUERY */.ku.QUERY,
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
      });
    }

    const operation = this.parseOperationType();
    let name;

    if (this.peek(tokenKind_TokenKind.NAME)) {
      name = this.parseName();
    }

    return this.node(start, {
      kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
      operation,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */

  parseOperationType() {
    const operationToken = this.expectToken(tokenKind_TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return ast/* OperationTypeNode.QUERY */.ku.QUERY;

      case 'mutation':
        return ast/* OperationTypeNode.MUTATION */.ku.MUTATION;

      case 'subscription':
        return ast/* OperationTypeNode.SUBSCRIPTION */.ku.SUBSCRIPTION;
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */

  parseVariableDefinitions() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseVariableDefinition,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */

  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.VARIABLE_DEFINITION */.h.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(tokenKind_TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
        ? this.parseConstValueLiteral()
        : undefined,
      directives: this.parseConstDirectives(),
    });
  }
  /**
   * Variable : $ Name
   */

  parseVariable() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.DOLLAR);
    return this.node(start, {
      kind: kinds/* Kind.VARIABLE */.h.VARIABLE,
      name: this.parseName(),
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */

  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.SELECTION_SET */.h.SELECTION_SET,
      selections: this.many(
        tokenKind_TokenKind.BRACE_L,
        this.parseSelection,
        tokenKind_TokenKind.BRACE_R,
      ),
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */

  parseSelection() {
    return this.peek(tokenKind_TokenKind.SPREAD)
      ? this.parseFragment()
      : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */

  parseField() {
    const start = this._lexer.token;
    const nameOrAlias = this.parseName();
    let alias;
    let name;

    if (this.expectOptionalToken(tokenKind_TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return this.node(start, {
      kind: kinds/* Kind.FIELD */.h.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(tokenKind_TokenKind.BRACE_L)
        ? this.parseSelectionSet()
        : undefined,
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */

  parseArguments(isConst) {
    const item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, item, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */

  parseArgument(isConst = false) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds/* Kind.ARGUMENT */.h.ARGUMENT,
      name,
      value: this.parseValueLiteral(isConst),
    });
  }

  parseConstArgument() {
    return this.parseArgument(true);
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */

  parseFragment() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.SPREAD);
    const hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(tokenKind_TokenKind.NAME)) {
      return this.node(start, {
        kind: kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
      });
    }

    return this.node(start, {
      kind: kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */

  parseFragmentDefinition() {
    const start = this._lexer.token;
    this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (this._options.allowLegacyFragmentVariables === true) {
      return this.node(start, {
        kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
      });
    }

    return this.node(start, {
      kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentName : Name but not `on`
   */

  parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseValueLiteral(isConst) {
    const token = this._lexer.token;

    switch (token.kind) {
      case tokenKind_TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case tokenKind_TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case tokenKind_TokenKind.INT:
        this.advanceLexer();
        return this.node(token, {
          kind: kinds/* Kind.INT */.h.INT,
          value: token.value,
        });

      case tokenKind_TokenKind.FLOAT:
        this.advanceLexer();
        return this.node(token, {
          kind: kinds/* Kind.FLOAT */.h.FLOAT,
          value: token.value,
        });

      case tokenKind_TokenKind.STRING:
      case tokenKind_TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case tokenKind_TokenKind.NAME:
        this.advanceLexer();

        switch (token.value) {
          case 'true':
            return this.node(token, {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: true,
            });

          case 'false':
            return this.node(token, {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: false,
            });

          case 'null':
            return this.node(token, {
              kind: kinds/* Kind.NULL */.h.NULL,
            });

          default:
            return this.node(token, {
              kind: kinds/* Kind.ENUM */.h.ENUM,
              value: token.value,
            });
        }

      case tokenKind_TokenKind.DOLLAR:
        if (isConst) {
          this.expectToken(tokenKind_TokenKind.DOLLAR);

          if (this._lexer.token.kind === tokenKind_TokenKind.NAME) {
            const varName = this._lexer.token.value;
            throw syntaxError(
              this._lexer.source,
              token.start,
              `Unexpected variable "$${varName}" in constant value.`,
            );
          } else {
            throw this.unexpected(token);
          }
        }

        return this.parseVariable();

      default:
        throw this.unexpected();
    }
  }

  parseConstValueLiteral() {
    return this.parseValueLiteral(true);
  }

  parseStringLiteral() {
    const token = this._lexer.token;
    this.advanceLexer();
    return this.node(token, {
      kind: kinds/* Kind.STRING */.h.STRING,
      value: token.value,
      block: token.kind === tokenKind_TokenKind.BLOCK_STRING,
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */

  parseList(isConst) {
    const item = () => this.parseValueLiteral(isConst);

    return this.node(this._lexer.token, {
      kind: kinds/* Kind.LIST */.h.LIST,
      values: this.any(tokenKind_TokenKind.BRACKET_L, item, tokenKind_TokenKind.BRACKET_R),
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */

  parseObject(isConst) {
    const item = () => this.parseObjectField(isConst);

    return this.node(this._lexer.token, {
      kind: kinds/* Kind.OBJECT */.h.OBJECT,
      fields: this.any(tokenKind_TokenKind.BRACE_L, item, tokenKind_TokenKind.BRACE_R),
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */

  parseObjectField(isConst) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds/* Kind.OBJECT_FIELD */.h.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst),
    });
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */

  parseDirectives(isConst) {
    const directives = [];

    while (this.peek(tokenKind_TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }

  parseConstDirectives() {
    return this.parseDirectives(true);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */

  parseDirective(isConst) {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.AT);
    return this.node(start, {
      kind: kinds/* Kind.DIRECTIVE */.h.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
    });
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */

  parseTypeReference() {
    const start = this._lexer.token;
    let type;

    if (this.expectOptionalToken(tokenKind_TokenKind.BRACKET_L)) {
      const innerType = this.parseTypeReference();
      this.expectToken(tokenKind_TokenKind.BRACKET_R);
      type = this.node(start, {
        kind: kinds/* Kind.LIST_TYPE */.h.LIST_TYPE,
        type: innerType,
      });
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(tokenKind_TokenKind.BANG)) {
      return this.node(start, {
        kind: kinds/* Kind.NON_NULL_TYPE */.h.NON_NULL_TYPE,
        type,
      });
    }

    return type;
  }
  /**
   * NamedType : Name
   */

  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.NAMED_TYPE */.h.NAMED_TYPE,
      name: this.parseName(),
    });
  } // Implements the parsing rules in the Type Definition section.

  peekDescription() {
    return this.peek(tokenKind_TokenKind.STRING) || this.peek(tokenKind_TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */

  parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */

  parseSchemaDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.many(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
    return this.node(start, {
      kind: kinds/* Kind.SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes,
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */

  parseOperationTypeDefinition() {
    const start = this._lexer.token;
    const operation = this.parseOperationType();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseNamedType();
    return this.node(start, {
      kind: kinds/* Kind.OPERATION_TYPE_DEFINITION */.h.OPERATION_TYPE_DEFINITION,
      operation,
      type,
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */

  parseScalarTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.SCALAR_TYPE_DEFINITION */.h.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */

  parseObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.OBJECT_TYPE_DEFINITION */.h.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */

  parseImplementsInterfaces() {
    return this.expectOptionalKeyword('implements')
      ? this.delimitedMany(tokenKind_TokenKind.AMP, this.parseNamedType)
      : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */

  parseFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseFieldDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */

  parseFieldDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.FIELD_DEFINITION */.h.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives,
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */

  parseArgumentDefs() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */

  parseInputValueDef() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    let defaultValue;

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      defaultValue = this.parseConstValueLiteral();
    }

    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.INPUT_VALUE_DEFINITION */.h.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives,
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */

  parseInterfaceTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.INTERFACE_TYPE_DEFINITION */.h.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */

  parseUnionTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    return this.node(start, {
      kind: kinds/* Kind.UNION_TYPE_DEFINITION */.h.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types,
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */

  parseUnionMemberTypes() {
    return this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
      ? this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseNamedType)
      : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */

  parseEnumTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    return this.node(start, {
      kind: kinds/* Kind.ENUM_TYPE_DEFINITION */.h.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values,
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */

  parseEnumValuesDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseEnumValueDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */

  parseEnumValueDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseEnumValueName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.ENUM_VALUE_DEFINITION */.h.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseEnumValueName() {
    if (
      this._lexer.token.value === 'true' ||
      this._lexer.token.value === 'false' ||
      this._lexer.token.value === 'null'
    ) {
      throw syntaxError(
        this._lexer.source,
        this._lexer.token.start,
        `${getTokenDesc(
          this._lexer.token,
        )} is reserved and cannot be used for an enum value.`,
      );
    }

    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */

  parseInputObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */

  parseInputFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */

  parseTypeSystemExtension() {
    const keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */

  parseSchemaExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION,
      directives,
      operationTypes,
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */

  parseScalarTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */

  parseObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */

  parseInterfaceTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */

  parseUnionTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION,
      name,
      directives,
      types,
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */

  parseEnumTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values,
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */

  parseInputObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */

  parseDirectiveDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(tokenKind_TokenKind.AT);
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    const repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    const locations = this.parseDirectiveLocations();
    return this.node(start, {
      kind: kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      repeatable,
      locations,
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */

  parseDirectiveLocations() {
    return this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */

  parseDirectiveLocation() {
    const start = this._lexer.token;
    const name = this.parseName();

    if (Object.prototype.hasOwnProperty.call(DirectiveLocation, name.value)) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */

  node(startToken, node) {
    if (this._options.noLocation !== true) {
      node.loc = new ast/* Location */.Ye(
        startToken,
        this._lexer.lastToken,
        this._lexer.source,
      );
    }

    return node;
  }
  /**
   * Determines if the next token is of a given kind
   */

  peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return token;
    }

    throw syntaxError(
      this._lexer.source,
      token.start,
      `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`,
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this.advanceLexer();
    } else {
      throw syntaxError(
        this._lexer.source,
        token.start,
        `Expected "${value}", found ${getTokenDesc(token)}.`,
      );
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */

  unexpected(atToken) {
    const token =
      atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(
      this._lexer.source,
      token.start,
      `Unexpected ${getTokenDesc(token)}.`,
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      const nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */

  delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  }

  advanceLexer() {
    const { maxTokens } = this._options;

    const token = this._lexer.advance();

    if (maxTokens !== undefined && token.kind !== tokenKind_TokenKind.EOF) {
      ++this._tokenCounter;

      if (this._tokenCounter > maxTokens) {
        throw syntaxError(
          this._lexer.source,
          token.start,
          `Document contains more that ${maxTokens} tokens. Parsing aborted.`,
        );
      }
    }
  }
}
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  const value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */

function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? `"${kind}"` : kind;
}

// EXTERNAL MODULE: ../../node_modules/wonka/dist/wonka.mjs
var wonka = __webpack_require__(94177);
;// CONCATENATED MODULE: ../../node_modules/urql/node_modules/@urql/core/dist/urql-core-chunk.mjs




var rehydrateGraphQlError = e => {
  if (e instanceof GraphQLError) {
    return e;
  } else if ("object" == typeof e && e.message) {
    return new GraphQLError(e.message, e.nodes, e.source, e.positions, e.path, e, e.extensions || {});
  } else {
    return new GraphQLError(e);
  }
};

class CombinedError extends Error {
  constructor(r) {
    var e = (r.graphQLErrors || []).map(rehydrateGraphQlError);
    var t = ((r, e) => {
      var t = "";
      if (r) {
        return `[Network] ${r.message}`;
      }
      if (e) {
        for (var a of e) {
          if (t) {
            t += "\n";
          }
          t += `[GraphQL] ${a.message}`;
        }
      }
      return t;
    })(r.networkError, e);
    super(t);
    this.name = "CombinedError";
    this.message = t;
    this.graphQLErrors = e;
    this.networkError = r.networkError;
    this.response = r.response;
  }
  toString() {
    return this.message;
  }
}

var phash = (r, e) => {
  var t = "number" == typeof e ? 0 | e : 5381;
  for (var a = 0, n = 0 | r.length; a < n; a++) {
    t = (t << 5) + t + r.charCodeAt(a);
  }
  return t;
};

var o = new Set;

var i = new WeakMap;

var stringify = r => {
  if (null === r || o.has(r)) {
    return "null";
  } else if ("object" != typeof r) {
    return JSON.stringify(r) || "";
  } else if (r.toJSON) {
    return stringify(r.toJSON());
  } else if (Array.isArray(r)) {
    var e = "[";
    for (var t of r) {
      if ("[" !== e) {
        e += ",";
      }
      e += (t = stringify(t)).length > 0 ? t : "null";
    }
    return e += "]";
  }
  var a = Object.keys(r).sort();
  if (!a.length && r.constructor && r.constructor !== Object) {
    var n = i.get(r) || Math.random().toString(36).slice(2);
    i.set(r, n);
    return `{"__key":"${n}"}`;
  }
  o.add(r);
  var s = "{";
  for (var v of a) {
    var f = stringify(r[v]);
    if (f) {
      if (s.length > 1) {
        s += ",";
      }
      s += stringify(v) + ":" + f;
    }
  }
  o.delete(r);
  return s += "}";
};

var stringifyVariables = r => {
  o.clear();
  return stringify(r);
};

var s = /("{3}[\s\S]*"{3}|"(?:\\.|[^"])*")/g;

var v = /(#[^\n\r]+)?(?:\n|\r\n?|$)+/g;

var replaceOutsideStrings = (r, e) => e % 2 == 0 ? r.replace(v, "\n") : r;

var sanitizeDocument = r => r.split(s).map(replaceOutsideStrings).join("").trim();

var f = new Map;

var l = new Map;

var stringifyDocument = r => {
  var e;
  if ("string" == typeof r) {
    e = sanitizeDocument(r);
  } else if (r.loc && l.get(r.__key) === r) {
    e = r.loc.source.body;
  } else {
    e = f.get(r) || sanitizeDocument(print(r));
    f.set(r, e);
  }
  if ("string" != typeof r && !r.loc) {
    r.loc = {
      start: 0,
      end: e.length,
      source: {
        body: e,
        name: "gql",
        locationOffset: {
          line: 1,
          column: 1
        }
      }
    };
  }
  return e;
};

var hashDocument = r => {
  var e = phash(stringifyDocument(r));
  if ("object" == typeof r && "definitions" in r) {
    var t = getOperationName(r);
    if (t) {
      e = phash(`\n# ${t}`, e);
    }
  }
  return e;
};

var keyDocument = r => {
  var e;
  var t;
  if ("string" == typeof r) {
    e = hashDocument(r);
    t = l.get(e) || parse(r, {
      noLocation: !0
    });
  } else {
    e = r.__key || hashDocument(r);
    t = l.get(e) || r;
  }
  if (!t.loc) {
    stringifyDocument(t);
  }
  t.__key = e;
  l.set(e, t);
  return t;
};

var createRequest = (r, e) => {
  if (!e) {
    e = {};
  }
  var t = keyDocument(r);
  var a = stringifyVariables(e);
  var n = t.__key;
  if ("{}" !== a) {
    n = phash(a, n);
  }
  return {
    key: n,
    query: t,
    variables: e
  };
};

var getOperationName = r => {
  for (var t of r.definitions) {
    if (t.kind === kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION && t.name) {
      return t.name.value;
    }
  }
};

var getOperationType = r => {
  for (var t of r.definitions) {
    if (t.kind === e.OPERATION_DEFINITION) {
      return t.operation;
    }
  }
};

var makeResult = (r, e, t) => {
  if (!("data" in e) && !("errors" in e) || "incremental" in e) {
    throw new Error("No Content");
  }
  var a = "subscription" === r.kind;
  return {
    operation: r,
    data: e.data,
    error: Array.isArray(e.errors) ? new CombinedError({
      graphQLErrors: e.errors,
      response: t
    }) : void 0,
    extensions: "object" == typeof e.extensions && e.extensions || void 0,
    hasNext: null == e.hasNext ? a : e.hasNext
  };
};

var mergeResultPatch = (r, e, t) => {
  var a;
  var n = !!r.extensions || !!e.extensions;
  var o = {
    ...r.extensions,
    ...e.extensions
  };
  var i = r.error ? r.error.graphQLErrors : [];
  var s = e.incremental;
  if ("path" in e) {
    s = [ {
      data: e.data,
      path: e.path
    } ];
  }
  if (s) {
    a = {
      ...r.data
    };
    for (var v of s) {
      if (Array.isArray(v.errors)) {
        i.push(...v.errors);
      }
      if (v.extensions) {
        Object.assign(o, v.extensions);
        n = !0;
      }
      var f = v.path[0];
      var l = a;
      for (var u = 1, d = v.path.length; u < d; f = v.path[u++]) {
        l = l[f] = Array.isArray(l[f]) ? [ ...l[f] ] : {
          ...l[f]
        };
      }
      if (Array.isArray(v.items)) {
        var c = +f >= 0 ? f : 0;
        for (var p = 0, h = v.items.length; p < h; p++) {
          l[c + p] = v.items[p];
        }
      } else if (void 0 !== v.data) {
        l[f] = l[f] && v.data ? {
          ...l[f],
          ...v.data
        } : v.data;
      }
    }
  } else {
    a = e.data || r.data;
  }
  return {
    operation: r.operation,
    data: a,
    error: i.length ? new CombinedError({
      graphQLErrors: i,
      response: t
    }) : void 0,
    extensions: n ? o : void 0,
    hasNext: !!e.hasNext
  };
};

var makeErrorResult = (r, e, t) => ({
  operation: r,
  data: void 0,
  error: new CombinedError({
    networkError: e,
    response: t
  }),
  extensions: void 0
});

function makeFetchBody(r) {
  return {
    query: stringifyDocument(r.query),
    operationName: getOperationName(r.query),
    variables: r.variables || void 0,
    extensions: void 0
  };
}

var makeFetchURL = (r, e) => {
  var t = "query" === r.kind && r.context.preferGetMethod;
  if (!t || !e) {
    return r.context.url;
  }
  var a = new URL(r.context.url);
  var n = a.searchParams;
  if (e.operationName) {
    n.set("operationName", e.operationName);
  }
  if (e.query) {
    n.set("query", e.query);
  }
  if (e.variables) {
    n.set("variables", stringifyVariables(e.variables));
  }
  if (e.extensions) {
    n.set("extensions", stringifyVariables(e.extensions));
  }
  var o = a.toString();
  if (o.length > 2047 && "force" !== t) {
    r.context.preferGetMethod = !1;
    return r.context.url;
  }
  return o;
};

var makeFetchOptions = (r, e) => {
  var t = "query" === r.kind && !!r.context.preferGetMethod;
  var a = {
    accept: "multipart/mixed, application/graphql-response+json, application/graphql+json, application/json"
  };
  if (!t) {
    a["content-type"] = "application/json";
  }
  var n = ("function" == typeof r.context.fetchOptions ? r.context.fetchOptions() : r.context.fetchOptions) || {};
  if (n.headers) {
    for (var o in n.headers) {
      a[o.toLowerCase()] = n.headers[o];
    }
  }
  return {
    ...n,
    body: !t && e ? JSON.stringify(e) : void 0,
    method: t ? "GET" : "POST",
    headers: a
  };
};

var u = "undefined" != typeof TextDecoder ? new TextDecoder : null;

var d = /content-type:[^\r\n]*application\/json/i;

var c = /boundary="?([^=";]+)"?/i;

var makeFetchSource = (r, e, t) => {
  var a = "manual" === t.redirect ? 400 : 300;
  var o = r.context.fetch;
  return (0,wonka/* make */.Sy)((({next: n, complete: i}) => {
    var s = "undefined" != typeof AbortController ? new AbortController : null;
    if (s) {
      t.signal = s.signal;
    }
    var v = !1;
    var executeIncrementalFetch = (r, e, t) => {
      var a = t.headers && t.headers.get("Content-Type") || "";
      if (/text\//i.test(a)) {
        return t.text().then((a => {
          r(makeErrorResult(e, new Error(a), t));
        }));
      } else if (!/multipart\/mixed/i.test(a)) {
        return t.text().then((a => {
          r(makeResult(e, JSON.parse(a), t));
        }));
      }
      var n = "---";
      var o = a.match(c);
      if (o) {
        n = "--" + o[1];
      }
      var i;
      var cancel = () => {};
      if (t[Symbol.asyncIterator]) {
        var s = t[Symbol.asyncIterator]();
        i = s.next.bind(s);
      } else if ("body" in t && t.body) {
        var f = t.body.getReader();
        cancel = () => f.cancel();
        i = () => f.read();
      } else {
        throw new TypeError("Streaming requests unsupported");
      }
      var l = "";
      var p = !0;
      var h = null;
      var y = null;
      return i().then((function next(a) {
        if (!a.done) {
          var o = "Buffer" === (w = a.value).constructor.name ? w.toString() : u.decode(w);
          var s = o.indexOf(n);
          if (s > -1) {
            s += l.length;
          } else {
            s = l.indexOf(n);
          }
          l += o;
          while (s > -1) {
            var f = l.slice(0, s);
            var c = l.slice(s + n.length);
            if (p) {
              p = !1;
            } else {
              var x = f.indexOf("\r\n\r\n") + 4;
              var m = f.slice(0, x);
              var g = f.slice(x, f.lastIndexOf("\r\n"));
              var b = void 0;
              if (d.test(m)) {
                try {
                  b = JSON.parse(g);
                  h = y = y ? mergeResultPatch(y, b, t) : makeResult(e, b, t);
                } catch (r) {}
              }
              if ("--" === c.slice(0, 2) || b && !b.hasNext) {
                if (!y) {
                  return r(makeResult(e, {}, t));
                }
                break;
              }
            }
            s = (l = c).indexOf(n);
          }
        } else {
          v = !0;
        }
        var w;
        if (h) {
          r(h);
          h = null;
        }
        if (!a.done && (!y || y.hasNext)) {
          return i().then(next);
        }
      })).finally(cancel);
    };
    var f = !1;
    var l = !1;
    var p;
    Promise.resolve().then((() => {
      if (f) {
        return;
      }
      return (o || fetch)(e, t);
    })).then((e => {
      if (!e) {
        return;
      }
      l = (p = e).status < 200 || p.status >= a;
      return executeIncrementalFetch(n, r, p);
    })).then(i).catch((e => {
      if (v) {
        throw e;
      }
      var t = makeErrorResult(r, l ? p.statusText ? new Error(p.statusText) : e : e, p);
      n(t);
      i();
    }));
    return () => {
      f = !0;
      if (s) {
        s.abort();
      }
    };
  }));
};


//# sourceMappingURL=urql-core-chunk.mjs.map


/***/ }),

/***/ 54569:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Y": function() { return /* binding */ ssrExchange; },
/* harmony export */   "B5": function() { return /* binding */ dedupExchange; },
/* harmony export */   "Ek": function() { return /* binding */ fetchExchange; },
/* harmony export */   "HG": function() { return /* binding */ cacheExchange; },
/* harmony export */   "eI": function() { return /* binding */ $; },
/* harmony export */   "vx": function() { return /* binding */ makeOperation; }
/* harmony export */ });
/* unused harmony exports Client, composeExchanges, debugExchange, defaultExchanges, errorExchange, formatDocument, gql, mapExchange, maskTypename, subscriptionExchange */
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95115);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58867);
/* harmony import */ var _urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29041);
/* harmony import */ var wonka__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94177);








var collectTypes = (e, r) => {
  if (Array.isArray(e)) {
    for (var t of e) {
      collectTypes(t, r);
    }
  } else if ("object" == typeof e && null !== e) {
    for (var a in e) {
      if ("__typename" === a && "string" == typeof e[a]) {
        r.add(e[a]);
      } else {
        collectTypes(e[a], r);
      }
    }
  }
  return r;
};

var formatNode = e => {
  if (!e.selectionSet) {
    return e;
  }
  for (var t of e.selectionSet.selections) {
    if (t.kind === graphql__WEBPACK_IMPORTED_MODULE_0__/* .Kind.FIELD */ .h.FIELD && "__typename" === t.name.value && !t.alias) {
      return e;
    }
  }
  return {
    ...e,
    selectionSet: {
      ...e.selectionSet,
      selections: [ ...e.selectionSet.selections, {
        kind: graphql__WEBPACK_IMPORTED_MODULE_0__/* .Kind.FIELD */ .h.FIELD,
        name: {
          kind: graphql__WEBPACK_IMPORTED_MODULE_0__/* .Kind.NAME */ .h.NAME,
          value: "__typename"
        }
      } ]
    }
  };
};

var I = new Map;

var formatDocument = r => {
  var a = (0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.k)(r);
  var n = I.get(a.__key);
  if (!n) {
    n = (0,graphql__WEBPACK_IMPORTED_MODULE_2__/* .visit */ .Vn)(a, {
      Field: formatNode,
      InlineFragment: formatNode
    });
    Object.defineProperty(n, "__key", {
      value: a.__key,
      enumerable: !1
    });
    I.set(a.__key, n);
  }
  return n;
};

var maskTypename = (e, r) => {
  if (!e || "object" != typeof e) {
    return e;
  } else if (Array.isArray(e)) {
    return e.map((e => maskTypename(e)));
  } else if (e && "object" == typeof e && (r || "__typename" in e)) {
    var t = {};
    for (var a in e) {
      if ("__typename" === a) {
        Object.defineProperty(t, "__typename", {
          enumerable: !1,
          value: e.__typename
        });
      } else {
        t[a] = maskTypename(e[a]);
      }
    }
    return t;
  } else {
    return e;
  }
};

function withPromise(e) {
  e.toPromise = () => new Promise((r => {
    var t = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .subscribe */ .Ld)((e => {
      if (!e.stale && !e.hasNext) {
        Promise.resolve().then((() => {
          t.unsubscribe();
          r(e);
        }));
      }
    }))(e);
  }));
  return e;
}

function makeOperation(e, r, t) {
  if (!t) {
    t = r.context;
  }
  return {
    key: r.key,
    query: r.query,
    variables: r.variables,
    kind: e,
    context: t
  };
}

var addMetadata = (e, r) => makeOperation(e.kind, e, {
  ...e.context,
  meta: {
    ...e.context.meta,
    ...r
  }
});

var noop = () => {};

var applyDefinitions = (e, t, a) => {
  for (var o of a) {
    if (o.kind === r.FRAGMENT_DEFINITION) {
      var i = o.name.value;
      var s = n(o);
      if (!e.has(i)) {
        e.set(i, s);
        t.push(o);
      } else if (false) {}
    } else {
      t.push(o);
    }
  }
};

function gql() {
  var e = new Map;
  var a = [];
  var n = [];
  var o = Array.isArray(arguments[0]) ? arguments[0][0] : arguments[0] || "";
  for (var i = 1; i < arguments.length; i++) {
    var s = arguments[i];
    if (s && s.definitions) {
      n.push(...s.definitions);
    } else {
      o += s;
    }
    o += arguments[0][i];
  }
  applyDefinitions(e, a, t(o).definitions);
  applyDefinitions(e, a, n);
  return t({
    kind: r.DOCUMENT,
    definitions: a
  });
}

var shouldSkip = ({kind: e}) => "mutation" !== e && "query" !== e;

var cacheExchange = ({forward: e, client: r, dispatchDebug: t}) => {
  var a = new Map;
  var n = new Map;
  var mapTypeNames = e => {
    var r = makeOperation(e.kind, e);
    r.query = formatDocument(e.query);
    return r;
  };
  var isOperationCached = e => {
    var {key: r, kind: t, context: {requestPolicy: n}} = e;
    return "query" === t && "network-only" !== n && ("cache-only" === n || a.has(r));
  };
  return o => {
    var i = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .share */ .BN)(o);
    var s = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)((e => {
      var n = a.get(e.key);
       false && 0;
      var o = {
        ...n,
        operation: addMetadata(e, {
          cacheOutcome: n ? "hit" : "miss"
        })
      };
      if ("cache-and-network" === e.context.requestPolicy) {
        o.stale = !0;
        reexecuteOperation(r, e);
      }
      return o;
    }))((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .hX)((e => !shouldSkip(e) && isOperationCached(e)))(i));
    var u = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .tap */ .bw)((e => {
      var {operation: o} = e;
      if (!o) {
        return;
      }
      var i = (e => [ ...collectTypes(e, new Set) ])(e.data).concat(o.context.additionalTypenames || []);
      if ("mutation" === e.operation.kind) {
        var s = new Set;
         false && 0;
        for (var u = 0; u < i.length; u++) {
          var c = i[u];
          var p = n.get(c);
          if (!p) {
            n.set(c, p = new Set);
          }
          for (var v of p.values()) {
            s.add(v);
          }
          p.clear();
        }
        for (var l of s.values()) {
          if (a.has(l)) {
            o = a.get(l).operation;
            a.delete(l);
            reexecuteOperation(r, o);
          }
        }
      } else if ("query" === o.kind && e.data) {
        a.set(o.key, e);
        for (var d = 0; d < i.length; d++) {
          var f = i[d];
          var h = n.get(f);
          if (!h) {
            n.set(f, h = new Set);
          }
          h.add(o.key);
        }
      }
    }))(e((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .hX)((e => "query" !== e.kind || "cache-only" !== e.context.requestPolicy))((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)((e => addMetadata(e, {
      cacheOutcome: "miss"
    })))((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .merge */ .TS)([ (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)(mapTypeNames)((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .hX)((e => !shouldSkip(e) && !isOperationCached(e)))(i)), (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .hX)((e => shouldSkip(e)))(i) ])))));
    return (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .merge */ .TS)([ s, u ]);
  };
};

var reexecuteOperation = (e, r) => e.reexecuteOperation(makeOperation(r.kind, r, {
  ...r.context,
  requestPolicy: "network-only"
}));

var F = new Set;

var ssrExchange = (e = {}) => {
  var r = !!e.staleWhileRevalidate;
  var t = !!e.includeExtensions;
  var a = {};
  var n = [];
  var invalidate = e => {
    n.push(e.operation.key);
    if (1 === n.length) {
      Promise.resolve().then((() => {
        var e;
        while (e = n.shift()) {
          a[e] = null;
        }
      }));
    }
  };
  var ssr = ({client: n, forward: i}) => s => {
    var u = e && "boolean" == typeof e.isClient ? !!e.isClient : !n.suspense;
    var c = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .share */ .BN)(s);
    var p = i((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .hX)((e => !a[e.key] || !!a[e.key].hasNext || "network-only" === e.context.requestPolicy))(c));
    var v = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)((e => {
      var i = ((e, r, t) => ({
        operation: e,
        data: r.data ? JSON.parse(r.data) : void 0,
        extensions: t && r.extensions ? JSON.parse(r.extensions) : void 0,
        error: r.error ? new _urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.C({
          networkError: r.error.networkError ? new Error(r.error.networkError) : void 0,
          graphQLErrors: r.error.graphQLErrors
        }) : void 0,
        hasNext: r.hasNext
      }))(e, a[e.key], t);
      if (r && !F.has(e.key)) {
        i.stale = !0;
        F.add(e.key);
        reexecuteOperation(n, e);
      }
      return {
        ...i,
        operation: addMetadata(e, {
          cacheOutcome: "hit"
        })
      };
    }))((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .hX)((e => !!a[e.key] && "network-only" !== e.context.requestPolicy))(c));
    if (!u) {
      p = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .tap */ .bw)((e => {
        var {operation: r} = e;
        if ("mutation" !== r.kind) {
          var n = (({hasNext: e, data: r, extensions: t, error: a}, n) => {
            var o = {};
            if (void 0 !== r) {
              o.data = JSON.stringify(r);
            }
            if (n && void 0 !== t) {
              o.extensions = JSON.stringify(t);
            }
            if (e) {
              o.hasNext = !0;
            }
            if (a) {
              o.error = {
                graphQLErrors: a.graphQLErrors.map((e => {
                  if (!e.path && !e.extensions) {
                    return e.message;
                  }
                  return {
                    message: e.message,
                    path: e.path,
                    extensions: e.extensions
                  };
                }))
              };
              if (a.networkError) {
                o.error.networkError = "" + a.networkError;
              }
            }
            return o;
          })(e, t);
          a[r.key] = n;
        }
      }))(p);
    } else {
      v = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .tap */ .bw)(invalidate)(v);
    }
    return (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .merge */ .TS)([ p, v ]);
  };
  ssr.restoreData = e => {
    for (var r in e) {
      if (null !== a[r]) {
        a[r] = e[r];
      }
    }
  };
  ssr.extractData = () => {
    var e = {};
    for (var r in a) {
      if (null != a[r]) {
        e[r] = a[r];
      }
    }
    return e;
  };
  if (e && e.initialState) {
    ssr.restoreData(e.initialState);
  }
  return ssr;
};

var subscriptionExchange = ({forwardSubscription: e, enableAllOperations: r, isSubscriptionOperation: t}) => ({client: a, forward: o}) => {
  var i = t || (e => {
    var {kind: t} = e;
    return "subscription" === t || !!r && ("query" === t || "mutation" === t);
  });
  return r => {
    var t = g(r);
    var c = O((r => {
      var {key: o} = r;
      var i = w((e => "teardown" === e.kind && e.key === o))(t);
      return q(i)((r => {
        var t = e({
          key: r.key.toString(36),
          query: n(r.query),
          variables: r.variables,
          context: {
            ...r.context
          }
        });
        return N((({next: e, complete: n}) => {
          var o = !1;
          var i;
          Promise.resolve().then((() => {
            if (o) {
              return;
            }
            i = t.subscribe({
              next: t => e(s(r, t)),
              error: t => e(u(r, t)),
              complete: () => {
                if (!o) {
                  o = !0;
                  if ("subscription" === r.kind) {
                    a.reexecuteOperation(makeOperation("teardown", r, r.context));
                  }
                  n();
                }
              }
            });
          }));
          return () => {
            o = !0;
            if (i) {
              i.unsubscribe();
            }
          };
        }));
      })(r));
    }))(w(i)(t));
    var p = o(w((e => !i(e)))(t));
    return E([ c, p ]);
  };
};

var debugExchange = ({forward: e}) => {
  if (true) {
    return r => e(r);
  } else {}
};

var dedupExchange = ({forward: e, dispatchDebug: r}) => {
  var t = new Set;
  var filterIncomingOperation = e => {
    var {key: a, kind: n} = e;
    if ("teardown" === n || "mutation" === n) {
      t.delete(a);
      return !0;
    }
    var o = t.has(a);
    t.add(a);
    if (o) {
       false && 0;
    }
    return !o;
  };
  var afterOperationResult = ({operation: e, hasNext: r}) => {
    if (!r) {
      t.delete(e.key);
    }
  };
  return r => {
    var t = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .hX)(filterIncomingOperation)(r);
    return (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .tap */ .bw)(afterOperationResult)(e(t));
  };
};

var fetchExchange = ({forward: e, dispatchDebug: r}) => t => {
  var a = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .share */ .BN)(t);
  var n = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .mergeMap */ .zg)((e => {
    var {key: t} = e;
    var n = (0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.b)(e);
    var o = (0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.c)(e, n);
    var i = (0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.d)(e, n);
     false && 0;
    var s = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .takeUntil */ .Rs)((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .hX)((e => "teardown" === e.kind && e.key === t))(a))((0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.e)(e, o, i));
    if (false) {}
    return s;
  }))((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .hX)((e => "query" === e.kind || "mutation" === e.kind))(a));
  var o = e((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .hX)((e => "query" !== e.kind && "mutation" !== e.kind))(a));
  return (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .merge */ .TS)([ n, o ]);
};

var composeExchanges = e => ({client: r, forward: t, dispatchDebug: a}) => e.reduceRight(((e, t) => t({
  client: r,
  forward: e,
  dispatchDebug(e) {
     false && 0;
  }
})), t);

var mapExchange = ({onOperation: e, onResult: r, onError: t}) => ({forward: a}) => n => O((e => {
  if (t && e.error) {
    t(e.error, e.operation);
  }
  var a = r && r(e) || e;
  return "then" in a ? D(a) : P(a);
}))(a(O((r => {
  var t = e && e(r) || r;
  return "then" in t ? D(t) : P(t);
}))(n)));

var Q = [ dedupExchange, cacheExchange, fetchExchange ];

var fallbackExchange = ({dispatchDebug: e}) => r => (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .hX)((() => !1))((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .tap */ .bw)((r => {
  if ("teardown" !== r.kind && "production" !== "production") { var t; }
}))(r));

var L = function Client(e) {
  if (false) {}
  var r = 0;
  var t = new Map;
  var a = new Map;
  var n = [];
  var o = {
    url: e.url,
    fetchOptions: e.fetchOptions,
    fetch: e.fetch,
    preferGetMethod: !!e.preferGetMethod,
    requestPolicy: e.requestPolicy || "cache-first"
  };
  var {source: i, next: s} = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .makeSubject */ .nN)();
  var u = !1;
  function dispatchOperation(e) {
    if (e) {
      s(e);
    }
    if (!u) {
      u = !0;
      while (u && (e = n.shift())) {
        s(e);
      }
      u = !1;
    }
  }
  var makeResultSource = r => {
    var o = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .hX)((e => e.operation.kind === r.kind && e.operation.key === r.key && (!e.operation.context._instance || e.operation.context._instance === r.context._instance)))(m);
    if (e.maskTypename) {
      o = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)((e => ({
        ...e,
        data: maskTypename(e.data, !0)
      })))(o);
    }
    if ("mutation" === r.kind) {
      return (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .take */ .qn)(1)((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .onStart */ .Hr)((() => s(r)))(o));
    }
    return (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .share */ .BN)((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .onEnd */ .ok)((() => {
      t.delete(r.key);
      a.delete(r.key);
      for (var e = n.length - 1; e >= 0; e--) {
        if (n[e].key === r.key) {
          n.splice(e, 1);
        }
      }
      s(makeOperation("teardown", r, r.context));
    }))((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .onPush */ .Mq)((e => {
      t.set(r.key, e);
    }))((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .switchMap */ .wt)((e => {
      if ("query" !== r.kind || e.stale) {
        return (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .fromValue */ ._A)(e);
      }
      return (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .merge */ .TS)([ (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .fromValue */ ._A)(e), (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .map */ .UI)((() => ({
        ...e,
        stale: !0
      })))((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .take */ .qn)(1)((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .hX)((e => "query" === e.kind && e.key === r.key && "cache-only" !== e.context.requestPolicy))(i))) ]);
    }))((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .takeUntil */ .Rs)((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .filter */ .hX)((e => "teardown" === e.kind && e.key === r.key))(i))(o)))));
  };
  var c = this instanceof Client ? this : Object.create(Client.prototype);
  var p = Object.assign(c, {
    suspense: !!e.suspense,
    operations$: i,
    reexecuteOperation(e) {
      if ("mutation" === e.kind || a.has(e.key)) {
        n.push(e);
        Promise.resolve().then(dispatchOperation);
      }
    },
    createRequestOperation(e, t, a) {
      if (!a) {
        a = {};
      }
      var n;
      if (false) {}
      return makeOperation(e, t, {
        _instance: "mutation" === e ? r = r + 1 | 0 : void 0,
        ...o,
        ...a,
        requestPolicy: a.requestPolicy || o.requestPolicy,
        suspense: a.suspense || !1 !== a.suspense && p.suspense
      });
    },
    executeRequestOperation(e) {
      if ("mutation" === e.kind) {
        return makeResultSource(e);
      }
      return (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .make */ .Sy)((r => {
        var n = a.get(e.key);
        if (!n) {
          a.set(e.key, n = makeResultSource(e));
        }
        var o = "cache-and-network" === e.context.requestPolicy || "network-only" === e.context.requestPolicy;
        return (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .subscribe */ .Ld)(r.next)((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .onEnd */ .ok)((() => {
          u = !1;
          r.complete();
        }))((0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .onStart */ .Hr)((() => {
          var a = t.get(e.key);
          if ("subscription" === e.kind) {
            return dispatchOperation(e);
          } else if (o) {
            dispatchOperation(e);
          }
          if (null != a && a === t.get(e.key)) {
            r.next(o ? {
              ...a,
              stale: !0
            } : a);
          } else if (!o) {
            dispatchOperation(e);
          }
        }))(n))).unsubscribe;
      }));
    },
    executeQuery(e, r) {
      var t = p.createRequestOperation("query", e, r);
      return p.executeRequestOperation(t);
    },
    executeSubscription(e, r) {
      var t = p.createRequestOperation("subscription", e, r);
      return p.executeRequestOperation(t);
    },
    executeMutation(e, r) {
      var t = p.createRequestOperation("mutation", e, r);
      return p.executeRequestOperation(t);
    },
    query(e, r, t) {
      if (!t || "boolean" != typeof t.suspense) {
        t = {
          ...t,
          suspense: !1
        };
      }
      return withPromise(p.executeQuery((0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.f)(e, r), t));
    },
    readQuery(e, r, t) {
      var a = null;
      (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .subscribe */ .Ld)((e => {
        a = e;
      }))(p.query(e, r, t)).unsubscribe();
      return a;
    },
    subscription: (e, r, t) => p.executeSubscription((0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.f)(e, r), t),
    mutation: (e, r, t) => withPromise(p.executeMutation((0,_urql_core_chunk_mjs__WEBPACK_IMPORTED_MODULE_1__.f)(e, r), t))
  });
  var v = noop;
  if (false) { var f, l; }
  var h = composeExchanges(void 0 !== e.exchanges ? e.exchanges : Q);
  var m = (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .share */ .BN)(h({
    client: p,
    dispatchDebug: v,
    forward: fallbackExchange({
      dispatchDebug: v
    })
  })(i));
  (0,wonka__WEBPACK_IMPORTED_MODULE_3__/* .publish */ .nY)(m);
  return p;
};

var $ = L;


//# sourceMappingURL=urql-core.mjs.map


/***/ }),

/***/ 94177:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BN": function() { return /* binding */ share; },
/* harmony export */   "Hr": function() { return /* binding */ onStart; },
/* harmony export */   "Ld": function() { return /* binding */ subscribe; },
/* harmony export */   "Mq": function() { return /* binding */ onPush; },
/* harmony export */   "Rs": function() { return /* binding */ takeUntil; },
/* harmony export */   "Sy": function() { return /* binding */ make; },
/* harmony export */   "TS": function() { return /* binding */ merge; },
/* harmony export */   "UI": function() { return /* binding */ map; },
/* harmony export */   "Vi": function() { return /* binding */ toPromise; },
/* harmony export */   "Vo": function() { return /* binding */ lazy; },
/* harmony export */   "_A": function() { return /* binding */ fromValue; },
/* harmony export */   "bw": function() { return /* binding */ onPush; },
/* harmony export */   "cS": function() { return /* binding */ empty; },
/* harmony export */   "hX": function() { return /* binding */ filter; },
/* harmony export */   "nN": function() { return /* binding */ makeSubject; },
/* harmony export */   "nY": function() { return /* binding */ publish; },
/* harmony export */   "oE": function() { return /* binding */ takeWhile; },
/* harmony export */   "ok": function() { return /* binding */ onEnd; },
/* harmony export */   "p4": function() { return /* binding */ fromPromise; },
/* harmony export */   "qn": function() { return /* binding */ take; },
/* harmony export */   "wt": function() { return /* binding */ switchMap; },
/* harmony export */   "zg": function() { return /* binding */ mergeMap; }
/* harmony export */ });
/* unused harmony exports buffer, combine, concat, concatAll, concatMap, debounce, delay, flatten, forEach, fromArray, fromAsyncIterable, fromCallbag, fromDomEvent, fromIterable, fromObservable, interval, mergeAll, never, pipe, sample, scan, skip, skipUntil, skipWhile, switchAll, takeLast, throttle, toArray, toAsyncIterable, toCallbag, toObservable, zip */
var teardownPlaceholder = () => {};

var e = teardownPlaceholder;

function start(e) {
  return {
    tag: 0,
    0: e
  };
}

function push(e) {
  return {
    tag: 1,
    0: e
  };
}

var asyncIteratorSymbol = () => "function" == typeof Symbol && Symbol.asyncIterator || "@@asyncIterator";

var observableSymbol = () => "function" == typeof Symbol && Symbol.observable || "@@observable";

var identity = e => e;

function buffer(r) {
  return t => i => {
    var a = [];
    var f = e;
    var n = e;
    var s = !1;
    var l = !1;
    t((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        n(1);
        if (a.length) {
          i(push(a));
        }
        i(0);
      } else if (0 === e.tag) {
        f = e[0];
        r((e => {
          if (l) {} else if (0 === e) {
            l = !0;
            f(1);
            if (a.length) {
              i(push(a));
            }
            i(0);
          } else if (0 === e.tag) {
            n = e[0];
          } else if (a.length) {
            var r = push(a);
            a = [];
            i(r);
          }
        }));
      } else {
        a.push(e[0]);
        if (!s) {
          s = !0;
          f(0);
          n(0);
        } else {
          s = !1;
        }
      }
    }));
    i(start((e => {
      if (1 === e && !l) {
        l = !0;
        f(1);
        n(1);
      } else if (!l && !s) {
        s = !0;
        f(0);
        n(0);
      }
    })));
  };
}

function concatMap(r) {
  return t => i => {
    var a = [];
    var f = e;
    var n = e;
    var s = !1;
    var l = !1;
    var u = !1;
    var o = !1;
    function applyInnerSource(e) {
      u = !0;
      e((e => {
        if (0 === e) {
          if (u) {
            u = !1;
            if (a.length) {
              applyInnerSource(r(a.shift()));
            } else if (o) {
              i(0);
            } else if (!s) {
              s = !0;
              f(0);
            }
          }
        } else if (0 === e.tag) {
          l = !1;
          (n = e[0])(0);
        } else if (u) {
          i(e);
          if (l) {
            l = !1;
          } else {
            n(0);
          }
        }
      }));
    }
    t((e => {
      if (o) {} else if (0 === e) {
        o = !0;
        if (!u && !a.length) {
          i(0);
        }
      } else if (0 === e.tag) {
        f = e[0];
      } else {
        s = !1;
        if (u) {
          a.push(e[0]);
        } else {
          applyInnerSource(r(e[0]));
        }
      }
    }));
    i(start((e => {
      if (1 === e) {
        if (!o) {
          o = !0;
          f(1);
        }
        if (u) {
          u = !1;
          n(1);
        }
      } else {
        if (!o && !s) {
          s = !0;
          f(0);
        }
        if (u && !l) {
          l = !0;
          n(0);
        }
      }
    })));
  };
}

function concatAll(e) {
  return concatMap(identity)(e);
}

function concat(e) {
  return concatAll(r(e));
}

function filter(r) {
  return t => i => {
    var a = e;
    t((e => {
      if (0 === e) {
        i(0);
      } else if (0 === e.tag) {
        a = e[0];
        i(e);
      } else if (!r(e[0])) {
        a(0);
      } else {
        i(e);
      }
    }));
  };
}

function map(e) {
  return r => t => r((r => {
    if (0 === r || 0 === r.tag) {
      t(r);
    } else {
      t(push(e(r[0])));
    }
  }));
}

function mergeMap(r) {
  return t => i => {
    var a = [];
    var f = e;
    var n = !1;
    var s = !1;
    t((t => {
      if (s) {} else if (0 === t) {
        s = !0;
        if (!a.length) {
          i(0);
        }
      } else if (0 === t.tag) {
        f = t[0];
      } else {
        n = !1;
        !function applyInnerSource(r) {
          var t = e;
          r((e => {
            if (0 === e) {
              if (a.length) {
                var r = a.indexOf(t);
                if (r > -1) {
                  (a = a.slice()).splice(r, 1);
                }
                if (!a.length) {
                  if (s) {
                    i(0);
                  } else if (!n) {
                    n = !0;
                    f(0);
                  }
                }
              }
            } else if (0 === e.tag) {
              a.push(t = e[0]);
              t(0);
            } else if (a.length) {
              i(e);
              t(0);
            }
          }));
        }(r(t[0]));
        if (!n) {
          n = !0;
          f(0);
        }
      }
    }));
    i(start((e => {
      if (1 === e) {
        if (!s) {
          s = !0;
          f(1);
        }
        for (var r = 0, t = a, i = a.length; r < i; r++) {
          t[r](1);
        }
        a.length = 0;
      } else {
        if (!s && !n) {
          n = !0;
          f(0);
        } else {
          n = !1;
        }
        for (var l = 0, u = a, o = a.length; l < o; l++) {
          u[l](0);
        }
      }
    })));
  };
}

function mergeAll(e) {
  return mergeMap(identity)(e);
}

function merge(e) {
  return mergeAll(r(e));
}

function onEnd(e) {
  return r => t => {
    var i = !1;
    r((r => {
      if (i) {} else if (0 === r) {
        i = !0;
        t(0);
        e();
      } else if (0 === r.tag) {
        var a = r[0];
        t(start((r => {
          if (1 === r) {
            i = !0;
            a(1);
            e();
          } else {
            a(r);
          }
        })));
      } else {
        t(r);
      }
    }));
  };
}

function onPush(e) {
  return r => t => {
    var i = !1;
    r((r => {
      if (i) {} else if (0 === r) {
        i = !0;
        t(0);
      } else if (0 === r.tag) {
        var a = r[0];
        t(start((e => {
          if (1 === e) {
            i = !0;
          }
          a(e);
        })));
      } else {
        e(r[0]);
        t(r);
      }
    }));
  };
}

function onStart(e) {
  return r => t => r((r => {
    if (0 === r) {
      t(0);
    } else if (0 === r.tag) {
      t(r);
      e();
    } else {
      t(r);
    }
  }));
}

function sample(r) {
  return t => i => {
    var a = e;
    var f = e;
    var n;
    var s = !1;
    var l = !1;
    t((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        f(1);
        i(0);
      } else if (0 === e.tag) {
        a = e[0];
      } else {
        n = e[0];
        if (!s) {
          s = !0;
          f(0);
          a(0);
        } else {
          s = !1;
        }
      }
    }));
    r((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        a(1);
        i(0);
      } else if (0 === e.tag) {
        f = e[0];
      } else if (void 0 !== n) {
        var r = push(n);
        n = void 0;
        i(r);
      }
    }));
    i(start((e => {
      if (1 === e && !l) {
        l = !0;
        a(1);
        f(1);
      } else if (!l && !s) {
        s = !0;
        a(0);
        f(0);
      }
    })));
  };
}

function scan(e, r) {
  return t => i => {
    var a = r;
    t((r => {
      if (0 === r) {
        i(0);
      } else if (0 === r.tag) {
        i(r);
      } else {
        i(push(a = e(a, r[0])));
      }
    }));
  };
}

function share(r) {
  var t = [];
  var i = e;
  var a = !1;
  return e => {
    t.push(e);
    if (1 === t.length) {
      r((e => {
        if (0 === e) {
          for (var r = 0, f = t, n = t.length; r < n; r++) {
            f[r](0);
          }
          t.length = 0;
        } else if (0 === e.tag) {
          i = e[0];
        } else {
          a = !1;
          for (var s = 0, l = t, u = t.length; s < u; s++) {
            l[s](e);
          }
        }
      }));
    }
    e(start((r => {
      if (1 === r) {
        var f = t.indexOf(e);
        if (f > -1) {
          (t = t.slice()).splice(f, 1);
        }
        if (!t.length) {
          i(1);
        }
      } else if (!a) {
        a = !0;
        i(0);
      }
    })));
  };
}

function skip(r) {
  return t => i => {
    var a = e;
    var f = r;
    t((e => {
      if (0 === e) {
        i(0);
      } else if (0 === e.tag) {
        a = e[0];
        i(e);
      } else if (f-- > 0) {
        a(0);
      } else {
        i(e);
      }
    }));
  };
}

function skipUntil(r) {
  return t => i => {
    var a = e;
    var f = e;
    var n = !0;
    var s = !1;
    var l = !1;
    t((e => {
      if (l) {} else if (0 === e) {
        l = !0;
        if (n) {
          f(1);
        }
        i(0);
      } else if (0 === e.tag) {
        a = e[0];
        r((e => {
          if (0 === e) {
            if (n) {
              l = !0;
              a(1);
            }
          } else if (0 === e.tag) {
            (f = e[0])(0);
          } else {
            n = !1;
            f(1);
          }
        }));
      } else if (!n) {
        s = !1;
        i(e);
      } else if (!s) {
        s = !0;
        a(0);
        f(0);
      } else {
        s = !1;
      }
    }));
    i(start((e => {
      if (1 === e && !l) {
        l = !0;
        a(1);
        if (n) {
          f(1);
        }
      } else if (!l && !s) {
        s = !0;
        if (n) {
          f(0);
        }
        a(0);
      }
    })));
  };
}

function skipWhile(r) {
  return t => i => {
    var a = e;
    var f = !0;
    t((e => {
      if (0 === e) {
        i(0);
      } else if (0 === e.tag) {
        a = e[0];
        i(e);
      } else if (f) {
        if (r(e[0])) {
          a(0);
        } else {
          f = !1;
          i(e);
        }
      } else {
        i(e);
      }
    }));
  };
}

function switchMap(r) {
  return t => i => {
    var a = e;
    var f = e;
    var n = !1;
    var s = !1;
    var l = !1;
    var u = !1;
    t((t => {
      if (u) {} else if (0 === t) {
        u = !0;
        if (!l) {
          i(0);
        }
      } else if (0 === t.tag) {
        a = t[0];
      } else {
        if (l) {
          f(1);
          f = e;
        }
        if (!n) {
          n = !0;
          a(0);
        } else {
          n = !1;
        }
        !function applyInnerSource(e) {
          l = !0;
          e((e => {
            if (!l) {} else if (0 === e) {
              l = !1;
              if (u) {
                i(0);
              } else if (!n) {
                n = !0;
                a(0);
              }
            } else if (0 === e.tag) {
              s = !1;
              (f = e[0])(0);
            } else {
              i(e);
              if (!s) {
                f(0);
              } else {
                s = !1;
              }
            }
          }));
        }(r(t[0]));
      }
    }));
    i(start((e => {
      if (1 === e) {
        if (!u) {
          u = !0;
          a(1);
        }
        if (l) {
          l = !1;
          f(1);
        }
      } else {
        if (!u && !n) {
          n = !0;
          a(0);
        }
        if (l && !s) {
          s = !0;
          f(0);
        }
      }
    })));
  };
}

function switchAll(e) {
  return switchMap(identity)(e);
}

function take(r) {
  return t => i => {
    var a = e;
    var f = !1;
    var n = 0;
    t((e => {
      if (f) {} else if (0 === e) {
        f = !0;
        i(0);
      } else if (0 === e.tag) {
        if (r <= 0) {
          f = !0;
          i(0);
          e[0](1);
        } else {
          a = e[0];
        }
      } else if (n++ < r) {
        i(e);
        if (!f && n >= r) {
          f = !0;
          i(0);
          a(1);
        }
      } else {
        i(e);
      }
    }));
    i(start((e => {
      if (1 === e && !f) {
        f = !0;
        a(1);
      } else if (0 === e && !f && n < r) {
        a(0);
      }
    })));
  };
}

function takeLast(t) {
  return i => a => {
    var f = [];
    var n = e;
    i((e => {
      if (0 === e) {
        r(f)(a);
      } else if (0 === e.tag) {
        if (t <= 0) {
          e[0](1);
          r(f)(a);
        } else {
          (n = e[0])(0);
        }
      } else {
        if (f.length >= t && t) {
          f.shift();
        }
        f.push(e[0]);
        n(0);
      }
    }));
  };
}

function takeUntil(r) {
  return t => i => {
    var a = e;
    var f = e;
    var n = !1;
    t((e => {
      if (n) {} else if (0 === e) {
        n = !0;
        f(1);
        i(0);
      } else if (0 === e.tag) {
        a = e[0];
        r((e => {
          if (0 === e) {} else if (0 === e.tag) {
            (f = e[0])(0);
          } else {
            n = !0;
            f(1);
            a(1);
            i(0);
          }
        }));
      } else {
        i(e);
      }
    }));
    i(start((e => {
      if (1 === e && !n) {
        n = !0;
        a(1);
        f(1);
      } else if (!n) {
        a(0);
      }
    })));
  };
}

function takeWhile(r, t) {
  return i => a => {
    var f = e;
    var n = !1;
    i((e => {
      if (n) {} else if (0 === e) {
        n = !0;
        a(0);
      } else if (0 === e.tag) {
        f = e[0];
        a(e);
      } else if (!r(e[0])) {
        n = !0;
        if (t) {
          a(e);
        }
        a(0);
        f(1);
      } else {
        a(e);
      }
    }));
  };
}

function debounce(e) {
  return r => t => {
    var i;
    var a = !1;
    var f = !1;
    r((r => {
      if (f) {} else if (0 === r) {
        f = !0;
        if (i) {
          a = !0;
        } else {
          t(0);
        }
      } else if (0 === r.tag) {
        var n = r[0];
        t(start((e => {
          if (1 === e && !f) {
            f = !0;
            a = !1;
            if (i) {
              clearTimeout(i);
            }
            n(1);
          } else if (!f) {
            n(0);
          }
        })));
      } else {
        if (i) {
          clearTimeout(i);
        }
        i = setTimeout((() => {
          i = void 0;
          t(r);
          if (a) {
            t(0);
          }
        }), e(r[0]));
      }
    }));
  };
}

function delay(e) {
  return r => t => {
    var i = 0;
    r((r => {
      if (0 !== r && 0 === r.tag) {
        t(r);
      } else {
        i++;
        setTimeout((() => {
          if (i) {
            i--;
            t(r);
          }
        }), e);
      }
    }));
  };
}

function throttle(e) {
  return r => t => {
    var i = !1;
    var a;
    r((r => {
      if (0 === r) {
        if (a) {
          clearTimeout(a);
        }
        t(0);
      } else if (0 === r.tag) {
        var f = r[0];
        t(start((e => {
          if (1 === e) {
            if (a) {
              clearTimeout(a);
            }
            f(1);
          } else {
            f(0);
          }
        })));
      } else if (!i) {
        i = !0;
        if (a) {
          clearTimeout(a);
        }
        a = setTimeout((() => {
          a = void 0;
          i = !1;
        }), e(r[0]));
        t(r);
      }
    }));
  };
}

function lazy(e) {
  return r => e()(r);
}

function fromAsyncIterable(e) {
  return r => {
    var t = e[asyncIteratorSymbol()] && e[asyncIteratorSymbol()]() || e;
    var i = !1;
    var a = !1;
    var f = !1;
    var n;
    r(start((async e => {
      if (1 === e) {
        i = !0;
        if (t.return) {
          t.return();
        }
      } else if (a) {
        f = !0;
      } else {
        for (f = a = !0; f && !i; ) {
          if ((n = await t.next()).done) {
            i = !0;
            if (t.return) {
              await t.return();
            }
            r(0);
          } else {
            try {
              f = !1;
              r(push(n.value));
            } catch (e) {
              if (t.throw) {
                if (i = !!(await t.throw(e)).done) {
                  r(0);
                }
              } else {
                throw e;
              }
            }
          }
        }
        a = !1;
      }
    })));
  };
}

function fromIterable(e) {
  if (e[Symbol.asyncIterator]) {
    return fromAsyncIterable(e);
  }
  return r => {
    var t = e[Symbol.iterator]();
    var i = !1;
    var a = !1;
    var f = !1;
    var n;
    r(start((e => {
      if (1 === e) {
        i = !0;
        if (t.return) {
          t.return();
        }
      } else if (a) {
        f = !0;
      } else {
        for (f = a = !0; f && !i; ) {
          if ((n = t.next()).done) {
            i = !0;
            if (t.return) {
              t.return();
            }
            r(0);
          } else {
            try {
              f = !1;
              r(push(n.value));
            } catch (e) {
              if (t.throw) {
                if (i = !!t.throw(e).done) {
                  r(0);
                }
              } else {
                throw e;
              }
            }
          }
        }
        a = !1;
      }
    })));
  };
}

var r = fromIterable;

function fromValue(e) {
  return r => {
    var t = !1;
    r(start((i => {
      if (1 === i) {
        t = !0;
      } else if (!t) {
        t = !0;
        r(push(e));
        r(0);
      }
    })));
  };
}

function make(e) {
  return r => {
    var t = !1;
    var i = e({
      next(e) {
        if (!t) {
          r(push(e));
        }
      },
      complete() {
        if (!t) {
          t = !0;
          r(0);
        }
      }
    });
    r(start((e => {
      if (1 === e && !t) {
        t = !0;
        i();
      }
    })));
  };
}

function makeSubject() {
  var e;
  var r;
  return {
    source: share(make((t => {
      e = t.next;
      r = t.complete;
      return teardownPlaceholder;
    }))),
    next(r) {
      if (e) {
        e(r);
      }
    },
    complete() {
      if (r) {
        r();
      }
    }
  };
}

var empty = e => {
  var r = !1;
  e(start((t => {
    if (1 === t) {
      r = !0;
    } else if (!r) {
      r = !0;
      e(0);
    }
  })));
};

var never = r => {
  r(start(e));
};

function interval(e) {
  return make((r => {
    var t = 0;
    var i = setInterval((() => r.next(t++)), e);
    return () => clearInterval(i);
  }));
}

function fromDomEvent(e, r) {
  return make((t => {
    e.addEventListener(r, t.next);
    return () => e.removeEventListener(r, t.next);
  }));
}

function fromPromise(e) {
  return make((r => {
    e.then((e => {
      Promise.resolve(e).then((() => {
        r.next(e);
        r.complete();
      }));
    }));
    return teardownPlaceholder;
  }));
}

function subscribe(r) {
  return t => {
    var i = e;
    var a = !1;
    t((e => {
      if (0 === e) {
        a = !0;
      } else if (0 === e.tag) {
        (i = e[0])(0);
      } else if (!a) {
        r(e[0]);
        i(0);
      }
    }));
    return {
      unsubscribe() {
        if (!a) {
          a = !0;
          i(1);
        }
      }
    };
  };
}

function forEach(e) {
  return r => {
    subscribe(e)(r);
  };
}

function publish(e) {
  subscribe((e => {}))(e);
}

var t = {
  done: !0
};

var toAsyncIterable = r => {
  var i = [];
  var a = !1;
  var f = !1;
  var n = !1;
  var s = e;
  var l;
  return {
    async next() {
      if (!f) {
        f = !0;
        r((e => {
          if (a) {} else if (0 === e) {
            if (l) {
              l = l(t);
            }
            a = !0;
          } else if (0 === e.tag) {
            n = !0;
            (s = e[0])(0);
          } else {
            n = !1;
            if (l) {
              l = l({
                value: e[0],
                done: !1
              });
            } else {
              i.push(e[0]);
            }
          }
        }));
      }
      if (a && !i.length) {
        return t;
      } else if (!a && !n && i.length <= 1) {
        n = !0;
        s(0);
      }
      return i.length ? {
        value: i.shift(),
        done: !1
      } : new Promise((e => l = e));
    },
    async return() {
      if (!a) {
        l = s(1);
      }
      a = !0;
      return t;
    },
    [asyncIteratorSymbol()]() {
      return this;
    }
  };
};

function toArray(r) {
  var t = [];
  var i = e;
  var a = !1;
  r((e => {
    if (0 === e) {
      a = !0;
    } else if (0 === e.tag) {
      (i = e[0])(0);
    } else {
      t.push(e[0]);
      i(0);
    }
  }));
  if (!a) {
    i(1);
  }
  return t;
}

function toPromise(r) {
  return new Promise((t => {
    var i = e;
    var a;
    r((e => {
      if (0 === e) {
        Promise.resolve(a).then(t);
      } else if (0 === e.tag) {
        (i = e[0])(0);
      } else {
        a = e[0];
        i(0);
      }
    }));
  }));
}

function zip(r) {
  var t = Object.keys(r).length;
  return i => {
    var a = new Set;
    var f = Array.isArray(r) ? new Array(t).fill(e) : {};
    var n = Array.isArray(r) ? new Array(t) : {};
    var s = !1;
    var l = !1;
    var u = !1;
    var o = 0;
    var loop = function(v) {
      r[v]((c => {
        if (0 === c) {
          if (o >= t - 1) {
            u = !0;
            i(0);
          } else {
            o++;
          }
        } else if (0 === c.tag) {
          f[v] = c[0];
        } else if (!u) {
          n[v] = c[0];
          a.add(v);
          if (!s && a.size < t) {
            if (!l) {
              for (var h in r) {
                if (!a.has(h)) {
                  (f[h] || e)(0);
                }
              }
            } else {
              l = !1;
            }
          } else {
            s = !0;
            l = !1;
            i(push(Array.isArray(n) ? n.slice() : {
              ...n
            }));
          }
        }
      }));
    };
    for (var v in r) {
      loop(v);
    }
    i(start((e => {
      if (u) {} else if (1 === e) {
        u = !0;
        for (var r in f) {
          f[r](1);
        }
      } else if (!l) {
        l = !0;
        for (var t in f) {
          f[t](0);
        }
      }
    })));
  };
}

function combine(...e) {
  return zip(e);
}

function fromObservable(e) {
  return r => {
    var t = (e[observableSymbol()] ? e[observableSymbol()]() : e).subscribe({
      next(e) {
        r(push(e));
      },
      complete() {
        r(0);
      },
      error(e) {
        throw e;
      }
    });
    r(start((e => {
      if (1 === e) {
        t.unsubscribe();
      }
    })));
  };
}

function toObservable(r) {
  return {
    subscribe(t, i, a) {
      var f = "object" == typeof t ? t : {
        next: t,
        error: i,
        complete: a
      };
      var n = e;
      var s = !1;
      r((e => {
        if (s) {} else if (0 === e) {
          s = !0;
          if (f.complete) {
            f.complete();
          }
        } else if (0 === e.tag) {
          (n = e[0])(0);
        } else {
          f.next(e[0]);
          n(0);
        }
      }));
      var l = {
        closed: !1,
        unsubscribe() {
          l.closed = !0;
          s = !0;
          n(1);
        }
      };
      return l;
    },
    [observableSymbol()]() {
      return this;
    }
  };
}

function fromCallbag(e) {
  return r => {
    e(0, ((e, t) => {
      if (0 === e) {
        r(start((e => {
          t(e + 1);
        })));
      } else if (1 === e) {
        r(push(t));
      } else {
        r(0);
      }
    }));
  };
}

function toCallbag(e) {
  return (r, t) => {
    if (0 === r) {
      e((e => {
        if (0 === e) {
          t(2);
        } else if (0 === e.tag) {
          t(0, (r => {
            if (r < 3) {
              e[0](r - 1);
            }
          }));
        } else {
          t(1, e[0]);
        }
      }));
    }
  };
}

var pipe = (...e) => {
  var r = e[0];
  for (var t = 1, i = e.length; t < i; t++) {
    r = e[t](r);
  }
  return r;
};


//# sourceMappingURL=wonka.mjs.map


/***/ }),

/***/ 30195:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ z; }
/* harmony export */ });
/* unused harmony exports BRAND, DIRTY, EMPTY_PATH, INVALID, NEVER, OK, ParseStatus, Schema, ZodAny, ZodArray, ZodBigInt, ZodBoolean, ZodBranded, ZodCatch, ZodDate, ZodDefault, ZodDiscriminatedUnion, ZodEffects, ZodEnum, ZodError, ZodFirstPartyTypeKind, ZodFunction, ZodIntersection, ZodIssueCode, ZodLazy, ZodLiteral, ZodMap, ZodNaN, ZodNativeEnum, ZodNever, ZodNull, ZodNullable, ZodNumber, ZodObject, ZodOptional, ZodParsedType, ZodPipeline, ZodPromise, ZodReadonly, ZodRecord, ZodSchema, ZodSet, ZodString, ZodSymbol, ZodTransformer, ZodTuple, ZodType, ZodUndefined, ZodUnion, ZodUnknown, ZodVoid, addIssueToContext, any, array, bigint, boolean, coerce, custom, date, default, defaultErrorMap, discriminatedUnion, effect, enum, function, getErrorMap, getParsedType, instanceof, intersection, isAborted, isAsync, isDirty, isValid, late, lazy, literal, makeIssue, map, nan, nativeEnum, never, null, nullable, number, object, objectUtil, oboolean, onumber, optional, ostring, pipeline, preprocess, promise, quotelessJson, record, set, setErrorMap, strictObject, string, symbol, transformer, tuple, undefined, union, unknown, util, void */
var util;
(function (util) {
    util.assertEqual = (val) => val;
    function assertIs(_arg) { }
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items) => {
        const obj = {};
        for (const item of items) {
            obj[item] = item;
        }
        return obj;
    };
    util.getValidEnumValues = (obj) => {
        const validKeys = util.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys) {
            filtered[k] = obj[k];
        }
        return util.objectValues(filtered);
    };
    util.objectValues = (obj) => {
        return util.objectKeys(obj).map(function (e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
        ? (obj) => Object.keys(obj) // eslint-disable-line ban/ban
        : (object) => {
            const keys = [];
            for (const key in object) {
                if (Object.prototype.hasOwnProperty.call(object, key)) {
                    keys.push(key);
                }
            }
            return keys;
        };
    util.find = (arr, checker) => {
        for (const item of arr) {
            if (checker(item))
                return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function"
        ? (val) => Number.isInteger(val) // eslint-disable-line ban/ban
        : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array
            .map((val) => (typeof val === "string" ? `'${val}'` : val))
            .join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value) => {
        if (typeof value === "bigint") {
            return value.toString();
        }
        return value;
    };
})(util || (util = {}));
var objectUtil;
(function (objectUtil) {
    objectUtil.mergeShapes = (first, second) => {
        return {
            ...first,
            ...second, // second overwrites first
        };
    };
})(objectUtil || (objectUtil = {}));
const ZodParsedType = util.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set",
]);
const getParsedType = (data) => {
    const t = typeof data;
    switch (t) {
        case "undefined":
            return ZodParsedType.undefined;
        case "string":
            return ZodParsedType.string;
        case "number":
            return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
        case "boolean":
            return ZodParsedType.boolean;
        case "function":
            return ZodParsedType.function;
        case "bigint":
            return ZodParsedType.bigint;
        case "symbol":
            return ZodParsedType.symbol;
        case "object":
            if (Array.isArray(data)) {
                return ZodParsedType.array;
            }
            if (data === null) {
                return ZodParsedType.null;
            }
            if (data.then &&
                typeof data.then === "function" &&
                data.catch &&
                typeof data.catch === "function") {
                return ZodParsedType.promise;
            }
            if (typeof Map !== "undefined" && data instanceof Map) {
                return ZodParsedType.map;
            }
            if (typeof Set !== "undefined" && data instanceof Set) {
                return ZodParsedType.set;
            }
            if (typeof Date !== "undefined" && data instanceof Date) {
                return ZodParsedType.date;
            }
            return ZodParsedType.object;
        default:
            return ZodParsedType.unknown;
    }
};

const ZodIssueCode = util.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite",
]);
const quotelessJson = (obj) => {
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class ZodError extends Error {
    constructor(issues) {
        super();
        this.issues = [];
        this.addIssue = (sub) => {
            this.issues = [...this.issues, sub];
        };
        this.addIssues = (subs = []) => {
            this.issues = [...this.issues, ...subs];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) {
            // eslint-disable-next-line ban/ban
            Object.setPrototypeOf(this, actualProto);
        }
        else {
            this.__proto__ = actualProto;
        }
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper ||
            function (issue) {
                return issue.message;
            };
        const fieldErrors = { _errors: [] };
        const processError = (error) => {
            for (const issue of error.issues) {
                if (issue.code === "invalid_union") {
                    issue.unionErrors.map(processError);
                }
                else if (issue.code === "invalid_return_type") {
                    processError(issue.returnTypeError);
                }
                else if (issue.code === "invalid_arguments") {
                    processError(issue.argumentsError);
                }
                else if (issue.path.length === 0) {
                    fieldErrors._errors.push(mapper(issue));
                }
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while (i < issue.path.length) {
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) {
                            curr[el] = curr[el] || { _errors: [] };
                            // if (typeof el === "string") {
                            //   curr[el] = curr[el] || { _errors: [] };
                            // } else if (typeof el === "number") {
                            //   const errorArray: any = [];
                            //   errorArray._errors = [];
                            //   curr[el] = curr[el] || errorArray;
                            // }
                        }
                        else {
                            curr[el] = curr[el] || { _errors: [] };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue) => issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues) {
            if (sub.path.length > 0) {
                fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
                fieldErrors[sub.path[0]].push(mapper(sub));
            }
            else {
                formErrors.push(mapper(sub));
            }
        }
        return { formErrors, fieldErrors };
    }
    get formErrors() {
        return this.flatten();
    }
}
ZodError.create = (issues) => {
    const error = new ZodError(issues);
    return error;
};

const errorMap = (issue, _ctx) => {
    let message;
    switch (issue.code) {
        case ZodIssueCode.invalid_type:
            if (issue.received === ZodParsedType.undefined) {
                message = "Required";
            }
            else {
                message = `Expected ${issue.expected}, received ${issue.received}`;
            }
            break;
        case ZodIssueCode.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
            break;
        case ZodIssueCode.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
            break;
        case ZodIssueCode.invalid_union:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
            break;
        case ZodIssueCode.invalid_enum_value:
            message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case ZodIssueCode.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case ZodIssueCode.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case ZodIssueCode.invalid_date:
            message = `Invalid date`;
            break;
        case ZodIssueCode.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") {
                        message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                    }
                }
                else if ("startsWith" in issue.validation) {
                    message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                }
                else if ("endsWith" in issue.validation) {
                    message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                }
                else {
                    util.assertNever(issue.validation);
                }
            }
            else if (issue.validation !== "regex") {
                message = `Invalid ${issue.validation}`;
            }
            else {
                message = "Invalid";
            }
            break;
        case ZodIssueCode.too_small:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${issue.minimum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly equal to `
                    : issue.inclusive
                        ? `greater than or equal to `
                        : `greater than `}${new Date(Number(issue.minimum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.too_big:
            if (issue.type === "array")
                message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string")
                message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number")
                message = `Number must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint")
                message = `BigInt must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `less than or equal to`
                        : `less than`} ${issue.maximum}`;
            else if (issue.type === "date")
                message = `Date must be ${issue.exact
                    ? `exactly`
                    : issue.inclusive
                        ? `smaller than or equal to`
                        : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else
                message = "Invalid input";
            break;
        case ZodIssueCode.custom:
            message = `Invalid input`;
            break;
        case ZodIssueCode.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case ZodIssueCode.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case ZodIssueCode.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            util.assertNever(issue);
    }
    return { message };
};

let overrideErrorMap = errorMap;
function setErrorMap(map) {
    overrideErrorMap = map;
}
function getErrorMap() {
    return overrideErrorMap;
}

const makeIssue = (params) => {
    const { data, path, errorMaps, issueData } = params;
    const fullPath = [...path, ...(issueData.path || [])];
    const fullIssue = {
        ...issueData,
        path: fullPath,
    };
    let errorMessage = "";
    const maps = errorMaps
        .filter((m) => !!m)
        .slice()
        .reverse();
    for (const map of maps) {
        errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
    }
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage,
    };
};
const EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
    const issue = makeIssue({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            getErrorMap(),
            errorMap, // then global default map
        ].filter((x) => !!x),
    });
    ctx.common.issues.push(issue);
}
class ParseStatus {
    constructor() {
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid")
            this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted")
            this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results) {
            if (s.status === "aborted")
                return INVALID;
            if (s.status === "dirty")
                status.dirty();
            arrayValue.push(s.value);
        }
        return { status: status.value, value: arrayValue };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs) {
            syncPairs.push({
                key: await pair.key,
                value: await pair.value,
            });
        }
        return ParseStatus.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs) {
            const { key, value } = pair;
            if (key.status === "aborted")
                return INVALID;
            if (value.status === "aborted")
                return INVALID;
            if (key.status === "dirty")
                status.dirty();
            if (value.status === "dirty")
                status.dirty();
            if (key.value !== "__proto__" &&
                (typeof value.value !== "undefined" || pair.alwaysSet)) {
                finalObject[key.value] = value.value;
            }
        }
        return { status: status.value, value: finalObject };
    }
}
const INVALID = Object.freeze({
    status: "aborted",
});
const DIRTY = (value) => ({ status: "dirty", value });
const OK = (value) => ({ status: "valid", value });
const isAborted = (x) => x.status === "aborted";
const isDirty = (x) => x.status === "dirty";
const isValid = (x) => x.status === "valid";
const isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;

var errorUtil;
(function (errorUtil) {
    errorUtil.errToObj = (message) => typeof message === "string" ? { message } : message || {};
    errorUtil.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));

class ParseInputLazyPath {
    constructor(parent, value, path, key) {
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) {
                this._cachedPath.push(...this._path, ...this._key);
            }
            else {
                this._cachedPath.push(...this._path, this._key);
            }
        }
        return this._cachedPath;
    }
}
const handleResult = (ctx, result) => {
    if (isValid(result)) {
        return { success: true, data: result.value };
    }
    else {
        if (!ctx.common.issues.length) {
            throw new Error("Validation failed but no issues detected.");
        }
        return {
            success: false,
            get error() {
                if (this._error)
                    return this._error;
                const error = new ZodError(ctx.common.issues);
                this._error = error;
                return this._error;
            },
        };
    }
};
function processCreateParams(params) {
    if (!params)
        return {};
    const { errorMap, invalid_type_error, required_error, description } = params;
    if (errorMap && (invalid_type_error || required_error)) {
        throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    }
    if (errorMap)
        return { errorMap: errorMap, description };
    const customMap = (iss, ctx) => {
        if (iss.code !== "invalid_type")
            return { message: ctx.defaultError };
        if (typeof ctx.data === "undefined") {
            return { message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError };
        }
        return { message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError };
    };
    return { errorMap: customMap, description };
}
class ZodType {
    constructor(def) {
        /** Alias of safeParseAsync */
        this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return getParsedType(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return (ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: getParsedType(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent,
        });
    }
    _processInputParams(input) {
        return {
            status: new ParseStatus(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: getParsedType(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent,
            },
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if (isAsync(result)) {
            throw new Error("Synchronous parse encountered promise.");
        }
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const result = this._parseSync({ data, path: ctx.path, parent: ctx });
        return handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success)
            return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true,
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data,
            parsedType: getParsedType(data),
        };
        const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
        const result = await (isAsync(maybeAsyncResult)
            ? maybeAsyncResult
            : Promise.resolve(maybeAsyncResult));
        return handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val) => {
            if (typeof message === "string" || typeof message === "undefined") {
                return { message };
            }
            else if (typeof message === "function") {
                return message(val);
            }
            else {
                return message;
            }
        };
        return this._refinement((val, ctx) => {
            const result = check(val);
            const setError = () => ctx.addIssue({
                code: ZodIssueCode.custom,
                ...getIssueProperties(val),
            });
            if (typeof Promise !== "undefined" && result instanceof Promise) {
                return result.then((data) => {
                    if (!data) {
                        setError();
                        return false;
                    }
                    else {
                        return true;
                    }
                });
            }
            if (!result) {
                setError();
                return false;
            }
            else {
                return true;
            }
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx) => {
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function"
                    ? refinementData(val, ctx)
                    : refinementData);
                return false;
            }
            else {
                return true;
            }
        });
    }
    _refinement(refinement) {
        return new ZodEffects({
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "refinement", refinement },
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return ZodOptional.create(this, this._def);
    }
    nullable() {
        return ZodNullable.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return ZodArray.create(this, this._def);
    }
    promise() {
        return ZodPromise.create(this, this._def);
    }
    or(option) {
        return ZodUnion.create([this, option], this._def);
    }
    and(incoming) {
        return ZodIntersection.create(this, incoming, this._def);
    }
    transform(transform) {
        return new ZodEffects({
            ...processCreateParams(this._def),
            schema: this,
            typeName: ZodFirstPartyTypeKind.ZodEffects,
            effect: { type: "transform", transform },
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : () => def;
        return new ZodDefault({
            ...processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodDefault,
        });
    }
    brand() {
        return new ZodBranded({
            typeName: ZodFirstPartyTypeKind.ZodBranded,
            type: this,
            ...processCreateParams(this._def),
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : () => def;
        return new ZodCatch({
            ...processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: ZodFirstPartyTypeKind.ZodCatch,
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description,
        });
    }
    pipe(target) {
        return ZodPipeline.create(this, target);
    }
    readonly() {
        return ZodReadonly.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const cuidRegex = /^c[^\s-]{8,}$/i;
const cuid2Regex = /^[a-z][a-z0-9]*$/;
const ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let emojiRegex;
const ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const datetimeRegex = (args) => {
    if (args.precision) {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
        }
    }
    else if (args.precision === 0) {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
        }
    }
    else {
        if (args.offset) {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        }
        else {
            return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
        }
    }
};
function isValidIP(ip, version) {
    if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
        return true;
    }
    if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
        return true;
    }
    return false;
}
class ZodString extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = String(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.string) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.string,
                received: ctx.parsedType,
            }
            //
            );
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_big,
                            maximum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    else if (tooSmall) {
                        addIssueToContext(ctx, {
                            code: ZodIssueCode.too_small,
                            minimum: check.value,
                            type: "string",
                            inclusive: true,
                            exact: true,
                            message: check.message,
                        });
                    }
                    status.dirty();
                }
            }
            else if (check.kind === "email") {
                if (!emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "email",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "emoji") {
                if (!emojiRegex) {
                    emojiRegex = new RegExp(_emojiRegex, "u");
                }
                if (!emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "emoji",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "uuid") {
                if (!uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "uuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid") {
                if (!cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "cuid2") {
                if (!cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "cuid2",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ulid") {
                if (!ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ulid",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "url") {
                try {
                    new URL(input.data);
                }
                catch (_a) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "url",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "regex",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "trim") {
                input.data = input.data.trim();
            }
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { includes: check.value, position: check.position },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "toLowerCase") {
                input.data = input.data.toLowerCase();
            }
            else if (check.kind === "toUpperCase") {
                input.data = input.data.toUpperCase();
            }
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { startsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: { endsWith: check.value },
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "datetime") {
                const regex = datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_string,
                        validation: "datetime",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "ip") {
                if (!isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        validation: "ip",
                        code: ZodIssueCode.invalid_string,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    _regex(regex, validation, message) {
        return this.refinement((data) => regex.test(data), {
            validation,
            code: ZodIssueCode.invalid_string,
            ...errorUtil.errToObj(message),
        });
    }
    _addCheck(check) {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    email(message) {
        return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
    }
    url(message) {
        return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
    }
    emoji(message) {
        return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
    }
    uuid(message) {
        return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
    }
    cuid(message) {
        return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
    }
    cuid2(message) {
        return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
    }
    ulid(message) {
        return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
    }
    ip(options) {
        return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") {
            return this._addCheck({
                kind: "datetime",
                precision: null,
                offset: false,
                message: options,
            });
        }
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...errorUtil.errToObj(message),
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message),
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...errorUtil.errToObj(message),
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...errorUtil.errToObj(message),
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...errorUtil.errToObj(message),
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...errorUtil.errToObj(message),
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */
    nonempty(message) {
        return this.min(1, errorUtil.errToObj(message));
    }
    trim() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "trim" }],
        });
    }
    toLowerCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toLowerCase" }],
        });
    }
    toUpperCase() {
        return new ZodString({
            ...this._def,
            checks: [...this._def.checks, { kind: "toUpperCase" }],
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch) => ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch) => ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch) => ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch) => ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch) => ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch) => ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch) => ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch) => ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodString.create = (params) => {
    var _a;
    return new ZodString({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return (valInt % stepInt) / Math.pow(10, decCount);
}
class ZodNumber extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = Number(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.number) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.number,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "int") {
                if (!util.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_finite,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodNumber({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodNumber({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: errorUtil.toString(message),
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: errorUtil.toString(message),
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: errorUtil.toString(message),
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: errorUtil.toString(message),
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch) => ch.kind === "int" ||
            (ch.kind === "multipleOf" && util.isInteger(ch.value)));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "finite" ||
                ch.kind === "int" ||
                ch.kind === "multipleOf") {
                return true;
            }
            else if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
            else if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
ZodNumber.create = (params) => {
    return new ZodNumber({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodBigInt extends ZodType {
    constructor() {
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) {
            input.data = BigInt(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.bigint) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.bigint,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        let ctx = undefined;
        const status = new ParseStatus();
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                const tooSmall = check.inclusive
                    ? input.data < check.value
                    : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                const tooBig = check.inclusive
                    ? input.data > check.value
                    : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message,
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return { status: status.value, value: input.data };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new ZodBigInt({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind,
                    value,
                    inclusive,
                    message: errorUtil.toString(message),
                },
            ],
        });
    }
    _addCheck(check) {
        return new ZodBigInt({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: errorUtil.toString(message),
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: errorUtil.toString(message),
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value,
            message: errorUtil.toString(message),
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max;
    }
}
ZodBigInt.create = (params) => {
    var _a;
    return new ZodBigInt({
        checks: [],
        typeName: ZodFirstPartyTypeKind.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...processCreateParams(params),
    });
};
class ZodBoolean extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = Boolean(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.boolean) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.boolean,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodBoolean.create = (params) => {
    return new ZodBoolean({
        typeName: ZodFirstPartyTypeKind.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...processCreateParams(params),
    });
};
class ZodDate extends ZodType {
    _parse(input) {
        if (this._def.coerce) {
            input.data = new Date(input.data);
        }
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.date) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.date,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_date,
            });
            return INVALID;
        }
        const status = new ParseStatus();
        let ctx = undefined;
        for (const check of this._def.checks) {
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date",
                    });
                    status.dirty();
                }
            }
            else {
                util.assertNever(check);
            }
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime()),
        };
    }
    _addCheck(check) {
        return new ZodDate({
            ...this._def,
            checks: [...this._def.checks, check],
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: errorUtil.toString(message),
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "min") {
                if (min === null || ch.value > min)
                    min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks) {
            if (ch.kind === "max") {
                if (max === null || ch.value < max)
                    max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
ZodDate.create = (params) => {
    return new ZodDate({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: ZodFirstPartyTypeKind.ZodDate,
        ...processCreateParams(params),
    });
};
class ZodSymbol extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.symbol) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.symbol,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodSymbol.create = (params) => {
    return new ZodSymbol({
        typeName: ZodFirstPartyTypeKind.ZodSymbol,
        ...processCreateParams(params),
    });
};
class ZodUndefined extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.undefined,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodUndefined.create = (params) => {
    return new ZodUndefined({
        typeName: ZodFirstPartyTypeKind.ZodUndefined,
        ...processCreateParams(params),
    });
};
class ZodNull extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.null) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.null,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodNull.create = (params) => {
    return new ZodNull({
        typeName: ZodFirstPartyTypeKind.ZodNull,
        ...processCreateParams(params),
    });
};
class ZodAny extends ZodType {
    constructor() {
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodAny.create = (params) => {
    return new ZodAny({
        typeName: ZodFirstPartyTypeKind.ZodAny,
        ...processCreateParams(params),
    });
};
class ZodUnknown extends ZodType {
    constructor() {
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return OK(input.data);
    }
}
ZodUnknown.create = (params) => {
    return new ZodUnknown({
        typeName: ZodFirstPartyTypeKind.ZodUnknown,
        ...processCreateParams(params),
    });
};
class ZodNever extends ZodType {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: ZodParsedType.never,
            received: ctx.parsedType,
        });
        return INVALID;
    }
}
ZodNever.create = (params) => {
    return new ZodNever({
        typeName: ZodFirstPartyTypeKind.ZodNever,
        ...processCreateParams(params),
    });
};
class ZodVoid extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.undefined) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.void,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return OK(input.data);
    }
}
ZodVoid.create = (params) => {
    return new ZodVoid({
        typeName: ZodFirstPartyTypeKind.ZodVoid,
        ...processCreateParams(params),
    });
};
class ZodArray extends ZodType {
    _parse(input) {
        const { ctx, status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                addIssueToContext(ctx, {
                    code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
                    minimum: (tooSmall ? def.exactLength.value : undefined),
                    maximum: (tooBig ? def.exactLength.value : undefined),
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message,
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message,
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message,
                });
                status.dirty();
            }
        }
        if (ctx.common.async) {
            return Promise.all([...ctx.data].map((item, i) => {
                return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
            })).then((result) => {
                return ParseStatus.mergeArray(status, result);
            });
        }
        const result = [...ctx.data].map((item, i) => {
            return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return ParseStatus.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new ZodArray({
            ...this._def,
            minLength: { value: minLength, message: errorUtil.toString(message) },
        });
    }
    max(maxLength, message) {
        return new ZodArray({
            ...this._def,
            maxLength: { value: maxLength, message: errorUtil.toString(message) },
        });
    }
    length(len, message) {
        return new ZodArray({
            ...this._def,
            exactLength: { value: len, message: errorUtil.toString(message) },
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodArray.create = (schema, params) => {
    return new ZodArray({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: ZodFirstPartyTypeKind.ZodArray,
        ...processCreateParams(params),
    });
};
function deepPartialify(schema) {
    if (schema instanceof ZodObject) {
        const newShape = {};
        for (const key in schema.shape) {
            const fieldSchema = schema.shape[key];
            newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
        }
        return new ZodObject({
            ...schema._def,
            shape: () => newShape,
        });
    }
    else if (schema instanceof ZodArray) {
        return new ZodArray({
            ...schema._def,
            type: deepPartialify(schema.element),
        });
    }
    else if (schema instanceof ZodOptional) {
        return ZodOptional.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodNullable) {
        return ZodNullable.create(deepPartialify(schema.unwrap()));
    }
    else if (schema instanceof ZodTuple) {
        return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
    }
    else {
        return schema;
    }
}
class ZodObject extends ZodType {
    constructor() {
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */
        this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */
        this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null)
            return this._cached;
        const shape = this._def.shape();
        const keys = util.objectKeys(shape);
        return (this._cached = { shape, keys });
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.object) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const { status, ctx } = this._processInputParams(input);
        const { shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof ZodNever &&
            this._def.unknownKeys === "strip")) {
            for (const key in ctx.data) {
                if (!shapeKeys.includes(key)) {
                    extraKeys.push(key);
                }
            }
        }
        const pairs = [];
        for (const key of shapeKeys) {
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: { status: "valid", value: key },
                value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data,
            });
        }
        if (this._def.catchall instanceof ZodNever) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") {
                for (const key of extraKeys) {
                    pairs.push({
                        key: { status: "valid", value: key },
                        value: { status: "valid", value: ctx.data[key] },
                    });
                }
            }
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    addIssueToContext(ctx, {
                        code: ZodIssueCode.unrecognized_keys,
                        keys: extraKeys,
                    });
                    status.dirty();
                }
            }
            else if (unknownKeys === "strip") ;
            else {
                throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
            }
        }
        else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys) {
                const value = ctx.data[key];
                pairs.push({
                    key: { status: "valid", value: key },
                    value: catchall._parse(new ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data,
                });
            }
        }
        if (ctx.common.async) {
            return Promise.resolve()
                .then(async () => {
                const syncPairs = [];
                for (const pair of pairs) {
                    const key = await pair.key;
                    syncPairs.push({
                        key,
                        value: await pair.value,
                        alwaysSet: pair.alwaysSet,
                    });
                }
                return syncPairs;
            })
                .then((syncPairs) => {
                return ParseStatus.mergeObjectSync(status, syncPairs);
            });
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        errorUtil.errToObj;
        return new ZodObject({
            ...this._def,
            unknownKeys: "strict",
            ...(message !== undefined
                ? {
                    errorMap: (issue, ctx) => {
                        var _a, _b, _c, _d;
                        const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                        if (issue.code === "unrecognized_keys")
                            return {
                                message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError,
                            };
                        return {
                            message: defaultError,
                        };
                    },
                }
                : {}),
        });
    }
    strip() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "strip",
        });
    }
    passthrough() {
        return new ZodObject({
            ...this._def,
            unknownKeys: "passthrough",
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new ZodObject({
            ...this._def,
            shape: () => ({
                ...this._def.shape(),
                ...augmentation,
            }),
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */
    merge(merging) {
        const merged = new ZodObject({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: () => ({
                ...this._def.shape(),
                ...merging._def.shape(),
            }),
            typeName: ZodFirstPartyTypeKind.ZodObject,
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({ [key]: schema });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new ZodObject({
            ...this._def,
            catchall: index,
        });
    }
    pick(mask) {
        const shape = {};
        util.objectKeys(mask).forEach((key) => {
            if (mask[key] && this.shape[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    omit(mask) {
        const shape = {};
        util.objectKeys(this.shape).forEach((key) => {
            if (!mask[key]) {
                shape[key] = this.shape[key];
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => shape,
        });
    }
    /**
     * @deprecated
     */
    deepPartial() {
        return deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key) => {
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) {
                newShape[key] = fieldSchema;
            }
            else {
                newShape[key] = fieldSchema.optional();
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    required(mask) {
        const newShape = {};
        util.objectKeys(this.shape).forEach((key) => {
            if (mask && !mask[key]) {
                newShape[key] = this.shape[key];
            }
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while (newField instanceof ZodOptional) {
                    newField = newField._def.innerType;
                }
                newShape[key] = newField;
            }
        });
        return new ZodObject({
            ...this._def,
            shape: () => newShape,
        });
    }
    keyof() {
        return createZodEnum(util.objectKeys(this.shape));
    }
}
ZodObject.create = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.strictCreate = (shape, params) => {
    return new ZodObject({
        shape: () => shape,
        unknownKeys: "strict",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
ZodObject.lazycreate = (shape, params) => {
    return new ZodObject({
        shape,
        unknownKeys: "strip",
        catchall: ZodNever.create(),
        typeName: ZodFirstPartyTypeKind.ZodObject,
        ...processCreateParams(params),
    });
};
class ZodUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results) {
                if (result.result.status === "valid") {
                    return result.result;
                }
            }
            for (const result of results) {
                if (result.result.status === "dirty") {
                    // add issues from dirty option
                    ctx.common.issues.push(...result.ctx.common.issues);
                    return result.result;
                }
            }
            // return invalid
            const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return Promise.all(options.map(async (option) => {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                return {
                    result: await option._parseAsync({
                        data: ctx.data,
                        path: ctx.path,
                        parent: childCtx,
                    }),
                    ctx: childCtx,
                };
            })).then(handleResults);
        }
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options) {
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: [],
                    },
                    parent: null,
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx,
                });
                if (result.status === "valid") {
                    return result;
                }
                else if (result.status === "dirty" && !dirty) {
                    dirty = { result, ctx: childCtx };
                }
                if (childCtx.common.issues.length) {
                    issues.push(childCtx.common.issues);
                }
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues) => new ZodError(issues));
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union,
                unionErrors,
            });
            return INVALID;
        }
    }
    get options() {
        return this._def.options;
    }
}
ZodUnion.create = (types, params) => {
    return new ZodUnion({
        options: types,
        typeName: ZodFirstPartyTypeKind.ZodUnion,
        ...processCreateParams(params),
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const getDiscriminator = (type) => {
    if (type instanceof ZodLazy) {
        return getDiscriminator(type.schema);
    }
    else if (type instanceof ZodEffects) {
        return getDiscriminator(type.innerType());
    }
    else if (type instanceof ZodLiteral) {
        return [type.value];
    }
    else if (type instanceof ZodEnum) {
        return type.options;
    }
    else if (type instanceof ZodNativeEnum) {
        // eslint-disable-next-line ban/ban
        return Object.keys(type.enum);
    }
    else if (type instanceof ZodDefault) {
        return getDiscriminator(type._def.innerType);
    }
    else if (type instanceof ZodUndefined) {
        return [undefined];
    }
    else if (type instanceof ZodNull) {
        return [null];
    }
    else {
        return null;
    }
};
class ZodDiscriminatedUnion extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [discriminator],
            });
            return INVALID;
        }
        if (ctx.common.async) {
            return option._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
        else {
            return option._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
        }
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */
    static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options) {
            const discriminatorValues = getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) {
                throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            }
            for (const value of discriminatorValues) {
                if (optionsMap.has(value)) {
                    throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                }
                optionsMap.set(value, type);
            }
        }
        return new ZodDiscriminatedUnion({
            typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
            discriminator,
            options,
            optionsMap,
            ...processCreateParams(params),
        });
    }
}
function mergeValues(a, b) {
    const aType = getParsedType(a);
    const bType = getParsedType(b);
    if (a === b) {
        return { valid: true, data: a };
    }
    else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
        const bKeys = util.objectKeys(b);
        const sharedKeys = util
            .objectKeys(a)
            .filter((key) => bKeys.indexOf(key) !== -1);
        const newObj = { ...a, ...b };
        for (const key of sharedKeys) {
            const sharedValue = mergeValues(a[key], b[key]);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newObj[key] = sharedValue.data;
        }
        return { valid: true, data: newObj };
    }
    else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
        if (a.length !== b.length) {
            return { valid: false };
        }
        const newArray = [];
        for (let index = 0; index < a.length; index++) {
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = mergeValues(itemA, itemB);
            if (!sharedValue.valid) {
                return { valid: false };
            }
            newArray.push(sharedValue.data);
        }
        return { valid: true, data: newArray };
    }
    else if (aType === ZodParsedType.date &&
        bType === ZodParsedType.date &&
        +a === +b) {
        return { valid: true, data: a };
    }
    else {
        return { valid: false };
    }
}
class ZodIntersection extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight) => {
            if (isAborted(parsedLeft) || isAborted(parsedRight)) {
                return INVALID;
            }
            const merged = mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.invalid_intersection_types,
                });
                return INVALID;
            }
            if (isDirty(parsedLeft) || isDirty(parsedRight)) {
                status.dirty();
            }
            return { status: status.value, value: merged.data };
        };
        if (ctx.common.async) {
            return Promise.all([
                this._def.left._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
                this._def.right._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                }),
            ]).then(([left, right]) => handleParsed(left, right));
        }
        else {
            return handleParsed(this._def.left._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }), this._def.right._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            }));
        }
    }
}
ZodIntersection.create = (left, right, params) => {
    return new ZodIntersection({
        left: left,
        right: right,
        typeName: ZodFirstPartyTypeKind.ZodIntersection,
        ...processCreateParams(params),
    });
};
class ZodTuple extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.array) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.array,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        if (ctx.data.length < this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            return INVALID;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array",
            });
            status.dirty();
        }
        const items = [...ctx.data]
            .map((item, itemIndex) => {
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema)
                return null;
            return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        })
            .filter((x) => !!x); // filter nulls
        if (ctx.common.async) {
            return Promise.all(items).then((results) => {
                return ParseStatus.mergeArray(status, results);
            });
        }
        else {
            return ParseStatus.mergeArray(status, items);
        }
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new ZodTuple({
            ...this._def,
            rest,
        });
    }
}
ZodTuple.create = (schemas, params) => {
    if (!Array.isArray(schemas)) {
        throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    }
    return new ZodTuple({
        items: schemas,
        typeName: ZodFirstPartyTypeKind.ZodTuple,
        rest: null,
        ...processCreateParams(params),
    });
};
class ZodRecord extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.object) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.object,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for (const key in ctx.data) {
            pairs.push({
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
                value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key)),
            });
        }
        if (ctx.common.async) {
            return ParseStatus.mergeObjectAsync(status, pairs);
        }
        else {
            return ParseStatus.mergeObjectSync(status, pairs);
        }
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof ZodType) {
            return new ZodRecord({
                keyType: first,
                valueType: second,
                typeName: ZodFirstPartyTypeKind.ZodRecord,
                ...processCreateParams(third),
            });
        }
        return new ZodRecord({
            keyType: ZodString.create(),
            valueType: first,
            typeName: ZodFirstPartyTypeKind.ZodRecord,
            ...processCreateParams(second),
        });
    }
}
class ZodMap extends ZodType {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.map) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.map,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [...ctx.data.entries()].map(([key, value], index) => {
            return {
                key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
                value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"])),
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async () => {
                for (const pair of pairs) {
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") {
                        return INVALID;
                    }
                    if (key.status === "dirty" || value.status === "dirty") {
                        status.dirty();
                    }
                    finalMap.set(key.value, value.value);
                }
                return { status: status.value, value: finalMap };
            });
        }
        else {
            const finalMap = new Map();
            for (const pair of pairs) {
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") {
                    return INVALID;
                }
                if (key.status === "dirty" || value.status === "dirty") {
                    status.dirty();
                }
                finalMap.set(key.value, value.value);
            }
            return { status: status.value, value: finalMap };
        }
    }
}
ZodMap.create = (keyType, valueType, params) => {
    return new ZodMap({
        valueType,
        keyType,
        typeName: ZodFirstPartyTypeKind.ZodMap,
        ...processCreateParams(params),
    });
};
class ZodSet extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.set) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.set,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message,
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                addIssueToContext(ctx, {
                    code: ZodIssueCode.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message,
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements) {
                if (element.status === "aborted")
                    return INVALID;
                if (element.status === "dirty")
                    status.dirty();
                parsedSet.add(element.value);
            }
            return { status: status.value, value: parsedSet };
        }
        const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) {
            return Promise.all(elements).then((elements) => finalizeSet(elements));
        }
        else {
            return finalizeSet(elements);
        }
    }
    min(minSize, message) {
        return new ZodSet({
            ...this._def,
            minSize: { value: minSize, message: errorUtil.toString(message) },
        });
    }
    max(maxSize, message) {
        return new ZodSet({
            ...this._def,
            maxSize: { value: maxSize, message: errorUtil.toString(message) },
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
ZodSet.create = (valueType, params) => {
    return new ZodSet({
        valueType,
        minSize: null,
        maxSize: null,
        typeName: ZodFirstPartyTypeKind.ZodSet,
        ...processCreateParams(params),
    });
};
class ZodFunction extends ZodType {
    constructor() {
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.function) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.function,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        function makeArgsIssue(args, error) {
            return makeIssue({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_arguments,
                    argumentsError: error,
                },
            });
        }
        function makeReturnsIssue(returns, error) {
            return makeIssue({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    getErrorMap(),
                    errorMap,
                ].filter((x) => !!x),
                issueData: {
                    code: ZodIssueCode.invalid_return_type,
                    returnTypeError: error,
                },
            });
        }
        const params = { errorMap: ctx.common.contextualErrorMap };
        const fn = ctx.data;
        if (this._def.returns instanceof ZodPromise) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(async function (...args) {
                const error = new ZodError([]);
                const parsedArgs = await me._def.args
                    .parseAsync(args, params)
                    .catch((e) => {
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type
                    .parseAsync(result, params)
                    .catch((e) => {
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        }
        else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return OK(function (...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) {
                    throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
                }
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) {
                    throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
                }
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new ZodFunction({
            ...this._def,
            args: ZodTuple.create(items).rest(ZodUnknown.create()),
        });
    }
    returns(returnType) {
        return new ZodFunction({
            ...this._def,
            returns: returnType,
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new ZodFunction({
            args: (args
                ? args
                : ZodTuple.create([]).rest(ZodUnknown.create())),
            returns: returns || ZodUnknown.create(),
            typeName: ZodFirstPartyTypeKind.ZodFunction,
            ...processCreateParams(params),
        });
    }
}
class ZodLazy extends ZodType {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
    }
}
ZodLazy.create = (getter, params) => {
    return new ZodLazy({
        getter: getter,
        typeName: ZodFirstPartyTypeKind.ZodLazy,
        ...processCreateParams(params),
    });
};
class ZodLiteral extends ZodType {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_literal,
                expected: this._def.value,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
    get value() {
        return this._def.value;
    }
}
ZodLiteral.create = (value, params) => {
    return new ZodLiteral({
        value: value,
        typeName: ZodFirstPartyTypeKind.ZodLiteral,
        ...processCreateParams(params),
    });
};
function createZodEnum(values, params) {
    return new ZodEnum({
        values,
        typeName: ZodFirstPartyTypeKind.ZodEnum,
        ...processCreateParams(params),
    });
}
class ZodEnum extends ZodType {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values) {
            enumValues[val] = val;
        }
        return enumValues;
    }
    extract(values) {
        return ZodEnum.create(values);
    }
    exclude(values) {
        return ZodEnum.create(this.options.filter((opt) => !values.includes(opt)));
    }
}
ZodEnum.create = createZodEnum;
class ZodNativeEnum extends ZodType {
    _parse(input) {
        const nativeEnumValues = util.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== ZodParsedType.string &&
            ctx.parsedType !== ZodParsedType.number) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                expected: util.joinValues(expectedValues),
                received: ctx.parsedType,
                code: ZodIssueCode.invalid_type,
            });
            return INVALID;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = util.objectValues(nativeEnumValues);
            addIssueToContext(ctx, {
                received: ctx.data,
                code: ZodIssueCode.invalid_enum_value,
                options: expectedValues,
            });
            return INVALID;
        }
        return OK(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
ZodNativeEnum.create = (values, params) => {
    return new ZodNativeEnum({
        values: values,
        typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
        ...processCreateParams(params),
    });
};
class ZodPromise extends ZodType {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        if (ctx.parsedType !== ZodParsedType.promise &&
            ctx.common.async === false) {
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.promise,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        const promisified = ctx.parsedType === ZodParsedType.promise
            ? ctx.data
            : Promise.resolve(ctx.data);
        return OK(promisified.then((data) => {
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap,
            });
        }));
    }
}
ZodPromise.create = (schema, params) => {
    return new ZodPromise({
        type: schema,
        typeName: ZodFirstPartyTypeKind.ZodPromise,
        ...processCreateParams(params),
    });
};
class ZodEffects extends ZodType {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects
            ? this._def.schema.sourceType()
            : this._def.schema;
    }
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg) => {
                addIssueToContext(ctx, arg);
                if (arg.fatal) {
                    status.abort();
                }
                else {
                    status.dirty();
                }
            },
            get path() {
                return ctx.path;
            },
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) {
                return {
                    status: "dirty",
                    value: ctx.data,
                };
            }
            if (ctx.common.async) {
                return Promise.resolve(processed).then((processed) => {
                    return this._def.schema._parseAsync({
                        data: processed,
                        path: ctx.path,
                        parent: ctx,
                    });
                });
            }
            else {
                return this._def.schema._parseSync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc
            // effect: RefinementEffect<any>
            ) => {
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) {
                    return Promise.resolve(result);
                }
                if (result instanceof Promise) {
                    throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                }
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inner.status === "aborted")
                    return INVALID;
                if (inner.status === "dirty")
                    status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return { status: status.value, value: inner.value };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((inner) => {
                    if (inner.status === "aborted")
                        return INVALID;
                    if (inner.status === "dirty")
                        status.dirty();
                    return executeRefinement(inner.value).then(() => {
                        return { status: status.value, value: inner.value };
                    });
                });
            }
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (!isValid(base))
                    return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) {
                    throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                }
                return { status: status.value, value: result };
            }
            else {
                return this._def.schema
                    ._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx })
                    .then((base) => {
                    if (!isValid(base))
                        return base;
                    return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
                });
            }
        }
        util.assertNever(effect);
    }
}
ZodEffects.create = (schema, effect, params) => {
    return new ZodEffects({
        schema,
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        effect,
        ...processCreateParams(params),
    });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
    return new ZodEffects({
        schema,
        effect: { type: "preprocess", transform: preprocess },
        typeName: ZodFirstPartyTypeKind.ZodEffects,
        ...processCreateParams(params),
    });
};
class ZodOptional extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.undefined) {
            return OK(undefined);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodOptional.create = (type, params) => {
    return new ZodOptional({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodOptional,
        ...processCreateParams(params),
    });
};
class ZodNullable extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === ZodParsedType.null) {
            return OK(null);
        }
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
ZodNullable.create = (type, params) => {
    return new ZodNullable({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodNullable,
        ...processCreateParams(params),
    });
};
class ZodDefault extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === ZodParsedType.undefined) {
            data = this._def.defaultValue();
        }
        return this._def.innerType._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
ZodDefault.create = (type, params) => {
    return new ZodDefault({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodDefault,
        defaultValue: typeof params.default === "function"
            ? params.default
            : () => params.default,
        ...processCreateParams(params),
    });
};
class ZodCatch extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: [],
            },
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx,
            },
        });
        if (isAsync(result)) {
            return result.then((result) => {
                return {
                    status: "valid",
                    value: result.status === "valid"
                        ? result.value
                        : this._def.catchValue({
                            get error() {
                                return new ZodError(newCtx.common.issues);
                            },
                            input: newCtx.data,
                        }),
                };
            });
        }
        else {
            return {
                status: "valid",
                value: result.status === "valid"
                    ? result.value
                    : this._def.catchValue({
                        get error() {
                            return new ZodError(newCtx.common.issues);
                        },
                        input: newCtx.data,
                    }),
            };
        }
    }
    removeCatch() {
        return this._def.innerType;
    }
}
ZodCatch.create = (type, params) => {
    return new ZodCatch({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
        ...processCreateParams(params),
    });
};
class ZodNaN extends ZodType {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== ZodParsedType.nan) {
            const ctx = this._getOrReturnCtx(input);
            addIssueToContext(ctx, {
                code: ZodIssueCode.invalid_type,
                expected: ZodParsedType.nan,
                received: ctx.parsedType,
            });
            return INVALID;
        }
        return { status: "valid", value: input.data };
    }
}
ZodNaN.create = (params) => {
    return new ZodNaN({
        typeName: ZodFirstPartyTypeKind.ZodNaN,
        ...processCreateParams(params),
    });
};
const BRAND = Symbol("zod_brand");
class ZodBranded extends ZodType {
    _parse(input) {
        const { ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data,
            path: ctx.path,
            parent: ctx,
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class ZodPipeline extends ZodType {
    _parse(input) {
        const { status, ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async () => {
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx,
                });
                if (inResult.status === "aborted")
                    return INVALID;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return DIRTY(inResult.value);
                }
                else {
                    return this._def.out._parseAsync({
                        data: inResult.value,
                        path: ctx.path,
                        parent: ctx,
                    });
                }
            };
            return handleAsync();
        }
        else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx,
            });
            if (inResult.status === "aborted")
                return INVALID;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value,
                };
            }
            else {
                return this._def.out._parseSync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx,
                });
            }
        }
    }
    static create(a, b) {
        return new ZodPipeline({
            in: a,
            out: b,
            typeName: ZodFirstPartyTypeKind.ZodPipeline,
        });
    }
}
class ZodReadonly extends ZodType {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if (isValid(result)) {
            result.value = Object.freeze(result.value);
        }
        return result;
    }
}
ZodReadonly.create = (type, params) => {
    return new ZodReadonly({
        innerType: type,
        typeName: ZodFirstPartyTypeKind.ZodReadonly,
        ...processCreateParams(params),
    });
};
const custom = (check, params = {}, 
/**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */
fatal) => {
    if (check)
        return ZodAny.create().superRefine((data, ctx) => {
            var _a, _b;
            if (!check(data)) {
                const p = typeof params === "function"
                    ? params(data)
                    : typeof params === "string"
                        ? { message: params }
                        : params;
                const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
                const p2 = typeof p === "string" ? { message: p } : p;
                ctx.addIssue({ code: "custom", ...p2, fatal: _fatal });
            }
        });
    return ZodAny.create();
};
const late = {
    object: ZodObject.lazycreate,
};
var ZodFirstPartyTypeKind;
(function (ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
const instanceOfType = (
// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`,
}) => custom((data) => data instanceof cls, params);
const stringType = ZodString.create;
const numberType = ZodNumber.create;
const nanType = ZodNaN.create;
const bigIntType = ZodBigInt.create;
const booleanType = ZodBoolean.create;
const dateType = ZodDate.create;
const symbolType = ZodSymbol.create;
const undefinedType = ZodUndefined.create;
const nullType = ZodNull.create;
const anyType = ZodAny.create;
const unknownType = ZodUnknown.create;
const neverType = ZodNever.create;
const voidType = ZodVoid.create;
const arrayType = ZodArray.create;
const objectType = ZodObject.create;
const strictObjectType = ZodObject.strictCreate;
const unionType = ZodUnion.create;
const discriminatedUnionType = ZodDiscriminatedUnion.create;
const intersectionType = ZodIntersection.create;
const tupleType = ZodTuple.create;
const recordType = ZodRecord.create;
const mapType = ZodMap.create;
const setType = ZodSet.create;
const functionType = ZodFunction.create;
const lazyType = ZodLazy.create;
const literalType = ZodLiteral.create;
const enumType = ZodEnum.create;
const nativeEnumType = ZodNativeEnum.create;
const promiseType = ZodPromise.create;
const effectsType = ZodEffects.create;
const optionalType = ZodOptional.create;
const nullableType = ZodNullable.create;
const preprocessType = ZodEffects.createWithPreprocess;
const pipelineType = ZodPipeline.create;
const ostring = () => stringType().optional();
const onumber = () => numberType().optional();
const oboolean = () => booleanType().optional();
const coerce = {
    string: ((arg) => ZodString.create({ ...arg, coerce: true })),
    number: ((arg) => ZodNumber.create({ ...arg, coerce: true })),
    boolean: ((arg) => ZodBoolean.create({
        ...arg,
        coerce: true,
    })),
    bigint: ((arg) => ZodBigInt.create({ ...arg, coerce: true })),
    date: ((arg) => ZodDate.create({ ...arg, coerce: true })),
};
const NEVER = INVALID;

var z = /*#__PURE__*/Object.freeze({
    __proto__: null,
    defaultErrorMap: errorMap,
    setErrorMap: setErrorMap,
    getErrorMap: getErrorMap,
    makeIssue: makeIssue,
    EMPTY_PATH: EMPTY_PATH,
    addIssueToContext: addIssueToContext,
    ParseStatus: ParseStatus,
    INVALID: INVALID,
    DIRTY: DIRTY,
    OK: OK,
    isAborted: isAborted,
    isDirty: isDirty,
    isValid: isValid,
    isAsync: isAsync,
    get util () { return util; },
    get objectUtil () { return objectUtil; },
    ZodParsedType: ZodParsedType,
    getParsedType: getParsedType,
    ZodType: ZodType,
    ZodString: ZodString,
    ZodNumber: ZodNumber,
    ZodBigInt: ZodBigInt,
    ZodBoolean: ZodBoolean,
    ZodDate: ZodDate,
    ZodSymbol: ZodSymbol,
    ZodUndefined: ZodUndefined,
    ZodNull: ZodNull,
    ZodAny: ZodAny,
    ZodUnknown: ZodUnknown,
    ZodNever: ZodNever,
    ZodVoid: ZodVoid,
    ZodArray: ZodArray,
    ZodObject: ZodObject,
    ZodUnion: ZodUnion,
    ZodDiscriminatedUnion: ZodDiscriminatedUnion,
    ZodIntersection: ZodIntersection,
    ZodTuple: ZodTuple,
    ZodRecord: ZodRecord,
    ZodMap: ZodMap,
    ZodSet: ZodSet,
    ZodFunction: ZodFunction,
    ZodLazy: ZodLazy,
    ZodLiteral: ZodLiteral,
    ZodEnum: ZodEnum,
    ZodNativeEnum: ZodNativeEnum,
    ZodPromise: ZodPromise,
    ZodEffects: ZodEffects,
    ZodTransformer: ZodEffects,
    ZodOptional: ZodOptional,
    ZodNullable: ZodNullable,
    ZodDefault: ZodDefault,
    ZodCatch: ZodCatch,
    ZodNaN: ZodNaN,
    BRAND: BRAND,
    ZodBranded: ZodBranded,
    ZodPipeline: ZodPipeline,
    ZodReadonly: ZodReadonly,
    custom: custom,
    Schema: ZodType,
    ZodSchema: ZodType,
    late: late,
    get ZodFirstPartyTypeKind () { return ZodFirstPartyTypeKind; },
    coerce: coerce,
    any: anyType,
    array: arrayType,
    bigint: bigIntType,
    boolean: booleanType,
    date: dateType,
    discriminatedUnion: discriminatedUnionType,
    effect: effectsType,
    'enum': enumType,
    'function': functionType,
    'instanceof': instanceOfType,
    intersection: intersectionType,
    lazy: lazyType,
    literal: literalType,
    map: mapType,
    nan: nanType,
    nativeEnum: nativeEnumType,
    never: neverType,
    'null': nullType,
    nullable: nullableType,
    number: numberType,
    object: objectType,
    oboolean: oboolean,
    onumber: onumber,
    optional: optionalType,
    ostring: ostring,
    pipeline: pipelineType,
    preprocess: preprocessType,
    promise: promiseType,
    record: recordType,
    set: setType,
    strictObject: strictObjectType,
    string: stringType,
    symbol: symbolType,
    transformer: effectsType,
    tuple: tupleType,
    'undefined': undefinedType,
    union: unionType,
    unknown: unknownType,
    'void': voidType,
    NEVER: NEVER,
    ZodIssueCode: ZodIssueCode,
    quotelessJson: quotelessJson,
    ZodError: ZodError
});




/***/ }),

/***/ 80684:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ke": function() { return /* binding */ ARRIVAL_STATUS; },
  "DF": function() { return /* binding */ CALS_IDENTIFIER; },
  "P8": function() { return /* binding */ CONVEYANCE_TYPES; },
  "jJ": function() { return /* binding */ ConversionTrackingHelper; },
  "Nc": function() { return /* binding */ Customizer; },
  "Fb": function() { return /* binding */ DELIVERY_PROVIDER_STATUS; },
  "yU": function() { return /* binding */ InvalidBasket; },
  "dI": function() { return /* binding */ KoalaEnv; },
  "lo": function() { return /* binding */ MenuGetError; },
  "Xm": function() { return /* binding */ NotModified; },
  "G4": function() { return /* binding */ PAYMENT_TYPES; },
  "p9": function() { return /* binding */ UpsellsStep; },
  "fC": function() { return /* binding */ fallbackConfig; },
  "hL": function() { return /* binding */ fallbackStrings; },
  "fn": function() { return /* binding */ sdkStorage; },
  "fH": function() { return /* binding */ sdkUtils; }
});

// UNUSED EXPORTS: APP_TYPES, CONVEYANCE_MODES, DELIVER_PROVIDER_TERMINATING_STATUS, ErrorGettingLocation, InvalidIndex, InvalidQuantity, LocalStorageNull, LocationGetError, LocationRequired, MenuRequired, PROGRAM_TYPES, ReplaceBasketItemInvalid, StaleSession, Storage, TOKEN_TYPES, UpdateBasketError, address, allergenItemFixture, basketConveyanceDetailsFixture, basketFixture, basketItem, basketItemFixture, basketV2, basketV2Fixture, basketV2ItemFixture, billingAccount, cash, categoryFixture, categoryResponseFixture, conveyanceType, creditCard, creditCardBase, creditCardToken, crossSellsFixture, crossSellsOfferFixture, curbsideFixture, customerDetails, customerDetailsFixture, customerDetailsV2, dateTime, deliveryAddress, deliveryAddressFixture, deliveryAddressV2Fixture, deliveryCoverageResponseFixture, deliveryFixture, deliveryStatusFixture, digitalWallet, dineInFixture, donationFixture, driveInFixture, driveThruFixture, existingOptionFixture, externalAuthConfigFixture, fee, feeFixture, geoIpFixture, giftCard, handoffTimes, handoffTimesFixture, locationCachedDataFixture, locationFixture, locationOperatingHoursFixture, loyaltyConfigFixture, loyaltyStateFixture, loyaltyUserFixture, menuProductFixture, menuProductImagesFixture, menuProductLabelFixture, menuProductOptionFixture, menuProductOptionGroupFixture, menuProductResponseFixture, messageItemFixture, optionChoice, optionChoiceFixture, orderDetailsFixture, orderFixture, orderingTokenConfigFixture, orgTokenConfigFixture, organizationFixture, paymentDetails, paymentDetailsFixture, paymentTokenConfigFixture, paymentTypesFixture, pickupFixture, popularProductsFixture, popularProductsOfferFixture, redeemableItemFixture, redemptionItemFixture, requestMetaFixture, rewardHistoryItemFixture, rewardItemFixture, savedCardFixture, socialCauseFixture, storedAddress, storedAddressFixture, storedValueBalanceFixture, storedValueRequirement, submissionDetails, supportedPaymentMethods, supportedPaymentTypes, supportedPaymentTypesFixture, tagItemFixture, tokenConfigFixture, tokenizedCreditCard, tokenizedCreditCardFixture

;// CONCATENATED MODULE: ../../node_modules/fuse.js/dist/fuse.esm.js
/**
 * Fuse.js v6.6.2 - Lightweight fuzzy-search (http://fusejs.io)
 *
 * Copyright (c) 2022 Kiro Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 */

function isArray(value) {
  return !Array.isArray
    ? getTag(value) === '[object Array]'
    : Array.isArray(value)
}

// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/baseToString.js
const INFINITY = 1 / 0;
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value
  }
  let result = value + '';
  return result == '0' && 1 / value == -INFINITY ? '-0' : result
}

function fuse_esm_toString(value) {
  return value == null ? '' : baseToString(value)
}

function isString(value) {
  return typeof value === 'string'
}

function isNumber(value) {
  return typeof value === 'number'
}

// Adapted from: https://github.com/lodash/lodash/blob/master/isBoolean.js
function isBoolean(value) {
  return (
    value === true ||
    value === false ||
    (isObjectLike(value) && getTag(value) == '[object Boolean]')
  )
}

function isObject(value) {
  return typeof value === 'object'
}

// Checks if `value` is object-like.
function isObjectLike(value) {
  return isObject(value) && value !== null
}

function isDefined(value) {
  return value !== undefined && value !== null
}

function isBlank(value) {
  return !value.trim().length
}

// Gets the `toStringTag` of `value`.
// Adapted from: https://github.com/lodash/lodash/blob/master/.internal/getTag.js
function getTag(value) {
  return value == null
    ? value === undefined
      ? '[object Undefined]'
      : '[object Null]'
    : Object.prototype.toString.call(value)
}

const EXTENDED_SEARCH_UNAVAILABLE = 'Extended search is not available';

const INCORRECT_INDEX_TYPE = "Incorrect 'index' type";

const LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY = (key) =>
  `Invalid value for key ${key}`;

const PATTERN_LENGTH_TOO_LARGE = (max) =>
  `Pattern length exceeds max of ${max}.`;

const MISSING_KEY_PROPERTY = (name) => `Missing ${name} property in key`;

const INVALID_KEY_WEIGHT_VALUE = (key) =>
  `Property 'weight' in key '${key}' must be a positive integer`;

const hasOwn = Object.prototype.hasOwnProperty;

class KeyStore {
  constructor(keys) {
    this._keys = [];
    this._keyMap = {};

    let totalWeight = 0;

    keys.forEach((key) => {
      let obj = createKey(key);

      totalWeight += obj.weight;

      this._keys.push(obj);
      this._keyMap[obj.id] = obj;

      totalWeight += obj.weight;
    });

    // Normalize weights so that their sum is equal to 1
    this._keys.forEach((key) => {
      key.weight /= totalWeight;
    });
  }
  get(keyId) {
    return this._keyMap[keyId]
  }
  keys() {
    return this._keys
  }
  toJSON() {
    return JSON.stringify(this._keys)
  }
}

function createKey(key) {
  let path = null;
  let id = null;
  let src = null;
  let weight = 1;
  let getFn = null;

  if (isString(key) || isArray(key)) {
    src = key;
    path = createKeyPath(key);
    id = createKeyId(key);
  } else {
    if (!hasOwn.call(key, 'name')) {
      throw new Error(MISSING_KEY_PROPERTY('name'))
    }

    const name = key.name;
    src = name;

    if (hasOwn.call(key, 'weight')) {
      weight = key.weight;

      if (weight <= 0) {
        throw new Error(INVALID_KEY_WEIGHT_VALUE(name))
      }
    }

    path = createKeyPath(name);
    id = createKeyId(name);
    getFn = key.getFn;
  }

  return { path, id, weight, src, getFn }
}

function createKeyPath(key) {
  return isArray(key) ? key : key.split('.')
}

function createKeyId(key) {
  return isArray(key) ? key.join('.') : key
}

function get(obj, path) {
  let list = [];
  let arr = false;

  const deepGet = (obj, path, index) => {
    if (!isDefined(obj)) {
      return
    }
    if (!path[index]) {
      // If there's no path left, we've arrived at the object we care about.
      list.push(obj);
    } else {
      let key = path[index];

      const value = obj[key];

      if (!isDefined(value)) {
        return
      }

      // If we're at the last value in the path, and if it's a string/number/bool,
      // add it to the list
      if (
        index === path.length - 1 &&
        (isString(value) || isNumber(value) || isBoolean(value))
      ) {
        list.push(fuse_esm_toString(value));
      } else if (isArray(value)) {
        arr = true;
        // Search each item in the array.
        for (let i = 0, len = value.length; i < len; i += 1) {
          deepGet(value[i], path, index + 1);
        }
      } else if (path.length) {
        // An object. Recurse further.
        deepGet(value, path, index + 1);
      }
    }
  };

  // Backwards compatibility (since path used to be a string)
  deepGet(obj, isString(path) ? path.split('.') : path, 0);

  return arr ? list : list[0]
}

const MatchOptions = {
  // Whether the matches should be included in the result set. When `true`, each record in the result
  // set will include the indices of the matched characters.
  // These can consequently be used for highlighting purposes.
  includeMatches: false,
  // When `true`, the matching function will continue to the end of a search pattern even if
  // a perfect match has already been located in the string.
  findAllMatches: false,
  // Minimum number of characters that must be matched before a result is considered a match
  minMatchCharLength: 1
};

const BasicOptions = {
  // When `true`, the algorithm continues searching to the end of the input even if a perfect
  // match is found before the end of the same input.
  isCaseSensitive: false,
  // When true, the matching function will continue to the end of a search pattern even if
  includeScore: false,
  // List of properties that will be searched. This also supports nested properties.
  keys: [],
  // Whether to sort the result list, by score
  shouldSort: true,
  // Default sort function: sort by ascending score, ascending index
  sortFn: (a, b) =>
    a.score === b.score ? (a.idx < b.idx ? -1 : 1) : a.score < b.score ? -1 : 1
};

const FuzzyOptions = {
  // Approximately where in the text is the pattern expected to be found?
  location: 0,
  // At what point does the match algorithm give up. A threshold of '0.0' requires a perfect match
  // (of both letters and location), a threshold of '1.0' would match anything.
  threshold: 0.6,
  // Determines how close the match must be to the fuzzy location (specified above).
  // An exact letter match which is 'distance' characters away from the fuzzy location
  // would score as a complete mismatch. A distance of '0' requires the match be at
  // the exact location specified, a threshold of '1000' would require a perfect match
  // to be within 800 characters of the fuzzy location to be found using a 0.8 threshold.
  distance: 100
};

const AdvancedOptions = {
  // When `true`, it enables the use of unix-like search commands
  useExtendedSearch: false,
  // The get function to use when fetching an object's properties.
  // The default will search nested paths *ie foo.bar.baz*
  getFn: get,
  // When `true`, search will ignore `location` and `distance`, so it won't matter
  // where in the string the pattern appears.
  // More info: https://fusejs.io/concepts/scoring-theory.html#fuzziness-score
  ignoreLocation: false,
  // When `true`, the calculation for the relevance score (used for sorting) will
  // ignore the field-length norm.
  // More info: https://fusejs.io/concepts/scoring-theory.html#field-length-norm
  ignoreFieldNorm: false,
  // The weight to determine how much field length norm effects scoring.
  fieldNormWeight: 1
};

var Config = {
  ...BasicOptions,
  ...MatchOptions,
  ...FuzzyOptions,
  ...AdvancedOptions
};

const SPACE = /[^ ]+/g;

// Field-length norm: the shorter the field, the higher the weight.
// Set to 3 decimals to reduce index size.
function norm(weight = 1, mantissa = 3) {
  const cache = new Map();
  const m = Math.pow(10, mantissa);

  return {
    get(value) {
      const numTokens = value.match(SPACE).length;

      if (cache.has(numTokens)) {
        return cache.get(numTokens)
      }

      // Default function is 1/sqrt(x), weight makes that variable
      const norm = 1 / Math.pow(numTokens, 0.5 * weight);

      // In place of `toFixed(mantissa)`, for faster computation
      const n = parseFloat(Math.round(norm * m) / m);

      cache.set(numTokens, n);

      return n
    },
    clear() {
      cache.clear();
    }
  }
}

class FuseIndex {
  constructor({
    getFn = Config.getFn,
    fieldNormWeight = Config.fieldNormWeight
  } = {}) {
    this.norm = norm(fieldNormWeight, 3);
    this.getFn = getFn;
    this.isCreated = false;

    this.setIndexRecords();
  }
  setSources(docs = []) {
    this.docs = docs;
  }
  setIndexRecords(records = []) {
    this.records = records;
  }
  setKeys(keys = []) {
    this.keys = keys;
    this._keysMap = {};
    keys.forEach((key, idx) => {
      this._keysMap[key.id] = idx;
    });
  }
  create() {
    if (this.isCreated || !this.docs.length) {
      return
    }

    this.isCreated = true;

    // List is Array<String>
    if (isString(this.docs[0])) {
      this.docs.forEach((doc, docIndex) => {
        this._addString(doc, docIndex);
      });
    } else {
      // List is Array<Object>
      this.docs.forEach((doc, docIndex) => {
        this._addObject(doc, docIndex);
      });
    }

    this.norm.clear();
  }
  // Adds a doc to the end of the index
  add(doc) {
    const idx = this.size();

    if (isString(doc)) {
      this._addString(doc, idx);
    } else {
      this._addObject(doc, idx);
    }
  }
  // Removes the doc at the specified index of the index
  removeAt(idx) {
    this.records.splice(idx, 1);

    // Change ref index of every subsquent doc
    for (let i = idx, len = this.size(); i < len; i += 1) {
      this.records[i].i -= 1;
    }
  }
  getValueForItemAtKeyId(item, keyId) {
    return item[this._keysMap[keyId]]
  }
  size() {
    return this.records.length
  }
  _addString(doc, docIndex) {
    if (!isDefined(doc) || isBlank(doc)) {
      return
    }

    let record = {
      v: doc,
      i: docIndex,
      n: this.norm.get(doc)
    };

    this.records.push(record);
  }
  _addObject(doc, docIndex) {
    let record = { i: docIndex, $: {} };

    // Iterate over every key (i.e, path), and fetch the value at that key
    this.keys.forEach((key, keyIndex) => {
      let value = key.getFn ? key.getFn(doc) : this.getFn(doc, key.path);

      if (!isDefined(value)) {
        return
      }

      if (isArray(value)) {
        let subRecords = [];
        const stack = [{ nestedArrIndex: -1, value }];

        while (stack.length) {
          const { nestedArrIndex, value } = stack.pop();

          if (!isDefined(value)) {
            continue
          }

          if (isString(value) && !isBlank(value)) {
            let subRecord = {
              v: value,
              i: nestedArrIndex,
              n: this.norm.get(value)
            };

            subRecords.push(subRecord);
          } else if (isArray(value)) {
            value.forEach((item, k) => {
              stack.push({
                nestedArrIndex: k,
                value: item
              });
            });
          } else ;
        }
        record.$[keyIndex] = subRecords;
      } else if (isString(value) && !isBlank(value)) {
        let subRecord = {
          v: value,
          n: this.norm.get(value)
        };

        record.$[keyIndex] = subRecord;
      }
    });

    this.records.push(record);
  }
  toJSON() {
    return {
      keys: this.keys,
      records: this.records
    }
  }
}

function createIndex(
  keys,
  docs,
  { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}
) {
  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
  myIndex.setKeys(keys.map(createKey));
  myIndex.setSources(docs);
  myIndex.create();
  return myIndex
}

function parseIndex(
  data,
  { getFn = Config.getFn, fieldNormWeight = Config.fieldNormWeight } = {}
) {
  const { keys, records } = data;
  const myIndex = new FuseIndex({ getFn, fieldNormWeight });
  myIndex.setKeys(keys);
  myIndex.setIndexRecords(records);
  return myIndex
}

function computeScore$1(
  pattern,
  {
    errors = 0,
    currentLocation = 0,
    expectedLocation = 0,
    distance = Config.distance,
    ignoreLocation = Config.ignoreLocation
  } = {}
) {
  const accuracy = errors / pattern.length;

  if (ignoreLocation) {
    return accuracy
  }

  const proximity = Math.abs(expectedLocation - currentLocation);

  if (!distance) {
    // Dodge divide by zero error.
    return proximity ? 1.0 : accuracy
  }

  return accuracy + proximity / distance
}

function convertMaskToIndices(
  matchmask = [],
  minMatchCharLength = Config.minMatchCharLength
) {
  let indices = [];
  let start = -1;
  let end = -1;
  let i = 0;

  for (let len = matchmask.length; i < len; i += 1) {
    let match = matchmask[i];
    if (match && start === -1) {
      start = i;
    } else if (!match && start !== -1) {
      end = i - 1;
      if (end - start + 1 >= minMatchCharLength) {
        indices.push([start, end]);
      }
      start = -1;
    }
  }

  // (i-1 - start) + 1 => i - start
  if (matchmask[i - 1] && i - start >= minMatchCharLength) {
    indices.push([start, i - 1]);
  }

  return indices
}

// Machine word size
const MAX_BITS = 32;

function search(
  text,
  pattern,
  patternAlphabet,
  {
    location = Config.location,
    distance = Config.distance,
    threshold = Config.threshold,
    findAllMatches = Config.findAllMatches,
    minMatchCharLength = Config.minMatchCharLength,
    includeMatches = Config.includeMatches,
    ignoreLocation = Config.ignoreLocation
  } = {}
) {
  if (pattern.length > MAX_BITS) {
    throw new Error(PATTERN_LENGTH_TOO_LARGE(MAX_BITS))
  }

  const patternLen = pattern.length;
  // Set starting location at beginning text and initialize the alphabet.
  const textLen = text.length;
  // Handle the case when location > text.length
  const expectedLocation = Math.max(0, Math.min(location, textLen));
  // Highest score beyond which we give up.
  let currentThreshold = threshold;
  // Is there a nearby exact match? (speedup)
  let bestLocation = expectedLocation;

  // Performance: only computer matches when the minMatchCharLength > 1
  // OR if `includeMatches` is true.
  const computeMatches = minMatchCharLength > 1 || includeMatches;
  // A mask of the matches, used for building the indices
  const matchMask = computeMatches ? Array(textLen) : [];

  let index;

  // Get all exact matches, here for speed up
  while ((index = text.indexOf(pattern, bestLocation)) > -1) {
    let score = computeScore$1(pattern, {
      currentLocation: index,
      expectedLocation,
      distance,
      ignoreLocation
    });

    currentThreshold = Math.min(score, currentThreshold);
    bestLocation = index + patternLen;

    if (computeMatches) {
      let i = 0;
      while (i < patternLen) {
        matchMask[index + i] = 1;
        i += 1;
      }
    }
  }

  // Reset the best location
  bestLocation = -1;

  let lastBitArr = [];
  let finalScore = 1;
  let binMax = patternLen + textLen;

  const mask = 1 << (patternLen - 1);

  for (let i = 0; i < patternLen; i += 1) {
    // Scan for the best match; each iteration allows for one more error.
    // Run a binary search to determine how far from the match location we can stray
    // at this error level.
    let binMin = 0;
    let binMid = binMax;

    while (binMin < binMid) {
      const score = computeScore$1(pattern, {
        errors: i,
        currentLocation: expectedLocation + binMid,
        expectedLocation,
        distance,
        ignoreLocation
      });

      if (score <= currentThreshold) {
        binMin = binMid;
      } else {
        binMax = binMid;
      }

      binMid = Math.floor((binMax - binMin) / 2 + binMin);
    }

    // Use the result from this iteration as the maximum for the next.
    binMax = binMid;

    let start = Math.max(1, expectedLocation - binMid + 1);
    let finish = findAllMatches
      ? textLen
      : Math.min(expectedLocation + binMid, textLen) + patternLen;

    // Initialize the bit array
    let bitArr = Array(finish + 2);

    bitArr[finish + 1] = (1 << i) - 1;

    for (let j = finish; j >= start; j -= 1) {
      let currentLocation = j - 1;
      let charMatch = patternAlphabet[text.charAt(currentLocation)];

      if (computeMatches) {
        // Speed up: quick bool to int conversion (i.e, `charMatch ? 1 : 0`)
        matchMask[currentLocation] = +!!charMatch;
      }

      // First pass: exact match
      bitArr[j] = ((bitArr[j + 1] << 1) | 1) & charMatch;

      // Subsequent passes: fuzzy match
      if (i) {
        bitArr[j] |=
          ((lastBitArr[j + 1] | lastBitArr[j]) << 1) | 1 | lastBitArr[j + 1];
      }

      if (bitArr[j] & mask) {
        finalScore = computeScore$1(pattern, {
          errors: i,
          currentLocation,
          expectedLocation,
          distance,
          ignoreLocation
        });

        // This match will almost certainly be better than any existing match.
        // But check anyway.
        if (finalScore <= currentThreshold) {
          // Indeed it is
          currentThreshold = finalScore;
          bestLocation = currentLocation;

          // Already passed `loc`, downhill from here on in.
          if (bestLocation <= expectedLocation) {
            break
          }

          // When passing `bestLocation`, don't exceed our current distance from `expectedLocation`.
          start = Math.max(1, 2 * expectedLocation - bestLocation);
        }
      }
    }

    // No hope for a (better) match at greater error levels.
    const score = computeScore$1(pattern, {
      errors: i + 1,
      currentLocation: expectedLocation,
      expectedLocation,
      distance,
      ignoreLocation
    });

    if (score > currentThreshold) {
      break
    }

    lastBitArr = bitArr;
  }

  const result = {
    isMatch: bestLocation >= 0,
    // Count exact matches (those with a score of 0) to be "almost" exact
    score: Math.max(0.001, finalScore)
  };

  if (computeMatches) {
    const indices = convertMaskToIndices(matchMask, minMatchCharLength);
    if (!indices.length) {
      result.isMatch = false;
    } else if (includeMatches) {
      result.indices = indices;
    }
  }

  return result
}

function createPatternAlphabet(pattern) {
  let mask = {};

  for (let i = 0, len = pattern.length; i < len; i += 1) {
    const char = pattern.charAt(i);
    mask[char] = (mask[char] || 0) | (1 << (len - i - 1));
  }

  return mask
}

class BitapSearch {
  constructor(
    pattern,
    {
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance,
      includeMatches = Config.includeMatches,
      findAllMatches = Config.findAllMatches,
      minMatchCharLength = Config.minMatchCharLength,
      isCaseSensitive = Config.isCaseSensitive,
      ignoreLocation = Config.ignoreLocation
    } = {}
  ) {
    this.options = {
      location,
      threshold,
      distance,
      includeMatches,
      findAllMatches,
      minMatchCharLength,
      isCaseSensitive,
      ignoreLocation
    };

    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();

    this.chunks = [];

    if (!this.pattern.length) {
      return
    }

    const addChunk = (pattern, startIndex) => {
      this.chunks.push({
        pattern,
        alphabet: createPatternAlphabet(pattern),
        startIndex
      });
    };

    const len = this.pattern.length;

    if (len > MAX_BITS) {
      let i = 0;
      const remainder = len % MAX_BITS;
      const end = len - remainder;

      while (i < end) {
        addChunk(this.pattern.substr(i, MAX_BITS), i);
        i += MAX_BITS;
      }

      if (remainder) {
        const startIndex = len - MAX_BITS;
        addChunk(this.pattern.substr(startIndex), startIndex);
      }
    } else {
      addChunk(this.pattern, 0);
    }
  }

  searchIn(text) {
    const { isCaseSensitive, includeMatches } = this.options;

    if (!isCaseSensitive) {
      text = text.toLowerCase();
    }

    // Exact match
    if (this.pattern === text) {
      let result = {
        isMatch: true,
        score: 0
      };

      if (includeMatches) {
        result.indices = [[0, text.length - 1]];
      }

      return result
    }

    // Otherwise, use Bitap algorithm
    const {
      location,
      distance,
      threshold,
      findAllMatches,
      minMatchCharLength,
      ignoreLocation
    } = this.options;

    let allIndices = [];
    let totalScore = 0;
    let hasMatches = false;

    this.chunks.forEach(({ pattern, alphabet, startIndex }) => {
      const { isMatch, score, indices } = search(text, pattern, alphabet, {
        location: location + startIndex,
        distance,
        threshold,
        findAllMatches,
        minMatchCharLength,
        includeMatches,
        ignoreLocation
      });

      if (isMatch) {
        hasMatches = true;
      }

      totalScore += score;

      if (isMatch && indices) {
        allIndices = [...allIndices, ...indices];
      }
    });

    let result = {
      isMatch: hasMatches,
      score: hasMatches ? totalScore / this.chunks.length : 1
    };

    if (hasMatches && includeMatches) {
      result.indices = allIndices;
    }

    return result
  }
}

class BaseMatch {
  constructor(pattern) {
    this.pattern = pattern;
  }
  static isMultiMatch(pattern) {
    return getMatch(pattern, this.multiRegex)
  }
  static isSingleMatch(pattern) {
    return getMatch(pattern, this.singleRegex)
  }
  search(/*text*/) {}
}

function getMatch(pattern, exp) {
  const matches = pattern.match(exp);
  return matches ? matches[1] : null
}

// Token: 'file

class ExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'exact'
  }
  static get multiRegex() {
    return /^="(.*)"$/
  }
  static get singleRegex() {
    return /^=(.*)$/
  }
  search(text) {
    const isMatch = text === this.pattern;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    }
  }
}

// Token: !fire

class InverseExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-exact'
  }
  static get multiRegex() {
    return /^!"(.*)"$/
  }
  static get singleRegex() {
    return /^!(.*)$/
  }
  search(text) {
    const index = text.indexOf(this.pattern);
    const isMatch = index === -1;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

// Token: ^file

class PrefixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'prefix-exact'
  }
  static get multiRegex() {
    return /^\^"(.*)"$/
  }
  static get singleRegex() {
    return /^\^(.*)$/
  }
  search(text) {
    const isMatch = text.startsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, this.pattern.length - 1]
    }
  }
}

// Token: !^fire

class InversePrefixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-prefix-exact'
  }
  static get multiRegex() {
    return /^!\^"(.*)"$/
  }
  static get singleRegex() {
    return /^!\^(.*)$/
  }
  search(text) {
    const isMatch = !text.startsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

// Token: .file$

class SuffixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'suffix-exact'
  }
  static get multiRegex() {
    return /^"(.*)"\$$/
  }
  static get singleRegex() {
    return /^(.*)\$$/
  }
  search(text) {
    const isMatch = text.endsWith(this.pattern);

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [text.length - this.pattern.length, text.length - 1]
    }
  }
}

// Token: !.file$

class InverseSuffixExactMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'inverse-suffix-exact'
  }
  static get multiRegex() {
    return /^!"(.*)"\$$/
  }
  static get singleRegex() {
    return /^!(.*)\$$/
  }
  search(text) {
    const isMatch = !text.endsWith(this.pattern);
    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices: [0, text.length - 1]
    }
  }
}

class FuzzyMatch extends BaseMatch {
  constructor(
    pattern,
    {
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance,
      includeMatches = Config.includeMatches,
      findAllMatches = Config.findAllMatches,
      minMatchCharLength = Config.minMatchCharLength,
      isCaseSensitive = Config.isCaseSensitive,
      ignoreLocation = Config.ignoreLocation
    } = {}
  ) {
    super(pattern);
    this._bitapSearch = new BitapSearch(pattern, {
      location,
      threshold,
      distance,
      includeMatches,
      findAllMatches,
      minMatchCharLength,
      isCaseSensitive,
      ignoreLocation
    });
  }
  static get type() {
    return 'fuzzy'
  }
  static get multiRegex() {
    return /^"(.*)"$/
  }
  static get singleRegex() {
    return /^(.*)$/
  }
  search(text) {
    return this._bitapSearch.searchIn(text)
  }
}

// Token: 'file

class IncludeMatch extends BaseMatch {
  constructor(pattern) {
    super(pattern);
  }
  static get type() {
    return 'include'
  }
  static get multiRegex() {
    return /^'"(.*)"$/
  }
  static get singleRegex() {
    return /^'(.*)$/
  }
  search(text) {
    let location = 0;
    let index;

    const indices = [];
    const patternLen = this.pattern.length;

    // Get all exact matches
    while ((index = text.indexOf(this.pattern, location)) > -1) {
      location = index + patternLen;
      indices.push([index, location - 1]);
    }

    const isMatch = !!indices.length;

    return {
      isMatch,
      score: isMatch ? 0 : 1,
      indices
    }
  }
}

// ❗Order is important. DO NOT CHANGE.
const searchers = [
  ExactMatch,
  IncludeMatch,
  PrefixExactMatch,
  InversePrefixExactMatch,
  InverseSuffixExactMatch,
  SuffixExactMatch,
  InverseExactMatch,
  FuzzyMatch
];

const searchersLen = searchers.length;

// Regex to split by spaces, but keep anything in quotes together
const SPACE_RE = / +(?=(?:[^\"]*\"[^\"]*\")*[^\"]*$)/;
const OR_TOKEN = '|';

// Return a 2D array representation of the query, for simpler parsing.
// Example:
// "^core go$ | rb$ | py$ xy$" => [["^core", "go$"], ["rb$"], ["py$", "xy$"]]
function parseQuery(pattern, options = {}) {
  return pattern.split(OR_TOKEN).map((item) => {
    let query = item
      .trim()
      .split(SPACE_RE)
      .filter((item) => item && !!item.trim());

    let results = [];
    for (let i = 0, len = query.length; i < len; i += 1) {
      const queryItem = query[i];

      // 1. Handle multiple query match (i.e, once that are quoted, like `"hello world"`)
      let found = false;
      let idx = -1;
      while (!found && ++idx < searchersLen) {
        const searcher = searchers[idx];
        let token = searcher.isMultiMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          found = true;
        }
      }

      if (found) {
        continue
      }

      // 2. Handle single query matches (i.e, once that are *not* quoted)
      idx = -1;
      while (++idx < searchersLen) {
        const searcher = searchers[idx];
        let token = searcher.isSingleMatch(queryItem);
        if (token) {
          results.push(new searcher(token, options));
          break
        }
      }
    }

    return results
  })
}

// These extended matchers can return an array of matches, as opposed
// to a singl match
const MultiMatchSet = new Set([FuzzyMatch.type, IncludeMatch.type]);

/**
 * Command-like searching
 * ======================
 *
 * Given multiple search terms delimited by spaces.e.g. `^jscript .python$ ruby !java`,
 * search in a given text.
 *
 * Search syntax:
 *
 * | Token       | Match type                 | Description                            |
 * | ----------- | -------------------------- | -------------------------------------- |
 * | `jscript`   | fuzzy-match                | Items that fuzzy match `jscript`       |
 * | `=scheme`   | exact-match                | Items that are `scheme`                |
 * | `'python`   | include-match              | Items that include `python`            |
 * | `!ruby`     | inverse-exact-match        | Items that do not include `ruby`       |
 * | `^java`     | prefix-exact-match         | Items that start with `java`           |
 * | `!^earlang` | inverse-prefix-exact-match | Items that do not start with `earlang` |
 * | `.js$`      | suffix-exact-match         | Items that end with `.js`              |
 * | `!.go$`     | inverse-suffix-exact-match | Items that do not end with `.go`       |
 *
 * A single pipe character acts as an OR operator. For example, the following
 * query matches entries that start with `core` and end with either`go`, `rb`,
 * or`py`.
 *
 * ```
 * ^core go$ | rb$ | py$
 * ```
 */
class ExtendedSearch {
  constructor(
    pattern,
    {
      isCaseSensitive = Config.isCaseSensitive,
      includeMatches = Config.includeMatches,
      minMatchCharLength = Config.minMatchCharLength,
      ignoreLocation = Config.ignoreLocation,
      findAllMatches = Config.findAllMatches,
      location = Config.location,
      threshold = Config.threshold,
      distance = Config.distance
    } = {}
  ) {
    this.query = null;
    this.options = {
      isCaseSensitive,
      includeMatches,
      minMatchCharLength,
      findAllMatches,
      ignoreLocation,
      location,
      threshold,
      distance
    };

    this.pattern = isCaseSensitive ? pattern : pattern.toLowerCase();
    this.query = parseQuery(this.pattern, this.options);
  }

  static condition(_, options) {
    return options.useExtendedSearch
  }

  searchIn(text) {
    const query = this.query;

    if (!query) {
      return {
        isMatch: false,
        score: 1
      }
    }

    const { includeMatches, isCaseSensitive } = this.options;

    text = isCaseSensitive ? text : text.toLowerCase();

    let numMatches = 0;
    let allIndices = [];
    let totalScore = 0;

    // ORs
    for (let i = 0, qLen = query.length; i < qLen; i += 1) {
      const searchers = query[i];

      // Reset indices
      allIndices.length = 0;
      numMatches = 0;

      // ANDs
      for (let j = 0, pLen = searchers.length; j < pLen; j += 1) {
        const searcher = searchers[j];
        const { isMatch, indices, score } = searcher.search(text);

        if (isMatch) {
          numMatches += 1;
          totalScore += score;
          if (includeMatches) {
            const type = searcher.constructor.type;
            if (MultiMatchSet.has(type)) {
              allIndices = [...allIndices, ...indices];
            } else {
              allIndices.push(indices);
            }
          }
        } else {
          totalScore = 0;
          numMatches = 0;
          allIndices.length = 0;
          break
        }
      }

      // OR condition, so if TRUE, return
      if (numMatches) {
        let result = {
          isMatch: true,
          score: totalScore / numMatches
        };

        if (includeMatches) {
          result.indices = allIndices;
        }

        return result
      }
    }

    // Nothing was matched
    return {
      isMatch: false,
      score: 1
    }
  }
}

const registeredSearchers = [];

function register(...args) {
  registeredSearchers.push(...args);
}

function createSearcher(pattern, options) {
  for (let i = 0, len = registeredSearchers.length; i < len; i += 1) {
    let searcherClass = registeredSearchers[i];
    if (searcherClass.condition(pattern, options)) {
      return new searcherClass(pattern, options)
    }
  }

  return new BitapSearch(pattern, options)
}

const LogicalOperator = {
  AND: '$and',
  OR: '$or'
};

const KeyType = {
  PATH: '$path',
  PATTERN: '$val'
};

const isExpression = (query) =>
  !!(query[LogicalOperator.AND] || query[LogicalOperator.OR]);

const isPath = (query) => !!query[KeyType.PATH];

const isLeaf = (query) =>
  !isArray(query) && isObject(query) && !isExpression(query);

const convertToExplicit = (query) => ({
  [LogicalOperator.AND]: Object.keys(query).map((key) => ({
    [key]: query[key]
  }))
});

// When `auto` is `true`, the parse function will infer and initialize and add
// the appropriate `Searcher` instance
function parse(query, options, { auto = true } = {}) {
  const next = (query) => {
    let keys = Object.keys(query);

    const isQueryPath = isPath(query);

    if (!isQueryPath && keys.length > 1 && !isExpression(query)) {
      return next(convertToExplicit(query))
    }

    if (isLeaf(query)) {
      const key = isQueryPath ? query[KeyType.PATH] : keys[0];

      const pattern = isQueryPath ? query[KeyType.PATTERN] : query[key];

      if (!isString(pattern)) {
        throw new Error(LOGICAL_SEARCH_INVALID_QUERY_FOR_KEY(key))
      }

      const obj = {
        keyId: createKeyId(key),
        pattern
      };

      if (auto) {
        obj.searcher = createSearcher(pattern, options);
      }

      return obj
    }

    let node = {
      children: [],
      operator: keys[0]
    };

    keys.forEach((key) => {
      const value = query[key];

      if (isArray(value)) {
        value.forEach((item) => {
          node.children.push(next(item));
        });
      }
    });

    return node
  };

  if (!isExpression(query)) {
    query = convertToExplicit(query);
  }

  return next(query)
}

// Practical scoring function
function computeScore(
  results,
  { ignoreFieldNorm = Config.ignoreFieldNorm }
) {
  results.forEach((result) => {
    let totalScore = 1;

    result.matches.forEach(({ key, norm, score }) => {
      const weight = key ? key.weight : null;

      totalScore *= Math.pow(
        score === 0 && weight ? Number.EPSILON : score,
        (weight || 1) * (ignoreFieldNorm ? 1 : norm)
      );
    });

    result.score = totalScore;
  });
}

function transformMatches(result, data) {
  const matches = result.matches;
  data.matches = [];

  if (!isDefined(matches)) {
    return
  }

  matches.forEach((match) => {
    if (!isDefined(match.indices) || !match.indices.length) {
      return
    }

    const { indices, value } = match;

    let obj = {
      indices,
      value
    };

    if (match.key) {
      obj.key = match.key.src;
    }

    if (match.idx > -1) {
      obj.refIndex = match.idx;
    }

    data.matches.push(obj);
  });
}

function transformScore(result, data) {
  data.score = result.score;
}

function format(
  results,
  docs,
  {
    includeMatches = Config.includeMatches,
    includeScore = Config.includeScore
  } = {}
) {
  const transformers = [];

  if (includeMatches) transformers.push(transformMatches);
  if (includeScore) transformers.push(transformScore);

  return results.map((result) => {
    const { idx } = result;

    const data = {
      item: docs[idx],
      refIndex: idx
    };

    if (transformers.length) {
      transformers.forEach((transformer) => {
        transformer(result, data);
      });
    }

    return data
  })
}

class Fuse {
  constructor(docs, options = {}, index) {
    this.options = { ...Config, ...options };

    if (
      this.options.useExtendedSearch &&
      !true
    ) {}

    this._keyStore = new KeyStore(this.options.keys);

    this.setCollection(docs, index);
  }

  setCollection(docs, index) {
    this._docs = docs;

    if (index && !(index instanceof FuseIndex)) {
      throw new Error(INCORRECT_INDEX_TYPE)
    }

    this._myIndex =
      index ||
      createIndex(this.options.keys, this._docs, {
        getFn: this.options.getFn,
        fieldNormWeight: this.options.fieldNormWeight
      });
  }

  add(doc) {
    if (!isDefined(doc)) {
      return
    }

    this._docs.push(doc);
    this._myIndex.add(doc);
  }

  remove(predicate = (/* doc, idx */) => false) {
    const results = [];

    for (let i = 0, len = this._docs.length; i < len; i += 1) {
      const doc = this._docs[i];
      if (predicate(doc, i)) {
        this.removeAt(i);
        i -= 1;
        len -= 1;

        results.push(doc);
      }
    }

    return results
  }

  removeAt(idx) {
    this._docs.splice(idx, 1);
    this._myIndex.removeAt(idx);
  }

  getIndex() {
    return this._myIndex
  }

  search(query, { limit = -1 } = {}) {
    const {
      includeMatches,
      includeScore,
      shouldSort,
      sortFn,
      ignoreFieldNorm
    } = this.options;

    let results = isString(query)
      ? isString(this._docs[0])
        ? this._searchStringList(query)
        : this._searchObjectList(query)
      : this._searchLogical(query);

    computeScore(results, { ignoreFieldNorm });

    if (shouldSort) {
      results.sort(sortFn);
    }

    if (isNumber(limit) && limit > -1) {
      results = results.slice(0, limit);
    }

    return format(results, this._docs, {
      includeMatches,
      includeScore
    })
  }

  _searchStringList(query) {
    const searcher = createSearcher(query, this.options);
    const { records } = this._myIndex;
    const results = [];

    // Iterate over every string in the index
    records.forEach(({ v: text, i: idx, n: norm }) => {
      if (!isDefined(text)) {
        return
      }

      const { isMatch, score, indices } = searcher.searchIn(text);

      if (isMatch) {
        results.push({
          item: text,
          idx,
          matches: [{ score, value: text, norm, indices }]
        });
      }
    });

    return results
  }

  _searchLogical(query) {

    const expression = parse(query, this.options);

    const evaluate = (node, item, idx) => {
      if (!node.children) {
        const { keyId, searcher } = node;

        const matches = this._findMatches({
          key: this._keyStore.get(keyId),
          value: this._myIndex.getValueForItemAtKeyId(item, keyId),
          searcher
        });

        if (matches && matches.length) {
          return [
            {
              idx,
              item,
              matches
            }
          ]
        }

        return []
      }

      const res = [];
      for (let i = 0, len = node.children.length; i < len; i += 1) {
        const child = node.children[i];
        const result = evaluate(child, item, idx);
        if (result.length) {
          res.push(...result);
        } else if (node.operator === LogicalOperator.AND) {
          return []
        }
      }
      return res
    };

    const records = this._myIndex.records;
    const resultMap = {};
    const results = [];

    records.forEach(({ $: item, i: idx }) => {
      if (isDefined(item)) {
        let expResults = evaluate(expression, item, idx);

        if (expResults.length) {
          // Dedupe when adding
          if (!resultMap[idx]) {
            resultMap[idx] = { idx, item, matches: [] };
            results.push(resultMap[idx]);
          }
          expResults.forEach(({ matches }) => {
            resultMap[idx].matches.push(...matches);
          });
        }
      }
    });

    return results
  }

  _searchObjectList(query) {
    const searcher = createSearcher(query, this.options);
    const { keys, records } = this._myIndex;
    const results = [];

    // List is Array<Object>
    records.forEach(({ $: item, i: idx }) => {
      if (!isDefined(item)) {
        return
      }

      let matches = [];

      // Iterate over every key (i.e, path), and fetch the value at that key
      keys.forEach((key, keyIndex) => {
        matches.push(
          ...this._findMatches({
            key,
            value: item[keyIndex],
            searcher
          })
        );
      });

      if (matches.length) {
        results.push({
          idx,
          item,
          matches
        });
      }
    });

    return results
  }
  _findMatches({ key, value, searcher }) {
    if (!isDefined(value)) {
      return []
    }

    let matches = [];

    if (isArray(value)) {
      value.forEach(({ v: text, i: idx, n: norm }) => {
        if (!isDefined(text)) {
          return
        }

        const { isMatch, score, indices } = searcher.searchIn(text);

        if (isMatch) {
          matches.push({
            score,
            key,
            value: text,
            idx,
            norm,
            indices
          });
        }
      });
    } else {
      const { v: text, n: norm } = value;

      const { isMatch, score, indices } = searcher.searchIn(text);

      if (isMatch) {
        matches.push({ score, key, value: text, norm, indices });
      }
    }

    return matches
  }
}

Fuse.version = '6.6.2';
Fuse.createIndex = createIndex;
Fuse.parseIndex = parseIndex;
Fuse.config = Config;

{
  Fuse.parseQuery = parse;
}

{
  register(ExtendedSearch);
}



// EXTERNAL MODULE: ../../node_modules/pako/dist/pako.esm.mjs
var pako_esm = __webpack_require__(33654);
;// CONCATENATED MODULE: ../../packages/sdk/dist/index.mjs
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// ../../node_modules/lodash/_listCacheClear.js
var require_listCacheClear = __commonJS({
  "../../node_modules/lodash/_listCacheClear.js"(exports, module) {
    "use strict";
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    module.exports = listCacheClear;
  }
});

// ../../node_modules/lodash/eq.js
var require_eq = __commonJS({
  "../../node_modules/lodash/eq.js"(exports, module) {
    "use strict";
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    module.exports = eq;
  }
});

// ../../node_modules/lodash/_assocIndexOf.js
var require_assocIndexOf = __commonJS({
  "../../node_modules/lodash/_assocIndexOf.js"(exports, module) {
    "use strict";
    var eq = require_eq();
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    module.exports = assocIndexOf;
  }
});

// ../../node_modules/lodash/_listCacheDelete.js
var require_listCacheDelete = __commonJS({
  "../../node_modules/lodash/_listCacheDelete.js"(exports, module) {
    "use strict";
    var assocIndexOf = require_assocIndexOf();
    var arrayProto = Array.prototype;
    var splice = arrayProto.splice;
    function listCacheDelete(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }
    module.exports = listCacheDelete;
  }
});

// ../../node_modules/lodash/_listCacheGet.js
var require_listCacheGet = __commonJS({
  "../../node_modules/lodash/_listCacheGet.js"(exports, module) {
    "use strict";
    var assocIndexOf = require_assocIndexOf();
    function listCacheGet(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      return index < 0 ? void 0 : data[index][1];
    }
    module.exports = listCacheGet;
  }
});

// ../../node_modules/lodash/_listCacheHas.js
var require_listCacheHas = __commonJS({
  "../../node_modules/lodash/_listCacheHas.js"(exports, module) {
    "use strict";
    var assocIndexOf = require_assocIndexOf();
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    module.exports = listCacheHas;
  }
});

// ../../node_modules/lodash/_listCacheSet.js
var require_listCacheSet = __commonJS({
  "../../node_modules/lodash/_listCacheSet.js"(exports, module) {
    "use strict";
    var assocIndexOf = require_assocIndexOf();
    function listCacheSet(key, value) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }
    module.exports = listCacheSet;
  }
});

// ../../node_modules/lodash/_ListCache.js
var require_ListCache = __commonJS({
  "../../node_modules/lodash/_ListCache.js"(exports, module) {
    "use strict";
    var listCacheClear = require_listCacheClear();
    var listCacheDelete = require_listCacheDelete();
    var listCacheGet = require_listCacheGet();
    var listCacheHas = require_listCacheHas();
    var listCacheSet = require_listCacheSet();
    function ListCache(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    module.exports = ListCache;
  }
});

// ../../node_modules/lodash/_stackClear.js
var require_stackClear = __commonJS({
  "../../node_modules/lodash/_stackClear.js"(exports, module) {
    "use strict";
    var ListCache = require_ListCache();
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }
    module.exports = stackClear;
  }
});

// ../../node_modules/lodash/_stackDelete.js
var require_stackDelete = __commonJS({
  "../../node_modules/lodash/_stackDelete.js"(exports, module) {
    "use strict";
    function stackDelete(key) {
      var data = this.__data__, result = data["delete"](key);
      this.size = data.size;
      return result;
    }
    module.exports = stackDelete;
  }
});

// ../../node_modules/lodash/_stackGet.js
var require_stackGet = __commonJS({
  "../../node_modules/lodash/_stackGet.js"(exports, module) {
    "use strict";
    function stackGet(key) {
      return this.__data__.get(key);
    }
    module.exports = stackGet;
  }
});

// ../../node_modules/lodash/_stackHas.js
var require_stackHas = __commonJS({
  "../../node_modules/lodash/_stackHas.js"(exports, module) {
    "use strict";
    function stackHas(key) {
      return this.__data__.has(key);
    }
    module.exports = stackHas;
  }
});

// ../../node_modules/lodash/_freeGlobal.js
var require_freeGlobal = __commonJS({
  "../../node_modules/lodash/_freeGlobal.js"(exports, module) {
    "use strict";
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module.exports = freeGlobal;
  }
});

// ../../node_modules/lodash/_root.js
var require_root = __commonJS({
  "../../node_modules/lodash/_root.js"(exports, module) {
    "use strict";
    var freeGlobal = require_freeGlobal();
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    module.exports = root;
  }
});

// ../../node_modules/lodash/_Symbol.js
var require_Symbol = __commonJS({
  "../../node_modules/lodash/_Symbol.js"(exports, module) {
    "use strict";
    var root = require_root();
    var Symbol2 = root.Symbol;
    module.exports = Symbol2;
  }
});

// ../../node_modules/lodash/_getRawTag.js
var require_getRawTag = __commonJS({
  "../../node_modules/lodash/_getRawTag.js"(exports, module) {
    "use strict";
    var Symbol2 = require_Symbol();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var nativeObjectToString = objectProto.toString;
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    module.exports = getRawTag;
  }
});

// ../../node_modules/lodash/_objectToString.js
var require_objectToString = __commonJS({
  "../../node_modules/lodash/_objectToString.js"(exports, module) {
    "use strict";
    var objectProto = Object.prototype;
    var nativeObjectToString = objectProto.toString;
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    module.exports = objectToString;
  }
});

// ../../node_modules/lodash/_baseGetTag.js
var require_baseGetTag = __commonJS({
  "../../node_modules/lodash/_baseGetTag.js"(exports, module) {
    "use strict";
    var Symbol2 = require_Symbol();
    var getRawTag = require_getRawTag();
    var objectToString = require_objectToString();
    var nullTag = "[object Null]";
    var undefinedTag = "[object Undefined]";
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    module.exports = baseGetTag;
  }
});

// ../../node_modules/lodash/isObject.js
var require_isObject = __commonJS({
  "../../node_modules/lodash/isObject.js"(exports, module) {
    "use strict";
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    module.exports = isObject;
  }
});

// ../../node_modules/lodash/isFunction.js
var require_isFunction = __commonJS({
  "../../node_modules/lodash/isFunction.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var isObject = require_isObject();
    var asyncTag = "[object AsyncFunction]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var proxyTag = "[object Proxy]";
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    module.exports = isFunction;
  }
});

// ../../node_modules/lodash/_coreJsData.js
var require_coreJsData = __commonJS({
  "../../node_modules/lodash/_coreJsData.js"(exports, module) {
    "use strict";
    var root = require_root();
    var coreJsData = root["__core-js_shared__"];
    module.exports = coreJsData;
  }
});

// ../../node_modules/lodash/_isMasked.js
var require_isMasked = __commonJS({
  "../../node_modules/lodash/_isMasked.js"(exports, module) {
    "use strict";
    var coreJsData = require_coreJsData();
    var maskSrcKey = function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    module.exports = isMasked;
  }
});

// ../../node_modules/lodash/_toSource.js
var require_toSource = __commonJS({
  "../../node_modules/lodash/_toSource.js"(exports, module) {
    "use strict";
    var funcProto = Function.prototype;
    var funcToString = funcProto.toString;
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {
        }
        try {
          return func + "";
        } catch (e) {
        }
      }
      return "";
    }
    module.exports = toSource;
  }
});

// ../../node_modules/lodash/_baseIsNative.js
var require_baseIsNative = __commonJS({
  "../../node_modules/lodash/_baseIsNative.js"(exports, module) {
    "use strict";
    var isFunction = require_isFunction();
    var isMasked = require_isMasked();
    var isObject = require_isObject();
    var toSource = require_toSource();
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    module.exports = baseIsNative;
  }
});

// ../../node_modules/lodash/_getValue.js
var require_getValue = __commonJS({
  "../../node_modules/lodash/_getValue.js"(exports, module) {
    "use strict";
    function getValue(object, key) {
      return object == null ? void 0 : object[key];
    }
    module.exports = getValue;
  }
});

// ../../node_modules/lodash/_getNative.js
var require_getNative = __commonJS({
  "../../node_modules/lodash/_getNative.js"(exports, module) {
    "use strict";
    var baseIsNative = require_baseIsNative();
    var getValue = require_getValue();
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : void 0;
    }
    module.exports = getNative;
  }
});

// ../../node_modules/lodash/_Map.js
var require_Map = __commonJS({
  "../../node_modules/lodash/_Map.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var root = require_root();
    var Map2 = getNative(root, "Map");
    module.exports = Map2;
  }
});

// ../../node_modules/lodash/_nativeCreate.js
var require_nativeCreate = __commonJS({
  "../../node_modules/lodash/_nativeCreate.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var nativeCreate = getNative(Object, "create");
    module.exports = nativeCreate;
  }
});

// ../../node_modules/lodash/_hashClear.js
var require_hashClear = __commonJS({
  "../../node_modules/lodash/_hashClear.js"(exports, module) {
    "use strict";
    var nativeCreate = require_nativeCreate();
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    module.exports = hashClear;
  }
});

// ../../node_modules/lodash/_hashDelete.js
var require_hashDelete = __commonJS({
  "../../node_modules/lodash/_hashDelete.js"(exports, module) {
    "use strict";
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    module.exports = hashDelete;
  }
});

// ../../node_modules/lodash/_hashGet.js
var require_hashGet = __commonJS({
  "../../node_modules/lodash/_hashGet.js"(exports, module) {
    "use strict";
    var nativeCreate = require_nativeCreate();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : void 0;
    }
    module.exports = hashGet;
  }
});

// ../../node_modules/lodash/_hashHas.js
var require_hashHas = __commonJS({
  "../../node_modules/lodash/_hashHas.js"(exports, module) {
    "use strict";
    var nativeCreate = require_nativeCreate();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
    }
    module.exports = hashHas;
  }
});

// ../../node_modules/lodash/_hashSet.js
var require_hashSet = __commonJS({
  "../../node_modules/lodash/_hashSet.js"(exports, module) {
    "use strict";
    var nativeCreate = require_nativeCreate();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    module.exports = hashSet;
  }
});

// ../../node_modules/lodash/_Hash.js
var require_Hash = __commonJS({
  "../../node_modules/lodash/_Hash.js"(exports, module) {
    "use strict";
    var hashClear = require_hashClear();
    var hashDelete = require_hashDelete();
    var hashGet = require_hashGet();
    var hashHas = require_hashHas();
    var hashSet = require_hashSet();
    function Hash(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    module.exports = Hash;
  }
});

// ../../node_modules/lodash/_mapCacheClear.js
var require_mapCacheClear = __commonJS({
  "../../node_modules/lodash/_mapCacheClear.js"(exports, module) {
    "use strict";
    var Hash = require_Hash();
    var ListCache = require_ListCache();
    var Map2 = require_Map();
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map2 || ListCache)(),
        "string": new Hash()
      };
    }
    module.exports = mapCacheClear;
  }
});

// ../../node_modules/lodash/_isKeyable.js
var require_isKeyable = __commonJS({
  "../../node_modules/lodash/_isKeyable.js"(exports, module) {
    "use strict";
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    module.exports = isKeyable;
  }
});

// ../../node_modules/lodash/_getMapData.js
var require_getMapData = __commonJS({
  "../../node_modules/lodash/_getMapData.js"(exports, module) {
    "use strict";
    var isKeyable = require_isKeyable();
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    module.exports = getMapData;
  }
});

// ../../node_modules/lodash/_mapCacheDelete.js
var require_mapCacheDelete = __commonJS({
  "../../node_modules/lodash/_mapCacheDelete.js"(exports, module) {
    "use strict";
    var getMapData = require_getMapData();
    function mapCacheDelete(key) {
      var result = getMapData(this, key)["delete"](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    module.exports = mapCacheDelete;
  }
});

// ../../node_modules/lodash/_mapCacheGet.js
var require_mapCacheGet = __commonJS({
  "../../node_modules/lodash/_mapCacheGet.js"(exports, module) {
    "use strict";
    var getMapData = require_getMapData();
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    module.exports = mapCacheGet;
  }
});

// ../../node_modules/lodash/_mapCacheHas.js
var require_mapCacheHas = __commonJS({
  "../../node_modules/lodash/_mapCacheHas.js"(exports, module) {
    "use strict";
    var getMapData = require_getMapData();
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    module.exports = mapCacheHas;
  }
});

// ../../node_modules/lodash/_mapCacheSet.js
var require_mapCacheSet = __commonJS({
  "../../node_modules/lodash/_mapCacheSet.js"(exports, module) {
    "use strict";
    var getMapData = require_getMapData();
    function mapCacheSet(key, value) {
      var data = getMapData(this, key), size = data.size;
      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }
    module.exports = mapCacheSet;
  }
});

// ../../node_modules/lodash/_MapCache.js
var require_MapCache = __commonJS({
  "../../node_modules/lodash/_MapCache.js"(exports, module) {
    "use strict";
    var mapCacheClear = require_mapCacheClear();
    var mapCacheDelete = require_mapCacheDelete();
    var mapCacheGet = require_mapCacheGet();
    var mapCacheHas = require_mapCacheHas();
    var mapCacheSet = require_mapCacheSet();
    function MapCache(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    module.exports = MapCache;
  }
});

// ../../node_modules/lodash/_stackSet.js
var require_stackSet = __commonJS({
  "../../node_modules/lodash/_stackSet.js"(exports, module) {
    "use strict";
    var ListCache = require_ListCache();
    var Map2 = require_Map();
    var MapCache = require_MapCache();
    var LARGE_ARRAY_SIZE = 200;
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }
    module.exports = stackSet;
  }
});

// ../../node_modules/lodash/_Stack.js
var require_Stack = __commonJS({
  "../../node_modules/lodash/_Stack.js"(exports, module) {
    "use strict";
    var ListCache = require_ListCache();
    var stackClear = require_stackClear();
    var stackDelete = require_stackDelete();
    var stackGet = require_stackGet();
    var stackHas = require_stackHas();
    var stackSet = require_stackSet();
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    module.exports = Stack;
  }
});

// ../../node_modules/lodash/_defineProperty.js
var require_defineProperty = __commonJS({
  "../../node_modules/lodash/_defineProperty.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var defineProperty = function() {
      try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
      } catch (e) {
      }
    }();
    module.exports = defineProperty;
  }
});

// ../../node_modules/lodash/_baseAssignValue.js
var require_baseAssignValue = __commonJS({
  "../../node_modules/lodash/_baseAssignValue.js"(exports, module) {
    "use strict";
    var defineProperty = require_defineProperty();
    function baseAssignValue(object, key, value) {
      if (key == "__proto__" && defineProperty) {
        defineProperty(object, key, {
          "configurable": true,
          "enumerable": true,
          "value": value,
          "writable": true
        });
      } else {
        object[key] = value;
      }
    }
    module.exports = baseAssignValue;
  }
});

// ../../node_modules/lodash/_assignMergeValue.js
var require_assignMergeValue = __commonJS({
  "../../node_modules/lodash/_assignMergeValue.js"(exports, module) {
    "use strict";
    var baseAssignValue = require_baseAssignValue();
    var eq = require_eq();
    function assignMergeValue(object, key, value) {
      if (value !== void 0 && !eq(object[key], value) || value === void 0 && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }
    module.exports = assignMergeValue;
  }
});

// ../../node_modules/lodash/_createBaseFor.js
var require_createBaseFor = __commonJS({
  "../../node_modules/lodash/_createBaseFor.js"(exports, module) {
    "use strict";
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }
    module.exports = createBaseFor;
  }
});

// ../../node_modules/lodash/_baseFor.js
var require_baseFor = __commonJS({
  "../../node_modules/lodash/_baseFor.js"(exports, module) {
    "use strict";
    var createBaseFor = require_createBaseFor();
    var baseFor = createBaseFor();
    module.exports = baseFor;
  }
});

// ../../node_modules/lodash/_cloneBuffer.js
var require_cloneBuffer = __commonJS({
  "../../node_modules/lodash/_cloneBuffer.js"(exports, module) {
    "use strict";
    var root = require_root();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var Buffer2 = moduleExports ? root.Buffer : void 0;
    var allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : void 0;
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
      buffer.copy(result);
      return result;
    }
    module.exports = cloneBuffer;
  }
});

// ../../node_modules/lodash/_Uint8Array.js
var require_Uint8Array = __commonJS({
  "../../node_modules/lodash/_Uint8Array.js"(exports, module) {
    "use strict";
    var root = require_root();
    var Uint8Array2 = root.Uint8Array;
    module.exports = Uint8Array2;
  }
});

// ../../node_modules/lodash/_cloneArrayBuffer.js
var require_cloneArrayBuffer = __commonJS({
  "../../node_modules/lodash/_cloneArrayBuffer.js"(exports, module) {
    "use strict";
    var Uint8Array2 = require_Uint8Array();
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array2(result).set(new Uint8Array2(arrayBuffer));
      return result;
    }
    module.exports = cloneArrayBuffer;
  }
});

// ../../node_modules/lodash/_cloneTypedArray.js
var require_cloneTypedArray = __commonJS({
  "../../node_modules/lodash/_cloneTypedArray.js"(exports, module) {
    "use strict";
    var cloneArrayBuffer = require_cloneArrayBuffer();
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }
    module.exports = cloneTypedArray;
  }
});

// ../../node_modules/lodash/_copyArray.js
var require_copyArray = __commonJS({
  "../../node_modules/lodash/_copyArray.js"(exports, module) {
    "use strict";
    function copyArray(source, array) {
      var index = -1, length = source.length;
      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }
    module.exports = copyArray;
  }
});

// ../../node_modules/lodash/_baseCreate.js
var require_baseCreate = __commonJS({
  "../../node_modules/lodash/_baseCreate.js"(exports, module) {
    "use strict";
    var isObject = require_isObject();
    var objectCreate = Object.create;
    var baseCreate = /* @__PURE__ */ function() {
      function object() {
      }
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object();
        object.prototype = void 0;
        return result;
      };
    }();
    module.exports = baseCreate;
  }
});

// ../../node_modules/lodash/_overArg.js
var require_overArg = __commonJS({
  "../../node_modules/lodash/_overArg.js"(exports, module) {
    "use strict";
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    module.exports = overArg;
  }
});

// ../../node_modules/lodash/_getPrototype.js
var require_getPrototype = __commonJS({
  "../../node_modules/lodash/_getPrototype.js"(exports, module) {
    "use strict";
    var overArg = require_overArg();
    var getPrototype = overArg(Object.getPrototypeOf, Object);
    module.exports = getPrototype;
  }
});

// ../../node_modules/lodash/_isPrototype.js
var require_isPrototype = __commonJS({
  "../../node_modules/lodash/_isPrototype.js"(exports, module) {
    "use strict";
    var objectProto = Object.prototype;
    function isPrototype(value) {
      var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value === proto;
    }
    module.exports = isPrototype;
  }
});

// ../../node_modules/lodash/_initCloneObject.js
var require_initCloneObject = __commonJS({
  "../../node_modules/lodash/_initCloneObject.js"(exports, module) {
    "use strict";
    var baseCreate = require_baseCreate();
    var getPrototype = require_getPrototype();
    var isPrototype = require_isPrototype();
    function initCloneObject(object) {
      return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
    }
    module.exports = initCloneObject;
  }
});

// ../../node_modules/lodash/isObjectLike.js
var require_isObjectLike = __commonJS({
  "../../node_modules/lodash/isObjectLike.js"(exports, module) {
    "use strict";
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    module.exports = isObjectLike;
  }
});

// ../../node_modules/lodash/_baseIsArguments.js
var require_baseIsArguments = __commonJS({
  "../../node_modules/lodash/_baseIsArguments.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var argsTag = "[object Arguments]";
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    module.exports = baseIsArguments;
  }
});

// ../../node_modules/lodash/isArguments.js
var require_isArguments = __commonJS({
  "../../node_modules/lodash/isArguments.js"(exports, module) {
    "use strict";
    var baseIsArguments = require_baseIsArguments();
    var isObjectLike = require_isObjectLike();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var isArguments = baseIsArguments(/* @__PURE__ */ function() {
      return arguments;
    }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };
    module.exports = isArguments;
  }
});

// ../../node_modules/lodash/isArray.js
var require_isArray = __commonJS({
  "../../node_modules/lodash/isArray.js"(exports, module) {
    "use strict";
    var isArray = Array.isArray;
    module.exports = isArray;
  }
});

// ../../node_modules/lodash/isLength.js
var require_isLength = __commonJS({
  "../../node_modules/lodash/isLength.js"(exports, module) {
    "use strict";
    var MAX_SAFE_INTEGER = 9007199254740991;
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    module.exports = isLength;
  }
});

// ../../node_modules/lodash/isArrayLike.js
var require_isArrayLike = __commonJS({
  "../../node_modules/lodash/isArrayLike.js"(exports, module) {
    "use strict";
    var isFunction = require_isFunction();
    var isLength = require_isLength();
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    module.exports = isArrayLike;
  }
});

// ../../node_modules/lodash/isArrayLikeObject.js
var require_isArrayLikeObject = __commonJS({
  "../../node_modules/lodash/isArrayLikeObject.js"(exports, module) {
    "use strict";
    var isArrayLike = require_isArrayLike();
    var isObjectLike = require_isObjectLike();
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }
    module.exports = isArrayLikeObject;
  }
});

// ../../node_modules/lodash/stubFalse.js
var require_stubFalse = __commonJS({
  "../../node_modules/lodash/stubFalse.js"(exports, module) {
    "use strict";
    function stubFalse() {
      return false;
    }
    module.exports = stubFalse;
  }
});

// ../../node_modules/lodash/isBuffer.js
var require_isBuffer = __commonJS({
  "../../node_modules/lodash/isBuffer.js"(exports, module) {
    "use strict";
    var root = require_root();
    var stubFalse = require_stubFalse();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var Buffer2 = moduleExports ? root.Buffer : void 0;
    var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
    var isBuffer = nativeIsBuffer || stubFalse;
    module.exports = isBuffer;
  }
});

// ../../node_modules/lodash/isPlainObject.js
var require_isPlainObject = __commonJS({
  "../../node_modules/lodash/isPlainObject.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var getPrototype = require_getPrototype();
    var isObjectLike = require_isObjectLike();
    var objectTag = "[object Object]";
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var objectCtorString = funcToString.call(Object);
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
      return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
    }
    module.exports = isPlainObject;
  }
});

// ../../node_modules/lodash/_baseIsTypedArray.js
var require_baseIsTypedArray = __commonJS({
  "../../node_modules/lodash/_baseIsTypedArray.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var isLength = require_isLength();
    var isObjectLike = require_isObjectLike();
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var funcTag = "[object Function]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var objectTag = "[object Object]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var float32Tag = "[object Float32Array]";
    var float64Tag = "[object Float64Array]";
    var int8Tag = "[object Int8Array]";
    var int16Tag = "[object Int16Array]";
    var int32Tag = "[object Int32Array]";
    var uint8Tag = "[object Uint8Array]";
    var uint8ClampedTag = "[object Uint8ClampedArray]";
    var uint16Tag = "[object Uint16Array]";
    var uint32Tag = "[object Uint32Array]";
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }
    module.exports = baseIsTypedArray;
  }
});

// ../../node_modules/lodash/_baseUnary.js
var require_baseUnary = __commonJS({
  "../../node_modules/lodash/_baseUnary.js"(exports, module) {
    "use strict";
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    module.exports = baseUnary;
  }
});

// ../../node_modules/lodash/_nodeUtil.js
var require_nodeUtil = __commonJS({
  "../../node_modules/lodash/_nodeUtil.js"(exports, module) {
    "use strict";
    var freeGlobal = require_freeGlobal();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {
      }
    }();
    module.exports = nodeUtil;
  }
});

// ../../node_modules/lodash/isTypedArray.js
var require_isTypedArray = __commonJS({
  "../../node_modules/lodash/isTypedArray.js"(exports, module) {
    "use strict";
    var baseIsTypedArray = require_baseIsTypedArray();
    var baseUnary = require_baseUnary();
    var nodeUtil = require_nodeUtil();
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    module.exports = isTypedArray;
  }
});

// ../../node_modules/lodash/_safeGet.js
var require_safeGet = __commonJS({
  "../../node_modules/lodash/_safeGet.js"(exports, module) {
    "use strict";
    function safeGet(object, key) {
      if (key === "constructor" && typeof object[key] === "function") {
        return;
      }
      if (key == "__proto__") {
        return;
      }
      return object[key];
    }
    module.exports = safeGet;
  }
});

// ../../node_modules/lodash/_assignValue.js
var require_assignValue = __commonJS({
  "../../node_modules/lodash/_assignValue.js"(exports, module) {
    "use strict";
    var baseAssignValue = require_baseAssignValue();
    var eq = require_eq();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === void 0 && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }
    module.exports = assignValue;
  }
});

// ../../node_modules/lodash/_copyObject.js
var require_copyObject = __commonJS({
  "../../node_modules/lodash/_copyObject.js"(exports, module) {
    "use strict";
    var assignValue = require_assignValue();
    var baseAssignValue = require_baseAssignValue();
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});
      var index = -1, length = props.length;
      while (++index < length) {
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
        if (newValue === void 0) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }
    module.exports = copyObject;
  }
});

// ../../node_modules/lodash/_baseTimes.js
var require_baseTimes = __commonJS({
  "../../node_modules/lodash/_baseTimes.js"(exports, module) {
    "use strict";
    function baseTimes(n, iteratee) {
      var index = -1, result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }
    module.exports = baseTimes;
  }
});

// ../../node_modules/lodash/_isIndex.js
var require_isIndex = __commonJS({
  "../../node_modules/lodash/_isIndex.js"(exports, module) {
    "use strict";
    var MAX_SAFE_INTEGER = 9007199254740991;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
    }
    module.exports = isIndex;
  }
});

// ../../node_modules/lodash/_arrayLikeKeys.js
var require_arrayLikeKeys = __commonJS({
  "../../node_modules/lodash/_arrayLikeKeys.js"(exports, module) {
    "use strict";
    var baseTimes = require_baseTimes();
    var isArguments = require_isArguments();
    var isArray = require_isArray();
    var isBuffer = require_isBuffer();
    var isIndex = require_isIndex();
    var isTypedArray = require_isTypedArray();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
        (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
        isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = arrayLikeKeys;
  }
});

// ../../node_modules/lodash/_nativeKeysIn.js
var require_nativeKeysIn = __commonJS({
  "../../node_modules/lodash/_nativeKeysIn.js"(exports, module) {
    "use strict";
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = nativeKeysIn;
  }
});

// ../../node_modules/lodash/_baseKeysIn.js
var require_baseKeysIn = __commonJS({
  "../../node_modules/lodash/_baseKeysIn.js"(exports, module) {
    "use strict";
    var isObject = require_isObject();
    var isPrototype = require_isPrototype();
    var nativeKeysIn = require_nativeKeysIn();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object), result = [];
      for (var key in object) {
        if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = baseKeysIn;
  }
});

// ../../node_modules/lodash/keysIn.js
var require_keysIn = __commonJS({
  "../../node_modules/lodash/keysIn.js"(exports, module) {
    "use strict";
    var arrayLikeKeys = require_arrayLikeKeys();
    var baseKeysIn = require_baseKeysIn();
    var isArrayLike = require_isArrayLike();
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }
    module.exports = keysIn;
  }
});

// ../../node_modules/lodash/toPlainObject.js
var require_toPlainObject = __commonJS({
  "../../node_modules/lodash/toPlainObject.js"(exports, module) {
    "use strict";
    var copyObject = require_copyObject();
    var keysIn = require_keysIn();
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }
    module.exports = toPlainObject;
  }
});

// ../../node_modules/lodash/_baseMergeDeep.js
var require_baseMergeDeep = __commonJS({
  "../../node_modules/lodash/_baseMergeDeep.js"(exports, module) {
    "use strict";
    var assignMergeValue = require_assignMergeValue();
    var cloneBuffer = require_cloneBuffer();
    var cloneTypedArray = require_cloneTypedArray();
    var copyArray = require_copyArray();
    var initCloneObject = require_initCloneObject();
    var isArguments = require_isArguments();
    var isArray = require_isArray();
    var isArrayLikeObject = require_isArrayLikeObject();
    var isBuffer = require_isBuffer();
    var isFunction = require_isFunction();
    var isObject = require_isObject();
    var isPlainObject = require_isPlainObject();
    var isTypedArray = require_isTypedArray();
    var safeGet = require_safeGet();
    var toPlainObject = require_toPlainObject();
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : void 0;
      var isCommon = newValue === void 0;
      if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          } else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          } else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          } else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          } else {
            newValue = [];
          }
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          } else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        } else {
          isCommon = false;
        }
      }
      if (isCommon) {
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }
    module.exports = baseMergeDeep;
  }
});

// ../../node_modules/lodash/_baseMerge.js
var require_baseMerge = __commonJS({
  "../../node_modules/lodash/_baseMerge.js"(exports, module) {
    "use strict";
    var Stack = require_Stack();
    var assignMergeValue = require_assignMergeValue();
    var baseFor = require_baseFor();
    var baseMergeDeep = require_baseMergeDeep();
    var isObject = require_isObject();
    var keysIn = require_keysIn();
    var safeGet = require_safeGet();
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack());
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        } else {
          var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : void 0;
          if (newValue === void 0) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }
    module.exports = baseMerge;
  }
});

// ../../node_modules/lodash/identity.js
var require_identity = __commonJS({
  "../../node_modules/lodash/identity.js"(exports, module) {
    "use strict";
    function identity(value) {
      return value;
    }
    module.exports = identity;
  }
});

// ../../node_modules/lodash/_apply.js
var require_apply = __commonJS({
  "../../node_modules/lodash/_apply.js"(exports, module) {
    "use strict";
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    module.exports = apply;
  }
});

// ../../node_modules/lodash/_overRest.js
var require_overRest = __commonJS({
  "../../node_modules/lodash/_overRest.js"(exports, module) {
    "use strict";
    var apply = require_apply();
    var nativeMax = Math.max;
    function overRest(func, start, transform) {
      start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
      return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }
    module.exports = overRest;
  }
});

// ../../node_modules/lodash/constant.js
var require_constant = __commonJS({
  "../../node_modules/lodash/constant.js"(exports, module) {
    "use strict";
    function constant(value) {
      return function() {
        return value;
      };
    }
    module.exports = constant;
  }
});

// ../../node_modules/lodash/_baseSetToString.js
var require_baseSetToString = __commonJS({
  "../../node_modules/lodash/_baseSetToString.js"(exports, module) {
    "use strict";
    var constant = require_constant();
    var defineProperty = require_defineProperty();
    var identity = require_identity();
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
      });
    };
    module.exports = baseSetToString;
  }
});

// ../../node_modules/lodash/_shortOut.js
var require_shortOut = __commonJS({
  "../../node_modules/lodash/_shortOut.js"(exports, module) {
    "use strict";
    var HOT_COUNT = 800;
    var HOT_SPAN = 16;
    var nativeNow = Date.now;
    function shortOut(func) {
      var count = 0, lastCalled = 0;
      return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(void 0, arguments);
      };
    }
    module.exports = shortOut;
  }
});

// ../../node_modules/lodash/_setToString.js
var require_setToString = __commonJS({
  "../../node_modules/lodash/_setToString.js"(exports, module) {
    "use strict";
    var baseSetToString = require_baseSetToString();
    var shortOut = require_shortOut();
    var setToString = shortOut(baseSetToString);
    module.exports = setToString;
  }
});

// ../../node_modules/lodash/_baseRest.js
var require_baseRest = __commonJS({
  "../../node_modules/lodash/_baseRest.js"(exports, module) {
    "use strict";
    var identity = require_identity();
    var overRest = require_overRest();
    var setToString = require_setToString();
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + "");
    }
    module.exports = baseRest;
  }
});

// ../../node_modules/lodash/_isIterateeCall.js
var require_isIterateeCall = __commonJS({
  "../../node_modules/lodash/_isIterateeCall.js"(exports, module) {
    "use strict";
    var eq = require_eq();
    var isArrayLike = require_isArrayLike();
    var isIndex = require_isIndex();
    var isObject = require_isObject();
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
        return eq(object[index], value);
      }
      return false;
    }
    module.exports = isIterateeCall;
  }
});

// ../../node_modules/lodash/_createAssigner.js
var require_createAssigner = __commonJS({
  "../../node_modules/lodash/_createAssigner.js"(exports, module) {
    "use strict";
    var baseRest = require_baseRest();
    var isIterateeCall = require_isIterateeCall();
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? void 0 : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }
    module.exports = createAssigner;
  }
});

// ../../node_modules/lodash/merge.js
var require_merge = __commonJS({
  "../../node_modules/lodash/merge.js"(exports, module) {
    "use strict";
    var baseMerge = require_baseMerge();
    var createAssigner = require_createAssigner();
    var merge2 = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });
    module.exports = merge2;
  }
});

// ../../node_modules/lodash/_arrayEach.js
var require_arrayEach = __commonJS({
  "../../node_modules/lodash/_arrayEach.js"(exports, module) {
    "use strict";
    function arrayEach(array, iteratee) {
      var index = -1, length = array == null ? 0 : array.length;
      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }
    module.exports = arrayEach;
  }
});

// ../../node_modules/lodash/_nativeKeys.js
var require_nativeKeys = __commonJS({
  "../../node_modules/lodash/_nativeKeys.js"(exports, module) {
    "use strict";
    var overArg = require_overArg();
    var nativeKeys = overArg(Object.keys, Object);
    module.exports = nativeKeys;
  }
});

// ../../node_modules/lodash/_baseKeys.js
var require_baseKeys = __commonJS({
  "../../node_modules/lodash/_baseKeys.js"(exports, module) {
    "use strict";
    var isPrototype = require_isPrototype();
    var nativeKeys = require_nativeKeys();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != "constructor") {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = baseKeys;
  }
});

// ../../node_modules/lodash/keys.js
var require_keys = __commonJS({
  "../../node_modules/lodash/keys.js"(exports, module) {
    "use strict";
    var arrayLikeKeys = require_arrayLikeKeys();
    var baseKeys = require_baseKeys();
    var isArrayLike = require_isArrayLike();
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }
    module.exports = keys;
  }
});

// ../../node_modules/lodash/_baseAssign.js
var require_baseAssign = __commonJS({
  "../../node_modules/lodash/_baseAssign.js"(exports, module) {
    "use strict";
    var copyObject = require_copyObject();
    var keys = require_keys();
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }
    module.exports = baseAssign;
  }
});

// ../../node_modules/lodash/_baseAssignIn.js
var require_baseAssignIn = __commonJS({
  "../../node_modules/lodash/_baseAssignIn.js"(exports, module) {
    "use strict";
    var copyObject = require_copyObject();
    var keysIn = require_keysIn();
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }
    module.exports = baseAssignIn;
  }
});

// ../../node_modules/lodash/_arrayFilter.js
var require_arrayFilter = __commonJS({
  "../../node_modules/lodash/_arrayFilter.js"(exports, module) {
    "use strict";
    function arrayFilter(array, predicate) {
      var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[resIndex++] = value;
        }
      }
      return result;
    }
    module.exports = arrayFilter;
  }
});

// ../../node_modules/lodash/stubArray.js
var require_stubArray = __commonJS({
  "../../node_modules/lodash/stubArray.js"(exports, module) {
    "use strict";
    function stubArray() {
      return [];
    }
    module.exports = stubArray;
  }
});

// ../../node_modules/lodash/_getSymbols.js
var require_getSymbols = __commonJS({
  "../../node_modules/lodash/_getSymbols.js"(exports, module) {
    "use strict";
    var arrayFilter = require_arrayFilter();
    var stubArray = require_stubArray();
    var objectProto = Object.prototype;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var nativeGetSymbols = Object.getOwnPropertySymbols;
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };
    module.exports = getSymbols;
  }
});

// ../../node_modules/lodash/_copySymbols.js
var require_copySymbols = __commonJS({
  "../../node_modules/lodash/_copySymbols.js"(exports, module) {
    "use strict";
    var copyObject = require_copyObject();
    var getSymbols = require_getSymbols();
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }
    module.exports = copySymbols;
  }
});

// ../../node_modules/lodash/_arrayPush.js
var require_arrayPush = __commonJS({
  "../../node_modules/lodash/_arrayPush.js"(exports, module) {
    "use strict";
    function arrayPush(array, values) {
      var index = -1, length = values.length, offset = array.length;
      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }
    module.exports = arrayPush;
  }
});

// ../../node_modules/lodash/_getSymbolsIn.js
var require_getSymbolsIn = __commonJS({
  "../../node_modules/lodash/_getSymbolsIn.js"(exports, module) {
    "use strict";
    var arrayPush = require_arrayPush();
    var getPrototype = require_getPrototype();
    var getSymbols = require_getSymbols();
    var stubArray = require_stubArray();
    var nativeGetSymbols = Object.getOwnPropertySymbols;
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };
    module.exports = getSymbolsIn;
  }
});

// ../../node_modules/lodash/_copySymbolsIn.js
var require_copySymbolsIn = __commonJS({
  "../../node_modules/lodash/_copySymbolsIn.js"(exports, module) {
    "use strict";
    var copyObject = require_copyObject();
    var getSymbolsIn = require_getSymbolsIn();
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }
    module.exports = copySymbolsIn;
  }
});

// ../../node_modules/lodash/_baseGetAllKeys.js
var require_baseGetAllKeys = __commonJS({
  "../../node_modules/lodash/_baseGetAllKeys.js"(exports, module) {
    "use strict";
    var arrayPush = require_arrayPush();
    var isArray = require_isArray();
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }
    module.exports = baseGetAllKeys;
  }
});

// ../../node_modules/lodash/_getAllKeys.js
var require_getAllKeys = __commonJS({
  "../../node_modules/lodash/_getAllKeys.js"(exports, module) {
    "use strict";
    var baseGetAllKeys = require_baseGetAllKeys();
    var getSymbols = require_getSymbols();
    var keys = require_keys();
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }
    module.exports = getAllKeys;
  }
});

// ../../node_modules/lodash/_getAllKeysIn.js
var require_getAllKeysIn = __commonJS({
  "../../node_modules/lodash/_getAllKeysIn.js"(exports, module) {
    "use strict";
    var baseGetAllKeys = require_baseGetAllKeys();
    var getSymbolsIn = require_getSymbolsIn();
    var keysIn = require_keysIn();
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }
    module.exports = getAllKeysIn;
  }
});

// ../../node_modules/lodash/_DataView.js
var require_DataView = __commonJS({
  "../../node_modules/lodash/_DataView.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var root = require_root();
    var DataView = getNative(root, "DataView");
    module.exports = DataView;
  }
});

// ../../node_modules/lodash/_Promise.js
var require_Promise = __commonJS({
  "../../node_modules/lodash/_Promise.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var root = require_root();
    var Promise2 = getNative(root, "Promise");
    module.exports = Promise2;
  }
});

// ../../node_modules/lodash/_Set.js
var require_Set = __commonJS({
  "../../node_modules/lodash/_Set.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var root = require_root();
    var Set2 = getNative(root, "Set");
    module.exports = Set2;
  }
});

// ../../node_modules/lodash/_WeakMap.js
var require_WeakMap = __commonJS({
  "../../node_modules/lodash/_WeakMap.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var root = require_root();
    var WeakMap = getNative(root, "WeakMap");
    module.exports = WeakMap;
  }
});

// ../../node_modules/lodash/_getTag.js
var require_getTag = __commonJS({
  "../../node_modules/lodash/_getTag.js"(exports, module) {
    "use strict";
    var DataView = require_DataView();
    var Map2 = require_Map();
    var Promise2 = require_Promise();
    var Set2 = require_Set();
    var WeakMap = require_WeakMap();
    var baseGetTag = require_baseGetTag();
    var toSource = require_toSource();
    var mapTag = "[object Map]";
    var objectTag = "[object Object]";
    var promiseTag = "[object Promise]";
    var setTag = "[object Set]";
    var weakMapTag = "[object WeakMap]";
    var dataViewTag = "[object DataView]";
    var dataViewCtorString = toSource(DataView);
    var mapCtorString = toSource(Map2);
    var promiseCtorString = toSource(Promise2);
    var setCtorString = toSource(Set2);
    var weakMapCtorString = toSource(WeakMap);
    var getTag = baseGetTag;
    if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
      getTag = function(value) {
        var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : void 0, ctorString = Ctor ? toSource(Ctor) : "";
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;
            case mapCtorString:
              return mapTag;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag;
            case weakMapCtorString:
              return weakMapTag;
          }
        }
        return result;
      };
    }
    module.exports = getTag;
  }
});

// ../../node_modules/lodash/_initCloneArray.js
var require_initCloneArray = __commonJS({
  "../../node_modules/lodash/_initCloneArray.js"(exports, module) {
    "use strict";
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function initCloneArray(array) {
      var length = array.length, result = new array.constructor(length);
      if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }
    module.exports = initCloneArray;
  }
});

// ../../node_modules/lodash/_cloneDataView.js
var require_cloneDataView = __commonJS({
  "../../node_modules/lodash/_cloneDataView.js"(exports, module) {
    "use strict";
    var cloneArrayBuffer = require_cloneArrayBuffer();
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }
    module.exports = cloneDataView;
  }
});

// ../../node_modules/lodash/_cloneRegExp.js
var require_cloneRegExp = __commonJS({
  "../../node_modules/lodash/_cloneRegExp.js"(exports, module) {
    "use strict";
    var reFlags = /\w*$/;
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }
    module.exports = cloneRegExp;
  }
});

// ../../node_modules/lodash/_cloneSymbol.js
var require_cloneSymbol = __commonJS({
  "../../node_modules/lodash/_cloneSymbol.js"(exports, module) {
    "use strict";
    var Symbol2 = require_Symbol();
    var symbolProto = Symbol2 ? Symbol2.prototype : void 0;
    var symbolValueOf = symbolProto ? symbolProto.valueOf : void 0;
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }
    module.exports = cloneSymbol;
  }
});

// ../../node_modules/lodash/_initCloneByTag.js
var require_initCloneByTag = __commonJS({
  "../../node_modules/lodash/_initCloneByTag.js"(exports, module) {
    "use strict";
    var cloneArrayBuffer = require_cloneArrayBuffer();
    var cloneDataView = require_cloneDataView();
    var cloneRegExp = require_cloneRegExp();
    var cloneSymbol = require_cloneSymbol();
    var cloneTypedArray = require_cloneTypedArray();
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var symbolTag = "[object Symbol]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var float32Tag = "[object Float32Array]";
    var float64Tag = "[object Float64Array]";
    var int8Tag = "[object Int8Array]";
    var int16Tag = "[object Int16Array]";
    var int32Tag = "[object Int32Array]";
    var uint8Tag = "[object Uint8Array]";
    var uint8ClampedTag = "[object Uint8ClampedArray]";
    var uint16Tag = "[object Uint16Array]";
    var uint32Tag = "[object Uint32Array]";
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
          return new Ctor(+object);
        case dataViewTag:
          return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
          return cloneTypedArray(object, isDeep);
        case mapTag:
          return new Ctor();
        case numberTag:
        case stringTag:
          return new Ctor(object);
        case regexpTag:
          return cloneRegExp(object);
        case setTag:
          return new Ctor();
        case symbolTag:
          return cloneSymbol(object);
      }
    }
    module.exports = initCloneByTag;
  }
});

// ../../node_modules/lodash/_baseIsMap.js
var require_baseIsMap = __commonJS({
  "../../node_modules/lodash/_baseIsMap.js"(exports, module) {
    "use strict";
    var getTag = require_getTag();
    var isObjectLike = require_isObjectLike();
    var mapTag = "[object Map]";
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }
    module.exports = baseIsMap;
  }
});

// ../../node_modules/lodash/isMap.js
var require_isMap = __commonJS({
  "../../node_modules/lodash/isMap.js"(exports, module) {
    "use strict";
    var baseIsMap = require_baseIsMap();
    var baseUnary = require_baseUnary();
    var nodeUtil = require_nodeUtil();
    var nodeIsMap = nodeUtil && nodeUtil.isMap;
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
    module.exports = isMap;
  }
});

// ../../node_modules/lodash/_baseIsSet.js
var require_baseIsSet = __commonJS({
  "../../node_modules/lodash/_baseIsSet.js"(exports, module) {
    "use strict";
    var getTag = require_getTag();
    var isObjectLike = require_isObjectLike();
    var setTag = "[object Set]";
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }
    module.exports = baseIsSet;
  }
});

// ../../node_modules/lodash/isSet.js
var require_isSet = __commonJS({
  "../../node_modules/lodash/isSet.js"(exports, module) {
    "use strict";
    var baseIsSet = require_baseIsSet();
    var baseUnary = require_baseUnary();
    var nodeUtil = require_nodeUtil();
    var nodeIsSet = nodeUtil && nodeUtil.isSet;
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
    module.exports = isSet;
  }
});

// ../../node_modules/lodash/_baseClone.js
var require_baseClone = __commonJS({
  "../../node_modules/lodash/_baseClone.js"(exports, module) {
    "use strict";
    var Stack = require_Stack();
    var arrayEach = require_arrayEach();
    var assignValue = require_assignValue();
    var baseAssign = require_baseAssign();
    var baseAssignIn = require_baseAssignIn();
    var cloneBuffer = require_cloneBuffer();
    var copyArray = require_copyArray();
    var copySymbols = require_copySymbols();
    var copySymbolsIn = require_copySymbolsIn();
    var getAllKeys = require_getAllKeys();
    var getAllKeysIn = require_getAllKeysIn();
    var getTag = require_getTag();
    var initCloneArray = require_initCloneArray();
    var initCloneByTag = require_initCloneByTag();
    var initCloneObject = require_initCloneObject();
    var isArray = require_isArray();
    var isBuffer = require_isBuffer();
    var isMap = require_isMap();
    var isObject = require_isObject();
    var isSet = require_isSet();
    var keys = require_keys();
    var keysIn = require_keysIn();
    var CLONE_DEEP_FLAG = 1;
    var CLONE_FLAT_FLAG = 2;
    var CLONE_SYMBOLS_FLAG = 4;
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var objectTag = "[object Object]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var symbolTag = "[object Symbol]";
    var weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var float32Tag = "[object Float32Array]";
    var float64Tag = "[object Float64Array]";
    var int8Tag = "[object Int8Array]";
    var int16Tag = "[object Int16Array]";
    var int32Tag = "[object Int32Array]";
    var uint8Tag = "[object Uint8Array]";
    var uint8ClampedTag = "[object Uint8ClampedArray]";
    var uint16Tag = "[object Uint16Array]";
    var uint32Tag = "[object Uint32Array]";
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== void 0) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
          result = isFlat || isFunc ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      stack || (stack = new Stack());
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);
      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key2) {
          result.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
        });
      }
      var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
      var props = isArr ? void 0 : keysFunc(value);
      arrayEach(props || value, function(subValue, key2) {
        if (props) {
          key2 = subValue;
          subValue = value[key2];
        }
        assignValue(result, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
      });
      return result;
    }
    module.exports = baseClone;
  }
});

// ../../node_modules/lodash/cloneDeep.js
var require_cloneDeep = __commonJS({
  "../../node_modules/lodash/cloneDeep.js"(exports, module) {
    "use strict";
    var baseClone = require_baseClone();
    var CLONE_DEEP_FLAG = 1;
    var CLONE_SYMBOLS_FLAG = 4;
    function cloneDeep2(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }
    module.exports = cloneDeep2;
  }
});

// src/constants/storage.ts
var LOCAL_STORAGE_KEYS = {
  BASKET: "koalaOrder",
  MENU: "koalaOrderMenu"
};

// src/storage/basket.storage.ts
var BasketStorage = class {
  constructor(storage, key = LOCAL_STORAGE_KEYS.BASKET) {
    this.key = key;
    this.storage = storage;
  }
  set(basket2) {
    this.storage.set(this.key, basket2);
  }
  get() {
    return this.storage.get(this.key);
  }
  remove() {
    this.storage.remove(this.key);
  }
};

// src/utils/menu.helpers.ts
var import_merge = __toESM(require_merge());


// ../../node_modules/zod/lib/index.mjs
var util;
(function(util2) {
  util2.assertEqual = (val) => val;
  function assertIs(_arg) {
  }
  util2.assertIs = assertIs;
  function assertNever(_x) {
    throw new Error();
  }
  util2.assertNever = assertNever;
  util2.arrayToEnum = (items) => {
    const obj = {};
    for (const item of items) {
      obj[item] = item;
    }
    return obj;
  };
  util2.getValidEnumValues = (obj) => {
    const validKeys = util2.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
    const filtered = {};
    for (const k of validKeys) {
      filtered[k] = obj[k];
    }
    return util2.objectValues(filtered);
  };
  util2.objectValues = (obj) => {
    return util2.objectKeys(obj).map(function(e) {
      return obj[e];
    });
  };
  util2.objectKeys = typeof Object.keys === "function" ? (obj) => Object.keys(obj) : (object) => {
    const keys = [];
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        keys.push(key);
      }
    }
    return keys;
  };
  util2.find = (arr, checker) => {
    for (const item of arr) {
      if (checker(item))
        return item;
    }
    return void 0;
  };
  util2.isInteger = typeof Number.isInteger === "function" ? (val) => Number.isInteger(val) : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
  function joinValues(array, separator = " | ") {
    return array.map((val) => typeof val === "string" ? `'${val}'` : val).join(separator);
  }
  util2.joinValues = joinValues;
  util2.jsonStringifyReplacer = (_, value) => {
    if (typeof value === "bigint") {
      return value.toString();
    }
    return value;
  };
})(util || (util = {}));
var objectUtil;
(function(objectUtil2) {
  objectUtil2.mergeShapes = (first, second) => {
    return __spreadValues(__spreadValues({}, first), second);
  };
})(objectUtil || (objectUtil = {}));
var ZodParsedType = util.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]);
var getParsedType = (data) => {
  const t = typeof data;
  switch (t) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      if (Array.isArray(data)) {
        return ZodParsedType.array;
      }
      if (data === null) {
        return ZodParsedType.null;
      }
      if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
        return ZodParsedType.promise;
      }
      if (typeof Map !== "undefined" && data instanceof Map) {
        return ZodParsedType.map;
      }
      if (typeof Set !== "undefined" && data instanceof Set) {
        return ZodParsedType.set;
      }
      if (typeof Date !== "undefined" && data instanceof Date) {
        return ZodParsedType.date;
      }
      return ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
};
var ZodIssueCode = util.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
var quotelessJson = (obj) => {
  const json = JSON.stringify(obj, null, 2);
  return json.replace(/"([^"]+)":/g, "$1:");
};
var ZodError = class extends Error {
  constructor(issues) {
    super();
    this.issues = [];
    this.addIssue = (sub) => {
      this.issues = [...this.issues, sub];
    };
    this.addIssues = (subs = []) => {
      this.issues = [...this.issues, ...subs];
    };
    const actualProto = new.target.prototype;
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, actualProto);
    } else {
      this.__proto__ = actualProto;
    }
    this.name = "ZodError";
    this.issues = issues;
  }
  get errors() {
    return this.issues;
  }
  format(_mapper) {
    const mapper = _mapper || function(issue) {
      return issue.message;
    };
    const fieldErrors = { _errors: [] };
    const processError = (error) => {
      for (const issue of error.issues) {
        if (issue.code === "invalid_union") {
          issue.unionErrors.map(processError);
        } else if (issue.code === "invalid_return_type") {
          processError(issue.returnTypeError);
        } else if (issue.code === "invalid_arguments") {
          processError(issue.argumentsError);
        } else if (issue.path.length === 0) {
          fieldErrors._errors.push(mapper(issue));
        } else {
          let curr = fieldErrors;
          let i = 0;
          while (i < issue.path.length) {
            const el = issue.path[i];
            const terminal = i === issue.path.length - 1;
            if (!terminal) {
              curr[el] = curr[el] || { _errors: [] };
            } else {
              curr[el] = curr[el] || { _errors: [] };
              curr[el]._errors.push(mapper(issue));
            }
            curr = curr[el];
            i++;
          }
        }
      }
    };
    processError(this);
    return fieldErrors;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(mapper = (issue) => issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of this.issues) {
      if (sub.path.length > 0) {
        fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
        fieldErrors[sub.path[0]].push(mapper(sub));
      } else {
        formErrors.push(mapper(sub));
      }
    }
    return { formErrors, fieldErrors };
  }
  get formErrors() {
    return this.flatten();
  }
};
ZodError.create = (issues) => {
  const error = new ZodError(issues);
  return error;
};
var errorMap = (issue, _ctx) => {
  let message;
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === ZodParsedType.undefined) {
        message = "Required";
      } else {
        message = `Expected ${issue.expected}, received ${issue.received}`;
      }
      break;
    case ZodIssueCode.invalid_literal:
      message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_union_discriminator:
      message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      message = `Invalid function arguments`;
      break;
    case ZodIssueCode.invalid_return_type:
      message = `Invalid function return type`;
      break;
    case ZodIssueCode.invalid_date:
      message = `Invalid date`;
      break;
    case ZodIssueCode.invalid_string:
      if (typeof issue.validation === "object") {
        if ("includes" in issue.validation) {
          message = `Invalid input: must include "${issue.validation.includes}"`;
          if (typeof issue.validation.position === "number") {
            message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
          }
        } else if ("startsWith" in issue.validation) {
          message = `Invalid input: must start with "${issue.validation.startsWith}"`;
        } else if ("endsWith" in issue.validation) {
          message = `Invalid input: must end with "${issue.validation.endsWith}"`;
        } else {
          util.assertNever(issue.validation);
        }
      } else if (issue.validation !== "regex") {
        message = `Invalid ${issue.validation}`;
      } else {
        message = "Invalid";
      }
      break;
    case ZodIssueCode.too_small:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "bigint")
        message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.custom:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_intersection_types:
      message = `Intersection results could not be merged`;
      break;
    case ZodIssueCode.not_multiple_of:
      message = `Number must be a multiple of ${issue.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      message = "Number must be finite";
      break;
    default:
      message = _ctx.defaultError;
      util.assertNever(issue);
  }
  return { message };
};
var overrideErrorMap = errorMap;
function setErrorMap(map) {
  overrideErrorMap = map;
}
function getErrorMap() {
  return overrideErrorMap;
}
var makeIssue = (params) => {
  const { data, path, errorMaps, issueData } = params;
  const fullPath = [...path, ...issueData.path || []];
  const fullIssue = __spreadProps(__spreadValues({}, issueData), {
    path: fullPath
  });
  let errorMessage = "";
  const maps = errorMaps.filter((m) => !!m).slice().reverse();
  for (const map of maps) {
    errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
  }
  return __spreadProps(__spreadValues({}, issueData), {
    path: fullPath,
    message: issueData.message || errorMessage
  });
};
var EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
  const issue = makeIssue({
    issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [
      ctx.common.contextualErrorMap,
      ctx.schemaErrorMap,
      getErrorMap(),
      errorMap
      // then global default map
    ].filter((x) => !!x)
  });
  ctx.common.issues.push(issue);
}
var ParseStatus = class _ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    if (this.value === "valid")
      this.value = "dirty";
  }
  abort() {
    if (this.value !== "aborted")
      this.value = "aborted";
  }
  static mergeArray(status, results) {
    const arrayValue = [];
    for (const s of results) {
      if (s.status === "aborted")
        return INVALID;
      if (s.status === "dirty")
        status.dirty();
      arrayValue.push(s.value);
    }
    return { status: status.value, value: arrayValue };
  }
  static mergeObjectAsync(status, pairs) {
    return __async(this, null, function* () {
      const syncPairs = [];
      for (const pair of pairs) {
        syncPairs.push({
          key: yield pair.key,
          value: yield pair.value
        });
      }
      return _ParseStatus.mergeObjectSync(status, syncPairs);
    });
  }
  static mergeObjectSync(status, pairs) {
    const finalObject = {};
    for (const pair of pairs) {
      const { key, value } = pair;
      if (key.status === "aborted")
        return INVALID;
      if (value.status === "aborted")
        return INVALID;
      if (key.status === "dirty")
        status.dirty();
      if (value.status === "dirty")
        status.dirty();
      if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) {
        finalObject[key.value] = value.value;
      }
    }
    return { status: status.value, value: finalObject };
  }
};
var INVALID = Object.freeze({
  status: "aborted"
});
var DIRTY = (value) => ({ status: "dirty", value });
var OK = (value) => ({ status: "valid", value });
var isAborted = (x) => x.status === "aborted";
var isDirty = (x) => x.status === "dirty";
var isValid = (x) => x.status === "valid";
var isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;
var errorUtil;
(function(errorUtil2) {
  errorUtil2.errToObj = (message) => typeof message === "string" ? { message } : message || {};
  errorUtil2.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));
var ParseInputLazyPath = class {
  constructor(parent, value, path, key) {
    this._cachedPath = [];
    this.parent = parent;
    this.data = value;
    this._path = path;
    this._key = key;
  }
  get path() {
    if (!this._cachedPath.length) {
      if (this._key instanceof Array) {
        this._cachedPath.push(...this._path, ...this._key);
      } else {
        this._cachedPath.push(...this._path, this._key);
      }
    }
    return this._cachedPath;
  }
};
var handleResult = (ctx, result) => {
  if (isValid(result)) {
    return { success: true, data: result.value };
  } else {
    if (!ctx.common.issues.length) {
      throw new Error("Validation failed but no issues detected.");
    }
    return {
      success: false,
      get error() {
        if (this._error)
          return this._error;
        const error = new ZodError(ctx.common.issues);
        this._error = error;
        return this._error;
      }
    };
  }
};
function processCreateParams(params) {
  if (!params)
    return {};
  const { errorMap: errorMap2, invalid_type_error, required_error, description } = params;
  if (errorMap2 && (invalid_type_error || required_error)) {
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  }
  if (errorMap2)
    return { errorMap: errorMap2, description };
  const customMap = (iss, ctx) => {
    if (iss.code !== "invalid_type")
      return { message: ctx.defaultError };
    if (typeof ctx.data === "undefined") {
      return { message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError };
    }
    return { message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError };
  };
  return { errorMap: customMap, description };
}
var ZodType = class {
  constructor(def) {
    this.spa = this.safeParseAsync;
    this._def = def;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this.brand = this.brand.bind(this);
    this.default = this.default.bind(this);
    this.catch = this.catch.bind(this);
    this.describe = this.describe.bind(this);
    this.pipe = this.pipe.bind(this);
    this.readonly = this.readonly.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(input) {
    return getParsedType(input.data);
  }
  _getOrReturnCtx(input, ctx) {
    return ctx || {
      common: input.parent.common,
      data: input.data,
      parsedType: getParsedType(input.data),
      schemaErrorMap: this._def.errorMap,
      path: input.path,
      parent: input.parent
    };
  }
  _processInputParams(input) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      }
    };
  }
  _parseSync(input) {
    const result = this._parse(input);
    if (isAsync(result)) {
      throw new Error("Synchronous parse encountered promise.");
    }
    return result;
  }
  _parseAsync(input) {
    const result = this._parse(input);
    return Promise.resolve(result);
  }
  parse(data, params) {
    const result = this.safeParse(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  safeParse(data, params) {
    var _a;
    const ctx = {
      common: {
        issues: [],
        async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
      },
      path: (params === null || params === void 0 ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const result = this._parseSync({ data, path: ctx.path, parent: ctx });
    return handleResult(ctx, result);
  }
  parseAsync(data, params) {
    return __async(this, null, function* () {
      const result = yield this.safeParseAsync(data, params);
      if (result.success)
        return result.data;
      throw result.error;
    });
  }
  safeParseAsync(data, params) {
    return __async(this, null, function* () {
      const ctx = {
        common: {
          issues: [],
          contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
          async: true
        },
        path: (params === null || params === void 0 ? void 0 : params.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data,
        parsedType: getParsedType(data)
      };
      const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
      const result = yield isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult);
      return handleResult(ctx, result);
    });
  }
  refine(check, message) {
    const getIssueProperties = (val) => {
      if (typeof message === "string" || typeof message === "undefined") {
        return { message };
      } else if (typeof message === "function") {
        return message(val);
      } else {
        return message;
      }
    };
    return this._refinement((val, ctx) => {
      const result = check(val);
      const setError = () => ctx.addIssue(__spreadValues({
        code: ZodIssueCode.custom
      }, getIssueProperties(val)));
      if (typeof Promise !== "undefined" && result instanceof Promise) {
        return result.then((data) => {
          if (!data) {
            setError();
            return false;
          } else {
            return true;
          }
        });
      }
      if (!result) {
        setError();
        return false;
      } else {
        return true;
      }
    });
  }
  refinement(check, refinementData) {
    return this._refinement((val, ctx) => {
      if (!check(val)) {
        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
        return false;
      } else {
        return true;
      }
    });
  }
  _refinement(refinement) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement }
    });
  }
  superRefine(refinement) {
    return this._refinement(refinement);
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this, this._def);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(option) {
    return ZodUnion.create([this, option], this._def);
  }
  and(incoming) {
    return ZodIntersection.create(this, incoming, this._def);
  }
  transform(transform) {
    return new ZodEffects(__spreadProps(__spreadValues({}, processCreateParams(this._def)), {
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform }
    }));
  }
  default(def) {
    const defaultValueFunc = typeof def === "function" ? def : () => def;
    return new ZodDefault(__spreadProps(__spreadValues({}, processCreateParams(this._def)), {
      innerType: this,
      defaultValue: defaultValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    }));
  }
  brand() {
    return new ZodBranded(__spreadValues({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this
    }, processCreateParams(this._def)));
  }
  catch(def) {
    const catchValueFunc = typeof def === "function" ? def : () => def;
    return new ZodCatch(__spreadProps(__spreadValues({}, processCreateParams(this._def)), {
      innerType: this,
      catchValue: catchValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    }));
  }
  describe(description) {
    const This = this.constructor;
    return new This(__spreadProps(__spreadValues({}, this._def), {
      description
    }));
  }
  pipe(target) {
    return ZodPipeline.create(this, target);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
var cuidRegex = /^c[^\s-]{8,}$/i;
var cuid2Regex = /^[a-z][a-z0-9]*$/;
var ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
var uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
var emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
var _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
var emojiRegex;
var ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
var ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
var datetimeRegex = (args) => {
  if (args.precision) {
    if (args.offset) {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
    } else {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    }
  } else if (args.precision === 0) {
    if (args.offset) {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
    } else {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    }
  } else {
    if (args.offset) {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
    } else {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
  }
};
function isValidIP(ip, version) {
  if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
    return true;
  }
  if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
    return true;
  }
  return false;
}
var ZodString = class _ZodString extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = String(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.string) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(
        ctx2,
        {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.string,
          received: ctx2.parsedType
        }
        //
      );
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.length < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.length > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "length") {
        const tooBig = input.data.length > check.value;
        const tooSmall = input.data.length < check.value;
        if (tooBig || tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          if (tooBig) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          } else if (tooSmall) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          }
          status.dirty();
        }
      } else if (check.kind === "email") {
        if (!emailRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "email",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "emoji") {
        if (!emojiRegex) {
          emojiRegex = new RegExp(_emojiRegex, "u");
        }
        if (!emojiRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "emoji",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "uuid") {
        if (!uuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "uuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid") {
        if (!cuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid2") {
        if (!cuid2Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid2",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ulid") {
        if (!ulidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ulid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "url") {
        try {
          new URL(input.data);
        } catch (_a) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "url",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "regex") {
        check.regex.lastIndex = 0;
        const testResult = check.regex.test(input.data);
        if (!testResult) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "regex",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "trim") {
        input.data = input.data.trim();
      } else if (check.kind === "includes") {
        if (!input.data.includes(check.value, check.position)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { includes: check.value, position: check.position },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "toLowerCase") {
        input.data = input.data.toLowerCase();
      } else if (check.kind === "toUpperCase") {
        input.data = input.data.toUpperCase();
      } else if (check.kind === "startsWith") {
        if (!input.data.startsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { startsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "endsWith") {
        if (!input.data.endsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { endsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "datetime") {
        const regex = datetimeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "datetime",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ip") {
        if (!isValidIP(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ip",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _regex(regex, validation, message) {
    return this.refinement((data) => regex.test(data), __spreadValues({
      validation,
      code: ZodIssueCode.invalid_string
    }, errorUtil.errToObj(message)));
  }
  _addCheck(check) {
    return new _ZodString(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, check]
    }));
  }
  email(message) {
    return this._addCheck(__spreadValues({ kind: "email" }, errorUtil.errToObj(message)));
  }
  url(message) {
    return this._addCheck(__spreadValues({ kind: "url" }, errorUtil.errToObj(message)));
  }
  emoji(message) {
    return this._addCheck(__spreadValues({ kind: "emoji" }, errorUtil.errToObj(message)));
  }
  uuid(message) {
    return this._addCheck(__spreadValues({ kind: "uuid" }, errorUtil.errToObj(message)));
  }
  cuid(message) {
    return this._addCheck(__spreadValues({ kind: "cuid" }, errorUtil.errToObj(message)));
  }
  cuid2(message) {
    return this._addCheck(__spreadValues({ kind: "cuid2" }, errorUtil.errToObj(message)));
  }
  ulid(message) {
    return this._addCheck(__spreadValues({ kind: "ulid" }, errorUtil.errToObj(message)));
  }
  ip(options) {
    return this._addCheck(__spreadValues({ kind: "ip" }, errorUtil.errToObj(options)));
  }
  datetime(options) {
    var _a;
    if (typeof options === "string") {
      return this._addCheck({
        kind: "datetime",
        precision: null,
        offset: false,
        message: options
      });
    }
    return this._addCheck(__spreadValues({
      kind: "datetime",
      precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
      offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false
    }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
  }
  regex(regex, message) {
    return this._addCheck(__spreadValues({
      kind: "regex",
      regex
    }, errorUtil.errToObj(message)));
  }
  includes(value, options) {
    return this._addCheck(__spreadValues({
      kind: "includes",
      value,
      position: options === null || options === void 0 ? void 0 : options.position
    }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
  }
  startsWith(value, message) {
    return this._addCheck(__spreadValues({
      kind: "startsWith",
      value
    }, errorUtil.errToObj(message)));
  }
  endsWith(value, message) {
    return this._addCheck(__spreadValues({
      kind: "endsWith",
      value
    }, errorUtil.errToObj(message)));
  }
  min(minLength, message) {
    return this._addCheck(__spreadValues({
      kind: "min",
      value: minLength
    }, errorUtil.errToObj(message)));
  }
  max(maxLength, message) {
    return this._addCheck(__spreadValues({
      kind: "max",
      value: maxLength
    }, errorUtil.errToObj(message)));
  }
  length(len, message) {
    return this._addCheck(__spreadValues({
      kind: "length",
      value: len
    }, errorUtil.errToObj(message)));
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(message) {
    return this.min(1, errorUtil.errToObj(message));
  }
  trim() {
    return new _ZodString(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, { kind: "trim" }]
    }));
  }
  toLowerCase() {
    return new _ZodString(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    }));
  }
  toUpperCase() {
    return new _ZodString(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    }));
  }
  get isDatetime() {
    return !!this._def.checks.find((ch) => ch.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((ch) => ch.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((ch) => ch.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((ch) => ch.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((ch) => ch.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((ch) => ch.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((ch) => ch.kind === "ip");
  }
  get minLength() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxLength() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
};
ZodString.create = (params) => {
  var _a;
  return new ZodString(__spreadValues({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
  }, processCreateParams(params)));
};
function floatSafeRemainder(val, step) {
  const valDecCount = (val.toString().split(".")[1] || "").length;
  const stepDecCount = (step.toString().split(".")[1] || "").length;
  const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
  const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / Math.pow(10, decCount);
}
var ZodNumber = class _ZodNumber extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
    this.step = this.multipleOf;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = Number(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.number) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "int") {
        if (!util.isInteger(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: "integer",
            received: "float",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (floatSafeRemainder(input.data, check.value) !== 0) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "finite") {
        if (!Number.isFinite(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_finite,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new _ZodNumber(__spreadProps(__spreadValues({}, this._def), {
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    }));
  }
  _addCheck(check) {
    return new _ZodNumber(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, check]
    }));
  }
  int(message) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(message)
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  finite(message) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(message)
    });
  }
  safe(message) {
    return this._addCheck({
      kind: "min",
      inclusive: true,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(message)
    })._addCheck({
      kind: "max",
      inclusive: true,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
  get isInt() {
    return !!this._def.checks.find((ch) => ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value));
  }
  get isFinite() {
    let max = null, min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") {
        return true;
      } else if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      } else if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return Number.isFinite(min) && Number.isFinite(max);
  }
};
ZodNumber.create = (params) => {
  return new ZodNumber(__spreadValues({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodNumber,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
  }, processCreateParams(params)));
};
var ZodBigInt = class _ZodBigInt extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = BigInt(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.bigint) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.bigint,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            type: "bigint",
            minimum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            type: "bigint",
            maximum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (input.data % check.value !== BigInt(0)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new _ZodBigInt(__spreadProps(__spreadValues({}, this._def), {
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    }));
  }
  _addCheck(check) {
    return new _ZodBigInt(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, check]
    }));
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
};
ZodBigInt.create = (params) => {
  var _a;
  return new ZodBigInt(__spreadValues({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
  }, processCreateParams(params)));
};
var ZodBoolean = class extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = Boolean(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.boolean) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodBoolean.create = (params) => {
  return new ZodBoolean(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodBoolean,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
  }, processCreateParams(params)));
};
var ZodDate = class _ZodDate extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = new Date(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.date) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    if (isNaN(input.data.getTime())) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_date
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.getTime() < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            message: check.message,
            inclusive: true,
            exact: false,
            minimum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.getTime() > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            message: check.message,
            inclusive: true,
            exact: false,
            maximum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return {
      status: status.value,
      value: new Date(input.data.getTime())
    };
  }
  _addCheck(check) {
    return new _ZodDate(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, check]
    }));
  }
  min(minDate, message) {
    return this._addCheck({
      kind: "min",
      value: minDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  max(maxDate, message) {
    return this._addCheck({
      kind: "max",
      value: maxDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  get minDate() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min != null ? new Date(min) : null;
  }
  get maxDate() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max != null ? new Date(max) : null;
  }
};
ZodDate.create = (params) => {
  return new ZodDate(__spreadValues({
    checks: [],
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    typeName: ZodFirstPartyTypeKind.ZodDate
  }, processCreateParams(params)));
};
var ZodSymbol = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.symbol) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodSymbol.create = (params) => {
  return new ZodSymbol(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodSymbol
  }, processCreateParams(params)));
};
var ZodUndefined = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodUndefined.create = (params) => {
  return new ZodUndefined(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodUndefined
  }, processCreateParams(params)));
};
var ZodNull = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.null) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodNull.create = (params) => {
  return new ZodNull(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodNull
  }, processCreateParams(params)));
};
var ZodAny = class extends ZodType {
  constructor() {
    super(...arguments);
    this._any = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
ZodAny.create = (params) => {
  return new ZodAny(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodAny
  }, processCreateParams(params)));
};
var ZodUnknown = class extends ZodType {
  constructor() {
    super(...arguments);
    this._unknown = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
ZodUnknown.create = (params) => {
  return new ZodUnknown(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodUnknown
  }, processCreateParams(params)));
};
var ZodNever = class extends ZodType {
  _parse(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: ctx.parsedType
    });
    return INVALID;
  }
};
ZodNever.create = (params) => {
  return new ZodNever(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodNever
  }, processCreateParams(params)));
};
var ZodVoid = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodVoid.create = (params) => {
  return new ZodVoid(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodVoid
  }, processCreateParams(params)));
};
var ZodArray = class _ZodArray extends ZodType {
  _parse(input) {
    const { ctx, status } = this._processInputParams(input);
    const def = this._def;
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (def.exactLength !== null) {
      const tooBig = ctx.data.length > def.exactLength.value;
      const tooSmall = ctx.data.length < def.exactLength.value;
      if (tooBig || tooSmall) {
        addIssueToContext(ctx, {
          code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
          minimum: tooSmall ? def.exactLength.value : void 0,
          maximum: tooBig ? def.exactLength.value : void 0,
          type: "array",
          inclusive: true,
          exact: true,
          message: def.exactLength.message
        });
        status.dirty();
      }
    }
    if (def.minLength !== null) {
      if (ctx.data.length < def.minLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.minLength.message
        });
        status.dirty();
      }
    }
    if (def.maxLength !== null) {
      if (ctx.data.length > def.maxLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.maxLength.message
        });
        status.dirty();
      }
    }
    if (ctx.common.async) {
      return Promise.all([...ctx.data].map((item, i) => {
        return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
      })).then((result2) => {
        return ParseStatus.mergeArray(status, result2);
      });
    }
    const result = [...ctx.data].map((item, i) => {
      return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
    });
    return ParseStatus.mergeArray(status, result);
  }
  get element() {
    return this._def.type;
  }
  min(minLength, message) {
    return new _ZodArray(__spreadProps(__spreadValues({}, this._def), {
      minLength: { value: minLength, message: errorUtil.toString(message) }
    }));
  }
  max(maxLength, message) {
    return new _ZodArray(__spreadProps(__spreadValues({}, this._def), {
      maxLength: { value: maxLength, message: errorUtil.toString(message) }
    }));
  }
  length(len, message) {
    return new _ZodArray(__spreadProps(__spreadValues({}, this._def), {
      exactLength: { value: len, message: errorUtil.toString(message) }
    }));
  }
  nonempty(message) {
    return this.min(1, message);
  }
};
ZodArray.create = (schema, params) => {
  return new ZodArray(__spreadValues({
    type: schema,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: ZodFirstPartyTypeKind.ZodArray
  }, processCreateParams(params)));
};
function deepPartialify(schema) {
  if (schema instanceof ZodObject) {
    const newShape = {};
    for (const key in schema.shape) {
      const fieldSchema = schema.shape[key];
      newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
    }
    return new ZodObject(__spreadProps(__spreadValues({}, schema._def), {
      shape: () => newShape
    }));
  } else if (schema instanceof ZodArray) {
    return new ZodArray(__spreadProps(__spreadValues({}, schema._def), {
      type: deepPartialify(schema.element)
    }));
  } else if (schema instanceof ZodOptional) {
    return ZodOptional.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodNullable) {
    return ZodNullable.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodTuple) {
    return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
  } else {
    return schema;
  }
}
var ZodObject = class _ZodObject extends ZodType {
  constructor() {
    super(...arguments);
    this._cached = null;
    this.nonstrict = this.passthrough;
    this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const shape = this._def.shape();
    const keys = util.objectKeys(shape);
    return this._cached = { shape, keys };
  }
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.object) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const { status, ctx } = this._processInputParams(input);
    const { shape, keys: shapeKeys } = this._getCached();
    const extraKeys = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
      for (const key in ctx.data) {
        if (!shapeKeys.includes(key)) {
          extraKeys.push(key);
        }
      }
    }
    const pairs = [];
    for (const key of shapeKeys) {
      const keyValidator = shape[key];
      const value = ctx.data[key];
      pairs.push({
        key: { status: "valid", value: key },
        value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
        alwaysSet: key in ctx.data
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const unknownKeys = this._def.unknownKeys;
      if (unknownKeys === "passthrough") {
        for (const key of extraKeys) {
          pairs.push({
            key: { status: "valid", value: key },
            value: { status: "valid", value: ctx.data[key] }
          });
        }
      } else if (unknownKeys === "strict") {
        if (extraKeys.length > 0) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.unrecognized_keys,
            keys: extraKeys
          });
          status.dirty();
        }
      } else if (unknownKeys === "strip") ;
      else {
        throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
      }
    } else {
      const catchall = this._def.catchall;
      for (const key of extraKeys) {
        const value = ctx.data[key];
        pairs.push({
          key: { status: "valid", value: key },
          value: catchall._parse(
            new ParseInputLazyPath(ctx, value, ctx.path, key)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: key in ctx.data
        });
      }
    }
    if (ctx.common.async) {
      return Promise.resolve().then(() => __async(this, null, function* () {
        const syncPairs = [];
        for (const pair of pairs) {
          const key = yield pair.key;
          syncPairs.push({
            key,
            value: yield pair.value,
            alwaysSet: pair.alwaysSet
          });
        }
        return syncPairs;
      })).then((syncPairs) => {
        return ParseStatus.mergeObjectSync(status, syncPairs);
      });
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get shape() {
    return this._def.shape();
  }
  strict(message) {
    errorUtil.errToObj;
    return new _ZodObject(__spreadValues(__spreadProps(__spreadValues({}, this._def), {
      unknownKeys: "strict"
    }), message !== void 0 ? {
      errorMap: (issue, ctx) => {
        var _a, _b, _c, _d;
        const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
        if (issue.code === "unrecognized_keys")
          return {
            message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
          };
        return {
          message: defaultError
        };
      }
    } : {}));
  }
  strip() {
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      unknownKeys: "strip"
    }));
  }
  passthrough() {
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      unknownKeys: "passthrough"
    }));
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(augmentation) {
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => __spreadValues(__spreadValues({}, this._def.shape()), augmentation)
    }));
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(merging) {
    const merged = new _ZodObject({
      unknownKeys: merging._def.unknownKeys,
      catchall: merging._def.catchall,
      shape: () => __spreadValues(__spreadValues({}, this._def.shape()), merging._def.shape()),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
    return merged;
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(key, schema) {
    return this.augment({ [key]: schema });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(index) {
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      catchall: index
    }));
  }
  pick(mask) {
    const shape = {};
    util.objectKeys(mask).forEach((key) => {
      if (mask[key] && this.shape[key]) {
        shape[key] = this.shape[key];
      }
    });
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => shape
    }));
  }
  omit(mask) {
    const shape = {};
    util.objectKeys(this.shape).forEach((key) => {
      if (!mask[key]) {
        shape[key] = this.shape[key];
      }
    });
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => shape
    }));
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(mask) {
    const newShape = {};
    util.objectKeys(this.shape).forEach((key) => {
      const fieldSchema = this.shape[key];
      if (mask && !mask[key]) {
        newShape[key] = fieldSchema;
      } else {
        newShape[key] = fieldSchema.optional();
      }
    });
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => newShape
    }));
  }
  required(mask) {
    const newShape = {};
    util.objectKeys(this.shape).forEach((key) => {
      if (mask && !mask[key]) {
        newShape[key] = this.shape[key];
      } else {
        const fieldSchema = this.shape[key];
        let newField = fieldSchema;
        while (newField instanceof ZodOptional) {
          newField = newField._def.innerType;
        }
        newShape[key] = newField;
      }
    });
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => newShape
    }));
  }
  keyof() {
    return createZodEnum(util.objectKeys(this.shape));
  }
};
ZodObject.create = (shape, params) => {
  return new ZodObject(__spreadValues({
    shape: () => shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};
ZodObject.strictCreate = (shape, params) => {
  return new ZodObject(__spreadValues({
    shape: () => shape,
    unknownKeys: "strict",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};
ZodObject.lazycreate = (shape, params) => {
  return new ZodObject(__spreadValues({
    shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};
var ZodUnion = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const options = this._def.options;
    function handleResults(results) {
      for (const result of results) {
        if (result.result.status === "valid") {
          return result.result;
        }
      }
      for (const result of results) {
        if (result.result.status === "dirty") {
          ctx.common.issues.push(...result.ctx.common.issues);
          return result.result;
        }
      }
      const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return Promise.all(options.map((option) => __async(this, null, function* () {
        const childCtx = __spreadProps(__spreadValues({}, ctx), {
          common: __spreadProps(__spreadValues({}, ctx.common), {
            issues: []
          }),
          parent: null
        });
        return {
          result: yield option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: childCtx
          }),
          ctx: childCtx
        };
      }))).then(handleResults);
    } else {
      let dirty = void 0;
      const issues = [];
      for (const option of options) {
        const childCtx = __spreadProps(__spreadValues({}, ctx), {
          common: __spreadProps(__spreadValues({}, ctx.common), {
            issues: []
          }),
          parent: null
        });
        const result = option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: childCtx
        });
        if (result.status === "valid") {
          return result;
        } else if (result.status === "dirty" && !dirty) {
          dirty = { result, ctx: childCtx };
        }
        if (childCtx.common.issues.length) {
          issues.push(childCtx.common.issues);
        }
      }
      if (dirty) {
        ctx.common.issues.push(...dirty.ctx.common.issues);
        return dirty.result;
      }
      const unionErrors = issues.map((issues2) => new ZodError(issues2));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
};
ZodUnion.create = (types, params) => {
  return new ZodUnion(__spreadValues({
    options: types,
    typeName: ZodFirstPartyTypeKind.ZodUnion
  }, processCreateParams(params)));
};
var getDiscriminator = (type) => {
  if (type instanceof ZodLazy) {
    return getDiscriminator(type.schema);
  } else if (type instanceof ZodEffects) {
    return getDiscriminator(type.innerType());
  } else if (type instanceof ZodLiteral) {
    return [type.value];
  } else if (type instanceof ZodEnum) {
    return type.options;
  } else if (type instanceof ZodNativeEnum) {
    return Object.keys(type.enum);
  } else if (type instanceof ZodDefault) {
    return getDiscriminator(type._def.innerType);
  } else if (type instanceof ZodUndefined) {
    return [void 0];
  } else if (type instanceof ZodNull) {
    return [null];
  } else {
    return null;
  }
};
var ZodDiscriminatedUnion = class _ZodDiscriminatedUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const discriminator = this.discriminator;
    const discriminatorValue = ctx.data[discriminator];
    const option = this.optionsMap.get(discriminatorValue);
    if (!option) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [discriminator]
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return option._parseAsync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    } else {
      return option._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    }
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(discriminator, options, params) {
    const optionsMap = /* @__PURE__ */ new Map();
    for (const type of options) {
      const discriminatorValues = getDiscriminator(type.shape[discriminator]);
      if (!discriminatorValues) {
        throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
      }
      for (const value of discriminatorValues) {
        if (optionsMap.has(value)) {
          throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
        }
        optionsMap.set(value, type);
      }
    }
    return new _ZodDiscriminatedUnion(__spreadValues({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator,
      options,
      optionsMap
    }, processCreateParams(params)));
  }
};
function mergeValues(a, b) {
  const aType = getParsedType(a);
  const bType = getParsedType(b);
  if (a === b) {
    return { valid: true, data: a };
  } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
    const bKeys = util.objectKeys(b);
    const sharedKeys = util.objectKeys(a).filter((key) => bKeys.indexOf(key) !== -1);
    const newObj = __spreadValues(__spreadValues({}, a), b);
    for (const key of sharedKeys) {
      const sharedValue = mergeValues(a[key], b[key]);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newObj[key] = sharedValue.data;
    }
    return { valid: true, data: newObj };
  } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
    if (a.length !== b.length) {
      return { valid: false };
    }
    const newArray = [];
    for (let index = 0; index < a.length; index++) {
      const itemA = a[index];
      const itemB = b[index];
      const sharedValue = mergeValues(itemA, itemB);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newArray.push(sharedValue.data);
    }
    return { valid: true, data: newArray };
  } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) {
    return { valid: true, data: a };
  } else {
    return { valid: false };
  }
}
var ZodIntersection = class extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const handleParsed = (parsedLeft, parsedRight) => {
      if (isAborted(parsedLeft) || isAborted(parsedRight)) {
        return INVALID;
      }
      const merged = mergeValues(parsedLeft.value, parsedRight.value);
      if (!merged.valid) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_intersection_types
        });
        return INVALID;
      }
      if (isDirty(parsedLeft) || isDirty(parsedRight)) {
        status.dirty();
      }
      return { status: status.value, value: merged.data };
    };
    if (ctx.common.async) {
      return Promise.all([
        this._def.left._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }),
        this._def.right._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        })
      ]).then(([left, right]) => handleParsed(left, right));
    } else {
      return handleParsed(this._def.left._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }), this._def.right._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }));
    }
  }
};
ZodIntersection.create = (left, right, params) => {
  return new ZodIntersection(__spreadValues({
    left,
    right,
    typeName: ZodFirstPartyTypeKind.ZodIntersection
  }, processCreateParams(params)));
};
var ZodTuple = class _ZodTuple extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (ctx.data.length < this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      return INVALID;
    }
    const rest = this._def.rest;
    if (!rest && ctx.data.length > this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_big,
        maximum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      status.dirty();
    }
    const items = [...ctx.data].map((item, itemIndex) => {
      const schema = this._def.items[itemIndex] || this._def.rest;
      if (!schema)
        return null;
      return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
    }).filter((x) => !!x);
    if (ctx.common.async) {
      return Promise.all(items).then((results) => {
        return ParseStatus.mergeArray(status, results);
      });
    } else {
      return ParseStatus.mergeArray(status, items);
    }
  }
  get items() {
    return this._def.items;
  }
  rest(rest) {
    return new _ZodTuple(__spreadProps(__spreadValues({}, this._def), {
      rest
    }));
  }
};
ZodTuple.create = (schemas, params) => {
  if (!Array.isArray(schemas)) {
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  }
  return new ZodTuple(__spreadValues({
    items: schemas,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null
  }, processCreateParams(params)));
};
var ZodRecord = class _ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const pairs = [];
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    for (const key in ctx.data) {
      pairs.push({
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
        value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
      });
    }
    if (ctx.common.async) {
      return ParseStatus.mergeObjectAsync(status, pairs);
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get element() {
    return this._def.valueType;
  }
  static create(first, second, third) {
    if (second instanceof ZodType) {
      return new _ZodRecord(__spreadValues({
        keyType: first,
        valueType: second,
        typeName: ZodFirstPartyTypeKind.ZodRecord
      }, processCreateParams(third)));
    }
    return new _ZodRecord(__spreadValues({
      keyType: ZodString.create(),
      valueType: first,
      typeName: ZodFirstPartyTypeKind.ZodRecord
    }, processCreateParams(second)));
  }
};
var ZodMap = class extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.map) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    const pairs = [...ctx.data.entries()].map(([key, value], index) => {
      return {
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
        value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"]))
      };
    });
    if (ctx.common.async) {
      const finalMap = /* @__PURE__ */ new Map();
      return Promise.resolve().then(() => __async(this, null, function* () {
        for (const pair of pairs) {
          const key = yield pair.key;
          const value = yield pair.value;
          if (key.status === "aborted" || value.status === "aborted") {
            return INVALID;
          }
          if (key.status === "dirty" || value.status === "dirty") {
            status.dirty();
          }
          finalMap.set(key.value, value.value);
        }
        return { status: status.value, value: finalMap };
      }));
    } else {
      const finalMap = /* @__PURE__ */ new Map();
      for (const pair of pairs) {
        const key = pair.key;
        const value = pair.value;
        if (key.status === "aborted" || value.status === "aborted") {
          return INVALID;
        }
        if (key.status === "dirty" || value.status === "dirty") {
          status.dirty();
        }
        finalMap.set(key.value, value.value);
      }
      return { status: status.value, value: finalMap };
    }
  }
};
ZodMap.create = (keyType, valueType, params) => {
  return new ZodMap(__spreadValues({
    valueType,
    keyType,
    typeName: ZodFirstPartyTypeKind.ZodMap
  }, processCreateParams(params)));
};
var ZodSet = class _ZodSet extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.set) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const def = this._def;
    if (def.minSize !== null) {
      if (ctx.data.size < def.minSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.minSize.message
        });
        status.dirty();
      }
    }
    if (def.maxSize !== null) {
      if (ctx.data.size > def.maxSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.maxSize.message
        });
        status.dirty();
      }
    }
    const valueType = this._def.valueType;
    function finalizeSet(elements2) {
      const parsedSet = /* @__PURE__ */ new Set();
      for (const element of elements2) {
        if (element.status === "aborted")
          return INVALID;
        if (element.status === "dirty")
          status.dirty();
        parsedSet.add(element.value);
      }
      return { status: status.value, value: parsedSet };
    }
    const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
    if (ctx.common.async) {
      return Promise.all(elements).then((elements2) => finalizeSet(elements2));
    } else {
      return finalizeSet(elements);
    }
  }
  min(minSize, message) {
    return new _ZodSet(__spreadProps(__spreadValues({}, this._def), {
      minSize: { value: minSize, message: errorUtil.toString(message) }
    }));
  }
  max(maxSize, message) {
    return new _ZodSet(__spreadProps(__spreadValues({}, this._def), {
      maxSize: { value: maxSize, message: errorUtil.toString(message) }
    }));
  }
  size(size, message) {
    return this.min(size, message).max(size, message);
  }
  nonempty(message) {
    return this.min(1, message);
  }
};
ZodSet.create = (valueType, params) => {
  return new ZodSet(__spreadValues({
    valueType,
    minSize: null,
    maxSize: null,
    typeName: ZodFirstPartyTypeKind.ZodSet
  }, processCreateParams(params)));
};
var ZodFunction = class _ZodFunction extends ZodType {
  constructor() {
    super(...arguments);
    this.validate = this.implement;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.function) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: ctx.parsedType
      });
      return INVALID;
    }
    function makeArgsIssue(args, error) {
      return makeIssue({
        data: args,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: error
        }
      });
    }
    function makeReturnsIssue(returns, error) {
      return makeIssue({
        data: returns,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: error
        }
      });
    }
    const params = { errorMap: ctx.common.contextualErrorMap };
    const fn = ctx.data;
    if (this._def.returns instanceof ZodPromise) {
      const me = this;
      return OK(function(...args) {
        return __async(this, null, function* () {
          const error = new ZodError([]);
          const parsedArgs = yield me._def.args.parseAsync(args, params).catch((e) => {
            error.addIssue(makeArgsIssue(args, e));
            throw error;
          });
          const result = yield Reflect.apply(fn, this, parsedArgs);
          const parsedReturns = yield me._def.returns._def.type.parseAsync(result, params).catch((e) => {
            error.addIssue(makeReturnsIssue(result, e));
            throw error;
          });
          return parsedReturns;
        });
      });
    } else {
      const me = this;
      return OK(function(...args) {
        const parsedArgs = me._def.args.safeParse(args, params);
        if (!parsedArgs.success) {
          throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
        }
        const result = Reflect.apply(fn, this, parsedArgs.data);
        const parsedReturns = me._def.returns.safeParse(result, params);
        if (!parsedReturns.success) {
          throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
        }
        return parsedReturns.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...items) {
    return new _ZodFunction(__spreadProps(__spreadValues({}, this._def), {
      args: ZodTuple.create(items).rest(ZodUnknown.create())
    }));
  }
  returns(returnType) {
    return new _ZodFunction(__spreadProps(__spreadValues({}, this._def), {
      returns: returnType
    }));
  }
  implement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  strictImplement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  static create(args, returns, params) {
    return new _ZodFunction(__spreadValues({
      args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: returns || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction
    }, processCreateParams(params)));
  }
};
var ZodLazy = class extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const lazySchema = this._def.getter();
    return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
  }
};
ZodLazy.create = (getter, params) => {
  return new ZodLazy(__spreadValues({
    getter,
    typeName: ZodFirstPartyTypeKind.ZodLazy
  }, processCreateParams(params)));
};
var ZodLiteral = class extends ZodType {
  _parse(input) {
    if (input.data !== this._def.value) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
  get value() {
    return this._def.value;
  }
};
ZodLiteral.create = (value, params) => {
  return new ZodLiteral(__spreadValues({
    value,
    typeName: ZodFirstPartyTypeKind.ZodLiteral
  }, processCreateParams(params)));
};
function createZodEnum(values, params) {
  return new ZodEnum(__spreadValues({
    values,
    typeName: ZodFirstPartyTypeKind.ZodEnum
  }, processCreateParams(params)));
}
var ZodEnum = class _ZodEnum extends ZodType {
  _parse(input) {
    if (typeof input.data !== "string") {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (this._def.values.indexOf(input.data) === -1) {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Values() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  extract(values) {
    return _ZodEnum.create(values);
  }
  exclude(values) {
    return _ZodEnum.create(this.options.filter((opt) => !values.includes(opt)));
  }
};
ZodEnum.create = createZodEnum;
var ZodNativeEnum = class extends ZodType {
  _parse(input) {
    const nativeEnumValues = util.getValidEnumValues(this._def.values);
    const ctx = this._getOrReturnCtx(input);
    if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (nativeEnumValues.indexOf(input.data) === -1) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get enum() {
    return this._def.values;
  }
};
ZodNativeEnum.create = (values, params) => {
  return new ZodNativeEnum(__spreadValues({
    values,
    typeName: ZodFirstPartyTypeKind.ZodNativeEnum
  }, processCreateParams(params)));
};
var ZodPromise = class extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
    return OK(promisified.then((data) => {
      return this._def.type.parseAsync(data, {
        path: ctx.path,
        errorMap: ctx.common.contextualErrorMap
      });
    }));
  }
};
ZodPromise.create = (schema, params) => {
  return new ZodPromise(__spreadValues({
    type: schema,
    typeName: ZodFirstPartyTypeKind.ZodPromise
  }, processCreateParams(params)));
};
var ZodEffects = class extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const effect = this._def.effect || null;
    const checkCtx = {
      addIssue: (arg) => {
        addIssueToContext(ctx, arg);
        if (arg.fatal) {
          status.abort();
        } else {
          status.dirty();
        }
      },
      get path() {
        return ctx.path;
      }
    };
    checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
    if (effect.type === "preprocess") {
      const processed = effect.transform(ctx.data, checkCtx);
      if (ctx.common.issues.length) {
        return {
          status: "dirty",
          value: ctx.data
        };
      }
      if (ctx.common.async) {
        return Promise.resolve(processed).then((processed2) => {
          return this._def.schema._parseAsync({
            data: processed2,
            path: ctx.path,
            parent: ctx
          });
        });
      } else {
        return this._def.schema._parseSync({
          data: processed,
          path: ctx.path,
          parent: ctx
        });
      }
    }
    if (effect.type === "refinement") {
      const executeRefinement = (acc) => {
        const result = effect.refinement(acc, checkCtx);
        if (ctx.common.async) {
          return Promise.resolve(result);
        }
        if (result instanceof Promise) {
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        }
        return acc;
      };
      if (ctx.common.async === false) {
        const inner = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inner.status === "aborted")
          return INVALID;
        if (inner.status === "dirty")
          status.dirty();
        executeRefinement(inner.value);
        return { status: status.value, value: inner.value };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((inner) => {
          if (inner.status === "aborted")
            return INVALID;
          if (inner.status === "dirty")
            status.dirty();
          return executeRefinement(inner.value).then(() => {
            return { status: status.value, value: inner.value };
          });
        });
      }
    }
    if (effect.type === "transform") {
      if (ctx.common.async === false) {
        const base = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (!isValid(base))
          return base;
        const result = effect.transform(base.value, checkCtx);
        if (result instanceof Promise) {
          throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
        }
        return { status: status.value, value: result };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((base) => {
          if (!isValid(base))
            return base;
          return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
        });
      }
    }
    util.assertNever(effect);
  }
};
ZodEffects.create = (schema, effect, params) => {
  return new ZodEffects(__spreadValues({
    schema,
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    effect
  }, processCreateParams(params)));
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
  return new ZodEffects(__spreadValues({
    schema,
    effect: { type: "preprocess", transform: preprocess },
    typeName: ZodFirstPartyTypeKind.ZodEffects
  }, processCreateParams(params)));
};
var ZodOptional = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.undefined) {
      return OK(void 0);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodOptional.create = (type, params) => {
  return new ZodOptional(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional
  }, processCreateParams(params)));
};
var ZodNullable = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.null) {
      return OK(null);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodNullable.create = (type, params) => {
  return new ZodNullable(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodNullable
  }, processCreateParams(params)));
};
var ZodDefault = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    let data = ctx.data;
    if (ctx.parsedType === ZodParsedType.undefined) {
      data = this._def.defaultValue();
    }
    return this._def.innerType._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
ZodDefault.create = (type, params) => {
  return new ZodDefault(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodDefault,
    defaultValue: typeof params.default === "function" ? params.default : () => params.default
  }, processCreateParams(params)));
};
var ZodCatch = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const newCtx = __spreadProps(__spreadValues({}, ctx), {
      common: __spreadProps(__spreadValues({}, ctx.common), {
        issues: []
      })
    });
    const result = this._def.innerType._parse({
      data: newCtx.data,
      path: newCtx.path,
      parent: __spreadValues({}, newCtx)
    });
    if (isAsync(result)) {
      return result.then((result2) => {
        return {
          status: "valid",
          value: result2.status === "valid" ? result2.value : this._def.catchValue({
            get error() {
              return new ZodError(newCtx.common.issues);
            },
            input: newCtx.data
          })
        };
      });
    } else {
      return {
        status: "valid",
        value: result.status === "valid" ? result.value : this._def.catchValue({
          get error() {
            return new ZodError(newCtx.common.issues);
          },
          input: newCtx.data
        })
      };
    }
  }
  removeCatch() {
    return this._def.innerType;
  }
};
ZodCatch.create = (type, params) => {
  return new ZodCatch(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodCatch,
    catchValue: typeof params.catch === "function" ? params.catch : () => params.catch
  }, processCreateParams(params)));
};
var ZodNaN = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.nan) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
};
ZodNaN.create = (params) => {
  return new ZodNaN(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodNaN
  }, processCreateParams(params)));
};
var BRAND = Symbol("zod_brand");
var ZodBranded = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const data = ctx.data;
    return this._def.type._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  unwrap() {
    return this._def.type;
  }
};
var ZodPipeline = class _ZodPipeline extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.common.async) {
      const handleAsync = () => __async(this, null, function* () {
        const inResult = yield this._def.in._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inResult.status === "aborted")
          return INVALID;
        if (inResult.status === "dirty") {
          status.dirty();
          return DIRTY(inResult.value);
        } else {
          return this._def.out._parseAsync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx
          });
        }
      });
      return handleAsync();
    } else {
      const inResult = this._def.in._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
      if (inResult.status === "aborted")
        return INVALID;
      if (inResult.status === "dirty") {
        status.dirty();
        return {
          status: "dirty",
          value: inResult.value
        };
      } else {
        return this._def.out._parseSync({
          data: inResult.value,
          path: ctx.path,
          parent: ctx
        });
      }
    }
  }
  static create(a, b) {
    return new _ZodPipeline({
      in: a,
      out: b,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
};
var ZodReadonly = class extends ZodType {
  _parse(input) {
    const result = this._def.innerType._parse(input);
    if (isValid(result)) {
      result.value = Object.freeze(result.value);
    }
    return result;
  }
};
ZodReadonly.create = (type, params) => {
  return new ZodReadonly(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodReadonly
  }, processCreateParams(params)));
};
var custom = (check, params = {}, fatal) => {
  if (check)
    return ZodAny.create().superRefine((data, ctx) => {
      var _a, _b;
      if (!check(data)) {
        const p = typeof params === "function" ? params(data) : typeof params === "string" ? { message: params } : params;
        const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
        const p2 = typeof p === "string" ? { message: p } : p;
        ctx.addIssue(__spreadProps(__spreadValues({ code: "custom" }, p2), { fatal: _fatal }));
      }
    });
  return ZodAny.create();
};
var late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind2) {
  ZodFirstPartyTypeKind2["ZodString"] = "ZodString";
  ZodFirstPartyTypeKind2["ZodNumber"] = "ZodNumber";
  ZodFirstPartyTypeKind2["ZodNaN"] = "ZodNaN";
  ZodFirstPartyTypeKind2["ZodBigInt"] = "ZodBigInt";
  ZodFirstPartyTypeKind2["ZodBoolean"] = "ZodBoolean";
  ZodFirstPartyTypeKind2["ZodDate"] = "ZodDate";
  ZodFirstPartyTypeKind2["ZodSymbol"] = "ZodSymbol";
  ZodFirstPartyTypeKind2["ZodUndefined"] = "ZodUndefined";
  ZodFirstPartyTypeKind2["ZodNull"] = "ZodNull";
  ZodFirstPartyTypeKind2["ZodAny"] = "ZodAny";
  ZodFirstPartyTypeKind2["ZodUnknown"] = "ZodUnknown";
  ZodFirstPartyTypeKind2["ZodNever"] = "ZodNever";
  ZodFirstPartyTypeKind2["ZodVoid"] = "ZodVoid";
  ZodFirstPartyTypeKind2["ZodArray"] = "ZodArray";
  ZodFirstPartyTypeKind2["ZodObject"] = "ZodObject";
  ZodFirstPartyTypeKind2["ZodUnion"] = "ZodUnion";
  ZodFirstPartyTypeKind2["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
  ZodFirstPartyTypeKind2["ZodIntersection"] = "ZodIntersection";
  ZodFirstPartyTypeKind2["ZodTuple"] = "ZodTuple";
  ZodFirstPartyTypeKind2["ZodRecord"] = "ZodRecord";
  ZodFirstPartyTypeKind2["ZodMap"] = "ZodMap";
  ZodFirstPartyTypeKind2["ZodSet"] = "ZodSet";
  ZodFirstPartyTypeKind2["ZodFunction"] = "ZodFunction";
  ZodFirstPartyTypeKind2["ZodLazy"] = "ZodLazy";
  ZodFirstPartyTypeKind2["ZodLiteral"] = "ZodLiteral";
  ZodFirstPartyTypeKind2["ZodEnum"] = "ZodEnum";
  ZodFirstPartyTypeKind2["ZodEffects"] = "ZodEffects";
  ZodFirstPartyTypeKind2["ZodNativeEnum"] = "ZodNativeEnum";
  ZodFirstPartyTypeKind2["ZodOptional"] = "ZodOptional";
  ZodFirstPartyTypeKind2["ZodNullable"] = "ZodNullable";
  ZodFirstPartyTypeKind2["ZodDefault"] = "ZodDefault";
  ZodFirstPartyTypeKind2["ZodCatch"] = "ZodCatch";
  ZodFirstPartyTypeKind2["ZodPromise"] = "ZodPromise";
  ZodFirstPartyTypeKind2["ZodBranded"] = "ZodBranded";
  ZodFirstPartyTypeKind2["ZodPipeline"] = "ZodPipeline";
  ZodFirstPartyTypeKind2["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
var instanceOfType = (cls, params = {
  message: `Input not instance of ${cls.name}`
}) => custom((data) => data instanceof cls, params);
var stringType = ZodString.create;
var numberType = ZodNumber.create;
var nanType = ZodNaN.create;
var bigIntType = ZodBigInt.create;
var booleanType = ZodBoolean.create;
var dateType = ZodDate.create;
var symbolType = ZodSymbol.create;
var undefinedType = ZodUndefined.create;
var nullType = ZodNull.create;
var anyType = ZodAny.create;
var unknownType = ZodUnknown.create;
var neverType = ZodNever.create;
var voidType = ZodVoid.create;
var arrayType = ZodArray.create;
var objectType = ZodObject.create;
var strictObjectType = ZodObject.strictCreate;
var unionType = ZodUnion.create;
var discriminatedUnionType = ZodDiscriminatedUnion.create;
var intersectionType = ZodIntersection.create;
var tupleType = ZodTuple.create;
var recordType = ZodRecord.create;
var mapType = ZodMap.create;
var setType = ZodSet.create;
var functionType = ZodFunction.create;
var lazyType = ZodLazy.create;
var literalType = ZodLiteral.create;
var enumType = ZodEnum.create;
var nativeEnumType = ZodNativeEnum.create;
var promiseType = ZodPromise.create;
var effectsType = ZodEffects.create;
var optionalType = ZodOptional.create;
var nullableType = ZodNullable.create;
var preprocessType = ZodEffects.createWithPreprocess;
var pipelineType = ZodPipeline.create;
var ostring = () => stringType().optional();
var onumber = () => numberType().optional();
var oboolean = () => booleanType().optional();
var coerce = {
  string: (arg) => ZodString.create(__spreadProps(__spreadValues({}, arg), { coerce: true })),
  number: (arg) => ZodNumber.create(__spreadProps(__spreadValues({}, arg), { coerce: true })),
  boolean: (arg) => ZodBoolean.create(__spreadProps(__spreadValues({}, arg), {
    coerce: true
  })),
  bigint: (arg) => ZodBigInt.create(__spreadProps(__spreadValues({}, arg), { coerce: true })),
  date: (arg) => ZodDate.create(__spreadProps(__spreadValues({}, arg), { coerce: true }))
};
var NEVER = INVALID;
var z = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: errorMap,
  setErrorMap,
  getErrorMap,
  makeIssue,
  EMPTY_PATH,
  addIssueToContext,
  ParseStatus,
  INVALID,
  DIRTY,
  OK,
  isAborted,
  isDirty,
  isValid,
  isAsync,
  get util() {
    return util;
  },
  get objectUtil() {
    return objectUtil;
  },
  ZodParsedType,
  getParsedType,
  ZodType,
  ZodString,
  ZodNumber,
  ZodBigInt,
  ZodBoolean,
  ZodDate,
  ZodSymbol,
  ZodUndefined,
  ZodNull,
  ZodAny,
  ZodUnknown,
  ZodNever,
  ZodVoid,
  ZodArray,
  ZodObject,
  ZodUnion,
  ZodDiscriminatedUnion,
  ZodIntersection,
  ZodTuple,
  ZodRecord,
  ZodMap,
  ZodSet,
  ZodFunction,
  ZodLazy,
  ZodLiteral,
  ZodEnum,
  ZodNativeEnum,
  ZodPromise,
  ZodEffects,
  ZodTransformer: ZodEffects,
  ZodOptional,
  ZodNullable,
  ZodDefault,
  ZodCatch,
  ZodNaN,
  BRAND,
  ZodBranded,
  ZodPipeline,
  ZodReadonly,
  custom,
  Schema: ZodType,
  ZodSchema: ZodType,
  late,
  get ZodFirstPartyTypeKind() {
    return ZodFirstPartyTypeKind;
  },
  coerce,
  any: anyType,
  array: arrayType,
  bigint: bigIntType,
  boolean: booleanType,
  date: dateType,
  discriminatedUnion: discriminatedUnionType,
  effect: effectsType,
  "enum": enumType,
  "function": functionType,
  "instanceof": instanceOfType,
  intersection: intersectionType,
  lazy: lazyType,
  literal: literalType,
  map: mapType,
  nan: nanType,
  nativeEnum: nativeEnumType,
  never: neverType,
  "null": nullType,
  nullable: nullableType,
  number: numberType,
  object: objectType,
  oboolean,
  onumber,
  optional: optionalType,
  ostring,
  pipeline: pipelineType,
  preprocess: preprocessType,
  promise: promiseType,
  record: recordType,
  set: setType,
  strictObject: strictObjectType,
  string: stringType,
  symbol: symbolType,
  transformer: effectsType,
  tuple: tupleType,
  "undefined": undefinedType,
  union: unionType,
  unknown: unknownType,
  "void": voidType,
  NEVER,
  ZodIssueCode,
  quotelessJson,
  ZodError
});

// src/v4/api/menu.models.ts
var CALS_IDENTIFIER = "Cals";
var menuProductOption = z.lazy(
  () => z.object({
    /** Allergens associated with this option. */
    allergens: z.optional(allergenItem.passthrough().array()),
    /** Visual separator for the calorie range. Eg: `-`.  */
    calories_separator: z.string().nullable(),
    /** The number of calories for this option. */
    calories: z.number().nullable(),
    /** Option cost. */
    cost: z.number(),
    /** Option description. */
    description: z.optional(z.nullable(z.string())),
    /** Can this option be selected? */
    enabled: z.optional(z.boolean()),
    /** The Option's ID across all locations. */
    global_option_id: z.string(),
    /** Option ID unique to a single location. */
    id: z.string(),
    /** Display images for this option. */
    images: z.nullable(menuProductImages.passthrough()),
    /** Is the option currently available for purchase? */
    is_available: z.boolean(),
    /** Is this the default option for its group? */
    is_default: z.boolean(),
    /**
     * If a product is inverted, then options are pre-selected and the
     * product is customized by removing options.
     */
    is_inverted: z.optional(z.boolean()),
    /** Warning labels for this option. */
    labels: menuProductLabel.passthrough().array(),
    /** Max calories for this option. */
    max_calories: z.nullable(z.number()),
    /** Alternative name for inverted products. Eg: `Remove {x}` */
    name_inverted: z.optional(z.nullable(z.string())),
    /** Option name. */
    name: z.string(),
    /** Any sub-groups that this option contains. */
    option_groups: menuProductOptionGroup.passthrough().array(),
    /** How many of this option has the user selected? */
    quantity: z.optional(z.number()),
    /** Is this option selected? */
    selected: z.optional(z.boolean()),
    is_max_selections_reached: z.optional(z.boolean()),
    contains_adv_nested_modifiers: z.optional(z.boolean())
  })
);
var allergenItem = z.object({
  /** Allergen ID. */
  id: z.number(),
  /** Name. Eg: "Tree Nut Allergy" */
  label: z.string(),
  /** @TODO what does this property mean? */
  is_removal: z.boolean()
}).passthrough();
var existingOption = z.object({
  /** Option ID. */
  id: z.string(),
  /** Option quantity. */
  quantity: z.number(),
  cost: z.optional(z.number()),
  /** The Option's ID across all locations. */
  global_option_id: z.optional(z.string()),
  /** Option name. */
  name: z.optional(z.string())
});
var tagItem = z.object({
  /** @TODO what is this value? */
  background_color: z.optional(z.string()),
  /** @TODO what is this value? */
  icon_image_url: z.optional(z.nullable(z.string())),
  /** Category ID. */
  id: z.number(),
  /** Category name. */
  label: z.string(),
  /** ID of the organization this belongs to. */
  organization_id: z.optional(z.number()),
  /** @TODO what is this value? */
  text_color: z.optional(z.string()),
  /** Marketing tags are visual additions, but filter tags change how the menu is displayed. */
  type: z.union([z.literal("marketing"), z.literal("filter")]),
  /** This property is responsible for suppressing the label value
   * from the marketing tag rendered on the menu and leads to surfacing only the image.
   */
  hide_label: z.boolean()
}).passthrough();
var menuProductImages = z.object({
  image_url_1_by_1: z.nullable(z.string())
});
var menuProductLabel = z.object({
  /** Full legal warning text. */
  description: z.string(),
  /** Alt text for the label image. */
  image_description: z.string(),
  /** Warning label image URL. */
  image_url: z.string(),
  /** Name of the warning. Eg: `Sodium - NY`. */
  name: z.string()
});
var menuProductOptionGroup = z.object({
  /** If quantity selection is enabled, how much should it increment? */
  choice_quantity_increment: z.number(),
  /* Text description. */
  description: z.string(),
  /** @TODO how does this differ from `description`? */
  explanation_text: z.nullable(z.string()),
  /** The Group's ID across all locations. */
  global_id: z.string(),
  /** Group ID unique to a single location. */
  id: z.string(),
  /** Is this group hidden? */
  is_hidden: z.boolean(),
  /**
   * Total combined quantity of options that can be selected in this group.
   * Eg: Dipping sauces. Make 30 selections from up to 2 options.
   */
  max_aggregate_quantity: z.nullable(z.number()),
  /** The maximum selectable quantity for any one option. */
  max_choice_quantity: z.nullable(z.number()),
  /** The maximum number of selections that can be made from this group. */
  max_selections: z.nullable(z.number()),
  /** Minimum combined quantity of options that can be selected in this group.  */
  min_aggregate_quantity: z.nullable(z.number()),
  /** Minimum valid option quantity. */
  min_choice_quantity: z.nullable(z.number()),
  /** The minimum required selections from this group. */
  min_selections: z.nullable(z.number()),
  /** The customization options in this group. */
  options: menuProductOption.array(),
  /** Global ID of the parent product or option. */
  parent_global_id: z.optional(z.nullable(z.string())),
  /** Is an option from this group required for the product to be valid? */
  requires_user_selection: z.boolean(),
  /** Can multiples of an option be selected? */
  supports_quantity_selection: z.boolean(),
  /** Is the current selection state valid? */
  valid: z.optional(z.boolean()),
  /** When sum of all option quantities are equal to greater than max_aggregate_quantity this property is set to true and the opposite */
  is_max_aggregate_quantity_reached: z.optional(z.boolean()),
  /** Contains current sum of all option quantities of the current option group*/
  total_aggregate_quantity: z.optional(z.number()),
  /** If the group is options of advanced nested modifiers */
  is_adv_nested_modifier: z.optional(z.boolean())
});
var menuProductResponse = z.object({
  /** Allergens associated with this product. */
  allergens: allergenItem.passthrough().array(),
  /** Visual separator for the calorie range. Eg: `-`.  */
  calories_separator: z.string().nullable(),
  /** Calories for the base product. */
  calories: z.nullable(z.number()),
  /** Cost for the base product. */
  cost: z.number(),
  /** Text description. */
  description: z.string(),
  /** The master category that this product belongs to. */
  filter_tags: z.nullable(tagItem.passthrough().array()),
  /** Total calories for the product plus all customizations. */
  final_calories: z.optional(z.number()),
  /** Total cost for the product plus all customizations. */
  final_cost: z.optional(z.number()),
  /** The Product's ID across all locations. */
  global_id: z.string(),
  /** Product ID unique to a single location. */
  id: z.string(),
  /** Main product image. */
  image: z.nullable(z.string()),
  /** Full set of product images in multiple aspect ratios. */
  images: menuProductImages.passthrough(),
  /** Warning labels for this product. */
  labels: menuProductLabel.passthrough().array(),
  /** A list of tags associated with this product. */
  marketing_tags: z.nullable(tagItem.passthrough().array()),
  /** Max calories for customizable options. */
  max_calories: z.nullable(z.number()),
  /** Maximum quantity that can be ordered. */
  max_quantity: z.nullable(z.number()),
  /** Minimum quantity that can be ordered. */
  min_quantity: z.nullable(z.number()),
  /** How much to increment the quantity by when using quantity controls. */
  quantity_increment: z.nullable(z.number()),
  /** @TODO what is this value? */
  meta_data: z.nullable(z.record(z.unknown())),
  /** Product name. */
  name: z.string(),
  /** @TODO what is this value? */
  options: z.optional(existingOption.passthrough().array()),
  /** Customizable product options. */
  option_groups: menuProductOptionGroup.passthrough().array(),
  /** Visible option groups added by the Customizer. @TODO remove from this model. */
  surfaceable_option_groups: z.optional(
    menuProductOptionGroup.passthrough().array()
  ),
  /** Are all selected customizations valid? */
  valid_customization: z.optional(z.boolean())
});
var categoryResponse = z.object({
  /** Text description of the category's products. */
  description: z.string(),
  /** The Product's ID across all locations. */
  global_id: z.nullable(z.string()),
  /** @TODO what is this value? */
  icon: z.null(),
  /**
   * Category ID.
   * @TODO determine why this could be either a string or a number.
   */
  id: z.union([z.string(), z.number()]),
  /** Should this category be hidden from users? */
  is_hidden: z.boolean(),
  /** Category name. Eg: `Sandwiches`. */
  name: z.string(),
  /** Products in this category. */
  products: menuProductResponse.passthrough().array(),
  /** Category name. Eg: `Sandwiches`. @TODO duplicate of `name`? */
  type: z.string().nullable()
});
var menuResponse = z.object({
  categories: categoryResponse.passthrough().array()
});
var menuProduct = menuProductResponse.extend({
  /** Min and max calories for customizable products. Eg: `300-700 cals`. */
  calorie_range: z.string(),
  /** Calorie units label. Eg: `Cals`. */
  calsIdentifier: z.string(),
  /** Can this product be customized? */
  customizable: z.boolean(),
  /** Options supported by this product. */
  options: existingOption.passthrough().array(),
  /** Formatted number of calories. Eg: `700 cals`. */
  pretty_calories: z.string(),
  /** Formatted price. Eg: `$12.99`. */
  pretty_price: z.nullable(z.string()),
  /** Warning labels for this product. */
  warningLabels: z.optional(menuProductLabel.passthrough().array())
});
var category = categoryResponse.extend({
  products: menuProduct.passthrough().array()
});
var menu = menuResponse.extend({
  categories: category.passthrough().array()
});
var menuProductWithCategory = menuProduct.extend({
  category
});

// src/utils/menu.helpers.ts
var objectifyOptionsProductLevel = (product) => {
  const productOptionsDictionary = {};
  const iterateThroughOptionGroup = (option_groups) => {
    option_groups.forEach((optionGroup) => {
      optionGroup.options.forEach((option) => {
        productOptionsDictionary[option.id] = option;
        if (option.option_groups.length) {
          iterateThroughOptionGroup(option.option_groups);
        }
      });
    });
  };
  iterateThroughOptionGroup(product.option_groups);
  return productOptionsDictionary;
};
var objectifyOptionsMenuLevel = (menuCategories) => {
  const menuOptionsDictionary = {};
  menuCategories.forEach((category2) => {
    category2.products.forEach((product) => {
      const productLevelOptions = objectifyOptionsProductLevel(product);
      if (Object.keys(productLevelOptions).length) {
        (0, import_merge.default)(menuOptionsDictionary, productLevelOptions);
      }
    });
  });
  return menuOptionsDictionary;
};
var calculateIncrementor = (option, optionGroup) => {
  return option.quantity > 0 || !optionGroup.min_choice_quantity ? optionGroup.choice_quantity_increment || 1 : optionGroup.min_choice_quantity || 1;
};
var findMenuItemById = (itemId, menuCategories) => {
  let product;
  menuCategories.forEach((category2) => {
    category2.products.forEach((menuProduct2) => {
      if (menuProduct2.id === itemId) {
        product = Object.assign({}, menuProduct2, {
          category: category2
        });
        return false;
      }
      return;
    });
    if (product && product.id) {
      return false;
    }
    return;
  });
  return product;
};
var findProductCategory = (productId, menuCategories) => {
  if (!productId) {
    return null;
  }
  let categoryObject = null;
  menuCategories.forEach((category2) => {
    category2.products.forEach((product) => {
      if (product.id === productId) {
        categoryObject = category2;
      }
    });
  });
  return categoryObject;
};
var findProductCategoryId = (productId, menuCategories) => {
  var _a;
  if (!productId) {
    return null;
  }
  return ((_a = findProductCategory(productId, menuCategories)) == null ? void 0 : _a.id) || null;
};
var createMenuProductDictionary = (categories, isFoodHall) => {
  const productDictionary = {};
  categories.forEach((category2) => {
    category2.products.forEach((product) => {
      var _a;
      if (isFoodHall && ((_a = product.filter_tags) == null ? void 0 : _a.length) === 0) {
        return;
      }
      productDictionary[product.name] = { product, category: category2 };
    });
  });
  return Object.values(productDictionary);
};
var findFuzzyMenuMatches = (productDictionary, searchString) => {
  const fuse = new Fuse(productDictionary, {
    keys: ["product.name", "product.description"],
    threshold: 0.4
  });
  return fuse.search(searchString);
};
function prettyPrice(product) {
  const optionsCost = calculateOptionsPrice(product.option_groups, 0);
  const prettyPrice2 = product.cost + optionsCost;
  return prettyPrice2 === 0 ? null : `$${(prettyPrice2 / 100).toFixed(2)}`;
}
function calculateOptionsPrice(option_groups, optionsPrice) {
  option_groups.map((group) => {
    if (group.min_selections && group.min_selections > 0) {
      optionsPrice += group.options.filter((option) => option.is_default).reduce((total, defaultOption) => {
        total += defaultOption.cost;
        if (defaultOption == null ? void 0 : defaultOption.option_groups.length) {
          total = calculateOptionsPrice(defaultOption.option_groups, total);
        }
        return total;
      }, 0);
    }
  });
  return optionsPrice;
}
function deriveProductWarningLabels(product) {
  var _a;
  let labels = {};
  if (((_a = product.labels) == null ? void 0 : _a.length) > 0) {
    product.labels.forEach((label) => {
      labels[label.name] = label;
    });
  }
  const recursivelyFilterLabels = (option_groups, labels2) => {
    option_groups.forEach((group) => {
      group.options.forEach((option) => {
        var _a2, _b;
        if (((_a2 = option.labels) == null ? void 0 : _a2.length) > 0) {
          option.labels.forEach((label) => {
            labels2[label.name] = label;
          });
        }
        if (((_b = option.option_groups) == null ? void 0 : _b.length) > 0) {
          recursivelyFilterLabels(option.option_groups, labels2);
        }
      });
    });
    return labels2;
  };
  labels = recursivelyFilterLabels(product.option_groups, labels);
  return Object.values(labels);
}
function deriveCalorieRange(product) {
  if (product.calories !== null && product.calories_separator !== null && product.max_calories !== null) {
    return `${product.calories}${product.calories_separator}${product.max_calories} ${CALS_IDENTIFIER}`;
  }
  return "";
}
function prettyCalories(product) {
  const calorieRange = deriveCalorieRange(product);
  if (calorieRange) {
    return calorieRange;
  }
  if (typeof product.calories === "number") {
    return `${product.calories} ${CALS_IDENTIFIER}`;
  }
  return "";
}
function isCustomizable(product) {
  var _a;
  return ((_a = product.option_groups) == null ? void 0 : _a.length) >= 1;
}
function slugName(category2) {
  let slug = category2.name.toLowerCase().trim();
  const from = "\xE0\xE1\xE3\xE4\xE2\xE8\xE9\xEB\xEA\xEC\xED\xEF\xEE\xF2\xF3\xF6\xF4\xF9\xFA\xFC\xFB\xF1\xE7";
  const to = "aaaaaeeeeiiiioooouuuunc";
  for (let i = 0, l = from.length; i < l; i++) {
    slug = slug.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
  }
  return slug.replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-").replace(/^-|-$/g, "");
}
function augmentMenuProduct(product) {
  return __spreadProps(__spreadValues({}, product), {
    calorie_range: deriveCalorieRange(product),
    calsIdentifier: CALS_IDENTIFIER,
    customizable: isCustomizable(product),
    pretty_calories: prettyCalories(product),
    pretty_price: prettyPrice(product),
    warningLabels: deriveProductWarningLabels(product)
  });
}

// src/utils/service.helpers.ts

function decompressBinaryContent(compressedData) {
  try {
    const uncompressed = (0,pako_esm/* inflate */.rr)(compressedData, { to: "string" });
    return JSON.parse(uncompressed);
  } catch (e) {
    console.error("Failed to decompress binary content.");
    throw e;
  }
}

// src/storage/menu.storage.ts
var MenuStorage = class {
  constructor(storage, key = LOCAL_STORAGE_KEYS.MENU) {
    this.key = key;
    this.storage = storage;
  }
  set(menu2) {
    this.storage.set(this.key, menu2);
  }
  get() {
    try {
      const parsedMenu = this.storage.get(this.key) || [];
      if (parsedMenu.compressed) {
        const response = decompressBinaryContent(
          parsedMenu.categories
        );
        const computedCategories = response.data.categories.map((category2) => __spreadProps(__spreadValues({}, category2), {
          products: category2.products.map(
            (product) => augmentMenuProduct(product)
          )
        }));
        return computedCategories;
      } else if (parsedMenu.compressed === false) {
        return parsedMenu.categories;
      }
      return parsedMenu;
    } catch (err) {
      console.error(err);
      return [];
    }
  }
};

// src/types/errors/basket-errors.ts
var UpdateBasketError = new Error(
  "Basket retrieved from storage or data provided to be updated is malformed. Please ensure it is valid."
);
var MenuGetError = new Error("Menu Local Storage key is missing.");
var LocationGetError = new Error(
  "Location Local Storage key is missing."
);
var LocalStorageNull = new Error(
  "Basket Local Storage  key is missing"
);
var InvalidIndex = new Error("The index provided is not valid.");
var ReplaceBasketItemInvalid = new Error(
  "For replaceItem method, the basketItem you want to replace with is not valid."
);
var InvalidQuantity = new Error(
  "Invalid quantity. Must be at least 1"
);
var MenuRequired = new Error("Menu is is required to create basket");
var LocationRequired = new Error(
  "Location is required to create basket"
);
var InvalidBasket = new Error("Basket you provided is not valid.");
var ErrorGettingLocation = new Error(
  "Error getting location from storage"
);

// src/utils/basket.helpers.ts
var filterAvailableItems = (order2, categories) => {
  if (!order2.location.id) {
    throw LocationGetError;
  }
  if (categories.length <= 0) {
    throw MenuGetError;
  }
  const availableBasketItems = order2.basket_items.filter((basketItem3) => {
    return findMenuItemById(basketItem3.product.id, categories);
  });
  if (availableBasketItems.length <= 0) {
    throw InvalidBasket;
  }
  availableBasketItems.forEach((basketItem3) => {
    const productCategory = findProductCategory(
      basketItem3.product.id,
      categories
    );
    basketItem3.product.cross_sell_id = null;
    basketItem3.product.category_id = (productCategory == null ? void 0 : productCategory.global_id) || null;
    basketItem3.product.category_label = (productCategory == null ? void 0 : productCategory.name) || null;
  });
  return availableBasketItems;
};

// src/utils/generic.storage.ts
var InMemoryStorage = class {
  constructor() {
    this.length = 0;
    this.storage = {};
  }
  getItem(key) {
    return this.storage[key];
  }
  setItem(key, value) {
    this.storage[key] = value;
  }
  removeItem(key) {
    delete this.storage[key];
    return;
  }
  clear() {
    this.storage = {};
  }
};
var GenericStorage = class {
  constructor() {
    try {
      this.storage = localStorage;
    } catch (e) {
      this.storage = new InMemoryStorage();
    }
  }
  /**
   * Returns the value for the given key or null if the key does not exist.
   */
  get(key) {
    try {
      const value = this.storage.getItem(key);
      if (value === null) {
        return null;
      }
      return JSON.parse(value);
    } catch (err) {
      return null;
    }
  }
  /**
   * Adds the key to storage with the given value, if the key
   * already exists the value for that key will be updated.
   */
  set(key, value) {
    try {
      this.storage.setItem(key, JSON.stringify(value));
      return true;
    } catch (err) {
      if (err instanceof Error) {
        if (err.name === "QUOTA_EXCEEDED_ERR") {
          console.error("We have exceeded the allowed storage quota");
        }
      }
      console.error(err);
      return null;
    }
  }
  /**
   * Checks if the given key exists.
   */
  has(key) {
    return this.get(key) !== null;
  }
  /**
   * Removes an item from storage.
   */
  remove(key) {
    this.storage.removeItem(key);
    return this;
  }
  /**
   * Empties the storage of all keys.
   */
  clear() {
    this.storage.clear();
    return this;
  }
  /**
   * Returns the number of data items currently in storage.
   */
  length() {
    return this.storage.length;
  }
};
var ExpiryLocalStorage = class extends GenericStorage {
  /**
   * Method to set an item with an expiry time (in milliseconds)
   * @param key
   * @param value
   * @param expiryTime - in milliseconds
   */
  set(key, value, expiryTime) {
    if (expiryTime === void 0) {
      return super.set(key, value);
    }
    const expiryDate = (/* @__PURE__ */ new Date()).getTime() + expiryTime;
    const item = {
      value,
      expiryDate
    };
    return super.set(key, item);
  }
  /**
   * Method to get an item, returning null if it has expired
   * @param key
   */
  get(key) {
    const item = super.get(key);
    if (!item) {
      return null;
    }
    const now = (/* @__PURE__ */ new Date()).getTime();
    if (now > item.expiryDate) {
      this.remove(key);
      return null;
    }
    return item.value;
  }
};

// src/constants/loyalty.ts
var PROGRAM_TYPES = /* @__PURE__ */ ((PROGRAM_TYPES2) => {
  PROGRAM_TYPES2["POINTS_CONVERT_REDEEMABLES"] = "points_convert_redeemables";
  PROGRAM_TYPES2["POINTS_CONVERT_CURRENCY"] = "points_convert_currency";
  PROGRAM_TYPES2["POINTS_CONVERT_REWARDS"] = "points_convert_rewards";
  PROGRAM_TYPES2["SP_POINTS_CONVERT_REWARDS"] = "sp_points_convert_rewards";
  return PROGRAM_TYPES2;
})(PROGRAM_TYPES || {});

// src/utils/loyalty.helpers.ts
var nextLargestRewardPointValue = (programType, loyaltyState2, myRedeemables) => {
  const sortedRedeemables = myRedeemables.sort(
    (a, b) => a.points_required > b.points_required ? 1 : -1
  );
  const { points, points_threshold } = loyaltyState2;
  switch (programType) {
    case "points_convert_redeemables" /* POINTS_CONVERT_REDEEMABLES */:
      if (!sortedRedeemables.length) {
        return 0;
      }
      const largestRedeemable = sortedRedeemables.find(
        (redeemable) => redeemable.points_required > points
      );
      if (!largestRedeemable) {
        return sortedRedeemables[sortedRedeemables.length - 1].points_required;
      }
      return largestRedeemable.points_required;
    default:
      return points_threshold;
  }
};
var calculateProgressBarWidth = (progress, base) => {
  const percentage = Math.min(1, progress / base);
  return `${percentage * 100}%`;
};

// test/__fixtures__/location.fixtures.ts
var deliveryCoverageResponseFixture = (overrides = {}) => __spreadValues({
  can_deliver: true,
  message: null
}, overrides);
var locationCachedDataFixture = (overrides = {}) => __spreadValues({
  id: "138233",
  zip: "92663",
  city: "Newport Beach",
  meta: [],
  tags: [],
  label: "Bluth's Original Frozen Banana Stand # 1",
  state: "CA",
  country: "US",
  latitude: 49.1181157,
  longitude: -122.6699885,
  is_available: true,
  phone_number: "(604) 534-5966",
  street_address: "110 Marine Ave",
  utc_offset: 0,
  card_types: []
}, overrides);
var locationOperatingHoursFixture = (overrides = {}) => __spreadValues({
  created_at: "2022-04-12T00:08:52+00:00",
  day_of_week: "Saturday",
  end: "2022-04-10T05:00:00+00:00",
  id: "1f3abb19-985f-47f6-9845-d0fe0eb4d732",
  start: "2022-04-09T17:00:00+00:00",
  store_location_id: 8687,
  type: "operating_hours",
  updated_at: "2022-04-12T00:08:52+00:00"
}, overrides);
var locationFixture = (overrides = {}) => __spreadValues({
  attributes: [],
  card_types: [],
  distance_miles: 0,
  id: 8687,
  created_at: "2022-03-07T18:52:07+00:00",
  updated_at: "2022-04-12T23:07:01+00:00",
  deleted_at: null,
  delivery_minimum: null,
  organization_id: 54,
  brand_id: "1",
  location_id: "138233",
  label: "Bluth's Original Frozen Banana Stand # 1",
  slug: "banana-stand-1",
  status_id: 4,
  latitude: 49.1181157,
  longitude: -122.6699885,
  synced_at: "2022-03-23T13:00:22+00:00",
  cached_data: locationCachedDataFixture(),
  state_id: 0,
  supports_drive_in: false,
  zip_code: "92663",
  street_address: "110 Marine Ave",
  city: "Newport Beach",
  country: "US",
  provider_enabled: true,
  image_url_1_by_1: "",
  phone_number: "(604) 534-5966",
  order_asap: true,
  supports_curbside: false,
  supports_delivery: false,
  supports_drive_thru: false,
  supports_pick_up: true,
  supports_to_stay: false,
  supports_tip: false,
  order_ahead_days: 7,
  order_ahead: true,
  special_instructions_max_length: 64,
  disclaimers: [],
  supports_utensils: false,
  supports_basket_instructions: false,
  basket_instructions_max_length: null,
  supports_dine_in: false,
  supports_dine_in_table_number: false,
  supports_split_payment: true,
  supports_item_recipients: true,
  item_recipient_label: "Name:",
  is_delivery_only: false,
  delivery_hours: [locationOperatingHoursFixture()],
  operating_hours: [locationOperatingHoursFixture()],
  business_hours: [locationOperatingHoursFixture()],
  cross_street: null,
  supports_promo_code: true
}, overrides);

// test/__fixtures__/basket.fixtures.ts
var basketConveyanceDetailsFixture = (overrides = {}) => __spreadValues({
  type: "pick_up",
  table_tent_number: null,
  make: null,
  parking_spot_number: null,
  model: null,
  color: null,
  delivery_address: null
}, overrides);
var basketItemFixture = (overrides = {}) => __spreadValues({
  id: "abcdefg",
  product: {
    id: "12345",
    global_id: "54321",
    name: "Bahn Mi",
    cost: 995,
    cross_sell_id: null,
    category_id: null,
    category_label: null,
    filter_tags: null
  },
  options: [],
  quantity: 1,
  special_instructions: "",
  recipient: "Bart"
}, overrides);
var deliveryAddressFixture = (overrides = {}) => __spreadValues({
  id: 385189395,
  time_wanted: "",
  time_wanted_mode: "asap",
  street_address: "6 Broadway",
  street_address_2: "",
  city: "New York",
  state: "",
  zip_code: "10004",
  special_instructions: "",
  default: true
}, overrides);
var basketFixture = (overrides = {}) => __spreadValues({
  id: "e84fc190-2f75-42ce-aaff-d2a1e6e5196e",
  special_instructions: null,
  basket_instructions: null,
  conveyance_type: basketConveyanceDetailsFixture(),
  tip: 0,
  delivery_fee: 0,
  wanted_at: "",
  subtotal: 1e3,
  sales_tax: 80,
  total: 1080,
  time_estimate_minutes: 0,
  supports_tip: false,
  promo_discount: 0,
  order_asap: true,
  fees: [
    {
      note: "Fee for store handoff.",
      amount: 200,
      description: "Service Fee"
    }
  ],
  utensils: false,
  location: locationFixture(),
  basket_items: [basketItemFixture()]
}, overrides);
var storedValueBalanceFixture = (overrides = {}) => __spreadValues({
  balance: 999999,
  card_number: "4242424242424242"
}, overrides);
var paymentTypesFixture = (overrides = {}) => __spreadValues({
  stored_value_requirements: [],
  supports_billing_account: true,
  supports_cash: true,
  supports_credit_card: true,
  supports_prepaid: true,
  supports_split_payment: true,
  supports_stored_value: true,
  supported_digital_wallets: []
}, overrides);

// test/__fixtures__/menu.fixtures.ts
var allergenItemFixture = (overrides = {}) => __spreadValues({
  id: 123,
  label: "Vegetarian",
  is_removal: false
}, overrides);
var existingOptionFixture = (overrides = {}) => __spreadValues({
  id: "12345",
  quantity: 1
}, overrides);
var menuProductResponseFixture = (overrides = {}) => __spreadValues({
  allergens: [],
  calories_separator: "-",
  calories: 900,
  cost: 995,
  description: "A tasty sandwich",
  filter_tags: null,
  final_calories: 950,
  final_cost: 1120,
  global_id: "54321",
  id: "12345",
  image: "https://cataas.com/cat",
  images: menuProductImagesFixture(),
  labels: [],
  marketing_tags: null,
  max_calories: 950,
  max_quantity: null,
  min_quantity: null,
  quantity_increment: null,
  meta_data: null,
  name: "Bahn Mi",
  options: [existingOptionFixture()],
  option_groups: [menuProductOptionGroupFixture()],
  surfaceable_option_groups: []
}, overrides);
var menuProductFixture = (overrides = {}) => __spreadValues({
  allergens: [],
  calorie_range: "900-950 Cals",
  calories_separator: "-",
  calories: 900,
  calsIdentifier: CALS_IDENTIFIER,
  cost: 995,
  customizable: true,
  description: "A tasty sandwich",
  filter_tags: null,
  final_calories: 950,
  final_cost: 1120,
  global_id: "54321",
  id: "12345",
  image: "https://cataas.com/cat",
  images: menuProductImagesFixture(),
  labels: [],
  marketing_tags: null,
  max_calories: 950,
  max_quantity: null,
  min_quantity: null,
  quantity_increment: null,
  meta_data: null,
  name: "Bahn Mi",
  options: [existingOptionFixture()],
  option_groups: [menuProductOptionGroupFixture()],
  surfaceable_option_groups: [],
  pretty_calories: "900-950 Cals",
  pretty_price: "$9.95",
  warningLabels: []
}, overrides);
var menuProductOptionFixture = (overrides = {}) => __spreadValues({
  calories_separator: "-",
  calories: 50,
  cost: 125,
  description: "Spice up your life",
  global_option_id: "109294",
  id: "915826",
  images: null,
  is_available: true,
  is_default: false,
  labels: [],
  max_calories: 50,
  name: "Jalape\xF1os",
  option_groups: [],
  quantity: 1,
  selected: false
}, overrides);
var menuProductImagesFixture = (overrides = {}) => __spreadValues({
  image_url_1_by_1: "https://cataas.com/cat"
}, overrides);
var menuProductOptionGroupFixture = (overrides = {}) => __spreadValues({
  choice_quantity_increment: 1,
  description: "Select addons",
  explanation_text: "",
  global_id: "54321",
  id: "12345",
  is_hidden: false,
  max_aggregate_quantity: 0,
  max_choice_quantity: null,
  max_selections: null,
  min_aggregate_quantity: 0,
  min_choice_quantity: null,
  min_selections: null,
  options: [menuProductOptionFixture()],
  parent_global_id: null,
  requires_user_selection: false,
  supports_quantity_selection: false,
  total_aggregate_quantity: 0
}, overrides);
var menuProductLabelFixture = (overrides = {}) => __spreadValues({
  name: "Prop65",
  image_url: "https://static.olocdn.net/img/sodium.png",
  image_description: "High Sodium",
  description: "Warning:  This product can expose you to chemicals which are known to the State of California to cause cancer."
}, overrides);
var tagItemFixture = (overrides = {}) => __spreadValues({
  id: 39,
  label: "Seasonal",
  organization_id: 123,
  type: "marketing",
  hide_label: false
}, overrides);
var categoryFixture = (overrides = {}) => __spreadValues({
  description: "",
  icon: null,
  global_id: null,
  id: "10788",
  is_hidden: false,
  name: "Sandwiches",
  products: [menuProductFixture()],
  type: "Sandwiches"
}, overrides);
var categoryResponseFixture = (overrides = {}) => __spreadValues({
  description: "",
  icon: null,
  global_id: null,
  id: "10788",
  is_hidden: false,
  name: "Sandwiches",
  products: [menuProductResponseFixture()],
  type: "Sandwiches"
}, overrides);

// test/__fixtures__/basket.fixtures.v2.ts
var deliveryAddressFixture2 = (overrides = {}) => __spreadValues({
  street_address: "25 Broadway",
  street_address_2: "Unit 325",
  city: "New York",
  state: "NY",
  zip_code: "10004",
  phone_number: "636-555-3226",
  special_instructions: ""
}, overrides);
var storedAddressFixture = (overrides = {}) => __spreadValues(__spreadValues({
  id: 555,
  default: true
}, deliveryAddressFixture2(overrides)), overrides);
var curbsideFixture = (overrides = {}) => __spreadValues({
  color: "Silver",
  make: "Audi",
  model: "RS6",
  type: "curbside"
}, overrides);
var deliveryFixture = (overrides = {}) => __spreadValues({
  delivery_address: deliveryAddressFixture2(),
  type: "delivery"
}, overrides);
var dineInFixture = (overrides = {}) => __spreadValues({
  table_tent_number: "125",
  type: "dine_in"
}, overrides);
var driveInFixture = (overrides = {}) => __spreadValues({
  parking_spot_number: "12",
  type: "drive_in"
}, overrides);
var driveThruFixture = (overrides = {}) => __spreadValues({ type: "drive_thru" }, overrides);
var pickupFixture = (overrides = {}) => __spreadValues({ type: "pick_up" }, overrides);
var feeFixture = (overrides = {}) => __spreadValues({
  amount: 27,
  description: "Delivery Fee",
  note: null
}, overrides);
var handoffTimesFixture = (overrides = []) => ["2023-01-01T18:11:37.119Z", ...overrides];
var optionChoiceFixture = (overrides = {}) => __spreadValues({
  id: "jH7OPrTYHvI",
  cost: 1299,
  name: "Test option",
  option_id: "lCAI8KtVK4Lt",
  quantity: 4,
  allergens: null
}, overrides);
var basketItemFixture2 = (overrides = {}) => __spreadValues({
  id: "PLmbO5eusHs",
  quantity: 1,
  base_cost: 399,
  total_cost: 1698,
  special_instructions: "",
  recipient: "",
  category_id: "",
  options: [optionChoiceFixture()],
  product: menuProductFixture()
}, overrides);
var basketV2Fixture = (overrides = {}) => __spreadValues({
  id: "PLmbO5eusHs",
  basket_instructions: null,
  basket_items: [basketItemFixture2()],
  conveyance_type: pickupFixture(),
  delivery_fee: 0,
  earliest_ready_time_at_location: null,
  fees: [],
  location: locationFixture(),
  order_asap: true,
  promo_discount: 0,
  sales_tax: 199,
  special_instructions: null,
  subtotal: 1698,
  supports_tip: true,
  time_estimate_minutes: 20,
  tip: 200,
  total: 2097,
  utensils: false,
  wanted_at: null
}, overrides);
var supportedPaymentTypesFixture = (overrides = {}) => __spreadValues({
  billing_account: { supported: false },
  cash: { supported: false },
  credit_card_token: {
    supported: false,
    provider: null,
    environment: null,
    key: null
  },
  credit_card: {
    supported: true,
    proxy: "pci_proxy",
    environment: "sandbox",
    key: "3000016050"
  },
  digital_wallet: {
    provider: null,
    supported: false,
    key: null,
    environment: null,
    supported_digital_wallets: []
  },
  prepaid: { supported: false },
  stored_value: { supported: false, requirements: [] }
}, overrides);

// test/__fixtures__/geoip.fixtures.ts
var geoIpFixture = (overrides = {}) => __spreadValues({
  requestIp: "127.0.0.1",
  geoData: {
    area: 1e3,
    city: "Foobar City",
    country: "USA",
    eu: false,
    ll: [0, 0],
    metro: 123,
    region: "CO",
    timezone: "America/Denver"
  }
}, overrides);

// test/__fixtures__/loyalty.fixtures.ts
var loyaltyStateFixture = (overrides = {}) => __spreadValues({
  points: 300,
  net_points: 400,
  membership_level_id: null,
  membership_level_name: null,
  banked_currency: 0,
  banked_currency_expiring: 0,
  banked_currency_expiration_date: null,
  points_threshold: 0,
  conversion_rate: 0,
  rewards: void 0
}, overrides);
var loyaltyUserFixture = (overrides = {}) => __spreadValues({
  created_at: "2018-02-05T18:22:27+00:00",
  deleted_at: null,
  external_provider_id: 1,
  external_user_id: "homer@simpsons.org",
  first_name: "Homer",
  email: "homer@simpsons.org",
  qrcode: "",
  birthday: "",
  referral_code: "abc123",
  id: 29,
  opt_in: true,
  identifier: "homer@simpsons.org",
  last_name: "Simpson",
  name: "Homer Simpson",
  organization_id: 4,
  phone: "636-555-3226",
  updated_at: "2018-02-05T18:22:27+00:00",
  username: "",
  external_user_fk: null
}, overrides);
var messageItemFixture = (overrides = {}) => __spreadValues({
  id: "122742",
  title: "Free Pizza! Act Fast",
  subtitle: "Place an order today!",
  body: "Free pizza through the end of the week.",
  type: "user_specific",
  rank: 0,
  read_at: null,
  launch_time: "",
  message_ctas: [
    {
      type: "deep_link",
      url: "Order Today",
      label: "https://cataas.com/cat",
      priority: "primary"
    },
    {
      type: "deep_link",
      url: "https://cataas.com/cat",
      label: "See Your Offers ",
      priority: "secondary"
    }
  ],
  hero_content: {
    type: "image",
    url: "https://cataas.com/cat",
    alt_text: "Koala's Are Great, Order One Today!",
    initial_frame: ""
  },
  background_content: {
    type: "image",
    url: "https://cataas.com/cat",
    alt_text: "Koala's Are Great, Order One Today!",
    initial_frame: ""
  }
}, overrides);
var redeemableItemFixture = (overrides = {}) => __spreadValues({
  id: 2008,
  label: "Free Samosas",
  description: "",
  points_required: 50,
  meta_data: "",
  image: { name: "redeemable_image", url: "https://cataas.com/cat" },
  supports_donation: true
}, overrides);
var redemptionItemFixture = (overrides = {}) => __spreadValues({
  description: "",
  expiring_at: "2020-09-17T17:39:52-04:00",
  id: 129380123,
  label: "Free Snack Cup",
  redeemable_id: 2007,
  starting_at: "2020-08-18T17:39:52-04:00",
  status: "redeemable",
  tracking_code: "6791916",
  image: { name: "redemption_image", url: "https://cataas.com/cat" }
}, overrides);
var rewardHistoryItemFixture = (overrides = {}) => __spreadValues({
  date: "2020-08-05T14:09:48.000000Z",
  value: "-50 points",
  description: "Free Samosas redeemed using redemption code 2008 (Available)"
}, overrides);
var rewardItemFixture = (overrides = {}) => __spreadValues({
  available_offline: true,
  available_online: true,
  copy: "Brand new users sign up",
  description: "Brand new users sign up",
  expires_at: "2018-03-28T06:59:59+00:00",
  id: "120683553",
  image: {
    name: "reward_image",
    url: "https://res.cloudinary.com/punchh/image/upload/fl_lossy,q_auto/default_redemption_bg.png"
  },
  label: "Brand new users sign up",
  locations: [],
  quantity_applied: 0,
  quantity_available: 0,
  starts_at: "2018-02-26T18:51:47+00:00",
  type: "Campaign",
  value: 0,
  reference: "",
  supports_donation: true
}, overrides);
var socialCauseFixture = (overrides = {}) => __spreadValues({
  id: 1,
  name: "Social Cause Test",
  description: "Social Cause Test Description",
  image_url: "https://res.cloudinary.com/punchh/image/upload/fl_lossy,q_auto/default_redemption_bg.png",
  street_address: "123 Main St",
  address: "123 Main St",
  city: "San Francisco",
  state: "CA",
  zip_code: "94105",
  phone: "555-555-5555",
  email: "test@test.com",
  miscellaneous: ""
}, overrides);
var donationFixture = (overrides = {}) => __spreadValues({
  type: "redeemable",
  item: redeemableItemFixture().id.toString()
}, overrides);

// src/v4/api/locations.models.ts
var deliveryCoverageResponse = z.object({
  /** Can the location deliver to this address? */
  can_deliver: z.boolean(),
  /** Error message to show if delivery is unavailable. */
  message: z.nullable(z.string())
});
var locationOperatingHours = z.object({
  /** ISO8601 datestamp when the hours were created. */
  created_at: z.string(),
  /** Day that these hours apply to. */
  day_of_week: z.string(),
  /** ISO8601 datestamp when the location closes. */
  end: z.string(),
  /** ID for this set of operating hours. */
  id: z.string(),
  /** ISO8601 datestamp when the location opens. */
  start: z.string(),
  /** ID of the location these hours apply to. */
  store_location_id: z.number(),
  /**
   * The type of operating hours, such as delivery, pickup, or curbside.
   * @see https://github.com/koala-labs/koala-ordering-api/blob/production/core/Ordering/Models/LocationHour.php#L25-L30
   * @TODO make this an enum?
   */
  type: z.string(),
  /** ISO8601 datestamp when the hours were last updated. */
  updated_at: z.string()
});
var locationCachedData = z.object({
  /** The ordering provider's ID for this location. Maps to `location_id`. */
  id: z.string(),
  /** Location zip code. */
  zip: z.string(),
  /** Location city. */
  city: z.string(),
  /** @TODO improve this type. */
  meta: z.unknown(),
  /** @TODO what is this value? */
  tags: z.string().array(),
  /** Location name. */
  label: z.string(),
  /** Location state or province. */
  state: z.string(),
  /** Country code that the location is in. Eg: `USA`. */
  country: z.string(),
  /** Location latitude. */
  latitude: z.number(),
  /** Location longitude. */
  longitude: z.number(),
  /** Can this location be ordered from? */
  is_available: z.boolean(),
  /** Location phone number. */
  phone_number: z.string().nullable(),
  /** Street address of the location. */
  street_address: z.string(),
  /** UTC offset representing the location's time zone. */
  utc_offset: z.number(),
  /** Accepted credit card types. @TODO expand this type. */
  card_types: z.object({ label: z.string() }).passthrough().array()
});
var locationPositionAttribute = z.object({
  id: z.number(),
  label: z.string(),
  description: z.string(),
  type: z.string(),
  accessor: z.string(),
  required: z.boolean()
});
var dist_location = z.object({
  /** Misc. custom location info. Eg: a Grubhub link. */
  attributes: z.optional(
    z.object({
      id: z.optional(z.number()),
      label: z.unknown(),
      value: z.unknown(),
      position: z.optional(locationPositionAttribute)
    }).passthrough().array()
  ),
  /** Max length of special instructions added during checkout? (if supported) */
  basket_instructions_max_length: z.nullable(z.number()),
  /** Brands can set this ID in the ordering provider to match PoS ID, etc. */
  brand_id: z.optional(z.nullable(z.string())),
  /** Accepted credit card types. @TODO expand this type. */
  card_types: z.object({ label: z.string() }).array(),
  /** ISO8601 datestamp when this location was created. */
  created_at: z.string().optional(),
  /** @TODO reduce our reliance on this property. */
  cached_data: z.optional(locationCachedData.passthrough()),
  /** Location city. */
  city: z.string(),
  /** Country code that the location is in. Eg: `USA`. */
  country: z.string(),
  /** The cross street value added to addresses */
  cross_street: z.nullable(z.string()),
  /** ISO8601 datestamp when this location was deleted. */
  deleted_at: z.optional(z.nullable(z.string())),
  /** Hours that this location will deliver. */
  delivery_hours: z.optional(locationOperatingHours.passthrough().array()),
  /** Minimum order amount that is eligible for delivery. */
  delivery_minimum: z.nullable(z.number()),
  /** @TODO improve this type. */
  disclaimers: z.object({ name: z.string(), description: z.string() }).passthrough().array(),
  /** The location's distance in miles from the user's selected address. */
  distance_miles: z.optional(z.number()),
  /** Koala Location ID. */
  id: z.number(),
  /** @TODO where do these images display? */
  image_url_1_by_1: z.optional(z.nullable(z.string())),
  /** Does this location only support delivery conveyance? */
  is_delivery_only: z.optional(z.boolean()),
  /** Label to use when adding a recipient. Eg: "Name" or "Customer". */
  item_recipient_label: z.nullable(z.string()),
  /** Location name. */
  label: z.string(),
  /** Location latitude. */
  latitude: z.number(),
  /** The ordering provider's ID for this location. */
  location_id: z.optional(z.string()),
  /** Location longitude. */
  longitude: z.number(),
  /**
   * Hours that Online ordering available.
   * (for now `business_hours` will be the same as the `operating_hours` for Olo and Square locations.)
   */
  operating_hours: z.optional(locationOperatingHours.passthrough().array()),
  /** Hours that this location is open. (Chowly locations will have only `business_hours`)*/
  business_hours: z.optional(locationOperatingHours.passthrough().array()),
  /** Does this location support ordering ahead? */
  order_ahead: z.boolean(),
  /** If ordering ahead is supported, how many days can you order ahead? */
  order_ahead_days: z.number(),
  /** Does this location support ordering ASAP? */
  order_asap: z.boolean(),
  /** ID of the organization that this location belongs to. */
  organization_id: z.number(),
  /** Location phone number. */
  phone_number: z.string().nullable(),
  /** Is the location enabled in the ordering provider? */
  provider_enabled: z.optional(z.boolean()),
  /** Location URL slug. */
  slug: z.string().nullable(),
  /** Maximum number of characters for special order instructions. */
  special_instructions_max_length: z.number(),
  /** The state's foreign key to the US States database table. */
  state_id: z.optional(z.number()),
  /**
   * Current location status.
   * @see https://github.com/koala-labs/koala-ordering-api/blob/production/app/Status.php#L44-L53
   * @TODO make this into an enum?
   */
  status_id: z.optional(z.number()),
  /** Street address of the location. */
  street_address: z.string(),
  /** Can special instructions be added to an order during checkout? */
  supports_basket_instructions: z.boolean(),
  /** Does this location support curbside pickup? */
  supports_curbside: z.boolean(),
  /** Does this location support delivery conveyance? */
  supports_delivery: z.boolean(),
  /** Does this location support dine-in conveyance? */
  supports_dine_in: z.boolean(),
  /** Does this location support drive-in conveyance? */
  supports_drive_in: z.boolean(),
  /** Does this location support table numbers? */
  supports_dine_in_table_number: z.boolean(),
  /** Does this location support drive-thru conveyance? */
  supports_drive_thru: z.boolean(),
  /** Can individual items be marked for people in the customer's party? */
  supports_item_recipients: z.boolean(),
  /** Does this location only support delivery conveyance? */
  supports_pick_up: z.boolean(),
  /** Can payment be split between multiple methods? */
  supports_split_payment: z.boolean(),
  /** Does this location support tipping during checkout? */
  supports_tip: z.boolean(),
  /** Does this location support dine-in for an online order? */
  supports_to_stay: z.boolean(),
  /** Can you request utensils from this location during checkout? */
  supports_utensils: z.boolean(),
  /** Flag indicates if promo code form should be supported during checkout */
  supports_promo_code: z.boolean(),
  /**
   * ISO8601 datestamp when this location's menu was last synced.
   * @TODO should we be using `synced_at` or `last_synced_at`?
   */
  synced_at: z.optional(z.string()),
  /** ISO8601 datestamp when this location was last updated. */
  updated_at: z.optional(z.string()),
  /** Location zip code. */
  zip_code: z.optional(z.string())
});

// src/v4/api/payment.models.ts
var PAYMENT_TYPES = /* @__PURE__ */ ((PAYMENT_TYPES2) => {
  PAYMENT_TYPES2["CREDIT_CARD"] = "credit_card";
  PAYMENT_TYPES2["CREDIT_CARD_TOKEN"] = "credit_card_token";
  PAYMENT_TYPES2["CASH"] = "cash";
  PAYMENT_TYPES2["STORED_VALUE"] = "stored_value";
  PAYMENT_TYPES2["BILLING_ACCOUNT"] = "billing_account";
  PAYMENT_TYPES2["DIGITAL_WALLET"] = "digital_wallet";
  return PAYMENT_TYPES2;
})(PAYMENT_TYPES || {});
var PAYMENT_METHODS = z.enum([
  "cash",
  "prepaid",
  "billing_account",
  "digital_wallet",
  "credit_card",
  "credit_card_token",
  "stored_value"
]);
var payment = z.object({
  customer: z.object({
    first_name: z.string(),
    last_name: z.string(),
    email: z.string(),
    // Matches a 10-digit string.
    contact_number: z.string().regex(/^\d{10}$/)
  }),
  amount: z.number(),
  tip: z.optional(z.number())
});
var billingAccount = payment.extend({
  type: z.literal(PAYMENT_METHODS.enum.billing_account),
  saved_account_id: z.string()
});
var cash = payment.extend({
  type: z.literal(PAYMENT_METHODS.enum.cash)
});
var creditCard = payment.extend({
  type: z.literal(PAYMENT_METHODS.enum.credit_card),
  id: z.string(),
  alias_cc: z.string(),
  alias_cvv: z.string(),
  card_brand: z.string(),
  last_four: z.string(),
  expiry_month: z.number(),
  expiry_year: z.number(),
  zip_code: z.string(),
  country: z.string(),
  save: z.boolean()
});
var creditCardToken = payment.extend({
  type: z.literal(PAYMENT_METHODS.enum.credit_card_token),
  card_token: z.string(),
  card_brand: z.string(),
  last_four: z.string(),
  expiry_month: z.number(),
  expiry_year: z.number(),
  zip_code: z.string(),
  country: z.string(),
  save: z.boolean()
});
var digitalWallet = payment.extend({
  type: z.literal(PAYMENT_METHODS.enum.digital_wallet),
  digital_wallet_id: z.number(),
  card_token: z.string(),
  card_brand: z.string(),
  // Matches a 4-digit string.
  last_four: z.string().regex(/^\d{4}$/),
  expiry_month: z.number(),
  expiry_year: z.number(),
  zip_code: z.string(),
  country: z.string(),
  save: z.boolean()
});
var giftCard = payment.extend({
  type: z.literal(PAYMENT_METHODS.enum.stored_value),
  stored_value_requirements: z.object({
    /** Could be something like "pin" or "card_number". */
    name: z.nullable(z.string()),
    /** Value for corresponding name */
    value: z.nullable(z.string())
  }).array()
});
var supportedPaymentMethods = z.discriminatedUnion("type", [
  billingAccount,
  cash,
  creditCard,
  creditCardToken,
  digitalWallet,
  giftCard
]);
var customerDetails = z.object({
  first_name: z.string(),
  last_name: z.string(),
  email: z.string(),
  contact_number: z.string(),
  /** Should the receipt be emailed to the user? */
  email_receipt: z.boolean().optional(),
  opt_in: z.boolean().optional()
});
var creditCardBase = z.object({
  /** Tokenized card number that the API can use to submit a charge. */
  alias_cc: z.nullable(z.string()).optional(),
  /** Tokenized card CVV. (the 3/4 digit number) */
  alias_cvv: z.nullable(z.string()).optional(),
  /** Credit card type. Eg: "VIS" */
  payment_method: z.nullable(z.string()).optional(),
  /** Year that the card expires. */
  expiry_year: z.nullable(z.number()).optional(),
  /** Month that the card expires. */
  expiry_month: z.nullable(z.number()).optional(),
  /** Payment country code. Eg: "US" */
  country: z.nullable(z.string()).optional(),
  /** Last 4 digits of the credit card. Eg: "x-4242" */
  last_four: z.nullable(z.string()).optional()
});
var tokenizedCreditCard = creditCardBase.extend({
  /** Masked card number. Eg: "411111xxxxxx1111". */
  masked_card: z.string().optional()
});
var storedValueRequirement = z.object({
  /** Could be something like "pin" or "card_number". */
  name: z.nullable(z.string()),
  /** Value for corresponding name */
  value: z.nullable(z.string())
});
var paymentDetails = tokenizedCreditCard.extend({
  id: z.nullable(z.string()).optional(),
  /** Id that should be set from paymentTypesResponse.supported_digital_wallets,
   * depending on what digital wallet type is available,
   * used for authorizing payment.
   */
  digital_wallet_id: z.number().optional(),
  /** Token that is getting exchanged for card data, used for authorizing payment. */
  card_token: z.nullable(z.string()).optional(),
  /** Total payment, excluding tip. */
  amount: z.number().optional(),
  /** Credit Card brand. */
  card_brand: z.string().optional(),
  /** Details about the customer who submitted the order. */
  customer: customerDetails.passthrough().optional(),
  /** @TODO what is this value? */
  payment_location_id: z.string().optional(),
  /** Is this payment method saved? */
  save: z.boolean().optional(),
  /** @TODO what is this value? */
  /** @TODO is it really number? */
  saved_account_id: z.nullable(z.string()).optional(),
  /** @TODO what is this value? */
  stored_value_number: z.nullable(z.number()).optional(),
  /** @TODO what is this value? */
  stored_value_pin: z.nullable(z.number()).optional(),
  /**
   * Collection of StoredValueRequirement
   * Required if type === PAYMENT_TYPE.billing_account
   */
  stored_value_requirements: storedValueRequirement.passthrough().array().optional(),
  /** Tip amount. */
  tip: z.number().optional(),
  /** Payment type, such as cash, or card. */
  type: z.nativeEnum(PAYMENT_TYPES),
  /** Billing zip code. */
  zip_code: z.string().optional()
});

// src/api/basket.models.v2.ts
var dateTime = z.string().datetime({ offset: true });
var basketLocation = dist_location.omit({ cached_data: true, zip_code: true }).passthrough();
var basketProduct = menuProduct.omit({
  images: true,
  calorie_range: true,
  calsIdentifier: true,
  pretty_price: true,
  pretty_calories: true,
  customizable: true,
  filter_tags: true
}).partial({ options: true }).passthrough();
var CONVEYANCE_MODES = z.enum([
  "curbside",
  "delivery",
  "dine_in",
  "drive_in",
  "drive_thru",
  "pick_up"
]);
var deliveryAddress = z.object({
  street_address: z.string(),
  street_address_2: z.optional(z.nullable(z.string())),
  city: z.string(),
  state: z.nullable(z.string()),
  zip_code: z.string(),
  phone_number: z.string(),
  special_instructions: z.string()
});
var storedAddress = deliveryAddress.extend({
  id: z.number(),
  default: z.boolean()
});
var address = z.union([deliveryAddress, storedAddress]);
var curbside = z.object({
  type: z.literal(CONVEYANCE_MODES.enum.curbside),
  make: z.string(),
  model: z.string(),
  color: z.string()
});
var delivery = z.object({
  type: z.literal(CONVEYANCE_MODES.enum.delivery),
  delivery_address: deliveryAddress
});
var dineIn = z.object({
  type: z.literal(CONVEYANCE_MODES.enum.dine_in),
  table_tent_number: z.nullable(z.string())
});
var driveIn = z.object({
  type: z.literal(CONVEYANCE_MODES.enum.drive_in),
  parking_spot_number: z.string()
});
var driveThru = z.object({
  type: z.literal(CONVEYANCE_MODES.enum.drive_thru)
});
var pickup = z.object({
  type: z.literal(CONVEYANCE_MODES.enum.pick_up)
});
var conveyanceType = z.discriminatedUnion("type", [
  curbside,
  delivery,
  dineIn,
  driveIn,
  driveThru,
  pickup
]);
var fee = z.object({
  amount: z.number(),
  description: z.nullable(z.string()),
  note: z.nullable(z.string())
});
var optionChoice = z.object({
  id: z.string(),
  cost: z.number(),
  name: z.string(),
  option_id: z.string(),
  quantity: z.number(),
  allergens: z.nullable(allergenItem.array())
});
var basketItem = z.object({
  id: z.string(),
  quantity: z.number(),
  base_cost: z.number(),
  total_cost: z.number(),
  special_instructions: z.string(),
  recipient: z.string(),
  category_id: z.string().nullable(),
  options: optionChoice.array(),
  product: basketProduct
});
var basketV2 = z.object({
  id: z.string(),
  basket_instructions: z.nullable(z.string()),
  basket_items: basketItem.array(),
  conveyance_type: conveyanceType,
  delivery_fee: z.number(),
  earliest_ready_time_at_location: z.nullable(dateTime),
  fees: fee.array(),
  location: basketLocation,
  order_asap: z.boolean(),
  promo_discount: z.number(),
  sales_tax: z.number(),
  special_instructions: z.nullable(z.string()),
  subtotal: z.number(),
  supports_tip: z.boolean(),
  time_estimate_minutes: z.number(),
  tip: z.number(),
  total: z.number(),
  utensils: z.boolean(),
  wanted_at: z.nullable(dateTime)
});
var handoffTimes = dateTime.array();
var customerDetailsV2 = z.object({
  first_name: z.string(),
  last_name: z.string(),
  email: z.string(),
  contact_number: z.string(),
  email_receipt: z.boolean(),
  opt_in: z.boolean()
});
var paymentEnvironments = z.union([
  z.literal("sandbox"),
  z.literal("production")
]);
var paymentProviders = z.union([
  z.literal("stripe"),
  z.literal("olo_pay"),
  z.literal("square")
]);
var creditCardTokenSupport = z.discriminatedUnion("supported", [
  z.object({
    supported: z.literal(true),
    provider: paymentProviders,
    environment: paymentEnvironments,
    key: z.string()
  }),
  z.object({
    supported: z.literal(false),
    provider: z.null(),
    environment: z.null(),
    key: z.null()
  })
]);
var creditCardSupport = z.discriminatedUnion("supported", [
  z.object({
    supported: z.literal(true),
    proxy: z.literal("pci_proxy"),
    environment: paymentEnvironments,
    key: z.string()
  }),
  z.object({
    supported: z.literal(false),
    proxy: z.null(),
    environment: z.null(),
    key: z.null()
  })
]);
var digitalWallet2 = z.object({
  id: z.number(),
  name: z.union([z.literal("google_pay"), z.literal("apple_pay")])
});
var digitalWalletSupport = z.discriminatedUnion("supported", [
  z.object({
    provider: paymentProviders,
    supported: z.literal(true),
    environment: paymentEnvironments,
    /** in case of OloPay implementation we don't use key as it is built into OloPay library */
    key: z.string().nullable(),
    supported_digital_wallets: z.array(digitalWallet2)
  }),
  z.object({
    provider: z.null(),
    supported: z.literal(false),
    environment: z.null(),
    key: z.null(),
    supported_digital_wallets: z.array(digitalWallet2).default([])
  })
]);
var giftCardRequirement = z.object({
  /** Formatted label label. Eg: "Gift Card PIN" */
  label: z.string(),
  /** Field input type. Eg: "password" */
  type: z.string(),
  /** Field name. Eg: "pin" */
  name: z.string(),
  value: z.nullable(z.string())
});
var giftCardSupport = z.object({
  supported: z.boolean(),
  requirements: giftCardRequirement.array()
});
var supportedPaymentTypes = z.object({
  billing_account: z.object({ supported: z.boolean() }),
  cash: z.object({ supported: z.boolean() }),
  credit_card_token: creditCardTokenSupport,
  credit_card: creditCardSupport,
  digital_wallet: digitalWalletSupport,
  prepaid: z.object({ supported: z.boolean() }),
  stored_value: giftCardSupport
});
var submissionDetails = z.object({
  payment: supportedPaymentMethods.array(),
  customer: customerDetailsV2.passthrough(),
  allergies: z.string().array()
});

// src/v4/api/basket.models.ts
var storedAddress2 = z.object({
  /** Desired delivery day. @TODO how is this formatted? */
  day_wanted: z.optional(z.string()),
  /** Desired delivery time. @TODO how is this formatted? */
  time_wanted: z.nullable(z.string()),
  street_address: z.string(),
  street_address_2: z.string(),
  city: z.string(),
  state: z.optional(z.nullable(z.string())),
  zip_code: z.string(),
  /** Special delivery instructions for this address, such as a door code. */
  special_instructions: z.string(),
  /** Address ID. */
  id: z.number(),
  /** Is this the user's default address? */
  default: z.boolean()
});
var deliveryAddress2 = z.object({
  /** Desired delivery time. @TODO how is this formatted? */
  time_wanted: z.nullable(z.string()),
  time_wanted_mode: z.enum(["asap", "advance"]),
  street_address: z.string(),
  city: z.string(),
  zip_code: z.string(),
  /** Desired delivery day. @TODO how is this formatted? */
  day_wanted: z.optional(z.string()),
  street_address_2: z.optional(z.string()),
  state: z.optional(z.nullable(z.string())),
  /**
   * @TODO remove alongside standardizeAddressZipCode after we figure out
   * which parts of the ordering app send `zip` instead of `zip_code`.
   */
  zip: z.optional(z.string()),
  /** Special delivery instructions for this address, such as a door code. */
  special_instructions: z.optional(z.string()),
  /** Address ID. */
  id: z.optional(z.nullable(z.number())),
  /** @TODO what is this value? */
  stale_id: z.optional(z.number()),
  /** Is this the user's default address? */
  default: z.optional(z.boolean())
});
var basketConveyanceDetails = z.object({
  /** Car color. */
  color: z.nullable(z.string()),
  /** Street address for delivery orders. */
  delivery_address: z.nullable(deliveryAddress2.passthrough()),
  /** Car manufacturer. */
  make: z.nullable(z.string()),
  /** Car model. */
  model: z.nullable(z.string()),
  /** Parking spot where the customer is parked. */
  parking_spot_number: z.nullable(z.string()),
  /** For in-store orders, the customer's table number. */
  table_tent_number: z.nullable(z.string()),
  /** @TODO what is this value? */
  type: z.string()
});
var basketFee = z.object({
  amount: z.number(),
  description: z.nullable(z.string()),
  note: z.nullable(z.string())
});
var basketItemOption = z.object({
  /** Option ID. */
  id: z.string(),
  /** Option ID as present in Remote Basket. */
  option_id: z.optional(z.string()),
  /** Quantity added to the item. */
  quantity: z.number(),
  /** Cost associated with this option. */
  cost: z.optional(z.number()),
  /** Option name. */
  name: z.optional(z.string()),
  /** Allergens associated with this option. */
  allergens: z.optional(allergenItem.passthrough().array()),
  /** The Option's ID across all locations. */
  global_option_id: z.optional(z.string())
});
var basketItem2 = z.object({
  product: z.object({
    /** Product ID unique to a single location. */
    id: z.string(),
    /** The Product's ID across all locations. */
    global_id: z.string(),
    /** Product name. */
    name: z.string(),
    /** Unformatted item cost. */
    cost: z.number(),
    /** Local to the application value. ID of the cross-sell, if this item was added as a cross-sell. */
    cross_sell_id: z.string().nullable().optional(),
    /** Local to the application value. ID of the category this product is in. */
    category_id: z.string().nullable().optional(),
    /** Local to the application value. Label of the category this product is in. */
    category_label: z.string().nullable().optional(),
    /** Product's filter tag */
    filter_tags: z.optional(z.nullable(tagItem.passthrough().array()))
  }),
  /** Customized options for this item. */
  options: basketItemOption.passthrough().array(),
  /** Item quantity that was ordered. */
  quantity: z.number(),
  /** Any special ordering instructions. */
  special_instructions: z.string(),
  /** The person that this item is for. */
  recipient: z.string(),
  /** Basket Item ID. */
  id: z.optional(z.string())
});
var curbsideDetails = z.object({
  /** Car color. */
  color: z.string(),
  /** Car manufacturer. */
  make: z.string(),
  /** Car model. */
  model: z.string()
});
var dineInDetails = z.object({
  /** For in-store orders, the customer's table number. */
  table_tent_number: z.string()
});
var driveInDetails = z.object({
  parking_spot_number: z.string()
});
var basket = z.object({
  /** Basket ID. */
  id: z.string(),
  /** How the basket will be given to the customer. */
  conveyance_type: basketConveyanceDetails.passthrough(),
  /** @TODO how does this differ from `special_instructions`? */
  basket_instructions: z.nullable(z.string()),
  /** Any special ordering instructions. */
  special_instructions: z.nullable(z.string()),
  /** Tip amount. */
  tip: z.number(),
  /** Unformatted subtotal amount, excluding tax & tip. */
  subtotal: z.number(),
  /** Unformatted tax amount. */
  sales_tax: z.number(),
  fees: basketFee.passthrough().array(),
  /** Unformatted order total cost, including tax & tip. */
  total: z.number(),
  /** Esimated fulfillment time for the order, in minutes. */
  time_estimate_minutes: z.number(),
  /** Does this location support ordering ASAP? */
  order_asap: z.boolean(),
  /** Price discount from promotions. */
  promo_discount: z.number(),
  /** Does the location support tipping? */
  supports_tip: z.boolean(),
  /** Should utensils be included in this order? */
  utensils: z.boolean(),
  /** The order's delivery fee, if applicable. */
  delivery_fee: z.number(),
  /** Location that the basket is ordered from */
  location: dist_location.passthrough(),
  /** Items in the user's basket. */
  basket_items: basketItem2.passthrough().array(),
  /** ISO8601 datestamp when the customer would like the order. */
  wanted_at: z.nullable(z.string())
}).passthrough();
var digitalWallet3 = z.object({
  id: z.number(),
  name: z.union([z.literal("google_pay"), z.literal("apple_pay")])
});
var paymentTypesResponse = z.object({
  /** @TODO improve this type. */
  stored_value_requirements: z.unknown().array(),
  supports_billing_account: z.boolean(),
  supports_cash: z.boolean(),
  supports_credit_card: z.boolean(),
  supports_prepaid: z.boolean(),
  supports_split_payment: z.boolean(),
  supports_stored_value: z.boolean(),
  supports_credit_card_token: z.nullable(z.boolean()).optional(),
  supported_digital_wallets: z.array(digitalWallet3).default([])
}).passthrough();
var paymentProviders2 = z.union([
  z.literal("stripe"),
  z.literal("olo_pay"),
  z.literal("square")
]);
var paymentEnvironments2 = z.union([
  z.literal("sandbox"),
  z.literal("production")
]);
var creditCardTokenSupport2 = z.discriminatedUnion("supported", [
  z.object({
    supported: z.literal(true),
    provider: paymentProviders2,
    environment: paymentEnvironments2,
    key: z.string()
  }),
  z.object({
    supported: z.literal(false),
    provider: z.null(),
    environment: z.null(),
    key: z.null()
  })
]);
var creditCardSupport2 = z.discriminatedUnion("supported", [
  z.object({
    supported: z.literal(true),
    proxy: z.literal("pci_proxy"),
    environment: paymentEnvironments2,
    key: z.string()
  }),
  z.object({
    supported: z.literal(false),
    proxy: z.null(),
    environment: z.null(),
    key: z.null()
  })
]);
var digitalWalletSupport2 = z.discriminatedUnion("supported", [
  z.object({
    provider: paymentProviders2,
    supported: z.literal(true),
    environment: paymentEnvironments2,
    /** in case of OloPay implementation we don't use key as it is built into OloPay library */
    key: z.string().nullable(),
    supported_digital_wallets: z.array(digitalWallet3)
  }),
  z.object({
    provider: z.null(),
    supported: z.literal(false),
    environment: z.null(),
    key: z.null(),
    supported_digital_wallets: z.array(digitalWallet3).default([])
  })
]);
var giftCardRequirement2 = z.object({
  /** Formatted label label. Eg: "Gift Card PIN" */
  label: z.string(),
  /** Field input type. Eg: "password" */
  type: z.string(),
  /** Field name. Eg: "pin" */
  name: z.string(),
  value: z.nullable(z.string())
});
var giftCardSupport2 = z.object({
  supported: z.boolean(),
  requirements: giftCardRequirement2.array()
});
var supportedPaymentTypes2 = z.object({
  billing_account: z.object({ supported: z.boolean() }),
  cash: z.object({ supported: z.boolean() }),
  credit_card_token: creditCardTokenSupport2,
  credit_card: creditCardSupport2,
  digital_wallet: digitalWalletSupport2,
  prepaid: z.object({ supported: z.boolean() }),
  stored_value: giftCardSupport2
}).passthrough();
var storedValueBalanceResponse = z.object({
  /** Remaining balance. */
  balance: z.number(),
  /** Gift card number. */
  card_number: z.string()
}).passthrough();
var submitBasketData = z.object({
  /** Payment details for the basket. */
  payment: z.lazy(() => paymentDetails.passthrough().array()),
  /** Customer details submitted alongside the basket. */
  customer: z.lazy(() => customerDetails.passthrough()),
  allergies: z.string().array()
});
var basketOrder = z.object({
  /** Menu items to order. */
  basket_items: basketItem2.passthrough().array(),
  /**
   * ID of the location to order from.
   * @TODO should this be `location_id` or a full `location record`?
   */
  location: z.object({ id: z.number() }),
  /** Any special ordering instructions. */
  special_instructions: z.string(),
  referral_tracking_code: z.optional(z.string())
});
var checkoutBasketDeliveryAddress = deliveryAddress2.extend({
  time_wanted_mode: z.union([
    z.literal("advance"),
    z.literal("asap"),
    z.null()
  ])
});
var checkoutBasketConveyanceDetails = z.object({
  /** Car color. */
  color: z.nullable(z.string()),
  /** Street address for delivery orders. */
  delivery_address: checkoutBasketDeliveryAddress.passthrough(),
  /** Car manufacturer. */
  make: z.nullable(z.string()),
  /** Car model. */
  model: z.nullable(z.string()),
  /** Parking spot where the customer is parked. */
  parking_spot_number: z.nullable(z.string()),
  /** For in-store orders, the customer's table number. */
  table_tent_number: z.nullable(z.string()),
  /** @TODO what is this value? */
  type: z.string()
});
var checkoutBasket = z.object({
  /** Basket ID. */
  id: z.string(),
  /** @TODO how does this differ from `special_instructions`? */
  basket_instructions: z.string(),
  /** Any special ordering instructions. */
  special_instructions: z.string(),
  /** Fees associated with this order. */
  fees: basketFee.passthrough().array(),
  /** Tip amount. */
  tip: z.number(),
  /** Does the location support tipping? */
  supports_tip: z.boolean(),
  /** The order's delivery fee, if applicable. */
  delivery_fee: z.number(),
  /** Unformatted subtotal amount, excluding tax & tip. */
  subtotal: z.number(),
  /** Unformatted tax amount. */
  sales_tax: z.number(),
  /** Unformatted order total cost, including tax & tip. */
  total: z.number(),
  /** Esimated fulfillment time for the order, in minutes. */
  time_estimate_minutes: z.number(),
  /** Price discount from promotions. */
  promo_discount: z.number(),
  /** ISO8601 datestamp when the customer would like the order.
   * Can be null if the order is ASAP.
   */
  wanted_at: z.string().nullable(),
  /** @TODO what is this value? */
  version: z.unknown(),
  /** Does this location support ordering ASAP? */
  order_asap: z.boolean(),
  /** Should utensils be included in this order? */
  utensils: z.boolean(),
  /** ISO8601 datestamp when the food will be ready. */
  earliest_ready_time_at_location: z.string(),
  /** Location that the basket is ordered from */
  location: dist_location.passthrough(),
  /** Purchased items. */
  basket_items: basketItem2.passthrough().array(),
  /**
   * As of 4/27/22, this appears unused though null is returned from the API.
   * @TODO remove?
   */
  promo_codes: z.unknown(),
  /** How the basket will be given to the customer. */
  conveyance_type: checkoutBasketConveyanceDetails.passthrough()
});
var availableWantedAtTimes = z.string().array();
var customerDetailsV22 = z.object({
  first_name: z.string(),
  last_name: z.string(),
  email: z.string(),
  contact_number: z.string(),
  email_receipt: z.boolean(),
  opt_in: z.boolean()
});
var submissionDetails2 = z.object({
  payment: supportedPaymentMethods.array(),
  customer: customerDetailsV22.passthrough(),
  allergies: z.string().array()
}).passthrough();

// src/v4/api/ordering.models.ts
var ARRIVAL_STATUS = /* @__PURE__ */ ((ARRIVAL_STATUS2) => {
  ARRIVAL_STATUS2["NOT_SUPPORTED"] = "not_supported";
  ARRIVAL_STATUS2["ORDER_PLACED"] = "order_placed";
  ARRIVAL_STATUS2["ARRIVED"] = "arrived";
  ARRIVAL_STATUS2["PICKED_UP"] = "picked_up";
  return ARRIVAL_STATUS2;
})(ARRIVAL_STATUS || {});
var CONVEYANCE_TYPES = /* @__PURE__ */ ((CONVEYANCE_TYPES3) => {
  CONVEYANCE_TYPES3["PICKUP"] = "Pickup";
  CONVEYANCE_TYPES3["DELIVERY"] = "Delivery";
  CONVEYANCE_TYPES3["CURBSIDE"] = "Curbside";
  CONVEYANCE_TYPES3["DINEIN"] = "Dine-In";
  CONVEYANCE_TYPES3["DRIVETHRU"] = "Drive-Thru";
  CONVEYANCE_TYPES3["DRIVEIN"] = "Drive-In";
  return CONVEYANCE_TYPES3;
})(CONVEYANCE_TYPES || {});
var DELIVERY_PROVIDER_STATUS = /* @__PURE__ */ ((DELIVERY_PROVIDER_STATUS2) => {
  DELIVERY_PROVIDER_STATUS2["PENDING"] = "Pending";
  DELIVERY_PROVIDER_STATUS2["PICKUP_IN_PROGRESS"] = "PickupInProgress";
  DELIVERY_PROVIDER_STATUS2["DELIVERY_IN_PROGRESS"] = "DeliveryInProgress";
  DELIVERY_PROVIDER_STATUS2["DELIVERED"] = "Delivered";
  DELIVERY_PROVIDER_STATUS2["CANCELLED"] = "Canceled";
  DELIVERY_PROVIDER_STATUS2["RETURNED"] = "Returned";
  return DELIVERY_PROVIDER_STATUS2;
})(DELIVERY_PROVIDER_STATUS || {});
var DELIVER_PROVIDER_TERMINATING_STATUS = (/* unused pure expression or super */ null && ([
  "Delivered" /* DELIVERED */,
  "Canceled" /* CANCELLED */,
  "Returned" /* RETURNED */
]));
var customerDetails2 = z.object({
  first_name: z.string(),
  last_name: z.string(),
  email: z.string(),
  contact_number: z.string(),
  /** Should the receipt be emailed to the user? */
  email_receipt: z.boolean().optional(),
  opt_in: z.boolean().optional()
});
var creditCardBase2 = z.object({
  /** Tokenized card number that the API can use to submit a charge. */
  alias_cc: z.nullable(z.string()).optional(),
  /** Tokenized card CVV. (the 3/4 digit number) */
  alias_cvv: z.nullable(z.string()).optional(),
  /** Credit card type. Eg: "VIS" */
  payment_method: z.nullable(z.string()).optional(),
  /** Year that the card expires. */
  expiry_year: z.nullable(z.number()).optional(),
  /** Month that the card expires. */
  expiry_month: z.nullable(z.number()).optional(),
  /** Payment country code. Eg: "US" */
  country: z.nullable(z.string()).optional(),
  /** Last 4 digits of the credit card. Eg: "x-4242" */
  last_four: z.nullable(z.string()).optional()
});
var tokenizedCreditCard2 = creditCardBase2.extend({
  /** Masked card number. Eg: "411111xxxxxx1111". */
  masked_card: z.string().optional()
});
var storedValueRequirement2 = z.object({
  /** Could be something like "pin" or "card_number". */
  name: z.nullable(z.string()),
  /** Value for corresponding name */
  value: z.nullable(z.string())
});
var paymentDetails2 = tokenizedCreditCard2.extend({
  id: z.nullable(z.string()).optional(),
  /** Id that should be set from paymentTypesResponse.supported_digital_wallets,
   * depending on what digital wallet type is available,
   * used for authorizing payment.
   */
  digital_wallet_id: z.number().optional(),
  /** Token that is getting exchanged for card data, used for authorizing payment. */
  card_token: z.nullable(z.string()).optional(),
  /** Total payment, excluding tip. */
  amount: z.number().optional(),
  /** Credit Card brand. */
  card_brand: z.string().optional(),
  /** Details about the customer who submitted the order. */
  customer: customerDetails2.passthrough().optional(),
  /** @TODO what is this value? */
  payment_location_id: z.string().optional(),
  /** Is this payment method saved? */
  save: z.boolean().optional(),
  /** @TODO what is this value? */
  /** @TODO is it really number? */
  saved_account_id: z.nullable(z.string()).optional(),
  /** @TODO what is this value? */
  stored_value_number: z.nullable(z.number()).optional(),
  /** @TODO what is this value? */
  stored_value_pin: z.nullable(z.number()).optional(),
  /**
   * Collection of StoredValueRequirement
   * Required if type === PAYMENT_TYPE.billing_account
   */
  stored_value_requirements: storedValueRequirement2.passthrough().array().optional(),
  /** Tip amount. */
  tip: z.number().optional(),
  /** Payment type, such as cash, or card. */
  type: z.nativeEnum(PAYMENT_TYPES),
  /** Billing zip code. */
  zip_code: z.string().optional()
});
var order = z.object({
  /** Order ID. */
  id: z.string(),
  /** Unformatted subtotal amount, excluding tax & tip. */
  subtotal: z.optional(z.number()),
  /** Unformatted tax amount. */
  sales_tax: z.optional(z.number()),
  /** Unformatted order total cost, including tax & tip. */
  total: z.number(),
  /** ISO8601 datestamp when the order will be ready. */
  ready_at: z.string(),
  /** ISO8601 datestamp when the order was submitted. */
  ordered_at: z.optional(z.string()),
  /** @TODO how does this differ from `id`? */
  order_number: z.string(),
  /** Unformatted discount amount. */
  promo_discount: z.optional(z.number())
});
var orderDetails = z.object({
  /** Current arrival status of a delivery order. */
  arrival_status: z.nullable(z.nativeEnum(ARRIVAL_STATUS)),
  /** @TODO what is this value? */
  balance: z.number(),
  /** ID of the basket submitted by this order. */
  basket_id: z.string(),
  /** Items in the order. */
  basket_items: z.lazy(() => basketItem2.passthrough().array()),
  /** @TODO what is this value? */
  client_id: z.nullable(z.string()),
  /** ISO8601 datestamp when the order was submitted. */
  created_at: z.string(),
  /** ISO8601 datestamp when the delivery status was updated by the ordering provider. */
  delivery_status_updated_at: z.nullable(z.string()),
  /** Current status of a delivery order. */
  delivery_status: z.nullable(z.nativeEnum(DELIVERY_PROVIDER_STATUS)),
  /** Order ID. */
  id: z.string(),
  /** IP address that submitted the order. */
  ip: z.nullable(z.string()),
  /** Has the order been fulfilled. */
  is_complete: z.boolean(),
  /** Was this basket saved in a user's list of favorite order? */
  is_favorite: z.nullable(z.boolean()),
  /** Does this order include loyalty rewards? */
  is_loyalty_claimed: z.nullable(z.number()),
  /** The store location that the order was made at. */
  location: dist_location.passthrough(),
  /** @TODO how does this differ from `id`? */
  order_id: z.string(),
  /** @TODO how does this differ from `id`? */
  order_number: z.nullable(z.string()),
  /** ID of the organization this order was made to. */
  organization_id: z.number(),
  /** The brand's payment driver. */
  payment_driver_id: z.nullable(z.number()),
  /** ISO8601 datestamp when the order will be ready. */
  ready_at: z.string(),
  /** @TODO how does this differ from `id`? */
  request_id: z.nullable(z.string()),
  /** @TODO what is this value? */
  status_id: z.number(),
  /** ID of the location that this order was made to. */
  store_location_id: z.number(),
  /** The location that this order was made to. */
  store_location: z.nullable(dist_location.passthrough()),
  /** Unformatted order total cost, including tax & tip. */
  total: z.number(),
  /** ISO8601 datestamp when the order was last modified. */
  updated_at: z.string(),
  /** The customer's loyalty user ID, if applicable. */
  user_id: z.nullable(z.string()),
  order_data: z.object({
    /** Details about the customer who submitted the order. */
    customer: customerDetails2.passthrough(),
    order: z.object({
      /** Current arrival status of a delivery order. */
      arrival_status: z.nullable(z.nativeEnum(ARRIVAL_STATUS)),
      /** Order ID. */
      id: z.string(),
      /** @TODO improve this type. */
      order_items: z.unknown().array(),
      /** Order Number. @TODO how does this differ from `id`? */
      order_number: z.string(),
      /** ISO8601 datestamp when the order was submitted. */
      ordered_at: z.string(),
      /** @TODO is this the credit card brand? Or Credit Card vs. Gift Card? */
      payment_card_type: z.optional(z.string()),
      /** @TODO what is this value? */
      payment_card: z.optional(z.string()),
      /** Unformatted discount amount. */
      promo_discount: z.optional(z.number()),
      /** ISO8601 datestamp when the order will be ready. */
      ready_at: z.optional(z.string()),
      /** Unformatted tax amount. */
      sales_tax: z.number(),
      /** Unformatted subtotal amount, excluding tax & tip. */
      subtotal: z.number(),
      /** Unformatted order total, including tax & tip.  */
      total: z.number()
    }).passthrough(),
    /**
     * The user's ordered basket of items.
     */
    basket: basketV2.passthrough(),
    /** How the order was paid for. */
    payment: paymentDetails2.passthrough().array()
  }).passthrough()
});
var savedCard = z.object({
  /** ID of the saved card. */
  id: z.string(),
  /** @TODO is this credit/debit? How does it differ from `card_type`? */
  type: z.string(),
  /** Card type. @TODO is this amex/mastercard/visa? */
  card_type: z.nullable(z.string()),
  /** Last 4 digits. @TODO rename this for consistency. */
  suffix: z.nullable(z.string()),
  /** User-provided description. */
  description: z.string(),
  /** @TODO what is this value? */
  is_removable: z.boolean(),
  /** Card expiry. @TODO how is this formatted? */
  expires: z.nullable(z.string())
}).passthrough();
var deliveryStatus = z.object({
  /** @TODO how does `order_id` differ from `order_number`? */
  order_id: z.string(),
  order_number: z.string(),
  /** Dispatch service that will deliver the order. */
  delivery_service: z.string(),
  /** Driver information. */
  driver_name: z.optional(z.string()),
  driver_number: z.optional(z.string()),
  /** Current status of the delivery order. */
  status: z.nativeEnum(DELIVERY_PROVIDER_STATUS),
  /** Estimated pickup time. */
  estimated_pick_up_time: z.optional(z.string()),
  /** Estimated delivery time. */
  estimated_drop_off_time: z.optional(z.string()),
  /** Time that the order was picked up by the driver. */
  pick_up_time: z.optional(z.string()),
  /** Time that the order was delivered by the driver. */
  drop_off_time: z.optional(z.string()),
  /** ISO8601 timestamp when the order was cancelled. */
  cancelled_at_time: z.optional(z.string()),
  /** Reason why the order was cancelled. */
  cancelled_reason: z.optional(z.string()),
  /** Current latitude of the delivery driver. */
  lat: z.number(),
  /** Current longitude of the delivery driver. */
  long: z.number()
}).passthrough();
var arrivalResponse = z.object({
  /** Order ID. */
  id: z.optional(z.string()),
  /** Order total. */
  total: z.optional(z.number()),
  /** @TODO what is this value? */
  arrival_status: z.nullable(z.string())
});

// test/__fixtures__/ordering.fixtures.ts
var customerDetailsFixture = (overrides = {}) => __spreadValues({
  first_name: "Homer",
  last_name: "Simpson",
  email: "homer@simpsons.org",
  contact_number: "6365553226",
  opt_in: true,
  email_receipt: true
}, overrides);
var paymentDetailsFixture = (overrides = {}) => __spreadValues({
  id: "123",
  card_token: "123",
  masked_card: "41123xxxx123",
  alias_cc: "1234",
  alias_cvv: "123",
  amount: 1299,
  card_brand: "MasterCard",
  customer: customerDetailsFixture(),
  expiry_month: 5,
  expiry_year: 26,
  last_four: "0313",
  payment_location_id: "29",
  save: false,
  saved_account_id: null,
  stored_value_number: null,
  stored_value_pin: null,
  stored_value_requirements: [],
  tip: 200,
  type: "credit_card" /* CREDIT_CARD */,
  zip_code: "80526",
  country: "US"
}, overrides);
var orderFixture = (overrides = {}) => __spreadValues({
  id: "12345",
  subtotal: 999,
  sales_tax: 400,
  total: 1299,
  ready_at: "2022-04-22T17:30:13.221Z",
  ordered_at: "2022-04-22T15:30:13.221Z",
  order_number: "12345",
  promo_discount: 100
}, overrides);
var orderDetailsFixture = (overrides = {}) => __spreadValues({
  arrival_status: null,
  balance: 0,
  basket_id: "5b27816b-bc08-472a-92c6-528c973ed5d2",
  basket_items: [basketItemFixture()],
  client_id: "test_client_id",
  created_at: "2022-04-22T15:30:13.221Z",
  delivery_status_updated_at: null,
  delivery_status: null,
  id: "12345",
  ip: "10.219.18.1",
  is_complete: true,
  is_favorite: null,
  is_loyalty_claimed: null,
  location: locationFixture(),
  order_id: "558e99a3-6d2b-e811-a979-0afcc1bd9d86",
  order_number: "123457",
  organization_id: 123,
  payment_driver_id: 2,
  ready_at: "2022-04-22T17:30:13.221Z",
  request_id: null,
  status_id: 3,
  store_location_id: 29,
  store_location: locationFixture(),
  total: 1299,
  updated_at: "2022-04-22T15:30:13.221Z",
  user_id: null,
  order_data: {
    customer: customerDetailsFixture(),
    order: {
      arrival_status: null,
      id: "12345",
      order_items: [],
      order_number: "1234567",
      ordered_at: "2022-04-22T15:30:13.221Z",
      ready_at: "2022-04-22T17:30:13.221Z",
      sales_tax: 400,
      subtotal: 999,
      total: 1299
    },
    basket: basketV2Fixture(),
    payment: [paymentDetailsFixture()]
  }
}, overrides);
var deliveryStatusFixture = (overrides = {}) => __spreadValues({
  order_id: "123321",
  order_number: "f68cf909-fe43-4282-9f52-4d79d39043d1",
  delivery_service: "test delivery service",
  driver_name: "test driver name",
  driver_number: "502-111-11-11",
  status: "Delivered" /* DELIVERED */,
  estimated_pick_up_time: "2018-03-28T00:00:00+00:00",
  estimated_drop_off_time: "2018-03-28T00:00:00+00:00",
  pick_up_time: "2018-03-28T00:00:00+00:00",
  drop_off_time: "2018-03-28T00:00:00+00:00",
  cancelled_at_time: "2018-03-28T00:00:00+00:00",
  cancelled_reason: "",
  lat: 40.121,
  long: 40.121
}, overrides);
var savedCardFixture = (overrides = {}) => __spreadValues({
  id: "12212",
  type: "credit",
  card_type: "American Express",
  suffix: "4242",
  description: "Test card.",
  is_removable: false,
  expires: "05/26"
}, overrides);
var tokenizedCreditCardFixture = (overrides = {}) => __spreadValues({
  masked_card: "424242xxxxxx4242",
  alias_cc: "WCCx4PEYAAEAAAGAzo6Po3PiqXtxAP9F",
  alias_cvv: "XP1ggsarQZWsTSXZBZb2OZG8",
  payment_method: "VIS",
  expiry_year: 24,
  expiry_month: 12,
  country: "PL",
  last_four: "x-4242"
}, overrides);

// src/v4/api/organization.models.ts
var LOYALTY_PROGRAM_TYPES = /* @__PURE__ */ ((LOYALTY_PROGRAM_TYPES2) => {
  LOYALTY_PROGRAM_TYPES2["POINTS_CONVERT_REDEEMABLES"] = "points_convert_redeemables";
  LOYALTY_PROGRAM_TYPES2["POINTS_CONVERT_CURRENCY"] = "points_convert_currency";
  LOYALTY_PROGRAM_TYPES2["POINTS_CONVERT_REWARDS"] = "points_convert_rewards";
  LOYALTY_PROGRAM_TYPES2["SP_POINTS_CONVERT_REWARDS"] = "sp_points_convert_rewards";
  return LOYALTY_PROGRAM_TYPES2;
})(LOYALTY_PROGRAM_TYPES || {});
var LOYALTY_FEATURES = /* @__PURE__ */ ((LOYALTY_FEATURES2) => {
  LOYALTY_FEATURES2["GET_AVAILABLE_REWARDS"] = "getAvailableRewards";
  LOYALTY_FEATURES2["APPLY_REWARDS"] = "applyRewards";
  LOYALTY_FEATURES2["GET_APPLIED_REWARDS"] = "getAppliedRewards";
  LOYALTY_FEATURES2["DESTROY_REWARD"] = "destroyReward";
  LOYALTY_FEATURES2["CLAIM_REWARDS"] = "claimRewards";
  LOYALTY_FEATURES2["CLAIM_REWARDS_BY_RECEIPT"] = "claimRewardsByReceipt";
  LOYALTY_FEATURES2["INDEX_MY_REWARDS"] = "indexMyRewards";
  LOYALTY_FEATURES2["INDEX_REDEEMABLES"] = "indexRedeemables";
  LOYALTY_FEATURES2["INDEX_REDEMPTIONS"] = "indexRedemptions";
  LOYALTY_FEATURES2["CREATE_REDEMPTION_USING_REDEEMABLE"] = "createRedemptionUsingRedeemable";
  LOYALTY_FEATURES2["CREATE_REDEMPTION_USING_REWARD"] = "createRedemptionUsingReward";
  LOYALTY_FEATURES2["SHOW_LOYALTY_HISTORY"] = "showLoyaltyHistory";
  LOYALTY_FEATURES2["INDEX_LOYALTY_MESSAGES"] = "indexLoyaltyMessages";
  LOYALTY_FEATURES2["DESTROY_LOYALTY_MESSAGE"] = "destroyLoyaltyMessage";
  LOYALTY_FEATURES2["MARK_READ_LOYALTY_MESSAGE"] = "markReadLoyaltyMessage";
  LOYALTY_FEATURES2["SHOW_LOYALTY_STATE"] = "showLoyaltyState";
  LOYALTY_FEATURES2["SUPPORTS_QR"] = "supportsQR";
  LOYALTY_FEATURES2["SUPPORTS_REFERRAL_CODE"] = "supportsReferralCode";
  LOYALTY_FEATURES2["SUPPORTS_PUSH_NOTIFICATIONS"] = "supportsPushNotifications";
  LOYALTY_FEATURES2["SUPPORTS_SOCIAL_CAUSES"] = "supportsSocialCauses";
  return LOYALTY_FEATURES2;
})(LOYALTY_FEATURES || {});
var orderingTokenConfig = z.object({
  /** ID of the ordering engine. */
  driver_id: z.number(),
  /** Name of the ordering engine. Eg: `olo_full_xml`. */
  label: z.string()
});
var orgTokenConfig = z.object({
  /** ISO8601 datestamp when the brand was created. */
  created_at: z.string(),
  /** ISO8601 datestamp when the brand was deleted. */
  deleted_at: z.nullable(z.string()),
  /** External auth service used by this brand. */
  external_provider_id: z.number(),
  /** Brand ID. */
  id: z.number(),
  /** Brand name. Eg: `Koala Labs`. */
  label: z.string(),
  /** Brand Accessor/URL slug. Eg: `koala-labs`. */
  slug: z.string(),
  /** ISO8601 datestamp when the brand synced with the ordering provider. */
  last_synced_at: z.string(),
  /** ID of the loyalty engine used by this brand. */
  loyalty_driver_id: z.nullable(z.number()),
  /** URL of general nutrition information for this brand. */
  nutrition_url: z.nullable(z.string()),
  /** ID of the ordering engine used by this brand. */
  ordering_driver_id: z.number(),
  /** ISO8601 datestamp when the brand was last updated. */
  updated_at: z.string(),
  /** ID of the upsells engine used by this brand. */
  upsell_driver_id: z.number()
});
var paymentTokenConfig = z.object({
  /** ID of the payment engine. */
  driver_id: z.number(),
  /** Name of the payment engine. Eg: `pci_proxy`. */
  label: z.string()
});
var externalAuthConfig = z.object({
  /** ID of the auth provider. */
  driver_id: z.number(),
  /** Auth provider name, such as "Olo". */
  label: z.string(),
  /** Captcha configuration, if supported by the auth provider. */
  captcha: z.optional(
    z.object({ actions: z.string().array(), site_key: z.string() })
  ),
  /** Supported account features. */
  features: z.object({
    deleteStoredAddresses: z.boolean(),
    listStoredAddresses: z.boolean(),
    requiresEmailVerification: z.boolean(),
    /** Supported social login providers. Eg: "facebook" or "apple". */
    supportForLoginWithSocial: z.string().array(),
    supportsAccountDeletion: z.boolean(),
    supportsSingleFavoriteLocations: z.boolean(),
    supportsStoredAddresses: z.boolean(),
    supportsStoredCards: z.boolean(),
    updateStoredAddresses: z.boolean()
  }),
  /** Required fields for user registration. */
  registration_fields: z.object({ user: z.string().array() }),
  /** Non-modifiable account fields. Once set, they can't be changed. */
  readonly_fields: z.object({ user: z.string().array() }),
  /** User-modifiable account fields. */
  updatable_fields: z.object({ user: z.string().array() })
});
var loyaltyConfig = z.object({
  /** ID of the loyalty provider. */
  driver_id: z.number(),
  /** Loyalty provider name, such as "punchh". */
  label: z.string(),
  /** Features supported by the loyalty provider. */
  features: z.optional(z.record(z.nativeEnum(LOYALTY_FEATURES), z.boolean())),
  /** The loyalty program type—determines how rewards are earned/redeemed. */
  program_type: z.nativeEnum(LOYALTY_PROGRAM_TYPES)
});
var locationsConfig = z.object({
  features: z.object({
    isSingleLocation: z.object({
      /** This field is used when isSingleLocation is enabled otherwise it is null */
      storeLocationId: z.number().nullable(),
      /** Enables the feature */
      enabled: z.boolean()
    })
  })
});
var guestProfileConfig = z.object({
  features: z.object({
    /**
     * This flag indicates if user should be auto-enrolled all into marketing emails.
     * This will maximize the opportunity for data collection for the restaurant operators.
     * If flag is true - we pass opt_in: true with order submission data
     */
    hasImplicitOptIn: z.boolean()
  })
});
var tokenConfig = z.object({
  external_auth: z.optional(externalAuthConfig.passthrough()),
  loyalty: z.optional(loyaltyConfig.passthrough()),
  ordering: orderingTokenConfig.passthrough(),
  organization: orgTokenConfig.passthrough(),
  payment: z.optional(paymentTokenConfig.passthrough()),
  locations: locationsConfig.passthrough(),
  guest_profile: guestProfileConfig.passthrough()
});

// test/__fixtures__/token-configs.fixtures.ts
var paymentTokenConfigFixture = (overrides = {}) => __spreadValues({
  driver_id: 2,
  label: "pci_proxy"
}, overrides);
var loyaltyConfigFixture = (overrides = {}) => __spreadValues({
  driver_id: 2,
  label: "punchh_mobile_through_olo",
  features: {
    ["getAvailableRewards" /* GET_AVAILABLE_REWARDS */]: true,
    ["applyRewards" /* APPLY_REWARDS */]: true,
    ["getAppliedRewards" /* GET_APPLIED_REWARDS */]: true,
    ["destroyReward" /* DESTROY_REWARD */]: true,
    ["claimRewards" /* CLAIM_REWARDS */]: true,
    ["claimRewardsByReceipt" /* CLAIM_REWARDS_BY_RECEIPT */]: true,
    ["indexMyRewards" /* INDEX_MY_REWARDS */]: true,
    ["indexRedeemables" /* INDEX_REDEEMABLES */]: true,
    ["indexRedemptions" /* INDEX_REDEMPTIONS */]: true,
    ["createRedemptionUsingRedeemable" /* CREATE_REDEMPTION_USING_REDEEMABLE */]: true,
    ["createRedemptionUsingReward" /* CREATE_REDEMPTION_USING_REWARD */]: true,
    ["showLoyaltyHistory" /* SHOW_LOYALTY_HISTORY */]: true,
    ["indexLoyaltyMessages" /* INDEX_LOYALTY_MESSAGES */]: true,
    ["destroyLoyaltyMessage" /* DESTROY_LOYALTY_MESSAGE */]: true,
    ["markReadLoyaltyMessage" /* MARK_READ_LOYALTY_MESSAGE */]: true,
    ["showLoyaltyState" /* SHOW_LOYALTY_STATE */]: true,
    ["supportsQR" /* SUPPORTS_QR */]: true,
    ["supportsSocialCauses" /* SUPPORTS_SOCIAL_CAUSES */]: true
  },
  program_type: "points_convert_redeemables" /* POINTS_CONVERT_REDEEMABLES */
}, overrides);
var externalAuthConfigFixture = (overrides = {}) => __spreadValues({
  driver_id: 3,
  label: "Punchh Mobile Through Olo",
  features: {
    deleteStoredAddresses: true,
    listStoredAddresses: true,
    requiresEmailVerification: false,
    supportForLoginWithSocial: ["facebook", "apple"],
    supportsAccountDeletion: true,
    supportsSingleFavoriteLocations: true,
    supportsStoredAddresses: true,
    supportsStoredCards: true,
    updateStoredAddresses: true
  },
  registration_fields: {
    user: [
      "email",
      "password",
      "first_name",
      "last_name",
      "birthday",
      "phone",
      "city",
      "zip_code",
      "address_line1",
      "address_line2",
      "state",
      "country",
      "invite_code",
      "terms_and_conditions",
      "signup_channel",
      "favorite_location_id",
      "apn_token",
      "fcm_token",
      "opt_in"
    ]
  },
  readonly_fields: { user: ["email"] },
  updatable_fields: {
    user: [
      "password",
      "current_password",
      "password_confirmation",
      "first_name",
      "last_name",
      "birthday",
      "anniversary",
      "phone",
      "unsubscribed",
      "city",
      "zip_code",
      "address_line1",
      "address_line2",
      "state",
      "country",
      "gender",
      "invite_code",
      "terms_and_conditions",
      "apn_token",
      "fcm_token",
      "opt_in"
    ]
  }
}, overrides);
var orderingTokenConfigFixture = (overrides = {}) => __spreadValues({
  driver_id: 4,
  label: "olo_xml"
}, overrides);
var orgTokenConfigFixture = (overrides = {}) => __spreadValues({
  created_at: "2020-01-08T13:29:11+00:00",
  deleted_at: null,
  external_provider_id: 3,
  id: 24,
  label: "Bluth's Original Frozen Banana Stand",
  slug: "bluths-original-frozen-banana-stand",
  last_synced_at: "2022-04-16T19:00:07+00:00",
  loyalty_driver_id: 2,
  nutrition_url: "https://www.imdb.com/title/tt0367279/",
  ordering_driver_id: 4,
  updated_at: "2022-04-16T19:00:07+00:00",
  upsell_driver_id: 3
}, overrides);
var tokenConfigFixture = (overrides = {}) => __spreadValues({
  external_auth: externalAuthConfigFixture(),
  loyalty: loyaltyConfigFixture(),
  ordering: orderingTokenConfigFixture(),
  organization: orgTokenConfigFixture(),
  payment: paymentTokenConfigFixture(),
  locations: {
    features: {
      isSingleLocation: {
        enabled: false,
        storeLocationId: null
      }
    }
  },
  guest_profile: {
    features: {
      hasImplicitOptIn: false
    }
  }
}, overrides);

// test/__fixtures__/recommendations.fixtures.ts
var crossSellsOfferFixture = (overrides = {}) => __spreadValues({
  type: "addon",
  target: null,
  products: [menuProductFixture()]
}, overrides);
var crossSellsFixture = (overrides = {}) => ({
  data: __spreadValues({
    id: "12345",
    upsells_rule: "recommendations",
    upsells: [crossSellsOfferFixture()]
  }, overrides)
});
var popularProductsOfferFixture = (overrides = {}) => __spreadValues({
  type: "popular",
  score: 1,
  products: [menuProductResponseFixture()]
}, overrides);
var popularProductsFixture = (overrides = {}) => __spreadValues({
  id: "12345",
  products: [popularProductsOfferFixture()]
}, overrides);

// test/__fixtures__/organization.fixtures.ts
var organizationFixture = (overrides = {}) => __spreadValues({
  ordering: { driver_id: 4, label: "olo_xml", environment: "sandbox" },
  organization: {
    id: 23,
    created_at: "2020-01-08T13:28:42+00:00",
    updated_at: "2022-03-12T21:00:36+00:00",
    deleted_at: null,
    label: "Bluth's Original Frozen Banana Stand",
    slug: "bluths-original-frozen-banana-stand",
    ordering_driver_id: 4,
    loyalty_driver_id: 2,
    external_provider_id: 3,
    last_synced_at: "2022-03-12T21:00:36+00:00",
    nutrition_url: null,
    upsell_driver_id: 3
  },
  payment: { driver_id: 2, label: "pci_proxy", meta: [] },
  external_auth: {
    driver_id: 3,
    label: "Punchh Mobile Through Olo",
    readonly_fields: { user: ["email"] },
    features: {
      requiresEmailVerification: false,
      supportForLoginWithSocial: ["facebook", "apple"],
      supportsStoredCards: true,
      supportsSingleFavoriteLocations: true,
      // @ts-expect-error missing from SDK type.
      supportsStoredAddresses: true,
      updateStoredAddresses: true,
      listStoredAddresses: true,
      deleteStoredAddresses: true,
      supportsAccountDeletion: true
    },
    captcha: { site_key: "TEST_CAPTCHA_KEY", actions: ["login"] }
  },
  loyalty: {
    driver_id: 2,
    label: "punchh_mobile_through_olo",
    features: {
      getAvailableRewards: true,
      applyRewards: true,
      getAppliedRewards: true,
      destroyReward: true,
      claimRewards: false,
      claimRewardsByReceipt: true,
      indexMyRewards: true,
      indexRedeemables: true,
      // @ts-expect-error missing from SDK type.
      createRedemptionUsingRedeemable: true,
      createRedemptionUsingReward: true,
      indexRedemptions: true,
      showLoyaltyHistory: true,
      showLoyaltyState: true,
      indexLoyaltyMessages: true,
      markReadLoyaltyMessage: true,
      destroyLoyaltyMessage: true,
      supportsQR: true,
      supportsPushNotifications: true,
      supportsReferralCode: true,
      supportsSocialCauses: true
    },
    program_type: "points_convert_rewards" /* POINTS_CONVERT_REWARDS */
  },
  locations: {
    features: {
      isSingleLocation: {
        storeLocationId: null,
        enabled: false
      }
    }
  }
}, overrides);

// test/__fixtures__/index.ts
var requestMetaFixture = (overrides = {}) => __spreadValues({
  headers: { "x-request-origin": "sandbox.api.koala.io" }
}, overrides);

// src/v4/api/geoip.models.ts
var geoData = z.object({
  area: z.number(),
  city: z.string(),
  country: z.string(),
  eu: z.boolean(),
  ll: z.number().array(),
  metro: z.number(),
  region: z.string(),
  timezone: z.string()
});
var geoIp = z.object({
  requestIp: z.string(),
  geoData: z.nullable(geoData.passthrough())
});

// src/v4/api/loyalty.models.ts
var loyaltyState = z.object({
  /** The user's available reward points balance. */
  points: z.number(),
  /** @TODO what is this value? */
  net_points: z.number(),
  /** Id of the user's membership level. */
  membership_level_id: z.nullable(z.number()),
  /** Formatted name of the user's membership level. */
  membership_level_name: z.nullable(z.string()),
  /** @TODO what is this value? */
  banked_currency: z.number(),
  /** @TODO what is this value? */
  banked_currency_expiring: z.number(),
  /** @TODO what is this value? */
  banked_currency_expiration_date: z.nullable(z.string()),
  /** @TODO what is this value? */
  points_threshold: z.number(),
  /** @TODO what is this value? */
  conversion_rate: z.number(),
  /** @TODO improve typing. */
  rewards: z.undefined()
});
var loyaltyUser = z.object({
  /** The user's birthday. date_format:Y-m-d */
  birthday: z.nullable(z.string()),
  /** ISO8601 datestamp when the user was created. */
  created_at: z.string(),
  /** ISO8601 datestamp when the user was deleted. */
  deleted_at: z.nullable(z.string()),
  /** User's email address. */
  email: z.string(),
  /** ID of the loyalty provider the user is registered with. */
  external_provider_id: z.number(),
  /** User ID with the loyalty provider. */
  external_user_id: z.string(),
  /** User's first name. */
  first_name: z.string(),
  /** Koala User ID. */
  id: z.number(),
  /** User's unique identifier. Likely their email address. */
  identifier: z.optional(z.string()),
  /** User's last name. */
  last_name: z.string(),
  /** User's full name. */
  name: z.string(),
  /** ID of the organization this user belongs to. */
  organization_id: z.number(),
  /** User's phone number. */
  phone: z.string(),
  /** User's QR code for earning points in-store. */
  qrcode: z.nullable(z.string()),
  /** Has the user opted-in to recieving marketing emails? */
  opt_in: z.optional(z.boolean()),
  /** Signup referral code that the user can distribute. */
  referral_code: z.nullable(z.string()),
  /** ISO8601 datestamp when the user was last updated. */
  updated_at: z.string(),
  /** The user's username, if it differs from email. */
  username: z.nullable(z.string()),
  /** User's zip code */
  zip_code: z.optional(z.nullable(z.string())),
  /** ID for in-store earning and redemption */
  external_user_fk: z.nullable(z.string())
});
var messageCTA = z.object({
  type: z.string(),
  /** CTA link URL. */
  url: z.string(),
  /** CTA label text. */
  label: z.string(),
  /** Higher priority CTAs will appear first. */
  priority: z.string()
});
var messageHeroContent = z.object({
  /** Alt text for the content. */
  alt_text: z.string(),
  /** If the content is a video, this image shows behind the play button. */
  initial_frame: z.string(),
  /** The hero content can be either an image or a video. */
  type: z.string(),
  /** Content URL. */
  url: z.string()
});
var messageBackgroundContent = z.object({
  /** Alt text for the content. */
  alt_text: z.string(),
  /** If the content is a video, this image shows behind the play button. */
  initial_frame: z.string(),
  /** The background content can be either an image or a video. */
  type: z.string(),
  /** Content URL. */
  url: z.string()
});
var messageItem = z.object({
  /** Message ID. */
  id: z.string(),
  /** Message title. */
  title: z.string(),
  /** Message subtitle. */
  subtitle: z.string(),
  /** Message body text. */
  body: z.string(),
  /** Message type. Eg: `user_specific`. */
  type: z.string(),
  /** Importance level of the message. */
  rank: z.number(),
  /** ISO8601 datestamp when the message was marked as read. */
  read_at: z.nullable(z.string()),
  /**
   * ISO8601 datestamp when the message was should be shown on the client.
   * This allows brands to write messages and schedule their delivery for later.
   */
  launch_time: z.string(),
  /** Calls to Action to display at the bottom of the message. */
  message_ctas: messageCTA.passthrough().array(),
  /** Image or video shown above the message. */
  hero_content: messageHeroContent.passthrough(),
  /** Image or video shown behind the message. */
  background_content: messageBackgroundContent.passthrough()
});
var redeemableItem = z.object({
  /** Item ID. */
  id: z.number(),
  /** Item title. */
  label: z.string(),
  /** Text description of the item. */
  description: z.string(),
  /** The number of points required to redeem. */
  points_required: z.number(),
  /** @TODO what is this value? */
  meta_data: z.string(),
  /** The item's display image. */
  image: z.object({ name: z.string(), url: z.string() }).passthrough(),
  /** Flag that indicates that item can be donated or not */
  supports_donation: z.boolean()
});
var redemptionItem = z.object({
  /** Text description of the item. */
  description: z.string(),
  /** ISO8601 datestamp when the tracking_code would expire. */
  expiring_at: z.string(),
  /** Item ID. @TODO how does this differ from the `redeemable_id`?  */
  id: z.number(),
  /** The item's display image. */
  image: z.object({ name: z.string(), url: z.string() }).passthrough(),
  /** Item title. */
  label: z.string(),
  /** ID of the item being redeemed. */
  redeemable_id: z.number(),
  /** @TODO what is this value? */
  starting_at: z.string(),
  /** @TODO what is this value? */
  status: z.string(),
  /** Code entered by the end-user at checkout if they redeem in-store. */
  tracking_code: z.string()
});
var rewardHistoryItem = z.object({
  /** ISO8601 datestamp when the event took place. */
  date: z.string(),
  /** Description of the event. */
  description: z.string(),
  /** Point value, positive or negative. */
  value: z.string()
});
var rewardItem = z.object({
  /** Whether the item can be claimed in-store. */
  available_offline: z.boolean(),
  /** Whether the item can be claimed on an online order. */
  available_online: z.boolean(),
  /** Text description of the item. */
  copy: z.string(),
  /** Text description of the item. @TODO duplicate of `copy`? */
  description: z.string(),
  /** ISO8601 datestamp when the reward expires. */
  expires_at: z.string(),
  /** Item ID. */
  id: z.string(),
  /** The item's display image. */
  image: z.object({ name: z.string(), url: z.string() }).passthrough(),
  /** Item title. */
  label: z.string(),
  /** @TODO what is this value? */
  locations: z.unknown(),
  /** @TODO what is this value? */
  quantity_applied: z.number(),
  /** @TODO what is this value? */
  quantity_available: z.number(),
  /** ISO8601 datestamp when the reward becomes available. */
  starts_at: z.nullable(z.string()),
  /** Item type. Eg: `gift`. */
  type: z.string(),
  /** @TODO what is this value? */
  value: z.number(),
  /** @TODO what is this value? */
  reference: z.string(),
  /** if reward has redemption item created based on its id then there will be redemption attached to it */
  redemption: redemptionItem.passthrough().optional(),
  /** Flag that indicates that item can be donated or not */
  supports_donation: z.boolean()
}).passthrough();
var socialCause = z.object({
  /** The ID of the social cause associated with the campaign */
  id: z.number(),
  /** The name of the campaign */
  name: z.string().nullable(),
  /** A brief description of the campaign */
  description: z.string().nullable(),
  /** The URL of the campaign's image */
  image_url: z.string().nullable(),
  /** Miscellaneous information about the campaign */
  miscellaneous: z.string().nullable(),
  /** The city where the campaign is located */
  city: z.string().nullable(),
  /** The state where the campaign is located */
  state: z.string().nullable(),
  /** The street address where the campaign is located */
  street_address: z.string().nullable(),
  /** The ZIP code of the campaign's location */
  zip_code: z.string().nullable(),
  /** The phone number associated with the campaign */
  phone: z.string().nullable(),
  /** The email address associated with the campaign */
  email: z.string().nullable(),
  /** The full address of the campaign */
  address: z.string().nullable()
});
var donationTypes = z.union([
  z.literal("currency"),
  z.literal("reward"),
  z.literal("redeemable")
]);
var donation = z.object({
  /** The type of donation */
  type: donationTypes,
  /** The item being donated
   * if currency - $ amount that needs to be donated
   * if reward - reward_id of the reward that needs to be donated.
   * if redeemable - redeemable_id of the redeemable that needs to be donated.
   */
  item: z.string(),
  /** The number of occurrences of the donation */
  occurrences: z.number().nullable().optional()
});

// src/v4/api/recommendations.models.ts
var UpsellsStep = /* @__PURE__ */ ((UpsellsStep2) => {
  UpsellsStep2["add"] = "add_product";
  UpsellsStep2["checkout"] = "checkout";
  return UpsellsStep2;
})(UpsellsStep || {});
var crossSellsOffer = z.object({
  /** The type of offer. `addon` or `replace`. */
  type: z.union([z.literal("addon"), z.literal("replace")]),
  /** ID of the BasketItem that will be replaced if the offer is `replace`. */
  target: z.nullable(z.string()),
  /** Recommended menu items. */
  products: menuProduct.passthrough().array()
});
var crossSells = z.object({
  data: z.object({
    /** ID for the set of upsells presented. */
    id: z.string(),
    /** Origin of the cross-sells list. Most likely `recommendations`. */
    upsells_rule: z.string().optional(),
    /** List of product recommendations. */
    upsells: crossSellsOffer.passthrough().array()
  })
});
var popularProductsOffer = z.object({
  /** The type of offer (popular products always return `popular`) */
  type: z.literal("popular"),
  /** Popular product score, we can use this to sort the items */
  score: z.number(),
  /** Recommended menu items. */
  products: menuProductResponse.passthrough().array()
});
var popularProducts = z.object({
  /** ID for the set of popular products presented. */
  id: z.string(),
  /** Popular menu items. */
  products: popularProductsOffer.passthrough().array()
});

// src/constants/auth.ts
var APP_TYPES = {
  CMS: "CMS",
  ORDER_APP: "ORDER_APP"
};
var TOKEN_TYPES = {
  CMS: "cms",
  CMS_GUEST: "cms_guest",
  EXT_AUTH: "ext_auth",
  ORDER_APP: "order_app"
};

// src/constants/env.ts
var KoalaEnv = z.enum(["dev", "sandbox", "staging", "production"]);

// src/models/ordering/customizer.ts
var import_cloneDeep = __toESM(require_cloneDeep());
var Customizer = class {
  constructor(product, existingOptions) {
    /*
     Simple helper function that returns whether an option's parent option is selected
     */
    this.isParentOptionSelected = (parentOption) => {
      if (!parentOption) {
        return true;
      }
      return Boolean(parentOption.selected);
    };
    /*
      This is a helper function that returns an object with a `quantity` and `selected` boolean based on a variety of conditions - such as whether we're editing a product or opening up a product for the first time, and whether an option is a default. Depending on the condition, the quantity set will either be 0, 1, an existing quantity passed in, or a min_choice_quantity
     */
    this.handleOptionQuantityAndSelection = (option, optionGroup, existingOptions, parentOption) => {
      if (!existingOptions || !Object.keys(existingOptions).length) {
        return {
          quantity: option.is_default ? optionGroup.min_choice_quantity || 1 : 0,
          selected: option.is_default
        };
      }
      if (existingOptions) {
        const existingOption2 = existingOptions[option.id];
        if (existingOption2) {
          return {
            quantity: existingOption2.quantity,
            selected: true
          };
        }
      }
      if (option.is_default) {
        if (existingOptions && !this.isParentOptionSelected(parentOption)) {
          return {
            quantity: optionGroup.min_choice_quantity || 1,
            selected: true
          };
        }
      }
      return {
        quantity: 0,
        selected: false
      };
    };
    /*
       We run this function the first time we open up a product. This will tag all options with quantities and set `quantity` and `selected` status (through a helper function), and set option group validity.
    
       In addition, if the option group is a child, it will set the `parent_global_id` (useful for more complicated PDPs like Pizza Template)
       */
    this.iterateThroughTopLevelOptionGroups = (option_groups, existingOptions, parentGlobalId, parentOption) => {
      option_groups.forEach((optionGroup) => {
        optionGroup.parent_global_id = parentGlobalId || null;
        optionGroup.options.forEach((option) => {
          const { quantity, selected } = this.handleOptionQuantityAndSelection(
            option,
            optionGroup,
            existingOptions,
            parentOption
          );
          option.quantity = quantity;
          option.selected = selected;
          if (option.option_groups.length) {
            const parentGlobalId2 = optionGroup.global_id;
            this.iterateThroughTopLevelOptionGroups(
              option.option_groups,
              existingOptions,
              parentGlobalId2,
              option
            );
          }
        });
        optionGroup.total_aggregate_quantity = this.getTotalAggregateQuantity(optionGroup);
        optionGroup.valid = this.isOptionGroupValid(optionGroup);
      });
    };
    /*
     This function does quadruple duty:
     1) it iterates through the option groups and pushes them into our `surfaceable_option_groups` array, which determines what is shown to the user on the frontend. If an option is selected AND has nested option groups, those option groups will be pushed into `surfaceable_option_groups` as well.
     2) If an option is selected, it also pushes the option ID and quantity into our `options` array on the product.
     3) It will calculate the `final_price` of our product based on the base cost and any option costs.
     4) It will calculate the `final_calories` of our product based on the base calories and any option cals.
    */
    this.setOptionsSurfaceableOptionGroupsFinalPriceAndCalories = () => {
      this.product.surfaceable_option_groups = [];
      this.product.options = [];
      this.product.final_cost = this.product.cost;
      this.product.final_calories = this.product.calories;
      const iterateThroughOptionGroup = (option_groups) => {
        option_groups.forEach((optionGroup) => {
          this.product.surfaceable_option_groups.push(optionGroup);
          optionGroup.options.forEach((option) => {
            if (option.quantity > 0) {
              this.product.options.push({
                id: option.id,
                // @ts-expect-error
                quantity: option.quantity,
                cost: option.cost,
                global_option_id: option.global_option_id,
                name: option.name
              });
              this.product.final_cost = // @ts-expect-error
              this.product.final_cost + option.cost * option.quantity;
              this.product.final_calories = // @ts-expect-error
              this.product.final_calories + // @ts-expect-error
              (option.calories || 0) * option.quantity;
              if (option.option_groups.length) {
                iterateThroughOptionGroup(option.option_groups);
              }
              if (this.hasAdvancedNestedModOptionGroup(option)) {
                this.setCalorieDisplayOverride(option);
              }
            } else {
              if (this.hasAdvancedNestedModOptionGroup(option)) {
                option.calorieDisplayOverride = void 0;
              }
            }
          });
        });
      };
      iterateThroughOptionGroup(this.product.option_groups);
    };
    /*
     This function checks the validity of option groups at every point - when product is first loaded, and when a user increments or decrements an option. The `valid` tag on the option group is what we'll use to surface errors to the user on the frontend.
    */
    this.isOptionGroupValid = (optionGroup) => {
      const selectedOptions = this.getSelectedOptions(optionGroup).length;
      const justQuantitiesArray = optionGroup.options.reduce(
        (quants, opt) => {
          if (opt.selected) {
            quants.push(opt.quantity);
          }
          return quants;
        },
        []
      );
      const totalAgg = this.getTotalAggregateQuantity(optionGroup);
      const meetMinSelections = selectedOptions >= (optionGroup.min_selections || 0);
      const meetMinAggregateQuantity = totalAgg >= (optionGroup.min_aggregate_quantity || 0);
      const meetMinChoice = justQuantitiesArray.every(
        (quant) => quant >= (optionGroup.min_choice_quantity || 0)
      );
      const meetMaxSelections = selectedOptions <= (optionGroup.max_selections || optionGroup.options.length);
      const meetMaxAggregateQuantity = totalAgg <= (optionGroup.max_aggregate_quantity || Infinity);
      const meetMaxChoice = justQuantitiesArray.every(
        (quant) => quant <= (optionGroup.max_choice_quantity || Infinity)
      );
      return meetMinSelections && meetMinAggregateQuantity && meetMinChoice && meetMaxSelections && meetMaxAggregateQuantity && meetMaxChoice;
    };
    this.setIsMaxSelectionsReached = (options, value) => {
      options.forEach((option) => {
        if (!option.selected) {
          option.is_max_selections_reached = value;
        }
      });
    };
    this.isOptionGroupMaxSelectionsReached = (optionGroup) => {
      const numberOfSelectedOptions = this.getSelectedOptions(optionGroup).length;
      return !!optionGroup.max_selections && numberOfSelectedOptions >= optionGroup.max_selections && numberOfSelectedOptions > 1;
    };
    this.isOptionGroupMaxAggregateQuantityReached = (optionGroup) => !!optionGroup.max_aggregate_quantity && !!optionGroup.total_aggregate_quantity && optionGroup.total_aggregate_quantity >= optionGroup.max_aggregate_quantity;
    this.getSelectedOptions = (optionGroup) => optionGroup.options.filter((opt) => opt.selected);
    this.getTotalAggregateQuantity = (optionGroup) => (
      // @ts-expect-error
      this.getSelectedOptions(optionGroup).map((option) => option.quantity).reduce((total, quantity) => total + quantity, 0)
    );
    /*
     Helper function that unselects the previously selected option if there's a max_selection of 1
     */
    this.unselectPrevOptionIfMaxOfOne = (optionGroup, optionId) => {
      const firstSelectedOptionInGroup = optionGroup.options.find(
        (opt) => opt.selected
      );
      if (firstSelectedOptionInGroup && optionId !== firstSelectedOptionInGroup.id) {
        this.decrementOption(firstSelectedOptionInGroup.id, true);
      }
    };
    this.product = (0, import_cloneDeep.default)(product);
    this.tagProductWithNeededProps(existingOptions);
  }
  /*
   Simple getter that returns our product
   */
  getProduct() {
    return this.product;
  }
  /*
     We run this function when a user increments an option. We loop through the product to find the corresponding option ID, then increment the option quantity by either 1 or min_choice_quantity, as long as it stays within our min/max limits.
  
     Upon incrementing, we also update `selected` to true and check option group validity every time. We also set the updated `surfaceable_option_groups` on every increment.
     */
  incrementOption(optionId, fixedQuantity) {
    return this.loopThroughOptionGroup(optionId, (optionGroup, option) => {
      const incrementor = !fixedQuantity ? calculateIncrementor(option, optionGroup) : 0;
      if (optionGroup.max_selections === 1) {
        this.unselectPrevOptionIfMaxOfOne(optionGroup, optionId);
      }
      if (!optionGroup.max_choice_quantity || // @ts-expect-error
      option.quantity + incrementor <= optionGroup.max_choice_quantity) {
        option.quantity = fixedQuantity || option.quantity + incrementor;
        optionGroup.total_aggregate_quantity += incrementor;
        option.selected = true;
        optionGroup.valid = this.isOptionGroupValid(optionGroup);
        if (this.isOptionGroupMaxSelectionsReached(optionGroup)) {
          this.setIsMaxSelectionsReached(optionGroup.options, true);
        }
        if (this.isOptionGroupMaxAggregateQuantityReached(optionGroup)) {
          optionGroup.is_max_aggregate_quantity_reached = true;
        }
      }
    });
  }
  /*
     Similar to our increment function, but a little more lenient, following KoalaKit's model.
  
     We allow a user to decrement a choice even if it breaks our minimums - otherwise a user would never be able to change their mind on an option. Even if a user doesn't meet minimums, our validity check on the option group will return false anyway.
  
     We also set the updated `surfaceable_option_groups` on every decrement. `setToZero` is an optional boolean that will set the quantity to 0 instead of decrementing by 1, used for when a user completely unselects an option that previously had a quantity.
     */
  decrementOption(optionId, setToZero) {
    return this.loopThroughOptionGroup(optionId, (optionGroup, option) => {
      const choiceQuantityIncrement = setToZero ? option.quantity : optionGroup.choice_quantity_increment || 1;
      if (option.quantity - choiceQuantityIncrement >= 0) {
        option.quantity = option.quantity - choiceQuantityIncrement;
        option.selected = option.quantity > 0;
        optionGroup.total_aggregate_quantity -= choiceQuantityIncrement;
        optionGroup.valid = this.isOptionGroupValid(optionGroup);
        if (!this.isOptionGroupMaxSelectionsReached(optionGroup)) {
          this.setIsMaxSelectionsReached(optionGroup.options, false);
        }
        if (!this.isOptionGroupMaxAggregateQuantityReached(optionGroup)) {
          optionGroup.is_max_aggregate_quantity_reached = false;
        }
      }
    });
  }
  hasAdvancedNestedModOptionGroup(option) {
    return option.contains_adv_nested_modifiers;
  }
  isAdvancedNestedModOptionGroup(optionGroup) {
    return optionGroup.is_adv_nested_modifier;
  }
  /*
   This is a helper function that's shared between `incrementOption` and `decrementOption` - it separates out the looping behavior that's reused between the two functions
   */
  loopThroughOptionGroup(optionId, handleMatchingOption) {
    const iterateThroughOptionGroup = (option_groups) => {
      option_groups.forEach((optionGroup) => {
        optionGroup.options.forEach((option) => {
          if (option.id === optionId) {
            handleMatchingOption(optionGroup, option);
          }
          if (option.option_groups.length) {
            iterateThroughOptionGroup(option.option_groups);
          }
        });
      });
    };
    iterateThroughOptionGroup(this.product.option_groups);
    this.setOptionsSurfaceableOptionGroupsFinalPriceAndCalories();
    return this.product;
  }
  /*
     This is our comprehensive function for when we first open the product. It will run `iterateThroughTopLevelOptionGroups`, which tags our product with the necessary props, such as quantity, valid, selected, etc.
  
     Then it will set `surfaceable_option_groups` on the product. The optional `existingOptions` params is for when we are instantiating a Customizer class with existing options and quantities - i.e. editing a product.
     */
  tagProductWithNeededProps(existingOptions) {
    this.iterateThroughTopLevelOptionGroups(
      this.product.option_groups,
      existingOptions
    );
    this.setOptionsSurfaceableOptionGroupsFinalPriceAndCalories();
    return this.product;
  }
  /**
   * Sets the options calorie display override based on the selected advanced modifier options.
   */
  setCalorieDisplayOverride(option) {
    option.calorieDisplayOverride = void 0;
    const advancedModOptionGroup = option.option_groups.find(
      (group) => this.isAdvancedNestedModOptionGroup(group)
    );
    if (advancedModOptionGroup) {
      let additionalCalories = 0;
      advancedModOptionGroup.options.forEach((advancedModOption) => {
        if (advancedModOption.quantity && advancedModOption.quantity > 0) {
          additionalCalories += (advancedModOption.calories || 0) * advancedModOption.quantity;
        }
      });
      if (additionalCalories > 0) {
        option.calorieDisplayOverride = additionalCalories + (option.calories || 0);
      }
      if (!option.calorieDisplayOverride && !option.calories) {
        option.calorieDisplayOverride = advancedModOptionGroup.options.filter(
          (advancedModOption) => advancedModOption.is_default
        )[0].calories || 0;
      }
    }
  }
};

// src/types/errors/not-modified-error.ts
var NotModified = class _NotModified extends Error {
  constructor() {
    super("The requested resource has not been modified.");
    Object.setPrototypeOf(this, _NotModified.prototype);
  }
};

// src/types/errors/stale-session-error.ts
var StaleSession = class _StaleSession extends Error {
  constructor() {
    super("Refreshing to load the latest version.");
    Object.setPrototypeOf(this, _StaleSession.prototype);
  }
};

// src/types/gen/strings.fallback.ts
var fallbackStrings = {
  login: {
    cta: "Sign In",
    header: "Welcome!",
    prompt: "Already have an account?",
    subheader: "Please enter your email and password to log in.",
    cta_loading: "Submitting"
  },
  signup: {
    cta: "Sign Up",
    header: "Welcome!",
    opt_in: "Yes, I would like to receive emailed information and offers from $brandName$",
    prompt: "Don't have an account?",
    subheader: "Sign Up Below",
    cta_loading: "Submitting",
    accept_terms_conditions: 'By signing up, I accept the <a target="_blank" href="https://koala-configurations.s3.us-east-1.amazonaws.com/public/assets/Chowly-Terms-and-Conditions-b3cca027-acb6-42db-9d1f-11080e29b1e1.pdf">Terms and Conditions</a> and <a target="_blank" href="https://koala-configurations.s3.us-east-1.amazonaws.com/public/assets/Chowly-Privacy-Policy-202f4118-faeb-4593-8574-57dc447ae203.pdf">Privacy Policy</a> of $brandName$',
    email_verification_text: "Thank you for signing up! A message has been sent to your email. Please verify your email address to complete your account setup.",
    email_verification_header: "Thank you!"
  },
  forgot_password: {
    header: "Welcome!",
    prompt: "Forgot Password?",
    subheader: "Please enter your email to reset your password.",
    submit_cta: "Submit",
    submit_cta_loading: "Submitting"
  },
  locations: {
    subheader: "Search or view nearby locations below",
    no_results: "There are no $brandName$s in your area yet!",
    search_cta: "Search",
    header_user: "Welcome back, $first_name$",
    header_guest: "Welcome",
    search_start_cta: "To find a $brandName$ store, enter city, state, or zip code above.",
    all_locations_cta: "View All Locations",
    location_inactive: "Not currently accepting online orders.",
    cross_street_label: null,
    search_cta_loading: "Searching",
    search_placeholder: "Enter your zip code",
    incomplete_address_text: "Your address must include $missingAddressFields$",
    search_tab_default_text: "Pickup",
    search_tab_delivery_text: "Delivery",
    delivery_search_placeholder: "Enter your address",
    loyalty_module_signed_in_cta: "View Rewards",
    delivery_search_addresses_cta: "Order",
    delivery_search_no_results_text: "We\u2019re sorry, no locations currently deliver to this address. Please try again or look for nearby locations offering pickup.",
    loyalty_module_signed_in_header: "Congrats! You have a total of $points$ points.",
    google_address_not_selected_text: "Please select an address from the dropdown to continue.",
    loyalty_module_signed_out_header: "Join rewards and start earning points!",
    delivery_search_instructional_text: "Enter your full street address to start your delivery order.<br /><br />Bldg/Suite/Apt info and delivery instructions (cross street, buzzer#, etc) added at checkout.",
    loyalty_module_signed_out_join_cta: "Join Now",
    loyalty_module_signed_out_learn_cta: "How Rewards Work",
    loyalty_module_signed_in_header_no_points: "Order now to start earning points!"
  },
  location_ctas: {
    fifth_label: null,
    fifth_value: null,
    ninth_label: null,
    ninth_value: null,
    sixth_label: null,
    sixth_value: null,
    third_label: null,
    third_value: null,
    eighth_label: null,
    eighth_value: null,
    fourth_label: null,
    fourth_value: null,
    primary_label: "Order Now",
    primary_value: "$pickupUrl$",
    seventh_label: null,
    seventh_value: null,
    secondary_label: null,
    secondary_value: null,
    overflow_modal_headline: null,
    overflow_modal_subheadline: null,
    overflow_modal_trigger_label: null
  },
  store: {
    banner: "This location is currently closed and opens at $openHours$. You will be able to choose your $conveyanceType$ time at checkout!",
    back_to_top_cta: "Back <br /> To Top",
    menu_disclaimer: null,
    menu_descriptors: null,
    nutrition_url_cta: "Nutrition Information",
    food_hall_headline: null,
    ordering_from_copy: "Ordering From",
    search_placeholder: "Search Menu",
    location_detail_button: "(see location info)",
    popular_products_header: "Popular Items",
    search_no_results_header: "No search results for $searchTerm$",
    search_no_results_subheader: "Please try searching for something else"
  },
  delivery: {
    modal_header: "Delivery Information",
    modal_submit_cta: "Continue",
    add_new_address_cta: "Add New Address",
    switch_to_pickup_cta: "Continue",
    stick_with_pickup_cta: "Stick with pickup",
    switch_to_delivery_cta: "Continue",
    stick_with_delivery_cta: "Stick with delivery",
    switch_to_pickup_header: "Switch to pickup?",
    address_details_subheader: "Address Details",
    switch_to_delivery_header: "Switch to delivery?",
    switch_to_pickup_subheader: "Are you sure you want to change your order type from delivery to pickup?",
    switch_to_delivery_subheader: "Are you sure you want to change your order type from pickup to delivery? We\u2019ll need you to enter in your address to ensure this location can deliver to you."
  },
  cart_checkout: {
    cta: "Cart",
    header: "Your Order",
    add_text: "Add to cart",
    custom_tip: "Custom",
    guest_opt_in: "Please send me $brand$ emails about offers and updates",
    dine_in_header: "Dine In",
    rewards_header: "Available Rewards",
    drive_in_header: "Drive In",
    back_to_menu_cta: "Back to Menu",
    submit_order_cta: "Place Order",
    cart_items_header: "Selected Items",
    drive_thru_header: "Drive Thru",
    edit_order_button: "Edit Order",
    rewards_subheader: "You have $number$ available rewards for this order",
    your_order_header: "Your Order",
    guest_checkout_cta: "Checkout as Guest",
    apply_reward_button: "Apply Reward",
    change_location_cta: "Change Location",
    dine_in_instructions: "Please enter your table number here. Your food will be brought to you when it's ready!",
    dine_in_table_number: "Table Number",
    logout_from_checkout: "Switch Account",
    store_address_header: "Ordering from:",
    submit_order_loading: "Processing",
    drive_in_instructions: "Enter your parking spot number below. When your order is ready, a member of our team will bring it out to your car!",
    escape_table_order_cta: "Not in store? Click here to update your order.",
    handoff_details_header: "Handoff Details",
    return_to_auth_screens: "Sign In or Sign Up",
    delivery_address_header: "Delivering to:",
    email_verification_text: "Please check your email to verify your account and proceed. If you checkout prior to verifying your account, you will not receive credit for this order.",
    utensils_checkbox_label: "Disposable Plates & Utensils?",
    your_information_header: "Your Information",
    continue_to_checkout_cta: "Checkout",
    guest_checkout_edit_info: "Edit Your Info",
    basket_instructions_add_cta: "Add Special Instructions",
    change_delivery_address_cta: "Change Delivery Address",
    guest_checkout_continue_cta: "Continue as Guest",
    delivery_min_not_met_message: "There is a $delivery_minimum$ minimum for delivery orders.",
    drive_in_parking_spot_number: "Parking Spot Number",
    order_submitting_message_text: "Hang tight, your order is processing. Please do not refresh this page.",
    basket_instructions_form_header: "Special Instructions",
    dine_in_table_number_submit_cta: "Apply",
    basket_instructions_apply_button: "Save",
    basket_instructions_input_placeholder: "Enter Special Instructions for this order.",
    handoff_details_pickup_details_header: "Pickup Address",
    dine_in_table_number_input_placeholder: "Table Number",
    drive_in_parking_spot_number_submit_cta: "Apply",
    handoff_details_delivery_details_header: "Delivery Address",
    drive_in_parking_spot_number_input_placeholder: "Parking Spot Number",
    accept_terms_conditions: "By Clicking $submitCta$, I accept the Terms and Conditions and Privacy Policy"
  },
  pickup_mode: {
    header: "Pickup Mode",
    curbside_cta: "Curbside",
    in_store_cta: "In Store",
    curbside_header: "Your Vehicle Info",
    instructions_header: "Pickup Instructions",
    curbside_helper_text: null,
    curbside_vehicle_info_apply_cta: "Apply",
    curbside_vehicle_make_placeholder_text: "Vehicle Make",
    curbside_vehicle_color_placeholder_text: "Vehicle Color",
    curbside_vehicle_model_placeholder_text: "Vehicle Model"
  },
  remove_item: {
    cta: "Remove",
    confirm_prompt: "<span>Are you sure you want to remove</span><br /> $productToRemove$?"
  },
  empty_cart: {
    header: "Your cart is empty",
    back_cta: "Back",
    subheader: "Get started and add some tasty food"
  },
  cross_sell: {
    header: "Complete Your Meal",
    subheader: "Add a drink or side for a full meal."
  },
  handoff_time: {
    order_info_header: "$fulfillmentType$ Time",
    no_available_times: "No availability found today or tomorrow. Please check back at another time.",
    asap_select_option_text: "ASAP",
    no_available_basket_times: "We're sorry, this restaurant is not accepting orders for $date$. Please try another date!",
    loading_text: "Loading available times..."
  },
  checkout_delivery_details: {
    header: "Delivery Details",
    edit_address_cta: "Edit Delivery Address",
    update_address_cta: "Update",
    edit_apartment_number: "Edit",
    apply_instructions_cta: "Apply",
    delivery_instructions_header: "Delivery Instructions:",
    delivery_instructions_placeholder: "e.g. Buzz apartment 3B",
    apartment_number_input_placeholder: "Apt/Floor/Suite (optional)",
    apartment_number_tooltip_instructions: "Add your apartment number or suite below. To change your delivery address, return to the menu."
  },
  dietary_preferences: {
    modal_cta: "Update Preferences",
    menu_trigger: "Dietary Preferences",
    modal_eyebrow: "Dietary Preferences",
    modal_headline: "Have A Preference Or Restriction?",
    modal_disclaimer: "*Our gluten-free items are prepared in a common kitchen with the risk of gluten exposure. We do not recommend our gluten-free items for customers with Celiac or any other gluten-sensitive disease. <br /> *No menu items contain fish, shellfish or sulphites",
    modal_subheadline: "Select from these options and items with those properties will be flagged."
  },
  promo: { cta: "Apply", placeholder: "Enter Coupon Code" },
  product_details: {
    special_instructions_header: "Special Instructions",
    special_instructions_subheader: "Enter special instructions below and we'll do our best",
    special_instructions_placeholder: "Ex: no dressing",
    min_quantity_info: "Min: $minQuantity$"
  },
  payment: {
    header: "Payment Info",
    new_card_button: "New Card",
    gift_card_header: "Gift Card",
    apply_new_card_cta: "Apply Payment",
    gift_card_apply_cta: "Apply",
    pay_in_store_button: "Pay in Store (cash)",
    gift_card_remove_button: "Remove",
    save_card_checkbox_text: "Save credit card for future purchases",
    delete_card_confirm_text: "Are you sure you want to delete this card?"
  },
  add_tip: { header: "Add Tip:" },
  order_confirmation: {
    header: "Order Confirmation",
    subheader: "Order scheduled for $fulfillmentType$ $readyAtDate$ at $readyAtTime$",
    order_instructions: "Walk up to the pickup area and give your first and last name.",
    dine_in_instructions: "Grab a seat and when your order is ready, a member of our team will call out your name. Enjoy!",
    curbside_instructions: "Please park in one of the dedicated curbside pickup parking spots and a member of our staff will assist you.",
    delivery_instructions: null,
    drive_in_instructions: "Stay in your designated spot. When your order is ready, a member of our team will bring it out to your car!",
    drive_thru_instructions: "Please proceed through the Drive Thru lane when your order is ready to collect your meal!",
    dine_in_table_number_instructions: "Don\u2019t forget to take your table number to your seat! When your order is ready, a member of our team will bring it to your table. Enjoy!"
  },
  global_header: { sign_in_cta: "Sign In/Join" },
  account: {
    title: "Account",
    header: "Account",
    birthday_header: "My Birthday",
    sign_out_button: "Sign Out",
    addresses_header: "My Addresses",
    contact_info_header: "Contact Information",
    birthday_edit_button: "Edit Your Birthday",
    referral_code_header: "Personal invite code:",
    birthday_instructions: "Add your birthday",
    reset_password_header: "Reset Password",
    change_password_button: "Submit",
    change_password_header: "Change Your Password",
    addresses_delete_button: "Remove address",
    addresses_default_button: "Save as default",
    contact_info_edit_button: "Edit Your Info",
    reset_password_subheader: "Please enter and confirm your new password. Please note that any credit card details stored on your account will be cleared for your security.",
    reset_password_submit_cta: "Submit",
    referral_code_instructions: "Use this personal referral code to invite your friends and qualify for rewards!",
    add_favorite_location_button: "Add favorite location",
    add_favorite_location_header: "Favorite Location",
    favorite_location_modal_header: "Add a favorite location",
    addresses_delete_success_message: "Your address has been removed!",
    favorite_location_modal_subheader: "Favorite location can be changed at any time.",
    referral_code_instructions_header: "Referral Code",
    addresses_special_instructions_text: "Special Instructions: $specialInstructions$",
    addresses_set_default_success_message: "Default address set!"
  },
  arrival_notification: {
    notify_cta: "I'm here",
    failure_cta: "Retry",
    failure_text: "Once we receive your notification, a member of our team will bring your order out to your car.",
    success_text: "We will bring out your meal shortly.",
    failure_header: "We're sorry, your arrival notification didn't go through. Please try again!",
    success_header: "Thanks for letting us know you've arrived.",
    instructions_text: "Your order has been confirmed. When you arrive, please let us know you're here so the store knows to bring your food to you.",
    instructions_header: "$fulfillmentType$ Instructions"
  },
  order_history: {
    title: "Order History",
    header: "Order History",
    reorder_button: "Reorder",
    view_reciept_button: "View Receipt",
    orders_empty_state_header: "You haven't placed any orders yet!",
    orders_empty_state_subheader: ""
  },
  favorites: {
    title: "Favorites",
    orders_header: "My Favorite Orders",
    locations_header: "My Favorite Locations",
    orders_empty_state_header: "No favorite orders yet!",
    locations_empty_state_header: "No favorite locations yet!",
    orders_empty_state_subheader: "",
    locations_empty_state_subheader: ""
  },
  inbox: { title: "Inbox", empty_state: "No new messages, check back soon!" },
  rewards: {
    title: "Rewards",
    offers_header: "Offers",
    learn_more_url: null,
    rewards_counter: "point",
    no_offers_header: "Coming Soon!",
    order_now_button: "Order Now",
    learn_more_button: "How Rewards Work",
    learn_more_header: "Learn More About $brand$ Rewards",
    my_rewards_header: "My Rewards",
    no_rewards_header: "Order now to start earning points!",
    maximum_tier_header: "Total available points: $points$",
    no_offers_subheader: "Offers will be updated periodically.",
    donate_reward_button: "Donate Reward",
    enter_barcode_button: "Enter Receipt Barcode",
    enter_barcode_header: "Forgot to Scan Your Rewards Code?",
    my_rewards_subheader: "Earn points to unlock rewards",
    point_history_button: "View Points History",
    point_history_header: "My Points History",
    banked_currency_header: "My Rewards",
    maximum_tier_subheader: "Keep earning points to gain more rewards!",
    points_meter_subheader: "$number$ $counter$ until your next reward",
    redeem_in_store_button: "Redeem In Store",
    barcode_success_message: "Congratulations! You've earned $points$ points on this purchase!",
    donate_reward_error_text: "Your reward was unable to be donated. Please try again.",
    banked_currency_subheader: "Earn points to gain banked currency!",
    pending_points_disclaimer: "Points can take up to 24 hours to be added",
    donate_reward_modal_header: "Donate Reward",
    donate_reward_success_text: "Your reward has been donated to $socialCauseName$. Thank you!",
    earn_in_store_modal_header: "$brand$ Rewards",
    enter_barcode_modal_header: "Forgot to Scan?",
    point_history_modal_header: "My Points History",
    banked_currency_card_header: "Your Total Banked Currency",
    redeem_in_store_modal_header: "$brand$ Rewards",
    account_menu_points_subheader: "$number$ reward $counter$",
    donate_reward_modal_subheader: "Please select a social cause from the list below.",
    enter_barcode_disclaimer_text: "Points can take up to 24 hours to be added",
    enter_barcode_placeholder_text: "Enter Barcode",
    points_history_modal_empty_CTA: "Order Now",
    banked_currency_expiration_text: "$currency$ expiring on $date$",
    banked_currency_empty_state_text: "Almost there! Order now to gain more points.",
    earn_in_store_instructional_text: "Scan before paying in the restaurant to earn points for your order",
    enter_barcode_instructional_text: "We got you! Enter the barcode number on your receipt to earn points.",
    donate_reward_modal_donate_button: "Donate",
    points_history_modal_empty_header: "Looks like you have no earning history yet.",
    redeem_in_store_instructional_text: "Scan before paying in the restaurant to use this reward",
    user_summary_membership_level_text: "You made it to $level$!",
    points_history_modal_empty_subheader: "Place an order to start earning!",
    user_summary_total_available_points_text: "Total available points: $points$"
  },
  reorders: {
    reorder_cta: "Reorder",
    add_to_cart_cta: "Add to Cart",
    new_order_title: "Start a New Order",
    recent_orders_title: "Recent Orders",
    view_all_past_orders_cta: "View All Orders"
  },
  android_home: {
    inbox: "Inbox",
    reorder: "Recent Orders",
    rewards: "$brand$ Rewards",
    sign_in: "Sign in",
    order_now: "Order Now",
    header_user: "Welcome back, $user$!",
    header_guest: "Welcome to $brand$",
    redeem_rewards: "Redeem Now",
    sub_header_user: "You have a total of $points$ points!",
    sub_header_guest: "Sign in to earn points and receive exclusive rewards!",
    my_account_no_loyalty: "My Account",
    sub_header_user_no_loyalty: "View your account for recent orders, stored addresses and more!",
    sub_header_guest_no_loyalty: "Sign in to access your account"
  },
  android_drawer: {
    account: "Account",
    sign_out: "Sign Out",
    favorites: "Favorites",
    locations: "Locations",
    user_title: "Hi, $user$!",
    guest_title: "Welcome!",
    order_history: "Order History",
    route_one_url: null,
    route_two_url: null,
    guest_subtitle: "Sign in to earn rewards",
    privacy_policy: "Privacy Policy",
    route_one_name: null,
    route_two_name: null,
    route_three_url: null,
    route_three_name: null,
    user_points_total: "$points$ rewards points",
    privacy_policy_url: "https://koala.io/privacy",
    terms_and_conditions: "Terms & Conditions",
    terms_and_conditions_url: "https://koala.io/terms",
    guest_subtitle_no_loyalty: "Sign in to access your favorites and order history"
  },
  dispatch_tracking: {
    header: "We\u2019ve received your order, $name$!",
    subheader: "Your order is estimated to arrive at $eta$",
    error_header: "Something went wrong",
    pending_header: "Order Received",
    canceled_header: "Looks like your order has been canceled. Please call $storePhone$ for more details.",
    error_subheader: "We\u2019re currently unable to track your order. Please call $storePhone$ for more information.",
    delivered_header: "Order Delivered",
    pending_subheader: "$storeName$ has received your order #$number$",
    returned_subheader: "Looks like your order is being returned. Please call $storePhone$ for more details.",
    delivered_subheader: "Your order has been delivered!",
    out_for_delivery_header: "Out for Delivery",
    pickup_in_progress_header: "Pickup in Progress",
    out_for_delivery_subheader: "$courierName$ is heading your way!",
    pickup_in_progress_subheader: "$courierName$ is picking up your order."
  }
};

// src/v4/api/basket.service.ts


// src/v4/core/utils.ts

var token = z.object({
  token_type: z.literal("Bearer"),
  expires_in: z.number(),
  access_token: z.string(),
  scopes: z.string().array(),
  refresh_token: z.string().optional(),
  refresh_token_expires_in: z.number().optional()
});

// src/v4/api/basket.service.ts
var basketResponse = z.object({ data: basket });

// src/v4/api/communication.model.ts
var contactResponse = z.object({
  // add response values here
});

// src/v4/core/client.ts



// src/v4/core/auth.ts


// src/types/gen/web-config.fallback.ts
var fallbackConfig = {
  admin: { food_hall: false },
  global: {
    favicon: "https://koala-configurations.s3.us-east-1.amazonaws.com/public/assets/new-favicon-4c847042-6417-48a1-8ad3-871e5c000eb6.png",
    body_color: "#ffffff",
    error_color: "#d82c0d",
    border_radius: 8,
    success_color: "#008060",
    footer_enabled: true,
    loading_bar_color: "#ff6e47",
    google_fonts_css_url: null,
    primary_active_color: "#ff6e47",
    primary_border_color: "#e6e6e6",
    secondary_body_color: "#fafafa",
    radar_maps: false,
    loyalty_accessor: true,
    default_conveyance_type: 0 /* PICKUP */,
    us_only: true
  },
  accounts: {
    birthday: "disabled",
    reorders: true,
    zip_code: "disabled",
    barcode_scan: false,
    rewards_icon: null,
    nav_font_size: null,
    disable_accounts: false,
    stored_addresses: true,
    favorite_location: "disabled",
    opt_in_auto_select: true,
    punchh_referral_code_field: false
  },
  text: {
    primary_font: {
      color: "#111111",
      font_size: 15,
      font_style: "normal",
      font_family: '"Montserrat-Regular", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    secondary_font: {
      color: "#111111",
      font_size: 24,
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 700,
      line_height: "normal"
    },
    primary_text_size: 15,
    primary_text_color: "#111111",
    secondary_text_size: 24,
    secondary_text_color: "#111111"
  },
  primary_font: {
    bold: {
      color: "#222222",
      font_size: 16,
      font_style: "normal",
      font_family: '"Montserrat-Regular", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    light: {
      color: "#222222",
      font_size: 16,
      font_style: "normal",
      font_family: '"Montserrat-Regular", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    medium: {
      color: "#222222",
      font_size: 16,
      font_style: "normal",
      font_family: '"Montserrat-Regular", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    regular: {
      color: "#222222",
      font_size: 16,
      font_style: "normal",
      font_family: '"Montserrat-Regular", sans-serif',
      font_weight: 400,
      line_height: "normal"
    }
  },
  secondary_font: {
    bold: {
      color: "#222222",
      font_size: 16,
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    light: {
      color: "#222222",
      font_size: 16,
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    medium: {
      color: "#222222",
      font_size: 16,
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    regular: {
      color: "#222222",
      font_size: 16,
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 400,
      line_height: "normal"
    }
  },
  primary_font_family: {
    bold: '"Montserrat-Regular", sans-serif',
    light: '"Montserrat-Regular", sans-serif',
    medium: '"Montserrat-Regular", sans-serif',
    regular: '"Montserrat-Regular", sans-serif'
  },
  secondary_font_family: {
    bold: '"Montserrat-Bold", sans-serif',
    light: '"Montserrat-Bold", sans-serif',
    medium: '"Montserrat-Bold", sans-serif',
    regular: '"Montserrat-Bold", sans-serif'
  },
  header: {
    font: {
      color: "#1a1a1a",
      font_size: 16,
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 700,
      line_height: "normal"
    },
    logo: null,
    cart_icon: "https://koala-configurations.s3.us-east-1.amazonaws.com/public/assets/Updated-Header-Cart-Icon-f555ffcc-7469-4c72-a339-99a78b048690.svg",
    font_size: 16,
    font_color: "#1a1a1a",
    font_family: '"Montserrat-Bold", sans-serif',
    account_icon: null,
    border_color: "#e6e6e6",
    logo_cta_url: "",
    border_radius: null,
    background_color: "#ffffff",
    background_image: null,
    active_font_color: "#ffffff",
    back_to_menu_icon: null,
    mobile_logo_width: 80,
    desktop_logo_width: 120,
    navigation_display: "hidden",
    active_border_color: "#dd6d4f",
    active_background_color: "#dd6d4f"
  },
  buttons: {
    primary_font: {
      color: null,
      font_size: "revert",
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 700,
      line_height: "normal"
    },
    knockout_font: {
      color: "#1a1a1a",
      font_size: "revert",
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 700,
      line_height: "normal"
    },
    secondary_font: {
      color: null,
      font_size: "revert",
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 700,
      line_height: "normal"
    },
    primary_button_text_color: null,
    knockout_button_text_color: "#1a1a1a",
    primary_button_font_family: '"Montserrat-Bold", "Sans-Serif"',
    knockout_button_font_family: '"Montserrat-Bold", "Sans-Serif"',
    primary_button_border_color: "#dd6d4f",
    secondary_button_text_color: null,
    knockout_button_border_color: "#1a1a1a",
    primary_button_border_radius: 8,
    secondary_button_font_family: '"Montserrat-Bold", "Sans-Serif"',
    knockout_button_border_radius: 8,
    secondary_button_border_color: "#1a1a1a",
    secondary_button_border_radius: 8,
    primary_button_background_color: "#dd6d4f",
    primary_button_text_hover_color: null,
    knockout_button_background_color: "#ffffff",
    knockout_button_text_hover_color: "#111111",
    primary_button_border_hover_color: null,
    secondary_button_background_color: "#1a1a1a",
    secondary_button_text_hover_color: null,
    knockout_button_border_hover_color: null,
    secondary_button_border_hover_color: null,
    primary_button_background_hover_color: null,
    knockout_button_background_hover_color: "#ffffff",
    secondary_button_background_hover_color: null
  },
  forms: {
    font: {
      color: "#111111",
      font_size: 15,
      font_style: "normal",
      font_family: '"Montserrat-Regular", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    font_size: 15,
    font_color: "#111111",
    font_family: '"Montserrat-Regular", sans-serif',
    border_color: "#909090",
    field_height: 48,
    border_radius: 8,
    background_color: "#ffffff",
    placeholder_color: "#dedede"
  },
  modals: {
    font: {
      color: "#111111",
      font_size: 15,
      font_style: "normal",
      font_family: '"Montserrat-Regular", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    font_size: 15,
    font_color: "#111111",
    font_family: '"Montserrat-Regular", sans-serif',
    border_color: "#dedede",
    footer_color: null,
    border_radius: 8,
    tertiary_font: {
      color: "#111111",
      font_size: 15,
      font_style: "normal",
      font_family: '"Montserrat-Regular", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    secondary_font: {
      color: "#111111",
      font_size: 24,
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 700,
      line_height: "normal"
    },
    background_color: "#ffffff",
    active_font_color: "#335ece",
    tertiary_font_size: 15,
    active_border_color: "#ff6e47",
    secondary_font_size: 24,
    tertiary_font_color: "#111111",
    secondary_font_color: "#111111",
    tertiary_font_family: '"Montserrat-Regular", sans-serif',
    secondary_font_family: '"Montserrat-Bold", sans-serif',
    active_background_color: "#ff6e47"
  },
  locations: {
    map_key: "AIzaSyC2eV_110jEYm9HjK5bYbzGgQhGgaKHDBU",
    map_icon: null,
    cross_street: false,
    list_display: "group",
    map_position: "right",
    delivery_search: true,
    map_icon_active: null,
    location_id_source: "koala_id",
    disable_locations_page: false,
    geoip: false,
    location_banner_targeting_enabled: false
  },
  store_detail: {
    text_color: "#1a1a1a",
    hero_height: 375,
    active_color: "#dd6d4f",
    background_color: "#ffffff",
    background_image: "https://koala-configurations.s3.us-east-1.amazonaws.com/public/assets/testhero3-marketing-production-2943.jpeg",
    mobile_background_color: "#ffffff"
  },
  store_banner: {
    font: {
      color: null,
      font_size: 15,
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 700,
      line_height: "normal"
    },
    display: "never",
    font_size: 15,
    placement: "top",
    font_color: null,
    font_family: '"Montserrat-Bold", "Sans-Serif"',
    border_color: "#dd6d4f",
    background_color: "#dd6d4f"
  },
  menu_categories: {
    category_nav_font: {
      color: "#1a1a1a",
      font_size: "revert",
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 700,
      line_height: "normal"
    },
    category_nav_display: "sticky",
    category_nav_font_size: null,
    category_nav_text_color: "#1a1a1a",
    category_nav_font_family: '"Montserrat-Bold", sans-serif',
    mobile_category_nav_display: "scroll",
    category_menu_header_display: "stacked",
    category_nav_background_color: "#ffffff",
    category_nav_text_hover_color: "#dd6d4f",
    external_link: {
      enabled: false,
      label: "",
      url_template: ""
    }
  },
  menu_category_header: {
    font: {
      color: "#1a1a1a",
      font_size: 24,
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 700,
      line_height: "normal"
    },
    font_size: 24,
    font_color: "#1a1a1a",
    font_family: '"Montserrat-Bold", sans-serif',
    secondary_font: {
      color: "#1a1a1a",
      font_size: "revert",
      font_style: "normal",
      font_family: '"Montserrat-Regular", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    secondary_font_size: null,
    secondary_font_color: "#1a1a1a",
    secondary_font_family: '"Montserrat-Regular", sans-serif'
  },
  menu: {
    menu_search: true,
    popular_products: false,
    product_exclusions: [],
    category_exclusions: [],
    flagship_store_location: null,
    mobile_web_product_grid: "2x",
    dietary_preferences_enabled: false,
    background: {
      size: "auto",
      image: null,
      repeat: "none",
      attachment: "scroll",
      vertical_position: "top",
      horizontal_position: "left"
    }
  },
  product_detail: {
    image_layout: "inline",
    modifier_image_layout: "inline",
    pizza_option_group_layout: [],
    special_instructions_enabled: false,
    pizza_weight_option_group_layout: [],
    pizza_position_option_group_layout: []
  },
  food_hall: {
    filter_nav_text_color: "#ffffff",
    splash_screen_text_color: "#ffffff",
    filter_nav_background_color: "#333333",
    splash_screen_background_color: "#333333",
    splash_screen_background_image: "https://koala-marketing-api-sandbox.s3.amazonaws.com/default-assets/about-landscape.png"
  },
  location_splash_page: {
    layout_align_items: "center",
    search_column_width: 450,
    location_splash_page: false,
    layout_flex_direction: "row-reverse",
    search_column_headline: "Find a Location",
    image_column_background: null,
    search_results_cta_text: null,
    search_column_background: null,
    image_column_mobile_image: "https://via.placeholder.com/400x200",
    search_column_subheadline: null,
    container_background_image: null,
    image_column_desktop_image: "https://via.placeholder.com/1000x600"
  },
  location_card: {
    font: {
      color: "#111111",
      font_size: 15,
      font_style: "normal",
      font_family: '"Montserrat-Regular", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    font_size: 15,
    font_color: "#111111",
    font_family: '"Montserrat-Regular", sans-serif',
    border_color: "#dedede",
    border_radius: 8,
    secondary_font: {
      color: "#111111",
      font_size: 18,
      font_style: "normal",
      font_family: '"Montserrat-Bold"',
      font_weight: 700,
      line_height: "normal"
    },
    background_color: "#ffffff",
    secondary_font_size: 18,
    primary_button_theme: "primary",
    secondary_font_color: "#111111",
    secondary_font_family: '"Montserrat-Bold", sans-serif',
    show_conveyance_types: true,
    secondary_button_theme: "knockout"
  },
  location_search: {
    font: {
      color: "#111111",
      font_size: 15,
      font_style: "normal",
      font_family: '"Montserrat-Regular", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    font_size: 15,
    font_color: "#111111",
    error_color: "#d82c0d",
    font_family: '"Montserrat-Regular", sans-serif',
    border_color: "#dedede",
    border_radius: 8,
    tertiary_font: {
      color: "#111111",
      font_size: 15,
      font_style: "normal",
      font_family: '"Montserrat-Regular", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    secondary_font: {
      color: "#111111",
      font_size: 40,
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 700,
      line_height: "normal"
    },
    background_color: "#ffffff",
    tertiary_font_size: 15,
    secondary_font_size: 40,
    tertiary_font_color: "#111111",
    secondary_font_color: "#111111",
    tertiary_font_family: '"Montserrat-Regular", sans-serif',
    secondary_font_family: '"Montserrat-Bold", sans-serif'
  },
  dietary_preferences_modal: {
    font: {
      color: "#111111",
      font_size: 15,
      font_style: "normal",
      font_family: '"Montserrat-Regular"',
      font_weight: 400,
      line_height: "normal"
    },
    font_size: 15,
    font_color: "#111111",
    font_family: '"Montserrat-Regular", sans-serif',
    border_color: "#dedede",
    border_radius: 8,
    secondary_font: {
      color: "#111111",
      font_size: 24,
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 700,
      line_height: "normal"
    },
    background_color: "#ffffff",
    secondary_font_size: 24,
    secondary_font_color: "#111111",
    secondary_font_family: '"Montserrat-Bold", sans-serif'
  },
  dietary_preferences_tag: {
    font: {
      color: "#111111",
      font_size: 15,
      font_style: "normal",
      font_family: '"Montserrat-Regular", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    font_size: 15,
    font_color: "#111111",
    font_family: '"Montserrat-Regular", sans-serif',
    border_color: "#dedede",
    border_radius: 8,
    background_color: "#dedede",
    active_font_color: "#ffffff",
    active_border_color: "#335ece",
    active_background_color: "#335ece"
  },
  menu_product_card: {
    font: {
      color: "#1a1a1a",
      font_size: 14,
      font_style: "normal",
      font_family: '"Montserrat-Regular", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    font_size: 14,
    font_color: "#1a1a1a",
    hide_price: false,
    image_size: "cover",
    font_family: '"Montserrat-Regular", sans-serif',
    border_color: "#e6e6e6",
    border_radius: 8,
    hide_calories: false,
    tertiary_font: {
      color: "#1a1a1a",
      font_size: 15,
      font_style: "normal",
      font_family: '"Montserrat-Regular", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    secondary_font: {
      color: "#1a1a1a",
      font_size: 18,
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 700,
      line_height: "normal"
    },
    background_color: "#ffffff",
    hide_description: false,
    tertiary_font_size: 15,
    secondary_font_size: 18,
    tertiary_font_color: "#1a1a1a",
    secondary_font_color: "#1a1a1a",
    tertiary_font_family: '"Montserrat-Regular", sans-serif',
    secondary_font_family: '"Montserrat-Bold", sans-serif',
    hide_description_mobile: false,
    card_orientation: "vertical",
    hide_image: false,
    compact_menu_card: false
  },
  checkout: {
    font: {
      color: "#111111",
      font_size: 15,
      font_style: "normal",
      font_family: '"Montserrat-Regular", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    font_size: 15,
    font_color: "#111111",
    font_family: '"Montserrat-Regular", sans-serif',
    border_color: "#909090",
    guest_opt_in: false,
    border_radius: 8,
    secondary_font: {
      color: "#111111",
      font_size: 24,
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 700,
      line_height: "normal"
    },
    background_color: "#ffffff",
    active_font_color: "#111111",
    active_border_color: "#335ece",
    cart_image_override: null,
    secondary_font_size: 24,
    show_product_images: false,
    secondary_font_color: "#111111",
    secondary_font_family: '"Montserrat-Bold", sans-serif',
    active_background_color: "#f7f7f7"
  },
  tipping: {
    custom_tips: true,
    pickup_tip_tier_1: 10,
    pickup_tip_tier_2: 15,
    pickup_tip_tier_3: 20,
    delivery_tip_tier_1: 10,
    delivery_tip_tier_2: 15,
    delivery_tip_tier_3: 20,
    default_pickup_tip_tier: "None",
    default_delivery_tip_tier: "None"
  },
  auth_page: {
    font: {
      color: "#111111",
      font_size: 15,
      font_style: "normal",
      font_family: '"Montserrat-Regular", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    font_size: 15,
    font_color: "#111111",
    font_family: '"Montserrat-Regular", sans-serif',
    border_color: "#ffffff",
    border_radius: 8,
    tertiary_font: {
      color: "#111111",
      font_size: 15,
      font_style: "normal",
      font_family: '"Montserrat-Regular", sans-serif',
      font_weight: 400,
      line_height: "normal"
    },
    secondary_font: {
      color: "#111111",
      font_size: 24,
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 700,
      line_height: "normal"
    },
    background_color: "#ffffff",
    tertiary_font_size: 15,
    secondary_font_size: 24,
    tertiary_font_color: "#111111",
    secondary_font_color: "#111111",
    tertiary_font_family: '"Montserrat-Regular", sans-serif',
    secondary_font_family: '"Montserrat-Bold", sans-serif'
  },
  sidecart: {
    font: {
      color: "#1a1a1a",
      font_size: 15,
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 700,
      line_height: "normal"
    },
    font_size: 15,
    font_color: "#1a1a1a",
    font_family: '"Montserrat-Bold", sans-serif',
    border_color: "#e6e6e6",
    border_radius: 8,
    secondary_font: {
      color: "#111111",
      font_size: 24,
      font_style: "normal",
      font_family: '"Montserrat-Bold", sans-serif',
      font_weight: 700,
      line_height: "normal"
    },
    max_cross_sells: 8,
    background_color: "#ffffff",
    active_font_color: "#e6e6e6",
    active_border_color: "#e6e6e6",
    secondary_font_size: 24,
    show_product_images: true,
    secondary_font_color: "#111111",
    secondary_font_family: '"Montserrat-Bold", sans-serif',
    active_background_color: "#ffffff",
    background_color_no_items: "#ffffff"
  },
  seo: {
    image: "",
    title: "",
    base_url: "",
    site_name: "",
    robots_txt: null,
    description: "",
    store_page_title: null,
    product_page_title: null,
    store_page_description: null,
    product_page_description: null
  },
  google: {
    gtag_id: null,
    ecommerce: false,
    analytics_id: null,
    tag_manager_id: null,
    site_verification: null
  },
  integrations: {
    branch_id: null,
    userway_id: null,
    facebook_pixel: null,
    facebook_app_id: null,
    site_improve_id: null,
    apple_service_id: null,
    apple_itunes_app_id: null,
    cookieyes_id: null,
    roku_pixel_id: null
  },
  rewards: {
    donatable_rewards: false,
    offers_first: false,
    footer_heading_text_align: "left"
  },
  order_confirmation: {
    hide_store_phone_number: false,
    order_instructions_font_size: 12,
    show_customer_info: false
  },
  dispatch_tracking: {
    order_origin_icon: null,
    order_tracking_icon: "https://koala-marketing-api-sandbox.s3.amazonaws.com/default-assets/dispatch-car-icon-2x.png",
    order_destination_icon: "https://koala-marketing-api-sandbox.s3.amazonaws.com/default-assets/dispatch-destination-icon-2x.png",
    dispatch_tracking_enabled: false
  },
  android_home: {
    home_image: null,
    inbox_icon: "https://koala-marketing-api-sandbox.s3.amazonaws.com/default-assets/inbox-icon-2x.png",
    header_font: {
      color: "#222222",
      font_size: "revert",
      font_style: "normal",
      font_family: '"Times", "serif"',
      font_weight: 400,
      line_height: "normal"
    },
    reorder_icon: "https://koala-marketing-api-sandbox.s3.amazonaws.com/default-assets/reorders-icon-2x.png",
    rewards_icon: "https://koala-marketing-api-sandbox.s3.amazonaws.com/default-assets/gift-icon-2x.png",
    favorites_icon: "https://koala-marketing-api-sandbox.s3.amazonaws.com/default-assets/heart-icon-2x.png",
    sub_header_font: {
      color: "#222222",
      font_size: "revert",
      font_style: "normal",
      font_family: '"Arial", "Helvetica"',
      font_weight: 400,
      line_height: "normal"
    },
    background_color: "#fbf8f7",
    badge_count_font: {
      color: "#ffffff",
      font_size: 8,
      font_style: "normal",
      font_family: '"Times", "serif"',
      font_weight: 400,
      line_height: "normal"
    },
    header_text_color: "#222222",
    header_font_family: '"Times", "serif"',
    reorder_button_font: {
      color: "#ffffff",
      font_size: "revert",
      font_style: "normal",
      font_family: '"Arial", "Helvetica"',
      font_weight: 400,
      line_height: "normal"
    },
    selection_view_font: {
      color: "#222222",
      font_size: "revert",
      font_style: "normal",
      font_family: '"Times", "serif"',
      font_weight: 400,
      line_height: "normal"
    },
    sign_in_button_font: {
      color: "#222222",
      font_size: "revert",
      font_style: "normal",
      font_family: '"Arial", "Helvetica"',
      font_weight: 400,
      line_height: "normal"
    },
    order_now_button_font: {
      color: "#ffffff",
      font_size: "revert",
      font_style: "normal",
      font_family: '"Arial", "Helvetica"',
      font_weight: 400,
      line_height: "normal"
    },
    sub_header_text_color: "#222222",
    my_account_button_font: {
      color: "#222222",
      font_size: "revert",
      font_style: "normal",
      font_family: '"Arial", "Helvetica"',
      font_weight: 700,
      line_height: "normal"
    },
    sub_header_font_family: '"Arial", "Helvetica"',
    badge_count_font_family: '"Times", "serif"',
    reorder_button_text_color: "#ffffff",
    selection_view_text_color: "#222222",
    sign_in_button_text_color: "#222222",
    reorder_button_font_family: '"Arial", "Helvetica"',
    selection_view_font_family: '"Times", "serif"',
    sign_in_button_font_family: '"Arial", "Helvetica"',
    order_now_button_text_color: "#ffffff",
    reorder_button_border_width: 1,
    my_account_button_text_color: "#222222",
    order_now_button_font_family: '"Arial", "Helvetica"',
    reorder_button_border_radius: 8,
    my_account_button_font_family: '"Arial", "Helvetica"',
    order_now_button_border_radius: 8,
    reorder_button_background_color: "#6b6baa",
    order_now_button_background_color: "#c8102e"
  },
  android_drawer: {
    separator: "#fbf8f7",
    title_font: {
      color: "#222222",
      font_size: 24,
      font_style: "normal",
      font_family: '"Times", "serif"',
      font_weight: 400,
      line_height: "normal"
    },
    section_font: {
      color: "#222222",
      font_size: "revert",
      font_style: "normal",
      font_family: '"Times", "serif"',
      font_weight: 400,
      line_height: "normal"
    },
    subtitle_font: {
      color: "#222222",
      font_size: "revert",
      font_style: "normal",
      font_family: '"Arial", "Helvetica"',
      font_weight: 400,
      line_height: "normal"
    },
    title_font_size: 24,
    background_color: "#fbf8f7",
    title_text_color: "#222222",
    title_font_family: '"Times", "serif"',
    section_text_color: "#222222",
    bottom_section_font: {
      color: "#222222",
      font_size: "revert",
      font_style: "normal",
      font_family: '"Arial", "Helvetica"',
      font_weight: 400,
      line_height: "normal"
    },
    section_font_family: '"Times", "serif"',
    subtitle_text_color: "#222222",
    subtitle_font_family: '"Arial", "Helvetica"',
    bottom_section_text_color: "#222222",
    bottom_section_font_family: '"Arial", "Helvetica"'
  },
  android_features: {
    reorders: true,
    reorders_view: "CTA",
    app_rating_enabled: true
  },
  footer: {
    tiktok_url: "",
    footer_logo: null,
    twitter_url: "",
    youtube_url: "",
    facebook_url: "",
    instagram_url: "",
    apple_store_url: "",
    google_play_store_url: ""
  }
};

// src/utils/conversion-tracking.helpers.ts
var ConversionTrackingHelper = class {
  constructor() {
    this.CONVERSION_TRACKING_KEY = "rwg_token";
    this.CONVERSION_TRACKING_URL_PARAM = this.CONVERSION_TRACKING_KEY;
    this.conversionToken = new URLSearchParams(window.location.search).get(
      this.CONVERSION_TRACKING_URL_PARAM
    );
    this.storage = new ExpiryLocalStorage();
  }
  setTrackingKey() {
    if (this.conversionToken === null) {
      return false;
    }
    const thirtyDaysInMilliseconds = 30 * 24 * 60 * 60 * 1e3;
    return this.storage.set(
      this.CONVERSION_TRACKING_KEY,
      this.conversionToken,
      thirtyDaysInMilliseconds
    );
  }
  getTrackingKey() {
    return this.storage.get(this.CONVERSION_TRACKING_KEY);
  }
  clearTrackingKey() {
    return this.storage.remove(this.CONVERSION_TRACKING_KEY);
  }
};

// src/index.ts
var sdkStorage = {
  menu: new MenuStorage(new GenericStorage()),
  basket: new BasketStorage(new GenericStorage())
};
var sdkUtils = {
  calculateIncrementor,
  objectifyOptionsMenuLevel,
  objectifyOptionsProductLevel,
  nextLargestRewardPointValue,
  calculateProgressBarWidth,
  findMenuItemById,
  filterAvailableItems,
  findProductCategory,
  findProductCategoryId,
  createMenuProductDictionary,
  findFuzzyMenuMatches,
  slugName,
  augmentMenuProduct
};



/***/ }),

/***/ 40024:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ke": function() { return /* binding */ ARRIVAL_STATUS; },
  "P8": function() { return /* binding */ CONVEYANCE_TYPES; },
  "zW": function() { return /* binding */ addBasketItem; },
  "fu": function() { return /* binding */ addPromo; },
  "yt": function() { return /* binding */ addRewards; },
  "h9": function() { return /* binding */ addTip; },
  "ts": function() { return /* binding */ checkDeliveryCoverage; },
  "PX": function() { return /* binding */ contact; },
  "Y6": function() { return /* binding */ createBasket; },
  "YY": function() { return /* binding */ createBasketFromOrderId; },
  "J": function() { return /* binding */ createRedemption; },
  "HB": function() { return /* binding */ createRedemptionUsingBankCurrency; },
  "eC": function() { return /* binding */ defaultStoredAddress; },
  "ml": function() { return /* binding */ deleteFavoriteLocation; },
  "$Z": function() { return /* binding */ deleteMessage; },
  "r6": function() { return /* binding */ deleteStoredAddress; },
  "rJ": function() { return /* binding */ donateToSocialCause; },
  "ML": function() { return /* binding */ favoriteOrders; },
  "vJ": function() { return /* binding */ favoritesDelete; },
  "WY": function() { return /* binding */ favoritesSave; },
  "Es": function() { return /* binding */ fetchClientToken; },
  "hO": function() { return /* binding */ fetchLoyaltyState; },
  "y$": function() { return /* binding */ fetchLoyaltyToken; },
  "W4": function() { return /* binding */ fetchMessages; },
  "v": function() { return /* binding */ fetchRedeemables; },
  "by": function() { return /* binding */ fetchRedemptions; },
  "U8": function() { return /* binding */ fetchRewardsHistory; },
  "sX": function() { return /* binding */ fetchSocialCauses; },
  "gF": function() { return /* binding */ forgotPassword; },
  "Cg": function() { return /* binding */ geoIpLookup; },
  "qU": function() { return /* binding */ getAllergens; },
  "fs": function() { return /* binding */ getAppliedRewards; },
  "FQ": function() { return /* binding */ getBasketRewards; },
  "o": function() { return /* binding */ getCrossSells; },
  "Zm": function() { return /* binding */ getDeliveryCoverage; },
  "j4": function() { return /* binding */ getFavoriteLocations; },
  "$2": function() { return /* binding */ getFooter; },
  "k$": function() { return /* binding */ getLocation; },
  "g9": function() { return /* binding */ getLocationByBrandId; },
  "r7": function() { return /* binding */ getMenu; },
  "GI": function() { return /* binding */ getOrderDeliveryStatus; },
  "Q2": function() { return /* binding */ getOrderSummary; },
  "RB": function() { return /* binding */ getOrgConfig; },
  "Pc": function() { return /* binding */ getPersistedToken; },
  "Wq": function() { return /* binding */ getPickupTime; },
  "gk": function() { return /* binding */ getPickupTimeByBasket; },
  "ji": function() { return /* binding */ getPopularProducts; },
  "rl": function() { return /* binding */ getRewards; },
  "Gu": function() { return /* binding */ getSavedCards; },
  "I8": function() { return /* binding */ getStoredAddresses; },
  "mM": function() { return /* binding */ getStoredValue; },
  "Fx": function() { return /* binding */ getStrings; },
  "k6": function() { return /* binding */ getSupportedPaymentTypes; },
  "NJ": function() { return /* binding */ getTags; },
  "Z4": function() { return /* binding */ getTokenizedCreditCard; },
  "PR": function() { return /* binding */ getUser; },
  "IO": function() { return /* binding */ getWebConfig; },
  "Mb": function() { return /* binding */ httpClient; },
  "Jp": function() { return /* binding */ listLocations; },
  "kS": function() { return /* binding */ logout; },
  "RC": function() { return /* binding */ markMessageAsRead; },
  "Hd": function() { return /* binding */ pastOrders; },
  "s8": function() { return /* binding */ persistToken; },
  "$1": function() { return /* binding */ redeemReceiptBarcode; },
  "z2": function() { return /* binding */ register; },
  "yN": function() { return /* binding */ removeBasketItem; },
  "Di": function() { return /* binding */ removePickupTime; },
  "fW": function() { return /* binding */ removePromo; },
  "j6": function() { return /* binding */ removeReward; },
  "jG": function() { return /* binding */ removeSavedCard; },
  "c0": function() { return /* binding */ resetPassword; },
  "Eu": function() { return /* binding */ resetToken; },
  "nB": function() { return /* binding */ saveFavoriteLocation; },
  "rp": function() { return /* binding */ setConveyance; },
  "ZR": function() { return /* binding */ setInstructions; },
  "cq": function() { return /* binding */ setPickupTime; },
  "Ip": function() { return /* binding */ setUtensils; },
  "pm": function() { return /* binding */ submitOrder; },
  "Jv": function() { return /* binding */ updateArrivalStatus; },
  "B6": function() { return /* binding */ updateBasketItem; },
  "DO": function() { return /* binding */ updateMe; },
  "J5": function() { return /* binding */ validateBasket; },
  "XA": function() { return /* binding */ validateLoyaltyToken; }
});

// UNUSED EXPORTS: CALS_IDENTIFIER, CONVEYANCE_TYPE_KEYS, DELIVERY_PROVIDER_STATUS, DELIVER_PROVIDER_TERMINATING_STATUS, LOYALTY_FEATURES, LOYALTY_PROGRAM_TYPES, UpsellsStep, allergenItem, arrivalResponse, availableWantedAtTimes, basket, basketConveyanceDetails, basketFee, basketItem, basketItemOption, basketOrder, category, categoryResponse, checkoutBasket, checkoutBasketConveyanceDetails, checkoutBasketDeliveryAddress, contactResponse, creditCardBase, crossSells, curbsideDetails, customerDetails, customerDetailsV2, deliveryAddress, deliveryCoverageResponse, deliveryStatus, digitalWallet, dineInDetails, donation, donationTypes, driveInDetails, existingOption, externalAuthConfig, geoData, geoIp, getMostRecentCard, getOrderDetails, getPaymentTypes, location, locationCachedData, locationOperatingHours, loyaltyState, loyaltyUser, menu, menuProduct, menuProductImages, menuProductLabel, menuProductOption, menuProductOptionGroup, menuProductResponse, menuResponse, messageItem, order, orderDetails, orderingTokenConfig, orgTokenConfig, paymentDetails, paymentTokenConfig, paymentTypesResponse, popularProducts, redeemableItem, redemptionItem, rewardHistoryItem, rewardItem, savedCard, socialCause, storedAddress, storedValueBalanceResponse, storedValueRequirement, submissionDetails, submitBasketData, supportedPaymentTypes, tagItem, tokenConfig, tokenizedCreditCard

// EXTERNAL MODULE: ../../node_modules/qs/lib/index.js
var lib = __webpack_require__(19126);
// EXTERNAL MODULE: ../../node_modules/pako/dist/pako.esm.mjs
var pako_esm = __webpack_require__(33654);
;// CONCATENATED MODULE: ../../node_modules/wretch/dist/constants.js
const JSON_MIME = "application/json";
const CONTENT_TYPE_HEADER = "Content-Type";
const FETCH_ERROR = Symbol();
//# sourceMappingURL=constants.js.map
;// CONCATENATED MODULE: ../../node_modules/wretch/dist/utils.js

function extractContentType(headers = {}) {
    var _a;
    return (_a = Object.entries(headers).find(([k]) => k.toLowerCase() === CONTENT_TYPE_HEADER.toLowerCase())) === null || _a === void 0 ? void 0 : _a[1];
}
function isLikelyJsonMime(value) {
    return /^application\/.*json.*/.test(value);
}
const mix = function (one, two, mergeArrays = false) {
    return Object.entries(two).reduce((acc, [key, newValue]) => {
        const value = one[key];
        if (Array.isArray(value) && Array.isArray(newValue)) {
            acc[key] = mergeArrays ? [...value, ...newValue] : newValue;
        }
        else if (typeof value === "object" && typeof newValue === "object") {
            acc[key] = mix(value, newValue, mergeArrays);
        }
        else {
            acc[key] = newValue;
        }
        return acc;
    }, { ...one });
};
//# sourceMappingURL=utils.js.map
;// CONCATENATED MODULE: ../../node_modules/wretch/dist/config.js

const config = {
    // Default options
    options: {},
    // Error type
    errorType: "text",
    // Polyfills
    polyfills: {
    // fetch: null,
    // FormData: null,
    // URLSearchParams: null,
    // performance: null,
    // PerformanceObserver: null,
    // AbortController: null
    },
    polyfill(p, doThrow = true, instance = false, ...args) {
        const res = this.polyfills[p] ||
            (typeof self !== "undefined" ? self[p] : null) ||
            (typeof global !== "undefined" ? global[p] : null);
        if (doThrow && !res)
            throw new Error(p + " is not defined");
        return instance && res ? new res(...args) : res;
    }
};
/**
 * Sets the default fetch options that will be stored internally when instantiating wretch objects.
 *
 * ```js
 * import wretch from "wretch"
 *
 * wretch.options({ headers: { "Accept": "application/json" } });
 *
 * // The fetch request is sent with both headers.
 * wretch("...", { headers: { "X-Custom": "Header" } }).get().res();
 * ```
 *
 * @param options Default options
 * @param replace If true, completely replaces the existing options instead of mixing in
 */
function setOptions(options, replace = false) {
    config.options = replace ? options : mix(config.options, options);
}
/**
 * Sets the default polyfills that will be stored internally when instantiating wretch objects.
 * Useful for browserless environments like `node.js`.
 *
 * Needed for libraries like [fetch-ponyfill](https://github.com/qubyte/fetch-ponyfill).
 *
 * ```js
 * import wretch from "wretch"
 *
 * wretch.polyfills({
 *   fetch: require("node-fetch"),
 *   FormData: require("form-data"),
 *   URLSearchParams: require("url").URLSearchParams,
 * });
 *
 * // Uses the above polyfills.
 * wretch("...").get().res();
 * ```
 *
 * @param polyfills An object containing the polyfills
 * @param replace If true, replaces the current polyfills instead of mixing in
 */
function setPolyfills(polyfills, replace = false) {
    config.polyfills = replace ? polyfills : mix(config.polyfills, polyfills);
}
/**
 * Sets the default method (text, json, …) used to parse the data contained in the response body in case of an HTTP error.
 * As with other static methods, it will affect wretch instances created after calling this function.
 *
 * _Note: if the response Content-Type header is set to "application/json", the body will be parsed as json regardless of the errorType._
 *
 * ```js
 * import wretch from "wretch"
 *
 * wretch.errorType("json")
 *
 * wretch("http://server/which/returns/an/error/with/a/json/body")
 *   .get()
 *   .res()
 *   .catch(error => {
 *     // error[errorType] (here, json) contains the parsed body
 *     console.log(error.json)
 *   })
 * ```
 *
 * If null, defaults to "text".
 */
function setErrorType(errorType) {
    config.errorType = errorType;
}
/* harmony default export */ var dist_config = (config);
//# sourceMappingURL=config.js.map
;// CONCATENATED MODULE: ../../node_modules/wretch/dist/middleware.js
/**
 * @private @internal
 */
const middlewareHelper = (middlewares) => (fetchFunction) => {
    return middlewares.reduceRight((acc, curr) => curr(acc), fetchFunction) || fetchFunction;
};
//# sourceMappingURL=middleware.js.map
;// CONCATENATED MODULE: ../../node_modules/wretch/dist/resolver.js



/**
 * This class inheriting from Error is thrown when the fetch response is not "ok".
 * It extends Error and adds status, text and body fields.
 */
class WretchError extends Error {
}
const resolver = (wretch) => {
    const sharedState = Object.create(null);
    wretch = wretch._addons.reduce((w, addon) => addon.beforeRequest &&
        addon.beforeRequest(w, wretch._options, sharedState)
        || w, wretch);
    const { _url: url, _options: opts, _config: config, _catchers: _catchers, _resolvers: resolvers, _middlewares: middlewares, _addons: addons } = wretch;
    const catchers = new Map(_catchers);
    const finalOptions = mix(config.options, opts);
    // The generated fetch request
    let finalUrl = url;
    const _fetchReq = middlewareHelper(middlewares)((url, options) => {
        finalUrl = url;
        return config.polyfill("fetch")(url, options);
    })(url, finalOptions);
    // Throws on an http error
    const referenceError = new Error();
    const throwingPromise = _fetchReq
        .catch(error => {
        throw { __wrap: error };
    })
        .then(response => {
        if (!response.ok) {
            const err = new WretchError();
            // Enhance the error object
            err["cause"] = referenceError;
            err.stack = err.stack + "\nCAUSE: " + referenceError.stack;
            err.response = response;
            err.url = finalUrl;
            if (response.type === "opaque") {
                throw err;
            }
            return response.text().then((body) => {
                var _a;
                err.message = body;
                if (config.errorType === "json" || ((_a = response.headers.get("Content-Type")) === null || _a === void 0 ? void 0 : _a.split(";")[0]) === "application/json") {
                    try {
                        err.json = JSON.parse(body);
                    }
                    catch (e) { /* ignore */ }
                }
                err.text = body;
                err["status"] = response.status;
                throw err;
            });
        }
        return response;
    });
    // Wraps the Promise in order to dispatch the error to a matching catcher
    const catchersWrapper = (promise) => {
        return promise.catch(err => {
            const error = err.__wrap || err;
            const catcher = (error.status && catchers.get(error.status)) ||
                catchers.get(error.name) || (err.__wrap && catchers.has(FETCH_ERROR) && catchers.get(FETCH_ERROR));
            if (catcher)
                return catcher(error, wretch);
            throw error;
        });
    };
    const bodyParser = funName => cb => funName ?
        // If a callback is provided, then callback with the body result otherwise return the parsed body itself.
        catchersWrapper(throwingPromise.then(_ => _ && _[funName]()).then(_ => cb ? cb(_) : _)) :
        // No body parsing method - return the response
        catchersWrapper(throwingPromise.then(_ => cb ? cb(_) : _));
    const responseChain = {
        _wretchReq: wretch,
        _fetchReq,
        _sharedState: sharedState,
        res: bodyParser(null),
        json: bodyParser("json"),
        blob: bodyParser("blob"),
        formData: bodyParser("formData"),
        arrayBuffer: bodyParser("arrayBuffer"),
        text: bodyParser("text"),
        error(errorId, cb) {
            catchers.set(errorId, cb);
            return this;
        },
        badRequest(cb) { return this.error(400, cb); },
        unauthorized(cb) { return this.error(401, cb); },
        forbidden(cb) { return this.error(403, cb); },
        notFound(cb) { return this.error(404, cb); },
        timeout(cb) { return this.error(408, cb); },
        internalError(cb) { return this.error(500, cb); },
        fetchError(cb) { return this.error(FETCH_ERROR, cb); },
    };
    const enhancedResponseChain = addons.reduce((chain, addon) => ({
        ...chain,
        ...addon.resolver
    }), responseChain);
    return resolvers.reduce((chain, r) => r(chain, wretch), enhancedResponseChain);
};
//# sourceMappingURL=resolver.js.map
;// CONCATENATED MODULE: ../../node_modules/wretch/dist/core.js




const core = {
    _url: "",
    _options: {},
    _config: dist_config,
    _catchers: new Map(),
    _resolvers: [],
    _deferred: [],
    _middlewares: [],
    _addons: [],
    addon(addon) {
        return { ...this, _addons: [...this._addons, addon], ...addon.wretch };
    },
    errorType(errorType) {
        return {
            ...this,
            _config: {
                ...this._config,
                errorType
            }
        };
    },
    polyfills(polyfills, replace = false) {
        return {
            ...this,
            _config: {
                ...this._config,
                polyfills: replace ? polyfills : mix(this._config.polyfills, polyfills)
            }
        };
    },
    url(_url, replace = false) {
        if (replace)
            return { ...this, _url };
        const split = this._url.split("?");
        return {
            ...this,
            _url: split.length > 1 ?
                split[0] + _url + "?" + split[1] :
                this._url + _url
        };
    },
    options(options, replace = false) {
        return { ...this, _options: replace ? options : mix(this._options, options) };
    },
    headers(headerValues) {
        return { ...this, _options: mix(this._options, { headers: headerValues || {} }) };
    },
    accept(headerValue) {
        return this.headers({ Accept: headerValue });
    },
    content(headerValue) {
        return this.headers({ [CONTENT_TYPE_HEADER]: headerValue });
    },
    auth(headerValue) {
        return this.headers({ Authorization: headerValue });
    },
    catcher(errorId, catcher) {
        const newMap = new Map(this._catchers);
        newMap.set(errorId, catcher);
        return { ...this, _catchers: newMap };
    },
    resolve(resolver, clear = false) {
        return { ...this, _resolvers: clear ? [resolver] : [...this._resolvers, resolver] };
    },
    defer(callback, clear = false) {
        return {
            ...this,
            _deferred: clear ? [callback] : [...this._deferred, callback]
        };
    },
    middlewares(middlewares, clear = false) {
        return {
            ...this,
            _middlewares: clear ? middlewares : [...this._middlewares, ...middlewares]
        };
    },
    fetch(method = this._options.method, url = "", body = null) {
        let base = this.url(url).options({ method });
        // "Jsonify" the body if it is an object and if it is likely that the content type targets json.
        const contentType = extractContentType(base._options.headers);
        const jsonify = typeof body === "object" && (!base._options.headers || !contentType || isLikelyJsonMime(contentType));
        base =
            !body ? base :
                jsonify ? base.json(body, contentType) :
                    base.body(body);
        return resolver(base
            ._deferred
            .reduce((acc, curr) => curr(acc, acc._url, acc._options), base));
    },
    get(url = "") {
        return this.fetch("GET", url);
    },
    delete(url = "") {
        return this.fetch("DELETE", url);
    },
    put(body, url = "") {
        return this.fetch("PUT", url, body);
    },
    post(body, url = "") {
        return this.fetch("POST", url, body);
    },
    patch(body, url = "") {
        return this.fetch("PATCH", url, body);
    },
    head(url = "") {
        return this.fetch("HEAD", url);
    },
    opts(url = "") {
        return this.fetch("OPTIONS", url);
    },
    body(contents) {
        return { ...this, _options: { ...this._options, body: contents } };
    },
    json(jsObject, contentType) {
        const currentContentType = extractContentType(this._options.headers);
        return this.content(contentType ||
            isLikelyJsonMime(currentContentType) && currentContentType ||
            JSON_MIME).body(JSON.stringify(jsObject));
    }
};
//# sourceMappingURL=core.js.map
;// CONCATENATED MODULE: ../../node_modules/wretch/dist/index.js



/**
 * Creates a new wretch instance with a base url and base
 * [fetch options](https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/fetch).
 *
 * ```ts
 * import wretch from "wretch"
 *
 * // Reusable instance
 * const w = wretch("https://domain.com", { mode: "cors" })
 * ```
 *
 * @param _url The base url
 * @param _options The base fetch options
 * @returns A fresh wretch instance
 */
function factory(_url = "", _options = {}) {
    return { ...core, _url, _options };
}
factory["default"] = factory;
/** {@inheritDoc setOptions} */
factory.options = setOptions;
/** {@inheritDoc setErrorType} */
factory.errorType = setErrorType;
/** {@inheritDoc setPolyfills} */
factory.polyfills = setPolyfills;
factory.WretchError = WretchError;
/* harmony default export */ var dist = (factory);
//# sourceMappingURL=index.js.map
;// CONCATENATED MODULE: ../../node_modules/wretch/dist/addons/queryString.js
function stringify(value) {
    return typeof value !== "undefined" ? value : "";
}
const appendQueryParams = (url, qp, replace, config) => {
    let queryString;
    if (typeof qp === "string") {
        queryString = qp;
    }
    else {
        const usp = config.polyfill("URLSearchParams", true, true);
        for (const key in qp) {
            const value = qp[key];
            if (qp[key] instanceof Array) {
                for (const val of value)
                    usp.append(key, stringify(val));
            }
            else {
                usp.append(key, stringify(value));
            }
        }
        queryString = usp.toString();
    }
    const split = url.split("?");
    if (!queryString)
        return replace ? split[0] : url;
    if (replace || split.length < 2)
        return split[0] + "?" + queryString;
    return url + "&" + queryString;
};
/**
 * Adds the ability to append query parameters from a javascript object.
 *
 * ```js
 * import QueryAddon from "wretch/addons/queryString"
 *
 * wretch().addon(QueryAddon)
 * ```
 */
const queryString = {
    wretch: {
        query(qp, replace = false) {
            return { ...this, _url: appendQueryParams(this._url, qp, replace, this._config) };
        }
    }
};
/* harmony default export */ var addons_queryString = (queryString);
//# sourceMappingURL=queryString.js.map
;// CONCATENATED MODULE: ../../packages/sdk/dist/v4/index.mjs
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// ../../node_modules/lodash/_listCacheClear.js
var require_listCacheClear = __commonJS({
  "../../node_modules/lodash/_listCacheClear.js"(exports, module) {
    "use strict";
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }
    module.exports = listCacheClear;
  }
});

// ../../node_modules/lodash/eq.js
var require_eq = __commonJS({
  "../../node_modules/lodash/eq.js"(exports, module) {
    "use strict";
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }
    module.exports = eq;
  }
});

// ../../node_modules/lodash/_assocIndexOf.js
var require_assocIndexOf = __commonJS({
  "../../node_modules/lodash/_assocIndexOf.js"(exports, module) {
    "use strict";
    var eq = require_eq();
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }
    module.exports = assocIndexOf;
  }
});

// ../../node_modules/lodash/_listCacheDelete.js
var require_listCacheDelete = __commonJS({
  "../../node_modules/lodash/_listCacheDelete.js"(exports, module) {
    "use strict";
    var assocIndexOf = require_assocIndexOf();
    var arrayProto = Array.prototype;
    var splice = arrayProto.splice;
    function listCacheDelete(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }
    module.exports = listCacheDelete;
  }
});

// ../../node_modules/lodash/_listCacheGet.js
var require_listCacheGet = __commonJS({
  "../../node_modules/lodash/_listCacheGet.js"(exports, module) {
    "use strict";
    var assocIndexOf = require_assocIndexOf();
    function listCacheGet(key) {
      var data = this.__data__, index = assocIndexOf(data, key);
      return index < 0 ? void 0 : data[index][1];
    }
    module.exports = listCacheGet;
  }
});

// ../../node_modules/lodash/_listCacheHas.js
var require_listCacheHas = __commonJS({
  "../../node_modules/lodash/_listCacheHas.js"(exports, module) {
    "use strict";
    var assocIndexOf = require_assocIndexOf();
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }
    module.exports = listCacheHas;
  }
});

// ../../node_modules/lodash/_listCacheSet.js
var require_listCacheSet = __commonJS({
  "../../node_modules/lodash/_listCacheSet.js"(exports, module) {
    "use strict";
    var assocIndexOf = require_assocIndexOf();
    function listCacheSet(key, value) {
      var data = this.__data__, index = assocIndexOf(data, key);
      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }
    module.exports = listCacheSet;
  }
});

// ../../node_modules/lodash/_ListCache.js
var require_ListCache = __commonJS({
  "../../node_modules/lodash/_ListCache.js"(exports, module) {
    "use strict";
    var listCacheClear = require_listCacheClear();
    var listCacheDelete = require_listCacheDelete();
    var listCacheGet = require_listCacheGet();
    var listCacheHas = require_listCacheHas();
    var listCacheSet = require_listCacheSet();
    function ListCache(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype["delete"] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;
    module.exports = ListCache;
  }
});

// ../../node_modules/lodash/_stackClear.js
var require_stackClear = __commonJS({
  "../../node_modules/lodash/_stackClear.js"(exports, module) {
    "use strict";
    var ListCache = require_ListCache();
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }
    module.exports = stackClear;
  }
});

// ../../node_modules/lodash/_stackDelete.js
var require_stackDelete = __commonJS({
  "../../node_modules/lodash/_stackDelete.js"(exports, module) {
    "use strict";
    function stackDelete(key) {
      var data = this.__data__, result = data["delete"](key);
      this.size = data.size;
      return result;
    }
    module.exports = stackDelete;
  }
});

// ../../node_modules/lodash/_stackGet.js
var require_stackGet = __commonJS({
  "../../node_modules/lodash/_stackGet.js"(exports, module) {
    "use strict";
    function stackGet(key) {
      return this.__data__.get(key);
    }
    module.exports = stackGet;
  }
});

// ../../node_modules/lodash/_stackHas.js
var require_stackHas = __commonJS({
  "../../node_modules/lodash/_stackHas.js"(exports, module) {
    "use strict";
    function stackHas(key) {
      return this.__data__.has(key);
    }
    module.exports = stackHas;
  }
});

// ../../node_modules/lodash/_freeGlobal.js
var require_freeGlobal = __commonJS({
  "../../node_modules/lodash/_freeGlobal.js"(exports, module) {
    "use strict";
    var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
    module.exports = freeGlobal;
  }
});

// ../../node_modules/lodash/_root.js
var require_root = __commonJS({
  "../../node_modules/lodash/_root.js"(exports, module) {
    "use strict";
    var freeGlobal = require_freeGlobal();
    var freeSelf = typeof self == "object" && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function("return this")();
    module.exports = root;
  }
});

// ../../node_modules/lodash/_Symbol.js
var require_Symbol = __commonJS({
  "../../node_modules/lodash/_Symbol.js"(exports, module) {
    "use strict";
    var root = require_root();
    var Symbol2 = root.Symbol;
    module.exports = Symbol2;
  }
});

// ../../node_modules/lodash/_getRawTag.js
var require_getRawTag = __commonJS({
  "../../node_modules/lodash/_getRawTag.js"(exports, module) {
    "use strict";
    var Symbol2 = require_Symbol();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var nativeObjectToString = objectProto.toString;
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
      try {
        value[symToStringTag] = void 0;
        var unmasked = true;
      } catch (e) {
      }
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }
    module.exports = getRawTag;
  }
});

// ../../node_modules/lodash/_objectToString.js
var require_objectToString = __commonJS({
  "../../node_modules/lodash/_objectToString.js"(exports, module) {
    "use strict";
    var objectProto = Object.prototype;
    var nativeObjectToString = objectProto.toString;
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }
    module.exports = objectToString;
  }
});

// ../../node_modules/lodash/_baseGetTag.js
var require_baseGetTag = __commonJS({
  "../../node_modules/lodash/_baseGetTag.js"(exports, module) {
    "use strict";
    var Symbol2 = require_Symbol();
    var getRawTag = require_getRawTag();
    var objectToString = require_objectToString();
    var nullTag = "[object Null]";
    var undefinedTag = "[object Undefined]";
    var symToStringTag = Symbol2 ? Symbol2.toStringTag : void 0;
    function baseGetTag(value) {
      if (value == null) {
        return value === void 0 ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }
    module.exports = baseGetTag;
  }
});

// ../../node_modules/lodash/isObject.js
var require_isObject = __commonJS({
  "../../node_modules/lodash/isObject.js"(exports, module) {
    "use strict";
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == "object" || type == "function");
    }
    module.exports = isObject;
  }
});

// ../../node_modules/lodash/isFunction.js
var require_isFunction = __commonJS({
  "../../node_modules/lodash/isFunction.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var isObject = require_isObject();
    var asyncTag = "[object AsyncFunction]";
    var funcTag = "[object Function]";
    var genTag = "[object GeneratorFunction]";
    var proxyTag = "[object Proxy]";
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }
    module.exports = isFunction;
  }
});

// ../../node_modules/lodash/_coreJsData.js
var require_coreJsData = __commonJS({
  "../../node_modules/lodash/_coreJsData.js"(exports, module) {
    "use strict";
    var root = require_root();
    var coreJsData = root["__core-js_shared__"];
    module.exports = coreJsData;
  }
});

// ../../node_modules/lodash/_isMasked.js
var require_isMasked = __commonJS({
  "../../node_modules/lodash/_isMasked.js"(exports, module) {
    "use strict";
    var coreJsData = require_coreJsData();
    var maskSrcKey = function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
      return uid ? "Symbol(src)_1." + uid : "";
    }();
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }
    module.exports = isMasked;
  }
});

// ../../node_modules/lodash/_toSource.js
var require_toSource = __commonJS({
  "../../node_modules/lodash/_toSource.js"(exports, module) {
    "use strict";
    var funcProto = Function.prototype;
    var funcToString = funcProto.toString;
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {
        }
        try {
          return func + "";
        } catch (e) {
        }
      }
      return "";
    }
    module.exports = toSource;
  }
});

// ../../node_modules/lodash/_baseIsNative.js
var require_baseIsNative = __commonJS({
  "../../node_modules/lodash/_baseIsNative.js"(exports, module) {
    "use strict";
    var isFunction = require_isFunction();
    var isMasked = require_isMasked();
    var isObject = require_isObject();
    var toSource = require_toSource();
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var reIsNative = RegExp(
      "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
    );
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }
    module.exports = baseIsNative;
  }
});

// ../../node_modules/lodash/_getValue.js
var require_getValue = __commonJS({
  "../../node_modules/lodash/_getValue.js"(exports, module) {
    "use strict";
    function getValue(object, key) {
      return object == null ? void 0 : object[key];
    }
    module.exports = getValue;
  }
});

// ../../node_modules/lodash/_getNative.js
var require_getNative = __commonJS({
  "../../node_modules/lodash/_getNative.js"(exports, module) {
    "use strict";
    var baseIsNative = require_baseIsNative();
    var getValue = require_getValue();
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : void 0;
    }
    module.exports = getNative;
  }
});

// ../../node_modules/lodash/_Map.js
var require_Map = __commonJS({
  "../../node_modules/lodash/_Map.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var root = require_root();
    var Map2 = getNative(root, "Map");
    module.exports = Map2;
  }
});

// ../../node_modules/lodash/_nativeCreate.js
var require_nativeCreate = __commonJS({
  "../../node_modules/lodash/_nativeCreate.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var nativeCreate = getNative(Object, "create");
    module.exports = nativeCreate;
  }
});

// ../../node_modules/lodash/_hashClear.js
var require_hashClear = __commonJS({
  "../../node_modules/lodash/_hashClear.js"(exports, module) {
    "use strict";
    var nativeCreate = require_nativeCreate();
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }
    module.exports = hashClear;
  }
});

// ../../node_modules/lodash/_hashDelete.js
var require_hashDelete = __commonJS({
  "../../node_modules/lodash/_hashDelete.js"(exports, module) {
    "use strict";
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }
    module.exports = hashDelete;
  }
});

// ../../node_modules/lodash/_hashGet.js
var require_hashGet = __commonJS({
  "../../node_modules/lodash/_hashGet.js"(exports, module) {
    "use strict";
    var nativeCreate = require_nativeCreate();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? void 0 : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : void 0;
    }
    module.exports = hashGet;
  }
});

// ../../node_modules/lodash/_hashHas.js
var require_hashHas = __commonJS({
  "../../node_modules/lodash/_hashHas.js"(exports, module) {
    "use strict";
    var nativeCreate = require_nativeCreate();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== void 0 : hasOwnProperty.call(data, key);
    }
    module.exports = hashHas;
  }
});

// ../../node_modules/lodash/_hashSet.js
var require_hashSet = __commonJS({
  "../../node_modules/lodash/_hashSet.js"(exports, module) {
    "use strict";
    var nativeCreate = require_nativeCreate();
    var HASH_UNDEFINED = "__lodash_hash_undefined__";
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = nativeCreate && value === void 0 ? HASH_UNDEFINED : value;
      return this;
    }
    module.exports = hashSet;
  }
});

// ../../node_modules/lodash/_Hash.js
var require_Hash = __commonJS({
  "../../node_modules/lodash/_Hash.js"(exports, module) {
    "use strict";
    var hashClear = require_hashClear();
    var hashDelete = require_hashDelete();
    var hashGet = require_hashGet();
    var hashHas = require_hashHas();
    var hashSet = require_hashSet();
    function Hash(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    Hash.prototype.clear = hashClear;
    Hash.prototype["delete"] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;
    module.exports = Hash;
  }
});

// ../../node_modules/lodash/_mapCacheClear.js
var require_mapCacheClear = __commonJS({
  "../../node_modules/lodash/_mapCacheClear.js"(exports, module) {
    "use strict";
    var Hash = require_Hash();
    var ListCache = require_ListCache();
    var Map2 = require_Map();
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        "hash": new Hash(),
        "map": new (Map2 || ListCache)(),
        "string": new Hash()
      };
    }
    module.exports = mapCacheClear;
  }
});

// ../../node_modules/lodash/_isKeyable.js
var require_isKeyable = __commonJS({
  "../../node_modules/lodash/_isKeyable.js"(exports, module) {
    "use strict";
    function isKeyable(value) {
      var type = typeof value;
      return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
    }
    module.exports = isKeyable;
  }
});

// ../../node_modules/lodash/_getMapData.js
var require_getMapData = __commonJS({
  "../../node_modules/lodash/_getMapData.js"(exports, module) {
    "use strict";
    var isKeyable = require_isKeyable();
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
    }
    module.exports = getMapData;
  }
});

// ../../node_modules/lodash/_mapCacheDelete.js
var require_mapCacheDelete = __commonJS({
  "../../node_modules/lodash/_mapCacheDelete.js"(exports, module) {
    "use strict";
    var getMapData = require_getMapData();
    function mapCacheDelete(key) {
      var result = getMapData(this, key)["delete"](key);
      this.size -= result ? 1 : 0;
      return result;
    }
    module.exports = mapCacheDelete;
  }
});

// ../../node_modules/lodash/_mapCacheGet.js
var require_mapCacheGet = __commonJS({
  "../../node_modules/lodash/_mapCacheGet.js"(exports, module) {
    "use strict";
    var getMapData = require_getMapData();
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }
    module.exports = mapCacheGet;
  }
});

// ../../node_modules/lodash/_mapCacheHas.js
var require_mapCacheHas = __commonJS({
  "../../node_modules/lodash/_mapCacheHas.js"(exports, module) {
    "use strict";
    var getMapData = require_getMapData();
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }
    module.exports = mapCacheHas;
  }
});

// ../../node_modules/lodash/_mapCacheSet.js
var require_mapCacheSet = __commonJS({
  "../../node_modules/lodash/_mapCacheSet.js"(exports, module) {
    "use strict";
    var getMapData = require_getMapData();
    function mapCacheSet(key, value) {
      var data = getMapData(this, key), size = data.size;
      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }
    module.exports = mapCacheSet;
  }
});

// ../../node_modules/lodash/_MapCache.js
var require_MapCache = __commonJS({
  "../../node_modules/lodash/_MapCache.js"(exports, module) {
    "use strict";
    var mapCacheClear = require_mapCacheClear();
    var mapCacheDelete = require_mapCacheDelete();
    var mapCacheGet = require_mapCacheGet();
    var mapCacheHas = require_mapCacheHas();
    var mapCacheSet = require_mapCacheSet();
    function MapCache(entries) {
      var index = -1, length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype["delete"] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;
    module.exports = MapCache;
  }
});

// ../../node_modules/lodash/_stackSet.js
var require_stackSet = __commonJS({
  "../../node_modules/lodash/_stackSet.js"(exports, module) {
    "use strict";
    var ListCache = require_ListCache();
    var Map2 = require_Map();
    var MapCache = require_MapCache();
    var LARGE_ARRAY_SIZE = 200;
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }
    module.exports = stackSet;
  }
});

// ../../node_modules/lodash/_Stack.js
var require_Stack = __commonJS({
  "../../node_modules/lodash/_Stack.js"(exports, module) {
    "use strict";
    var ListCache = require_ListCache();
    var stackClear = require_stackClear();
    var stackDelete = require_stackDelete();
    var stackGet = require_stackGet();
    var stackHas = require_stackHas();
    var stackSet = require_stackSet();
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }
    Stack.prototype.clear = stackClear;
    Stack.prototype["delete"] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;
    module.exports = Stack;
  }
});

// ../../node_modules/lodash/_defineProperty.js
var require_defineProperty = __commonJS({
  "../../node_modules/lodash/_defineProperty.js"(exports, module) {
    "use strict";
    var getNative = require_getNative();
    var defineProperty = function() {
      try {
        var func = getNative(Object, "defineProperty");
        func({}, "", {});
        return func;
      } catch (e) {
      }
    }();
    module.exports = defineProperty;
  }
});

// ../../node_modules/lodash/_baseAssignValue.js
var require_baseAssignValue = __commonJS({
  "../../node_modules/lodash/_baseAssignValue.js"(exports, module) {
    "use strict";
    var defineProperty = require_defineProperty();
    function baseAssignValue(object, key, value) {
      if (key == "__proto__" && defineProperty) {
        defineProperty(object, key, {
          "configurable": true,
          "enumerable": true,
          "value": value,
          "writable": true
        });
      } else {
        object[key] = value;
      }
    }
    module.exports = baseAssignValue;
  }
});

// ../../node_modules/lodash/_assignMergeValue.js
var require_assignMergeValue = __commonJS({
  "../../node_modules/lodash/_assignMergeValue.js"(exports, module) {
    "use strict";
    var baseAssignValue = require_baseAssignValue();
    var eq = require_eq();
    function assignMergeValue(object, key, value) {
      if (value !== void 0 && !eq(object[key], value) || value === void 0 && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }
    module.exports = assignMergeValue;
  }
});

// ../../node_modules/lodash/_createBaseFor.js
var require_createBaseFor = __commonJS({
  "../../node_modules/lodash/_createBaseFor.js"(exports, module) {
    "use strict";
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }
    module.exports = createBaseFor;
  }
});

// ../../node_modules/lodash/_baseFor.js
var require_baseFor = __commonJS({
  "../../node_modules/lodash/_baseFor.js"(exports, module) {
    "use strict";
    var createBaseFor = require_createBaseFor();
    var baseFor = createBaseFor();
    module.exports = baseFor;
  }
});

// ../../node_modules/lodash/_cloneBuffer.js
var require_cloneBuffer = __commonJS({
  "../../node_modules/lodash/_cloneBuffer.js"(exports, module) {
    "use strict";
    var root = require_root();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var Buffer2 = moduleExports ? root.Buffer : void 0;
    var allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : void 0;
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
      buffer.copy(result);
      return result;
    }
    module.exports = cloneBuffer;
  }
});

// ../../node_modules/lodash/_Uint8Array.js
var require_Uint8Array = __commonJS({
  "../../node_modules/lodash/_Uint8Array.js"(exports, module) {
    "use strict";
    var root = require_root();
    var Uint8Array2 = root.Uint8Array;
    module.exports = Uint8Array2;
  }
});

// ../../node_modules/lodash/_cloneArrayBuffer.js
var require_cloneArrayBuffer = __commonJS({
  "../../node_modules/lodash/_cloneArrayBuffer.js"(exports, module) {
    "use strict";
    var Uint8Array2 = require_Uint8Array();
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array2(result).set(new Uint8Array2(arrayBuffer));
      return result;
    }
    module.exports = cloneArrayBuffer;
  }
});

// ../../node_modules/lodash/_cloneTypedArray.js
var require_cloneTypedArray = __commonJS({
  "../../node_modules/lodash/_cloneTypedArray.js"(exports, module) {
    "use strict";
    var cloneArrayBuffer = require_cloneArrayBuffer();
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }
    module.exports = cloneTypedArray;
  }
});

// ../../node_modules/lodash/_copyArray.js
var require_copyArray = __commonJS({
  "../../node_modules/lodash/_copyArray.js"(exports, module) {
    "use strict";
    function copyArray(source, array) {
      var index = -1, length = source.length;
      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }
    module.exports = copyArray;
  }
});

// ../../node_modules/lodash/_baseCreate.js
var require_baseCreate = __commonJS({
  "../../node_modules/lodash/_baseCreate.js"(exports, module) {
    "use strict";
    var isObject = require_isObject();
    var objectCreate = Object.create;
    var baseCreate = /* @__PURE__ */ function() {
      function object() {
      }
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object();
        object.prototype = void 0;
        return result;
      };
    }();
    module.exports = baseCreate;
  }
});

// ../../node_modules/lodash/_overArg.js
var require_overArg = __commonJS({
  "../../node_modules/lodash/_overArg.js"(exports, module) {
    "use strict";
    function overArg(func, transform) {
      return function(arg) {
        return func(transform(arg));
      };
    }
    module.exports = overArg;
  }
});

// ../../node_modules/lodash/_getPrototype.js
var require_getPrototype = __commonJS({
  "../../node_modules/lodash/_getPrototype.js"(exports, module) {
    "use strict";
    var overArg = require_overArg();
    var getPrototype = overArg(Object.getPrototypeOf, Object);
    module.exports = getPrototype;
  }
});

// ../../node_modules/lodash/_isPrototype.js
var require_isPrototype = __commonJS({
  "../../node_modules/lodash/_isPrototype.js"(exports, module) {
    "use strict";
    var objectProto = Object.prototype;
    function isPrototype(value) {
      var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
      return value === proto;
    }
    module.exports = isPrototype;
  }
});

// ../../node_modules/lodash/_initCloneObject.js
var require_initCloneObject = __commonJS({
  "../../node_modules/lodash/_initCloneObject.js"(exports, module) {
    "use strict";
    var baseCreate = require_baseCreate();
    var getPrototype = require_getPrototype();
    var isPrototype = require_isPrototype();
    function initCloneObject(object) {
      return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
    }
    module.exports = initCloneObject;
  }
});

// ../../node_modules/lodash/isObjectLike.js
var require_isObjectLike = __commonJS({
  "../../node_modules/lodash/isObjectLike.js"(exports, module) {
    "use strict";
    function isObjectLike(value) {
      return value != null && typeof value == "object";
    }
    module.exports = isObjectLike;
  }
});

// ../../node_modules/lodash/_baseIsArguments.js
var require_baseIsArguments = __commonJS({
  "../../node_modules/lodash/_baseIsArguments.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var isObjectLike = require_isObjectLike();
    var argsTag = "[object Arguments]";
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }
    module.exports = baseIsArguments;
  }
});

// ../../node_modules/lodash/isArguments.js
var require_isArguments = __commonJS({
  "../../node_modules/lodash/isArguments.js"(exports, module) {
    "use strict";
    var baseIsArguments = require_baseIsArguments();
    var isObjectLike = require_isObjectLike();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var propertyIsEnumerable = objectProto.propertyIsEnumerable;
    var isArguments = baseIsArguments(/* @__PURE__ */ function() {
      return arguments;
    }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
    };
    module.exports = isArguments;
  }
});

// ../../node_modules/lodash/isArray.js
var require_isArray = __commonJS({
  "../../node_modules/lodash/isArray.js"(exports, module) {
    "use strict";
    var isArray = Array.isArray;
    module.exports = isArray;
  }
});

// ../../node_modules/lodash/isLength.js
var require_isLength = __commonJS({
  "../../node_modules/lodash/isLength.js"(exports, module) {
    "use strict";
    var MAX_SAFE_INTEGER = 9007199254740991;
    function isLength(value) {
      return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }
    module.exports = isLength;
  }
});

// ../../node_modules/lodash/isArrayLike.js
var require_isArrayLike = __commonJS({
  "../../node_modules/lodash/isArrayLike.js"(exports, module) {
    "use strict";
    var isFunction = require_isFunction();
    var isLength = require_isLength();
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }
    module.exports = isArrayLike;
  }
});

// ../../node_modules/lodash/isArrayLikeObject.js
var require_isArrayLikeObject = __commonJS({
  "../../node_modules/lodash/isArrayLikeObject.js"(exports, module) {
    "use strict";
    var isArrayLike = require_isArrayLike();
    var isObjectLike = require_isObjectLike();
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }
    module.exports = isArrayLikeObject;
  }
});

// ../../node_modules/lodash/stubFalse.js
var require_stubFalse = __commonJS({
  "../../node_modules/lodash/stubFalse.js"(exports, module) {
    "use strict";
    function stubFalse() {
      return false;
    }
    module.exports = stubFalse;
  }
});

// ../../node_modules/lodash/isBuffer.js
var require_isBuffer = __commonJS({
  "../../node_modules/lodash/isBuffer.js"(exports, module) {
    "use strict";
    var root = require_root();
    var stubFalse = require_stubFalse();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var Buffer2 = moduleExports ? root.Buffer : void 0;
    var nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : void 0;
    var isBuffer = nativeIsBuffer || stubFalse;
    module.exports = isBuffer;
  }
});

// ../../node_modules/lodash/isPlainObject.js
var require_isPlainObject = __commonJS({
  "../../node_modules/lodash/isPlainObject.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var getPrototype = require_getPrototype();
    var isObjectLike = require_isObjectLike();
    var objectTag = "[object Object]";
    var funcProto = Function.prototype;
    var objectProto = Object.prototype;
    var funcToString = funcProto.toString;
    var hasOwnProperty = objectProto.hasOwnProperty;
    var objectCtorString = funcToString.call(Object);
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
      return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
    }
    module.exports = isPlainObject;
  }
});

// ../../node_modules/lodash/_baseIsTypedArray.js
var require_baseIsTypedArray = __commonJS({
  "../../node_modules/lodash/_baseIsTypedArray.js"(exports, module) {
    "use strict";
    var baseGetTag = require_baseGetTag();
    var isLength = require_isLength();
    var isObjectLike = require_isObjectLike();
    var argsTag = "[object Arguments]";
    var arrayTag = "[object Array]";
    var boolTag = "[object Boolean]";
    var dateTag = "[object Date]";
    var errorTag = "[object Error]";
    var funcTag = "[object Function]";
    var mapTag = "[object Map]";
    var numberTag = "[object Number]";
    var objectTag = "[object Object]";
    var regexpTag = "[object RegExp]";
    var setTag = "[object Set]";
    var stringTag = "[object String]";
    var weakMapTag = "[object WeakMap]";
    var arrayBufferTag = "[object ArrayBuffer]";
    var dataViewTag = "[object DataView]";
    var float32Tag = "[object Float32Array]";
    var float64Tag = "[object Float64Array]";
    var int8Tag = "[object Int8Array]";
    var int16Tag = "[object Int16Array]";
    var int32Tag = "[object Int32Array]";
    var uint8Tag = "[object Uint8Array]";
    var uint8ClampedTag = "[object Uint8ClampedArray]";
    var uint16Tag = "[object Uint16Array]";
    var uint32Tag = "[object Uint32Array]";
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }
    module.exports = baseIsTypedArray;
  }
});

// ../../node_modules/lodash/_baseUnary.js
var require_baseUnary = __commonJS({
  "../../node_modules/lodash/_baseUnary.js"(exports, module) {
    "use strict";
    function baseUnary(func) {
      return function(value) {
        return func(value);
      };
    }
    module.exports = baseUnary;
  }
});

// ../../node_modules/lodash/_nodeUtil.js
var require_nodeUtil = __commonJS({
  "../../node_modules/lodash/_nodeUtil.js"(exports, module) {
    "use strict";
    var freeGlobal = require_freeGlobal();
    var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
    var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;
    var nodeUtil = function() {
      try {
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) {
          return types;
        }
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
      } catch (e) {
      }
    }();
    module.exports = nodeUtil;
  }
});

// ../../node_modules/lodash/isTypedArray.js
var require_isTypedArray = __commonJS({
  "../../node_modules/lodash/isTypedArray.js"(exports, module) {
    "use strict";
    var baseIsTypedArray = require_baseIsTypedArray();
    var baseUnary = require_baseUnary();
    var nodeUtil = require_nodeUtil();
    var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
    module.exports = isTypedArray;
  }
});

// ../../node_modules/lodash/_safeGet.js
var require_safeGet = __commonJS({
  "../../node_modules/lodash/_safeGet.js"(exports, module) {
    "use strict";
    function safeGet(object, key) {
      if (key === "constructor" && typeof object[key] === "function") {
        return;
      }
      if (key == "__proto__") {
        return;
      }
      return object[key];
    }
    module.exports = safeGet;
  }
});

// ../../node_modules/lodash/_assignValue.js
var require_assignValue = __commonJS({
  "../../node_modules/lodash/_assignValue.js"(exports, module) {
    "use strict";
    var baseAssignValue = require_baseAssignValue();
    var eq = require_eq();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === void 0 && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }
    module.exports = assignValue;
  }
});

// ../../node_modules/lodash/_copyObject.js
var require_copyObject = __commonJS({
  "../../node_modules/lodash/_copyObject.js"(exports, module) {
    "use strict";
    var assignValue = require_assignValue();
    var baseAssignValue = require_baseAssignValue();
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});
      var index = -1, length = props.length;
      while (++index < length) {
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : void 0;
        if (newValue === void 0) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }
    module.exports = copyObject;
  }
});

// ../../node_modules/lodash/_baseTimes.js
var require_baseTimes = __commonJS({
  "../../node_modules/lodash/_baseTimes.js"(exports, module) {
    "use strict";
    function baseTimes(n, iteratee) {
      var index = -1, result = Array(n);
      while (++index < n) {
        result[index] = iteratee(index);
      }
      return result;
    }
    module.exports = baseTimes;
  }
});

// ../../node_modules/lodash/_isIndex.js
var require_isIndex = __commonJS({
  "../../node_modules/lodash/_isIndex.js"(exports, module) {
    "use strict";
    var MAX_SAFE_INTEGER = 9007199254740991;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
    }
    module.exports = isIndex;
  }
});

// ../../node_modules/lodash/_arrayLikeKeys.js
var require_arrayLikeKeys = __commonJS({
  "../../node_modules/lodash/_arrayLikeKeys.js"(exports, module) {
    "use strict";
    var baseTimes = require_baseTimes();
    var isArguments = require_isArguments();
    var isArray = require_isArray();
    var isBuffer = require_isBuffer();
    var isIndex = require_isIndex();
    var isTypedArray = require_isTypedArray();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
        (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
        isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = arrayLikeKeys;
  }
});

// ../../node_modules/lodash/_nativeKeysIn.js
var require_nativeKeysIn = __commonJS({
  "../../node_modules/lodash/_nativeKeysIn.js"(exports, module) {
    "use strict";
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = nativeKeysIn;
  }
});

// ../../node_modules/lodash/_baseKeysIn.js
var require_baseKeysIn = __commonJS({
  "../../node_modules/lodash/_baseKeysIn.js"(exports, module) {
    "use strict";
    var isObject = require_isObject();
    var isPrototype = require_isPrototype();
    var nativeKeysIn = require_nativeKeysIn();
    var objectProto = Object.prototype;
    var hasOwnProperty = objectProto.hasOwnProperty;
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object), result = [];
      for (var key in object) {
        if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }
    module.exports = baseKeysIn;
  }
});

// ../../node_modules/lodash/keysIn.js
var require_keysIn = __commonJS({
  "../../node_modules/lodash/keysIn.js"(exports, module) {
    "use strict";
    var arrayLikeKeys = require_arrayLikeKeys();
    var baseKeysIn = require_baseKeysIn();
    var isArrayLike = require_isArrayLike();
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }
    module.exports = keysIn;
  }
});

// ../../node_modules/lodash/toPlainObject.js
var require_toPlainObject = __commonJS({
  "../../node_modules/lodash/toPlainObject.js"(exports, module) {
    "use strict";
    var copyObject = require_copyObject();
    var keysIn = require_keysIn();
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }
    module.exports = toPlainObject;
  }
});

// ../../node_modules/lodash/_baseMergeDeep.js
var require_baseMergeDeep = __commonJS({
  "../../node_modules/lodash/_baseMergeDeep.js"(exports, module) {
    "use strict";
    var assignMergeValue = require_assignMergeValue();
    var cloneBuffer = require_cloneBuffer();
    var cloneTypedArray = require_cloneTypedArray();
    var copyArray = require_copyArray();
    var initCloneObject = require_initCloneObject();
    var isArguments = require_isArguments();
    var isArray = require_isArray();
    var isArrayLikeObject = require_isArrayLikeObject();
    var isBuffer = require_isBuffer();
    var isFunction = require_isFunction();
    var isObject = require_isObject();
    var isPlainObject = require_isPlainObject();
    var isTypedArray = require_isTypedArray();
    var safeGet = require_safeGet();
    var toPlainObject = require_toPlainObject();
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : void 0;
      var isCommon = newValue === void 0;
      if (isCommon) {
        var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          } else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          } else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          } else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          } else {
            newValue = [];
          }
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          } else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        } else {
          isCommon = false;
        }
      }
      if (isCommon) {
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }
    module.exports = baseMergeDeep;
  }
});

// ../../node_modules/lodash/_baseMerge.js
var require_baseMerge = __commonJS({
  "../../node_modules/lodash/_baseMerge.js"(exports, module) {
    "use strict";
    var Stack = require_Stack();
    var assignMergeValue = require_assignMergeValue();
    var baseFor = require_baseFor();
    var baseMergeDeep = require_baseMergeDeep();
    var isObject = require_isObject();
    var keysIn = require_keysIn();
    var safeGet = require_safeGet();
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack());
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        } else {
          var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : void 0;
          if (newValue === void 0) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }
    module.exports = baseMerge;
  }
});

// ../../node_modules/lodash/identity.js
var require_identity = __commonJS({
  "../../node_modules/lodash/identity.js"(exports, module) {
    "use strict";
    function identity(value) {
      return value;
    }
    module.exports = identity;
  }
});

// ../../node_modules/lodash/_apply.js
var require_apply = __commonJS({
  "../../node_modules/lodash/_apply.js"(exports, module) {
    "use strict";
    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);
        case 1:
          return func.call(thisArg, args[0]);
        case 2:
          return func.call(thisArg, args[0], args[1]);
        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }
      return func.apply(thisArg, args);
    }
    module.exports = apply;
  }
});

// ../../node_modules/lodash/_overRest.js
var require_overRest = __commonJS({
  "../../node_modules/lodash/_overRest.js"(exports, module) {
    "use strict";
    var apply = require_apply();
    var nativeMax = Math.max;
    function overRest(func, start, transform) {
      start = nativeMax(start === void 0 ? func.length - 1 : start, 0);
      return function() {
        var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array(length);
        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }
    module.exports = overRest;
  }
});

// ../../node_modules/lodash/constant.js
var require_constant = __commonJS({
  "../../node_modules/lodash/constant.js"(exports, module) {
    "use strict";
    function constant(value) {
      return function() {
        return value;
      };
    }
    module.exports = constant;
  }
});

// ../../node_modules/lodash/_baseSetToString.js
var require_baseSetToString = __commonJS({
  "../../node_modules/lodash/_baseSetToString.js"(exports, module) {
    "use strict";
    var constant = require_constant();
    var defineProperty = require_defineProperty();
    var identity = require_identity();
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": constant(string),
        "writable": true
      });
    };
    module.exports = baseSetToString;
  }
});

// ../../node_modules/lodash/_shortOut.js
var require_shortOut = __commonJS({
  "../../node_modules/lodash/_shortOut.js"(exports, module) {
    "use strict";
    var HOT_COUNT = 800;
    var HOT_SPAN = 16;
    var nativeNow = Date.now;
    function shortOut(func) {
      var count = 0, lastCalled = 0;
      return function() {
        var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(void 0, arguments);
      };
    }
    module.exports = shortOut;
  }
});

// ../../node_modules/lodash/_setToString.js
var require_setToString = __commonJS({
  "../../node_modules/lodash/_setToString.js"(exports, module) {
    "use strict";
    var baseSetToString = require_baseSetToString();
    var shortOut = require_shortOut();
    var setToString = shortOut(baseSetToString);
    module.exports = setToString;
  }
});

// ../../node_modules/lodash/_baseRest.js
var require_baseRest = __commonJS({
  "../../node_modules/lodash/_baseRest.js"(exports, module) {
    "use strict";
    var identity = require_identity();
    var overRest = require_overRest();
    var setToString = require_setToString();
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + "");
    }
    module.exports = baseRest;
  }
});

// ../../node_modules/lodash/_isIterateeCall.js
var require_isIterateeCall = __commonJS({
  "../../node_modules/lodash/_isIterateeCall.js"(exports, module) {
    "use strict";
    var eq = require_eq();
    var isArrayLike = require_isArrayLike();
    var isIndex = require_isIndex();
    var isObject = require_isObject();
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
        return eq(object[index], value);
      }
      return false;
    }
    module.exports = isIterateeCall;
  }
});

// ../../node_modules/lodash/_createAssigner.js
var require_createAssigner = __commonJS({
  "../../node_modules/lodash/_createAssigner.js"(exports, module) {
    "use strict";
    var baseRest = require_baseRest();
    var isIterateeCall = require_isIterateeCall();
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : void 0, guard = length > 2 ? sources[2] : void 0;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : void 0;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? void 0 : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }
    module.exports = createAssigner;
  }
});

// ../../node_modules/lodash/merge.js
var require_merge = __commonJS({
  "../../node_modules/lodash/merge.js"(exports, module) {
    "use strict";
    var baseMerge = require_baseMerge();
    var createAssigner = require_createAssigner();
    var merge2 = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });
    module.exports = merge2;
  }
});

// ../../node_modules/zod/lib/index.mjs
var util;
(function(util2) {
  util2.assertEqual = (val) => val;
  function assertIs(_arg) {
  }
  util2.assertIs = assertIs;
  function assertNever(_x) {
    throw new Error();
  }
  util2.assertNever = assertNever;
  util2.arrayToEnum = (items) => {
    const obj = {};
    for (const item of items) {
      obj[item] = item;
    }
    return obj;
  };
  util2.getValidEnumValues = (obj) => {
    const validKeys = util2.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
    const filtered = {};
    for (const k of validKeys) {
      filtered[k] = obj[k];
    }
    return util2.objectValues(filtered);
  };
  util2.objectValues = (obj) => {
    return util2.objectKeys(obj).map(function(e) {
      return obj[e];
    });
  };
  util2.objectKeys = typeof Object.keys === "function" ? (obj) => Object.keys(obj) : (object) => {
    const keys = [];
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        keys.push(key);
      }
    }
    return keys;
  };
  util2.find = (arr, checker) => {
    for (const item of arr) {
      if (checker(item))
        return item;
    }
    return void 0;
  };
  util2.isInteger = typeof Number.isInteger === "function" ? (val) => Number.isInteger(val) : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
  function joinValues(array, separator = " | ") {
    return array.map((val) => typeof val === "string" ? `'${val}'` : val).join(separator);
  }
  util2.joinValues = joinValues;
  util2.jsonStringifyReplacer = (_, value) => {
    if (typeof value === "bigint") {
      return value.toString();
    }
    return value;
  };
})(util || (util = {}));
var objectUtil;
(function(objectUtil2) {
  objectUtil2.mergeShapes = (first, second) => {
    return __spreadValues(__spreadValues({}, first), second);
  };
})(objectUtil || (objectUtil = {}));
var ZodParsedType = util.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]);
var getParsedType = (data) => {
  const t = typeof data;
  switch (t) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      if (Array.isArray(data)) {
        return ZodParsedType.array;
      }
      if (data === null) {
        return ZodParsedType.null;
      }
      if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
        return ZodParsedType.promise;
      }
      if (typeof Map !== "undefined" && data instanceof Map) {
        return ZodParsedType.map;
      }
      if (typeof Set !== "undefined" && data instanceof Set) {
        return ZodParsedType.set;
      }
      if (typeof Date !== "undefined" && data instanceof Date) {
        return ZodParsedType.date;
      }
      return ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
};
var ZodIssueCode = util.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
var quotelessJson = (obj) => {
  const json = JSON.stringify(obj, null, 2);
  return json.replace(/"([^"]+)":/g, "$1:");
};
var ZodError = class extends Error {
  constructor(issues) {
    super();
    this.issues = [];
    this.addIssue = (sub) => {
      this.issues = [...this.issues, sub];
    };
    this.addIssues = (subs = []) => {
      this.issues = [...this.issues, ...subs];
    };
    const actualProto = new.target.prototype;
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, actualProto);
    } else {
      this.__proto__ = actualProto;
    }
    this.name = "ZodError";
    this.issues = issues;
  }
  get errors() {
    return this.issues;
  }
  format(_mapper) {
    const mapper = _mapper || function(issue) {
      return issue.message;
    };
    const fieldErrors = { _errors: [] };
    const processError = (error) => {
      for (const issue of error.issues) {
        if (issue.code === "invalid_union") {
          issue.unionErrors.map(processError);
        } else if (issue.code === "invalid_return_type") {
          processError(issue.returnTypeError);
        } else if (issue.code === "invalid_arguments") {
          processError(issue.argumentsError);
        } else if (issue.path.length === 0) {
          fieldErrors._errors.push(mapper(issue));
        } else {
          let curr = fieldErrors;
          let i = 0;
          while (i < issue.path.length) {
            const el = issue.path[i];
            const terminal = i === issue.path.length - 1;
            if (!terminal) {
              curr[el] = curr[el] || { _errors: [] };
            } else {
              curr[el] = curr[el] || { _errors: [] };
              curr[el]._errors.push(mapper(issue));
            }
            curr = curr[el];
            i++;
          }
        }
      }
    };
    processError(this);
    return fieldErrors;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(mapper = (issue) => issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of this.issues) {
      if (sub.path.length > 0) {
        fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
        fieldErrors[sub.path[0]].push(mapper(sub));
      } else {
        formErrors.push(mapper(sub));
      }
    }
    return { formErrors, fieldErrors };
  }
  get formErrors() {
    return this.flatten();
  }
};
ZodError.create = (issues) => {
  const error = new ZodError(issues);
  return error;
};
var errorMap = (issue, _ctx) => {
  let message;
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === ZodParsedType.undefined) {
        message = "Required";
      } else {
        message = `Expected ${issue.expected}, received ${issue.received}`;
      }
      break;
    case ZodIssueCode.invalid_literal:
      message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_union_discriminator:
      message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      message = `Invalid function arguments`;
      break;
    case ZodIssueCode.invalid_return_type:
      message = `Invalid function return type`;
      break;
    case ZodIssueCode.invalid_date:
      message = `Invalid date`;
      break;
    case ZodIssueCode.invalid_string:
      if (typeof issue.validation === "object") {
        if ("includes" in issue.validation) {
          message = `Invalid input: must include "${issue.validation.includes}"`;
          if (typeof issue.validation.position === "number") {
            message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
          }
        } else if ("startsWith" in issue.validation) {
          message = `Invalid input: must start with "${issue.validation.startsWith}"`;
        } else if ("endsWith" in issue.validation) {
          message = `Invalid input: must end with "${issue.validation.endsWith}"`;
        } else {
          util.assertNever(issue.validation);
        }
      } else if (issue.validation !== "regex") {
        message = `Invalid ${issue.validation}`;
      } else {
        message = "Invalid";
      }
      break;
    case ZodIssueCode.too_small:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "bigint")
        message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.custom:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_intersection_types:
      message = `Intersection results could not be merged`;
      break;
    case ZodIssueCode.not_multiple_of:
      message = `Number must be a multiple of ${issue.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      message = "Number must be finite";
      break;
    default:
      message = _ctx.defaultError;
      util.assertNever(issue);
  }
  return { message };
};
var overrideErrorMap = errorMap;
function setErrorMap(map) {
  overrideErrorMap = map;
}
function getErrorMap() {
  return overrideErrorMap;
}
var makeIssue = (params) => {
  const { data, path, errorMaps, issueData } = params;
  const fullPath = [...path, ...issueData.path || []];
  const fullIssue = __spreadProps(__spreadValues({}, issueData), {
    path: fullPath
  });
  let errorMessage = "";
  const maps = errorMaps.filter((m) => !!m).slice().reverse();
  for (const map of maps) {
    errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
  }
  return __spreadProps(__spreadValues({}, issueData), {
    path: fullPath,
    message: issueData.message || errorMessage
  });
};
var EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
  const issue = makeIssue({
    issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [
      ctx.common.contextualErrorMap,
      ctx.schemaErrorMap,
      getErrorMap(),
      errorMap
      // then global default map
    ].filter((x) => !!x)
  });
  ctx.common.issues.push(issue);
}
var ParseStatus = class _ParseStatus {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    if (this.value === "valid")
      this.value = "dirty";
  }
  abort() {
    if (this.value !== "aborted")
      this.value = "aborted";
  }
  static mergeArray(status, results) {
    const arrayValue = [];
    for (const s of results) {
      if (s.status === "aborted")
        return INVALID;
      if (s.status === "dirty")
        status.dirty();
      arrayValue.push(s.value);
    }
    return { status: status.value, value: arrayValue };
  }
  static mergeObjectAsync(status, pairs) {
    return __async(this, null, function* () {
      const syncPairs = [];
      for (const pair of pairs) {
        syncPairs.push({
          key: yield pair.key,
          value: yield pair.value
        });
      }
      return _ParseStatus.mergeObjectSync(status, syncPairs);
    });
  }
  static mergeObjectSync(status, pairs) {
    const finalObject = {};
    for (const pair of pairs) {
      const { key, value } = pair;
      if (key.status === "aborted")
        return INVALID;
      if (value.status === "aborted")
        return INVALID;
      if (key.status === "dirty")
        status.dirty();
      if (value.status === "dirty")
        status.dirty();
      if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) {
        finalObject[key.value] = value.value;
      }
    }
    return { status: status.value, value: finalObject };
  }
};
var INVALID = Object.freeze({
  status: "aborted"
});
var DIRTY = (value) => ({ status: "dirty", value });
var OK = (value) => ({ status: "valid", value });
var isAborted = (x) => x.status === "aborted";
var isDirty = (x) => x.status === "dirty";
var isValid = (x) => x.status === "valid";
var isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;
var errorUtil;
(function(errorUtil2) {
  errorUtil2.errToObj = (message) => typeof message === "string" ? { message } : message || {};
  errorUtil2.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));
var ParseInputLazyPath = class {
  constructor(parent, value, path, key) {
    this._cachedPath = [];
    this.parent = parent;
    this.data = value;
    this._path = path;
    this._key = key;
  }
  get path() {
    if (!this._cachedPath.length) {
      if (this._key instanceof Array) {
        this._cachedPath.push(...this._path, ...this._key);
      } else {
        this._cachedPath.push(...this._path, this._key);
      }
    }
    return this._cachedPath;
  }
};
var handleResult = (ctx, result) => {
  if (isValid(result)) {
    return { success: true, data: result.value };
  } else {
    if (!ctx.common.issues.length) {
      throw new Error("Validation failed but no issues detected.");
    }
    return {
      success: false,
      get error() {
        if (this._error)
          return this._error;
        const error = new ZodError(ctx.common.issues);
        this._error = error;
        return this._error;
      }
    };
  }
};
function processCreateParams(params) {
  if (!params)
    return {};
  const { errorMap: errorMap2, invalid_type_error, required_error, description } = params;
  if (errorMap2 && (invalid_type_error || required_error)) {
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  }
  if (errorMap2)
    return { errorMap: errorMap2, description };
  const customMap = (iss, ctx) => {
    if (iss.code !== "invalid_type")
      return { message: ctx.defaultError };
    if (typeof ctx.data === "undefined") {
      return { message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError };
    }
    return { message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError };
  };
  return { errorMap: customMap, description };
}
var ZodType = class {
  constructor(def) {
    this.spa = this.safeParseAsync;
    this._def = def;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this.brand = this.brand.bind(this);
    this.default = this.default.bind(this);
    this.catch = this.catch.bind(this);
    this.describe = this.describe.bind(this);
    this.pipe = this.pipe.bind(this);
    this.readonly = this.readonly.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(input) {
    return getParsedType(input.data);
  }
  _getOrReturnCtx(input, ctx) {
    return ctx || {
      common: input.parent.common,
      data: input.data,
      parsedType: getParsedType(input.data),
      schemaErrorMap: this._def.errorMap,
      path: input.path,
      parent: input.parent
    };
  }
  _processInputParams(input) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      }
    };
  }
  _parseSync(input) {
    const result = this._parse(input);
    if (isAsync(result)) {
      throw new Error("Synchronous parse encountered promise.");
    }
    return result;
  }
  _parseAsync(input) {
    const result = this._parse(input);
    return Promise.resolve(result);
  }
  parse(data, params) {
    const result = this.safeParse(data, params);
    if (result.success)
      return result.data;
    throw result.error;
  }
  safeParse(data, params) {
    var _a;
    const ctx = {
      common: {
        issues: [],
        async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
      },
      path: (params === null || params === void 0 ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const result = this._parseSync({ data, path: ctx.path, parent: ctx });
    return handleResult(ctx, result);
  }
  parseAsync(data, params) {
    return __async(this, null, function* () {
      const result = yield this.safeParseAsync(data, params);
      if (result.success)
        return result.data;
      throw result.error;
    });
  }
  safeParseAsync(data, params) {
    return __async(this, null, function* () {
      const ctx = {
        common: {
          issues: [],
          contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
          async: true
        },
        path: (params === null || params === void 0 ? void 0 : params.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data,
        parsedType: getParsedType(data)
      };
      const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
      const result = yield isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult);
      return handleResult(ctx, result);
    });
  }
  refine(check, message) {
    const getIssueProperties = (val) => {
      if (typeof message === "string" || typeof message === "undefined") {
        return { message };
      } else if (typeof message === "function") {
        return message(val);
      } else {
        return message;
      }
    };
    return this._refinement((val, ctx) => {
      const result = check(val);
      const setError = () => ctx.addIssue(__spreadValues({
        code: ZodIssueCode.custom
      }, getIssueProperties(val)));
      if (typeof Promise !== "undefined" && result instanceof Promise) {
        return result.then((data) => {
          if (!data) {
            setError();
            return false;
          } else {
            return true;
          }
        });
      }
      if (!result) {
        setError();
        return false;
      } else {
        return true;
      }
    });
  }
  refinement(check, refinementData) {
    return this._refinement((val, ctx) => {
      if (!check(val)) {
        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
        return false;
      } else {
        return true;
      }
    });
  }
  _refinement(refinement) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement }
    });
  }
  superRefine(refinement) {
    return this._refinement(refinement);
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this, this._def);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(option) {
    return ZodUnion.create([this, option], this._def);
  }
  and(incoming) {
    return ZodIntersection.create(this, incoming, this._def);
  }
  transform(transform) {
    return new ZodEffects(__spreadProps(__spreadValues({}, processCreateParams(this._def)), {
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform }
    }));
  }
  default(def) {
    const defaultValueFunc = typeof def === "function" ? def : () => def;
    return new ZodDefault(__spreadProps(__spreadValues({}, processCreateParams(this._def)), {
      innerType: this,
      defaultValue: defaultValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    }));
  }
  brand() {
    return new ZodBranded(__spreadValues({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this
    }, processCreateParams(this._def)));
  }
  catch(def) {
    const catchValueFunc = typeof def === "function" ? def : () => def;
    return new ZodCatch(__spreadProps(__spreadValues({}, processCreateParams(this._def)), {
      innerType: this,
      catchValue: catchValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    }));
  }
  describe(description) {
    const This = this.constructor;
    return new This(__spreadProps(__spreadValues({}, this._def), {
      description
    }));
  }
  pipe(target) {
    return ZodPipeline.create(this, target);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
var cuidRegex = /^c[^\s-]{8,}$/i;
var cuid2Regex = /^[a-z][a-z0-9]*$/;
var ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
var uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
var emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
var _emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
var emojiRegex;
var ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
var ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
var datetimeRegex = (args) => {
  if (args.precision) {
    if (args.offset) {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
    } else {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    }
  } else if (args.precision === 0) {
    if (args.offset) {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
    } else {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    }
  } else {
    if (args.offset) {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
    } else {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
  }
};
function isValidIP(ip, version) {
  if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
    return true;
  }
  if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
    return true;
  }
  return false;
}
var ZodString = class _ZodString extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = String(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.string) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(
        ctx2,
        {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.string,
          received: ctx2.parsedType
        }
        //
      );
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.length < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.length > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "length") {
        const tooBig = input.data.length > check.value;
        const tooSmall = input.data.length < check.value;
        if (tooBig || tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          if (tooBig) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          } else if (tooSmall) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          }
          status.dirty();
        }
      } else if (check.kind === "email") {
        if (!emailRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "email",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "emoji") {
        if (!emojiRegex) {
          emojiRegex = new RegExp(_emojiRegex, "u");
        }
        if (!emojiRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "emoji",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "uuid") {
        if (!uuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "uuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid") {
        if (!cuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid2") {
        if (!cuid2Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid2",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ulid") {
        if (!ulidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ulid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "url") {
        try {
          new URL(input.data);
        } catch (_a) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "url",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "regex") {
        check.regex.lastIndex = 0;
        const testResult = check.regex.test(input.data);
        if (!testResult) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "regex",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "trim") {
        input.data = input.data.trim();
      } else if (check.kind === "includes") {
        if (!input.data.includes(check.value, check.position)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { includes: check.value, position: check.position },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "toLowerCase") {
        input.data = input.data.toLowerCase();
      } else if (check.kind === "toUpperCase") {
        input.data = input.data.toUpperCase();
      } else if (check.kind === "startsWith") {
        if (!input.data.startsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { startsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "endsWith") {
        if (!input.data.endsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { endsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "datetime") {
        const regex = datetimeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "datetime",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ip") {
        if (!isValidIP(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ip",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _regex(regex, validation, message) {
    return this.refinement((data) => regex.test(data), __spreadValues({
      validation,
      code: ZodIssueCode.invalid_string
    }, errorUtil.errToObj(message)));
  }
  _addCheck(check) {
    return new _ZodString(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, check]
    }));
  }
  email(message) {
    return this._addCheck(__spreadValues({ kind: "email" }, errorUtil.errToObj(message)));
  }
  url(message) {
    return this._addCheck(__spreadValues({ kind: "url" }, errorUtil.errToObj(message)));
  }
  emoji(message) {
    return this._addCheck(__spreadValues({ kind: "emoji" }, errorUtil.errToObj(message)));
  }
  uuid(message) {
    return this._addCheck(__spreadValues({ kind: "uuid" }, errorUtil.errToObj(message)));
  }
  cuid(message) {
    return this._addCheck(__spreadValues({ kind: "cuid" }, errorUtil.errToObj(message)));
  }
  cuid2(message) {
    return this._addCheck(__spreadValues({ kind: "cuid2" }, errorUtil.errToObj(message)));
  }
  ulid(message) {
    return this._addCheck(__spreadValues({ kind: "ulid" }, errorUtil.errToObj(message)));
  }
  ip(options) {
    return this._addCheck(__spreadValues({ kind: "ip" }, errorUtil.errToObj(options)));
  }
  datetime(options) {
    var _a;
    if (typeof options === "string") {
      return this._addCheck({
        kind: "datetime",
        precision: null,
        offset: false,
        message: options
      });
    }
    return this._addCheck(__spreadValues({
      kind: "datetime",
      precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
      offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false
    }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
  }
  regex(regex, message) {
    return this._addCheck(__spreadValues({
      kind: "regex",
      regex
    }, errorUtil.errToObj(message)));
  }
  includes(value, options) {
    return this._addCheck(__spreadValues({
      kind: "includes",
      value,
      position: options === null || options === void 0 ? void 0 : options.position
    }, errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)));
  }
  startsWith(value, message) {
    return this._addCheck(__spreadValues({
      kind: "startsWith",
      value
    }, errorUtil.errToObj(message)));
  }
  endsWith(value, message) {
    return this._addCheck(__spreadValues({
      kind: "endsWith",
      value
    }, errorUtil.errToObj(message)));
  }
  min(minLength, message) {
    return this._addCheck(__spreadValues({
      kind: "min",
      value: minLength
    }, errorUtil.errToObj(message)));
  }
  max(maxLength, message) {
    return this._addCheck(__spreadValues({
      kind: "max",
      value: maxLength
    }, errorUtil.errToObj(message)));
  }
  length(len, message) {
    return this._addCheck(__spreadValues({
      kind: "length",
      value: len
    }, errorUtil.errToObj(message)));
  }
  /**
   * @deprecated Use z.string().min(1) instead.
   * @see {@link ZodString.min}
   */
  nonempty(message) {
    return this.min(1, errorUtil.errToObj(message));
  }
  trim() {
    return new _ZodString(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, { kind: "trim" }]
    }));
  }
  toLowerCase() {
    return new _ZodString(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    }));
  }
  toUpperCase() {
    return new _ZodString(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    }));
  }
  get isDatetime() {
    return !!this._def.checks.find((ch) => ch.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((ch) => ch.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((ch) => ch.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((ch) => ch.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((ch) => ch.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((ch) => ch.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((ch) => ch.kind === "ip");
  }
  get minLength() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxLength() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
};
ZodString.create = (params) => {
  var _a;
  return new ZodString(__spreadValues({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
  }, processCreateParams(params)));
};
function floatSafeRemainder(val, step) {
  const valDecCount = (val.toString().split(".")[1] || "").length;
  const stepDecCount = (step.toString().split(".")[1] || "").length;
  const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
  const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / Math.pow(10, decCount);
}
var ZodNumber = class _ZodNumber extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
    this.step = this.multipleOf;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = Number(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.number) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "int") {
        if (!util.isInteger(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: "integer",
            received: "float",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (floatSafeRemainder(input.data, check.value) !== 0) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "finite") {
        if (!Number.isFinite(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_finite,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new _ZodNumber(__spreadProps(__spreadValues({}, this._def), {
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    }));
  }
  _addCheck(check) {
    return new _ZodNumber(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, check]
    }));
  }
  int(message) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(message)
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  finite(message) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(message)
    });
  }
  safe(message) {
    return this._addCheck({
      kind: "min",
      inclusive: true,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(message)
    })._addCheck({
      kind: "max",
      inclusive: true,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
  get isInt() {
    return !!this._def.checks.find((ch) => ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value));
  }
  get isFinite() {
    let max = null, min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") {
        return true;
      } else if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      } else if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return Number.isFinite(min) && Number.isFinite(max);
  }
};
ZodNumber.create = (params) => {
  return new ZodNumber(__spreadValues({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodNumber,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
  }, processCreateParams(params)));
};
var ZodBigInt = class _ZodBigInt extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = BigInt(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.bigint) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.bigint,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            type: "bigint",
            minimum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            type: "bigint",
            maximum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (input.data % check.value !== BigInt(0)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new _ZodBigInt(__spreadProps(__spreadValues({}, this._def), {
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    }));
  }
  _addCheck(check) {
    return new _ZodBigInt(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, check]
    }));
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
};
ZodBigInt.create = (params) => {
  var _a;
  return new ZodBigInt(__spreadValues({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false
  }, processCreateParams(params)));
};
var ZodBoolean = class extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = Boolean(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.boolean) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodBoolean.create = (params) => {
  return new ZodBoolean(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodBoolean,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false
  }, processCreateParams(params)));
};
var ZodDate = class _ZodDate extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = new Date(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.date) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    if (isNaN(input.data.getTime())) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_date
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.getTime() < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            message: check.message,
            inclusive: true,
            exact: false,
            minimum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.getTime() > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            message: check.message,
            inclusive: true,
            exact: false,
            maximum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return {
      status: status.value,
      value: new Date(input.data.getTime())
    };
  }
  _addCheck(check) {
    return new _ZodDate(__spreadProps(__spreadValues({}, this._def), {
      checks: [...this._def.checks, check]
    }));
  }
  min(minDate, message) {
    return this._addCheck({
      kind: "min",
      value: minDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  max(maxDate, message) {
    return this._addCheck({
      kind: "max",
      value: maxDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  get minDate() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min != null ? new Date(min) : null;
  }
  get maxDate() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max != null ? new Date(max) : null;
  }
};
ZodDate.create = (params) => {
  return new ZodDate(__spreadValues({
    checks: [],
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    typeName: ZodFirstPartyTypeKind.ZodDate
  }, processCreateParams(params)));
};
var ZodSymbol = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.symbol) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodSymbol.create = (params) => {
  return new ZodSymbol(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodSymbol
  }, processCreateParams(params)));
};
var ZodUndefined = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodUndefined.create = (params) => {
  return new ZodUndefined(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodUndefined
  }, processCreateParams(params)));
};
var ZodNull = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.null) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodNull.create = (params) => {
  return new ZodNull(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodNull
  }, processCreateParams(params)));
};
var ZodAny = class extends ZodType {
  constructor() {
    super(...arguments);
    this._any = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
ZodAny.create = (params) => {
  return new ZodAny(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodAny
  }, processCreateParams(params)));
};
var ZodUnknown = class extends ZodType {
  constructor() {
    super(...arguments);
    this._unknown = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
ZodUnknown.create = (params) => {
  return new ZodUnknown(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodUnknown
  }, processCreateParams(params)));
};
var ZodNever = class extends ZodType {
  _parse(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: ctx.parsedType
    });
    return INVALID;
  }
};
ZodNever.create = (params) => {
  return new ZodNever(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodNever
  }, processCreateParams(params)));
};
var ZodVoid = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodVoid.create = (params) => {
  return new ZodVoid(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodVoid
  }, processCreateParams(params)));
};
var ZodArray = class _ZodArray extends ZodType {
  _parse(input) {
    const { ctx, status } = this._processInputParams(input);
    const def = this._def;
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (def.exactLength !== null) {
      const tooBig = ctx.data.length > def.exactLength.value;
      const tooSmall = ctx.data.length < def.exactLength.value;
      if (tooBig || tooSmall) {
        addIssueToContext(ctx, {
          code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
          minimum: tooSmall ? def.exactLength.value : void 0,
          maximum: tooBig ? def.exactLength.value : void 0,
          type: "array",
          inclusive: true,
          exact: true,
          message: def.exactLength.message
        });
        status.dirty();
      }
    }
    if (def.minLength !== null) {
      if (ctx.data.length < def.minLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.minLength.message
        });
        status.dirty();
      }
    }
    if (def.maxLength !== null) {
      if (ctx.data.length > def.maxLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.maxLength.message
        });
        status.dirty();
      }
    }
    if (ctx.common.async) {
      return Promise.all([...ctx.data].map((item, i) => {
        return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
      })).then((result2) => {
        return ParseStatus.mergeArray(status, result2);
      });
    }
    const result = [...ctx.data].map((item, i) => {
      return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
    });
    return ParseStatus.mergeArray(status, result);
  }
  get element() {
    return this._def.type;
  }
  min(minLength, message) {
    return new _ZodArray(__spreadProps(__spreadValues({}, this._def), {
      minLength: { value: minLength, message: errorUtil.toString(message) }
    }));
  }
  max(maxLength, message) {
    return new _ZodArray(__spreadProps(__spreadValues({}, this._def), {
      maxLength: { value: maxLength, message: errorUtil.toString(message) }
    }));
  }
  length(len, message) {
    return new _ZodArray(__spreadProps(__spreadValues({}, this._def), {
      exactLength: { value: len, message: errorUtil.toString(message) }
    }));
  }
  nonempty(message) {
    return this.min(1, message);
  }
};
ZodArray.create = (schema, params) => {
  return new ZodArray(__spreadValues({
    type: schema,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: ZodFirstPartyTypeKind.ZodArray
  }, processCreateParams(params)));
};
function deepPartialify(schema) {
  if (schema instanceof ZodObject) {
    const newShape = {};
    for (const key in schema.shape) {
      const fieldSchema = schema.shape[key];
      newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
    }
    return new ZodObject(__spreadProps(__spreadValues({}, schema._def), {
      shape: () => newShape
    }));
  } else if (schema instanceof ZodArray) {
    return new ZodArray(__spreadProps(__spreadValues({}, schema._def), {
      type: deepPartialify(schema.element)
    }));
  } else if (schema instanceof ZodOptional) {
    return ZodOptional.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodNullable) {
    return ZodNullable.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodTuple) {
    return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
  } else {
    return schema;
  }
}
var ZodObject = class _ZodObject extends ZodType {
  constructor() {
    super(...arguments);
    this._cached = null;
    this.nonstrict = this.passthrough;
    this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const shape = this._def.shape();
    const keys = util.objectKeys(shape);
    return this._cached = { shape, keys };
  }
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.object) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const { status, ctx } = this._processInputParams(input);
    const { shape, keys: shapeKeys } = this._getCached();
    const extraKeys = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
      for (const key in ctx.data) {
        if (!shapeKeys.includes(key)) {
          extraKeys.push(key);
        }
      }
    }
    const pairs = [];
    for (const key of shapeKeys) {
      const keyValidator = shape[key];
      const value = ctx.data[key];
      pairs.push({
        key: { status: "valid", value: key },
        value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
        alwaysSet: key in ctx.data
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const unknownKeys = this._def.unknownKeys;
      if (unknownKeys === "passthrough") {
        for (const key of extraKeys) {
          pairs.push({
            key: { status: "valid", value: key },
            value: { status: "valid", value: ctx.data[key] }
          });
        }
      } else if (unknownKeys === "strict") {
        if (extraKeys.length > 0) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.unrecognized_keys,
            keys: extraKeys
          });
          status.dirty();
        }
      } else if (unknownKeys === "strip") ;
      else {
        throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
      }
    } else {
      const catchall = this._def.catchall;
      for (const key of extraKeys) {
        const value = ctx.data[key];
        pairs.push({
          key: { status: "valid", value: key },
          value: catchall._parse(
            new ParseInputLazyPath(ctx, value, ctx.path, key)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: key in ctx.data
        });
      }
    }
    if (ctx.common.async) {
      return Promise.resolve().then(() => __async(this, null, function* () {
        const syncPairs = [];
        for (const pair of pairs) {
          const key = yield pair.key;
          syncPairs.push({
            key,
            value: yield pair.value,
            alwaysSet: pair.alwaysSet
          });
        }
        return syncPairs;
      })).then((syncPairs) => {
        return ParseStatus.mergeObjectSync(status, syncPairs);
      });
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get shape() {
    return this._def.shape();
  }
  strict(message) {
    errorUtil.errToObj;
    return new _ZodObject(__spreadValues(__spreadProps(__spreadValues({}, this._def), {
      unknownKeys: "strict"
    }), message !== void 0 ? {
      errorMap: (issue, ctx) => {
        var _a, _b, _c, _d;
        const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
        if (issue.code === "unrecognized_keys")
          return {
            message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
          };
        return {
          message: defaultError
        };
      }
    } : {}));
  }
  strip() {
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      unknownKeys: "strip"
    }));
  }
  passthrough() {
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      unknownKeys: "passthrough"
    }));
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(augmentation) {
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => __spreadValues(__spreadValues({}, this._def.shape()), augmentation)
    }));
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(merging) {
    const merged = new _ZodObject({
      unknownKeys: merging._def.unknownKeys,
      catchall: merging._def.catchall,
      shape: () => __spreadValues(__spreadValues({}, this._def.shape()), merging._def.shape()),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
    return merged;
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(key, schema) {
    return this.augment({ [key]: schema });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(index) {
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      catchall: index
    }));
  }
  pick(mask) {
    const shape = {};
    util.objectKeys(mask).forEach((key) => {
      if (mask[key] && this.shape[key]) {
        shape[key] = this.shape[key];
      }
    });
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => shape
    }));
  }
  omit(mask) {
    const shape = {};
    util.objectKeys(this.shape).forEach((key) => {
      if (!mask[key]) {
        shape[key] = this.shape[key];
      }
    });
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => shape
    }));
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(mask) {
    const newShape = {};
    util.objectKeys(this.shape).forEach((key) => {
      const fieldSchema = this.shape[key];
      if (mask && !mask[key]) {
        newShape[key] = fieldSchema;
      } else {
        newShape[key] = fieldSchema.optional();
      }
    });
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => newShape
    }));
  }
  required(mask) {
    const newShape = {};
    util.objectKeys(this.shape).forEach((key) => {
      if (mask && !mask[key]) {
        newShape[key] = this.shape[key];
      } else {
        const fieldSchema = this.shape[key];
        let newField = fieldSchema;
        while (newField instanceof ZodOptional) {
          newField = newField._def.innerType;
        }
        newShape[key] = newField;
      }
    });
    return new _ZodObject(__spreadProps(__spreadValues({}, this._def), {
      shape: () => newShape
    }));
  }
  keyof() {
    return createZodEnum(util.objectKeys(this.shape));
  }
};
ZodObject.create = (shape, params) => {
  return new ZodObject(__spreadValues({
    shape: () => shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};
ZodObject.strictCreate = (shape, params) => {
  return new ZodObject(__spreadValues({
    shape: () => shape,
    unknownKeys: "strict",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};
ZodObject.lazycreate = (shape, params) => {
  return new ZodObject(__spreadValues({
    shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject
  }, processCreateParams(params)));
};
var ZodUnion = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const options = this._def.options;
    function handleResults(results) {
      for (const result of results) {
        if (result.result.status === "valid") {
          return result.result;
        }
      }
      for (const result of results) {
        if (result.result.status === "dirty") {
          ctx.common.issues.push(...result.ctx.common.issues);
          return result.result;
        }
      }
      const unionErrors = results.map((result) => new ZodError(result.ctx.common.issues));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return Promise.all(options.map((option) => __async(this, null, function* () {
        const childCtx = __spreadProps(__spreadValues({}, ctx), {
          common: __spreadProps(__spreadValues({}, ctx.common), {
            issues: []
          }),
          parent: null
        });
        return {
          result: yield option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: childCtx
          }),
          ctx: childCtx
        };
      }))).then(handleResults);
    } else {
      let dirty = void 0;
      const issues = [];
      for (const option of options) {
        const childCtx = __spreadProps(__spreadValues({}, ctx), {
          common: __spreadProps(__spreadValues({}, ctx.common), {
            issues: []
          }),
          parent: null
        });
        const result = option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: childCtx
        });
        if (result.status === "valid") {
          return result;
        } else if (result.status === "dirty" && !dirty) {
          dirty = { result, ctx: childCtx };
        }
        if (childCtx.common.issues.length) {
          issues.push(childCtx.common.issues);
        }
      }
      if (dirty) {
        ctx.common.issues.push(...dirty.ctx.common.issues);
        return dirty.result;
      }
      const unionErrors = issues.map((issues2) => new ZodError(issues2));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
};
ZodUnion.create = (types, params) => {
  return new ZodUnion(__spreadValues({
    options: types,
    typeName: ZodFirstPartyTypeKind.ZodUnion
  }, processCreateParams(params)));
};
var getDiscriminator = (type) => {
  if (type instanceof ZodLazy) {
    return getDiscriminator(type.schema);
  } else if (type instanceof ZodEffects) {
    return getDiscriminator(type.innerType());
  } else if (type instanceof ZodLiteral) {
    return [type.value];
  } else if (type instanceof ZodEnum) {
    return type.options;
  } else if (type instanceof ZodNativeEnum) {
    return Object.keys(type.enum);
  } else if (type instanceof ZodDefault) {
    return getDiscriminator(type._def.innerType);
  } else if (type instanceof ZodUndefined) {
    return [void 0];
  } else if (type instanceof ZodNull) {
    return [null];
  } else {
    return null;
  }
};
var ZodDiscriminatedUnion = class _ZodDiscriminatedUnion extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const discriminator = this.discriminator;
    const discriminatorValue = ctx.data[discriminator];
    const option = this.optionsMap.get(discriminatorValue);
    if (!option) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [discriminator]
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return option._parseAsync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    } else {
      return option._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    }
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(discriminator, options, params) {
    const optionsMap = /* @__PURE__ */ new Map();
    for (const type of options) {
      const discriminatorValues = getDiscriminator(type.shape[discriminator]);
      if (!discriminatorValues) {
        throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
      }
      for (const value of discriminatorValues) {
        if (optionsMap.has(value)) {
          throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
        }
        optionsMap.set(value, type);
      }
    }
    return new _ZodDiscriminatedUnion(__spreadValues({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator,
      options,
      optionsMap
    }, processCreateParams(params)));
  }
};
function mergeValues(a, b) {
  const aType = getParsedType(a);
  const bType = getParsedType(b);
  if (a === b) {
    return { valid: true, data: a };
  } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
    const bKeys = util.objectKeys(b);
    const sharedKeys = util.objectKeys(a).filter((key) => bKeys.indexOf(key) !== -1);
    const newObj = __spreadValues(__spreadValues({}, a), b);
    for (const key of sharedKeys) {
      const sharedValue = mergeValues(a[key], b[key]);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newObj[key] = sharedValue.data;
    }
    return { valid: true, data: newObj };
  } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
    if (a.length !== b.length) {
      return { valid: false };
    }
    const newArray = [];
    for (let index = 0; index < a.length; index++) {
      const itemA = a[index];
      const itemB = b[index];
      const sharedValue = mergeValues(itemA, itemB);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newArray.push(sharedValue.data);
    }
    return { valid: true, data: newArray };
  } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) {
    return { valid: true, data: a };
  } else {
    return { valid: false };
  }
}
var ZodIntersection = class extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const handleParsed = (parsedLeft, parsedRight) => {
      if (isAborted(parsedLeft) || isAborted(parsedRight)) {
        return INVALID;
      }
      const merged = mergeValues(parsedLeft.value, parsedRight.value);
      if (!merged.valid) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_intersection_types
        });
        return INVALID;
      }
      if (isDirty(parsedLeft) || isDirty(parsedRight)) {
        status.dirty();
      }
      return { status: status.value, value: merged.data };
    };
    if (ctx.common.async) {
      return Promise.all([
        this._def.left._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }),
        this._def.right._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        })
      ]).then(([left, right]) => handleParsed(left, right));
    } else {
      return handleParsed(this._def.left._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }), this._def.right._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }));
    }
  }
};
ZodIntersection.create = (left, right, params) => {
  return new ZodIntersection(__spreadValues({
    left,
    right,
    typeName: ZodFirstPartyTypeKind.ZodIntersection
  }, processCreateParams(params)));
};
var ZodTuple = class _ZodTuple extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (ctx.data.length < this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      return INVALID;
    }
    const rest = this._def.rest;
    if (!rest && ctx.data.length > this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_big,
        maximum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      status.dirty();
    }
    const items = [...ctx.data].map((item, itemIndex) => {
      const schema = this._def.items[itemIndex] || this._def.rest;
      if (!schema)
        return null;
      return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
    }).filter((x) => !!x);
    if (ctx.common.async) {
      return Promise.all(items).then((results) => {
        return ParseStatus.mergeArray(status, results);
      });
    } else {
      return ParseStatus.mergeArray(status, items);
    }
  }
  get items() {
    return this._def.items;
  }
  rest(rest) {
    return new _ZodTuple(__spreadProps(__spreadValues({}, this._def), {
      rest
    }));
  }
};
ZodTuple.create = (schemas, params) => {
  if (!Array.isArray(schemas)) {
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  }
  return new ZodTuple(__spreadValues({
    items: schemas,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null
  }, processCreateParams(params)));
};
var ZodRecord = class _ZodRecord extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const pairs = [];
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    for (const key in ctx.data) {
      pairs.push({
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
        value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
      });
    }
    if (ctx.common.async) {
      return ParseStatus.mergeObjectAsync(status, pairs);
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get element() {
    return this._def.valueType;
  }
  static create(first, second, third) {
    if (second instanceof ZodType) {
      return new _ZodRecord(__spreadValues({
        keyType: first,
        valueType: second,
        typeName: ZodFirstPartyTypeKind.ZodRecord
      }, processCreateParams(third)));
    }
    return new _ZodRecord(__spreadValues({
      keyType: ZodString.create(),
      valueType: first,
      typeName: ZodFirstPartyTypeKind.ZodRecord
    }, processCreateParams(second)));
  }
};
var ZodMap = class extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.map) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    const pairs = [...ctx.data.entries()].map(([key, value], index) => {
      return {
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
        value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"]))
      };
    });
    if (ctx.common.async) {
      const finalMap = /* @__PURE__ */ new Map();
      return Promise.resolve().then(() => __async(this, null, function* () {
        for (const pair of pairs) {
          const key = yield pair.key;
          const value = yield pair.value;
          if (key.status === "aborted" || value.status === "aborted") {
            return INVALID;
          }
          if (key.status === "dirty" || value.status === "dirty") {
            status.dirty();
          }
          finalMap.set(key.value, value.value);
        }
        return { status: status.value, value: finalMap };
      }));
    } else {
      const finalMap = /* @__PURE__ */ new Map();
      for (const pair of pairs) {
        const key = pair.key;
        const value = pair.value;
        if (key.status === "aborted" || value.status === "aborted") {
          return INVALID;
        }
        if (key.status === "dirty" || value.status === "dirty") {
          status.dirty();
        }
        finalMap.set(key.value, value.value);
      }
      return { status: status.value, value: finalMap };
    }
  }
};
ZodMap.create = (keyType, valueType, params) => {
  return new ZodMap(__spreadValues({
    valueType,
    keyType,
    typeName: ZodFirstPartyTypeKind.ZodMap
  }, processCreateParams(params)));
};
var ZodSet = class _ZodSet extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.set) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const def = this._def;
    if (def.minSize !== null) {
      if (ctx.data.size < def.minSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.minSize.message
        });
        status.dirty();
      }
    }
    if (def.maxSize !== null) {
      if (ctx.data.size > def.maxSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.maxSize.message
        });
        status.dirty();
      }
    }
    const valueType = this._def.valueType;
    function finalizeSet(elements2) {
      const parsedSet = /* @__PURE__ */ new Set();
      for (const element of elements2) {
        if (element.status === "aborted")
          return INVALID;
        if (element.status === "dirty")
          status.dirty();
        parsedSet.add(element.value);
      }
      return { status: status.value, value: parsedSet };
    }
    const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
    if (ctx.common.async) {
      return Promise.all(elements).then((elements2) => finalizeSet(elements2));
    } else {
      return finalizeSet(elements);
    }
  }
  min(minSize, message) {
    return new _ZodSet(__spreadProps(__spreadValues({}, this._def), {
      minSize: { value: minSize, message: errorUtil.toString(message) }
    }));
  }
  max(maxSize, message) {
    return new _ZodSet(__spreadProps(__spreadValues({}, this._def), {
      maxSize: { value: maxSize, message: errorUtil.toString(message) }
    }));
  }
  size(size, message) {
    return this.min(size, message).max(size, message);
  }
  nonempty(message) {
    return this.min(1, message);
  }
};
ZodSet.create = (valueType, params) => {
  return new ZodSet(__spreadValues({
    valueType,
    minSize: null,
    maxSize: null,
    typeName: ZodFirstPartyTypeKind.ZodSet
  }, processCreateParams(params)));
};
var ZodFunction = class _ZodFunction extends ZodType {
  constructor() {
    super(...arguments);
    this.validate = this.implement;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.function) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: ctx.parsedType
      });
      return INVALID;
    }
    function makeArgsIssue(args, error) {
      return makeIssue({
        data: args,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: error
        }
      });
    }
    function makeReturnsIssue(returns, error) {
      return makeIssue({
        data: returns,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: error
        }
      });
    }
    const params = { errorMap: ctx.common.contextualErrorMap };
    const fn = ctx.data;
    if (this._def.returns instanceof ZodPromise) {
      const me = this;
      return OK(function(...args) {
        return __async(this, null, function* () {
          const error = new ZodError([]);
          const parsedArgs = yield me._def.args.parseAsync(args, params).catch((e) => {
            error.addIssue(makeArgsIssue(args, e));
            throw error;
          });
          const result = yield Reflect.apply(fn, this, parsedArgs);
          const parsedReturns = yield me._def.returns._def.type.parseAsync(result, params).catch((e) => {
            error.addIssue(makeReturnsIssue(result, e));
            throw error;
          });
          return parsedReturns;
        });
      });
    } else {
      const me = this;
      return OK(function(...args) {
        const parsedArgs = me._def.args.safeParse(args, params);
        if (!parsedArgs.success) {
          throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
        }
        const result = Reflect.apply(fn, this, parsedArgs.data);
        const parsedReturns = me._def.returns.safeParse(result, params);
        if (!parsedReturns.success) {
          throw new ZodError([makeReturnsIssue(result, parsedReturns.error)]);
        }
        return parsedReturns.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...items) {
    return new _ZodFunction(__spreadProps(__spreadValues({}, this._def), {
      args: ZodTuple.create(items).rest(ZodUnknown.create())
    }));
  }
  returns(returnType) {
    return new _ZodFunction(__spreadProps(__spreadValues({}, this._def), {
      returns: returnType
    }));
  }
  implement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  strictImplement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  static create(args, returns, params) {
    return new _ZodFunction(__spreadValues({
      args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: returns || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction
    }, processCreateParams(params)));
  }
};
var ZodLazy = class extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const lazySchema = this._def.getter();
    return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
  }
};
ZodLazy.create = (getter, params) => {
  return new ZodLazy(__spreadValues({
    getter,
    typeName: ZodFirstPartyTypeKind.ZodLazy
  }, processCreateParams(params)));
};
var ZodLiteral = class extends ZodType {
  _parse(input) {
    if (input.data !== this._def.value) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
  get value() {
    return this._def.value;
  }
};
ZodLiteral.create = (value, params) => {
  return new ZodLiteral(__spreadValues({
    value,
    typeName: ZodFirstPartyTypeKind.ZodLiteral
  }, processCreateParams(params)));
};
function createZodEnum(values, params) {
  return new ZodEnum(__spreadValues({
    values,
    typeName: ZodFirstPartyTypeKind.ZodEnum
  }, processCreateParams(params)));
}
var ZodEnum = class _ZodEnum extends ZodType {
  _parse(input) {
    if (typeof input.data !== "string") {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (this._def.values.indexOf(input.data) === -1) {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Values() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  extract(values) {
    return _ZodEnum.create(values);
  }
  exclude(values) {
    return _ZodEnum.create(this.options.filter((opt) => !values.includes(opt)));
  }
};
ZodEnum.create = createZodEnum;
var ZodNativeEnum = class extends ZodType {
  _parse(input) {
    const nativeEnumValues = util.getValidEnumValues(this._def.values);
    const ctx = this._getOrReturnCtx(input);
    if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (nativeEnumValues.indexOf(input.data) === -1) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get enum() {
    return this._def.values;
  }
};
ZodNativeEnum.create = (values, params) => {
  return new ZodNativeEnum(__spreadValues({
    values,
    typeName: ZodFirstPartyTypeKind.ZodNativeEnum
  }, processCreateParams(params)));
};
var ZodPromise = class extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
    return OK(promisified.then((data) => {
      return this._def.type.parseAsync(data, {
        path: ctx.path,
        errorMap: ctx.common.contextualErrorMap
      });
    }));
  }
};
ZodPromise.create = (schema, params) => {
  return new ZodPromise(__spreadValues({
    type: schema,
    typeName: ZodFirstPartyTypeKind.ZodPromise
  }, processCreateParams(params)));
};
var ZodEffects = class extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const effect = this._def.effect || null;
    const checkCtx = {
      addIssue: (arg) => {
        addIssueToContext(ctx, arg);
        if (arg.fatal) {
          status.abort();
        } else {
          status.dirty();
        }
      },
      get path() {
        return ctx.path;
      }
    };
    checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
    if (effect.type === "preprocess") {
      const processed = effect.transform(ctx.data, checkCtx);
      if (ctx.common.issues.length) {
        return {
          status: "dirty",
          value: ctx.data
        };
      }
      if (ctx.common.async) {
        return Promise.resolve(processed).then((processed2) => {
          return this._def.schema._parseAsync({
            data: processed2,
            path: ctx.path,
            parent: ctx
          });
        });
      } else {
        return this._def.schema._parseSync({
          data: processed,
          path: ctx.path,
          parent: ctx
        });
      }
    }
    if (effect.type === "refinement") {
      const executeRefinement = (acc) => {
        const result = effect.refinement(acc, checkCtx);
        if (ctx.common.async) {
          return Promise.resolve(result);
        }
        if (result instanceof Promise) {
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        }
        return acc;
      };
      if (ctx.common.async === false) {
        const inner = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inner.status === "aborted")
          return INVALID;
        if (inner.status === "dirty")
          status.dirty();
        executeRefinement(inner.value);
        return { status: status.value, value: inner.value };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((inner) => {
          if (inner.status === "aborted")
            return INVALID;
          if (inner.status === "dirty")
            status.dirty();
          return executeRefinement(inner.value).then(() => {
            return { status: status.value, value: inner.value };
          });
        });
      }
    }
    if (effect.type === "transform") {
      if (ctx.common.async === false) {
        const base = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (!isValid(base))
          return base;
        const result = effect.transform(base.value, checkCtx);
        if (result instanceof Promise) {
          throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
        }
        return { status: status.value, value: result };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((base) => {
          if (!isValid(base))
            return base;
          return Promise.resolve(effect.transform(base.value, checkCtx)).then((result) => ({ status: status.value, value: result }));
        });
      }
    }
    util.assertNever(effect);
  }
};
ZodEffects.create = (schema, effect, params) => {
  return new ZodEffects(__spreadValues({
    schema,
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    effect
  }, processCreateParams(params)));
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
  return new ZodEffects(__spreadValues({
    schema,
    effect: { type: "preprocess", transform: preprocess },
    typeName: ZodFirstPartyTypeKind.ZodEffects
  }, processCreateParams(params)));
};
var ZodOptional = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.undefined) {
      return OK(void 0);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodOptional.create = (type, params) => {
  return new ZodOptional(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional
  }, processCreateParams(params)));
};
var ZodNullable = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.null) {
      return OK(null);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodNullable.create = (type, params) => {
  return new ZodNullable(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodNullable
  }, processCreateParams(params)));
};
var ZodDefault = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    let data = ctx.data;
    if (ctx.parsedType === ZodParsedType.undefined) {
      data = this._def.defaultValue();
    }
    return this._def.innerType._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
ZodDefault.create = (type, params) => {
  return new ZodDefault(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodDefault,
    defaultValue: typeof params.default === "function" ? params.default : () => params.default
  }, processCreateParams(params)));
};
var ZodCatch = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const newCtx = __spreadProps(__spreadValues({}, ctx), {
      common: __spreadProps(__spreadValues({}, ctx.common), {
        issues: []
      })
    });
    const result = this._def.innerType._parse({
      data: newCtx.data,
      path: newCtx.path,
      parent: __spreadValues({}, newCtx)
    });
    if (isAsync(result)) {
      return result.then((result2) => {
        return {
          status: "valid",
          value: result2.status === "valid" ? result2.value : this._def.catchValue({
            get error() {
              return new ZodError(newCtx.common.issues);
            },
            input: newCtx.data
          })
        };
      });
    } else {
      return {
        status: "valid",
        value: result.status === "valid" ? result.value : this._def.catchValue({
          get error() {
            return new ZodError(newCtx.common.issues);
          },
          input: newCtx.data
        })
      };
    }
  }
  removeCatch() {
    return this._def.innerType;
  }
};
ZodCatch.create = (type, params) => {
  return new ZodCatch(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodCatch,
    catchValue: typeof params.catch === "function" ? params.catch : () => params.catch
  }, processCreateParams(params)));
};
var ZodNaN = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.nan) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
};
ZodNaN.create = (params) => {
  return new ZodNaN(__spreadValues({
    typeName: ZodFirstPartyTypeKind.ZodNaN
  }, processCreateParams(params)));
};
var BRAND = Symbol("zod_brand");
var ZodBranded = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const data = ctx.data;
    return this._def.type._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  unwrap() {
    return this._def.type;
  }
};
var ZodPipeline = class _ZodPipeline extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.common.async) {
      const handleAsync = () => __async(this, null, function* () {
        const inResult = yield this._def.in._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inResult.status === "aborted")
          return INVALID;
        if (inResult.status === "dirty") {
          status.dirty();
          return DIRTY(inResult.value);
        } else {
          return this._def.out._parseAsync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx
          });
        }
      });
      return handleAsync();
    } else {
      const inResult = this._def.in._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
      if (inResult.status === "aborted")
        return INVALID;
      if (inResult.status === "dirty") {
        status.dirty();
        return {
          status: "dirty",
          value: inResult.value
        };
      } else {
        return this._def.out._parseSync({
          data: inResult.value,
          path: ctx.path,
          parent: ctx
        });
      }
    }
  }
  static create(a, b) {
    return new _ZodPipeline({
      in: a,
      out: b,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
};
var ZodReadonly = class extends ZodType {
  _parse(input) {
    const result = this._def.innerType._parse(input);
    if (isValid(result)) {
      result.value = Object.freeze(result.value);
    }
    return result;
  }
};
ZodReadonly.create = (type, params) => {
  return new ZodReadonly(__spreadValues({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodReadonly
  }, processCreateParams(params)));
};
var custom = (check, params = {}, fatal) => {
  if (check)
    return ZodAny.create().superRefine((data, ctx) => {
      var _a, _b;
      if (!check(data)) {
        const p = typeof params === "function" ? params(data) : typeof params === "string" ? { message: params } : params;
        const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
        const p2 = typeof p === "string" ? { message: p } : p;
        ctx.addIssue(__spreadProps(__spreadValues({ code: "custom" }, p2), { fatal: _fatal }));
      }
    });
  return ZodAny.create();
};
var late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind2) {
  ZodFirstPartyTypeKind2["ZodString"] = "ZodString";
  ZodFirstPartyTypeKind2["ZodNumber"] = "ZodNumber";
  ZodFirstPartyTypeKind2["ZodNaN"] = "ZodNaN";
  ZodFirstPartyTypeKind2["ZodBigInt"] = "ZodBigInt";
  ZodFirstPartyTypeKind2["ZodBoolean"] = "ZodBoolean";
  ZodFirstPartyTypeKind2["ZodDate"] = "ZodDate";
  ZodFirstPartyTypeKind2["ZodSymbol"] = "ZodSymbol";
  ZodFirstPartyTypeKind2["ZodUndefined"] = "ZodUndefined";
  ZodFirstPartyTypeKind2["ZodNull"] = "ZodNull";
  ZodFirstPartyTypeKind2["ZodAny"] = "ZodAny";
  ZodFirstPartyTypeKind2["ZodUnknown"] = "ZodUnknown";
  ZodFirstPartyTypeKind2["ZodNever"] = "ZodNever";
  ZodFirstPartyTypeKind2["ZodVoid"] = "ZodVoid";
  ZodFirstPartyTypeKind2["ZodArray"] = "ZodArray";
  ZodFirstPartyTypeKind2["ZodObject"] = "ZodObject";
  ZodFirstPartyTypeKind2["ZodUnion"] = "ZodUnion";
  ZodFirstPartyTypeKind2["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
  ZodFirstPartyTypeKind2["ZodIntersection"] = "ZodIntersection";
  ZodFirstPartyTypeKind2["ZodTuple"] = "ZodTuple";
  ZodFirstPartyTypeKind2["ZodRecord"] = "ZodRecord";
  ZodFirstPartyTypeKind2["ZodMap"] = "ZodMap";
  ZodFirstPartyTypeKind2["ZodSet"] = "ZodSet";
  ZodFirstPartyTypeKind2["ZodFunction"] = "ZodFunction";
  ZodFirstPartyTypeKind2["ZodLazy"] = "ZodLazy";
  ZodFirstPartyTypeKind2["ZodLiteral"] = "ZodLiteral";
  ZodFirstPartyTypeKind2["ZodEnum"] = "ZodEnum";
  ZodFirstPartyTypeKind2["ZodEffects"] = "ZodEffects";
  ZodFirstPartyTypeKind2["ZodNativeEnum"] = "ZodNativeEnum";
  ZodFirstPartyTypeKind2["ZodOptional"] = "ZodOptional";
  ZodFirstPartyTypeKind2["ZodNullable"] = "ZodNullable";
  ZodFirstPartyTypeKind2["ZodDefault"] = "ZodDefault";
  ZodFirstPartyTypeKind2["ZodCatch"] = "ZodCatch";
  ZodFirstPartyTypeKind2["ZodPromise"] = "ZodPromise";
  ZodFirstPartyTypeKind2["ZodBranded"] = "ZodBranded";
  ZodFirstPartyTypeKind2["ZodPipeline"] = "ZodPipeline";
  ZodFirstPartyTypeKind2["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
var instanceOfType = (cls, params = {
  message: `Input not instance of ${cls.name}`
}) => custom((data) => data instanceof cls, params);
var stringType = ZodString.create;
var numberType = ZodNumber.create;
var nanType = ZodNaN.create;
var bigIntType = ZodBigInt.create;
var booleanType = ZodBoolean.create;
var dateType = ZodDate.create;
var symbolType = ZodSymbol.create;
var undefinedType = ZodUndefined.create;
var nullType = ZodNull.create;
var anyType = ZodAny.create;
var unknownType = ZodUnknown.create;
var neverType = ZodNever.create;
var voidType = ZodVoid.create;
var arrayType = ZodArray.create;
var objectType = ZodObject.create;
var strictObjectType = ZodObject.strictCreate;
var unionType = ZodUnion.create;
var discriminatedUnionType = ZodDiscriminatedUnion.create;
var intersectionType = ZodIntersection.create;
var tupleType = ZodTuple.create;
var recordType = ZodRecord.create;
var mapType = ZodMap.create;
var setType = ZodSet.create;
var functionType = ZodFunction.create;
var lazyType = ZodLazy.create;
var literalType = ZodLiteral.create;
var enumType = ZodEnum.create;
var nativeEnumType = ZodNativeEnum.create;
var promiseType = ZodPromise.create;
var effectsType = ZodEffects.create;
var optionalType = ZodOptional.create;
var nullableType = ZodNullable.create;
var preprocessType = ZodEffects.createWithPreprocess;
var pipelineType = ZodPipeline.create;
var ostring = () => stringType().optional();
var onumber = () => numberType().optional();
var oboolean = () => booleanType().optional();
var coerce = {
  string: (arg) => ZodString.create(__spreadProps(__spreadValues({}, arg), { coerce: true })),
  number: (arg) => ZodNumber.create(__spreadProps(__spreadValues({}, arg), { coerce: true })),
  boolean: (arg) => ZodBoolean.create(__spreadProps(__spreadValues({}, arg), {
    coerce: true
  })),
  bigint: (arg) => ZodBigInt.create(__spreadProps(__spreadValues({}, arg), { coerce: true })),
  date: (arg) => ZodDate.create(__spreadProps(__spreadValues({}, arg), { coerce: true }))
};
var NEVER = INVALID;
var z = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: errorMap,
  setErrorMap,
  getErrorMap,
  makeIssue,
  EMPTY_PATH,
  addIssueToContext,
  ParseStatus,
  INVALID,
  DIRTY,
  OK,
  isAborted,
  isDirty,
  isValid,
  isAsync,
  get util() {
    return util;
  },
  get objectUtil() {
    return objectUtil;
  },
  ZodParsedType,
  getParsedType,
  ZodType,
  ZodString,
  ZodNumber,
  ZodBigInt,
  ZodBoolean,
  ZodDate,
  ZodSymbol,
  ZodUndefined,
  ZodNull,
  ZodAny,
  ZodUnknown,
  ZodNever,
  ZodVoid,
  ZodArray,
  ZodObject,
  ZodUnion,
  ZodDiscriminatedUnion,
  ZodIntersection,
  ZodTuple,
  ZodRecord,
  ZodMap,
  ZodSet,
  ZodFunction,
  ZodLazy,
  ZodLiteral,
  ZodEnum,
  ZodNativeEnum,
  ZodPromise,
  ZodEffects,
  ZodTransformer: ZodEffects,
  ZodOptional,
  ZodNullable,
  ZodDefault,
  ZodCatch,
  ZodNaN,
  BRAND,
  ZodBranded,
  ZodPipeline,
  ZodReadonly,
  custom,
  Schema: ZodType,
  ZodSchema: ZodType,
  late,
  get ZodFirstPartyTypeKind() {
    return ZodFirstPartyTypeKind;
  },
  coerce,
  any: anyType,
  array: arrayType,
  bigint: bigIntType,
  boolean: booleanType,
  date: dateType,
  discriminatedUnion: discriminatedUnionType,
  effect: effectsType,
  "enum": enumType,
  "function": functionType,
  "instanceof": instanceOfType,
  intersection: intersectionType,
  lazy: lazyType,
  literal: literalType,
  map: mapType,
  nan: nanType,
  nativeEnum: nativeEnumType,
  never: neverType,
  "null": nullType,
  nullable: nullableType,
  number: numberType,
  object: objectType,
  oboolean,
  onumber,
  optional: optionalType,
  ostring,
  pipeline: pipelineType,
  preprocess: preprocessType,
  promise: promiseType,
  record: recordType,
  set: setType,
  strictObject: strictObjectType,
  string: stringType,
  symbol: symbolType,
  transformer: effectsType,
  tuple: tupleType,
  "undefined": undefinedType,
  union: unionType,
  unknown: unknownType,
  "void": voidType,
  NEVER,
  ZodIssueCode,
  quotelessJson,
  ZodError
});

// src/v4/api/locations.models.ts
var deliveryCoverageResponse = z.object({
  /** Can the location deliver to this address? */
  can_deliver: z.boolean(),
  /** Error message to show if delivery is unavailable. */
  message: z.nullable(z.string())
});
var locationOperatingHours = z.object({
  /** ISO8601 datestamp when the hours were created. */
  created_at: z.string(),
  /** Day that these hours apply to. */
  day_of_week: z.string(),
  /** ISO8601 datestamp when the location closes. */
  end: z.string(),
  /** ID for this set of operating hours. */
  id: z.string(),
  /** ISO8601 datestamp when the location opens. */
  start: z.string(),
  /** ID of the location these hours apply to. */
  store_location_id: z.number(),
  /**
   * The type of operating hours, such as delivery, pickup, or curbside.
   * @see https://github.com/koala-labs/koala-ordering-api/blob/production/core/Ordering/Models/LocationHour.php#L25-L30
   * @TODO make this an enum?
   */
  type: z.string(),
  /** ISO8601 datestamp when the hours were last updated. */
  updated_at: z.string()
});
var locationCachedData = z.object({
  /** The ordering provider's ID for this location. Maps to `location_id`. */
  id: z.string(),
  /** Location zip code. */
  zip: z.string(),
  /** Location city. */
  city: z.string(),
  /** @TODO improve this type. */
  meta: z.unknown(),
  /** @TODO what is this value? */
  tags: z.string().array(),
  /** Location name. */
  label: z.string(),
  /** Location state or province. */
  state: z.string(),
  /** Country code that the location is in. Eg: `USA`. */
  country: z.string(),
  /** Location latitude. */
  latitude: z.number(),
  /** Location longitude. */
  longitude: z.number(),
  /** Can this location be ordered from? */
  is_available: z.boolean(),
  /** Location phone number. */
  phone_number: z.string().nullable(),
  /** Street address of the location. */
  street_address: z.string(),
  /** UTC offset representing the location's time zone. */
  utc_offset: z.number(),
  /** Accepted credit card types. @TODO expand this type. */
  card_types: z.object({ label: z.string() }).passthrough().array()
});
var locationPositionAttribute = z.object({
  id: z.number(),
  label: z.string(),
  description: z.string(),
  type: z.string(),
  accessor: z.string(),
  required: z.boolean()
});
var v4_location = z.object({
  /** Misc. custom location info. Eg: a Grubhub link. */
  attributes: z.optional(
    z.object({
      id: z.optional(z.number()),
      label: z.unknown(),
      value: z.unknown(),
      position: z.optional(locationPositionAttribute)
    }).passthrough().array()
  ),
  /** Max length of special instructions added during checkout? (if supported) */
  basket_instructions_max_length: z.nullable(z.number()),
  /** Brands can set this ID in the ordering provider to match PoS ID, etc. */
  brand_id: z.optional(z.nullable(z.string())),
  /** Accepted credit card types. @TODO expand this type. */
  card_types: z.object({ label: z.string() }).array(),
  /** ISO8601 datestamp when this location was created. */
  created_at: z.string().optional(),
  /** @TODO reduce our reliance on this property. */
  cached_data: z.optional(locationCachedData.passthrough()),
  /** Location city. */
  city: z.string(),
  /** Country code that the location is in. Eg: `USA`. */
  country: z.string(),
  /** The cross street value added to addresses */
  cross_street: z.nullable(z.string()),
  /** ISO8601 datestamp when this location was deleted. */
  deleted_at: z.optional(z.nullable(z.string())),
  /** Hours that this location will deliver. */
  delivery_hours: z.optional(locationOperatingHours.passthrough().array()),
  /** Minimum order amount that is eligible for delivery. */
  delivery_minimum: z.nullable(z.number()),
  /** @TODO improve this type. */
  disclaimers: z.object({ name: z.string(), description: z.string() }).passthrough().array(),
  /** The location's distance in miles from the user's selected address. */
  distance_miles: z.optional(z.number()),
  /** Koala Location ID. */
  id: z.number(),
  /** @TODO where do these images display? */
  image_url_1_by_1: z.optional(z.nullable(z.string())),
  /** Does this location only support delivery conveyance? */
  is_delivery_only: z.optional(z.boolean()),
  /** Label to use when adding a recipient. Eg: "Name" or "Customer". */
  item_recipient_label: z.nullable(z.string()),
  /** Location name. */
  label: z.string(),
  /** Location latitude. */
  latitude: z.number(),
  /** The ordering provider's ID for this location. */
  location_id: z.optional(z.string()),
  /** Location longitude. */
  longitude: z.number(),
  /**
   * Hours that Online ordering available.
   * (for now `business_hours` will be the same as the `operating_hours` for Olo and Square locations.)
   */
  operating_hours: z.optional(locationOperatingHours.passthrough().array()),
  /** Hours that this location is open. (Chowly locations will have only `business_hours`)*/
  business_hours: z.optional(locationOperatingHours.passthrough().array()),
  /** Does this location support ordering ahead? */
  order_ahead: z.boolean(),
  /** If ordering ahead is supported, how many days can you order ahead? */
  order_ahead_days: z.number(),
  /** Does this location support ordering ASAP? */
  order_asap: z.boolean(),
  /** ID of the organization that this location belongs to. */
  organization_id: z.number(),
  /** Location phone number. */
  phone_number: z.string().nullable(),
  /** Is the location enabled in the ordering provider? */
  provider_enabled: z.optional(z.boolean()),
  /** Location URL slug. */
  slug: z.string().nullable(),
  /** Maximum number of characters for special order instructions. */
  special_instructions_max_length: z.number(),
  /** The state's foreign key to the US States database table. */
  state_id: z.optional(z.number()),
  /**
   * Current location status.
   * @see https://github.com/koala-labs/koala-ordering-api/blob/production/app/Status.php#L44-L53
   * @TODO make this into an enum?
   */
  status_id: z.optional(z.number()),
  /** Street address of the location. */
  street_address: z.string(),
  /** Can special instructions be added to an order during checkout? */
  supports_basket_instructions: z.boolean(),
  /** Does this location support curbside pickup? */
  supports_curbside: z.boolean(),
  /** Does this location support delivery conveyance? */
  supports_delivery: z.boolean(),
  /** Does this location support dine-in conveyance? */
  supports_dine_in: z.boolean(),
  /** Does this location support drive-in conveyance? */
  supports_drive_in: z.boolean(),
  /** Does this location support table numbers? */
  supports_dine_in_table_number: z.boolean(),
  /** Does this location support drive-thru conveyance? */
  supports_drive_thru: z.boolean(),
  /** Can individual items be marked for people in the customer's party? */
  supports_item_recipients: z.boolean(),
  /** Does this location only support delivery conveyance? */
  supports_pick_up: z.boolean(),
  /** Can payment be split between multiple methods? */
  supports_split_payment: z.boolean(),
  /** Does this location support tipping during checkout? */
  supports_tip: z.boolean(),
  /** Does this location support dine-in for an online order? */
  supports_to_stay: z.boolean(),
  /** Can you request utensils from this location during checkout? */
  supports_utensils: z.boolean(),
  /** Flag indicates if promo code form should be supported during checkout */
  supports_promo_code: z.boolean(),
  /**
   * ISO8601 datestamp when this location's menu was last synced.
   * @TODO should we be using `synced_at` or `last_synced_at`?
   */
  synced_at: z.optional(z.string()),
  /** ISO8601 datestamp when this location was last updated. */
  updated_at: z.optional(z.string()),
  /** Location zip code. */
  zip_code: z.optional(z.string())
});

// src/v4/api/menu.models.ts
var CALS_IDENTIFIER = "Cals";
var menuProductOption = z.lazy(
  () => z.object({
    /** Allergens associated with this option. */
    allergens: z.optional(allergenItem.passthrough().array()),
    /** Visual separator for the calorie range. Eg: `-`.  */
    calories_separator: z.string().nullable(),
    /** The number of calories for this option. */
    calories: z.number().nullable(),
    /** Option cost. */
    cost: z.number(),
    /** Option description. */
    description: z.optional(z.nullable(z.string())),
    /** Can this option be selected? */
    enabled: z.optional(z.boolean()),
    /** The Option's ID across all locations. */
    global_option_id: z.string(),
    /** Option ID unique to a single location. */
    id: z.string(),
    /** Display images for this option. */
    images: z.nullable(menuProductImages.passthrough()),
    /** Is the option currently available for purchase? */
    is_available: z.boolean(),
    /** Is this the default option for its group? */
    is_default: z.boolean(),
    /**
     * If a product is inverted, then options are pre-selected and the
     * product is customized by removing options.
     */
    is_inverted: z.optional(z.boolean()),
    /** Warning labels for this option. */
    labels: menuProductLabel.passthrough().array(),
    /** Max calories for this option. */
    max_calories: z.nullable(z.number()),
    /** Alternative name for inverted products. Eg: `Remove {x}` */
    name_inverted: z.optional(z.nullable(z.string())),
    /** Option name. */
    name: z.string(),
    /** Any sub-groups that this option contains. */
    option_groups: menuProductOptionGroup.passthrough().array(),
    /** How many of this option has the user selected? */
    quantity: z.optional(z.number()),
    /** Is this option selected? */
    selected: z.optional(z.boolean()),
    is_max_selections_reached: z.optional(z.boolean()),
    contains_adv_nested_modifiers: z.optional(z.boolean())
  })
);
var allergenItem = z.object({
  /** Allergen ID. */
  id: z.number(),
  /** Name. Eg: "Tree Nut Allergy" */
  label: z.string(),
  /** @TODO what does this property mean? */
  is_removal: z.boolean()
}).passthrough();
var existingOption = z.object({
  /** Option ID. */
  id: z.string(),
  /** Option quantity. */
  quantity: z.number(),
  cost: z.optional(z.number()),
  /** The Option's ID across all locations. */
  global_option_id: z.optional(z.string()),
  /** Option name. */
  name: z.optional(z.string())
});
var tagItem = z.object({
  /** @TODO what is this value? */
  background_color: z.optional(z.string()),
  /** @TODO what is this value? */
  icon_image_url: z.optional(z.nullable(z.string())),
  /** Category ID. */
  id: z.number(),
  /** Category name. */
  label: z.string(),
  /** ID of the organization this belongs to. */
  organization_id: z.optional(z.number()),
  /** @TODO what is this value? */
  text_color: z.optional(z.string()),
  /** Marketing tags are visual additions, but filter tags change how the menu is displayed. */
  type: z.union([z.literal("marketing"), z.literal("filter")]),
  /** This property is responsible for suppressing the label value
   * from the marketing tag rendered on the menu and leads to surfacing only the image.
   */
  hide_label: z.boolean()
}).passthrough();
var menuProductImages = z.object({
  image_url_1_by_1: z.nullable(z.string())
});
var menuProductLabel = z.object({
  /** Full legal warning text. */
  description: z.string(),
  /** Alt text for the label image. */
  image_description: z.string(),
  /** Warning label image URL. */
  image_url: z.string(),
  /** Name of the warning. Eg: `Sodium - NY`. */
  name: z.string()
});
var menuProductOptionGroup = z.object({
  /** If quantity selection is enabled, how much should it increment? */
  choice_quantity_increment: z.number(),
  /* Text description. */
  description: z.string(),
  /** @TODO how does this differ from `description`? */
  explanation_text: z.nullable(z.string()),
  /** The Group's ID across all locations. */
  global_id: z.string(),
  /** Group ID unique to a single location. */
  id: z.string(),
  /** Is this group hidden? */
  is_hidden: z.boolean(),
  /**
   * Total combined quantity of options that can be selected in this group.
   * Eg: Dipping sauces. Make 30 selections from up to 2 options.
   */
  max_aggregate_quantity: z.nullable(z.number()),
  /** The maximum selectable quantity for any one option. */
  max_choice_quantity: z.nullable(z.number()),
  /** The maximum number of selections that can be made from this group. */
  max_selections: z.nullable(z.number()),
  /** Minimum combined quantity of options that can be selected in this group.  */
  min_aggregate_quantity: z.nullable(z.number()),
  /** Minimum valid option quantity. */
  min_choice_quantity: z.nullable(z.number()),
  /** The minimum required selections from this group. */
  min_selections: z.nullable(z.number()),
  /** The customization options in this group. */
  options: menuProductOption.array(),
  /** Global ID of the parent product or option. */
  parent_global_id: z.optional(z.nullable(z.string())),
  /** Is an option from this group required for the product to be valid? */
  requires_user_selection: z.boolean(),
  /** Can multiples of an option be selected? */
  supports_quantity_selection: z.boolean(),
  /** Is the current selection state valid? */
  valid: z.optional(z.boolean()),
  /** When sum of all option quantities are equal to greater than max_aggregate_quantity this property is set to true and the opposite */
  is_max_aggregate_quantity_reached: z.optional(z.boolean()),
  /** Contains current sum of all option quantities of the current option group*/
  total_aggregate_quantity: z.optional(z.number()),
  /** If the group is options of advanced nested modifiers */
  is_adv_nested_modifier: z.optional(z.boolean())
});
var menuProductResponse = z.object({
  /** Allergens associated with this product. */
  allergens: allergenItem.passthrough().array(),
  /** Visual separator for the calorie range. Eg: `-`.  */
  calories_separator: z.string().nullable(),
  /** Calories for the base product. */
  calories: z.nullable(z.number()),
  /** Cost for the base product. */
  cost: z.number(),
  /** Text description. */
  description: z.string(),
  /** The master category that this product belongs to. */
  filter_tags: z.nullable(tagItem.passthrough().array()),
  /** Total calories for the product plus all customizations. */
  final_calories: z.optional(z.number()),
  /** Total cost for the product plus all customizations. */
  final_cost: z.optional(z.number()),
  /** The Product's ID across all locations. */
  global_id: z.string(),
  /** Product ID unique to a single location. */
  id: z.string(),
  /** Main product image. */
  image: z.nullable(z.string()),
  /** Full set of product images in multiple aspect ratios. */
  images: menuProductImages.passthrough(),
  /** Warning labels for this product. */
  labels: menuProductLabel.passthrough().array(),
  /** A list of tags associated with this product. */
  marketing_tags: z.nullable(tagItem.passthrough().array()),
  /** Max calories for customizable options. */
  max_calories: z.nullable(z.number()),
  /** Maximum quantity that can be ordered. */
  max_quantity: z.nullable(z.number()),
  /** Minimum quantity that can be ordered. */
  min_quantity: z.nullable(z.number()),
  /** How much to increment the quantity by when using quantity controls. */
  quantity_increment: z.nullable(z.number()),
  /** @TODO what is this value? */
  meta_data: z.nullable(z.record(z.unknown())),
  /** Product name. */
  name: z.string(),
  /** @TODO what is this value? */
  options: z.optional(existingOption.passthrough().array()),
  /** Customizable product options. */
  option_groups: menuProductOptionGroup.passthrough().array(),
  /** Visible option groups added by the Customizer. @TODO remove from this model. */
  surfaceable_option_groups: z.optional(
    menuProductOptionGroup.passthrough().array()
  ),
  /** Are all selected customizations valid? */
  valid_customization: z.optional(z.boolean())
});
var categoryResponse = z.object({
  /** Text description of the category's products. */
  description: z.string(),
  /** The Product's ID across all locations. */
  global_id: z.nullable(z.string()),
  /** @TODO what is this value? */
  icon: z.null(),
  /**
   * Category ID.
   * @TODO determine why this could be either a string or a number.
   */
  id: z.union([z.string(), z.number()]),
  /** Should this category be hidden from users? */
  is_hidden: z.boolean(),
  /** Category name. Eg: `Sandwiches`. */
  name: z.string(),
  /** Products in this category. */
  products: menuProductResponse.passthrough().array(),
  /** Category name. Eg: `Sandwiches`. @TODO duplicate of `name`? */
  type: z.string().nullable()
});
var menuResponse = z.object({
  categories: categoryResponse.passthrough().array()
});
var menuProduct = menuProductResponse.extend({
  /** Min and max calories for customizable products. Eg: `300-700 cals`. */
  calorie_range: z.string(),
  /** Calorie units label. Eg: `Cals`. */
  calsIdentifier: z.string(),
  /** Can this product be customized? */
  customizable: z.boolean(),
  /** Options supported by this product. */
  options: existingOption.passthrough().array(),
  /** Formatted number of calories. Eg: `700 cals`. */
  pretty_calories: z.string(),
  /** Formatted price. Eg: `$12.99`. */
  pretty_price: z.nullable(z.string()),
  /** Warning labels for this product. */
  warningLabels: z.optional(menuProductLabel.passthrough().array())
});
var category = categoryResponse.extend({
  products: menuProduct.passthrough().array()
});
var menu = menuResponse.extend({
  categories: category.passthrough().array()
});
var menuProductWithCategory = menuProduct.extend({
  category
});

// src/v4/api/payment.models.ts
var PAYMENT_TYPES = /* @__PURE__ */ ((PAYMENT_TYPES2) => {
  PAYMENT_TYPES2["CREDIT_CARD"] = "credit_card";
  PAYMENT_TYPES2["CREDIT_CARD_TOKEN"] = "credit_card_token";
  PAYMENT_TYPES2["CASH"] = "cash";
  PAYMENT_TYPES2["STORED_VALUE"] = "stored_value";
  PAYMENT_TYPES2["BILLING_ACCOUNT"] = "billing_account";
  PAYMENT_TYPES2["DIGITAL_WALLET"] = "digital_wallet";
  return PAYMENT_TYPES2;
})(PAYMENT_TYPES || {});
var PAYMENT_METHODS = z.enum([
  "cash",
  "prepaid",
  "billing_account",
  "digital_wallet",
  "credit_card",
  "credit_card_token",
  "stored_value"
]);
var payment = z.object({
  customer: z.object({
    first_name: z.string(),
    last_name: z.string(),
    email: z.string(),
    // Matches a 10-digit string.
    contact_number: z.string().regex(/^\d{10}$/)
  }),
  amount: z.number(),
  tip: z.optional(z.number())
});
var billingAccount = payment.extend({
  type: z.literal(PAYMENT_METHODS.enum.billing_account),
  saved_account_id: z.string()
});
var cash = payment.extend({
  type: z.literal(PAYMENT_METHODS.enum.cash)
});
var creditCard = payment.extend({
  type: z.literal(PAYMENT_METHODS.enum.credit_card),
  id: z.string(),
  alias_cc: z.string(),
  alias_cvv: z.string(),
  card_brand: z.string(),
  last_four: z.string(),
  expiry_month: z.number(),
  expiry_year: z.number(),
  zip_code: z.string(),
  country: z.string(),
  save: z.boolean()
});
var creditCardToken = payment.extend({
  type: z.literal(PAYMENT_METHODS.enum.credit_card_token),
  card_token: z.string(),
  card_brand: z.string(),
  last_four: z.string(),
  expiry_month: z.number(),
  expiry_year: z.number(),
  zip_code: z.string(),
  country: z.string(),
  save: z.boolean()
});
var digitalWallet = payment.extend({
  type: z.literal(PAYMENT_METHODS.enum.digital_wallet),
  digital_wallet_id: z.number(),
  card_token: z.string(),
  card_brand: z.string(),
  // Matches a 4-digit string.
  last_four: z.string().regex(/^\d{4}$/),
  expiry_month: z.number(),
  expiry_year: z.number(),
  zip_code: z.string(),
  country: z.string(),
  save: z.boolean()
});
var giftCard = payment.extend({
  type: z.literal(PAYMENT_METHODS.enum.stored_value),
  stored_value_requirements: z.object({
    /** Could be something like "pin" or "card_number". */
    name: z.nullable(z.string()),
    /** Value for corresponding name */
    value: z.nullable(z.string())
  }).array()
});
var supportedPaymentMethods = z.discriminatedUnion("type", [
  billingAccount,
  cash,
  creditCard,
  creditCardToken,
  digitalWallet,
  giftCard
]);
var customerDetails = z.object({
  first_name: z.string(),
  last_name: z.string(),
  email: z.string(),
  contact_number: z.string(),
  /** Should the receipt be emailed to the user? */
  email_receipt: z.boolean().optional(),
  opt_in: z.boolean().optional()
});
var creditCardBase = z.object({
  /** Tokenized card number that the API can use to submit a charge. */
  alias_cc: z.nullable(z.string()).optional(),
  /** Tokenized card CVV. (the 3/4 digit number) */
  alias_cvv: z.nullable(z.string()).optional(),
  /** Credit card type. Eg: "VIS" */
  payment_method: z.nullable(z.string()).optional(),
  /** Year that the card expires. */
  expiry_year: z.nullable(z.number()).optional(),
  /** Month that the card expires. */
  expiry_month: z.nullable(z.number()).optional(),
  /** Payment country code. Eg: "US" */
  country: z.nullable(z.string()).optional(),
  /** Last 4 digits of the credit card. Eg: "x-4242" */
  last_four: z.nullable(z.string()).optional()
});
var tokenizedCreditCard = creditCardBase.extend({
  /** Masked card number. Eg: "411111xxxxxx1111". */
  masked_card: z.string().optional()
});
var storedValueRequirement = z.object({
  /** Could be something like "pin" or "card_number". */
  name: z.nullable(z.string()),
  /** Value for corresponding name */
  value: z.nullable(z.string())
});
var paymentDetails = tokenizedCreditCard.extend({
  id: z.nullable(z.string()).optional(),
  /** Id that should be set from paymentTypesResponse.supported_digital_wallets,
   * depending on what digital wallet type is available,
   * used for authorizing payment.
   */
  digital_wallet_id: z.number().optional(),
  /** Token that is getting exchanged for card data, used for authorizing payment. */
  card_token: z.nullable(z.string()).optional(),
  /** Total payment, excluding tip. */
  amount: z.number().optional(),
  /** Credit Card brand. */
  card_brand: z.string().optional(),
  /** Details about the customer who submitted the order. */
  customer: customerDetails.passthrough().optional(),
  /** @TODO what is this value? */
  payment_location_id: z.string().optional(),
  /** Is this payment method saved? */
  save: z.boolean().optional(),
  /** @TODO what is this value? */
  /** @TODO is it really number? */
  saved_account_id: z.nullable(z.string()).optional(),
  /** @TODO what is this value? */
  stored_value_number: z.nullable(z.number()).optional(),
  /** @TODO what is this value? */
  stored_value_pin: z.nullable(z.number()).optional(),
  /**
   * Collection of StoredValueRequirement
   * Required if type === PAYMENT_TYPE.billing_account
   */
  stored_value_requirements: storedValueRequirement.passthrough().array().optional(),
  /** Tip amount. */
  tip: z.number().optional(),
  /** Payment type, such as cash, or card. */
  type: z.nativeEnum(PAYMENT_TYPES),
  /** Billing zip code. */
  zip_code: z.string().optional()
});

// src/v4/api/basket.models.ts
var storedAddress = z.object({
  /** Desired delivery day. @TODO how is this formatted? */
  day_wanted: z.optional(z.string()),
  /** Desired delivery time. @TODO how is this formatted? */
  time_wanted: z.nullable(z.string()),
  street_address: z.string(),
  street_address_2: z.string(),
  city: z.string(),
  state: z.optional(z.nullable(z.string())),
  zip_code: z.string(),
  /** Special delivery instructions for this address, such as a door code. */
  special_instructions: z.string(),
  /** Address ID. */
  id: z.number(),
  /** Is this the user's default address? */
  default: z.boolean()
});
var deliveryAddress = z.object({
  /** Desired delivery time. @TODO how is this formatted? */
  time_wanted: z.nullable(z.string()),
  time_wanted_mode: z.enum(["asap", "advance"]),
  street_address: z.string(),
  city: z.string(),
  zip_code: z.string(),
  /** Desired delivery day. @TODO how is this formatted? */
  day_wanted: z.optional(z.string()),
  street_address_2: z.optional(z.string()),
  state: z.optional(z.nullable(z.string())),
  /**
   * @TODO remove alongside standardizeAddressZipCode after we figure out
   * which parts of the ordering app send `zip` instead of `zip_code`.
   */
  zip: z.optional(z.string()),
  /** Special delivery instructions for this address, such as a door code. */
  special_instructions: z.optional(z.string()),
  /** Address ID. */
  id: z.optional(z.nullable(z.number())),
  /** @TODO what is this value? */
  stale_id: z.optional(z.number()),
  /** Is this the user's default address? */
  default: z.optional(z.boolean())
});
var basketConveyanceDetails = z.object({
  /** Car color. */
  color: z.nullable(z.string()),
  /** Street address for delivery orders. */
  delivery_address: z.nullable(deliveryAddress.passthrough()),
  /** Car manufacturer. */
  make: z.nullable(z.string()),
  /** Car model. */
  model: z.nullable(z.string()),
  /** Parking spot where the customer is parked. */
  parking_spot_number: z.nullable(z.string()),
  /** For in-store orders, the customer's table number. */
  table_tent_number: z.nullable(z.string()),
  /** @TODO what is this value? */
  type: z.string()
});
var basketFee = z.object({
  amount: z.number(),
  description: z.nullable(z.string()),
  note: z.nullable(z.string())
});
var basketItemOption = z.object({
  /** Option ID. */
  id: z.string(),
  /** Option ID as present in Remote Basket. */
  option_id: z.optional(z.string()),
  /** Quantity added to the item. */
  quantity: z.number(),
  /** Cost associated with this option. */
  cost: z.optional(z.number()),
  /** Option name. */
  name: z.optional(z.string()),
  /** Allergens associated with this option. */
  allergens: z.optional(allergenItem.passthrough().array()),
  /** The Option's ID across all locations. */
  global_option_id: z.optional(z.string())
});
var basketItem = z.object({
  product: z.object({
    /** Product ID unique to a single location. */
    id: z.string(),
    /** The Product's ID across all locations. */
    global_id: z.string(),
    /** Product name. */
    name: z.string(),
    /** Unformatted item cost. */
    cost: z.number(),
    /** Local to the application value. ID of the cross-sell, if this item was added as a cross-sell. */
    cross_sell_id: z.string().nullable().optional(),
    /** Local to the application value. ID of the category this product is in. */
    category_id: z.string().nullable().optional(),
    /** Local to the application value. Label of the category this product is in. */
    category_label: z.string().nullable().optional(),
    /** Product's filter tag */
    filter_tags: z.optional(z.nullable(tagItem.passthrough().array()))
  }),
  /** Customized options for this item. */
  options: basketItemOption.passthrough().array(),
  /** Item quantity that was ordered. */
  quantity: z.number(),
  /** Any special ordering instructions. */
  special_instructions: z.string(),
  /** The person that this item is for. */
  recipient: z.string(),
  /** Basket Item ID. */
  id: z.optional(z.string())
});
var curbsideDetails = z.object({
  /** Car color. */
  color: z.string(),
  /** Car manufacturer. */
  make: z.string(),
  /** Car model. */
  model: z.string()
});
var dineInDetails = z.object({
  /** For in-store orders, the customer's table number. */
  table_tent_number: z.string()
});
var driveInDetails = z.object({
  parking_spot_number: z.string()
});
var basket = z.object({
  /** Basket ID. */
  id: z.string(),
  /** How the basket will be given to the customer. */
  conveyance_type: basketConveyanceDetails.passthrough(),
  /** @TODO how does this differ from `special_instructions`? */
  basket_instructions: z.nullable(z.string()),
  /** Any special ordering instructions. */
  special_instructions: z.nullable(z.string()),
  /** Tip amount. */
  tip: z.number(),
  /** Unformatted subtotal amount, excluding tax & tip. */
  subtotal: z.number(),
  /** Unformatted tax amount. */
  sales_tax: z.number(),
  fees: basketFee.passthrough().array(),
  /** Unformatted order total cost, including tax & tip. */
  total: z.number(),
  /** Esimated fulfillment time for the order, in minutes. */
  time_estimate_minutes: z.number(),
  /** Does this location support ordering ASAP? */
  order_asap: z.boolean(),
  /** Price discount from promotions. */
  promo_discount: z.number(),
  /** Does the location support tipping? */
  supports_tip: z.boolean(),
  /** Should utensils be included in this order? */
  utensils: z.boolean(),
  /** The order's delivery fee, if applicable. */
  delivery_fee: z.number(),
  /** Location that the basket is ordered from */
  location: v4_location.passthrough(),
  /** Items in the user's basket. */
  basket_items: basketItem.passthrough().array(),
  /** ISO8601 datestamp when the customer would like the order. */
  wanted_at: z.nullable(z.string())
}).passthrough();
var digitalWallet2 = z.object({
  id: z.number(),
  name: z.union([z.literal("google_pay"), z.literal("apple_pay")])
});
var paymentTypesResponse = z.object({
  /** @TODO improve this type. */
  stored_value_requirements: z.unknown().array(),
  supports_billing_account: z.boolean(),
  supports_cash: z.boolean(),
  supports_credit_card: z.boolean(),
  supports_prepaid: z.boolean(),
  supports_split_payment: z.boolean(),
  supports_stored_value: z.boolean(),
  supports_credit_card_token: z.nullable(z.boolean()).optional(),
  supported_digital_wallets: z.array(digitalWallet2).default([])
}).passthrough();
var paymentProviders = z.union([
  z.literal("stripe"),
  z.literal("olo_pay"),
  z.literal("square")
]);
var paymentEnvironments = z.union([
  z.literal("sandbox"),
  z.literal("production")
]);
var creditCardTokenSupport = z.discriminatedUnion("supported", [
  z.object({
    supported: z.literal(true),
    provider: paymentProviders,
    environment: paymentEnvironments,
    key: z.string()
  }),
  z.object({
    supported: z.literal(false),
    provider: z.null(),
    environment: z.null(),
    key: z.null()
  })
]);
var creditCardSupport = z.discriminatedUnion("supported", [
  z.object({
    supported: z.literal(true),
    proxy: z.literal("pci_proxy"),
    environment: paymentEnvironments,
    key: z.string()
  }),
  z.object({
    supported: z.literal(false),
    proxy: z.null(),
    environment: z.null(),
    key: z.null()
  })
]);
var digitalWalletSupport = z.discriminatedUnion("supported", [
  z.object({
    provider: paymentProviders,
    supported: z.literal(true),
    environment: paymentEnvironments,
    /** in case of OloPay implementation we don't use key as it is built into OloPay library */
    key: z.string().nullable(),
    supported_digital_wallets: z.array(digitalWallet2)
  }),
  z.object({
    provider: z.null(),
    supported: z.literal(false),
    environment: z.null(),
    key: z.null(),
    supported_digital_wallets: z.array(digitalWallet2).default([])
  })
]);
var giftCardRequirement = z.object({
  /** Formatted label label. Eg: "Gift Card PIN" */
  label: z.string(),
  /** Field input type. Eg: "password" */
  type: z.string(),
  /** Field name. Eg: "pin" */
  name: z.string(),
  value: z.nullable(z.string())
});
var giftCardSupport = z.object({
  supported: z.boolean(),
  requirements: giftCardRequirement.array()
});
var supportedPaymentTypes = z.object({
  billing_account: z.object({ supported: z.boolean() }),
  cash: z.object({ supported: z.boolean() }),
  credit_card_token: creditCardTokenSupport,
  credit_card: creditCardSupport,
  digital_wallet: digitalWalletSupport,
  prepaid: z.object({ supported: z.boolean() }),
  stored_value: giftCardSupport
}).passthrough();
var storedValueBalanceResponse = z.object({
  /** Remaining balance. */
  balance: z.number(),
  /** Gift card number. */
  card_number: z.string()
}).passthrough();
var submitBasketData = z.object({
  /** Payment details for the basket. */
  payment: z.lazy(() => paymentDetails.passthrough().array()),
  /** Customer details submitted alongside the basket. */
  customer: z.lazy(() => customerDetails.passthrough()),
  allergies: z.string().array()
});
var basketOrder = z.object({
  /** Menu items to order. */
  basket_items: basketItem.passthrough().array(),
  /**
   * ID of the location to order from.
   * @TODO should this be `location_id` or a full `location record`?
   */
  location: z.object({ id: z.number() }),
  /** Any special ordering instructions. */
  special_instructions: z.string(),
  referral_tracking_code: z.optional(z.string())
});
var checkoutBasketDeliveryAddress = deliveryAddress.extend({
  time_wanted_mode: z.union([
    z.literal("advance"),
    z.literal("asap"),
    z.null()
  ])
});
var checkoutBasketConveyanceDetails = z.object({
  /** Car color. */
  color: z.nullable(z.string()),
  /** Street address for delivery orders. */
  delivery_address: checkoutBasketDeliveryAddress.passthrough(),
  /** Car manufacturer. */
  make: z.nullable(z.string()),
  /** Car model. */
  model: z.nullable(z.string()),
  /** Parking spot where the customer is parked. */
  parking_spot_number: z.nullable(z.string()),
  /** For in-store orders, the customer's table number. */
  table_tent_number: z.nullable(z.string()),
  /** @TODO what is this value? */
  type: z.string()
});
var checkoutBasket = z.object({
  /** Basket ID. */
  id: z.string(),
  /** @TODO how does this differ from `special_instructions`? */
  basket_instructions: z.string(),
  /** Any special ordering instructions. */
  special_instructions: z.string(),
  /** Fees associated with this order. */
  fees: basketFee.passthrough().array(),
  /** Tip amount. */
  tip: z.number(),
  /** Does the location support tipping? */
  supports_tip: z.boolean(),
  /** The order's delivery fee, if applicable. */
  delivery_fee: z.number(),
  /** Unformatted subtotal amount, excluding tax & tip. */
  subtotal: z.number(),
  /** Unformatted tax amount. */
  sales_tax: z.number(),
  /** Unformatted order total cost, including tax & tip. */
  total: z.number(),
  /** Esimated fulfillment time for the order, in minutes. */
  time_estimate_minutes: z.number(),
  /** Price discount from promotions. */
  promo_discount: z.number(),
  /** ISO8601 datestamp when the customer would like the order.
   * Can be null if the order is ASAP.
   */
  wanted_at: z.string().nullable(),
  /** @TODO what is this value? */
  version: z.unknown(),
  /** Does this location support ordering ASAP? */
  order_asap: z.boolean(),
  /** Should utensils be included in this order? */
  utensils: z.boolean(),
  /** ISO8601 datestamp when the food will be ready. */
  earliest_ready_time_at_location: z.string(),
  /** Location that the basket is ordered from */
  location: v4_location.passthrough(),
  /** Purchased items. */
  basket_items: basketItem.passthrough().array(),
  /**
   * As of 4/27/22, this appears unused though null is returned from the API.
   * @TODO remove?
   */
  promo_codes: z.unknown(),
  /** How the basket will be given to the customer. */
  conveyance_type: checkoutBasketConveyanceDetails.passthrough()
});
var availableWantedAtTimes = z.string().array();
var customerDetailsV2 = z.object({
  first_name: z.string(),
  last_name: z.string(),
  email: z.string(),
  contact_number: z.string(),
  email_receipt: z.boolean(),
  opt_in: z.boolean()
});
var submissionDetails = z.object({
  payment: supportedPaymentMethods.array(),
  customer: customerDetailsV2.passthrough(),
  allergies: z.string().array()
}).passthrough();

// src/v4/api/basket.service.ts


// src/v4/core/utils.ts

var token = z.object({
  token_type: z.literal("Bearer"),
  expires_in: z.number(),
  access_token: z.string(),
  scopes: z.string().array(),
  refresh_token: z.string().optional(),
  refresh_token_expires_in: z.number().optional()
});
function tokenLockName(origin) {
  return encodeURIComponent(`koala-lock-${origin}`);
}
function buildOrderingApiUrl(env) {
  return isProd(env) ? "https://api.koala.io" : `https://${env}.api.koala.io`;
}
function safeParse({
  data,
  schema,
  uri
}) {
  const parsedResponse = schema.safeParse(data);
  if (parsedResponse.success) {
    return parsedResponse.data;
  }
  if (false) {}
  if (false) {}
  return data;
}
function isProd(env) {
  return env === "production";
}
function listSchema(schema) {
  return z.object({
    data: schema.array(),
    meta: z.object({
      pagination: z.object({
        count: z.number(),
        current_page: z.number(),
        per_page: z.number(),
        total: z.number(),
        total_pages: z.number()
      })
    })
  });
}
function v4_stringify(...args) {
  return (0,lib.stringify)(args[0], __spreadProps(__spreadValues({}, args[1]), { encodeValuesOnly: true }));
}
function getLock(origin) {
  return window.localStorage.getItem(tokenLockName(origin));
}
function setLock(origin) {
  const lockTime = String((/* @__PURE__ */ new Date()).getTime());
  window.localStorage.setItem(tokenLockName(origin), lockTime);
}
function removeLock(origin) {
  window.localStorage.removeItem(tokenLockName(origin));
}
function lockIsStale(origin) {
  const lock = window.localStorage.getItem(tokenLockName(origin));
  if (!lock) {
    return false;
  }
  return parseInt(lock) <= (/* @__PURE__ */ new Date()).getTime() - 1e4;
}
function replayRequest(req, token2) {
  var _a, _b, _c, _d, _e, _f;
  const originalRequest = req.auth(`Bearer ${token2.access_token}`).fetch().unauthorized((err) => {
    throw err;
  });
  if (((_b = (_a = req == null ? void 0 : req._options) == null ? void 0 : _a.headers) == null ? void 0 : _b.Accept) === "application/zlib") {
    return originalRequest.arrayBuffer();
  }
  if (((_d = (_c = req == null ? void 0 : req._options) == null ? void 0 : _c.headers) == null ? void 0 : _d.status) === 204 || ((_f = (_e = req == null ? void 0 : req._options) == null ? void 0 : _e.headers) == null ? void 0 : _f.status) === 202) {
    return originalRequest.res();
  }
  return originalRequest.json();
}

// src/v4/api/loyalty.models.ts
var loyaltyState = z.object({
  /** The user's available reward points balance. */
  points: z.number(),
  /** @TODO what is this value? */
  net_points: z.number(),
  /** Id of the user's membership level. */
  membership_level_id: z.nullable(z.number()),
  /** Formatted name of the user's membership level. */
  membership_level_name: z.nullable(z.string()),
  /** @TODO what is this value? */
  banked_currency: z.number(),
  /** @TODO what is this value? */
  banked_currency_expiring: z.number(),
  /** @TODO what is this value? */
  banked_currency_expiration_date: z.nullable(z.string()),
  /** @TODO what is this value? */
  points_threshold: z.number(),
  /** @TODO what is this value? */
  conversion_rate: z.number(),
  /** @TODO improve typing. */
  rewards: z.undefined()
});
var loyaltyUser = z.object({
  /** The user's birthday. date_format:Y-m-d */
  birthday: z.nullable(z.string()),
  /** ISO8601 datestamp when the user was created. */
  created_at: z.string(),
  /** ISO8601 datestamp when the user was deleted. */
  deleted_at: z.nullable(z.string()),
  /** User's email address. */
  email: z.string(),
  /** ID of the loyalty provider the user is registered with. */
  external_provider_id: z.number(),
  /** User ID with the loyalty provider. */
  external_user_id: z.string(),
  /** User's first name. */
  first_name: z.string(),
  /** Koala User ID. */
  id: z.number(),
  /** User's unique identifier. Likely their email address. */
  identifier: z.optional(z.string()),
  /** User's last name. */
  last_name: z.string(),
  /** User's full name. */
  name: z.string(),
  /** ID of the organization this user belongs to. */
  organization_id: z.number(),
  /** User's phone number. */
  phone: z.string(),
  /** User's QR code for earning points in-store. */
  qrcode: z.nullable(z.string()),
  /** Has the user opted-in to recieving marketing emails? */
  opt_in: z.optional(z.boolean()),
  /** Signup referral code that the user can distribute. */
  referral_code: z.nullable(z.string()),
  /** ISO8601 datestamp when the user was last updated. */
  updated_at: z.string(),
  /** The user's username, if it differs from email. */
  username: z.nullable(z.string()),
  /** User's zip code */
  zip_code: z.optional(z.nullable(z.string())),
  /** ID for in-store earning and redemption */
  external_user_fk: z.nullable(z.string())
});
var messageCTA = z.object({
  type: z.string(),
  /** CTA link URL. */
  url: z.string(),
  /** CTA label text. */
  label: z.string(),
  /** Higher priority CTAs will appear first. */
  priority: z.string()
});
var messageHeroContent = z.object({
  /** Alt text for the content. */
  alt_text: z.string(),
  /** If the content is a video, this image shows behind the play button. */
  initial_frame: z.string(),
  /** The hero content can be either an image or a video. */
  type: z.string(),
  /** Content URL. */
  url: z.string()
});
var messageBackgroundContent = z.object({
  /** Alt text for the content. */
  alt_text: z.string(),
  /** If the content is a video, this image shows behind the play button. */
  initial_frame: z.string(),
  /** The background content can be either an image or a video. */
  type: z.string(),
  /** Content URL. */
  url: z.string()
});
var messageItem = z.object({
  /** Message ID. */
  id: z.string(),
  /** Message title. */
  title: z.string(),
  /** Message subtitle. */
  subtitle: z.string(),
  /** Message body text. */
  body: z.string(),
  /** Message type. Eg: `user_specific`. */
  type: z.string(),
  /** Importance level of the message. */
  rank: z.number(),
  /** ISO8601 datestamp when the message was marked as read. */
  read_at: z.nullable(z.string()),
  /**
   * ISO8601 datestamp when the message was should be shown on the client.
   * This allows brands to write messages and schedule their delivery for later.
   */
  launch_time: z.string(),
  /** Calls to Action to display at the bottom of the message. */
  message_ctas: messageCTA.passthrough().array(),
  /** Image or video shown above the message. */
  hero_content: messageHeroContent.passthrough(),
  /** Image or video shown behind the message. */
  background_content: messageBackgroundContent.passthrough()
});
var redeemableItem = z.object({
  /** Item ID. */
  id: z.number(),
  /** Item title. */
  label: z.string(),
  /** Text description of the item. */
  description: z.string(),
  /** The number of points required to redeem. */
  points_required: z.number(),
  /** @TODO what is this value? */
  meta_data: z.string(),
  /** The item's display image. */
  image: z.object({ name: z.string(), url: z.string() }).passthrough(),
  /** Flag that indicates that item can be donated or not */
  supports_donation: z.boolean()
});
var redemptionItem = z.object({
  /** Text description of the item. */
  description: z.string(),
  /** ISO8601 datestamp when the tracking_code would expire. */
  expiring_at: z.string(),
  /** Item ID. @TODO how does this differ from the `redeemable_id`?  */
  id: z.number(),
  /** The item's display image. */
  image: z.object({ name: z.string(), url: z.string() }).passthrough(),
  /** Item title. */
  label: z.string(),
  /** ID of the item being redeemed. */
  redeemable_id: z.number(),
  /** @TODO what is this value? */
  starting_at: z.string(),
  /** @TODO what is this value? */
  status: z.string(),
  /** Code entered by the end-user at checkout if they redeem in-store. */
  tracking_code: z.string()
});
var rewardHistoryItem = z.object({
  /** ISO8601 datestamp when the event took place. */
  date: z.string(),
  /** Description of the event. */
  description: z.string(),
  /** Point value, positive or negative. */
  value: z.string()
});
var rewardItem = z.object({
  /** Whether the item can be claimed in-store. */
  available_offline: z.boolean(),
  /** Whether the item can be claimed on an online order. */
  available_online: z.boolean(),
  /** Text description of the item. */
  copy: z.string(),
  /** Text description of the item. @TODO duplicate of `copy`? */
  description: z.string(),
  /** ISO8601 datestamp when the reward expires. */
  expires_at: z.string(),
  /** Item ID. */
  id: z.string(),
  /** The item's display image. */
  image: z.object({ name: z.string(), url: z.string() }).passthrough(),
  /** Item title. */
  label: z.string(),
  /** @TODO what is this value? */
  locations: z.unknown(),
  /** @TODO what is this value? */
  quantity_applied: z.number(),
  /** @TODO what is this value? */
  quantity_available: z.number(),
  /** ISO8601 datestamp when the reward becomes available. */
  starts_at: z.nullable(z.string()),
  /** Item type. Eg: `gift`. */
  type: z.string(),
  /** @TODO what is this value? */
  value: z.number(),
  /** @TODO what is this value? */
  reference: z.string(),
  /** if reward has redemption item created based on its id then there will be redemption attached to it */
  redemption: redemptionItem.passthrough().optional(),
  /** Flag that indicates that item can be donated or not */
  supports_donation: z.boolean()
}).passthrough();
var socialCause = z.object({
  /** The ID of the social cause associated with the campaign */
  id: z.number(),
  /** The name of the campaign */
  name: z.string().nullable(),
  /** A brief description of the campaign */
  description: z.string().nullable(),
  /** The URL of the campaign's image */
  image_url: z.string().nullable(),
  /** Miscellaneous information about the campaign */
  miscellaneous: z.string().nullable(),
  /** The city where the campaign is located */
  city: z.string().nullable(),
  /** The state where the campaign is located */
  state: z.string().nullable(),
  /** The street address where the campaign is located */
  street_address: z.string().nullable(),
  /** The ZIP code of the campaign's location */
  zip_code: z.string().nullable(),
  /** The phone number associated with the campaign */
  phone: z.string().nullable(),
  /** The email address associated with the campaign */
  email: z.string().nullable(),
  /** The full address of the campaign */
  address: z.string().nullable()
});
var donationTypes = z.union([
  z.literal("currency"),
  z.literal("reward"),
  z.literal("redeemable")
]);
var donation = z.object({
  /** The type of donation */
  type: donationTypes,
  /** The item being donated
   * if currency - $ amount that needs to be donated
   * if reward - reward_id of the reward that needs to be donated.
   * if redeemable - redeemable_id of the redeemable that needs to be donated.
   */
  item: z.string(),
  /** The number of occurrences of the donation */
  occurrences: z.number().nullable().optional()
});

// src/api/basket.models.v2.ts
var dateTime = z.string().datetime({ offset: true });
var basketLocation = v4_location.omit({ cached_data: true, zip_code: true }).passthrough();
var basketProduct = menuProduct.omit({
  images: true,
  calorie_range: true,
  calsIdentifier: true,
  pretty_price: true,
  pretty_calories: true,
  customizable: true,
  filter_tags: true
}).partial({ options: true }).passthrough();
var CONVEYANCE_MODES = z.enum([
  "curbside",
  "delivery",
  "dine_in",
  "drive_in",
  "drive_thru",
  "pick_up"
]);
var deliveryAddress2 = z.object({
  street_address: z.string(),
  street_address_2: z.optional(z.nullable(z.string())),
  city: z.string(),
  state: z.nullable(z.string()),
  zip_code: z.string(),
  phone_number: z.string(),
  special_instructions: z.string()
});
var storedAddress2 = deliveryAddress2.extend({
  id: z.number(),
  default: z.boolean()
});
var address = z.union([deliveryAddress2, storedAddress2]);
var curbside = z.object({
  type: z.literal(CONVEYANCE_MODES.enum.curbside),
  make: z.string(),
  model: z.string(),
  color: z.string()
});
var delivery = z.object({
  type: z.literal(CONVEYANCE_MODES.enum.delivery),
  delivery_address: deliveryAddress2
});
var dineIn = z.object({
  type: z.literal(CONVEYANCE_MODES.enum.dine_in),
  table_tent_number: z.nullable(z.string())
});
var driveIn = z.object({
  type: z.literal(CONVEYANCE_MODES.enum.drive_in),
  parking_spot_number: z.string()
});
var driveThru = z.object({
  type: z.literal(CONVEYANCE_MODES.enum.drive_thru)
});
var pickup = z.object({
  type: z.literal(CONVEYANCE_MODES.enum.pick_up)
});
var conveyanceType = z.discriminatedUnion("type", [
  curbside,
  delivery,
  dineIn,
  driveIn,
  driveThru,
  pickup
]);
var fee = z.object({
  amount: z.number(),
  description: z.nullable(z.string()),
  note: z.nullable(z.string())
});
var optionChoice = z.object({
  id: z.string(),
  cost: z.number(),
  name: z.string(),
  option_id: z.string(),
  quantity: z.number(),
  allergens: z.nullable(allergenItem.array())
});
var basketItem2 = z.object({
  id: z.string(),
  quantity: z.number(),
  base_cost: z.number(),
  total_cost: z.number(),
  special_instructions: z.string(),
  recipient: z.string(),
  category_id: z.string().nullable(),
  options: optionChoice.array(),
  product: basketProduct
});
var basketV2 = z.object({
  id: z.string(),
  basket_instructions: z.nullable(z.string()),
  basket_items: basketItem2.array(),
  conveyance_type: conveyanceType,
  delivery_fee: z.number(),
  earliest_ready_time_at_location: z.nullable(dateTime),
  fees: fee.array(),
  location: basketLocation,
  order_asap: z.boolean(),
  promo_discount: z.number(),
  sales_tax: z.number(),
  special_instructions: z.nullable(z.string()),
  subtotal: z.number(),
  supports_tip: z.boolean(),
  time_estimate_minutes: z.number(),
  tip: z.number(),
  total: z.number(),
  utensils: z.boolean(),
  wanted_at: z.nullable(dateTime)
});
var handoffTimes = dateTime.array();
var customerDetailsV22 = z.object({
  first_name: z.string(),
  last_name: z.string(),
  email: z.string(),
  contact_number: z.string(),
  email_receipt: z.boolean(),
  opt_in: z.boolean()
});
var paymentEnvironments2 = z.union([
  z.literal("sandbox"),
  z.literal("production")
]);
var paymentProviders2 = z.union([
  z.literal("stripe"),
  z.literal("olo_pay"),
  z.literal("square")
]);
var creditCardTokenSupport2 = z.discriminatedUnion("supported", [
  z.object({
    supported: z.literal(true),
    provider: paymentProviders2,
    environment: paymentEnvironments2,
    key: z.string()
  }),
  z.object({
    supported: z.literal(false),
    provider: z.null(),
    environment: z.null(),
    key: z.null()
  })
]);
var creditCardSupport2 = z.discriminatedUnion("supported", [
  z.object({
    supported: z.literal(true),
    proxy: z.literal("pci_proxy"),
    environment: paymentEnvironments2,
    key: z.string()
  }),
  z.object({
    supported: z.literal(false),
    proxy: z.null(),
    environment: z.null(),
    key: z.null()
  })
]);
var digitalWallet3 = z.object({
  id: z.number(),
  name: z.union([z.literal("google_pay"), z.literal("apple_pay")])
});
var digitalWalletSupport2 = z.discriminatedUnion("supported", [
  z.object({
    provider: paymentProviders2,
    supported: z.literal(true),
    environment: paymentEnvironments2,
    /** in case of OloPay implementation we don't use key as it is built into OloPay library */
    key: z.string().nullable(),
    supported_digital_wallets: z.array(digitalWallet3)
  }),
  z.object({
    provider: z.null(),
    supported: z.literal(false),
    environment: z.null(),
    key: z.null(),
    supported_digital_wallets: z.array(digitalWallet3).default([])
  })
]);
var giftCardRequirement2 = z.object({
  /** Formatted label label. Eg: "Gift Card PIN" */
  label: z.string(),
  /** Field input type. Eg: "password" */
  type: z.string(),
  /** Field name. Eg: "pin" */
  name: z.string(),
  value: z.nullable(z.string())
});
var giftCardSupport2 = z.object({
  supported: z.boolean(),
  requirements: giftCardRequirement2.array()
});
var supportedPaymentTypes2 = z.object({
  billing_account: z.object({ supported: z.boolean() }),
  cash: z.object({ supported: z.boolean() }),
  credit_card_token: creditCardTokenSupport2,
  credit_card: creditCardSupport2,
  digital_wallet: digitalWalletSupport2,
  prepaid: z.object({ supported: z.boolean() }),
  stored_value: giftCardSupport2
});
var submissionDetails2 = z.object({
  payment: supportedPaymentMethods.array(),
  customer: customerDetailsV22.passthrough(),
  allergies: z.string().array()
});

// src/v4/api/ordering.models.ts
var ARRIVAL_STATUS = /* @__PURE__ */ ((ARRIVAL_STATUS2) => {
  ARRIVAL_STATUS2["NOT_SUPPORTED"] = "not_supported";
  ARRIVAL_STATUS2["ORDER_PLACED"] = "order_placed";
  ARRIVAL_STATUS2["ARRIVED"] = "arrived";
  ARRIVAL_STATUS2["PICKED_UP"] = "picked_up";
  return ARRIVAL_STATUS2;
})(ARRIVAL_STATUS || {});
var CONVEYANCE_TYPES = /* @__PURE__ */ ((CONVEYANCE_TYPES2) => {
  CONVEYANCE_TYPES2["PICKUP"] = "Pickup";
  CONVEYANCE_TYPES2["DELIVERY"] = "Delivery";
  CONVEYANCE_TYPES2["CURBSIDE"] = "Curbside";
  CONVEYANCE_TYPES2["DINEIN"] = "Dine-In";
  CONVEYANCE_TYPES2["DRIVETHRU"] = "Drive-Thru";
  CONVEYANCE_TYPES2["DRIVEIN"] = "Drive-In";
  return CONVEYANCE_TYPES2;
})(CONVEYANCE_TYPES || {});
var CONVEYANCE_TYPE_KEYS = /* @__PURE__ */ ((CONVEYANCE_TYPE_KEYS2) => {
  CONVEYANCE_TYPE_KEYS2[CONVEYANCE_TYPE_KEYS2["PICKUP"] = 0] = "PICKUP";
  CONVEYANCE_TYPE_KEYS2[CONVEYANCE_TYPE_KEYS2["DELIVERY"] = 1] = "DELIVERY";
  CONVEYANCE_TYPE_KEYS2[CONVEYANCE_TYPE_KEYS2["CURBSIDE"] = 2] = "CURBSIDE";
  CONVEYANCE_TYPE_KEYS2[CONVEYANCE_TYPE_KEYS2["DINEIN"] = 3] = "DINEIN";
  CONVEYANCE_TYPE_KEYS2[CONVEYANCE_TYPE_KEYS2["DRIVETHRU"] = 4] = "DRIVETHRU";
  CONVEYANCE_TYPE_KEYS2[CONVEYANCE_TYPE_KEYS2["DRIVEIN"] = 5] = "DRIVEIN";
  return CONVEYANCE_TYPE_KEYS2;
})(CONVEYANCE_TYPE_KEYS || {});
var DELIVERY_PROVIDER_STATUS = /* @__PURE__ */ ((DELIVERY_PROVIDER_STATUS2) => {
  DELIVERY_PROVIDER_STATUS2["PENDING"] = "Pending";
  DELIVERY_PROVIDER_STATUS2["PICKUP_IN_PROGRESS"] = "PickupInProgress";
  DELIVERY_PROVIDER_STATUS2["DELIVERY_IN_PROGRESS"] = "DeliveryInProgress";
  DELIVERY_PROVIDER_STATUS2["DELIVERED"] = "Delivered";
  DELIVERY_PROVIDER_STATUS2["CANCELLED"] = "Canceled";
  DELIVERY_PROVIDER_STATUS2["RETURNED"] = "Returned";
  return DELIVERY_PROVIDER_STATUS2;
})(DELIVERY_PROVIDER_STATUS || {});
var DELIVER_PROVIDER_TERMINATING_STATUS = (/* unused pure expression or super */ null && ([
  "Delivered" /* DELIVERED */,
  "Canceled" /* CANCELLED */,
  "Returned" /* RETURNED */
]));
var customerDetails2 = z.object({
  first_name: z.string(),
  last_name: z.string(),
  email: z.string(),
  contact_number: z.string(),
  /** Should the receipt be emailed to the user? */
  email_receipt: z.boolean().optional(),
  opt_in: z.boolean().optional()
});
var creditCardBase2 = z.object({
  /** Tokenized card number that the API can use to submit a charge. */
  alias_cc: z.nullable(z.string()).optional(),
  /** Tokenized card CVV. (the 3/4 digit number) */
  alias_cvv: z.nullable(z.string()).optional(),
  /** Credit card type. Eg: "VIS" */
  payment_method: z.nullable(z.string()).optional(),
  /** Year that the card expires. */
  expiry_year: z.nullable(z.number()).optional(),
  /** Month that the card expires. */
  expiry_month: z.nullable(z.number()).optional(),
  /** Payment country code. Eg: "US" */
  country: z.nullable(z.string()).optional(),
  /** Last 4 digits of the credit card. Eg: "x-4242" */
  last_four: z.nullable(z.string()).optional()
});
var tokenizedCreditCard2 = creditCardBase2.extend({
  /** Masked card number. Eg: "411111xxxxxx1111". */
  masked_card: z.string().optional()
});
var storedValueRequirement2 = z.object({
  /** Could be something like "pin" or "card_number". */
  name: z.nullable(z.string()),
  /** Value for corresponding name */
  value: z.nullable(z.string())
});
var paymentDetails2 = tokenizedCreditCard2.extend({
  id: z.nullable(z.string()).optional(),
  /** Id that should be set from paymentTypesResponse.supported_digital_wallets,
   * depending on what digital wallet type is available,
   * used for authorizing payment.
   */
  digital_wallet_id: z.number().optional(),
  /** Token that is getting exchanged for card data, used for authorizing payment. */
  card_token: z.nullable(z.string()).optional(),
  /** Total payment, excluding tip. */
  amount: z.number().optional(),
  /** Credit Card brand. */
  card_brand: z.string().optional(),
  /** Details about the customer who submitted the order. */
  customer: customerDetails2.passthrough().optional(),
  /** @TODO what is this value? */
  payment_location_id: z.string().optional(),
  /** Is this payment method saved? */
  save: z.boolean().optional(),
  /** @TODO what is this value? */
  /** @TODO is it really number? */
  saved_account_id: z.nullable(z.string()).optional(),
  /** @TODO what is this value? */
  stored_value_number: z.nullable(z.number()).optional(),
  /** @TODO what is this value? */
  stored_value_pin: z.nullable(z.number()).optional(),
  /**
   * Collection of StoredValueRequirement
   * Required if type === PAYMENT_TYPE.billing_account
   */
  stored_value_requirements: storedValueRequirement2.passthrough().array().optional(),
  /** Tip amount. */
  tip: z.number().optional(),
  /** Payment type, such as cash, or card. */
  type: z.nativeEnum(PAYMENT_TYPES),
  /** Billing zip code. */
  zip_code: z.string().optional()
});
var order = z.object({
  /** Order ID. */
  id: z.string(),
  /** Unformatted subtotal amount, excluding tax & tip. */
  subtotal: z.optional(z.number()),
  /** Unformatted tax amount. */
  sales_tax: z.optional(z.number()),
  /** Unformatted order total cost, including tax & tip. */
  total: z.number(),
  /** ISO8601 datestamp when the order will be ready. */
  ready_at: z.string(),
  /** ISO8601 datestamp when the order was submitted. */
  ordered_at: z.optional(z.string()),
  /** @TODO how does this differ from `id`? */
  order_number: z.string(),
  /** Unformatted discount amount. */
  promo_discount: z.optional(z.number())
});
var orderDetails = z.object({
  /** Current arrival status of a delivery order. */
  arrival_status: z.nullable(z.nativeEnum(ARRIVAL_STATUS)),
  /** @TODO what is this value? */
  balance: z.number(),
  /** ID of the basket submitted by this order. */
  basket_id: z.string(),
  /** Items in the order. */
  basket_items: z.lazy(() => basketItem.passthrough().array()),
  /** @TODO what is this value? */
  client_id: z.nullable(z.string()),
  /** ISO8601 datestamp when the order was submitted. */
  created_at: z.string(),
  /** ISO8601 datestamp when the delivery status was updated by the ordering provider. */
  delivery_status_updated_at: z.nullable(z.string()),
  /** Current status of a delivery order. */
  delivery_status: z.nullable(z.nativeEnum(DELIVERY_PROVIDER_STATUS)),
  /** Order ID. */
  id: z.string(),
  /** IP address that submitted the order. */
  ip: z.nullable(z.string()),
  /** Has the order been fulfilled. */
  is_complete: z.boolean(),
  /** Was this basket saved in a user's list of favorite order? */
  is_favorite: z.nullable(z.boolean()),
  /** Does this order include loyalty rewards? */
  is_loyalty_claimed: z.nullable(z.number()),
  /** The store location that the order was made at. */
  location: v4_location.passthrough(),
  /** @TODO how does this differ from `id`? */
  order_id: z.string(),
  /** @TODO how does this differ from `id`? */
  order_number: z.nullable(z.string()),
  /** ID of the organization this order was made to. */
  organization_id: z.number(),
  /** The brand's payment driver. */
  payment_driver_id: z.nullable(z.number()),
  /** ISO8601 datestamp when the order will be ready. */
  ready_at: z.string(),
  /** @TODO how does this differ from `id`? */
  request_id: z.nullable(z.string()),
  /** @TODO what is this value? */
  status_id: z.number(),
  /** ID of the location that this order was made to. */
  store_location_id: z.number(),
  /** The location that this order was made to. */
  store_location: z.nullable(v4_location.passthrough()),
  /** Unformatted order total cost, including tax & tip. */
  total: z.number(),
  /** ISO8601 datestamp when the order was last modified. */
  updated_at: z.string(),
  /** The customer's loyalty user ID, if applicable. */
  user_id: z.nullable(z.string()),
  order_data: z.object({
    /** Details about the customer who submitted the order. */
    customer: customerDetails2.passthrough(),
    order: z.object({
      /** Current arrival status of a delivery order. */
      arrival_status: z.nullable(z.nativeEnum(ARRIVAL_STATUS)),
      /** Order ID. */
      id: z.string(),
      /** @TODO improve this type. */
      order_items: z.unknown().array(),
      /** Order Number. @TODO how does this differ from `id`? */
      order_number: z.string(),
      /** ISO8601 datestamp when the order was submitted. */
      ordered_at: z.string(),
      /** @TODO is this the credit card brand? Or Credit Card vs. Gift Card? */
      payment_card_type: z.optional(z.string()),
      /** @TODO what is this value? */
      payment_card: z.optional(z.string()),
      /** Unformatted discount amount. */
      promo_discount: z.optional(z.number()),
      /** ISO8601 datestamp when the order will be ready. */
      ready_at: z.optional(z.string()),
      /** Unformatted tax amount. */
      sales_tax: z.number(),
      /** Unformatted subtotal amount, excluding tax & tip. */
      subtotal: z.number(),
      /** Unformatted order total, including tax & tip.  */
      total: z.number()
    }).passthrough(),
    /**
     * The user's ordered basket of items.
     */
    basket: basketV2.passthrough(),
    /** How the order was paid for. */
    payment: paymentDetails2.passthrough().array()
  }).passthrough()
});
var savedCard = z.object({
  /** ID of the saved card. */
  id: z.string(),
  /** @TODO is this credit/debit? How does it differ from `card_type`? */
  type: z.string(),
  /** Card type. @TODO is this amex/mastercard/visa? */
  card_type: z.nullable(z.string()),
  /** Last 4 digits. @TODO rename this for consistency. */
  suffix: z.nullable(z.string()),
  /** User-provided description. */
  description: z.string(),
  /** @TODO what is this value? */
  is_removable: z.boolean(),
  /** Card expiry. @TODO how is this formatted? */
  expires: z.nullable(z.string())
}).passthrough();
var deliveryStatus = z.object({
  /** @TODO how does `order_id` differ from `order_number`? */
  order_id: z.string(),
  order_number: z.string(),
  /** Dispatch service that will deliver the order. */
  delivery_service: z.string(),
  /** Driver information. */
  driver_name: z.optional(z.string()),
  driver_number: z.optional(z.string()),
  /** Current status of the delivery order. */
  status: z.nativeEnum(DELIVERY_PROVIDER_STATUS),
  /** Estimated pickup time. */
  estimated_pick_up_time: z.optional(z.string()),
  /** Estimated delivery time. */
  estimated_drop_off_time: z.optional(z.string()),
  /** Time that the order was picked up by the driver. */
  pick_up_time: z.optional(z.string()),
  /** Time that the order was delivered by the driver. */
  drop_off_time: z.optional(z.string()),
  /** ISO8601 timestamp when the order was cancelled. */
  cancelled_at_time: z.optional(z.string()),
  /** Reason why the order was cancelled. */
  cancelled_reason: z.optional(z.string()),
  /** Current latitude of the delivery driver. */
  lat: z.number(),
  /** Current longitude of the delivery driver. */
  long: z.number()
}).passthrough();
var arrivalResponse = z.object({
  /** Order ID. */
  id: z.optional(z.string()),
  /** Order total. */
  total: z.optional(z.number()),
  /** @TODO what is this value? */
  arrival_status: z.nullable(z.string())
});

// src/v4/api/basket.service.ts
var basketResponse = z.object({ data: basket });
function createBasket(_0, _1, _2) {
  return __async(this, arguments, function* (order2, locationId, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets`;
    const data = yield client.post(order2, uri).json();
    const newBasket = safeParse({ data, schema: basketResponse, uri });
    return newBasket.data;
  });
}
function addBasketItem(_0, _1) {
  return __async(this, arguments, function* ({ locationId, basketId, item }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}`;
    const data = yield client.put(item, uri).json();
    const newBasket = safeParse({ data, schema: basketResponse, uri });
    return newBasket.data;
  });
}
function removeBasketItem(_0, _1) {
  return __async(this, arguments, function* ({ locationId, basketId, itemId }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/items/${itemId}`;
    const data = yield client.delete(uri).json();
    const newBasket = safeParse({ data, schema: basketResponse, uri });
    return newBasket.data;
  });
}
function updateBasketItem(_0, _1) {
  return __async(this, arguments, function* ({ locationId, basketId, itemId, item }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/items/${itemId}`;
    const data = yield client.put(item, uri).json();
    const newBasket = safeParse({ data, schema: basketResponse, uri });
    return newBasket.data;
  });
}
function validateBasket(_0, _1) {
  return __async(this, arguments, function* ({ locationId, basketId }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/validate`;
    const data = yield client.post({}, uri).json();
    const newBasket = safeParse({ data, schema: basketResponse, uri });
    return newBasket.data;
  });
}
function getPaymentTypes(_0, _1) {
  return __async(this, arguments, function* ({ locationId, basketId }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/available-payment-types`;
    const data = yield client.post({}, uri).json();
    const paymentTypes = safeParse({
      data,
      schema: z.object({ data: paymentTypesResponse }),
      uri
    });
    return paymentTypes.data;
  });
}
function getSupportedPaymentTypes(_0, _1) {
  return __async(this, arguments, function* ({ basketId, locationId }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/supported-payment-types`;
    const data = yield client.get(uri).json();
    const paymentTypes = safeParse({
      data,
      schema: z.object({ data: supportedPaymentTypes }),
      uri
    });
    return paymentTypes.data;
  });
}
function getStoredValue(_0, _1) {
  return __async(this, arguments, function* ({ basketId, locationId, cardNumber, pin, captcha }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/stored-value-balance`;
    const data = yield client.headers(__spreadValues({}, captcha && { "X-Captcha-Response": captcha })).post({ card_number: cardNumber, pin }, uri).json();
    const balance = safeParse({
      data,
      schema: z.object({ data: storedValueBalanceResponse }),
      uri
    });
    return balance.data;
  });
}
function addPromo(_0, _1) {
  return __async(this, arguments, function* ({ basketId, locationId, promoCode }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/promo`;
    const data = yield client.post({ promo_code: promoCode }, uri).json();
    const newBasket = safeParse({ data, schema: basketResponse, uri });
    return newBasket.data;
  });
}
function removePromo(_0, _1) {
  return __async(this, arguments, function* ({ basketId, locationId, promoCode }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/promo/${promoCode}`;
    const data = yield client.delete(uri).json();
    const newBasket = safeParse({ data, schema: basketResponse, uri });
    return newBasket.data;
  });
}
function getBasketRewards(_0, _1) {
  return __async(this, arguments, function* ({ basketId, locationId }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/rewards/available`;
    const data = yield client.get(uri).json();
    const rewards = safeParse({
      data,
      schema: z.object({ data: rewardItem.array() }),
      uri
    });
    return rewards.data;
  });
}
function getAppliedRewards(_0, _1) {
  return __async(this, arguments, function* ({ basketId, locationId }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/rewards`;
    const data = yield client.get(uri).json();
    const rewards = safeParse({
      data,
      schema: z.object({ data: rewardItem.array() }),
      uri
    });
    return rewards.data;
  });
}
function addRewards(_0, _1) {
  return __async(this, arguments, function* ({ basketId, locationId, rewardCodes, validate = false }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/rewards`;
    const data = yield client.query({ validate }).post({ rewards: rewardCodes }, uri).json();
    const newBasket = safeParse({ data, schema: basketResponse, uri });
    return newBasket.data;
  });
}
function removeReward(_0, _1) {
  return __async(this, arguments, function* ({ basketId, locationId, rewardCode }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/rewards/${rewardCode}`;
    const data = yield client.delete(uri).json();
    const newBasket = safeParse({ data, schema: basketResponse, uri });
    return newBasket.data;
  });
}
function getPickupTime(_0, _1) {
  return __async(this, arguments, function* ({ locationId, wantedAtType, dayWanted }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/wanted-time`;
    const data = yield client.query({ day: dayWanted, type: wantedAtType }).get(uri).json();
    const times = safeParse({
      data,
      schema: z.object({ data: availableWantedAtTimes }),
      uri
    });
    return times.data;
  });
}
function getPickupTimeByBasket(_0, _1) {
  return __async(this, arguments, function* ({ basketId, locationId, hoursType, dayWanted }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/wanted-time`;
    const data = yield client.query({ day: dayWanted, type: hoursType }).get(uri).json();
    const times = safeParse({
      data,
      schema: z.object({ data: availableWantedAtTimes }),
      uri
    });
    return times.data;
  });
}
function setPickupTime(_0, _1) {
  return __async(this, arguments, function* ({ basketId, locationId, wanted_at }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/wanted-time`;
    const data = yield client.post({ wanted_at }, uri).json();
    const newBasket = safeParse({ data, schema: basketResponse, uri });
    return newBasket.data;
  });
}
function removePickupTime(_0, _1) {
  return __async(this, arguments, function* ({ basketId, locationId }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/wanted-time`;
    const data = yield client.delete(uri).json();
    const newBasket = safeParse({ data, schema: basketResponse, uri });
    return newBasket.data;
  });
}
function addTip(_0, _1) {
  return __async(this, arguments, function* ({ basketId, locationId, tipAmount }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/tip-amount`;
    const data = yield client.post({ amount: tipAmount }, uri).json();
    const newBasket = safeParse({ data, schema: basketResponse, uri });
    return newBasket.data;
  });
}
function setUtensils(_0, _1) {
  return __async(this, arguments, function* ({ basketId, locationId, preference }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/utensils`;
    const data = yield client.post({ preference }, uri).json();
    const newBasket = safeParse({ data, schema: basketResponse, uri });
    return newBasket.data;
  });
}
function setInstructions(_0, _1) {
  return __async(this, arguments, function* ({ basketId, locationId, basket_instructions }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/instructions`;
    const data = yield client.post({ basket_instructions }, uri).json();
    const newBasket = safeParse({ data, schema: basketResponse, uri });
    return newBasket.data;
  });
}
function getSavedCards(_0, _1) {
  return __async(this, arguments, function* (basketId, { client }) {
    const uri = `/v1/ordering/me/stored-cards`;
    const data = yield client.query((0,lib.stringify)({ meta: { basket_id: basketId } })).get(uri).json();
    const cards = safeParse({
      data,
      schema: z.object({ data: savedCard.array() }),
      uri
    });
    return cards.data;
  });
}
function removeSavedCard(_0, _1) {
  return __async(this, arguments, function* (cardId, { client }) {
    const uri = `/v1/ordering/me/stored-cards/${cardId}`;
    const data = yield client.delete(uri).res();
    return safeParse({ data, schema: z.unknown(), uri });
  });
}
function getMostRecentCard(_0) {
  return __async(this, arguments, function* ({
    client
  }) {
    const uri = `/v1/ordering/me/stored-cards`;
    const data = yield client.get(uri).json();
    return safeParse({
      data,
      schema: z.object({ data: savedCard.array() }),
      uri
    });
  });
}
function submitOrder(_0, _1) {
  return __async(this, arguments, function* ({ basketId, locationId, orderData, captcha }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/submit`;
    const parsedOrderData = safeParse({
      data: orderData,
      uri,
      schema: submissionDetails
    });
    const data = yield client.headers(__spreadValues({}, captcha && { "X-Captcha-Response": captcha })).post(parsedOrderData, uri).json();
    return safeParse({ data: data.data, schema: z.unknown(), uri });
  });
}
function getAllergens(_0, _1) {
  return __async(this, arguments, function* ({ perPage = 10 }, { client }) {
    const uri = "/v1/allergies";
    const data = yield client.query({ per_page: perPage }).get(uri).json();
    const allergens = safeParse({
      data,
      schema: z.object({ data: allergenItem.array() }),
      uri
    });
    return allergens.data;
  });
}
function getTags(_0, _1) {
  return __async(this, arguments, function* ({ type, perPage = 50 }, { client }) {
    const uri = "/v1/tags";
    const data = yield client.query((0,lib.stringify)({ per_page: perPage, filters: { type } })).get(uri).json();
    const tags = safeParse({
      data,
      schema: z.object({ data: tagItem.array() }),
      uri
    });
    return tags.data;
  });
}
function setConveyance(_0, _1) {
  return __async(this, arguments, function* ({ basketId, locationId, type, data }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/conveyance`;
    const options = type === "delivery" ? { delivery_address: data } : data;
    const res = yield client.post({ options, type }, uri).json();
    const newBasket = safeParse({ data: res, schema: basketResponse, uri });
    return newBasket.data;
  });
}
function createBasketFromOrderId(_0, _1) {
  return __async(this, arguments, function* ({ orderId, locationId, skipUnavailable = false }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets`;
    const data = yield client.query({ skip_unavailable: skipUnavailable }).post({ from_order_id: orderId }, uri).json();
    const newBasket = safeParse({ data, schema: basketResponse, uri });
    return newBasket.data;
  });
}
function getOrderSummary(_0, _1) {
  return __async(this, arguments, function* (orderId, { client }) {
    const uri = "/v1/ordering/orders/summary";
    const data = yield client.query({ order_id: orderId }).get(uri).json();
    const summary = safeParse({
      data,
      schema: z.object({ data: orderDetails.passthrough() }),
      uri
    });
    return summary.data;
  });
}
function updateArrivalStatus(_0, _1) {
  return __async(this, arguments, function* ({ orderId, externalOrder = false, message }, { client }) {
    const uri = "/v1/ordering/orders/customer-arrival";
    const payload = message ? { message } : {};
    yield client.query(externalOrder ? { order_id: orderId } : { id: orderId }).post(payload, uri).res();
  });
}
function getOrderDeliveryStatus(_0, _1) {
  return __async(this, arguments, function* (orderNumber, { client }) {
    const uri = "/v1/ordering/orders/delivery-status";
    const data = yield client.query({ order_number: orderNumber }).get(uri).json();
    const status = safeParse({
      data,
      schema: z.object({ data: deliveryStatus }),
      uri
    });
    return status.data;
  });
}
function getTokenizedCreditCard(_0, _1) {
  return __async(this, arguments, function* ({ basketId, locationId, transactionId }, { client }) {
    const uri = `/v1/ordering/store-locations/${locationId}/baskets/${basketId}/card-tokenization`;
    const data = yield client.post({ transaction_id: transactionId }, uri).json();
    const tokenizedCard = safeParse({
      data,
      schema: z.object({ data: tokenizedCreditCard2 }),
      uri
    });
    return tokenizedCard.data;
  });
}

// src/v4/api/organization.models.ts
var LOYALTY_PROGRAM_TYPES = /* @__PURE__ */ ((LOYALTY_PROGRAM_TYPES2) => {
  LOYALTY_PROGRAM_TYPES2["POINTS_CONVERT_REDEEMABLES"] = "points_convert_redeemables";
  LOYALTY_PROGRAM_TYPES2["POINTS_CONVERT_CURRENCY"] = "points_convert_currency";
  LOYALTY_PROGRAM_TYPES2["POINTS_CONVERT_REWARDS"] = "points_convert_rewards";
  LOYALTY_PROGRAM_TYPES2["SP_POINTS_CONVERT_REWARDS"] = "sp_points_convert_rewards";
  return LOYALTY_PROGRAM_TYPES2;
})(LOYALTY_PROGRAM_TYPES || {});
var LOYALTY_FEATURES = /* @__PURE__ */ ((LOYALTY_FEATURES2) => {
  LOYALTY_FEATURES2["GET_AVAILABLE_REWARDS"] = "getAvailableRewards";
  LOYALTY_FEATURES2["APPLY_REWARDS"] = "applyRewards";
  LOYALTY_FEATURES2["GET_APPLIED_REWARDS"] = "getAppliedRewards";
  LOYALTY_FEATURES2["DESTROY_REWARD"] = "destroyReward";
  LOYALTY_FEATURES2["CLAIM_REWARDS"] = "claimRewards";
  LOYALTY_FEATURES2["CLAIM_REWARDS_BY_RECEIPT"] = "claimRewardsByReceipt";
  LOYALTY_FEATURES2["INDEX_MY_REWARDS"] = "indexMyRewards";
  LOYALTY_FEATURES2["INDEX_REDEEMABLES"] = "indexRedeemables";
  LOYALTY_FEATURES2["INDEX_REDEMPTIONS"] = "indexRedemptions";
  LOYALTY_FEATURES2["CREATE_REDEMPTION_USING_REDEEMABLE"] = "createRedemptionUsingRedeemable";
  LOYALTY_FEATURES2["CREATE_REDEMPTION_USING_REWARD"] = "createRedemptionUsingReward";
  LOYALTY_FEATURES2["SHOW_LOYALTY_HISTORY"] = "showLoyaltyHistory";
  LOYALTY_FEATURES2["INDEX_LOYALTY_MESSAGES"] = "indexLoyaltyMessages";
  LOYALTY_FEATURES2["DESTROY_LOYALTY_MESSAGE"] = "destroyLoyaltyMessage";
  LOYALTY_FEATURES2["MARK_READ_LOYALTY_MESSAGE"] = "markReadLoyaltyMessage";
  LOYALTY_FEATURES2["SHOW_LOYALTY_STATE"] = "showLoyaltyState";
  LOYALTY_FEATURES2["SUPPORTS_QR"] = "supportsQR";
  LOYALTY_FEATURES2["SUPPORTS_REFERRAL_CODE"] = "supportsReferralCode";
  LOYALTY_FEATURES2["SUPPORTS_PUSH_NOTIFICATIONS"] = "supportsPushNotifications";
  LOYALTY_FEATURES2["SUPPORTS_SOCIAL_CAUSES"] = "supportsSocialCauses";
  return LOYALTY_FEATURES2;
})(LOYALTY_FEATURES || {});
var orderingTokenConfig = z.object({
  /** ID of the ordering engine. */
  driver_id: z.number(),
  /** Name of the ordering engine. Eg: `olo_full_xml`. */
  label: z.string()
});
var orgTokenConfig = z.object({
  /** ISO8601 datestamp when the brand was created. */
  created_at: z.string(),
  /** ISO8601 datestamp when the brand was deleted. */
  deleted_at: z.nullable(z.string()),
  /** External auth service used by this brand. */
  external_provider_id: z.number(),
  /** Brand ID. */
  id: z.number(),
  /** Brand name. Eg: `Koala Labs`. */
  label: z.string(),
  /** Brand Accessor/URL slug. Eg: `koala-labs`. */
  slug: z.string(),
  /** ISO8601 datestamp when the brand synced with the ordering provider. */
  last_synced_at: z.string(),
  /** ID of the loyalty engine used by this brand. */
  loyalty_driver_id: z.nullable(z.number()),
  /** URL of general nutrition information for this brand. */
  nutrition_url: z.nullable(z.string()),
  /** ID of the ordering engine used by this brand. */
  ordering_driver_id: z.number(),
  /** ISO8601 datestamp when the brand was last updated. */
  updated_at: z.string(),
  /** ID of the upsells engine used by this brand. */
  upsell_driver_id: z.number()
});
var paymentTokenConfig = z.object({
  /** ID of the payment engine. */
  driver_id: z.number(),
  /** Name of the payment engine. Eg: `pci_proxy`. */
  label: z.string()
});
var externalAuthConfig = z.object({
  /** ID of the auth provider. */
  driver_id: z.number(),
  /** Auth provider name, such as "Olo". */
  label: z.string(),
  /** Captcha configuration, if supported by the auth provider. */
  captcha: z.optional(
    z.object({ actions: z.string().array(), site_key: z.string() })
  ),
  /** Supported account features. */
  features: z.object({
    deleteStoredAddresses: z.boolean(),
    listStoredAddresses: z.boolean(),
    requiresEmailVerification: z.boolean(),
    /** Supported social login providers. Eg: "facebook" or "apple". */
    supportForLoginWithSocial: z.string().array(),
    supportsAccountDeletion: z.boolean(),
    supportsSingleFavoriteLocations: z.boolean(),
    supportsStoredAddresses: z.boolean(),
    supportsStoredCards: z.boolean(),
    updateStoredAddresses: z.boolean()
  }),
  /** Required fields for user registration. */
  registration_fields: z.object({ user: z.string().array() }),
  /** Non-modifiable account fields. Once set, they can't be changed. */
  readonly_fields: z.object({ user: z.string().array() }),
  /** User-modifiable account fields. */
  updatable_fields: z.object({ user: z.string().array() })
});
var loyaltyConfig = z.object({
  /** ID of the loyalty provider. */
  driver_id: z.number(),
  /** Loyalty provider name, such as "punchh". */
  label: z.string(),
  /** Features supported by the loyalty provider. */
  features: z.optional(z.record(z.nativeEnum(LOYALTY_FEATURES), z.boolean())),
  /** The loyalty program type—determines how rewards are earned/redeemed. */
  program_type: z.nativeEnum(LOYALTY_PROGRAM_TYPES)
});
var locationsConfig = z.object({
  features: z.object({
    isSingleLocation: z.object({
      /** This field is used when isSingleLocation is enabled otherwise it is null */
      storeLocationId: z.number().nullable(),
      /** Enables the feature */
      enabled: z.boolean()
    })
  })
});
var guestProfileConfig = z.object({
  features: z.object({
    /**
     * This flag indicates if user should be auto-enrolled all into marketing emails.
     * This will maximize the opportunity for data collection for the restaurant operators.
     * If flag is true - we pass opt_in: true with order submission data
     */
    hasImplicitOptIn: z.boolean()
  })
});
var tokenConfig = z.object({
  external_auth: z.optional(externalAuthConfig.passthrough()),
  loyalty: z.optional(loyaltyConfig.passthrough()),
  ordering: orderingTokenConfig.passthrough(),
  organization: orgTokenConfig.passthrough(),
  payment: z.optional(paymentTokenConfig.passthrough()),
  locations: locationsConfig.passthrough(),
  guest_profile: guestProfileConfig.passthrough()
});

// src/v4/api/organization.service.ts
function getOrgConfig(_0) {
  return __async(this, arguments, function* ({ client }) {
    const uri = "/v1/config";
    const data = yield client.get(uri).json();
    const tokenConfigRes = safeParse({
      data,
      schema: z.object({ data: tokenConfig }),
      uri
    });
    return tokenConfigRes.data;
  });
}

// src/v4/api/configurations.service.ts
function getWebConfig(_0) {
  return __async(this, arguments, function* ({ client }) {
    var _a, _b;
    const uri = "/configurations/schema/v1/config/label/web-config";
    const orgConfig = yield getOrgConfig({ client });
    const res = yield client.headers({ "X-Organization-Id": (_b = (_a = orgConfig == null ? void 0 : orgConfig.organization) == null ? void 0 : _a.id) == null ? void 0 : _b.toString() }).get(uri).json();
    return res.data.data;
  });
}
function getStrings(_0) {
  return __async(this, arguments, function* ({ client }) {
    const uri = "/configurations/schema/v1/config/label/web-strings";
    const orgConfig = yield getOrgConfig({ client });
    const res = yield client.headers({ "X-Organization-Id": orgConfig.organization.id.toString() }).get(uri).json();
    return res.data.data;
  });
}
function getFooter(_0) {
  return __async(this, arguments, function* ({ client }) {
    const uri = "/configurations/schema/v1/config/label/web-footer";
    const orgConfig = yield getOrgConfig({ client });
    const res = yield client.headers({ "X-Organization-Id": orgConfig.organization.id.toString() }).get(uri).json();
    return res.data.data;
  });
}

// src/v4/api/communication.model.ts
var contactResponse = z.object({
  // add response values here
});

// src/v4/api/communication.service.ts
function contact(_0, _1) {
  return __async(this, arguments, function* (input, { client }) {
    const uri = "/v1/forms/contact";
    const data = yield client.post(input, uri).res();
    return safeParse({
      data,
      schema: contactResponse.passthrough(),
      uri
    });
  });
}

// src/v4/api/geoip.models.ts
var geoData = z.object({
  area: z.number(),
  city: z.string(),
  country: z.string(),
  eu: z.boolean(),
  ll: z.number().array(),
  metro: z.number(),
  region: z.string(),
  timezone: z.string()
});
var geoIp = z.object({
  requestIp: z.string(),
  geoData: z.nullable(geoData.passthrough())
});

// src/v4/api/geoip.service.ts
function geoIpLookup(_0) {
  return __async(this, arguments, function* ({ client }) {
    const uri = "/v1/geoip";
    const data = yield client.get(uri).json();
    return safeParse({ data, schema: geoIp, uri });
  });
}

// src/utils/locations.utils.ts
function standardizeAddressZipCode(address2) {
  if (typeof address2.zip_code === "string" && address2.zip_code !== "") {
    return __spreadProps(__spreadValues({}, address2), {
      zip: void 0
    });
  }
  if (typeof address2.zip === "string" && address2.zip !== "") {
    return __spreadProps(__spreadValues({}, address2), {
      zip: void 0,
      zip_code: address2.zip
    });
  }
  return address2;
}

// src/v4/api/locations.service.ts
function listLocations(_0, _1) {
  return __async(this, arguments, function* (query, { client }) {
    const uri = "/v1/ordering/store-locations";
    const data = yield client.query(v4_stringify(query)).get(uri).json();
    return safeParse({
      data,
      schema: listSchema(v4_location.passthrough()),
      uri
    });
  });
}
function getLocation(_0, _1) {
  return __async(this, arguments, function* ({ id, meta, ifModifiedSince }, { client }) {
    const uri = "/v1/ordering/store-locations";
    const data = yield client.query(v4_stringify(meta)).headers(ifModifiedSince ? { "If-Modified-Since": ifModifiedSince } : {}).get(`${uri}/${id}`).json();
    return safeParse({
      data,
      schema: z.object({
        data: v4_location.passthrough()
      }),
      uri
    });
  });
}
function getLocationByBrandId(_0, _1) {
  return __async(this, arguments, function* ({ brand_id, meta }, { client }) {
    const uri = "/v1/ordering/store-locations/brand";
    const data = yield client.query(v4_stringify(meta)).get(`${uri}/${brand_id}`).json();
    return safeParse({
      data,
      schema: z.object({
        data: v4_location.passthrough()
      }),
      uri
    });
  });
}
function getDeliveryCoverage(_0, _1) {
  return __async(this, arguments, function* (address2, { client }) {
    const uri = "/v1/ordering/store-locations/search-delivery-coverage";
    const data = yield client.post(standardizeAddressZipCode(address2), uri).json();
    return safeParse({
      data,
      schema: z.object({
        data: v4_location.passthrough()
      }),
      uri
    });
  });
}
function checkDeliveryCoverage(_0, _1, _2) {
  return __async(this, arguments, function* (locationId, address2, { client }) {
    const uri = "/v1/ordering/store-locations";
    const data = yield client.post(
      standardizeAddressZipCode(address2),
      `${uri}/${locationId}/check-delivery-coverage`
    ).json();
    return safeParse({
      data,
      schema: z.object({
        data: deliveryCoverageResponse.passthrough()
      }),
      uri
    });
  });
}

// src/v4/api/loyalty.service.ts
function createRedemption(_0, _1, _2) {
  return __async(this, arguments, function* (redeemableId, rewardType, { client }) {
    const uri = "/v1/ordering/loyalty/redemptions";
    const data = yield client.post({ [rewardType]: redeemableId }, uri).json();
    return safeParse({
      data,
      schema: z.object({
        data: redemptionItem.passthrough()
      }),
      uri
    });
  });
}
function createRedemptionUsingBankCurrency(_0, _1) {
  return __async(this, arguments, function* (bankCurrency, { client }) {
    const uri = "/v1/ordering/loyalty/redemptions";
    const data = yield client.post({ banked_currency: bankCurrency }, uri).json();
    return safeParse({
      data,
      schema: z.object({
        data: redemptionItem.passthrough()
      }),
      uri
    });
  });
}
function defaultStoredAddress(_0, _1) {
  return __async(this, arguments, function* (addressId, { client }) {
    const uri = `/v1/ordering/me/addresses/${addressId}`;
    const data = yield client.put({}, uri).res();
    return safeParse({
      data,
      schema: deliveryAddress.passthrough().array(),
      uri
    });
  });
}
function deleteStoredAddress(_0, _1) {
  return __async(this, arguments, function* (addressId, { client }) {
    const uri = `/v1/ordering/me/addresses/${addressId}`;
    const data = yield client.delete(uri).res();
    return safeParse({
      data,
      schema: deliveryAddress.passthrough().array(),
      uri
    });
  });
}
function fetchLoyaltyState(_0) {
  return __async(this, arguments, function* ({
    client
  }) {
    const uri = "/v1/ordering/loyalty/state";
    const data = yield client.get(uri).json();
    return safeParse({
      data,
      schema: z.object({
        data: loyaltyState.passthrough()
      }),
      uri
    });
  });
}
function forgotPassword(_0, _1) {
  return __async(this, arguments, function* (email, { client }) {
    const uri = "/v1/ordering/loyalty/forgot-password";
    yield client.post({ email }, uri).res();
  });
}
function getRewards(_0) {
  return __async(this, arguments, function* ({
    client
  }) {
    const uri = "/v1/ordering/me/rewards";
    const data = yield client.get(uri).json();
    return safeParse({
      data,
      schema: z.object({
        data: rewardItem.array()
      }),
      uri
    });
  });
}
function getStoredAddresses(_0) {
  return __async(this, arguments, function* ({
    client
  }) {
    const uri = "/v1/ordering/me/addresses";
    const data = yield client.get(uri).json();
    return safeParse({
      data,
      schema: z.object({
        data: storedAddress.passthrough().array()
      }),
      uri
    });
  });
}
function getUser(_0) {
  return __async(this, arguments, function* ({
    client
  }) {
    const uri = "/v1/ordering/loyalty/me";
    const data = yield client.get(uri).json();
    return safeParse({
      data,
      schema: z.object({
        data: loyaltyUser.passthrough()
      }),
      uri
    });
  });
}
function register(_0, _1) {
  return __async(this, arguments, function* (userDetails, { client }) {
    const uri = "/v1/ordering/loyalty/register";
    const data = yield client.post(userDetails, uri).json();
    return safeParse({
      data,
      schema: loyaltyUser.passthrough(),
      uri
    });
  });
}
function resetPassword(_0, _1) {
  return __async(this, arguments, function* (passwordResetInfo, { client }) {
    const uri = "/v1/ordering/loyalty/reset-password";
    yield client.post(passwordResetInfo, uri).res();
  });
}
function updateMe(_0, _1) {
  return __async(this, arguments, function* (userDetails, { client }) {
    const uri = "/v1/ordering/loyalty/me";
    const data = yield client.put(userDetails, uri).json();
    return safeParse({
      data,
      schema: loyaltyUser.passthrough(),
      uri
    });
  });
}
function fetchRedeemables(_0) {
  return __async(this, arguments, function* ({
    client
  }) {
    const uri = "/v1/ordering/loyalty/redeemables";
    const data = yield client.get(uri).json();
    return safeParse({
      data,
      schema: z.object({
        data: redeemableItem.passthrough().array()
      }),
      uri
    });
  });
}
function fetchRedemptions(_0) {
  return __async(this, arguments, function* ({
    client
  }) {
    const uri = "/v1/ordering/loyalty/redemptions";
    const data = yield client.get(uri).json();
    return safeParse({
      data,
      schema: z.object({
        data: redemptionItem.passthrough().array()
      }),
      uri
    });
  });
}
function fetchRewardsHistory(_0) {
  return __async(this, arguments, function* ({
    client
  }) {
    const uri = "/v1/ordering/loyalty/history";
    const data = yield client.get(uri).json();
    return safeParse({
      data,
      schema: z.object({
        data: rewardHistoryItem.passthrough().array()
      }),
      uri
    });
  });
}
function fetchMessages(_0) {
  return __async(this, arguments, function* ({
    client
  }) {
    const uri = "/v1/ordering/loyalty/messages";
    const data = yield client.get(uri).json();
    return safeParse({
      data,
      schema: z.object({
        data: messageItem.passthrough().array()
      }),
      uri
    });
  });
}
function markMessageAsRead(_0, _1) {
  return __async(this, arguments, function* (messageId, { client }) {
    const uri = `/v1/ordering/loyalty/messages/${messageId}`;
    yield client.put({}, uri).res();
  });
}
function deleteMessage(_0, _1) {
  return __async(this, arguments, function* (messageId, { client }) {
    const uri = `/v1/ordering/loyalty/messages/${messageId}`;
    yield client.delete(uri).res();
  });
}
function redeemReceiptBarcode(_0, _1) {
  return __async(this, arguments, function* (barcode, { client }) {
    const uri = "/v1/ordering/orders/claim-rewards";
    const data = yield client.post({ barcode }, uri).json();
    return safeParse({
      data,
      schema: loyaltyState.passthrough(),
      uri
    });
  });
}
function fetchSocialCauses(_0) {
  return __async(this, arguments, function* ({
    client
  }) {
    const uri = "/v1/ordering/loyalty/social-causes";
    const data = yield client.get(uri).json();
    return safeParse({
      data,
      schema: z.object({
        data: socialCause.passthrough().array()
      }),
      uri
    });
  });
}
function donateToSocialCause(_0, _1, _2) {
  return __async(this, arguments, function* (id, donation2, { client }) {
    const uri = `/v1/ordering/loyalty/social-causes/${id}`;
    yield client.put(donation2, uri).json();
  });
}
function saveFavoriteLocation(_0, _1) {
  return __async(this, arguments, function* (locationId, { client }) {
    const uri = "/v1/ordering/me/favorites/store-locations";
    yield client.post({}, `${uri}/${locationId}`).res();
  });
}
function deleteFavoriteLocation(_0, _1) {
  return __async(this, arguments, function* (locationId, { client }) {
    const uri = "/v1/ordering/me/favorites/store-locations";
    yield client.delete(`${uri}/${locationId}`).res();
  });
}
function getFavoriteLocations(_0) {
  return __async(this, arguments, function* ({
    client
  }) {
    const uri = "/v1/ordering/me/favorites/store-locations";
    const data = yield client.get(uri).json();
    return safeParse({
      data,
      schema: z.object({
        data: v4_location.passthrough().array()
      }),
      uri
    });
  });
}

// src/utils/menu.helpers.ts
var import_merge = __toESM(require_merge());

function prettyPrice(product) {
  const optionsCost = calculateOptionsPrice(product.option_groups, 0);
  const prettyPrice2 = product.cost + optionsCost;
  return prettyPrice2 === 0 ? null : `$${(prettyPrice2 / 100).toFixed(2)}`;
}
function calculateOptionsPrice(option_groups, optionsPrice) {
  option_groups.map((group) => {
    if (group.min_selections && group.min_selections > 0) {
      optionsPrice += group.options.filter((option) => option.is_default).reduce((total, defaultOption) => {
        total += defaultOption.cost;
        if (defaultOption == null ? void 0 : defaultOption.option_groups.length) {
          total = calculateOptionsPrice(defaultOption.option_groups, total);
        }
        return total;
      }, 0);
    }
  });
  return optionsPrice;
}
function deriveProductWarningLabels(product) {
  var _a;
  let labels = {};
  if (((_a = product.labels) == null ? void 0 : _a.length) > 0) {
    product.labels.forEach((label) => {
      labels[label.name] = label;
    });
  }
  const recursivelyFilterLabels = (option_groups, labels2) => {
    option_groups.forEach((group) => {
      group.options.forEach((option) => {
        var _a2, _b;
        if (((_a2 = option.labels) == null ? void 0 : _a2.length) > 0) {
          option.labels.forEach((label) => {
            labels2[label.name] = label;
          });
        }
        if (((_b = option.option_groups) == null ? void 0 : _b.length) > 0) {
          recursivelyFilterLabels(option.option_groups, labels2);
        }
      });
    });
    return labels2;
  };
  labels = recursivelyFilterLabels(product.option_groups, labels);
  return Object.values(labels);
}
function deriveCalorieRange(product) {
  if (product.calories !== null && product.calories_separator !== null && product.max_calories !== null) {
    return `${product.calories}${product.calories_separator}${product.max_calories} ${CALS_IDENTIFIER}`;
  }
  return "";
}
function prettyCalories(product) {
  const calorieRange = deriveCalorieRange(product);
  if (calorieRange) {
    return calorieRange;
  }
  if (typeof product.calories === "number") {
    return `${product.calories} ${CALS_IDENTIFIER}`;
  }
  return "";
}
function isCustomizable(product) {
  var _a;
  return ((_a = product.option_groups) == null ? void 0 : _a.length) >= 1;
}
function augmentMenuProduct(product) {
  return __spreadProps(__spreadValues({}, product), {
    calorie_range: deriveCalorieRange(product),
    calsIdentifier: CALS_IDENTIFIER,
    customizable: isCustomizable(product),
    pretty_calories: prettyCalories(product),
    pretty_price: prettyPrice(product),
    warningLabels: deriveProductWarningLabels(product)
  });
}

// src/utils/service.helpers.ts

function decompressBinaryContent(compressedData) {
  try {
    const uncompressed = (0,pako_esm/* inflate */.rr)(compressedData, { to: "string" });
    return JSON.parse(uncompressed);
  } catch (e) {
    console.error("Failed to decompress binary content.");
    throw e;
  }
}

// src/v4/api/menu.service.ts
function getMenu(_0, _1) {
  return __async(this, arguments, function* ({ id, ifModifiedSince, compressed = true, wantedAt }, { client }) {
    const base = "/v1/ordering/store-locations";
    const query = wantedAt ? `?wanted-at=${encodeURIComponent(wantedAt)}` : "";
    const uri = `${base}/${id}/menu${query}`;
    const res = client.headers(__spreadProps(__spreadValues({}, ifModifiedSince && { "If-Modified-Since": ifModifiedSince }), {
      Accept: compressed ? "application/zlib" : "application/json"
    })).get(uri);
    const data = compressed ? yield res.arrayBuffer() : yield res.json();
    const isCompressed = (_, isCompressed2) => isCompressed2;
    if (isCompressed(data, compressed)) {
      const menuByteArray = new Uint8Array(data);
      const decompressedMenu = decompressBinaryContent(menuByteArray);
      const parsedMenu2 = safeParse({
        data: decompressedMenu.data,
        schema: menuResponse.passthrough(),
        uri
      });
      const computedCategories2 = parsedMenu2.categories.map((category2) => __spreadProps(__spreadValues({}, category2), {
        products: category2.products.map((product) => augmentMenuProduct(product))
      }));
      return [computedCategories2, Array.from(menuByteArray)];
    }
    const parsedMenu = safeParse({
      data,
      schema: z.object({
        data: menuResponse.passthrough()
      }),
      uri: base
    });
    const computedCategories = parsedMenu.data.categories.map((category2) => __spreadProps(__spreadValues({}, category2), {
      products: category2.products.map((product) => augmentMenuProduct(product))
    }));
    return [computedCategories, []];
  });
}

// src/v4/api/ordering-profile.service.ts
function pastOrders(_0) {
  return __async(this, arguments, function* ({ client }) {
    const uri = "/v1/ordering/me/orders?include[]=store_location&sort[created_at]=desc";
    const data = yield client.get(uri).json();
    return safeParse({
      data,
      schema: z.object({
        data: order.passthrough().array()
      }),
      uri
    });
  });
}
function favoriteOrders(_0) {
  return __async(this, arguments, function* ({ client }) {
    const uri = "/v1/ordering/me/favorites/orders?include[]=store_location&sort[created_at]=desc";
    const data = yield client.get(uri).json();
    return safeParse({
      data,
      schema: z.object({
        data: order.passthrough().array()
      }),
      uri
    });
  });
}
function favoritesSave(_0, _1) {
  return __async(this, arguments, function* (orderId, { client }) {
    const uri = "/v1/ordering/me/favorites/orders";
    yield client.post({}, `${uri}/${orderId}`).res();
  });
}
function favoritesDelete(_0, _1) {
  return __async(this, arguments, function* (orderId, { client }) {
    const uri = "/v1/ordering/me/favorites/orders";
    yield client.delete(`${uri}/${orderId}`).res();
  });
}
function getOrderDetails(_0, _1) {
  return __async(this, arguments, function* (order_id, { client }) {
    const uri = "/v1/ordering/orders";
    const data = yield client.get(`${uri}/${order_id}?include[]=store_location`).json();
    return {
      data: safeParse({
        data,
        schema: orderDetails.passthrough().array(),
        uri
      })
    };
  });
}

// src/v4/api/recommendations.models.ts
var UpsellsStep = /* @__PURE__ */ ((UpsellsStep2) => {
  UpsellsStep2["add"] = "add_product";
  UpsellsStep2["checkout"] = "checkout";
  return UpsellsStep2;
})(UpsellsStep || {});
var crossSellsOffer = z.object({
  /** The type of offer. `addon` or `replace`. */
  type: z.union([z.literal("addon"), z.literal("replace")]),
  /** ID of the BasketItem that will be replaced if the offer is `replace`. */
  target: z.nullable(z.string()),
  /** Recommended menu items. */
  products: menuProduct.passthrough().array()
});
var crossSells = z.object({
  data: z.object({
    /** ID for the set of upsells presented. */
    id: z.string(),
    /** Origin of the cross-sells list. Most likely `recommendations`. */
    upsells_rule: z.string().optional(),
    /** List of product recommendations. */
    upsells: crossSellsOffer.passthrough().array()
  })
});
var popularProductsOffer = z.object({
  /** The type of offer (popular products always return `popular`) */
  type: z.literal("popular"),
  /** Popular product score, we can use this to sort the items */
  score: z.number(),
  /** Recommended menu items. */
  products: menuProductResponse.passthrough().array()
});
var popularProducts = z.object({
  /** ID for the set of popular products presented. */
  id: z.string(),
  /** Popular menu items. */
  products: popularProductsOffer.passthrough().array()
});

// src/v4/api/recommendations.service.ts
function getCrossSells(_0, _1) {
  return __async(this, arguments, function* (options, { client }) {
    const uri = "/v1/ordering/upsells";
    const query = options.wanted_at ? `?wanted-at=${encodeURIComponent(options.wanted_at)}` : "";
    const data = yield client.post(options, `${uri}${query}`).json();
    return safeParse({
      data,
      schema: crossSells.passthrough(),
      uri
    });
  });
}
function getPopularProducts(_0, _1) {
  return __async(this, arguments, function* (options, { client }) {
    var _a;
    const uri = "/v1/ordering/recommendations/products/popular";
    const query = options.wantedAt ? `?wanted-at=${encodeURIComponent(options.wantedAt)}` : "";
    const res = yield client.post(
      {
        store_location_id: options.locationId,
        max: (_a = options == null ? void 0 : options.maxItems) != null ? _a : 5
      },
      `${uri}${query}`
    ).json();
    const parsedRes = safeParse({
      data: res,
      schema: z.object({ data: popularProducts.passthrough() }),
      uri
    });
    return parsedRes.data;
  });
}

// src/v4/core/client.ts



// src/v4/core/auth.ts

function invalidOriginError() {
  const err = new Error("Invalid origin domain");
  err.statusCode = 401;
  err.status = 401;
  err.error = {
    error: "invalid_credentials",
    error_description: "Invalid or unrecognized origin domain"
  };
  return err;
}
function throwInvalidOrigin() {
  throw invalidOriginError();
}
function tokenName(origin) {
  return encodeURIComponent(`koala-token-${origin}`);
}
function getPersistedToken({ origin }) {
  if (typeof window !== "undefined") {
    const tokenString = window.localStorage.getItem(tokenName(origin));
    if (tokenString) {
      try {
        const persistedToken = token.parse(JSON.parse(tokenString));
        return persistedToken;
      } catch (e) {
        console.error("Failed to parse persisted token", e);
      }
    }
  }
  return null;
}
function resetToken(_0) {
  return __async(this, arguments, function* ({
    credentials,
    env,
    origin,
    headers = {}
  }) {
    const token2 = yield fetchClientToken({ credentials, env, origin, headers });
    persistToken({ origin, token: token2 });
  });
}
function persistToken({ origin, token: token2 }) {
  if (typeof window !== "undefined") {
    window.localStorage.setItem(tokenName(origin), JSON.stringify(token2));
  }
}
function fetchClientToken(_0) {
  return __async(this, arguments, function* ({
    credentials,
    env,
    origin,
    headers = {}
  }) {
    return dist(`${buildOrderingApiUrl(env)}/oauth/access_token`).headers(__spreadProps(__spreadValues({}, headers), { "x-request-origin": origin })).post({
      client_id: credentials.clientId,
      client_secret: credentials.clientSecret,
      grant_type: "ordering_app_credentials",
      scope: "group:ordering_app"
    }).unauthorized((err) => __async(this, null, function* () {
      var _a;
      try {
        const errorBody = yield err.json();
        if ((errorBody == null ? void 0 : errorBody.error) === "invalid_credentials" && ((_a = errorBody == null ? void 0 : errorBody.error_description) == null ? void 0 : _a.includes(
          "Invalid or unrecognized origin domain"
        ))) {
          if (typeof window !== "undefined") {
            window.location.href = "https://chowly.com";
            throw new Error("Invalid origin domain - redirecting");
          }
          throwInvalidOrigin();
        }
      } catch (parseError) {
      }
      throw err;
    })).json();
  });
}
function fetchLoyaltyToken(_0) {
  return __async(this, arguments, function* ({
    credentials,
    env,
    origin,
    payload,
    headers = {}
  }) {
    return dist(`${buildOrderingApiUrl(env)}/oauth/access_token`).headers(__spreadProps(__spreadValues({}, headers), { "x-request-origin": origin })).post({
      client_id: credentials.clientId,
      client_secret: credentials.clientSecret,
      grant_type: "external_provider",
      scope: "group:external_provider",
      payload
    }).unauthorized((err) => __async(this, null, function* () {
      var _a;
      try {
        const errorBody = yield err.json();
        if ((errorBody == null ? void 0 : errorBody.error) === "invalid_credentials" && ((_a = errorBody == null ? void 0 : errorBody.error_description) == null ? void 0 : _a.includes(
          "Invalid or unrecognized origin domain"
        ))) {
          if (typeof window !== "undefined") {
            window.location.href = "https://chowly.com";
            throw new Error("Invalid origin domain - redirecting");
          }
          throwInvalidOrigin();
        }
      } catch (parseError) {
      }
      throw err;
    })).json();
  });
}
function refreshLoyaltyToken({
  credentials,
  env,
  origin,
  refreshToken
}) {
  return dist(`${buildOrderingApiUrl(env)}/oauth/access_token`).headers({ "x-request-origin": origin }).post({
    client_id: credentials.clientId,
    client_secret: credentials.clientSecret,
    grant_type: "refresh_token",
    scope: "group:external_provider",
    refresh_token: refreshToken
  }).unauthorized((err) => __async(this, null, function* () {
    var _a;
    try {
      const errorBody = yield err.json();
      if ((errorBody == null ? void 0 : errorBody.error) === "invalid_credentials" && ((_a = errorBody == null ? void 0 : errorBody.error_description) == null ? void 0 : _a.includes(
        "Invalid or unrecognized origin domain"
      ))) {
        if (typeof window !== "undefined") {
          window.location.href = "https://chowly.com";
          throw new Error("Invalid origin domain - redirecting");
        }
        throwInvalidOrigin();
      }
    } catch (parseError) {
    }
    throw err;
  }));
}
function validateLoyaltyToken(origin) {
  const currentToken = getPersistedToken({ origin });
  if (currentToken && currentToken.refresh_token) {
    return true;
  }
  return false;
}
function logout(_0) {
  return __async(this, arguments, function* ({
    client
  }) {
    return yield client.post({}, "/oauth/logout").json();
  });
}

// src/v4/core/client.ts
function httpClient({
  credentials,
  env,
  origin,
  headers = {}
}) {
  return dist(buildOrderingApiUrl(env)).defer((w) => {
    const token2 = getPersistedToken({ origin });
    return token2 ? w.auth(`Bearer ${token2.access_token}`) : w;
  }).headers(__spreadProps(__spreadValues({}, headers), { "X-Channel-Id": "web" })).catcher(401, (_, req) => __async(this, null, function* () {
    var _a;
    try {
      let token2 = getPersistedToken({ origin });
      if (token2 == null ? void 0 : token2.refresh_token) {
        if (typeof window !== "undefined" && !getLock(origin)) {
          setLock(origin);
          yield refreshLoyaltyToken({
            credentials,
            env,
            origin,
            refreshToken: token2.refresh_token
          }).unauthorized((err) => __async(this, null, function* () {
            token2 = yield fetchClientToken({
              credentials,
              env,
              origin
            });
            persistToken({ origin, token: token2 });
            throw err;
          })).json((json) => {
            token2 = json;
            persistToken({ origin, token: token2 });
          }).finally(
            () => (
              // finally, remove the lock in any case
              removeLock(origin)
            )
          );
        }
      } else {
        token2 = yield fetchClientToken({ credentials, env, origin });
        persistToken({ origin, token: token2 });
      }
      yield new Promise((resolve) => {
        if (typeof window !== "undefined" && getLock(origin)) {
          const interval = setInterval(function() {
            const lock = getLock(origin);
            if (lockIsStale(origin)) {
              removeLock(origin);
              window.location.reload();
            }
            if (!lock) {
              resolve();
              clearInterval(interval);
            }
          }, 50);
        } else {
          resolve();
        }
      });
      return replayRequest(req, token2);
    } catch (err) {
      const error = err;
      if (error && typeof error.json === "function") {
        try {
          const errorBody = yield error.json();
          if ((errorBody == null ? void 0 : errorBody.error) === "invalid_credentials" && ((_a = errorBody == null ? void 0 : errorBody.error_description) == null ? void 0 : _a.includes(
            "Invalid or unrecognized origin domain"
          ))) {
            if (typeof window !== "undefined") {
              window.location.href = "https://chowly.com";
              throw new Error("Invalid origin domain - redirecting");
            }
          }
        } catch (parseError) {
        }
      }
      return req.json({ message: error.message || "Request failed" });
    }
  })).addon(addons_queryString);
}



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,179], function() { return __webpack_exec__(12527), __webpack_exec__(86570), __webpack_exec__(93642); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);